(function(){
    "use strict";

    angular.module('SmartAdmin.Forms', []);
})();;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartWizard', function () {
    return {
        restrict: 'A',
        scope: {
            'smartWizardCallback': '&'
        },
        link: function (scope, element, attributes) {

            var stepsCount = $('[data-smart-wizard-tab]').length;

            var currentStep = 1;

            var validSteps = [];

            var $form = element.closest('form');

            var $prev = $('[data-smart-wizard-prev]', element);

            var $next = $('[data-smart-wizard-next]', element);

            function setStep(step) {
                currentStep = step;
                $('[data-smart-wizard-pane=' + step + ']', element).addClass('active').siblings('[data-smart-wizard-pane]').removeClass('active');
                $('[data-smart-wizard-tab=' + step + ']', element).addClass('active').siblings('[data-smart-wizard-tab]').removeClass('active');

                $prev.toggleClass('disabled', step == 1)
            }


            element.on('click', '[data-smart-wizard-tab]', function (e) {
                setStep(parseInt($(this).data('smartWizardTab')));
                e.preventDefault();
            });

            $next.on('click', function (e) {
                if ($form.data('validator')) {
                    if (!$form.valid()) {
                        validSteps = _.without(validSteps, currentStep);
                        $form.data('validator').focusInvalid();
                        return false;
                    } else {
                        validSteps = _.without(validSteps, currentStep);
                        validSteps.push(currentStep);
                        element.find('[data-smart-wizard-tab=' + currentStep + ']')
                            .addClass('complete')
                            .find('.step')
                            .html('<i class="fa fa-check"></i>');
                    }
                }
                if (currentStep < stepsCount) {
                    setStep(currentStep + 1);
                } else {
                    if (validSteps.length < stepsCount) {
                        var steps = _.range(1, stepsCount + 1)

                        _(steps).forEach(function (num) {
                            if (validSteps.indexOf(num) == -1) {
                                console.log(num);
                                setStep(num);
                                return false;
                            }
                        })
                    } else {
                        var data = {};
                        _.each($form.serializeArray(), function(field){
                            data[field.name] = field.value
                        });
                        if(typeof  scope.smartWizardCallback() === 'function'){
                            scope.smartWizardCallback()(data)
                        }
                    }
                }

                e.preventDefault();
            });

            $prev.on('click', function (e) {
                if (!$prev.hasClass('disabled') && currentStep > 0) {
                    setStep(currentStep - 1);
                }
                e.preventDefault();
            });


            setStep(currentStep);

        }
    }
});;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartFueluxWizard', function () {
    return {
        restrict: 'A',
        scope: {
            smartWizardCallback: '&'
        },
        link: function (scope, element, attributes) {

            var wizard = element.wizard();

            var $form = element.find('form');

            wizard.on('actionclicked.fu.wizard', function(e, data){
                if ($form.data('validator')) {
                    if (!$form.valid()) {
                        $form.data('validator').focusInvalid();
                        e.preventDefault();
                    }
                }
            });

            wizard.on('finished.fu.wizard', function (e, data) {
                var formData = {};
                _.each($form.serializeArray(), function(field){
                    formData[field.name] = field.value
                });
                if(typeof scope.smartWizardCallback() === 'function'){
                    scope.smartWizardCallback()(formData)
                }
            });
        }
    }
});;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartValidateForm', function (formsCommon) {
    return {
        restrict: 'A',
        link: function (scope, form, attributes) {

            var validateOptions = {
                rules: {},
                messages: {},
                highlight: function (element) {
                    $(element).closest('.form-group').removeClass('has-success').addClass('has-error');
                },
                unhighlight: function (element) {
                    $(element).closest('.form-group').removeClass('has-error').addClass('has-success');
                },
                errorElement: 'span',
                errorClass: 'help-block',
                errorPlacement: function (error, element) {
                    if (element.parent('.input-group').length) {
                        error.insertAfter(element.parent());
                    } else {
                        error.insertAfter(element);
                    }
                }
            };
            form.find('[data-smart-validate-input], [smart-validate-input]').each(function () {
                var $input = $(this), fieldName = $input.attr('name');

                validateOptions.rules[fieldName] = {};

                if ($input.data('required') != undefined) {
                    validateOptions.rules[fieldName].required = true;
                }
                if ($input.data('email') != undefined) {
                    validateOptions.rules[fieldName].email = true;
                }

                if ($input.data('maxlength') != undefined) {
                    validateOptions.rules[fieldName].maxlength = $input.data('maxlength');
                }

                if ($input.data('minlength') != undefined) {
                    validateOptions.rules[fieldName].minlength = $input.data('minlength');
                }

                if($input.data('message')){
                    validateOptions.messages[fieldName] = $input.data('message');
                } else {
                    angular.forEach($input.data(), function(value, key){
                        if(key.search(/message/)== 0){
                            if(!validateOptions.messages[fieldName])
                                validateOptions.messages[fieldName] = {};

                            var messageKey = key.toLowerCase().replace(/^message/,'')
                            validateOptions.messages[fieldName][messageKey] = value;
                        }
                    });
                }
            });


            form.validate(validateOptions);

        }
    }
});
;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartDropzone', function () {
    return function (scope, element, attrs) {
        var config, dropzone;

        config = scope[attrs.smartDropzone];

        // create a Dropzone for the element with the given options
        dropzone = new Dropzone(element[0], config.options);

        // bind the given event handlers
        angular.forEach(config.eventHandlers, function (handler, event) {
            dropzone.on(event, handler);
        });
    };
});
;
(function(){
    "use strict";

    angular.module('SmartAdmin.Layout', []);
})();;
 "use strict";
 
 angular.module('SmartAdmin.Layout').directive('widgetGrid', function ($rootScope, $compile, $q, $state, $timeout) {

    var jarvisWidgetsDefaults = {
        grid: 'article',
        widgets: '.jarviswidget',
        localStorage: true,
        deleteSettingsKey: '#deletesettingskey-options',
        settingsKeyLabel: 'Reset settings?',
        deletePositionKey: '#deletepositionkey-options',
        positionKeyLabel: 'Reset position?',
        sortable: true,
        buttonsHidden: false,
        // toggle button
        toggleButton: true,
        toggleClass: 'fa fa-minus | fa fa-plus',
        toggleSpeed: 200,
        onToggle: function () {
        },
        // delete btn
        deleteButton: true,
        deleteMsg: 'Warning: This action cannot be undone!',
        deleteClass: 'fa fa-times',
        deleteSpeed: 200,
        onDelete: function () {
        },
        // edit btn
        editButton: true,
        editPlaceholder: '.jarviswidget-editbox',
        editClass: 'fa fa-cog | fa fa-save',
        editSpeed: 200,
        onEdit: function () {
        },
        // color button
        colorButton: true,
        // full screen
        fullscreenButton: true,
        fullscreenClass: 'fa fa-expand | fa fa-compress',
        fullscreenDiff: 3,
        onFullscreen: function () {
        },
        // custom btn
        customButton: false,
        customClass: 'folder-10 | next-10',
        customStart: function () {
            alert('Hello you, this is a custom button...');
        },
        customEnd: function () {
            alert('bye, till next time...');
        },
        // order
        buttonOrder: '%refresh% %custom% %edit% %toggle% %fullscreen% %delete%',
        opacity: 1.0,
        dragHandle: '> header',
        placeholderClass: 'jarviswidget-placeholder',
        indicator: true,
        indicatorTime: 600,
        ajax: true,
        timestampPlaceholder: '.jarviswidget-timestamp',
        timestampFormat: 'Last update: %m%/%d%/%y% %h%:%i%:%s%',
        refreshButton: true,
        refreshButtonClass: 'fa fa-refresh',
        labelError: 'Sorry but there was a error:',
        labelUpdated: 'Last Update:',
        labelRefresh: 'Refresh',
        labelDelete: 'Delete widget:',
        afterLoad: function () {
        },
        rtl: false, // best not to toggle this!
        onChange: function () {

        },
        onSave: function () {

        },
        ajaxnav: true

    }

    var dispatchedWidgetIds = [];
    var setupWaiting = false;

    var debug = 1;

    var setupWidgets = function (element, widgetIds) {

        if (!setupWaiting) {

            if(_.intersection(widgetIds, dispatchedWidgetIds).length != widgetIds.length){

                dispatchedWidgetIds = _.union(widgetIds, dispatchedWidgetIds);

//                    console.log('setupWidgets', debug++);

                element.data('jarvisWidgets') && element.data('jarvisWidgets').destroy();
                element.jarvisWidgets(jarvisWidgetsDefaults);
                initDropdowns(widgetIds);
            }

        } else {
            if (!setupWaiting) {
                setupWaiting = true;
                $timeout(function () {
                    setupWaiting = false;
                    setupWidgets(element, widgetIds)
                }, 200);
            }
        }

    };

    var destroyWidgets = function(element, widgetIds){
        element.data('jarvisWidgets') && element.data('jarvisWidgets').destroy();
        dispatchedWidgetIds = _.xor(dispatchedWidgetIds, widgetIds);
    };

    var initDropdowns = function (widgetIds) {
        angular.forEach(widgetIds, function (wid) {
            $('#' + wid + ' [data-toggle="dropdown"]').each(function () {
                var $parent = $(this).parent();
                // $(this).removeAttr('data-toggle');
                if (!$parent.attr('dropdown')) {
                    $(this).removeAttr('href');
                    $parent.attr('dropdown', '');
                    var compiled = $compile($parent)($parent.scope())
                    $parent.replaceWith(compiled);
                }
            })
        });
    };

    var jarvisWidgetAddedOff,
        $viewContentLoadedOff,
        $stateChangeStartOff;

    return {
        restrict: 'A',
        compile: function(element){

            element.removeAttr('widget-grid data-widget-grid');

            var widgetIds = [];

            $viewContentLoadedOff = $rootScope.$on('$viewContentLoaded', function (event, data) {
                $timeout(function () {
                    setupWidgets(element, widgetIds)
                }, 100);
            });


            $stateChangeStartOff = $rootScope.$on('$stateChangeStart',
                function(event, toState, toParams, fromState, fromParams){
                    jarvisWidgetAddedOff();
                    $viewContentLoadedOff();
                    $stateChangeStartOff();
                    destroyWidgets(element, widgetIds)
                });

            jarvisWidgetAddedOff = $rootScope.$on('jarvisWidgetAdded', function (event, widget) {
                if (widgetIds.indexOf(widget.attr('id')) == -1) {
                    widgetIds.push(widget.attr('id'));
                    $timeout(function () {
                        setupWidgets(element, widgetIds)
                    }, 100);
                }
//                    console.log('jarvisWidgetAdded', widget.attr('id'));
            });

        }
    }
});
;
/**
 * Jarvis Widget Directive
 *
 *    colorbutton="false"
 *    editbutton="false"
      togglebutton="false"
       deletebutton="false"
        fullscreenbutton="false"
        custombutton="false"
        collapsed="true"
          sortable="false"
 *
 *
 */
"use strict";

angular.module('SmartAdmin.Layout').directive('jarvisWidget', function($rootScope){
    return {
        restrict: "A",
        compile: function(element, attributes){
            if(element.data('widget-color'))
                element.addClass('jarviswidget-color-' + element.data('widget-color'));


            element.find('.widget-body').prepend('<div class="jarviswidget-editbox"><input class="form-control" type="text"></div>');

            element.addClass('jarviswidget');
            $rootScope.$emit('jarvisWidgetAdded', element )

        }
    }
});;
(function(){
    "use strict";

    angular.module('SmartAdmin.Layout').directive('smartMenuItems', function ($http, $rootScope, $compile) {
    return {
        restrict: 'A',
        compile: function (element, attrs) {
            

            function createItem(item, parent, level){
                var li = $('<li />' ,{'ui-sref-active': "active"})
                var a = $('<a />');
                var i = $('<i />');

                li.append(a);

                if(item.sref)
                    a.attr('ui-sref', item.sref);
                if(item.href)
                    a.attr('href', item.href);
                if(item.icon){
                    i.attr('class', 'fa fa-lg fa-fw fa-'+item.icon);
                    a.append(i);
                }
                if(item.title){
                    a.attr('title', item.title);
                    if(level == 1){ 
                        a.append(' <span class="menu-item-parent">' + item.title + '</span>');
                    } else {
                        a.append(' ' + item.title);

                    }
                }

                if(item.items){
                    var ul = $('<ul />');
                    li.append(ul);
                    li.attr('data-menu-collapse', '');
                    _.forEach(item.items, function(child) {
                        createItem(child, ul, level+1);
                    })
                } 

                parent.append(li); 
            }


            $http.get(attrs.smartMenuItems).then(function(res){
                var ul = $('<ul />', {
                    'smart-menu': ''
                })
                _.forEach(res.data.items, function(item) {
                    createItem(item, ul, 1);
                })
                
                var $scope = $rootScope.$new();
                var html = $('<div>').append(ul).html(); 
                var linkingFunction = $compile(html);
                
                var _element = linkingFunction($scope);

                element.replaceWith(_element);                
            })
        }
    }
});
})();;
"use strict";

(function ($) {

    $.fn.smartCollapseToggle = function () {

        return this.each(function () {

            var $body = $('body');
            var $this = $(this);

            // only if not  'menu-on-top'
            if ($body.hasClass('menu-on-top')) {


            } else {

                $body.hasClass('mobile-view-activated')

                // toggle open
                $this.toggleClass('open');

                // for minified menu collapse only second level
                if ($body.hasClass('minified')) {
                    if ($this.closest('nav ul ul').length) {
                        $this.find('>a .collapse-sign .fa').toggleClass('fa-minus-square-o fa-plus-square-o');
                        $this.find('ul:first').slideToggle(200);
                    }
                } else {
                    // toggle expand item
                    $this.find('>a .collapse-sign .fa').toggleClass('fa-minus-square-o fa-plus-square-o');
                    $this.find('ul:first').slideToggle( 200);
                }
            }
        });
    };
})(jQuery);

angular.module('SmartAdmin.Layout').directive('smartMenu', function ($state, $rootScope,$timeout) {
    // Stocker les éléments li déjà pris en compte
    var processedLiElements = new Set();

    
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var $body = $('body');

            var $collapsible = element.find('li[data-menu-collapse]');

            var bindEvents = function(){
                $collapsible = element.find('li[data-menu-collapse]');
                $collapsible.each(function (idx, li) {
                    var $li = $(li);
                    // Vérifier si cet élément li a déjà été pris en compte
                    if (!processedLiElements.has($li[0])) {
	                    $li
	                        .on('click', '>a', function (e) {
	
	                            // collapse all open siblings
	                            $li.siblings('.open').smartCollapseToggle();
	
	                            // toggle element
	                            $li.smartCollapseToggle();
	
	                            // add active marker to collapsed element if it has active childs
	                            if (!$li.hasClass('open') && $li.find('li.active').length > 0) {
	                                $li.addClass('active')
	                            }
	
	                            e.preventDefault();
	                        })
	                        .find('>a').append('<b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>');
	
	                    // initialization toggle
	                    if ($li.find('li.active').length) {
	                        $li.smartCollapseToggle();
	                        $li.find('li.active').parents('li').addClass('active');
	                    }
	                    // Ajouter cet élément li à la liste des éléments déjà traités
	                    processedLiElements.add($li[0]);
                    }
                });
            }
        //    bindEvents();
            
            var refreshMenu = function() {
                bindEvents();
            };
            $timeout(function() {
            	refreshMenu();
            }
            );

        //    $rootScope.$on('refreshSmartMenu',refreshMenu);
 
            
            
            // click on route link
            element.on('click', 'a[data-ui-sref]', function (e) {
                // collapse all siblings to element parents and remove active markers
                $(this)
                    .parents('li').addClass('active')
                    .each(function () {
                        $(this).siblings('li.open').smartCollapseToggle();
                        $(this).siblings('li').removeClass('active')
                    });

                if ($body.hasClass('mobile-view-activated')) {
                    $rootScope.$broadcast('requestToggleMenu');
                }
            });


            scope.$on('$smartLayoutMenuOnTop', function (event, menuOnTop) {
                if (menuOnTop) {
                    $collapsible.filter('.open').smartCollapseToggle();
                }
            });
        }
    }
});;
"use strict";

angular.module('SmartAdmin.Forms').directive('smartXeditable', function($timeout, $log){

	function link (scope, element, attrs, ngModel) {

        var defaults = {
            // display: function(value, srcData) {
            //     ngModel.$setViewValue(value);
            //     // scope.$apply();
            // }
        };

        var inited = false;

        var initXeditable = function() {

            var options = scope.options || {};
    		var initOptions = angular.extend(defaults, options);

            // $log.log(initOptions);
            element.editable('destroy');
            element.editable(initOptions);
        }

        scope.$watch("options", function(newValue) {

            if(!newValue) {
                return false;
            }

            initXeditable();

            // $log.log("Options changed...");

        }, true);

    }

    return {
    	restrict: 'A',
    	require: "ngModel",
        scope: {
            options: "="
        },
    	link: link 

    }
});;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartUislider', function ($parse, lazyScript) {
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {

            tElement.removeAttr('smart-uislider data-smart-uislider');

            lazyScript.register('build/vendor.ui.js').then(function(){
			    tElement.bootstrapSlider();

			    $(tElement.data('bootstrapSlider').sliderElem).prepend(tElement);      	
            })

        }
    }
});;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartTimepicker', function () {
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {
            tElement.removeAttr('smart-timepicker data-smart-timepicker');
            tElement.timepicker();
        }
    }
});
;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartTagsinput', function () {
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {
            tElement.removeAttr('smart-tagsinput data-smart-tagsinput');
            tElement.tagsinput();
        }
    }
});;
'use strict'

angular.module('SmartAdmin.Forms').directive('smartSpinner', function () {
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {
            tElement.removeAttr('smart-spinner');

            var options = {};
            if(tAttributes.smartSpinner == 'deicimal'){
                options = {
                    step: 0.01,
                    numberFormat: "n"
                };
            }else if(tAttributes.smartSpinner == 'currency'){
                options = {
                    min: 5,
                    max: 2500,
                    step: 25,
                    start: 1000,
                    numberFormat: "C"
                };
            }

            tElement.spinner(options);
        }
    }
});;
'use strict'

angular.module('SmartAdmin.Forms').directive('smartSelect2', function (lazyScript) {
    return {
        restrict: 'A',
        compile: function (element, attributes) {
            element.hide().removeAttr('smart-select2 data-smart-select2');
        	lazyScript.register('build/vendor.ui.js').then(function(){
	            element.show().select2();
        	})
        }
    }
});;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartNouislider', function ($parse, lazyScript) {
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {
            lazyScript.register('build/vendor.ui.js').then(function(){
                tElement.removeAttr('smart-nouislider data-smart-nouislider');

                tElement.addClass('noUiSlider');

                var options = {
                    range: {
                        min: tAttributes.rangeMin ? parseInt(tAttributes.rangeMin) : 0,
                        max: tAttributes.rangeMax ? parseInt(tAttributes.rangeMax) : 1000
                    },
                    start: $parse(tAttributes.start)()
                };

                if (tAttributes.step) options.step =  parseInt(tAttributes.step);

                if(tAttributes.connect) options.connect = tAttributes.connect == 'true' ? true : tAttributes.connect;

                tElement.noUiSlider(options);

                if(tAttributes.update) tElement.on('slide', function(){
                    $(tAttributes.update).text(JSON.stringify(tElement.val()));
                });                
            })
        }
    }
});;
"use strict";

angular.module('SmartAdmin.Forms').directive('smartMaskedInput', function(lazyScript){
    return {
        restrict: 'A',
        compile: function(tElement, tAttributes){
            tElement.removeAttr('smart-masked-input data-smart-masked-input');

        	lazyScript.register('build/vendor.ui.js').then(function(){

	            var options = {};
	            if(tAttributes.maskPlaceholder) options.placeholder =  tAttributes.maskPlaceholder;
	            tElement.mask(tAttributes.smartMaskedInput, options);
        	})	            
        }
    }
});;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartKnob', function () {
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {
            tElement.removeAttr('smart-knob data-smart-knob');

            tElement.knob();
        }
    }
});;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartIonslider', function (lazyScript) {
    return {
        restrict: 'A',
        compile: function (element, attributes) {
            element.removeAttr('smart-ionslider data-smart-ionslider');

        	lazyScript.register('build/vendor.ui.js').then(function(){
            	element.ionRangeSlider();
        	});
        }
    }
});;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartDuallistbox', function () {
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {
            tElement.removeAttr('smart-duallistbox data-smart-duallistbox');


            var aOptions = _.pick(tAttributes, ['nonSelectedFilter']);

            var options = _.extend(aOptions, {
                nonSelectedListLabel: 'Non-selected',
                selectedListLabel: 'Selected',
                preserveSelectionOnMove: 'moved',
                moveOnSelect: false
            });

            tElement.bootstrapDualListbox(options);
        }
    }
});
;
"use strict";

angular.module('SmartAdmin.Forms').directive('smartDatepicker', function () {
    return {
        restrict: 'A',
        scope: {
            options: '='
        },
        link: function (scope, element, attributes) {

            var onSelectCallbacks = [];
            if (attributes.minRestrict) {
                onSelectCallbacks.push(function (selectedDate) {
                    $(attributes.minRestrict).datepicker('option', 'minDate', selectedDate);
                });
            }
            if (attributes.maxRestrict) {
                onSelectCallbacks.push(function (selectedDate) {
                    $(attributes.maxRestrict).datepicker('option', 'maxDate', selectedDate);
                });
            }

            //Let others know about changes to the data field
            onSelectCallbacks.push(function (selectedDate) {
                //CVB - 07/14/2015 - Update the scope with the selected value
                element.triggerHandler("change");

                //CVB - 07/17/2015 - Update Bootstrap Validator
                var form = element.closest('form');

                if(typeof form.bootstrapValidator == 'function')
                    form.bootstrapValidator('revalidateField', element.attr('name'));
            });

            var options = _.extend({
                prevText: '<i class="fa fa-chevron-left"></i>',
                nextText: '<i class="fa fa-chevron-right"></i>',
                onSelect: function (selectedDate) {
                    angular.forEach(onSelectCallbacks, function (callback) {
                        callback.call(this, selectedDate)
                    })
                }
            }, scope.options || {});


            if (attributes.numberOfMonths) options.numberOfMonths = parseInt(attributes.numberOfMonths);

            if (attributes.dateFormat) options.dateFormat = attributes.dateFormat;

            if (attributes.defaultDate) options.defaultDate = attributes.defaultDate;

            if (attributes.changeMonth) options.changeMonth = attributes.changeMonth == "true";


            element.datepicker(options)
        }
    }
});;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartColorpicker', function () {
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {
            tElement.removeAttr('smart-colorpicker data-smart-colorpicker');


            var aOptions = _.pick(tAttributes, ['']);

            var options = _.extend(aOptions, {});

            tElement.colorpicker(options);
        }
    }
});;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartClockpicker', function () {
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {
            tElement.removeAttr('smart-clockpicker data-smart-clockpicker');

            var options = {
                placement: 'top',
                donetext: 'Done'
            }

            tElement.clockpicker(options);
        }
    }
});
;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartSummernoteEditor', function (lazyScript) {
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {
            tElement.removeAttr('smart-summernote-editor data-smart-summernote-editor');

            var options = {
                focus : true,
                tabsize : 2
            };

            if(tAttributes.height){
                options.height = tAttributes.height;
            }

            lazyScript.register('build/vendor.ui.js').then(function(){
                tElement.summernote(options);                
            });
        }
    }
});;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartMarkdownEditor', function () {
    return {
        restrict: 'A',
        compile: function (element, attributes) {
            element.removeAttr('smart-markdown-editor data-smart-markdown-editor')

            var options = {
                autofocus:false,
                savable:true,
                fullscreen: {
                    enable: false
                }
            };

            if(attributes.height){
                options.height = parseInt(attributes.height);
            }

            element.markdown(options);
        }
    }
});
;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartEditSummernote', function () {
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {
            tElement.removeAttr('smart-edit-summernote data-smart-edit-summernote');
            tElement.on('click', function(){
                angular.element(tAttributes.smartEditSummernote).summernote({
                    focus : true
                });  
            });
        }
    }
});
;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartDestroySummernote', function () {
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {
            tElement.removeAttr('smart-destroy-summernote data-smart-destroy-summernote')
            tElement.on('click', function() {
                angular.element(tAttributes.smartDestroySummernote).destroy();
            })
        }
    }
});
;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartCkEditor', function () {
    return {
        restrict: 'A',
        compile: function ( tElement) {
            tElement.removeAttr('smart-ck-editor data-smart-ck-editor');
            //CKEDITOR.basePath = 'bower_components/ckeditor/';

            CKEDITOR.replace( tElement.attr('name'), { height: '380px', startupFocus : true} );
        }
    }
});;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartReviewForm', function (formsCommon, lazyScript) {
    return {
        restrict: 'E',
        link: function (scope, form) {
            lazyScript.register('build/vendor.ui.js').then(function(){

                form.validate(angular.extend({
                    // Rules for form validation
                    rules : {
                        name : {
                            required : true
                        },
                        email : {
                            required : true,
                            email : true
                        },
                        review : {
                            required : true,
                            minlength : 20
                        },
                        quality : {
                            required : true
                        },
                        reliability : {
                            required : true
                        },
                        overall : {
                            required : true
                        }
                    },

                    // Messages for form validation
                    messages : {
                        name : {
                            required : 'Please enter your name'
                        },
                        email : {
                            required : 'Please enter your email address',
                            email : '<i class="fa fa-warning"></i><strong>Please enter a VALID email addres</strong>'
                        },
                        review : {
                            required : 'Please enter your review'
                        },
                        quality : {
                            required : 'Please rate quality of the product'
                        },
                        reliability : {
                            required : 'Please rate reliability of the product'
                        },
                        overall : {
                            required : 'Please rate the product'
                        }
                    }

                }, formsCommon.validateOptions));
            });
        }
    }
});;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartRegistrationForm', function (formsCommon, lazyScript) {
    return {
        restrict: 'A',
        link: function (scope, form, attributes) {
            lazyScript.register('build/vendor.ui.js').then(function(){
                form.validate(angular.extend({

                    // Rules for form validation
                    rules: {
                        username: {
                            required: true
                        },
                        email: {
                            required: true,
                            email: true
                        },
                        password: {
                            required: true,
                            minlength: 3,
                            maxlength: 20
                        },
                        passwordConfirm: {
                            required: true,
                            minlength: 3,
                            maxlength: 20,
                            equalTo: '#password'
                        },
                        firstname: {
                            required: true
                        },
                        lastname: {
                            required: true
                        },
                        gender: {
                            required: true
                        },
                        terms: {
                            required: true
                        }
                    },

                    // Messages for form validation
                    messages: {
                        login: {
                            required: 'Please enter your login'
                        },
                        email: {
                            required: 'Please enter your email address',
                            email: 'Please enter a VALID email address'
                        },
                        password: {
                            required: 'Please enter your password'
                        },
                        passwordConfirm: {
                            required: 'Please enter your password one more time',
                            equalTo: 'Please enter the same password as above'
                        },
                        firstname: {
                            required: 'Please select your first name'
                        },
                        lastname: {
                            required: 'Please select your last name'
                        },
                        gender: {
                            required: 'Please select your gender'
                        },
                        terms: {
                            required: 'You must agree with Terms and Conditions'
                        }
                    }

                }, formsCommon.validateOptions));
            });
        }
    }
});;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartOrderForm', function (formsCommon, lazyScript) {
    return {
        restrict: 'E',
        link: function (scope, form) {
            lazyScript.register('build/vendor.ui.js').then(function(){
                form.validate(angular.extend({
                    // Rules for form validation
                    rules : {
                        name : {
                            required : true
                        },
                        email : {
                            required : true,
                            email : true
                        },
                        phone : {
                            required : true
                        },
                        interested : {
                            required : true
                        },
                        budget : {
                            required : true
                        }
                    },

                    // Messages for form validation
                    messages : {
                        name : {
                            required : 'Please enter your name'
                        },
                        email : {
                            required : 'Please enter your email address',
                            email : 'Please enter a VALID email address'
                        },
                        phone : {
                            required : 'Please enter your phone number'
                        },
                        interested : {
                            required : 'Please select interested service'
                        },
                        budget : {
                            required : 'Please select your budget'
                        }
                    },

                }, formsCommon.validateOptions));
            });

        }
    }
});;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartContactsForm', function (formsCommon, lazyScript) {
    return {
        restrict: 'A',
        link: function (scope, form) {
            lazyScript.register('build/vendor.ui.js').then(function(){
                form.validate(angular.extend({
                    // Rules for form validation
                    rules : {
                        name : {
                            required : true
                        },
                        email : {
                            required : true,
                            email : true
                        },
                        message : {
                            required : true,
                            minlength : 10
                        }
                    },

                    // Messages for form validation
                    messages : {
                        name : {
                            required : 'Please enter your name'
                        },
                        email : {
                            required : 'Please enter your email address',
                            email : 'Please enter a VALID email address'
                        },
                        message : {
                            required : 'Please enter your message'
                        }
                    },

                    // Ajax form submition
                    submitHandler : function() {
                        form.ajaxSubmit({
                            success : function() {
                                form.addClass('submited');
                            }
                        });
                    }
                }, formsCommon.validateOptions));
            });
        }
    }
});;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartCommentForm', function (formsCommon, lazyScript) {
    return {
        restrict: 'A',
        link: function (scope, form) {
            lazyScript.register('build/vendor.ui.js').then(function(){
                form.validate(angular.extend({
                    // Rules for form validation
                    rules : {
                        name : {
                            required : true
                        },
                        email : {
                            required : true,
                            email : true
                        },
                        url : {
                            url : true
                        },
                        comment : {
                            required : true
                        }
                    },

                    // Messages for form validation
                    messages : {
                        name : {
                            required : 'Enter your name',
                        },
                        email : {
                            required : 'Enter your email address',
                            email : 'Enter a VALID email'
                        },
                        url : {
                            email : 'Enter a VALID url'
                        },
                        comment : {
                            required : 'Please enter your comment'
                        }
                    },

                    // Ajax form submition
                    submitHandler : function() {
                        form.ajaxSubmit({
                            success : function() {
                                form.addClass('submited');
                            }
                        });
                    }

                }, formsCommon.validateOptions));
            });

        }
    }
});
;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartCheckoutForm', function (formsCommon, lazyScript) {
    return {
        restrict: 'A',
        link: function (scope, form) {
           lazyScript.register('build/vendor.ui.js').then(function(){

               scope.countries = formsCommon.countries;

               form.validate(angular.extend({
                    // Rules for form validation
                    rules : {
                        fname : {
                            required : true
                        },
                        lname : {
                            required : true
                        },
                        email : {
                            required : true,
                            email : true
                        },
                        phone : {
                            required : true
                        },
                        country : {
                            required : true
                        },
                        city : {
                            required : true
                        },
                        code : {
                            required : true,
                            digits : true
                        },
                        address : {
                            required : true
                        },
                        name : {
                            required : true
                        },
                        card : {
                            required : true,
                            creditcard : true
                        },
                        cvv : {
                            required : true,
                            digits : true
                        },
                        month : {
                            required : true
                        },
                        year : {
                            required : true,
                            digits : true
                        }
                    },

                    // Messages for form validation
                    messages : {
                        fname : {
                            required : 'Please enter your first name'
                        },
                        lname : {
                            required : 'Please enter your last name'
                        },
                        email : {
                            required : 'Please enter your email address',
                            email : 'Please enter a VALID email address'
                        },
                        phone : {
                            required : 'Please enter your phone number'
                        },
                        country : {
                            required : 'Please select your country'
                        },
                        city : {
                            required : 'Please enter your city'
                        },
                        code : {
                            required : 'Please enter code',
                            digits : 'Digits only please'
                        },
                        address : {
                            required : 'Please enter your full address'
                        },
                        name : {
                            required : 'Please enter name on your card'
                        },
                        card : {
                            required : 'Please enter your card number'
                        },
                        cvv : {
                            required : 'Enter CVV2',
                            digits : 'Digits only'
                        },
                        month : {
                            required : 'Select month'
                        },
                        year : {
                            required : 'Enter year',
                            digits : 'Digits only please'
                        }
                    }
                }, formsCommon.validateOptions));
            });
        }
    }
});;
'use strict';

angular.module('SmartAdmin.Forms').directive('smartJcrop', function ($q) {
    return {
        restrict: 'A',
        scope: {
            coords: '=',
            options: '=',
            selection: '='
        },
        link: function (scope, element, attributes) {
            var jcropApi, imageWidth, imageHeight, imageLoaded = $q.defer();

            var listeners = {
                onSelectHandlers: [],
                onChangeHandlers: [],
                onSelect: function (c) {
                    angular.forEach(listeners.onSelectHandlers, function (handler) {
                        handler.call(jcropApi, c)
                    })
                },
                onChange: function (c) {
                    angular.forEach(listeners.onChangeHandlers, function (handler) {
                        handler.call(jcropApi, c)
                    })
                }
            };

            if (attributes.coords) {
                var coordsUpdate = function (c) {
                    scope.$apply(function () {
                        scope.coords = c;
                    });
                };
                listeners.onSelectHandlers.push(coordsUpdate);
                listeners.onChangeHandlers.push(coordsUpdate);
            }

            var $previewPane = $(attributes.smartJcropPreview),
                $previewContainer = $previewPane.find('.preview-container'),
                $previewImg = $previewPane.find('img');

            if ($previewPane.length && $previewImg.length) {
                var previewUpdate = function (coords) {
                    if (parseInt(coords.w) > 0) {
                        var rx = $previewContainer.width() / coords.w;
                        var ry = $previewContainer.height() / coords.h;

                        $previewImg.css({
                            width: Math.round(rx * imageWidth) + 'px',
                            height: Math.round(ry * imageHeight) + 'px',
                            marginLeft: '-' + Math.round(rx * coords.x) + 'px',
                            marginTop: '-' + Math.round(ry * coords.y) + 'px'
                        });
                    }
                };
                listeners.onSelectHandlers.push(previewUpdate);
                listeners.onChangeHandlers.push(previewUpdate);
            }


            var options = {
                onSelect: listeners.onSelect,
                onChange: listeners.onChange
            };

            if ($previewContainer.length) {
                options.aspectRatio = $previewContainer.width() / $previewContainer.height()
            }

            if (attributes.selection) {
                scope.$watch('selection', function (newVal, oldVal) {
                    if (newVal != oldVal) {
                        var rectangle = newVal == 'release' ? [imageWidth / 2, imageHeight / 2, imageWidth / 2, imageHeight / 2] : newVal;

                        var callback = newVal == 'release' ? function () {
                            jcropApi.release();
                        } : angular.noop;

                        imageLoaded.promise.then(function () {
                            if (scope.options && scope.options.animate) {
                                jcropApi.animateTo(rectangle, callback);
                            } else {
                                jcropApi.setSelect(rectangle);
                            }
                        });
                    }
                });
            }

            if (attributes.options) {

                var optionNames = [
                    'bgOpacity', 'bgColor', 'bgFade', 'shade', 'outerImage',
                    'allowSelect', 'allowMove', 'allowResize',
                    'aspectRatio'
                ];

                angular.forEach(optionNames, function (name) {
                    if (scope.options[name])
                        options[name] = scope.options[name]

                    scope.$watch('options.' + name, function (newVal, oldVal) {
                        if (newVal != oldVal) {
                            imageLoaded.promise.then(function () {
                                var update = {};
                                update[name] = newVal;
                                jcropApi.setOptions(update);
                            });
                        }
                    });

                });


                scope.$watch('options.disabled', function (newVal, oldVal) {
                    if (newVal != oldVal) {
                        if (newVal) {
                            jcropApi.disable();
                        } else {
                            jcropApi.enable();
                        }
                    }
                });

                scope.$watch('options.destroyed', function (newVal, oldVal) {
                    if (newVal != oldVal) {
                        if (newVal) {
                            jcropApi.destroy();
                        } else {
                            _init();
                        }
                    }
                });

                scope.$watch('options.src', function (newVal, oldVal) {
                    imageLoaded = $q.defer();
                    if (newVal != oldVal) {
                        jcropApi.setImage(scope.options.src, function () {
                            imageLoaded.resolve();
                        });
                    }
                });

                var updateSize = function(){
                    jcropApi.setOptions({
                        minSize: [scope.options.minSizeWidth, scope.options.minSizeHeight],
                        maxSize: [scope.options.maxSizeWidth, scope.options.maxSizeHeight]
                    });
                };

                scope.$watch('options.minSizeWidth', function (newVal, oldVal) {
                    if (newVal != oldVal) updateSize();
                });
                scope.$watch('options.minSizeHeight', function (newVal, oldVal) {
                    if (newVal != oldVal) updateSize();
                });
                scope.$watch('options.maxSizeWidth', function (newVal, oldVal) {
                    if (newVal != oldVal) updateSize();
                });
                scope.$watch('options.maxSizeHeight', function (newVal, oldVal) {
                    if (newVal != oldVal) updateSize();
                });
            }

            var _init = function () {
                element.Jcrop(options, function () {
                    jcropApi = this;
                    // Use the API to get the real image size
                    var bounds = this.getBounds();
                    imageWidth = bounds[0];
                    imageHeight = bounds[1];

                    if (attributes.selection && angular.isArray(scope.selection)) {
                        if (scope.options && scope.options.animate) {
                            jcropApi.animateTo(scope.selection);
                        } else {
                            jcropApi.setSelect(scope.selection);
                        }
                    }
                    imageLoaded.resolve();
                });
            };

            _init()


        }
    }
});;
"use strict";


angular.module('SmartAdmin.Forms').directive('bootstrapTogglingForm', function(){

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/_common/forms/directives/bootstrap-validation/bootstrap-toggling-form.tpl.html',
        link: function(scope, form){
            form.bootstrapValidator({
                feedbackIcons : {
                    valid : 'glyphicon glyphicon-ok',
                    invalid : 'glyphicon glyphicon-remove',
                    validating : 'glyphicon glyphicon-refresh'
                },
                fields : {
                    firstName : {
                        validators : {
                            notEmpty : {
                                message : 'The first name is required'
                            }
                        }
                    },
                    lastName : {
                        validators : {
                            notEmpty : {
                                message : 'The last name is required'
                            }
                        }
                    },
                    company : {
                        validators : {
                            notEmpty : {
                                message : 'The company name is required'
                            }
                        }
                    },
                    // These fields will be validated when being visible
                    job : {
                        validators : {
                            notEmpty : {
                                message : 'The job title is required'
                            }
                        }
                    },
                    department : {
                        validators : {
                            notEmpty : {
                                message : 'The department name is required'
                            }
                        }
                    },
                    mobilePhone : {
                        validators : {
                            notEmpty : {
                                message : 'The mobile phone number is required'
                            },
                            digits : {
                                message : 'The mobile phone number is not valid'
                            }
                        }
                    },
                    // These fields will be validated when being visible
                    homePhone : {
                        validators : {
                            digits : {
                                message : 'The home phone number is not valid'
                            }
                        }
                    },
                    officePhone : {
                        validators : {
                            digits : {
                                message : 'The office phone number is not valid'
                            }
                        }
                    }
                }
            }).find('button[data-toggle]').on('click', function() {
                var $target = $($(this).attr('data-toggle'));
                // Show or hide the additional fields
                // They will or will not be validated based on their visibilities
                $target.toggle();
                if (!$target.is(':visible')) {
                    // Enable the submit buttons in case additional fields are not valid
                    form.data('bootstrapValidator').disableSubmitButtons(false);
                }
            });
        }

    }



});;
"use strict";


angular.module('SmartAdmin.Forms').directive('bootstrapProfileForm', function(){

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/_common/forms/directives/bootstrap-validation/bootstrap-profile-form.tpl.html',
        link: function(scope, form){
           form.bootstrapValidator({
                feedbackIcons : {
                    valid : 'glyphicon glyphicon-ok',
                    invalid : 'glyphicon glyphicon-remove',
                    validating : 'glyphicon glyphicon-refresh'
                },
                fields : {
                    email : {
                        validators : {
                            notEmpty : {
                                message : 'The email address is required'
                            },
                            emailAddress : {
                                message : 'The email address is not valid'
                            }
                        }
                    },
                    password : {
                        validators : {
                            notEmpty : {
                                message : 'The password is required'
                            }
                        }
                    }
                }
            });
        }

    }

});;
"use strict";


angular.module('SmartAdmin.Forms').directive('bootstrapProductForm', function(){

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/_common/forms/directives/bootstrap-validation/bootstrap-product-form.tpl.html',
        link: function(scope, form){
            form.bootstrapValidator({
                feedbackIcons : {
                    valid : 'glyphicon glyphicon-ok',
                    invalid : 'glyphicon glyphicon-remove',
                    validating : 'glyphicon glyphicon-refresh'
                },
                fields : {
                    price : {
                        validators : {
                            notEmpty : {
                                message : 'The price is required'
                            },
                            numeric : {
                                message : 'The price must be a number'
                            }
                        }
                    },
                    amount : {
                        validators : {
                            notEmpty : {
                                message : 'The amount is required'
                            },
                            numeric : {
                                message : 'The amount must be a number'
                            }
                        }
                    },
                    color : {
                        validators : {
                            notEmpty : {
                                message : 'The color is required'
                            }
                        }
                    },
                    size : {
                        validators : {
                            notEmpty : {
                                message : 'The size is required'
                            }
                        }
                    }
                }
            });
        }

    }
});;
"use strict";


angular.module('SmartAdmin.Forms').directive('bootstrapMovieForm', function(){

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/_common/forms/directives/bootstrap-validation/bootstrap-movie-form.tpl.html',
        link: function(scope, form){
            form.bootstrapValidator({
                feedbackIcons : {
                    valid : 'glyphicon glyphicon-ok',
                    invalid : 'glyphicon glyphicon-remove',
                    validating : 'glyphicon glyphicon-refresh'
                },
                fields : {
                    title : {
                        group : '.col-md-8',
                        validators : {
                            notEmpty : {
                                message : 'The title is required'
                            },
                            stringLength : {
                                max : 200,
                                message : 'The title must be less than 200 characters long'
                            }
                        }
                    },
                    genre : {
                        group : '.col-md-4',
                        validators : {
                            notEmpty : {
                                message : 'The genre is required'
                            }
                        }
                    },
                    director : {
                        group : '.col-md-4',
                        validators : {
                            notEmpty : {
                                message : 'The director name is required'
                            },
                            stringLength : {
                                max : 80,
                                message : 'The director name must be less than 80 characters long'
                            }
                        }
                    },
                    writer : {
                        group : '.col-md-4',
                        validators : {
                            notEmpty : {
                                message : 'The writer name is required'
                            },
                            stringLength : {
                                max : 80,
                                message : 'The writer name must be less than 80 characters long'
                            }
                        }
                    },
                    producer : {
                        group : '.col-md-4',
                        validators : {
                            notEmpty : {
                                message : 'The producer name is required'
                            },
                            stringLength : {
                                max : 80,
                                message : 'The producer name must be less than 80 characters long'
                            }
                        }
                    },
                    website : {
                        group : '.col-md-6',
                        validators : {
                            notEmpty : {
                                message : 'The website address is required'
                            },
                            uri : {
                                message : 'The website address is not valid'
                            }
                        }
                    },
                    trailer : {
                        group : '.col-md-6',
                        validators : {
                            notEmpty : {
                                message : 'The trailer link is required'
                            },
                            uri : {
                                message : 'The trailer link is not valid'
                            }
                        }
                    },
                    review : {
                        // The group will be set as default (.form-group)
                        validators : {
                            stringLength : {
                                max : 500,
                                message : 'The review must be less than 500 characters long'
                            }
                        }
                    },
                    rating : {
                        // The group will be set as default (.form-group)
                        validators : {
                            notEmpty : {
                                message : 'The rating is required'
                            }
                        }
                    }
                }
            });

        }

    }

});;
"use strict";


angular.module('SmartAdmin.Forms').directive('bootstrapContactForm', function(){

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/_common/forms/directives/bootstrap-validation/bootstrap-contact-form.tpl.html',
        link: function(scope, form){
            form.bootstrapValidator({
                container : '#messages',
                feedbackIcons : {
                    valid : 'glyphicon glyphicon-ok',
                    invalid : 'glyphicon glyphicon-remove',
                    validating : 'glyphicon glyphicon-refresh'
                },
                fields : {
                    fullName : {
                        validators : {
                            notEmpty : {
                                message : 'The full name is required and cannot be empty'
                            }
                        }
                    },
                    email : {
                        validators : {
                            notEmpty : {
                                message : 'The email address is required and cannot be empty'
                            },
                            emailAddress : {
                                message : 'The email address is not valid'
                            }
                        }
                    },
                    title : {
                        validators : {
                            notEmpty : {
                                message : 'The title is required and cannot be empty'
                            },
                            stringLength : {
                                max : 100,
                                message : 'The title must be less than 100 characters long'
                            }
                        }
                    },
                    content : {
                        validators : {
                            notEmpty : {
                                message : 'The content is required and cannot be empty'
                            },
                            stringLength : {
                                max : 500,
                                message : 'The content must be less than 500 characters long'
                            }
                        }
                    }
                }
            });

        }

    }

});;
"use strict";


angular.module('SmartAdmin.Forms').directive('bootstrapButtonGroupForm', function(){

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/_common/forms/directives/bootstrap-validation/bootstrap-button-group-form.tpl.html',
        link: function(scope, form){
            form.bootstrapValidator({
                excluded : ':disabled',
                feedbackIcons : {
                    valid : 'glyphicon glyphicon-ok',
                    invalid : 'glyphicon glyphicon-remove',
                    validating : 'glyphicon glyphicon-refresh'
                },
                fields : {
                    gender : {
                        validators : {
                            notEmpty : {
                                message : 'The gender is required'
                            }
                        }
                    },
                    'languages[]' : {
                        validators : {
                            choice : {
                                min : 1,
                                max : 2,
                                message : 'Please choose 1 - 2 languages you can speak'
                            }
                        }
                    }
                }
            });


        }

    }
});;
"use strict";


angular.module('SmartAdmin.Forms').directive('bootstrapAttributeForm', function(){

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/_common/forms/directives/bootstrap-validation/bootstrap-attribute-form.tpl.html',
        link: function(scope, form){
            form.bootstrapValidator();


        }

    }
});;
'use strict';

angular.module('SmartAdmin.Layout').factory('SmartCss', function ($rootScope, $timeout) {

    var sheet = (function () {
        // Create the <style> tag
        var style = document.createElement("style");

        // Add a media (and/or media query) here if you'd like!
        // style.setAttribute("media", "screen")
        // style.setAttribute("media", "@media only screen and (max-width : 1024px)")

        // WebKit hack :(
        style.appendChild(document.createTextNode(""));

        // Add the <style> element to the page
        document.head.appendChild(style);

        return style.sheet;
    })();

    var _styles = {};


    var SmartCss = {
        writeRule: function(selector){
            SmartCss.deleteRuleFor(selector);
            if(_.has(_styles, selector)){
                var css = selector + '{ ' + _.map(_styles[selector], function(v, k){
                    return  k + ':' +  v + ';'
                }).join(' ') +'}';
                sheet.insertRule(css, _.size(_styles) - 1);
            }
        },
        add: function (selector, property, value, delay) {
            if(!_.has(_styles, selector))
                _styles[selector] = {};

            if(value == undefined || value == null || value == '')
                delete _styles[selector][property];
            else
                _styles[selector][property] = value;


            if(_.keys(_styles[selector]).length == 0)
                delete _styles[selector];

            if(!delay)
                delay = 0;
            $timeout(function(){
                SmartCss.writeRule(selector);
            }, delay);

        },
        remove: function(selector, property, delay){
            SmartCss.add(selector, property, null, delay);
        },
        deleteRuleFor: function (selector) {
            _(sheet.rules).forEach(function (rule, idx) {
                if (rule.selectorText == selector) {
                    sheet.deleteRule(idx);
                }
            });
        },
        appViewSize: null
    };

    $rootScope.$on('$smartContentResize', function (event, data) {
        SmartCss.appViewSize = data;
    });

    return SmartCss;

});



;
'use strict';

angular.module('SmartAdmin.Layout').factory('lazyScript', function($q, $http){

    var cache = {};

    function isPending(scriptName){
        return (cache.hasOwnProperty(scriptName) && cache[scriptName].promise && cache[scriptName].promise.$$state.pending)
    }

    function isRegistered(scriptName){
        return cache.hasOwnProperty(scriptName)
    }
    function loadScript(scriptName){
        if(!cache[scriptName]){
            cache[scriptName] = $q.defer();
            var el = document.createElement( 'script' );
            el.onload = function(script){
                console.log('script is lazy loaded:', scriptName)
                cache[scriptName].resolve(scriptName);
            };
            el.src = scriptName;
            var x = document.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(el, x);
            
        }
        return cache[scriptName].promise;

    }

    function register(scriptName){
        if(isPending(scriptName)){
            return cache[scriptName].promise
        }
        if(isRegistered(scriptName)){
            return $q.resolve(scriptName);
        } else {
            var dfd = $q.defer();

            loadScript(scriptName).then(function(){
                dfd.resolve(scriptName);
            });

            return dfd.promise; 

        }
    }
    return {
        register: function (scripts) {
            
            var dfd = $q.defer();
            var promises = [];
            if (angular.isString(scripts))
                scripts = [scripts];

            angular.forEach(scripts, function(script){
                promises.push(register(script));
            })

            $q.all(promises).then(function(resolves){
                dfd.resolve(resolves);
            })
            return dfd.promise;

        }
    };
});;
'use strict';

angular.module('SmartAdmin.Layout').directive('stateBreadcrumbs', function ($rootScope, $state) {


    return {
        restrict: 'EA',
        replace: true,
        template: '<ol class="breadcrumb"><li>Home</li></ol>',
        link: function (scope, element) {

            function setBreadcrumbs(breadcrumbs) {
                var html = '<li>Home</li>';
                angular.forEach(breadcrumbs, function (crumb) {
                    html += '<li>' + crumb + '</li>'
                });
                element.html(html)
            }

            function fetchBreadcrumbs(stateName, breadcrunbs) {

                var state = $state.get(stateName);

                if (state && state.data && state.data.title && breadcrunbs.indexOf(state.data.title) == -1) {
                    breadcrunbs.unshift(state.data.title)
                }

                var parentName = stateName.replace(/.?\w+$/, '');
                if (parentName) {
                    return fetchBreadcrumbs(parentName, breadcrunbs);
                } else {
                    return breadcrunbs;
                }
            }

            function processState(state) {
                var breadcrumbs;
                if (state.data && state.data.breadcrumbs) {
                    breadcrumbs = state.data.breadcrumbs;
                } else {
                    breadcrumbs = fetchBreadcrumbs(state.name, []);
                }
                setBreadcrumbs(breadcrumbs);
            }

            processState($state.current);

            $rootScope.$on('$stateChangeStart', function (event, state) {
                processState(state);
            })
        }
    }
});;
angular.module('SmartAdmin.Layout').directive('speechRecognition', function ($log) {
	'use strict';

	$.root_ = $('body');
	var root, commands;

    root = window;
    window.appConfig = window.appConfig || {};

	if (appConfig.voice_command) {
		commands = appConfig.commands;
	}


	/*
	 * SMART VOICE
	 * Author: MyOrange | @bootstraphunt
	 * http://www.myorange.ca
	 */

	var SpeechRecognition = root.SpeechRecognition || root.webkitSpeechRecognition || root.mozSpeechRecognition || root.msSpeechRecognition || root.oSpeechRecognition;

// ref: http://updates.html5rocks.com/2013/01/Voice-Driven-Web-Apps-Introduction-to-the-Web-Speech-API


// function
	$.speechApp = (function(speech) {

		speech.start = function() {

			// Add our commands to smartSpeechRecognition
			smartSpeechRecognition.addCommands(commands);

			if (smartSpeechRecognition) {
				// activate plugin
				smartSpeechRecognition.start();
				// add btn class
				$.root_.addClass("voice-command-active");
				// play sound
				$.speechApp.playON();
				// set localStorage when switch is on manually
				if (appConfig.voice_localStorage) {
					localStorage.setItem('sm-setautovoice', 'true');
				}

			} else {
				// if plugin not found
				alert("speech plugin not loaded");
			}

		};
		speech.stop = function() {

			if (smartSpeechRecognition) {
				// deactivate plugin
				smartSpeechRecognition.abort();
				// remove btn class
				$.root_.removeClass("voice-command-active");
				// sound
				$.speechApp.playOFF();
				// del localStorage when switch if off manually
				if (appConfig.voice_localStorage) {
					localStorage.setItem('sm-setautovoice', 'false');
				}
				// remove popover if visible
				if ($('#speech-btn .popover').is(':visible')) {
					$('#speech-btn .popover').fadeOut(250);
				}
			}

		};

		// play sound
		speech.playON = function() {

			var audioElement = document.createElement('audio');

			if (navigator.userAgent.match('Firefox/'))
				audioElement.setAttribute('src', appConfig.sound_path + 'voice_on' + ".ogg");
			else
				audioElement.setAttribute('src', appConfig.sound_path + 'voice_on' + ".mp3");

			//$.get();
			audioElement.addEventListener("load", function() {
				audioElement.play();
			}, true);

			if (appConfig.sound_on) {
				audioElement.pause();
				audioElement.play();
			}
		};

		speech.playOFF = function() {

			var audioElement = document.createElement('audio');

			if (navigator.userAgent.match('Firefox/'))
				audioElement.setAttribute('src', appConfig.sound_path + 'voice_off' + ".ogg");
			else
				audioElement.setAttribute('src', appConfig.sound_path + 'voice_off' + ".mp3");

			$.get();
			audioElement.addEventListener("load", function() {
				audioElement.play();
			}, true);

			if (appConfig.sound_on) {
				audioElement.pause();
				audioElement.play();
			}
		};

		speech.playConfirmation = function() {

			var audioElement = document.createElement('audio');

			if (navigator.userAgent.match('Firefox/'))
				audioElement.setAttribute('src', appConfig.sound_path + 'voice_alert' + ".ogg");
			else
				audioElement.setAttribute('src', appConfig.sound_path + 'voice_alert' + ".mp3");

			$.get();
			audioElement.addEventListener("load", function() {
				audioElement.play();
			}, true);

			if (appConfig.sound_on) {
				audioElement.pause();
				audioElement.play();
			}
		};

		return speech;

	})({});



	/*
	 * SPEECH RECOGNITION ENGINE
	 * Copyright (c) 2013 Tal Ater
	 * Modified by MyOrange
	 * All modifications made are hereby copyright (c) 2014 MyOrange
	 */

	(function(undefined) {"use strict";

		// Check browser support
		// This is done as early as possible, to make it as fast as possible for unsupported browsers
		if (!SpeechRecognition) {
			root.smartSpeechRecognition = null;
			return undefined;
		}

		var commandsList = [], recognition, callbacks = {
				start : [],
				error : [],
				end : [],
				result : [],
				resultMatch : [],
				resultNoMatch : [],
				errorNetwork : [],
				errorPermissionBlocked : [],
				errorPermissionDenied : []
			}, autoRestart, lastStartedAt = 0,
		//debugState = false, // decleared in app.appConfig.js
		//appConfig.debugStyle = 'font-weight: bold; color: #00f;', // decleared in app.appConfig.js

		// The command matching code is a modified version of Backbone.Router by Jeremy Ashkenas, under the MIT license.
			optionalParam = /\s*\((.*?)\)\s*/g, optionalRegex = /(\(\?:[^)]+\))\?/g, namedParam = /(\(\?)?:\w+/g, splatParam = /\*\w+/g, escapeRegExp = /[\-{}\[\]+?.,\\\^$|#]/g, commandToRegExp = function(command) {
				command = command.replace(escapeRegExp, '\\$&').replace(optionalParam, '(?:$1)?').replace(namedParam, function(match, optional) {
					return optional ? match : '([^\\s]+)';
				}).replace(splatParam, '(.*?)').replace(optionalRegex, '\\s*$1?\\s*');
				return new RegExp('^' + command + '$', 'i');
			};

		// This method receives an array of callbacks to iterate over, and invokes each of them
		var invokeCallbacks = function(callbacks) {
			callbacks.forEach(function(callback) {
				callback.callback.apply(callback.context);
			});
		};

		var initIfNeeded = function() {
			if (!isInitialized()) {
				root.smartSpeechRecognition.init({}, false);
			}
		};

		var isInitialized = function() {
			return recognition !== undefined;
		};

		root.smartSpeechRecognition = {
			// Initialize smartSpeechRecognition with a list of commands to recognize.
			// e.g. smartSpeechRecognition.init({'hello :name': helloFunction})
			// smartSpeechRecognition understands commands with named variables, splats, and optional words.
			init : function(commands, resetCommands) {

				// resetCommands defaults to true
				if (resetCommands === undefined) {
					resetCommands = true;
				} else {
					resetCommands = !!resetCommands;
				}

				// Abort previous instances of recognition already running
				if (recognition && recognition.abort) {
					recognition.abort();
				}

				// initiate SpeechRecognition
				recognition = new SpeechRecognition();

				// Set the max number of alternative transcripts to try and match with a command
				recognition.maxAlternatives = 5;
				recognition.continuous = true;
				// Sets the language to the default 'en-US'. This can be changed with smartSpeechRecognition.setLanguage()
				recognition.lang = appConfig.voice_command_lang || 'en-US';

				recognition.onstart = function() {
					invokeCallbacks(callbacks.start);
					//debugState
					if (appConfig.debugState) {
						root.console.log('%c ✔ SUCCESS: User allowed access the microphone service to start ', appConfig.debugStyle_success);
						root.console.log('Language setting is set to: ' + recognition.lang, appConfig.debugStyle);
					}
					$.root_.removeClass("service-not-allowed");
					$.root_.addClass("service-allowed");
				};

				recognition.onerror = function(event) {
					invokeCallbacks(callbacks.error);
					switch (event.error) {
						case 'network':
							invokeCallbacks(callbacks.errorNetwork);
							break;
						case 'not-allowed':
						case 'service-not-allowed':
							// if permission to use the mic is denied, turn off auto-restart
							autoRestart = false;
							$.root_.removeClass("service-allowed");
							$.root_.addClass("service-not-allowed");
							//debugState
							if (appConfig.debugState) {
								root.console.log('%c WARNING: Microphone was not detected (either user denied access or it is not installed properly) ', appConfig.debugStyle_warning);
							}
							// determine if permission was denied by user or automatically.
							if (new Date().getTime() - lastStartedAt < 200) {
								invokeCallbacks(callbacks.errorPermissionBlocked);
							} else {
								invokeCallbacks(callbacks.errorPermissionDenied);
								//console.log("You need your mic to be active")
							}
							break;
					}
				};

				recognition.onend = function() {
					invokeCallbacks(callbacks.end);
					// smartSpeechRecognition will auto restart if it is closed automatically and not by user action.
					if (autoRestart) {
						// play nicely with the browser, and never restart smartSpeechRecognition automatically more than once per second
						var timeSinceLastStart = new Date().getTime() - lastStartedAt;
						if (timeSinceLastStart < 1000) {
							setTimeout(root.smartSpeechRecognition.start, 1000 - timeSinceLastStart);
						} else {
							root.smartSpeechRecognition.start();
						}
					}
				};

				recognition.onresult = function(event) {
					invokeCallbacks(callbacks.result);

					var results = event.results[event.resultIndex], commandText;

					// go over each of the 5 results and alternative results received (we've set maxAlternatives to 5 above)
					for (var i = 0; i < results.length; i++) {
						// the text recognized
						commandText = results[i].transcript.trim();
						if (appConfig.debugState) {
							root.console.log('Speech recognized: %c' + commandText, appConfig.debugStyle);
						}

						// try and match recognized text to one of the commands on the list
						for (var j = 0, l = commandsList.length; j < l; j++) {
							var result = commandsList[j].command.exec(commandText);
							if (result) {
								var parameters = result.slice(1);
								if (appConfig.debugState) {
									root.console.log('command matched: %c' + commandsList[j].originalPhrase, appConfig.debugStyle);
									if (parameters.length) {
										root.console.log('with parameters', parameters);
									}
								}
								// execute the matched command
								commandsList[j].callback.apply(this, parameters);
								invokeCallbacks(callbacks.resultMatch);

								// for commands "sound on", "stop" and "mute" do not play sound or display message
								//var myMatchedCommand = commandsList[j].originalPhrase;

								var ignoreCallsFor = ["sound on", "mute", "stop"];

								if (ignoreCallsFor.indexOf(commandsList[j].originalPhrase) < 0) {
									// play sound when match found
									console.log(2);
									$.smallBox({
										title : (commandsList[j].originalPhrase),
										content : "loading...",
										color : "#333",
										sound_file : 'voice_alert',
										timeout : 2000
									});

									if ($('#speech-btn .popover').is(':visible')) {
										$('#speech-btn .popover').fadeOut(250);
									}
								}// end if

								return true;
							}
						} // end for
					}// end for

					invokeCallbacks(callbacks.resultNoMatch);
					//console.log("no match found for: " + commandText)
					$.smallBox({
						title : "Error: <strong>" + ' " ' + commandText + ' " ' + "</strong> no match found!",
						content : "Please speak clearly into the microphone",
						color : "#a90329",
						timeout : 5000,
						icon : "fa fa-microphone"
					});
					if ($('#speech-btn .popover').is(':visible')) {
						$('#speech-btn .popover').fadeOut(250);
					}
					return false;
				};

				// build commands list
				if (resetCommands) {
					commandsList = [];
				}
				if (commands.length) {
					this.addCommands(commands);
				}
			},

			// Start listening (asking for permission first, if needed).
			// Call this after you've initialized smartSpeechRecognition with commands.
			// Receives an optional options object:
			// { autoRestart: true }
			start : function(options) {
				initIfNeeded();
				options = options || {};
				if (options.autoRestart !== undefined) {
					autoRestart = !!options.autoRestart;
				} else {
					autoRestart = true;
				}
				lastStartedAt = new Date().getTime();
				recognition.start();
			},

			// abort the listening session (aka stop)
			abort : function() {
				autoRestart = false;
				if (isInitialized) {
					recognition.abort();
				}
			},

			// Turn on output of debug messages to the console. Ugly, but super-handy!
			debug : function(newState) {
				if (arguments.length > 0) {
					appConfig.debugState = !!newState;
				} else {
					appConfig.debugState = true;
				}
			},

			// Set the language the user will speak in. If not called, defaults to 'en-US'.
			// e.g. 'fr-FR' (French-France), 'es-CR' (Español-Costa Rica)
			setLanguage : function(language) {
				initIfNeeded();
				recognition.lang = language;
			},

			// Add additional commands that smartSpeechRecognition will respond to. Similar in syntax to smartSpeechRecognition.init()
			addCommands : function(commands) {
				var cb, command;

				initIfNeeded();

				for (var phrase in commands) {
					if (commands.hasOwnProperty(phrase)) {
						cb = root[commands[phrase]] || commands[phrase];
						if ( typeof cb !== 'function') {
							continue;
						}
						//convert command to regex
						command = commandToRegExp(phrase);

						commandsList.push({
							command : command,
							callback : cb,
							originalPhrase : phrase
						});
					}
				}
				if (appConfig.debugState) {
					root.console.log('Commands successfully loaded: %c' + commandsList.length, appConfig.debugStyle);
				}
			},

			// Remove existing commands. Called with a single phrase, array of phrases, or methodically. Pass no params to remove all commands.
			removeCommands : function(commandsToRemove) {
				if (commandsToRemove === undefined) {
					commandsList = [];
					return;
				}
				commandsToRemove = Array.isArray(commandsToRemove) ? commandsToRemove : [commandsToRemove];
				commandsList = commandsList.filter(function(command) {
					for (var i = 0; i < commandsToRemove.length; i++) {
						if (commandsToRemove[i] === command.originalPhrase) {
							return false;
						}
					}
					return true;
				});
			},

			// Lets the user add a callback of one of 9 types:
			// start, error, end, result, resultMatch, resultNoMatch, errorNetwork, errorPermissionBlocked, errorPermissionDenied
			// Can also optionally receive a context for the callback function as the third argument
			addCallback : function(type, callback, context) {
				if (callbacks[type] === undefined) {
					return;
				}
				var cb = root[callback] || callback;
				if ( typeof cb !== 'function') {
					return;
				}
				callbacks[type].push({
					callback : cb,
					context : context || this
				});
			}
		};

	}).call(this);

	var autoStart = function() {

		smartSpeechRecognition.addCommands(commands);

		if (smartSpeechRecognition) {
			// activate plugin
			smartSpeechRecognition.start();
			// add btn class
			$.root_.addClass("voice-command-active");
			// set localStorage when switch is on manually
			if (appConfig.voice_localStorage) {
				localStorage.setItem('sm-setautovoice', 'true');
			}

		} else {
			// if plugin not found
			alert("speech plugin not loaded");
		}
	}
// if already running with localstorage
	if (SpeechRecognition && appConfig.voice_command && localStorage.getItem('sm-setautovoice') == 'true') {
		autoStart();
	}

// auto start
	if (SpeechRecognition && appConfig.voice_command_auto && appConfig.voice_command) {
		autoStart();
	}


	var link = function(scope, element) {


		if (SpeechRecognition && appConfig.voice_command) {

			// create dynamic modal instance
			var modal = $('<div class="modal fade" id="voiceModal" tabindex="-1" role="dialog" aria-labelledby="remoteModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"></div></div></div>');
			// attach to body
			modal.appendTo("body");

			element.on("click", function(e) {

            	if ($.root_.hasClass("voice-command-active")) {
					$.speechApp.stop();
					//$('#speech-btn > span > a > i').removeClass().addClass('fa fa-microphone-slash');
				} else {
					$.speechApp.start();
					//add popover
					$('#speech-btn .popover').fadeIn(350);
					//$('#speech-btn > span > a > i').removeClass().addClass('fa fa-microphone')

				}

				e.preventDefault();

            });

			//remove popover
			$(document).mouseup(function(e) {
				if (!$('#speech-btn .popover').is(e.target) && $('#speech-btn .popover').has(e.target).length === 0) {
					$('#speech-btn .popover').fadeOut(250);
				}
			});


			$("#speech-help-btn").on("click", function() {
				commands.help();
			});

		}
		else {
			$("#speech-btn").addClass("display-none");
		}


	}



    return {
        restrict: 'AE',
        link: link
    }
});
;
'use strict';

angular.module('SmartAdmin.Layout').directive('smartRouterAnimationWrap', function ($rootScope,$timeout) {
    return {
        restrict: 'A',
        compile: function (element, attributes) {
            element.removeAttr('smart-router-animation-wrap data-smart-router-animation-wrap wrap-for data-wrap-for');

            element.addClass('router-animation-container');


            var $loader = $('<div class="router-animation-loader"><i class="fa fa-gear fa-4x fa-spin"></i></div>')
                .css({
                    position: 'absolute',
                    top: 50,
                    left: 10
                }).hide().appendTo(element);


            var animateElementSelector = attributes.wrapFor;
            var viewsToMatch = attributes.smartRouterAnimationWrap.split(/\s/);

            var needRunContentViewAnimEnd = false;
            function contentViewAnimStart() {
                needRunContentViewAnimEnd = true;
                element.css({
                    height: element.height() + 'px',
                    overflow: 'hidden'
                }).addClass('active');
                $loader.fadeIn();

                $(animateElementSelector).addClass('animated faster fadeOutDown');
            }

            function contentViewAnimEnd() {
                if(needRunContentViewAnimEnd){
                    element.css({
                        height: 'auto',
                        overflow: 'visible'
                    }).removeClass('active');
                    

                    $(animateElementSelector).addClass('animated faster fadeInUp');

                    needRunContentViewAnimEnd = false;

                    $timeout(function(){
                        $(animateElementSelector).removeClass('animated');
                    },10);
                }
                $loader.fadeOut();
            }


            var destroyForStart = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                var isAnimRequired = _.any(viewsToMatch, function(view){
                   return _.has(toState.views, view) || _.has(fromState.views, view);
                });
                if(isAnimRequired){
                    contentViewAnimStart()
                }
            });

            var destroyForEnd = $rootScope.$on('$viewContentLoaded', function (event) {
                contentViewAnimEnd();
            });

            element.on('$destroy', function(){
                destroyForStart();
                destroyForEnd();

            });



        }
    }
});;


'use strict';

angular.module('SmartAdmin.Layout').directive('smartPageTitle', function ($rootScope, $timeout) {
    return {
        restrict: 'A',
        compile: function (element, attributes) {
            element.removeAttr('smart-page-title data-smart-page-title');

            var defaultTitle = attributes.smartPageTitle;
            var listener = function(event, toState, toParams, fromState, fromParams) {
                var title = defaultTitle;
                if (toState.data && toState.data.title) title = toState.data.title + ' | ' + title;
                // Set asynchronously so page changes before title does
                $timeout(function() {
                    $('html head title').text(title);
                });
            };

            $rootScope.$on('$stateChangeStart', listener);

        }
    }
});;

'use strict';

angular.module('SmartAdmin.Layout').directive('smartLayout', function ($rootScope, $timeout, $interval, $q, SmartCss, APP_CONFIG) {
    
    var _debug = 0;

    function getDocHeight() {
        var D = document;
        return Math.max(
            D.body.scrollHeight, D.documentElement.scrollHeight,
            D.body.offsetHeight, D.documentElement.offsetHeight,
            D.body.clientHeight, D.documentElement.clientHeight
        );
    }

    var initialized = false, 
           initializedResolver = $q.defer();
    initializedResolver.promise.then(function () {
        initialized = true;
    });

    var $window = $(window),
        $document = $(document),
        $html = $('html'),
        $body = $('body'),
        $navigation ,
        $menu,
        $ribbon,
        $footer,
        $contentAnimContainer;


    (function cacheElements() {
        $navigation = $('#header');
        $menu = $('#left-panel');
        $ribbon = $('#ribbon');
        $footer = $('.page-footer');
        if (_.every([$navigation, $menu, $ribbon, $footer], function ($it) {
            return angular.isNumber($it.height())
        })) {
            initializedResolver.resolve();
        } else {
            $timeout(cacheElements, 100);
        }
    })();

    (function applyConfigSkin(){
        if(APP_CONFIG.smartSkin){
            $body.removeClass(_.pluck(APP_CONFIG.skins, 'name').join(' '));
            $body.addClass(APP_CONFIG.smartSkin);
        }
    })();


    return {
        priority: 2014,
        restrict: 'A',
        compile: function (tElement, tAttributes) {
            tElement.removeAttr('smart-layout data-smart-layout');

            var appViewHeight = 0 ,
                appViewWidth = 0,
                calcWidth,
                calcHeight,
                deltaX,
                deltaY;

            var forceResizeTrigger = false;

            function resizeListener() {

//                    full window height appHeight = Math.max($menu.outerHeight() - 10, getDocHeight() - 10);

                var menuHeight = $body.hasClass('menu-on-top') && $menu.is(':visible') ? $menu.height() : 0;
                var menuWidth = !$body.hasClass('menu-on-top') && $menu.is(':visible') ? $menu.width() + $menu.offset().left : 0;

                var $content = $('#content');
                var contentXPad = $content.outerWidth(true) - $content.width();
                var contentYPad = $content.outerHeight(true) - $content.height();


                calcWidth = $window.width() - menuWidth - contentXPad;
                calcHeight = $window.height() - menuHeight - contentYPad - $navigation.height() - $ribbon.height() - $footer.height();

                deltaX = appViewWidth - calcWidth;
                deltaY = appViewHeight - calcHeight;
                if (Math.abs(deltaX) || Math.abs(deltaY) || forceResizeTrigger) {

                    //console.log('exec', calcWidth, calcHeight);
                    $rootScope.$broadcast('$smartContentResize', {
                        width: calcWidth,
                        height: calcHeight,
                        deltaX: deltaX,
                        deltaY: deltaY
                    });
                    appViewWidth = calcWidth;
                    appViewHeight = calcHeight;
                    forceResizeTrigger = false;
                }
            }


            var looping = false;
            $interval(function () {
                if (looping) loop();
            }, 300);

            var debouncedRun = _.debounce(function () {
                run(300)
            }, 300);

            function run(delay) {
                initializedResolver.promise.then(function () {
                    attachOnResize(delay);
                });
            }

            run(10);

            function detachOnResize() {
                looping = false;
            }

            function attachOnResize(delay) {
                $timeout(function () {
                    looping = true;
                }, delay);
            }

            function loop() {
                $body.toggleClass('mobile-view-activated', $window.width() < 979);

                if ($window.width() < 979)
                    $body.removeClass('minified');

                resizeListener();
            }

            function handleHtmlId(toState) {
                if (toState.data && toState.data.htmlId) $html.attr('id', toState.data.htmlId);
                else $html.removeAttr('id');
            }

            $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                //console.log(1, '$stateChangeStart', event, toState, toParams, fromState, fromParams);

                handleHtmlId(toState);
                detachOnResize();
            });

            // initialized with 1 cause we came here with one $viewContentLoading request
            var viewContentLoading = 1;
            $rootScope.$on('$viewContentLoading', function (event, viewConfig) {
                //console.log(2, '$viewContentLoading', event, viewConfig);
                viewContentLoading++;
            });

            $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                //console.log(3, '$stateChangeSuccess', event, toState, toParams, fromState, fromParams);
                forceResizeTrigger = true;
            });

            $rootScope.$on('$viewContentLoaded', function (event) {
                //console.log(4, '$viewContentLoaded', event);
                viewContentLoading--;

                if (viewContentLoading == 0 && initialized) {
                    debouncedRun();
                }
            });
        }
    }
});
;

"use strict";

angular.module('SmartAdmin.Layout').directive('smartInclude', function () {
        return {
            replace: true,
            restrict: 'A',
            templateUrl: function (element, attr) {
                return attr.smartInclude;
            },
            compile: function(element){
                element[0].className = element[0].className.replace(/placeholder[^\s]+/g, '');
            }
        };
    }
);
;
/*'use strict';

angular.module('SmartAdmin.Layout').directive('smartFitAppView', function ($rootScope, SmartCss) {
    return {
        restrict: 'A',
        compile: function (element, attributes) {
            element.removeAttr('smart-fit-app-view data-smart-fit-app-view leading-y data-leading-y');

            var leadingY = attributes.leadingY ? parseInt(attributes.leadingY) : 0;

            var selector = attributes.smartFitAppView;

            if(SmartCss.appViewSize && SmartCss.appViewSize.height){
                var height =  SmartCss.appViewSize.height - leadingY < 252 ? 252 :  SmartCss.appViewSize.height - leadingY;
                SmartCss.add(selector, 'height', height+'px');
            }

            var listenerDestroy = $rootScope.$on('$smartContentResize', function (event, data) {
                var height = data.height - leadingY < 252 ? 252 : data.height - leadingY;
                SmartCss.add(selector, 'height', height+'px');
            });

            element.on('$destroy', function () {
                listenerDestroy();
                SmartCss.remove(selector, 'height');
            });


        }
    }
});*/;
/**
 *
 * Description: Directive utilizes FastClick library.
 *
 *
 * FastClick is a simple, easy-to-use library for eliminating the
 * 300ms delay between a physical tap and the firing of a click event on mobile browsers.
 * FastClick doesn't attach any listeners on desktop browsers.
 * @link: https://github.com/ftlabs/fastclick
 *
 * On mobile devices 'needsclick' class is attached to <tElement>
 *
 */


'use strict';

angular.module('SmartAdmin.Layout').directive('smartFastClick', function () {
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {
            tElement.removeAttr('smart-fast-click data-smart-fast-click');

            FastClick.attach(tElement);

            if(!FastClick.notNeeded())
                tElement.addClass('needsclick')
        }
    }
});
;
/**
 * DETECT MOBILE DEVICES
 * Description: Detects mobile device - if any of the listed device is
 *
 * detected class is inserted to <tElement>.
 *
 *  (so far this is covering most hand held devices)
 */
'use strict';

angular.module('SmartAdmin.Layout').directive('smartDeviceDetect', function () {
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {
            tElement.removeAttr('smart-device-detect data-smart-device-detect');

            var isMobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
            
            tElement.toggleClass('desktop-detected', !isMobile);
            tElement.toggleClass('mobile-detected', isMobile);


        }
    }
});;
'use strict';

/*
* Directive for toggling a ng-model with a button
* Source: https://gist.github.com/aeife/9374784
*/

angular.module('SmartAdmin.Layout').directive('radioToggle', function ($log) {
    return {
        scope: {
            model: "=ngModel",
            value: "@value"
        },
        link: function(scope, element, attrs) {

            element.parent().on('click', function() {
                scope.model = scope.value;
                scope.$apply();
            });
        }
    }
});;
'use strict';

angular.module('SmartAdmin.Layout').directive('hrefVoid', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attributes) {
            element.attr('href','#');
            element.on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
            })
        }
    }
});;
'use strict';

angular.module('SmartAdmin.Layout').directive('dismisser', function () {
    return {
        restrict: 'A',
        compile: function (element) {
            element.removeAttr('dismisser data-dissmiser')
            var closer = '<button class="close">&times;</button>';
            element.prepend(closer);
            element.on('click', '>button.close', function(){
                element.fadeOut('fast',function(){ $(this).remove(); });

            })
        }
    }
});;
'use strict';

angular.module('SmartAdmin.Layout').directive('bigBreadcrumbs', function () {
    return {
        restrict: 'EA',
        replace: true,
        template: '<div><h1 class="page-title txt-color-blueDark"></h1></div>',
        scope: {
            items: '=',
            icon: '@'
        },
        link: function (scope, element) {
            var first = _.first(scope.items);

            var icon = scope.icon || 'home';
            element.find('h1').append('<i class="fa-fw fa fa-' + icon + '"></i> ' + first);
            _.rest(scope.items).forEach(function (item) {
                element.find('h1').append(' <span>> ' + item + '</span>')
            })
        }
    }
});
;
"use strict";

angular.module('SmartAdmin.Layout').directive('toggleMenu', function(){
    return {
        restrict: 'A',
        link: function(scope, element){
            var $body = $('body');

            var toggleMenu = function(){
                if (!$body.hasClass("menu-on-top")){
                    $('html').toggleClass("hidden-menu-mobile-lock");
                    $body.toggleClass("hidden-menu");
                    $body.removeClass("minified");
                } else if ( $body.hasClass("menu-on-top") && $body.hasClass("mobile-view-activated") ) {
                    $('html').toggleClass("hidden-menu-mobile-lock");
                    $body.toggleClass("hidden-menu");
                    $body.removeClass("minified");
                }
            };

            element.on('click', toggleMenu);

            scope.$on('requestToggleMenu', function(){
                toggleMenu();
            });
        }
    }
});;
'use strict';

angular.module('SmartAdmin.Layout').directive('searchMobile', function () {
    return {
        restrict: 'A',
        compile: function (element, attributes) {
            element.removeAttr('search-mobile data-search-mobile');


            element.on('click', function (e) {
                $('body').addClass('search-mobile');
                e.preventDefault();
            });

            $('#cancel-search-js').on('click', function (e) {
                $('body').removeClass('search-mobile');
                e.preventDefault();
            });
        }
    }
});;
"use strict";

angular.module('SmartAdmin.Layout').directive('resetWidgets', function($state){

    return {
        restrict: 'A',
        link: function(scope, element){
            element.on('click', function(){
                $.SmartMessageBox({
                    title : "<i class='fa fa-refresh' style='color:green'></i> Clear Local Storage",
                    content : "Would you like to RESET all your saved widgets and clear LocalStorage?1",
                    buttons : '[No][Yes]'
                }, function(ButtonPressed) {
                    if (ButtonPressed == "Yes" && localStorage) {
                        localStorage.clear();
                        location.reload()
                    }
                });

            });
        }
    }

});
;
'use strict';

angular.module('SmartAdmin.Layout').directive('reloadState', function ($rootScope) {
    return {
        restrict: 'A',
        compile: function (tElement, tAttributes) {
            tElement.removeAttr('reload-state data-reload-state');
            tElement.on('click', function (e) {
                $rootScope.$state.transitionTo($rootScope.$state.current, $rootScope.$stateParams, {
                    reload: true,
                    inherit: false,
                    notify: true
                });
                e.preventDefault();
            })
        }
    }
});
;
"use strict";

angular.module('SmartAdmin.Layout').directive('minifyMenu', function(){
    return {
        restrict: 'A',
        link: function(scope, element){
                var $body = $('body');
            var minifyMenu = function() {
                if (!$body.hasClass("menu-on-top")) {
                    $body.toggleClass("minified");
                    $body.removeClass("hidden-menu");
                    $('html').removeClass("hidden-menu-mobile-lock");
                }
            };

            element.on('click', minifyMenu);
        }
    }
});
"use strict";

angular.module('SmartAdmin.Layout').directive('fullScreen', function(){
    return {
        restrict: 'A',
        link: function(scope, element){
            var $body = $('body');
            var toggleFullSceen = function(e){
                if (!$body.hasClass("full-screen")) {
                    $body.addClass("full-screen");
                    if (document.documentElement.requestFullscreen) {
                        document.documentElement.requestFullscreen();
                    } else if (document.documentElement.mozRequestFullScreen) {
                        document.documentElement.mozRequestFullScreen();
                    } else if (document.documentElement.webkitRequestFullscreen) {
                        document.documentElement.webkitRequestFullscreen();
                    } else if (document.documentElement.msRequestFullscreen) {
                        document.documentElement.msRequestFullscreen();
                    }
                } else {
                    $body.removeClass("full-screen");
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                    }
                }
            };

            element.on('click', toggleFullSceen);

        }
    }
});;
(function(){
    "use strict";

    angular.module('SmartAdmin.UI', []);
})();;

"use strict";

angular.module('SmartAdmin.UI').directive('smartTooltipHtml', function () {
        return {
            restrict: 'A',
            link: function(scope, element, attributes){
                element.tooltip({
                    placement: attributes.tooltipPlacement || 'top',
                    html: true,
                    title: attributes.smartTooltipHtml
                })
            }
        };
    }
);
;

"use strict";

angular.module('SmartAdmin.UI').directive('smartPopoverHtml', function () {
    return {
        restrict: "A",
        link: function(scope, element, attributes){
            var options = {};
            options.content = attributes.smartPopoverHtml;
            options.placement = attributes.popoverPlacement || 'top';
            options.html = true;
            options.trigger =  attributes.popoverTrigger || 'click';
            options.title =  attributes.popoverTitle || attributes.title;
            element.popover(options)

        }

    };
});
;
(function() {
    'use strict';

    angular
        .module('wamasysApp', [
            'ngStorage', 
            'tmh.dynamicLocale',
            'pascalprecht.translate', 
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            
            //TFE ajout module select
            'ui.select', 
            
            //TFE : jaout module pour Leaflet 
           'nemLogging',
            'ui-leaflet',
            
            //TFE : ajout module pour chart.js 
            'chart.js',
            
            //TFE : Ajout de module du template SmartAdmin
            'ngSanitize',
            'ngAnimate',
            'restangular',
            'daterangepicker',
            // Smartadmin Angular Common Module
            'SmartAdmin',
            'SmartAdmin.Layout',
            'SmartAdmin.Forms',
            'datatables', 
            'datatables.bootstrap',
            
            'ngDragDrop'
            // App
          //  'app.auth',
           // 'app.layout',
            //'app.chat',
            //'app.dashboard',
            //'app.calendar',
            //'app.inbox',
            //'app.graphs',
            //'app.tables',
            //'app.forms',
            //'app.ui',
            //'app.widgets',
            //'app.maps',
            //'app.appViews',
            //'app.misc',
            //'app.smartAdmin',
            //'app.eCommerce'
          
            //'app.home'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler',
                   '$localStorage',
                   '$window'];

    function run(stateHandler, translationHandler, $localStorage, $window) {
    	  if (
    		        !$localStorage.authenticationToken &&
    		        $window.AndroidAuth &&
    		        $window.AndroidAuth.getAuthenticationToken
    		    ) {
    		        var token = $window.AndroidAuth.getAuthenticationToken();
    		        if (token) {
    		            $localStorage.authenticationToken = token;
    		        }
    		    }
    	  
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();
;
'use strict';

angular.module('wamasysApp').directive('jqGridReleveCompteur', function ($compile,$filter,$http,$q,$state,$window,AlertService) {
    var jqGridCounter = 0;

    return {
        replace: true,
        restrict: 'E',
        scope: {
            gridData: '=',
            releveCompteur: '='
        },
        template: '<div>' +
            '<table></table>' +
            '<div class="jqgrid-pagination" ></div>' +
            '<photo-viewer-modal modal="photoModal"></photo-viewer-modal>' +
            '</div>',

        link: function (scope, element) {
            var gridNumber = jqGridCounter++;
            var wrapperId = 'jqgrid-' + gridNumber;
            element.attr('id', wrapperId);

            var tableId = 'jqgrid-table-' + gridNumber;
            var table = element.find('table');
            table.attr('id', tableId);

            scope.photoModal = {
                visible: false,
                url: null,
                title: ''
            };
            scope.photoObjectUrls = [];
            scope.photoCache = {};

             var gridData = {
                     data: [],
                     colNames: ['id', $filter('translate')('wamasysApp.individualMeter.type'), 
                                $filter('translate')('wamasysApp.individualMeter.numeroSerie') ,
                                $filter('translate')('wamasysApp.individualMeter.contrat') ,
                                $filter('translate')('wamasysApp.individualMeter.cluster') ,
                                $filter('translate')('wamasysApp.individualMeter.runningOrder') ,
                                $filter('translate')('wamasysApp.individualMeter.datePrecedenteLecture') ,
                                $filter('translate')('wamasysApp.individualMeter.valeurPrecedenteLecture') ,
                                $filter('translate')('wamasysApp.individualMeter.precedenteConsommation') ,
                                $filter('translate')('wamasysApp.individualMeter.newReadingDate') ,
                                'idCasNonReleve',
                                $filter('translate')('wamasysApp.individualMeter.casNonReleve') ,
                                $filter('translate')('wamasysApp.individualMeter.newConsumption') ,
                                $filter('translate')('wamasysApp.releveCompteur.detail.nvReleve'),
                                'valeurMaximumAccepte','casNonReleve' ],
                   
                     
                     colModel: [
                        {
                            name: 'id',
                            index: 'id',
                            editable: false,
                            hidden:true
                        },
                        {
                            name: 'type',
                            index: 'type',
                            editable: false,
                            width:'5%'
                        },
                        {
                            name:'referenceCompteur',
                            index: 'referenceCompteur',
                            align: "right",
                            editable: false,
                            width:'10%',
                            formatter: function (cellValue, options, rowObject) {
                            	if(rowObject.idCompteur){
                            		return '<a target="_blank"  href="#/individual-meter/'
                            		+ rowObject.idCompteur +'">'+rowObject.referenceCompteur
                            		+'</a>';
                            	}if(rowObject.idBulkMeter ){
                            		return '<a target="_blank"  href="#/bulk-meter/' + rowObject.idBulkMeter +'">'+rowObject.referenceCompteur+'</a>';
                            		
                            	
                            	}else{
                            		return '';
                            	}
                            	
                           
                            }
                        },
                        {
                            name: 'nomContrat',
                            index: 'nomContrat',
                            editable: false,
                            width:'15%',
                            formatter: function (cellValue, options, rowObject) {
                            	if(rowObject.nomContrat){
                            		return '<a target="_blank"  href="#/contrat/' + rowObject.idContrat + '/dataanalyse">'+rowObject.nomContrat+'</a>';
                            	}else{
                            		return '';
                            	}
                            	
                           
                            }
                        },
                         {
                             name: 'cluster',
                             index: 'cluster',
                             editable: false,
                             width:'9%'
                         },
                         {
                         	name: 'runningOrder',
                             index: 'runningOrder',
                             align: "center",
                             editable: false,
                             width:'6%'
                         },
                         {
                             name: 'datePrecedentReleveCompteur',
                             index: 'datePrecedentReleveCompteur',
                             align: "right",
                             editable: false,
                             width:'10%'
                         },
                         {
                             name: 'relevePrecedent',
                             index: 'relevePrecedent',
                             align: "right",
                             editable: false,
                             width:'10%'
                         },
                         {
                             name: 'precedenteConsommation',
                             index: 'precedenteConsommation',
                             align: "right",
                             editable: false,
                             width:'8%'
                         },
                         {
                             name: 'readingDate',
                             index: 'readingDate',
                             align: "right",
                             editable: false,
                             width:'12%',
                             formatter: function(cellValue, options, rowObject) {
                                 return buildReadingDateCell(cellValue, rowObject);
                             }
                         },
                         {
                             name: 'idCasNonReleve',
                             index: 'idCasNonReleve',  
                             hidden: true, 
                             editable: false 
                         },
                         {
                             name: 'casNonReleve',
                             index: 'casNonReleve',
                             align: "right",
                             editable: true,
                             width:'10%', 
                             edittype: 'select',
//                             editDropdownValueLabel: 'value', 
//                             formatter: function (cellvalue, options, rowObject) {
//                                 var id = rowObject.idCasNonReleve; 
//                                 var label = '';
//                                 angular.forEach(scope.listCasNonReleve, function (option) {
//                                     if (option.id == id) {
//                                         label = option.label;
//                                     }
//                                 });
//                                 return label;
//                             },
                             editoptions:{   
                            	   value: function () {
                                       var options = '';
                                       angular.forEach(scope.listCasNonReleve, function (option) {
                                 
                                           options += option.id + ":" + option.libelle +";" ;
                                       });
                                       options += ":"
                                       return options;
                                   },
                                   dataEvents: [{
                                       type: 'change', // Type d'événement
                                       fn: function(e) {
                                           var rowId = $(this).closest('tr.jqgrow').attr('id'); // Obtenez l'ID de la ligne
                                           var cellValue = $(this).val(); // Obtenez la nouvelle valeur de la cellule
                                           $(this).closest('table').jqGrid('setCell', rowId, 'idCasNonReleve', cellValue);
                                           
                                           
                                           // Faites quelque chose avec la nouvelle valeur, par exemple, déclenchez un événement AngularJS
                                      
                                       }
                                   }]
                             }
                         },
                         {
                             name: 'consumption',
                             index: 'consumption',
                             align: "right",
                             editable: false,
                             width:'8%'
                         },
                         {
                             name: 'nouveauReleve',
                             index: 'nouveauReleve',
                             align: "right",
                         //    formatter:'number',
                             formatter: function (cellvalue, options, rowObject) {
                                 if (cellvalue === null || cellvalue === undefined || cellvalue === "") {
                                     return ""; // Retourne une chaîne vide si la valeur est null ou undefined
                                 } else {
                                     return $.fn.fmatter('number', cellvalue, options, rowObject);
                                 }
                             },
                             formatoptions: { decimalPlaces: 3, thousandsSeparator: "" ,decimalSeparator:"."},
                             editrules:{required: false, number:true,minValue: 0},
                             editable: true,
                             width:'10%'
                         },
                         {
                             name: 'valeurMaximumAccepte',
                             index: 'valeurMaximumAccepte',
                             editable: false,
                             hidden:true
                         },
                         {
                             name: 'casNonReleve',
                             index: 'casNonReleve',
                             editable: false,
                             hidden:true
                         },
                         
                         
                     ]
                 }

             scope.navigateToDetails = function(id) {
                 $state.go('contrat-detail.information', { id: id });
             }; 
             
             scope.getListCasNonReleve = function(){
                 var options = '';
                 // Supposons que $scope.autreVariable contienne vos options
                 angular.forEach($scope.listCasNonReleve, function (option) {
                     options += option.id + ":" + option.label + ";";
                 });
                 return options;
             
              }
            
            /* */
            table.jqGrid({
                data : gridData.data,
                datatype : "local",
                
                pgbuttons : false,
                viewrecords : false,
                pgtext : "",
                pginput : false,
                rowNum : 10000,
                
                editurl : "clientArray",
                height : 'auto',
                colNames : gridData.colNames || [],
                colModel : gridData.colModel || [],
                cmTemplate : {sortable: false },
             //   sortname : 'id',
           //     sortorder : "asc",

                autowidth : true,

                /*code permettant de mettre en orange les lignes ayant une erreur de donnée */
                loadComplete: function() {
        			var grid = $("table[id^=jqgrid-table]");

        			var ids = grid.jqGrid('getDataIDs');


        			for (var i = 0; i < ids.length; i++) {

            			var nvReleve = parseFloat(grid.jqGrid('getRowData', ids[i]).nouveauReleve);
    					var relevePrecedent = parseFloat(grid.jqGrid('getRowData', ids[i]).relevePrecedent);
    					var maxAccepte = parseFloat(grid.jqGrid('getRowData', ids[i]).valeurMaximumAccepte);
    					if(relevePrecedent!=NaN 
    							&& (
    									nvReleve > maxAccepte
    									|| nvReleve < relevePrecedent
    							)
    							){
    		              //  $('#' + $.jgrid.jqID(ids[i])).find('td').eq(12).css( { background:'orange', color:'white'}); 
    		                $('#' + $.jgrid.jqID(ids[i])).css( { background:'#E7C800', color:'white'}); //orange FireBrick
    		                $('#' + $.jgrid.jqID(ids[i])).find('a').css( {  color:'white',  'font-weight':'bold', 'text-decoration':'underline'});
    					}else if(!isNaN(nvReleve) && nvReleve!==relevePrecedent){// 
    		                $('#' + $.jgrid.jqID(ids[i])).css( { background:'lightseagreen', color:'white'}); //lightseagreen  SeaGreen
    		                $('#' + $.jgrid.jqID(ids[i])).find('a').css( { color:'white', 'font-weight':'bold', 'text-decoration':'underline' });
    					}else if(!isNaN(nvReleve)){// && nvReleve!==relevePrecedent
    		                $('#' + $.jgrid.jqID(ids[i])).css( { background:'SeaGreen', color:'white'}); //forestgreen  DarkOliveGreen
    		                $('#' + $.jgrid.jqID(ids[i])).find('a').css( { color:'white', 'font-weight':'bold', 'text-decoration':'underline' });
    					} else if(isNaN(nvReleve )){ 
    		                $('#' + $.jgrid.jqID(ids[i])).css( { background:'lightgray'}); //yellow 
    		                $('#' + $.jgrid.jqID(ids[i])).find('a').css( { 'font-weight':'bold', 'text-decoration':'underline' });  
    					}
    					var casNonReleve = grid.jqGrid('getRowData', ids[i]).casNonReleve;
    					if(casNonReleve && casNonReleve.length>0){
    		                $('#' + $.jgrid.jqID(ids[i])).css( { background:'LightCoral', color:'white'}); // LightCoral indianred  DarkSalmon
    		                $('#' + $.jgrid.jqID(ids[i])).find('a').css({ color:'white', 'font-weight':'bold', 'text-decoration':'underline' });
    					}
        			}
					
                }
            });



         	scope.$on( 'updateLigneReleveCompteur', 	function(event, data) {
         		
					var dataArray = [];

					if (data) {
						scope.listCasNonReleve = data.casNonReleve;
						if (data.clusterReleveCompteurDTO) {

							for (var x = 0; x < data.clusterReleveCompteurDTO.length; x++) {
								if (data.clusterReleveCompteurDTO[x].ligneReleveCompteur) {
								
								
									for (var i = 0; i < data.clusterReleveCompteurDTO[x].ligneReleveCompteur.length; i++) {
										if (data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].individualMeter) {
	
											var varConsumption =0;
											if(data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].valeurReleve && !isNaN( data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].valeurPrecedentReleve)){
												 varConsumption = parseFloat(data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].valeurReleve -  data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].valeurPrecedentReleve).toFixed(3);
											}
																				
											var maxConsumption = 0;
											if(data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].valeurMaximumAccepte && !isNaN(data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].valeurPrecedentReleve)){
												maxConsumption=parseFloat(data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].valeurMaximumAccepte-data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].valeurPrecedentReleve).toFixed(3);
											}
											varConsumption = '<span title=" Max consumption: '+maxConsumption+'">'+varConsumption + '</span>';
											if(data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].individualMeter.disableCheckMaxValue){
												   varConsumption = varConsumption + ' <span title=" Warning the control of the maximum value is disable on this meter"> <i class="fa fa-lg text-danger fa-exclamation-circle "></i>   </span> ';
											}
										
											var dataReleve = {
												id : data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].idLigneReleveCompteur,
												refContrat : data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].referenceContrat  ,
												idContrat : data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].idContrat  ,
												idCompteur : data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].individualMeter.id  ,
												nomContrat  :data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].nomContrat  ,
												type : 'Individual',
												cluster : data.clusterReleveCompteurDTO[x].cluster.numeroSerie,
												runningOrder : data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].individualMeter.runningOrder,
												referenceCompteur : data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].individualMeter.numeroSerie,
												datePrecedentReleveCompteur : $filter('date')(data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].datePrecedentReleveCompteur, "medium"),
												relevePrecedent : data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].valeurPrecedentReleve,
												readingDate :  $filter('date')(data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].readingDate, "medium"),
												nouveauReleve :data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].valeurReleve,
                                                photoViewUrl : data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].pathPhoto ? 'api/releve-compteurs/' + data.id + '/photo/' + data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].idLigneReleveCompteur + '?download=false' : '',
                                                photoTitle : data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].individualMeter.numeroSerie,
												consumption : varConsumption,
												casNonReleve:  "",
												idCasNonReleve:  0,
												valeurMaximumAccepte : data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].valeurMaximumAccepte,
												precedenteConsommation : data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].individualMeter.valeurPrecedenteConsommation
											}
											
											if(data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].casNonReleve){
												dataReleve.casNonReleve=  data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].casNonReleve.libelle;
												dataReleve.idCasNonReleve=  data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].casNonReleve.id;
											}
											
											if( data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].commentaire){
												if(dataReleve.readingDate && dataReleve.readingDate.length>0){
													dataReleve.readingDate = dataReleve.readingDate+ "<br/> Comment: " + data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].commentaire;
												}else{
													dataReleve.readingDate = "Comment: "+ data.clusterReleveCompteurDTO[x].ligneReleveCompteur[i].commentaire;
												}
												
											}
											
											
											dataArray.push(dataReleve);
										}
									}
								}
							}
						}

						if (data.listLigneReleveCompteurBulkMeter) {

							for (var i = 0; i < data.listLigneReleveCompteurBulkMeter.length; i++) {

								var varConsumption =0;
								if(data.listLigneReleveCompteurBulkMeter[i].valeurReleve && !isNaN(data.listLigneReleveCompteurBulkMeter[i].valeurPrecedentReleve)){
									 varConsumption = parseFloat(data.listLigneReleveCompteurBulkMeter[i].valeurReleve -  data.listLigneReleveCompteurBulkMeter[i].valeurPrecedentReleve).toFixed(3);
								}
								var maxConsumption = 0;
								if(data.listLigneReleveCompteurBulkMeter[i].valeurMaximumAccepte && !isNaN(data.listLigneReleveCompteurBulkMeter[i].valeurPrecedentReleve)){
									maxConsumption=parseFloat(data.listLigneReleveCompteurBulkMeter[i].valeurMaximumAccepte-data.listLigneReleveCompteurBulkMeter[i].valeurPrecedentReleve).toFixed(3);
								}
								varConsumption = '<span title=" Max consumption: '+maxConsumption+'">'+varConsumption + '</span>';
								if(data.listLigneReleveCompteurBulkMeter[i].bulkMeter.disableCheckMaxValue){
									   varConsumption = varConsumption + ' <span title=" Warning the control of the maximum value is disable on this meter"> <i class="fa fa-lg text-danger fa-exclamation-circle "></i>   </span> ';
								}
								
								var dataReleve = {
									id : data.listLigneReleveCompteurBulkMeter[i].idLigneReleveCompteur,
									type : 'Bulk Meter',
									cluster : null,
									runningOrder : null,
									refContrat : null,
									idContrat : null  ,
									nomContrat : null,
									idBulkMeter : data.listLigneReleveCompteurBulkMeter[i].bulkMeter.id  ,
									referenceCompteur : data.listLigneReleveCompteurBulkMeter[i].bulkMeter.numeroSerie,
									datePrecedentReleveCompteur :  $filter('date')(data.listLigneReleveCompteurBulkMeter[i].datePrecedentReleveCompteur, "medium"),
									relevePrecedent : data.listLigneReleveCompteurBulkMeter[i].valeurPrecedentReleve,
									readingDate : $filter('date')(data.listLigneReleveCompteurBulkMeter[i].readingDate, "medium"),
									nouveauReleve : data.listLigneReleveCompteurBulkMeter[i].valeurReleve,
                                    photoViewUrl : data.listLigneReleveCompteurBulkMeter[i].pathPhoto ? 'api/releve-compteurs/' + data.id + '/photo/' + data.listLigneReleveCompteurBulkMeter[i].idLigneReleveCompteur + '?download=false' : '',
                                    photoTitle : data.listLigneReleveCompteurBulkMeter[i].bulkMeter.numeroSerie,
									consumption : varConsumption,
									casNonReleve:  "",
									idCasNonReleve:  0,
									valeurMaximumAccepte : data.listLigneReleveCompteurBulkMeter[i].valeurMaximumAccepte,
									precedenteConsommation : data.listLigneReleveCompteurBulkMeter[i].valeurPrecedenteConsommation
								}
								
								if(data.listLigneReleveCompteurBulkMeter[i].casNonReleve){
									dataReleve.casNonReleve =data.listLigneReleveCompteurBulkMeter[i].casNonReleve.libelle;
									dataReleve.idCasNonReleve=  data.listLigneReleveCompteurBulkMeter[i].casNonReleve.id;
								}
								
								if( data.listLigneReleveCompteurBulkMeter[i].commentaire){
									if(dataReleve.readingDate && dataReleve.readingDate.length>0){
										dataReleve.readingDate = dataReleve.readingDate+ "<br/> Comment: " + data.listLigneReleveCompteurBulkMeter[i].commentaire;
									}else{
										dataReleve.readingDate =  "Comment: "+data.listLigneReleveCompteurBulkMeter[i].commentaire;
									}
						
								}
								
								
								dataArray
										.push(dataReleve);
							}
						}

					}
					table.jqGrid('setGridParam', {
						data : dataArray
					}).trigger('reloadGrid');
				});



            element.find(".ui-jqgrid").removeClass("ui-widget ui-widget-content");
            element.find(".ui-jqgrid-view").children().removeClass("ui-widget-header ui-state-default");
            element.find(".ui-jqgrid-labels, .ui-search-toolbar").children().removeClass("ui-state-default ui-th-column ui-th-ltr");
            element.find(".ui-jqgrid-pager").removeClass("ui-state-default");
            element.find(".ui-jqgrid").removeClass("ui-widget-content");

            // add classes
            element.find(".ui-jqgrid-htable").addClass("table table-bordered table-hover");
            element.find(".ui-jqgrid-btable").addClass("table table-bordered table-striped");

            element.find(".ui-pg-div").removeClass().addClass("btn btn-sm btn-primary");
            element.find(".ui-icon.ui-icon-plus").removeClass().addClass("fa fa-plus");
            element.find(".ui-icon.ui-icon-pencil").removeClass().addClass("fa fa-pencil");
            element.find(".ui-icon.ui-icon-trash").removeClass().addClass("fa fa-trash-o");
            element.find(".ui-icon.ui-icon-search").removeClass().addClass("fa fa-search");
            element.find(".ui-icon.ui-icon-refresh").removeClass().addClass("fa fa-refresh");
            element.find(".ui-icon.ui-icon-disk").removeClass().addClass("fa fa-save").parent(".btn-primary").removeClass("btn-primary").addClass("btn-success");
            element.find(".ui-icon.ui-icon-cancel").removeClass().addClass("fa fa-times").parent(".btn-primary").removeClass("btn-primary").addClass("btn-danger");

            element.find(".ui-icon.ui-icon-seek-prev").wrap("<div class='btn btn-sm btn-default'></div>");
            element.find(".ui-icon.ui-icon-seek-prev").removeClass().addClass("fa fa-backward");

            element.find(".ui-icon.ui-icon-seek-first").wrap("<div class='btn btn-sm btn-default'></div>");
            element.find(".ui-icon.ui-icon-seek-first").removeClass().addClass("fa fa-fast-backward");

            element.find(".ui-icon.ui-icon-seek-next").wrap("<div class='btn btn-sm btn-default'></div>");
            element.find(".ui-icon.ui-icon-seek-next").removeClass().addClass("fa fa-forward");

            element.find(".ui-icon.ui-icon-seek-end").wrap("<div class='btn btn-sm btn-default'></div>");
            element.find(".ui-icon.ui-icon-seek-end").removeClass().addClass("fa fa-fast-forward");
         	
            $(window).on('resize.jqGrid', function() {
               table.jqGrid('setGridWidth', $("#content").width());
            });

            $(element).on('click', '.jqgrid-photo-link', function(event) {
                event.preventDefault();
                var target = angular.element(event.currentTarget);
                var photoUrl = target.attr('data-photo-url');
                var photoTitle = target.attr('data-photo-title') || $filter('translate')('wamasysApp.releveCompteur.detail.photo');

                loadPhoto(photoUrl).then(function(objectUrl) {
                    if (!objectUrl) {
                        return;
                    }

                    scope.$applyAsync(function() {
                        scope.photoModal.visible = true;
                        scope.photoModal.url = objectUrl;
                        scope.photoModal.title = photoTitle;
                    });
                });
            });

            scope.$on('$destroy', function() {
                $(element).off('click', '.jqgrid-photo-link');
                $(window).off('resize.jqGrid');
                angular.forEach(scope.photoObjectUrls, function(url) {
                    $window.URL.revokeObjectURL(url);
                });
            });

            $compile(element.contents())(scope);

            function buildReadingDateCell(cellValue, rowObject) {
                var label = cellValue || '';

                if (!rowObject.photoViewUrl) {
                    return label;
                }

                return '<a href="" class="jqgrid-photo-link" data-photo-url="' + escapeAttribute(rowObject.photoViewUrl) +
                    '" data-photo-title="' + escapeAttribute(rowObject.photoTitle || $filter('translate')('wamasysApp.releveCompteur.detail.photo')) +
                    '" style="margin-right: 6px;" title="' + escapeAttribute($filter('translate')('wamasysApp.releveCompteur.detail.photo')) + '">' +
                    '<span class="fa fa-camera"></span></a>' + label;
            }

            function escapeAttribute(value) {
                return String(value)
                    .replace(/&/g, '&amp;')
                    .replace(/"/g, '&quot;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;');
            }

            function loadPhoto(photoUrl) {
                if (!photoUrl) {
                    return $q.when(null);
                }

                if (scope.photoCache[photoUrl]) {
                    return $q.when(scope.photoCache[photoUrl]);
                }

                return $http.get(photoUrl, {
                    responseType: 'arraybuffer'
                }).then(function(response) {
                    var photoBlob = new Blob([response.data], {
                        type: response.headers('Content-Type') || 'image/jpeg'
                    });
                    var objectUrl = $window.URL.createObjectURL(photoBlob);
                    scope.photoCache[photoUrl] = objectUrl;
                    scope.photoObjectUrls.push(objectUrl);
                    return objectUrl;
                }).catch(function(error) {
                    AlertService.error((error && error.data && error.data.message) || $filter('translate')('wamasysApp.releveCompteur.control.photoDownloadFailed'));
                    return null;
                });
            }
        }
    }
});
;
'use strict';

angular.module('wamasysApp').directive('jqGridCollectionList', function (CollectionListe,Principal,$compile,$filter) {
    var jqGridCounter = 0;

    return {
        replace: true,
        restrict: 'E',
        scope: {
            gridData: '=',
            collectionList: '='
        },
        template: '<div>' +
            '<table></table>' +
            '<div class="jqgrid-pagination"></div>' +
            '</div>',

        link: function (scope, element) {
            var gridNumber = jqGridCounter++;
            var wrapperId = 'jqgrid-' + gridNumber;
            element.attr('id', wrapperId);

            var tableId = 'jqgrid-table-' + gridNumber;
            var table = element.find('table');
            table.attr('id', tableId);
            
            var idAgence ;
            getIdAgence();
            function getIdAgence() {
                Principal.identity().then(function(account) {
                	scope.account = account;
                	if(account.agence){
                    	idAgence = account.agence.id
                	}
                });
            };

            
    		scope.downloadImage = function(idAgence,idCl,idContratCl) {
	
    		    CollectionListe.downloadSignature({
    				idAgence : idAgence,
    				idCl:idCl,
    				idContratCl:idContratCl,
    			}, function(result) {
    		          
                    var file = result.response;
    
                    var isChrome = !!window.chrome && !!window.chrome.webstore;
                    var isIE = /*@cc_on!@*/false || !!document.documentMode;
                    var isEdge = !isIE && !!window.StyleMedia;
    
    
                    if (isChrome){
                        var url = window.URL || window.webkitURL;
    
                        var downloadLink = angular.element('<a></a>');
                        downloadLink.attr('href',url.createObjectURL(file));
                        downloadLink.attr('target','_self');
                        downloadLink.attr('download', 'image.jpg');
                        downloadLink[0].click();
                    }
                    else if(isEdge || isIE){
                        window.navigator.msSaveOrOpenBlob(file,'image.jpg');
    
                    }
                    else {
                        var fileURL = URL.createObjectURL(file);
                        window.open(fileURL);
                    }
    
    			});
    		}
            
             var gridData = {
                     data: [],
                     colNames: ["id",
                                $filter('translate')('wamasysApp.contrat.referenceContrat'), 
                                $filter('translate')('wamasysApp.contrat.nomPersonne'), 
                                $filter('translate')('wamasysApp.collectionListe.service'), 
//                                $filter('translate')('wamasysApp.contrat.type'), 
//                                $filter('translate')('wamasysApp.contrat.dernierReleveCompteur'),  
                                $filter('translate')('wamasysApp.collectionListe.quantity'), 
                                $filter('translate')('wamasysApp.collectionListe.signature'), 
                                $filter('translate')('wamasysApp.collectionListe.montantAPayer'), 
                                $filter('translate')('wamasysApp.collectionListe.moneyBoxAvantPaiement'), 
                                $filter('translate')('wamasysApp.collectionListe.montantTotalAPayer'),
//                                $filter('translate')('wamasysApp.collectionListe.payeEnAgence'), 
                                $filter('translate')('wamasysApp.collectionListe.montantCollecte')
                                ],
                     colModel: [
                        {
                            name: 'id',
                            index: 'id',
                            editable: false,
                            hidden:true
                        },
                        
                        {
                            name: 'referenceContrat',
                            index: 'referenceContrat',
                            formatter: function (cellValue, options, rowObject) {
                                 var lien = '<a target="_blank"  href="#/contrat/' + rowObject.idContrat + '/dataanalyse">'+rowObject.referenceContrat+'</a>';
                                 return lien;
                            }
                        },
                        {
                            name: 'nomClient',
                            index: 'nomClient'
                        },
                        {
                            name: 'service',
                            index: 'service'
                        },
//                        {
//                            name: 'typeService',
//                            index: 'typeService'
//                        },
//                        {
//                            name: 'dernierRelevecompteur',
//                            index: 'dernierRelevecompteur'
//                        },
                        {
                            name: 'quantity',
                            index: 'quantity'
                        },
                        {
                            name: 'signature',
                            index: 'signature'
                            	
                        },
                        {
                            name: 'montantAPayerTtc',
                            index: 'montantAPayerTtc'
                        },
                        {
                            name: 'moneyBoxAvantPaiement',
                            index: 'moneyBoxAvantPaiement'
                        },
                        {
                            name: 'montantTotalAPayer',
                            index: 'montantTotalAPayer'
                        },
                         {
                             name: 'montantCollecte',
                             index: 'montantCollecte',
                             align: "right",
                             formatter:'number',
                             formatoptions: { decimalPlaces: 2, decimalSeparator: ".", thousandsSeparator: "" },
                             editrules:{required: true, number:true},
                             editable: true
                         }
                     ]
                 }


            
            
            /* */
            table.jqGrid({
                data : gridData.data,
                datatype : "local",
                pgbuttons : false,
                viewrecords : false,
                pgtext : "",
                pginput : false,
                rowNum : 10000,
                editurl : "clientArray",
                height : 'auto',
      
                colNames : gridData.colNames || [],
                colModel : gridData.colModel || [],
 
                cmTemplate : {sortable: false },
                autowidth : true,
                loadComplete: function() {
                    //compiling DOM after table load
                    $compile($('.clickMe'))(scope);
                //    $compile(angular.element('#' + newValue.id))(scope);
                },

            });

         	scope.$on('updateLigneCollectionListe',function(event, data){
                /*            */
                var dataArray = [];

                
                if(data && data.contratCollectionLists){
                    for (var i = 0; i < data.contratCollectionLists.length; i++) { 
                    
                    	if(data.contratCollectionLists[i].lignePaiementService ){
                    		

                            for (var x = 0; x < data.contratCollectionLists[i].lignePaiementService.length; x++) { 
                            	
                            
                        	  var dataReleve = {
                        	      id : data.contratCollectionLists[i].lignePaiementService[x].idLignePaiementService,

                        	      idContrat :  data.contratCollectionLists[i].contrat.id,
                        	      referenceContrat :  data.contratCollectionLists[i].contrat.referenceContrat,
                                  nomClient : data.contratCollectionLists[i].contrat.nomPersonne,
                                  service : data.contratCollectionLists[i].lignePaiementService[x].ligneContrat.serviceVendu.libelle  ,
//                                  typeService : data.contratCollectionLists[i].lignePaiementService[x].ligneContrat.serviceVendu.typeService.libelle ,
                                  quantity : data.contratCollectionLists[i].lignePaiementService[x].quantity ,
                                  signature : null,
//                                  dernierRelevecompteur : data.contratCollectionLists[i].lignePaiementService[x].valeurCompteurReleve ,
                                  montantAPayerTtc :data.contratCollectionLists[i].lignePaiementService[x].montantAPayerTtc ,
                                  montantTotalAPayer: parseFloat(
                                		  parseFloat(data.contratCollectionLists[i].lignePaiementService[x].montantAPayerTtc) - 
                                		  parseFloat(data.contratCollectionLists[i].lignePaiementService[x].moneyboxAvantPaiement )).toFixed(2),
                                  dateDebutPeriode :  data.contratCollectionLists[i].date,
                                  moneyBoxAvantPaiement :  data.contratCollectionLists[i].lignePaiementService[x].moneyboxAvantPaiement ,
                                  montantCollecte :  data.contratCollectionLists[i].lignePaiementService[x].montantPayeCollecteur 
                        	  }
                        	  
                        	  if(data.contratCollectionLists[i].msgPourEncodeur && data.contratCollectionLists[i].msgPourEncodeur ===true){
                        		  dataReleve.referenceContrat = 
                        			  	'<span title="'
                        			  		+data.contratCollectionLists[i].textMsgPourEncodeur
                        			  	+ '"><span class="label bg-color-red txt-color-white" ><i class="fa fa-exclamation"></i>  </span> ' 
                        			  	+dataReleve.referenceContrat
                        			  	+'</span>';
                        	     
                        	  }
                        	  
						    if( data.contratCollectionLists[i].pathSignatureClient || data.contratCollectionLists[i].handoffSignatureAvailable){
							 		 if( data.contratCollectionLists[i].pathSignatureClient === 'DELETED' && !data.contratCollectionLists[i].handoffSignatureAvailable){
										dataReleve.signature = 'Expired';
									}else {
		                        	  	dataReleve.signature = 
		                        			  '<a class="clickMe" '
		                        			  +'ng-click="downloadImage('+idAgence+','+data.id+','+data.contratCollectionLists[i].id+')' 
		                        			  +'">download</a>';
		                        	}
                        	  }
                        	  
                        	 
                        	  if("A_PAYER_AVEC_ECHELONNEMENT" == data.contratCollectionLists[i].lignePaiementService[x].ligneContrat.serviceVendu.typePaiement){
                        		  var montantBalanceCf =  parseFloat(data.contratCollectionLists[i].lignePaiementService[x].montantTotalAPayer)-
                        		  parseFloat(data.contratCollectionLists[i].lignePaiementService[x].montantTotalDejaPaye);
                        		  
                        		  
                        		  if(data.etat ==  "VALIDE"){
                        			  
                        			  if(data.contratCollectionLists[i].lignePaiementService[x].montantPayeCollecteur){
                        				  montantBalanceCf = parseFloat(montantBalanceCf) 
                        				  - parseFloat(data.contratCollectionLists[i].lignePaiementService[x].montantPayeCollecteur);
                        			  }
                        			  if(data.contratCollectionLists[i].lignePaiementService[x].montantPayeAgence){
                        				  montantBalanceCf = parseFloat(montantBalanceCf) 
                        				  - parseFloat(data.contratCollectionLists[i].lignePaiementService[x].montantPayeAgence);
                        				  
                        			  }
                        		  }
                        		 
                        		  dataReleve.service = dataReleve.service +" Credit Balance : "+montantBalanceCf.toFixed(2) ;
                        		  
                        	  }
                        	  
                              for (var z = 0; z < data.paymentCorrectionList.length; z++){
                              	if(data.paymentCorrectionList[z].ligneContratId === data.contratCollectionLists[i].lignePaiementService[x].ligneContrat.id){
                              		
                              	  
                              		dataReleve.referenceContrat =  
                      			  	'<span title="'+ "Payment correction : "+data.paymentCorrectionList[z].montantTtc +" on "+ dataReleve.montantCollecte +" paid."
                      			  	+ '"><span class="label bg-color-red txt-color-white" ><i class="fa fa-exclamation"></i>  </span> ' 
                      			  	+'</span>'
                      			  	+ dataReleve.referenceContrat ;

                              		dataReleve.montantCollecte =  (dataReleve.montantCollecte +data.paymentCorrectionList[z].montantTtc) ;
                              	}
                              }
                              
                          	  dataArray.push(dataReleve);
                            }
                        	  
                    	}
                    	
                     }

             	   
                }

         		table.jqGrid('setGridParam', { data: dataArray })
                .trigger('reloadGrid');
         	});

            element.find(".ui-jqgrid").removeClass("ui-widget ui-widget-content");
            element.find(".ui-jqgrid-view").children().removeClass("ui-widget-header ui-state-default");
            element.find(".ui-jqgrid-labels, .ui-search-toolbar").children().removeClass("ui-state-default ui-th-column ui-th-ltr");
            element.find(".ui-jqgrid-pager").removeClass("ui-state-default");
            element.find(".ui-jqgrid").removeClass("ui-widget-content");

            // add classes
            element.find(".ui-jqgrid-htable").addClass("table table-bordered table-hover");
            element.find(".ui-jqgrid-btable").addClass("table table-bordered table-striped");

            element.find(".ui-pg-div").removeClass().addClass("btn btn-sm btn-primary");
            element.find(".ui-icon.ui-icon-plus").removeClass().addClass("fa fa-plus");
            element.find(".ui-icon.ui-icon-pencil").removeClass().addClass("fa fa-pencil");
            element.find(".ui-icon.ui-icon-trash").removeClass().addClass("fa fa-trash-o");
            element.find(".ui-icon.ui-icon-search").removeClass().addClass("fa fa-search");
            element.find(".ui-icon.ui-icon-refresh").removeClass().addClass("fa fa-refresh");
            element.find(".ui-icon.ui-icon-disk").removeClass().addClass("fa fa-save").parent(".btn-primary").removeClass("btn-primary").addClass("btn-success");
            element.find(".ui-icon.ui-icon-cancel").removeClass().addClass("fa fa-times").parent(".btn-primary").removeClass("btn-primary").addClass("btn-danger");

            element.find(".ui-icon.ui-icon-seek-prev").wrap("<div class='btn btn-sm btn-default'></div>");
            element.find(".ui-icon.ui-icon-seek-prev").removeClass().addClass("fa fa-backward");

            element.find(".ui-icon.ui-icon-seek-first").wrap("<div class='btn btn-sm btn-default'></div>");
            element.find(".ui-icon.ui-icon-seek-first").removeClass().addClass("fa fa-fast-backward");

            element.find(".ui-icon.ui-icon-seek-next").wrap("<div class='btn btn-sm btn-default'></div>");
            element.find(".ui-icon.ui-icon-seek-next").removeClass().addClass("fa fa-forward");

            element.find(".ui-icon.ui-icon-seek-end").wrap("<div class='btn btn-sm btn-default'></div>");
            element.find(".ui-icon.ui-icon-seek-end").removeClass().addClass("fa fa-fast-forward");

            $(window).on('resize.jqGrid', function() {
               table.jqGrid('setGridWidth', $("#content").width());
            });


            $compile(element.contents())(scope);
        }
    }
});
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth','$state'];

    function RequestResetController ($timeout, Auth,$state) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.requestLoginPage = requestLoginPage;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('[ng-model="resetAccount.email"]').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
        

	    function requestLoginPage () {
	        $state.go('home');
	    }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('[ng-model="vm.resetAccount.password"]').focus();});

        function finishReset() {
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getAdministrationDetail': { method:'GET', url:'api/users/:login/administration-detail' },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'},
            'bulkUpdate': { method:'POST', url:'api/users/bulk-update' },
            'exportCsv': {
                method: 'GET',
                url: 'api/users/export/csv',
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data, headersGetter) {
                    return {
                        response: new Blob([data], { type: headersGetter('Content-Type') || 'text/csv;charset=UTF-8' }),
                        fileName: getFileNameFromDisposition(headersGetter('Content-Disposition'))
                    };
                }
            }
        });

        return service;
    }

    function getFileNameFromDisposition(contentDisposition) {
        if (!contentDisposition) {
            return null;
        }
        var match = contentDisposition.match(/filename="(.+)"/);
        return match ? match[1] : null;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('UserSearch', UserSearch);

    UserSearch.$inject = ['$resource'];

    function UserSearch($resource) {
        var resourceUrl =  'api/users/';

        return $resource(resourceUrl, {}, {
            'searchCollecteur': { method: 'GET', url :'api/users/searchCollecteur', isArray: true},
            'searchUserArea': { method: 'GET', url :'api/users/searchUserCurrentArea', isArray: true},
            'searchUserByArea': { method: 'GET', url :'api/users/searchUserByArea', isArray: true}
            
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            hasModule: hasModule,
            identity: identity,
            isAuthenticated: isAuthenticated,
            getIdentityIfExist: getIdentityIfExist,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function hasModule (moduleArg) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.modules && _id.modules.indexOf(moduleArg) !== -1;
            }, function(){
                return false;
            });
        }
        
        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }

        function getIdentityIfExist () {
            return _identity;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular.module('wamasysApp').factory('Mfa', Mfa);
    Mfa.$inject = ['$http'];

    function Mfa($http) {
        // Les secrets d'enrôlement restent en mémoire ; aucun stockage local ni journalisation.
        return {
            status: function() { return $http.get('api/account/mfa').then(body); },
            setup: function(proof) { return $http.post('api/account/mfa/setup', proof).then(body); },
            activate: function(proof) { return $http.post('api/account/mfa/activate', proof).then(body); },
            disable: function(proof) { return $http.post('api/account/mfa/disable', proof).then(body); },
            managedStatus: function(login) { return $http.get(userUrl(login)).then(body); },
            disableForUser: function(login) { return $http.delete(userUrl(login)).then(body); }
        };

        function userUrl(login) { return 'api/users/' + encodeURIComponent(login) + '/mfa'; }
        function body(response) { return response.data; }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .directive('hasModule', hasModule);

    function hasModule(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var module = attrs.hasModule.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                };
            var setHidden = function () {
                    element.addClass('hidden');
                };
            var   defineVisibility = function (reset) {

//                    if (reset) {
//                        setVisible();
//                    }

                    Principal.hasModule(module)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (module.length > 0) {
                defineVisibility(false);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(false);
                });
            }
        }
    }
    
    

    angular
        .module('wamasysApp')
        .directive('cssColIfHasModule', cssColIfHasModule);

    function cssColIfHasModule(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var module = attrs.cssColIfHasModule.replace(/\s+/g, '');

            var setVisible = function () {
                element.addClass('col-md-8');
                element.removeClass('col-md-12');
                },
                setHidden = function () {
                    element.addClass('col-md-12');
                    element.removeClass('col-md-8');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasModule(module)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (module.length > 0) {
                defineVisibility(false);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(false);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .directive('hasAuthority', hasAuthority);

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

//            var setVisible = function () {
//                    element.removeClass('hidden');
//                };
            var setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

//                    if (reset) {
//                        setVisible();
//                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
//                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

//            var setVisible = function () {
//                    element.removeClass('hidden');
//                };
            var  setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
//                    if (reset) {
//                        setVisible();
//                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
//                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', '$injector'];

    function Auth ($rootScope, $state, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, $injector) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            changerAgence : changerAgence ,
            createAccount: createAccount,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        $rootScope.redirected = true;
                        $rootScope.previousStateName = $rootScope.toState;
                        $rootScope.previousStateNameParams = $rootScope.toStateParams;

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied');
                        LoginService.open();
                    }
                }
            }
        }

        function changePassword (currentPassword,newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save({"currentPassword":currentPassword,"newPassword":newPassword}, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }
        
        function changerAgence(idAgence, callback) {

            var cb = callback || angular.noop;
            var deferred = $q.defer();

        	
             AuthServerProvider.changerAgence(idAgence)
             	.then(changerAgenceThen)
             	.catch(function (err) {
	                this.logout();
	                deferred.reject(err);
	                return cb(err);
	            }.bind(this));

             function changerAgenceThen (data) {
                 Principal.identity(true).then(function(account) {
                     deferred.resolve(data);
                 });
                 return cb();
             }

             return deferred.promise;
            
            
        }
        
        function logout () {
            // Arrêter le flux et révoquer le navigateur avant de supprimer le JWT (sans attendre le réseau).
            $injector.get('NotificationInbox').prepareLogout();
            AuthServerProvider.logout();
            Principal.authenticate(null);

            // Reset state memory if not redirected
            if(!$rootScope.redirected) {
                $rootScope.previousStateName = undefined;
                $rootScope.previousStateNameParams = undefined;
            }
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            changerAgence: changerAgence,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function hasValidToken () {
            var token = this.getToken();
            return token && token.expires && token.expires > new Date().getTime();
        }


        function changerAgence (idAgence) {

        	return $http.post('/api/account/change_agence', idAgence).success(	
    	
    		function(data, status, headers){

                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    if($localStorage.authenticationToken ){
                        $localStorage.authenticationToken = jwt;
                    }
                    if($sessionStorage.authenticationToken ){
                    	$sessionStorage.authenticationToken = jwt;
                    }
                    return jwt;
                }
    
    		
    		});
    		
        }
        function login (credentials) {
            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe,
                mfaCode: credentials.mfaCode
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (jwt !== undefined) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            }
            else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('num-reference-contrat', {
            parent: 'entity',
            url: '/num-reference-contrat?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'wamasysApp.numReferenceContrat.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/num-reference-contrat/num-reference-contrats.html',
                    controller: 'NumReferenceContratController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('numReferenceContrat');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('num-reference-contrat-detail', {
            parent: 'entity',
            url: '/num-reference-contrat/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'wamasysApp.numReferenceContrat.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/num-reference-contrat/num-reference-contrat-detail.html',
                    controller: 'NumReferenceContratDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('numReferenceContrat');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'NumReferenceContrat', function($stateParams, NumReferenceContrat) {
                    return NumReferenceContrat.get({id : $stateParams.id});
                }]
            }
        })
        .state('num-reference-contrat.new', {
            parent: 'num-reference-contrat',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/num-reference-contrat/num-reference-contrat-dialog.html',
                    controller: 'NumReferenceContratDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                numeroActuel: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('num-reference-contrat', null, { reload: true });
                }, function() {
                    $state.go('num-reference-contrat');
                });
            }]
        })
        .state('num-reference-contrat.edit', {
            parent: 'num-reference-contrat',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/num-reference-contrat/num-reference-contrat-dialog.html',
                    controller: 'NumReferenceContratDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NumReferenceContrat', function(NumReferenceContrat) {
                            return NumReferenceContrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('num-reference-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('num-reference-contrat.delete', {
            parent: 'num-reference-contrat',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/num-reference-contrat/num-reference-contrat-delete-dialog.html',
                    controller: 'NumReferenceContratDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NumReferenceContrat', function(NumReferenceContrat) {
                            return NumReferenceContrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('num-reference-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('NumReferenceContrat', NumReferenceContrat);

    NumReferenceContrat.$inject = ['$resource'];

    function NumReferenceContrat ($resource) {
        var resourceUrl =  'api/num-reference-contrats/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('NumReferenceContratController', NumReferenceContratController);

    NumReferenceContratController.$inject = ['$scope', '$state', 'NumReferenceContrat', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function NumReferenceContratController ($scope, $state, NumReferenceContrat, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            NumReferenceContrat.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.numReferenceContrats = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('NumReferenceContratDialogController', NumReferenceContratDialogController);

    NumReferenceContratDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'NumReferenceContrat', 'Agence'];

    function NumReferenceContratDialogController ($scope, $stateParams, $uibModalInstance, entity, NumReferenceContrat, Agence) {
        var vm = this;
        vm.numReferenceContrat = entity;
        vm.agences = Agence.query();
        vm.load = function(id) {
            NumReferenceContrat.get({id : id}, function(result) {
                vm.numReferenceContrat = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:numReferenceContratUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.numReferenceContrat.id !== null) {
                NumReferenceContrat.update(vm.numReferenceContrat, onSaveSuccess, onSaveError);
            } else {
                NumReferenceContrat.save(vm.numReferenceContrat, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('NumReferenceContratDetailController', NumReferenceContratDetailController);

    NumReferenceContratDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'NumReferenceContrat', 'Agence'];

    function NumReferenceContratDetailController($scope, $rootScope, $stateParams, entity, NumReferenceContrat, Agence) {
        var vm = this;
        vm.numReferenceContrat = entity;
        vm.load = function (id) {
            NumReferenceContrat.get({id: id}, function(result) {
                vm.numReferenceContrat = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:numReferenceContratUpdate', function(event, result) {
            vm.numReferenceContrat = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('NumReferenceContratDeleteController',NumReferenceContratDeleteController);

    NumReferenceContratDeleteController.$inject = ['$uibModalInstance', 'entity', 'NumReferenceContrat'];

    function NumReferenceContratDeleteController($uibModalInstance, entity, NumReferenceContrat) {
        var vm = this;
        vm.numReferenceContrat = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            NumReferenceContrat.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'entity',
            url: '/user-management',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                pageTitle: 'user-management.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/user/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('mfa');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management-detail', {
            parent: 'entity',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/user/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('mfa');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/user/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                agence:null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/user/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/user/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'paginationConstants', 'JhiLanguageService', 'Agence', '$uibModal', '$window', 'AlertService', 'Mfa', '$translate', '$scope', '$interval'];

    function UserManagementController(Principal, User, ParseLinks, paginationConstants, JhiLanguageService, Agence, $uibModal, $window, AlertService, Mfa, $translate, $scope, $interval) {
        var vm = this;

        vm.authorities = ['ROLE_EQUIPMENT_READ', 'ROLE_EQUIPMENT_EDIT', 'ROLE_EQUIPMENT_SECRETS', 'ROLE_EQUIPMENT_REMOTE_CONTROL', 'ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_AREA_MANAGEMENT', 'ROLE_DATA_OPERATOR', 'ROLE_COLLECTOR', 'ROLE_SPECIFIC_PRICE', 'ROLE_READ_ONLY', 'ROLE_AI_ASSISTANT', 'ROLE_EVT_EDIT', 'ROLE_EVT_READ_ONLY', 'ROLE_FORM_VALIDATION', 'ROLE_BUDGET_READ_ONLY', 'ROLE_BUDGET_EDIT'];
        vm.agences = Agence.currentOrganisation();
        vm.currentAccount = null;
        vm.languages = null;
        vm.links = null;
        vm.page = 1;
        vm.selection = {};
        vm.selectAllOnPage = false;
        vm.selectedActivated = null;
        vm.selectedAgenceId = null;
        vm.selectedRole = null;
        vm.selectedAndroidDevice = null;
        vm.selectedAppVersion = null;
        vm.selectedMfaEnabled = null;
        vm.totalItems = null;
        vm.users = [];

        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.applyFilters = applyFilters;
        vm.resetFilters = resetFilters;
        vm.setActive = setActive;
        vm.disableMfa = disableMfa;
        vm.toggleSelectAll = toggleSelectAll;
        vm.updateSelectAllState = updateSelectAllState;
        vm.hasSelection = hasSelection;
        vm.selectedCount = selectedCount;
        vm.openBulkEdit = openBulkEdit;
        vm.downloadCsv = downloadCsv;

        vm.stateOptions = [
            { value: null, labelKey: 'userManagement.filters.allStates' },
            { value: true, labelKey: 'userManagement.activated' },
            { value: false, labelKey: 'userManagement.deactivated' }
        ];

        vm.androidDeviceOptions = [
            { value: null, labelKey: 'userManagement.android.allDevices' },
            { value: true, labelKey: 'userManagement.android.yes' },
            { value: false, labelKey: 'userManagement.android.no' }
        ];

        vm.mfaOptions = [
            { value: null, labelKey: 'userManagement.mfa.all' },
            { value: true, labelKey: 'userManagement.mfa.enabled' },
            { value: false, labelKey: 'userManagement.mfa.disabled' }
        ];

        vm.loadAll();

        // Ne remplace pas les lignes : les sélections restent intactes pendant le suivi.
        var presenceRequestPending = false;
        var presenceTimer = $interval(function () {
            if (presenceRequestPending || !vm.users.length) return;
            var currentUsers = vm.users;
            presenceRequestPending = true;
            User.query(buildQueryParams(true), function (result) {
                presenceRequestPending = false;
                if (vm.users !== currentUsers) return;
                var observations = {};
                angular.forEach(result, function (user) { observations[user.id] = user; });
                angular.forEach(currentUsers, function (user) {
                    var observation = observations[user.id];
                    if (!observation) { user.online = false; return; }
                    user.online = observation.online;
                    user.lastLoginDate = observation.lastLoginDate;
                    user.lastSeenDate = observation.lastSeenDate;
                });
            }, function () {
                presenceRequestPending = false;
                // Une présence non vérifiée ne doit pas rester affichée en ligne.
                angular.forEach(currentUsers, function (user) { user.online = false; });
            });
        }, 30000);
        $scope.$on('$destroy', function () { $interval.cancel(presenceTimer); });

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function loadAll () {
            User.query(buildQueryParams(true), function (result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.users = result;
                resetSelectionState();
            });
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        function applyFilters() {
            vm.page = 1;
            vm.loadAll();
        }

        function resetFilters() {
            vm.filter = null;
            vm.selectedRole = null;
            vm.selectedAgenceId = null;
            vm.selectedActivated = null;
            vm.selectedAndroidDevice = null;
            vm.selectedAppVersion = null;
            vm.selectedMfaEnabled = null;
            vm.applyFilters();
        }

        function disableMfa(user) {
            if (!user.mfaEnabled || user.mfaBusy ||
                !$window.confirm($translate.instant('mfa.adminConfirm', {login: user.login}))) { return; }
            user.mfaBusy = true;
            user.mfaError = false;
            // Réutiliser le déblocage administratif et ses contrôles de périmètre côté serveur.
            Mfa.disableForUser(user.login).then(function(status) {
                user.mfaEnabled = status.enabled;
                // Actualiser aussi le total et les résultats lorsque le filtre MFA est actif.
                vm.loadAll();
            }).catch(function() {
                user.mfaError = true;
            }).finally(function() {
                user.mfaBusy = false;
            });
        }

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
            if (vm.editForm) {
                vm.editForm.$setPristine();
                vm.editForm.$setUntouched();
            }
        }

        function toggleSelectAll() {
            angular.forEach(vm.users, function(user) {
                vm.selection[user.id] = vm.selectAllOnPage;
            });
        }

        function updateSelectAllState() {
            var allSelected = vm.users.length > 0;
            angular.forEach(vm.users, function(user) {
                if (!vm.selection[user.id]) {
                    allSelected = false;
                }
            });
            vm.selectAllOnPage = allSelected;
        }

        function hasSelection() {
            return selectedCount() > 0;
        }

        function selectedCount() {
            return getSelectedUserIds().length;
        }

        function openBulkEdit(action) {
            $uibModal.open({
                templateUrl: 'app/components/user-management-bulk-edit/user-management-bulk-edit-dialog.html',
                controller: 'UserManagementBulkEditDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    selectionCount: function () {
                        return selectedCount();
                    },
                    selectedUserIds: function () {
                        return getSelectedUserIds();
                    },
                    action: function () {
                        return action;
                    },
                    agences: function () {
                        return vm.agences;
                    },
                    authorities: function () {
                        return vm.authorities;
                    },
                    bulkService: function () {
                        return User;
                    }
                }
            }).result.then(function () {
                vm.loadAll();
            });
        }

        function downloadCsv() {
            User.exportCsv(buildQueryParams(false), function(result) {
                saveCsvFile(result, 'wamasys-users.csv');
            }, function(error) {
                AlertService.error(resolveErrorMessage(error, 'Export CSV impossible.'));
            });
        }

        function buildQueryParams(includePaging) {
            var params = {};
            if (vm.filter) {
                params.filter = vm.filter;
            }
            if (vm.selectedRole) {
                params.role = vm.selectedRole;
            }
            if (vm.selectedAgenceId) {
                params.agenceId = vm.selectedAgenceId;
            }
            if (vm.selectedActivated === true || vm.selectedActivated === false) {
                params.activated = vm.selectedActivated;
            }
            // Conserver les mêmes critères Android pour la pagination et l’export CSV.
            if (vm.selectedAndroidDevice === true || vm.selectedAndroidDevice === false) {
                params.androidDevice = vm.selectedAndroidDevice;
            }
            if (vm.selectedAppVersion && vm.selectedAppVersion.trim()) {
                params.appVersion = vm.selectedAppVersion.trim();
            }
            // Le filtre MFA est commun au tableau paginé et à l’export.
            if (vm.selectedMfaEnabled === true || vm.selectedMfaEnabled === false) {
                params.mfaEnabled = vm.selectedMfaEnabled;
            }
            if (includePaging) {
                params.page = vm.page - 1;
                params.size = paginationConstants.itemsPerPage;
            }
            return params;
        }

        function getSelectedUserIds() {
            var selectedUserIds = [];
            angular.forEach(vm.users, function(user) {
                if (vm.selection[user.id]) {
                    selectedUserIds.push(user.id);
                }
            });
            return selectedUserIds;
        }

        function resetSelectionState() {
            vm.selection = {};
            vm.selectAllOnPage = false;
        }

        function saveCsvFile(result, defaultFileName) {
            var url = $window.URL || $window.webkitURL;
            var fileName = result.fileName || defaultFileName;

            if ($window.navigator && $window.navigator.msSaveOrOpenBlob) {
                $window.navigator.msSaveOrOpenBlob(result.response, fileName);
                return;
            }

            var downloadLink = angular.element('<a></a>');
            downloadLink.attr('href', url.createObjectURL(result.response));
            downloadLink.attr('download', fileName);
            downloadLink[0].click();
            downloadLink.remove();
        }

        function resolveErrorMessage(error, defaultMessage) {
            if (error && error.data && error.data.message) {
                return error.data.message;
            }
            return defaultMessage;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService', 'Agence'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService, Agence) {
        var vm = this;

        vm.authorities = ['ROLE_EQUIPMENT_READ', 'ROLE_EQUIPMENT_EDIT', 'ROLE_EQUIPMENT_SECRETS', 'ROLE_EQUIPMENT_REMOTE_CONTROL', 'ROLE_ADMIN','ROLE_AREA_CONFIGURATION','ROLE_AREA_MANAGEMENT','ROLE_DATA_OPERATOR','ROLE_COLLECTOR','ROLE_SPECIFIC_PRICE','ROLE_READ_ONLY','ROLE_AI_ASSISTANT','ROLE_EVT_EDIT','ROLE_EVT_READ_ONLY','ROLE_FORM_VALIDATION','ROLE_BUDGET_READ_ONLY','ROLE_BUDGET_EDIT'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        vm.agences = Agence.query();

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User', 'Mfa', '$window', '$translate'];

    function UserManagementDetailController ($stateParams, User, Mfa, $window, $translate) {
        var vm = this;

        vm.load = load;
        vm.user = {};
        vm.disableMfa = disableMfa;

        vm.load($stateParams.login);

        function load (login) {
            User.getAdministrationDetail({login: login}, function(result) {
                vm.user = result;
                Mfa.managedStatus(login).then(function(status) { vm.mfaStatus = status; })
                    .catch(function() { vm.mfaStatus = null; });
            });
        }

        function disableMfa() {
            if (vm.mfaBusy || !$window.confirm($translate.instant('mfa.adminConfirm', {login: vm.user.login}))) { return; }
            vm.mfaBusy = true;
            vm.mfaError = null;
            Mfa.disableForUser(vm.user.login).then(function(status) {
                vm.mfaStatus = status;
                vm.mfaSuccess = true;
            }).catch(function() { vm.mfaError = true; }).finally(function() { vm.mfaBusy = false; });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.deleteError = null;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            vm.deleteError = null;
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                },
                function (error) {
                    vm.deleteError = (error.headers && error.headers('X-wamasysApp-detail')) || 'Suppression impossible.';
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeTaxController', TypeTaxController);

    TypeTaxController.$inject = ['$scope', '$state', 'TypeTax', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TypeTaxController ($scope, $state, TypeTax, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.isEmbeddedInContractSetup = $state.includes('modele-contrat.type-tax');
        vm.loadAll();

        function loadAll () {
            TypeTax.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.typeTaxs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('modele-contrat.type-tax', {
            url: '/type-tax/',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION', 'ROLE_READ_ONLY'],
                authenticate: true
            },
            views: {
                'panneau@content': {
                    templateUrl: 'app/business/type-tax/type-taxs.html',
                    controller: 'TypeTaxController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeTax');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('serviceVendu');
                    return $translate.refresh();
                }]
            }
        })
        .state('modele-contrat.type-tax.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-tax/type-tax-dialog.html',
                    controller: 'TypeTaxDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                taxRate: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('modele-contrat.type-tax', null, { reload: true });
                }, function() {
                    $state.go('modele-contrat.type-tax');
                });
            }]
        })
        .state('modele-contrat.type-tax.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-tax/type-tax-dialog.html',
                    controller: 'TypeTaxDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TypeTax', function(TypeTax) {
                            return TypeTax.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('modele-contrat.type-tax', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modele-contrat.type-tax.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-tax/type-tax-delete-dialog.html',
                    controller: 'TypeTaxDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TypeTax', function(TypeTax) {
                            return TypeTax.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('modele-contrat.type-tax', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-tax', {
            parent: 'entity',
            url: '/type-tax?page&sort&search',
            data: {   
                authorities: ['ROLE_AREA_CONFIGURATION', 'ROLE_READ_ONLY'],
                authenticate: true,
                pageTitle: 'wamasysApp.typeTax.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-tax/type-taxs.html',
                    controller: 'TypeTaxController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeTax');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('serviceVendu');
                    return $translate.refresh();
                }]
            }
        })
        .state('type-tax-detail', {
            parent: 'entity',
            url: '/type-tax/{id}',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION', 'ROLE_READ_ONLY'],
                authenticate: true,
                pageTitle: 'wamasysApp.typeTax.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-tax/type-tax-detail.html',
                    controller: 'TypeTaxDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeTax');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TypeTax', function($stateParams, TypeTax) {
                    return TypeTax.get({id : $stateParams.id});
                }]
            }
        })
        .state('type-tax.new', {
            parent: 'type-tax',
            url: '/new',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-tax/type-tax-dialog.html',
                    controller: 'TypeTaxDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                taxRate: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('type-tax', null, { reload: true });
                }, function() {
                    $state.go('type-tax');
                });
            }]
        })
        .state('type-tax.edit', {
            parent: 'type-tax',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-tax/type-tax-dialog.html',
                    controller: 'TypeTaxDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TypeTax', function(TypeTax) {
                            return TypeTax.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-tax', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-tax.delete', {
            parent: 'type-tax',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-tax/type-tax-delete-dialog.html',
                    controller: 'TypeTaxDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TypeTax', function(TypeTax) {
                            return TypeTax.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-tax', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('TypeTax', TypeTax);

    TypeTax.$inject = ['$resource'];

    function TypeTax ($resource) {
        var resourceUrl =  'api/type-tax/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeTaxDialogController', TypeTaxDialogController);

    TypeTaxDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeTax'];

    function TypeTaxDialogController ($scope, $stateParams, $uibModalInstance, entity, TypeTax) {
        var vm = this;
        vm.typeTax = entity;
        vm.load = function(id) {
            TypeTax.get({id : id}, function(result) {
                vm.typeTax = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:typeTaxUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.typeTax.id !== null) {
                TypeTax.update(vm.typeTax, onSaveSuccess, onSaveError);
            } else {
                TypeTax.save(vm.typeTax, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeTaxDetailController', TypeTaxDetailController);

    TypeTaxDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TypeTax'];

    function TypeTaxDetailController($scope, $rootScope, $stateParams, entity, TypeTax) {
        var vm = this;
        vm.typeTax = entity;
        vm.load = function (id) {
            TypeTax.get({id: id}, function(result) {
                vm.typeTax = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:typeTaxUpdate', function(event, result) {
            vm.typeTax = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeTaxDeleteController',TypeTaxDeleteController);

    TypeTaxDeleteController.$inject = ['$uibModalInstance', 'entity', 'TypeTax'];

    function TypeTaxDeleteController($uibModalInstance, entity, TypeTax) {
        var vm = this;
        vm.typeTax = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TypeTax.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$rootScope','$timeout','$location', '$state', 'Auth', 'Principal', 'ENV', 'LoginService', 'EventDashboard', '$scope'];

    function NavbarController ($rootScope,$timeout, $location, $state, Auth, Principal, ENV, LoginService, EventDashboard, $scope) {
        var vm = this;

        vm.navCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.inProduction = ENV === 'prod';
        vm.login = login;
        vm.logout = logout;
        vm.$state = $state;
        vm.eventDashboards = [];
        vm.hasAnyAuthority = hasAnyAuthority;

        // Manual saves and assistant creation refresh the menu without reloading the application.
        var unregisterDashboardUpdate = $rootScope.$on('wamasysApp:eventDashboardUpdate', loadEventDashboards);
        $scope.$on('$destroy', unregisterDashboardUpdate);

        function loadEventDashboards() {
            if (!hasAnyAuthority(['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_EVT_EDIT', 'ROLE_EVT_READ_ONLY'])) {
                return;
            }
            EventDashboard.navbar(function(result) {
                vm.eventDashboards = result;
                $timeout(function() {
                    $rootScope.$broadcast('refreshSmartMenu', 'refresh');
                });
            });
        }

        function login () {
            LoginService.open();
        }

        function logout () {
            Auth.logout();
            $state.go('home');
        }

        function hasAnyAuthority(authorities) {
            var userAuthorities = vm.user && vm.user.authorities ? vm.user.authorities : [];
            for (var i = 0; i < authorities.length; i++) {
                if (userAuthorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }
            return false;
        }
        
        vm.user = {} ;
        Principal.identity().then(function(account) {
        	  vm.user = account;
              $timeout(function() {
                  $rootScope.$broadcast('refreshSmartMenu','refresh');
              });

 			 if(vm.user.listDashboardKibana && typeof vm.user.listDashboardKibana === 'string'){
        		 try {
        			 vm.user.listDashboardKibana = JSON.parse(vm.user.listDashboardKibana);
        			 $timeout(function() {
        				$rootScope.$broadcast('refreshSmartMenu','refresh');
        			 });
        			 
         	    } catch (e) {
         	    	console.log(e);
         	    } 
			 }

             loadEventDashboards();
 			 
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .directive('activeMenu', activeMenu);

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();
;
'use strict';

angular.module('wamasysApp')
    .controller('HeaderController', function ($scope, $location,  $translate, $state, JhiLanguageService,Auth, ManualHelpContextService,Principal, ENV, NotificationInbox) {
        $scope.isAuthenticated = Principal.isAuthenticated;
        $scope.$state = $state;
        $scope.inProduction = ENV === 'prod';
        
        $scope.currentLanguage =  $translate.use();
    	
    
        var vm = this;
        vm.notifications = NotificationInbox.state;
        vm.refreshNotifications = NotificationInbox.refresh;
        $scope.$on('$stateChangeSuccess', function () { vm.notifications.toast = null; });
        vm.showteamwork = false;
        vm.searchContratHeader = '' ;
        vm.canSearchManualHelp = false;
        vm.canUseAssistant = false;
        vm.canSeeNewFeatures = false;
        vm.isSuperAdmin = false;

        vm.isAuthenticated = Principal.isAuthenticated;
        vm.username = "" ;
        vm.user = {} ;
        Principal.identity().then(function(account) {
        	if(account){
              updateUserContext(account);

        	}
        });

        $scope.$watch(function () {
            return Principal.getIdentityIfExist();
        }, function (account) {
            if (account) {
                updateUserContext(account);
            } else {
                vm.showteamwork = false;
            }
        });
        
        $scope.logout = function () {
            Auth.logout();
            $state.go('home');
        };
        
        vm.searchContrat = function(){
        	  $state.go('contrat', {searchQuery:vm.searchContratHeader},null);
        }

		vm.openAssistant = openAssistant;
		function openAssistant() {
            if (!vm.canSearchManualHelp) {
                return;
            }
		    ManualHelpContextService.openAssistant();
		}

        function hasAssistantAuthority(authorities) {
            var index;
            for (index = 0; index < authorities.length; index++) {
                if (authorities[index] === 'ROLE_AI_ASSISTANT'
                    || authorities[index] === 'ROLE_ADMIN'
                    || authorities[index] === 'ROLE_SUPER_ADMIN') {
                    return true;
                }
            }
            return false;
        }

        function hasManualHelpSearchAuthority(authorities) {
            var index;
            for (index = 0; index < authorities.length; index++) {
                if (authorities[index] === 'ROLE_DATA_OPERATOR'
                    || authorities[index] === 'ROLE_READ_ONLY'
                    || authorities[index] === 'ROLE_AREA_MANAGEMENT'
                    || authorities[index] === 'ROLE_COLLECTOR'
                    || authorities[index] === 'ROLE_AI_ASSISTANT'
                    || authorities[index] === 'ROLE_ADMIN'
                    || authorities[index] === 'ROLE_SUPER_ADMIN') {
                    return true;
                }
            }
            return false;
        }

        function updateUserContext(account) {
            var authorities = account.authorities || [];
            var modules = account.modules || [];

            vm.username = account.login;
            vm.user = account;
            vm.canSearchManualHelp = hasManualHelpSearchAuthority(authorities);
            vm.canUseAssistant = modules.indexOf('AI_ASSISTANT') !== -1
                && hasAssistantAuthority(authorities);
            vm.canSeeNewFeatures = modules.indexOf('NEW_FEATURES_VISIBILITY') !== -1;
            vm.isSuperAdmin = authorities.indexOf('ROLE_SUPER_ADMIN') !== -1;
            vm.showteamwork = modules.indexOf('TEAM') !== -1;
            ManualHelpContextService.setCapabilities(vm.canSearchManualHelp, vm.canUseAssistant);
        }

    })
    .directive('myEnter', function () {
	    return function (scope, element, attrs) {
	
	        element.on('keydown', function (event) {
	            if (event.which === 13) {
	
	                scope.$applyAsync(function () {
	                    scope.$eval(attrs.myEnter);
	                });
	
	                event.preventDefault();
	                event.stopPropagation();
	            }
	        });
	
	        scope.$on('$destroy', function () {
	            element.off('keydown');
	        });
	    };
    });

//    .directive('myEnter', function () {
//	    return function (scope, element, attrs) {
//	        element.bind("keydown keypress", function (event) {
//	            if(event.which === 13) {
//	                scope.$apply(function (){
//	                    scope.$eval(attrs.myEnter);
//	                });
//	
//	                event.preventDefault();
//	            }
//	        });
//	    };
//	});
    
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();
;
(function(){
    'use strict';

    angular
        .module('wamasysApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse (header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if( angular.isString(page) ) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();
;
(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    '<span translate="global.itemCount" translate-values="{first: $ctrl.queryCount === 0 ? 0 : (($ctrl.page - 1) * 20) + 1, second: ($ctrl.page * 20) < $ctrl.queryCount ? ($ctrl.page * 20) : $ctrl.queryCount, total: $ctrl.queryCount}">' +
                        'Showing {{ $ctrl.queryCount === 0 ? 0 : (($ctrl.page - 1) * 20) + 1 }} - ' +
                        '{{ ($ctrl.page * 20) < $ctrl.queryCount ? ($ctrl.page * 20) : $ctrl.queryCount }} ' +
                        'of {{ $ctrl.queryCount }} items.' +
                    '</span>' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total'
        }
    };

    angular
        .module('wamasysApp')
        .component('jhiItemCount', jhiItemCount);
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('wamasysApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }
        }
    }
})();
;
(function(){
    "use strict";

    angular.module('SmartAdmin', [
        "SmartAdmin.Forms",
        "SmartAdmin.Layout",
        "SmartAdmin.UI"
    ]);
})();;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('type-service', {
            parent: 'entity',
            url: '/type-service?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.typeService.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-service/type-services.html',
                    controller: 'TypeServiceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeService');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('type-service-detail', {
            parent: 'entity',
            url: '/type-service/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.typeService.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-service/type-service-detail.html',
                    controller: 'TypeServiceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeService');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TypeService', function($stateParams, TypeService) {
                    return TypeService.get({id : $stateParams.id});
                }]
            }
        })
        .state('type-service.new', {
            parent: 'type-service',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-service/type-service-dialog.html',
                    controller: 'TypeServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('type-service', null, { reload: true });
                }, function() {
                    $state.go('type-service');
                });
            }]
        })
        .state('type-service.edit', {
            parent: 'type-service',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-service/type-service-dialog.html',
                    controller: 'TypeServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TypeService', function(TypeService) {
                            return TypeService.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-service', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-service.delete', {
            parent: 'type-service',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-service/type-service-delete-dialog.html',
                    controller: 'TypeServiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TypeService', function(TypeService) {
                            return TypeService.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-service', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('TypeService', TypeService);

    TypeService.$inject = ['$resource'];

    function TypeService ($resource) {
        var resourceUrl =  'api/type-services/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeServiceController', TypeServiceController);

    TypeServiceController.$inject = ['$scope', '$state', 'TypeService', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TypeServiceController ($scope, $state, TypeService, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            TypeService.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.typeServices = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeServiceDialogController', TypeServiceDialogController);

    TypeServiceDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeService'];

    function TypeServiceDialogController ($scope, $stateParams, $uibModalInstance, entity, TypeService) {
        var vm = this;
        vm.typeService = entity;
        vm.load = function(id) {
            TypeService.get({id : id}, function(result) {
                vm.typeService = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:typeServiceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.typeService.id !== null) {
                TypeService.update(vm.typeService, onSaveSuccess, onSaveError);
            } else {
                TypeService.save(vm.typeService, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeServiceDetailController', TypeServiceDetailController);

    TypeServiceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TypeService'];

    function TypeServiceDetailController($scope, $rootScope, $stateParams, entity, TypeService) {
        var vm = this;
        vm.typeService = entity;
        vm.load = function (id) {
            TypeService.get({id: id}, function(result) {
                vm.typeService = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:typeServiceUpdate', function(event, result) {
            vm.typeService = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeServiceDeleteController',TypeServiceDeleteController);

    TypeServiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'TypeService'];

    function TypeServiceDeleteController($uibModalInstance, entity, TypeService) {
        var vm = this;
        vm.typeService = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TypeService.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('UserManagementBulkEditDialogController', UserManagementBulkEditDialogController);

    UserManagementBulkEditDialogController.$inject = ['$uibModalInstance', 'selectionCount', 'selectedUserIds', 'action', 'agences', 'authorities', 'bulkService'];

    function UserManagementBulkEditDialogController($uibModalInstance, selectionCount, selectedUserIds, action, agences, authorities, bulkService) {
        var vm = this;

        vm.agences = agences;
        vm.authorities = authorities;
        vm.isSaving = false;
        vm.selectionCount = selectionCount;
        vm.form = {
            userIds: selectedUserIds,
            operation: action,
            authority: null,
            agenceId: null
        };

        vm.clear = clear;
        vm.save = save;
        vm.isAuthorityAction = isAuthorityAction;
        vm.isAgenceAction = isAgenceAction;
        vm.getTitleKey = getTitleKey;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            bulkService.bulkUpdate(vm.form, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function isAuthorityAction() {
            return vm.form.operation === 'ADD_AUTHORITY' || vm.form.operation === 'REMOVE_AUTHORITY';
        }

        function isAgenceAction() {
            return vm.form.operation === 'ADD_AGENCE' || vm.form.operation === 'REMOVE_AGENCE';
        }

        function getTitleKey() {
            return 'userManagement.bulk.actions.' + vm.form.operation;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope,$state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.textErreur = 'login.messages.error.authentication';
        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;
        vm.mfaRequired = false;
        vm.mfaCode = null;
        vm.submitting = false;

        $timeout(function (){angular.element('[ng-model="vm.username"]').focus();});

        function cancel () {
            vm.password = null;
            vm.mfaCode = null;
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            if (vm.submitting) { return; }
            vm.submitting = true;
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe,
                mfaCode: vm.mfaCode
            }).then(function () {
                vm.authenticationError = false;
                vm.password = null;
                vm.mfaCode = null;
                $uibModalInstance.close();
                // If we're redirected to login, our
                // previousState is already set in the authExpiredInterceptor. When login succesful go to stored state
                if ($rootScope.redirected && $rootScope.previousStateName) {
                    $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
                    $rootScope.redirected = false;
                } else {
                    $rootScope.$broadcast('authenticationSuccess');
                }
            }).catch(function (erreur) {
                var errorKey = erreur.data && erreur.data.errorKey;
                vm.textErreur = errorKey || erreur.headers('X-wamasysApp-error') || 'login.messages.error.authentication';
                vm.mfaRequired = !!(erreur.data && erreur.data.mfa_required);
                vm.mfaCode = null;
                // Le premier code demandé est une étape normale, pas une erreur de mot de passe.
                vm.authenticationError = vm.textErreur !== 'login.messages.error.mfaRequired';
                if (vm.mfaRequired) {
                    $timeout(function() { angular.element('[ng-model="vm.mfaCode"]').focus(); });
                }
            }).finally(function() {
                vm.submitting = false;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();
;
(function() {
    'use strict';

    var DEFAULT_AGENCE_POSITION = { lat: 48.8582846, lon: 2.2944474 };
    var DEFAULT_ZOOM = 10;
    var READONLY_ZOOM = 16;
    var GEOMETRY_PATH_COLOR = '#2e3974';
    var GEOMETRY_HOLE_COLOR = '#6f7d8c';

    var mapLeaflet = {
        bindings: {
            contrat: '=',
            readonly: '@',
            geometry: '=?',
            geometryEditable: '@',
            refreshToken: '<?',
            height: '@',
            width: '@'
        },
        templateUrl: 'app/components/map-leaflet/map-leaflet.tpl.html',
        controller: mapLeafletController
    };

    mapLeafletController.$inject = ['$scope', '$attrs', '$timeout', 'Principal', 'leafletData'];

    function mapLeafletController($scope, $attrs, $timeout, Principal, leafletData) {
        var ctrl = this;
        var hasExplicitGeometryBinding = angular.isDefined($attrs.geometry);

        ctrl.markerEditMode = false;
        ctrl.geometryEditMode = false;
        ctrl.geometryPointCreationMode = false;
        ctrl.activeGeometryRing = null;
        ctrl.isReadonly = isReadonly;
        ctrl.hasGeometryEditor = hasGeometryEditor;
        ctrl.toggleGeometryEditMode = toggleGeometryEditMode;
        ctrl.toggleGeometryPointCreationMode = toggleGeometryPointCreationMode;
        ctrl.clearGeometry = clearGeometry;
        ctrl.updateCoord = updateCoord;
        ctrl.mapId = 'map_leaflet_' + Math.floor(Math.random() * 1000000000);

        angular.extend($scope, {
            center: {},
            bounds: {},
            markers: {},
            defaults: {},
            paths: {},
            layers: {
                baselayers: {
                    osm: {
                        name: 'OpenStreetMap',
                        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                        type: 'xyz'
                    },
                    satelite: {
                        name: 'Satelite',
                        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                        type: 'xyz'
                    }
                }
            },
            events: {
                map: {
                    enable: ['click', 'contextmenu'],
                    logic: 'emit'
                }
            }
        });

        ctrl.$onInit = function() {
            refreshMap();
            scheduleInvalidateMapSize(4);
        };

        function hasCoordValue(value) {
            return value !== null && value !== undefined && value !== '';
        }

        function hasCoordinates() {
            return ctrl.contrat && hasCoordValue(ctrl.contrat.lat) && hasCoordValue(ctrl.contrat.lon);
        }

        function getMarkerLabel() {
            if (!ctrl.contrat) {
                return '';
            }
            return ctrl.contrat.referenceContrat || ctrl.contrat.numeroSerie || ctrl.contrat.nom || '';
        }

        function isReadonly() {
            return ctrl.readonly === true || ctrl.readonly === 'true';
        }

        function hasGeometryEditor() {
            return ctrl.geometryEditable === true || ctrl.geometryEditable === 'true';
        }

        function getGeometryValue() {
            if (hasExplicitGeometryBinding) {
                return ctrl.geometry;
            }
            return ctrl.contrat ? ctrl.contrat.geographicCoord : null;
        }

        function setGeometryValue(value) {
            if (hasExplicitGeometryBinding) {
                ctrl.geometry = value;
            } else if (ctrl.contrat) {
                ctrl.contrat.geographicCoord = value;
            }
        }

        function buildMarkerState() {
            var markers = {};

            if (hasCoordinates()) {
                var markerLabel = getMarkerLabel();
                markers.contrat = {
                    lat: ctrl.contrat.lat,
                    lng: ctrl.contrat.lon,
                    message: (markerLabel ? markerLabel + '<br/> ' : '') + '@' + ctrl.contrat.lat + ',' + ctrl.contrat.lon,
                    draggable: !isReadonly() && ctrl.markerEditMode
                };
            }

            return markers;
        }

        function refreshMap() {
            var geometryState = buildGeometryState();
            var markers = buildMarkerState();

            angular.extend(markers, geometryState.markers);

            angular.extend($scope, {
                defaults: {
                    scrollWheelZoom: false
                },
                markers: markers,
                paths: geometryState.paths,
                bounds: geometryState.bounds
            });

            refreshCenter(geometryState.bounds);
            scheduleInvalidateMapSize(1);
        }

        function scheduleInvalidateMapSize(retryCount) {
            $timeout(function() {
                leafletData.getMap(ctrl.mapId).then(function(map) {
                    if (!map || !map.invalidateSize) {
                        return;
                    }

                    map.invalidateSize(false);

                    if (retryCount > 0) {
                        scheduleInvalidateMapSize(retryCount - 1);
                    }
                }, angular.noop);
            }, 150, false);
        }

        function refreshCenter(boundsOverride) {
            var bounds = boundsOverride || buildGeometryState().bounds;

            if (bounds && bounds.southWest && bounds.northEast) {
                angular.extend($scope, {
                    center: {
                        lat: (bounds.southWest.lat + bounds.northEast.lat) / 2,
                        lng: (bounds.southWest.lng + bounds.northEast.lng) / 2,
                        zoom: isReadonly() ? READONLY_ZOOM : DEFAULT_ZOOM
                    }
                });
                return;
            }

            if (hasCoordinates()) {
                angular.extend($scope, {
                    center: {
                        lat: ctrl.contrat.lat,
                        lng: ctrl.contrat.lon,
                        zoom: isReadonly() ? READONLY_ZOOM : DEFAULT_ZOOM
                    }
                });
                return;
            }

            angular.extend($scope, {
                center: {
                    lat: DEFAULT_AGENCE_POSITION.lat,
                    lng: DEFAULT_AGENCE_POSITION.lon,
                    zoom: 5
                }
            });
        }

        function buildGeometryState() {
            var geometryData = parseGeometryValue(getGeometryValue());
            var paths = {};
            var markers = {};
            var bounds = emptyBounds();

            if (!geometryData || !geometryData.geometry || !angular.isArray(geometryData.geometry.coordinates)) {
                return {
                    paths: paths,
                    markers: markers,
                    bounds: null
                };
            }

            angular.forEach(geometryData.geometry.coordinates, function(polygon, polygonIndex) {
                if (!angular.isArray(polygon)) {
                    return;
                }

                angular.forEach(polygon, function(ring, ringIndex) {
                    if (!angular.isArray(ring) || !ring.length) {
                        return;
                    }

                    var ringLatLngs = [];
                    var uniqueRingCoordinates = getUniqueRingCoordinates(ring);

                    angular.forEach(ring, function(point) {
                        if (!isValidCoordinate(point)) {
                            return;
                        }

                        ringLatLngs.push({
                            lat: point[1],
                            lng: point[0]
                        });
                        extendBounds(bounds, point[1], point[0]);
                    });

                    if (ringLatLngs.length >= 3) {
                        // On garde un rendu simple par anneau pour rester compatible avec l'existant ui-leaflet.
                        paths['geometry_' + polygonIndex + '_' + ringIndex] = {
                            color: ringIndex === 0 ? GEOMETRY_PATH_COLOR : GEOMETRY_HOLE_COLOR,
                            fillColor: ringIndex === 0 ? GEOMETRY_PATH_COLOR : GEOMETRY_HOLE_COLOR,
                            fillOpacity: ringIndex === 0 ? 0.15 : 0.08,
                            weight: ringIndex === 0 ? 3 : 2,
                            type: 'polygon',
                            latlngs: ringLatLngs
                        };
                    }

                    if (hasGeometryEditor()) {
                        angular.forEach(uniqueRingCoordinates, function(point, pointIndex) {
                            markers[getVertexMarkerName(polygonIndex, ringIndex, pointIndex)] = {
                                lat: point[1],
                                lng: point[0],
                                draggable: ctrl.geometryEditMode,
                                riseOnHover: true
                            };
                        });
                    }
                });
            });

            return {
                paths: paths,
                markers: markers,
                bounds: bounds.isEmpty ? null : {
                    southWest: {
                        lat: bounds.minLat,
                        lng: bounds.minLng
                    },
                    northEast: {
                        lat: bounds.maxLat,
                        lng: bounds.maxLng
                    }
                }
            };
        }

        function emptyBounds() {
            return {
                minLat: null,
                maxLat: null,
                minLng: null,
                maxLng: null,
                isEmpty: true
            };
        }

        function extendBounds(bounds, lat, lng) {
            if (!bounds) {
                return;
            }

            if (bounds.isEmpty) {
                bounds.minLat = lat;
                bounds.maxLat = lat;
                bounds.minLng = lng;
                bounds.maxLng = lng;
                bounds.isEmpty = false;
                return;
            }

            bounds.minLat = Math.min(bounds.minLat, lat);
            bounds.maxLat = Math.max(bounds.maxLat, lat);
            bounds.minLng = Math.min(bounds.minLng, lng);
            bounds.maxLng = Math.max(bounds.maxLng, lng);
        }

        function parseGeometryValue(geometryValue) {
            if (!geometryValue) {
                return null;
            }

            try {
                return angular.fromJson(geometryValue);
            } catch (error) {
                return null;
            }
        }

        function isValidCoordinate(point) {
            return angular.isArray(point) && point.length >= 2 && angular.isNumber(point[0]) && angular.isNumber(point[1]);
        }

        function getVertexMarkerName(polygonIndex, ringIndex, pointIndex) {
            return ['geometryVertex', polygonIndex, ringIndex, pointIndex].join('_');
        }

        function parseVertexMarkerName(markerName) {
            if (!markerName || markerName.indexOf('geometryVertex_') !== 0) {
                return null;
            }

            var parts = markerName.split('_');
            if (parts.length !== 4) {
                return null;
            }

            return {
                polygonIndex: parseInt(parts[1], 10),
                ringIndex: parseInt(parts[2], 10),
                pointIndex: parseInt(parts[3], 10)
            };
        }

        function getUniqueRingCoordinates(ring) {
            var uniqueCoordinates = angular.copy(ring || []);

            if (uniqueCoordinates.length > 1 && isSameCoordinate(uniqueCoordinates[0], uniqueCoordinates[uniqueCoordinates.length - 1])) {
                uniqueCoordinates.pop();
            }

            return uniqueCoordinates;
        }

        function isSameCoordinate(firstPoint, secondPoint) {
            return isValidCoordinate(firstPoint) && isValidCoordinate(secondPoint)
                && firstPoint[0] === secondPoint[0]
                && firstPoint[1] === secondPoint[1];
        }

        function ensureGeometryObject() {
            var geometryData = parseGeometryValue(getGeometryValue());

            // On force toujours une structure Elastic MultiPolygon minimale pour pouvoir éditer la géométrie.
            if (!geometryData || !geometryData.geometry || geometryData.geometry.type !== 'MultiPolygon' || !angular.isArray(geometryData.geometry.coordinates)) {
                geometryData = {
                    geometry: {
                        type: 'MultiPolygon',
                        coordinates: [
                            [
                                []
                            ]
                        ]
                    }
                };
            }

            if (!geometryData.geometry.coordinates.length) {
                geometryData.geometry.coordinates.push([[]]);
            }

            if (!geometryData.geometry.coordinates[0].length) {
                geometryData.geometry.coordinates[0].push([]);
            }

            return geometryData;
        }

        function ensureGeometryRing(geometryData, polygonIndex, ringIndex) {
            while (geometryData.geometry.coordinates.length <= polygonIndex) {
                geometryData.geometry.coordinates.push([[]]);
            }

            while (geometryData.geometry.coordinates[polygonIndex].length <= ringIndex) {
                geometryData.geometry.coordinates[polygonIndex].push([]);
            }
        }

        function closeRing(uniqueCoordinates) {
            var closedRing = angular.copy(uniqueCoordinates || []);

            // Le backend attend un anneau fermé : on duplique le premier point en fin de tableau dès que le polygone est dessinable.
            if (closedRing.length >= 3) {
                closedRing.push(angular.copy(closedRing[0]));
            }

            return closedRing;
        }

        function saveGeometryObject(geometryData) {
            setGeometryValue(angular.toJson(geometryData, true));
            refreshMap();
        }

        function updateEditableRing(uniqueCoordinates, polygonIndex, ringIndex) {
            var geometryData = ensureGeometryObject();
            var safePolygonIndex = angular.isNumber(polygonIndex) ? polygonIndex : 0;
            var safeRingIndex = angular.isNumber(ringIndex) ? ringIndex : 0;

            ensureGeometryRing(geometryData, safePolygonIndex, safeRingIndex);
            geometryData.geometry.coordinates[safePolygonIndex][safeRingIndex] = closeRing(uniqueCoordinates);
            saveGeometryObject(geometryData);
        }

        function getEditableRingUniqueCoordinates(polygonIndex, ringIndex) {
            var geometryData = ensureGeometryObject();
            var safePolygonIndex = angular.isNumber(polygonIndex) ? polygonIndex : 0;
            var safeRingIndex = angular.isNumber(ringIndex) ? ringIndex : 0;

            ensureGeometryRing(geometryData, safePolygonIndex, safeRingIndex);
            return getUniqueRingCoordinates(geometryData.geometry.coordinates[safePolygonIndex][safeRingIndex]);
        }

        function toggleGeometryEditMode() {
            if (!hasGeometryEditor()) {
                return;
            }

            ctrl.geometryEditMode = !ctrl.geometryEditMode;
            refreshMap();
        }

        function toggleGeometryPointCreationMode() {
            if (!hasGeometryEditor()) {
                return;
            }

            ctrl.geometryPointCreationMode = !ctrl.geometryPointCreationMode;
        }

        function clearGeometry() {
            if (!hasGeometryEditor()) {
                return;
            }

            ctrl.geometryEditMode = false;
            ctrl.geometryPointCreationMode = false;
            ctrl.activeGeometryRing = null;
            setGeometryValue(null);
            refreshMap();
        }

        function getActiveGeometryRing() {
            if (ctrl.activeGeometryRing) {
                return ctrl.activeGeometryRing;
            }

            return {
                polygonIndex: 0,
                ringIndex: 0
            };
        }

        function addGeometryPoint(latlng) {
            var activeRing;
            if (!latlng) {
                return;
            }

            activeRing = getActiveGeometryRing();

            var uniqueCoordinates = getEditableRingUniqueCoordinates(activeRing.polygonIndex, activeRing.ringIndex);
            uniqueCoordinates.push([latlng.lng, latlng.lat]);
            updateEditableRing(uniqueCoordinates, activeRing.polygonIndex, activeRing.ringIndex);
        }

        function updateGeometryPoint(markerName, latlng) {
            var markerMetadata = parseVertexMarkerName(markerName);
            var geometryData;
            var uniqueCoordinates;

            if (!markerMetadata || !latlng) {
                return;
            }

            geometryData = ensureGeometryObject();

            if (!geometryData.geometry.coordinates[markerMetadata.polygonIndex]
                || !geometryData.geometry.coordinates[markerMetadata.polygonIndex][markerMetadata.ringIndex]) {
                return;
            }

            uniqueCoordinates = getUniqueRingCoordinates(geometryData.geometry.coordinates[markerMetadata.polygonIndex][markerMetadata.ringIndex]);

            if (!uniqueCoordinates[markerMetadata.pointIndex]) {
                return;
            }

            ctrl.activeGeometryRing = {
                polygonIndex: markerMetadata.polygonIndex,
                ringIndex: markerMetadata.ringIndex
            };
            uniqueCoordinates[markerMetadata.pointIndex] = [latlng.lng, latlng.lat];
            geometryData.geometry.coordinates[markerMetadata.polygonIndex][markerMetadata.ringIndex] = closeRing(uniqueCoordinates);
            saveGeometryObject(geometryData);
        }

        function updateCoord() {
            refreshMap();
        }

        function getMapScopedLeafletEventName(eventName) {
            var firstSeparatorIndex = eventName.indexOf('.');

            if (!ctrl.mapId || firstSeparatorIndex === -1) {
                return eventName;
            }

            return eventName.substring(0, firstSeparatorIndex) + '.' + ctrl.mapId + eventName.substring(firstSeparatorIndex);
        }

        function listenLeafletEvent(eventName, handler) {
            var scopedEventName = getMapScopedLeafletEventName(eventName);

            $scope.$on(eventName, handler);

            if (scopedEventName !== eventName) {
                // ui-leaflet prefixes events with the map id when the map has an id.
                $scope.$on(scopedEventName, handler);
            }
        }

        listenLeafletEvent('leafletDirectiveMap.contextmenu', function(event, args) {
            if (hasGeometryEditor()) {
                return;
            }

            if (!hasCoordinates()) {
                ctrl.contrat.lat = args.leafletEvent.latlng.lat;
                ctrl.contrat.lon = args.leafletEvent.latlng.lng;
                updateCoord();
            }
        });

        listenLeafletEvent('leafletDirectiveMap.click', function(event, args) {
            if (!hasGeometryEditor() || !ctrl.geometryPointCreationMode) {
                return;
            }

            addGeometryPoint(args.leafletEvent.latlng);
        });

        $scope.centerMap = function() {
            refreshCenter($scope.bounds);
        };

        $scope.deleteMarker = function() {
            ctrl.contrat.lat = null;
            ctrl.contrat.lon = null;
            ctrl.markerEditMode = false;
            refreshMap();
        };

        $scope.addMarker = function() {
            var agence = angular.copy(DEFAULT_AGENCE_POSITION);
            var account;

            if (hasCoordinates()) {
                return;
            }

            if (Principal.isIdentityResolved()) {
                account = Principal.getIdentityIfExist();

                if (account && account.agence && account.agence.lat && account.agence.lon) {
                    agence = account.agence;
                }
            }

            ctrl.contrat.lat = agence.lat;
            ctrl.contrat.lon = agence.lon;
            refreshMap();
        };

        $scope.editMarker = function() {
            $scope.addMarker();
            ctrl.markerEditMode = !ctrl.markerEditMode;
            refreshMap();
        };

        listenLeafletEvent('leafletDirectiveMarker.dragend', function(event, args) {
            var vertexMetadata = parseVertexMarkerName(args.modelName);

            if (vertexMetadata) {
                updateGeometryPoint(args.modelName, {
                    lat: args.model.lat,
                    lng: args.model.lng
                });
                return;
            }

            if (args.modelName === 'contrat') {
                ctrl.contrat.lat = args.model.lat;
                ctrl.contrat.lon = args.model.lng;
                refreshMap();
            }
        });

        listenLeafletEvent('leafletDirectiveMarker.click', function(event, args) {
            var vertexMetadata = parseVertexMarkerName(args.modelName);

            if (!vertexMetadata) {
                return;
            }

            ctrl.activeGeometryRing = {
                polygonIndex: vertexMetadata.polygonIndex,
                ringIndex: vertexMetadata.ringIndex
            };
        });

        $scope.$watchGroup([
            function() {
                return ctrl.contrat && ctrl.contrat.lat;
            },
            function() {
                return ctrl.contrat && ctrl.contrat.lon;
            },
            function() {
                return ctrl.contrat && getMarkerLabel();
            },
            function() {
                return getGeometryValue();
            },
            function() {
                return ctrl.markerEditMode;
            },
            function() {
                return ctrl.geometryEditMode;
            },
            function() {
                return ctrl.refreshToken;
            }
        ], function() {
            refreshMap();
        });
    }

    angular
        .module('wamasysApp')
        .component('mapLeaflet', mapLeaflet);
})();
;
(function() {
    'use strict';

    angular.module('wamasysApp').directive('smartphoneHandoffs', smartphoneHandoffs);

    smartphoneHandoffs.$inject = ['$http', '$window', '$timeout'];

    function smartphoneHandoffs($http, $window, $timeout) {
        return {
            restrict: 'E',
            scope: {documentType: '@', documentId: '=', document: '=?', onUpdated: '&?', onStatus: '&?'},
            templateUrl: 'app/components/smartphone-handoffs/smartphone-handoffs.html',
            link: function(scope) {
                var generation = 0;
                var page = 0;
                var baseUrl = 'api/smartphone/handoffs';
                scope.handoffs = [];
                scope.refresh = function() { page = 0; load(false); };
                scope.next = function() { load(true, page + 1); };
                scope.retry = retry;
                scope.downloadSource = downloadSource;
                scope.loadAttachments = loadAttachments;
                scope.downloadAttachment = downloadAttachment;
                // Seuls des diagnostics connus choisissent une traduction ; les codes bruts restent dans les détails.
                var reasons = ('PAYMENT_ITEM_MISSING PAYMENT_ITEM_MISMATCH PAYMENT_CONTRACT_MISMATCH ' +
                    'PAYMENT_SERVICE_DUPLICATED_IN_COLLECTION PAYMENT_ALLOCATIONS_MISSING PAYMENT_SERVICE_MISSING ' +
                    'PAYMENT_SERVICE_MISMATCH PAYMENT_SERVICE_DUPLICATED PAYMENT_AMOUNT_INVALID ' +
                    'PAYMENT_ALLOCATION_MISMATCH PAYMENT_RECEIPT_MISSING PAYMENT_TOTAL_MISSING INVALID_PAYMENT ' +
                    'PAYMENT_RECONCILIATION_REQUIRED READING_RECONCILIATION_REQUIRED MISSING_READING ' +
                    'ASSIGNMENT_REVIEW_REQUIRED RETRY_REQUIRED OFFICE_REVIEW_REQUIRED').split(' ');
                scope.issueKey = function(anomaly, field) {
                    var reason = reasons.indexOf(anomaly.reason) >= 0 ? anomaly.reason : 'OFFICE_REVIEW_REQUIRED';
                    return 'global.handoff.issues.' + reason + '.' + field;
                };
                scope.statusKey = function(row) {
                    var status = row.processingStatus;
                    if (!row.received) status = 'RECEIVING';
                    else if (['PENDING', 'PROCESSING', 'ANOMALY', 'READY', 'VALIDATED'].indexOf(status) < 0) status = 'UNKNOWN';
                    if (status === 'READY' && scope.documentType === 'RF') status = 'RF_READY';
                    return 'global.handoff.status.' + status;
                };
                scope.itemLabel = function(anomaly) {
                    if (anomaly.itemId == null || !scope.document) return null;
                    var document = scope.document;
                    var label = null;
                    // Utiliser le document autorisé déjà chargé, sans télécharger le dépôt contenant les données personnelles.
                    angular.forEach(document.contratCollectionLists || [], function(item) {
                        if (String(item.id) === String(anomaly.itemId) && item.contrat) {
                            label = [item.contrat.referenceContrat, item.contrat.nomPersonne].filter(Boolean).join(' — ');
                        }
                    });
                    function readingLabel(item) {
                        if (String(item.idLigneReleveCompteur) !== String(anomaly.itemId)) return;
                        var meter = item.individualMeter || item.bulkMeter || {};
                        label = [item.referenceContrat, item.nomContrat, meter.numeroSerie].filter(Boolean).join(' — ');
                    }
                    angular.forEach(document.clusterReleveCompteurDTO || [], function(cluster) {
                        angular.forEach(cluster.ligneReleveCompteur || [], readingLabel);
                    });
                    angular.forEach(document.listLigneReleveCompteurBulkMeter || [], readingLabel);
                    return label;
                };

                scope.$watchGroup(['documentId', 'documentType'], function() {
                    scope.handoffs = [];
                    scope.hasNext = false;
                    scope.loading = false;
                    scope.error = false;
                    if (scope.onStatus) scope.onStatus({received: false});
                    scope.refresh();
                });
                scope.$on('$destroy', function() { generation++; });

                function load(append, requestedPage) {
                    var requestGeneration = ++generation;
                    requestedPage = requestedPage || 0;
                    if (!scope.documentId || (scope.documentType !== 'CL' && scope.documentType !== 'RF')) return;
                    scope.loading = true;
                    scope.error = false;
                    $http.get(baseUrl + '/office', {params: {
                        documentType: scope.documentType, documentId: scope.documentId, page: requestedPage, size: 20
                    }}).then(function(response) {
                        if (generation !== requestGeneration) return;
                        var data = response.data || {};
                        var rows = angular.isArray(data.content) ? data.content : [];
                        angular.forEach(rows, function(row) {
                            row.received = row.received === true || !!row.receivedAt;
                            // Le rapport est du texte, jamais du HTML ni du code à interpréter.
                            try {
                                row.report = angular.isString(row.processingReport)
                                    ? angular.fromJson(row.processingReport) : row.processingReport;
                            } catch (ignored) { row.reportUnavailable = true; }
                            row.report = row.report || {};
                            row.anomalies = angular.isArray(row.report.anomalies) ? row.report.anomalies : [];
                        });
                        scope.handoffs = append ? scope.handoffs.concat(rows) : rows;
                        page = requestedPage;
                        scope.hasNext = data.hasNext === true || data.last === false;
                        if (scope.onStatus) scope.onStatus({received: scope.handoffs.some(function(row) {
                            return row.received && row.applicationAuthorized;
                        })});
                    }, function() {
                        if (generation !== requestGeneration) return;
                        // Une API absente ou refusée n'est pas présentée comme zéro dépôt.
                        scope.error = true;
                    }).finally(function() {
                        if (generation === requestGeneration) scope.loading = false;
                    });
                }

                function idOf(row) { return encodeURIComponent(row.handoffId || row.id); }

                function retry(row) {
                    if (row.busy) return;
                    row.busy = true;
                    row.error = false;
                    $http.post(baseUrl + '/' + idOf(row) + '/retry', {}).then(function() {
                        scope.refresh();
                        if (scope.onUpdated) scope.onUpdated();
                    }, function() { row.error = true; }).finally(function() { row.busy = false; });
                }

                function downloadSource(row) {
                    download(baseUrl + '/' + idOf(row) + '/payload', 'depot-' + idOf(row) + '.json', row);
                }

                function loadAttachments(row) {
                    row.loadingAttachments = true;
                    $http.get(baseUrl + '/' + idOf(row) + '/attachments').then(function(response) {
                        var data = response.data;
                        row.attachments = angular.isArray(data) ? data : (data && data.content) || [];
                        row.attachmentsLoaded = true;
                    }, function() { row.error = true; }).finally(function() { row.loadingAttachments = false; });
                }

                function downloadAttachment(row, attachment) {
                    var id = encodeURIComponent(attachment.attachmentId || attachment.id);
                    download(baseUrl + '/' + idOf(row) + '/attachments/' + id, 'piece-' + id, row);
                }

                function download(url, filename, row) {
                    row.error = false;
                    $http.get(url, {responseType: 'blob'}).then(function(response) {
                        // $http conserve l'authentification ; aucun JWT dans une URL de téléchargement.
                        var objectUrl = $window.URL.createObjectURL(response.data);
                        var anchor = $window.document.createElement('a');
                        anchor.href = objectUrl;
                        anchor.download = filename;
                        $window.document.body.appendChild(anchor);
                        anchor.click();
                        $window.document.body.removeChild(anchor);
                        $timeout(function() { $window.URL.revokeObjectURL(objectUrl); }, 1000);
                    }, function() { row.error = true; });
                }
            }
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('wamasysApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'fr'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .component('photoViewerModal', {
            bindings: {
                modal: '='
            },
            templateUrl: 'app/components/photo-viewer-modal/photo-viewer-modal.tpl.html',
            controller: PhotoViewerModalController
        });

    PhotoViewerModalController.$inject = ['$document', '$scope'];

    function PhotoViewerModalController($document, $scope) {
        var ctrl = this;
        var mouseMoveHandler = null;
        var mouseUpHandler = null;

        ctrl.$onInit = function() {
            ensureModalState();
        };

        ctrl.close = function() {
            ensureModalState();
            ctrl.modal.visible = false;
            resetView();
            detachDocumentHandlers();
        };

        ctrl.zoomIn = function() {
            setScale((ctrl.modal.scale || 1) + 0.25);
        };

        ctrl.zoomOut = function() {
            setScale((ctrl.modal.scale || 1) - 0.25);
        };

        ctrl.reset = function() {
            resetView();
        };

        ctrl.rotate = function() {
            ensureModalState();
            ctrl.modal.rotation = ((ctrl.modal.rotation || 0) + 90) % 360;
        };

        ctrl.startDrag = function($event) {
            ensureModalState();

            if ((ctrl.modal.scale || 1) <= 1) {
                return;
            }

            $event.preventDefault();
            ctrl.modal.dragging = true;
            ctrl.modal.dragStartX = $event.pageX - (ctrl.modal.translateX || 0);
            ctrl.modal.dragStartY = $event.pageY - (ctrl.modal.translateY || 0);

            detachDocumentHandlers();
            mouseMoveHandler = function(event) {
                if (!ctrl.modal.dragging) {
                    return;
                }

                $scope.$applyAsync(function() {
                    ctrl.modal.translateX = event.pageX - ctrl.modal.dragStartX;
                    ctrl.modal.translateY = event.pageY - ctrl.modal.dragStartY;
                });
            };
            mouseUpHandler = function() {
                $scope.$applyAsync(function() {
                    ctrl.modal.dragging = false;
                });
                detachDocumentHandlers();
            };

            $document.on('mousemove', mouseMoveHandler);
            $document.on('mouseup', mouseUpHandler);
        };

        ctrl.onImageLoad = function() {
            resetView();
        };

        ctrl.getImageStyle = function() {
            ensureModalState();

            return {
                cursor: (ctrl.modal.scale || 1) > 1 ? (ctrl.modal.dragging ? 'grabbing' : 'grab') : 'default',
                transform: 'translate(' + (ctrl.modal.translateX || 0) + 'px, ' + (ctrl.modal.translateY || 0) + 'px) rotate(' + (ctrl.modal.rotation || 0) + 'deg) scale(' + (ctrl.modal.scale || 1) + ')',
                transformOrigin: 'center center',
                transition: ctrl.modal.dragging ? 'none' : 'transform 0.15s ease'
            };
        };

        $scope.$watch(function() {
            if (!ctrl.modal) {
                return '';
            }

            return [
                ctrl.modal.visible,
                ctrl.modal.url,
                ctrl.modal.title
            ].join('|');
        }, function(newValue, oldValue) {
            if (newValue !== oldValue && ctrl.modal && ctrl.modal.visible) {
                resetView();
            }
        });

        $scope.$on('$destroy', function() {
            detachDocumentHandlers();
        });

        function ensureModalState() {
            if (!ctrl.modal) {
                ctrl.modal = {};
            }

            if (!angular.isNumber(ctrl.modal.scale)) {
                ctrl.modal.scale = 1;
            }
            if (!angular.isNumber(ctrl.modal.translateX)) {
                ctrl.modal.translateX = 0;
            }
            if (!angular.isNumber(ctrl.modal.translateY)) {
                ctrl.modal.translateY = 0;
            }
            if (!ctrl.modal.title) {
                ctrl.modal.title = '';
            }
            if (!angular.isNumber(ctrl.modal.rotation)) {
                ctrl.modal.rotation = 0;
            }
        }

        function resetView() {
            ensureModalState();
            ctrl.modal.scale = 1;
            ctrl.modal.translateX = 0;
            ctrl.modal.translateY = 0;
            ctrl.modal.rotation = 0;
            ctrl.modal.dragging = false;
        }

        function setScale(nextScale) {
            ensureModalState();
            ctrl.modal.scale = Math.max(1, Math.min(6, nextScale));
            if (ctrl.modal.scale === 1) {
                ctrl.modal.translateX = 0;
                ctrl.modal.translateY = 0;
            }
        }

        function detachDocumentHandlers() {
            if (mouseMoveHandler) {
                $document.off('mousemove', mouseMoveHandler);
                mouseMoveHandler = null;
            }
            if (mouseUpHandler) {
                $document.off('mouseup', mouseUpHandler);
                mouseUpHandler = null;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .component('journeyMap', {
            bindings: {
                activePointKey: '<?',
                geometry: '<',
                points: '<',
                height: '@',
                refreshToken: '<?',
                fitBoundsToken: '<?',
                showRoute: '<?'
            },
            templateUrl: 'app/components/journey-map/journey-map.tpl.html',
            controller: JourneyMapController
        });

    JourneyMapController.$inject = ['$scope', '$timeout', 'leafletData'];

    function JourneyMapController($scope, $timeout, leafletData) {
        var ctrl = this;

        var defaultCenter = {
            lat: 0,
            lng: 0,
            zoom: 2
        };

        ctrl.mapId = 'journey_map_' + Math.floor(Math.random() * 1000000000);
        ctrl.refreshVersion = 0;
        ctrl.lastFocusedPointKey = null;
        ctrl.ignoreActivePointOnce = false;

        angular.extend($scope, {
            bounds: null,
            center: angular.copy(defaultCenter),
            defaults: {
                scrollWheelZoom: false
            },
            renderMap: true,
            layers: {
                baselayers: {
                    osm: {
                        name: 'OpenStreetMap',
                        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                        type: 'xyz'
                    },
                    satelite: {
                        name: 'Satelite',
                        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                        type: 'xyz'
                    }
                }
            },
            markers: {},
            paths: {}
        });

   /*     ctrl.$onInit = function() {
            $scope.$watch(function() {
                return ctrl.activePointKey;
            }, function(newValue, oldValue) {
                if (!newValue) {
                    return;
                }

                if (newValue === oldValue && newValue === ctrl.lastFocusedPointKey) {
                    return;
                }

                ctrl.lastFocusedPointKey = newValue;
                focusActivePointOnly();
            });
        };

		ctrl.$onChanges = function(changesObj) {
		    if (changesObj.fitBoundsToken) {
		        refreshMap(true);
		        return;
		    }

		    if (changesObj.points || changesObj.geometry || changesObj.showRoute || changesObj.refreshToken) {
		        refreshMap(false);
		    }
		};
*/
ctrl.$onInit = function() {
    console.error('JOURNEY MAP INIT', ctrl.mapId);

    $scope.$watchGroup([
        function() { return ctrl.points; },
        function() { return ctrl.geometry; },
        function() { return ctrl.refreshToken; },
        function() { return ctrl.fitBoundsToken; },
        function() { return ctrl.showRoute; }
    ], function(newValues, oldValues) {
        if (!oldValues) {
            return;
        }

        console.error('JOURNEY MAP WATCH GROUP', {
            refreshToken: newValues[2],
            fitBoundsToken: newValues[3]
        });

        var fitBoundsChanged = newValues[3] !== oldValues[3];
        refreshMap(fitBoundsChanged);
    });

    $scope.$watch(function() {
        return ctrl.activePointKey;
    }, function(newValue, oldValue) {
        if (!newValue) {
            return;
        }

        if (newValue === oldValue && newValue === ctrl.lastFocusedPointKey) {
            return;
        }

        ctrl.lastFocusedPointKey = newValue;
        focusActivePointOnly();
    });
};

        ctrl.zoomToData = function() {
            ctrl.ignoreActivePointOnce = true;
            refreshMap(true);
        };

        function refreshMap(forceFitBounds) {
            ctrl.refreshVersion += 1;
            var refreshVersion = ctrl.refreshVersion;

            var points = angular.isArray(ctrl.points) ? ctrl.points : [];
            var geometryPaths = buildGeometryPaths(ctrl.geometry);
            var validPoints = points.filter(function(point) {
                return isFiniteNumber(point.lat) && isFiniteNumber(point.lon);
            });
            var shouldShowRoute = ctrl.showRoute !== false;

            if (!validPoints.length && !geometryPaths.length) {
                applyMapState({}, {}, angular.copy(defaultCenter), null, null, false, refreshVersion);
                ctrl.ignoreActivePointOnce = false;
                return;
            }

            var markers = {};
            var pathMap = {};
            var routeLatLngs = [];
            var minLat = Number.POSITIVE_INFINITY;
            var maxLat = Number.NEGATIVE_INFINITY;
            var minLon = Number.POSITIVE_INFINITY;
            var maxLon = Number.NEGATIVE_INFINITY;
            var activePoint = null;

            angular.forEach(validPoints, function(point, index) {
                var markerKey = normalizeMarkerKey(point.key || ('point' + index));
                var isActive = !ctrl.ignoreActivePointOnce && normalizeMarkerKey(ctrl.activePointKey) === markerKey;

                markers[markerKey] = {
                    lat: point.lat,
                    lng: point.lon,
                    focus: isActive,
                    icon: buildMarkerIcon(point),
                    message: buildMessage(point),
                    draggable: false
                };

                if (isActive) {
                    activePoint = point;
                }

                routeLatLngs.push({
                    lat: point.lat,
                    lng: point.lon
                });

                updateExtrema(point.lat, point.lon);
            });

            if (shouldShowRoute && validPoints.length > 1) {
                pathMap.route = {
                    color: '#1f77b4',
                    weight: 4,
                    latlngs: routeLatLngs,
                    opacity: 0.75
                };
            }

            angular.forEach(geometryPaths, function(path, index) {
                pathMap['area' + index] = path;
                angular.forEach(path.latlngs, function(latlng) {
                    updateExtrema(latlng.lat, latlng.lng);
                });
            });

            if (activePoint) {
                applyMapState(markers, pathMap, {
                    lat: activePoint.lat,
                    lng: activePoint.lon,
                    zoom: activePoint.focusZoom || 17
                }, null, activePoint, false, refreshVersion);
                ctrl.ignoreActivePointOnce = false;
                return;
            }

            if (!geometryPaths.length && validPoints.length === 1) {
                applyMapState(markers, pathMap, {
                    lat: validPoints[0].lat,
                    lng: validPoints[0].lon,
                    zoom: validPoints[0].focusZoom || 16
                }, null, null, false, refreshVersion);
                ctrl.ignoreActivePointOnce = false;
                return;
            }

            var bounds = buildBounds(minLat, maxLat, minLon, maxLon);

            applyMapState(
                markers,
                pathMap,
                {
                    lat: minLat + ((maxLat - minLat) / 2),
                    lng: minLon + ((maxLon - minLon) / 2),
                    zoom: 5
                },
                bounds,
                null,
                !!forceFitBounds,
                refreshVersion
            );

            ctrl.ignoreActivePointOnce = false;

            function updateExtrema(lat, lon) {
                minLat = Math.min(minLat, lat);
                maxLat = Math.max(maxLat, lat);
                minLon = Math.min(minLon, lon);
                maxLon = Math.max(maxLon, lon);
            }
        }

        function focusActivePointOnly() {
            var points = angular.isArray(ctrl.points) ? ctrl.points : [];
            var targetKey = normalizeMarkerKey(ctrl.activePointKey);
            var activePoint = null;
            var refreshVersion = ctrl.refreshVersion;

            angular.forEach(points, function(point, index) {
                var markerKey = normalizeMarkerKey(point.key || ('point' + index));
                if (markerKey === targetKey) {
                    activePoint = point;
                }
            });

            if (!activePoint) {
                return;
            }

            focusMarker(activePoint, 0, refreshVersion);
        }

        function applyMapState(markers, paths, center, bounds, activePoint, forceFitBounds, refreshVersion) {
            $scope.renderMap = false;

            $timeout(function() {
                if (refreshVersion !== ctrl.refreshVersion) {
                    return;
                }

                $scope.markers = markers;
                $scope.paths = paths;
                $scope.center = center;
                $scope.bounds = bounds;
                $scope.renderMap = true;

                $timeout(function() {
                    if (refreshVersion !== ctrl.refreshVersion) {
                        return;
                    }

                    if (forceFitBounds && bounds) {
                        fitMapToBounds(bounds, 0, refreshVersion);
                        return;
                    }

                    if (activePoint) {
                        focusMarker(activePoint, 0, refreshVersion);
                    }
                }, 0);
            }, 0);
        }

        function focusMarker(activePoint, attempt, refreshVersion) {
            attempt = attempt || 0;

            if (refreshVersion !== ctrl.refreshVersion) {
                return;
            }

            leafletData.getMap(ctrl.mapId).then(function(map) {
                if (refreshVersion !== ctrl.refreshVersion) {
                    return;
                }

                if (!map) {
                    retryFocus(activePoint, attempt, refreshVersion);
                    return;
                }

                map.setView([activePoint.lat, activePoint.lon], activePoint.focusZoom || 17, {
                    animate: true
                });

                $timeout(function() {
                    if (refreshVersion !== ctrl.refreshVersion) {
                        return;
                    }
                    openPopupForPoint(map, activePoint, attempt, refreshVersion);
                }, 250);
            });
        }

        function openPopupForPoint(map, activePoint, attempt, refreshVersion) {
            if (refreshVersion !== ctrl.refreshVersion) {
                return;
            }

            var popupOpened = false;

            angular.forEach(map._layers, function(layer) {
                if (popupOpened || !layer || !layer.getLatLng || !layer.openPopup) {
                    return;
                }

                var latLng = layer.getLatLng();
                if (!latLng) {
                    return;
                }

                var sameLat = Math.abs(latLng.lat - activePoint.lat) < 0.000001;
                var sameLng = Math.abs(latLng.lng - activePoint.lon) < 0.000001;

                if (sameLat && sameLng) {
                    if (layer.getPopup && !layer.getPopup()) {
                        return;
                    }

                    layer.openPopup();
                    popupOpened = true;
                }
            });

            if (!popupOpened) {
                retryFocus(activePoint, attempt, refreshVersion);
            }
        }

        function retryFocus(activePoint, attempt, refreshVersion) {
            if (attempt >= 6) {
                return;
            }

            $timeout(function() {
                if (refreshVersion !== ctrl.refreshVersion) {
                    return;
                }
                focusMarker(activePoint, attempt + 1, refreshVersion);
            }, 180);
        }

        function fitMapToBounds(bounds, attempt, refreshVersion) {
            attempt = attempt || 0;

            if (refreshVersion !== ctrl.refreshVersion) {
                return;
            }

            leafletData.getMap(ctrl.mapId).then(function(map) {
                if (refreshVersion !== ctrl.refreshVersion) {
                    return;
                }

                if (!map) {
                    retryFitBounds(bounds, attempt, refreshVersion);
                    return;
                }

                map.fitBounds([
                    [bounds.southWest.lat, bounds.southWest.lng],
                    [bounds.northEast.lat, bounds.northEast.lng]
                ], {
                    animate: false,
                    padding: [20, 20]
                });
            });
        }

        function retryFitBounds(bounds, attempt, refreshVersion) {
            if (attempt >= 5) {
                return;
            }

            $timeout(function() {
                if (refreshVersion !== ctrl.refreshVersion) {
                    return;
                }
                fitMapToBounds(bounds, attempt + 1, refreshVersion);
            }, 120);
        }

        function buildBounds(minLat, maxLat, minLon, maxLon) {
            var latSpan = maxLat - minLat;
            var lonSpan = maxLon - minLon;

            var latPadding = Math.max(latSpan * 0.12, 0.0015);
            var lonPadding = Math.max(lonSpan * 0.12, 0.0015);

            return {
                northEast: {
                    lat: maxLat + latPadding,
                    lng: maxLon + lonPadding
                },
                southWest: {
                    lat: minLat - latPadding,
                    lng: minLon - lonPadding
                }
            };
        }

        function buildGeometryPaths(geometry) {
            var polygons = extractPolygons(geometry);
            var paths = [];

            angular.forEach(polygons, function(polygon) {
                angular.forEach(polygon, function(ring, ringIndex) {
                    var latlngs = [];

                    angular.forEach(ring, function(coord) {
                        if (!angular.isArray(coord) || coord.length < 2) {
                            return;
                        }

                        var lon = parseCoordinate(coord[0]);
                        var lat = parseCoordinate(coord[1]);

                        if (lat === null || lon === null) {
                            return;
                        }

                        latlngs.push({
                            lat: lat,
                            lng: lon
                        });
                    });

                    if (latlngs.length >= 3) {
                        paths.push({
                            type: 'polygon',
                            color: ringIndex === 0 ? '#2c7a3f' : '#4a5568',
                            weight: ringIndex === 0 ? 3 : 2,
                            fillColor: ringIndex === 0 ? '#8fd19e' : '#cbd5e0',
                            fillOpacity: ringIndex === 0 ? 0.18 : 0.05,
                            latlngs: latlngs,
                            dashArray: ringIndex === 0 ? null : '6 6'
                        });
                    }
                });
            });

            return paths;
        }

        function extractPolygons(geometry) {
            var payload = geometry;

            if (!payload) {
                return [];
            }

            if (angular.isString(payload)) {
                try {
                    payload = angular.fromJson(payload);
                } catch (e) {
                    return [];
                }
            }

            if (payload.geometry) {
                payload = payload.geometry;
            }

            if (!payload || !payload.type || !angular.isArray(payload.coordinates)) {
                return [];
            }

            if (payload.type === 'MultiPolygon') {
                return payload.coordinates;
            }

            if (payload.type === 'Polygon') {
                return [payload.coordinates];
            }

            return [];
        }

        function parseCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = parseFloat(String(value).replace(',', '.'));
            return isNaN(parsedValue) ? null : parsedValue;
        }

        function buildMessage(point) {
            var parts = [];

            if (point.sequence) {
                parts.push('<strong>#' + escapeHtml(String(point.sequence)) + '</strong>');
            }
            if (point.dateLabel) {
                parts.push(escapeHtml(point.dateLabel));
            }
            if (point.title) {
                parts.push(escapeHtml(point.title));
            }
            if (point.subtitle) {
                parts.push(escapeHtml(point.subtitle));
            }
            if (point.valueLabel) {
                parts.push(escapeHtml(point.valueLabel));
            }

            return parts.join('<br/>');
        }

        function buildMarkerIcon(point) {
            if (!point || !point.markerHtml) {
                return undefined;
            }

            return {
                type: 'div',
                className: point.markerClassName || 'journey-map-div-icon',
                html: point.markerHtml,
                iconSize: point.iconSize || [36, 36],
                iconAnchor: point.iconAnchor || [18, 18],
                popupAnchor: point.popupAnchor || [0, -18]
            };
        }

        function normalizeMarkerKey(value) {
            if (value === null || value === undefined || value === '') {
                return 'point';
            }

            return String(value).replace(/[^A-Za-z0-9_]/g, '_');
        }

        function escapeHtml(value) {
            return String(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }

        function isFiniteNumber(value) {
            return angular.isNumber(value) && !isNaN(value) && isFinite(value);
        }
    }
})();;
(function() {
    'use strict';

//    var srcIFrame= "https://c4d9c071efbd4c70bcb88dc3b740506e.eu-west-1.aws.found.io:9243/app/kibana#/dashboard/";

    
    var myIframe = {
              bindings: {
              	  height: '@',
              	  width: '@',
              	  scrolling: '@',
              	  iddashboard:'@',
              	  endurl:'@',
              	  idgotodashboard:'@',
              	  idcontrat:'@',
              	  filtreagence:'@',
              	  periodkibana :'@'
                },
    	      template: '<iframe id="iframeelk" class="frame" height="{{$ctrl.height}}" width="{{$ctrl.width}}" '
    	    	  +'frameborder="0" border="0" marginwidth="0" marginheight="0" scrolling="{{$ctrl.scrolling}}" ng-src="{{embedUrl}}"></iframe>',

              controller: myIframeController
    };
    
    myIframeController.$inject  = ['$scope', '$sce','Principal','$timeout']; 


    function myIframeController($scope, $sce,Principal,$timeout){
    	var ctrl = this;
    	
    	
    	if(Principal.isIdentityResolved()){
    		
	    	var account= Principal.getIdentityIfExist();
	    	var srcIFrame= account.kibanaUrl;
	    	
	    	if(ctrl.endurl){
	    		srcIFrame= srcIFrame+ctrl.endurl;
	    	}else{
	    	  	if(ctrl.iddashboard){
		    		srcIFrame= srcIFrame+"/app/kibana#/dashboard/"+ctrl.iddashboard ;
		    	//	srcIFrame= srcIFrame+"/app/dashboard#/view/"+ctrl.iddashboard ;
	    	  		
	    	  		//pour test
//		    		srcIFrame= srcIFrame+"/login?next=%2Fapp%2Fkibana";
//	            	$scope["embedUrl"] = $sce.trustAsResourceUrl(srcIFrame);
//			    	return;
		    	}else if(ctrl.idgotodashboard){
		    		//FIXME Attention les short URL (goto) ne marchent pas bien avec le embed donc on ne l'utilise pas pour l'instant
		    		srcIFrame= srcIFrame+"/goto/"+ctrl.idgotodashboard ;
		    	}
	    	}

        

     	    if(ctrl.periodkibana && ctrl.periodkibana == 'true'){
     	    	srcIFrame = srcIFrame+"?embed=true&show-time-filter=true";
     	    }else{
     	    	//now-1y%2Fy
      	    	var dateFrom='now-12M%2FM';//2018-03-26 09:34:12.715
      	    	var dateTo ='now-1d';//now-1w%2Fy
      	    	srcIFrame = srcIFrame
      	    	  +"?embed=true&show-time-filter=true"
      	    	  +"&_g=(refreshInterval:(display:Off,pause:!f,value:0),time:(from:"+
      	    	  dateFrom+",interval:'1M',mode:quick,timezone:Europe%2FBerlin,to:"+
      	   	      dateTo +"))" ;
     	    }
         	 
         	  
           	//Filtre sur contrat
     	    if(ctrl.idcontrat){
     		  srcIFrame = srcIFrame+ "&_a=(description:'',filters:!(('$state':(store:appState)," +
  			"meta:(alias:!n,disabled:!f,index:'2e040d90-4312-11e8-81c3-b55237bddc5a'," +
      		"key:contractNumber,negate:!f,"  +
      		"params:(query:'"+ctrl.idcontrat+"'),type:phrase)," +
      		"query:(match_phrase:(contractNumber:'"+ctrl.idcontrat+"'))))" +
      		",query:(language:lucene,query:''))";
     		  
 
     	    }
    

     	    
     	    
     	    
     	    
         	// filtre sur une agence.
           	if(ctrl.filtreagence && ctrl.filtreagence=='true'){

      	 		//On fait un timeout sinon ça pose un problème avec laffichage du menu latéral
//      	 		$timeout(function(){
      	 			
            	if(account.agence){
            		ctrl.currentCodeAgence = account.agence.codeAgence;
            		ctrl.currentAreaName = account.agence.nom;
            		if(account.agence.waterNetwork){
            			ctrl.currentListWaterNetwork = account.agence.waterNetwork.map(function(item) {
            				  return "'" + item.label+ "'";
            			}).join(",");
            		}

            	}
           		ctrl.titreRequete = "Area : "+ctrl.currentAreaName +" %26 Water network : "+ctrl.currentListWaterNetwork.replaceAll("'","");
           		
            	/** Ancienne requête ne prend pas en compte les réseaux d'eau */ 
//            	srcIFrame = srcIFrame+ "&_a=(description:'',filters:!(('$state':(store:appState)," +
//            			"meta:(alias:!n,disabled:!f,index:'2e040d90-4312-11e8-81c3-b55237bddc5a'," +//
//			      		"key:areaName,negate:!f,"  +
//			      		"params:(query:'"+ctrl.currentAreaName+"'),type:phrase)," +
//			      		"query:(match_phrase:(areaName:'"+ctrl.currentAreaName+"'))))" +
//			      		",query:(language:lucene,query:''))";

            	/** ancien format n'affiche pas la zone filtre */ 
            	//srcIFrame = srcIFrame+ "&_a=(query:(bool:(should:!((term:(areaName:'"+ctrl.currentAreaName+"')),(bool:(should:!((terms:(waterNetworkLabel.keyword:!("+ctrl.currentListWaterNetwork +"))))))))))";
		
            	
            	srcIFrame = srcIFrame+ "&_a=(description:'',filters:!(('$state':(store:appState)," +
            			"meta:(alias:'"+ctrl.titreRequete+"',disabled:!f,index:'2e040d90-4312-11e8-81c3-b55237bddc5a'," +
            			"key:query,negate:!f,type:custom),query:(bool:(should:!((term:(areaName:'"+ctrl.currentAreaName+"'))," +
            			"(bool:(should:!((terms:(waterNetworkLabel.keyword:!("+ctrl.currentListWaterNetwork +")))))))))))," +
            			"query:(language:lucene,query:''),tags:!(),timeRange:(from:now-12M,to:now))"

            	
            	$scope["embedUrl"] = $sce.trustAsResourceUrl(srcIFrame);
      
           	}else{
           		$scope["embedUrl"] = $sce.trustAsResourceUrl(srcIFrame);
           	}

    	}
        
       
         
      }
  
    angular
        .module('wamasysApp')
        .component('myIframe', myIframe);

    
})();;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(paginationConfig);

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('wamasysApp')
        .config(pagerConfig);

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        scope.$watch(function() {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();
;
(function() {
    'use strict';
    angular.module('wamasysApp').factory('EventConfigurationAssistant', EventConfigurationAssistant);
    EventConfigurationAssistant.$inject = ['$http', 'Principal', 'AssistantPanelService', 'CommunicationAutomationConf', '$rootScope'];

    function EventConfigurationAssistant($http, Principal, AssistantPanelService, CommunicationAutomationConf, $rootScope) {
        return {open: open, canUse: canUse};

        function canUse(mode) {
            return Principal.identity().then(function(account) {
                var roles = (account && account.authorities) || [];
                var admin = roles.indexOf('ROLE_ADMIN') !== -1 || roles.indexOf('ROLE_SUPER_ADMIN') !== -1;
                return !!account && (account.modules || []).indexOf('AI_ASSISTANT') !== -1
                    && (admin || roles.indexOf('ROLE_AI_ASSISTANT') !== -1)
                    && (admin || mode === 'DASHBOARD' && (roles.indexOf('ROLE_EVT_EDIT') !== -1 || roles.indexOf('ROLE_EVT_READ_ONLY') !== -1));
            });
        }

        function open(mode, onCreated) {
            var latestMessage;
            var creating = false;
            var baseUrl = 'api/event-configuration-assistant/' + mode;
            var context = {
                contextType: 'EVENT_CONFIGURATION', entityId: mode,
                title: mode === 'DASHBOARD' ? 'Assistant — tableaux de bord' : 'Assistant — dictionnaire des événements',
                subtitle: 'Décrivez votre besoin, puis validez la proposition.',
                promptPlaceholder: mode === 'DASHBOARD' ? 'Quels événements et indicateurs souhaitez-vous suivre ?' : 'Quelles informations souhaitez-vous recueillir, et pour quel événement ?',
                supportsActionProposal: false, supportsDataScopes: false,
                defaultSelectedDataScopes: [], defaultSelectedInstructionDomains: [],
                defaultCreativityLevel: 'PRECISE',
                adapter: {
                    getErrorMessage: function(error) {
                        return (error.data && error.data.message) || (error.headers && error.headers('X-wamasysApp-detail'))
                            || 'L’assistant n’a pas pu préparer la proposition. Réessayez dans quelques instants.';
                    },
                    getUsage: function(success, error) { CommunicationAutomationConf.getAssistantUsage(success, error); },
                    chat: function(payload, success, error) {
                        if (creating) {
                            error({data: {message: 'Attendez la fin de la création avant de poursuivre la discussion.'}});
                            return;
                        }
                        // Keep the JSON in conversational history so a follow-up can refine the exact proposal.
                        if (latestMessage && latestMessage.configurationJson) {
                            for (var index = payload.messages.length - 1; index >= 0; index--) {
                                if (payload.messages[index].role === 'assistant') {
                                    payload.messages[index].content += '\nProposition JSON :\n' + latestMessage.configurationJson
                                        + (latestMessage.configurationCreated ? '\nCette proposition a déjà été créée.' : '');
                                    break;
                                }
                            }
                        }
                        // A later request supersedes previous proposals, preventing accidental stale writes.
                        if (latestMessage) { latestMessage.configurationSuperseded = true; }
                        $http.post(baseUrl + '/chat', payload).then(function(response) { success(response.data); }, error);
                    },
                    applyAssistantResponse: function(result, message) {
                        latestMessage = message;
                        var raw = (result.suggestedFieldValues || {}).template;
                        if (!raw || result.awaitingUserInput) { return; }
                        try {
                            message.configurationProposal = angular.fromJson(raw);
                            message.configurationJson = angular.toJson(message.configurationProposal, true);
                            message.configurationButton = mode === 'DASHBOARD' ? 'Créer ce tableau de bord' : 'Créer les champs et appliquer les ajouts';
                            message.confirmConfiguration = function() { create(message); };
                        } catch (error) {
                            message.configurationError = 'La proposition JSON est invalide. Demandez à l’assistant de la corriger.';
                        }
                    }
                }
            };
            canUse(mode).then(function(allowed) {
                if (!allowed) { return; }
                AssistantPanelService.open(context);
                // Reopening the same discussion keeps its proposals and attaches the current list refresh callback.
                angular.forEach(AssistantPanelService.state.messages, function(message) {
                    if (message.role === 'assistant') { latestMessage = message; }
                    if (message.configurationProposal) { message.confirmConfiguration = function() { create(message); }; }
                });
            });

            function create(message) {
                if (creating || message.configurationCreated || message.configurationSuperseded || AssistantPanelService.state.isSending) { return; }
                creating = true;
                message.configurationCreating = true;
                message.configurationError = null;
                // Only this user gesture writes. Receiving an assistant response never calls this endpoint.
                $http.post(baseUrl + '/create', message.configurationProposal).then(function() {
                    message.configurationCreated = true;
                    if (mode === 'DASHBOARD') { $rootScope.$broadcast('wamasysApp:eventDashboardUpdate'); }
                    AssistantPanelService.invalidateConversationContext();
                    if (onCreated) { onCreated(); }
                }, function(error) {
                    message.configurationError = (error.data && error.data.message) || (error.headers && error.headers('X-wamasysApp-detail'))
                        || 'La création a échoué. Vérifiez la configuration avant de réessayer.';
                }).finally(function() {
                    creating = false;
                    message.configurationCreating = false;
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('AssistantPanelService', AssistantPanelService);

    function AssistantPanelService() {
        var state = {
            isOpen: false,
            isMinimized: false,
            context: null,
            messages: [],
            prompt: '',
            allowAssistantToChooseData: true,
            selectedDataScopes: ['billingMonthlyStats', 'waterMonthlyStats'],
            availableDataScopes: [
                {key: 'billingMonthlyStats', labelKey: 'global.assistant.billingMonthlyStats'},
                {key: 'billingDetails', labelKey: 'global.assistant.billingDetails'},
                {key: 'waterMonthlyStats', labelKey: 'global.assistant.waterMonthlyStats'},
                {key: 'waterDetails', labelKey: 'global.assistant.waterDetails'},
                {key: 'contractHistory', labelKey: 'global.assistant.contractHistory'},
                {key: 'meterChanges', labelKey: 'global.assistant.meterChanges'}
            ],
            selectedInstructionDomains: ['FINANCIAL', 'PAYMENT', 'WATER_CONSUMPTION', 'CONTRACT_STATUS'],
            availableInstructionDomains: [
                {
                    key: 'FINANCIAL',
                    labelKey: 'global.assistant.instructionDomainFinancial',
                    descriptionKey: 'global.assistant.instructionDomainFinancialDescription'
                },
                {
                    key: 'PAYMENT',
                    labelKey: 'global.assistant.instructionDomainPayment',
                    descriptionKey: 'global.assistant.instructionDomainPaymentDescription'
                },
                {
                    key: 'WATER_CONSUMPTION',
                    labelKey: 'global.assistant.instructionDomainWater',
                    descriptionKey: 'global.assistant.instructionDomainWaterDescription'
                },
                {
                    key: 'CONTRACT_STATUS',
                    labelKey: 'global.assistant.instructionDomainContract',
                    descriptionKey: 'global.assistant.instructionDomainContractDescription'
                }
            ],
            responseDetailLevel: 'SHORT',
            selectedModel: 'AUTO',
            creativityLevel: 'EQUILIBREE',
            selectedAssistantFlowMode: 'LEGACY',
            latestUsage: null,
            usageExpanded: false,
            errorMessage: null,
            isSending: false,
            didExecuteActions: false,
            userQuestionCount: 0,
            feedbackPromptVisible: false,
            feedbackPromptTrigger: null,
            feedbackReasonPromptVisible: false,
            feedbackComment: '',
            closeAfterFeedback: false,
            feedbackSubmitted: false,
            conversationId: null,
            previousResponseId: null,
            lastContextSignature: null,
            selectedMaxOutputTokens: null,
            debugCopySuccess: false,
            processingStatus: null,
            delayedProcessingMessage: null
        };

        return {
            state: state,
            open: open,
            close: close,
            toggleMinimized: toggleMinimized,
            resetConversation: resetConversation,
            updateContextEntity: updateContextEntity,
            invalidateConversationContext: invalidateConversationContext
        };

        function open(context) {
            if (!context || !context.contextType || angular.isUndefined(context.entityId) || context.entityId === null) {
                return;
            }
            var isSameContext = state.context
                && state.context.contextType === context.contextType
                && state.context.entityId === context.entityId;

            state.isOpen = true;
            state.isMinimized = false;
            state.context = angular.extend({}, context);
            applyContextDefaults();

            if (!isSameContext) {
                resetConversation();
                state.latestUsage = null;
            } else if (!state.conversationId) {
                state.conversationId = generateConversationId();
            }
        }

        function close() {
            resetConversation();
            state.latestUsage = null;
            state.isOpen = false;
            state.isMinimized = false;
        }

        function toggleMinimized() {
            state.isMinimized = !state.isMinimized;
        }

        function resetConversation() {
            state.messages = [];
            state.prompt = '';
            state.errorMessage = null;
            state.isSending = false;
            state.didExecuteActions = false;
            state.userQuestionCount = 0;
            state.usageExpanded = !!(state.context && state.context.defaultUsageExpanded);
            state.feedbackPromptVisible = false;
            state.feedbackPromptTrigger = null;
            state.feedbackReasonPromptVisible = false;
            state.feedbackComment = '';
            state.closeAfterFeedback = false;
            state.feedbackSubmitted = false;
            state.conversationId = generateConversationId();
            state.previousResponseId = null;
            state.lastContextSignature = null;
            state.selectedMaxOutputTokens = null;
            applyContextDefaults();
            state.debugCopySuccess = false;
            state.processingStatus = null;
            state.delayedProcessingMessage = null;
        }

        function applyContextDefaults() {
            state.allowAssistantToChooseData = resolveContextBoolean('defaultAllowAssistantToChooseData', true);
            state.selectedDataScopes = resolveContextArray('defaultSelectedDataScopes', ['billingMonthlyStats', 'waterMonthlyStats']);
            state.selectedInstructionDomains = resolveContextArray('defaultSelectedInstructionDomains',
                ['FINANCIAL', 'PAYMENT', 'WATER_CONSUMPTION', 'CONTRACT_STATUS']);
            state.responseDetailLevel = resolveContextString('defaultResponseDetailLevel', 'SHORT');
            state.selectedModel = resolveContextString('defaultSelectedModel', 'AUTO');
            state.creativityLevel = resolveContextString('defaultCreativityLevel', 'EQUILIBREE');
            state.selectedAssistantFlowMode = resolveContextString('defaultAssistantFlowMode', 'LEGACY');
        }

        function resolveContextBoolean(key, fallbackValue) {
            if (!state.context || angular.isUndefined(state.context[key])) {
                return fallbackValue;
            }
            return !!state.context[key];
        }

        function resolveContextArray(key, fallbackValue) {
            if (!state.context || !angular.isArray(state.context[key])) {
                return angular.copy(fallbackValue);
            }
            return angular.copy(state.context[key]);
        }

        function resolveContextString(key, fallbackValue) {
            if (!state.context || !state.context[key]) {
                return fallbackValue;
            }
            return state.context[key];
        }

        function invalidateConversationContext() {
            state.previousResponseId = null;
            state.lastContextSignature = null;
        }

        function generateConversationId() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(character) {
                var randomValue = Math.random() * 16 | 0;
                var value = character === 'x' ? randomValue : ((randomValue & 0x3) | 0x8);
                return value.toString(16);
            });
        }

        function updateContextEntity(entity) {
            if (!state.context || !entity || state.context.entityId !== entity.id) {
                return;
            }
            state.context.entity = entity;
            state.context.subtitle = entity.referenceContrat ? ('#' + entity.referenceContrat) : state.context.subtitle;
            invalidateConversationContext();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('AssistantPanelController', AssistantPanelController);

    AssistantPanelController.$inject = ['$scope', '$window', '$timeout', '$translate', 'AssistantPanelService'];

    function AssistantPanelController($scope, $window, $timeout, $translate, AssistantPanelService) {
        var vm = this;
        var LONG_WAIT_DELAY_MS = 10000;
        var LONG_WAIT_ROTATION_DELAY_MS = 8000;
        var processingTimeouts = [];
        var longWaitTimer = null;
        var processingStepDefinitionsWithPlanner = [
            {delay: 0, key: 'global.assistant.processingAnalyzing'},
            {delay: 2200, key: 'global.assistant.processingPlanning'},
            {delay: 4500, key: 'global.assistant.processingCollectingData'},
            {delay: 7000, key: 'global.assistant.processingSendingContext'}
        ];
        var processingStepDefinitionsWithoutPlanner = [
            {delay: 0, key: 'global.assistant.processingAnalyzing'},
            {delay: 2200, key: 'global.assistant.processingPreparingContext'},
            {delay: 4500, key: 'global.assistant.processingCollectingData'},
            {delay: 7000, key: 'global.assistant.processingSendingContext'}
        ];
        var longWaitMessageKeys = [
            'global.assistant.longWait1',
            'global.assistant.longWait2',
            'global.assistant.longWait3',
            'global.assistant.longWait4',
            'global.assistant.longWait5',
            'global.assistant.longWait6',
            'global.assistant.longWait7',
            'global.assistant.longWait8',
            'global.assistant.longWait9',
            'global.assistant.longWait10'
        ];

        vm.state = AssistantPanelService.state;
        vm.askQuestion = askQuestion;
        vm.executeActions = executeActions;
        vm.close = close;
        vm.toggleMinimized = AssistantPanelService.toggleMinimized;
        vm.finishConversation = finishConversation;
        vm.dismissFeedbackPrompt = dismissFeedbackPrompt;
        vm.submitFeedback = submitFeedback;
        vm.beginUnsatisfiedFeedback = beginUnsatisfiedFeedback;
        vm.submitUnsatisfiedFeedback = submitUnsatisfiedFeedback;
        vm.toggleUsageDetails = toggleUsageDetails;
        vm.getUserUsagePercent = getUserUsagePercent;
        vm.getOrganisationUsagePercent = getOrganisationUsagePercent;
        vm.getUserUsageStatusClass = getUserUsageStatusClass;
        vm.getOrganisationUsageStatusClass = getOrganisationUsageStatusClass;
        vm.getUserUsageStatusLabel = getUserUsageStatusLabel;
        vm.getOrganisationUsageStatusLabel = getOrganisationUsageStatusLabel;
        vm.getUsagePeriodLabel = getUsagePeriodLabel;
        vm.getMaxOutputTokenOptions = getMaxOutputTokenOptions;
        vm.formatTokenUsage = formatTokenUsage;
        vm.formatTokenLimit = formatTokenLimit;
        vm.copyConversationDebugJson = copyConversationDebugJson;
        vm.supportsActionProposal = supportsActionProposal;
        vm.canConfigureDataScopes = canConfigureDataScopes;
        vm.supportsAssistantFlowModes = supportsAssistantFlowModes;
        vm.showExecutedActionsBlock = showExecutedActionsBlock;
        vm.showAdjustmentFollowUp = showAdjustmentFollowUp;
        vm.areProposedActionsReady = areProposedActionsReady;
        vm.handlePromptKeydown = handlePromptKeydown;
        vm.isScopeSelected = isScopeSelected;
        vm.toggleScope = toggleScope;
        vm.isInstructionDomainSelected = isInstructionDomainSelected;
        vm.toggleInstructionDomain = toggleInstructionDomain;
        vm.buildSentContextInfo = buildSentContextInfo;
        vm.openDocumentResult = openDocumentResult;

        $scope.$watch(function() {
            if (!vm.state.isOpen || !vm.state.context) {
                return null;
            }
            return vm.state.context.contextType + ':' + vm.state.context.entityId + ':' + (vm.state.context.llmModeEnabled ? '1' : '0');
        }, function(newValue) {
            if (newValue) {
                loadUsage();
            }
        });

        $scope.$watch(function() {
            return !!(vm.state.isOpen && !vm.state.isMinimized);
        }, function(isVisible) {
            if (isVisible) {
                schedulePromptFocus();
            }
        });

        function askQuestion() {
            send('QUESTION');
        }

        function handlePromptKeydown($event) {
            if (!$event || vm.state.isSending) {
                return;
            }
            if ($event.ctrlKey && ($event.key === 'Enter' || $event.keyCode === 13 || $event.which === 13)) {
                $event.preventDefault();
                askQuestion();
            }
        }

        function send(mode, actionContextType, allowEmptyPrompt) {
            var prompt = (vm.state.prompt || '').trim();
            var adapter = getAdapter();
            if (!adapter || vm.state.isSending) {
                return;
            }
            if (!allowEmptyPrompt && !prompt) {
                return;
            }
            if (allowEmptyPrompt && !prompt && !vm.state.messages.length) {
                return;
            }

            vm.state.errorMessage = null;
            if (prompt) {
                vm.state.messages.push({
                    role: 'user',
                    content: prompt,
                    exchangedAt: new Date().toISOString()
                });
                vm.state.userQuestionCount = vm.state.userQuestionCount + 1;
                vm.state.prompt = '';
            }
            vm.state.isSending = true;
            startProcessingFeedback();

            var payload = buildChatPayload(mode, actionContextType);
            var contextSignature = payload.contextSignature;
            delete payload.contextSignature;

            adapter.chat(payload, function(result) {
                applyAssistantResult(adapter, result, contextSignature);
            }, function(error) {
                stopProcessingFeedback();
                vm.state.isSending = false;
                vm.state.errorMessage = adapter.getErrorMessage ? adapter.getErrorMessage(error) : getTechnicalSupportErrorMessage();
            });
        }

        function executeActions(message) {
            var adapter = getAdapter();
            if (!adapter || !adapter.executeActions || !message || !message.proposedActions || !message.proposedActions.length || message.isExecutingActions) {
                return;
            }

            vm.state.errorMessage = null;
            message.isExecutingActions = true;

            adapter.executeActions({actions: message.proposedActions, conversationId: vm.state.conversationId}, function(result) {
                message.isExecutingActions = false;
                message.actionsExecuted = true;
                message.executedActionSummaries = result.executedActionSummaries || [];
                vm.state.conversationId = result.conversationId || vm.state.conversationId;
                vm.state.didExecuteActions = true;
                AssistantPanelService.invalidateConversationContext();
                if (adapter.refreshContextEntity) {
                    adapter.refreshContextEntity();
                }
            }, function(error) {
                message.isExecutingActions = false;
                vm.state.errorMessage = (error.headers && error.headers('X-wamasysApp-detail')) || 'Execution impossible';
            });
        }

        function finishConversation() {
            close('MANUAL_FINISH');
        }

        function close(trigger) {
            if (shouldPromptForFeedback()) {
                showFeedbackPrompt(trigger || 'WINDOW_CLOSE');
                vm.state.closeAfterFeedback = true;
                return;
            }
            stopProcessingFeedback();
            AssistantPanelService.close();
        }

        function showFeedbackPrompt(trigger) {
            vm.state.isMinimized = false;
            vm.state.feedbackPromptVisible = true;
            vm.state.feedbackPromptTrigger = trigger;
            vm.state.feedbackReasonPromptVisible = false;
        }

        function dismissFeedbackPrompt() {
            vm.state.feedbackPromptVisible = false;
            vm.state.feedbackPromptTrigger = null;
            vm.state.feedbackReasonPromptVisible = false;
            vm.state.feedbackComment = '';
            if (vm.state.closeAfterFeedback) {
                AssistantPanelService.close();
                return;
            }
            vm.state.closeAfterFeedback = false;
        }

        function submitFeedback(satisfied) {
            var adapter = getAdapter();
            var payload;
            if (!adapter || !adapter.submitFeedback || vm.state.feedbackSubmitted) {
                return;
            }
            payload = {
                satisfied: !!satisfied,
                questionCount: vm.state.userQuestionCount,
                trigger: vm.state.feedbackPromptTrigger || 'MANUAL_FINISH',
                responseId: vm.state.previousResponseId,
                conversationId: vm.state.conversationId,
                feedbackComment: satisfied ? null : ((vm.state.feedbackComment || '').trim() || null)
            };
            adapter.submitFeedback(payload, function() {
                vm.state.feedbackSubmitted = true;
                vm.state.closeAfterFeedback = false;
                vm.state.feedbackReasonPromptVisible = false;
                vm.state.feedbackComment = '';
                dismissFeedbackPrompt();
                AssistantPanelService.close();
            }, function(error) {
                vm.state.errorMessage = (error.headers && error.headers('X-wamasysApp-detail')) || 'Impossible d\'enregistrer votre retour';
            });
        }

        function beginUnsatisfiedFeedback() {
            vm.state.feedbackReasonPromptVisible = true;
            vm.state.isMinimized = false;
        }

        function submitUnsatisfiedFeedback() {
            submitFeedback(false);
        }

        function loadUsage() {
            var adapter = getAdapter();
            if (!adapter || !adapter.getUsage) {
                vm.state.latestUsage = null;
                vm.state.usageExpanded = false;
                return;
            }
            adapter.getUsage(function(result) {
                vm.state.latestUsage = result;
                initializeSelectedMaxOutputTokens(result);
                if (vm.state.context && vm.state.context.defaultUsageExpanded) {
                    vm.state.usageExpanded = true;
                }
            });
        }

        function toggleUsageDetails() {
            vm.state.usageExpanded = !vm.state.usageExpanded;
        }

        function buildChatPayload(mode, actionContextType) {
            var contextSignature = buildContextSignature();
            var payload = {
                contextType: vm.state.context.contextType,
                mode: mode,
                allowAssistantToChooseData: vm.state.allowAssistantToChooseData,
                selectedDataScopes: buildSelectedDataScopes(),
                selectedInstructionDomains: buildSelectedInstructionDomains(),
                responseDetailLevel: vm.state.responseDetailLevel,
                model: vm.state.selectedModel,
                creativityLevel: vm.state.creativityLevel,
                maxOutputTokens: vm.state.selectedMaxOutputTokens,
                assistantFlowMode: vm.state.selectedAssistantFlowMode,
                clientConversationId: vm.state.conversationId,
                previousResponseId: vm.state.lastContextSignature === contextSignature ? vm.state.previousResponseId : null,
                contextSignature: contextSignature,
                messages: vm.state.messages.map(function(message) {
                    return {
                        role: message.role,
                        content: message.content
                    };
                })
            };
            var adapter = getAdapter();
            if (adapter && adapter.extendChatPayload) {
                payload = adapter.extendChatPayload(payload) || payload;
            }
            payload.contextSignature = contextSignature;
            return payload;
        }

        function buildContextSignature() {
            var adapter = getAdapter();
            var adapterFragment = adapter && adapter.buildContextSignatureFragment ? adapter.buildContextSignatureFragment() : '';
            return [
                vm.state.context && vm.state.context.contextType,
                vm.state.context && vm.state.context.entityId,
                vm.state.allowAssistantToChooseData,
                buildSelectedDataScopes().join(','),
                buildSelectedInstructionDomains().join(','),
                vm.state.responseDetailLevel,
                vm.state.selectedModel,
                vm.state.creativityLevel,
                vm.state.selectedAssistantFlowMode,
                adapterFragment
            ].join('|');
        }

        function getAdapter() {
            return vm.state.context && vm.state.context.adapter ? vm.state.context.adapter : null;
        }

        function supportsActionProposal() {
            return !!(vm.state.context && vm.state.context.supportsActionProposal);
        }

        function canConfigureDataScopes() {
            return !!(vm.state.context && vm.state.context.supportsDataScopes);
        }

        function supportsAssistantFlowModes() {
            return !!(vm.state.context && vm.state.context.supportsAssistantFlowModes);
        }

        function buildSelectedDataScopes() {
            return angular.copy(vm.state.selectedDataScopes || []);
        }

        function buildSelectedInstructionDomains() {
            return angular.copy(vm.state.selectedInstructionDomains || []);
        }

        function isScopeSelected(scopeKey) {
            return (vm.state.selectedDataScopes || []).indexOf(scopeKey) !== -1;
        }

        function toggleScope(scopeKey) {
            toggleSelection(vm.state.selectedDataScopes, scopeKey);
        }

        function isInstructionDomainSelected(domainKey) {
            return (vm.state.selectedInstructionDomains || []).indexOf(domainKey) !== -1;
        }

        function toggleInstructionDomain(domainKey) {
            toggleSelection(vm.state.selectedInstructionDomains, domainKey);
        }

        function toggleSelection(collection, value) {
            var index;
            if (!collection || !value) {
                return;
            }
            index = collection.indexOf(value);
            if (index === -1) {
                collection.push(value);
                return;
            }
            collection.splice(index, 1);
        }

        function applyAssistantResult(adapter, result, contextSignature) {
            var message = {
                role: 'assistant',
                content: result.assistantMessage,
                exchangedAt: new Date().toISOString(),
                shouldSuggestAction: !!result.shouldSuggestAction,
                actionContextType: result.actionContextType,
                awaitingUserInput: !!result.awaitingUserInput,
                clarificationQuestions: result.clarificationQuestions || [],
                proposedActions: result.proposedActions || [],
                proposedActionSummaries: result.proposedActionSummaries || [],
                canExecuteActions: !!result.canExecuteActions,
                isExecutingActions: false,
                actionsExecuted: false,
                executedActionSummaries: [],
                suggestedFieldValues: result.suggestedFieldValues || {},
                selectedDataScopes: result.selectedDataScopes || [],
                selectedInstructionDomains: result.selectedInstructionDomains || [],
                plannerUsed: !!result.plannerUsed,
                sentContextSummary: result.sentContextSummary || null,
                debugExchange: result.debugExchange || null,
                assistantFlowMode: result.assistantFlowMode || vm.state.selectedAssistantFlowMode,
                documentResults: result.documentResults || []
            };

            if (result.usage) {
                vm.state.latestUsage = result.usage;
                initializeSelectedMaxOutputTokens(result.usage);
            }
            vm.state.previousResponseId = result.responseId || null;
            vm.state.conversationId = result.conversationId || vm.state.conversationId;
            vm.state.lastContextSignature = contextSignature;
            vm.state.errorMessage = null;
            vm.state.messages.push(message);
            stopProcessingFeedback();
            vm.state.isSending = false;

            if (adapter.applyAssistantResponse) {
                adapter.applyAssistantResponse(result, message);
            }
        }

        function getDefaultErrorMessage(error, fallbackMessage) {
            return (error && error.headers && error.headers('X-wamasysApp-detail')) || fallbackMessage;
        }

        function getTechnicalSupportErrorMessage() {
            return $translate.instant('global.assistant.technicalErrorSupport');
        }

        function schedulePromptFocus() {
            $timeout(function() {
                var promptElement = $window.document.querySelector('.assistant-panel__prompt-input');
                if (promptElement && angular.isFunction(promptElement.focus)) {
                    promptElement.focus();
                }
            }, 0, false);
        }

        function startProcessingFeedback() {
            stopProcessingFeedback();
            scheduleProcessingStepMessages();
            longWaitTimer = $timeout(function() {
                rotateLongWaitMessage(0);
            }, LONG_WAIT_DELAY_MS);
        }

        function stopProcessingFeedback() {
            while (processingTimeouts.length) {
                $timeout.cancel(processingTimeouts.pop());
            }
            if (longWaitTimer) {
                $timeout.cancel(longWaitTimer);
                longWaitTimer = null;
            }
            vm.state.processingStatus = null;
            vm.state.delayedProcessingMessage = null;
        }

        $scope.$on('$destroy', function() {
            stopProcessingFeedback();
        });

        function scheduleProcessingStepMessages() {
            var definitions = vm.state.allowAssistantToChooseData ? processingStepDefinitionsWithPlanner : processingStepDefinitionsWithoutPlanner;
            definitions.forEach(function(stepDefinition) {
                processingTimeouts.push($timeout(function() {
                    if (!vm.state.isSending) {
                        return;
                    }
                    vm.state.processingStatus = $translate.instant(stepDefinition.key);
                }, stepDefinition.delay));
            });
        }

        function rotateLongWaitMessage(index) {
            if (!vm.state.isSending) {
                return;
            }
            vm.state.delayedProcessingMessage = $translate.instant(longWaitMessageKeys[index % longWaitMessageKeys.length]);
            longWaitTimer = $timeout(function() {
                rotateLongWaitMessage(index + 1);
            }, LONG_WAIT_ROTATION_DELAY_MS);
        }

        function showExecutedActionsBlock(message) {
            return !!(message && message.actionsExecuted);
        }

        function showAdjustmentFollowUp(message) {
            return !!(message && message.actionsExecuted && containsActionType(message.proposedActions, 'CREATE_FINANCIAL_ADJUSTMENT')
                && !containsActionType(message.proposedActions, 'CLOSE_CONTRACT'));
        }

        function areProposedActionsReady(message) {
            return !!(message && message.proposedActions && message.proposedActions.length && message.proposedActions.every(function(action) {
                return action && action.actionReadiness === 'READY';
            }));
        }

        function containsActionType(actions, actionType) {
            return (actions || []).some(function(action) {
                return action && action.actionType === actionType;
            });
        }

        function getUserUsagePercent() {
            return percentage(vm.state.latestUsage && vm.state.latestUsage.currentMonthUserCostUsd, vm.state.latestUsage && vm.state.latestUsage.monthlyUserCostLimitUsd);
        }

        function getOrganisationUsagePercent() {
            return percentage(vm.state.latestUsage && vm.state.latestUsage.currentMonthOrganisationCostUsd,
                vm.state.latestUsage && vm.state.latestUsage.monthlyOrganisationCostLimitUsd);
        }

        function getUserUsageStatusClass() {
            return getUsageStatus(vm.state.latestUsage && vm.state.latestUsage.currentMonthUserCostUsd,
                vm.state.latestUsage && vm.state.latestUsage.monthlyUserCostLimitUsd).className;
        }

        function getOrganisationUsageStatusClass() {
            return getUsageStatus(vm.state.latestUsage && vm.state.latestUsage.currentMonthOrganisationCostUsd,
                vm.state.latestUsage && vm.state.latestUsage.monthlyOrganisationCostLimitUsd).className;
        }

        function getUserUsageStatusLabel() {
            return getUsageStatus(vm.state.latestUsage && vm.state.latestUsage.currentMonthUserCostUsd,
                vm.state.latestUsage && vm.state.latestUsage.monthlyUserCostLimitUsd).label;
        }

        function getOrganisationUsageStatusLabel() {
            return getUsageStatus(vm.state.latestUsage && vm.state.latestUsage.currentMonthOrganisationCostUsd,
                vm.state.latestUsage && vm.state.latestUsage.monthlyOrganisationCostLimitUsd).label;
        }

        function getUsagePeriodLabel() {
            if (!vm.state.latestUsage) {
                return '';
            }
            return [formatPeriodDate(vm.state.latestUsage.periodStart), formatPeriodDate(vm.state.latestUsage.periodEnd)]
                .filter(Boolean)
                .join(' -> ');
        }

        function percentage(currentValue, maxValue) {
            if (!maxValue) {
                return null;
            }
            return Math.min(100, Math.round(((currentValue || 0) / maxValue) * 100));
        }

        function getMaxOutputTokenOptions() {
            return (vm.state.latestUsage && vm.state.latestUsage.availableMaxOutputTokenOptions) || [];
        }

        function formatTokenUsage(currentValue, maxValue) {
            return Number(currentValue || 0).toFixed(4) + ' / ' + formatTokenLimit(maxValue) + ' USD';
        }

        function formatTokenLimit(limit) {
            return limit ? Number(limit).toFixed(2) : 'illimité';
        }

        function initializeSelectedMaxOutputTokens(usage) {
            if (!usage || vm.state.selectedMaxOutputTokens) {
                return;
            }
            vm.state.selectedMaxOutputTokens = usage.resolvedMaxOutputTokens || usage.configuredDefaultMaxOutputTokens || null;
        }

        function copyConversationDebugJson() {
            var debugPayload = buildConversationDebugPayload();
            var serialized = angular.toJson(debugPayload, true);
            copyText(serialized);
            vm.state.debugCopySuccess = true;
            $timeout(function() {
                vm.state.debugCopySuccess = false;
            }, 2000);
        }

        function buildConversationDebugPayload() {
            return {
                exportedAt: new Date().toISOString(),
                conversationId: vm.state.conversationId,
                exchanges: (vm.state.messages || []).map(function(message, index) {
                    return {
                        index: index,
                        exchangedAt: message.exchangedAt || null,
                        role: message.role,
                        content: message.content
                    };
                })
            };
        }

        function buildSentContextInfo(message) {
            var adapter = getAdapter();
            var sentContextSummary = message && message.sentContextSummary ? message.sentContextSummary : {};
            var scopes = sentContextSummary.selectedDataScopes || message.selectedDataScopes || [];
            var domains = sentContextSummary.selectedInstructionDomains || message.selectedInstructionDomains || [];
            var parts = [];
            if (adapter && adapter.buildSentContextInfo) {
                return adapter.buildSentContextInfo(message) || '';
            }
            if (message && message.plannerUsed) {
                parts.push($translate.instant('global.assistant.sentContextPlannerUsed'));
            } else {
                parts.push($translate.instant('global.assistant.sentContextPlannerSkipped'));
            }
            if (scopes.length) {
                parts.push($translate.instant('global.assistant.sentContextScopes') + ': ' + scopes.join(', '));
            }
            if (domains.length) {
                parts.push($translate.instant('global.assistant.sentContextRules') + ': ' + domains.join(', '));
            }
            return parts.join(' | ');
        }

        function openDocumentResult(result) {
            var adapter = getAdapter();
            if (!adapter || !adapter.openDocumentResult || !result) {
                return;
            }
            adapter.openDocumentResult(result);
        }

        function copyText(text) {
            var textarea;
            if ($window.navigator && $window.navigator.clipboard && $window.isSecureContext) {
                $window.navigator.clipboard.writeText(text);
                return;
            }
            textarea = $window.document.createElement('textarea');
            textarea.value = text;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.left = '-9999px';
            $window.document.body.appendChild(textarea);
            textarea.select();
            $window.document.execCommand('copy');
            $window.document.body.removeChild(textarea);
        }

        function shouldPromptForFeedback() {
            var adapter = getAdapter();
            return !!(adapter && adapter.submitFeedback && !vm.state.feedbackSubmitted && hasAtLeastOneUserMessage());
        }

        function hasAtLeastOneUserMessage() {
            return (vm.state.messages || []).some(function(message) {
                return message && message.role === 'user' && message.content;
            });
        }

        function getUsageStatus(currentValue, maxValue) {
            var remainingRatio;
            var remainingPeriodRatio;
            var proratedRemainingPercent;
            if (!maxValue) {
                return {
                    label: '-',
                    className: 'assistant-panel__usage-pill assistant-panel__usage-pill--neutral'
                };
            }
            remainingRatio = Math.max(0, (maxValue - (currentValue || 0)) / maxValue);
            remainingPeriodRatio = getRemainingPeriodRatio();
            proratedRemainingPercent = remainingPeriodRatio > 0 ? (remainingRatio / remainingPeriodRatio) * 100 : (remainingRatio > 0 ? 100 : 0);
            if (proratedRemainingPercent > 50) {
                return {
                    label: 'OK',
                    className: 'assistant-panel__usage-pill assistant-panel__usage-pill--success'
                };
            }
            if (proratedRemainingPercent >= 25) {
                return {
                    label: 'Warning',
                    className: 'assistant-panel__usage-pill assistant-panel__usage-pill--warning'
                };
            }
            return {
                label: 'Critique',
                className: 'assistant-panel__usage-pill assistant-panel__usage-pill--danger'
            };
        }

        function getRemainingPeriodRatio() {
            var now = new Date();
            var start = new Date(now.getFullYear(), now.getMonth(), 1);
            var end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
            var total = Math.max(1, end.getTime() - start.getTime());
            return Math.max(0, (end.getTime() - now.getTime()) / total);
        }

        function formatPeriodDate(value) {
            var date;
            if (!value) {
                return '';
            }
            date = new Date(value);
            if (isNaN(date.getTime())) {
                return value;
            }
            return [
                ('0' + date.getDate()).slice(-2),
                ('0' + (date.getMonth() + 1)).slice(-2),
                date.getFullYear()
            ].join('/');
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
;
(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('wamasysApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();
;
(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };
    
    angular
        .module('wamasysApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('wamasysApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-wamasysApp-error');
                var entityKey = httpResponse.headers('X-wamasysApp-params');
                var detail = httpResponse.headers('X-wamasysApp-detail');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName,detail: detail});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('wamasysApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();
;
"use strict";

angular.module('wamasysApp').factory('CurrentAgence', function($http){
    return {
        list: [
               {
                   "href": "/",
                   "title": "CEB - Cebu"
               },
               {
                   "href": "/",
                   "title": "MAN - Manille"
               }
           ]
    }
});;
"use strict";

angular.module('wamasysApp').directive('currentAgence', function(CurrentAgence,$timeout,Principal, $state,Auth){
    return {
        restrict: "EA",
        replace: true,
        templateUrl: "app/components/current-agence/current-agence.tpl.html",
        scope: true,
        link: function(scope, element, attrs){
        
        	scope.changerAgence = function(idAgence){

        		Auth.changerAgence(idAgence).then(function () {

        			if($state.current.name.startsWith("reporting-")){
        				$state.reload();
        			}else{
        				$state.go("home",{},{reload: true});
        			}

           		});
        		
        	};

            scope.account = null;
            
            function getAccount() {
                Principal.identity().then(function(account) {
                	scope.account = account;
                	if(account.agence){
                		scope.currentAgence = account.agence.nom;
                	}
                	if(account.organisationName){
                		scope.currentOrganisation = account.organisationName;
                	}
                	if(account.agencesRattachement){
                		scope.agencesRattachement = account.agencesRattachement;
                		scope.agencesRattachementNoFilter = account.agencesRattachement;
                		//Trie de la liste des agences.
//                		scope.agencesRattachement.sort(
//                				function (a, b) {
//                					 (a.nom > b.nom) ? 1 : -1 ;
//                				}		
//                		) ;
                	}
                	
                	scope.isAuthenticated = Principal.isAuthenticated;
                });
            }
            
            getAccount();

 

           
            scope.showInputFilter = function (arg){
            	$('#iBalAgence').toggle();
            	$('#currentAgenceFilter').toggle();
            	$('#spanAgence').toggle();
            	$timeout(function () {
            		$('#currentAgenceFilter').focus();
                   });
            };
            
            scope.filterLostFocus = function (arg){
            	$('#spanAgence').toggle();
            	$('#iBalAgence').toggle();
            	$('#currentAgenceFilter').toggle();
//            	$('#spanAgence').dropdown();
            	element.find('#currentAgenceFilter')[0].value ="";
        		scope.agencesRattachement = scope.agencesRattachementNoFilter;
            	
            };
            
//            scope.applyFilter = function (){
//            	if(element.find('#currentAgenceFilter')[0] && element.find('#currentAgenceFilter')[0].value && element.find('#currentAgenceFilter')[0].value.length > 0){
//            		scope.agencesRattachement = scope.agencesRattachementNoFilter.filter(function (agence) {
//	  	          		  return agence.nom.toLowerCase().includes(element.find('#currentAgenceFilter')[0].value.toLowerCase());
//	  	          	})
//            	}else{
//            		scope.agencesRattachement = scope.agencesRattachementNoFilter;
//            	}
//            
//          
//            };
        }
    }
});
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-wamasysApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-wamasysApp-params')});
            }
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            var data = response.data;
            // Le formulaire de connexion traite les demandes MFA et leurs erreurs.
            var isMfaResponse = (response.status === 401 || response.status === 503) && data && data.mfa_required === true;
            var isAccountResponse = response.status === 401 && (data === '' ||
                (data && typeof data.path === 'string' && data.path.indexOf('/api/account') === 0));
            if (!isMfaResponse && !isAccountResponse) {
                $rootScope.$emit('wamasysApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            
            return config;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider'];

    function localStorageConfig($localStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider', 'ENV'];

    function compileServiceConfig($compileProvider, ENV) {
        // disable debug data on prod profile to improve performance
        if(ENV === 'prod'){
            $compileProvider.debugInfoEnabled(false);
        }

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$translate', 'JhiLanguageService', 'translationHandler',
        'Auth', 'Principal', 'ENV', 'VERSION'];

    function stateHandler($rootScope, $state, $translate, JhiLanguageService, translationHandler,
        Auth, Principal, ENV, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.ENV = ENV;
            $rootScope.VERSION = VERSION;
            $rootScope.back = back;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                
                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Remember previous state unless we've been redirected to login or we've just
                // reset the state memory after logout. If we're redirected to login, our
                // previousState is already set in the authExpiredInterceptor. If we're going
                // to login directly, we don't want to be sent to some previous state anyway
                if (!$rootScope.redirected && $rootScope.previousStateName) {
                    $rootScope.previousStateName = fromState.name;
                    $rootScope.previousStateParams = fromParams;
                }

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });

            function back() {
                // If previous state is 'activate' or do not exist go to 'home'
                if ($rootScope.previousStateName === 'activate' || $state.get($rootScope.previousStateName) === null) {
                    $state.go('home');
                } else {
                    $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
                }
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('type-contrat', {
            parent: 'entity',
            url: '/type-contrat?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.contractType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-contrat/type-contrats.html',
                    controller: 'ContractTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contractType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('type-contrat-detail', {
            parent: 'entity',
            url: '/type-contrat/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.contractType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-contrat/type-contrat-detail.html',
                    controller: 'ContractTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contractType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ContractType', function($stateParams, ContractType) {
                    return ContractType.get({id : $stateParams.id});
                }]
            }
        })
        .state('type-contrat.new', {
            parent: 'type-contrat',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-contrat/type-contrat-dialog.html',
                    controller: 'ContractTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('type-contrat', null, { reload: true });
                }, function() {
                    $state.go('type-contrat');
                });
            }]
        })
        .state('type-contrat.edit', {
            parent: 'type-contrat',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-contrat/type-contrat-dialog.html',
                    controller: 'ContractTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ContractType', function(ContractType) {
                            return ContractType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-contrat.delete', {
            parent: 'type-contrat',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-contrat/type-contrat-delete-dialog.html',
                    controller: 'ContractTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ContractType', function(ContractType) {
                            return ContractType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ContractType', ContractType);

    ContractType.$inject = ['$resource'];

    function ContractType ($resource) {
        var resourceUrl =  'api/type-contrats/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractTypeController', ContractTypeController);

    ContractTypeController.$inject = ['$scope', '$state', 'ContractType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ContractTypeController ($scope, $state, ContractType, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            ContractType.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.contractTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractTypeDialogController', ContractTypeDialogController);

    ContractTypeDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ContractType'];

    function ContractTypeDialogController ($scope, $stateParams, $uibModalInstance, entity, ContractType) {
        var vm = this;
        vm.contractType = entity;
        vm.load = function(id) {
            ContractType.get({id : id}, function(result) {
                vm.contractType = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:contractTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.contractType.id !== null) {
                ContractType.update(vm.contractType, onSaveSuccess, onSaveError);
            } else {
                ContractType.save(vm.contractType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractTypeDetailController', ContractTypeDetailController);

    ContractTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ContractType'];

    function ContractTypeDetailController($scope, $rootScope, $stateParams, entity, ContractType) {
        var vm = this;
        vm.contractType = entity;
        vm.load = function (id) {
            ContractType.get({id: id}, function(result) {
                vm.contractType = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:contractTypeUpdate', function(event, result) {
            vm.contractType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractTypeDeleteController',ContractTypeDeleteController);

    ContractTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'ContractType'];

    function ContractTypeDeleteController($uibModalInstance, entity, ContractType) {
        var vm = this;
        vm.contractType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ContractType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('TestPlan', TestPlan);

    TestPlan.$inject = ['$resource'];

    function TestPlan($resource) {
        return $resource('api/test-plans/monitoring/:storageKey', { storageKey: '@storageKey' }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'detail': {
                method: 'GET'
            },
            'hide': {
                method: 'DELETE'
            },
            'deletePlan': {
                method: 'DELETE',
                url: 'api/test-plans/monitoring/:storageKey/permanent'
            },
            'assignableUsers': {
                method: 'GET',
                url: 'api/test-plans/users',
                isArray: true
            },
            'upload': {
                method: 'POST',
                url: 'api/test-plans/upload',
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            },
            'myPlans': {
                method: 'GET',
                url: 'api/test-plans/my',
                isArray: true
            },
            'myPlan': {
                method: 'GET',
                url: 'api/test-plans/my/:storageKey'
            },
            'saveMyPlan': {
                method: 'PUT',
                url: 'api/test-plans/my/:storageKey'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TestPlanRunnerController', TestPlanRunnerController);

    TestPlanRunnerController.$inject = ['$scope', '$stateParams', 'AlertService', 'TestPlan'];

    function TestPlanRunnerController($scope, $stateParams, AlertService, TestPlan) {
        var vm = this;

        vm.planKey = $stateParams.planKey;
        vm.myPlans = [];
        vm.currentPlan = null;
        vm.currentResult = null;
        vm.currentSummary = null;
        vm.selectedDomain = null;
        vm.isChoosingPlan = true;
        vm.isIntroCollapsed = false;
        vm.scenarioPanels = {};
        vm.scenarioResultsByKey = {};
        vm.loadPlan = loadPlan;
        vm.choosePlan = choosePlan;
        vm.toggleIntro = toggleIntro;
        vm.selectDomain = selectDomain;
        vm.previousDomain = previousDomain;
        vm.nextDomain = nextDomain;
        vm.hasPreviousDomain = hasPreviousDomain;
        vm.hasNextDomain = hasNextDomain;
        vm.getSelectedDomainIndex = getSelectedDomainIndex;
        vm.isSelectedDomain = isSelectedDomain;
        vm.isDomainStarted = isDomainStarted;
        vm.isDomainCompleted = isDomainCompleted;
        vm.getScenarioKey = getScenarioKey;
        vm.getScenarioResult = getScenarioResult;
        vm.getScenarioResponseType = getScenarioResponseType;
        vm.isStatusQuestion = isStatusQuestion;
        vm.isRatingQuestion = isRatingQuestion;
        vm.isSmileyQuestion = isSmileyQuestion;
        vm.getScenarioState = getScenarioState;
        vm.getScenarioStatusLabelKey = getScenarioStatusLabelKey;
        vm.getScenarioCommentPreview = getScenarioCommentPreview;
        vm.isScenarioExpanded = isScenarioExpanded;
        vm.toggleScenario = toggleScenario;
        vm.onScenarioCommentBlur = onScenarioCommentBlur;
        vm.setScenarioStatus = setScenarioStatus;
        vm.selectScenarioRating = selectScenarioRating;
        vm.selectScenarioSmiley = selectScenarioSmiley;
        vm.getSmileyLabelKey = getSmileyLabelKey;
        vm.getSmileyImagePath = getSmileyImagePath;
        vm.handleCommentPaste = handleCommentPaste;
        vm.removeAttachment = removeAttachment;
        vm.save = save;
        vm.domainProgress = domainProgress;

        activate();

        function activate() {
            TestPlan.myPlans(function(result) {
                vm.myPlans = result || [];
                if (vm.myPlans.length === 0) {
                    return;
                }

                if (vm.planKey) {
                    var selected = vm.myPlans[0];
                    vm.myPlans.forEach(function(plan) {
                        if (plan.storageKey === vm.planKey) {
                            selected = plan;
                        }
                    });
                    loadPlan(selected.storageKey);
                }
            });
        }

        function choosePlan() {
            vm.isChoosingPlan = true;
            vm.currentPlan = null;
            vm.currentResult = null;
            vm.currentSummary = null;
            vm.selectedDomain = null;
            vm.isIntroCollapsed = false;
            vm.scenarioPanels = {};
            vm.scenarioResultsByKey = {};
        }

        function loadPlan(storageKey) {
            if (!storageKey) {
                return;
            }
            vm.planKey = storageKey;
            vm.isIntroCollapsed = false;
            vm.scenarioPanels = {};
            TestPlan.myPlan({ storageKey: storageKey }, function(result) {
                vm.currentPlan = result.plan;
                vm.currentResult = result.result;
                vm.currentSummary = result.summary;
                indexScenarioResults();
                restoreSelectedDomain();
                vm.isChoosingPlan = false;
            }, function(response) {
                var errorDetail = response.headers('X-wamasysApp-detail');
                AlertService.error(errorDetail || 'Impossible de charger le plan de test.');
            });
        }

        function toggleIntro() {
            vm.isIntroCollapsed = !vm.isIntroCollapsed;
        }

        function selectDomain(domain) {
            vm.selectedDomain = domain;
        }

        function previousDomain() {
            moveToDomain(-1);
        }

        function nextDomain() {
            moveToDomain(1);
        }

        function hasPreviousDomain() {
            return getSelectedDomainIndex() > 0;
        }

        function hasNextDomain() {
            var currentIndex = getSelectedDomainIndex();
            return currentIndex > -1 && vm.currentPlan && vm.currentPlan.domains && currentIndex < vm.currentPlan.domains.length - 1;
        }

        function getSelectedDomainIndex() {
            return findDomainIndex(vm.selectedDomain ? vm.selectedDomain.domainId : null);
        }

        function isSelectedDomain(domain) {
            return !!domain && !!vm.selectedDomain && domain.domainId === vm.selectedDomain.domainId;
        }

        function getScenarioKey(domainId, scenarioId) {
            return domainId + '::' + scenarioId;
        }

        function getScenarioResult(domainId, scenarioId) {
            return vm.scenarioResultsByKey[getScenarioKey(domainId, scenarioId)] || null;
        }

        function getScenarioResponseType(scenario) {
            return scenario && scenario.responseType ? scenario.responseType : 'STATUS';
        }

        function isStatusQuestion(scenario) {
            return getScenarioResponseType(scenario) === 'STATUS';
        }

        function isRatingQuestion(scenario) {
            return getScenarioResponseType(scenario) === 'RATING_10';
        }

        function isSmileyQuestion(scenario) {
            return getScenarioResponseType(scenario) === 'SMILEY_4';
        }

        function getScenarioState(scenarioResult) {
            if (!scenarioResult || !scenarioResult.status || scenarioResult.status === 'NOT_TESTED') {
                return 'pending';
            }
            if (scenarioResult.status === 'UNABLE_TO_ANSWER') {
                return 'unable';
            }
            if (scenarioResult.status === 'ANSWERED') {
                return scenarioResult.answerValue !== null && scenarioResult.answerValue !== undefined ? 'answered' : 'pending';
            }
            if (scenarioResult.status === 'OK') {
                return 'ok';
            }
            if (scenarioResult.status === 'KO' && hasKoComment(scenarioResult)) {
                return 'ko';
            }
            return 'ko-pending';
        }

        function getScenarioStatusLabelKey(scenarioResult) {
            var state = getScenarioState(scenarioResult);
            if (state === 'ok') {
                return 'testPlan.runner.scenarioStatusOk';
            }
            if (state === 'ko') {
                return 'testPlan.runner.scenarioStatusKo';
            }
            if (state === 'ko-pending') {
                return 'testPlan.runner.scenarioStatusKoPending';
            }
            if (state === 'answered') {
                return 'testPlan.runner.scenarioStatusAnswered';
            }
            if (state === 'unable') {
                return 'testPlan.runner.scenarioStatusUnable';
            }
            return 'testPlan.runner.scenarioStatusPending';
        }

        function getScenarioCommentPreview(scenarioResult) {
            if (!scenarioResult || !scenarioResult.comment) {
                return '';
            }

            var compactComment = scenarioResult.comment.replace(/\s+/g, ' ').trim();
            if (compactComment.length <= 110) {
                return compactComment;
            }
            return compactComment.substring(0, 107) + '...';
        }

        function isScenarioExpanded(domainId, scenarioId) {
            var scenarioKey = getScenarioKey(domainId, scenarioId);
            if (vm.scenarioPanels.hasOwnProperty(scenarioKey)) {
                return vm.scenarioPanels[scenarioKey];
            }
            return !isScenarioCompleted(getScenarioResult(domainId, scenarioId));
        }

        function toggleScenario(domainId, scenarioId) {
            setScenarioExpanded(domainId, scenarioId, !isScenarioExpanded(domainId, scenarioId));
        }

        function onScenarioCommentBlur(domainId, scenarioId) {
            var scenarioResult = getScenarioResult(domainId, scenarioId);
            if (isScenarioCompleted(scenarioResult)) {
                setScenarioExpanded(domainId, scenarioId, false);
            }
        }

        function setScenarioStatus(domainId, scenarioId, status) {
            var result = getScenarioResult(domainId, scenarioId);
            if (!result) {
                return;
            }

            result.status = status;
            if (status !== 'ANSWERED') {
                result.answerValue = null;
            }

            // Completed answers collapse automatically to keep the remaining work visible.
            if (status === 'OK' || status === 'UNABLE_TO_ANSWER') {
                setScenarioExpanded(domainId, scenarioId, false);
                return;
            }
            if (status === 'KO') {
                setScenarioExpanded(domainId, scenarioId, !hasKoComment(result));
                return;
            }
            setScenarioExpanded(domainId, scenarioId, true);
        }

        function selectScenarioRating(domainId, scenarioId, value) {
            setScenarioAnswerValue(domainId, scenarioId, value);
        }

        function selectScenarioSmiley(domainId, scenarioId, value) {
            setScenarioAnswerValue(domainId, scenarioId, value);
        }

        function setScenarioAnswerValue(domainId, scenarioId, value) {
            var result = getScenarioResult(domainId, scenarioId);
            if (!result) {
                return;
            }
            result.status = 'ANSWERED';
            result.answerValue = value;
            setScenarioExpanded(domainId, scenarioId, false);
        }

        function getSmileyLabelKey(value) {
            if (value === 1) {
                return 'testPlan.runner.smiley1';
            }
            if (value === 2) {
                return 'testPlan.runner.smiley2';
            }
            if (value === 3) {
                return 'testPlan.runner.smiley3';
            }
            return 'testPlan.runner.smiley4';
        }

        function getSmileyImagePath(value) {
            if (value === 1) {
                return 'content/images/wamasys_smiley_fache.png';
            }
            if (value === 2) {
                return 'content/images/wamasys_smiley_mitige.png';
            }
            if (value === 3) {
                return 'content/images/wamasys_smiley_ok.png';
            }
            return 'content/images/wamasys_smiley_very_happy.png';
        }

        function handleCommentPaste($event, scenarioResult) {
            if (!scenarioResult || !$event || !$event.clipboardData || !$event.clipboardData.items) {
                return;
            }

            var imageItems = [];
            angular.forEach($event.clipboardData.items, function(item) {
                if (item && item.type && item.type.indexOf('image/') === 0) {
                    imageItems.push(item);
                }
            });
            if (imageItems.length === 0) {
                return;
            }

            if (!scenarioResult.attachments) {
                scenarioResult.attachments = [];
            }

            $event.preventDefault();
            angular.forEach(imageItems, function(item, index) {
                var file = item.getAsFile();
                if (!file) {
                    return;
                }
                var reader = new FileReader();
                reader.onload = function(loadEvent) {
                    $scope.$applyAsync(function() {
                        scenarioResult.attachments.push({
                            fileName: file.name || ('capture-' + (scenarioResult.attachments.length + index + 1) + '.png'),
                            contentType: file.type || 'image/png',
                            dataUrl: loadEvent.target.result
                        });
                    });
                };
                reader.readAsDataURL(file);
            });
        }

        function removeAttachment(scenarioResult, attachmentIndex) {
            if (!scenarioResult || !scenarioResult.attachments) {
                return;
            }
            scenarioResult.attachments.splice(attachmentIndex, 1);
        }

        function save() {
            if (!vm.planKey || !vm.currentResult) {
                return;
            }

            var selectedDomainId = vm.selectedDomain ? vm.selectedDomain.domainId : null;
            TestPlan.saveMyPlan({ storageKey: vm.planKey }, vm.currentResult, function(result) {
                vm.currentPlan = result.plan;
                vm.currentResult = result.result;
                vm.currentSummary = result.summary;
                indexScenarioResults();
                restoreSelectedDomain(selectedDomainId);
            }, function(response) {
                var errorDetail = response.headers('X-wamasysApp-detail');
                AlertService.error(errorDetail || 'Impossible d\'enregistrer votre résultat.');
            });
        }

        function domainProgress(domain) {
            if (!domain || !domain.scenarios || domain.scenarios.length === 0) {
                return '0/0';
            }

            return countCompletedScenarios(domain) + '/' + domain.scenarios.length;
        }

        function isDomainStarted(domain) {
            if (!domain || !domain.scenarios || domain.scenarios.length === 0) {
                return false;
            }

            return countStartedScenarios(domain) > 0 && !isDomainCompleted(domain);
        }

        function isDomainCompleted(domain) {
            return !!domain && !!domain.scenarios && domain.scenarios.length > 0
                && countCompletedScenarios(domain) === domain.scenarios.length;
        }

        function countStartedScenarios(domain) {
            var startedCount = 0;
            domain.scenarios.forEach(function(scenario) {
                if (isScenarioStarted(getScenarioResult(domain.domainId, scenario.scenarioId))) {
                    startedCount++;
                }
            });
            return startedCount;
        }

        function countCompletedScenarios(domain) {
            var completedCount = 0;
            domain.scenarios.forEach(function(scenario) {
                if (isScenarioCompleted(getScenarioResult(domain.domainId, scenario.scenarioId))) {
                    completedCount++;
                }
            });
            return completedCount;
        }

        function moveToDomain(offset) {
            var currentIndex = getSelectedDomainIndex();
            if (!vm.currentPlan || !vm.currentPlan.domains || currentIndex < 0) {
                return;
            }

            var nextIndex = currentIndex + offset;
            if (nextIndex < 0 || nextIndex >= vm.currentPlan.domains.length) {
                return;
            }

            vm.selectedDomain = vm.currentPlan.domains[nextIndex];
        }

        function restoreSelectedDomain(preferredDomainId) {
            if (!vm.currentPlan || !vm.currentPlan.domains || vm.currentPlan.domains.length === 0) {
                vm.selectedDomain = null;
                return;
            }

            var selectedDomain = vm.currentPlan.domains[0];
            if (preferredDomainId !== undefined && preferredDomainId !== null) {
                vm.currentPlan.domains.forEach(function(domain) {
                    if (domain.domainId === preferredDomainId) {
                        selectedDomain = domain;
                    }
                });
            }
            vm.selectedDomain = selectedDomain;
        }

        function findDomainIndex(domainId) {
            if (!vm.currentPlan || !vm.currentPlan.domains || domainId === undefined || domainId === null) {
                return -1;
            }

            var foundIndex = -1;
            vm.currentPlan.domains.forEach(function(domain, index) {
                if (domain.domainId === domainId) {
                    foundIndex = index;
                }
            });
            return foundIndex;
        }

        function indexScenarioResults() {
            vm.scenarioResultsByKey = {};
            if (!vm.currentResult || !vm.currentResult.scenarioResults) {
                return;
            }

            vm.currentResult.scenarioResults.forEach(function(item) {
                vm.scenarioResultsByKey[getScenarioKey(item.domainId, item.scenarioId)] = item;
            });
        }

        function isScenarioStarted(scenarioResult) {
            return !!scenarioResult && !!scenarioResult.status && scenarioResult.status !== 'NOT_TESTED';
        }

        function isScenarioCompleted(scenarioResult) {
            if (!isScenarioStarted(scenarioResult)) {
                return false;
            }
            if (scenarioResult.status === 'UNABLE_TO_ANSWER' || scenarioResult.status === 'OK') {
                return true;
            }
            if (scenarioResult.status === 'ANSWERED') {
                return scenarioResult.answerValue !== null && scenarioResult.answerValue !== undefined;
            }
            return scenarioResult.status === 'KO' && hasKoComment(scenarioResult);
        }

        function hasKoComment(scenarioResult) {
            return !!scenarioResult && !!scenarioResult.comment && scenarioResult.comment.trim().length > 0;
        }

        function setScenarioExpanded(domainId, scenarioId, expanded) {
            vm.scenarioPanels[getScenarioKey(domainId, scenarioId)] = expanded;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('test-plan-monitoring', {
                parent: 'entity',
                url: '/test-plan-monitoring?status',
                data: {
                    authenticate: true,
                    authorities: ['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_SUPER_ADMIN'],
                    pageTitle: 'global.menu.tech.testPlanMonitoring'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/business/test-plan/test-plan-monitoring.html',
                        controller: 'TestPlanMonitoringController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testPlan');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('test-plan-runner', {
                parent: 'account',
                url: '/test-plan-runner?planKey',
                data: {
                    authenticate: true,
                    authorities: ['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_AREA_MANAGEMENT', 'ROLE_DATA_OPERATOR', 'ROLE_READ_ONLY', 'ROLE_SUPER_ADMIN'],
                    pageTitle: 'global.menu.account.testPlan'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/business/test-plan/test-plan-runner.html',
                        controller: 'TestPlanRunnerController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testPlan');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('test-plan-create', {
                parent: 'entity',
                url: '/test-plan-create',
                data: {
                    authenticate: true,
                    authorities: ['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_SUPER_ADMIN'],
                    pageTitle: 'testPlan.create.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/business/test-plan/test-plan-create.html',
                        controller: 'TestPlanCreateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testPlan');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TestPlanMonitoringController', TestPlanMonitoringController);

    TestPlanMonitoringController.$inject = ['$stateParams', 'TestPlan', '$translate'];

    function TestPlanMonitoringController($stateParams, TestPlan, $translate) {
        var vm = this;

        vm.status = $stateParams.status || 'TODO';
        vm.plans = [];
        vm.selectedPlan = null;
        vm.scenarioDefinitionsByKey = {};
        vm.errorMessage = null;
        vm.planStats = null;

        vm.refresh = refresh;
        vm.showPlan = showPlan;
        vm.changeStatus = changeStatus;
        vm.hidePlan = hidePlan;
        vm.deletePlan = deletePlan;
        vm.deleting = false;
        vm.getScenarioDomainTitle = getScenarioDomainTitle;
        vm.getScenarioTitle = getScenarioTitle;
        vm.getScenarioAnswerLabel = getScenarioAnswerLabel;
        vm.getScenarioResponseTypeLabel = getScenarioResponseTypeLabel;
        vm.getOverallStatusLabel = getOverallStatusLabel;
        vm.getResultProgressLabel = getResultProgressLabel;
        vm.getAttachmentCount = getAttachmentCount;

        activate();

        function activate() {
            refresh();
        }

        function refresh() {
            resetSelectedPlan();
            vm.errorMessage = null;

            TestPlan.query({ status: vm.status }, function(result) {
                vm.plans = result || [];
                if (vm.plans.length > 0) {
                    showPlan(vm.plans[0]);
                }
            }, function(response) {
                vm.errorMessage = resolveErrorMessage(response, 'Impossible de charger la liste des plans de test.');
            });
        }

        function showPlan(planSummary) {
            if (!planSummary || !planSummary.storageKey) {
                resetSelectedPlan();
                return;
            }

            vm.errorMessage = null;
            TestPlan.detail({ storageKey: planSummary.storageKey, status: vm.status }, function(result) {
                vm.selectedPlan = result;
                indexScenarioDefinitions();
                buildPlanStats();
            }, function(response) {
                vm.errorMessage = resolveErrorMessage(response, 'Impossible de charger le détail du plan de test.');
            });
        }

        function changeStatus(status) {
            vm.status = status;
            refresh();
        }

        function hidePlan() {
            if (!vm.selectedPlan || !vm.selectedPlan.summary || !vm.selectedPlan.summary.storageKey) {
                return;
            }
            if (!window.confirm('Masquer ce plan de test de la liste ?')) {
                return;
            }

            TestPlan.hide({ storageKey: vm.selectedPlan.summary.storageKey, status: vm.status }, function() {
                resetSelectedPlan();
                refresh();
            }, function(response) {
                vm.errorMessage = resolveErrorMessage(response, 'Impossible de masquer le plan de test.');
            });
        }


        function deletePlan() {
            if (vm.deleting || !vm.selectedPlan || !vm.selectedPlan.summary) {
                return;
            }
            var plan = vm.selectedPlan.summary;
            if (!window.confirm($translate.instant('testPlan.monitoring.deleteConfirmation', { title: plan.title }))) {
                return;
            }

            vm.deleting = true;
            vm.errorMessage = null;
            TestPlan.deletePlan({ storageKey: plan.storageKey, status: vm.status }, function() {
                vm.deleting = false;
                refresh();
            }, function(response) {
                vm.deleting = false;
                vm.errorMessage = resolveErrorMessage(response, $translate.instant('testPlan.monitoring.deleteError'));
            });
        }

        function resetSelectedPlan() {
            vm.selectedPlan = null;
            vm.scenarioDefinitionsByKey = {};
            vm.planStats = null;
        }

        function indexScenarioDefinitions() {
            vm.scenarioDefinitionsByKey = {};
            if (!vm.selectedPlan || !vm.selectedPlan.plan || !vm.selectedPlan.plan.domains) {
                return;
            }

            vm.selectedPlan.plan.domains.forEach(function(domain) {
                if (!domain || !domain.scenarios) {
                    return;
                }
                domain.scenarios.forEach(function(scenario) {
                    vm.scenarioDefinitionsByKey[buildScenarioKey(domain.domainId, scenario.scenarioId)] = {
                        domainTitle: domain.title,
                        scenarioTitle: scenario.title,
                        responseType: scenario.responseType || 'STATUS'
                    };
                });
            });
        }

        function buildPlanStats() {
            var results = vm.selectedPlan && vm.selectedPlan.results ? vm.selectedPlan.results : [];
            var stats = {
                assignedCount: results.length,
                completedCount: 0,
                inProgressCount: 0,
                notStartedCount: 0,
                totalScenarioCount: 0,
                answeredCount: 0,
                pendingCount: 0,
                okCount: 0,
                koCount: 0,
                unableCount: 0,
                ratingAverage: null,
                smileyDominantLabelKey: null
            };
            var ratingSum = 0;
            var ratingCount = 0;
            var smileyCounts = {
                1: 0,
                2: 0,
                3: 0,
                4: 0
            };

            results.forEach(function(result) {
                var overallStatus = result && result.overallStatus ? result.overallStatus : 'NOT_STARTED';
                if (overallStatus === 'DONE') {
                    stats.completedCount++;
                } else if (overallStatus === 'IN_PROGRESS') {
                    stats.inProgressCount++;
                } else {
                    stats.notStartedCount++;
                }

                angular.forEach(result.scenarioResults || [], function(scenarioResult) {
                    var responseType = getScenarioResponseType(scenarioResult);
                    stats.totalScenarioCount++;

                    if (hasScenarioResponse(scenarioResult)) {
                        stats.answeredCount++;
                    } else {
                        stats.pendingCount++;
                    }

                    if (scenarioResult.status === 'OK') {
                        stats.okCount++;
                    } else if (scenarioResult.status === 'KO') {
                        stats.koCount++;
                    } else if (scenarioResult.status === 'UNABLE_TO_ANSWER') {
                        stats.unableCount++;
                    } else if (scenarioResult.status === 'ANSWERED' && responseType === 'RATING_10'
                        && scenarioResult.answerValue !== null && scenarioResult.answerValue !== undefined) {
                        ratingSum += Number(scenarioResult.answerValue);
                        ratingCount++;
                    } else if (scenarioResult.status === 'ANSWERED' && responseType === 'SMILEY_4'
                        && scenarioResult.answerValue !== null && scenarioResult.answerValue !== undefined) {
                        smileyCounts[scenarioResult.answerValue] = (smileyCounts[scenarioResult.answerValue] || 0) + 1;
                    }
                });
            });

            if (ratingCount > 0) {
                stats.ratingAverage = Math.round((ratingSum / ratingCount) * 10) / 10;
            }
            stats.smileyDominantLabelKey = resolveDominantSmileyLabelKey(smileyCounts);
            vm.planStats = stats;
        }

        function getScenarioDomainTitle(scenarioResult) {
            return getScenarioDefinition(scenarioResult).domainTitle || scenarioResult.domainId;
        }

        function getScenarioTitle(scenarioResult) {
            return getScenarioDefinition(scenarioResult).scenarioTitle || scenarioResult.scenarioId;
        }

        function getScenarioAnswerLabel(scenarioResult) {
            var responseType = getScenarioResponseType(scenarioResult);
            var status = scenarioResult && scenarioResult.status ? scenarioResult.status : 'NOT_TESTED';

            if (status === 'NOT_TESTED') {
                return $translate.instant('testPlan.runner.notTested');
            }
            if (status === 'UNABLE_TO_ANSWER') {
                return $translate.instant('testPlan.runner.unableToAnswer');
            }
            if (status === 'OK' || status === 'KO') {
                return status;
            }
            if (status === 'ANSWERED' && responseType === 'RATING_10') {
                return $translate.instant('testPlan.runner.ratingValue', { value: scenarioResult.answerValue });
            }
            if (status === 'ANSWERED' && responseType === 'SMILEY_4') {
                return $translate.instant(getSmileyLabelKey(scenarioResult.answerValue));
            }
            return status;
        }

        function getScenarioResponseTypeLabel(scenarioResult) {
            var responseType = getScenarioResponseType(scenarioResult);
            if (responseType === 'RATING_10') {
                return $translate.instant('testPlan.monitoring.responseTypeRating10');
            }
            if (responseType === 'SMILEY_4') {
                return $translate.instant('testPlan.monitoring.responseTypeSmiley4');
            }
            return $translate.instant('testPlan.monitoring.responseTypeStatus');
        }

        function getOverallStatusLabel(overallStatus) {
            if (overallStatus === 'DONE') {
                return $translate.instant('testPlan.monitoring.overallStatusDone');
            }
            if (overallStatus === 'IN_PROGRESS') {
                return $translate.instant('testPlan.monitoring.overallStatusInProgress');
            }
            return $translate.instant('testPlan.monitoring.overallStatusNotStarted');
        }

        function getResultProgressLabel(result) {
            var progress = getResultProgress(result);
            return progress.answered + ' / ' + progress.total;
        }

        function getAttachmentCount(scenarioResult) {
            return scenarioResult && scenarioResult.attachments ? scenarioResult.attachments.length : 0;
        }

        function getResultProgress(result) {
            var total = result && result.scenarioResults ? result.scenarioResults.length : 0;
            var answered = 0;

            angular.forEach(result && result.scenarioResults ? result.scenarioResults : [], function(scenarioResult) {
                if (hasScenarioResponse(scenarioResult)) {
                    answered++;
                }
            });

            return {
                answered: answered,
                total: total
            };
        }

        function hasScenarioResponse(scenarioResult) {
            return !!scenarioResult && !!scenarioResult.status && scenarioResult.status !== 'NOT_TESTED';
        }

        function getScenarioDefinition(scenarioResult) {
            if (!scenarioResult) {
                return {};
            }
            return vm.scenarioDefinitionsByKey[buildScenarioKey(scenarioResult.domainId, scenarioResult.scenarioId)] || {};
        }

        function getScenarioResponseType(scenarioResult) {
            return getScenarioDefinition(scenarioResult).responseType || 'STATUS';
        }

        function resolveDominantSmileyLabelKey(smileyCounts) {
            var dominantValue = null;
            var dominantCount = 0;

            angular.forEach(smileyCounts, function(count, value) {
                if (count > dominantCount) {
                    dominantCount = count;
                    dominantValue = Number(value);
                }
            });

            return dominantCount > 0 ? getSmileyLabelKey(dominantValue) : null;
        }

        function getSmileyLabelKey(value) {
            if (value === 1) {
                return 'testPlan.runner.smiley1';
            }
            if (value === 2) {
                return 'testPlan.runner.smiley2';
            }
            if (value === 3) {
                return 'testPlan.runner.smiley3';
            }
            return 'testPlan.runner.smiley4';
        }

        function buildScenarioKey(domainId, scenarioId) {
            return domainId + '::' + scenarioId;
        }

        function resolveErrorMessage(response, defaultMessage) {
            var headerDetail = readHeader(response, 'X-wamasysApp-detail');
            if (headerDetail) {
                return headerDetail;
            }
            if (response && response.data) {
                if (angular.isString(response.data)) {
                    return response.data;
                }
                if (response.data.message) {
                    return response.data.message;
                }
                if (response.data.error_description) {
                    return response.data.error_description;
                }
            }
            return defaultMessage;
        }

        function readHeader(response, headerName) {
            if (!response || !response.headers) {
                return null;
            }
            return response.headers(headerName) || response.headers(headerName.toLowerCase());
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TestPlanCreateController', TestPlanCreateController);

    TestPlanCreateController.$inject = ['TestPlan', '$translate'];

    function TestPlanCreateController(TestPlan, $translate) {
        var vm = this;

        vm.allUsers = [];
        vm.filteredUsers = [];
        vm.availableAgences = [];
        vm.availableRoles = [];
        vm.filter = null;
        vm.selectedAgenceId = null;
        vm.selectedRole = null;
        vm.selectedUsers = {};
        vm.selectAllVisible = false;
        vm.planFile = null;
        vm.errorMessage = null;
        vm.successMessage = null;
        vm.isLoadingUsers = false;
        vm.isSubmitting = false;

        vm.applyFilters = applyFilters;
        vm.clearMessages = clearMessages;
        vm.clearSelection = clearSelection;
        vm.createPlan = createPlan;
        vm.filteredUserCount = filteredUserCount;
        vm.hasUsers = hasUsers;
        vm.isUserSelected = isUserSelected;
        vm.resetFilters = resetFilters;
        vm.selectedCount = selectedCount;
        vm.setPlanFile = setPlanFile;
        vm.toggleSelectAllVisible = toggleSelectAllVisible;
        vm.updateSelectAllVisibleState = updateSelectAllVisibleState;

        activate();

        function activate() {
            loadUsers();
        }

        function loadUsers() {
            vm.isLoadingUsers = true;
            clearMessages();

            // Charger tous les destinataires de l'organisation, quelle que soit leur zone.
            TestPlan.assignableUsers(function(result) {
                vm.isLoadingUsers = false;
                vm.allUsers = sortUsers((result || []).filter(function(user) {
                    return user && user.activated;
                }));
                vm.availableRoles = buildRoleOptions(vm.allUsers);
                vm.availableAgences = buildAgenceOptions(vm.allUsers);
                applyFilters();
            }, function(response) {
                vm.isLoadingUsers = false;
                vm.allUsers = [];
                vm.filteredUsers = [];
                vm.availableRoles = [];
                vm.availableAgences = [];
                vm.errorMessage = resolveErrorMessage(response, $translate.instant('testPlan.create.loadUsersError'));
            });
        }

        function setPlanFile(file) {
            vm.planFile = file;
            vm.successMessage = null;
        }

        function applyFilters() {
            var normalizedFilter = normalizeText(vm.filter);

            vm.filteredUsers = vm.allUsers.filter(function(user) {
                return matchesFilter(user, normalizedFilter)
                    && matchesRole(user, vm.selectedRole)
                    && matchesAgence(user, vm.selectedAgenceId);
            });

            updateSelectAllVisibleState();
        }

        function resetFilters() {
            vm.filter = null;
            vm.selectedRole = null;
            vm.selectedAgenceId = null;
            applyFilters();
        }

        function hasUsers() {
            return vm.filteredUsers.length > 0;
        }

        function filteredUserCount() {
            return vm.filteredUsers.length;
        }

        function isUserSelected(login) {
            return !!vm.selectedUsers[login];
        }

        function selectedCount() {
            return vm.allUsers.filter(function(user) {
                return !!vm.selectedUsers[user.login];
            }).length;
        }

        function clearSelection() {
            vm.selectedUsers = {};
            vm.selectAllVisible = false;
        }

        function toggleSelectAllVisible() {
            vm.filteredUsers.forEach(function(user) {
                vm.selectedUsers[user.login] = vm.selectAllVisible;
            });
        }

        function updateSelectAllVisibleState() {
            vm.selectAllVisible = vm.filteredUsers.length > 0 && vm.filteredUsers.every(function(user) {
                return !!vm.selectedUsers[user.login];
            });
        }

        function createPlan() {
            var selectedUserLogins = vm.allUsers.filter(function(user) {
                return !!vm.selectedUsers[user.login];
            }).map(function(user) {
                return user.login;
            });

            clearMessages();

            if (!vm.planFile) {
                vm.errorMessage = $translate.instant('testPlan.create.fileRequired');
                return;
            }
            if (selectedUserLogins.length === 0) {
                vm.errorMessage = $translate.instant('testPlan.create.userRequired');
                return;
            }

            vm.isSubmitting = true;
            var formData = new FormData();
            formData.append('file', vm.planFile);
            formData.append('userLogins', angular.toJson(selectedUserLogins));

            TestPlan.upload({}, formData, function(result) {
                vm.isSubmitting = false;
                vm.successMessage = buildSuccessMessage(result, selectedUserLogins.length);
                vm.planFile = null;
                clearSelection();
                angular.element('#testPlanCreateFile').val(null);
            }, function(response) {
                vm.isSubmitting = false;
                vm.errorMessage = resolveErrorMessage(response, $translate.instant('testPlan.create.createError'));
            });
        }

        function clearMessages() {
            vm.errorMessage = null;
            vm.successMessage = null;
        }

        function buildSuccessMessage(result, selectedCountValue) {
            var title = result && result.title ? result.title : $translate.instant('testPlan.create.defaultPlanTitle');
            var assignedCount = result && result.assignedCount ? result.assignedCount : selectedCountValue;
            return $translate.instant('testPlan.create.createSuccess', {
                title: title,
                count: assignedCount
            });
        }

        function buildRoleOptions(users) {
            var roleMap = {};
            users.forEach(function(user) {
                angular.forEach(user.authorities || [], function(authority) {
                    if (authority) {
                        roleMap[authority] = true;
                    }
                });
            });
            return Object.keys(roleMap).sort();
        }

        function buildAgenceOptions(users) {
            var agenceMap = {};
            users.forEach(function(user) {
                angular.forEach(user.agencesRattachement || [], function(agence) {
                    if (agence && agence.id && !agenceMap[agence.id]) {
                        agenceMap[agence.id] = {
                            id: agence.id,
                            nom: agence.nom
                        };
                    }
                });
            });
            return Object.keys(agenceMap).map(function(key) {
                return agenceMap[key];
            }).sort(function(left, right) {
                return (left.nom || '').localeCompare(right.nom || '');
            });
        }

        function sortUsers(users) {
            return users.sort(function(left, right) {
                return buildUserLabel(left).localeCompare(buildUserLabel(right));
            });
        }

        function buildUserLabel(user) {
            return [
                normalizeText(user.lastName),
                normalizeText(user.firstName),
                normalizeText(user.login)
            ].join('|');
        }

        function matchesFilter(user, normalizedFilter) {
            if (!normalizedFilter) {
                return true;
            }

            return [
                user.login,
                user.email,
                user.firstName,
                user.lastName
            ].some(function(value) {
                return normalizeText(value).indexOf(normalizedFilter) !== -1;
            });
        }

        function matchesRole(user, selectedRole) {
            if (!selectedRole) {
                return true;
            }
            return (user.authorities || []).indexOf(selectedRole) !== -1;
        }

        function matchesAgence(user, selectedAgenceId) {
            if (!selectedAgenceId) {
                return true;
            }
            return (user.agencesRattachement || []).some(function(agence) {
                return agence && String(agence.id) === String(selectedAgenceId);
            });
        }

        function normalizeText(value) {
            return (value || '').toString().toLowerCase();
        }

        function resolveErrorMessage(response, defaultMessage) {
            var headerDetail = readHeader(response, 'X-wamasysApp-detail');
            if (headerDetail) {
                return headerDetail;
            }
            if (response && response.data) {
                if (angular.isString(response.data)) {
                    return response.data;
                }
                if (response.data.message) {
                    return response.data.message;
                }
                if (response.data.error_description) {
                    return response.data.error_description;
                }
            }
            return defaultMessage;
        }

        function readHeader(response, headerName) {
            if (!response || !response.headers) {
                return null;
            }
            return response.headers(headerName) || response.headers(headerName.toLowerCase());
        }
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').config(['$stateProvider', function ($stateProvider) {
        var pages = [
            {name:'water-quality', url:'/water-quality?checkId', section:'planning'},
            {name:'water-quality-records', url:'/water-quality/records', section:'records'},
            {name:'water-quality-schedules', url:'/water-quality/schedules', section:'schedules'},
            {name:'water-quality-locations', url:'/water-quality/locations', section:'locations'},
            {name:'water-quality-parameters', url:'/water-quality/parameters', section:'parameters'},
            {name:'water-quality-thresholds', url:'/water-quality/thresholds', section:'thresholds'},
            {name:'water-quality-alerts', url:'/water-quality/alerts', section:'alerts'},
            {name:'water-quality-check', url:'/water-quality/check/:checkId', section:'detail'}
        ];
        pages.forEach(function (page) {
            $stateProvider.state(page.name, {
                parent:'entity', url:page.url,
                data:{authenticate:true, authorities:['ROLE_ADMIN','ROLE_SUPER_ADMIN','ROLE_WATER_QUALITY_READ','ROLE_WATER_QUALITY_EDIT'], pageTitle:'Qualité de l’eau',waterQualitySection:page.section},
                resolve:{translatePartialLoader:['$translate','$translatePartialLoader',function ($translate,$translatePartialLoader) { $translatePartialLoader.addPart('global'); return $translate.refresh(); }]},
                views:{'content@':{templateUrl:'app/business/water-quality/water-quality.html',controller:'WaterQualityController',controllerAs:'vm'}}
            });
        });
    }]);
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').controller('WaterQualityController', WaterQualityController);
    WaterQualityController.$inject = ['$http', '$q', '$window', '$state', '$stateParams', 'Principal'];
    function WaterQualityController($http, $q, $window, $state, $stateParams, Principal) {
        var vm = this, root = 'api/water-quality/';
        vm.section = $state.current.data.waterQualitySection || 'planning';
        vm.meta = {areas: [], locations: [], parameters: [], operators: [], thresholds: []};
        vm.page = 0; vm.checks = []; vm.alerts = []; vm.schedules = {items: [], analyses: []};
        vm.labels = {TO_DO:'À faire', IN_PROGRESS:'En cours', VALIDATED:'Validé', CANCELLED:'Annulé', FIELD:'Terrain', LAB:'Laboratoire', EQ:'=', LT:'<', LE:'≤', GT:'>', GE:'≥', TEXT:'Texte', IN_LIMITS:'Dans les limites', OUT_OF_LIMITS:'Hors limites', NOT_EVALUABLE:'Non évaluable', OVERDUE:'Résultat en retard', PHOTO:'Photo', DOCUMENT:'Justificatif', LAB_REPORT:'Rapport laboratoire', DAYS:'jour(s)', WEEKS:'semaine(s)', MONTHS:'mois', YEARS:'an(s)'};
        vm.statusFilter = vm.section === 'planning' ? 'TO_DO' : 'IN_PROGRESS';
        function uuid() { var b = new $window.Uint8Array(16); $window.crypto.getRandomValues(b); b[6]=(b[6]&15)|64; b[8]=(b[8]&63)|128; return Array.prototype.map.call(b,function (v,i) { return ([4,6,8,10].indexOf(i)>=0?'-':'')+('0'+v.toString(16)).slice(-2); }).join(''); }
        function minute() { var d = new Date(); d.setSeconds(0,0); return d; }
        function dateOnly(d) { if (!d) { return null; } if (typeof d === 'string') { return d.slice(0,10); } return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
        function dateInput(d) { return d ? new Date(String(d).slice(0,10)+'T12:00:00') : null; }
        function request(method,path,body,params) { return $http({method:method,url:root+path,data:body,params:params}).then(function (r) { return r.data; }); }
        function get(path,params) { return request('GET',path,null,params); }
        function post(path,body) { return request('POST',path,body); }
        function put(path,body) { return request('PUT',path,body); }
        function failed(r) { vm.error = r && r.data && r.data.message || 'L’opération a échoué. Vérifiez la connexion et réessayez.'; }
        function run(action) { if (vm.busy) { return; } vm.busy=true; vm.error=null; vm.success=null; return $q.when().then(action).catch(failed).finally(function () { vm.busy=false; }); }
        vm.areaLabel = function (id) { var a=vm.meta.areas.filter(function (x) { return x.id===id; })[0]; return a ? a.label : ''; };
        vm.locationFor = function (id) { return vm.meta.locations.filter(function (x) { return x.id===id; })[0] || {}; };
        vm.parameterFor = function (id) { return vm.meta.parameters.filter(function (x) { return x.id===id; })[0] || {}; };
        vm.operators = function (locationId,effective) { var area=vm.locationFor(locationId).areaId; return vm.meta.operators.filter(function (o) { return o.areaIds.indexOf(area)>=0 && (!effective || vm.admin || o.id===vm.meta.actorId); }); };
        vm.activeLocations = function () { return vm.meta.locations.filter(function (x) { return x.active; }); };
        vm.activeParameters = function () { return vm.meta.parameters.filter(function (x) { return x.active; }); };
        vm.resultFor = function (line) { return vm.detail.results.filter(function (x) { return x.id===line.currentResultId; })[0]; };
        vm.dispatchFor = function (id) { return vm.detail.dispatches.filter(function (x) { return x.id===id; })[0]; };
        vm.missingCount = function () { return vm.detail ? vm.detail.analyses.filter(function (x) { return !x.currentResultId; }).length : 0; };
        vm.controlSteps = ['Planification', 'Prélèvement', 'Résultats', 'Validation'];
        // Repère visuel calculé depuis la fiche enregistrée, y compris après une réouverture.
        vm.progressStep = function () {
            if (!vm.detail) { return 0; }
            if (vm.detail.check.status === 'VALIDATED') { return 4; }
            if (!vm.detail.check.sampledAt) { return 1; }
            return vm.missingCount() ? 2 : 3;
        };
        vm.unassignedLabCount = function () { return vm.detail ? vm.detail.analyses.filter(function (x) { return x.source==='LAB' && !x.dispatchId; }).length : 0; };
        vm.editable = function () { return vm.canEdit && vm.detail && ['TO_DO','IN_PROGRESS'].indexOf(vm.detail.check.status)>=0; };
        vm.lines = function (source) { return vm.detail.analyses.filter(function (a) { return a.source===source; }); };
        vm.currentThresholds = function () { var seen={}; return vm.meta.thresholds.filter(function (t) { var key=t.parameterId+':'+t.locationId; if (seen[key]) { return false; } seen[key]=true; return t.active; }); };
        vm.isCurrentThreshold = function (threshold) { return vm.currentThresholds().some(function (t) { return t.id===threshold.id; }); };
        vm.thresholdHistory = function (t) { return vm.meta.thresholds.filter(function (x) { return x.parameterId===t.parameterId && x.locationId===t.locationId; }); };
        function loadMetadata() { return get('metadata').then(function (data) { vm.meta=data; }); }
        function loadChecks() { return get('checks',{page:vm.page,size:25,status:vm.statusFilter || undefined}).then(function (data) { vm.checks=data; }); }
        function loadAlerts() { return get('alerts',{page:vm.page,size:25,includeResolved:!!vm.includeResolved}).then(function (data) { vm.alerts=data; }); }
        function loadSchedules() { return get('schedules').then(function (data) { vm.schedules=data; }); }
        function detail(id,savedLine) {
            return get('checks/'+id).then(function (data) {
                var previous=vm.detail && vm.detail.check.id===data.check.id ? vm.detail.analyses : [];
                vm.detail=data;
                if (['VALIDATED','CANCELLED'].indexOf(data.check.status)>=0) { vm.lab=null; vm.planning=null; }
                data.analyses.forEach(function (line) {
                    var old=previous.filter(function (x) { return x.id===line.id && x.id!==savedLine; })[0];
                    if (old) { line.edit=old.edit; line.pending=old.pending; line.showEditor=old.showEditor; }
                });
                vm.sampling={version:data.check.version,operatorId:vm.meta.actorId,sampledAt:minute()};
                vm.uploadForm={kind:'PHOTO'}; vm.file=null; vm.pendingUpload=null;
            });
        }
        function loadSection() {
            if (vm.section==='detail') { return detail($stateParams.checkId); }
            if (vm.section==='planning' || vm.section==='records') { return loadChecks(); }
            if (vm.section==='alerts') { return loadAlerts(); }
            if (vm.section==='schedules') { return loadSchedules(); }
            return $q.when();
        }
        vm.refresh = function () { return run(function () { return loadMetadata().then(loadSection); }); };
        vm.filterChanged = function () { vm.page=0; vm.refresh(); };
        vm.pageBy = function (delta) { vm.page+=delta; vm.refresh(); };
        vm.open = function (id) { $state.go('water-quality-check',{checkId:id}); };
        vm.newPlan = function () { vm.draft={plannedDate:new Date(),analyses:[{source:'FIELD'}]}; vm.showPlan=true; vm.pendingPlan=null; };
        vm.savePlan = function () { return run(function () {
            if (!vm.pendingPlan) { vm.pendingPlan=angular.copy(vm.draft); vm.pendingPlan.plannedDate=dateOnly(vm.draft.plannedDate); vm.pendingPlan.operationUuid=uuid(); }
            return post('checks',vm.pendingPlan).then(function (data) { vm.pendingPlan=null; vm.open(data.id); }).catch(function (r) { if (r.status===400 || r.status===403) { vm.pendingPlan=null; } return $q.reject(r); });
        }); };
        vm.editPlanning = function () { vm.planning=angular.copy(vm.detail.check); vm.planning.plannedDate=dateInput(vm.planning.plannedDate); };
        vm.savePlanning = function () { return run(function () { var body=angular.copy(vm.planning); body.plannedDate=dateOnly(body.plannedDate); return put('checks/'+vm.detail.check.id+'/planning',body).then(function () { vm.planning=null; return detail(vm.detail.check.id); }); }); };
        vm.sample = function () { return run(function () { return post('checks/'+vm.detail.check.id+'/sampling',vm.sampling).then(function () { return detail(vm.detail.check.id); }); }); };
        vm.setStatus = function (status) { return run(function () { return put('checks/'+vm.detail.check.id+'/status',{version:vm.detail.check.version,status:status}).then(function () { return detail(vm.detail.check.id); }); }); };
        vm.editResult = function (line) { var result=vm.resultFor(line); line.showEditor=true; line.edit=result ? {value:result.value,textValue:result.textValue,qualifier:result.qualifier,measuredAt:new Date(result.measuredAt),unit:line.unit} : {qualifier:line.numeric?'EQ':'TEXT',measuredAt:new Date(vm.detail.check.sampledAt),unit:line.unit}; };
        vm.saveResult = function (line) { return run(function () {
            if (!line.pending) { line.pending=angular.copy(line.edit); line.pending.operationUuid=uuid(); line.pending.previousResultId=line.currentResultId; }
            return post('checks/'+vm.detail.check.id+'/analyses/'+line.id+'/results',line.pending).then(function () { return detail(vm.detail.check.id,line.id); }).catch(function (r) { if (r.status===400 || r.status===403) { line.pending=null; } return $q.reject(r); });
        }); };
        vm.addAnalysis = function () { return run(function () {
            if (!vm.pendingAnalysis) { vm.pendingAnalysis={operationUuid:uuid(),analyses:[angular.copy(vm.extraAnalysis)]}; }
            return post('checks/'+vm.detail.check.id+'/analyses',vm.pendingAnalysis).then(function () { vm.extraAnalysis=null;vm.pendingAnalysis=null;return detail(vm.detail.check.id); }).catch(function (r) { if (r.status===400 || r.status===403) { vm.pendingAnalysis=null; } return $q.reject(r); });
        }); };
        vm.deleteAnalysis = function (line) { if (!$window.confirm('Retirer ce paramètre attendu de la fiche ?')) { return; } return run(function () { return request('DELETE','checks/'+vm.detail.check.id+'/analyses/'+line.id,null,{version:line.version}).then(function () { return detail(vm.detail.check.id); }); }); };
        vm.editLab = function (dispatch) {
            vm.lab=dispatch ? angular.copy(dispatch) : {sentAt:minute(),expectedAt:new Date(Date.now()+7*86400000)};
            vm.lab.sentAt=new Date(vm.lab.sentAt); vm.lab.expectedAt=new Date(vm.lab.expectedAt);vm.labSelection={};vm.pendingLab=null;
            vm.lines('LAB').forEach(function (a) { if (dispatch && a.dispatchId===dispatch.id) { vm.labSelection[a.id]=true; } });
        };
        vm.labCandidates = function () { return vm.lines('LAB').filter(function (a) { return !a.dispatchId || vm.lab && a.dispatchId===vm.lab.id; }); };
        vm.saveLab = function () { return run(function () {
            if (!vm.pendingLab) { vm.pendingLab=angular.copy(vm.lab);vm.pendingLab.operationUuid=uuid();vm.pendingLab.clientKey=vm.pendingLab.operationUuid;vm.pendingLab.analysisIds=Object.keys(vm.labSelection).filter(function (id) { return vm.labSelection[id]; }).map(Number); }
            return request(vm.lab.id?'PUT':'POST','checks/'+vm.detail.check.id+'/dispatches'+(vm.lab.id?'/'+vm.lab.id:''),vm.pendingLab).then(function () { vm.lab=null;vm.pendingLab=null;return detail(vm.detail.check.id); }).catch(function (r) { if (r.status===400 || r.status===403) { vm.pendingLab=null; } return $q.reject(r); });
        }); };
        vm.editLocation = function (location) { vm.location=location ? angular.copy(location) : {areaId:vm.meta.currentAreaId,active:true}; };
        vm.editParameter = function (parameter) { vm.parameter=parameter ? angular.copy(parameter) : {numeric:true,active:true}; };
        vm.saveLocation = function () { return run(function () { return request(vm.location.id?'PUT':'POST','locations'+(vm.location.id?'/'+vm.location.id:''),vm.location).then(function () { vm.location=null;return loadMetadata(); }); }); };
        vm.saveParameter = function () { return run(function () { return request(vm.parameter.id?'PUT':'POST','parameters'+(vm.parameter.id?'/'+vm.parameter.id:''),vm.parameter).then(function () { vm.parameter=null;return loadMetadata(); }); }); };
        vm.deleteReference = function (kind,value) { if (!$window.confirm('Supprimer « '+value.label+' » des nouvelles saisies et arrêter les récurrences associées ? Les historiques seront conservés.')) { return; } return run(function () { return request('DELETE',kind+'/'+value.id,null,{version:value.version}).then(loadMetadata); }); };
        vm.editThreshold = function (t) { vm.threshold=t ? angular.copy(t) : {}; };
        vm.saveThreshold = function () { return run(function () { return request(vm.threshold.id?'PUT':'POST',vm.threshold.id?'thresholds/'+vm.threshold.id:'parameters/'+vm.threshold.parameterId+'/thresholds',vm.threshold).then(function () { vm.threshold=null;return loadMetadata(); }); }); };
        vm.deleteThreshold = function (t) { if (!$window.confirm('Supprimer ce seuil pour les prochains prélèvements ? Les évaluations déjà réalisées seront conservées.')) { return; } return run(function () { return request('DELETE','thresholds/'+t.id).then(loadMetadata); }); };
        vm.editSchedule = function (s) {
            vm.schedule=s ? angular.copy(s) : {startDate:new Date(),intervalCount:1,frequency:'MONTHS',analyses:[{source:'FIELD'}]};
            vm.schedule.startDate=s ? dateInput(s.startDate) : new Date();vm.schedule.endDate=s ? dateInput(s.endDate) : null;
            if (s) { vm.schedule.analyses=vm.schedules.analyses.filter(function (a) { return a.scheduleId===s.id; }).map(function (a) { return {parameterId:a.parameterId,source:a.source}; }); }
            vm.pendingSchedule=null;
        };
        vm.scheduleState = function (s) { return !s.active ? 'Arrêtée' : s.endDate && dateOnly(new Date())>s.endDate ? 'Terminée' : 'Active'; };
        vm.saveSchedule = function () { return run(function () {
            if (!vm.pendingSchedule) { vm.pendingSchedule=angular.copy(vm.schedule);vm.pendingSchedule.startDate=dateOnly(vm.schedule.startDate);vm.pendingSchedule.endDate=dateOnly(vm.schedule.endDate);vm.pendingSchedule.operationUuid=uuid(); }
            return request(vm.schedule.id?'PUT':'POST','schedules'+(vm.schedule.id?'/'+vm.schedule.id:''),vm.pendingSchedule).then(function () { vm.schedule=null;vm.pendingSchedule=null;return loadSchedules(); }).catch(function (r) { if (r.status===400 || r.status===403) { vm.pendingSchedule=null; } return $q.reject(r); });
        }); };
        vm.deleteSchedule = function (s) { if (!$window.confirm('Arrêter cette récurrence et annuler ses occurrences futures non commencées ?')) { return; } return run(function () { return request('DELETE','schedules/'+s.id,null,{version:s.version}).then(loadSchedules); }); };
        vm.fileSelected = function (file) { vm.file=file; };
        vm.upload = function () { return run(function () {
            var read=$q.defer();
            if (vm.pendingUpload) { read.resolve(vm.pendingUpload); }
            else if (!vm.file || vm.file.size>(vm.uploadForm.kind==='PHOTO'?10:20)*1024*1024) { read.reject({data:{message:'Choisissez une photo de 10 Mo maximum ou un document de 20 Mo maximum.'}}); }
            else { var reader=new $window.FileReader();reader.onload=function () { vm.pendingUpload=angular.extend({},vm.uploadForm,{uploadUuid:uuid(),fileName:vm.file.name,contentBase64:String(reader.result).split(',')[1]});read.resolve(vm.pendingUpload); };reader.onerror=function () { read.reject({data:{message:'Le fichier ne peut pas être lu.'}}); };reader.readAsDataURL(vm.file); }
            return read.promise.then(function (body) { return post('checks/'+vm.detail.check.id+'/attachments',body); }).then(function () { return detail(vm.detail.check.id); }).catch(function (r) { if (r.status===400 || r.status===403) { vm.pendingUpload=null; }return $q.reject(r); });
        }); };
        vm.download = function (file) { return run(function () { return $http.get(root+'checks/'+vm.detail.check.id+'/attachments/'+file.id,{responseType:'arraybuffer'}).then(function (r) { var url=$window.URL.createObjectURL(new $window.Blob([r.data],{type:file.contentType})),a=$window.document.createElement('a');a.href=url;a.download=file.fileName;$window.document.body.appendChild(a);a.click();a.remove();$window.setTimeout(function () { $window.URL.revokeObjectURL(url); },1000); }); }); };
        Principal.identity().then(function (account) {
            vm.admin=account.authorities.some(function (r) { return r==='ROLE_ADMIN' || r==='ROLE_SUPER_ADMIN'; });vm.canEdit=vm.admin || account.authorities.indexOf('ROLE_WATER_QUALITY_EDIT')>=0;vm.moduleDisabled=(account.modules||[]).indexOf('WATER_QUALITY')<0;
            if (vm.moduleDisabled) { return; }
            if ($stateParams.checkId && vm.section!=='detail') { vm.open($stateParams.checkId); return; }
            return run(function () { return loadMetadata().then(loadSection); });
        }).catch(failed);
    }
    angular.module('wamasysApp').directive('waterQualityFile',['$parse',function ($parse) { return {restrict:'A',link:function (scope,element,attrs) { function changed(event) { var file=event.target.files[0];scope.$apply(function () { $parse(attrs.waterQualityFile)(scope,{file:file}); }); }element.on('change',changed);scope.$on('$destroy',function () { element.off('change',changed); }); }}; }]);
    // Le contour affiché vient toujours de l’AREA du lieu en cours d’édition.
    angular.module('wamasysApp').component('waterQualityPosition', {
        bindings:{model:'=',areas:'<'},
        template:'<map-leaflet contrat="$ctrl.position" geometry="$ctrl.geometry" refresh-token="$ctrl.model.areaId" height="350px" width="100%"></map-leaflet>',
        controller:['$scope',function ($scope) { var ctrl=this;ctrl.position={};ctrl.$onInit=function () {
            $scope.$watchGroup(['$ctrl.model.latitude','$ctrl.model.longitude'],function (v) { ctrl.position.lat=v[0];ctrl.position.lon=v[1]; });
            $scope.$watchGroup(['$ctrl.position.lat','$ctrl.position.lon'],function (v) { if (v[0]!==undefined && v[1]!==undefined) { ctrl.model.latitude=v[0];ctrl.model.longitude=v[1]; } });
            $scope.$watch('$ctrl.model.areaId',function (id) { var area=(ctrl.areas||[]).filter(function (a) { return a.id===id; })[0];ctrl.geometry=area ? area.geometry : null; });
        }; }]
    });
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeAvoirController', TypeAvoirController);

    TypeAvoirController.$inject = ['$scope', '$state', 'TypeAvoir', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TypeAvoirController ($scope, $state, TypeAvoir, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            TypeAvoir.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.typeAvoirs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('type-avoir', {
            parent: 'entity',
            url: '/type-avoir?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.typeAvoir.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-avoir/type-avoirs.html',
                    controller: 'TypeAvoirController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeAvoir');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('type-avoir-detail', {
            parent: 'entity',
            url: '/type-avoir/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.typeAvoir.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-avoir/type-avoir-detail.html',
                    controller: 'TypeAvoirDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeAvoir');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TypeAvoir', function($stateParams, TypeAvoir) {
                    return TypeAvoir.get({id : $stateParams.id});
                }]
            }
        })
        .state('type-avoir.new', {
            parent: 'type-avoir',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-avoir/type-avoir-dialog.html',
                    controller: 'TypeAvoirDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('type-avoir', null, { reload: true });
                }, function() {
                    $state.go('type-avoir');
                });
            }]
        })
        .state('type-avoir.edit', {
            parent: 'type-avoir',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-avoir/type-avoir-dialog.html',
                    controller: 'TypeAvoirDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TypeAvoir', function(TypeAvoir) {
                            return TypeAvoir.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-avoir', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-avoir.delete', {
            parent: 'type-avoir',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-avoir/type-avoir-delete-dialog.html',
                    controller: 'TypeAvoirDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TypeAvoir', function(TypeAvoir) {
                            return TypeAvoir.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-avoir', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('TypeAvoir', TypeAvoir);

    TypeAvoir.$inject = ['$resource'];

    function TypeAvoir ($resource) {
        var resourceUrl =  'api/type-avoirs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeAvoirDialogController', TypeAvoirDialogController);

    TypeAvoirDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeAvoir'];

    function TypeAvoirDialogController ($scope, $stateParams, $uibModalInstance, entity, TypeAvoir) {
        var vm = this;
        vm.typeAvoir = entity;
        vm.load = function(id) {
            TypeAvoir.get({id : id}, function(result) {
                vm.typeAvoir = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:typeAvoirUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.typeAvoir.id !== null) {
                TypeAvoir.update(vm.typeAvoir, onSaveSuccess, onSaveError);
            } else {
                TypeAvoir.save(vm.typeAvoir, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeAvoirDetailController', TypeAvoirDetailController);

    TypeAvoirDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TypeAvoir'];

    function TypeAvoirDetailController($scope, $rootScope, $stateParams, entity, TypeAvoir) {
        var vm = this;
        vm.typeAvoir = entity;
        vm.load = function (id) {
            TypeAvoir.get({id: id}, function(result) {
                vm.typeAvoir = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:typeAvoirUpdate', function(event, result) {
            vm.typeAvoir = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeAvoirDeleteController',TypeAvoirDeleteController);

    TypeAvoirDeleteController.$inject = ['$uibModalInstance', 'entity', 'TypeAvoir'];

    function TypeAvoirDeleteController($uibModalInstance, entity, TypeAvoir) {
        var vm = this;
        vm.typeAvoir = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TypeAvoir.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('water-network', {
            parent: 'entity',
            url: '/water-network?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.waterNetwork.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/water-network/water-networks.html',
                    controller: 'WaterNetworkController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('waterNetwork');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('water-network-detail', {
            parent: 'entity',
            url: '/water-network/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.waterNetwork.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/water-network/water-network-detail.html',
                    controller: 'WaterNetworkDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('waterNetwork');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'WaterNetwork', function($stateParams, WaterNetwork) {
                    return WaterNetwork.get({id : $stateParams.id});
                }]
            }
        })
        .state('water-network.new', {
            parent: 'water-network',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/water-network/water-network-dialog.html',
                    controller: 'WaterNetworkDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('water-network', null, { reload: true });
                }, function() {
                    $state.go('water-network');
                });
            }]
        })
        .state('water-network.edit', {
            parent: 'water-network',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/water-network/water-network-dialog.html',
                    controller: 'WaterNetworkDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['WaterNetwork', function(WaterNetwork) {
                            return WaterNetwork.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('water-network', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('water-network.delete', {
            parent: 'water-network',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/water-network/water-network-delete-dialog.html',
                    controller: 'WaterNetworkDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['WaterNetwork', function(WaterNetwork) {
                            return WaterNetwork.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('water-network', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('WaterNetwork', WaterNetwork);

    WaterNetwork.$inject = ['$resource'];

    function WaterNetwork ($resource) {
        var resourceUrl =  'api/water-network/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'queryFilterArea': {
                method: 'GET',
                isArray: true,
                params: {areaFilter:true}
            },
            
            
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('WaterNetworkController', WaterNetworkController);

    WaterNetworkController.$inject = ['$scope', '$state', 'WaterNetwork', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function WaterNetworkController ($scope, $state, WaterNetwork, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            WaterNetwork.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.waterNetworks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('WaterNetworkDialogController', WaterNetworkDialogController);

    WaterNetworkDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'WaterNetwork'];

    function WaterNetworkDialogController ($scope, $stateParams, $uibModalInstance, entity, WaterNetwork) {
        var vm = this;
        vm.waterNetwork = entity;
        vm.load = function(id) {
            WaterNetwork.get({id : id}, function(result) {
                vm.waterNetwork = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:waterNetworkUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.waterNetwork.id !== null) {
                WaterNetwork.update(vm.waterNetwork, onSaveSuccess, onSaveError);
            } else {
                WaterNetwork.save(vm.waterNetwork, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('WaterNetworkDetailController', WaterNetworkDetailController);

    WaterNetworkDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'WaterNetwork'];

    function WaterNetworkDetailController($scope, $rootScope, $stateParams, entity, WaterNetwork) {
        var vm = this;
        vm.waterNetwork = entity;
        vm.load = function (id) {
            WaterNetwork.get({id: id}, function(result) {
                vm.waterNetwork = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:waterNetworkUpdate', function(event, result) {
            vm.waterNetwork = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('WaterNetworkDeleteController',WaterNetworkDeleteController);

    WaterNetworkDeleteController.$inject = ['$uibModalInstance', 'entity', 'WaterNetwork'];

    function WaterNetworkDeleteController($uibModalInstance, entity, WaterNetwork) {
        var vm = this;
        vm.waterNetwork = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            WaterNetwork.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').factory('TicketMarkdownCodec', function () {
        function escaped(text) { return text.replace(/([\\`*_{}\[\]<>#])/g, '\\$1'); }
        function inline(node) { return Array.prototype.map.call(node.childNodes, read).join(''); }
        function read(node) {
            if (node.nodeType === 3) { return escaped(node.nodeValue.replace(/\u00a0/g, ' ')); }
            if (node.nodeType !== 1) { return ''; }
            var tag = node.tagName.toLowerCase(), content = inline(node);
            if (/^(script|style|iframe|object|svg|form|input|button)$/.test(tag)) { return ''; }
            if (tag === 'br') { return '\n'; }
            if (tag === 'b' || tag === 'strong') { return '**' + content + '**'; }
            if (tag === 'i' || tag === 'em') { return '*' + content + '*'; }
            if (tag === 'code' && node.parentNode.tagName.toLowerCase() !== 'pre') { return '`' + node.textContent.replace(/`/g, '') + '`'; }
            if (tag === 'pre') { return '\n\n```\n' + node.textContent.replace(/```/g, '~~~') + '\n```\n\n'; }
            if (/^h[1-6]$/.test(tag)) { return '\n\n' + new Array(Number(tag[1]) + 1).join('#') + ' ' + content.trim() + '\n\n'; }
            if (tag === 'blockquote') { return '\n\n' + content.trim().split('\n').map(function (line) { return '> ' + line; }).join('\n') + '\n\n'; }
            if (tag === 'a') {
                var href = node.getAttribute('href') || '';
                return /^(https?:\/\/|mailto:)/i.test(href) ? '[' + content + '](' + href.replace(/[()\s]/g, encodeURIComponent) + ')' : content;
            }
            if (tag === 'img') {
                var id = node.getAttribute('data-ticket-image'), src = node.getAttribute('src') || '', match = /^\/?api\/native-tickets\/images\/(\d+)$/.exec(src);
                if (!id && match) { id = match[1]; }
                return id && /^\d+$/.test(id) ? '![' + escaped(node.getAttribute('alt') || 'Image') + '](/api/native-tickets/images/' + id + ')' : '';
            }
            if (tag === 'ul' || tag === 'ol') {
                var index = 0;
                return '\n\n' + Array.prototype.filter.call(node.children, function (child) { return child.tagName.toLowerCase() === 'li'; }).map(function (child) {
                    index++; var value = inline(child).trim();
                    return (tag === 'ol' ? index + '. ' : '- ') + value.replace(/\n/g, '\n    ');
                }).join('\n') + '\n\n';
            }
            if (tag === 'table') {
                var rows = Array.prototype.map.call(node.querySelectorAll('tr'), function (row) { return Array.prototype.map.call(row.children, function (cell) { return inline(cell).trim().replace(/\|/g, '\\|').replace(/\n/g, ' '); }); });
                if (!rows.length) { return ''; }
                rows.splice(1, 0, rows[0].map(function () { return '---'; }));
                return '\n\n' + rows.map(function (row) { return '| ' + row.join(' | ') + ' |'; }).join('\n') + '\n\n';
            }
            if (tag === 'p' || tag === 'div') { return '\n\n' + content + '\n\n'; }
            if (tag === 'hr') { return '\n\n---\n\n'; }
            return content;
        }
        function fromHtml(html) {
            var document = new DOMParser().parseFromString(html, 'text/html');
            return inline(document.body).replace(/\n{3,}/g, '\n\n').trim();
        }
        return {fromHtml: fromHtml};
    });
    // Les images privées passent par $http pour bénéficier de l’authentification Wama.
    angular.module('wamasysApp').directive('ticketImages', ['$http', function ($http) {
        return {restrict: 'A', link: function (scope, element) {
            var urls = [], stopped = false;
            function load() {
                Array.prototype.forEach.call(element[0].querySelectorAll('img'), function (img) {
                    var match = /^\/?api\/native-tickets\/images\/(\d+)$/.exec(img.getAttribute('src') || '');
                    if (!match || img.getAttribute('data-image-loading')) { return; }
                    img.setAttribute('data-ticket-image', match[1]); img.setAttribute('data-image-loading', 'true');
                    $http.get('api/native-tickets/images/' + match[1], {responseType: 'blob'}).then(function (response) {
                        if (stopped) { return; } var url = URL.createObjectURL(response.data); urls.push(url); img.src = url;
                    }, function () { if (!stopped) { img.removeAttribute('src'); img.alt = 'Image indisponible ou accès refusé'; } });
                });
            }
            var observer = new MutationObserver(load); observer.observe(element[0], {childList: true, subtree: true}); load();
            scope.$on('$destroy', function () { stopped = true; observer.disconnect(); urls.forEach(function (url) { URL.revokeObjectURL(url); }); });
        }};
    }]);
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').directive('ticketFilePicker', ['$parse', function ($parse) {
        return {restrict:'A', link:function (scope, element, attrs) {
            var callback = $parse(attrs.ticketFilePicker);
            function changed() { var files = Array.prototype.slice.call(element[0].files || []);scope.$evalAsync(function () { callback(scope, {files:files}); });element[0].value = ''; }
            element.on('change', changed);scope.$on('$destroy', function () { element.off('change', changed); });
        }};
    }]);
    angular.module('wamasysApp').directive('ticketEditor', ticketEditor);
    ticketEditor.$inject = ['$timeout', '$sanitize', '$q', 'NativeTicketApi', 'TicketMarkdownCodec'];
    function ticketEditor($timeout, $sanitize, $q, api, codec) {
        return {restrict: 'E', require: 'ngModel', scope: {ticketId: '=?', draftKey: '=', busy: '='},
            templateUrl: 'app/business/teamwork/ticket-editor.html',
            link: function (scope, element, attrs, model) {
                var visual = element[0].querySelector('[contenteditable]'), source = element[0].querySelector('textarea'), file = element[0].querySelector('input[type=file]');
                var range = null, timer = null, revision = 0, destroyed = false;
                scope.mode = 'visual'; scope.busy = false;
                model.$render = function () { scope.raw = model.$viewValue || ''; if (scope.mode === 'visual') { render(); } };
                function render() { var current = ++revision; api.preview(scope.raw).then(function (result) { if (!destroyed && current === revision) { visual.innerHTML = $sanitize(result.html); } }, failed); }
                function update() { scope.raw = codec.fromHtml(visual.innerHTML); scope.$evalAsync(function () { model.$setViewValue(scope.raw); }); }
                function remember() { var selection = window.getSelection(); if (selection.rangeCount && visual.contains(selection.anchorNode)) { range = selection.getRangeAt(0).cloneRange(); } }
                function restore() { visual.focus(); if (range && visual.contains(range.commonAncestorContainer)) { var selection = window.getSelection(); selection.removeAllRanges(); selection.addRange(range); } }
                function insert(html) { restore(); document.execCommand('insertHTML', false, html); remember(); update(); }
                function failed(error) { scope.error = error && error.data && error.data.message || 'Le texte ou l’image n’a pas pu être chargé.'; }
                scope.switchMode = function (mode) { if (scope.busy || scope.mode === mode) { return; } if (scope.mode === 'visual') { update(); } scope.mode = mode; if (mode === 'visual') { render(); } };
                scope.rawChanged = function () { model.$setViewValue(scope.raw); };
                scope.format = function (command, value) {
                    scope.error = null;
                    if (scope.mode === 'markdown') {
                        var start = source.selectionStart, end = source.selectionEnd, selected = scope.raw.slice(start, end), before = '', after = '';
                        if (command === 'bold') { before = '**'; after = '**'; }
                        else if (command === 'italic') { before = '*'; after = '*'; }
                        else if (command === 'formatBlock') { before = value === 'h2' ? '## ' : '> '; }
                        else if (command === 'insertUnorderedList') { before = '- '; }
                        else if (command === 'insertOrderedList') { before = '1. '; }
                        else if (command === 'createLink') { before = '['; after = '](https://)'; }
                        scope.raw = scope.raw.slice(0, start) + before + selected + after + scope.raw.slice(end); model.$setViewValue(scope.raw); source.focus(); return;
                    }
                    restore();
                    if (command === 'createLink') { value = window.prompt('Adresse du lien (https://…)'); if (!value || !/^https?:\/\//i.test(value)) { return; } }
                    document.execCommand(command, false, value || null); remember(); update();
                };
                function upload(blob) {
                    if (!blob || !/^image\/(png|jpeg)$/.test(blob.type) || blob.size > 10 * 1024 * 1024) { return $q.reject({data: {message: 'Choisissez une image JPEG ou PNG de 10 Mo maximum.'}}); }
                    var deferred = $q.defer(), reader = new FileReader();
                    reader.onload = function () { api.post('images', {ticketId: scope.ticketId || null, draftKey: scope.draftKey, fileName: blob.name || 'image.jpg', contentBase64: reader.result.split(',')[1]}).then(deferred.resolve, deferred.reject); };
                    reader.onerror = function () { deferred.reject({data: {message: 'L’image ne peut pas être lue.'}}); }; reader.readAsDataURL(blob); return deferred.promise;
                }
                function addImages(blobs) {
                    scope.busy = true; scope.error = null; var chain = $q.when();
                    blobs.forEach(function (blob) { chain = chain.then(function () { return upload(blob); }).then(function (image) {
                        if (destroyed) { return; }
                        if (scope.mode === 'markdown') { var position = source.selectionStart; scope.raw = scope.raw.slice(0, position) + '\n![Image](/api/native-tickets/images/' + image.id + ')\n' + scope.raw.slice(position); model.$setViewValue(scope.raw); }
                        else { insert('<img alt="Image" src="/api/native-tickets/images/' + image.id + '" data-ticket-image="' + image.id + '"><br>'); }
                    }); });
                    chain.catch(failed).finally(function () { scope.busy = false; file.value = ''; });
                }
                scope.chooseImage = function () { remember(); file.click(); };
                function fileChanged() { var blobs = Array.prototype.slice.call(file.files || []); scope.$evalAsync(function () { addImages(blobs); }); }
                function paste(event) {
                    var clipboard = (event.originalEvent || event).clipboardData; if (!clipboard) { return; }
                    var blobs = []; Array.prototype.forEach.call(clipboard.items || [], function (item) { if (item.kind === 'file' && /^image\//.test(item.type)) { blobs.push(item.getAsFile()); } });
                    if (blobs.length) { event.preventDefault(); remember(); scope.$evalAsync(function () { addImages(blobs); }); return; }
                    if (scope.mode === 'visual') {
                        event.preventDefault();remember();var html = clipboard.getData('text/html'), text = clipboard.getData('text/plain');
                        if (html) { scope.busy = true;api.preview(codec.fromHtml(html)).then(function (result) { insert($sanitize(result.html)); }, failed).finally(function () { scope.busy = false; }); }
                        else { restore();document.execCommand('insertText', false, text);update(); }
                    }
                }
                angular.element(visual).on('input', update).on('mouseup keyup blur', remember).on('paste', paste);
                angular.element(source).on('paste', paste);angular.element(file).on('change', fileChanged);
                scope.$on('$destroy', function () { destroyed = true;revision++;if (timer) { $timeout.cancel(timer); }angular.element(visual).off('input', update).off('mouseup keyup blur', remember).off('paste', paste);angular.element(source).off('paste', paste);angular.element(file).off('change', fileChanged); });
            }};
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('teamwork', {
            parent: 'app',
            url: '/teamwork?page&issuefilter',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/teamwork/teamwork.html',
                    controller: 'TeamworkController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                issuefilter: {
                    value: 'myissues',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        issuefilter: $stateParams.issuefilter,
         
                        search: $stateParams.search
                    };
                }],
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('login');
                    $translatePartialLoader.addPart('redmine');
                    return $translate.refresh();
                }]
            }
        })
        .state('teamwork.new_issue', {
            parent: 'teamwork',
            url: '/new_issue',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/teamwork/redmine-createticket-dialog.controller.html',
                    controller: 'RedmineCreateTicketController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nom: null,
                                codeAgence: null,
                                devise: null,
                                enteteFacture: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('teamwork', null, { reload: true });
                }, function() {
                    $state.go('teamwork');
                });
            }]
        });
        
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TeamworkController', TeamworkController);

    TeamworkController.$inject = ['$rootScope', '$state', '$timeout', 'Auth','$scope', 'Principal', 'LoginService','RedmineService','pagingParams','paginationConstants','ParseLinks'];

    function TeamworkController ($rootScope,$state, $timeout, Auth,$scope, Principal, LoginService,RedmineService,pagingParams, paginationConstants,ParseLinks) {
        var vm = this;

        
        vm.user = {} ;
        Principal.identity().then(function(account) {
        	if(account){
              vm.user =account ;
        	}
        });
        
        vm.transition = transition;
        vm.loadAll = loadAll;

        

        vm.loadAll();
        
        function loadAll() {
        	vm.issuefilter = pagingParams.issuefilter;
        	if(pagingParams.issuefilter == 'myissues'){
        		vm.indextab = 0;
        		 RedmineService.myIssues({
 	                page: pagingParams.page - 1,
 	                size: paginationConstants.itemsPerPage}, onSuccess, onError);
        	}else  if(pagingParams.issuefilter == 'createdbyme'){
        		vm.indextab = 2;
	            RedmineService.issuesCreatedByMe({
	                page: pagingParams.page - 1,
	                size: paginationConstants.itemsPerPage}, onSuccess, onError);	
        	}else  if(pagingParams.issuefilter == 'notassigned'){
        		vm.indextab = 1;
                RedmineService.issuesNotAssigned({
	                page: pagingParams.page - 1,
	                size: paginationConstants.itemsPerPage}, onSuccess, onError);
        	}
        }
        
        
        vm.issuesCreatedByMe = function () {
        	vm.issuefilter = 'createdbyme';
        	loadPage(1);
        }

        vm.myIssues = function () {
        	vm.issuefilter = 'myissues';
        	loadPage(1);
        }

        vm.issuesNotAssigned = function () {
        	vm.issuefilter = 'notassigned';
        	loadPage(1);
        }
        
        function onSuccess(data, headers) {
//            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = data.total_count;
            vm.queryCount = vm.totalItems;
            vm.listIssues = data;
//            vm.page = pagingParams.offset;
          vm.page = (data.offset/data.limit)+1;
            
        }
        
        function onError(error) {
            AlertService.error(error.data.message);
        }
        
        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }
        
        function transition () {
	        $state.transitionTo($state.$current, {
	            page: vm.page,
	            issuefilter: vm.issuefilter
	        	});
        }
        
        
        
    }
    
})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('RedmineService', RedmineService);

    RedmineService.$inject = ['$resource','DateUtils'];

    function RedmineService ($resource,DateUtils) {
        var resourceUrl =  'api/redmine/';

        return $resource(resourceUrl, {}, {
             'myIssues': {
                 method: 'GET',
                 url :'api/redmine/issues/assigned-to-me'
              },
             'issuesCreatedByMe': {
                 method: 'GET',
                 url :'api/redmine/issues/created-by-me'
              },
             'issuesForContract': {
                 method: 'GET',
                 url :'api/redmine/issues/contract/:contractRef'
              },
              'issuesNotAssigned': {
                  method: 'GET',
                  url :'api/redmine/issues/not-assigned'
               },
               'issuesNotAssignedByArea': {
                   method: 'GET',
                   url :'api/redmine/issues/not-assigned-by-area'
                },
             'createIssue': {
                 method: 'POST',
                 url :'api/redmine/issues'
              }
            		
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('RedmineCreateTicketController', RedmineCreateTicketController);

    RedmineCreateTicketController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'Principal', 'RedmineService','UserSearch'];

    function RedmineCreateTicketController ($scope, $stateParams, $uibModalInstance, Principal, RedmineService,UserSearch) {
        var vm = this;
        vm.RedmineService = {bulkMeter: vm.bulkMeter,isCorrection: true,lastModifiedDate:Date.now() };
        vm.users = UserSearch.searchUserArea({ offset: 0,size: 1000});
        vm.currentAgence ='';
        
        Principal.identity().then(function(account) {
        	if(account.agence){
        		vm.currentAgence = account.agence.nom;
        	}
        });
        
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:redmineUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            
            RedmineService.createIssue(vm.redmineIssue, onSaveSuccess, onSaveError);
          
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateSuppression = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').controller('NativeTicketsController', NativeTicketsController);
    NativeTicketsController.$inject = ['$state', '$stateParams', '$sanitize', '$scope', '$http', 'NativeTicketApi'];
    function NativeTicketsController($state, params, $sanitize, $scope, $http, api) {
        var vm = this;vm.pendingAttachments = [];
        vm.section = 'tickets'; vm.meta = {areas: [], users: [], categories: []}; vm.items = []; vm.filters = {view: 'all', search: '', page: 0};
        vm.labels = {OFFICE_WORK: 'Travail administratif', BUG: 'Anomalie', EVOLUTION: 'Évolution', TECHNICAL_EVOLUTION: 'Évolution technique', ESTIMATE: 'Évolution à chiffrer', ACTION: 'Action', CLIENT_TICKET: 'Demande abonné', CLIENT_FEEDBACK: 'Retour abonné', FIELD_WORK: 'Intervention terrain', NEW: 'Nouveau', VALIDATED: 'Validé', IN_PROGRESS: 'En cours', WAITING: 'En attente', DONE: 'Terminé', NEXT_VERSION: 'Prévu dans la prochaine version', CLOSED: 'Fermé', CANCELLED: 'Annulé', REFUSED: 'Refusé', URGENT: 'Urgente', HIGH: 'Haute', NORMAL: 'Normale', LOW: 'Basse', LOWEST: 'Très basse', DAYS: 'jour(s)', WEEKS: 'semaine(s)', MONTHS: 'mois', YEARS: 'année(s)'};
        vm.label = function (code) { return vm.labels[code] || code; };
        vm.closed = function (status) { return ['CLOSED', 'CANCELLED', 'REFUSED'].indexOf(status) !== -1; };
        vm.name = function (id) { var user = vm.meta.users.filter(function (value) { return value.id === id; })[0]; return user ? user.label : (id ? 'Ancien utilisateur #' + id : 'Non affecté'); };
        vm.areaName = function (id) { var area = vm.meta.areas.filter(function (value) { return value.id === id; })[0]; return area ? area.label : ''; };
        vm.categoryName = function (id) { var category = vm.meta.categories.filter(function (value) { return value.id === id; })[0]; return category ? category.label : ''; };
        function failed(error) { vm.error = error && error.data && error.data.message || 'L’opération n’a pas pu être réalisée. Réessayez.'; }
        function refreshMetadata() { return api.get('metadata').then(function (data) { vm.meta = data; }); }
        vm.load = function () {
            vm.loading = true; vm.error = null;
            var query = angular.copy(vm.filters); if (params.contractId) { query.contractId = params.contractId; }
            return api.get('', query).then(function (data) { vm.items = data.items; vm.total = data.total; }, failed).finally(function () { vm.loading = false; });
        };
        vm.filter = function () { vm.filters.page = 0; vm.load(); };
        vm.page = function (direction) { vm.filters.page += direction; vm.load(); };
        vm.newTicket = function () {
            vm.error = null; vm.notice = null; vm.detail = null; vm.draftKey = api.uuid(); vm.commentDraftKey = vm.draftKey; vm.commentMarkdown = ''; vm.privateNote = false; vm.pendingAttachments = []; vm.editable = true; vm.canClose = true;
            vm.ticket = {operationUuid: api.uuid(), areaId: Number(params.areaId) || (vm.meta.areas[0] && vm.meta.areas[0].id), type: 'FIELD_WORK', status: 'NEW', priority: 'NORMAL', descriptionMarkdown: '', watcherIds: [], doneRatio: 0};
            if (params.contractId) { vm.ticket.contractId = Number(params.contractId); vm.ticket.type = 'CLIENT_TICKET';vm.contractResults = [{id:vm.ticket.contractId,label:'Contrat #'+vm.ticket.contractId}]; }
        };
        vm.open = function (id) {
            vm.error = null; vm.loadingDetail = true;
            return api.get(String(id)).then(function (data) {
                vm.detail = data;vm.ticket = angular.copy(data.ticket);['startDate', 'dueDate'].forEach(function (key) { if (vm.ticket[key]) { vm.ticket[key] = new Date(vm.ticket[key].slice(0, 10) + 'T12:00:00'); } });vm.editable = data.canEdit && !vm.closed(data.ticket.status);vm.canClose = data.canClose;
                vm.draftKey = api.uuid();vm.commentDraftKey = vm.draftKey;vm.commentMarkdown = '';vm.privateNote = false;vm.pendingAttachments = [];vm.contractResults = data.contract ? [data.contract] : [];vm.equipmentResults = data.equipment ? [data.equipment] : [];
                vm.descriptionHtml = $sanitize(data.html);var previous = {};
                var fieldLabels = {subject:'Titre', type:'Type', status:'État', priority:'Priorité', categoryId:'Catégorie', subcategoryId:'Sous-catégorie', assigneeId:'Responsable', doneRatio:'Avancement (%)', startDate:'Début prévu', dueDate:'Échéance', estimatedHours:'Durée estimée (h)', spentHours:'Durée passée (h)', address:'Adresse', latitude:'Latitude', longitude:'Longitude', sector:'Secteur', contractId:'Contrat', equipmentId:'Équipement', parentId:'Ticket parent', resolution:'Conclusion', privateTicket:'Confidentiel'};
                data.history.forEach(function (line) {
                    line.html = $sanitize(line.html);var snapshot = JSON.parse(line.entry.snapshotJson);line.changes = [];
                    angular.forEach(fieldLabels, function (label, field) {
                        if (!angular.equals(previous[field], snapshot[field]) && snapshot[field] !== undefined) {
                            var value = snapshot[field];if (field === 'assigneeId') { value = vm.name(value); }
                            else if (field === 'categoryId' || field === 'subcategoryId') { value = vm.categoryName(value); }
                            else if (field === 'privateTicket') { value = value ? 'Oui' : 'Non'; }
                            else if (field === 'type' || field === 'status' || field === 'priority') { value = vm.label(value); }
                            line.changes.push({label:label, value:value === null || value === '' ? 'Non renseigné' : value});
                        }
                    });
                    if (previous.descriptionMarkdown !== snapshot.descriptionMarkdown) { line.changes.push({label:'Description', value:'Texte enregistré'}); }
                    previous = snapshot;
                });
                $state.go('native-tickets', {ticketId: id, contractId: params.contractId, areaId: null}, {notify: false, location: 'replace'});
            }, failed).finally(function () { vm.loadingDetail = false; });
        };
        vm.save = function () {
            vm.saving = true;vm.error = null;
            var ticketInput = angular.copy(vm.ticket);ticketInput.startDate = isoDate(ticketInput.startDate);ticketInput.dueDate = isoDate(ticketInput.dueDate);
            api.post('', {ticket: ticketInput, draftKey: vm.draftKey, commentMarkdown: vm.commentMarkdown, privateNote: vm.privateNote, attachmentIds: (vm.pendingAttachments || []).map(function (file) { return file.id; })}).then(function (ticket) { vm.notice = 'Le ticket a été enregistré.';vm.load();return vm.open(ticket.id); }, failed).finally(function () { vm.saving = false; });
        };
        vm.reopen = function () { vm.ticket.status = 'IN_PROGRESS'; vm.save(); };
        vm.addComment = function () {
            // Une note ne doit pas faire perdre les modifications de la description en cours.
            if (vm.editable) { vm.save(); return; }
            vm.saving = true;vm.error = null;
            api.post(vm.ticket.id + '/comments', {ticket: {version: vm.ticket.version}, draftKey: vm.commentDraftKey, commentMarkdown: vm.commentMarkdown, privateNote: vm.privateNote}).then(function () { vm.notice = 'La note a été ajoutée.';return vm.open(vm.ticket.id); }, failed).finally(function () { vm.saving = false; });
        };
        vm.categories = function (parent, selected) {
            return vm.meta.categories.filter(function (value) { return value.type === vm.ticket.type && (value.parentId || null) === (parent || null) && (value.active || value.id === selected); });
        };
        vm.changeType = function () { vm.ticket.categoryId = null; vm.ticket.subcategoryId = null; };
        vm.changeArea = function () { vm.ticket.assigneeId = null; vm.ticket.watcherIds = []; vm.ticket.contractId = null; vm.ticket.equipmentId = null; vm.contractResults = []; vm.equipmentResults = []; };
        vm.users = function () { return vm.meta.users.filter(function (user) { return vm.ticket && user.areaIds.indexOf(vm.ticket.areaId) !== -1; }); };
        vm.locate = function () {
            if (!navigator.geolocation) { vm.error = 'La géolocalisation n’est pas disponible.'; return; }
            vm.locating = true;navigator.geolocation.getCurrentPosition(function (position) { vm.ticket.latitude = position.coords.latitude;vm.ticket.longitude = position.coords.longitude;vm.locating = false;vm.geoNotice = 'Position relevée ; vérifiez-la avant d’enregistrer.';vm.applyLocation(); }, function () { vm.locating = false;vm.error = 'La position n’a pas pu être obtenue. Vous pouvez saisir les coordonnées.';vm.applyLocation(); }, {enableHighAccuracy: true, timeout: 15000});
        };
        // Les callbacks du navigateur réintègrent le cycle d’affichage Angular.
        vm.applyLocation = function () { $scope.$evalAsync(); };
        vm.lookup = function (kind) {
            vm.error = null;var search = kind === 'contract' ? vm.contractSearch : vm.equipmentSearch;
            api.get('lookup', {kind: kind, areaId: vm.ticket.areaId, search: search}).then(function (data) { if (kind === 'contract') { vm.contractResults = data; } else { vm.equipmentResults = data; } }, failed);
        };
        vm.uploadFiles = function (files) {
            if (!vm.ticket || vm.fileBusy) { return; }vm.fileBusy = true;vm.error = null;var index = 0;
            function next() {
                if (index >= files.length) { vm.fileBusy = false;return; }var file = files[index++];
                if (file.size > 20 * 1024 * 1024) { vm.error = 'Chaque fichier doit faire moins de 20 Mo.';vm.fileBusy = false;return; }
                var reader = new FileReader();reader.onerror = function () { $scope.$evalAsync(function () { vm.fileBusy = false;vm.error = 'Le fichier ne peut pas être lu.'; }); };
                reader.onload = function () { api.post('attachments', {ticketId: vm.ticket.id || null, draftKey: vm.draftKey, fileName: file.name, contentBase64: reader.result.split(',')[1]}).then(function (value) { vm.pendingAttachments.push(value);next(); }, function (error) { failed(error);vm.fileBusy = false; }); };reader.readAsDataURL(file);
            }
            next();
        };
        vm.download = function (file) {
            $http.get('api/native-tickets/images/' + file.id, {responseType:'blob'}).then(function (response) {
                var url = URL.createObjectURL(response.data), anchor = document.createElement('a');anchor.href = url;anchor.download = file.fileName;document.body.appendChild(anchor);anchor.click();anchor.remove();setTimeout(function () { URL.revokeObjectURL(url); }, 10000);
            }, failed);
        };
        vm.showSection = function (section) { vm.section = section;vm.error = null;if (section === 'schedules') { vm.loadSchedules(); }if (section === 'categories') { vm.newCategory(); } };
        vm.newCategory = function () { vm.category = {type: vm.categoryType || 'FIELD_WORK', active: true}; };
        vm.editCategory = function (value) { vm.categoryType = value.type;vm.category = angular.copy(value); };
        vm.categoryParents = function () { return vm.meta.categories.filter(function (value) { return vm.category && value.type === vm.category.type && !value.parentId && value.active; }); };
        vm.saveCategory = function () { vm.saving = true;vm.error = null;api.post('categories', vm.category).then(function () { vm.notice = 'Le classement a été enregistré.';vm.newCategory();return refreshMetadata(); }, failed).finally(function () { vm.saving = false; }); };
        vm.loadSchedules = function () { return api.get('schedules').then(function (data) { vm.schedules = data; }, failed); };
        function dateOnly(value) { return typeof value === 'string' ? value.slice(0, 10) : value; }
        vm.plan = function () {
            var template = angular.copy(vm.ticket);delete template.id;delete template.version;template.status = 'NEW';template.doneRatio = 0;template.startDate = isoDate(template.startDate);template.dueDate = isoDate(template.dueDate);
            vm.scheduleTemplate = template;vm.schedule = {label: template.subject, startDate: new Date(), frequency: 'MONTHS', intervalCount: 1, dueAfterDays: 0, active: true, zoneId: (window.Intl && Intl.DateTimeFormat().resolvedOptions().timeZone) || 'Europe/Paris'};
            vm.section = 'schedules';vm.loadSchedules();
        };
        vm.editSchedule = function (value) { vm.schedule = angular.copy(value);vm.schedule.startDate = new Date(dateOnly(value.startDate) + 'T12:00:00');vm.schedule.endDate = value.endDate ? new Date(dateOnly(value.endDate) + 'T12:00:00') : null;vm.scheduleTemplate = JSON.parse(value.templateJson); };
        function isoDate(value) { if (!value) { return null; } if (typeof value === 'string') { return value.slice(0, 10); }return value.getFullYear() + '-' + ('0' + (value.getMonth() + 1)).slice(-2) + '-' + ('0' + value.getDate()).slice(-2); }
        vm.saveSchedule = function () { vm.saving = true;vm.error = null;var schedule = angular.copy(vm.schedule);schedule.startDate = isoDate(schedule.startDate);schedule.endDate = isoDate(schedule.endDate);api.post('schedules', {schedule: schedule, template: vm.scheduleTemplate}).then(function () { vm.notice = 'La récurrence a été enregistrée.';vm.schedule = null;vm.loadSchedules(); }, failed).finally(function () { vm.saving = false; }); };
        vm.stopSchedule = function (value) { vm.saving = true;api.post('schedules/' + value.id + '/stop', {version: value.version}).then(vm.loadSchedules, failed).finally(function () { vm.saving = false; }); };
        vm.generate = function () { vm.saving = true;api.post('schedules/generate', {}).then(function () { vm.notice = 'Les tâches arrivées à échéance ont été préparées.';vm.loadSchedules();vm.load(); }, failed).finally(function () { vm.saving = false; }); };
        refreshMetadata().then(function () { vm.load();if (params.ticketId) { vm.open(params.ticketId); } }, failed);
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').factory('NativeTicketApi', NativeTicketApi);
    NativeTicketApi.$inject = ['$http'];
    function NativeTicketApi($http) {
        var base = 'api/native-tickets';
        function data(response) { return response.data; }
        return {
            get: function (path, params) { return $http.get(base + (path ? '/' + path : ''), {params: params}).then(data); },
            post: function (path, value) { return $http.post(base + (path ? '/' + path : ''), value).then(data); },
            preview: function (value) { return $http.post(base + '/preview', {markdown: value || ''}).then(data); },
            uuid: function () {
                // Identifiant stable pour les relances ; les droits restent contrôlés sur le serveur.
                var bytes = new Uint8Array(16);
                if (window.crypto && window.crypto.getRandomValues) { window.crypto.getRandomValues(bytes); }
                else { for (var i = 0; i < bytes.length; i++) { bytes[i] = Math.floor(Math.random() * 256); } }
                bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
                var hex = Array.prototype.map.call(bytes, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
                return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
            }
        };
    }
    angular.module('wamasysApp').config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('native-tickets', {
            parent: 'entity', url: '/tickets?ticketId&contractId&areaId',
            data: {authenticate: true, authorities: [], pageTitle: 'Tickets et tâches'},
            views: {'content@': {templateUrl: 'app/business/teamwork/native-tickets.html', controller: 'NativeTicketsController', controllerAs: 'vm'}}
        });
    }]);
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('organisation', {
            parent: 'entity',
            url: '/organisation?page&sort&search',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'wamasysApp.organisation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/organisation/organisations.html',
                    controller: 'OrganisationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('organisation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('organisation-detail', {
            parent: 'entity',
            url: '/organisation/{id}',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'wamasysApp.organisation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/organisation/organisation-detail.html',
                    controller: 'OrganisationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('organisation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Organisation', function($stateParams, Organisation) {
                    return Organisation.get({id : $stateParams.id});
                }]
            }
        })
        .state('organisation.new', {
            parent: 'organisation',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/organisation/organisation-dialog.html',
                    controller: 'OrganisationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                address: null,
                                country: null,
                                activated: true,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('organisation', null, { reload: true });
                }, function() {
                    $state.go('organisation');
                });
            }]
        })
        .state('organisation.edit', {
            parent: 'organisation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/organisation/organisation-dialog.html',
                    controller: 'OrganisationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Organisation', function(Organisation) {
                            return Organisation.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('organisation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('organisation.delete', {
            parent: 'organisation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/organisation/organisation-delete-dialog.html',
                    controller: 'OrganisationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Organisation', function(Organisation) {
                            return Organisation.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('organisation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('Organisation', Organisation);

    Organisation.$inject = ['$resource'];

    function Organisation ($resource) {
        var resourceUrl =  'api/organisations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('OrganisationController', OrganisationController);

    OrganisationController.$inject = ['$scope', '$state', 'Organisation', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OrganisationController ($scope, $state, Organisation, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Organisation.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.organisations = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('OrganisationDialogController', OrganisationDialogController);

    OrganisationDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Organisation', 'User'];

    function OrganisationDialogController ($scope, $stateParams, $uibModalInstance, entity, Organisation, User) {
        var vm = this;
        vm.organisation = entity;
        vm.users = User.query({ offset: 0,size: 1000});
        vm.load = function(id) {
            Organisation.get({id : id}, function(result) {
                vm.organisation = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:organisationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.organisation.id !== null) {
                Organisation.update(vm.organisation, onSaveSuccess, onSaveError);
            } else {
                Organisation.save(vm.organisation, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('OrganisationDetailController', OrganisationDetailController);

    OrganisationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Organisation',  'User'];

    function OrganisationDetailController($scope, $rootScope, $stateParams, entity, Organisation,User) {
        var vm = this;
        vm.organisation = entity;
        vm.load = function (id) {
            Organisation.get({id: id}, function(result) {
                vm.organisation = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:organisationUpdate', function(event, result) {
            vm.organisation = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('OrganisationDeleteController',OrganisationDeleteController);

    OrganisationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Organisation'];

    function OrganisationDeleteController($uibModalInstance, entity, Organisation) {
        var vm = this;
        vm.organisation = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Organisation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('type-remisecommerciale', {
            parent: 'entity',
            url: '/type-remisecommerciale?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.typeRemisecommerciale.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-remisecommerciale/type-remisecommerciales.html',
                    controller: 'TypeRemisecommercialeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeRemisecommerciale');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('type-remisecommerciale-detail', {
            parent: 'entity',
            url: '/type-remisecommerciale/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.typeRemisecommerciale.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-remisecommerciale/type-remisecommerciale-detail.html',
                    controller: 'TypeRemisecommercialeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeRemisecommerciale');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TypeRemisecommerciale', function($stateParams, TypeRemisecommerciale) {
                    return TypeRemisecommerciale.get({id : $stateParams.id});
                }]
            }
        })
        .state('type-remisecommerciale.new', {
            parent: 'type-remisecommerciale',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-remisecommerciale/type-remisecommerciale-dialog.html',
                    controller: 'TypeRemisecommercialeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('type-remisecommerciale', null, { reload: true });
                }, function() {
                    $state.go('type-remisecommerciale');
                });
            }]
        })
        .state('type-remisecommerciale.edit', {
            parent: 'type-remisecommerciale',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-remisecommerciale/type-remisecommerciale-dialog.html',
                    controller: 'TypeRemisecommercialeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TypeRemisecommerciale', function(TypeRemisecommerciale) {
                            return TypeRemisecommerciale.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-remisecommerciale', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-remisecommerciale.delete', {
            parent: 'type-remisecommerciale',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-remisecommerciale/type-remisecommerciale-delete-dialog.html',
                    controller: 'TypeRemisecommercialeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TypeRemisecommerciale', function(TypeRemisecommerciale) {
                            return TypeRemisecommerciale.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-remisecommerciale', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('TypeRemisecommerciale', TypeRemisecommerciale);

    TypeRemisecommerciale.$inject = ['$resource'];

    function TypeRemisecommerciale ($resource) {
        var resourceUrl =  'api/type-remisecommerciales/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeRemisecommercialeController', TypeRemisecommercialeController);

    TypeRemisecommercialeController.$inject = ['$scope', '$state', 'TypeRemisecommerciale', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TypeRemisecommercialeController ($scope, $state, TypeRemisecommerciale, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            TypeRemisecommerciale.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.typeRemisecommerciales = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeRemisecommercialeDialogController', TypeRemisecommercialeDialogController);

    TypeRemisecommercialeDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeRemisecommerciale'];

    function TypeRemisecommercialeDialogController ($scope, $stateParams, $uibModalInstance, entity, TypeRemisecommerciale) {
        var vm = this;
        vm.typeRemisecommerciale = entity;
        vm.load = function(id) {
            TypeRemisecommerciale.get({id : id}, function(result) {
                vm.typeRemisecommerciale = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:typeRemisecommercialeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.typeRemisecommerciale.id !== null) {
                TypeRemisecommerciale.update(vm.typeRemisecommerciale, onSaveSuccess, onSaveError);
            } else {
                TypeRemisecommerciale.save(vm.typeRemisecommerciale, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeRemisecommercialeDetailController', TypeRemisecommercialeDetailController);

    TypeRemisecommercialeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TypeRemisecommerciale'];

    function TypeRemisecommercialeDetailController($scope, $rootScope, $stateParams, entity, TypeRemisecommerciale) {
        var vm = this;
        vm.typeRemisecommerciale = entity;
        vm.load = function (id) {
            TypeRemisecommerciale.get({id: id}, function(result) {
                vm.typeRemisecommerciale = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:typeRemisecommercialeUpdate', function(event, result) {
            vm.typeRemisecommerciale = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeRemisecommercialeDeleteController',TypeRemisecommercialeDeleteController);

    TypeRemisecommercialeDeleteController.$inject = ['$uibModalInstance', 'entity', 'TypeRemisecommerciale'];

    function TypeRemisecommercialeDeleteController($uibModalInstance, entity, TypeRemisecommerciale) {
        var vm = this;
        vm.typeRemisecommerciale = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TypeRemisecommerciale.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
		.state('modele-contrat.service-autre',{
			url : '/service-autre/',
			views : {
				'panneau@content' : {
					templateUrl : 'app/business/service-autre/service-autres.html',

					controller : 'ServiceVenduController',
					controllerAs : 'vm'
					}
				}
			})
        .state('service-autre-detail', {
            parent: 'entity',
            url: '/service-autre/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.serviceVendu.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/service-autre/service-autre-detail.html',
                    controller: 'ServiceVenduDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceVendu');
                    $translatePartialLoader.addPart('typePaiementService');
                    
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ServiceVendu', function($stateParams, ServiceVendu) {
                    return ServiceVendu.get({id : $stateParams.id});
                }]
            }
        })
        .state('modele-contrat.service-autre.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/service-autre/service-autre-dialog.html',
                    controller: 'ServiceVenduDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                unitPrice: null,
                                totalCredit: null,
                                amountPerInstallment: null,
                                tauxTaxe:null,
                                libelleTaxe:null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('modele-contrat.service-autre', null, { reload: true });
                }, function() {
                    $state.go('modele-contrat.service-autre');
                });
            }]
        })
        .state('modele-contrat.service-autre.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/service-autre/service-autre-dialog.html',
                    controller: 'ServiceVenduDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ServiceVendu', function(ServiceVendu) {
                            return ServiceVendu.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('modele-contrat.service-autre', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modele-contrat.service-autre.delete', {
           
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/service-autre/service-autre-delete-dialog.html',
                    controller: 'ServiceVenduDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ServiceVendu', function(ServiceVendu) {
                            return ServiceVendu.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('modele-contrat.service-autre', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ServiceVendu', ServiceVendu);

    ServiceVendu.$inject = ['$resource'];

    function ServiceVendu ($resource) {
        var resourceUrl =  'api/service-autres/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ServiceVenduController', ServiceVenduController);

    ServiceVenduController.$inject = ['$scope', '$state', 'ServiceVendu', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ServiceVenduController ($scope, $state, ServiceVendu, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            ServiceVendu.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceVendus = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ServiceVenduDialogController', ServiceVenduDialogController);

    ServiceVenduDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceVendu',  'TypeService','TypeTax', 'ModeleContrat'];

    function ServiceVenduDialogController ($scope, $stateParams, $uibModalInstance, entity, ServiceVendu, TypeService,TypeTax, ModeleContrat) {
        var vm = this;
        vm.serviceVendu = entity;
        vm.typeTaxs = TypeTax.query({size:100});
//        vm.typeservices = TypeService.query({size:100});

        TypeService.query({size:100}, function(result) {
        	vm.typeservices = result;
        	entity.$promise.then(function(value) {
	        	if( vm.serviceVendu.typeService){
	        		var  fnctIdEqual = function(element) {return element.id === vm.serviceVendu.typeService.id};
	        		var index = vm.typeservices.findIndex(fnctIdEqual);
	        		if(index === -1 ){
	        			vm.typeservices.push(vm.serviceVendu.typeService);
	        		}
	        	}
        	});
        });
        
        vm.modelecontrats = ModeleContrat.query();
        vm.load = function(id) {
            ServiceVendu.get({id : id}, function(result) {
                vm.serviceVendu = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:serviceVenduUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.serviceVendu.id !== null) {
                ServiceVendu.update(vm.serviceVendu, onSaveSuccess, onSaveError);
            } else {
                ServiceVendu.save(vm.serviceVendu, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ServiceVenduDetailController', ServiceVenduDetailController);

    ServiceVenduDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ServiceVendu','Agence', 'TypeService', 'ModeleContrat','DTOptionsBuilder', 'DTColumnDefBuilder', '$translate'];

    function ServiceVenduDetailController($scope, $rootScope, $stateParams, entity, ServiceVendu, Agence, TypeService, ModeleContrat,DTOptionsBuilder, DTColumnDefBuilder, $translate) {
        var vm = this;
        vm.serviceVendu = entity;
        vm.historyRows = buildHistoryRows(entity);
        
        vm.load = function (id) {
            ServiceVendu.get({id: id}, function(result) {
                vm.serviceVendu = result;
                vm.historyRows = buildHistoryRows(result);
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:serviceVenduUpdate', function(event, result) {
            vm.serviceVendu = result;
            vm.historyRows = buildHistoryRows(result);
        });
        $scope.$on('$destroy', unsubscribe);

        
        vm.standardOptions = DTOptionsBuilder
        .newOptions()
         //Add Bootstrap compatibility
        .withDOM("<'dt-toolbar'<'col-xs-12 col-sm-6'f><'col-sm-6 col-xs-12 hidden-xs'l>r>" +
            "t" +
            "<'dt-toolbar-footer'<'col-sm-6 col-xs-12 hidden-xs'i><'col-xs-12 col-sm-6'p>>")
        .withBootstrap();
        
	    vm.standardColumns = [
	        DTColumnDefBuilder.newColumnDef(0),
	        DTColumnDefBuilder.newColumnDef(1),
	        DTColumnDefBuilder.newColumnDef(2),
	        DTColumnDefBuilder.newColumnDef(3)
	    ];

        /**
         * L'historique contient l'état précédant chaque modification. L'état qui
         * suit est donc l'état actuel pour la ligne la plus récente, puis l'état
         * précédent de la ligne plus récente pour les autres lignes.
         */
        function buildHistoryRows(serviceVendu) {
            var histories = angular.copy(serviceVendu.historiqueCoutContrats || []);
            var fields = [
                {name: 'unitPrice', labelKey: 'wamasysApp.serviceVendu.unitPrice'},
                {name: 'amountPerInstallment', labelKey: 'wamasysApp.serviceVendu.amountPerInstallment'},
                {name: 'totalCredit', labelKey: 'wamasysApp.serviceVendu.totalCredit'},
                {name: 'frequency', labelKey: 'wamasysApp.serviceVendu.frequency'},
                {name: 'intervalType', labelKey: 'wamasysApp.serviceVendu.intervalTypeLabel'},
                {name: 'typeTax', labelKey: 'wamasysApp.serviceVendu.typeTax'}
            ];

            histories.sort(function(left, right) {
                var dateComparison = new Date(right.dateCreation).getTime() - new Date(left.dateCreation).getTime();
                return dateComparison !== 0 ? dateComparison : (right.id || 0) - (left.id || 0);
            });

            return histories.map(function(history, index) {
                var newValues = index === 0 ? serviceVendu : histories[index - 1];
                var changes = [];

                angular.forEach(fields, function(field) {
                    var oldValue = history[field.name];
                    var newValue = newValues[field.name];
                    if (!sameHistoryValue(field.name, oldValue, newValue)) {
                        changes.push({
                            labelKey: field.labelKey,
                            oldValue: formatHistoryValue(field.name, oldValue),
                            newValue: formatHistoryValue(field.name, newValue)
                        });
                    }
                });

                return {
                    id: history.id,
                    dateCreation: history.dateCreation,
                    createdBy: history.createdBy,
                    commentaire: history.commentaire,
                    changes: changes
                };
            });
        }

        function sameHistoryValue(fieldName, oldValue, newValue) {
            if (fieldName === 'typeTax') {
                return taxIdentifier(oldValue) === taxIdentifier(newValue);
            }
            return oldValue === newValue;
        }

        function taxIdentifier(typeTax) {
            if (!typeTax) {
                return null;
            }
            return angular.isDefined(typeTax.id) ? typeTax.id : typeTax.label + '|' + typeTax.taxRate;
        }

        function formatHistoryValue(fieldName, value) {
            if (value === null || angular.isUndefined(value)) {
                return null;
            }
            if (fieldName === 'typeTax') {
                return value.label + ' (' + value.taxRate + ' %)';
            }
            if (fieldName === 'intervalType') {
                return $translate.instant('wamasysApp.serviceVendu.intervalType.' + value);
            }
            return value;
        }
    
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ServiceVenduDeleteController',ServiceVenduDeleteController);

    ServiceVenduDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceVendu'];

    function ServiceVenduDeleteController($uibModalInstance, entity, ServiceVendu) {
        var vm = this;
        vm.serviceVendu = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ServiceVendu.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporting-taxe', {
            parent: 'entity',
            url: '/reporting-taxe',
            data: {
                authorities: ['ROLE_READ_ONLY','ROLE_DATA_OPERATOR'],
                pageTitle: 'wamasysApp.reportingAgence.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-taxe/reporting-taxe.html',
                    controller: 'ReportingTaxeController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ReportingTaxe', ReportingTaxe);

    ReportingTaxe.$inject = ['$resource'];

    function ReportingTaxe ($resource) {
        var resourceUrl =  'api/reporting-taxe/search';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReportingTaxeController', ReportingTaxeController);

    ReportingTaxeController.$inject = ['$scope', '$state', '$filter', 'ParseLinks', 'AlertService', 'ReportingTaxe'];

    function ReportingTaxeController ($scope, $state, $filter,  ParseLinks, AlertService, ReportingTaxe) {
        var vm = this;
        vm.search=search;
        vm.date = {
                startDate: $state.params.startDate?new Date($state.params.startDate):null,
                endDate: $state.params.endDate?new Date($state.params.endDate):null

        };


        function onSuccess(data, headers) {
            vm.reporting = data;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }
        
        function search () {
            if ( vm.date.startDate && vm.date.endDate) {
	        	ReportingTaxe.query({
	        		fromDate:$filter('date')(new Date(vm.date.startDate), "yyyy-MM-dd"),
	        		toDate:$filter('date')(new Date(vm.date.endDate), "yyyy-MM-dd")
	            }, onSuccess, onError);
            }

        }

	      
        $scope.openRangeDateTimePicker = function() {
				$('#daterange1').data('daterangepicker').toggle();
		}

        
		$scope.getTotalFacture = function() {
			var total = 0;
			if (vm.reporting != undefined ) {
				for (var i = 0; i < vm.reporting.length; i++) {
					var service = vm.reporting[i];
					total += service.totalFacture ;
				}

			}
			return total;
		}
		

		$scope.getTotalEncaisseTtc= function() {
			var total = 0;
			if (vm.reporting != undefined ) {
				for (var i = 0; i < vm.reporting.length; i++) {
					var service = vm.reporting[i];
					total += service.totalEncaisseTtc ;
				}

			}
			return total;
		}

		$scope.getTotalTaxEncaisse= function() {
			var total = 0;
			if (vm.reporting != undefined ) {
				for (var i = 0; i < vm.reporting.length; i++) {
					var service = vm.reporting[i];
					total += (service.totalEncaisseTtc-service.totalEncaisseHt) ;
				}

			}
			return total;
		}
		

		$scope.getTotalTaxFacture = function() {
			var total = 0;
			if (vm.reporting != undefined ) {
				for (var i = 0; i < vm.reporting.length; i++) {
					var service = vm.reporting[i];
					total += service.totalTaxFacture ;
				}

			}
			return total;
		}

		$scope.getTotalWindFallGainTtc = function() {
			var total = 0;
			if (vm.reporting != undefined ) {
				for (var i = 0; i < vm.reporting.length; i++) {
					var service = vm.reporting[i];
					total += service.totalWindFallGainTtc ;
				}

			}
			return total;
		}

		$scope.getTotalWindFallGainTax = function() {
			var total = 0;
			if (vm.reporting != undefined ) {
				for (var i = 0; i < vm.reporting.length; i++) {
					var service = vm.reporting[i];
					total += service.totalWindFallGainTax ;
				}

			}
			return total;
		}

//    	vm.download = function(){
//    		ReportingTaxe.downloadcsv( {
//        		fromDate:$filter('date')(new Date(vm.date.startDate), "yyyy-MM-dd"),
//        		toDate:$filter('date')(new Date(vm.date.endDate), "yyyy-MM-dd")}
//    			,function (content){
//    		      var url = URL.createObjectURL(content.response);
//    		      var a = document.createElement('a');
//    		      a.href = url;
//    		      a.download = content.fileName;
//    		      a.target = '_blank';
//    		      a.click();
//    		}
//    				
//    		);
//    	}

	}
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('file-explorer', {
            parent: 'entity',
            url: '/file-explorer',
            data: {
                authorities: ['ROLE_ADMIN','ADMIN'],
                pageTitle: 'wamasysApp.reportingAgence.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/s3-filesexplorer/s3-fileexplorer.html',
                    controller: 'S3FileExplorerController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('S3FileExplorerService', S3FileExplorerService);

    S3FileExplorerService.$inject = ['$http'];

    function S3FileExplorerService($http) {
        return {
            list: list,
            downloadUrl: downloadUrl,
            directoryCounts: directoryCounts
        };

        function list(storageSystem, prefix, continuationToken) {
            var config = { params: {} };
            config.params.storageSystem = storageSystem;
            if (prefix) config.params.prefix = prefix;
            if (continuationToken) config.params.continuationToken = continuationToken;
            return $http.get('/api/s3', config).then(function(resp) { return resp.data; });
        }

        function downloadUrl(storageSystem, key) {
            return '/api/s3/download?storageSystem=' + encodeURIComponent(storageSystem) + '&key=' + encodeURIComponent(key);
        }

        function directoryCounts(storageSystem, prefix) {
            return $http.get('/api/s3/directory-counts', {
                params: {
                    storageSystem: storageSystem,
                    prefix: prefix || ''
                }
            }).then(function(resp) { return resp.data; });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('S3FileExplorerController', S3FileExplorerController);

    S3FileExplorerController.$inject = ['S3FileExplorerService', '$http'];

    function S3FileExplorerController(S3FileExplorerService, $http) {
        var vm = this;
        vm.storageSystems = [
            { key: 's2', label: 'Temporaire (s2)' },
            { key: 's1', label: 'Persistant (s1)' }
        ];
        vm.storageSystem = 's2';
        vm.prefix = '';
        vm.breadcrumb = [];
        vm.folders = [];
        vm.files = [];
        vm.searchText = '';
        vm.nextToken = null;
        vm.truncated = false;
        vm.directoryCounts = [];
        vm.directoryCountsLoaded = false;
        vm.directoryCountsLoading = false;

        vm.enter = enter;
        vm.goUp = goUp;
        vm.download = download;
        vm.refresh = refresh;
        vm.loadMore = loadMore;
        vm.filteredFiles = filteredFiles;
        vm.loadDirectoryCounts = loadDirectoryCounts;
        vm.changeStorageSystem = changeStorageSystem;
        vm.currentStorageSystemLabel = currentStorageSystemLabel;

        activate();

        function activate() {
            resetExplorer();
        }

        function refresh() {
            resetDirectoryCounts();
            S3FileExplorerService.list(vm.storageSystem, vm.prefix).then(function(data) {
                vm.folders = data.prefixes || [];
                vm.files = data.files || [];
                vm.truncated = data.truncated;
                vm.nextToken = data.nextContinuationToken;
            });
        }

        function loadMore() {
            if (!vm.truncated) return;
            S3FileExplorerService.list(vm.storageSystem, vm.prefix, vm.nextToken).then(function(data) {
                vm.folders = unique(vm.folders.concat(data.prefixes || []));
                vm.files = vm.files.concat(data.files || []);
                vm.truncated = data.truncated;
                vm.nextToken = data.nextContinuationToken;
            });
        }

        function unique(values) {
            return values.filter(function(value, index, array) {
                return array.indexOf(value) === index;
            });
        }

        function filteredFiles() {
            if (!vm.searchText) return vm.files;
            var text = vm.searchText.toLowerCase();
            return vm.files.filter(function(file) {
                var name = file.key.split('/').slice(-1)[0].toLowerCase();
                return name.indexOf(text) !== -1;
            });
        }

        function buildBreadcrumb() {
            var crumbs = [{ name: '/', prefix: '' }];
            if (!vm.prefix) {
                vm.breadcrumb = crumbs;
                return;
            }

            var parts = vm.prefix.split('/').filter(Boolean);
            var accum = '';
            parts.forEach(function(part) {
                accum = accum ? (accum + '/' + part) : part;
                crumbs.push({ name: part, prefix: accum });
            });
            vm.breadcrumb = crumbs;
        }

        function resetExplorer() {
            vm.prefix = '';
            vm.folders = [];
            vm.files = [];
            vm.truncated = false;
            vm.nextToken = null;
            buildBreadcrumb();
            refresh();
        }

        function resetDirectoryCounts() {
            vm.directoryCounts = [];
            vm.directoryCountsLoaded = false;
        }

        function currentStorageSystemLabel() {
            var current = vm.storageSystems.filter(function(item) {
                return item.key === vm.storageSystem;
            })[0];
            return current ? current.label : vm.storageSystem;
        }

        function changeStorageSystem() {
            resetExplorer();
        }

        function enter(folderName) {
            if (!vm.prefix) {
                vm.prefix = folderName;
            } else {
                vm.prefix = vm.prefix.replace(/\/$/, '') + '/' + folderName;
            }
            buildBreadcrumb();
            refresh();
        }

        function goUp(prefix) {
            vm.prefix = prefix || '';
            buildBreadcrumb();
            refresh();
        }

        function download(item) {
            var url = S3FileExplorerService.downloadUrl(vm.storageSystem, item.key);
            $http.get(url, { responseType: 'arraybuffer' }).then(function(response) {
                var blob = new Blob([response.data], { type: response.headers('Content-Type') });
                var filename = getFileNameFromHeader(response.headers('Content-Disposition')) || item.name;

                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.click();
            });
        }

        function getFileNameFromHeader(disposition) {
            if (!disposition) return null;
            var match = disposition.match(/filename="(.+)"/);
            return match ? match[1] : null;
        }

        function loadDirectoryCounts() {
            vm.directoryCountsLoading = true;
            S3FileExplorerService.directoryCounts(vm.storageSystem, vm.prefix).then(function(data) {
                vm.directoryCounts = data || [];
                vm.directoryCountsLoaded = true;
            }).finally(function() {
                vm.directoryCountsLoading = false;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('stored-document-stats', {
                parent: 'entity',
                url: '/stored-document-stats',
                data: {
                    authorities: ['ROLE_SUPER_ADMIN'],
                    pageTitle: 'Statistiques S3'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/business/stored-document-stats/stored-document-stats.html',
                        controller: 'StoredDocumentStatsController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('StoredDocumentStats', StoredDocumentStats);

    StoredDocumentStats.$inject = ['$http'];

    function StoredDocumentStats($http) {
        return {
            getAll: function() {
                return $http.get('api/admin/stored-document-stats');
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('StoredDocumentStatsController', StoredDocumentStatsController);

    StoredDocumentStatsController.$inject = ['StoredDocumentStats', 'AlertService'];

    function StoredDocumentStatsController(StoredDocumentStats, AlertService) {
        var vm = this;
        var FILE_TYPE_LABELS = {
            equipmentphoto: 'Photos des équipements',
            equipmentdoc: 'Documents des équipements',
            facture: 'Factures PDF',
            accounting: 'Exports comptables',
            signpict: 'Signatures',
            meterpict: 'Photos de compteur'
        };
        var STORAGE_LABELS = {
            s1: 'Persistant (s1)',
            s2: 'Temporaire (s2)'
        };

        vm.rows = [];
        vm.filteredRows = [];
        vm.searchText = '';
        vm.loading = false;
        vm.summary = buildSummary([]);

        vm.load = load;
        vm.applyFilter = applyFilter;
        vm.formatBytes = formatBytes;

        load();

        function load() {
            vm.loading = true;
            StoredDocumentStats.getAll().then(function(response) {
                vm.rows = (response.data || []).map(decorateRow);
                applyFilter();
            }).catch(function(error) {
                AlertService.error((error.data && error.data.message) || 'Impossible de charger les statistiques S3.');
            }).finally(function() {
                vm.loading = false;
            });
        }

        function applyFilter() {
            var searchText = (vm.searchText || '').trim().toLowerCase();
            vm.filteredRows = vm.rows.filter(function(row) {
                return !searchText || row.searchableText.indexOf(searchText) !== -1;
            });
            vm.summary = buildSummary(vm.filteredRows);
        }

        function decorateRow(row) {
            row.storageLabel = STORAGE_LABELS[row.storageSystem] || row.storageSystem;
            row.fileTypeLabel = FILE_TYPE_LABELS[row.fileType] || row.fileType;
            row.searchableText = [
                row.organisationName || '',
                row.storageLabel || '',
                row.fileTypeLabel || ''
            ].join(' ').toLowerCase();
            return row;
        }

        function buildSummary(rows) {
            var organisationIds = {};
            var organisationCount = 0;
            var totalFileCount = 0;
            var totalKnownSizeFileCount = 0;
            var totalSizeBytes = 0;
            var hasKnownSize = false;

            rows.forEach(function(row) {
                totalFileCount += row.fileCount || 0;
                totalKnownSizeFileCount += row.knownSizeFileCount || 0;
                if (row.organisationId !== null && row.organisationId !== undefined) {
                    organisationIds[row.organisationId] = true;
                }
                if (row.totalSizeBytes !== null && row.totalSizeBytes !== undefined) {
                    totalSizeBytes += row.totalSizeBytes;
                    hasKnownSize = true;
                }
            });
            angular.forEach(organisationIds, function() {
                organisationCount++;
            });

            return {
                groupCount: rows.length,
                organisationCount: organisationCount,
                totalFileCount: totalFileCount,
                totalKnownSizeFileCount: totalKnownSizeFileCount,
                totalSizeBytes: hasKnownSize ? totalSizeBytes : null
            };
        }

        function formatBytes(bytes) {
            var units = ['o', 'Ko', 'Mo', 'Go', 'To'];
            var value = bytes;
            var unitIndex = 0;

            if (bytes === null || bytes === undefined) {
                return '-';
            }
            while (value >= 1024 && unitIndex < units.length - 1) {
                value = value / 1024;
                unitIndex++;
            }
            return (unitIndex === 0 ? value : value.toFixed(1)) + ' ' + units[unitIndex];
        }
    }
})();
;
(function() {
    'use strict';
    angular.module('wamasysApp').config(stateConfig);
    stateConfig.$inject = ['$stateProvider'];
    function stateConfig($stateProvider) {
        $stateProvider.state('reporting-zone-analysis', {
            parent: 'entity', url: '/reporting-agence/analyse-ia',
            data: {
                authorities: ['ROLE_READ_ONLY', 'ROLE_AREA_MANAGEMENT', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                pageTitle: 'wamasysApp.zoneAnalysis.title'
            },
            views: { 'content@': {
                templateUrl: 'app/business/reporting-zone-analysis/reporting-zone-analysis.html',
                controller: 'ReportingZoneAnalysisController', controllerAs: 'vm'
            } },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, loader) {
                    loader.addPart('zoneAnalysis'); loader.addPart('global'); return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';
    angular.module('wamasysApp').factory('ReportingZoneAnalysis', service);
    service.$inject = ['$resource'];
    function service($resource) {
        var url = 'api/reporting-zone-analysis';
        return $resource(url, {}, {
            overview: {method: 'GET'},
            prompts: {method: 'GET', url: url + '/prompts', isArray: true},
            savePrompt: {method: 'POST', url: url + '/prompts'},
            history: {method: 'GET', url: url + '/analyses', isArray: true},
            detail: {method: 'GET', url: url + '/analyses/:id'},
            run: {method: 'POST', url: url + '/analyses'}
        });
    }
})();
;
(function() {
    'use strict';
    angular.module('wamasysApp').controller('ReportingZoneAnalysisController', controller);
    controller.$inject = ['ReportingZoneAnalysis', 'Principal', '$scope', '$interval', '$translate', '$uibModal'];
    function controller(api, Principal, $scope, $interval, $translate, $uibModal) {
        var vm = this;
        var timer;
        var evidenceCache = Object.create(null);
        var reportingCache = Object.create(null);
        var analysisRequest = 0;
        vm.form = {objectives: '', context: '', weeklyEnabled: true, previousPromptId: null};
        vm.prompts = []; vm.analyses = []; vm.promptPage = 0; vm.analysisPage = 0;
        vm.sections = ['kpiFacts', 'monitoringFacts', 'investigations', 'usageIdeas'];
        vm.load = load; vm.save = save; vm.run = run; vm.select = select;
        vm.promptHistory = promptHistory; vm.analysisHistory = analysisHistory;
        vm.hasUnsavedChanges = hasUnsavedChanges; vm.showSource = showSource;
        vm.sourceState = sourceState; vm.busy = busy; vm.evidenceParts = evidenceParts; vm.hasSource = hasSource; vm.reportingLinks = reportingLinks; vm.durationLabel = durationLabel;
        Principal.identity().then(function(account) {
            var roles = account && account.authorities || [];
            // La modification des prompts et le lancement manuel sont réservés aux administrateurs.
            vm.canEdit = roles.indexOf('ROLE_ADMIN') >= 0 || roles.indexOf('ROLE_SUPER_ADMIN') >= 0;
            vm.canRun = vm.canEdit;
        });
        load();
        $scope.$on('$destroy', function() { if (timer) { $interval.cancel(timer); } });

        function error(response) {
            vm.error = response && response.data && response.data.message || $translate.instant('wamasysApp.zoneAnalysis.requestFailed');
            if (response && response.status === 409) { vm.error = $translate.instant('wamasysApp.zoneAnalysis.conflict'); }
        }
        function applyPrompt(prompt) {
            vm.latestPrompt = prompt || null;
            vm.form = {
                objectives: prompt ? prompt.objectives : '', context: prompt ? prompt.context : '',
                weeklyEnabled: prompt ? prompt.weeklyEnabled : true, previousPromptId: prompt ? prompt.id : null
            };
        }
        function load() {
            vm.loading = true; vm.error = null;
            api.overview().$promise.then(function(data) {
                vm.areaName = data.areaName; vm.configured = data.configured;
                vm.prompts = data.prompts; vm.analyses = data.analyses;
                vm.promptPage = 0; vm.analysisPage = 0;
                applyPrompt(vm.prompts[0]);
                if (vm.analyses.length) { select(vm.analyses[0]); }
                polling();
            }, error).finally(function() { vm.loading = false; });
        }
        function save() {
            vm.saving = true; vm.error = null; vm.saved = false;
            api.savePrompt(angular.copy(vm.form)).$promise.then(function(prompt) {
                applyPrompt(prompt); vm.saved = true; promptHistory(0);
            }, error).finally(function() { vm.saving = false; });
        }
        function hasUnsavedChanges() {
            return vm.form.objectives !== (vm.latestPrompt ? vm.latestPrompt.objectives : '') ||
                vm.form.context !== (vm.latestPrompt ? vm.latestPrompt.context : '') ||
                vm.form.weeklyEnabled !== (vm.latestPrompt ? vm.latestPrompt.weeklyEnabled : true);
        }
        function busy() {
            return vm.analyses.some(function(item) {
                return (item.status === 'QUEUED' || item.status === 'RUNNING') &&
                    new Date(item.createdAt).getTime() > Date.now() - 2 * 60 * 60 * 1000;
            });
        }
        function run() {
            if (hasUnsavedChanges() || busy()) { return; }
            vm.launching = true; vm.error = null;
            api.run({}).$promise.then(function(result) {
                analysisHistory(0); select({id: result.id});
            }, error).finally(function() { vm.launching = false; });
        }
        function promptHistory(page) {
            vm.loadingPrompts = true;
            api.prompts({page: page}).$promise.then(function(items) {
                vm.prompts = items; vm.promptPage = page;
            }, error).finally(function() { vm.loadingPrompts = false; });
        }
        function analysisHistory(page) {
            var request = ++analysisRequest;
            vm.loadingAnalyses = true;
            return api.history({page: page}).$promise.then(function(items) {
                if (request !== analysisRequest) { return; }
                vm.analyses = items; vm.analysisPage = page; polling();
            }, error).finally(function() { if (request === analysisRequest) { vm.loadingAnalyses = false; } });
        }
        function select(item) {
            vm.selectedId = item.id; vm.loadingDetail = true; vm.source = null;
            api.detail({id: item.id}).$promise.then(function(detail) {
                // Une réponse ancienne ne doit pas remplacer une sélection plus récente.
                if (vm.selectedId !== detail.id) { return; }
                vm.detail = detail; vm.result = detail.resultJson ? angular.fromJson(detail.resultJson) : null;
                vm.snapshot = detail.snapshotJson ? angular.fromJson(detail.snapshotJson) : null;
                polling();
            }, error).finally(function() { if (vm.selectedId === item.id) { vm.loadingDetail = false; } });
        }
        function polling() {
            var pending = busy() || (vm.detail && (vm.detail.status === 'QUEUED' || vm.detail.status === 'RUNNING') &&
                new Date(vm.detail.createdAt).getTime() > Date.now() - 2 * 60 * 60 * 1000);
            if (!pending && timer) { $interval.cancel(timer); timer = null; }
            if (pending && !timer) {
                timer = $interval(function() {
                    // Actualiser uniquement les résultats : préserver les prompts en cours de saisie.
                    if (vm.analysisPage === 0) { analysisHistory(0); }
                    if (vm.detail && vm.detail.id === vm.selectedId && !vm.loadingDetail &&
                        (vm.detail.status === 'QUEUED' || vm.detail.status === 'RUNNING')) { select(vm.detail); }
                }, 10000);
            }
        }
        function hasSource(id) {
            return !!(vm.snapshot && vm.snapshot.sources && Object.prototype.hasOwnProperty.call(vm.snapshot.sources, id));
        }
        function showSource(id) {
            if (!hasSource(id)) { return; }
            // Afficher immédiatement la source, plutôt qu'un panneau éloigné en bas de page.
            var source = {id: id, data: angular.copy(vm.snapshot.sources[id]), state: sourceState(id)};
            $uibModal.open({
                templateUrl: 'zone-analysis-source.html', controllerAs: 'sourceVm',
                controller: ['$uibModalInstance', function(instance) {
                    this.source = source; this.close = function() { instance.close(); };
                }]
            });
        }
        function evidenceParts(value) {
            var text = value || '';
            if (evidenceCache[text]) { return evidenceCache[text]; }
            var parts = [], cursor = 0, match;
            // Découper le texte en segments, sans injecter de HTML fourni par l'IA.
            var numbers = /[+-]?\d+(?:[ \u00a0\u202f]\d{3})*(?:[.,]\d+)?(?:[ \u00a0\u202f]?(?:%|€|\$))?/g;
            while ((match = numbers.exec(text))) {
                if (match.index > cursor) { parts.push({text: text.slice(cursor, match.index), highlighted: false}); }
                parts.push({text: match[0], highlighted: true}); cursor = numbers.lastIndex;
            }
            if (cursor < text.length) { parts.push({text: text.slice(cursor), highlighted: false}); }
            evidenceCache[text] = parts;
            return parts;
        }
        function durationLabel(value) {
            if (value == null) { return '—'; }
            var seconds = Math.round(value / 1000);
            return seconds < 60 ? seconds + ' s' : Math.floor(seconds / 60) + ' min ' + (seconds % 60) + ' s';
        }
        function reportingLinks(sources) {
            var key = (sources || []).join('|');
            if (reportingCache[key]) { return reportingCache[key]; }
            var links = [], seen = {};
            (sources || []).forEach(function(id) {
                var state = sourceState(id);
                if (state && !seen[state]) { seen[state] = true; links.push({state: state}); }
            });
            reportingCache[key] = links;
            return links;
        }
        function sourceState(id) {
            if (id.indexOf('FINANCE_') === 0) { return 'reporting-agence'; }
            if (id.indexOf('MONITORING_') === 0) { return 'monitoring-rule-history'; }
            if (id === 'ACTIVITY_SIX_MONTHS') { return 'reporting-area-activity'; }
            return null;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporting-paiement', {
            parent: 'entity',
            url: '/reporting-paiement',
            data: {
                authorities: ['ROLE_READ_ONLY','ROLE_DATA_OPERATOR'],
                pageTitle: 'wamasysApp.reportingPaiement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-paiement/reporting-paiement.html',
                    controller: 'ReportingPaiementController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('contrat');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ReportingPaiement', ReportingPaiement);

    ReportingPaiement.$inject = ['$resource'];

    function ReportingPaiement ($resource) {
        var resourceUrl =  'api/reporting-paiement/search';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'downloadCsvPayments': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/reporting-agence/download-payment',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },
            'downloadCsvReceipts': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/reporting-agence/download-receipt',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            }
            
            
            
        });
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReportingPaiementController', ReportingPaiementController);

    ReportingPaiementController.$inject = ['$scope', '$state', '$filter', 'ParseLinks', 'AlertService', 'ReportingPaiement'];

    function ReportingPaiementController ($scope, $state, $filter,  ParseLinks, AlertService, ReportingPaiement) {
        var vm = this;
        vm.search=search;
        vm.date = {
                startDate: $state.params.startDate?new Date($state.params.startDate):null,
                endDate: $state.params.endDate?new Date($state.params.endDate):null

        };


        function onSuccess(data, headers) {
            vm.reporting = data;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }
        
        function search () {
            if ( vm.date.startDate && vm.date.endDate) {
            	vm.reporting = null;
	        	ReportingPaiement.query({
	        		fromDate:$filter('date')(new Date(vm.date.startDate), "yyyy-MM-dd"),
	        		toDate:$filter('date')(new Date(vm.date.endDate), "yyyy-MM-dd")
	            }, onSuccess, onError);
            }

        }

	      
        $scope.openRangeDateTimePicker = function() {
				$('#daterange1').data('daterangepicker').toggle();
		}

        
		$scope.getTotalPaye = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listePayment!= undefined) {
				for (var i = 0; i < vm.reporting.listePayment.length; i++) {
					var payment = vm.reporting.listePayment[i];
					total += payment.totalPaye ;
				}

			}
			return total;
		}
		

    	vm.download = function(){
    		ReportingPaiement.downloadcsv( {
        		fromDate:$filter('date')(new Date(vm.date.startDate), "yyyy-MM-dd"),
        		toDate:$filter('date')(new Date(vm.date.endDate), "yyyy-MM-dd")}
    			,function (content){
    		      var url = URL.createObjectURL(content.response);
    		      var a = document.createElement('a');
    		      a.href = url;
    		      a.download = content.fileName;
    		      a.target = '_blank';
    		      a.click();
    		}
    				
    		);
    	}
    	
    	
    	vm.downloadReceipts = function(){
    		ReportingPaiement.downloadCsvReceipts( {
        		fromDate:$filter('date')(new Date(vm.date.startDate), "yyyy-MM-dd"),
        		toDate:$filter('date')(new Date(vm.date.endDate), "yyyy-MM-dd")}
    			,function (content){
    		      var url = URL.createObjectURL(content.response);
    		      var a = document.createElement('a');
    		      a.href = url;
    		      a.download = content.fileName;
    		      a.target = '_blank';
    		      a.click();
    		}
    				
    		);
    	}

    	vm.downloadPayments = function(){
    		ReportingPaiement.downloadCsvPayments( {
        		fromDate:$filter('date')(new Date(vm.date.startDate), "yyyy-MM-dd"),
        		toDate:$filter('date')(new Date(vm.date.endDate), "yyyy-MM-dd")}
    			,function (content){
    		      var url = URL.createObjectURL(content.response);
    		      var a = document.createElement('a');
    		      a.href = url;
    		      a.download = content.fileName;
    		      a.target = '_blank';
    		      a.click();
    		}
    				
    		);
    	}

	}
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporting-fuite-eau', {
            parent: 'entity',
            url: '/reporting-fuite-eau',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingConsoEau.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-fuite-eau/reporting-fuite-eau.html',
                    controller: 'ReportingFuiteEauController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                   $translatePartialLoader.addPart('reportingConsoEau');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ReportingFuiteEau', ReportingFuiteEau);

    ReportingFuiteEau.$inject = ['$resource'];

    function ReportingFuiteEau ($resource) {
        var resourceUrl =  'api/reporting-fuite-eau/search';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET'}
        });
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReportingFuiteEauController', ReportingFuiteEauController);

    ReportingFuiteEauController.$inject = ['$scope', '$state', '$filter', 'ParseLinks', 'AlertService', 'ReportingFuiteEau'];

    function ReportingFuiteEauController ($scope, $state, $filter,  ParseLinks, AlertService, ReportingFuiteEau) {
        var vm = this;
        vm.search=search;
        vm.date = {
                startDate: $state.params.startDate?new Date($state.params.startDate):null,
                endDate: $state.params.endDate?new Date($state.params.endDate):null

        };


        function onSuccess(data, headers) {
            vm.reportConsoEau = data;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }
        
        function search () {
            if ( vm.date.startDate && vm.date.endDate) {
            

	        	ReportingFuiteEau.query({
	        		fromDate:$filter('date')(new Date(vm.date.startDate), "yyyy-MM-dd"),
	        		toDate:$filter('date')(new Date(vm.date.endDate), "yyyy-MM-dd")
	            }, onSuccess, onError);
            }

        }

	      
		 $scope.openRangeDateTimePicker = function() {
					$('#daterange1').data('daterangepicker').toggle();
			}
		


    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ModelMeterController', ModelMeterController);

    ModelMeterController.$inject = ['$scope', '$state', 'ModelMeter', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ModelMeterController ($scope, $state, ModelMeter, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            ModelMeter.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.modelMeters = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('model-meter', {
            parent: 'entity',
            url: '/model-meter?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.modelMeter.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/model-meter/model-meters.html',
                    controller: 'ModelMeterController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modelMeter');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('model-meter-detail', {
            parent: 'entity',
            url: '/model-meter/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.modelMeter.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/model-meter/model-meter-detail.html',
                    controller: 'ModelMeterDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modelMeter');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ModelMeter', function($stateParams, ModelMeter) {
                    return ModelMeter.get({id : $stateParams.id});
                }]
            }
        })
        .state('model-meter.new', {
            parent: 'model-meter',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/model-meter/model-meter-dialog.html',
                    controller: 'ModelMeterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('model-meter', null, { reload: true });
                }, function() {
                    $state.go('model-meter');
                });
            }]
        })
        .state('model-meter.edit', {
            parent: 'model-meter',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/model-meter/model-meter-dialog.html',
                    controller: 'ModelMeterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ModelMeter', function(ModelMeter) {
                            return ModelMeter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('model-meter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('model-meter.delete', {
            parent: 'model-meter',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/model-meter/model-meter-delete-dialog.html',
                    controller: 'ModelMeterDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ModelMeter', function(ModelMeter) {
                            return ModelMeter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('model-meter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ModelMeter', ModelMeter);

    ModelMeter.$inject = ['$resource'];

    function ModelMeter ($resource) {
        var resourceUrl =  'api/model-meters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ModelMeterDialogController', ModelMeterDialogController);

    ModelMeterDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ModelMeter'];

    function ModelMeterDialogController ($scope, $stateParams, $uibModalInstance, entity, ModelMeter) {
        var vm = this;
        vm.modelMeter = entity;
        vm.load = function(id) {
            ModelMeter.get({id : id}, function(result) {
                vm.modelMeter = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:modelMeterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.modelMeter.id !== null) {
                ModelMeter.update(vm.modelMeter, onSaveSuccess, onSaveError);
            } else {
                ModelMeter.save(vm.modelMeter, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ModelMeterDetailController', ModelMeterDetailController);

    ModelMeterDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ModelMeter'];

    function ModelMeterDetailController($scope, $rootScope, $stateParams, entity, ModelMeter) {
        var vm = this;
        vm.modelMeter = entity;
        vm.load = function (id) {
            ModelMeter.get({id: id}, function(result) {
                vm.modelMeter = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:modelMeterUpdate', function(event, result) {
            vm.modelMeter = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ModelMeterDeleteController',ModelMeterDeleteController);

    ModelMeterDeleteController.$inject = ['$uibModalInstance', 'entity', 'ModelMeter'];

    function ModelMeterDeleteController($uibModalInstance, entity, ModelMeter) {
        var vm = this;
        vm.modelMeter = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ModelMeter.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('reporting-pending-field-documents', {
            parent: 'entity',
            url: '/reporting-pending-field-documents',
            data: {
                authorities: ['ROLE_READ_ONLY', 'ROLE_DATA_OPERATOR', 'ROLE_AREA_MANAGEMENT', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                pageTitle: 'wamasysApp.pendingFieldDocuments.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-pending-field-documents/reporting-pending-field-documents.html',
                    controller: 'ReportingPendingFieldDocumentsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pendingFieldDocuments');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('ReportingPendingFieldDocuments', ReportingPendingFieldDocuments);

    ReportingPendingFieldDocuments.$inject = ['$resource'];

    function ReportingPendingFieldDocuments($resource) {
        return $resource('api/reporting-pending-field-documents', {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReportingPendingFieldDocumentsController', ReportingPendingFieldDocumentsController);

    ReportingPendingFieldDocumentsController.$inject = ['AlertService', 'ReportingPendingFieldDocuments'];

    function ReportingPendingFieldDocumentsController(AlertService, ReportingPendingFieldDocuments) {
        var vm = this;

        vm.documents = [];
        vm.filteredDocuments = [];
        vm.areas = [];
        vm.filters = {};
        vm.sort = { field: 'lastModifiedDate', direction: 'asc' };
        vm.loading = false;
        vm.load = load;
        vm.applyFilters = applyFilters;
        vm.resetFilters = resetFilters;
        vm.count = count;
        vm.applySort = applySort;

        load();

        function load() {
            vm.loading = true;
            ReportingPendingFieldDocuments.query({}, onSuccess, onError);
        }

        function onSuccess(data) {
            vm.loading = false;
            vm.documents = data || [];
            vm.areas = buildAreas(vm.documents);
            applyFilters();
        }

        function onError(error) {
            vm.loading = false;
            AlertService.error(error && error.data && error.data.message ? error.data.message :
                'wamasysApp.pendingFieldDocuments.loadError');
        }

        function buildAreas(documents) {
            var byId = {};
            angular.forEach(documents, function(document) {
                if (!byId[document.areaId]) {
                    byId[document.areaId] = {
                        id: document.areaId,
                        label: areaLabel(document)
                    };
                }
            });
            return Object.keys(byId).map(function(id) { return byId[id]; }).sort(function(left, right) {
                return left.label.localeCompare(right.label);
            });
        }

        function areaLabel(document) {
            var code = document.areaCode ? document.areaCode + ' - ' : '';
            return code + (document.areaName || '');
        }

        function applyFilters() {
            var search = (vm.filters.search || '').toLowerCase();
            vm.filteredDocuments = vm.documents.filter(function(document) {
                if (vm.filters.type && document.documentType !== vm.filters.type) return false;
                if (vm.filters.status && document.status !== vm.filters.status) return false;
                if (vm.filters.areaId && document.areaId !== vm.filters.areaId) return false;
                if (!search) return true;
                var searchable = [document.reference, document.areaCode, document.areaName,
                    document.creatorLogin, document.collectorLogin, document.collectorDisplayName,
                    document.lastModifiedBy].join(' ').toLowerCase();
                return searchable.indexOf(search) !== -1;
            });
            applySort();
        }

        function sortValue(document) {
            var field = vm.sort.field;
            var value = document[field];
            if (field === 'lastModifiedDate') value = value || document.createdDate;
            if (value === null || value === undefined || value === '') return null;
            if (field === 'createdDate' || field === 'fieldDate' || field === 'lastModifiedDate') {
                var timestamp = new Date(value).getTime();
                return isNaN(timestamp) ? null : timestamp;
            }
            return String(value).toLowerCase();
        }

        function applySort() {
            // Trier la vue filtrée, avec les valeurs absentes en dernier dans les deux sens.
            vm.filteredDocuments.sort(function(left, right) {
                var leftValue = sortValue(left);
                var rightValue = sortValue(right);
                if (leftValue === null && rightValue !== null) return 1;
                if (rightValue === null && leftValue !== null) return -1;
                var compared = 0;
                if (leftValue !== null && rightValue !== null) {
                    compared = typeof leftValue === 'number' ? leftValue - rightValue : leftValue.localeCompare(rightValue);
                }
                if (compared) return vm.sort.direction === 'desc' ? -compared : compared;
                // Départage stable, même après un rafraîchissement ou entre une CL et une RF.
                return (left.documentType + '-' + left.documentId).localeCompare(right.documentType + '-' + right.documentId);
            });
        }

        function resetFilters() {
            vm.filters = {};
            applyFilters();
        }

        function count(type, status) {
            var total = 0;
            angular.forEach(vm.documents, function(document) {
                if ((!type || document.documentType === type) && (!status || document.status === status)) total++;
            });
            return total;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporting-payment-arrears', {
            parent: 'entity',
            url: '/reporting-payment-arrears?page&sort&searchQuery&agenceId&etat&compteurFerme&portefeuilleContrat&contractType&contractProfil&serviceVendu&startDate&endDate&onlinePaymentActive&onlinePaymentQuery&onlinePaymentType&anyBillSince&dontPaidSince&currentBalanceSigne&currentBalanceValue&tooMuchPaid&minAmountPaid&toDatePayment&minAmountBilled&toDateBilling&maxWaterConsumption&toDateWaterConsumption&filterBalanceWithService',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingAgence.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-payment-arrears/reporting-payment-arrears.html',
                    controller: 'ReportingPaymentArrearsController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('contrat');
                    $translatePartialLoader.addPart('etatContrat');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReportingPaymentArrearsController', ReportingPaymentArrearsController);

    ReportingPaymentArrearsController.$inject = ['$q','$scope', '$state', '$filter', 'Contrat','Principal', 'ParseLinks','$timeout', 'AlertService', 'pagingParams', 'paginationConstants','PortefeuilleContrat','ContratSearch','ContractType','ContractProfil','ServiceVendu'];

    function ReportingPaymentArrearsController ($q,$scope, $state, $filter, Contrat,Principal, ParseLinks,$timeout, AlertService, pagingParams, paginationConstants,PortefeuilleContrat,ContratSearch,ContractType,ContractProfil,ServiceVendu) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.etat = $state.params.etat;
        
        vm.portefeuilleContrats = PortefeuilleContrat.query({ offset: 0,size: 1000,sort: 'libelle,asc'});
        vm.contractTypes = ContractType.query({ offset: 0,size: 1000,sort: 'label,asc'});
        vm.contractProfils = ContractProfil.query({ offset: 0,size: 1000,sort: 'libelle,asc'});
        vm.serviceVendus = ServiceVendu.queryInclDeleted({ offset: 0,size: 1000,sort: 'libelle,asc'});


        if($state.params.portefeuilleContrat){
//        	vm.portefeuilleContrat = {
//        			id:$state.params.portefeuilleContrat
//        	}
        	vm.portefeuilleContrat = [];
        	$state.params.portefeuilleContrat.split(",").map(
    			function(elem){ 
    				vm.portefeuilleContrat.push({	id:elem});
    		});
        			
	    	if(vm.portefeuilleContrats && vm.portefeuilleContrats.$promise){
	    		vm.portefeuilleContrats.$promise.then(function(value) {
        	    	vm.portefeuilleContratNotPromise = [];
		        	$state.params.portefeuilleContrat.split(",").map(
		        			function (item) { 
		        				vm.portefeuilleContratNotPromise.push(
			    						value.find(function(obj) {
			    							return obj.id == item
			    						})
			    				);
			    			}
		        		);
			    	});	
		          }
        }
        if($state.params.contractType){
        	vm.contractType = [];
        	$state.params.contractType.split(",").map(
    			function(elem){ 
    				vm.contractType.push({	id:elem});
    		});
        			
	    	if(vm.contractTypes && vm.contractTypes.$promise){
	    		vm.contractTypes.$promise.then(function(value) {
        	    	vm.contractTypeNotPromise = [];
		        	$state.params.contractType.split(",").map(
		        			function (item) { 
		        				vm.contractTypeNotPromise.push(
			    						value.find(function(obj) {
			    							return obj.id == item
			    						})
			    				);
			    			}
		        		);
			    	});	
		          }
        }
        if($state.params.contractProfil){
        	vm.contractProfil = [];
        	$state.params.contractProfil.split(",").map(
    			function(elem){ 
    				vm.contractProfil.push({	id:elem});
    		});
        			
	    	if(vm.contractProfils && vm.contractProfils.$promise){
	    		vm.contractProfils.$promise.then(function(value) {
        	    	vm.contractProfilNotPromise = [];
		        	$state.params.contractProfil.split(",").map(
		        			function (item) { 
		        				vm.contractProfilNotPromise.push(
			    						value.find(function(obj) {
			    							return obj.id == item
			    						})
			    				);
			    			}
		        		);
			    	});	
		          }        	
        }
      
        
        if($state.params.serviceVendu){
        	vm.serviceVendu = [];
        	$state.params.serviceVendu.split(",").map(
    			function(elem){ 
    				vm.serviceVendu.push({	id:elem});
    		});
        			
	    	if(vm.serviceVendus && vm.serviceVendus.$promise){
	    		vm.serviceVendus.$promise.then(function(value) {
        	    	vm.serviceVenduNotPromise = [];
		        	$state.params.serviceVendu.split(",").map(
		        			function (item) { 
		        				vm.serviceVenduNotPromise.push(
			    						value.find(function(obj) {
			    							return obj.id == item
			    						})
			    				);
			    			}
		        		);
			    	});	
		          }
        }
        
        

        if($state.params.agenceId){
        	vm.agenceId = [];
        	$state.params.agenceId.split(",").map(
        		function(elem){ 
        			vm.agenceId.push({	id:elem});
        	});
        }
        
        Principal.identity().then(function(account) {
        	if(account.agencesRattachement){
        		vm.agencesRattachement = account.agencesRattachement;

        		vm.agenceIdNotPromise = [];
        		if(vm.agenceId && vm.agenceId.length >0){
        			
		        	$state.params.agenceId.split(",").map(
	        			function (item) { 
	        				vm.agenceIdNotPromise.push(
	        						account.agencesRattachement.find(function(obj) {
		    							return obj.id == item
		    						})
		    				);
		    			}
	        		);
        		}
        	}
        	
        	

			  
        });

        vm.onlinePaymentType = 	$state.params.onlinePaymentType;
        vm.onlinePaymentQuery = $state.params.onlinePaymentQuery;
        vm.onlinePaymentActive =$state.params.onlinePaymentActive;
        vm.currentBalanceValue=$state.params.currentBalanceValue;
        vm.currentBalanceSigne=$state.params.currentBalanceSigne;

        vm.minAmountPaid=$state.params.minAmountPaid;
        vm.minAmountBilled=$state.params.minAmountBilled;
        vm.maxWaterConsumption=$state.params.maxWaterConsumption;
    	       
        vm.searchQuery = $state.params.searchQuery;
        vm.compteurFerme = $state.params.compteurFerme;
    	vm.date = {
                 startDate: $state.params.startDate?new Date($state.params.startDate):null,
                 endDate: $state.params.endDate?new Date($state.params.endDate):null

         }
    	
    	vm.anyBillSince = $state.params.anyBillSince?new Date($state.params.anyBillSince):null;
    	vm.dontPaidSince = $state.params.dontPaidSince?new Date($state.params.dontPaidSince):null;
        vm.toDatePayment = $state.params.toDatePayment?new Date($state.params.toDatePayment):null;
        vm.toDateBilling = $state.params.toDateBilling?new Date($state.params.toDateBilling):null;
        vm.toDateWaterConsumption = $state.params.toDateWaterConsumption?new Date($state.params.toDateWaterConsumption):null;
    	vm.tooMuchPaid = $state.params.tooMuchPaid=="true"?true:false; 
    	vm.filterBalanceWithService = $state.params.filterBalanceWithService=="true"?true:false; 
    	
    	
    	vm.contrats = [];
        vm.totalItems = 0;
        vm.queryCount = 0;
        vm.page = 1;
        
        vm.loadAll();
        
    	vm.download = function(){
    		Contrat.downloadcsv( {
    			agenceId:vm.agenceId?vm.agenceId.map(function(elem){ return elem.id;}).join(","):null,	 
        		nom: vm.searchQuery,
        		compteurFerme: vm.compteurFerme,
        		portefeuilleContrat:vm.portefeuilleContrat?vm.portefeuilleContrat.map(function(elem){ return elem.id;}).join(","):null,	
                //contractType:vm.contractType?vm.contractType.id:null,
        		contractType:vm.contractType?vm.contractType.map(function(elem){ return elem.id;}).join(","):null,		
                contractProfil:vm.contractProfil?vm.contractProfil.map(function(elem){ return elem.id;}).join(","):null,	
                serviceVendu:vm.serviceVendu?vm.serviceVendu.map(function(elem){ return elem.id;}).join(","):null,
        		etat:vm.etat,
        		fromDate:$filter('date')(vm.date.startDate, "yyyy-MM-dd"),
        		toDate:$filter('date')(vm.date.endDate, "yyyy-MM-dd"),
        		onlinePaymentType:vm.onlinePaymentType,
        		onlinePaymentQuery:vm.onlinePaymentQuery,
        		onlinePaymentActive:vm.onlinePaymentActive,
    			anyBillSince:$filter('date')(vm.anyBillSince, "yyyy-MM-dd"),
        		dontPaidSince:$filter('date')(vm.dontPaidSince, "yyyy-MM-dd"),
        		currentBalanceSigne:vm.currentBalanceSigne,
        		currentBalanceValue:vm.currentBalanceValue,
        		tooMuchPaid:vm.tooMuchPaid,
        		filterBalanceWithService:vm.filterBalanceWithService,
        		minAmountPaid:vm.minAmountPaid,
                toDatePayment:$filter('date')(vm.toDatePayment, "yyyy-MM-dd"),
                minAmountBilled:vm.minAmountBilled,
        		toDateBilling:$filter('date')(vm.toDateBilling, "yyyy-MM-dd"),
        		maxWaterConsumption:vm.maxWaterConsumption,
        		toDateWaterConsumption:$filter('date')(vm.toDateWaterConsumption, "yyyy-MM-dd"),

        		}
    			,function (content){
    		      var url = URL.createObjectURL(content.response);
    		      var a = document.createElement('a');
    		      a.href = url;
    		      a.download = content.fileName;
    		      a.target = '_blank';
    		      a.click();
    		}
    				
    		);
    	}


//
//       	vm.downloadService = function(){
//    		Contrat.downloadServicecsv( {}
//    			,function (content){
//    		      var url = URL.createObjectURL(content.response);
//    		      var a = document.createElement('a');
//    		      a.href = url;
//    		      a.download = content.fileName;
//    		      a.target = '_blank';
//    		      a.click();
//    		}
//    				
//    		);
//    	}
//
//       	vm.downloadDetailServiceNotClosedcsv = function(){
//    		Contrat.downloadDetailServiceNotClosedcsv( {}
//    			,function (content){
//    		      var url = URL.createObjectURL(content.response);
//    		      var a = document.createElement('a');
//    		      a.href = url;
//    		      a.download = content.fileName;
//    		      a.target = '_blank';
//    		      a.click();
//    		}
//    				
//    		);
//    	}
//    
    


    
        
        function loadAll () {
            if (vm.searchQuery || vm.agenceId || vm.portefeuilleContrat  || vm.contractType    || vm.contractProfil  ||  vm.serviceVendu || vm.etat || vm.date.startDate || vm.date.endDate 
            		|| vm.compteurFerme	|| vm.onlinePaymentType	|| vm.onlinePaymentQuery	|| vm.onlinePaymentActive || vm.anyBillSince ||   vm.dontPaidSince ||vm.currentBalanceValue
            		|| vm.currentBalanceSigne ||vm.tooMuchPaid || vm.filterBalanceWithService|| vm.minAmountPaid || vm.toDatePayment || vm.minAmountBilled || vm.toDateBilling||vm.maxWaterConsumption||vm.toDateWaterConsumption) {


                vm.wait=true;
                vm.currentSearch=true;
            	ContratSearch.query({
            		agenceId: vm.agenceId?vm.agenceId.map(function(elem){ return elem.id;}).join(","):null, 
            		nom: vm.searchQuery,
            		compteurFerme: vm.compteurFerme,
            		portefeuilleContrat:vm.portefeuilleContrat?vm.portefeuilleContrat.map(function(elem){ return elem.id;}).join(","):null,
            //		contractType:vm.contractType?vm.contractType.id:null,
            		contractType:vm.contractType?vm.contractType.map(function(elem){ return elem.id;}).join(","):null,
            		contractProfil:vm.contractProfil?vm.contractProfil.map(function(elem){ return elem.id;}).join(","):null,
                    serviceVendu:vm.serviceVendu?vm.serviceVendu.map(function(elem){ return elem.id;}).join(","):null,
            		etat:vm.etat,
            		fromDate:$filter('date')(vm.date.startDate, "yyyy-MM-dd"),
            		toDate:$filter('date')(vm.date.endDate, "yyyy-MM-dd"),
            		onlinePaymentType:vm.onlinePaymentType,
            		onlinePaymentQuery:vm.onlinePaymentQuery,
            		onlinePaymentActive:vm.onlinePaymentActive,
            		anyBillSince:$filter('date')(vm.anyBillSince, "yyyy-MM-dd"),
            		dontPaidSince:$filter('date')(vm.dontPaidSince, "yyyy-MM-dd"),
            		currentBalanceSigne:vm.currentBalanceSigne,
            		currentBalanceValue:vm.currentBalanceValue,
            		tooMuchPaid:vm.tooMuchPaid,
            		filterBalanceWithService:vm.filterBalanceWithService,
            		minAmountPaid:vm.minAmountPaid,
            		toDatePayment:$filter('date')(vm.toDatePayment, "yyyy-MM-dd"),
            		minAmountBilled:vm.minAmountBilled,
            		toDateBilling:$filter('date')(vm.toDateBilling, "yyyy-MM-dd"),
            		maxWaterConsumption:vm.maxWaterConsumption,
            		toDateWaterConsumption:$filter('date')(vm.toDateWaterConsumption, "yyyy-MM-dd"),
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
//            } else {
//                vm.currentSearch=false;
//	            Contrat.query({
//	                page: pagingParams.page - 1,
//	                size: paginationConstants.itemsPerPage,
//	                sort: sort()
//	            }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
              
//                if (vm.predicate === 'id') {
//                    result.push('id,desc');
//                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.wait=false;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.contrats = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                vm.wait=false;
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                searchQuery: vm.searchQuery,
        		compteurFerme: vm.compteurFerme,
                startDate: vm.date.startDate,
                endDate: vm.date.endDate,
        		agenceId:vm.agenceIdNotPromise?vm.agenceIdNotPromise.map(function(elem){ return elem.id;}).join(","):null,
                contractType:vm.contractTypeNotPromise?vm.contractTypeNotPromise.map(function(elem){ return elem.id;}).join(","):null,
        		contractProfil:vm.contractProfilNotPromise?vm.contractProfilNotPromise.map(function(elem){ return elem.id;}).join(","):null,
        		serviceVendu:vm.serviceVenduNotPromise?vm.serviceVenduNotPromise.map(function(elem){ return elem.id;}).join(","):null,
                portefeuilleContrat: vm.portefeuilleContratNotPromise?vm.portefeuilleContratNotPromise.map(function(elem){ return elem.id;}).join(","):null,
                etat: vm.etat,
                currentSearch : vm.currentSearch,
        		onlinePaymentType:vm.onlinePaymentType,
        		onlinePaymentQuery:vm.onlinePaymentQuery,
        		onlinePaymentActive:vm.onlinePaymentActive,
        		currentBalanceSigne:vm.currentBalanceSigne,
        		currentBalanceValue:vm.currentBalanceValue,
        		anyBillSince:vm.anyBillSince,
        		dontPaidSince:vm.dontPaidSince,
        		tooMuchPaid:vm.tooMuchPaid,
        		filterBalanceWithService:vm.filterBalanceWithService,
        		minAmountPaid:vm.minAmountPaid,
                toDatePayment:vm.toDatePayment,
                minAmountBilled:vm.minAmountBilled,
        		toDateBilling:vm.toDateBilling,
        		maxWaterConsumption:vm.maxWaterConsumption,
        		toDateWaterConsumption:vm.toDateWaterConsumption,
            });
        }
        
        

        function search () {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '';
            vm.reverse = false;
            vm.currentSearch=true;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true; 
            vm.agenceId = null;
            vm.agenceIdNotPromise = null;
            vm.searchQuery= null;
    		 vm.compteurFerme = null;
             vm.date.startDate= null;
             vm.date.endDate= null;
             vm.portefeuilleContrat= null;
             vm.portefeuilleContratNotPromise= null;
             vm.contractType= null;
             vm.contractTypeNotPromise= null;
             vm.contractProfil= null;
             vm.contractProfilNotPromise= null;
             vm.serviceVendu= null;
             vm.serviceVenduNotPromise =null;
     		vm.onlinePaymentType =null;
    		vm.onlinePaymentQuery= null;
    		vm.onlinePaymentActive= null;
    		vm.anyBillSince =null;
    		vm.dontPaidSince =null;
    		vm.currentBalanceSigne =null;
    		vm.currentBalanceValue =null;
    		vm.tooMuchPaid =null;
    		vm.filterBalanceWithService =null;
    		vm.minAmountPaid =null;
            vm.toDatePayment =null;
            vm.minAmountBilled =null;
    		vm.toDateBilling =null;
            vm.etat= null;
    		vm.maxWaterConsumption =null;
            vm.toDateWaterConsumption= null;
            currentSearch : vm.currentSearch= null;
            vm.transition();
        }
        

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.anyBillSince = false;
        vm.datePickerOpenStatus.dontPaidSince = false;
        vm.datePickerOpenStatus.toDatePayment = false;
        vm.datePickerOpenStatus.toDateBilling = false;
        vm.datePickerOpenStatus.toDateWaterConsumption = false;


        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
        
        
        

        
        
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporting-consommation-eau', {
            parent: 'entity',
            url: '/reporting-consommation-eau',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingAgence.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-consommation-eau/reporting-consommation-eau.html',
                    controller: 'ReportingConsoEauController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ReportingConsommationEau', ReportingConsommationEau);

    ReportingConsommationEau.$inject = ['$resource'];

    function ReportingConsommationEau ($resource) {
        var resourceUrl =  'api/reporting-agence-conso-eau/search';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false}
        });
        
    }
})();;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReportingConsoEauController', ReportingConsoEauController);

    ReportingConsoEauController.$inject = ['$scope', '$state', '$filter', 'ParseLinks', 'AlertService', 'ReportingConsommationEau'];

    function ReportingConsoEauController ($scope, $state, $filter,  ParseLinks, AlertService, ReportingConsommationEau) {
        var vm = this;
        vm.search=search;
        vm.showExplanation=true;
        vm.date = {
                startDate: $state.params.startDate?new Date($state.params.startDate):null,
                endDate: $state.params.endDate?new Date($state.params.endDate):null
        };


        function onSuccess(data, headers) {
            vm.reporting = data;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }
        
        function search () {
            if ( vm.date.startDate && vm.date.endDate) {
            	vm.showExplanation = false;
            	ReportingConsommationEau.query({
	        		fromDate:$filter('date')(new Date(vm.date.startDate), "yyyy-MM-dd"),
	        		toDate:$filter('date')(new Date(vm.date.endDate), "yyyy-MM-dd")
	            }, onSuccess, onError);
            }

        }

	      
        $scope.openRangeDateTimePicker = function() {
				$('#daterange1').data('daterangepicker').toggle();
		}

        
		$scope.getTotalConsommationEauTotale = function() {
			var total = 0;
			if (vm.reporting != undefined) {
				for (var i = 0; i < vm.reporting.listeCluster.length; i++) {
					var cluster = vm.reporting.listeCluster[i];
					total += cluster.consommationEauTotale ;
				}

			}
			return total;
		}
		$scope.getTotalIndividualMeterActifs = function() {
			var total = 0;
			if (vm.reporting != undefined) {
				for (var i = 0; i < vm.reporting.listeCluster.length; i++) {
					var cluster = vm.reporting.listeCluster[i];
					total += cluster.nbrIndividualMeterActifs ;
				}

			}
			return total;
		}
		$scope.getTotalFamilles = function() {
			var total = 0;
			if (vm.reporting != undefined) {
				for (var i = 0; i < vm.reporting.listeCluster.length; i++) {
					var cluster = vm.reporting.listeCluster[i];
					total += cluster.nbrFamilles ;
				}
			}
			return total;
		}
		$scope.getTotalIndividus = function() {
			var total = 0;
			if (vm.reporting != undefined) {
				for (var i = 0; i < vm.reporting.listeCluster.length; i++) {
					var cluster = vm.reporting.listeCluster[i];
					total += cluster.nbrIndividus ;
				}
			}
			return total;
		}
		
		$scope.getTotalConsommationEauContrat = function() {
			var total = 0;
			if (vm.reporting != undefined) {
				for (var i = 0; i < vm.reporting.listeContractProfil.length; i++) {
					var contractProfil = vm.reporting.listeContractProfil[i];
					total += contractProfil.consommationEauTotale ;
				}
			}
			return total;
		}

		$scope.getTotalnbrIndividualMeterActifs = function() {
			var total = 0;
			if (vm.reporting != undefined) {
				for (var i = 0; i < vm.reporting.listeContractProfil.length; i++) {
					var contractProfil = vm.reporting.listeContractProfil[i];
					total += contractProfil.nbrIndividualMeterActifs ;
				}
			}
			return total;
		}
		
		$scope.getTotalnbrFamilles = function() {
			var total = 0;
			if (vm.reporting != undefined) {
				for (var i = 0; i < vm.reporting.listeContractProfil.length; i++) {
					var contractProfil = vm.reporting.listeContractProfil[i];
					total += contractProfil.nbrFamilles ;
				}
			}
			return total;
		}
		
		$scope.getTotalnbrIndividus = function() {
			var total = 0;
			if (vm.reporting != undefined) {
				for (var i = 0; i < vm.reporting.listeContractProfil.length; i++) {
					var contractProfil = vm.reporting.listeContractProfil[i];
					total += contractProfil.nbrIndividus ;
				}
			}
			return total;
		}
		
		
		$scope.getTotalConsommationEauBulk = function() {
			var total = 0;
			if (vm.reporting != undefined) {
				for (var i = 0; i < vm.reporting.listeBulkMeter.length; i++) {
					var bulk = vm.reporting.listeBulkMeter[i];
					total += bulk.consoEauTotale ;
				}
			}
			return total;
		}

		$scope.getPourcentagePerte = function() {

			return ($scope.getTotalConsommationEauBulk()- $scope.getTotalConsommationEauContrat ()) /$scope.getTotalConsommationEauBulk() * 100;
		}
		


	}
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporting-global-graph-eau', {
            parent: 'entity',
            url: '/reporting-global-graph-eau',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalGraphEauController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
        
        $stateProvider
        .state('reporting-global-graph-consoeauglobal', {
            parent: 'entity',
            url: '/reporting-global-graph-consoeauglobal',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalGraphConsEauGlobalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );
        
        

        $stateProvider
        .state('reporting-global-graph-stat-contrat', {
            parent: 'entity',
            url: '/reporting-global-graph-stat-contrat',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalGraphStatContratController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
        

        $stateProvider
        .state('reporting-global-graph-synthese', {
            parent: 'entity',
            url: '/reporting-global-graph-synthese',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalGraphSyntheseController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );
        

        $stateProvider
        .state('reporting-global-graph-synthese-hebdo', {
            parent: 'entity',
            url: '/reporting-global-graph-synthese-hebdo',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalGraphSyntheseHebdoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );
        

        $stateProvider
        .state('reporting-global-graph-anomalie-finances', {
            parent: 'entity',
            url: '/reporting-global-graph-anomalie-finances',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalGraphAnomalieFinancesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );


        $stateProvider
        .state('reporting-global-graph-anomalie-water', {
            parent: 'entity',
            url: '/reporting-global-graph-anomalie-water',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalGraphAnomalieWaterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );
        
        
        $stateProvider
        .state('reporting-global-graph-interagence', {
            parent: 'entity',
            url: '/reporting-global-graph-interagence',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalGraphInterAgenceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );

        $stateProvider
        .state('reporting-global-graph-summary-global', {
            parent: 'entity',
            url: '/reporting-global-graph-summary-global',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalGraphSummaryGlobalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );

        $stateProvider
        .state('reporting-global-graph-search-payment', {
            parent: 'entity',
            url: '/reporting-global-graph-search-payment',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalGraphSearchPaymentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );

        $stateProvider
        .state('reporting-global-graph-summary-annual-global', {
            parent: 'entity',
            url: '/reporting-global-graph-summary-annual-global',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalGraphSummaryAnnualController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );

        $stateProvider
        .state('reporting-global-geolocation', {
            parent: 'entity',
            url: '/reporting-global-geolocation',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalGeolocationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );

        $stateProvider
        .state('reporting-global-evenement', {
            parent: 'entity',
            url: '/reporting-global-evenement',
            data: {
                authorities: ['ROLE_EVT_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalEvenementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );


        $stateProvider
        .state('reporting-budget', {
            parent: 'entity',
            url: '/reporting-budget',
            data: {
                authorities: ['ROLE_BUDGET_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingBudgetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );


        $stateProvider
        .state('reporting-budget-global', {
            parent: 'entity',
            url: '/reporting-budget-global',
            data: {
                authorities: ['ROLE_BUDGET_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingBudgetGlobalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );
        
        
        $stateProvider
        .state('reporting-global-graph-stat-financial', {
            parent: 'entity',
            url: '/reporting-global-stat-financial',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalStatFinancialController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );

        $stateProvider
        .state('reporting-global-discount', {
            parent: 'entity',
            url: '/reporting-global-discount',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalDiscountController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );


        $stateProvider
        .state('reporting-global-iot-smart-water-meter', {
            parent: 'entity',
            url: '/reporting-iot-smart-water-meter',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalIOTSmartWaterMeterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );


        $stateProvider
        .state('reporting-global-iot-alert-meter', {
            parent: 'entity',
            url: '/reporting-iot-alert-meter',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalIOTAlertMeterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );
        

        $stateProvider
        .state('reporting-global-communication-reporting', {
            parent: 'entity',
            url: '/reporting-communication-reporting',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalCommunicationReportingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );
       

        $stateProvider
        .state('reporting-global-my-dashboard', {
            parent: 'entity',
            url: '/reporting-global-my-dashboard/{index}',
            data: {
                authorities: ['ROLE_READ_ONLY','ROLE_EVT_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global-graph-eau/reporting-global-graph-eau.html',
                    controller: 'ReportingGlobalMyDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	confDashboard: ['$stateParams', 'Principal', function($stateParams, Principal) {
                	return  Principal.identity().then(function(account) {
	           			 if(account.listDashboardKibana){
	                  		 try {
	                  			 if(typeof account.listDashboardKibana === 'string'){
	                      			 account.listDashboardKibana = JSON.parse(account.listDashboardKibana);
	                  			 }
	                  			 if( account.listDashboardKibana &&  account.listDashboardKibana.dashboards){
		                  			 for(var i  = 0;i<account.listDashboardKibana.dashboards.length;i++){
		                  				 if(account.listDashboardKibana.dashboards[i].index ==  $stateParams.index){
		                  					 return account.listDashboardKibana.dashboards[i];
		                  				 }
		                  			 } 
	                  			 }
	                  			 if( account.listDashboardKibana &&  account.listDashboardKibana.dashboardsmenu){
		                  			 for(var i  = 0;i<account.listDashboardKibana.dashboardsmenu.length;i++){
			                  			 for(var x  = 0;x<account.listDashboardKibana.dashboardsmenu[i].items.length;x++){
			                  				 if(account.listDashboardKibana.dashboardsmenu[i].items[x].index ==  $stateParams.index){
			                  					 return account.listDashboardKibana.dashboardsmenu[i].items[x];
			                  				 }
			                  			 }
		                  			 }
	                  			 }
	                   	    } catch (e) {
	                   	    	console.log(e);
	                   	    } 
	          			 }
	           			 return null;
	           			 
	                  });
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }  );
        
        
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ReportingGlobalGraphEau', ReportingGlobalGraphEau);

    ReportingGlobalGraphEau.$inject = ['$resource'];

    function ReportingGlobalGraphEau ($resource) {
        var resourceUrl =  'api/reporting-global-graph-eau/search';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false}
        });
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReportingGlobalGraphEauController', ReportingGlobalGraphEauController);

    ReportingGlobalGraphEauController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce', 'ReportingGlobalGraphEau', 'ReportingAgence'];

    function ReportingGlobalGraphEauController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce, ReportingGlobalGraphEau,ReportingAgence) {
        var vm = this;
        vm.idDashboard = "38306f10-d87d-11e8-8320-c93d887536a8";//OLD 03848d60-ecaf-11e7-8569-d570740c277c
	    vm.filtreagence = true;
	    ReportingAgence.saveOpenReportingElastic("Conso Eau par cluster "+vm.idDashboard);
    }
    
    
    angular
    .module('wamasysApp')
    .controller('ReportingGlobalGraphConsEauGlobalController', ReportingGlobalGraphConsEauGlobalController);

    ReportingGlobalGraphConsEauGlobalController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence'];
	
	function ReportingGlobalGraphConsEauGlobalController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence) {
	    var vm = this;
	    vm.idDashboard = "03848d60-ecaf-11e7-8569-d570740c277c";
	    vm.filtreagence = false;
	    ReportingAgence.saveOpenReportingElastic("Water consumption statistic "+vm.idDashboard);

	}

    angular
    .module('wamasysApp')
    .controller('ReportingGlobalGraphStatContratController', ReportingGlobalGraphStatContratController);

    ReportingGlobalGraphStatContratController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence'];
	
	function ReportingGlobalGraphStatContratController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence) {
	    var vm = this;
	    vm.idDashboard = "2f4aaad0-f7c5-11e7-84cb-dd097765c84d";
	    vm.filtreagence = false;
	    ReportingAgence.saveOpenReportingElastic("contract statistic "+vm.idDashboard);

	}
	

    angular
    .module('wamasysApp')
    .controller('ReportingGlobalGraphSyntheseController', ReportingGlobalGraphSyntheseController);

    ReportingGlobalGraphSyntheseController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence'];
	
	function ReportingGlobalGraphSyntheseController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence) {
	    var vm = this;
	    vm.idDashboard = "28265f70-4486-11e8-81c3-b55237bddc5a";
	    vm.filtreagence = true;
	    ReportingAgence.saveOpenReportingElastic("Area Summary "+vm.idDashboard);

	}


    angular
    .module('wamasysApp')
    .controller('ReportingGlobalGraphSyntheseHebdoController', ReportingGlobalGraphSyntheseHebdoController);

    ReportingGlobalGraphSyntheseHebdoController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence'];
	
	function ReportingGlobalGraphSyntheseHebdoController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence) {
	    var vm = this;
	    vm.idDashboard = "d0f660b0-c7ac-11e8-8320-c93d887536a8";
	    vm.periodKibana = true;
	    vm.filtreagence = true;
	    ReportingAgence.saveOpenReportingElastic("Daily summary "+vm.idDashboard);

	}

    angular
    .module('wamasysApp')
    .controller('ReportingGlobalGraphSummaryGlobalController', ReportingGlobalGraphSummaryGlobalController);

    ReportingGlobalGraphSummaryGlobalController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence'];
	
	function ReportingGlobalGraphSummaryGlobalController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence) {
	    var vm = this;
	    vm.idDashboard = "117dce80-c7ac-11e8-8320-c93d887536a8";
	    vm.filtreagence = false;
	    ReportingAgence.saveOpenReportingElastic("Branch synthèse globale "+vm.idDashboard);

	}
	


    angular
    .module('wamasysApp')
    .controller('ReportingGlobalGraphInterAgenceController', ReportingGlobalGraphInterAgenceController);

    ReportingGlobalGraphInterAgenceController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence'];
	
	function ReportingGlobalGraphInterAgenceController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence) {
	    var vm = this;
	    vm.idDashboard = "d0ca0300-fb68-11e7-a63c-93391761857f";
	    vm.filtreagence = false;
	    ReportingAgence.saveOpenReportingElastic("Inter agency "+vm.idDashboard);

	}
	
	

    angular
        .module('wamasysApp')
        .controller('ReportingGlobalGraphAnomalieWaterController', ReportingGlobalGraphAnomalieWaterController);

    ReportingGlobalGraphAnomalieWaterController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence', 'ReportingGlobalGraphEau'];

    function ReportingGlobalGraphAnomalieWaterController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence, ReportingGlobalGraphEau) {
        var vm = this;
        vm.idDashboard = "98e9dee0-9afc-11e8-8320-c93d887536a8";
	    vm.filtreagence = true;
	    ReportingAgence.saveOpenReportingElastic("Water anomalies "+vm.idDashboard);

    }
    


    angular
        .module('wamasysApp')
        .controller('ReportingGlobalGraphAnomalieFinancesController', ReportingGlobalGraphAnomalieFinancesController);

    ReportingGlobalGraphAnomalieFinancesController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence', 'ReportingGlobalGraphEau'];

    function ReportingGlobalGraphAnomalieFinancesController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence, ReportingGlobalGraphEau) {
        var vm = this;
        vm.idDashboard = "5c937b10-48c0-11e8-81c3-b55237bddc5a";
	    vm.filtreagence = true;
	    ReportingAgence.saveOpenReportingElastic("Payment arrears "+vm.idDashboard);

    }

    angular
        .module('wamasysApp')
        .controller('ReportingGlobalGraphSearchPaymentController', ReportingGlobalGraphSearchPaymentController);

    ReportingGlobalGraphSearchPaymentController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence', 'ReportingGlobalGraphEau'];

    function ReportingGlobalGraphSearchPaymentController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence, ReportingGlobalGraphEau) {
        var vm = this;
        vm.idDashboard = "25d4a220-6dae-11e9-a255-eb470cf68f80";
	    vm.filtreagence = true;
	    vm.periodKibana = false;
	    ReportingAgence.saveOpenReportingElastic("Audit trail "+vm.idDashboard);

    }

    angular
        .module('wamasysApp')
        .controller('ReportingGlobalGraphSummaryAnnualController', ReportingGlobalGraphSummaryAnnualController);

    ReportingGlobalGraphSummaryAnnualController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence', 'ReportingGlobalGraphEau'];

    function ReportingGlobalGraphSummaryAnnualController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence, ReportingGlobalGraphEau) {
        var vm = this;
        vm.idDashboard = "1f372e20-83b5-11e9-a255-eb470cf68f80";
	    vm.filtreagence = false;
	    vm.periodKibana = true;
	    ReportingAgence.saveOpenReportingElastic("Branch synthèse globale Annuelle "+vm.idDashboard);
    }
	
	

    angular
        .module('wamasysApp')
        .controller('ReportingGlobalGeolocationController', ReportingGlobalGeolocationController);

    ReportingGlobalGeolocationController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence', 'ReportingGlobalGraphEau'];

    function ReportingGlobalGeolocationController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence, ReportingGlobalGraphEau) {
        var vm = this;
        vm.idDashboard = "9b43b4f0-7037-11eb-836b-c9e6a4c376cd";//"b1a9d550-cd61-11e9-a255-eb470cf68f80";
	    vm.filtreagence = false;
	    vm.periodKibana = true;
	    ReportingAgence.saveOpenReportingElastic("Geolocation "+vm.idDashboard);
    }


    angular
        .module('wamasysApp')
        .controller('ReportingGlobalEvenementController', ReportingGlobalEvenementController);

    ReportingGlobalEvenementController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence', 'ReportingGlobalGraphEau'];

    function ReportingGlobalEvenementController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence, ReportingGlobalGraphEau) {
        var vm = this;
        vm.idDashboard = "62d2a520-78b0-11e9-a255-eb470cf68f80";
	    vm.filtreagence = false;
	    vm.periodKibana = true;
	    ReportingAgence.saveOpenReportingElastic("Evenement "+vm.idDashboard);
    }


    angular
        .module('wamasysApp')
        .controller('ReportingBudgetController', ReportingBudgetController);

    ReportingBudgetController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence', 'ReportingGlobalGraphEau'];

    function ReportingBudgetController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence, ReportingGlobalGraphEau) {
        var vm = this;
        vm.idDashboard = "2b3dd5e0-b5ba-11ec-b05f-dfee97821c63";
	    vm.filtreagence = true;
	    vm.periodKibana = true;
	    ReportingAgence.saveOpenReportingElastic("Expense for one area "+vm.idDashboard);
    }


    angular
        .module('wamasysApp')
        .controller('ReportingBudgetGlobalController', ReportingBudgetGlobalController);

    ReportingBudgetGlobalController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence', 'ReportingGlobalGraphEau'];

    function ReportingBudgetGlobalController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence, ReportingGlobalGraphEau) {
        var vm = this;
        vm.idDashboard = "5de23610-beef-11ec-b05f-dfee97821c63";
	    vm.filtreagence = false;
	    vm.periodKibana = true;
	    ReportingAgence.saveOpenReportingElastic("Global expense "+vm.idDashboard);
    }
    
    angular
        .module('wamasysApp')
        .controller('ReportingGlobalStatFinancialController', ReportingGlobalStatFinancialController);

    ReportingGlobalStatFinancialController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence', 'ReportingGlobalGraphEau'];

    function ReportingGlobalStatFinancialController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence, ReportingGlobalGraphEau) {
        var vm = this;
        vm.idDashboard = "786ea980-eb9a-11e9-b27e-752c6f6f8c92";
	    vm.filtreagence = true;
	    vm.periodKibana = false;
	    ReportingAgence.saveOpenReportingElastic("Financial statistic "+vm.idDashboard);
    }

    angular
        .module('wamasysApp')
        .controller('ReportingGlobalDiscountController', ReportingGlobalDiscountController);

    ReportingGlobalDiscountController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence', 'ReportingGlobalGraphEau'];

    function ReportingGlobalDiscountController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence, ReportingGlobalGraphEau) {
        var vm = this;
        vm.idDashboard = "a644d2d0-eb9a-11e9-b27e-752c6f6f8c92";
	    vm.filtreagence = false;
	    vm.periodKibana = false;
	    ReportingAgence.saveOpenReportingElastic("Discounts analyse "+vm.idDashboard);
    }

    angular
        .module('wamasysApp')
        .controller('ReportingGlobalIOTSmartWaterMeterController', ReportingGlobalIOTSmartWaterMeterController);

    ReportingGlobalIOTSmartWaterMeterController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence', 'ReportingGlobalGraphEau'];

    function ReportingGlobalIOTSmartWaterMeterController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence, ReportingGlobalGraphEau) {
        var vm = this;
        vm.idDashboard = "eeba3ae0-3876-11ea-b497-25fc6f82f62a";
	    vm.filtreagence = false;
	    vm.periodKibana = false;
	    ReportingAgence.saveOpenReportingElastic("Smart water meter "+vm.idDashboard);
    }


    angular
        .module('wamasysApp')
        .controller('ReportingGlobalCommunicationReportingController', ReportingGlobalCommunicationReportingController);

    ReportingGlobalCommunicationReportingController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence', 'ReportingGlobalGraphEau'];

    function ReportingGlobalCommunicationReportingController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence, ReportingGlobalGraphEau) {
        var vm = this;
        vm.idDashboard = "f280c690-faac-11f0-9df7-5bd2bba819bd";
	    vm.filtreagence = false;
	    vm.periodKibana = false;
	    ReportingAgence.saveOpenReportingElastic("Smart water meter "+vm.idDashboard);
    }
    
    
    angular
        .module('wamasysApp')
        .controller('ReportingGlobalIOTAlertMeterController', ReportingGlobalIOTAlertMeterController);

    ReportingGlobalIOTAlertMeterController.$inject = ['$scope', '$state', '$filter', 'ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence', 'ReportingGlobalGraphEau'];

    function ReportingGlobalIOTAlertMeterController ($scope, $state, $filter,  ParseLinks,Principal, AlertService, $sce ,ReportingAgence, ReportingGlobalGraphEau) {
        var vm = this;
        vm.idDashboard = "0f7c72c0-b860-11ef-97c7-891d46b98746";
	    vm.filtreagence = false;
	    vm.periodKibana = false;
	    ReportingAgence.saveOpenReportingElastic("Smart water alert "+vm.idDashboard);
    }
    
    

    angular
        .module('wamasysApp')
        .controller('ReportingGlobalMyDashboardController', ReportingGlobalMyDashboardController);

    ReportingGlobalMyDashboardController.$inject = ['$scope', '$state', '$filter', 'confDashboard','ParseLinks','Principal', 'AlertService','$sce' , 'ReportingAgence', 'ReportingGlobalGraphEau'];

    function ReportingGlobalMyDashboardController ($scope, $state, $filter, confDashboard, ParseLinks,Principal, AlertService, $sce ,ReportingAgence, ReportingGlobalGraphEau) {
        var vm = this;

        vm.endUrl = confDashboard.url;
		if (typeof confDashboard.filtreagence === 'undefined' || confDashboard.filtreagence === "false") {
			vm.filtreagence = false;
		} else {
			vm.filtreagence = true;
		}
		if (typeof confDashboard.periodKibana === 'undefined' || confDashboard.periodKibana === "false") {
			vm.periodKibana = false;
		} else {
			vm.periodKibana = true;
		}
	    ReportingAgence.saveOpenReportingElastic("Autre "+vm.endUrl);
    }
    
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporting-global', {
            parent: 'entity',
            url: '/reporting-global',
            data: {
                authorities: ['ROLE_READ_ONLY','ROLE_EVT_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-global/reporting-global.html',
                    controller: 'ReportingGlobalController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ReportingGlobal', ReportingGlobal);

    ReportingGlobal.$inject = ['$resource'];

    function ReportingGlobal ($resource) {
        var resourceUrl =  'api/reporting-global/search';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false}
        });
        
    }
    
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReportingGlobalController', ReportingGlobalController);

    ReportingGlobalController.$inject = ['$scope', '$state', '$filter', 'ParseLinks', 'AlertService', 'ReportingGlobal'];

    function ReportingGlobalController ($scope, $state, $filter,  ParseLinks, AlertService, ReportingGlobal) {
        var vm = this;
        vm.search=search;
        vm.date = {
                startDate: $state.params.startDate?new Date($state.params.startDate):null,
                endDate: $state.params.endDate?new Date($state.params.endDate):null

        };


        function onSuccess(data, headers) {
            vm.reporting = data;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }
        
        function search () {
            if ( vm.date.startDate && vm.date.endDate) {
            

	        	ReportingGlobal.query({
	        		fromDate:$filter('date')(new Date(vm.date.startDate), "yyyy-MM-dd"),
	        		toDate:$filter('date')(new Date(vm.date.endDate), "yyyy-MM-dd")
	            }, onSuccess, onError);
            }

        }

	      
		 $scope.openRangeDateTimePicker = function() {
					$('#daterange1').data('daterangepicker').toggle();
			}
		


    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporting-collection-list', {
            parent: 'entity',
            url: '/reporting-collection-list',
            data: {
                authorities: ['ROLE_READ_ONLY','ROLE_DATA_OPERATOR'],
                pageTitle: 'wamasysApp.reportingAgence.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-collection-list/reporting-collection-list.html',
                    controller: 'ReportingCollectionListController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('contrat');
                    $translatePartialLoader.addPart('reportingCollectionList');
                    
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ReportingCollectionList', ReportingCollectionList);

    ReportingCollectionList.$inject = ['$resource'];

    function ReportingCollectionList ($resource) {
        var resourceUrl =  'api/reporting-collection-list/search';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
        
    }
})();;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReportingCollectionListController', ReportingCollectionListController);

    ReportingCollectionListController.$inject = ['$scope', '$state', '$filter', 'ParseLinks', 'AlertService', 'ReportingCollectionList','Collecteur','ServiceVendu'];

    function ReportingCollectionListController ($scope, $state, $filter,  ParseLinks, AlertService, ReportingCollectionList,Collecteur,ServiceVendu) {
        var vm = this;
        vm.search=search;
        vm.collecteurs = Collecteur.query({ offset: 0,size: 1000,sort: 'login,asc'});
//        vm.date = {
//                startDate: $state.params.startDate?new Date($state.params.startDate):null,
//                endDate: $state.params.endDate?new Date($state.params.endDate):null
//
//        };

        vm.date = {
                startDate: moment().subtract(1, "month"),
                endDate: moment()
            };

        
        
        vm.serviceVendus = ServiceVendu.queryInclDeleted({ offset: 0,size: 1000,sort: 'libelle,asc'});

        function onSuccess(data, headers) {
            vm.reporting = data;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }
        
        function search () {
            if (vm.date.startDate && vm.date.endDate) {
               vm.reporting = null;
               var  collectorsParam = vm.collecteurNotPromise?vm.collecteurNotPromise.map(function(elem){ return elem.id;}).join(","):null;
               var  servicesVenduParam = vm.serviceVenduNotPromise?vm.serviceVenduNotPromise.map(function(elem){ return elem.id;}).join(","):null;
           
            	ReportingCollectionList.query({
	        		fromDate:$filter('date')(new Date(vm.date.startDate), "yyyy-MM-dd"),
	        		toDate:$filter('date')(new Date(vm.date.endDate), "yyyy-MM-dd"),
	        		collectors:collectorsParam,
	        		servicesVendu:servicesVenduParam
	            }, onSuccess, onError);
            }

        }

	      
        $scope.openRangeDateTimePicker = function() {
				$('#daterange1').data('daterangepicker').toggle();
		}
        
		$scope.getTotal = function(nomVar1, nomVar2) {
			
			var total = 0;

			if (vm.reporting != undefined) {
			    for (var i=0; i < vm.reporting.length; i++) {
			        if(nomVar1!= undefined){
						total = total + vm.reporting[i][nomVar1];
					}
					if(nomVar2!= undefined){
						total = total + vm.reporting[i][nomVar2];
					}
			    }
			
			}
			return total;
		}
		  
		$scope.getRatioCollecteTotal = function(clReporting) {
			var total = 0;

			if (clReporting != undefined) {
				total = ( clReporting.totalCollecteParCollecteur +clReporting.totalCorrectionPaiement) /  clReporting.totalACollecte  * 100;
			
			}
			return total;
		}
		
		$scope.getRatioCollecteFacture= function(clReporting) {
			var total = 0;

			if (clReporting!= undefined) {
				total = ( clReporting.totalCollecteParCollecteur +clReporting.totalCorrectionPaiement) /  clReporting.totalFacture  * 100;
			
			}
			return total;
		}
		
		
		$scope.getTotalRatioCollecteTotal = function() {
			var total = 0;


			if (vm.reporting != undefined) {

				var ttotalCollecteParCollecteur = 	$scope.getTotal('totalCollecteParCollecteur');
				var ttotalCorrectionPaiement = 	$scope.getTotal('totalCorrectionPaiement');
				var ttotalACollecte = 	$scope.getTotal('totalACollecte');
				
				total = ( ttotalCollecteParCollecteur +ttotalCorrectionPaiement) /  ttotalACollecte  * 100;
				
			}
			return total;
		}
		
		$scope.getTotalRatioCollecteFacture= function() {
			var total = 0;

			if (vm.reporting != undefined) {

				var ttotalCollecteParCollecteur = 	$scope.getTotal('totalCollecteParCollecteur');
				var ttotalCorrectionPaiement = 	$scope.getTotal('totalCorrectionPaiement');
				var ttotalFacture = 	$scope.getTotal('totalFacture');
				
				total = ( ttotalCollecteParCollecteur +ttotalCorrectionPaiement) /  ttotalFacture  * 100;
				
			}
			return total;
			
			
		}
		
	}
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporting-casnonreleve', {
            parent: 'entity',
            url: '/reporting-casnonreleve?page&sort&searchQuery&agenceId&cluster&casNonReleve&collecteur&startDate&endDate',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingAgence.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-casnonreleve/reporting-casnonreleve.html',
                    controller: 'ReportingCasNonReleveController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('casNonReleve');
                    $translatePartialLoader.addPart('cluster');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReportingCasNonReleveController', ReportingCasNonReleveController);

    ReportingCasNonReleveController.$inject = ['$q','$scope', '$state', '$filter', 'Principal', 'ParseLinks','$timeout', 'AlertService', 'pagingParams', 'paginationConstants','Cluster','CasNonReleve','Collecteur'];

    function ReportingCasNonReleveController ($q,$scope, $state, $filter, Principal, ParseLinks,$timeout, AlertService, pagingParams, paginationConstants,Cluster,CasNonReleve,Collecteur) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        
        vm.clusters = Cluster.query({ offset: 0,size: 1000,sort: 'numeroSerie,asc'});
        vm.casNonReleves = CasNonReleve.query({ offset: 0,size: 1000,sort: 'libelle,asc'});
        vm.collecteurs = Collecteur.query({ offset: 0,size: 1000,sort: 'login,asc'});
 

        if($state.params.cluster){
//        	vm.cluster = {
//        			id:$state.params.cluster
//        	}
        	vm.cluster = [];
        	$state.params.cluster.split(",").map(
    			function(elem){ 
    				vm.cluster.push({	id:elem});
    		});
        			
	    	if(vm.clusters && vm.clusters.$promise){
	    		vm.clusters.$promise.then(function(value) {
        	    	vm.clusterNotPromise = [];
		        	$state.params.cluster.split(",").map(
		        			function (item) { 
		        				vm.clusterNotPromise.push(
			    						value.find(function(obj) {
			    							return obj.id == item
			    						})
			    				);
			    			}
		        		);
			    	});	
		          }
        }
        if($state.params.casNonReleve){
        	vm.casNonReleve = [];
        	$state.params.casNonReleve.split(",").map(
    			function(elem){ 
    				vm.casNonReleve.push({	id:elem});
    		});
        			
	    	if(vm.casNonReleves && vm.casNonReleves.$promise){
	    		vm.casNonReleves.$promise.then(function(value) {
        	    	vm.casNonReleveNotPromise = [];
		        	$state.params.casNonReleve.split(",").map(
		        			function (item) { 
		        				vm.casNonReleveNotPromise.push(
			    						value.find(function(obj) {
			    							return obj.id == item
			    						})
			    				);
			    			}
		        		);
			    	});	
		          }
        }
        if($state.params.collecteur){
        	vm.collecteur = [];
        	$state.params.collecteur.split(",").map(
    			function(elem){ 
    				vm.collecteur.push({	id:elem});
    		});
        			
	    	if(vm.collecteurs && vm.collecteurs.$promise){
	    		vm.collecteurs.$promise.then(function(value) {
        	    	vm.collecteurNotPromise = [];
		        	$state.params.collecteur.split(",").map(
		        			function (item) { 
		        				vm.collecteurNotPromise.push(
			    						value.find(function(obj) {
			    							return obj.id == item
			    						})
			    				);
			    			}
		        		);
			    	});	
		          }        	
        }
 
        

        if($state.params.agenceId){
        	vm.agenceId = [];
        	$state.params.agenceId.split(",").map(
        		function(elem){ 
        			vm.agenceId.push({	id:elem});
        	});
        }
        
        Principal.identity().then(function(account) {
            if (account && account.agencesRattachement && account.agencesRattachement.length) {
                bindAreaSelection(account);
                return;
            }

            Principal.identity(true).then(function(refreshedAccount) {
                if (refreshedAccount && refreshedAccount.agencesRattachement && refreshedAccount.agencesRattachement.length) {
                    bindAreaSelection(refreshedAccount);
                }
            });
        });

        function bindAreaSelection(account) {
            vm.agencesRattachement = account.agencesRattachement;
            vm.agenceIdNotPromise = [];
            if (vm.agenceId && vm.agenceId.length > 0) {
                $state.params.agenceId.split(',').map(function(item) {
                    vm.agenceIdNotPromise.push(
                        account.agencesRattachement.find(function(obj) {
                            return obj.id == item;
                        })
                    );
                });
            }
        }


        vm.searchQuery = $state.params.searchQuery;
    	vm.date = {
                 startDate: $state.params.startDate?new Date($state.params.startDate):null,
                 endDate: $state.params.endDate?new Date($state.params.endDate):null

         }
    	
    	vm.contrats = [];
        vm.totalItems = 0;
        vm.queryCount = 0;
        vm.page = 1;
        
        vm.loadAll();
        
    	vm.download = function(){
    		CasNonReleve.downloadcsv( {
    			agenceId:vm.agenceId?vm.agenceId.map(function(elem){ return elem.id;}).join(","):null,	 
        		nom: vm.searchQuery,
        		clusterId:vm.cluster?vm.cluster.map(function(elem){ return elem.id;}).join(","):null,	
        		casNonReleveId:vm.casNonReleve?vm.casNonReleve.map(function(elem){ return elem.id;}).join(","):null,		
                collecteurId:vm.collecteur?vm.collecteur.map(function(elem){ return elem.id;}).join(","):null,	
      
        		fromDate:$filter('date')(vm.date.startDate, "yyyy-MM-dd"),
        		toDate:$filter('date')(vm.date.endDate, "yyyy-MM-dd")

        		}
    			,function (content){
    		      var url = URL.createObjectURL(content.response);
    		      var a = document.createElement('a');
    		      a.href = url;
    		      a.download = content.fileName;
    		      a.target = '_blank';
    		      a.click();
    		}
    				
    		);
    	}



    


    
        
        function loadAll () {
            if (vm.searchQuery || vm.agenceId || vm.cluster  || vm.casNonReleve    || vm.collecteur   ||  vm.date.startDate || vm.date.endDate ) {


                vm.wait=true;
                vm.currentSearch=true;
            	CasNonReleve.search({
            		agenceId: vm.agenceId?vm.agenceId.map(function(elem){ return elem.id;}).join(","):null, 
            		nom: vm.searchQuery,
            		clusterId:vm.cluster?vm.cluster.map(function(elem){ return elem.id;}).join(","):null,
            		casNonReleveId:vm.casNonReleve?vm.casNonReleve.map(function(elem){ return elem.id;}).join(","):null,
            		collecteurId:vm.collecteur?vm.collecteur.map(function(elem){ return elem.id;}).join(","):null,
                    fromDate:$filter('date')(vm.date.startDate, "yyyy-MM-dd"),
            		toDate:$filter('date')(vm.date.endDate, "yyyy-MM-dd"),
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
            	// Obtenez la date actuelle
            	var currentDate = new Date();
            	currentDate.setMonth(currentDate.getMonth() - 3);

            	vm.date.startDate = currentDate;
            	vm.date.endDate  = new Date();
            	
                vm.currentSearch=false;
                CasNonReleve.search({
	                page: pagingParams.page - 1,
	                size: paginationConstants.itemsPerPage,
	                sort: sort()
	            }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
              
//                if (vm.predicate === 'id') {
//                    result.push('id,desc');
//                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.wait=false;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.contrats = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                vm.wait=false;
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                searchQuery: vm.searchQuery,
                startDate: vm.date.startDate,
                endDate: vm.date.endDate,
        		agenceId:vm.agenceIdNotPromise?vm.agenceIdNotPromise.map(function(elem){ return elem.id;}).join(","):null,
                casNonReleve:vm.casNonReleveNotPromise?vm.casNonReleveNotPromise.map(function(elem){ return elem.id;}).join(","):null,
        		collecteur:vm.collecteurNotPromise?vm.collecteurNotPromise.map(function(elem){ return elem.id;}).join(","):null,
                cluster: vm.clusterNotPromise?vm.clusterNotPromise.map(function(elem){ return elem.id;}).join(","):null,
                currentSearch : vm.currentSearch
            });
        }
        
        

        function search () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = '';
            vm.reverse = false;
            vm.currentSearch=true;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true; 
            vm.agenceId = null;
            vm.agenceIdNotPromise = null;
            vm.searchQuery= null;
             vm.date.startDate= null;
             vm.date.endDate= null;
             vm.cluster= null;
             vm.clusterNotPromise= null;
             vm.casNonReleve= null;
             vm.casNonReleveNotPromise= null;
             vm.collecteur= null;
             vm.collecteurNotPromise= null;
             vm.serviceVendu= null;
             vm.serviceVenduNotPromise =null;
            currentSearch : vm.currentSearch= null;
            vm.transition();
        }
        

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.toDatePayment = false;


        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
        
        
        

        
        
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporting-agence', {
            parent: 'entity',
            url: '/reporting-agence',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingAgence.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-agence/reporting-agence.html',
                    controller: 'ReportingAgenceController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('zoneAnalysis');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('contrat');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ReportingAgence', ReportingAgence);

    ReportingAgence.$inject = ['$resource'];

    function ReportingAgence ($resource) {
        var resourceUrl =  'api/reporting-agence/search';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'summary': { 
              	url :'/api/reporting-agence/summary',
              	method: 'GET',
              	isArray: false
             },
            'download': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/reporting-agence/downloadcsv',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },
            'downloadCsvBilling': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/reporting-agence/download-billing',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },
            'downloadCsvFinancialAdjustement': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/reporting-agence/download-financial-adjustement',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },
            'downloadCsvPayments': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/reporting-agence/download-payment',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },
            'saveOpenReportingElastic': {
                method: 'POST',
              	url :'/api/reporting/view_reporting',
              	isArray: false
            }
        });
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReportingAgenceController', ReportingAgenceController);

    ReportingAgenceController.$inject = ['$scope', '$state', '$filter', 'ParseLinks', 'AlertService', 'ReportingAgence','Factures'];

    function ReportingAgenceController ($scope, $state, $filter,  ParseLinks, AlertService, ReportingAgence,Factures) {
        var vm = this;
        vm.search=search;
        vm.newSearch=newSearch;
        vm.date = {
                startDate: $state.params.startDate?new Date($state.params.startDate):null,
                endDate: $state.params.endDate?new Date($state.params.endDate):null

        };


        function onSuccess(data, headers) {
            vm.reporting = data;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }
        
        
        function newSearch () {
            if ( vm.date.startDate && vm.date.endDate) {
            	vm.reporting = null;
	        	ReportingAgence.summary({
	        		fromDate:$filter('date')(new Date(vm.date.startDate), "yyyy-MM-dd"),
	        		toDate:$filter('date')(new Date(vm.date.endDate), "yyyy-MM-dd")
	            }, onSuccess, onError);
            }

        }
        
        function search () {
            if ( vm.date.startDate && vm.date.endDate && vm.reporting.listeContractProfil ==null) {
//            	vm.reporting = null;
	        	ReportingAgence.query({
	        		fromDate:$filter('date')(new Date(vm.date.startDate), "yyyy-MM-dd"),
	        		toDate:$filter('date')(new Date(vm.date.endDate), "yyyy-MM-dd")
	            }, onSuccess, onError);
            }

        }

	      
        $scope.openRangeDateTimePicker = function() {
				$('#daterange1').data('daterangepicker').toggle();
		}

        
		$scope.getTotalConsommationEauTotale = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeCluster!= undefined) {
				for (var i = 0; i < vm.reporting.listeCluster.length; i++) {
					var cluster = vm.reporting.listeCluster[i];
					total += cluster.consommationEauTotale ;
				}

			}
			return total;
		}
		$scope.getTotalIndividualMeterActifs = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeCluster!= undefined) {
				for (var i = 0; i < vm.reporting.listeCluster.length; i++) {
					var cluster = vm.reporting.listeCluster[i];
					total += cluster.nbrIndividualMeterActifs ;
				}

			}
			return total;
		}
		$scope.getTotalFamilles = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeCluster!= undefined) {
				for (var i = 0; i < vm.reporting.listeCluster.length; i++) {
					var cluster = vm.reporting.listeCluster[i];
					total += cluster.nbrFamilles ;
				}
			}
			return total;
		}
		$scope.getTotalIndividus = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeCluster!= undefined) {
				for (var i = 0; i < vm.reporting.listeCluster.length; i++) {
					var cluster = vm.reporting.listeCluster[i];
					total += cluster.nbrIndividus ;
				}
			}
			return total;
		}
		
		$scope.getTotalConsommationEauContrat = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeContractProfil!= undefined ) {
				for (var i = 0; i < vm.reporting.listeContractProfil.length; i++) {
					var contractProfil = vm.reporting.listeContractProfil[i];
					total += contractProfil.consommationEauTotale ;
				}
			}
			return total;
		}

		$scope.getTotalnbrIndividualMeterActifs = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeContractProfil!= undefined) {
				for (var i = 0; i < vm.reporting.listeContractProfil.length; i++) {
					var contractProfil = vm.reporting.listeContractProfil[i];
					total += contractProfil.nbrIndividualMeterActifs ;
				}
			}
			return total;
		}
		
		$scope.getTotalnbrFamilles = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeContractProfil!= undefined) {
				for (var i = 0; i < vm.reporting.listeContractProfil.length; i++) {
					var contractProfil = vm.reporting.listeContractProfil[i];
					total += contractProfil.nbrFamilles ;
				}
			}
			return total;
		}
		
		$scope.getTotalnbrIndividus = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeContractProfil!= undefined) {
				for (var i = 0; i < vm.reporting.listeContractProfil.length; i++) {
					var contractProfil = vm.reporting.listeContractProfil[i];
					total += contractProfil.nbrIndividus ;
				}
			}
			return total;
		}
		
		
		$scope.getTotalConsommationEauBulk = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeBulkMeter!= undefined) {
				for (var i = 0; i < vm.reporting.listeBulkMeter.length; i++) {
					var bulk = vm.reporting.listeBulkMeter[i];
					total += bulk.consoEauTotale ;
				}
			}
			return total;
		}
		

		
		$scope.getTotalAcompteFacture = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeTypeService!= undefined) {
				for (var i = 0; i < vm.reporting.listeTypeService.length; i++) {
					var typeService = vm.reporting.listeTypeService[i];
					total += typeService.totalAcompteFacture ;
				}
			}
			return total;
		}
		$scope.getTotalFactureViaCL = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeTypeService!= undefined) {
				for (var i = 0; i < vm.reporting.listeTypeService.length; i++) {
					var typeService = vm.reporting.listeTypeService[i];
					total += typeService.totalFactureViaCL ;
				}
			}
			return total;
		}
		$scope.getTotalAPayer = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeTypeService!= undefined) {
				for (var i = 0; i < vm.reporting.listeTypeService.length; i++) {
					var typeService = vm.reporting.listeTypeService[i];
					total += typeService.totalAPayer +  typeService.cumulDiscount  ;
				}
			}
			return total;
		}
		$scope.getTotalCumulPenaliteRemise = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeTypeService!= undefined) {
				for (var i = 0; i < vm.reporting.listeTypeService.length; i++) {
					var typeService = vm.reporting.listeTypeService[i];
					total += typeService.cumulPenaliteRemise ;
				}
			}
			return total;
		}
		$scope.getTotalCumulRegul = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeTypeService!= undefined) {
				for (var i = 0; i < vm.reporting.listeTypeService.length; i++) {
					var typeService = vm.reporting.listeTypeService[i];
					total += typeService.cumulRegul ;
				}
			}
			return total;
		}

		$scope.getTotalAvoir = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeTypeService!= undefined) {
				for (var i = 0; i < vm.reporting.listeTypeService.length; i++) {
					var typeService = vm.reporting.listeTypeService[i];
					total += typeService.cumulCreditNote ;
				}
			}
			return total;
		}
		
		$scope.getTotalDiscount = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeTypeService!= undefined) {
				for (var i = 0; i < vm.reporting.listeTypeService.length; i++) {
					var typeService = vm.reporting.listeTypeService[i];
					total += typeService.cumulDiscount;
				}
			}
			return total;
		}
		
		$scope.getTotalFacture = function() {
			var total = 0;
			if (vm.reporting != undefined) {
				total =  $scope.getTotalAPayer() - $scope.getTotalDiscount() - $scope.getTotalAvoir();
			} 
			return total;
		}
		
		$scope.getTotalCollecte = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeTypeService!= undefined) {
				for (var i = 0; i < vm.reporting.listeTypeService.length; i++) {
					var typeService = vm.reporting.listeTypeService[i];
					total += typeService.totalCollecte;
				}
			}
			return total;
		}

		$scope.getTotalRefund = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeTypeService!= undefined) {
				for (var i = 0; i < vm.reporting.listeTypeService.length; i++) {
					var typeService = vm.reporting.listeTypeService[i];
					total += typeService.cumulRefund;
				}
			}
			return total;
		}

		
		$scope.getTotalPaymentBalanceTransfer = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeTypeService!= undefined) {
				for (var i = 0; i < vm.reporting.listeTypeService.length; i++) {
					var typeService = vm.reporting.listeTypeService[i];
					total += typeService.cumulPaymentBalanceTransfer;
				}
			}
			return total;
		}
		
		$scope.getTotalRefundBalanceTransfer = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeTypeService!= undefined) {
				for (var i = 0; i < vm.reporting.listeTypeService.length; i++) {
					var typeService = vm.reporting.listeTypeService[i];
					total += typeService.cumulRefundBalanceTransfer;
				}
			}
			return total;
		}

		
		$scope.getTotalCorrectionPayment = function() {
			var total = 0;
			if (vm.reporting != undefined && vm.reporting.listeTypeService!= undefined) {
				for (var i = 0; i < vm.reporting.listeTypeService.length; i++) {
					var typeService = vm.reporting.listeTypeService[i];
					total += typeService.cumulRefundPaymentCorrection;
				}
			}
			return total;
		}
		$scope.getTotalPaye = function() {
			var total = 0;
			if (vm.reporting != undefined) {
				total =  $scope.getTotalCollecte() + $scope.getTotalPaymentBalanceTransfer() - $scope.getTotalRefundBalanceTransfer() - $scope.getTotalRefund()+$scope.getTotalCorrectionPayment() ;
			} 
			return total;
		}

    	vm.download = function(){
    		ReportingAgence.download( {
        		fromDate:$filter('date')(new Date(vm.date.startDate), "yyyy-MM-dd"),
        		toDate:$filter('date')(new Date(vm.date.endDate), "yyyy-MM-dd")}
    			,function (content){
    		      var url = URL.createObjectURL(content.response);
    		      var a = document.createElement('a');
    		      a.href = url;
    		      a.download = content.fileName;
    		      a.target = '_blank';
    		      a.click();
    		}
    				
    		);
    	}
    	
    	
    	vm.downloadBilling = function(){
    		ReportingAgence.downloadCsvBilling( {
        		fromDate:$filter('date')(new Date(vm.date.startDate), "yyyy-MM-dd"),
        		toDate:$filter('date')(new Date(vm.date.endDate), "yyyy-MM-dd")}
    			,function (content){
    		      var url = URL.createObjectURL(content.response);
    		      var a = document.createElement('a');
    		      a.href = url;
    		      a.download = content.fileName;
    		      a.target = '_blank';
    		      a.click();
    		}
    				
    		);
    	}

    	vm.downloadFactureZip = function(){
   		 //Boite de dialog d'attente.
    		var $dialog = $(
    				'<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-hidden="true" style="padding-top:15%; overflow-y:visible;">' +
    				'<div class="modal-dialog modal-m">' +
    				'<div class="modal-content">' +
    					'<div class="modal-header"><h3 style="margin:0;"></h3></div>' +
    					'<div class="modal-body">' +
    						'<div class="progress progress-striped active" style="margin-bottom:0;"><div class="progress-bar" style="width: 100%"></div></div>' +
    					'</div>' +
    				'</div></div></div>');

    		var options = {};
    		var message = 'Please wait ! Action in progress.';
    		var settings = $.extend({
    			dialogSize: 'm',
    			progressType: '',
    			onHide: null // This callback runs after the dialog was hidden
    		}, options);
    		$dialog.find('.modal-dialog').attr('class', 'modal-dialog').addClass('modal-' + settings.dialogSize);
    		$dialog.find('.progress-bar').attr('class', 'progress-bar');
    		$dialog.find('h3').text(message);
			$dialog.modal();
			
    		Factures.downloadzip( {
        		fromDate:$filter('date')(new Date(vm.date.startDate), "yyyy-MM-dd"),
        		toDate:$filter('date')(new Date(vm.date.endDate), "yyyy-MM-dd")}
    			,function (content){
    		      var url = URL.createObjectURL(content.response);
    		      var a = document.createElement('a');
    		      a.href = url;
    		      a.download = content.fileName;
    		      a.target = '_blank';
    		      a.click();
  				$dialog.modal('hide');
    		},
    		function(error) {
				$dialog.modal('hide');
			}
    				
    		);
    	}

    	vm.downloadFinancialAdjustement = function(){
    		ReportingAgence.downloadCsvFinancialAdjustement( {
        		fromDate:$filter('date')(new Date(vm.date.startDate), "yyyy-MM-dd"),
        		toDate:$filter('date')(new Date(vm.date.endDate), "yyyy-MM-dd")}
    			,function (content){
    		      var url = URL.createObjectURL(content.response);
    		      var a = document.createElement('a');
    		      a.href = url;
    		      a.download = content.fileName;
    		      a.target = '_blank';
    		      a.click();
    		}
    				
    		);
    	}

	}
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('releve-compteur', {
            parent: 'entity',
            url: '/releve-compteur?page&sort&search&etat&collecteur&startDate&endDate',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.releveCompteur.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/releve-compteur/releve-compteurs.html',
                    controller: 'ReleveCompteurController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'dateReleve,desc',//'etat,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('releveCompteur');
                    $translatePartialLoader.addPart('individualMeter');
                    $translatePartialLoader.addPart('etatReleveCompteur');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('releve-compteur-detail', {
            parent: 'entity',
            url: '/releve-compteur/{id}',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.releveCompteur.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/releve-compteur/releve-compteur-detail.html',
                    controller: 'ReleveCompteurDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('releveCompteur');
                    $translatePartialLoader.addPart('etatReleveCompteur');
                    $translatePartialLoader.addPart('individualMeter');
                    return $translate.refresh();
                }]
            /*,
                entity: ['$stateParams', 'ReleveCompteur', function($stateParams, ReleveCompteur) {
                    return ReleveCompteur.get({id : $stateParams.id});
                }]*/
            }
        })
        .state('releve-compteur-map', {
            parent: 'entity',
            url: '/releve-compteur/{id}/map',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.releveCompteur.map.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/releve-compteur/releve-compteur-map.html',
                    controller: 'ReleveCompteurMapController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('releveCompteur');
                    $translatePartialLoader.addPart('etatReleveCompteur');
                    $translatePartialLoader.addPart('individualMeter');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('releve-compteur-control', {
            parent: 'entity',
            url: '/releve-compteur/{id}/control',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.releveCompteur.control.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/releve-compteur/releve-compteur-control.html',
                    controller: 'ReleveCompteurControlController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('releveCompteur');
                    $translatePartialLoader.addPart('etatReleveCompteur');
                    $translatePartialLoader.addPart('individualMeter');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('releve-compteur.new', {
            parent: 'releve-compteur',
            url: '/new',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/releve-compteur/releve-compteur-dialog.html',
                    controller: 'ReleveCompteurDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                            	dateReleve: null,
                                etat: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('releve-compteur', null, { reload: true });
                }, function() {
                    $state.go('releve-compteur');
                });
            }]
        })
  /*      .state('releve-compteur.edit', {
            parent: 'releve-compteur',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/releve-compteur/releve-compteur-dialog.html',
                    controller: 'ReleveCompteurDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ReleveCompteur', function(ReleveCompteur) {
                            return ReleveCompteur.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('releve-compteur', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        .state('releve-compteur.delete', {
            parent: 'releve-compteur',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/releve-compteur/releve-compteur-delete-dialog.html',
                    controller: 'ReleveCompteurDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ReleveCompteur', function(ReleveCompteur) {
                           // return {id : $stateParams.id};
                            return ReleveCompteur.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('releve-compteur', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ReleveCompteur', ReleveCompteur);

    ReleveCompteur.$inject = ['$resource', 'DateUtils'];

    function ReleveCompteur ($resource, DateUtils) {
        var resourceUrl =  'api/releve-compteurs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateReleve = DateUtils.convertLocalDateFromServer(data.dateReleve);
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.dateReleve = DateUtils.convertLocalDateToServer(data.dateReleve);
                    return angular.toJson(clonedData);
                }

            },
            'update': { method:'PUT' ,
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.dateReleve = DateUtils.convertLocalDateToServer(data.dateReleve);
                    return angular.toJson(clonedData);
                }},
            'applyReadingGpsToContract': { method:'POST', url :'api/releve-compteurs/:id/lignes/:idLigne/apply-reading-gps-to-contract'},
            'applyReadingGpsToMeter': { method:'POST', url :'api/releve-compteurs/:id/lignes/:idLigne/apply-reading-gps-to-meter'},
            'valider' :{method:'GET', url :'api/releve-compteurs/valider/:id'},
            'byIndividualMeter' :{method:'GET', url :'api/releve-compteurs/individual-meter/:id', isArray: true},
            'byBulkMeter' :{method:'GET', url :'api/releve-compteurs/bulk-meter/:id', isArray: true}
            ,
            'addReading': { 
           	 method:'POST',
            	 url :'api/releve-compteur/reading',
            	 transformRequest: function (data) {
            		var clonedData = Object.assign({}, data);
            		
                	//clonedData.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                	clonedData.readingDate = DateUtils.convertDateTimeFromServer(data.readingDate);
                   return angular.toJson(clonedData);
                    
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('ReleveCompteurSearch', ReleveCompteurSearch);

    ReleveCompteurSearch.$inject = ['$resource'];

    function ReleveCompteurSearch($resource) {
        var resourceUrl =  'api/releve-compteur/search/';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReleveCompteurController', ReleveCompteurController);

    ReleveCompteurController.$inject = ['$scope', '$state', '$filter', 'ReleveCompteur', 'ParseLinks', 'AlertService', 'ReleveCompteurSearch', 'Collecteur', 'pagingParams', 'paginationConstants'];

    function ReleveCompteurController ($scope, $state, $filter, ReleveCompteur, ParseLinks, AlertService, ReleveCompteurSearch, Collecteur, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.search = search;
        vm.clear = clear;
        vm.getMapUrl = getMapUrl;
		vm.getControlUrl = getControlUrl;
        vm.collecteurs = Collecteur.query({sort: 'login,asc'});
        if($state.params.etat){
        	vm.etat = $state.params.etat;
        }else{
        //	vm.etat = "VALIDE";
        }
        if($state.params.collecteur){
         	vm.collecteur = {
         			id:$state.params.collecteur
        	};
            if (vm.collecteurs && vm.collecteurs.$promise) {
                vm.collecteurs.$promise.then(function(collecteurs) {
                    var collecteurSelectionne = collecteurs.find(function(collecteur) {
                        return String(collecteur.id) === String($state.params.collecteur);
                    });
                    if (collecteurSelectionne) {
                        vm.collecteur = collecteurSelectionne;
                    }
                });
            }
        }
	   	vm.date = {
	            startDate: $state.params.startDate?new Date($state.params.startDate):null,
	            endDate: $state.params.endDate?new Date($state.params.endDate):null
	    }

        vm.loadAll();

        function loadAll () {
            ReleveCompteurSearch.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                etat:vm.etat,
                collecteur:vm.collecteur ? vm.collecteur.id : null,
         		fromDate:$filter('date')(vm.date.startDate, "yyyy-MM-dd"),
         		toDate:$filter('date')(vm.date.endDate, "yyyy-MM-dd"),
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.releveCompteurs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }
        
        function search () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = '';
            vm.reverse = false;
            vm.transition();
        }
        
        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.etat = null;
            vm.collecteur = null;
            vm.date.startDate = null;
            vm.date.endDate = null;
            vm.transition();
        }


        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                etat:vm.etat,
                collecteur:vm.collecteur?vm.collecteur.id:null,
                startDate: vm.date.startDate,
                endDate: vm.date.endDate
            });
        }

        function getMapUrl(id) {
            return $state.href('releve-compteur-map', {id: id});
        }

		function getControlUrl(id) {
		    return $state.href('releve-compteur-control', {id: id});
		}


    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReleveCompteurValidateConfirmController', ReleveCompteurValidateConfirmController);

    ReleveCompteurValidateConfirmController.$inject = ['$uibModalInstance'];

    function ReleveCompteurValidateConfirmController($uibModalInstance) {
        var vm = this;

        vm.clear = clear;
        vm.confirmValidation = confirmValidation;
        vm.confirmationInput = '';
        vm.confirmationText = 'I confirm';
        vm.isConfirmationValid = isConfirmationValid;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmValidation() {
            if (!isConfirmationValid()) {
                return;
            }

            $uibModalInstance.close(true);
        }

        function isConfirmationValid() {
            return (vm.confirmationInput || '').trim() === vm.confirmationText;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReleveCompteurMapController', ReleveCompteurMapController);

    ReleveCompteurMapController.$inject = ['$filter', '$stateParams', '$timeout', 'Agence', 'ReleveCompteur'];

    function ReleveCompteurMapController($filter, $stateParams, $timeout, Agence, ReleveCompteur) {
        var vm = this;

        vm.activePointKey = null;
        vm.areaGeometry = null;
        vm.filteredRows = [];
        vm.mapPoints = [];
        vm.mapRefreshToken = 0;
        vm.openContractPopup = openContractPopup;
        vm.openMeterPopup = openMeterPopup;
        vm.openReadingPopup = openReadingPopup;
        vm.releveCompteur = {};
        vm.rows = [];
        vm.showContractPopupAction = showContractPopupAction;
        vm.showContracts = true;
        vm.showMeterPopupAction = showMeterPopupAction;
        vm.showMeters = true;
        vm.showReadingPassage = true;
        vm.showReadingPopupAction = showReadingPopupAction;
        vm.showReadingTime = true;
        vm.showReadings = true;
        vm.updateVisibility = updateVisibility;

        if ($stateParams.id) {
            ReleveCompteur.get({id: $stateParams.id}, function(result) {
                vm.releveCompteur = result;
                vm.rows = buildRows(result);
                updateVisibility();
                loadAgencyGeometry(result.agenceId);
            });
        }

        function updateVisibility() {
            vm.activePointKey = null;
            vm.filteredRows = vm.rows.filter(function(row) {
                return (vm.showReadings && row.hasReadingPoint) ||
                    (vm.showContracts && row.hasContractPoint) ||
                    (vm.showMeters && row.hasMeterPoint);
            });

            vm.mapPoints = buildVisiblePoints(vm.filteredRows);
            vm.mapRefreshToken += 1;
        }

        function buildRows(releveCompteur) {
            var rows = [];
            var rowIndex = 0;

            angular.forEach(releveCompteur.clusterReleveCompteurDTO || [], function(clusterDto) {
                angular.forEach(clusterDto.ligneReleveCompteur || [], function(line) {
                    rows.push(buildRow(line, releveCompteur, false, rowIndex));
                    rowIndex += 1;
                });
            });

            angular.forEach(releveCompteur.listLigneReleveCompteurBulkMeter || [], function(line) {
                rows.push(buildRow(line, releveCompteur, true, rowIndex));
                rowIndex += 1;
            });

            rows.sort(function(a, b) {
                return compareOrder(a.orderTime, b.orderTime, a.rowIndex, b.rowIndex);
            });

            return rows;
        }

        function buildRow(line, releveCompteur, isBulkMeter, rowIndex) {
            var readingCoords = buildCoords(line.coordLat, line.coordLon);
            var contractCoords = buildCoords(line.lat, line.lon);
            var meterCoords = isBulkMeter ?
                buildCoords(line.bulkMeter && line.bulkMeter.latitude, line.bulkMeter && line.bulkMeter.longitude) :
                buildCoords(line.individualMeter && line.individualMeter.latitude, line.individualMeter && line.individualMeter.longitude);
            var orderTime = resolveOrderTime(line.readingDate, releveCompteur.dateReleve);
            var timeLabel = formatDate(line.readingDate, releveCompteur.dateReleve);
            var meterNumber = isBulkMeter ? (line.bulkMeter ? line.bulkMeter.numeroSerie : '') : (line.individualMeter ? line.individualMeter.numeroSerie : '');
            var valueLabel = buildReadingLabel(line);
            var hasRecordedReading = hasRecordedReadingValue(line);

            return {
                contractGpsLabel: formatCoordinateLabel(contractCoords),
                contractId: line.idContrat,
                contractPoint: contractCoords ? {
                    dateLabel: timeLabel,
                    focusZoom: 17,
                    key: 'contract-' + line.idLigneReleveCompteur,
                    kind: 'contract',
                    lat: contractCoords.lat,
                    lon: contractCoords.lon,
                    subtitle: meterNumber,
                    title: line.referenceContrat || line.nomContrat || '-',
                    valueLabel: valueLabel
                } : null,
                contractReference: line.referenceContrat || line.nomContrat || '-',
                hasContractPoint: !!contractCoords,
                hasRecordedReading: hasRecordedReading,
                hasMeterPoint: !!meterCoords,
                hasReadingPoint: !!readingCoords,
                id: line.idLigneReleveCompteur,
                isBulkMeter: isBulkMeter,
                meterGpsLabel: formatCoordinateLabel(meterCoords),
                meterId: isBulkMeter ? (line.bulkMeter ? line.bulkMeter.id : null) : (line.individualMeter ? line.individualMeter.id : null),
                meterNumber: meterNumber,
                meterPath: isBulkMeter ? '#/bulk-meter/' + (line.bulkMeter ? line.bulkMeter.id : '') : '#/individual-meter/' + (line.individualMeter ? line.individualMeter.id : ''),
                meterPoint: meterCoords ? {
                    dateLabel: timeLabel,
                    focusZoom: 17,
                    hasRecordedReading: hasRecordedReading,
                    key: 'meter-' + line.idLigneReleveCompteur,
                    kind: 'meter',
                    lat: meterCoords.lat,
                    lon: meterCoords.lon,
                    subtitle: line.referenceContrat || line.nomContrat || '-',
                    title: meterNumber,
                    valueLabel: valueLabel
                } : null,
                orderTime: orderTime,
                rowIndex: rowIndex,
                readingPoint: readingCoords ? {
                    dateLabel: timeLabel,
                    focusZoom: 17,
                    hasRecordedReading: hasRecordedReading,
                    key: 'reading-' + line.idLigneReleveCompteur,
                    kind: 'reading',
                    lat: readingCoords.lat,
                    lon: readingCoords.lon,
                    orderTime: orderTime,
                    subtitle: meterNumber,
                    title: line.referenceContrat || line.nomContrat || '-',
                        valueLabel: valueLabel
                } : null,
                readingGpsLabel: formatCoordinateLabel(readingCoords, line.coordPrecision),
                timeLabel: timeLabel,
                valueLabel: valueLabel
            };
        }

        function buildVisiblePoints(rows) {
            var points = [];
            var readingSequence = 0;

            angular.forEach(rows || [], function(row) {
                if (vm.showReadings && row.readingPoint) {
                    readingSequence += 1;
                    points.push(buildReadingPoint(row, readingSequence));
                }

                if (vm.showContracts && row.contractPoint) {
                    points.push(buildContractPoint(row));
                }

                if (vm.showMeters && row.meterPoint) {
                    points.push(buildMeterPoint(row));
                }
            });

            return points;
        }

        function buildReadingPoint(row, readingSequence) {
            var point = angular.copy(row.readingPoint);
            point.sequence = readingSequence;
            point.markerHtml = buildReadingMarkerHtml(readingSequence, row.timeLabel, row.hasRecordedReading);
            point.iconSize = [68, vm.showReadingTime ? 54 : 36];
            point.iconAnchor = [18, 18];
            point.popupAnchor = [0, -16];
            return point;
        }

        function buildContractPoint(row) {
            var point = angular.copy(row.contractPoint);
            point.markerHtml = '<div style="' +
                'background:#2f855a;color:#fff;border:2px solid #ffffff;border-radius:12px;' +
                'width:24px;height:24px;line-height:20px;text-align:center;font-weight:bold;' +
                'box-shadow:0 1px 5px rgba(0,0,0,0.35);font-size:12px;">C</div>';
            point.iconSize = [24, 24];
            point.iconAnchor = [12, 12];
            point.popupAnchor = [0, -12];
            return point;
        }

        function buildMeterPoint(row) {
            var point = angular.copy(row.meterPoint);
            var backgroundColor = row.hasRecordedReading ? '#2f855a' : '#c05621';
            point.markerHtml = '<div style="' +
                'background:' + backgroundColor + ';color:#fff;border:2px solid #ffffff;border-radius:12px;' +
                'width:24px;height:24px;line-height:20px;text-align:center;font-weight:bold;' +
                'box-shadow:0 1px 5px rgba(0,0,0,0.35);font-size:12px;">M</div>';
            point.iconSize = [24, 24];
            point.iconAnchor = [12, 12];
            point.popupAnchor = [0, -12];
            return point;
        }

        function buildReadingMarkerHtml(readingSequence, timeLabel, hasRecordedReading) {
            var badgeLabel = vm.showReadingPassage ? String(readingSequence) : 'L';
            var backgroundColor = hasRecordedReading ? '#2f855a' : '#c05621';
            var html = '<div style="display:flex;flex-direction:column;align-items:center;">' +
                '<div style="' +
                'background:' + backgroundColor + ';color:#fff;border:2px solid #ffffff;border-radius:18px;' +
                'min-width:30px;height:30px;line-height:26px;text-align:center;font-weight:bold;' +
                'padding:0 6px;box-shadow:0 1px 5px rgba(0,0,0,0.35);font-size:12px;">' +
                escapeHtml(badgeLabel) +
                '</div>';

            if (vm.showReadingTime && timeLabel) {
                html += '<div style="' +
                    'margin-top:3px;background:rgba(255,255,255,0.92);color:#1a202c;border-radius:10px;' +
                    'padding:2px 6px;font-size:10px;line-height:1.2;white-space:nowrap;' +
                    'box-shadow:0 1px 3px rgba(0,0,0,0.25);">' + escapeHtml(timeLabel) + '</div>';
            }

            html += '</div>';
            return html;
        }

        function openReadingPopup(row) {
            if (!row || !row.readingPoint) {
                return;
            }

            focusPoint(row.readingPoint.key);
        }

        function openContractPopup(row) {
            if (!row || !row.contractPoint) {
                return;
            }

            focusPoint(row.contractPoint.key);
        }

        function openMeterPopup(row) {
            if (!row || !row.meterPoint) {
                return;
            }

            focusPoint(row.meterPoint.key);
        }

        function focusPoint(pointKey) {
            vm.activePointKey = null;
            vm.mapRefreshToken += 1;

            $timeout(function() {
                vm.activePointKey = pointKey;
                vm.mapRefreshToken += 1;
            }, 0);
        }

        function showReadingPopupAction(row) {
            return vm.showReadings && row && row.hasReadingPoint;
        }

        function showContractPopupAction(row) {
            return vm.showContracts && row && row.hasContractPoint;
        }

        function showMeterPopupAction(row) {
            return vm.showMeters && row && row.hasMeterPoint;
        }

        function loadAgencyGeometry(agenceId) {
            vm.areaGeometry = null;

            if (!agenceId) {
                return;
            }

            Agence.get({id: agenceId}, function(agence) {
                vm.areaGeometry = agence ? agence.geographicCoord : null;
            });
        }

        function resolveOrderTime(readingDate, fallbackDate) {
            if (readingDate) {
                return new Date(readingDate).getTime();
            }
            if (fallbackDate) {
                return new Date(fallbackDate).getTime();
            }
            return 0;
        }

        function formatDate(readingDate, fallbackDate) {
            if (readingDate) {
                return $filter('date')(readingDate, 'shortTime');
            }
            if (fallbackDate) {
                return $filter('date')(fallbackDate, 'mediumDate');
            }
            return '';
        }

        function buildReadingLabel(line) {
            if (line.valeurReleve !== null && line.valeurReleve !== undefined && line.valeurReleve !== '') {
                return $filter('translate')('wamasysApp.releveCompteur.map.reading') + ': ' + line.valeurReleve;
            }
            if (line.casNonReleve && line.casNonReleve.libelle) {
                return $filter('translate')('wamasysApp.releveCompteur.map.nonReading') + ': ' + line.casNonReleve.libelle;
            }
            return $filter('translate')('wamasysApp.releveCompteur.map.noReading');
        }

        function hasRecordedReadingValue(line) {
            return line && line.valeurReleve !== null && line.valeurReleve !== undefined && line.valeurReleve !== '';
        }

        function buildCoords(latValue, lonValue) {
            var lat = parseCoordinate(latValue);
            var lon = parseCoordinate(lonValue);

            if (lat === null || lon === null) {
                return null;
            }

            return {
                lat: lat,
                lon: lon
            };
        }

        function formatCoordinateLabel(coords, precision) {
            if (!coords) {
                return '-';
            }

            var label = $filter('number')(coords.lat, 6) + ', ' + $filter('number')(coords.lon, 6);

            if (precision !== null && precision !== undefined && precision !== '') {
                label += ' (' + $filter('number')(precision, 1) + ' m)';
            }

            return label;
        }

        function compareOrder(firstTime, secondTime, firstIndex, secondIndex) {
            if (firstTime !== secondTime) {
                return firstTime - secondTime;
            }

            return firstIndex - secondIndex;
        }

        function parseCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = parseFloat(String(value).replace(',', '.'));
            return isNaN(parsedValue) ? null : parsedValue;
        }

        function escapeHtml(value) {
            return String(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReleveCompteurDialogController', ReleveCompteurDialogController);

    ReleveCompteurDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ReleveCompteur', 'UserSearch','Cluster','BulkMeter'];

    function ReleveCompteurDialogController ($scope, $stateParams, $uibModalInstance, entity, ReleveCompteur, UserSearch,Cluster,BulkMeter) {
        var vm = this;
        vm.releveCompteur = entity;
        vm.users = UserSearch.searchCollecteur();
        vm.listCluster =[];
        vm.listBulkMeter =[];
        

        vm.updateCollecteur = function() {
            vm.listCluster =[];
            vm.listBulkMeter =[];
            vm.releveCompteur.listeCluster = null;
            vm.releveCompteur.listeBulkMeter=null;
            
        	Cluster.clusterActifByCollecteur(
    				{idCollector : vm.releveCompteur.collecteur.id}, 
    				function(result) {
    						vm.listCluster =  result;
    		});
        	
        	BulkMeter.bulkMeterByCollecteur(
    				{idCollector : vm.releveCompteur.collecteur.id}, 
    				function(result) {
    						vm.listBulkMeter =  result;
    		});
    		
        };
        
        vm.load = function(id) {
            ReleveCompteur.get({id : id}, function(result) {
                vm.releveCompteur = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:releveCompteurUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            
            ReleveCompteur.save(vm.releveCompteur, onSaveSuccess, onSaveError);
            
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateReleve = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReleveCompteurDetailController', ReleveCompteurDetailController);

    ReleveCompteurDetailController.$inject = ['$scope','$filter', '$rootScope', '$state', '$stateParams', '$uibModal', 'ReleveCompteur', 'Principal'];

    function ReleveCompteurDetailController($scope,$filter, $rootScope, $state, $stateParams, $uibModal, ReleveCompteur, Principal) {
        var vm = this;

		vm.erreurReleve =false;
		vm.disableBtnSaveCancel =false;
		vm.disableBtnEdition =false;
        vm.getMapUrl = getMapUrl;
        vm.getControlUrl = getControlUrl;
        vm.load = function (id) {
            ReleveCompteur.get({id: id}, function(result) {
                vm.releveCompteur = result;
                $rootScope.$broadcast('updateLigneReleveCompteur', result);
            });
        };
        

		var user = {} ;
        Principal.identity().then(function(account) {
        	if(account){
              user =account ;
        	}
        });
     
        if($stateParams.id){
            vm.load($stateParams.id);
        }
        	
        var unsubscribe = $rootScope.$on('wamasysApp:releveCompteurUpdate', function(event, result) {
            vm.releveCompteur = result;
        });
        
        $scope.$on('$destroy', unsubscribe);

        //boite de dialog pour lecture de compteur
    	  
		var $dialog = $(
				'<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-hidden="true" style="padding-top:15%; overflow-y:visible;">' +
				'<div class="modal-dialog modal-m">' +
				'<div class="modal-content">' +
					'<div class="modal-header"><h3 style="margin:0;"></h3></div>' +
					'<div class="modal-body">' +
						'<div class="progress progress-striped active" style="margin-bottom:0;"><div class="progress-bar" style="width: 100%"></div></div>' +
					'</div>' +
				'</div></div></div>');

		var options = {};
		var message = 'Please wait ! Action in progress.';
		var settings = $.extend({
			dialogSize: 'm',
			progressType: '',
			onHide: null // This callback runs after the dialog was hidden
		}, options);
		$dialog.find('.modal-dialog').attr('class', 'modal-dialog').addClass('modal-' + settings.dialogSize);
		$dialog.find('.progress-bar').attr('class', 'progress-bar');
		$dialog.find('h3').text(message);
		

        vm.valider= function() {

        	if(! checkerDecimalAquatech()){
				return ; 
			}

            // Une RF encore en cours peut contenir des lectures non remontées depuis le smartphone.
            if (requiresValidationConfirmation()) {
                openValidationConfirmation().then(function() {
                    executeValidation();
                });
                return;
            }

            executeValidation();
        }

        function requiresValidationConfirmation() {
            return vm.releveCompteur && vm.releveCompteur.etat === 'ENCOURS';
        }

        function openValidationConfirmation() {
            return $uibModal.open({
                templateUrl: 'app/business/releve-compteur/releve-compteur-validate-confirm-dialog.html',
                controller: 'ReleveCompteurValidateConfirmController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md'
            }).result;
        }

        function executeValidation() {

			$dialog.modal();
			
        	ReleveCompteur.valider({id:vm.releveCompteur.id},  function(result) {
	            $scope.$emit('wamasysApp:releveCompteurUpdate', result);
	            vm.isSaving = false;
				$dialog.modal('hide');
			},function(error) {
				$dialog.modal('hide');
			}
        	);
        }

        vm.startEdit = function() {
			
			vm.disableBtnEdition =true;
			vm.disableBtnSaveCancel =false;
			jQuery("#btnSaveRows,#btnCancelRows").show();
		
			var grid = $("table[id^=jqgrid-table]");
			var ids = grid.jqGrid('getDataIDs');

			for (var i = 0; i < ids.length; i++) {
				grid.jqGrid('editRow', ids[i]);
			}
			
		};
		
		function hasDecimals(number) {
		    return number % 1 !== 0;
		}
		
		function checkerDecimalAquatech(){
			var erreur = false;//fixme mettre false
			var messageErreur = '';
			
		        
			if(! user.organisationName.includes('Aquatech') && !  user.organisationName.includes('aquatech')
					&& user.organisationId !== 26529364 && user.organisationId !== 25683601){
				return true;
			}
			
			if (vm.releveCompteur && vm.releveCompteur.clusterReleveCompteurDTO) {
				for (var i = 0; i < vm.releveCompteur.clusterReleveCompteurDTO.length; i++) {
					if (vm.releveCompteur.clusterReleveCompteurDTO[i].ligneReleveCompteur) {
						for (var x = 0, lenLigne =  vm.releveCompteur.clusterReleveCompteurDTO[i].ligneReleveCompteur.length; x < lenLigne; x++)  {
							if(	vm.releveCompteur.clusterReleveCompteurDTO[i].ligneReleveCompteur[x].valeurReleve && hasDecimals(	vm.releveCompteur.clusterReleveCompteurDTO[i].ligneReleveCompteur[x].valeurReleve)){
								erreur = true;
								messageErreur = messageErreur+ 'Erreur relevé avec décimale sur '+	vm.releveCompteur.clusterReleveCompteurDTO[i].ligneReleveCompteur[x].individualMeter.numeroSerie +'\n';
							}
						}
					}
				}
			}
			
			
			if (vm.releveCompteur && vm.releveCompteur.listLigneReleveCompteurBulkMeter) {
				for (var i = 0; i < vm.releveCompteur.listLigneReleveCompteurBulkMeter.length; i++) {
					if (vm.releveCompteur.listLigneReleveCompteurBulkMeter[i].bulkMeter) {
						if(	vm.releveCompteur.listLigneReleveCompteurBulkMeter[i].valeurReleve && hasDecimals(	vm.releveCompteur.listLigneReleveCompteurBulkMeter[i].valeurReleve)){
							erreur = true;
							messageErreur = messageErreur+ 'Erreur relevé avec décimale sur '+	vm.releveCompteur.listLigneReleveCompteurBulkMeter[i].bulkMeter.numeroSerie +'\n';
						}
					}
				}
			}
			
			if(erreur){
				alert('Vous avez des erreurs bloquantes pour la validation du relevé de compteur : \n'+messageErreur);
				return false;
			}
			
			return true;
		}
		
		
		vm.print = function() {
			 // var printContents = document.getElementById('full-screen-widget').innerHTML;
			  
			  var content = '<strong>'+ $filter('translate')('wamasysApp.releveCompteur.titreImprimerDetail')+' '+ $filter('date')(vm.releveCompteur.dateReleve, "mediumDate") 
			  +'</strong> '+ $filter('translate')('wamasysApp.releveCompteur.collecteur')+' :  '+vm.releveCompteur.collecteur.firstName + ' ' + vm.releveCompteur.collecteur.lastName+'<br>';
			


			              
				content += '<table style=" ">';
					content += '<tr><td>'+$filter('translate')('wamasysApp.individualMeter.type')+'</td><td>'+ $filter('translate')('wamasysApp.individualMeter.nomContrat')+'</td><td>'+$filter('translate')('wamasysApp.individualMeter.cluster')+'</td><td>'+ $filter('translate')('wamasysApp.individualMeter.runningOrder')
					+'</td><td>'+ $filter('translate')('wamasysApp.individualMeter.numeroSerie')+'</td><td>'+ $filter('translate')('wamasysApp.individualMeter.datePrecedenteLecture')+'</td><td>'+ $filter('translate')('wamasysApp.individualMeter.valeurPrecedenteLecture')+'</td>'
						+'<td style="width:60px;"></td><td style="width:60px;"></td><td style="width:60px;"></td><td style="width:60px;"></td><td style="width:60px;"></td></tr>';

				if (vm.releveCompteur && vm.releveCompteur.clusterReleveCompteurDTO) {
					for (var i = 0; i < vm.releveCompteur.clusterReleveCompteurDTO.length; i++) {

						if (vm.releveCompteur.clusterReleveCompteurDTO[i].ligneReleveCompteur) {
		
							for (var x = 0, lenLigne =  vm.releveCompteur.clusterReleveCompteurDTO[i].ligneReleveCompteur.length; x < lenLigne; x++)  {
		
							
		
							content += '<tr><td>'+ $filter('translate')('wamasysApp.releveCompteur.typeIndividualMeter')+'</td>'
								+'<td >'+vm.releveCompteur.clusterReleveCompteurDTO[i].ligneReleveCompteur[x].nomContrat+'</td><td>'+vm.releveCompteur.clusterReleveCompteurDTO[i].cluster.numeroSerie
								+'</td><td align="center">'+vm.releveCompteur.clusterReleveCompteurDTO[i].ligneReleveCompteur[x].individualMeter.runningOrder
							
								+'</td><td>'+ vm.releveCompteur.clusterReleveCompteurDTO[i].ligneReleveCompteur[x].individualMeter.numeroSerie+'</td><td>'
								+$filter('date')(vm.releveCompteur.clusterReleveCompteurDTO[i].ligneReleveCompteur[x].datePrecedentReleveCompteur , "medium")+'</td>'
								+'<td>' + vm.releveCompteur.clusterReleveCompteurDTO[i].ligneReleveCompteur[x].valeurPrecedentReleve+'</td>'
								+'<td> </td><td> </td><td> </td><td> </td><td> </td></tr>';
							
							}
						}
					}
				}
				
				
				if (vm.releveCompteur && vm.releveCompteur.listLigneReleveCompteurBulkMeter) {
					for (var i = 0; i < vm.releveCompteur.listLigneReleveCompteurBulkMeter.length; i++) {
						if (vm.releveCompteur.listLigneReleveCompteurBulkMeter[i].bulkMeter) {

							content += '<tr><td>'+ $filter('translate')('wamasysApp.releveCompteur.typeBulkMeter')+'</td>'
								+'<td colspan="4">'+ vm.releveCompteur.listLigneReleveCompteurBulkMeter[i].bulkMeter.numeroSerie+'</td><td>'
								+$filter('date')(vm.releveCompteur.listLigneReleveCompteurBulkMeter[i].datePrecedentReleveCompteur, "medium")+'</td><td>'+ vm.releveCompteur.listLigneReleveCompteurBulkMeter[i].valeurPrecedentReleve+'</td>'
								+'<td> </td><td> </td><td> </td><td> </td><td> </td></tr>';
							
						}
					}
				}
				

				
				content += "</table>";
				var printContents= content;
			  
			  
			  var popupWin = window.open('', '_blank');
			  popupWin.document.open();
			  
			
			 

			  popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" />'
					  +'<style type="text/css" media="print">@page { size: landscape; }    </style>'
					  +'<style type="text/css" > table {border-spacing: 0.5rem;border-collapse: collapse;} table, table td, table th { border: 1px solid black; }   </style>'
					  +'</head><body onload="window.print()">' + printContents + '</body></html>');
			  popupWin.document.close();
		} 
    
       var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:releveCompteurUpdate', result);
            vm.isSaving = false;
			$dialog.modal('hide');
        };

        var onSaveError = function () {
            vm.isSaving = false;
			$dialog.modal('hide');
        };
	        
	        
	        
	        
		vm.saveRows = function(forceSave) {
			//On désactive les boutons.
			vm.disableBtnSaveCancel =true;
			

			var grid = $("table[id^=jqgrid-table]");

			var ids = grid.jqGrid('getDataIDs');

			vm.erreurReleve =false;
			
	
			/** On test que les valeurs sont bien renseignées*/
			var erreur = false;
			for (var i = 0; i < ids.length; i++) {
                $('#' + $.jgrid.jqID(ids[i])).css( { background:'none'});
                
				var success =  grid.jqGrid('saveRow', ids[i]); //Permet de savoir si l'enregistrement de la ligne est bon. Si on a un carctères ça retourne false
				
				var maxDepasse = false;
				if( success && ( ! forceSave)){ //On ne fait pas le test si l'user clique sur ForceSave
					var nvReleveStr = grid.jqGrid('getRowData', ids[i]).nouveauReleve;
					if(nvReleveStr !== "" ){
						var nvReleve = parseFloat(nvReleveStr);
						var relevePrecedent = parseFloat(grid.jqGrid('getRowData', ids[i]).relevePrecedent);
						var maxAccepte = parseFloat(grid.jqGrid('getRowData', ids[i]).valeurMaximumAccepte);
						if(relevePrecedent!=NaN 
								&& (
										nvReleve == NaN
										|| maxAccepte == NaN
										|| nvReleve > maxAccepte
										|| nvReleve < relevePrecedent
								)){
							maxDepasse = true;
						}	
					}

				}
				
				erreur = erreur ||(! success) || maxDepasse;

				if(maxDepasse ){
	                $('#' + $.jgrid.jqID(ids[i])).css( { background:'orange'});           
				}
				if(! success ){
	                $('#' + $.jgrid.jqID(ids[i])).css( { background:'red'});           
				}
				
			}

            
			var grid = $("table[id^=jqgrid-table]");
			var dataInGrid = grid.jqGrid('getRowData') ;
		
			for (var i = 0; i < dataInGrid.length; i++) { 
 
              	var id = dataInGrid[i].id ;
              		
          		var listTrouveBulkMeter =  jQuery.grep(vm.releveCompteur.listLigneReleveCompteurBulkMeter, function(e){ return e.idLigneReleveCompteur == id; });
          			
          		if(listTrouveBulkMeter && listTrouveBulkMeter.length > 0 ){
	            	listTrouveBulkMeter[0].valeurReleve = dataInGrid[i].nouveauReleve;

              		if(dataInGrid[i].casNonReleve){
              			listTrouveBulkMeter[0].casNonReleve = {id:dataInGrid[i].idCasNonReleve, libelle:dataInGrid[i].casNonReleve};
              		}else{
              			listTrouveBulkMeter[0].casNonReleve = null;
              		}
	            }
         

              	var ligneIndividual =  chercherLigneReleveCompteur(vm.releveCompteur.clusterReleveCompteurDTO,id);
              		
              	if(ligneIndividual){
              		ligneIndividual.valeurReleve = dataInGrid[i].nouveauReleve;
              		if(dataInGrid[i].casNonReleve){
              			ligneIndividual.casNonReleve = {id:dataInGrid[i].idCasNonReleve, libelle:dataInGrid[i].casNonReleve};
              		}else{
              			ligneIndividual.casNonReleve = null;
              		}
	            }
              		
            }

            $rootScope.$broadcast('updateLigneReleveCompteur', vm.releveCompteur);
			  
			if(erreur){
				vm.erreurReleve =true;
			//	alert( $filter('translate')('wamasysApp.releveCompteur.erreurSaisie') );
				for (var i = 0; i < ids.length; i++) {
					grid.jqGrid('editRow', ids[i]);
				}
				/** On affiche le bouton de sauvegarde forcée*/
				jQuery("#btnSaveRows,#btnCancelRows,#btnSaveRowsForce").show();
				vm.disableBtnSaveCancel =false;
				return ;
			}
			
			
	
			//Ensuite si pas d'erreur on enregistre en appelant le WebService.
			

		


			$dialog.modal();
            ReleveCompteur.update(vm.releveCompteur, onSaveSuccess, onSaveError);
			jQuery("#btnSaveRows,#btnCancelRows,#btnSaveRowsForce").hide();
			vm.disableBtnSaveCancel =true;
			
			vm.disableBtnEdition =false;

		}
		
		var chercherLigneReleveCompteur = function(listeCluster,idToLookFor) {
			
			for (var i = 0, len = listeCluster.length; i < len; i++)  {
				
				for (var x = 0, lenLigne = listeCluster[i].ligneReleveCompteur.length; x < lenLigne; x++)  {

				    if (listeCluster[i].ligneReleveCompteur[x].idLigneReleveCompteur == idToLookFor) {
				        return listeCluster[i].ligneReleveCompteur[x]; // Return as soon as the object is found
				    }
				}
			}
		}

		vm.cancelEditRows = function() {

			jQuery("#btnSaveRows,#btnCancelRows,#btnSaveRowsForce").hide();

			var grid = $("table[id^=jqgrid-table]");

			var ids = grid.jqGrid('getDataIDs');

			for (var i = 0; i < ids.length; i++) {
				grid.jqGrid('restoreRow', ids[i]);
			}
			vm.disableBtnEdition =false;

		}

        function getMapUrl(id) {
            return $state.href('releve-compteur-map', {id: id});
        }

        function getControlUrl(id) {
            return $state.href('releve-compteur-control', {id: id});
        }
        
 
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReleveCompteurDeleteController',ReleveCompteurDeleteController);

    ReleveCompteurDeleteController.$inject = ['$uibModalInstance', 'entity', 'ReleveCompteur','$rootScope'];

    function ReleveCompteurDeleteController($uibModalInstance, entity, ReleveCompteur,$rootScope) {
        var vm = this;
        vm.releveCompteur = entity;
        vm.confirmDelete = null;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        
        
        vm.confirmDeleteAction = function (id) {

        	if(! vm.confirmDelete || vm.confirmDelete != "yes"){
       		 $rootScope.$emit('wamasysApp.httpError', "Incorrect ! Write yes if you want to delete.");
        	}else{
        		
				var $dialog = $(
						'<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-hidden="true" style="padding-top:15%; overflow-y:visible;">' +
						'<div class="modal-dialog modal-m">' +
						'<div class="modal-content">' +
							'<div class="modal-header"><h3 style="margin:0;"></h3></div>' +
							'<div class="modal-body">' +
								'<div class="progress progress-striped active" style="margin-bottom:0;"><div class="progress-bar" style="width: 100%"></div></div>' +
							'</div>' +
						'</div></div></div>');
	
				var options = {};
				var message = 'Please wait ! Action in progress.';
				var settings = $.extend({
					dialogSize: 'm',
					progressType: '',
					onHide: null // This callback runs after the dialog was hidden
				}, options);
				$dialog.find('.modal-dialog').attr('class', 'modal-dialog').addClass('modal-' + settings.dialogSize);
				$dialog.find('.progress-bar').attr('class', 'progress-bar');
				$dialog.find('h3').text(message);
				$dialog.modal();
				
	            ReleveCompteur.delete({id: id},
	                function () {
					$dialog.modal('hide');
	                    $uibModalInstance.close(true);
	                },
	                function () {
						$dialog.modal('hide');
	                });
        	}
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReleveCompteurControlController', ReleveCompteurControlController);

    ReleveCompteurControlController.$inject = ['$filter', '$http', '$q', '$scope', '$stateParams', '$uibModal', '$window', 'AlertService', 'Principal', 'ReleveCompteur'];

    function ReleveCompteurControlController($filter, $http, $q, $scope, $stateParams, $uibModal, $window, AlertService, Principal, ReleveCompteur) {
        var vm = this;
        var photoObjectUrls = [];
        var user = {};
        var ocrRun = 0;

        vm.analyzeImages = analyzeImages;
        vm.canUseOcr = function() {
            return (user.authorities || []).indexOf('ROLE_SUPER_ADMIN') !== -1 &&
                (user.modules || []).indexOf('OCR') !== -1;
        };
        vm.hasOcrPhotos = function() {
            return vm.controlRows.some(function(row) { return row.hasPhoto; });
        };

        // Une seule requête à la fois ; les autres photos continuent si une analyse échoue.
        function analyzeImages() {
            if (vm.ocrRunning || !vm.canUseOcr()) return;
            var run = ++ocrRun;
            var rows = vm.controlRows.filter(function(row) { return row.hasPhoto; });
            vm.ocrRunning = true;
            vm.ocrCompleted = 0;
            vm.ocrTotal = rows.length;
            var chain = $q.when();
            angular.forEach(rows, function(row) {
                row.ocr = null;
                row.ocrError = null;
                chain = chain.then(function() {
                    if (run !== ocrRun) return;
                    row.ocrLoading = true;
                    return $http.post('api/releve-compteurs/' + row.idReleveCompteur + '/photo/' + row.idLigneReleveCompteur + '/analyze', {}).then(function(response) {
                        if (run === ocrRun) row.ocr = response.data;
                    }).catch(function(error) {
                        if (run === ocrRun) {
                            var errorKey = error.headers && error.headers('X-wamasysApp-error');
                            row.ocrError = $filter('translate')(errorKey || 'wamasysApp.releveCompteur.ocr.failed');
                        }
                    }).finally(function() {
                        row.ocrLoading = false;
                        if (run === ocrRun) vm.ocrCompleted += 1;
                    });
                });
            });
            chain.finally(function() { if (run === ocrRun) vm.ocrRunning = false; });
        }

        vm.allReadingMapPoints = [];
        vm.applyMissingReadingGpsToContracts = applyMissingReadingGpsToContracts;
        vm.applyMissingReadingGpsToMeters = applyMissingReadingGpsToMeters;
        vm.applyReadingGpsToContract = applyReadingGpsToContract;
        vm.applyReadingGpsToMeter = applyReadingGpsToMeter;
        vm.cancelCorrection = cancelCorrection;
        vm.canModify = canModify;
        vm.canShowValidate = canShowValidate;
        vm.canValidate = canValidate;
        vm.caseOptions = [];
        vm.closeMapModal = closeMapModal;
        vm.controlSummary = {};
        vm.controlRows = [];
        vm.controlMode = 'none';
        vm.downloadPhoto = downloadPhoto;
        vm.enableCorrection = enableCorrection;
        vm.getVisibleRows = getVisibleRows;
        vm.isReadingFormComplete = isReadingFormComplete;
        vm.isRowInError = isRowInError;
        vm.isDistanceAlert = isDistanceAlert;
        vm.loadPhoto = loadPhoto;
        vm.mapModal = {
            points: [],
            refreshToken: 0,
            rows: [],
            showContracts: true,
            showMeters: true,
            showReadings: true,
            showRoute: true,
            title: '',
            visible: false
        };
        vm.openAllReadingsMap = openAllReadingsMap;
        vm.openPhotoModal = openPhotoModal;
        vm.openRowMap = openRowMap;
        vm.photoModal = {
            title: '',
            url: null,
            visible: false
        };
        vm.releveCompteur = {};
        vm.saveCorrection = saveCorrection;
        vm.setControlMode = setControlMode;
        vm.showOnlyErrors = false;
        vm.showOnlyFilled = false;
        vm.showOnlyNonReadingCase = false;
        vm.shouldSuggestBulkMeterGpsUpdate = shouldSuggestBulkMeterGpsUpdate;
        vm.updateMapModalPoints = updateMapModalPoints;
        vm.validerReleve = validerReleve;
        vm.refreshHandoffDocument = function() {
            if ($stateParams.id) ReleveCompteur.get({id: $stateParams.id}, refreshControlData);
        };

        $scope.$on('$destroy', revokePhotoObjectUrls);
        $scope.$on('$destroy', function() { ocrRun += 1; });

        Principal.identity().then(function(account) {
            if (account) {
                user = account;
            }
        });

        if ($stateParams.id) {
            ReleveCompteur.get({id: $stateParams.id}, function(result) {
                refreshControlData(result);
            });
        }

        function refreshControlData(releveCompteur) {
            // Une actualisation invalide les résultats et arrête la file d'analyses précédente.
            ocrRun += 1;
            vm.ocrRunning = false;
            vm.ocrTotal = 0;
            revokePhotoObjectUrls();
            vm.releveCompteur = releveCompteur || {};
            vm.caseOptions = angular.isArray(vm.releveCompteur.casNonReleve) ? vm.releveCompteur.casNonReleve : [];
            vm.controlRows = buildControlRows(vm.releveCompteur);
            vm.controlSummary = buildControlSummary(vm.controlRows);
            vm.allReadingMapPoints = buildAllReadingMapPoints(vm.controlRows);

            angular.forEach(vm.controlRows, function(row) {
                if (row.hasPhoto) {
                    loadPhoto(row);
                }
            });
        }

        function buildControlRows(releveCompteur) {
            var rows = [];

            angular.forEach(releveCompteur.clusterReleveCompteurDTO || [], function(clusterDto) {
                angular.forEach(clusterDto.ligneReleveCompteur || [], function(line) {
                    rows.push(buildRow(releveCompteur, line, false, clusterDto.cluster));
                });
            });

            angular.forEach(releveCompteur.listLigneReleveCompteurBulkMeter || [], function(line) {
                rows.push(buildRow(releveCompteur, line, true, null));
            });

            rows.sort(function(a, b) {
                return a.sortValue - b.sortValue;
            });

            return rows;
        }

        function buildRow(releveCompteur, line, isBulkMeter, cluster) {
            var previousValue = toNumber(line.valeurPrecedentReleve);
            var currentValue = toNumber(line.valeurReleve);
            var maxAccepted = toNumber(line.valeurMaximumAccepte);
            var consumption = previousValue !== null && currentValue !== null ? currentValue - previousValue : null;
            var maxAcceptedConsumption = previousValue !== null && maxAccepted !== null ? maxAccepted - previousValue : null;
            var abnormal = currentValue !== null && (
                (maxAccepted !== null && currentValue > maxAccepted) ||
                (previousValue !== null && currentValue < previousValue)
            );
            var readingLat = parseCoordinate(line.coordLat);
            var readingLon = parseCoordinate(line.coordLon);
            var readingPrecision = toNumber(line.coordPrecision);
            var contractLat = parseCoordinate(line.lat);
            var contractLon = parseCoordinate(line.lon);
            var meterLat = resolveMeterLat(line, isBulkMeter);
            var meterLon = resolveMeterLon(line, isBulkMeter);
            var nonReadingCase = line.casNonReleve || null;
            var meterNumber = isBulkMeter ? (line.bulkMeter ? line.bulkMeter.numeroSerie : '') : (line.individualMeter ? line.individualMeter.numeroSerie : '');
            var previousConsumption = resolvePreviousConsumption(line, isBulkMeter);
            var meterUrl = buildMeterUrl(isBulkMeter, line);
            var beneficiaryName = line.nomContrat || '';

            var row = {
                abnormal: abnormal,
                abnormalLabel: abnormal ? $filter('translate')('wamasysApp.releveCompteur.control.abnormal') : $filter('translate')('wamasysApp.releveCompteur.control.normal'),
                beneficiaryName: beneficiaryName,
                clusterLabel: cluster && cluster.numeroSerie ? cluster.numeroSerie : '-',
                consumption: consumption,
                contractGpsLabel: formatCoordinateLabel(contractLat, contractLon),
                contractLat: contractLat,
                contractLon: contractLon,
                contractReference: line.referenceContrat || '',
                contractUrl: line.idContrat ? '#/contrat/' + line.idContrat + '/dataanalyse' : null,
                hasMaxAcceptedCheck: maxAccepted !== null,
                hasMissingReadingGps: readingLat === null || readingLon === null,
                hasPhoto: !!line.pathPhoto,
                hasRecordedReading: currentValue !== null,
                idContrat: line.idContrat,
                idLigneReleveCompteur: line.idLigneReleveCompteur,
                idReleveCompteur: releveCompteur.id,
                isCompleted: currentValue !== null || !!nonReadingCase,
                isBulkMeter: isBulkMeter,
                isEditing: false,
                lineRef: line,
                maxAccepted: maxAccepted,
                maxAcceptedConsumption: maxAcceptedConsumption,
                maxCheckDisabled: isBulkMeter ? !!(line.bulkMeter && line.bulkMeter.disableCheckMaxValue) : !!(line.individualMeter && line.individualMeter.disableCheckMaxValue),
                meterDistanceMeters: null,
                meterGpsLabel: formatCoordinateLabel(meterLat, meterLon),
                meterId: isBulkMeter ? (line.bulkMeter ? line.bulkMeter.id : null) : (line.individualMeter ? line.individualMeter.id : null),
                meterLat: meterLat,
                meterLon: meterLon,
                meterNumber: meterNumber,
                meterType: isBulkMeter ? $filter('translate')('wamasysApp.releveCompteur.typeBulkMeter') : $filter('translate')('wamasysApp.releveCompteur.typeIndividualMeter'),
                meterUrl: meterUrl,
                nonReadingCaseId: nonReadingCase ? nonReadingCase.id : null,
                nonReadingCaseLabel: nonReadingCase ? nonReadingCase.libelle : '',
                photoContentType: null,
                photoDownloadUrl: buildPhotoUrl(releveCompteur.id, line.idLigneReleveCompteur, true),
                photoError: false,
                photoLoading: false,
                photoObjectUrl: null,
                photoTitle: meterNumber || line.referenceContrat || $filter('translate')('wamasysApp.releveCompteur.detail.photo'),
                photoViewUrl: buildPhotoUrl(releveCompteur.id, line.idLigneReleveCompteur, false),
                previousConsumption: previousConsumption,
                previousReadingDateLabel: line.datePrecedentReleveCompteur ? $filter('date')(line.datePrecedentReleveCompteur, 'medium') : '-',
                previousReadingValue: previousValue,
                readingDateLabel: line.readingDate ? $filter('date')(line.readingDate, 'medium') : $filter('date')(releveCompteur.dateReleve, 'mediumDate'),
                readingGpsLabel: formatReadingCoordinateLabel(readingLat, readingLon, readingPrecision),
                readingLat: readingLat,
                readingLon: readingLon,
                readingPrecision: readingPrecision,
                readingValue: line.valeurReleve,
                runningOrderLabel: !isBulkMeter && line.individualMeter && line.individualMeter.runningOrder ? line.individualMeter.runningOrder : '-',
                sortValue: line.readingDate ? new Date(line.readingDate).getTime() : new Date(releveCompteur.dateReleve).getTime()
            };

            resetRowEditingState(row);
            updateDistanceState(row);
            return row;
        }

        function buildPhotoUrl(idReleveCompteur, idLigneReleveCompteur, download) {
            return 'api/releve-compteurs/' + idReleveCompteur + '/photo/' + idLigneReleveCompteur + '?download=' + (download ? 'true' : 'false');
        }

        function buildMeterUrl(isBulkMeter, line) {
            var meterId = isBulkMeter ? (line.bulkMeter ? line.bulkMeter.id : null) : (line.individualMeter ? line.individualMeter.id : null);
            if (!meterId) {
                return null;
            }

            return isBulkMeter ? '#/bulk-meter/' + meterId : '#/individual-meter/' + meterId;
        }

        function buildAllReadingMapPoints(rows) {
            var points = [];

            angular.forEach(rows || [], function(row) {
                if (row.readingLat === null || row.readingLon === null) {
                    return;
                }

                points.push({
                    hasRecordedReading: row.hasRecordedReading,
                    lat: row.readingLat,
                    lon: row.readingLon,
                    orderTime: row.sortValue,
                    dateLabel: row.readingDateLabel,
                    title: row.contractReference || row.meterNumber || '-',
                    subtitle: row.meterNumber,
                    valueLabel: buildReadingValueLabel(row)
                });
            });

            points.sort(function(a, b) {
                return a.orderTime - b.orderTime;
            });

            angular.forEach(points, function(point, index) {
                point.sequence = index + 1;
                point.markerHtml = buildReadingMarkerHtml(point.sequence, point.dateLabel, point.hasRecordedReading);
                point.iconSize = [68, 54];
                point.iconAnchor = [18, 18];
                point.popupAnchor = [0, -16];
            });

            return points;
        }

        function buildControlSummary(rows) {
            var summary = {
                remaining: 0,
                totalNonReading: 0,
                totalRead: 0,
                totalToRead: rows ? rows.length : 0,
                warnings: {
                    abnormal: 0,
                    noGps: 0,
                    shortCheck: 0,
                    wideCheck: 0
                }
            };

            angular.forEach(rows || [], function(row) {
                if (row.hasRecordedReading) {
                    summary.totalRead += 1;
                }
                if (row.nonReadingCaseId) {
                    summary.totalNonReading += 1;
                }
                if (!row.isCompleted) {
                    summary.remaining += 1;
                }
                if (row.abnormal) {
                    summary.warnings.abnormal += 1;
                }
                if (row.hasMissingReadingGps && row.isCompleted) {
                    summary.warnings.noGps += 1;
                }
                if (row.distanceAlertLarge) {
                    summary.warnings.wideCheck += 1;
                }
                if (row.distanceAlertShort) {
                    summary.warnings.shortCheck += 1;
                }
            });

            return summary;
        }

        function buildReadingValueLabel(row) {
            if (row.nonReadingCaseLabel) {
                return $filter('translate')('wamasysApp.releveCompteur.map.nonReading') + ': ' + row.nonReadingCaseLabel;
            }

            if (row.readingValue !== null && row.readingValue !== undefined && row.readingValue !== '') {
                return $filter('translate')('wamasysApp.releveCompteur.map.reading') + ': ' + row.readingValue;
            }

            return $filter('translate')('wamasysApp.releveCompteur.map.noReading');
        }

        function setControlMode(mode) {
            vm.controlMode = mode;
        }

        function getVisibleRows() {
            return (vm.controlRows || []).filter(function(row) {
                if (vm.showOnlyErrors && !isRowInError(row)) {
                    return false;
                }

                if (vm.showOnlyFilled && !isRowFilled(row)) {
                    return false;
                }

                if (vm.showOnlyNonReadingCase && !row.nonReadingCaseId) {
                    return false;
                }

                return true;
            });
        }

        function isRowFilled(row) {
            return !!row && (toNumber(row.readingValue) !== null || !!row.nonReadingCaseId);
        }

        function canModify() {
            return vm.releveCompteur && ['ARENSEIGNER', 'ENCOURS', 'AVALIDER'].indexOf(vm.releveCompteur.etat) !== -1;
        }

        function canShowValidate() {
            return vm.releveCompteur && ['ENCOURS', 'AVALIDER'].indexOf(vm.releveCompteur.etat) !== -1;
        }

        function canValidate() {
            if (!canShowValidate()) {
                return false;
            }

            return vm.releveCompteur.etat === 'ENCOURS' || isReadingFormComplete();
        }

        function isReadingFormComplete() {
            return (vm.controlRows || []).every(function(row) {
                return row.isCompleted;
            });
        }

        function isRowInError(row) {
            return !!row && (row.abnormal || row.hasMissingReadingGps || isDistanceAlert(row));
        }

        function isDistanceAlert(row) {
            if (!row || vm.controlMode === 'none') {
                return false;
            }

            if (vm.controlMode === 'large') {
                return !!row.distanceAlertLarge;
            }

            return !!row.distanceAlertShort;
        }

        function openPhotoModal(row) {
            if (!row || !row.hasPhoto) {
                return;
            }

            loadPhoto(row).then(function() {
                if (!row.photoObjectUrl) {
                    return;
                }

                vm.photoModal.visible = true;
                vm.photoModal.url = row.photoObjectUrl;
                vm.photoModal.title = row.photoTitle;
            });
        }

        function loadPhoto(row) {
            if (!row || !row.hasPhoto) {
                return $q.when();
            }
            if (row.photoObjectUrl) {
                return $q.when(row.photoObjectUrl);
            }
            if (row.photoLoading && row.photoPromise) {
                return row.photoPromise;
            }

            row.photoLoading = true;
            row.photoError = false;
            row.photoPromise = $http.get(row.photoViewUrl, {
                responseType: 'arraybuffer'
            }).then(function(response) {
                var photoBlob = buildPhotoBlob(response.data, response.headers('Content-Type'));
                row.photoContentType = photoBlob.type;
                row.photoObjectUrl = registerPhotoObjectUrl($window.URL.createObjectURL(photoBlob));
                return row.photoObjectUrl;
            }).catch(function(error) {
                row.photoError = true;
                AlertService.error(resolveErrorMessage(error, 'wamasysApp.releveCompteur.control.photoDownloadFailed'));
                return null;
            }).finally(function() {
                row.photoLoading = false;
            });

            return row.photoPromise;
        }

        function downloadPhoto(row) {
            if (!row || !row.hasPhoto || row.photoDownloading) {
                return;
            }

            row.photoDownloading = true;
            $http.get(row.photoDownloadUrl, {
                responseType: 'arraybuffer'
            }).then(function(response) {
                var photoBlob = buildPhotoBlob(response.data, response.headers('Content-Type'));
                var fileName = extractFileName(response.headers('Content-Disposition'), row);

                if ($window.navigator.msSaveOrOpenBlob) {
                    $window.navigator.msSaveOrOpenBlob(photoBlob, fileName);
                    return;
                }

                var downloadUrl = $window.URL.createObjectURL(photoBlob);
                var link = $window.document.createElement('a');
                link.href = downloadUrl;
                link.download = fileName;
                $window.document.body.appendChild(link);
                link.click();
                $window.document.body.removeChild(link);
                $window.URL.revokeObjectURL(downloadUrl);
            }).catch(function(error) {
                AlertService.error(resolveErrorMessage(error, 'wamasysApp.releveCompteur.control.photoDownloadFailed'));
            }).finally(function() {
                row.photoDownloading = false;
            });
        }

        function buildPhotoBlob(data, contentType) {
            return new Blob([data], {
                type: contentType || 'image/jpeg'
            });
        }

        function registerPhotoObjectUrl(url) {
            photoObjectUrls.push(url);
            return url;
        }

        function revokePhotoObjectUrls() {
            angular.forEach(photoObjectUrls, function(url) {
                $window.URL.revokeObjectURL(url);
            });
            photoObjectUrls = [];
        }

        function extractFileName(contentDisposition, row) {
            var matches = /filename\*?=(?:UTF-8''|")?([^\";]+)/i.exec(contentDisposition || '');
            if (matches && matches[1]) {
                return decodeURIComponent(matches[1].replace(/"/g, ''));
            }

            return buildFallbackPhotoFileName(row);
        }

        function buildFallbackPhotoFileName(row) {
            var baseName = row.photoTitle || 'photo-compteur';
            if (!/\.[A-Za-z0-9]+$/.test(baseName)) {
                baseName += '.jpg';
            }
            return baseName;
        }

        function openRowMap(row) {
            vm.mapModal.rows = row ? [row] : [];
            vm.mapModal.showReadings = true;
            vm.mapModal.showContracts = true;
            vm.mapModal.showMeters = true;
            vm.mapModal.title = (row.contractReference || row.meterNumber || '') + ' - ' + $filter('translate')('wamasysApp.releveCompteur.control.openMap');
            vm.mapModal.visible = true;
            updateMapModalPoints();
        }

        function openAllReadingsMap() {
            vm.mapModal.rows = vm.controlRows || [];
            vm.mapModal.showReadings = true;
            vm.mapModal.showContracts = true;
            vm.mapModal.showMeters = true;
            vm.mapModal.title = $filter('translate')('wamasysApp.releveCompteur.control.allReadingsMapTitle');
            vm.mapModal.visible = true;
            updateMapModalPoints();
        }

        function closeMapModal() {
            vm.mapModal.visible = false;
            vm.mapModal.points = [];
            vm.mapModal.refreshToken = 0;
            vm.mapModal.rows = [];
            vm.mapModal.showContracts = true;
            vm.mapModal.showMeters = true;
            vm.mapModal.showReadings = true;
            vm.mapModal.showRoute = true;
            vm.mapModal.title = '';
        }

        function updateMapModalPoints() {
            var points = [];
            var readingSequence = 0;

            angular.forEach((vm.mapModal.rows || []).slice().sort(function(firstRow, secondRow) {
                return firstRow.sortValue - secondRow.sortValue;
            }), function(row) {
                if (vm.mapModal.showReadings && row.readingLat !== null && row.readingLon !== null) {
                    readingSequence += 1;
                    points.push(buildMapModalReadingPoint(row, readingSequence));
                }

                if (vm.mapModal.showContracts && row.contractLat !== null && row.contractLon !== null) {
                    points.push(buildMapModalContractPoint(row));
                }

                if (vm.mapModal.showMeters && row.meterLat !== null && row.meterLon !== null) {
                    points.push(buildMapModalMeterPoint(row));
                }
            });

            vm.mapModal.points = points;
            vm.mapModal.showRoute = vm.mapModal.showReadings && !vm.mapModal.showContracts && !vm.mapModal.showMeters && readingSequence > 1;
            vm.mapModal.refreshToken += 1;
        }

        function buildMapModalReadingPoint(row, readingSequence) {
            return {
                dateLabel: row.readingDateLabel,
                focusZoom: 17,
                iconAnchor: [18, 18],
                iconSize: [68, 54],
                key: 'modal-reading-' + row.idLigneReleveCompteur,
                lat: row.readingLat,
                lon: row.readingLon,
                markerHtml: buildReadingMarkerHtml(readingSequence, row.readingDateLabel, row.hasRecordedReading),
                popupAnchor: [0, -16],
                sequence: readingSequence,
                subtitle: row.meterNumber,
                title: row.contractReference || '-',
                valueLabel: row.readingGpsLabel
            };
        }

        function buildMapModalContractPoint(row) {
            return {
                focusZoom: 17,
                iconAnchor: [12, 12],
                iconSize: [24, 24],
                key: 'modal-contract-' + row.idLigneReleveCompteur,
                lat: row.contractLat,
                lon: row.contractLon,
                markerHtml: buildLetterMarkerHtml('C', '#2f855a'),
                popupAnchor: [0, -12],
                subtitle: row.contractReference || '-',
                title: $filter('translate')('wamasysApp.releveCompteur.control.rowMapContract'),
                valueLabel: row.contractGpsLabel
            };
        }

        function buildMapModalMeterPoint(row) {
            return {
                focusZoom: 17,
                iconAnchor: [12, 12],
                iconSize: [24, 24],
                key: 'modal-meter-' + row.idLigneReleveCompteur,
                lat: row.meterLat,
                lon: row.meterLon,
                markerHtml: buildLetterMarkerHtml('M', row.hasRecordedReading ? '#2f855a' : '#c05621'),
                popupAnchor: [0, -12],
                subtitle: row.meterNumber || '-',
                title: $filter('translate')('wamasysApp.releveCompteur.control.rowMapMeter'),
                valueLabel: row.meterGpsLabel
            };
        }

        function enableCorrection(row) {
            if (!canModify()) {
                return;
            }
            row.isEditing = true;
            resetRowEditingState(row);
        }

        function cancelCorrection(row) {
            row.isEditing = false;
            resetRowEditingState(row);
        }

        function saveCorrection(row) {
            if (!row || !row.lineRef || row.savingCorrection) {
                return;
            }
            if (!canModify()) {
                AlertService.error($filter('translate')('wamasysApp.releveCompteur.control.modificationNotAllowed'));
                return;
            }

            var correctionChecks = validateCorrection(row);
            if (correctionChecks.errors.length) {
                AlertService.error(correctionChecks.errors.join(' '));
                return;
            }
            if (correctionChecks.warnings.length && !$window.confirm(correctionChecks.warnings.join('\n') + '\n\n' + $filter('translate')('wamasysApp.releveCompteur.control.forceCorrectionConfirm'))) {
                return;
            }

            row.savingCorrection = true;
            row.lineRef.valeurReleve = normalizeNumber(row.editedReadingValue);
            row.lineRef.casNonReleve = findCaseById(row.editedNonReadingCaseId);

            ReleveCompteur.update(vm.releveCompteur,
                function(result) {
                    row.savingCorrection = false;
                    refreshControlData(result);
                    AlertService.success($filter('translate')('wamasysApp.releveCompteur.control.correctionSaved'));
                },
                function(error) {
                    row.savingCorrection = false;
                    AlertService.error(resolveErrorMessage(error, 'wamasysApp.releveCompteur.control.correctionFailed'));
                });
        }

        function validerReleve() {
            if (!vm.releveCompteur || !vm.releveCompteur.id || vm.validatingReleve) {
                return;
            }
            if (!checkerDecimalAquatech()) {
                return;
            }

            // Une RF encore en cours peut contenir des lectures non remontées depuis le smartphone.
            if (requiresValidationConfirmation()) {
                openValidationConfirmation().then(function() {
                    executeValidation();
                });
                return;
            }
            if (!isReadingFormComplete()) {
                AlertService.error($filter('translate')('wamasysApp.releveCompteur.control.validationIncomplete'));
                return;
            }

            executeValidation();
        }

        function requiresValidationConfirmation() {
            return vm.releveCompteur && vm.releveCompteur.etat === 'ENCOURS';
        }

        function openValidationConfirmation() {
            return $uibModal.open({
                templateUrl: 'app/business/releve-compteur/releve-compteur-validate-confirm-dialog.html',
                controller: 'ReleveCompteurValidateConfirmController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md'
            }).result;
        }

        function executeValidation() {
            vm.validatingReleve = true;
            ReleveCompteur.valider({id: vm.releveCompteur.id},
                function(result) {
                    vm.validatingReleve = false;
                    refreshControlData(result);
                    AlertService.success($filter('translate')('wamasysApp.releveCompteur.control.validationSuccess'));
                },
                function(error) {
                    vm.validatingReleve = false;
                    AlertService.error(resolveErrorMessage(error, 'wamasysApp.releveCompteur.control.validationFailed'));
                });
        }

        function resetRowEditingState(row) {
            row.editedReadingValue = row.readingValue;
            row.editedNonReadingCaseId = row.nonReadingCaseId;
        }

        function shouldSuggestBulkMeterGpsUpdate(row) {
            return !!row && row.isBulkMeter && canModify() && row.meterId &&
                row.readingLat !== null && row.readingLon !== null &&
                ((row.meterLat === null || row.meterLon === null) || row.distanceAlertLarge || row.distanceAlertShort);
        }

        function applyReadingGpsToContract(row) {
            if (!row || !row.idContrat || row.readingLat === null || row.readingLon === null || row.updatingContract) {
                return;
            }
            if (!$window.confirm($filter('translate')('wamasysApp.releveCompteur.control.confirmContractGpsUpdate'))) {
                return;
            }

            row.updatingContract = true;
            ReleveCompteur.applyReadingGpsToContract({id: row.idReleveCompteur, idLigne: row.idLigneReleveCompteur}, {},
                function() {
                    row.contractLat = row.readingLat;
                    row.contractLon = row.readingLon;
                    row.contractGpsLabel = formatCoordinateLabel(row.contractLat, row.contractLon);
                    updateDistanceState(row);
                    row.updatingContract = false;
                    AlertService.success($filter('translate')('wamasysApp.releveCompteur.control.contractGpsUpdated'));
                },
                function(error) {
                    row.updatingContract = false;
                    AlertService.error(resolveErrorMessage(error, 'wamasysApp.releveCompteur.control.contractGpsUpdateFailed'));
                });
        }

        function applyReadingGpsToMeter(row) {
            if (!row || !row.meterId || row.readingLat === null || row.readingLon === null || row.updatingMeter) {
                return;
            }
            if (!$window.confirm($filter('translate')('wamasysApp.releveCompteur.control.confirmMeterGpsUpdate'))) {
                return;
            }

            row.updatingMeter = true;
            ReleveCompteur.applyReadingGpsToMeter({id: row.idReleveCompteur, idLigne: row.idLigneReleveCompteur}, {},
                function() {
                    row.meterLat = row.readingLat;
                    row.meterLon = row.readingLon;
                    row.meterGpsLabel = formatCoordinateLabel(row.meterLat, row.meterLon);
                    updateDistanceState(row);
                    row.updatingMeter = false;
                    AlertService.success($filter('translate')('wamasysApp.releveCompteur.control.meterGpsUpdated'));
                },
                function(error) {
                    row.updatingMeter = false;
                    AlertService.error(resolveErrorMessage(error, 'wamasysApp.releveCompteur.control.meterGpsUpdateFailed'));
                });
        }

        function applyMissingReadingGpsToContracts() {
            var rowsToUpdate = vm.controlRows.filter(function(row) {
                return row.idContrat && row.readingLat !== null && row.readingLon !== null && (row.contractLat === null || row.contractLon === null);
            });

            if (!rowsToUpdate.length) {
                AlertService.info($filter('translate')('wamasysApp.releveCompteur.control.noContractGpsToUpdate'));
                return;
            }

            if (!$window.confirm($filter('translate')('wamasysApp.releveCompteur.control.confirmBulkContractGpsUpdate'))) {
                return;
            }

            vm.bulkUpdatingContracts = true;
            applyRowsSequentially(rowsToUpdate, function(row) {
                return ReleveCompteur.applyReadingGpsToContract({id: row.idReleveCompteur, idLigne: row.idLigneReleveCompteur}, {}).$promise;
            }).then(function() {
                return ReleveCompteur.get({id: vm.releveCompteur.id}).$promise;
            }).then(function(result) {
                refreshControlData(result);
                AlertService.success($filter('translate')('wamasysApp.releveCompteur.control.bulkContractGpsUpdated'));
            }).catch(function(error) {
                AlertService.error(resolveErrorMessage(error, 'wamasysApp.releveCompteur.control.contractGpsUpdateFailed'));
            }).finally(function() {
                vm.bulkUpdatingContracts = false;
            });
        }

        function applyMissingReadingGpsToMeters() {
            var rowsToUpdate = vm.controlRows.filter(function(row) {
                return row.meterId && row.readingLat !== null && row.readingLon !== null && (row.meterLat === null || row.meterLon === null);
            });

            if (!rowsToUpdate.length) {
                AlertService.info($filter('translate')('wamasysApp.releveCompteur.control.noMeterGpsToUpdate'));
                return;
            }

            if (!$window.confirm($filter('translate')('wamasysApp.releveCompteur.control.confirmBulkMeterGpsUpdate'))) {
                return;
            }

            vm.bulkUpdatingMeters = true;
            applyRowsSequentially(rowsToUpdate, function(row) {
                return ReleveCompteur.applyReadingGpsToMeter({id: row.idReleveCompteur, idLigne: row.idLigneReleveCompteur}, {}).$promise;
            }).then(function() {
                return ReleveCompteur.get({id: vm.releveCompteur.id}).$promise;
            }).then(function(result) {
                refreshControlData(result);
                AlertService.success($filter('translate')('wamasysApp.releveCompteur.control.bulkMeterGpsUpdated'));
            }).catch(function(error) {
                AlertService.error(resolveErrorMessage(error, 'wamasysApp.releveCompteur.control.meterGpsUpdateFailed'));
            }).finally(function() {
                vm.bulkUpdatingMeters = false;
            });
        }

        function applyRowsSequentially(rows, action) {
            var promise = $q.when();

            angular.forEach(rows, function(row) {
                promise = promise.then(function() {
                    return action(row);
                });
            });

            return promise;
        }

        function buildReadingMarkerHtml(sequence, dateLabel, hasRecordedReading) {
            var backgroundColor = hasRecordedReading ? '#2f855a' : '#c05621';
            return '<div style="display:flex;flex-direction:column;align-items:center;">' +
                '<div style="' +
                'background:' + backgroundColor + ';color:#fff;border:2px solid #ffffff;border-radius:18px;' +
                'min-width:30px;height:30px;line-height:26px;text-align:center;font-weight:bold;' +
                'padding:0 6px;box-shadow:0 1px 5px rgba(0,0,0,0.35);font-size:12px;">' +
                escapeHtml(sequence) +
                '</div>' +
                '<div style="' +
                'margin-top:3px;background:rgba(255,255,255,0.92);color:#1a202c;border-radius:10px;' +
                'padding:2px 6px;font-size:10px;line-height:1.2;white-space:nowrap;' +
                'box-shadow:0 1px 3px rgba(0,0,0,0.25);">' + escapeHtml(dateLabel || '') + '</div>' +
                '</div>';
        }

        function buildLetterMarkerHtml(label, backgroundColor) {
            return '<div style="' +
                'background:' + backgroundColor + ';color:#fff;border:2px solid #ffffff;border-radius:12px;' +
                'width:24px;height:24px;line-height:20px;text-align:center;font-weight:bold;' +
                'box-shadow:0 1px 5px rgba(0,0,0,0.35);font-size:12px;">' + escapeHtml(label) + '</div>';
        }

        function updateDistanceState(row) {
            row.contractDistanceMeters = computeDistanceMeters(row.readingLat, row.readingLon, row.contractLat, row.contractLon);
            row.meterDistanceMeters = computeDistanceMeters(row.readingLat, row.readingLon, row.meterLat, row.meterLon);
            row.distanceSummaryLabel = buildDistanceSummaryLabel(row);
            row.distanceHeadlineLabel = buildDistanceHeadlineLabel(row);
            row.distanceAlertLarge = hasDistanceAlert(row, 20, false);
            row.distanceAlertShort = hasDistanceAlert(row, 5, true);
        }

        function buildDistanceSummaryLabel(row) {
            var labels = [];

            if (row.meterDistanceMeters !== null) {
                labels.push($filter('translate')('wamasysApp.releveCompteur.control.distanceMeter') + ': ' + $filter('number')(row.meterDistanceMeters, 0) + ' m');
            }
            if (row.contractDistanceMeters !== null) {
                labels.push($filter('translate')('wamasysApp.releveCompteur.control.distanceContract') + ': ' + $filter('number')(row.contractDistanceMeters, 0) + ' m');
            }

            return labels.length ? labels.join(' | ') : '-';
        }

        function buildDistanceHeadlineLabel(row) {
            var labels = [];

            if (row.meterDistanceMeters !== null) {
                labels.push($filter('translate')('wamasysApp.releveCompteur.control.distanceMeterShort') + ' ' + $filter('number')(row.meterDistanceMeters, 0) + ' m');
            }
            if (row.contractDistanceMeters !== null) {
                labels.push($filter('translate')('wamasysApp.releveCompteur.control.distanceContractShort') + ' ' + $filter('number')(row.contractDistanceMeters, 0) + ' m');
            }

            return labels.length ? labels.join(' | ') : '-';
        }

        function hasDistanceAlert(row, baseDistanceMeters, strictPrecisionCheck) {
            var precision = row.readingPrecision !== null && row.readingPrecision !== undefined ? row.readingPrecision : 0;
            var maxDistance = baseDistanceMeters + Math.max(precision, 0);

            if (strictPrecisionCheck && precision > 5) {
                return true;
            }

            return exceedsDistance(row.contractDistanceMeters, maxDistance) || exceedsDistance(row.meterDistanceMeters, maxDistance);
        }

        function exceedsDistance(distanceMeters, maxDistance) {
            return distanceMeters !== null && distanceMeters > maxDistance;
        }

        function computeDistanceMeters(lat1, lon1, lat2, lon2) {
            if (lat1 === null || lon1 === null || lat2 === null || lon2 === null) {
                return null;
            }

            var earthRadius = 6371000;
            var dLat = degreesToRadians(lat2 - lat1);
            var dLon = degreesToRadians(lon2 - lon1);
            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(degreesToRadians(lat1)) * Math.cos(degreesToRadians(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

            return earthRadius * c;
        }

        function degreesToRadians(value) {
            return value * Math.PI / 180;
        }

        function resolveMeterLat(line, isBulkMeter) {
            if (isBulkMeter) {
                return parseCoordinate(line.bulkMeter && line.bulkMeter.latitude);
            }
            return parseCoordinate(line.individualMeter && line.individualMeter.latitude);
        }

        function resolveMeterLon(line, isBulkMeter) {
            if (isBulkMeter) {
                return parseCoordinate(line.bulkMeter && line.bulkMeter.longitude);
            }
            return parseCoordinate(line.individualMeter && line.individualMeter.longitude);
        }

        function formatReadingCoordinateLabel(lat, lon, precision) {
            if (lat === null || lon === null) {
                return '-';
            }

            var label = formatCoordinateLabel(lat, lon);
            if (precision !== null && precision !== undefined) {
                label += ' (' + $filter('number')(precision, 1) + ' m)';
            }
            return label;
        }

        function formatCoordinateLabel(lat, lon) {
            if (lat === null || lon === null) {
                return '-';
            }

            return $filter('number')(lat, 6) + ', ' + $filter('number')(lon, 6);
        }

        function parseCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = parseFloat(String(value).replace(',', '.'));
            return isNaN(parsedValue) ? null : parsedValue;
        }

        function normalizeNumber(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = parseFloat(String(value).replace(',', '.'));
            return isNaN(parsedValue) ? null : parsedValue;
        }

        function findCaseById(id) {
            if (id === null || id === undefined || id === '') {
                return null;
            }

            var searchedId = parseInt(id, 10);
            var selectedCase = null;
            angular.forEach(vm.caseOptions, function(caseItem) {
                if (!selectedCase && caseItem && caseItem.id === searchedId) {
                    selectedCase = {
                        id: caseItem.id,
                        libelle: caseItem.libelle
                    };
                }
            });

            return selectedCase;
        }

        function resolveErrorMessage(error, defaultTranslationKey) {
            if (error && error.data && error.data.message) {
                return error.data.message;
            }
            return $filter('translate')(defaultTranslationKey);
        }

        function escapeHtml(value) {
            return String(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }

        function toNumber(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = parseFloat(value);
            return isNaN(parsedValue) ? null : parsedValue;
        }

        function resolvePreviousConsumption(line, isBulkMeter) {
            if (isBulkMeter) {
                return toNumber(line.valeurPrecedenteConsommation || (line.bulkMeter && line.bulkMeter.valeurPrecedenteConsommation));
            }

            return toNumber(line.individualMeter && line.individualMeter.valeurPrecedenteConsommation);
        }

        function validateCorrection(row) {
            var errors = [];
            var warnings = [];
            var editedReadingValue = normalizeNumber(row.editedReadingValue);

            if (editedReadingValue !== null && editedReadingValue < 0) {
                errors.push($filter('translate')('wamasysApp.releveCompteur.control.correctionValidationNegative'));
            }

            if (editedReadingValue !== null && row.previousReadingValue !== null && editedReadingValue < row.previousReadingValue) {
                warnings.push($filter('translate')('wamasysApp.releveCompteur.control.correctionValidationPrevious'));
            }

            if (editedReadingValue !== null && row.maxAccepted !== null && editedReadingValue > row.maxAccepted) {
                warnings.push($filter('translate')('wamasysApp.releveCompteur.control.correctionValidationMax'));
            }

            return {
                errors: errors,
                warnings: warnings
            };
        }

        function hasDecimals(number) {
            return number % 1 !== 0;
        }

        function checkerDecimalAquatech() {
            var erreur = false;
            var messageErreur = '';
            var organisationName = user.organisationName || '';

            if (organisationName.indexOf('Aquatech') === -1 && organisationName.indexOf('aquatech') === -1
                && user.organisationId !== 26529364 && user.organisationId !== 25683601) {
                return true;
            }

            angular.forEach(vm.releveCompteur.clusterReleveCompteurDTO || [], function(clusterDto) {
                angular.forEach(clusterDto.ligneReleveCompteur || [], function(line) {
                    if (line.valeurReleve && hasDecimals(line.valeurReleve)) {
                        erreur = true;
                        messageErreur += 'Erreur releve avec decimale sur ' + ((line.individualMeter && line.individualMeter.numeroSerie) || '-') + '\n';
                    }
                });
            });

            angular.forEach(vm.releveCompteur.listLigneReleveCompteurBulkMeter || [], function(line) {
                if (line.valeurReleve && hasDecimals(line.valeurReleve)) {
                    erreur = true;
                    messageErreur += 'Erreur releve avec decimale sur ' + ((line.bulkMeter && line.bulkMeter.numeroSerie) || '-') + '\n';
                }
            });

            if (erreur) {
                $window.alert('Vous avez des erreurs bloquantes pour la validation du releve de compteur : \n' + messageErreur);
                return false;
            }

            return true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('expense-type', {
            parent: 'entity',
            url: '/expense-type?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.expenseType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/expense-type/expense-types.html',
                    controller: 'ExpenseTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('expenseType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('expense-type-detail', {
            parent: 'entity',
            url: '/expense-type/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.expenseType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/expense-type/expense-type-detail.html',
                    controller: 'ExpenseTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('expenseType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ExpenseType', function($stateParams, ExpenseType) {
                    return ExpenseType.get({id : $stateParams.id});
                }]
            }
        })
        .state('expense-type.new', {
            parent: 'expense-type',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/expense-type/expense-type-dialog.html',
                    controller: 'ExpenseTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('expense-type', null, { reload: true });
                }, function() {
                    $state.go('expense-type');
                });
            }]
        })
        .state('expense-type.edit', {
            parent: 'expense-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/expense-type/expense-type-dialog.html',
                    controller: 'ExpenseTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ExpenseType', function(ExpenseType) {
                            return ExpenseType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('expense-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('expense-type.delete', {
            parent: 'expense-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/expense-type/expense-type-delete-dialog.html',
                    controller: 'ExpenseTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ExpenseType', function(ExpenseType) {
                            return ExpenseType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('expense-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ExpenseType', ExpenseType);

    ExpenseType.$inject = ['$resource'];

    function ExpenseType ($resource) {
        var resourceUrl =  'api/expense-type/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ExpenseTypeController', ExpenseTypeController);

    ExpenseTypeController.$inject = ['$scope', '$state', 'ExpenseType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ExpenseTypeController ($scope, $state, ExpenseType, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            ExpenseType.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.expenseTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ExpenseTypeDialogController', ExpenseTypeDialogController);

    ExpenseTypeDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ExpenseType','GlobalExpenseType'];

    function ExpenseTypeDialogController ($scope, $stateParams, $uibModalInstance, entity, ExpenseType,GlobalExpenseType) {
        var vm = this;
        vm.expenseType = entity;
        vm.load = function(id) {
            ExpenseType.get({id : id}, function(result) {
                vm.expenseType = result;
            });
        };

        GlobalExpenseType.query({size:100}, function(result) {
        	vm.globalExpenseTypes = result;
        	entity.$promise.then(function(value) {
	        	if( vm.expenseType.globalExpenseType){
	        		var indexElt = -1;
	        		var  fnctIdEqual = function(element,i) {
	        			if(element.id === vm.expenseType.globalExpenseType.id){
	        				indexElt=i;
	        			}
	        			return element.id === vm.expenseType.globalExpenseType.id;
	        		};
	        		
	        		var index = vm.globalExpenseTypes.findIndex(fnctIdEqual);
	        		if(index === -1 ){
	        			vm.globalExpenseTypes.push(value.globalExpenseType);
	        		}
	        	}
        	});
        });
        
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:expenseTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.expenseType.id !== null) {
                ExpenseType.update(vm.expenseType, onSaveSuccess, onSaveError);
            } else {
                ExpenseType.save(vm.expenseType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ExpenseTypeDetailController', ExpenseTypeDetailController);

    ExpenseTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ExpenseType'];

    function ExpenseTypeDetailController($scope, $rootScope, $stateParams, entity, ExpenseType) {
        var vm = this;
        vm.expenseType = entity;
        vm.load = function (id) {
            ExpenseType.get({id: id}, function(result) {
                vm.expenseType = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:expenseTypeUpdate', function(event, result) {
            vm.expenseType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ExpenseTypeDeleteController',ExpenseTypeDeleteController);

    ExpenseTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'ExpenseType'];

    function ExpenseTypeDeleteController($uibModalInstance, entity, ExpenseType) {
        var vm = this;
        vm.expenseType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ExpenseType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('reporting-area-activity', {
            parent: 'entity',
            url: '/reporting-area-activity',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                pageTitle: 'wamasysApp.reportingAreaActivity.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-area-activity/reporting-area-activity.html',
                    controller: 'ReportingAreaActivityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reportingAreaActivity');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('ReportingAreaActivity', ReportingAreaActivity);

    ReportingAreaActivity.$inject = ['$resource'];

    function ReportingAreaActivity($resource) {
        return $resource('api/reporting-area-activity', {}, {
            'getFilters': {
                method: 'GET',
                isArray: false,
                url: '/api/reporting-area-activity/filters'
            },
            'get': {
                method: 'GET',
                isArray: false
            },
            'downloadJson': {
                method: 'GET',
                headers: {
                    accept: 'application/json'
                },
                responseType: 'arraybuffer',
                url: '/api/reporting-area-activity/download-json',
                transformResponse: function(data, headers) {
                    var filename = headers('FileName') || 'reporting-area-activity.json';
                    var contentType = headers('ContentType') || 'application/json';
                    var file = null;
                    if (data) {
                        file = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: file,
                        fileName: filename,
                        contentType: contentType
                    };
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReportingAreaActivityController', ReportingAreaActivityController);

    ReportingAreaActivityController.$inject = ['ReportingAreaActivity', 'AlertService', '$translate'];

    function ReportingAreaActivityController(ReportingAreaActivity, AlertService, $translate) {
        var vm = this;

        vm.loading = true;
        vm.filterOptionsReady = false;
        vm.hasLoadedData = false;
        vm.reporting = null;
        vm.areas = [];
        vm.agencyOptions = [];
        vm.agencyFilters = {};
        vm.visibleAreas = [];
        vm.areaOptions = [];
        vm.areaFilters = {};
        vm.sortedAreas = [];
        vm.kpis = [];
        vm.visibleKpis = [];
        vm.kpiGroups = [];
        vm.visibleKpiGroups = [];
        vm.groupOptions = [];
        vm.groupFilters = {};
        vm.filtersCollapsed = false;
        vm.sortKey = 'areaName';
        vm.sortDescending = false;
        vm.applyFilters = applyFilters;
        vm.downloadJson = downloadJson;
        vm.getSortIcon = getSortIcon;
        vm.hasSelectedAreas = hasSelectedAreas;
        vm.onAgencyFilterChanged = onAgencyFilterChanged;
        vm.onAreaFilterChanged = onAreaFilterChanged;
        vm.refreshView = refreshView;
        vm.sortBy = sortBy;
        vm.toggleFilters = toggleFilters;

        loadFilters();

        function loadFilters() {
            vm.loading = true;
            vm.kpis = buildKpiDefinitions();
            vm.kpiGroups = buildKpiGroups(vm.kpis);
            ReportingAreaActivity.getFilters(onFiltersSuccess, onError);
        }

        function onFiltersSuccess(data) {
            vm.filterOptionsReady = true;
            initializeFilters(data);
            vm.loading = false;
        }

        function onSuccess(data) {
            vm.reporting = data;
            vm.areas = (data.areas || []).map(enrichArea);
            refreshView();
            vm.hasLoadedData = true;
            vm.loading = false;
        }

        function onError(error) {
            vm.loading = false;
            AlertService.error(error && error.data && error.data.message ? error.data.message : 'Unable to load reporting.');
        }

        function enrichArea(area) {
            area.contractsPerCollector = buildWorkload(area.latestKnownActiveContracts, area.latestKnownCollectors);
            area.contractsPerReader = buildWorkload(area.latestKnownActiveContracts, area.latestKnownReaders);
            area.cells = buildCells(area);
            return area;
        }

        function buildKpiGroups(kpis) {
            var groups = [];
            angular.forEach(kpis, function(kpi) {
                var lastGroup = groups.length ? groups[groups.length - 1] : null;
                if (!lastGroup || lastGroup.key !== kpi.groupKey) {
                    groups.push({
                        key: kpi.groupKey,
                        label: kpi.groupLabel,
                        span: 1
                    });
                } else {
                    lastGroup.span += 1;
                }
            });
            return groups;
        }

        function buildKpiDefinitions() {
            return [
                metric('contractsOpened', 'contractsOpened', 'contracts'),
                metric('contractsClosed', 'contractsClosed', 'contracts'),
                metric('meterReadingForms', 'meterReadingForms', 'meterReading'),
                metric('metersToRead', 'metersToRead', 'meterReading'),
                metric('metersRead', 'metersRead', 'meterReading'),
                metric('metersNotRead', 'metersNotRead', 'meterReading'),
                metric('metersWithPhoto', 'metersWithPhoto', 'meterReading'),
                metric('collectionLists', 'collectionLists', 'payments'),
                metric('contractsToCollect', 'contractsToCollect', 'payments'),
                metric('collectedContracts', 'collectedContracts', 'payments'),
                metric('collectionPayments', 'collectionPayments', 'payments'),
                metric('collectionPaymentsWithSignature', 'collectionPaymentsWithSignature', 'payments'),
                metric('agencyCollections', 'agencyCollections', 'payments'),
                metric('mobileMoneyCollections', 'mobileMoneyCollections', 'payments'),
                metric('quotesCreated', 'quotesCreated', 'billing'),
                metric('quotesTransformedToSale', 'quotesTransformedToSale', 'billing'),
                metric('invoicesGenerated', 'invoicesGenerated', 'billing'),
                metric('paymentRecoveryNotices', 'paymentRecoveryNotices', 'billing'),
                metric('refunds', 'refunds', 'financialAdjustment'),
                metric('paymentCorrections', 'paymentCorrections', 'financialAdjustment'),
                metric('avoirs', 'avoirs', 'financialAdjustment'),
                metric('creditNotes', 'creditNotes', 'financialAdjustment'),
                metric('debtWaivers', 'debtWaivers', 'financialAdjustment'),
                metric('windfallGains', 'windfallGains', 'financialAdjustment'),
                metric('calendarEventsCreated', 'calendarEventsCreated', 'teamwork'),
                metric('eventFormsCreated', 'eventFormsCreated', 'teamwork'),
                metric('automationMessages', 'automationMessages', 'communication'),
                metric('campaignMessages', 'campaignMessages', 'communication'),
                metric('clientPortalPageViews', 'clientPortalPageViews', 'clientPortal'),
                metric('clientPortalUniqueUsers', 'clientPortalUniqueUsers', 'clientPortal'),
                metric('clientPortalEmailLogins', 'clientPortalEmailLogins', 'clientPortal'),
                metric('clientPortalSmsLogins', 'clientPortalSmsLogins', 'clientPortal'),
                metric('clientPortalLostPasswords', 'clientPortalLostPasswords', 'clientPortal')
            ];

            function metric(key, field, groupKey) {
                return {
                    key: key,
                    field: field,
                    label: $translate.instant('wamasysApp.reportingAreaActivity.metrics.' + key),
                    groupKey: groupKey,
                    groupLabel: $translate.instant('wamasysApp.reportingAreaActivity.groups.' + groupKey)
                };
            }
        }

        function buildCells(area) {
            var months = area.months || [];
            var activeContracts = area.latestKnownActiveContracts;

            return vm.kpis.map(function(definition) {
                var values = months.map(function(month) {
                    return safeLong(month[definition.field]);
                });
                var latest = values.length ? values[values.length - 1] : 0;
                var total = values.reduce(function(sum, value) {
                    return sum + value;
                }, 0);
                var ratio = buildPerContractRatio(total, activeContracts);

                return {
                    key: definition.key,
                    label: definition.label,
                    latest: latest,
                    ratio: ratio,
                    total: total,
                    tooltip: buildTooltip(total, ratio, activeContracts),
                    sparkline: buildSparkline(months, definition.field)
                };
            });
        }

        function initializeFilters(filters) {
            vm.agencyFilters = {};
            vm.areaFilters = {};
            vm.groupFilters = {};
            vm.agencyOptions = (filters && filters.agencies ? filters.agencies : []).slice().sort(function(left, right) {
                return compareText(left.name, right.name);
            });
            vm.areaOptions = (filters && filters.areas ? filters.areas : []).slice().sort(function(left, right) {
                return compareText(left.name, right.name);
            });
            vm.groupOptions = vm.kpiGroups.map(function(group) {
                return {
                    key: group.key,
                    label: group.label
                };
            });

            angular.forEach(vm.agencyOptions, function(option) {
                vm.agencyFilters[option.id] = false;
            });
            angular.forEach(vm.areaOptions, function(option) {
                vm.areaFilters[option.id] = false;
            });
            angular.forEach(vm.groupOptions, function(option) {
                vm.groupFilters[option.key] = true;
            });
        }

        function buildSparkline(months, field) {
            var values = (months || []).map(function(month) {
                return safeLong(month[field]);
            });

            if (!values || !values.length) {
                return null;
            }

            var width = 108;
            var height = 28;
            var padding = 4;
            var max = Math.max.apply(null, values.concat([0]));
            var min = Math.min.apply(null, values.concat([0]));
            var range = max - min;

            var points = values.map(function(value, index) {
                var x = values.length === 1 ? width / 2 : padding + (index * (width - (padding * 2)) / (values.length - 1));
                var y = range === 0 ? height / 2 : height - padding - (((value - min) / range) * (height - (padding * 2)));
                var monthLabel = months[index] && months[index].month ? months[index].month : String(index + 1);
                return {
                    x: x,
                    y: y,
                    value: value,
                    title: monthLabel + ' : ' + value
                };
            });

            return {
                width: width,
                height: height,
                polylinePoints: points.map(function(point) {
                    return point.x.toFixed(2) + ',' + point.y.toFixed(2);
                }).join(' '),
                points: points
            };
        }

        function safeLong(value) {
            return value || 0;
        }

        function buildWorkload(activeContracts, headcount) {
            var contracts = safeLong(activeContracts);
            var people = safeLong(headcount);
            if (!people) {
                return null;
            }
            return contracts / people;
        }

        function buildPerContractRatio(totalValue, activeContracts) {
            var contracts = safeLong(activeContracts);
            if (!contracts) {
                return null;
            }
            return totalValue / contracts;
        }

        function formatPerContractRatio(ratio) {
            if (ratio === null) {
                return '-';
            }
            return ratio.toFixed(2) + ' / ' + $translate.instant('wamasysApp.reportingAreaActivity.table.contract');
        }

        function buildTooltip(totalValue, ratio, activeContracts) {
            return $translate.instant('wamasysApp.reportingAreaActivity.table.ratioTooltip', {
                totalValue: totalValue || 0,
                ratioValue: formatPerContractRatio(ratio),
                activeContracts: activeContracts || 0
            });
        }

        function hasSelectedAreas() {
            return vm.areaOptions.some(function(option) {
                return vm.areaFilters[option.id] === true;
            });
        }

        function onAgencyFilterChanged(agencyId) {
            var isSelected = vm.agencyFilters[agencyId] === true;
            angular.forEach(vm.areaOptions, function(option) {
                if (option.agencyId === agencyId) {
                    vm.areaFilters[option.id] = isSelected;
                }
            });
        }

        function onAreaFilterChanged(areaId) {
            var areaOption = null;
            angular.forEach(vm.areaOptions, function(option) {
                if (option.id === areaId) {
                    areaOption = option;
                }
            });

            if (!areaOption) {
                return;
            }

            var hasSelectedAreaForAgency = vm.areaOptions.some(function(option) {
                return option.agencyId === areaOption.agencyId && vm.areaFilters[option.id] === true;
            });
            vm.agencyFilters[areaOption.agencyId] = hasSelectedAreaForAgency;
        }

        function applyFilters() {
            var request = buildRequestParameters();
            if (!request.areaIds) {
                vm.reporting = null;
                vm.areas = [];
                vm.visibleAreas = [];
                vm.sortedAreas = [];
                vm.hasLoadedData = false;
                AlertService.error($translate.instant('wamasysApp.reportingAreaActivity.home.selectionRequired'));
                return;
            }

            vm.loading = true;
            ReportingAreaActivity.get(request, onSuccess, onError);
        }

        function buildRequestParameters() {
            var selectedAreaIds = vm.areaOptions.filter(function(option) {
                return vm.areaFilters[option.id] === true;
            }).map(function(option) {
                return option.id;
            });
            var selectedGroupKeys = vm.groupOptions.filter(function(option) {
                return vm.groupFilters[option.key] !== false;
            }).map(function(option) {
                return option.key;
            });

            return {
                areaIds: selectedAreaIds.join(','),
                groupKeys: selectedGroupKeys.join(',')
            };
        }

        function refreshView() {
            vm.visibleAreas = (vm.areas || []).filter(function(area) {
                if (vm.agencyFilters[area.agencyId || 0] === false) {
                    return false;
                }
                return vm.areaFilters[area.areaId] !== false;
            });
            vm.visibleKpis = (vm.kpis || []).filter(function(kpi) {
                return vm.groupFilters[kpi.groupKey] !== false;
            });
            vm.visibleKpiGroups = buildKpiGroups(vm.visibleKpis);
            angular.forEach(vm.visibleAreas, function(area) {
                area.visibleCells = buildVisibleCells(area);
            });

            if (vm.sortKey !== 'areaName' && !findVisibleKpi(vm.sortKey)) {
                vm.sortKey = 'areaName';
                vm.sortDescending = false;
            }

            applySorting();
        }

        function toggleFilters() {
            vm.filtersCollapsed = !vm.filtersCollapsed;
        }

        function sortBy(kpiKey) {
            if (vm.sortKey === kpiKey) {
                vm.sortDescending = !vm.sortDescending;
            } else {
                vm.sortKey = kpiKey;
                vm.sortDescending = true;
            }
            applySorting();
        }

        function applySorting() {
            vm.sortedAreas = (vm.visibleAreas || []).slice().sort(function(left, right) {
                if (vm.sortKey === 'areaName') {
                    var nameComparison = compareText(left.areaName, right.areaName);
                    return vm.sortDescending ? (nameComparison * -1) : nameComparison;
                }

                var leftValue = getSortValue(left, vm.sortKey);
                var rightValue = getSortValue(right, vm.sortKey);

                if (leftValue === null && rightValue === null) {
                    return compareText(left.areaName, right.areaName);
                }
                if (leftValue === null) {
                    return 1;
                }
                if (rightValue === null) {
                    return -1;
                }
                if (leftValue === rightValue) {
                    return compareText(left.areaName, right.areaName);
                }

                if (vm.sortDescending) {
                    return rightValue > leftValue ? 1 : -1;
                }
                return leftValue > rightValue ? 1 : -1;
            });
        }

        function getSortValue(area, sortKey) {
            if (sortKey === 'areaName') {
                return area.areaName || '';
            }
            var cell = findCell(area, sortKey);
            if (!cell) {
                return null;
            }
            return cell.total || 0;
        }

        function compareText(left, right) {
            left = left || '';
            right = right || '';
            return left.localeCompare(right);
        }

        function findCell(area, key) {
            if (!area || !area.cells) {
                return null;
            }
            for (var index = 0; index < area.cells.length; index++) {
                if (area.cells[index].key === key) {
                    return area.cells[index];
                }
            }
            return null;
        }

        function findVisibleKpi(key) {
            for (var index = 0; index < vm.visibleKpis.length; index++) {
                if (vm.visibleKpis[index].key === key) {
                    return vm.visibleKpis[index];
                }
            }
            return null;
        }

        function buildVisibleCells(area) {
            return vm.visibleKpis.map(function(kpi) {
                return findCell(area, kpi.key);
            }).filter(function(cell) {
                return !!cell;
            });
        }

        function getSortIcon(kpiKey) {
            if (vm.sortKey !== kpiKey) {
                return 'fa-sort';
            }
            return vm.sortDescending ? 'fa-sort-desc' : 'fa-sort-asc';
        }

        function downloadJson() {
            var request = buildRequestParameters();
            if (!request.areaIds) {
                AlertService.error($translate.instant('wamasysApp.reportingAreaActivity.home.selectionRequired'));
                return;
            }

            ReportingAreaActivity.downloadJson(request, function(content) {
                var url = URL.createObjectURL(content.response);
                var link = document.createElement('a');
                link.href = url;
                link.download = content.fileName;
                link.target = '_blank';
                link.click();
            }, onError);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporting-accounting', {
            parent: 'entity',
            url: '/reporting-accounting?page&sort',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-accounting/reporting-accounting.html',
                    controller: 'ReportingAccountingController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ReportingAccounting', ReportingAccounting);

    ReportingAccounting.$inject = ['$resource'];

    function ReportingAccounting ($resource) {
        var resourceUrl =  'api/accounting-export/';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
	       , 'download' :{
	       	 method:'GET', 
	       	 responseType: 'arraybuffer',
	           headers: {
	           	'Content-Type': undefined
	           },
	           cache: false,
	           transformResponse: function (data) {
	               return {
	                 response: new Blob([data], {type: 'text/csv'})
	               };
	           },
	       	 url :'api/accounting-export/download/:idAgence/:accountingName'
	       }
        });
        
    }
    
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReportingAccountingController', ReportingAccountingController);

    ReportingAccountingController.$inject = ['$scope', '$state', '$filter', 'ParseLinks', 'AlertService', 'ReportingAccounting','pagingParams','paginationConstants'];

    function ReportingAccountingController ($scope, $state, $filter,  ParseLinks, AlertService, ReportingAccounting,pagingParams,paginationConstants) {

    	  var vm = this;
          vm.loadAll = loadAll;
          vm.loadPage = loadPage;
          vm.predicate = pagingParams.predicate;
          vm.reverse = pagingParams.ascending;
          vm.transition = transition;
          vm.getDisplayFileName = getDisplayFileName;
          vm.loadAll();

          function loadAll () {
              ReportingAccounting.query({
                  page: pagingParams.page - 1,
                  size: paginationConstants.itemsPerPage,
                  sort: sort()
              }, onSuccess, onError);
              function sort() {
                  var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                  if (vm.predicate !== 'id') {
                      result.push('id, asc');
                  }
                  return result;
              }
              function onSuccess(data, headers) {
                  vm.links = ParseLinks.parse(headers('link'));
                  vm.totalItems = headers('X-Total-Count');
                  vm.queryCount = vm.totalItems;
                  vm.reportingAccountings = data;
                  vm.page = pagingParams.page;
              }
              function onError(error) {
                  AlertService.error(error.data.message);
              }
          }

          function loadPage (page) {
              vm.page = page;
              vm.transition();
          }

          function transition () {
              $state.transitionTo($state.$current, {
                  page: vm.page,
                  sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                  search: vm.currentSearch
              });
          }
          
          
          $scope.downloadAccounting = function(idAgence,accountingName) {
        	  ReportingAccounting.download({
        		 idAgence : idAgence,
        		 accountingName: accountingName
  			}, function(result) {
  		          
  	                var file = result.response;

  	               var url = window.URL || window.webkitURL;

                    var downloadLink = angular.element('<a></a>');
                    downloadLink.attr('href', url.createObjectURL(file));
                    downloadLink.attr('target','_blank');
                    downloadLink.attr('download', accountingName);
                    downloadLink[0].click();
                    downloadLink.remove();
	                    
//  	                var isChrome = !!window.chrome && !!window.chrome.webstore;
//  	                var isIE = /*@cc_on!@*/false || !!document.documentMode;
//  	                var isEdge = !isIE && !!window.StyleMedia; 
//  	                if (isChrome){
//  	                    var url = window.URL || window.webkitURL;
//
//  	                    var downloadLink = angular.element('<a></a>');
//  	                    downloadLink.attr('href', url.createObjectURL(file));
//  	                    downloadLink.attr('target','_blank');
//  	                    downloadLink.attr('download', accountingName);
//  	                    downloadLink[0].click();
//  	                    downloadLink.remove();
//  	                }
//  	                else if(isEdge || isIE){
//  	                    window.navigator.msSaveOrOpenBlob(file,'file.csv');
//  	                }
//  	                else {
//  	                    var fileURL = URL.createObjectURL(file);
//  	                    window.open(fileURL);
//  	              
//  	                }

  			});
  			
  		}

          function getDisplayFileName(fileName) {
              if (!fileName) {
                  return fileName;
              }
              var lastSlashIndex = fileName.lastIndexOf('/');
              return lastSlashIndex === -1 ? fileName : fileName.substring(lastSlashIndex + 1);
          }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('profil-contrat', {
            parent: 'entity',
            url: '/profil-contrat?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.contractProfil.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/profil-contrat/profil-contrats.html',
                    controller: 'ContractProfilController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contractProfil');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('profil-contrat-detail', {
            parent: 'entity',
            url: '/profil-contrat/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.contractProfil.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/profil-contrat/profil-contrat-detail.html',
                    controller: 'ContractProfilDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contractProfil');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ContractProfil', function($stateParams, ContractProfil) {
                    return ContractProfil.get({id : $stateParams.id});
                }]
            }
        })
        .state('profil-contrat.new', {
            parent: 'profil-contrat',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/profil-contrat/profil-contrat-dialog.html',
                    controller: 'ContractProfilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('profil-contrat', null, { reload: true });
                }, function() {
                    $state.go('profil-contrat');
                });
            }]
        })
        .state('profil-contrat.edit', {
            parent: 'profil-contrat',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/profil-contrat/profil-contrat-dialog.html',
                    controller: 'ContractProfilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ContractProfil', function(ContractProfil) {
                            return ContractProfil.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('profil-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profil-contrat.delete', {
            parent: 'profil-contrat',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/profil-contrat/profil-contrat-delete-dialog.html',
                    controller: 'ContractProfilDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ContractProfil', function(ContractProfil) {
                            return ContractProfil.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('profil-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ContractProfil', ContractProfil);

    ContractProfil.$inject = ['$resource'];

    function ContractProfil ($resource) {
        var resourceUrl =  'api/profil-contract/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractProfilController', ContractProfilController);

    ContractProfilController.$inject = ['$scope', '$state', 'ContractProfil', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ContractProfilController ($scope, $state, ContractProfil, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            ContractProfil.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.contractProfils = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractProfilDialogController', ContractProfilDialogController);

    ContractProfilDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ContractProfil'];

    function ContractProfilDialogController ($scope, $stateParams, $uibModalInstance, entity, ContractProfil) {
        var vm = this;
        vm.contractProfil = entity;
        vm.load = function(id) {
            ContractProfil.get({id : id}, function(result) {
                vm.contractProfil = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:contractProfilUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.contractProfil.id !== null) {
                ContractProfil.update(vm.contractProfil, onSaveSuccess, onSaveError);
            } else {
                ContractProfil.save(vm.contractProfil, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractProfilDetailController', ContractProfilDetailController);

    ContractProfilDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ContractProfil'];

    function ContractProfilDetailController($scope, $rootScope, $stateParams, entity, ContractProfil) {
        var vm = this;
        vm.contractProfil = entity;
        vm.load = function (id) {
            ContractProfil.get({id: id}, function(result) {
                vm.contractProfil = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:contractProfilUpdate', function(event, result) {
            vm.contractProfil = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractProfilDeleteController',ContractProfilDeleteController);

    ContractProfilDeleteController.$inject = ['$uibModalInstance', 'entity', 'ContractProfil'];

    function ContractProfilDeleteController($uibModalInstance, entity, ContractProfil) {
        var vm = this;
        vm.contractProfil = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ContractProfil.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('IOmobileMoneyController', IOmobileMoneyController);

    IOmobileMoneyController.$inject = ['$scope', '$state', '$filter', 'ParseLinks', 'AlertService', 'Importation','Contrat'];

    function IOmobileMoneyController ($scope, $state, $filter,  ParseLinks, AlertService, Importation,Contrat) {
        var vm = this;
     
        

    	vm.download = function(){
    		Contrat.downloadImpayeMobileMoney( {}
//        		fromDate:$filter('date')(new Date(vm.date.startDate), "yyyy-MM-dd"),
//        		toDate:$filter('date')(new Date(vm.date.endDate), "yyyy-MM-dd")}
    			,function (content){
    		      var url = URL.createObjectURL(content.response);
    		      var a = document.createElement('a');
    		      a.href = url;
    		      a.download = content.fileName;
    		      a.target = '_blank';
    		      a.click();
    		}
    				
    		);
    	}
    	
		 //Boite de dialog d'attente.
			var $dialog = $(
					'<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-hidden="true" style="padding-top:15%; overflow-y:visible;">' +
					'<div class="modal-dialog modal-m">' +
					'<div class="modal-content">' +
						'<div class="modal-header"><h3 style="margin:0;"></h3></div>' +
						'<div class="modal-body">' +
							'<div class="progress progress-striped active" style="margin-bottom:0;"><div class="progress-bar" style="width: 100%"></div></div>' +
						'</div>' +
					'</div></div></div>');
	
			var options = {};
			var message = 'Please wait ! Action in progress.';
			var settings = $.extend({
				dialogSize: 'm',
				progressType: '',
				onHide: null // This callback runs after the dialog was hidden
			}, options);
			$dialog.find('.modal-dialog').attr('class', 'modal-dialog').addClass('modal-' + settings.dialogSize);
			$dialog.find('.progress-bar').attr('class', 'progress-bar');
			$dialog.find('h3').text(message);
			
			
		
		
		
         vm.importCreditNote = function(){
         	 vm.businessAlert = null;
             vm.businessInfo = null;
             var file = $scope.fileToImportCreditNote;
             var fd = new FormData();
             fd.append('file', file);

			 $dialog.modal();
             Importation.importPaiementMobileMoney({},fd, onSaveSuccess, onSaveError);
             $scope.fileToImportCreditNote = '';
             
          };

          var onSaveSuccess = function (result) {
			  $dialog.modal('hide');
              vm.businessInfo = "Les paiements ont été correctement enregistrés";
              $scope.fileToImportCreditNote = '';
           //   $scope.$emit('wamasysApp:importUpdate', result);
          };

          var onSaveError = function (httpResponse) {
				$dialog.modal('hide');
              $scope.fileToImportCreditNote = '';
              var errorHeader = httpResponse.headers('X-wamasysApp-error');
//              var entityKey = httpResponse.headers('X-wamasysApp-params');
              if(errorHeader){
             	 if(errorHeader.search("error.business.")>-1){
                      vm.businessAlert =  $filter('translate')(errorHeader);
             	 }else{
                      vm.businessAlert = errorHeader.replace("error.", "");
             	 }
              }
              
              angular.copy( $scope.fileToUploadGPSCoordonnees);
              angular.element("input[type='file']").val(null);
              
              vm.isSaving = false;
          };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('importation', {
            parent: 'entity',
            url: '/importation',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.reportingGlobal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/importation/importation.html',
                    controller: 'ImportationController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('importation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('io-mobile-money', {
            parent: 'entity',
            url: '/io-mobile-money',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.importation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/importation/io-mobile-money.html',
                    controller: 'IOmobileMoneyController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('importation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        } );
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('Importation', Importation);

    Importation.$inject = ['$resource'];

    function Importation ($resource) {
        var resourceUrl =  'api/importation/';

        return $resource(resourceUrl, {}, {
            'uploadFile': { 
            	method: 'POST',
            	transformRequest: angular.identity,
                headers: {
                	'Content-Type': undefined
                }
            },
            'uploadFileUpdateContract': { 
            	method: 'POST',
            	url:'api/import_csv/update_contracts',
            	transformRequest: angular.identity,
                headers: {
                	'Content-Type': undefined
                }
            },
            'importBalanceTransfer': { 
            	method: 'POST',
            	url:'api/import_csv/import_balance_transfer',
            	transformRequest: angular.identity,
                headers: {
                	'Content-Type': undefined
                }
            },
            'importServiceCloseOrStandbyOnContracts': { 
            	method: 'POST',
            	url:'api/import_csv/import_update_service__on_contracts',
            	transformRequest: angular.identity,
                headers: {
                	'Content-Type': undefined
                }
            },
            'importCreditNote': { 
            	method: 'POST',
            	url:'api/import_csv/import_credit_note',
            	transformRequest: angular.identity,
                headers: {
                	'Content-Type': undefined
                }
            },
            'importLineContract': {
            	method: 'POST',
            	url:'api/import_csv/import_line_contract',
            	transformRequest: angular.identity,
                headers: {
                	'Content-Type': undefined
                }
            },
            'importWaterConsumptionCorrection': {
            	method: 'POST',
            	url:'api/import_csv/import_water_consumption_correction',
            	transformRequest: angular.identity,
                headers: {
                	'Content-Type': undefined
                }
            },
            'importPaiementMobileMoney': { 
            	method: 'POST',
            	url:'api/import_csv/import_paiement_mobile_money',
            	transformRequest: angular.identity,
                headers: {
                	'Content-Type': undefined
                }
            }
            
            

        });
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ImportationController', ImportationController);

    ImportationController.$inject = ['$scope', '$state', '$filter', 'ParseLinks', 'AlertService', 'Importation'];

    function ImportationController ($scope, $state, $filter,  ParseLinks, AlertService, Importation) {
        var vm = this;
     
        
        

        vm.importBalanceTransfer = function(){
        	vm.businessAlert = null;
            var file = $scope.fileToImportBalanceTransfer;
                       
            var fd = new FormData();
            fd.append('file', file);
            Importation.importBalanceTransfer({},fd, onSaveSuccess, onSaveError);
            
         };


         vm.importServiceCloseOrStandbyOnContracts = function(){
         	vm.businessAlert = null;
             var file = $scope.fileToImportServiceCloseOrStandbyOnContracts;
                        
             var fd = new FormData();
             fd.append('file', file);
             Importation.importServiceCloseOrStandbyOnContracts({},fd, onSaveSuccess, onSaveError);
             
          };
          

         vm.importCreditNote = function(){
         	vm.businessAlert = null;
             var file = $scope.fileToImportCreditNote;
                        
             var fd = new FormData();
             fd.append('file', file);
             Importation.importCreditNote({},fd, onSaveSuccess, onSaveError);
             
          };

         vm.importLineContract = function(){
         	vm.businessAlert = null;
             var file = $scope.fileToImportLineContract;

             var fd = new FormData();
             fd.append('file', file);
             Importation.importLineContract({},fd, onSaveSuccess, onSaveError);
         };

         vm.importWaterConsumptionCorrection = function(){
         	vm.businessAlert = null;
             var file = $scope.fileToImportWaterConsumptionCorrection;

             var fd = new FormData();
             fd.append('file', file);
             Importation.importWaterConsumptionCorrection({},fd, onSaveSuccess, onSaveError);
         };
         
         
        vm.uploadFileUpdateContract = function(){
        	vm.businessAlert = null;
            var file = $scope.fileToUploadGPSCoordonnees;
                       
            var fd = new FormData();
            fd.append('file', file);
            Importation.uploadFileUpdateContract({},fd, onSaveSuccess, onSaveError);
            
//           angular.copy($scope.fileToUploadGPSCoordonnees );
//            = null;
         };
         
        vm.uploadFile = function(){
        	vm.businessAlert = null;
            var file = $scope.fileToUpload;
                        
            var fd = new FormData();
            fd.append('file', file);
            Importation.uploadFile({},fd, onSaveSuccess, onSaveError);
            
         };
         
         var onSaveSuccess = function (result) {
             $scope.$emit('wamasysApp:importUpdate', result);
         };

         var onSaveError = function (httpResponse) {
             var errorHeader = httpResponse.headers('X-wamasysApp-error');
             var errorDetail = httpResponse.headers('X-wamasysApp-detail');
             if(errorDetail){
             	vm.businessAlert = errorDetail;
             }else if(errorHeader){
            	 if(errorHeader.search("error.business.")>-1){
                     vm.businessAlert =  $filter('translate')(errorHeader);
            	 }else{
                     vm.businessAlert = errorHeader.replace("error.", "");
            	 }
             }
             
             angular.copy( $scope.fileToUploadGPSCoordonnees);
             angular.element("input[type='file']").val(null);
             
             vm.isSaving = false;
         };
         
        /* 

         var fichier = document.getElementById('fichier').files[0];
         var lecture = new FileReader();
         lecture.onloadend = function(evenement){
	         var donnees = evenement.target.result;
	         //Traitez ici vos données binaires. Vous pouvez par exemple les envoyer à un autre niveau du framework avec $http ou $ressource
	       }
         lecture.readAsBinaryString(fichier);
         }
*/
    }
})();
;
'use strict';

angular.module('wamasysApp').directive('fileModel',[ '$parse', function ($parse) { 
    return {
        restrict: 'EA',
		scope: {
			setFileData: "&"
		},
        link: function(scope, element, attrs) {
           var model = $parse(attrs['fileModel']);
           var modelSetter = model.assign;
           
           element.bind('change', function(){
              scope.$apply(function(){
                 modelSetter(scope, element[0].files[0]);
				 scope.setFileData({ value: element[0].files[0] });
              });
           });
        }
     };
} ]);;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('manual-help', {
            parent: 'entity',
            url: '/manual-help?doc&section',
            data: {
                authorities: [
                    'ROLE_DATA_OPERATOR',
                    'ROLE_READ_ONLY',
                    'ROLE_AREA_MANAGEMENT',
                    'ROLE_COLLECTOR',
                    'ROLE_AI_ASSISTANT',
                    'ROLE_ADMIN',
                    'ROLE_SUPER_ADMIN'
                ],
                pageTitle: 'Documentation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/manual-help/manual-help.html',
                    controller: 'ManualHelpController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('ManualHelp', ManualHelp);

    ManualHelp.$inject = ['$resource'];

    function ManualHelp($resource) {
        return $resource('api/help/manual/documents/:key', {key: '@key'}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET'
            },
            'indexDocuments': {
                method: 'POST',
                url: 'api/help/manual/index'
            },
            'chatAssistant': {
                method: 'POST',
                url: 'api/help/manual/chat',
                transformRequest: function(data) {
                    return angular.toJson(data);
                }
            },
            'getAssistantUsage': {
                method: 'GET',
                url: 'api/help/manual/usage'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ManualHelpController', ManualHelpController);

    ManualHelpController.$inject = ['$scope', '$element', '$state', '$stateParams', '$sce', '$timeout', '$window', 'ManualHelp',
        'ManualHelpContextService', 'Principal', 'AlertService'];

    function ManualHelpController($scope, $element, $state, $stateParams, $sce, $timeout, $window, ManualHelp,
        ManualHelpContextService, Principal, AlertService) {
        var vm = this;
        var markdownRootElement = null;
        var markdownClickHandler = null;
        var $body = angular.element('body');
        var wasMinifiedOnEntry = false;
        var sectionScrollRetryToken = 0;
        var sectionScrollRetryDelays = [0, 150, 400, 900, 1800];

        vm.context = ManualHelpContextService.state;
        vm.documents = [];
        vm.currentDocument = null;
        vm.documentHtml = null;
        vm.activeDocumentKey = null;
        vm.activeSectionId = null;
        vm.sectionTree = [];
        vm.canSearchAssistant = false;
        vm.canUseLlmAssistant = false;
        vm.canIndexDocuments = false;
        vm.isLoadingDocuments = false;
        vm.isLoadingDocument = false;
        vm.openDocument = openDocument;
        vm.openSection = openSection;
        vm.openSectionFromTree = openSectionFromTree;
        vm.toggleSectionNode = toggleSectionNode;
        vm.expandAllSections = expandAllSections;
        vm.collapseAllSections = collapseAllSections;
        vm.openAssistant = openAssistant;
        vm.openSearchResult = openSearchResult;
        vm.isResultForCurrentDocument = isResultForCurrentDocument;

        var sectionNodesById = {};

        activate();

        function activate() {
            // Masque le menu latéral pendant la consultation de la documentation.
            minifySidebarForDocumentation();
            registerMarkdownClickHandler();
            $scope.$on('$destroy', function() {
                sectionScrollRetryToken++;
                if (markdownRootElement && markdownClickHandler) {
                    angular.element(markdownRootElement).off('click', markdownClickHandler);
                }
                restoreSidebarState();
            });
            Principal.identity().then(function(account) {
                if (!account) {
                    return;
                }
                vm.canSearchAssistant = hasManualHelpSearchAuthority(account.authorities || []);
                vm.canUseLlmAssistant = (account.modules || []).indexOf('AI_ASSISTANT') !== -1
                    && hasAssistantAuthority(account.authorities || []);
                vm.canIndexDocuments = (account.authorities || []).indexOf('ROLE_SUPER_ADMIN') !== -1;
                ManualHelpContextService.setCapabilities(vm.canSearchAssistant, vm.canUseLlmAssistant);
            });

            loadDocuments();
        }

        function minifySidebarForDocumentation() {
            if ($body.hasClass('menu-on-top')) {
                return;
            }
            wasMinifiedOnEntry = $body.hasClass('minified');
            $body.addClass('minified');
            $body.removeClass('hidden-menu');
            angular.element('html').removeClass('hidden-menu-mobile-lock');
        }

        function restoreSidebarState() {
            if ($body.hasClass('menu-on-top') || wasMinifiedOnEntry) {
                return;
            }
            $body.removeClass('minified');
        }

        function loadDocuments() {
            vm.isLoadingDocuments = true;
            ManualHelp.query(function(result) {
                vm.documents = result || [];
                ManualHelpContextService.setDocuments(vm.documents);
                vm.isLoadingDocuments = false;

                openDocument(resolveInitialDocumentKey(), resolveInitialSectionId(), false);
            }, function() {
                vm.isLoadingDocuments = false;
                AlertService.error('Impossible de charger la liste de la documentation.');
            });
        }

        function resolveInitialDocumentKey() {
            return $stateParams.doc || ManualHelpContextService.state.activeDocumentKey || (vm.documents[0] && vm.documents[0].key);
        }

        function resolveInitialSectionId() {
            return $stateParams.section || ManualHelpContextService.state.activeSectionId || null;
        }

        function openDocument(documentKey, sectionId, clearSearchSelection) {
            if (!documentKey) {
                return;
            }
            if (clearSearchSelection !== false) {
                ManualHelpContextService.clearSearchSelection();
            }

            vm.isLoadingDocument = true;
            ManualHelp.get({key: documentKey}, function(result) {
                vm.currentDocument = result;
                vm.documentHtml = $sce.trustAsHtml((result && result.html) || '');
                vm.sectionTree = buildSectionTree((result && result.sections) || []);
                vm.activeDocumentKey = result.key;
                vm.activeSectionId = sectionId || null;
                expandSectionPath(vm.activeSectionId);
                vm.isLoadingDocument = false;

                ManualHelpContextService.setCurrentDocument(result);
                ManualHelpContextService.setActiveLocation(result.key, vm.activeSectionId);

                $state.go('manual-help', {
                    doc: result.key,
                    section: vm.activeSectionId
                }, {
                    notify: false,
                    location: 'replace'
                });

                registerMarkdownClickHandler();
                scheduleScrollToSection(vm.activeSectionId);
            }, function() {
                vm.isLoadingDocument = false;
                AlertService.error('Impossible de charger ce document.');
            });
        }

        function openSection(sectionId) {
            if (!vm.activeDocumentKey) {
                return;
            }
            vm.activeSectionId = sectionId || null;
            expandSectionPath(vm.activeSectionId);
            ManualHelpContextService.setActiveLocation(vm.activeDocumentKey, vm.activeSectionId);
            $state.go('manual-help', {
                doc: vm.activeDocumentKey,
                section: vm.activeSectionId
            }, {
                notify: false,
                location: 'replace'
            });
            scheduleScrollToSection(vm.activeSectionId);
        }

        function openSectionFromTree(sectionNode) {
            if (!sectionNode) {
                return;
            }
            if (sectionNode.children && sectionNode.children.length) {
                sectionNode.isExpanded = true;
            }
            openSection(sectionNode.id);
        }

        function toggleSectionNode(sectionNode, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            if (!sectionNode || !sectionNode.children || !sectionNode.children.length) {
                return;
            }
            sectionNode.isExpanded = !sectionNode.isExpanded;
        }

        function expandAllSections() {
            setSectionExpandedState(vm.sectionTree, true);
        }

        function collapseAllSections() {
            setSectionExpandedState(vm.sectionTree, false);
        }

        function openAssistant() {
            ManualHelpContextService.openAssistant();
        }

        function openSearchResult(result) {
            ManualHelpContextService.navigateToResult(result);
        }

        function isResultForCurrentDocument(result) {
            return !!(result && vm.activeDocumentKey && result.docKey === vm.activeDocumentKey);
        }

        function scrollToSection(sectionId) {
            var element;
            if (!sectionId) {
                $window.scrollTo(0, 0);
                return;
            }
            element = $window.document.getElementById(sectionId);
            if (element && angular.isFunction(element.scrollIntoView)) {
                element.scrollIntoView(true);
            }
        }

        function scheduleScrollToSection(sectionId) {
            var retryToken = ++sectionScrollRetryToken;
            // Retry after render because markdown content can appear and shift asynchronously.
            angular.forEach(sectionScrollRetryDelays, function(delay) {
                $timeout(function() {
                    if (retryToken !== sectionScrollRetryToken) {
                        return;
                    }
                    scrollToSection(sectionId);
                }, delay, false);
            });
        }

        function hasAssistantAuthority(authorities) {
            var index;
            for (index = 0; index < authorities.length; index++) {
                if (authorities[index] === 'ROLE_AI_ASSISTANT'
                    || authorities[index] === 'ROLE_ADMIN'
                    || authorities[index] === 'ROLE_SUPER_ADMIN') {
                    return true;
                }
            }
            return false;
        }

        function hasManualHelpSearchAuthority(authorities) {
            var index;
            for (index = 0; index < authorities.length; index++) {
                if (authorities[index] === 'ROLE_DATA_OPERATOR'
                    || authorities[index] === 'ROLE_READ_ONLY'
                    || authorities[index] === 'ROLE_AREA_MANAGEMENT'
                    || authorities[index] === 'ROLE_COLLECTOR'
                    || authorities[index] === 'ROLE_AI_ASSISTANT'
                    || authorities[index] === 'ROLE_ADMIN'
                    || authorities[index] === 'ROLE_SUPER_ADMIN') {
                    return true;
                }
            }
            return false;
        }

        function registerMarkdownClickHandler() {
            $timeout(function() {
                if (markdownRootElement && markdownClickHandler) {
                    angular.element(markdownRootElement).off('click', markdownClickHandler);
                }
                markdownRootElement = $element[0].querySelector('.manual-help-markdown');
                if (!markdownRootElement) {
                    return;
                }
                markdownClickHandler = handleMarkdownClick;
                angular.element(markdownRootElement).on('click', markdownClickHandler);
            }, 0, false);
        }

        function handleMarkdownClick(event) {
            var link = findClosestLink(event.target);
            var manualHelpTarget;
            var href;
            if (!link) {
                return;
            }
            href = link.getAttribute('href');
            if (!href) {
                return;
            }

            event.stopPropagation();
            if (href.charAt(0) === '#') {
                event.preventDefault();
                openSection(href.substring(1));
                return;
            }

            manualHelpTarget = parseManualHelpLink(href);
            if (!manualHelpTarget) {
                return;
            }

            event.preventDefault();
            if (manualHelpTarget.docKey && manualHelpTarget.docKey !== vm.activeDocumentKey) {
                openDocument(manualHelpTarget.docKey, manualHelpTarget.sectionId || null, true);
                return;
            }
            openSection(manualHelpTarget.sectionId || null);
        }

        function findClosestLink(target) {
            var current = target;
            while (current && current !== markdownRootElement) {
                if (current.tagName && current.tagName.toLowerCase() === 'a') {
                    return current;
                }
                current = current.parentNode;
            }
            return null;
        }

        function parseManualHelpLink(href) {
            var parser;
            var hashValue;
            var routeValue;
            var params;
            if (!href) {
                return null;
            }
            parser = $window.document.createElement('a');
            parser.href = href;
            if (parser.pathname && parser.pathname.indexOf('/manual-help') !== -1) {
                return {
                    docKey: readQueryParam(parser.search, 'doc'),
                    sectionId: normalizeHash(parser.hash)
                };
            }
            hashValue = parser.hash || '';
            if (hashValue.indexOf('#/manual-help') !== 0) {
                return null;
            }
            routeValue = hashValue.substring(1);
            params = routeValue.split('?')[1] || '';
            return {
                docKey: readQueryParam(params ? ('?' + params) : '', 'doc'),
                sectionId: normalizeHash(parser.hash.split('#')[2] ? ('#' + parser.hash.split('#')[2]) : '')
            };
        }

        function readQueryParam(search, key) {
            var expression = new RegExp('[?&]' + key + '=([^&#]*)');
            var match = expression.exec(search || '');
            return match && match[1] ? decodeURIComponent(match[1]) : null;
        }

        function normalizeHash(hash) {
            return hash && hash.charAt(0) === '#' ? hash.substring(1) : null;
        }

        function buildSectionTree(sections) {
            var tree = [];
            var stack = [];

            sectionNodesById = {};
            // Reconstitue l'arborescence a partir de la liste plate fournie par le backend.
            angular.forEach(sections || [], function(section) {
                var level = section && section.level ? section.level : 1;
                var sectionNode = {
                    id: section.id,
                    title: section.title,
                    level: level,
                    path: section.path,
                    children: [],
                    parentId: null,
                    isExpanded: false
                };

                while (stack.length && stack[stack.length - 1].level >= level) {
                    stack.pop();
                }

                if (stack.length) {
                    sectionNode.parentId = stack[stack.length - 1].id;
                    stack[stack.length - 1].children.push(sectionNode);
                } else {
                    tree.push(sectionNode);
                }

                sectionNodesById[sectionNode.id] = sectionNode;
                stack.push(sectionNode);
            });

            return tree;
        }

        function expandSectionPath(sectionId) {
            var sectionNode = sectionId ? sectionNodesById[sectionId] : null;
            // Garde visible la branche du chapitre actif apres navigation ou recherche.
            while (sectionNode) {
                if (sectionNode.children && sectionNode.children.length) {
                    sectionNode.isExpanded = true;
                }
                sectionNode = sectionNode.parentId ? sectionNodesById[sectionNode.parentId] : null;
            }
        }

        function setSectionExpandedState(sectionNodes, isExpanded) {
            angular.forEach(sectionNodes || [], function(sectionNode) {
                if (!sectionNode.children || !sectionNode.children.length) {
                    return;
                }
                sectionNode.isExpanded = isExpanded;
                setSectionExpandedState(sectionNode.children, isExpanded);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('ManualHelpContextService', ManualHelpContextService);

    ManualHelpContextService.$inject = ['$state', '$translate', 'AssistantPanelService', 'ManualHelp'];

    function ManualHelpContextService($state, $translate, AssistantPanelService, ManualHelp) {
        var state = {
            documents: [],
            currentDocument: null,
            activeDocumentKey: null,
            activeSectionId: null,
            documentResults: [],
            selectedResultDocKeys: [],
            selectedResultChunkIds: [],
            canSearch: false,
            canUseLlm: false,
            llmModeEnabled: false,
            hasSearchResults: false
        };

        return {
            state: state,
            setCapabilities: setCapabilities,
            setDocuments: setDocuments,
            setCurrentDocument: setCurrentDocument,
            setActiveLocation: setActiveLocation,
            clearSearchSelection: clearSearchSelection,
            openAssistant: openAssistant,
            navigateToResult: navigateToResult,
            enableLlmMode: enableLlmMode,
            syncAssistantContext: syncAssistantContext
        };

        function setCapabilities(canSearch, canUseLlm) {
            state.canSearch = !!canSearch;
            state.canUseLlm = !!canUseLlm;
            if (!state.canUseLlm) {
                state.llmModeEnabled = false;
            }
            syncAssistantContext();
        }

        function setDocuments(documents) {
            state.documents = angular.copy(documents || []);
        }

        function setCurrentDocument(document) {
            state.currentDocument = angular.copy(document || null);
            if (document && document.key) {
                state.activeDocumentKey = document.key;
            }
            syncAssistantContext();
        }

        function setActiveLocation(documentKey, sectionId) {
            if (documentKey) {
                state.activeDocumentKey = documentKey;
            }
            state.activeSectionId = sectionId || null;
            syncAssistantContext();
        }

        function clearSearchSelection() {
            state.selectedResultDocKeys = [];
            state.selectedResultChunkIds = [];
            state.hasSearchResults = false;
        }

        function openAssistant() {
            AssistantPanelService.open(buildAssistantContext());
        }

        function enableLlmMode() {
            if (!state.canUseLlm || !state.hasSearchResults) {
                return;
            }
            state.llmModeEnabled = true;
            syncAssistantContext();
        }

        function syncAssistantContext() {
            if (AssistantPanelService.state.isOpen
                && AssistantPanelService.state.context
                && AssistantPanelService.state.context.contextType === 'MANUAL_HELP') {
                AssistantPanelService.open(buildAssistantContext());
            }
        }

        function navigateToResult(result) {
            if (!result) {
                return;
            }
            state.selectedResultChunkIds = result.chunkId ? [result.chunkId] : [];
            state.selectedResultDocKeys = result.docKey ? [result.docKey] : [];
            setActiveLocation(result.docKey || state.activeDocumentKey, result.sectionAnchor || null);
            $state.go('manual-help', {
                doc: result.docKey || state.activeDocumentKey,
                section: result.sectionAnchor || null
            });
        }

        function buildAssistantContext() {
            return {
                contextType: 'MANUAL_HELP',
                entityId: 'manual-help',
                title: $translate.instant('global.assistant.manualTitle'),
                subtitle: resolveSubtitle(),
                promptPlaceholder: $translate.instant('global.assistant.manualPromptPlaceholder'),
                supportsActionProposal: false,
                supportsDataScopes: false,
                supportsAssistantFlowModes: false,
                defaultAssistantFlowMode: 'LEGACY',
                defaultUsageExpanded: state.llmModeEnabled,
                tokenWarningMessage: state.llmModeEnabled ? $translate.instant('global.assistant.manualTokenWarning') : null,
                canUseLlm: state.canUseLlm,
                llmModeEnabled: state.llmModeEnabled,
                hasSearchResults: state.hasSearchResults,
                showLlmUpgrade: !state.llmModeEnabled && state.hasSearchResults,
                llmUpgradeLockedMessage: !state.canUseLlm && state.hasSearchResults
                    ? $translate.instant('global.assistant.manualLlmLocked')
                    : null,
                llmUpgradeMessage: state.canUseLlm && state.hasSearchResults && !state.llmModeEnabled
                    ? $translate.instant('global.assistant.manualLlmUpgrade')
                    : null,
                enableLlmMode: enableLlmMode,
                adapter: {
                    getUsage: state.llmModeEnabled ? function(success, error) {
                        ManualHelp.getAssistantUsage(success, error);
                    } : null,
                    chat: function(payload, success, error) {
                        ManualHelp.chatAssistant(enrichPayload(payload), success, error);
                    },
                    extendChatPayload: function(payload) {
                        return enrichPayload(payload);
                    },
                    applyAssistantResponse: function(result, message) {
                        var documentResults = angular.copy((result && result.documentResults) || []);
                        message.documentResults = documentResults;
                        state.documentResults = documentResults;
                        state.selectedResultChunkIds = extractChunkIds(documentResults);
                        state.selectedResultDocKeys = extractDocKeys(documentResults);
                        state.hasSearchResults = documentResults.length > 0;
                    },
                    openDocumentResult: function(result) {
                        navigateToResult(result);
                    },
                    buildContextSignatureFragment: function() {
                        return [
                            state.activeDocumentKey || '',
                            state.activeSectionId || '',
                            state.llmModeEnabled ? 'llm' : 'search',
                            (state.selectedResultDocKeys || []).join(','),
                            (state.selectedResultChunkIds || []).join(',')
                        ].join('|');
                    },
                    buildSentContextInfo: function() {
                        return state.currentDocument && state.currentDocument.title ? state.currentDocument.title : '';
                    }
                }
            };
        }

        function enrichPayload(payload) {
            return angular.extend({}, payload || {}, {
                activeDocumentKey: state.activeDocumentKey,
                manualHelpLlmEnabled: state.llmModeEnabled,
                selectedResultDocKeys: angular.copy(state.selectedResultDocKeys || []),
                selectedResultChunkIds: angular.copy(state.selectedResultChunkIds || [])
            });
        }

        function resolveSubtitle() {
            return state.currentDocument && state.currentDocument.title
                ? state.currentDocument.title
                : $translate.instant('global.menu.help.userGuide');
        }

        function extractDocKeys(results) {
            var seen = {};
            var docKeys = [];
            angular.forEach(results || [], function(result) {
                if (!result || !result.docKey || seen[result.docKey]) {
                    return;
                }
                seen[result.docKey] = true;
                docKeys.push(result.docKey);
            });
            return docKeys;
        }

        function extractChunkIds(results) {
            var chunkIds = [];
            angular.forEach(results || [], function(result) {
                if (result && result.chunkId) {
                    chunkIds.push(result.chunkId);
                }
            });
            return chunkIds;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('portefeuille-contrat', {
            parent: 'entity',
            url: '/portefeuille-contrat?page&sort&search',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                authenticate: true,
                pageTitle: 'wamasysApp.portefeuilleContrat.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/portefeuille-contrat/portefeuille-contrats.html',
                    controller: 'PortefeuilleContratController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('portefeuilleContrat');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('portefeuille-contrat-detail', {
            parent: 'entity',
            url: '/portefeuille-contrat/{id}?page&sort&search',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                authenticate: true,
                pageTitle: 'wamasysApp.portefeuilleContrat.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/portefeuille-contrat/portefeuille-contrat-detail.html',
                    controller: 'PortefeuilleContratDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
            	pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('portefeuilleContrat');
                    $translatePartialLoader.addPart('contrat');
                    $translatePartialLoader.addPart('etatContrat');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PortefeuilleContrat', function($stateParams, PortefeuilleContrat) {
                    return PortefeuilleContrat.get({id : $stateParams.id});
                }]
            }
        })
        
        
        
        .state('portefeuille-contrat-detail.billing', {
            url: '/billing',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/portefeuille-contrat/billing-portefeuille-dialog.html',
                    controller: 'BillingPortefeuilleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['$stateParams', 'PortefeuilleContrat', function($stateParams, PortefeuilleContrat) {
//                            return PortefeuilleContrat.get({id : $stateParams.id});
                            return {id : $stateParams.id};
                        }]
                    }
                }).result.then(function(result) {                	
                    $state.go('portefeuille-contrat-detail',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('portefeuille-contrat-detail');
                });
            }]
        })
        
        
        .state('portefeuille-contrat.new', {
            parent: 'portefeuille-contrat',
            url: '/new',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/portefeuille-contrat/portefeuille-contrat-dialog.html',
                    controller: 'PortefeuilleContratDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('portefeuille-contrat', null, { reload: true });
                }, function() {
                    $state.go('portefeuille-contrat');
                });
            }]
        })
        .state('portefeuille-contrat.edit', {
            parent: 'portefeuille-contrat',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT','ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/portefeuille-contrat/portefeuille-contrat-dialog.html',
                    controller: 'PortefeuilleContratDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PortefeuilleContrat', function(PortefeuilleContrat) {
                            return PortefeuilleContrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('portefeuille-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('portefeuille-contrat.delete', {
            parent: 'portefeuille-contrat',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/portefeuille-contrat/portefeuille-contrat-delete-dialog.html',
                    controller: 'PortefeuilleContratDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PortefeuilleContrat', function(PortefeuilleContrat) {
                            return PortefeuilleContrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('portefeuille-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('PortefeuilleContrat', PortefeuilleContrat);

    PortefeuilleContrat.$inject = ['$resource','DateUtils'];

    function PortefeuilleContrat ($resource,DateUtils) {
        var resourceUrl =  'api/portefeuille-contrats/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.autoInvoiceNextDate = DateUtils.convertLocalDateFromServer(data.autoInvoiceNextDate);
                    data.autoBillingNextDate = DateUtils.convertLocalDateFromServer(data.autoBillingNextDate);
                    return data;
                }
            },
            'update': { method:'PUT' ,
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.autoInvoiceNextDate = DateUtils.convertLocalDateToServer(data.autoInvoiceNextDate);
                	clonedData.autoBillingNextDate = DateUtils.convertLocalDateToServer(data.autoBillingNextDate);
                    return angular.toJson(clonedData);
                }
            },
            'save': { method:'POST' ,
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.autoInvoiceNextDate = DateUtils.convertLocalDateToServer(data.autoInvoiceNextDate);
                	clonedData.autoBillingNextDate = DateUtils.convertLocalDateToServer(data.autoBillingNextDate);
                    return angular.toJson(clonedData);
                }
            },
            'portefeuilleContratByCollecteur' :{
              	 method:'GET', 
              	isArray: true,
              	 url :'api/portefeuille-contrats-by-collector/:idCollector'
              }
        });
    }
})();

;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('PortefeuilleContratController', PortefeuilleContratController);

    PortefeuilleContratController.$inject = ['$scope', '$state', 'PortefeuilleContrat', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PortefeuilleContratController ($scope, $state, PortefeuilleContrat, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            PortefeuilleContrat.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.portefeuilleContrats = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('PortefeuilleContratDialogController', PortefeuilleContratDialogController);

    PortefeuilleContratDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'PortefeuilleContrat',  'UserSearch','Principal','AlertService'];

    function PortefeuilleContratDialogController ($scope, $stateParams, $uibModalInstance, entity, PortefeuilleContrat,  UserSearch,Principal,AlertService) {
        var vm = this;
        vm.portefeuilleContrat = entity;
        vm.users = UserSearch.searchCollecteur({ offset: 0,size: 1000});
        vm.load = function(id) {
            PortefeuilleContrat.get({id : id}, function(result) {
                vm.portefeuilleContrat = result;
            });
        };

        vm.hasAreaManagementRight = false;
        Principal.hasAuthority('ROLE_AREA_MANAGEMENT').then(function (result) {
            if (result) {
            	vm.hasAreaManagementRight =true;
            }
        });
        
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:portefeuilleContratUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
        	if(	vm.autoBillingEnabled ==false && (vm.portefeuilleContrat.autoBillingNextDate || vm.portefeuilleContrat.autoInvoiceNextDate) ){

				AlertService.error("Please delete next billing and paper invoice date if you want to disable automation");
        		return;
        	}
            vm.isSaving = true;
            if (vm.portefeuilleContrat.id !== null) {
                PortefeuilleContrat.update(vm.portefeuilleContrat, onSaveSuccess, onSaveError);
            } else {
                PortefeuilleContrat.save(vm.portefeuilleContrat, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

		/*
	    lundi 		1	0b00000001
	    mardi 		2	0b00000010
	    mercredi 	4 	0b00000100
	    jeudi		8	0b00001000
	    vendredi	16	0b00010000
	    samedi		32	0b00100000
	    dimanche	64	0b01000000
	*/
	    var lundi = 1;	
	    var mardi = 2;	
	    var mercredi = 4;	
	    var  jeudi	=	8	;
	    var  vendredi=	16	;
	    var samedi	=	32	;
	    var dimanche=	64	;

	    if( vm.portefeuilleContrat &&  vm.portefeuilleContrat.$promise){
	    	
		    vm.portefeuilleContrat.$promise.then(function(value) {
		    	
		    	if(vm.portefeuilleContrat.autoBillingNextDate || vm.portefeuilleContrat.autoInvoiceNextDate){
		    		vm.autoBillingEnabled = true;
		    	}
		    
		
		        if(vm.portefeuilleContrat.autoBillingPeriodType == 'WEEKDAY'){
		            var billingValeurInitiale = vm.portefeuilleContrat.autoBillingInterval ;
		    	    
		    	    //On intialise le billing
		    		var billingLeLundi = (billingValeurInitiale | lundi) == billingValeurInitiale;
		    		var billingLeMardi= (billingValeurInitiale | mardi) == billingValeurInitiale;
		    		var billingLeMercredi= (billingValeurInitiale | mercredi) == billingValeurInitiale;
		    		var billingLeJeudi= (billingValeurInitiale | jeudi) == billingValeurInitiale;
		    		var billingLevendredi= (billingValeurInitiale | vendredi) == billingValeurInitiale;
		    		var billingLesamedi= (billingValeurInitiale | samedi) == billingValeurInitiale;
		    		var billingLedimanche= (billingValeurInitiale | dimanche) == billingValeurInitiale;
		    		
		    		vm.billingWeekday = [];
		    		if(billingLeLundi){
		    			vm.billingWeekday.push(""+lundi);
		    		}
		    		if(billingLeMardi){
		    			vm.billingWeekday.push(""+mardi);
		    		}
		    		if(billingLeMercredi){
		    			vm.billingWeekday.push(""+mercredi);
		    		}
		    		if(billingLeJeudi){
		    			vm.billingWeekday.push(""+jeudi);
		    		}
		    		if(billingLevendredi){
		    			vm.billingWeekday.push(""+vendredi);
		    		}
		    		if(billingLesamedi){
		    			vm.billingWeekday.push(""+samedi);
		    		}
		    		if(billingLedimanche){
		    			vm.billingWeekday.push(""+dimanche);
		    		}
		        }
	
		        if(vm.portefeuilleContrat.autoInvoicePeriodType == 'WEEKDAY'){
		            var invoiceValeurInitiale = vm.portefeuilleContrat.autoInvoiceInterval ;
		    	    
		    	    //On intialise le invoice
		    		var invoiceLeLundi = (invoiceValeurInitiale | lundi) == invoiceValeurInitiale;
		    		var invoiceLeMardi= (invoiceValeurInitiale | mardi) == invoiceValeurInitiale;
		    		var invoiceLeMercredi= (invoiceValeurInitiale | mercredi) == invoiceValeurInitiale;
		    		var invoiceLeJeudi= (invoiceValeurInitiale | jeudi) == invoiceValeurInitiale;
		    		var invoiceLevendredi= (invoiceValeurInitiale | vendredi) == invoiceValeurInitiale;
		    		var invoiceLesamedi= (invoiceValeurInitiale | samedi) == invoiceValeurInitiale;
		    		var invoiceLedimanche= (invoiceValeurInitiale | dimanche) == invoiceValeurInitiale;
		    		
		    		vm.invoiceWeekday = [];
		    		if(invoiceLeLundi){
		    			vm.invoiceWeekday.push(""+lundi);
		    		}
		    		if(invoiceLeMardi){
		    			vm.invoiceWeekday.push(""+mardi);
		    		}
		    		if(invoiceLeMercredi){
		    			vm.invoiceWeekday.push(""+mercredi);
		    		}
		    		if(invoiceLeJeudi){
		    			vm.invoiceWeekday.push(""+jeudi);
		    		}
		    		if(invoiceLevendredi){
		    			vm.invoiceWeekday.push(""+vendredi);
		    		}
		    		if(invoiceLesamedi){
		    			vm.invoiceWeekday.push(""+samedi);
		    		}
		    		if(invoiceLedimanche){
		    			vm.invoiceWeekday.push(""+dimanche);
		    		}
		        }
	        });
	    }
		
	    vm.onUpdateInvoiceWeekday= function() {
			var result = 0;
			for ( var i = 0; i < vm.invoiceWeekday.length; i++) {
				result = result + parseInt( vm.invoiceWeekday[i]);
			}

			vm.portefeuilleContrat.autoInvoiceInterval = result;
        };
	    
		vm.onUpdateBillingWeekday= function() {
			var result = 0;
			for ( var i = 0; i < vm.billingWeekday.length; i++) {
				result = result + parseInt( vm.billingWeekday[i]);
			}
			vm.portefeuilleContrat.autoBillingInterval = result;
        };
		
		
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateCloture = false;
        vm.datePickerOpenStatus.dateActivation = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('PortefeuilleContratDetailController', PortefeuilleContratDetailController);

    PortefeuilleContratDetailController.$inject = ['$scope','$state',  '$rootScope', '$stateParams', 'entity', 'PortefeuilleContrat', 'ParseLinks', 'AlertService', 'ContratSearch', 'Agence', 'User', 'pagingParams', 'paginationConstants'];

    function PortefeuilleContratDetailController($scope, $state, $rootScope, $stateParams, entity, PortefeuilleContrat,ParseLinks, AlertService, ContratSearch, Agence, User, pagingParams, paginationConstants) {
        var vm = this;
        vm.portefeuilleContrat = entity;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        
        vm.loadPage = function (page) {
        	ContratSearch.query({
            		portefeuilleContrat:$stateParams.id,                 
            		page: pagingParams.page -1,
            		size: paginationConstants.itemsPerPage,
            		sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.contrats = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
        vm.loadPage();
        
        var unsubscribe = $rootScope.$on('wamasysApp:portefeuilleContratUpdate', function(event, result) {
            vm.portefeuilleContrat = result;
        });
        $scope.$on('$destroy', unsubscribe);

        
        vm.transition = function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                id:$stateParams.id,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            });
        };
        
        
	    var lundi = 1;	
	    var mardi = 2;	
	    var mercredi = 4;	
	    var  jeudi	=	8	;
	    var  vendredi=	16	;
	    var samedi	=	32	;
	    var dimanche=	64	;

        if(vm.portefeuilleContrat && vm.portefeuilleContrat.$promise){
		    vm.portefeuilleContrat.$promise.then(function(value) {
		
		        if(vm.portefeuilleContrat.autoBillingPeriodType == 'WEEKDAY'){
		            var billingValeurInitiale = vm.portefeuilleContrat.autoBillingInterval ;
		    	    
		    	    //On intialise le billing
		    		var billingLeLundi = (billingValeurInitiale | lundi) == billingValeurInitiale;
		    		var billingLeMardi= (billingValeurInitiale | mardi) == billingValeurInitiale;
		    		var billingLeMercredi= (billingValeurInitiale | mercredi) == billingValeurInitiale;
		    		var billingLeJeudi= (billingValeurInitiale | jeudi) == billingValeurInitiale;
		    		var billingLevendredi= (billingValeurInitiale | vendredi) == billingValeurInitiale;
		    		var billingLesamedi= (billingValeurInitiale | samedi) == billingValeurInitiale;
		    		var billingLedimanche= (billingValeurInitiale | dimanche) == billingValeurInitiale;
		    		
		    		vm.billingWeekday = [];
		    		if(billingLeLundi){
		    			vm.billingWeekday.push("wamasysApp.portefeuilleContrat.periodType.monday");
		    		}
		    		if(billingLeMardi){
		    			vm.billingWeekday.push("wamasysApp.portefeuilleContrat.periodType.tuesday");
		    		}
		    		if(billingLeMercredi){
		    			vm.billingWeekday.push("wamasysApp.portefeuilleContrat.periodType.wednesday");
		    		}
		    		if(billingLeJeudi){
		    			vm.billingWeekday.push("wamasysApp.portefeuilleContrat.periodType.thursday");
		    		}
		    		if(billingLevendredi){
		    			vm.billingWeekday.push("wamasysApp.portefeuilleContrat.periodType.friday");
		    		}
		    		if(billingLesamedi){
		    			vm.billingWeekday.push("wamasysApp.portefeuilleContrat.periodType.saturday");
		    		}
		    		if(billingLedimanche){
		    			vm.billingWeekday.push("wamasysApp.portefeuilleContrat.periodType.sunday");
		    		}
		        }
	
		        if(vm.portefeuilleContrat.autoInvoicePeriodType == 'WEEKDAY'){
		            var invoiceValeurInitiale = vm.portefeuilleContrat.autoInvoiceInterval ;
		    	    
		    	    //On intialise le invoice
		    		var invoiceLeLundi = (invoiceValeurInitiale | lundi) == invoiceValeurInitiale;
		    		var invoiceLeMardi= (invoiceValeurInitiale | mardi) == invoiceValeurInitiale;
		    		var invoiceLeMercredi= (invoiceValeurInitiale | mercredi) == invoiceValeurInitiale;
		    		var invoiceLeJeudi= (invoiceValeurInitiale | jeudi) == invoiceValeurInitiale;
		    		var invoiceLevendredi= (invoiceValeurInitiale | vendredi) == invoiceValeurInitiale;
		    		var invoiceLesamedi= (invoiceValeurInitiale | samedi) == invoiceValeurInitiale;
		    		var invoiceLedimanche= (invoiceValeurInitiale | dimanche) == invoiceValeurInitiale;
		    		
		    		vm.invoiceWeekday = [];
		    		if(invoiceLeLundi){
		    			vm.invoiceWeekday.push("wamasysApp.portefeuilleContrat.periodType.monday");
		    		}
		    		if(invoiceLeMardi){
		    			vm.invoiceWeekday.push("wamasysApp.portefeuilleContrat.periodType.tuesday");
		    		}
		    		if(invoiceLeMercredi){
		    			vm.invoiceWeekday.push("wamasysApp.portefeuilleContrat.periodType.wednesday");
		    		}
		    		if(invoiceLeJeudi){
		    			vm.invoiceWeekday.push("wamasysApp.portefeuilleContrat.periodType.thursday");
		    		}
		    		if(invoiceLevendredi){
		    			vm.invoiceWeekday.push("wamasysApp.portefeuilleContrat.periodType.friday");
		    		}
		    		if(invoiceLesamedi){
		    			vm.invoiceWeekday.push("wamasysApp.portefeuilleContrat.periodType.saturday");
		    		}
		    		if(invoiceLedimanche){
		    			vm.invoiceWeekday.push("wamasysApp.portefeuilleContrat.periodType.sunday");
		    		}
		        }
		    });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('PortefeuilleContratDeleteController',PortefeuilleContratDeleteController);

    PortefeuilleContratDeleteController.$inject = ['$uibModalInstance', 'entity', 'PortefeuilleContrat'];

    function PortefeuilleContratDeleteController($uibModalInstance, entity, PortefeuilleContrat) {
        var vm = this;
        vm.portefeuilleContrat = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PortefeuilleContrat.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('BillingPortefeuilleDialogController', BillingPortefeuilleDialogController );

    BillingPortefeuilleDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity',  'Billing', 'UserSearch'];

    function BillingPortefeuilleDialogController  ($scope, $stateParams, $uibModalInstance, entity, Billing, UserSearch) {
        var vm = this;
        vm.portefeuilleContrat = entity;
   //     vm.dateFacturation = Date.now() ;
        
		var $dialog = $(
				'<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-hidden="true" style="padding-top:15%; overflow-y:visible;">' +
				'<div class="modal-dialog modal-m">' +
				'<div class="modal-content">' +
					'<div class="modal-header"><h3 style="margin:0;"></h3></div>' +
					'<div class="modal-body">' +
						'<div class="progress progress-striped active" style="margin-bottom:0;"><div class="progress-bar" style="width: 100%"></div></div>' +
					'</div>' +
				'</div></div></div>');
		
        var onSaveSuccess = function (result) {
			$dialog.modal('hide');
            $scope.$emit('wamasysApp:billingContractUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
			$dialog.modal('hide');
            vm.isSaving = false;
        };

        vm.save = function () {



			var options = {};
			var message = 'Please wait ! Action in progress.';
			var settings = $.extend({
				dialogSize: 'm',
				progressType: '',
				onHide: null // This callback runs after the dialog was hidden
			}, options);
			$dialog.find('.modal-dialog').attr('class', 'modal-dialog').addClass('modal-' + settings.dialogSize);
			$dialog.find('.progress-bar').attr('class', 'progress-bar');
			$dialog.find('h3').text(message);
			$dialog.modal();
			
            vm.isSaving = true;
            Billing.createForPortfolio(
            		{
            			listIdPortefeuilleContrat:[vm.portefeuilleContrat.id]
            		}
            		, onSaveSuccess, onSaveError);
        
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

    //    vm.datePickerOpenStatus = {};
    //    vm.datePickerOpenStatus.dateFacturation = false;

  //      vm.openCalendar = function(date) {
  //          vm.datePickerOpenStatus[date] = true;
  //      };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('expense', {
            parent: 'entity',
            url: '/expense?page&sort&search',
            data: {
                authorities: ['ROLE_BUDGET_READ_ONLY','ROLE_BUDGET_EDIT'],
                pageTitle: 'wamasysApp.expense.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/expense/expenses.html',
                    controller: 'ExpenseController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('expense');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('expense-detail', {
            parent: 'entity',
            url: '/expense/{id}',
            data: {
                authenticate: true,
                authorities: ['ROLE_BUDGET_READ_ONLY','ROLE_BUDGET_EDIT'],
                pageTitle: 'wamasysApp.expense.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/expense/expense-detail.html',
                    controller: 'ExpenseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('expense');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Expense', function($stateParams, Expense) {
                    return Expense.get({id : $stateParams.id});
                }]
            }
        })
        .state('expense.new', {
            parent: 'expense',
            url: '/new',
            data: {
        		authorities: ['ROLE_BUDGET_EDIT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/expense/expense-dialog.html',
                    controller: 'ExpenseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('expense', null, { reload: true });
                }, function() {
                    $state.go('expense');
                });
            }]
        })
        .state('expense.edit', {
            parent: 'expense',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_BUDGET_EDIT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/expense/expense-dialog.html',
                    controller: 'ExpenseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Expense', function(Expense) {
                            return Expense.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('expense', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('expense.delete', {
            parent: 'expense',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_BUDGET_EDIT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/expense/expense-delete-dialog.html',
                    controller: 'ExpenseDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Expense', function(Expense) {
                            return Expense.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('expense', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('Expense', Expense);

    Expense.$inject = ['$resource','DateUtils'];

    function Expense ($resource,DateUtils) {
        var resourceUrl =  'api/expense/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.date = DateUtils.convertLocalDateFromServer(data.date);
                    return data;
                }
            },
            'update': {
            	method:'PUT',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.date = DateUtils.convertLocalDateToServer(data.date);
                    return angular.toJson(clonedData);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.date = DateUtils.convertLocalDateToServer(data.date);
                    return angular.toJson(clonedData);
                }
            },
            'downloadcsv': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/expense/downloadcsv',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ExpenseController', ExpenseController);

    ExpenseController.$inject = ['$scope', '$state', 'Expense', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ExpenseController ($scope, $state, Expense, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Expense.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.expenses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }


    	vm.download = function(){
    		Expense.downloadcsv( {}
    			,function (content){
    		      var url = URL.createObjectURL(content.response);
    		      var a = document.createElement('a');
    		      a.href = url;
    		      a.download = content.fileName;
    		      a.target = '_blank';
    		      a.click();
    		}
    				
    		);
    	}



    
    	
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ExpenseDialogController', ExpenseDialogController);

    ExpenseDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Expense','ExpenseType','TypeTax'];

    function ExpenseDialogController ($scope, $stateParams, $uibModalInstance, entity, Expense,ExpenseType,TypeTax) {
        var vm = this;
        vm.expense = entity;
        vm.typeTaxs = TypeTax.query({size:100});
        vm.taxeSelected = null;
        vm.load = function(id) {
            Expense.get({id : id}, function(result) {
                vm.expense = result;
            });
        };

        ExpenseType.query({size:100}, function(result) {
        	vm.expenseTypes = result;
        	if(entity.$promise){
        		entity.$promise.then(function(value) {
    	        	if( vm.expense.expenseType){
    	        		var  fnctIdEqual = function(element) {return element.id === vm.expense.expenseType.id};
    	        		var index = vm.expenseTypes.findIndex(fnctIdEqual);
    	        		if(index === -1 ){
    	        			vm.expenseTypes.push(vm.expense.expenseType);
    	        		}
    	        	}
            	});	
        	}
        
        });
        
        vm.selectTax  = function() {
        	if(vm.expense.amountInclTaxes){
	        	 vm.expense.amountExclTaxes = vm.expense.amountInclTaxes / ((vm.taxeSelected.taxRate/100) +1);
	        	 vm.expense.amountExclTaxes =  Math.round( vm.expense.amountExclTaxes * 100) / 100;
	        	 vm.expense.taxes = vm.expense.amountInclTaxes -  vm.expense.amountExclTaxes;
	        	 vm.expense.taxes =  Math.round( vm.expense.taxes * 100) / 100;
	        	 vm.taxRate = vm.taxeSelected.taxRate;
        	}
        };
        
        vm.changeAmountInclTaxes = function() {
        	if(vm.expense.amountInclTaxes && vm.taxeSelected && vm.taxeSelected.taxRate){
        		vm.expense.amountExclTaxes = vm.expense.amountInclTaxes / ( 1+ (vm.taxeSelected.taxRate/100)); 
           	 	vm.expense.amountExclTaxes =  Math.round( vm.expense.amountExclTaxes * 100) / 100;
            	vm.taxRate = 	(( vm.expense.amountInclTaxes / vm.expense.amountExclTaxes )-1)*100;
           	 	vm.taxRate =  Math.round( vm.taxRate * 100) / 100;
           	 	vm.expense.taxes = vm.expense.amountInclTaxes -  vm.expense.amountExclTaxes;
           	 	vm.expense.taxes =  Math.round( vm.expense.taxes * 100) / 100;
        	}else{
        		vm.expense.amountExclTaxes = vm.expense.amountInclTaxes;
           	 	vm.expense.amountExclTaxes =  Math.round( vm.expense.amountExclTaxes * 100) / 100;
        		vm.expense.taxes = 0;
        		vm.taxRate = 0;
        	}
      
       };
        

       vm.changeAmountExclTaxes = function() {
       	if(vm.expense.amountInclTaxes &&  vm.expense.amountExclTaxes){
           	vm.taxRate = 	(( vm.expense.amountInclTaxes / vm.expense.amountExclTaxes )-1)*100;
          	vm.taxRate =  Math.round( vm.taxRate * 100) / 100;
          	vm.expense.taxes = vm.expense.amountInclTaxes -  vm.expense.amountExclTaxes;
          	vm.expense.taxes =  Math.round( vm.expense.taxes * 100) / 100;
       	}
     
      };
      
      vm.changeTaxes = function() {
         	if(vm.expense.amountInclTaxes &&  vm.expense.taxes){
         		vm.expense.amountExclTaxes = 	vm.expense.amountInclTaxes - vm.expense.taxes 
             	vm.taxRate = 	(( vm.expense.amountInclTaxes / vm.expense.amountExclTaxes )-1)*100;
            	vm.taxRate =  Math.round( vm.taxRate * 100) / 100;
         	}
        };
      
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:expenseUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            
//            if(! vm.expense.amountInclTaxes || vm.expense.amountInclTaxes < 0 ){
//            	editForm.amountInclTaxes.$invalid = true;
//            	return ;
//            }
//            if(! vm.expense.amountExclTaxes || vm.expense.amountExclTaxes < 0 ){
//            	editForm.amountExclTaxes.$invalid = true;
//            	return ;
//            }
//            if(! vm.expense.taxes || vm.expense.taxes < 0 ){
//            	editForm.taxes.$invalid = true;
//            	return ;
//            }

            if (vm.expense.id !== null) {
                Expense.update(vm.expense, onSaveSuccess, onSaveError);
            } else {
                Expense.save(vm.expense, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.date = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ExpenseDetailController', ExpenseDetailController);

    ExpenseDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Expense'];

    function ExpenseDetailController($scope, $rootScope, $stateParams, entity, Expense) {
        var vm = this;
        vm.expense = entity;
        vm.load = function (id) {
            Expense.get({id: id}, function(result) {
                vm.expense = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:expenseUpdate', function(event, result) {
            vm.expense = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ExpenseDeleteController',ExpenseDeleteController);

    ExpenseDeleteController.$inject = ['$uibModalInstance', 'entity', 'Expense'];

    function ExpenseDeleteController($uibModalInstance, entity, Expense) {
        var vm = this;
        vm.expense = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Expense.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').config(stateConfig);
    stateConfig.$inject = ['$stateProvider'];
    function stateConfig($stateProvider) {
        function definition(url, template, controller) {
            return {parent: 'app', url: url, data: {authorities: [], pageTitle: 'global.menu.notifications'},
                views: {'content@': {templateUrl: 'app/business/notifications/' + template, controller: controller, controllerAs: 'vm'}},
                resolve: {notificationSession: ['Principal', '$state', '$q', '$rootScope', 'LoginService', function (Principal, $state, $q, $rootScope, LoginService) {
                    return Principal.identity().then(function (account) {
                        if (!account || account.activated === false) {
                            // Le projet utilise une fenêtre de connexion, pas un état 'login'.
                            $rootScope.redirected = true;
                            $rootScope.previousStateName = $rootScope.toState.name;
                            $rootScope.previousStateNameParams = angular.copy($rootScope.toStateParams);
                            $state.go('accessdenied'); LoginService.open();
                            return $q.reject('AUTHENTICATION_REQUIRED');
                        }
                        return account;
                    });
                }]}};
        }
        $stateProvider.state('notifications', definition('/notifications', 'notifications.html', 'NotificationsController'))
            .state('notification-detail', definition('/notifications/{id:[0-9]+}', 'notification-detail.html', 'NotificationDetailController'));
    }
}());
;
(function () {
    'use strict';
    angular.module('wamasysApp').factory('NotificationInbox', NotificationInbox);
    NotificationInbox.$inject = ['$rootScope', '$http', '$q', '$interval', '$timeout', '$window', 'Principal', 'AuthServerProvider', 'NotificationProtocol', 'WebNotificationPush'];
    function NotificationInbox($rootScope, $http, $q, $interval, $timeout, $window, Principal, AuthServerProvider, protocol, push) {
        var epoch = 0, context, canceler, poll, reconnect, expiryTimer, stream, seen = {}, refreshing;
        var state = {unreadCount: 0, messages: [], toast: null, connected: false, active: false, revision: null};
        var service = {state: state, page: page, find: find, read: read, refresh: summary,
            generation: function () { return epoch; }, prepareLogout: stop,
            enablePush: function () { return push.enable(context); },
            disablePush: function () { return push.disable(context); }, push: push.state};
        $rootScope.$watch(sessionKey, restart);
        return service;

        function sessionKey() {
            var account = Principal.getIdentityIfExist(), token = AuthServerProvider.getToken();
            if (!Principal.isAuthenticated() || !account || account.activated === false || !token) { return ''; }
            return [token, account.id || account.login, account.agence && account.agence.id,
                account.entiteParente && account.entiteParente.id].join('|');
        }
        function current(generation) { return context && epoch === generation && sessionKey() === context.key; }
        function stop() {
            var previous = context;
            epoch++; context = null; seen = {}; refreshing = null;
            if (canceler) { canceler.resolve(); }
            if (stream) { stream.abort(); stream = null; }
            if (poll) { $interval.cancel(poll); poll = null; }
            if (reconnect) { $timeout.cancel(reconnect); reconnect = null; }
            if (expiryTimer) { $timeout.cancel(expiryTimer); expiryTimer = null; }
            state.unreadCount = 0; state.messages = []; state.toast = null; state.connected = false;
            state.active = false; state.revision = null;
            push.disconnect(previous);
            $rootScope.$broadcast('notifications:reset');
        }
        function restart(key) {
            stop();
            if (!key) { return; }
            var account = Principal.getIdentityIfExist();
            context = {key: key, token: AuthServerProvider.getToken(),
                accountKey: [account.id || account.login, account.entiteParente && account.entiteParente.id,
                    account.agence && account.agence.id].join(':'), generation: epoch};
            var expiration;
            try { expiration = JSON.parse($window.atob(context.token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).exp * 1000; }
            catch (ignore) { expiration = 0; }
            if (expiration && expiration <= Date.now()) { stop(); return; }
            if (expiration) { expiryTimer = $timeout(stop, Math.min(expiration - Date.now(), 2147483647)); }
            canceler = $q.defer(); state.active = true;
            push.configure(context, function () { summary(); });
            summary(); openStream(epoch);
            // Le repli reste actif : proxy sans streaming, navigateur ancien ou événement perdu.
            poll = $interval(summary, 30000);
        }
        function request(method, path, body, params) {
            var generation = epoch;
            if (!current(generation)) { return $q.reject({cancelled: true}); }
            return $http({method: method, url: 'api/notifications/' + path, data: body, params: params,
                timeout: canceler.promise, cache: false}).then(function (response) {
                if (!current(generation)) { return $q.reject({cancelled: true}); }
                return response.data;
            }, function (error) {
                if (!current(generation)) { return $q.reject({cancelled: true}); }
                if (error.status === 401 || error.status === 403) { stop(); }
                return $q.reject(error);
            });
        }
        function received(messages) {
            angular.forEach(messages, function (message) {
                if (!message || message.type !== 'VISIBLE' || !protocol.positiveId(message.id)) { return; }
                var key = 'received:' + message.id;
                if (seen[key]) { return; }
                seen[key] = true;
                var generation = epoch;
                request('POST', 'receipt', {messageId: message.id, status: 'RECEIVED'}).catch(function () {
                    if (current(generation)) { delete seen[key]; }
                });
            });
        }
        function page(beforeId) {
            return request('GET', 'inbox', null, {beforeId: beforeId || undefined, size: 30}).then(function (result) {
                result.messages = (result.messages || []).filter(function (message) { return message.type === 'VISIBLE'; });
                received(result.messages); return result;
            });
        }
        function summary() {
            if (!context || refreshing) { return; }
            push.checkPermission();
            var generation = epoch;
            refreshing = request('GET', 'summary').then(function (result) {
                var changed = state.revision !== result.revision;
                var initial = state.revision === null;
                state.unreadCount = result.unreadCount || 0; state.revision = result.revision;
                if (changed || !state.messages.length) {
                    return page().then(function (inbox) {
                        var newMessage;
                        angular.forEach(inbox.messages, function (message) {
                            if (!seen['message:' + message.id] && !message.read && !newMessage) { newMessage = message; }
                            seen['message:' + message.id] = true;
                        });
                        state.messages = inbox.messages;
                        if (!initial && newMessage) { state.toast = {id: newMessage.id}; }
                        $rootScope.$broadcast('notifications:changed');
                    });
                }
            }).catch(angular.noop).finally(function () { if (epoch === generation) { refreshing = null; } });
        }
        function find(id) {
            if (!protocol.positiveId(id)) { return $q.reject({status: 404}); }
            return request('GET', 'inbox/' + id).then(function (message) { received([message]); return message; });
        }
        function read(message) {
            return request('POST', 'receipt', {messageId: message.id, status: 'READ'}).then(function () {
                if (!message.read) { state.unreadCount = Math.max(0, state.unreadCount - 1); }
                message.read = true;
                angular.forEach(state.messages, function (item) { if (item.id === message.id) { item.read = true; } });
                summary();
            });
        }
        function openStream(generation) {
            if (!current(generation) || !$window.fetch || !$window.AbortController || !$window.TextDecoder) { return; }
            stream = new $window.AbortController();
            var controller = stream;
            var parser = protocol.createParser(function (name) {
                if (name === 'inbox-changed') { $rootScope.$evalAsync(function () { if (current(generation)) { summary(); } }); }
            });
            $window.fetch('api/notifications/events', {headers: {Authorization: 'Bearer ' + context.token, Accept: 'text/event-stream'},
                credentials: 'same-origin', cache: 'no-store', signal: controller.signal}).then(function (response) {
                if (!current(generation)) { controller.abort(); return; }
                if (response.status === 401) {
                    $rootScope.$evalAsync(function () { if (current(generation)) { stop(); } }); return;
                }
                // 403 signifie aussi SSE désactivé ou limite de connexions atteinte.
                // La boîte et son repli HTTP restent actifs ; pas de reconnexion en boucle.
                if (response.status === 403) { return; }
                if (!response.ok || !response.body || !response.body.getReader) { throw new Error('Streaming indisponible'); }
                $rootScope.$evalAsync(function () { if (current(generation)) { state.connected = true; } });
                var reader = response.body.getReader(), decoder = new $window.TextDecoder('utf-8');
                function pump() {
                    return reader.read().then(function (chunk) {
                        if (!current(generation)) { return reader.cancel(); }
                        if (chunk.done) { throw new Error('Flux terminé'); }
                        parser.push(decoder.decode(chunk.value, {stream: true})); return pump();
                    });
                }
                return pump();
            }).catch(function () {
                $rootScope.$evalAsync(function () {
                    if (!current(generation)) { return; }
                    state.connected = false;
                    reconnect = $timeout(function () { openStream(generation); }, 10000);
                });
            });
        }
    }
}());
;
(function (root) {
    'use strict';
    function createParser(onEvent) {
        var buffer = '', eventName = '', data = [];
        function line(value) {
            if (!value) {
                if (data.length) { onEvent(eventName || 'message', data.join('\n')); }
                eventName = ''; data = []; return;
            }
            if (value.charAt(0) === ':') { return; }
            var colon = value.indexOf(':'), field = colon < 0 ? value : value.slice(0, colon);
            var content = colon < 0 ? '' : value.slice(colon + 1).replace(/^ /, '');
            if (field === 'event') { eventName = content; }
            if (field === 'data') { data.push(content); }
        }
        return {push: function (chunk) {
            buffer += chunk;
            if (buffer.length > 262144) { throw new Error('Événement trop volumineux'); }
            var end;
            while ((end = buffer.indexOf('\n')) >= 0) {
                line(buffer.slice(0, end).replace(/\r$/, '')); buffer = buffer.slice(end + 1);
            }
        }};
    }
    function positiveId(value) { return /^[1-9][0-9]*$/.test(String(value || '')); }
    function selectionFingerprint(query, collectorOnly) {
        return JSON.stringify([String(query || '').trim(), collectorOnly === null ? null : collectorOnly]);
    }
    var api = {createParser: createParser, positiveId: positiveId, selectionFingerprint: selectionFingerprint};
    if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
    if (root.angular) { root.angular.module('wamasysApp').factory('NotificationProtocol', function () { return api; }); }
}(typeof window === 'undefined' ? this : window));
;
(function () {
    'use strict';
    angular.module('wamasysApp').controller('NotificationsController', NotificationsController)
        .controller('NotificationDetailController', NotificationDetailController);
    NotificationsController.$inject = ['$scope', 'NotificationInbox'];
    function NotificationsController($scope, inbox) {
        var vm = this, generation = inbox.generation(), destroyed = false, refreshPending = false;
        vm.messages = []; vm.loading = false; vm.push = inbox.push;
        vm.load = load; vm.more = function () { load(vm.nextBeforeId); };
        vm.enablePush = function () { inbox.enablePush().catch(angular.noop); };
        vm.disablePush = function () { inbox.disablePush().catch(angular.noop); };
        function load(beforeId) {
            if (vm.loading) { return; }
            vm.loading = true; vm.error = null; generation = inbox.generation();
            inbox.page(beforeId).then(function (result) {
                if (destroyed || generation !== inbox.generation()) { return; }
                vm.messages = beforeId ? vm.messages.concat(result.messages) : result.messages;
                vm.nextBeforeId = result.nextBeforeId;
            }).catch(function (error) {
                if (!destroyed && !error.cancelled) { vm.error = 'Impossible de charger les messages. Réessayez.'; }
            }).finally(function () {
                vm.loading = false;
                if (!destroyed && refreshPending) { refreshPending = false; load(); }
            });
        }
        $scope.$on('notifications:changed', function () {
            if (vm.messages.length) { vm.notice = 'La boîte a été actualisée avec les messages les plus récents.'; }
            if (vm.loading) { refreshPending = true; } else { load(); }
        });
        $scope.$on('notifications:reset', function () { vm.messages = []; vm.nextBeforeId = null; vm.notice = null; refreshPending = false; });
        $scope.$on('$destroy', function () { destroyed = true; });
        load();
    }
    NotificationDetailController.$inject = ['$scope', '$stateParams', '$timeout', '$window', 'NotificationInbox'];
    function NotificationDetailController($scope, $stateParams, $timeout, $window, inbox) {
        var vm = this, destroyed = false, sending = false, generation = inbox.generation(), timer;
        vm.load = load; vm.retryRead = acknowledge;
        function acknowledge() {
            // Une cloche, un toast ou un onglet masqué ne constituent pas une lecture.
            if (destroyed || generation !== inbox.generation() || !vm.message || vm.message.read || sending
                    || $window.document.hidden || !$window.document.hasFocus()) { return; }
            sending = true; vm.receiptError = null;
            inbox.read(vm.message).catch(function (error) {
                if (!destroyed && !error.cancelled) { vm.receiptError = 'Lecture enregistrée à l’écran, confirmation serveur à réessayer.'; }
            }).finally(function () { sending = false; });
        }
        function focused() { $scope.$evalAsync(acknowledge); }
        function load() {
            vm.loading = true; vm.error = null; generation = inbox.generation();
            inbox.find($stateParams.id).then(function (message) {
                if (destroyed || generation !== inbox.generation()) { return; }
                vm.message = message;
                // Attendre que le détail soit rendu avant d'envoyer READ.
                timer = $timeout(acknowledge, 0);
            }).catch(function (error) {
                if (!destroyed && !error.cancelled) { vm.error = error.status === 404 ? 'Message introuvable.' : 'Impossible de charger ce message. Réessayez.'; }
            }).finally(function () { vm.loading = false; });
        }
        $window.addEventListener('focus', focused);
        $window.document.addEventListener('visibilitychange', focused);
        $scope.$on('notifications:changed', function () { if (!vm.message && !vm.loading) { load(); } });
        $scope.$on('notifications:reset', function () { vm.message = null; vm.receiptError = null; });
        $scope.$on('$destroy', function () {
            destroyed = true; $timeout.cancel(timer);
            $window.removeEventListener('focus', focused); $window.document.removeEventListener('visibilitychange', focused);
        });
        load();
    }
}());
;
(function () {
    'use strict';
    angular.module('wamasysApp').factory('WebNotificationPush', WebNotificationPush);
    WebNotificationPush.$inject = ['$http', '$q', '$rootScope', '$window'];
    function WebNotificationPush($http, $q, $rootScope, $window) {
        var current, config, sdkPromise, messaging, unsubscribe, activation, cleanup = $q.when(), revision = 0;
        var state = {available: false, enabled: false, busy: false, error: null};
        var version = '10.14.1';
        return {state: state, configure: configure, enable: enable, disable: disable, disconnect: disconnect,
            checkPermission: function () {
                if (current && state.enabled && $window.Notification.permission !== 'granted') { disable(current); }
            }};

        function key(context) { return 'wamasys-web-push:' + $window.location.origin + ':' + context.accountKey; }
        function stored(context) {
            try { return JSON.parse($window.localStorage.getItem(key(context)) || '{}'); } catch (ignore) { return {}; }
        }
        function save(context, value) { try { $window.localStorage.setItem(key(context), JSON.stringify(value)); } catch (ignore) { } }
        function supported() {
            return $window.location.protocol === 'https:' && $window.Notification && $window.navigator.serviceWorker
                && $window.PushManager && $window.fetch && $window.AbortController;
        }
        function valid(context) { return context && current === context; }
        function bounded(promise, milliseconds) {
            var deferred = $q.defer(), finished = false;
            var timer = $window.setTimeout(function () {
                if (!finished) { finished = true; deferred.reject(new Error('Délai de réponse dépassé.')); }
            }, milliseconds);
            $q.when(promise).then(function (result) {
                if (!finished) { finished = true; $window.clearTimeout(timer); deferred.resolve(result); }
            }, function (error) {
                if (!finished) { finished = true; $window.clearTimeout(timer); deferred.reject(error); }
            });
            return deferred.promise;
        }
        function configure(context, wake) {
            revision++; current = context; config = null; state.error = null; state.enabled = false;
            state.available = false; state.busy = false; context.wake = wake;
            if (!supported()) { return; }
            $http.get('api/notifications/push/config', {cache: false, timeout: 10000}).then(function (response) {
                if (!valid(context)) { return; }
                config = response.data;
                state.available = !!(config.enabled && config.firebaseConfig && config.vapidPublicKey);
                if (state.available && stored(context).optedIn && $window.Notification.permission === 'granted') {
                    activate(context).catch(angular.noop);
                }
            }, angular.noop);
        }
        function script(url) {
            var deferred = $q.defer(), element = $window.document.createElement('script');
            element.src = url; element.async = true; element.referrerPolicy = 'no-referrer';
            element.onload = function () { deferred.resolve(); };
            element.onerror = function () { deferred.reject(new Error('Chargement Firebase impossible.')); };
            $window.document.head.appendChild(element);
            return bounded(deferred.promise, 10000).catch(function (error) {
                if (element.parentNode) { element.parentNode.removeChild(element); }
                return $q.reject(error);
            });
        }
        function sdk() {
            if (!sdkPromise) {
                sdkPromise = script('https://www.gstatic.com/firebasejs/' + version + '/firebase-app-compat.js')
                    .then(function () { return script('https://www.gstatic.com/firebasejs/' + version + '/firebase-messaging-compat.js'); })
                    .catch(function (error) { sdkPromise = null; return $q.reject(error); });
            }
            return sdkPromise;
        }
        function enable(context) {
            if (!valid(context) || !state.available || state.busy) { return $q.when(); }
            state.error = null;
            // Cet appel reste directement dans le gestionnaire du clic : aucune demande au chargement.
            return $q.when($window.Notification.requestPermission()).then(function (permission) {
                if (!valid(context)) { return; }
                if (permission !== 'granted') { state.error = 'Les notifications ne sont pas autorisées dans ce navigateur.'; return; }
                var record = stored(context); record.optedIn = true; save(context, record);
                return activate(context);
            });
        }
        function activate(context) {
            state.busy = true;
            var settings = config, record = stored(context), registration;
            if (!record.installationId) {
                var bytes = new Uint32Array(4); $window.crypto.getRandomValues(bytes);
                record.installationId = 'web-' + Array.prototype.map.call(bytes, function (n) { return n.toString(16); }).join('-');
                save(context, record);
            }
            activation = cleanup.then(sdk).then(function () {
                if (!valid(context)) { throw new Error('Session modifiée.'); }
                if (!$window.firebase.messaging.isSupported()) { throw new Error('Notifications non prises en charge.'); }
                var name = 'wamasys-notifications-' + settings.firebaseConfig.projectId;
                var app = $window.firebase.apps.filter(function (candidate) { return candidate.name === name; })[0]
                    || $window.firebase.initializeApp(settings.firebaseConfig, name);
                messaging = app.messaging();
                return bounded($window.navigator.serviceWorker.register('/firebase-messaging-sw.js', {scope: '/firebase-push/'}), 10000);
            }).then(function (result) {
                if (!valid(context)) { throw new Error('Session modifiée.'); }
                registration = result;
                // register() peut renvoyer un worker encore en installation.
                if (registration.active) { return; }
                return bounded($q(function (resolve, reject) {
                    var worker = registration.installing || registration.waiting;
                    if (!worker) { reject(new Error('Activation du service de notifications impossible.')); return; }
                    worker.addEventListener('statechange', function () {
                        if (worker.state === 'activated') { resolve(); }
                        if (worker.state === 'redundant') { reject(new Error('Installation du service de notifications impossible.')); }
                    });
                }), 10000);
            }).then(function () {
                if (!valid(context)) { throw new Error('Session modifiée.'); }
                return bounded(messaging.getToken({vapidKey: settings.vapidPublicKey, serviceWorkerRegistration: registration}), 15000);
            }).then(function (token) {
                if (!valid(context)) { throw new Error('Session modifiée.'); }
                return $http.put('api/notifications/push/subscription', {
                    installationId: record.installationId, token: token, permission: true
                }, {timeout: 10000});
            }).then(function () {
                if (!valid(context)) { return; }
                state.enabled = true;
                if (unsubscribe) { unsubscribe(); }
                unsubscribe = messaging.onMessage(function () {
                    $rootScope.$evalAsync(function () { if (valid(context)) { context.wake(); } });
                });
            }).catch(function (error) {
                if (valid(context)) { state.error = 'Activation impossible. La boîte de réception reste disponible.'; }
                return $q.reject(error);
            }).finally(function () { if (valid(context)) { state.busy = false; } });
            return activation;
        }
        function removeSubscription(context) {
            if (!context || !$window.fetch || !$window.AbortController) { return $q.when(); }
            var record = stored(context);
            if (!record.installationId) { return $q.when(); }
            var controller = new $window.AbortController();
            var timer = $window.setTimeout(function () { controller.abort(); }, 3000);
            // Snapshot du JWT uniquement dans la page : jamais dans le service worker ni dans son URL.
            return $q.when($window.fetch('/api/notifications/push/subscription?installationId=' + encodeURIComponent(record.installationId), {
                method: 'DELETE', headers: {Authorization: 'Bearer ' + context.token},
                credentials: 'same-origin', signal: controller.signal
            })).catch(angular.noop).finally(function () { $window.clearTimeout(timer); });
        }
        function disconnect(context) {
            if (!context) { return; }
            revision++;
            if (current === context) { current = null; }
            state.enabled = false; state.available = false; state.busy = false;
            if (unsubscribe) { unsubscribe(); unsubscribe = null; }
            var oldMessaging = messaging; messaging = null;
            var oldActivation = activation; activation = null;
            // La déconnexion n'attend pas le réseau ; la prochaine activation attend le nettoyage.
            // Attendre un éventuel PUT déjà parti, sinon sa réponse tardive réinscrirait un utilisateur déconnecté.
            cleanup = $q.when(oldActivation).catch(angular.noop).then(function () {
                // Le SDK n'expose pas d'annulation ; ne pas bloquer la session suivante indéfiniment.
                var revoke = oldMessaging ? bounded(oldMessaging.deleteToken(), 5000).catch(angular.noop) : $q.when();
                return $q.all([removeSubscription(context), revoke]);
            });
            return cleanup;
        }
        function disable(context) {
            if (!context) { return $q.when(); }
            var record = stored(context); record.optedIn = false; save(context, record);
            var settings = config;
            var pending = disconnect(context), operationRevision = revision;
            return $q.when(pending).finally(function () {
                if (revision !== operationRevision) { return; }
                current = context; config = settings; state.available = !!(settings && settings.enabled);
            });
        }
    }
}());
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('modele-contrat', {
            parent: 'entity',
            url: '/modele-contrat?page&sort&search',
            data: {
                authenticate: true,
                authorities: ['ROLE_AREA_CONFIGURATION','ROLE_DATA_OPERATOR', 'ROLE_READ_ONLY'],
                pageTitle: 'global.menu.parametragecontrats'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/modele-contrat/modele-contrats.html'
                }
        
            },
          

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modeleContrat');
                    $translatePartialLoader.addPart('serviceVendu');
                    $translatePartialLoader.addPart('typeTax');
                    $translatePartialLoader.addPart('typePaiementService');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
	
        .state('modele-contrat.liste-contrat',{
			url : '/liste-contrat/',
			views : {
	            'panneau@content': {
	                templateUrl: 'app/business/modele-contrat/modele-contrats-liste-contrat.html',	
	                controller: 'ModeleContratController',
	                controllerAs: 'vm'
	            }
			}
		})	



    
        .state('modele-contrat-detail', {
            parent: 'entity',
            url: '/modele-contrat/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.modeleContrat.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/modele-contrat/modele-contrat-detail.html',
                    controller: 'ModeleContratDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modeleContrat');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ModeleContrat', function($stateParams, ModeleContrat) {
                    return ModeleContrat.get({id : $stateParams.id});
                }]
            }
        })

        .state('modele-contrat.liste-contrat.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/modele-contrat/modele-contrat-dialog.html',
                    controller: 'ModeleContratDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('modele-contrat.liste-contrat', null, { reload: true });
                }, function() {
                    $state.go('modele-contrat.liste-contrat');
                });
            }]
        })
        .state('modele-contrat.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/modele-contrat/modele-contrat-dialog.html',
                    controller: 'ModeleContratDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ModeleContrat', function(ModeleContrat) {
                            return ModeleContrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('modele-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modele-contrat.delete', {
            parent: 'modele-contrat',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/modele-contrat/modele-contrat-delete-dialog.html',
                    controller: 'ModeleContratDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ModeleContrat', function(ModeleContrat) {
                            return ModeleContrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('modele-contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ModeleContrat', ModeleContrat);

    ModeleContrat.$inject = ['$resource'];

    function ModeleContrat ($resource) {
        var resourceUrl =  'api/modele-contrats/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ModeleContratController', ModeleContratController);

    ModeleContratController.$inject = ['$scope', '$state', 'ModeleContrat', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ModeleContratController ($scope, $state, ModeleContrat, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            ModeleContrat.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                if(vm.predicate !== 'id' && vm.predicate !== 'libelle'){
                	result = ['id'];
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.modeleContrats = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ModeleContratDialogController', ModeleContratDialogController);

    ModeleContratDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ModeleContrat',   'ServiceVendu'];

    function ModeleContratDialogController ($scope, $stateParams, $uibModalInstance, entity, ModeleContrat,  ServiceVendu) {
        var vm = this;
        vm.modeleContrat = entity;
        vm.serviceautres = ServiceVendu.query({ offset: 0,size: 1000});
        vm.load = function(id) {
            ModeleContrat.get({id : id}, function(result) {
                vm.modeleContrat = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:modeleContratUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.modeleContrat.id !== null) {
                ModeleContrat.update(vm.modeleContrat, onSaveSuccess, onSaveError);
            } else {
                ModeleContrat.save(vm.modeleContrat, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ModeleContratDetailController', ModeleContratDetailController);

    ModeleContratDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ModeleContrat', 'Agence',  'ServiceVendu'];

    function ModeleContratDetailController($scope, $rootScope, $stateParams, entity, ModeleContrat, Agence,  ServiceVendu) {
        var vm = this;
        vm.modeleContrat = entity;
        vm.load = function (id) {
            ModeleContrat.get({id: id}, function(result) {
                vm.modeleContrat = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:modeleContratUpdate', function(event, result) {
            vm.modeleContrat = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ModeleContratDeleteController',ModeleContratDeleteController);

    ModeleContratDeleteController.$inject = ['$uibModalInstance', 'entity', 'ModeleContrat'];

    function ModeleContratDeleteController($uibModalInstance, entity, ModeleContrat) {
        var vm = this;
        vm.modeleContrat = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ModeleContrat.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('MonitoringRuleController', MonitoringRuleController);

    MonitoringRuleController.$inject = ['$scope', '$state', 'MonitoringRule', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','$filter'];

    function MonitoringRuleController ($scope, $state, MonitoringRule, ParseLinks, AlertService, pagingParams, paginationConstants,$filter) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.formatRecipient = formatRecipient;
        vm.loadAll();

        
		var $dialog = $(
				'<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-hidden="true" style="padding-top:1%; overflow-y:visible;">' +
				'<div class="modal-dialog modal-m">' +
				'<div class="modal-content">' +
					'<div class="modal-header">'+
					'<h3 class="modal-title" >Run monitoring alert</h3>'+
					'<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>'+
			      
					'</div>' +
					'<div class="modal-body">' +
						'<div class="progress progress-striped active" style="margin-bottom:0;"><div class="progress-bar" style="width: 100%"></div></div>' +
					'</div>' +
				'</div></div></div>');
    	
		var options = {};
		var message = 'Please wait ! Action in progress.';
		var settings = $.extend({
			dialogSize: 'lg',
			progressType: '',
			onHide: null // This callback runs after the dialog was hidden
		}, options);
		$dialog.find('.modal-dialog').attr('class', 'modal-dialog').addClass('modal-' + settings.dialogSize);
		$dialog.find('.progress-bar').attr('class', 'progress-bar');


		vm.fermerDialog = function(){
			  $dialog.modal('hide');
		}
        
        
		function isEmpty(value) {
			for (var prop in value) {
			    if (value.hasOwnProperty(prop)) return false;
			}
			return true;
		}

        function formatRecipient(recipient) {
            if (!recipient) {
                return '';
            }
            var name = trimText((recipient.firstName || '') + ' ' + (recipient.lastName || ''));
            return name || recipient.email || recipient.login;
        }

        function trimText(value) {
            return (value || '').replace(/^\s+|\s+$/g, '');
        }

        

        vm.runRule = function (idRuleParam){
      
			$dialog.find('.modal-body').html( "");
    		$dialog.modal();
        	MonitoringRule.runMonitoringRule({idRule:idRuleParam}, onSuccessrunRules, onErrorrunRules);
        	function onSuccessrunRules(data, headers) {
        	      var popupContent = '';

        	        for (var manager in data) {
        	        	if(manager.startsWith("$") || manager.startsWith("toJSON")){
        	        		continue;
        	        	}
        	            var managerData = data[manager];

        	            if(!managerData || isEmpty(managerData)){
        	            	continue;
        	            }
        	            
        	            popupContent += '<h4 style="text-align: center; "> ' + $filter('translate')('wamasysApp.monitoringRule.recipientEnum.'+manager)   + '</h4>';
        	            
        	            for (var key in managerData) {
        	         
        	                popupContent += '<h5>' +$filter('translate')('wamasysApp.monitoringRule.typeEnum.'+key)  + '</h5>';
        	                popupContent += '<table class="table table-bordered">';
        	                popupContent += '<thead><tr>';

            	            if(!managerData[key] || ! managerData[key][0]){
            	            	continue;
            	            }
        	                // Construire les en-têtes dynamiquement
        	                var firstItem = managerData[key][0];

        	                for (var header in firstItem) {
        	                	if(header==="areaId"|| header ==='suffixErreur'){
        	                		continue;
        	                	}
        	                    popupContent += '<th>' +  $filter('translate')('wamasysApp.monitoringRule.header.'+header)   + '</th>';
        	                }
        	                popupContent += '</tr></thead><tbody>';


        	                // Construire les lignes dynamiquement
        	                Array.prototype.forEach.call( managerData[key], function(item){
        	             
        	                    popupContent += '<tr>';
        	                    for (var value in item) {
        	                       	if(value==='areaId' || value ==='suffixErreur' ){
            	                		continue;
            	                	}

        	                    	var valCol = item[value];
        	                       	if(value==='monitoringRule'){
        	                       		valCol = 	$filter('translate')('wamasysApp.monitoringRule.typeEnum.'+valCol.typeRule) .replace('X', valCol.param1).replace('Y', valCol.nbDays)
        	                       	}else if(value==='nombreErreur'){
        	                    		valCol = valCol+  item['suffixErreur']; 
        	                    	}else if(value==='message'){
        	                    		valCol = valCol.replaceAll(';','; ') 
        	                    	}

        	                        popupContent += '<td>' +valCol + '</td>';
        	                    }
        	                    popupContent += '</tr>';
        	                	
        	                }
        	                		
        	                );
        	                
        	                
//        	                managerData[key].forEach(function(item) {
//        	                    popupContent += '<tr>';
//        	                    for (var value in item) {
//        	                        popupContent += '<td>' + item[value] + '</td>';
//        	                    }
//        	                    popupContent += '</tr>';
//        	                });

        	                popupContent += '</tbody></table>';
        	            }
    	                popupContent += '<hr/>';
        	        }

        			$dialog.find('.modal-body').html( popupContent);
     
        	        
            }
            function onErrorrunRules(error) {
                AlertService.error(error.data.message);
            }
            
        }

        
        vm.runRules = function (){
      
			$dialog.find('.modal-body').html( "");
    		$dialog.modal();
        	MonitoringRule.runMonitoringRules({}, onSuccessrunRules, onErrorrunRules);
        	function onSuccessrunRules(data, headers) {
        	      var popupContent = '';

//        	        // Transformer les données en tableau plat
//        	        vm.flatData = [];
//        	        angular.forEach(data, function (group) {
//        	            angular.forEach(group, function (items) {
//        	                vm.flatData = vm.flatData.concat(items);
//        	            });
//        	        });
//
//        	        vm.flatData.sort(function (a, b) {
//        	        	if(!a || !b) return 0;
//        	            if (a.area < b.area) return -1;
//        	            if (a.area > b.area) return 1;
//        	            if (a.libelle > b.libelle) return -1; // Tri secondaire
//        	            if (a.libelle < b.libelle) return 1;
//        	            return 0;
//        	        });
//        	      
//
//	                popupContent += '<table class="table table-bordered">';
//	                popupContent += '<thead><tr>';
//	               popupContent += '<th style="  width: 20%;">Area</th>'+'<th style="  width: 20%;">Règle</th>'+'<th style="  width: 20%;">Erreur</th>'+'<th style="  width: 40%;">Détail</th>';
//	              
//	                popupContent += '</tr></thead><tbody>';
//	                
//	                // Construire les lignes dynamiquement
//	                Array.prototype.forEach.call(vm.flatData, function(item){
//	                    popupContent += '<tr>';
//	                    for (var value in item) {
//	                    	var valCol = item[value];
//	                    	if(value==='message'){
//	                    		if(valCol && valCol.length>200){
//	                    			valCol = valCol.substring(0,200)+'...';
//	                    		}
//	                    		valCol = valCol.replaceAll(';','; ') ;
//	                    	}
//	                        popupContent += '<td>' +valCol + '</td>';
//	                    }
//	                    popupContent += '</tr>';
//	                	
//	                });
//	                
//	                popupContent += '</tbody></table>';
	                
        	        for (var manager in data) {
        	        	if(manager.startsWith("$") || manager.startsWith("toJSON")){
        	        		continue;
        	        	}
        	            popupContent += '<h4 style="text-align: center; ">' + $filter('translate')('wamasysApp.monitoringRule.recipientEnum.'+manager)    + '</h4>';
        	            var managerData = data[manager];

        	            if(!managerData){
        	            	continue;
        	            }
        	            
        	            for (var key in managerData) {
        	                popupContent += '<h5>' + $filter('translate')('wamasysApp.monitoringRule.typeEnum.'+key)  + '</h5>';
        	                popupContent += '<table class="table table-bordered">';
        	                popupContent += '<thead><tr>';

            	            if(!managerData[key] || ! managerData[key][0]){
            	            	continue;
            	            }
        	                // Construire les en-têtes dynamiquement
        	                var firstItem = managerData[key][0];

        	                for (var header in firstItem) {
        	                    popupContent += '<th>' + $filter('translate')('wamasysApp.monitoringRule.header.'+header)   + '</th>';
        	                }
        	                popupContent += '</tr></thead><tbody>';


        	                // Construire les lignes dynamiquement
        	                Array.prototype.forEach.call( managerData[key], function(item){
        	                    popupContent += '<tr>';
        	                    for (var value in item) {
        	                    	var valCol = item[value];
        	                    	if(value==='message'){
        	                    		if(valCol && valCol.length>200){
	    	                    			valCol = valCol.substring(0,200)+'...';
	    	                    		}
	    	                    		valCol = valCol.replaceAll(';','; ') ;
        	                    	}
        	                        popupContent += '<td>' +valCol + '</td>';
        	                    }
        	                    popupContent += '</tr>';
        	                	
        	                }
        	                		
        	                );
        	                
        	                
//        	                managerData[key].forEach(function(item) {
//        	                    popupContent += '<tr>';
//        	                    for (var value in item) {
//        	                        popupContent += '<td>' + item[value] + '</td>';
//        	                    }
//        	                    popupContent += '</tr>';
//        	                });

        	                popupContent += '</tbody></table>';
        	            }
    	                popupContent += '<hr/>';
        	        }

        			$dialog.find('.modal-body').html( popupContent);
     
        	        
            }
            function onErrorrunRules(error) {
                AlertService.error(error.data.message);
            }
            
        }


        function loadAll () {
            // Le catalogue inclut les utilisations sur toute l'organisation, sans limite de page.
            vm.availableTypeCount = null;
            MonitoringRule.queryTypeRules({}, function(types) {
                vm.availableTypeCount = types.filter(function(type) { return !type.configuredCount; }).length;
            });
            MonitoringRule.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.monitoringRules = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('monitoring-rule', {
            parent: 'entity',
            url: '/monitoring-rule?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.monitoringRule.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/monitoring-rule/monitoring-rules.html',
                    controller: 'MonitoringRuleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('monitoringRule');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('monitoring-rule-detail', {
            parent: 'entity',
            url: '/monitoring-rule/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.monitoringRule.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/monitoring-rule/monitoring-rule-detail.html',
                    controller: 'MonitoringRuleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('monitoringRule');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MonitoringRule', function($stateParams, MonitoringRule) {
                    return MonitoringRule.get({id : $stateParams.id});
                }]
            }
        })
        .state('monitoring-rule.new', {
            parent: 'monitoring-rule',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/monitoring-rule/monitoring-rule-dialog.html',
                    controller: 'MonitoringRuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('monitoring-rule', null, { reload: true });
                }, function() {
                    $state.go('monitoring-rule');
                });
            }]
        })
        .state('monitoring-rule.edit', {
            parent: 'monitoring-rule',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/monitoring-rule/monitoring-rule-dialog.html',
                    controller: 'MonitoringRuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MonitoringRule', function(MonitoringRule) {
                            return MonitoringRule.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('monitoring-rule', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('monitoring-rule.delete', {
            parent: 'monitoring-rule',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/monitoring-rule/monitoring-rule-delete-dialog.html',
                    controller: 'MonitoringRuleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MonitoringRule', function(MonitoringRule) {
                            return MonitoringRule.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('monitoring-rule', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('monitoring-rule-exclusions', {
            parent: 'entity',
            url: '/monitoring-rule/{id}/exclusions',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.monitoringRule.home.viewExclusions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/monitoring-rule/monitoring-rule-exclusions.html',
                    controller: 'MonitoringRuleExclusionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('monitoringRule');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('monitoring-rule-history', {
            parent: 'entity',
            url: '/monitoring-rule-history',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.monitoringRule.history.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/monitoring-rule/monitoring-rule-history.html',
                    controller: 'MonitoringRuleHistoryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('monitoringRule');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('MonitoringRule', MonitoringRule);

    MonitoringRule.$inject = ['$resource'];

    function MonitoringRule ($resource) {
        var resourceUrl =  'api/monitoring-rules/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryTypeRules': { 
            	method: 'GET', isArray: true,
                url :'api/type-rules'
            	},
            

            	
                'runMonitoringRule': {
                    method: 'GET',
                    url :'api/run-monitoring-rule/:idRule'
                },
         'runMonitoringRules': {
             method: 'GET',
             url :'api/run-monitoring-rules'
         },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('MonitoringRuleTemporaryExclusion', MonitoringRuleTemporaryExclusion);

    MonitoringRuleTemporaryExclusion.$inject = ['$resource'];

    function MonitoringRuleTemporaryExclusion($resource) {
        return $resource('api/monitoring-rule-temporary-exclusions/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('MonitoringRuleHistoryController', MonitoringRuleHistoryController);

    MonitoringRuleHistoryController.$inject = ['$scope', '$filter', '$timeout', '$window', '$uibModal', 'AlertService', 'Agence',
        'MonitoringRule', 'MonitoringRuleErrorHistory', 'Principal'];

    function MonitoringRuleHistoryController($scope, $filter, $timeout, $window, $uibModal, AlertService, Agence, MonitoringRule,
        MonitoringRuleErrorHistory, Principal) {
        var vm = this;
        var processedUpdates = {};
        var currentAccount = null;
        var listRevision = 0;
        var destroyed = false;

        vm.filters = {
            processedStatus: 'all',
            viewMode: 'summary',
            errorItemText: null,
            recipient: null
        };
        vm.sort = {
            field: 'executionDate',
            direction: 'desc'
        };
        vm.pagination = {
            page: 0,
            size: 50,
            hasMore: true,
            isLoadingMore: false
        };
        vm.histories = [];
        vm.stats = {
            errorCount: 0,
            areaCount: 0
        };
        vm.isRefreshing = false;
        vm.isInitialized = false;
        vm.agences = [];
        vm.rules = [];
        vm.availableRecipients = [];
        vm.canFilterRecipient = false;
        vm.canCreateTemporaryExclusion = false;
        vm.canUpdateProcessedStatus = false;

        vm.search = refreshList;
        vm.loadMore = loadMore;
        vm.onFiltersChanged = onFiltersChanged;
        vm.changeSort = changeSort;
        vm.isSortActive = isSortActive;
        vm.buildRuleLabel = buildRuleLabel;
        vm.openCreateTicket = openCreateTicket;
        vm.openCreateExclusion = openCreateExclusion;
        vm.applyAreaFilter = applyAreaFilter;
        vm.applyRuleFilter = applyRuleFilter;
        vm.applyErrorItemFilter = applyErrorItemFilter;
        vm.setViewMode = setViewMode;
        vm.toggleProcessed = toggleProcessed;
        vm.isUpdatingProcessed = isUpdatingProcessed;
        vm.hasProcessedFeedback = hasProcessedFeedback;
        vm.date = {
            startDate: new Date(),
            endDate: new Date()
        };

        vm.date.startDate.setDate(vm.date.startDate.getDate() - 7);

        Principal.identity().then(function(account) {
            currentAccount = account;
            var authorities = account && account.authorities ? account.authorities : [];
            var isAdmin = authorities.indexOf('ROLE_ADMIN') !== -1;
            var isSuperAdmin = authorities.indexOf('ROLE_SUPER_ADMIN') !== -1;
            var isAreaManager = authorities.indexOf('ROLE_AREA_MANAGEMENT') !== -1;

            vm.canCreateTemporaryExclusion = isAdmin;
            vm.canUpdateProcessedStatus = isAdmin || isSuperAdmin || isAreaManager;

            if (isAdmin || isSuperAdmin || isAreaManager) {
                vm.availableRecipients.push('AREA_MANAGER');
            }
            if (isAdmin || isSuperAdmin) {
                vm.availableRecipients.push('TOP_MANAGER');
            }
            vm.canFilterRecipient = vm.availableRecipients.length > 1;
        });

        Agence.query(function(result) {
            vm.agences = normalizeAreas(result || []);
            reconcileSelectedFilters();
        });
        MonitoringRule.query({ page: 0, size: 200, sort: 'id,asc' }, function(result) {
            vm.rules = normalizeRules(result || []);
            reconcileSelectedFilters();
        });

        $scope.$watch(function() {
            var start = vm.date && vm.date.startDate ? new Date(vm.date.startDate).getTime() : '';
            var end = vm.date && vm.date.endDate ? new Date(vm.date.endDate).getTime() : '';
            return start + '|' + end;
        }, function(newValue, oldValue) {
            if (!vm.isInitialized) {
                return;
            }
            if (newValue !== oldValue) {
                refreshList();
            }
        });

        angular.element($window).on('scroll', onWindowScroll);
        $scope.$on('$destroy', function() {
            destroyed = true;
            angular.forEach(processedUpdates, function(update) {
                if (update.timer) { $timeout.cancel(update.timer); }
            });
            angular.element($window).off('scroll', onWindowScroll);
        });

        vm.isInitialized = true;
        refreshList();

        $scope.openRangeDateTimePicker = function() {
            $('#daterange1').data('daterangepicker').toggle();
        };

        function refreshList() {
            listRevision++;
            angular.forEach(processedUpdates, function(update, uuid) {
                if (!update.pending) {
                    if (update.timer) { $timeout.cancel(update.timer); }
                    delete processedUpdates[uuid];
                }
            });
            vm.pagination.page = 0;
            vm.pagination.hasMore = true;
            vm.histories = [];
            fetchPage(true);
        }

        function loadMore() {
            if (!vm.pagination.hasMore || vm.pagination.isLoadingMore || vm.isRefreshing || hasActiveProcessedUpdates()) {
                return;
            }
            fetchPage(false);
        }

        function fetchPage(reset) {
            if (reset) {
                vm.isRefreshing = true;
            } else {
                vm.pagination.isLoadingMore = true;
            }

            var revision = listRevision;
            var pageToLoad = vm.pagination.page;
            MonitoringRuleErrorHistory.query(buildParams(pageToLoad), function(result) {
                if (destroyed || revision !== listRevision) { return; }
                var items = result || [];
                angular.forEach(items, applyProcessedUpdate);
                if (reset) {
                    vm.histories = items;
                } else {
                    // Replayed pages after a removal must not duplicate the rows already displayed.
                    var existingRows = {};
                    angular.forEach(vm.histories, function(history) { existingRows[history.rowKey] = true; });
                    angular.forEach(items, function(history) {
                        if (!existingRows[history.rowKey] && matchesProcessedFilter(history)) {
                            vm.histories.push(history);
                            existingRows[history.rowKey] = true;
                        }
                    });
                }

                vm.pagination.hasMore = items.length === vm.pagination.size;
                vm.pagination.page = pageToLoad + 1;
                vm.isRefreshing = false;
                vm.pagination.isLoadingMore = false;
                updateStats();
                reconcileSelectedFilters();
                $timeout(checkAutoLoadMore);
            }, function(error) {
                if (!destroyed && revision === listRevision) { onError(error); }
            });
        }

        function buildParams(page) {
            var params = {
                viewMode: vm.filters.viewMode,
                processedStatus: vm.filters.processedStatus || 'all',
                sortField: vm.sort.field,
                sortDirection: vm.sort.direction,
                page: page,
                size: vm.pagination.size,
                _t: new Date().getTime()
            };
            if (vm.date && vm.date.startDate) {
                params.fromDate = $filter('date')(new Date(vm.date.startDate), 'yyyy-MM-dd');
            }
            if (vm.date && vm.date.endDate) {
                params.toDate = $filter('date')(new Date(vm.date.endDate), 'yyyy-MM-dd');
            }
            if (vm.filters.areaId) {
                params.areaId = vm.filters.areaId;
            }
            if (vm.filters.monitoringRuleId) {
                params.monitoringRuleId = vm.filters.monitoringRuleId;
            }
            if (vm.filters.recipient) {
                params.recipient = vm.filters.recipient;
            }
            if (vm.filters.errorItemText && vm.filters.errorItemText.trim().length > 0) {
                params.errorItemText = vm.filters.errorItemText.trim();
            }
            return params;
        }

        function updateStats() {
            var areaIds = {};
            var errorCount = 0;

            angular.forEach(vm.histories, function(history) {
                if (history && history.errorValue) {
                    errorCount += history.errorValue;
                }
                if (history && history.areaId) {
                    areaIds[history.areaId] = true;
                } else if (history && history.areaName) {
                    areaIds[history.areaName] = true;
                }
            });

            vm.stats.errorCount = errorCount;
            vm.stats.areaCount = Object.keys(areaIds).length;
        }

        function buildRuleLabel(item) {
            if (!item || !item.typeRule) {
                return '';
            }
            return $filter('translate')('wamasysApp.monitoringRule.typeEnum.' + item.typeRule)
                .replace('X', item.param1)
                .replace('Y', item.nbDays);
        }

        function onFiltersChanged() {
            if (!vm.isInitialized) {
                return;
            }
            refreshList();
        }

        function changeSort(field) {
            if (vm.sort.field === field) {
                vm.sort.direction = vm.sort.direction === 'asc' ? 'desc' : 'asc';
            } else {
                vm.sort.field = field;
                vm.sort.direction = field === 'uuidExecution' ? 'asc' : 'desc';
            }
            refreshList();
        }

        function isSortActive(field, direction) {
            return vm.sort.field === field && vm.sort.direction === direction;
        }

        function applyAreaFilter(history) {
            if (!history || !history.areaId) {
                return;
            }
            ensureAreaOption(history);
            $timeout(function() {
                vm.filters.areaId = parseInt(history.areaId, 10);
                refreshList();
            });
        }

        function applyRuleFilter(history) {
            if (!history || !history.monitoringRuleId) {
                return;
            }
            ensureRuleOption(history);
            $timeout(function() {
                vm.filters.monitoringRuleId = parseInt(history.monitoringRuleId, 10);
                refreshList();
            });
        }

        function applyErrorItemFilter(history) {
            if (!history || !history.errorItems || vm.filters.viewMode !== 'detail') {
                return;
            }
            vm.filters.errorItemText = history.errorItems;
            refreshList();
        }

        function setViewMode(viewMode) {
            if (vm.filters.viewMode === viewMode) {
                return;
            }
            vm.filters.viewMode = viewMode;
            refreshList();
        }

        function toggleProcessed(history) {
            if (!history || !history.uuidExecution) {
                return;
            }
            if (!vm.canUpdateProcessedStatus) {
                AlertService.warning('wamasysApp.monitoringRule.history.processedStatusRolesOnly');
                return;
            }
            updateProcessedStatus(history.uuidExecution, !history.processed);
        }

        function isUpdatingProcessed(history) {
            var update = history && processedUpdates[history.uuidExecution];
            return !!(update && update.pending);
        }

        function hasProcessedFeedback(history) {
            var update = history && processedUpdates[history.uuidExecution];
            return !!(update && update.feedback);
        }

        function hasActiveProcessedUpdates() {
            return Object.keys(processedUpdates).some(function(uuid) {
                return processedUpdates[uuid].pending || processedUpdates[uuid].feedback;
            });
        }

        function matchesProcessedFilter(history) {
            return vm.filters.processedStatus === 'all'
                || (vm.filters.processedStatus === 'processed' && history.processed)
                || (vm.filters.processedStatus === 'unprocessed' && !history.processed);
        }

        function applyProcessedUpdate(history) {
            var update = processedUpdates[history.uuidExecution];
            if (update && !update.pending) {
                history.processed = update.processed;
                history.processedBy = update.processedBy;
                history.processedAt = update.processedAt;
            }
        }

        function updateProcessedStatus(uuid, processed) {
            var previous = processedUpdates[uuid];
            if (destroyed || (previous && (previous.pending || previous.feedback))) { return; }
            if (previous && previous.timer) { $timeout.cancel(previous.timer); }
            var update = { pending: true };
            processedUpdates[uuid] = update;
            MonitoringRuleErrorHistory.updateProcessed({
                uuidExecution: uuid,
                processed: processed,
                _t: new Date().getTime()
            }, function() {
                if (destroyed) { return; }
                // Change every detail row of the execution only once the server confirms success.
                update.pending = false;
                update.processed = processed;
                update.processedBy = processed && currentAccount ? currentAccount.login : null;
                update.processedAt = processed ? new Date() : null;
                update.feedback = true;
                angular.forEach(vm.histories, applyProcessedUpdate);
                update.timer = $timeout(function() {
                    update.feedback = false;
                    update.timer = null;
                    var removed = 0;
                    vm.histories = vm.histories.filter(function(history) {
                        var keep = history.uuidExecution !== uuid || matchesProcessedFilter(history);
                        if (!keep) { removed++; }
                        return keep;
                    });
                    if (removed) {
                        listRevision++;
                        vm.pagination.isLoadingMore = false;
                        // Deletions shift server page offsets: replay overlapping pages to avoid missing alerts.
                        vm.pagination.page = Math.max(0, vm.pagination.page - Math.ceil(removed / vm.pagination.size));
                        updateStats();
                    }
                    checkAutoLoadMore();
                }, 2000);
            }, function(error) {
                if (destroyed) { return; }
                if (previous) { processedUpdates[uuid] = previous; }
                else { delete processedUpdates[uuid]; }
                AlertService.error(error && error.data ? error.data.message : 'Erreur');
            });
        }

        function openCreateTicket(history) {
            $uibModal.open({
                templateUrl: 'app/business/monitoring-rule/monitoring-rule-history-createticket-dialog.html',
                controller: 'MonitoringRuleHistoryCreateTicketController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return angular.copy(history);
                    }
                }
            }).result.then(handleActionResult);
        }

        function openCreateExclusion(history) {
            if (!vm.canCreateTemporaryExclusion) {
                AlertService.warning('wamasysApp.monitoringRule.history.excludeTempAdminOnly');
                return;
            }
            $uibModal.open({
                templateUrl: 'app/business/monitoring-rule/monitoring-rule-exclusion-dialog.html',
                controller: 'MonitoringRuleExclusionDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function() {
                        var firstItem = null;
                        if (!history.firstRefContrat && !history.firstSerialNumber && history.errorItems) {
                            var items = history.errorItems.split(';').filter(function(item) {
                                return item && item.trim().length > 0;
                            });
                            if (items.length === 1) {
                                firstItem = items[0].trim();
                            }
                        }
                        return {
                            id: null,
                            monitoringRuleId: history.monitoringRuleId,
                            areaId: history.areaId,
                            areaName: history.areaName,
                            validiteMois: 1,
                            referenceContrat: history.firstRefContrat || firstItem,
                            serialNumber: history.firstSerialNumber || null,
                            commentaire: 'Exclusion temporaire créée depuis l\'historique'
                        };
                    },
                    historyContext: function() {
                        return {
                            uuidExecution: history.uuidExecution
                        };
                    }
                }
            }).result.then(handleActionResult);
        }

        function handleActionResult(result) {
            if (result && result.markAsProcessed && result.uuidExecution) {
                updateProcessedStatus(result.uuidExecution, true);
                return;
            }
            refreshList();
        }

        function ensureAreaOption(history) {
            if (!vm.agences || !history || !history.areaId) {
                return;
            }
            var normalizedId = parseInt(history.areaId, 10);
            var exists = false;
            angular.forEach(vm.agences, function(agence) {
                if (parseInt(agence.id, 10) === normalizedId) {
                    exists = true;
                }
            });
            if (!exists) {
                vm.agences.push({
                    id: normalizedId,
                    nom: history.areaName || ('Zone ' + normalizedId)
                });
            }
            vm.agences = normalizeAreas(vm.agences);
        }

        function ensureRuleOption(history) {
            if (!vm.rules || !history || !history.monitoringRuleId) {
                return;
            }
            var normalizedId = parseInt(history.monitoringRuleId, 10);
            var exists = false;
            angular.forEach(vm.rules, function(rule) {
                if (parseInt(rule.id, 10) === normalizedId) {
                    exists = true;
                }
            });
            if (!exists) {
                vm.rules.push({
                    id: normalizedId,
                    typeRule: history.typeRule,
                    param1: history.param1,
                    nbDays: history.nbDays
                });
            }
            vm.rules = normalizeRules(vm.rules);
        }

        function reconcileSelectedFilters() {
            if (vm.filters.areaId) {
                ensureAreaOption({
                    areaId: vm.filters.areaId,
                    areaName: findAreaName(vm.filters.areaId)
                });
                vm.filters.areaId = parseInt(vm.filters.areaId, 10);
            }
            if (vm.filters.monitoringRuleId) {
                ensureRuleOption(findRule(vm.filters.monitoringRuleId));
                vm.filters.monitoringRuleId = parseInt(vm.filters.monitoringRuleId, 10);
            }
        }

        function findAreaName(areaId) {
            var areaName = null;
            angular.forEach(vm.histories, function(history) {
                if (!areaName && history && parseInt(history.areaId, 10) === parseInt(areaId, 10)) {
                    areaName = history.areaName;
                }
            });
            return areaName || ('Zone ' + areaId);
        }

        function findRule(ruleId) {
            var foundRule = null;
            angular.forEach(vm.histories, function(history) {
                if (!foundRule && history && parseInt(history.monitoringRuleId, 10) === parseInt(ruleId, 10)) {
                    foundRule = {
                        monitoringRuleId: history.monitoringRuleId,
                        typeRule: history.typeRule,
                        param1: history.param1,
                        nbDays: history.nbDays
                    };
                }
            });
            return foundRule || {
                monitoringRuleId: ruleId
            };
        }

        function normalizeAreas(areas) {
            angular.forEach(areas, function(area) {
                if (area && area.id !== undefined && area.id !== null) {
                    area.id = parseInt(area.id, 10);
                }
            });
            return areas;
        }

        function normalizeRules(rules) {
            angular.forEach(rules, function(rule) {
                if (rule && rule.id !== undefined && rule.id !== null) {
                    rule.id = parseInt(rule.id, 10);
                }
            });
            return rules;
        }

        function onWindowScroll() {
            if (shouldLoadMore()) {
                $scope.$applyAsync(loadMore);
            }
        }

        function shouldLoadMore() {
            if (vm.isRefreshing || vm.pagination.isLoadingMore || !vm.pagination.hasMore || hasActiveProcessedUpdates()) {
                return false;
            }
            var scrollTop = $window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            var windowHeight = $window.innerHeight || document.documentElement.clientHeight || 0;
            var documentHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
            return scrollTop + windowHeight + 200 >= documentHeight;
        }

        function checkAutoLoadMore() {
            if (shouldLoadMore()) {
                loadMore();
            }
        }

        function onError(error) {
            vm.isRefreshing = false;
            vm.pagination.isLoadingMore = false;
            AlertService.error(error && error.data ? error.data.message : 'Erreur');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('MonitoringRuleHistoryCreateTicketController', MonitoringRuleHistoryCreateTicketController);

    MonitoringRuleHistoryCreateTicketController.$inject = ['$scope', '$filter', '$uibModalInstance', 'entity', 'RedmineService', 'UserSearch'];

    function MonitoringRuleHistoryCreateTicketController($scope, $filter, $uibModalInstance, entity, RedmineService, UserSearch) {
        var vm = this;
        vm.history = entity;
        vm.users = UserSearch.searchUserArea({ offset: 0, size: 1000 });
        vm.clear = clear;
        vm.save = save;
        vm.markAsProcessed = !!entity.uuidExecution;
        vm.ruleLabel = $filter('translate')('wamasysApp.monitoringRule.typeEnum.' + entity.typeRule).replace('X', entity.param1).replace('Y', entity.nbDays);
        vm.redmineIssue = {
            subject: '[Monitoring] ' + vm.ruleLabel + ' - ' + (entity.areaName || ''),
            description: [
                'Date : ' + $filter('date')(entity.executionDate, 'dd/MM/yyyy HH:mm'),
                'Zone : ' + (entity.areaName || ''),
                'Regle : ' + vm.ruleLabel,
                'Valeur : ' + entity.errorValue + (entity.suffixErreur || ''),
                '',
                'Elements en erreur :',
                entity.errorItems || ''
            ].join('\n')
        };

        if (entity.firstRefContrat) {
            vm.redmineIssue.contractReference = entity.firstRefContrat;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            RedmineService.createIssue(vm.redmineIssue, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $scope.$emit('wamasysApp:redmineUpdate', result);
            $uibModalInstance.close({
                ticket: result,
                markAsProcessed: vm.markAsProcessed,
                uuidExecution: vm.history.uuidExecution
            });
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('MonitoringRuleExclusionsController', MonitoringRuleExclusionsController);

    MonitoringRuleExclusionsController.$inject = ['$scope', '$state', '$stateParams', '$uibModal', 'AlertService', 'MonitoringRule', 'MonitoringRuleTemporaryExclusion'];

    function MonitoringRuleExclusionsController($scope, $state, $stateParams, $uibModal, AlertService, MonitoringRule, MonitoringRuleTemporaryExclusion) {
        var vm = this;
        vm.monitoringRule = {};
        vm.exclusions = [];
        vm.loadAll = loadAll;
        vm.openDialog = openDialog;
        vm.delete = remove;

        MonitoringRule.get({ id: $stateParams.id }, function(result) {
            vm.monitoringRule = result;
        });

        vm.loadAll();

        function loadAll() {
            MonitoringRuleTemporaryExclusion.query({ monitoringRuleId: $stateParams.id }, function(result) {
                vm.exclusions = result;
            }, onError);
        }

        function openDialog(entity) {
            $uibModal.open({
                templateUrl: 'app/business/monitoring-rule/monitoring-rule-exclusion-dialog.html',
                controller: 'MonitoringRuleExclusionDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function() {
                        if (entity) {
                            return angular.copy(entity);
                        }
                        return {
                            id: null,
                            monitoringRuleId: parseInt($stateParams.id, 10),
                            validiteMois: 1
                        };
                    },
                    historyContext: function() {
                        return null;
                    }
                }
            }).result.then(function() {
                loadAll();
            });
        }

        function remove(id) {
            if (!window.confirm('Supprimer cette exclusion temporaire ?')) {
                return;
            }
            MonitoringRuleTemporaryExclusion.delete({ id: id }, function() {
                loadAll();
            }, onError);
        }

        function onError(error) {
            AlertService.error(error && error.data ? error.data.message : 'Erreur');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('MonitoringRuleExclusionDialogController', MonitoringRuleExclusionDialogController);

    MonitoringRuleExclusionDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'historyContext', 'MonitoringRuleTemporaryExclusion'];

    function MonitoringRuleExclusionDialogController($scope, $uibModalInstance, entity, historyContext, MonitoringRuleTemporaryExclusion) {
        var vm = this;
        vm.exclusion = entity;
        vm.historyContext = historyContext;
        vm.markAsProcessed = !!(historyContext && historyContext.uuidExecution);
        vm.clear = clear;
        vm.save = save;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.exclusion.id) {
                MonitoringRuleTemporaryExclusion.update(vm.exclusion, onSaveSuccess, onSaveError);
            } else {
                MonitoringRuleTemporaryExclusion.save(vm.exclusion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('wamasysApp:monitoringRuleExclusionUpdate', result);
            $uibModalInstance.close({
                exclusion: result,
                markAsProcessed: vm.markAsProcessed,
                uuidExecution: historyContext ? historyContext.uuidExecution : null
            });
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('MonitoringRuleErrorHistory', MonitoringRuleErrorHistory);

    MonitoringRuleErrorHistory.$inject = ['$resource'];

    function MonitoringRuleErrorHistory($resource) {
        return $resource('api/monitoring-rule-error-history', {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'updateProcessed': {
                method: 'GET',
                url: 'api/monitoring-rule-error-history/:uuidExecution/processed'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('MonitoringRuleDialogController', MonitoringRuleDialogController);

    MonitoringRuleDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'MonitoringRule', 'Agence', 'User', '$filter'];

    function MonitoringRuleDialogController ($scope, $stateParams, $uibModalInstance, entity, MonitoringRule,Agence, User, $filter) {
        var vm = this;
        vm.monitoringRule = entity;
        // Une règle en cours d'édition doit conserver son type déjà configuré.
        vm.isNew = !entity.$promise && !entity.id;
        vm.onlyUnconfigured = vm.isNew;
        vm.listTypeRules = [];
        vm.typesLoaded = false;
        vm.typeRulesLoadError = false;
        vm.formatTypeRule = formatTypeRule;

        vm.agences = Agence.query();
        vm.users = User.query({ page: 0, size: 200, activated: true, sort: 'login,asc' });
        vm.formatUser = formatUser;
        ensureAdditionalRecipients();
        
        MonitoringRule.queryTypeRules({}, function(result) {
        	vm.listTypeRules =  result;
            vm.typesLoaded = true;
            vm.availableTypeCount = result.filter(function(type) { return !type.configuredCount; }).length;
        	
            // Extraire les groupes uniques
            var uniqueGroups = {};
        	vm.groups = [];
        	vm.listTypeRules.forEach(function (rule) {
        	    if (!uniqueGroups[rule.group]) {
        	        uniqueGroups[rule.group] = true;
        	        vm.groups.push(rule.group);
        	    }
        	});
            
            
         	if(vm.monitoringRule && vm.monitoringRule.$promise){
        		vm.monitoringRule.$promise.then(function(value) {
                    ensureAdditionalRecipients();
        			
        			function findTypeRuleFunction(item, index, array) {
        				if(item.name== vm.monitoringRule.typeRule){
       					 	vm.monitoringRule.typeRule = item;
        				}
        			}
        			
        			vm.listTypeRules.forEach(findTypeRuleFunction);
    
    	    	});	
            }
            // Initialiser les règles filtrées
            vm.updateFilteredTypeRules();
        }, function() {
            vm.typeRulesLoadError = true;
        });
        
        
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:monitoringRuleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            vm.monitoringRule.additionalRecipientUserIds = [];
            angular.forEach(vm.monitoringRule.additionalRecipients, function(user) {
                if (user && user.id) {
                    vm.monitoringRule.additionalRecipientUserIds.push(user.id);
                }
            });
            // Garder l'objet sélectionné si l'enregistrement échoue et doit être réessayé.
            var payload = angular.copy(vm.monitoringRule);
            payload.typeRule = vm.monitoringRule.typeRule.name;
            if (vm.monitoringRule.id !== null) {
                MonitoringRule.update(payload, onSaveSuccess, onSaveError);
            } else {
                MonitoringRule.save(payload, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        


        // Valeur par défaut du groupe sélectionné (affiche tout au départ)
        vm.selectedGroup = '';

        // Fonction pour filtrer la liste selon le groupe sélectionné
        vm.getFilteredTypeRules = function () {
            return vm.listTypeRules.filter(function (rule) {
                return (!vm.selectedGroup || rule.group === vm.selectedGroup)
                    && (!vm.onlyUnconfigured || !rule.configuredCount);
            });
        };

        // Mettre à jour les règles filtrées
        vm.updateFilteredTypeRules = function () {
            vm.filteredTypeRules = vm.getFilteredTypeRules();
            // Ne pas enregistrer par mégarde un type masqué par un nouveau filtre.
            if (vm.isNew && vm.monitoringRule.typeRule && !vm.filteredTypeRules.some(function(type) {
                return type.name === vm.monitoringRule.typeRule.name;
            })) {
                vm.monitoringRule.typeRule = null;
            }
        };

        function formatTypeRule(type) {
            var label = $filter('translate')('wamasysApp.monitoringRule.typeEnum.' + type.name);
            if (type.configuredCount) {
                label += ' — ' + $filter('translate')('wamasysApp.monitoringRule.availability.configured', {count: type.configuredCount});
            }
            return label;
        }

        function ensureAdditionalRecipients() {
            if (vm.monitoringRule && !vm.monitoringRule.additionalRecipients) {
                vm.monitoringRule.additionalRecipients = [];
            }
        }

        function formatUser(user) {
            if (!user) {
                return '';
            }
            var name = trimText((user.firstName || '') + ' ' + (user.lastName || ''));
            if (name && user.email) {
                return name + ' (' + user.email + ')';
            }
            return name || user.email || user.login;
        }

        function trimText(value) {
            return (value || '').replace(/^\s+|\s+$/g, '');
        }



    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('MonitoringRuleDetailController', MonitoringRuleDetailController);

    MonitoringRuleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'MonitoringRule'];

    function MonitoringRuleDetailController($scope, $rootScope, $stateParams, entity, MonitoringRule) {
        var vm = this;
        vm.monitoringRule = entity;
        vm.load = function (id) {
            MonitoringRule.get({id: id}, function(result) {
                vm.monitoringRule = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:monitoringRuleUpdate', function(event, result) {
            vm.monitoringRule = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('MonitoringRuleDeleteController',MonitoringRuleDeleteController);

    MonitoringRuleDeleteController.$inject = ['$uibModalInstance', 'entity', 'MonitoringRule'];

    function MonitoringRuleDeleteController($uibModalInstance, entity, MonitoringRule) {
        var vm = this;
        vm.monitoringRule = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            MonitoringRule.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function(){'use strict';angular.module('wamasysApp').config(stateConfig);stateConfig.$inject=['$stateProvider'];function stateConfig($stateProvider){$stateProvider.state('mobile-message',{parent:'entity',url:'/mobile-message?page&sort',data:{authorities:['ROLE_ADMIN','ROLE_AREA_CONFIGURATION','ROLE_AREA_MANAGEMENT','ROLE_READ_ONLY'],pageTitle:'wamasysApp.mobileMessage.title'},views:{'content@':{templateUrl:'app/business/mobile-message/mobile-message.html',controller:'MobileMessageController',controllerAs:'vm'}},params:{page:{value:'1',squash:true},sort:{value:'sentDate,desc',squash:true}},resolve:{pagingParams:['$stateParams','PaginationUtil',function(p,PaginationUtil){return{page:PaginationUtil.parsePage(p.page),predicate:PaginationUtil.parsePredicate(p.sort),ascending:PaginationUtil.parseAscending(p.sort)};}],translatePartialLoader:['$translate','$translatePartialLoader',function($translate,loader){loader.addPart('mobileMessage');loader.addPart('global');return $translate.refresh();}]}});}})();
;
(function () {
    'use strict';

    angular.module('wamasysApp').factory('MobileMessage', MobileMessage);
    MobileMessage.$inject = ['$resource'];

    function MobileMessage($resource) {
        return $resource('api/mobile-messages/:id', {id: '@id'}, {
            query: {method: 'GET', isArray: true},
            create: {method: 'POST'},
            users: {method: 'GET', url: 'api/mobile-messages/users', isArray: true},
            diagnostics: {method: 'GET', url: 'api/mobile-messages/diagnostics'},
            recipients: {method: 'GET', url: 'api/mobile-messages/:id/recipients', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular.module('wamasysApp').controller('MobileMessageController', MobileMessageController);

    MobileMessageController.$inject = ['$scope', '$interval', '$state', '$stateParams', 'MobileMessage', 'ParseLinks',
        'AlertService', 'pagingParams', 'paginationConstants', 'Principal', 'NotificationProtocol'];

    function MobileMessageController($scope, $interval, $state, $stateParams, MobileMessage, ParseLinks,
            AlertService, pagingParams, paginationConstants, Principal, NotificationProtocol) {
        var vm = this;
        vm.messages = [];
        vm.page = pagingParams.page;
        vm.users = [];
        vm.selected = {};
        vm.form = {type: 'VISIBLE', userIds: []};
        vm.canEdit = Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_AREA_MANAGEMENT']);
        vm.load = load;
        vm.loadPage = loadPage;
        vm.openCreate = openCreate;
        vm.cancelCreate = function () { vm.creating = false; };
        vm.toggleAll = toggleAll;
        vm.filtersChanged = filtersChanged;
        vm.loadUsers = loadUsers;
        vm.chooseMatching = chooseMatching;
        vm.selectedCount = selectedCount;
        vm.send = send;
        vm.showDetails = showDetails;
        vm.loadRecipients = loadRecipients;
        vm.deliveryLabel = deliveryLabel;
        vm.permissionLabel = permissionLabel;
        vm.statusLabel = statusLabel;
        var usersGeneration = 0, viewGeneration = 0, eligible = {}, matchingSelection = null;
        $scope.$watch(function () {
            var account = Principal.getIdentityIfExist();
            return account ? [account.id || account.login, account.entiteParente && account.entiteParente.id,
                account.agence && account.agence.id].join(':') : '';
        }, function (next, previous) {
            if (next === previous) { return; }
            viewGeneration++; usersGeneration++;
            vm.creating = false; vm.detail = null; vm.recipients = []; vm.messages = []; vm.users = [];
            vm.selected = {}; eligible = {}; matchingSelection = null; vm.allMatching = false;
            vm.canEdit = Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_AREA_MANAGEMENT']);
            if (next) { load(); }
        });

        load();
        var refreshPromise = $interval(refreshTracking, 2000);
        $scope.$on('$destroy', function () { viewGeneration++; usersGeneration++; $interval.cancel(refreshPromise); });

        function load() {
            var generation = viewGeneration;
            MobileMessage.query({page: pagingParams.page - 1, size: paginationConstants.itemsPerPage, sort: 'sentDate,desc'},
                function (data, headers) {
                    if (generation !== viewGeneration) { return; }
                    vm.messages = data;
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.page = pagingParams.page;
                }, error);
            MobileMessage.diagnostics({}, function (data) { if (generation === viewGeneration) { vm.diagnostics = data; } }, error);
        }

        function loadPage(page) { $state.go('.', {page: page, sort: 'sentDate,desc'}); }

        function refreshTracking() {
            if (!Principal.isAuthenticated()) { return; }
            var generation = viewGeneration;
            MobileMessage.query({page: vm.page - 1, size: paginationConstants.itemsPerPage, sort: 'sentDate,desc'},
                function (data, headers) {
                    if (generation !== viewGeneration) { return; }
                    vm.messages = data;
                    vm.totalItems = headers('X-Total-Count');
                });
            if (vm.detail) {
                loadRecipients();
            }
        }

        function openCreate() {
            vm.creating = true;
            vm.selected = {};
            vm.form = {type: 'VISIBLE', title: null, body: null, internalComment: null, userIds: []};
            vm.userQuery = ''; vm.collectorChoice = 'all'; vm.userPage = 1;
            vm.allMatching = false; vm.selectAll = false; matchingSelection = null; eligible = {};
            loadUsers();
        }

        function collectorOnly() { return vm.collectorChoice === 'all' ? null : vm.collectorChoice === 'yes'; }
        function fingerprint() { return NotificationProtocol.selectionFingerprint(vm.userQuery, collectorOnly()); }
        function filtersChanged() {
            // Une sélection globale ne doit jamais suivre silencieusement de nouveaux filtres.
            vm.selected = {}; eligible = {}; matchingSelection = null;
            vm.allMatching = false; vm.selectAll = false; vm.userPage = 1;
            loadUsers();
        }
        function loadUsers() {
            var generation = ++usersGeneration;
            vm.loadingUsers = true; vm.selectAll = false;
            MobileMessage.users({query: (vm.userQuery || '').trim(), collectorOnly: collectorOnly(),
                page: (vm.userPage || 1) - 1, size: 50}, function (data, headers) {
                if (generation !== usersGeneration || !vm.creating) { return; }
                vm.users = data; vm.totalUsers = parseInt(headers('X-Total-Count'), 10) || 0;
                angular.forEach(data, function (user) { if (user.accountActivated) { eligible[user.id] = true; } });
                vm.loadingUsers = false;
            }, function (response) { if (generation === usersGeneration) { vm.loadingUsers = false; error(response); } });
        }
        function chooseMatching() {
            vm.selected = {}; vm.selectAll = false;
            matchingSelection = vm.allMatching ? {fingerprint: fingerprint(), query: (vm.userQuery || '').trim(),
                collectorOnly: collectorOnly(), count: vm.totalUsers} : null;
        }
        function selectedCount() {
            if (vm.allMatching && matchingSelection) { return matchingSelection.count; }
            return Object.keys(vm.selected).filter(function (id) { return vm.selected[id] && eligible[id]; }).length;
        }

        function toggleAll() {
            angular.forEach(vm.users, function (user) {
                vm.selected[user.id] = vm.selectAll && user.accountActivated;
            });
        }

        function send() {
            if (vm.saving || vm.loadingUsers) { return; }
            var payload = angular.copy(vm.form);
            payload.userIds = [];
            angular.forEach(vm.selected, function (value, key) {
                if (value) {
                    if (eligible[key]) {
                        payload.userIds.push(parseInt(key, 10));
                    }
                }
            });
            if (vm.allMatching) {
                if (!matchingSelection || matchingSelection.fingerprint !== fingerprint()) {
                    AlertService.error('Les filtres ont changé. Vérifiez puis sélectionnez à nouveau les destinataires.'); return;
                }
                delete payload.userIds; payload.allMatching = true;
                payload.query = matchingSelection.query; payload.collectorOnly = matchingSelection.collectorOnly;
            }
            if (!selectedCount()) {
                AlertService.error('Sélectionnez au moins un utilisateur.');
                return;
            }
            if (payload.type === 'VISIBLE' && (!(payload.title || '').trim() || !(payload.body || '').trim())) {
                AlertService.error('Renseignez le titre et le message.'); return;
            }
            if (vm.allMatching && !window.confirm('Envoyer ce message à ' + selectedCount() + ' utilisateurs correspondant aux filtres affichés ?')) { return; }
            if (vm.form.type === 'UPLOAD_LOGS_AND_ARCHIVES' &&
                    !window.confirm('Cette commande déclenchera silencieusement l’envoi des journaux et archives des appareils sélectionnés. Continuer ?')) {
                return;
            }
            vm.saving = true;
            var generation = viewGeneration;
            MobileMessage.create(payload, function () {
                if (generation !== viewGeneration) { return; }
                vm.saving = false;
                vm.creating = false;
                load();
                AlertService.success('Message envoyé aux destinataires sélectionnés.');
            }, function (response) {
                if (generation !== viewGeneration) { return; }
                vm.saving = false;
                error(response);
            });
        }

        function showDetails(message) {
            vm.detail = message;
            vm.recipientPage = 1; vm.recipients = [];
            loadRecipients();
        }
        function loadRecipients() {
            if (!vm.detail) { return; }
            var message = vm.detail, page = vm.recipientPage || 1;
            var generation = viewGeneration;
            MobileMessage.recipients({id: message.id, page: page - 1, size: 50, sort: 'id,asc'},
                function (data, headers) {
                    if (generation === viewGeneration && vm.detail === message && page === vm.recipientPage) {
                        vm.recipients = data; vm.recipientTotal = parseInt(headers('X-Total-Count'), 10) || 0;
                    }
                }, error);
        }

        function deliveryLabel(user) {
            if (!user || user.deliveryMode === 'NO_DEVICE') { return 'Boîte Web ; aucun appareil Android enregistré'; }
            if (user.deliveryMode === 'FCM') { return 'Firebase (' + user.firebaseDeviceCount + ')'; }
            return 'Repli HTTP';
        }

        function permissionLabel(permission) {
            if (permission === true) { return 'Autorisées'; }
            if (permission === false) { return 'Refusées'; }
            return 'Inconnues';
        }

        function statusLabel(recipient) {
            var status = angular.isObject(recipient) ? recipient.status : recipient;
            if (status === 'NO_DEVICE' && vm.detail && vm.detail.type !== 'VISIBLE') { return 'Aucun appareil Android enregistré'; }
            if (status === 'PENDING' && angular.isObject(recipient)) {
                if (recipient.errorMessage) { return 'Échec Firebase, nouvelle tentative prévue'; }
                if (!vm.diagnostics || !vm.diagnostics.initialized ||
                        recipient.userDiagnostics.deliveryMode !== 'FCM') {
                    return 'Disponible dans la boîte, en attente de récupération';
                }
                return 'En attente du traitement serveur';
            }
            var labels = {
                PENDING: 'En attente d’envoi',
                NO_DEVICE: 'Disponible dans la boîte — aucun appareil Android',
                ACCEPTED_BY_FIREBASE: 'Notification Android acceptée par Firebase',
                RECEIVED: 'Reçu par l’application',
                READ: 'Lu par l’utilisateur',
                COMMAND_STARTED: 'Commande démarrée',
                COMMAND_COMPLETED: 'Commande terminée',
                COMMAND_FAILED: 'Commande en erreur',
                FAILED: 'Échec de l’envoi'
            };
            return labels[status] || status;
        }

        function error(response) {
            AlertService.error(response && response.data && response.data.message ? response.data.message :
                'Erreur lors de l’opération sur les messages mobiles.');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('compteur', {
            parent: 'entity',
            url: '/compteur',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_AREA_MANAGEMENT','ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.individualMeter.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/individual-meter/individual-meters.html'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('individualMeter');
                    $translatePartialLoader.addPart('cluster');
                    $translatePartialLoader.addPart('etatCluster');
                    $translatePartialLoader.addPart('etatReleveCompteur');
                    $translatePartialLoader.addPart('bulkMeter');
                    $translatePartialLoader.addPart('etatMeter');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        
        
        .state('compteur.individual-meter',{
			url : '/individual-meter?page&sort&search&isIOT&text&cluster&etat&modelMeter',
			views : {

				'panneau@content' : {
	                templateUrl: 'app/business/individual-meter/individual-meters-liste.html',	
	                controller: 'IndividualMeterController',
	                controllerAs: 'vm'
	            }
			}
		})
        .state('compteur.bulk-meter',{
			url : '/bulk-meter',
			views : {

				'panneau@content' : {
					templateUrl : 'app/business/bulk-meter/bulk-meters.html',
					controller : 'BulkMeterController',
					controllerAs : 'vm'
				}
			}
		})
		.state('compteur.cluster',{
			url : '/cluster',
			views : {
				'panneau@content' : {
					templateUrl : 'app/business/cluster/clusters.html',

					controller : 'ClusterController',
					controllerAs : 'vm'
					}
				}
			})
        .state('individual-meter-detail', {
            parent: 'entity',
            url: '/individual-meter/{id}?page&sort&search',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_AREA_MANAGEMENT','ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.individualMeter.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/individual-meter/individual-meter-detail.html',
                    controller: 'IndividualMeterDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
            	pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('individualMeter');
                    $translatePartialLoader.addPart('etatMeter');
                    $translatePartialLoader.addPart('collectionListe');
                    $translatePartialLoader.addPart('etatCollectionList');
                    $translatePartialLoader.addPart('etatReleveCompteur');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'IndividualMeter', function($stateParams, IndividualMeter) {
                    return IndividualMeter.get({id : $stateParams.id});
                }]
            }
        })
        .state('compteur.individual-meter.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT','ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/individual-meter/individual-meter-dialog.html',
                    controller: 'IndividualMeterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                numeroSerie: null,
                                dateCreation: null,
                                type: null,
                                valeurInitiale: null,
                                etat: null,
                                dateSuppression: null,
                                runningOrder: null,
                                longitude: null,
                                latitude: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('compteur.individual-meter', null, { reload: true });
                }, function() {
                    $state.go('compteur.individual-meter');
                });
            }]
        })
        .state('compteur.individual-meter.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT','ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/individual-meter/individual-meter-dialog.html',
                    controller: 'IndividualMeterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['IndividualMeter', function(IndividualMeter) {
                            return IndividualMeter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('compteur.individual-meter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('compteur.individual-meter.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/individual-meter/individual-meter-delete-dialog.html',
                    controller: 'IndividualMeterDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['IndividualMeter', function(IndividualMeter) {
                            return IndividualMeter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('compteur.individual-meter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
        .state('individual-meter-detail.addreading', {
            url: '/individual-meter/{id}/addreading',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/individual-meter/individual-meter-addreading-dialog.html',
                    controller: 'IndividualMeterAddReadingController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['IndividualMeter', function(IndividualMeter) {
                            return IndividualMeter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('individual-meter-detail', {id : $stateParams.id}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
        ;
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('IndividualMeter', IndividualMeter);

    IndividualMeter.$inject = ['$resource', 'DateUtils'];

    function IndividualMeter ($resource, DateUtils) {
        var resourceUrl =  'api/individual-meters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateMiseEnService = DateUtils.convertLocalDateFromServer(data.dateMiseEnService);
                    data.datePrecedenteLecture= DateUtils.convertDateTimeFromServer(data.datePrecedenteLecture);
                    data.dateSuppression = DateUtils.convertDateTimeFromServer(data.dateSuppression);
                    return data;
                }
            },
            'update': { 
            	method:'PUT',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.dateMiseEnService = DateUtils.convertLocalDateToServer(data.dateMiseEnService);
                	clonedData.datePrecedenteLecture = DateUtils.convertDateTimeFromServer(data.datePrecedenteLecture);
                    return angular.toJson(clonedData);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.dateMiseEnService = DateUtils.convertLocalDateToServer(data.dateMiseEnService);
                	clonedData.datePrecedenteLecture = DateUtils.convertDateTimeFromServer(data.datePrecedenteLecture);
                    return angular.toJson(clonedData);
                }
            },

            'queryActif': { method: 'GET', url:'api/individual-meters-actif', isArray: true},
            
            
            'queryNonSupprimeNonUtilise': { method: 'GET',url:'api/individual-meters-libre', isArray: true},
            
            'downloadcsv': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/individual-meters/downloadcsv',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            }
            
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('IndividualMeterSearch', IndividualMeterSearch);

    IndividualMeterSearch.$inject = ['$resource'];

    function IndividualMeterSearch($resource) {
        var resourceUrl =  'api/individual-meters/search/';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('IndividualMeterController', IndividualMeterController);

    IndividualMeterController.$inject = ['$scope', '$state', 'IndividualMeter','Cluster', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'IndividualMeterSearch','ModelMeter'];

    function IndividualMeterController ($scope, $state, IndividualMeter,Cluster, ParseLinks, AlertService, pagingParams, paginationConstants, IndividualMeterSearch,ModelMeter) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.search = search;
        vm.clear = clear;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clusters = Cluster.query({ offset: 0,size: 1000});
        vm.modelMeters = ModelMeter.query({ offset: 0,size: 1000});
        vm.etat = $state.params.etat;
        if($state.params.cluster){
         	vm.cluster = {
         			id:$state.params.cluster
        	};
            if (vm.clusters && vm.clusters.$promise) {
                vm.clusters.$promise.then(function(clusters) {
                    var clusterSelectionne = clusters.find(function(cluster) {
                        return String(cluster.id) === String($state.params.cluster);
                    });
                    if (clusterSelectionne) {
                        vm.cluster = clusterSelectionne;
                    }
                });
            }
        }
        if($state.params.modelMeter){
         	vm.modelMeter = {
         			id:$state.params.modelMeter
        	};
            if (vm.modelMeters && vm.modelMeters.$promise) {
                vm.modelMeters.$promise.then(function(modelMeters) {
                    var modelMeterSelectionne = modelMeters.find(function(modelMeter) {
                        return String(modelMeter.id) === String($state.params.modelMeter);
                    });
                    if (modelMeterSelectionne) {
                        vm.modelMeter = modelMeterSelectionne;
                    }
                });
            }
        }
        vm.text = $state.params.text;
        vm.isIOT = $state.params.isIOT;
        
        vm.currentSearch = false ;
        if( $state.params.text ||  $state.params.isIOT || $state.params.etat || $state.params.cluster || $state.params.modelMeter){
            vm.currentSearch = true ;
        }
        
        vm.loadAll();

        function loadAll () {
        	IndividualMeterSearch.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                etat:vm.etat,
                cluster:vm.cluster ? vm.cluster.id : null,
                modelMeter:vm.modelMeter ? vm.modelMeter.id : null,
                text:vm.text,
                isIOT:vm.isIOT,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.individualMeters = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }
        
        function search () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = '';
            vm.reverse = false;
            vm.transition();
        }
        
        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.etat =null;
            vm.text =null;
            vm.isIOT =null;
            vm.cluster =null;
            vm.modelMeter =null;
            vm.transition();
        }


        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                etat:vm.etat,
                text:vm.text,
                isIOT:vm.isIOT,
                modelMeter:vm.modelMeter?vm.modelMeter.id:null,
                cluster:vm.cluster?vm.cluster.id:null
            });
        }
        


      	vm.download = function(){
       		IndividualMeter.downloadcsv( {
    	        etat:vm.etat,
    	        cluster:vm.cluster ? vm.cluster.id : null,
    	        modelMeter:vm.modelMeter ? vm.modelMeter.id : null,
    	        text:vm.text,
                isIOT:vm.isIOT,
         		}
    			,function (content){
    		      var url = URL.createObjectURL(content.response);
    		      var a = document.createElement('a');
    		      a.href = url;
    		      a.download = content.fileName;
    		      a.target = '_blank';
    		      a.click();
    		}
    				
    		);
    	}
      	
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('IndividualMeterDialogController', IndividualMeterDialogController);

    IndividualMeterDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'IndividualMeter', 'Cluster','ModelMeter'];

    function IndividualMeterDialogController ($scope, $stateParams, $uibModalInstance, entity, IndividualMeter, Cluster,ModelMeter) {
        var vm = this;
        vm.individualMeter = entity;
        vm.mapMeter = createMapMeter(vm.individualMeter);
        vm.clusters = Cluster.queryActif({ offset: 0,size: 1000});
        vm.modelMeters = ModelMeter.query({ offset: 0,size: 1000});
        vm.load = function(id) {
            IndividualMeter.get({id : id}, function(result) {
                vm.individualMeter = result;
                vm.mapMeter = createMapMeter(vm.individualMeter);
            });
        };

        if (vm.individualMeter && vm.individualMeter.$promise) {
            vm.individualMeter.$promise.then(function() {
                vm.mapMeter = createMapMeter(vm.individualMeter);
            });
        }

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:individualMeterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            syncMapMeter();
            if (vm.individualMeter.id !== null) {
                IndividualMeter.update(vm.individualMeter, onSaveSuccess, onSaveError);
            } else {
                IndividualMeter.save(vm.individualMeter, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateMiseEnService = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        function createMapMeter(individualMeter) {
            return {
                lat: parseCoordinate(individualMeter && individualMeter.latitude),
                lon: parseCoordinate(individualMeter && individualMeter.longitude),
                referenceContrat: individualMeter && individualMeter.numeroSerie ? individualMeter.numeroSerie : ''
            };
        }

        function parseCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = Number(String(value).replace(',', '.'));
            return isNaN(parsedValue) ? null : parsedValue;
        }

        function formatCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            return String(value);
        }

        function syncMapMeter() {
            vm.individualMeter.latitude = formatCoordinate(vm.mapMeter && vm.mapMeter.lat);
            vm.individualMeter.longitude = formatCoordinate(vm.mapMeter && vm.mapMeter.lon);

            if (vm.mapMeter) {
                vm.mapMeter.referenceContrat = vm.individualMeter.numeroSerie;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('IndividualMeterDetailController', IndividualMeterDetailController);

    IndividualMeterDetailController.$inject = ['$scope','$state', '$rootScope', '$stateParams', 'entity', 'IndividualMeter', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'Cluster', 'ReleveCompteur'];

    function IndividualMeterDetailController($scope, $state,  $rootScope, $stateParams, entity, IndividualMeter, ParseLinks, AlertService, pagingParams, paginationConstants, Cluster, ReleveCompteur) {
        var vm = this;
        vm.individualMeter = entity;
        vm.mapMeter = createMapMeter(vm.individualMeter);
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.load = function () {
           ReleveCompteur.byIndividualMeter({
        	   id:$stateParams.id,                
        	   page: pagingParams.page - 1,
               size: paginationConstants.itemsPerPage
           }, function(result, headers) {
        	   vm.listeCollectionList  = result;
               vm.links = ParseLinks.parse(headers('link'));
               vm.totalItems = headers('X-Total-Count');
               vm.queryCount = vm.totalItems;
               vm.page = pagingParams.page;
            },  function (error) {
                AlertService.error(error.data.message);
            });
           

        };
        vm.load();

        if (vm.individualMeter && vm.individualMeter.$promise) {
            vm.individualMeter.$promise.then(function() {
                vm.mapMeter = createMapMeter(vm.individualMeter);
            });
        }

        var unsubscribe = $rootScope.$on('wamasysApp:individualMeterUpdate', function(event, result) {
            vm.individualMeter = result;
            vm.mapMeter = createMapMeter(vm.individualMeter);
        });
        $scope.$on('$destroy', unsubscribe);

       
        vm.transition = function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                id:$stateParams.id,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            });
        };

        function createMapMeter(individualMeter) {
            return {
                lat: parseCoordinate(individualMeter && individualMeter.latitude),
                lon: parseCoordinate(individualMeter && individualMeter.longitude),
                referenceContrat: individualMeter && individualMeter.numeroSerie ? individualMeter.numeroSerie : ''
            };
        }

        function parseCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = Number(String(value).replace(',', '.'));
            return isNaN(parsedValue) ? null : parsedValue;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('IndividualMeterDeleteController',IndividualMeterDeleteController);

    IndividualMeterDeleteController.$inject = ['$uibModalInstance', 'entity', 'IndividualMeter'];

    function IndividualMeterDeleteController($uibModalInstance, entity, IndividualMeter) {
        var vm = this;
        vm.individualMeter = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            IndividualMeter.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('IndividualMeterAddReadingController', IndividualMeterAddReadingController);

    IndividualMeterAddReadingController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'IndividualMeter','ReleveCompteur'];

    function IndividualMeterAddReadingController ($scope, $stateParams, $uibModalInstance, entity, IndividualMeter,ReleveCompteur) {
        var vm = this;
        vm.individualMeter = entity;
        vm.readingIndividualMeter = {individualMeter: vm.individualMeter,releveCompteur:{id:-1},valeurPrecedentReleve: vm.individualMeter.valeurPrecedenteLecture };
        vm.load = function(id) {
            IndividualMeter.get({id : id}, function(result) {
                vm.individualMeter = result;
                vm.readingIndividualMeter.valeurPrecedentReleve = vm.individualMeter.valeurPrecedenteLecture;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:individualMeterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            vm.readingIndividualMeter.datePrecedentReleveCompteur= vm.individualMeter.datePrecedenteLecture; 
            vm.readingIndividualMeter.valeurPrecedentReleve = vm.individualMeter.valeurPrecedenteLecture;
            ReleveCompteur.addReading(vm.readingIndividualMeter, onSaveSuccess, onSaveError);
          
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.readingDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('global-expense-type', {
            parent: 'entity',
            url: '/global-expense-type?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.globalExpenseType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/global-expense-type/global-expense-types.html',
                    controller: 'GlobalExpenseTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('globalExpenseType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('global-expense-type-detail', {
            parent: 'entity',
            url: '/global-expense-type/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.globalExpenseType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/global-expense-type/global-expense-type-detail.html',
                    controller: 'GlobalExpenseTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('globalExpenseType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GlobalExpenseType', function($stateParams, GlobalExpenseType) {
                    return GlobalExpenseType.get({id : $stateParams.id});
                }]
            }
        })
        .state('global-expense-type.new', {
            parent: 'global-expense-type',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/global-expense-type/global-expense-type-dialog.html',
                    controller: 'GlobalExpenseTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('global-expense-type', null, { reload: true });
                }, function() {
                    $state.go('global-expense-type');
                });
            }]
        })
        .state('global-expense-type.edit', {
            parent: 'global-expense-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/global-expense-type/global-expense-type-dialog.html',
                    controller: 'GlobalExpenseTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GlobalExpenseType', function(GlobalExpenseType) {
                            return GlobalExpenseType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('global-expense-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('global-expense-type.delete', {
            parent: 'global-expense-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/global-expense-type/global-expense-type-delete-dialog.html',
                    controller: 'GlobalExpenseTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GlobalExpenseType', function(GlobalExpenseType) {
                            return GlobalExpenseType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('global-expense-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('GlobalExpenseType', GlobalExpenseType);

    GlobalExpenseType.$inject = ['$resource'];

    function GlobalExpenseType ($resource) {
        var resourceUrl =  'api/global-expense-type/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('GlobalExpenseTypeController', GlobalExpenseTypeController);

    GlobalExpenseTypeController.$inject = ['$scope', '$state', 'GlobalExpenseType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function GlobalExpenseTypeController ($scope, $state, GlobalExpenseType, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            GlobalExpenseType.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.globalExpenseTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('GlobalExpenseTypeDialogController', GlobalExpenseTypeDialogController);

    GlobalExpenseTypeDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'GlobalExpenseType'];

    function GlobalExpenseTypeDialogController ($scope, $stateParams, $uibModalInstance, entity, GlobalExpenseType) {
        var vm = this;
        vm.globalExpenseType = entity;
        vm.load = function(id) {
            GlobalExpenseType.get({id : id}, function(result) {
                vm.globalExpenseType = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:globalExpenseTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.globalExpenseType.id !== null) {
                GlobalExpenseType.update(vm.globalExpenseType, onSaveSuccess, onSaveError);
            } else {
                GlobalExpenseType.save(vm.globalExpenseType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('GlobalExpenseTypeDetailController', GlobalExpenseTypeDetailController);

    GlobalExpenseTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'GlobalExpenseType'];

    function GlobalExpenseTypeDetailController($scope, $rootScope, $stateParams, entity, GlobalExpenseType) {
        var vm = this;
        vm.globalExpenseType = entity;
        vm.load = function (id) {
            GlobalExpenseType.get({id: id}, function(result) {
                vm.globalExpenseType = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:globalExpenseTypeUpdate', function(event, result) {
            vm.globalExpenseType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('GlobalExpenseTypeDeleteController',GlobalExpenseTypeDeleteController);

    GlobalExpenseTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'GlobalExpenseType'];

    function GlobalExpenseTypeDeleteController($uibModalInstance, entity, GlobalExpenseType) {
        var vm = this;
        vm.globalExpenseType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            GlobalExpenseType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TransferBalanceDialogController', TransferBalanceDialogController);

    TransferBalanceDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Billing',  'LigneContrat'];

    function TransferBalanceDialogController ($scope, $stateParams, $uibModalInstance, entity, Billing,  LigneContrat) {
        var vm = this;
        vm.balanceTransfer  = entity;
        vm.lignecontrats = LigneContrat.findActifByContrat({idContrat:$stateParams.id});
        vm.getBalanceAfterTransfer = getBalanceAfterTransfer;
        vm.getCurrentBalance = getCurrentBalance;
        vm.hasTransferPreview = hasTransferPreview;

        vm.lignecontrats.$promise.then(function(result) {
            vm.lignecontrats = result;

            if (vm.balanceTransfer.ligneContrat && vm.balanceTransfer.ligneContrat.id) {
                vm.balanceTransfer.ligneContrat = findLineById(vm.balanceTransfer.ligneContrat.id);
            }

            if (vm.balanceTransfer.ligneContratCible && vm.balanceTransfer.ligneContratCible.id) {
                vm.balanceTransfer.ligneContratCible = findLineById(vm.balanceTransfer.ligneContratCible.id);
            }
        });
                 
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:impactPenalitRemiseRegulUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            Billing.saveBalanceTransfer(vm.balanceTransfer , onSaveSuccess, onSaveError);
            
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        function findLineById(id) {
            var matchedLine = null;

            angular.forEach(vm.lignecontrats, function(ligneContrat) {
                if (!matchedLine && String(ligneContrat.id) === String(id)) {
                    matchedLine = ligneContrat;
                }
            });

            return matchedLine;
        }

        function getCurrentBalance(ligneContrat) {
            if (!ligneContrat) {
                return 0;
            }
            if (ligneContrat.moneyboxApresPaiement !== undefined && ligneContrat.moneyboxApresPaiement !== null) {
                return ligneContrat.moneyboxApresPaiement;
            }
            if (ligneContrat.derniereLignePaiement
                && ligneContrat.derniereLignePaiement.moneyboxApresPaiement !== undefined
                && ligneContrat.derniereLignePaiement.moneyboxApresPaiement !== null) {
                return ligneContrat.derniereLignePaiement.moneyboxApresPaiement;
            }
            return 0;
        }

        function getBalanceAfterTransfer(ligneContrat, direction) {
            var amount = Number(vm.balanceTransfer.amount || 0);
            var currentBalance = getCurrentBalance(ligneContrat);

            if (!ligneContrat || !amount) {
                return currentBalance;
            }

            if (direction === 'DEBIT') {
                return currentBalance - amount;
            }

            return currentBalance + amount;
        }

        function hasTransferPreview() {
            return vm.balanceTransfer.ligneContrat
                && vm.balanceTransfer.ligneContratCible
                && vm.balanceTransfer.amount > 0;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TicketsContratController', TicketsContratController);

    TicketsContratController.$inject = ['$scope', '$rootScope', '$stateParams', 'Principal','entity', 'Contrat','RedmineService'];

    function TicketsContratController($scope, $rootScope, $stateParams,Principal, entity, Contrat,RedmineService) {
        var vm = this;
        vm.contract = entity;

        vm.user = {} ;
        Principal.identity().then(function(account) {
        	if(account){
              vm.user =account ;
        	}
        });

    	vm.listIssues = RedmineService.issuesForContract({contractRef:  $stateParams.ref});
    	
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ServicesContratController', ServicesContratController);

    ServicesContratController.$inject = ['$scope', '$window','$rootScope', '$stateParams','Principal', 'entity', 'Contrat','ImpactPenalitRemiseRegul','DateUtils'];

    function ServicesContratController($scope, $window,$rootScope, $stateParams,Principal, entity, Contrat,ImpactPenalitRemiseRegul,DateUtils) {
        var vm = this;
        vm.contrat = entity;
        vm.countService = 0;
        vm.countAboJournalier= 0;
        vm.countCredit= 0;
        vm.countVenteUnitaire= 0;
        vm.countServiceEau = 0;
        vm.today = new Date();
		vm.canEditContract = false;
		  
        vm.load = function (id) {
            Contrat.get({id: id}, function(result) {
                vm.contrat = result;

                
                angular.forEach(vm.contrat.ligneContrats, function(itm){
                	if (itm.serviceVendu.typePaiement === 'A_PAYER_EN_UNE_FOIS') {
        				vm.countVenteUnitaire++;
        			} else if (itm.serviceVendu.typePaiement === 'A_PAYER_PAR_JOUR') {
        				vm.countAboJournalier++;
        			} else if (itm.serviceVendu.typePaiement === 'A_PAYER_AVEC_ECHELONNEMENT') {
        				vm.countCredit++;
        			} else if (itm.serviceVendu.typePaiement === 'A_PAYER_SUR_CONSO_EAU') {
        				vm.countServiceEau++;
        			}
                	
                	if( itm.closed === false){
                		vm.countService++;
                	}
                	
                });
                
            });

            
            ImpactPenalitRemiseRegul.findByContrat({id : id}, function(result) {
            	vm.impactPenalitRemiseRegul =  result;
            });
        };

        vm.load($stateParams.id);

		    Principal.identity().then(function(account) {
		    	if(account){
		            vm.canEditContract = account.authorities.indexOf('ROLE_DATA_OPERATOR') !== -1
					 ||  account.authorities.indexOf('ROLE_AREA_MANAGEMENT') !== -1
					 ||  account.authorities.indexOf('ROLE_ADMIN') !== -1;
					
					   
		    	}
		    });
			
        vm.getDateFromString = function(dateString) {
        	return DateUtils.convertLocalDateFromServer(dateString);
//            var dateParts = dateString.split("-");
//            var year = parseInt(dateParts[0]);
//            var month = parseInt(dateParts[1]); // Les mois dans JavaScript sont indexés à partir de 0 (janvier = 0, février = 1, etc.)
//            var day = parseInt(dateParts[2]);
//            return new Date(year, month, day);
        };
        
        
        vm.activeTab=1;
        vm.setActiveTab = function(index){
        	vm.activeTab = index;
        }

        $('.table-responsive').on('show.bs.dropdown', function () {
			var clientWidth = document.documentElement.clientWidth;
			if (clientWidth > 992) {
				$('.table-responsive').css( "overflow", "inherit" );
			}else{
				$('.table-responsive .dropdown-menu').css( "position", "static !important" );
				
			}
		
       });

       $('.table-responsive').on('hide.bs.dropdown', function () {
			$('.table-responsive').css( "overflow", "auto" );
       })
       
       

       vm.addTabsLeft =  function () {

			var clientWidth = document.documentElement.clientWidth;

			var classtoadd = angular.element('#tabsParent');
			if (clientWidth > 992) {//768
				classtoadd.addClass('tabs-left')
			} else {
				classtoadd.removeClass('tabs-left')
			}
		}
       vm.addTabsLeft();

//       angular.element($window).on('resize',  vm.addTabsLeft());
		angular.element($window).bind('resize', function() {
			vm.addTabsLeft();
		});
		
		vm.calculTotalToBePaid = function(){

			var totalToBePaid = 0;

		 	angular.forEach(vm.contrat.ligneContrats, function(itm){
		 		if(itm.closed === false && itm.derniereLignePaiement  != null   ){
		 		totalToBePaid = totalToBePaid - itm.derniereLignePaiement.moneyboxApresPaiement  ;
		 		}
		    });
			
		 	return totalToBePaid;
		}
		   
    }
    
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ServiceContratDeleteController',ServiceContratDeleteController);

    ServiceContratDeleteController.$inject = ['$uibModalInstance', 'entity', 'LigneContrat'];

    function ServiceContratDeleteController($uibModalInstance, entity, LigneContrat) {
        var vm = this;
        vm.contrat = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
        	LigneContrat.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReceiptsContratController', ReceiptsContratController);

    ReceiptsContratController.$inject = ['$scope', '$state','$filter', '$rootScope', '$stateParams', 'entity', 'Factures', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ReceiptsContratController($scope, $state,$filter, $rootScope, $stateParams, entity, Factures, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.contrat = entity;
        vm.idContrat=$stateParams.id;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.activeTab=1;
        vm.setActiveTab = function(index){
        	vm.activeTab = index;
        }
        
        vm.load = function () {
  
            vm.currentSearch=false;

            Factures.queryReceipts(
            	{id : $stateParams.id,
	            page: pagingParams.page - 1,
	            size: paginationConstants.itemsPerPage,
	            sort: sort()
            }, onSuccess, onError);
            
            

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(result, headers) {
    			vm.factures =  result;
    			vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
        
        vm.load();

        vm.transition = function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                id:$stateParams.id,
                currentSearch : vm.currentSearch
            });
        };

		  
        $scope.downloadReceipt = function(idReceipt) {
			Factures.getReceipts({
				id : idReceipt
			}, function(result) {
		          
        			if(result.receiptTemplate && result.receiptTemplate.length > 0){
        				var contentFinal = createReceipt(result.receiptTemplate,result);

        				var popupWin = window.open('', '_blank');
        				popupWin.document.open();

        				popupWin.document
        						.write('<html><head>'
        								+ '<style type="text/css" media="print">@page { size: portrait; }    </style>'
        								+ '<style type="text/css" >.size1{ font-size: 18px; }  .size2{ font-size: 21px; }  .size3{ font-size: 24px; }  </style>'
        								
        								+ '</head><body onload="window.print()" style="font-family:control;width:262px;font-size: 18px;">'
        								+ contentFinal + '</body></html>');
        				popupWin.document.close();
        			}else{
                        AlertService.error(
                        		$filter('translate')('wamasysApp.contrat.documents.noReceiptTemplateForPrinting')		);
        			}
			});
		}


        
 
    var divOpen =false;
    var spanOpen =false;
    
    function createReceipt(  textData ,  donneesContrat)  {
    	var result = "";
    	
    	if(textData){
        	textData = textData.replace(/\n/g, "<br/>");
        	textData = textData.replace(/\s\s/g, " &nbsp;");
	     	while(textData.length>0){
	     		
                //On recherche les commandes
                var index = textData.indexOf("${");
                if(index<0){
                    //Si pas de commande on imprime le text
                	result =result+ textData.substring(0,textData.length);
                    textData = '';
                }else{
                    //Si on a une commande on envoie à l'imprimante le text à imprimer avant.
                    if(index>0){
                    	result = result+ textData.substring(0,index);
                    	textData = textData.substring(index,textData.length);
                    }
                    index = 0;//N'est plus utilisé, mais l'index de départ devient 0

                    //On recherche le nom de la commande, on l'execute puis on supprime le text en question du buffer
                    var indexlast = textData.indexOf("}");
                    var cmd = textData.substring(2,indexlast);
                    
                    result = result+ executerCommande(cmd, donneesContrat,$filter);
                    
                	textData = textData.substring(indexlast+1,textData.length);
                }
            }
	     	
	    	if(divOpen) result = result+ '</span>'; 
	    	if(spanOpen) result = result+ '</span>'; 
	    	}
    	
     	return result;

    }

    /*
    */
    function executerCommande(  command ,donneesContrat,$filter)  {
    	var result = "";
        if(command==null ){
            return;
        }
        switch (command) {
            case "center" :
            	if(divOpen)
            		result = result + '</span>'; 
            	result = result + '<span  style="text-align: center; display: block;">'; //mPrinter.addTextAlign(Printer.ALIGN_CENTER);
            	divOpen=true;
                break;
            case "left" :
            	if(divOpen)
            		result = result +'</span>'; 
            	
            	divOpen=false;
                break;
                
            case "right" :
            	if(divOpen)
            		result = result +'</span>'; 
            	result = result + '<span style="float: right">'; 
            	divOpen=true;
                break;
                
            case "s1" :
            	if(spanOpen)
            		result = result +'</pre>'; 
//            	result = result + '<pre class="size1">'; 
//            	spanOpen=true;
                break;
                
            case "s2" :
            	if(spanOpen)
            		result = result +'</pre>'; 
            	result = result + '<pre class="size2">'; 
            	spanOpen=true;
                break;
                
            case "s3" :
            	if(spanOpen)
            		result = result +'</pre>'; 
            	result = result + '<pre class="size3">'; 
            	spanOpen=true;
                break;

            case "checkId" :
            	return donneesContrat.paymentReceipt.checkId;
                break;

            case "receiptId" :
            	return donneesContrat.paymentReceipt.receiptNumber;
                break;
                
            case "dateReceipt" :
            	//const options = {  year: 'numeric', month: 'numeric', day: 'numeric' };
            	var datePaiement = donneesContrat.datePaiement;
            	if(!datePaiement){
            		datePaiement=new Date();
            	}else{
            		datePaiement =new Date(datePaiement);
            	}
            
            	return datePaiement.toLocaleDateString(
            			navigator.language, {  year: 'numeric', month: 'numeric', day: 'numeric' })
            			+ " - " 
            			+ datePaiement.toLocaleTimeString(navigator.language);
            //	return $filter('date')(, "mediumDate");
                break;

            case "paid" :
            	return donneesContrat.paymentReceipt.amountPaid;
                break;
           
            case "paidExclTax" :
            	var paidExclTax = 0;
            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		paidExclTax = paidExclTax + donneesContrat.listPaymentReceived[i].paidExclTax;
            	}
            	return paidExclTax;
                break;

            case "customerCopy" :
            	if(donneesContrat.paymentReceipt.originalPrinted){
            		return $filter('translate')('wamasysApp.contrat.paiement.duplicate');
            	}else{
            		return $filter('translate')('wamasysApp.contrat.paiement.customerCopy');
            	}
                break;
            case "servicesPaid" :
            	var retour = "";
            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		retour = retour + '<span style="float: left">' + donneesContrat.listPaymentReceived[i].serviceName + '</span>'
            		+ '<span style="float: right">' + donneesContrat.listPaymentReceived[i].paidInclTax + '</span><br/>';
            		//  paidExclTax;
            	}
            	return retour ;
                break;

            case "servicesPaidExclTaxes" :
            	var retour = "";
            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		retour = retour + '<span style="float: left">' + donneesContrat.listPaymentReceived[i].serviceName + '</span>'
            		+ '<span style="float: right">' + donneesContrat.listPaymentReceived[i].paidExclTax + '</span><br/>';
            	}
            	return retour ;
                break;
                
            case "taxesPaid" :
            	var map = {};

            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		if(donneesContrat.listPaymentReceived[i].taxeName || donneesContrat.listPaymentReceived[i].taxPaid){
            			if(map[donneesContrat.listPaymentReceived[i].taxeName ]){
            				map[donneesContrat.listPaymentReceived[i].taxeName ] = map[donneesContrat.listPaymentReceived[i].taxeName] + donneesContrat.listPaymentReceived[i].taxPaid;
            			}else{
            				map[donneesContrat.listPaymentReceived[i].taxeName ] =  donneesContrat.listPaymentReceived[i].taxPaid;
            			}
            			
            		}
            	}
            			
            	
            	var retour = "";

            	for (var key in map) {
            		 if (map.hasOwnProperty(key)) {
               			retour = retour + '<span style="float: left">' + key + '</span>'
               			+ '<span style="float: right">' + Number.parseFloat(map[key] ).toFixed(2) + '</span><br/>';
            		 }
            	}

            	return retour ;
                break;

            case "remainingBalance" :
            	var remainingBalance = 0.0;
            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		var lignePaiement =  donneesContrat.listPaymentReceived[i];
            		remainingBalance = remainingBalance + lignePaiement.remainingBalanceAfterPayment ;
            	}
            	return remainingBalance.toFixed(2); ;
                break;
                

            case "amountBilled" :
            	var totalMontantAPayerTtc = 0.0;
            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
                		totalMontantAPayerTtc = totalMontantAPayerTtc
                			+ donneesContrat.listPaymentReceived[i].amountToBePaid
            		
            	}
            	return totalMontantAPayerTtc.toFixed(2); 
                break;
                
            case "totalToBePaid" :
            	var totalToBePaid = 0.0;
            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		
            		totalToBePaid = totalToBePaid
            			+ donneesContrat.listPaymentReceived[i].amountToBePaid
            			- donneesContrat.listPaymentReceived[i].remainingBalanceBeforePayment
            	}
            	return totalToBePaid.toFixed(2); 
                break;

            case "balanceBeforePayment" :
            	var balanceBeforePayment = 0.0;
            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		balanceBeforePayment = balanceBeforePayment
            			+ donneesContrat.listPaymentReceived[i].remainingBalanceBeforePayment
            	}
            	return balanceBeforePayment.toFixed(2); 
                break;

            case "servicesToBePaid" :
            	var retour = "";
            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		retour = retour + '<span style="float: left">' + donneesContrat.listPaymentReceived[i].serviceName + '</span>'
            		+ '<span style="float: right">' + donneesContrat.listPaymentReceived[i].amountToBePaid + '</span><br/>';
            	}
            	return retour ;
                break;
                
            case "taxesToBePaid" :
            	var map = {};

            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		if(donneesContrat.listPaymentReceived[i].taxeName || donneesContrat.listPaymentReceived[i].taxToBePaid){
            			if(map[donneesContrat.listPaymentReceived[i].taxeName ]){
            				map[donneesContrat.listPaymentReceived[i].taxeName ] = map[donneesContrat.listPaymentReceived[i].taxeName] + donneesContrat.listPaymentReceived[i].taxToBePaid;
            			}else{
            				map[donneesContrat.listPaymentReceived[i].taxeName ] =  donneesContrat.listPaymentReceived[i].taxToBePaid;
            			}
            			
            		}
            	}
            			
            	
            	var retour = "";
            	for (var key in map) {
            		 if (map.hasOwnProperty(key)) {
               			retour = retour + '<span style="float: left">' + key + '</span>'
               			+ '<span style="float: right">' + Number.parseFloat(map[key] ).toFixed(2)+ '</span><br/>';
            		 }
            	}

            	
            	return retour ;
                break;
                
                
            case "machineIdNumber" :
            	return donneesContrat.paymentReceipt.machineIdNumber;
                break;
                
            case "contractRef" :
            	return donneesContrat.contrat.referenceContrat;
                break;
                
            case "contractName" :
            	return donneesContrat.contrat.nomPersonne;
                break;
                
            case "contractAddress" :
            	return donneesContrat.contrat.adresse;
                break;
                
            case "logo" :
//                printLogo(mPrinter);
                break;


            default :
                break;

        }
//        if (command.startsWith("qrCode:")) {
//            String url = command.substring(7);
//            printQrCode(mPrinter,  url);
//        }
        return result;
    }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('PrintContratDialogController', PrintContratDialogController);

    PrintContratDialogController.$inject = ['$scope', '$filter', '$stateParams', '$uibModalInstance', 'entity', 'Factures'];

    function PrintContratDialogController ($scope, $filter, $stateParams, $uibModalInstance, entity, Factures) {
        var vm = this;
        vm.idContrat = entity.id;

		var $dialog = $(
				'<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-hidden="true" style="padding-top:15%; overflow-y:visible;">' +
				'<div class="modal-dialog modal-m">' +
				'<div class="modal-content">' +
					'<div class="modal-header"><h3 style="margin:0;"></h3></div>' +
					'<div class="modal-body">' +
						'<div class="progress progress-striped active" style="margin-bottom:0;"><div class="progress-bar" style="width: 100%"></div></div>' +
					'</div>' +
				'</div></div></div>');
		
        var onPrintSuccess = function (result) {
			$dialog.modal('hide');
            $uibModalInstance.close();
            vm.isPrinting = false;
		      var url = URL.createObjectURL(result.response);
		      var a = document.createElement('a');
		      a.href = url;
		      a.download = result.fileName;
		      a.target = '_blank';
		      a.click();

        };

        var onPrintError = function () {
			$dialog.modal('hide');
            vm.isPrinting = false;
        };

        vm.print = function () {



			var options = {};
			var message = 'Please wait ! Action in progress.';
			var settings = $.extend({
				dialogSize: 'm',
				progressType: '',
				onHide: null // This callback runs after the dialog was hidden
			}, options);
			$dialog.find('.modal-dialog').attr('class', 'modal-dialog').addClass('modal-' + settings.dialogSize);
			$dialog.find('.progress-bar').attr('class', 'progress-bar');
			$dialog.find('h3').text(message);
			$dialog.modal();
			
        	Factures.generer({
            	id:vm.idContrat
//            	,
//            	dateFrom:$filter('date')(vm.dateFrom, "yyyy-MM-dd"),
//        		dateTo:$filter('date')(vm.dateTo, "yyyy-MM-dd")
            }, onPrintSuccess, onPrintError);
            
        }; 

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

//        vm.datePickerOpenStatus = {};
////        vm.datePickerOpenStatus.dateFrom = false;
//        vm.datePickerOpenStatus.dateTo = false;
//
//        vm.openCalendar = function(date) {
//            vm.datePickerOpenStatus[date] = true;
//        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('PaiementsContratController', PaiementsContratController);

    PaiementsContratController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Contrat','CollectionListe'];

    function PaiementsContratController($scope, $rootScope, $stateParams, entity, Contrat,CollectionListe) {
        var vm = this;
        vm.contrat = entity;
        vm.load = function (id) {
//            Contrat.get({id: id}, function(result) {
//                vm.contrat = result;
//            });

            CollectionListe.collectionListeEnCoursByContrat({id : id}, function(result) {
            	vm.collectionListeEnCours =  result;
            });
        };
        vm.load($stateParams.id);

  

        vm.activeTab=1;
        vm.setActiveTab = function(index){
        	vm.activeTab = index;
        }
        
        vm.hasActiveLine = function(){

        	var active = false;
        	
       	 	angular.forEach(vm.contrat.ligneContrats, function(itm){
       	 		if( itm.closed ===false &&  itm.derniereLignePaiement ){
           	 		active = true;
       	 		}
            });
        	
        	return active;
        }
        vm.calculTotalToBePaid = function(){

        	var totalToBePaid = 0;

       	 	angular.forEach(vm.contrat.ligneContrats, function(itm){
       	 		if(itm.closed === false && itm.derniereLignePaiement  != null   ){
       	 		totalToBePaid = totalToBePaid - itm.derniereLignePaiement.moneyboxApresPaiement  ;
       	 		}
            });
        	
       	 	return totalToBePaid;
        }
        
        vm.calculPayment = function(listPayment){
        	var payment = 0;
        	 angular.forEach(listPayment, function(itm){
        		 payment += itm.paidInclTax;
             });
        	 return payment;
        }


        vm.calculRemainingBalance = function(ligneContrat){
        	var result = 0;
        	if(ligneContrat.derniereLignePaiement && ligneContrat.derniereLignePaiement  != null ){
        		result = - ligneContrat.derniereLignePaiement.moneyboxApresPaiement;
            		
        	}
//        	if(ligneContrat.listPaymentReceived){
//	        	 angular.forEach(ligneContrat.listPaymentReceived, function(itm){
//	        		 result -= itm.paidInclTax;
//	             });
//        	}
        	 return result;
        }
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('PaiementInitialDialogController', PaiementInitialDialogController);

    PaiementInitialDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity',  'LigneContrat', 'UserSearch'];

    function PaiementInitialDialogController ($scope, $stateParams, $uibModalInstance, entity, LigneContrat, UserSearch) {
        var vm = this;
        vm.ligneContrat = entity;
        vm.users = UserSearch.searchCollecteur();
        
     /*   vm.load = function(id) {
           LigneContrat.get({id : id}, function(result) {
                vm.paiementInitial.ligneContrat = result;
            });
        };
        
        vm.load($stateParams.idLigneContrat);*/
        
        
        
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:paiementInitialUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            
            LigneContrat.updatePaiementInitial(vm.ligneContrat, onSaveSuccess, onSaveError);
        
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.datePaiementInitial = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('PaiementAgenceDialogController', PaiementAgenceDialogController);

    PaiementAgenceDialogController.$inject = ['$scope','$filter', 'entity','$stateParams', '$uibModalInstance','Billing','AlertService'];

    function PaiementAgenceDialogController ($scope,$filter,entity,$stateParams, $uibModalInstance,  Billing ,AlertService) {
        var vm = this;
        vm.contrat = entity;
        
        vm.paymentDTO = {
        		paidAmount:0,
        		contrat:null,
        		datePaiement : new Date(),
        		listLigneCollectionList:[]
        };
        vm.showDetail = false;
 
        vm.calculTotalToBePaid = function(){
        	var payment = 0;
       	 	angular.forEach(vm.contrat.ligneContrats, function(itm){
       	 		if(itm.closed === false &&  itm.derniereLignePaiement != null){
           	 		payment = payment - itm.derniereLignePaiement.moneyboxApresPaiement ;
       	 		}
            });
        	
       	 	return payment;
        }
        
        vm.calculPaidOnEachLine = function(){
        	var payment = 0;
       	 	angular.forEach(vm.contrat.ligneContrats, function(itm){
       	 		if(itm.closed === false &&  itm.derniereLignePaiement != null){
           	 		payment = payment + itm.derniereLignePaiement.montantPayeCollecteur ;
       	 		}
            });
        	
       	 	return payment.toFixed(2);
        }
 
        vm.countLigneActives = function(){
        	var result = 0;
       	 	angular.forEach(vm.contrat.ligneContrats, function(itm){
       	 		if(itm.closed === false){
       	 			result++ ;
       	 		}
            });
        	
       	 	return result;
        }
        
        vm.onSavePayment = function () {
        	if( vm.showDetail){
           	 	if(vm.calculPaidOnEachLine() === Number.parseFloat(vm.paymentDTO.paidAmount).toFixed(2)){
           	 		//Save si le total des lignes === le montant  global payé.
       	    		vm.save();
           	 	}else{
                    AlertService.error("error.business.billing.paymentTotalNotEqualInDetail");

           	 	}
        	}else{
        		if(vm.paymentDTO.paidAmount === vm.calculTotalToBePaid() ){
        			//Répartir le paiement entre les lignes
               	 	angular.forEach(vm.contrat.ligneContrats, function(itm){
               	 		if(itm.derniereLignePaiement && itm.closed === false){
               	 			itm.derniereLignePaiement.montantPayeCollecteur = - itm.derniereLignePaiement.moneyboxApresPaiement ;
               	 		}
                    });
               	 	//On refait un controle.
            		if(vm.paymentDTO.paidAmount === vm.calculPaidOnEachLine()){
            			vm.save();
            		}else{
       	    		 	vm.showDetail = true;
    	   	    	}
	   	    	}else if (vm.countLigneActives() == 1){
               	 	angular.forEach(vm.contrat.ligneContrats, function(itm){
               	 		if(itm.closed === false){
               	 			itm.derniereLignePaiement.montantPayeCollecteur = vm.paymentDTO.paidAmount ;
               	 		}
                    });	
               	 	//On refait un controle.
            		if(vm.paymentDTO.paidAmount === vm.calculPaidOnEachLine()){
            			vm.save();
            		}else{
       	    		 	vm.showDetail = true;
    	   	    	}
	   	    	}else{
   	    		 	vm.showDetail = true;
	   	    	}
        		
        		if(vm.showDetail ){
        			//On répartie le montant entre les lignes.
        			var mapRatio = {};
        			var listLignePaiement = [];
        			 
        			var toBePaidPositive = 0;
        			var countToBePaidZero = 0;
        			var countToBePaidNegative = 0;
               	 	angular.forEach(vm.contrat.ligneContrats, function(itm){
               	 		if(itm.closed === false &&  itm.derniereLignePaiement != null && itm.derniereLignePaiement.moneyboxApresPaiement < 0 ){
               	 			toBePaidPositive = toBePaidPositive - itm.derniereLignePaiement.moneyboxApresPaiement ;
               	 		}else if(itm.closed === false &&  itm.derniereLignePaiement != null && itm.derniereLignePaiement.moneyboxApresPaiement === 0){
               	 			countToBePaidZero++ ;
               	 		}else if(itm.closed === false && itm.derniereLignePaiement != null && itm.derniereLignePaiement.moneyboxApresPaiement > 0){
               	 			countToBePaidNegative++;
               	 		}
                    });
               	 	
               	 	//cas où on a un tobePaid positif à payer, on réparti entre les lignes.
               	 	if(toBePaidPositive>0){
	               		 angular.forEach(vm.contrat.ligneContrats, function(itm){
	                	 		if(itm.closed === false &&  itm.derniereLignePaiement != null ){
	                	 			if(itm.derniereLignePaiement.moneyboxApresPaiement < 0 ){
	                	 				var ratio =  (- itm.derniereLignePaiement.moneyboxApresPaiement ) / toBePaidPositive ;
	                	 				mapRatio[itm.derniereLignePaiement.id]= ratio;
	                	 				listLignePaiement.push(itm.derniereLignePaiement);
	                	 			}else{
	                	 				mapRatio[itm.derniereLignePaiement.id]=  0;
	                	 				listLignePaiement.push(itm.derniereLignePaiement);
	                	 			}
	                	 			
	                	 		}
	         			 });	
               	 	}else if(countToBePaidZero > 0){
               	 		//Pas de toBePaid positif, dans ce cas on 
	               		 angular.forEach(vm.contrat.ligneContrats, function(itm){
	             	 		if(itm.closed === false &&  itm.derniereLignePaiement != null ){
	             	 			if(itm.derniereLignePaiement.moneyboxApresPaiement === 0 ){
	             	 				mapRatio[itm.derniereLignePaiement.id]= 1/countToBePaidZero;
	             	 				listLignePaiement.push(itm.derniereLignePaiement);
	             	 			}else{
                	 				mapRatio[itm.derniereLignePaiement.id]=  0;
	             	 				listLignePaiement.push(itm.derniereLignePaiement);
	             	 			}
	             	 		}
	               		 });	
              	 	}else if(countToBePaidNegative > 0){
               	 		//Pas de toBePaid positif, dans ce cas on 
	               		 angular.forEach(vm.contrat.ligneContrats, function(itm){
	             	 		if(itm.closed === false &&  itm.derniereLignePaiement != null ){
	             	 			if(itm.derniereLignePaiement.moneyboxApresPaiement > 0 ){
	             	 				mapRatio[itm.derniereLignePaiement.id]= 1/countToBePaidNegative;
	             	 				listLignePaiement.push(itm.derniereLignePaiement);
	             	 			}else{
	             	 				mapRatio[itm.derniereLignePaiement.id]=  0;
	             	 				listLignePaiement.push(itm.derniereLignePaiement);
	             	 			}
	             	 			
	             	 		}
	               		 });	
               	 	}
        	

        			 for (var i = 0; i < listLignePaiement.length; i++) {
        				 
        				 listLignePaiement[i].montantPayeCollecteur =  Number.parseFloat( 
        						 (vm.paymentDTO.paidAmount *  mapRatio[listLignePaiement[i].id]).toFixed(2));	
        			 }
        			 
        			 //On controle qu'on a pas besoin d'ajoute run arrondi à la fin
        			 var totalPaid = 0;
        			 for (var i = 0; i < listLignePaiement.length; i++) {
        				 totalPaid = totalPaid+listLignePaiement[i].montantPayeCollecteur ;
        				 if(i == (listLignePaiement.length-1)){
        					 if( vm.paymentDTO.paidAmount !== totalPaid ){
        						 listLignePaiement[i].montantPayeCollecteur  = 
        							 Number.parseFloat( ( listLignePaiement[i].montantPayeCollecteur  +( vm.paymentDTO.paidAmount - totalPaid )).toFixed(2));
        					 }
        				 }
        			 }
        		}
        	}
        }
        
        var onSaveSuccess = function (result) {

            $scope.$emit('wamasysApp:paiementAgenceUpdate', vm.resultPayment);
	        $uibModalInstance.close(vm.resultPayment);
	        vm.isSaving = false;

        	vm.resultPayment = result ;
        	vm.printReceipt();
	        
	        /*
        	$("#btnSavePayment").hide();
        	$("#bodyPaiement").hide();
        	$("#bodyPaiementEffectue").show();
        	

            vm.isSaving = false;*/
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            
            
            //On ajoute les lignes dans l'array
            vm.paymentDTO.listLigneCollectionList = [];
            angular.forEach(vm.contrat.ligneContrats, function(itm){
            	if(itm.closed === false && itm.derniereLignePaiement){ // .montantPayeCollecteur 

                	itm.derniereLignePaiement.ligneContrat = {id:itm.id};
                	vm.paymentDTO.listLigneCollectionList.push(itm.derniereLignePaiement);
            	}
            });
            vm.paymentDTO.contrat = vm.contrat,
            
            Billing.savePayement(vm.paymentDTO , onSaveSuccess, onSaveError);
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        
        
        

		
		vm.printReceipt = function() {
			
//	        $scope.$emit('wamasysApp:paiementAgenceUpdate', vm.resultPayment);
//	        $uibModalInstance.close(vm.resultPayment);
//	        vm.isSaving = false;
	        
			var content = vm.resultPayment.receiptTemplate;

			/*
			content = '<strong>'
					+ $filter('translate')
							(
									'wamasysApp.collectionListe.titreListeCollecteImpression')
					+ ' '
					+ $filter('date')(vm.collectionListe.dateFinPeriode,
							"mediumDate")
		*/

			/*
			content += '<div align="center">E&V Tubig Pag-asa, Inc.</br>' + 
			 'address</br>' + 
			 'Philippines</br></div>' + 
			 '</br>' + 
			 'VAT Registered TIN 123-456-789-0000' + 
			 '</br>' + 
			 '</br>' + 
			 'ablablabla' + 
			 '<h2><div align="center">OFFICIAL RECEIPT </div></h2>' + 
			 '</br>' + 
			 '</br>' + 
			 'MIN : ${machineIdNumber}' + 
			 '</br>' + 
			 '</br>' + 
			 'Receipt : ${receiptId}' + 
			 'Date : ${dateReceipt} ' + 
			 'Contract : ${contractRef} ' + 
			 'Name : ${contractName} ' + 
			 'Address: ${contractAddress}' + 
			 'SERVICE              |               PAID' + 
			 '${servicesPaid}' + 
			 '-----------------------------------------' + 
			 'TAXES                |               PAID' + 
			 '${taxesPaid}' + 
			 '${s2}${right}Total Paid  ${paid}' + 
			 '${s1}${left}' + 
			 'Internal id : ${checkId}' + 
			 'Wamasys' + 
			 'blablabla' + 
			 '<br/>' + 
			 '--------------------1--------------------<br/>' + 
			 'D--------------------------------------0E' + 
			 '<br/>' + 
			 'Water service <span align="right">100,00.00</span><br/>' + 
			 'Water Access <span align="right">100,00.00</span><br/>' + 
			 '<h4><div align="right">Payé : 10 000.00  </div></h4>' + 
			 '<br/>';
			 */
			
			//On boucle, des qu'on voit une commande on fait.
			
			if(content && content.length > 0){
				var contentFinal = createReceipt(content,vm.resultPayment,$filter);

				var popupWin = window.open('', '_blank');
				popupWin.document.open();

				popupWin.document
						.write('<html><head>'
								+ '<style type="text/css" media="print">@page { size: portrait; }    </style>'
								+ '<style type="text/css" >.size1{ font-size: 18px; }  .size2{ font-size: 21px; }  .size3{ font-size: 24px; }  </style>'
								
								+ '</head><body onload="window.print()" style="font-family:control;width:262px;font-size: 18px;">'
								+ contentFinal + '</body></html>');
				popupWin.document.close();
			}
		
	
		}
    }
    
    var divOpen =false;
    var spanOpen =false;
    
    function createReceipt(  textData ,  donneesContrat,$filter)  {
    	var result = "";
    	
    	if(textData){
        	textData = textData.replace(/\n/g, "<br/>");
        	textData = textData.replace(/\s\s/g, " &nbsp;");
	     	while(textData.length>0){
	     		
                //On recherche les commandes
                var index = textData.indexOf("${");
                if(index<0){
                    //Si pas de commande on imprime le text
                	result =result+ textData.substring(0,textData.length);
                    textData = '';
                }else{
                    //Si on a une commande on envoie à l'imprimante le text à imprimer avant.
                    if(index>0){
                    	result = result+ textData.substring(0,index);
                    	textData = textData.substring(index,textData.length);
                    }
                    index = 0;//N'est plus utilisé, mais l'index de départ devient 0

                    //On recherche le nom de la commande, on l'execute puis on supprime le text en question du buffer
                    var indexlast = textData.indexOf("}");
                    var cmd = textData.substring(2,indexlast);
                    
                    result = result+ executerCommande(cmd, donneesContrat,$filter);
                    
                	textData = textData.substring(indexlast+1,textData.length);
                }
            }
	     	
	    	if(divOpen) result = result+ '</span>'; 
	    	if(spanOpen) result = result+ '</span>'; 
	    	}
    	
     	return result;

    }

    /*
    */
    function executerCommande(  command ,donneesContrat,$filter)  {
    	var result = "";
        if(command==null ){
            return;
        }
        switch (command) {
            case "center" :
            	if(divOpen)
            		result = result + '</span>'; 
            	result = result + '<span  style="text-align: center; display: block;">'; //mPrinter.addTextAlign(Printer.ALIGN_CENTER);
            	divOpen=true;
                break;
            case "left" :
            	if(divOpen)
            		result = result +'</span>'; 
            	
            	divOpen=false;
                break;
                
            case "right" :
            	if(divOpen)
            		result = result +'</span>'; 
            	result = result + '<span style="float: right">'; 
            	divOpen=true;
                break;
                
            case "s1" :
            	if(spanOpen)
            		result = result +'</pre>'; 
//            	result = result + '<pre class="size1">'; 
//            	spanOpen=true;
                break;
                
            case "s2" :
            	if(spanOpen)
            		result = result +'</pre>'; 
            	result = result + '<pre class="size2">'; 
            	spanOpen=true;
                break;
                
            case "s3" :
            	if(spanOpen)
            		result = result +'</pre>'; 
            	result = result + '<pre class="size3">'; 
            	spanOpen=true;
                break;

            case "checkId" :
            	return donneesContrat.paymentReceipt.checkId;
                break;

            case "receiptId" :
            	return donneesContrat.paymentReceipt.receiptNumber;
                break;
                
            case "dateReceipt" :
            	//const options = {  year: 'numeric', month: 'numeric', day: 'numeric' };
             	var datePaiement = donneesContrat.datePaiement;
            	if(!datePaiement){
            		datePaiement=new Date();
            	}else{
            		datePaiement =new Date(datePaiement);
            	}
            	return datePaiement.toLocaleDateString(
            			navigator.language, {  year: 'numeric', month: 'numeric', day: 'numeric' })
            			+ " - " 
            			+ datePaiement.toLocaleTimeString(navigator.language);
            //	return $filter('date')(, "mediumDate");
                break;

            case "paid" :
            	return donneesContrat.paidAmount;
                break;

            case "paidExclTax" :
            	var paidExclTax = 0;
            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		paidExclTax = paidExclTax + donneesContrat.listPaymentReceived[i].paidExclTax;
            	}
            	return paidExclTax;
                break;

            case "customerCopy" :
            	//Attention ici on indique déjà que c'est imprimé, donc on agfiche toujours customercopy
//            	if(donneesContrat.paymentReceipt.originalPrinted){
//            		return $filter('translate')('wamasysApp.contrat.paiement.duplicate');
//            	}else{
//            		return $filter('translate')('wamasysApp.contrat.paiement.customerCopy');
//            	}
            	return $filter('translate')('wamasysApp.contrat.paiement.customerCopy');
                break;
                
            case "servicesPaid" :
            	var retour = "";
            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		retour = retour + '<span style="float: left">' + donneesContrat.listPaymentReceived[i].serviceName + '</span>'
            		+ '<span style="float: right">' + donneesContrat.listPaymentReceived[i].paidInclTax + '</span><br/>';
            		//  paidExclTax;
            	}
            	return retour ;
                break;
                
            case "taxesPaid" :
            	var map = {};

            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		if(donneesContrat.listPaymentReceived[i].taxeName || donneesContrat.listPaymentReceived[i].taxPaid){
            			if(map[donneesContrat.listPaymentReceived[i].taxeName ]){
            				map[donneesContrat.listPaymentReceived[i].taxeName ] = map[donneesContrat.listPaymentReceived[i].taxeName] + donneesContrat.listPaymentReceived[i].taxPaid;
            			}else{
            				map[donneesContrat.listPaymentReceived[i].taxeName ] =  donneesContrat.listPaymentReceived[i].taxPaid;
            			}
            			
            		}
            	}
            			
            	
            	var retour = "";

            	for (var key in map) {
            		 if (map.hasOwnProperty(key)) {
               			retour = retour + '<span style="float: left">' + key + '</span>'
               			+ '<span style="float: right">' + Number.parseFloat(map[key] ).toFixed(2) + '</span><br/>';
            		 }
            	}

            	return retour ;
                break;

            case "remainingBalance" :
            	var remainingBalance = 0.0;
            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		var lignePaiement =  donneesContrat.listPaymentReceived[i];
            		
            		remainingBalance = remainingBalance +   lignePaiement.remainingBalanceAfterPayment ;
                  
            		
            	}
            	return remainingBalance.toFixed(2); ;
                break;
                

            case "amountBilled" :
            	var totalMontantAPayerTtc = 0.0;
            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
                		totalMontantAPayerTtc = totalMontantAPayerTtc
                			+ donneesContrat.listPaymentReceived[i].amountToBePaid
            		
            	}
            	return totalMontantAPayerTtc.toFixed(2); 
                break;
                
            case "totalToBePaid" :
            	var totalToBePaid = 0.0;
            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		
            		totalToBePaid = totalToBePaid
            			+ donneesContrat.listPaymentReceived[i].amountToBePaid
            			- donneesContrat.listPaymentReceived[i].remainingBalanceBeforePayment
            	}
            	return totalToBePaid.toFixed(2); 
                break;

            case "balanceBeforePayment" :
            	var balanceBeforePayment = 0.0;
            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		balanceBeforePayment = balanceBeforePayment
            			+ donneesContrat.listPaymentReceived[i].remainingBalanceBeforePayment
            	}
            	return balanceBeforePayment.toFixed(2); 
                break;

            case "servicesToBePaid" :
            	var retour = "";
            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		retour = retour + '<span style="float: left">' + donneesContrat.listPaymentReceived[i].serviceName + '</span>'
            		+ '<span style="float: right">' + donneesContrat.listPaymentReceived[i].amountToBePaid + '</span><br/>';
            	}
            	return retour ;
                break;

            case "servicesPaidExclTaxes" :
            	var retour = "";
            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		retour = retour + '<span style="float: left">' + donneesContrat.listPaymentReceived[i].serviceName + '</span>'
            		+ '<span style="float: right">' + donneesContrat.listPaymentReceived[i].paidExclTax + '</span><br/>';
            	}
            	return retour ;
                break;
                
            case "taxesToBePaid" :
            	var map = {};

            	for( var i = 0; i < donneesContrat.listPaymentReceived.length; i++  ){
            		if(donneesContrat.listPaymentReceived[i].taxeName || donneesContrat.listPaymentReceived[i].taxToBePaid){
            			if(map[donneesContrat.listPaymentReceived[i].taxeName ]){
            				map[donneesContrat.listPaymentReceived[i].taxeName ] = map[donneesContrat.listPaymentReceived[i].taxeName] + donneesContrat.listPaymentReceived[i].taxToBePaid;
            			}else{
            				map[donneesContrat.listPaymentReceived[i].taxeName ] =  donneesContrat.listPaymentReceived[i].taxToBePaid;
            			}
            			
            		}
            	}
            			
            	
            	var retour = "";
            	for (var key in map) {
            		 if (map.hasOwnProperty(key)) {
               			retour = retour + '<span style="float: left">' + key + '</span>'
               			+ '<span style="float: right">' + Number.parseFloat(map[key] ).toFixed(2)+ '</span><br/>';
            		 }
            	}

            	
            	return retour ;
                break;
                
                
            case "machineIdNumber" :
            	return donneesContrat.paymentReceipt.machineIdNumber;
                break;
                
            case "contractRef" :
            	return donneesContrat.contrat.referenceContrat;
                break;
                
            case "contractName" :
            	return donneesContrat.contrat.nomPersonne;
                break;
                
            case "contractAddress" :
            	return donneesContrat.contrat.adresse;
                break;
                
            case "logo" :
//                printLogo(mPrinter);
                break;


            default :
                break;

        }
//        if (command.startsWith("qrCode:")) {
//            String url = command.substring(7);
//            printQrCode(mPrinter,  url);
//        }
        return result;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('PaymentReceivedDeleteController',PaymentReceivedDeleteController);

    PaymentReceivedDeleteController.$inject = ['$uibModalInstance','entity', 'Billing'];

    function PaymentReceivedDeleteController($uibModalInstance, entity, Billing) {
        var vm = this;
        vm.paymentReceived = entity;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
        	Billing.deletePayment({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('LigneContrat', LigneContrat);

    LigneContrat.$inject = ['$resource', 'DateUtils'];

    function LigneContrat ($resource, DateUtils) {
        var resourceUrl =  'api/ligne-contrats/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateActivation = DateUtils.convertLocalDateFromServer(data.dateActivation);
                    data.datePaiementInitial = DateUtils.convertLocalDateFromServer(data.datePaiementInitial);
                	
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.dateActivation = DateUtils.convertLocalDateToServer(data.dateActivation);
                	clonedData.datePaiementInitial = DateUtils.convertLocalDateToServer(data.datePaiementInitial);
                    return angular.toJson(clonedData);
                }
            },/*
            'update': { method:'PUT' ,
                transformRequest: function (data) {
                    data.dateActivation = DateUtils.convertLocalDateToServer(data.dateActivation);
                    return angular.toJson(data);
                }
            },
            'updatePaiementInitial': {
                method: 'PUT', 
                url :'api/ligne-contrats/update-paiement-initial/',
                transformRequest: function (data) {
                    data.dateActivation = DateUtils.convertLocalDateToServer(data.dateActivation);
                    data.datePaiementInitial = DateUtils.convertLocalDateToServer(data.datePaiementInitial);
                    return angular.toJson(data);
                }
            },*/
            'standBy': {
                method: 'POST', 
                url :'api/ligne-contrats/:idLigneContrat/stand_by'
            },
            'reopen': {
                method: 'POST', 
                url :'api/ligne-contrats/:idLigneContrat/reopen'
            },
            'findByContrat':{ method: 'GET', isArray: true, url :'api/ligne-contrats/search-by-contrat/:idContrat'},
            'findActifByContrat':{ method: 'GET', isArray: true, url :'api/ligne-contrats/search-actif-by-contrat/:idContrat'}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('InformationContratController', InformationContratController);

    InformationContratController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Contrat','ContractType','ContractProfil','PortefeuilleContrat','Agence','Principal'];

    function InformationContratController($scope, $rootScope, $stateParams, entity, Contrat,ContractType,ContractProfil,PortefeuilleContrat,Agence,Principal) {
        var vm = this;
        vm.contrat = entity;
        vm.canEditContract = false;

        vm.canManageCommunicationSubscriptions = false;
        
        Principal.identity().then(function(account) {
        	if(account){
                vm.canEditContract = account.authorities.indexOf('ROLE_DATA_OPERATOR') !== -1
				 ||  account.authorities.indexOf('ROLE_AREA_MANAGEMENT') !== -1
				 ||  account.authorities.indexOf('ROLE_ADMIN') !== -1;
             
                vm.canManageCommunicationSubscriptions = vm.canEditContract
                    || account.authorities.indexOf('ROLE_AREA_CONFIGURATION') !== -1;
				
				    
        		vm.onlinePaymentConf =  Agence.getOnlinePaymentConf({idArea:account.agence.id});
            
        	}
        });
        
        

        ContractType.query({}, function(result) {
        	vm.contractTypes = result;
        	entity.$promise.then(function(value) {
	        	if(vm.contrat.contractType){
	        		var  fnctIdEqual = function(element) { return element.id === vm.contrat.contractType.id};
	        		var index = vm.contractTypes.findIndex(fnctIdEqual);
	        		if(index === -1 ){
	        			vm.contractTypes.push(vm.contrat.contractType);
	        		}
	        	}
        	});
        });
        ContractProfil.query({}, function(result) {
        	vm.contractProfils = result;
        	entity.$promise.then(function(value) {
	        	if(vm.contrat.contractProfil){
	        		var  fnctIdEqual = function(element) {return element.id === vm.contrat.contractProfil.id};
	        		var index = vm.contractProfils.findIndex(fnctIdEqual);
	        		if(index === -1 ){
	        			vm.contractProfils.push(vm.contrat.contractProfil);
	        		}
	        	}
        	});
        });
//        vm.contractProfils = ContractProfil.query();
        
        vm.portefeuillecontrats = PortefeuilleContrat.query({ offset: 0,size: 1000});
        
        
        vm.onlinePaymentList = Contrat.getListOnlinePayment({idContrat: $stateParams.id});
        vm.communicationSubscriptions = Contrat.getCommunicationSubscriptions({idContrat: $stateParams.id});


        var unsubscribe = $rootScope.$on('wamasysApp:contratUpdate', function(event, result) {
            vm.contrat = result;
        });
        $scope.$on('$destroy', unsubscribe);

        
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:contratUpdate', result);
         //   $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            if (!vm.canEditContract) {
                return;
            }
            vm.isSaving = true;
            if (vm.contrat.id !== null) {
                Contrat.update(vm.contrat, onSaveSuccess, onSaveError);
            } else {
                Contrat.save(vm.contrat, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
    }
})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ImpactPenalitRemiseRegul', ImpactPenalitRemiseRegul);

    ImpactPenalitRemiseRegul.$inject = ['$resource'];

    function ImpactPenalitRemiseRegul ($resource) {
        var resourceUrl =  'api/impact-penalit-remise-reguls/:id';

        return $resource(resourceUrl, {}, {
            'findByContrat':{ method: 'GET', isArray: true, url :'api/impact-penalit-remise-reguls/search-by-contrat/:id'},
            'saveMulti': { method: 'POST', isArray: true, url :'api/impact-penalit-remise-reguls/multi'},
            'createACancellationForThisAdjustement':{ method: 'POST', url :'api/impact-penalit-remise-reguls/createACancellationForThisAdjustement'}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ImpactPenalitRemiseRegulDialogController', ImpactPenalitRemiseRegulDialogController);

    ImpactPenalitRemiseRegulDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ImpactPenalitRemiseRegul', 'TypeAvoir', 'TypeRemisecommerciale', 'LigneContrat'];

    function ImpactPenalitRemiseRegulDialogController ($scope, $stateParams, $uibModalInstance, entity, ImpactPenalitRemiseRegul, TypeAvoir, TypeRemisecommerciale, LigneContrat) {
        var vm = this;
        vm.impactPenalitRemiseRegul = entity;
        vm.typeAvoirs = TypeAvoir.query();
        vm.typeremisecommerciales = TypeRemisecommerciale.query();
//        vm.lignecontrats = LigneContrat.findActifByContrat({idContrat:$stateParams.id});
                
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:impactPenalitRemiseRegulUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
             ImpactPenalitRemiseRegul.save(vm.impactPenalitRemiseRegul, onSaveSuccess, onSaveError);
            
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ImpactPenalitRemiseRegulDeleteController',ImpactPenalitRemiseRegulDeleteController);

    ImpactPenalitRemiseRegulDeleteController.$inject = ['$uibModalInstance','entity', 'ImpactPenalitRemiseRegul'];

    function ImpactPenalitRemiseRegulDeleteController($uibModalInstance, entity, ImpactPenalitRemiseRegul) {
        var vm = this;
        vm.impactPenalitRemiseRegul = entity;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        

        vm.confirmDelete = function (id) {
        	
        	if(vm.impactPenalitRemiseRegul.lignePaiementServiceId >0){
                ImpactPenalitRemiseRegul.createACancellationForThisAdjustement({id: id, commentaire: vm.commentaire},
                        function () {
                            $uibModalInstance.close(true);
                        });
        	}else{
                ImpactPenalitRemiseRegul.delete({id: id},
                    function () {
                        $uibModalInstance.close(true);
                    });
        	}
  
        };
        

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ImpactPenalitRemiseRegulContratDialogController', ImpactPenalitRemiseRegulContratDialogController);

    ImpactPenalitRemiseRegulContratDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity',
        'ImpactPenalitRemiseRegul', 'TypeAvoir', 'TypeRemisecommerciale', 'LigneContrat'];

    function ImpactPenalitRemiseRegulContratDialogController($scope, $stateParams, $uibModalInstance, entity,
        ImpactPenalitRemiseRegul, TypeAvoir, TypeRemisecommerciale, LigneContrat) {
        var vm = this;
        vm.impactPenalitRemiseRegul = entity;
        vm.typeAvoirs = TypeAvoir.query();
        vm.typeremisecommerciales = TypeRemisecommerciale.query();
        vm.lignecontrats = [];

        vm.clear = clear;
        vm.save = save;
        vm.getRemainingToBePaid = getRemainingToBePaid;
        vm.getAllocatedTotal = getAllocatedTotal;
        vm.getCurrentBaseTotal = getCurrentBaseTotal;
        vm.hasValidAllocatedTotal = hasValidAllocatedTotal;
        vm.updateSuggestedAllocations = updateSuggestedAllocations;

        loadEligibleLines();

        function loadEligibleLines() {
            LigneContrat.findActifByContrat({idContrat: $stateParams.id}).$promise.then(function(result) {
                vm.lignecontrats = result.filter(isEligibleLine);
                angular.forEach(vm.lignecontrats, function(ligneContrat) {
                    ligneContrat.montantAffecte = 0;
                });
            });
        }

        function isEligibleLine(ligneContrat) {
            if (!ligneContrat || ligneContrat.closed === true || !ligneContrat.serviceVendu) {
                return false;
            }

            if (vm.impactPenalitRemiseRegul.type === 'DISCOUNT') {
                if (ligneContrat.serviceVendu.typePaiement === 'A_PAYER_AVEC_ECHELONNEMENT') {
                    return false;
                }
                if (ligneContrat.serviceVendu.typePaiement === 'A_PAYER_EN_UNE_FOIS'
                    && hasExistingBilling(ligneContrat)) {
                    return false;
                }
                return true;
            }

            return hasExistingBilling(ligneContrat);
        }

        function getRemainingToBePaid(ligneContrat) {
            var currentBalance = getCurrentBalance(ligneContrat);

            if (vm.impactPenalitRemiseRegul.type === 'REFUND') {
                return roundAmount(Math.max(0, currentBalance));
            }

            return roundAmount(Math.max(0, -currentBalance));
        }

        function updateSuggestedAllocations() {
            var totalAmount = roundAmount(Number(vm.impactPenalitRemiseRegul.montantTtc || 0));
            var remainingTotal = 0;
            var remainingLines = [];
            var allocatedTotal = 0;

            angular.forEach(vm.lignecontrats, function(ligneContrat) {
                ligneContrat.montantAffecte = 0;

                var remaining = getRemainingToBePaid(ligneContrat);
                if (remaining > 0) {
                    remainingLines.push(ligneContrat);
                    remainingTotal += remaining;
                }
            });

            if (totalAmount <= 0 || remainingTotal <= 0) {
                return;
            }

            angular.forEach(remainingLines, function(ligneContrat, index) {
                var remaining = getRemainingToBePaid(ligneContrat);
                var suggestedAmount = roundAmount((totalAmount * remaining) / remainingTotal);

                if (index === remainingLines.length - 1) {
                    suggestedAmount = roundAmount(totalAmount - allocatedTotal);
                }

                ligneContrat.montantAffecte = suggestedAmount;
                allocatedTotal = roundAmount(allocatedTotal + suggestedAmount);
            });
        }

        function getAllocatedTotal() {
            var allocatedTotal = 0;

            angular.forEach(vm.lignecontrats, function(ligneContrat) {
                allocatedTotal += Number(ligneContrat.montantAffecte || 0);
            });

            return roundAmount(allocatedTotal);
        }

        function getCurrentBaseTotal() {
            var currentBaseTotal = 0;

            angular.forEach(vm.lignecontrats, function(ligneContrat) {
                currentBaseTotal += Number(getRemainingToBePaid(ligneContrat) || 0);
            });

            return roundAmount(currentBaseTotal);
        }

        function hasValidAllocatedTotal() {
            var totalAmount = roundAmount(Number(vm.impactPenalitRemiseRegul.montantTtc || 0));
            return totalAmount > 0
                && vm.lignecontrats.length > 0
                && getAllocatedLines().length > 0
                && getAllocatedTotal() === totalAmount;
        }

        function getAllocatedLines() {
            return vm.lignecontrats.filter(function(ligneContrat) {
                return Number(ligneContrat.montantAffecte || 0) > 0;
            });
        }

        function buildPayload() {
            return {
                type: vm.impactPenalitRemiseRegul.type,
                montantTtc: roundAmount(Number(vm.impactPenalitRemiseRegul.montantTtc || 0)),
                label: vm.impactPenalitRemiseRegul.label,
                commentaire: vm.impactPenalitRemiseRegul.commentaire,
                typeAvoir: vm.impactPenalitRemiseRegul.typeAvoir,
                typeRemisecommerciale: vm.impactPenalitRemiseRegul.typeRemisecommerciale,
                lignes: getAllocatedLines().map(function(ligneContrat) {
                    return {
                        ligneContrat: {id: ligneContrat.id},
                        montantTtc: roundAmount(Number(ligneContrat.montantAffecte || 0))
                    };
                })
            };
        }

        function save() {
            vm.isSaving = true;

            ImpactPenalitRemiseRegul.saveMulti(buildPayload(), onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $scope.$emit('wamasysApp:impactPenalitRemiseRegulUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function hasExistingBilling(ligneContrat) {
            return !!(ligneContrat
                && ((ligneContrat.derniereLignePaiement && ligneContrat.derniereLignePaiement.id)
                || ligneContrat.lastBillingDate));
        }

        function getCurrentBalance(ligneContrat) {
            if (!ligneContrat) {
                return 0;
            }

            if (ligneContrat.moneyboxApresPaiement !== undefined && ligneContrat.moneyboxApresPaiement !== null) {
                return Number(ligneContrat.moneyboxApresPaiement);
            }

            if (ligneContrat.derniereLignePaiement
                && ligneContrat.derniereLignePaiement.moneyboxApresPaiement !== undefined
                && ligneContrat.derniereLignePaiement.moneyboxApresPaiement !== null) {
                return Number(ligneContrat.derniereLignePaiement.moneyboxApresPaiement);
            }

            return 0;
        }

        function roundAmount(amount) {
            return Math.round(Number(amount || 0) * 100) / 100;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('HistoriqueChangementCompteurDialogController', HistoriqueChangementCompteurDialogController);

    HistoriqueChangementCompteurDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Contrat', 'HistoriqueCompteurContrat'];

    function HistoriqueChangementCompteurDialogController ($scope, $stateParams, $uibModalInstance, entity, Contrat, HistoriqueCompteurContrat ) {
        var vm = this;
        vm.listHistoriqueCompteurContrat = HistoriqueCompteurContrat.getHistoriqueByContrat( {id:$stateParams.id});
        
        
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('HistoPaiementsContratController', HistoPaiementsContratController);

    HistoPaiementsContratController.$inject = ['$scope', '$state', '$filter', '$rootScope', '$stateParams', 'Principal',
        'entity', 'Contrat', 'CollectionListe', 'ServiceVendu', 'LigneContrat', 'ParseLinks', 'AlertService',
        'pagingParams', 'paginationConstants'];

    function HistoPaiementsContratController($scope, $state, $filter, $rootScope, $stateParams, Principal, entity, Contrat,
        CollectionListe, ServiceVendu, LigneContrat, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.contrat = entity;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.displayMode = 'BILLING';
        vm.groupedCollectionListeValide = [];

        vm.clear = clear;
        vm.onFiltersChanged = onFiltersChanged;
        vm.search = search;
        vm.isBillingDisplayMode = isBillingDisplayMode;
        vm.toggleBillingDetails = toggleBillingDetails;
        vm.ligneContrats = LigneContrat.findByContrat({idContrat:$stateParams.id, offset: 0, size: 1000});
        vm.canEditContract = false;

        if ($state.params.ligneContrat) {
            vm.ligneContrat = {
                id: $state.params.ligneContrat
            };
        }

        Principal.identity().then(function(account) {
            if (account) {
                vm.canEditContract = account.authorities.indexOf('ROLE_DATA_OPERATOR') !== -1
                 || account.authorities.indexOf('ROLE_AREA_MANAGEMENT') !== -1
                 || account.authorities.indexOf('ROLE_ADMIN') !== -1;
            }
        });

        vm.date = {
            startDate: $state.params.startDate ? new Date($state.params.startDate) : null,
            endDate: $state.params.endDate ? new Date($state.params.endDate) : null
        };
        vm.opts = {
            eventHandlers: {
                // Trigger the search only after the user validates the date range.
                'apply.daterangepicker': function() {
                    $scope.$applyAsync(function() {
                        onFiltersChanged();
                    });
                }
            }
        };
        syncDisplayMode();

        vm.load = function() {
            Contrat.get({id: $stateParams.id}, function(result) {
                vm.contrat = result;
            });

            syncDisplayMode();
            vm.currentSearch = !!(vm.ligneContrat || vm.date.startDate || vm.date.endDate);
            if (isBillingDisplayMode()) {
                loadBillingHistory();
            } else {
                loadLineHistory();
            }
        };

        vm.load();

        vm.transition = function transition () {
            syncDisplayMode();
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                ligneContrat: vm.ligneContrat ? vm.ligneContrat.id : null,
                startDate: vm.date.startDate,
                endDate: vm.date.endDate,
                displayMode: vm.displayMode,
                id: $stateParams.id,
                currentSearch: vm.currentSearch
            });
        };

        vm.calcultotalPaye = function(listPaymentReceived) {
            var totalPaye = 0;

            listPaymentReceived.forEach(function(paymentReceived) {
                totalPaye += paymentReceived.paidInclTax;
            });

            return totalPaye;
        };

        vm.calcultotalAvoirAbandonDette = function(listAvoirAbandonDette) {
            var total = 0;

            listAvoirAbandonDette.forEach(function(avoirAbandonDette) {
                if (avoirAbandonDette.type === 'CREDIT_NOTE' || avoirAbandonDette.type === 'DEBT_WAIVER') {
                    total += avoirAbandonDette.montantTtc;
                }
            });

            return total;
        };

        vm.detailListPaymentReceived = null;
        vm.modalDetailPayment = function(listPaymentReceived) {
            vm.detailListPaymentReceived = listPaymentReceived;
            $('#modalPaymentReceived').modal();
        };

        function buildLineRequestParams(billingId, page, size) {
            return {
                id: $stateParams.id,
                page: angular.isDefined(page) ? page : pagingParams.page - 1,
                size: angular.isDefined(size) ? size : paginationConstants.itemsPerPage,
                sort: sort(),
                ligneContrat: $state.params.ligneContrat,
                billingId: billingId,
                fromDate: $filter('date')(vm.date.startDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(vm.date.endDate, 'yyyy-MM-dd')
            };
        }

        function buildBillingRequestParams() {
            return {
                id: $stateParams.id,
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                fromDate: $filter('date')(vm.date.startDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(vm.date.endDate, 'yyyy-MM-dd')
            };
        }

        function sort() {
            return ['datePaiement,desc', 'id,desc'];
        }

        function toggleBillingDetails(groupedBilling) {
            if (groupedBilling.detailsVisible) {
                groupedBilling.detailsVisible = false;
                return;
            }

            if (groupedBilling.detailsLoaded) {
                groupedBilling.detailsVisible = true;
                return;
            }

            groupedBilling.detailsLoading = true;
            CollectionListe.collectionListeValideByContrat(
                buildLineRequestParams(groupedBilling.billingId, 0, 200),
                function(result) {
                    groupedBilling.lines = result;
                    groupedBilling.detailsLoaded = true;
                    groupedBilling.detailsVisible = true;
                    groupedBilling.detailsLoading = false;
                },
                function(error) {
                    groupedBilling.detailsLoading = false;
                    AlertService.error(error.data.message);
                }
            );
        }

        function isBillingDisplayMode() {
            return vm.displayMode === 'BILLING';
        }

        function search() {
            applyFilters();
        }

        function onFiltersChanged() {
            applyFilters();
        }

        function applyFilters() {
            vm.links = null;
            vm.page = 1;
            vm.currentSearch = !!(vm.ligneContrat || vm.date.startDate || vm.date.endDate);
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;

            vm.ligneContrat = null;
            vm.date.startDate = null;
            vm.date.endDate = null;
            vm.currentSearch = false;
            vm.transition();
        }

        function roundAmount(amount) {
            return Math.round(Number(amount || 0) * 100) / 100;
        }

        function syncDisplayMode() {
            vm.displayMode = vm.ligneContrat ? 'LINE' : 'BILLING';
        }

        function loadBillingHistory() {
            CollectionListe.billingHistoryByContrat(buildBillingRequestParams(), onBillingHistorySuccess, onError);
        }

        function loadLineHistory() {
            CollectionListe.collectionListeValideByContrat(buildLineRequestParams(), onLineHistorySuccess, onError);
        }

        function onBillingHistorySuccess(result, headers) {
            vm.collectionListeValide = [];
            vm.groupedCollectionListeValide = result.map(function(groupedBilling) {
                groupedBilling.lines = [];
                groupedBilling.detailsLoaded = false;
                groupedBilling.detailsLoading = false;
                groupedBilling.detailsVisible = false;
                groupedBilling.totalACollecter = roundAmount(groupedBilling.totalACollecter);
                groupedBilling.montantAPayerTtc = roundAmount(groupedBilling.montantAPayerTtc);
                groupedBilling.moneyboxAvantPaiement = roundAmount(groupedBilling.moneyboxAvantPaiement);
                groupedBilling.totalPayeTtc = roundAmount(groupedBilling.totalPayeTtc);
                groupedBilling.moneyboxApresPaiement = roundAmount(groupedBilling.moneyboxApresPaiement);
                groupedBilling.quantity = roundAmount(groupedBilling.quantity);
                return groupedBilling;
            });
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
        }

        function onLineHistorySuccess(result, headers) {
            vm.collectionListeValide = result;
            vm.groupedCollectionListeValide = [];
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('HistoConsoContratController', HistoConsoContratController);

    HistoConsoContratController.$inject = ['$scope', '$state', '$rootScope', '$stateParams', '$uibModalInstance',  'ConsommationEauContrat', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function HistoConsoContratController($scope, $state, $rootScope, $stateParams,$uibModalInstance,  ConsommationEauContrat, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
//        vm.contrat = entity;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.load = function () {
//            Contrat.get({id: $stateParams.id}, function(result) {
//                vm.contrat = result;
//            });
            ConsommationEauContrat.byContrat({
               id:$stateParams.id,                
        	   page: pagingParams.page - 1,
               size: paginationConstants.itemsPerPage
               }, function(result, headers) {
          	   vm.listeConsommationEau = result;
               vm.links = ParseLinks.parse(headers('link'));
               vm.totalItems = headers('X-Total-Count');
               vm.queryCount = vm.totalItems;
               vm.page = pagingParams.page;
              },  function (error) {
                  AlertService.error(error.data.message);
              });
        };
        vm.load();

        vm.transition = function transition () {
            $uibModalInstance.close({
                page: vm.page,
                id:$stateParams.id,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            });
        };


        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('GeneratePaymentRecoveryNoticeController', GeneratePaymentRecoveryNoticeController);

    GeneratePaymentRecoveryNoticeController.$inject = ['$scope', '$filter', '$stateParams', '$uibModalInstance', 'entity', 'Factures'];

    function GeneratePaymentRecoveryNoticeController ($scope, $filter, $stateParams, $uibModalInstance, entity, Factures) {
        var vm = this;
        vm.idContrat = entity.id;

		var $dialog = $(
				'<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-hidden="true" style="padding-top:15%; overflow-y:visible;">' +
				'<div class="modal-dialog modal-m">' +
				'<div class="modal-content">' +
					'<div class="modal-header"><h3 style="margin:0;"></h3></div>' +
					'<div class="modal-body">' +
						'<div class="progress progress-striped active" style="margin-bottom:0;"><div class="progress-bar" style="width: 100%"></div></div>' +
					'</div>' +
				'</div></div></div>');
		
        var onPrintSuccess = function (result) {
			$dialog.modal('hide');
            $uibModalInstance.close();
            vm.isPrinting = false;
		      var url = URL.createObjectURL(result.response);
		      var a = document.createElement('a');
		      a.href = url;
		      a.download = result.fileName;
		      a.target = '_blank';
		      a.click();

        };

        var onPrintError = function () {
			$dialog.modal('hide');
            vm.isPrinting = false;
        };

        vm.print = function () {



			var options = {};
			var message = 'Please wait ! Action in progress.';
			var settings = $.extend({
				dialogSize: 'm',
				progressType: '',
				onHide: null // This callback runs after the dialog was hidden
			}, options);
			$dialog.find('.modal-dialog').attr('class', 'modal-dialog').addClass('modal-' + settings.dialogSize);
			$dialog.find('.progress-bar').attr('class', 'progress-bar');
			$dialog.find('h3').text(message);
			$dialog.modal();
			
        	Factures.generatePaymentRecoveryNotice({
            	id:vm.idContrat
            }, onPrintSuccess, onPrintError);
            
        }; 

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };


    }
})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('Factures', Factures);

    Factures.$inject = ['$resource', 'DateUtils'];

    function Factures ($resource, DateUtils) {
        var resourceUrl =  'api/factures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            
            'queryReceipts': { method: 'GET', url :'/api/receipts/:id' , isArray: true},

            'getReceipts': { method: 'GET', url :'/api/receipts/download/:id' },
            
            
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.dateCloture = DateUtils.convertLocalDateToServer(data.dateCloture);
                	clonedData.dateActivation = DateUtils.convertLocalDateToServer(data.dateActivation);
                    return angular.toJson(clonedData);
                }
            },
            'download' :{
            	 method:'GET', 
            	 //isArray: true,
            	 responseType: 'arraybuffer',
                headers: {
                	'Content-Type': undefined
                },
                cache: false,
                transformResponse: function (data) {
                    return {
                      response: new Blob([data], {type: 'application/pdf'})
                    };
                },
            	 url :'api/factures/download/:idAgence/:idContrat/:idFacture'
            },
            'downloadzip' :{
           	 method:'GET', 
           	 //isArray: true,
           	 responseType: 'arraybuffer',
               headers: {
               	'Content-Type': undefined
               },
               cache: false,
               transformResponse: function (data) {
                   return {
                     response: new Blob([data], {type: 'application/zip'})
                   };
               },
           	 url :'api/factures/downloadzip'
           },
            'generer': {
                method: 'POST',
                headers: {
                    accept: 'application/pdf'
                },
                responseType: 'arraybuffer',
              	url :'/api/factures/generer',
                transformResponse: function (data,headers) {

                	var filename = headers('FileName');
                	var contentType = headers('ContentType');
                    var blob;
                    if (data) {
                    	blob = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: blob,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },
            'generatePaymentRecoveryNotice': {
                method: 'POST',
                headers: {
                    accept: 'application/pdf'
                },
                responseType: 'arraybuffer',
              	url :'/api/factures/generatePaymentRecoveryNotice',
                transformResponse: function (data,headers) {

                	var filename = headers('FileName');
                	var contentType = headers('ContentType');
                    var blob;
                    if (data) {
                    	blob = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: blob,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            }
            
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('FacturesContratController', FacturesContratController);

    FacturesContratController.$inject = ['$scope', '$state','$filter', '$rootScope', '$stateParams', 'entity', 'Factures', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function FacturesContratController($scope, $state,$filter, $rootScope, $stateParams, entity, Factures, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.contrat = entity;
        vm.idContrat=$stateParams.id;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.activeTab=1;
        vm.setActiveTab = function(index){
        	vm.activeTab = index;
        }
        
        vm.load = function () {
  
            vm.currentSearch=false;
            Factures.query(
            	{id : $stateParams.id,
	            page: pagingParams.page - 1,
	            size: paginationConstants.itemsPerPage,
	            sort: sort()
            }, onSuccess, onError);
            


            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(result, headers) {
    			vm.factures =  result;
    			vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }


        };
        
        vm.load();

        vm.transition = function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                id:$stateParams.id,
                currentSearch : vm.currentSearch
            });
        };

		  
        $scope.downloadFacture = function(idAgence,idContrat,idFacture) {
			Factures.download({
				idAgence : idAgence,
				idContrat:idContrat,
				idFacture:idFacture,
			}, function(result) {
		          
                var file = result.response;

                var isChrome = !!window.chrome && !!window.chrome.webstore;
                var isIE = /*@cc_on!@*/false || !!document.documentMode;
                var isEdge = !isIE && !!window.StyleMedia;


                if (isChrome){
                    var url = window.URL || window.webkitURL;

                    var downloadLink = angular.element('<a></a>');
                    downloadLink.attr('href',url.createObjectURL(file));
                    downloadLink.attr('target','_self');
                    downloadLink.attr('download', 'image.jpg');
                    downloadLink[0].click();
                }
                else if(isEdge || isIE){
                    window.navigator.msSaveOrOpenBlob(file,'image.jpg');

                }
                else {
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }

			});
		}
        

    


    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('DocumentsContratController', DocumentsContratController);

    DocumentsContratController.$inject = ['$stateParams', 'entity'];

    function DocumentsContratController($stateParams, entity) {
        var vm = this;

        vm.idContrat = $stateParams.id;
        vm.contrat = entity;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('DevisContrat', DevisContrat);

    DevisContrat.$inject = ['$http', 'DateUtils'];

    function DevisContrat($http, DateUtils) {
        return {
            query: query,
            get: get,
            save: save,
            transform: transform,
            downloadPdf: downloadPdf
        };

        function query(contractId) {
            return $http.get('api/contrats/' + contractId + '/devis').then(function(response) {
                angular.forEach(response.data || [], normalizeQuote);
                return response.data || [];
            });
        }

        function get(contractId, devisId) {
            return $http.get('api/contrats/' + contractId + '/devis/' + devisId).then(function(response) {
                return normalizeQuote(response.data);
            });
        }

        function save(contractId, devis) {
            return $http.post('api/contrats/' + contractId + '/devis', serializeQuote(devis)).then(function(response) {
                return normalizeQuote(response.data);
            });
        }

        function transform(contractId, devisId) {
            return $http.post('api/contrats/' + contractId + '/devis/' + devisId + '/transform').then(function(response) {
                return normalizeQuote(response.data);
            });
        }

        function downloadPdf(contractId, devisId) {
            return $http({
                url: 'api/contrats/' + contractId + '/devis/' + devisId + '/pdf',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(response) {
                return {
                    response: new Blob([response.data], {
                        type: response.headers('Content-Type') || 'application/pdf'
                    }),
                    fileName: extractFileName(response.headers('Content-Disposition')) || ('devis-' + devisId + '.pdf')
                };
            });
        }

        function normalizeQuote(quote) {
            if (!quote) {
                return quote;
            }
            quote.dateDevis = DateUtils.convertLocalDateFromServer(quote.dateDevis);
            quote.validUntil = DateUtils.convertLocalDateFromServer(quote.validUntil);
            quote.pdfGeneratedDate = DateUtils.convertDateTimeFromServer(quote.pdfGeneratedDate);
            quote.transformedDate = DateUtils.convertDateTimeFromServer(quote.transformedDate);
            quote.acceptedDate = DateUtils.convertDateTimeFromServer(quote.acceptedDate);
            quote.createdDate = DateUtils.convertDateTimeFromServer(quote.createdDate);
            quote.lastModifiedDate = DateUtils.convertDateTimeFromServer(quote.lastModifiedDate);
            quote.lignes = quote.lignes || [];
            quote.remisesCommerciales = quote.remisesCommerciales || [];
            return quote;
        }

        function serializeQuote(devis) {
            var payload = angular.copy(devis || {});
            payload.dateDevis = DateUtils.convertLocalDateToServer(payload.dateDevis);
            payload.validUntil = DateUtils.convertLocalDateToServer(payload.validUntil);
            angular.forEach(payload.lignes || [], function(line) {
                delete line.$$hashKey;
            });
            angular.forEach(payload.remisesCommerciales || [], function(discount) {
                delete discount.$$hashKey;
            });
            return payload;
        }

        function extractFileName(contentDisposition) {
            if (!contentDisposition) {
                return null;
            }
            var match = /filename=\"([^\"]+)\"/i.exec(contentDisposition);
            return match && match[1] ? match[1] : null;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('DevisDialogController', DevisDialogController);

    DevisDialogController.$inject = ['$uibModalInstance', '$translate', 'contract', 'devisId', 'readOnly', 'mode', 'DevisContrat', 'ServiceVendu', 'TypeRemisecommerciale', 'AlertService'];

    function DevisDialogController($uibModalInstance, $translate, contract, devisId, readOnly, mode, DevisContrat, ServiceVendu, TypeRemisecommerciale, AlertService) {
        var vm = this;

        vm.contract = contract;
        vm.mode = mode || (readOnly ? 'view' : 'edit');
        vm.readOnly = readOnly;
        vm.isSaving = false;
        vm.serviceVendus = [];
        vm.serviceById = {};
        vm.discountServices = [];
        vm.typeRemisecommerciales = [];
        vm.typeRemiseById = {};
        vm.availableStates = [
            { value: 'DRAFT', labelKey: 'wamasysApp.contrat.quote.status.DRAFT' },
            { value: 'SENT', labelKey: 'wamasysApp.contrat.quote.status.SENT' },
            { value: 'ACCEPTED', labelKey: 'wamasysApp.contrat.quote.status.ACCEPTED' },
            { value: 'REFUSED', labelKey: 'wamasysApp.contrat.quote.status.REFUSED' },
            { value: 'CANCELLED', labelKey: 'wamasysApp.contrat.quote.status.CANCELLED' }
        ];
        vm.etatsDevis = [];
        vm.devis = buildDefaultQuote();
        vm.datePickerOpenStatus = {
            dateDevis: false,
            validUntil: false
        };
        vm.lineTotalHt = 0;
        vm.lineTotalTva = 0;
        vm.lineTotalTtc = 0;
        vm.discountTotalHt = 0;
        vm.discountTotalTva = 0;
        vm.discountTotalTtc = 0;

        vm.addLine = addLine;
        vm.removeLine = removeLine;
        vm.addDiscount = addDiscount;
        vm.removeDiscount = removeDiscount;
        vm.onServiceChange = onServiceChange;
        vm.onDiscountServiceChange = onDiscountServiceChange;
        vm.onDiscountTypeChange = onDiscountTypeChange;
        vm.recalculateLine = recalculateLine;
        vm.recalculateDiscount = recalculateDiscount;
        vm.recalculateTotals = recalculateTotals;
        vm.resolveServiceLabel = resolveServiceLabel;
        vm.resolveDiscountTypeLabel = resolveDiscountTypeLabel;
        vm.serviceLabel = serviceLabel;
        vm.statusLabelKey = statusLabelKey;
        vm.dialogTitleKey = dialogTitleKey;
        vm.saveButtonLabelKey = saveButtonLabelKey;
        vm.clear = clear;
        vm.save = save;
        vm.openCalendar = openCalendar;
        vm.canEditContent = canEditContent;
        vm.canChangeState = canChangeState;

        refreshStateOptions();
        loadServices();
        loadDiscountTypes();
        if (devisId) {
            loadQuote();
        } else {
            recalculateTotals();
        }

        function loadServices() {
            vm.serviceVendus = ServiceVendu.query({ offset: 0, size: 1000 });
            if (vm.serviceVendus.$promise) {
                vm.serviceVendus.$promise.then(function(result) {
                    vm.serviceVendus = result || [];
                    angular.forEach(vm.serviceVendus, function(service) {
                        vm.serviceById[service.id] = service;
                    });
                    updateDiscountServices();
                    recalculateTotals();
                });
            }
        }

        function loadDiscountTypes() {
            vm.typeRemisecommerciales = TypeRemisecommerciale.query({ page: 0, size: 1000, sort: 'libelle,asc' });
            if (vm.typeRemisecommerciales.$promise) {
                vm.typeRemisecommerciales.$promise.then(function(result) {
                    vm.typeRemisecommerciales = result || [];
                    angular.forEach(vm.typeRemisecommerciales, function(typeRemisecommerciale) {
                        vm.typeRemiseById[typeRemisecommerciale.id] = typeRemisecommerciale;
                    });
                    recalculateTotals();
                });
            }
        }

        function loadQuote() {
            DevisContrat.get(contract.id, devisId).then(function(result) {
                vm.devis = result;
                if (vm.mode === 'edit' && vm.devis.etat !== 'DRAFT') {
                    vm.mode = 'status';
                    refreshStateOptions();
                }
                if (!vm.devis.lignes || !vm.devis.lignes.length) {
                    vm.devis.lignes = [buildEmptyLine()];
                }
                vm.devis.remisesCommerciales = vm.devis.remisesCommerciales || [];
                updateDiscountServices();
                recalculateTotals();
            }, function(error) {
                AlertService.error(resolveErrorMessage(error, $translate.instant('wamasysApp.contrat.quote.technicalErrorSingle')));
                $uibModalInstance.dismiss('error');
            });
        }

        function buildDefaultQuote() {
            var today = new Date();
            var validUntil = new Date(today.getTime());
            validUntil.setDate(validUntil.getDate() + 30);
            return {
                dateDevis: today,
                validUntil: validUntil,
                etat: 'DRAFT',
                commentaireInterne: null,
                lignes: [buildEmptyLine()],
                remisesCommerciales: []
            };
        }

        function buildEmptyLine() {
            return {
                quantite: 1,
                prixUnitaireHt: 0,
                tauxTva: 0,
                montantHt: 0,
                montantTva: 0,
                montantTtc: 0
            };
        }

        function buildEmptyDiscount() {
            return {
                montantTtc: 0,
                montantHt: 0,
                montantTva: 0,
                tauxTva: 0
            };
        }

        function refreshStateOptions() {
            vm.etatsDevis = vm.availableStates.filter(function(state) {
                return vm.mode !== 'status' || state.value !== 'DRAFT';
            });
        }

        function canEditContent() {
            return !vm.readOnly && vm.mode === 'edit';
        }

        function canChangeState() {
            return !vm.readOnly;
        }

        function dialogTitleKey() {
            if (vm.readOnly) {
                return 'wamasysApp.contrat.quote.viewTitle';
            }
            if (!vm.devis.id) {
                return 'wamasysApp.contrat.quote.createTitle';
            }
            return vm.mode === 'status'
                ? 'wamasysApp.contrat.quote.changeStateTitle'
                : 'wamasysApp.contrat.quote.editTitle';
        }

        function saveButtonLabelKey() {
            return vm.mode === 'status'
                ? 'wamasysApp.contrat.quote.updateState'
                : 'wamasysApp.contrat.quote.save';
        }

        function addLine() {
            if (!canEditContent()) {
                return;
            }
            vm.devis.lignes.push(buildEmptyLine());
            updateDiscountServices();
            recalculateTotals();
        }

        function removeLine(index) {
            if (!canEditContent()) {
                return;
            }
            vm.devis.lignes.splice(index, 1);
            if (!vm.devis.lignes.length) {
                vm.devis.lignes.push(buildEmptyLine());
            }
            updateDiscountServices();
            recalculateTotals();
        }

        function addDiscount() {
            if (!canEditContent()) {
                return;
            }
            vm.devis.remisesCommerciales = vm.devis.remisesCommerciales || [];
            vm.devis.remisesCommerciales.push(buildEmptyDiscount());
            recalculateTotals();
        }

        function removeDiscount(index) {
            if (!canEditContent()) {
                return;
            }
            vm.devis.remisesCommerciales.splice(index, 1);
            recalculateTotals();
        }

        function onServiceChange(line) {
            if (!canEditContent()) {
                return;
            }
            var service = vm.serviceById[line.serviceVenduId];
            if (!service) {
                return;
            }
            line.serviceVenduLabel = serviceLabel(service);
            line.libelle = serviceLabel(service);
            line.prixUnitaireHt = resolveServicePrice(service);
            line.tauxTva = resolveServiceTaxRate(service);
            line.amountPerInstallment = toNullableNumber(service.amountPerInstallment);
            line.totalCredit = toNullableNumber(service.totalCredit);
            updateDiscountServices();
            recalculateLine(line);
        }

        function onDiscountServiceChange(discount) {
            if (!canEditContent()) {
                return;
            }
            discount.tauxTva = resolveTaxRateByServiceId(discount.serviceVenduId);
            recalculateDiscount(discount);
        }

        function onDiscountTypeChange(discount) {
            var typeRemisecommerciale = vm.typeRemiseById[discount.typeRemisecommercialeId];
            if (!typeRemisecommerciale) {
                return;
            }
            discount.libelle = typeRemisecommerciale.libelle;
            recalculateTotals();
        }

        function recalculateLine(line) {
            line.quantite = positiveOrDefault(line.quantite, 1);
            line.prixUnitaireHt = toNumber(line.prixUnitaireHt);
            line.tauxTva = toNumber(line.tauxTva);
            line.montantHt = round2(line.quantite * line.prixUnitaireHt);
            line.montantTva = round2(line.montantHt * line.tauxTva / 100);
            line.montantTtc = round2(line.montantHt + line.montantTva);
            recalculateTotals();
        }

        function recalculateDiscount(discount) {
            discount.montantTtc = positiveOrZero(discount.montantTtc);
            discount.tauxTva = resolveTaxRateByServiceId(discount.serviceVenduId);
            discount.montantHt = calculateAmountExclTax(discount.montantTtc, discount.tauxTva);
            discount.montantTva = round2(discount.montantTtc - discount.montantHt);
            recalculateTotals();
        }

        function recalculateTotals() {
            var totalHt = 0;
            var totalTva = 0;
            var totalTtc = 0;
            var discountHt = 0;
            var discountTva = 0;
            var discountTtc = 0;

            updateDiscountServices();

            angular.forEach(vm.devis.lignes || [], function(line, index) {
                line.displayOrder = index;
                line.quantite = positiveOrDefault(line.quantite, 1);
                line.prixUnitaireHt = toNumber(line.prixUnitaireHt);
                line.tauxTva = toNumber(line.tauxTva);
                line.montantHt = round2(line.quantite * line.prixUnitaireHt);
                line.montantTva = round2(line.montantHt * line.tauxTva / 100);
                line.montantTtc = round2(line.montantHt + line.montantTva);
                if (!line.serviceVenduLabel && line.serviceVenduId && vm.serviceById[line.serviceVenduId]) {
                    line.serviceVenduLabel = serviceLabel(vm.serviceById[line.serviceVenduId]);
                }
                totalHt += line.montantHt;
                totalTva += line.montantTva;
                totalTtc += line.montantTtc;
            });

            angular.forEach(vm.devis.remisesCommerciales || [], function(discount, index) {
                discount.displayOrder = index;
                discount.montantTtc = positiveOrZero(discount.montantTtc);
                discount.tauxTva = resolveTaxRateByServiceId(discount.serviceVenduId);
                discount.montantHt = calculateAmountExclTax(discount.montantTtc, discount.tauxTva);
                discount.montantTva = round2(discount.montantTtc - discount.montantHt);
                discount.serviceVenduLabel = resolveDiscountServiceLabel(discount);
                discount.typeRemisecommercialeLabel = resolveDiscountTypeLabel(discount);
                if (!discount.libelle && discount.typeRemisecommercialeLabel) {
                    discount.libelle = discount.typeRemisecommercialeLabel;
                }
                discountHt += discount.montantHt;
                discountTva += discount.montantTva;
                discountTtc += discount.montantTtc;
            });

            vm.lineTotalHt = round2(totalHt);
            vm.lineTotalTva = round2(totalTva);
            vm.lineTotalTtc = round2(totalTtc);
            vm.discountTotalHt = round2(discountHt);
            vm.discountTotalTva = round2(discountTva);
            vm.discountTotalTtc = round2(discountTtc);
            vm.devis.totalHt = round2(totalHt - discountHt);
            vm.devis.totalTva = round2(totalTva - discountTva);
            vm.devis.totalTtc = round2(totalTtc - discountTtc);
        }

        function updateDiscountServices() {
            var uniqueServiceIds = {};
            vm.discountServices = [];
            angular.forEach(vm.devis.lignes || [], function(line) {
                if (!line || !line.serviceVenduId || uniqueServiceIds[line.serviceVenduId]) {
                    return;
                }
                uniqueServiceIds[line.serviceVenduId] = true;
                if (vm.serviceById[line.serviceVenduId]) {
                    vm.discountServices.push(vm.serviceById[line.serviceVenduId]);
                }
            });
        }

        function resolveServiceLabel(line) {
            if (!line) {
                return '';
            }
            if (line.serviceVenduLabel) {
                return line.serviceVenduLabel;
            }
            if (line.serviceVenduId && vm.serviceById[line.serviceVenduId]) {
                return serviceLabel(vm.serviceById[line.serviceVenduId]);
            }
            return '';
        }

        function resolveDiscountServiceLabel(discount) {
            if (!discount) {
                return '';
            }
            if (discount.serviceVenduLabel) {
                return discount.serviceVenduLabel;
            }
            if (discount.serviceVenduId && vm.serviceById[discount.serviceVenduId]) {
                return serviceLabel(vm.serviceById[discount.serviceVenduId]);
            }
            return '';
        }

        function resolveDiscountTypeLabel(discount) {
            if (!discount) {
                return '';
            }
            if (discount.typeRemisecommercialeLabel) {
                return discount.typeRemisecommercialeLabel;
            }
            if (discount.typeRemisecommercialeId && vm.typeRemiseById[discount.typeRemisecommercialeId]) {
                return vm.typeRemiseById[discount.typeRemisecommercialeId].libelle;
            }
            return discount.libelle || '';
        }

        function serviceLabel(service) {
            if (!service) {
                return '';
            }
            return service.clientLabel
                || service.libelle
                || $translate.instant('wamasysApp.contrat.quote.serviceFallback', { id: service.id });
        }

        function statusLabelKey(status) {
            return status ? 'wamasysApp.contrat.quote.status.' + status : '';
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            var invalidDiscount;

            if (!canChangeState()) {
                return;
            }

            vm.devis.lignes = (vm.devis.lignes || []).filter(function(line) {
                return !!line.serviceVenduId;
            });

            if (canEditContent() && !vm.devis.lignes.length) {
                vm.devis.lignes = [buildEmptyLine()];
                AlertService.error($translate.instant('wamasysApp.contrat.quote.lineRequired'));
                return;
            }

            invalidDiscount = (vm.devis.remisesCommerciales || []).some(function(discount) {
                var hasAnyValue = !!(discount.serviceVenduId || discount.typeRemisecommercialeId || positiveOrZero(discount.montantTtc) > 0);
                return hasAnyValue && !isValidDiscount(discount);
            });
            if (canEditContent() && invalidDiscount) {
                AlertService.error($translate.instant('wamasysApp.contrat.quote.discountInvalid'));
                return;
            }

            vm.devis.remisesCommerciales = (vm.devis.remisesCommerciales || []).filter(isValidDiscount);
            recalculateTotals();
            vm.isSaving = true;
            DevisContrat.save(contract.id, vm.devis).then(function(result) {
                vm.isSaving = false;
                $uibModalInstance.close(result);
            }, function(error) {
                vm.isSaving = false;
                AlertService.error(resolveErrorMessage(error, $translate.instant('wamasysApp.contrat.quote.technicalErrorSingle')));
            });
        }

        function openCalendar(dateField) {
            if (!canEditContent()) {
                return;
            }
            vm.datePickerOpenStatus[dateField] = true;
        }

        function isValidDiscount(discount) {
            return !!(discount
                && discount.serviceVenduId
                && discount.typeRemisecommercialeId
                && positiveOrZero(discount.montantTtc) > 0
                && isDiscountServiceAllowed(discount.serviceVenduId));
        }

        function isDiscountServiceAllowed(serviceVenduId) {
            return (vm.discountServices || []).some(function(service) {
                return service.id === serviceVenduId;
            });
        }

        function resolveServicePrice(service) {
            if (!service) {
                return 0;
            }
            if (service.unitPrice !== null && typeof service.unitPrice !== 'undefined') {
                return toNumber(service.unitPrice);
            }
            if (service.typePaiement === 'A_PAYER_AVEC_ECHELONNEMENT' && service.totalCredit !== null && typeof service.totalCredit !== 'undefined') {
                return toNumber(service.totalCredit);
            }
            if (service.amountPerInstallment !== null && typeof service.amountPerInstallment !== 'undefined') {
                return toNumber(service.amountPerInstallment);
            }
            return 0;
        }

        function resolveServiceTaxRate(service) {
            if (!service || !service.typeTax || service.typeTax.taxRate === null || typeof service.typeTax.taxRate === 'undefined') {
                return 0;
            }
            return toNumber(service.typeTax.taxRate);
        }

        function resolveTaxRateByServiceId(serviceVenduId) {
            if (!serviceVenduId || !vm.serviceById[serviceVenduId]) {
                return 0;
            }
            return resolveServiceTaxRate(vm.serviceById[serviceVenduId]);
        }

        function calculateAmountExclTax(amountInclTax, taxRate) {
            var ttc = positiveOrZero(amountInclTax);
            var rate = toNumber(taxRate);
            if (rate <= 0) {
                return round2(ttc);
            }
            return round2(ttc / (1 + rate / 100));
        }

        function round2(value) {
            var numericValue = Number(value || 0);
            return Math.round(numericValue * 100) / 100;
        }

        function positiveOrDefault(value, defaultValue) {
            var numericValue = Number(value);
            return isNaN(numericValue) || numericValue <= 0 ? defaultValue : numericValue;
        }

        function positiveOrZero(value) {
            var numericValue = Number(value);
            return isNaN(numericValue) || numericValue < 0 ? 0 : numericValue;
        }

        function toNumber(value) {
            var numericValue = Number(value);
            return isNaN(numericValue) ? 0 : numericValue;
        }

        function toNullableNumber(value) {
            if (value === null || typeof value === 'undefined' || value === '') {
                return null;
            }
            return toNumber(value);
        }

        function resolveErrorMessage(error, defaultMessage) {
            return error && error.data && error.data.message ? error.data.message : defaultMessage;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('DevisContratController', DevisContratController);

    DevisContratController.$inject = ['$stateParams', '$uibModal', '$window', '$translate', 'entity', 'DevisContrat', 'AlertService', 'Principal'];

    function DevisContratController($stateParams, $uibModal, $window, $translate, entity, DevisContrat, AlertService, Principal) {
        var vm = this;

        vm.contrat = entity;
        vm.idContrat = $stateParams.id;
        vm.canEdit = false;
        vm.devisList = [];

        vm.load = load;
        vm.openCreate = openCreate;
        vm.openView = openView;
        vm.openEdit = openEdit;
        vm.downloadPdf = downloadPdf;
        vm.transform = transform;
        vm.statusLabelKey = statusLabelKey;
        vm.canEditQuote = canEditQuote;
        vm.canTransform = canTransform;
        vm.canDownloadPdf = canDownloadPdf;
        vm.editActionLabelKey = editActionLabelKey;
        vm.isContractClosed = isContractClosed;

        Principal.identity().then(function(account) {
            if (!account) {
                return;
            }
            vm.canEdit = account.authorities.indexOf('ROLE_DATA_OPERATOR') !== -1
                || account.authorities.indexOf('ROLE_AREA_MANAGEMENT') !== -1
                || account.authorities.indexOf('ROLE_ADMIN') !== -1;
        });

        load();

        function load() {
            DevisContrat.query(vm.idContrat).then(function(result) {
                vm.devisList = result;
            }, handleError);
        }

        function openCreate() {
            if (!vm.canEdit || isContractClosed()) {
                return;
            }
            openDialog(null, 'edit');
        }

        function openView(devis) {
            if (!devis || !devis.id) {
                return;
            }
            openDialog(devis.id, 'view');
        }

        function openEdit(devis) {
            if (!canEditQuote(devis)) {
                return;
            }
            openDialog(devis.id, devis.etat === 'DRAFT' ? 'edit' : 'status');
        }

        function openDialog(devisId, mode) {
            $uibModal.open({
                templateUrl: 'app/business/contrat/devis-dialog.html',
                controller: 'DevisDialogController',
                controllerAs: 'vm',
                size: 'lg',
                windowClass: 'devis-modal-xl',
                resolve: {
                    contract: function() {
                        return vm.contrat;
                    },
                    devisId: function() {
                        return devisId;
                    },
                    readOnly: function() {
                        return mode === 'view';
                    },
                    mode: function() {
                        return mode;
                    }
                }
            }).result.then(function() {
                load();
            });
        }

        function downloadPdf(devis) {
            if (!canDownloadPdf(devis)) {
                return;
            }
            DevisContrat.downloadPdf(vm.idContrat, devis.id).then(function(result) {
                var defaultFileName = $translate.instant('wamasysApp.contrat.quote.defaultPdfFileName');
                var fileName = result.fileName || ((devis.referenceDevis || defaultFileName) + '.pdf');
                if ($window.navigator.msSaveOrOpenBlob) {
                    $window.navigator.msSaveOrOpenBlob(result.response, fileName);
                    return;
                }
                var url = ($window.URL || $window.webkitURL).createObjectURL(result.response);
                var link = angular.element('<a/>');
                link.attr('href', url);
                link.attr('download', fileName);
                angular.element(document.body).append(link);
                link[0].click();
                link.remove();
                ($window.URL || $window.webkitURL).revokeObjectURL(url);
            }, handleError);
        }

        function transform(devis) {
            if (!canTransform(devis)) {
                return;
            }
            if (!$window.confirm($translate.instant('wamasysApp.contrat.quote.confirmTransform'))) {
                return;
            }
            DevisContrat.transform(vm.idContrat, devis.id).then(function() {
                AlertService.success($translate.instant('wamasysApp.contrat.quote.transformSuccess'));
                load();
            }, handleError);
        }

        function statusLabelKey(status) {
            return status ? 'wamasysApp.contrat.quote.status.' + status : '';
        }

        function canEditQuote(devis) {
            return vm.canEdit
                && !isContractClosed()
                && devis
                && devis.etat !== 'TRANSFORMED';
        }

        function canTransform(devis) {
            return vm.canEdit
                && !isContractClosed()
                && devis
                && devis.id
                && devis.etat !== 'TRANSFORMED'
                && devis.etat !== 'REFUSED'
                && devis.etat !== 'CANCELLED';
        }

        function canDownloadPdf(devis) {
            return !!(devis
                && devis.id
                && devis.etat !== 'DRAFT'
                && devis.referenceDevis
                && devis.pdfPath);
        }

        function editActionLabelKey(devis) {
            return devis && devis.etat === 'DRAFT'
                ? 'wamasysApp.contrat.quote.editAction'
                : 'wamasysApp.contrat.quote.changeStateAction';
        }

        function isContractClosed() {
            return vm.contrat && vm.contrat.etat === 'CLOSED';
        }

        function handleError(error) {
            AlertService.error(resolveErrorMessage(error, $translate.instant('wamasysApp.contrat.quote.technicalError')));
        }

        function resolveErrorMessage(error, defaultMessage) {
            return error && error.data && error.data.message ? error.data.message : defaultMessage;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('DataAnalyseContratController', DataAnalyseContratController);

    DataAnalyseContratController.$inject = ['$scope', '$state', '$filter','entity', 'ParseLinks', 'AlertService','$sce'];

    function DataAnalyseContratController ($scope, $state, $filter, entity, ParseLinks, AlertService, $sce) {
        var vm = this;
        vm.dataLoaded = false;
     //   vm.referenceContrat = entity.referenceContrat;

        entity.$promise.then(function(data) {
            vm.referenceContrat = data.referenceContrat;
        	vm.dataLoaded = true; // Mettre à jour la variable pour indiquer que les données sont chargées
		});

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('contrat', {
            parent: 'entity',
            url: '/contrat?page&sort&searchQuery&etat&compteurFerme&portefeuilleContrat&contractType&contractProfil&serviceVendu&startDate&endDate&onlinePaymentActive&onlinePaymentQuery&onlinePaymentType&hasEmail&hasPhone&agenceId&currentBalanceSigne&currentBalanceValue&tooMuchPaid&filterBalanceWithService&minAmountPaid&toDatePayment&minAmountBilled&toDateBilling&maxWaterConsumption&toDateWaterConsumption',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.contrat.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/contrat/contrats.html',
                    controller: 'ContratController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contrat');
                    $translatePartialLoader.addPart('etatContrat');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('ligneContrat');
                    return $translate.refresh();
                }]
            }
        })
        .state('contrat-detail', {
            parent: 'entity',
            url: '/contrat/{id}',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY','ROLE_COLLECTOR'],
                pageTitle: 'wamasysApp.contrat.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/contrat/contrat-detail.html',
	                controller: 'ContratDetailController',
	                controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contrat');
                    $translatePartialLoader.addPart('etatContrat');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('etatMeter');
                    $translatePartialLoader.addPart('collectionListe');
                    $translatePartialLoader.addPart('ligneContrat');
                    $translatePartialLoader.addPart('serviceVendu');
                    $translatePartialLoader.addPart('redmine');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Contrat', function($stateParams, Contrat) {
                    return Contrat.get({id : $stateParams.id});
                }]
            }
        })
        
        .state('contrat-detail.information', {
            url: '/information',
            views: {'panneau@content': {
	                templateUrl: 'app/business/contrat/information-contrat.html',	
	                controller: 'InformationContratController',
	                controllerAs: 'vm'
	            }
            }
        })
        
        
		.state('contrat-detail.services',{
			url : '/services',
			views : {
				'panneau@content' : {
					templateUrl : 'app/business/contrat/services-contrat.html',

					controller : 'ServicesContratController',
					controllerAs : 'vm'
					}
				}
			})
		.state('contrat-detail.devis',{
			url : '/devis',
			views : {
				'panneau@content' : {
					templateUrl : 'app/business/contrat/devis-contrat.html',
					controller : 'DevisContratController',
					controllerAs : 'vm'
					}
				}
			})
		.state('contrat-detail.paiements',{
			url : '/paiements',
			views : {
				'panneau@content' : {
					templateUrl : 'app/business/contrat/paiements-contrat.html',

					controller : 'PaiementsContratController',
					controllerAs : 'vm'
					}
				}
			})
			
		.state('contrat-detail.documents',{
				abstract: true,
				url : '/documents',
				views : {
					'panneau@content' : {
						templateUrl : 'app/business/contrat/documents-contrat.html',
						controller : 'DocumentsContratController',
						controllerAs : 'vm'
						}
					}
			})
		.state('contrat-detail.documents.autres',{
				url : '/autres',
				views : {
					'documentsTab@contrat-detail.documents' : {
						templateUrl : 'app/business/contrat/contract-documents.html',
						controller : 'ContractDocumentsController',
						controllerAs : 'vm'
						}
					}
			})
		.state('contrat-detail.documents.factures',{
				url : '/factures?page&sort',
	            params: {
	                page: {
	                    value: '1',
	                    squash: true
	                },
	                sort: {
	                    value: 'id,asc',
	                    squash: true
	                }
	            },
				views : {
					'documentsTab@contrat-detail.documents' : {
						templateUrl : 'app/business/contrat/factures-contrat.html',

						controller : 'FacturesContratController',
						controllerAs : 'vm'
						}
					},
		            resolve: {
		                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
		                    return {
		                        page: PaginationUtil.parsePage($stateParams.page),
		                        sort: $stateParams.sort,
		                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
		                        ascending: PaginationUtil.parseAscending($stateParams.sort),
		                        search: $stateParams.search
		                    };
		                }],
		            }
			})
		.state('contrat-detail.documents.receipts',{
				url : '/receipts?page&sort',
	            params: {
	                page: {
	                    value: '1',
	                    squash: true
	                },
	                sort: {
	                    value: 'id,asc',
	                    squash: true
	                }
	            },
				views : {
					'documentsTab@contrat-detail.documents' : {
						templateUrl : 'app/business/contrat/receipts-contrat.html',

						controller : 'ReceiptsContratController',
						controllerAs : 'vm'
						}
					},
		            resolve: {
		                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
		                    return {
		                        page: PaginationUtil.parsePage($stateParams.page),
		                        sort: $stateParams.sort,
		                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
		                        ascending: PaginationUtil.parseAscending($stateParams.sort),
		                        search: $stateParams.search
		                    };
		                }],
		            }
			})
			
			
        .state('contrat-detail.information.historiqueconsoeau', {
            url: '/histo-consommation-eau?page&sort',
            params: {
	            page: {
	                value: '1',
	                squash: true
	            },
	            sort: {
	                value: 'id,asc',
	                squash: true
	            }
            },
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY','ROLE_COLLECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            	var page = $stateParams.page;
            	var sort = $stateParams.sort;
                $uibModal.open({
                    templateUrl: 'app/business/contrat/historiqueconso-contrat-dialog.html',
                    controller: 'HistoConsoContratController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
//                        entity: ['Contrat', function(Contrat) {
//                            return Contrat.get({id : $stateParams.id});
//                        }]
//                    	$transition$: () => $transition$ },
		                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//		                	if(! $stateParams.page){
//	                    		$stateParams.page = 1;
//	                    	}
//	                    	if(! $stateParams.sort){
//	                    		$stateParams.sort = 'id,asc';
//	                    	}
	                    	
		                    return {
		                        page: PaginationUtil.parsePage(page),
		                        sort: sort,
		                        predicate: PaginationUtil.parsePredicate(sort),
		                        ascending: PaginationUtil.parseAscending(sort)
		                    };
		                }]
		            
                    }
                }).result.then(function(resolvedResponse) {
                	if(resolvedResponse){
                        $state.transitionTo($state.$current, resolvedResponse);
                	}else{
                		$state.go('contrat-detail.information',{id:$stateParams.id},{reload:true});
                	}
                }, function() {
                    $state.go('^');
                });
            }]
        })
        

			.state('contrat-detail.historiquepaiements',{
				url : '/historiquepaiements?page&sort&ligneContrat&startDate&endDate&displayMode',
	            params: {
	                page: {
	                    value: '1',
	                    squash: true
	                },
 	                sort: {
 	                    value: 'id,asc',
 	                    squash: true
 	                },
 	                displayMode: {
  	                    value: 'BILLING',
 	                    squash: true
 	                }
 	            },
				views : {
					'panneau@content' : {
						templateUrl : 'app/business/contrat/historiquepaiements-contrat.html',

						controller : 'HistoPaiementsContratController',
						controllerAs : 'vm'
						}
					},
		            resolve: {
		                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
		                    return {
		                        page: PaginationUtil.parsePage($stateParams.page),
		                        sort: $stateParams.sort,
		                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
		                        ascending: PaginationUtil.parseAscending($stateParams.sort),
		                        search: $stateParams.search
		                    };
		                }],
		            }
					
			})
			
			
			.state('contrat-detail.historiquepaiements.paymentcorrection',{
				url : '/historiquepaiements/{idPayment}/addPaymentCorrection',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/contrat-addpaymentcorrection-dialog.html',
                    controller: 'ContratAddPaymentCorrectionController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity:  ['CollectionListe', function(CollectionListe) {
                        	return  CollectionListe.getPaymentReceived({id:$stateParams.idPayment});
                        }]
        
                    }
                }).result.then(function() {
                    $state.go('contrat-detail.historiquepaiements',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('^');
                });
            }]
        })
				
			.state('contrat-detail.dataanalyse',{
				url : '/dataanalyse',
				views : {
					'panneau@content' : {
						templateUrl : 'app/business/contrat/dataanalyse-contrat.html',

						controller : 'DataAnalyseContratController',
						controllerAs : 'vm'
						}
					}
					
			})
			
			.state('contrat-detail.tickets',{
				url : '/tickets/{ref}',
				views : {
					'panneau@content' : {
						templateUrl : 'app/business/contrat/tickets-contrat.html',
						controller : 'TicketsContratController',
						controllerAs : 'vm'
						}
					}
					
			})
	        .state('contrat-detail.tickets.new', {
	            parent: 'contrat-detail.tickets',
	            url: '/new',
	            data: {
//	                authorities: ['ROLE_DATA_OPERATOR']
	            },
	            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
	                $uibModal.open({
	                    templateUrl: 'app/business/contrat/contrat-createticket-dialog.controller.html',
	                    controller: 'ContratCreateTicketController',
	                    controllerAs: 'vm',
	                    backdrop: 'static',
	                    size: 'lg',
	                    resolve: {
	                        entity: function () {
	                            return {
	                            	id: null
	                            };
	                        }
	                    }
	                }).result.then(function(result) {  
	                	 $state.go('^',{},{reload:true});
	                }, function() {
	                    $state.go('^');
	                });
	            }]
	        })
			
        .state('contrat.new', {
            parent: 'contrat',
            url: '/new',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/contrat-create-dialog.html',
                    controller: 'ContratCreateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomPersonne: null,
                                referenceContrat: null,
                                indexAdresse: null,
                                adresse: null,
                                phone: null,
                                email: null,
                                nombreFamille: null,
                                nombrePersonne: null,
                                commentaire: null,
                                dateCloture: null,
                                etat: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function(result) {                	
                    $state.go('contrat-detail.services',{id:result.id});
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('contrat-detail.services.newservice', {
            url: '/newservice',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/contrat.services-dialog.html',
                    controller: 'ContratServicesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity:  ['Contrat', function(Contrat) {
                        	return {
                            	contrat : {id:$stateParams.id}
                        		};
                        }]
                    }
                }).result.then(function(result) {                	
                    $state.go('contrat-detail.services',{id:result.contrat.id },{reload:true});
                }, function() { 	
                    $state.go('^');
                });
            }]
        })
        
        .state('contrat-detail.services.editService', {
            url: '/editService/{idLigneContrat}',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/contrat.services-dialog.html',
                    controller: 'ContratServicesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: { 
                        entity: ['LigneContrat', function(LigneContrat) {
                            return LigneContrat.get({id : $stateParams.idLigneContrat});
                        }]
                    }
                }).result.then(function(result) {                	
                    $state.go('contrat-detail.services',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('contrat-detail.services');
                });
            }]
        })
           .state('contrat-detail.services.delete', {
            url: '/{idLignecontrat}/delete',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/service-contrat-delete-dialog.html',
                    controller: 'ServiceContratDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LigneContrat', function(LigneContrat) {
                            return LigneContrat.get({id : $stateParams.idLignecontrat});
                        }]
                    }
                }).result.then(function(result) {
                    $state.go('contrat-detail.services',null,{reload:true});
                }, function() {
                    $state.go('^');
                });
            }]
        })

        .state('contrat.delete', {
            parent: 'contrat',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/contrat-delete-dialog.html',
                    controller: 'ContratDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Contrat', function(Contrat) {
                            return Contrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('contrat', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contrat-detail.documents.autres.print', {
        	url: '/print',
        	data: {
        		authorities: ['ROLE_AREA_MANAGEMENT','ROLE_DATA_OPERATOR']
        	},
        	onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        		$uibModal.open({
        			templateUrl: 'app/business/contrat/print-contrat-dialog.html',
        			controller: 'PrintContratDialogController',
        			controllerAs: 'vm',
        			size: 'md',
        			resolve: {
        				entity: {
        					id:$stateParams.id
        				}
        			}
        		}).result.then(function() {
                    $state.go('contrat-detail.documents.autres',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('^');
                });
        	}]
        })
        .state('contrat-detail.documents.autres.generatePaymentRecoveryNotice', {
        	url: '/generate-payment-recovery-notice',
        	data: {
        		authorities: ['ROLE_AREA_MANAGEMENT','ROLE_DATA_OPERATOR']
        	},
        	onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        		$uibModal.open({
        			templateUrl: 'app/business/contrat/generate-payment-recoverynotice-dialog.html',
        			controller: 'GeneratePaymentRecoveryNoticeController',
        			controllerAs: 'vm',
        			size: 'md',
        			resolve: {
        				entity: {
        					id:$stateParams.id
        				}
        			}
        		}).result.then(function() {
                    $state.go('contrat-detail.documents.autres',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('^');
                });
        	}]
        })
        .state('contrat-detail.information.cloturer', {
            url: '/cloturer',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/cloturation-contrat-dialog.html',
                    controller: 'CloturationContratDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: {
                        	id:$stateParams.id
                        }
                    }
                }).result.then(function() {
                    $state.go('contrat-detail.information',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contrat-detail.information.activer', {
            url: '/activer',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/activation-contrat-dialog.html',
                    controller: 'ActivationContratDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: {
                        	id:$stateParams.id
                        }
                    }
                }).result.then(function() {
                    $state.go('contrat-detail.information',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contrat-detail.information.historique-changement-compteur', {
            url: '/histo-changement-compteur',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY','ROLE_COLLECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/historique-changement-compteur-dialog.html',
                    controller: 'HistoriqueChangementCompteurDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['Contrat', function(Contrat) {
                            return Contrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('contrat-detail.information',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contrat-detail.information.add-water-correction', {
            url: '/add-water-correction',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/contrat-addwatercorrection-dialog.html',
                    controller: 'ContratAddWaterCorrectionController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['Contrat', function(Contrat) {
                            return Contrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('contrat-detail.information',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
        .state('contrat-detail.information.changercompteur', {
            url: '/changercompteur',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/changer-compteur-contrat-dialog.html',
                    controller: 'ChangerCompteurContratDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Contrat', function(Contrat) {
                            return Contrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function(result) {                	
                    $state.go('contrat-detail.information',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('contrat-detail.information');
                });
            }]
        })
        
        .state('contrat-detail.information.onlinePaymentCreate', {
            url: '/onlinepayment/new',
            data: {
                authorities: ['ROLE_DATA_OPERATOR', 'ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/contract-online-payment-dialog.html',
                    controller: 'ContractOnlinePaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Contrat', function(Contrat) {
                            return Contrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function(result) {                	
                    $state.go('contrat-detail.information',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('contrat-detail.information');
                });
            }]
        })
        .state('contrat-detail.information.onlinePaymentDelete', {
            url: '/onlinepayment/{idOnlinepayment}/delete',
            data: {
                authorities: ['ROLE_DATA_OPERATOR', 'ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/contract-online-payment-delete-dialog.html',
                    controller: 'ContractOnlinePaymentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Contrat', function(Contrat) {
                            return Contrat.getOnlinePayment({idOnlinePayment : $stateParams.idOnlinepayment});
                        }]
                    }
                }).result.then(function(result) {
                    $state.go('contrat-detail.information',null,{reload:true});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contrat.new-prospect', {
            parent: 'contrat',
            url: '/new-prospect',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/contrat-create-dialog.html',
                    controller: 'ContratCreateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomPersonne: null,
                                referenceContrat: null,
                                indexAdresse: null,
                                adresse: null,
                                phone: null,
                                email: null,
                                nombreFamille: null,
                                nombrePersonne: null,
                                commentaire: null,
                                dateCloture: null,
                                etat: 'PROSPECT',
                                isProspectCreation: true,
                                id: null
                            };
                        }
                    }
                }).result.then(function(result) {
                    $state.go('contrat-detail.services',{id:result.id});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contrat-detail.information.communicationSubscriptionCreate', {
            url: '/communication-subscription/new',
            data: {
                authorities: ['ROLE_DATA_OPERATOR', 'ROLE_AREA_MANAGEMENT', 'ROLE_AREA_CONFIGURATION', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/communication-subscription-dialog.html',
                    controller: 'CommunicationSubscriptionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                contratId: $stateParams.id,
                                optin: true
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('contrat-detail.information', {id: $stateParams.id}, {reload: true});
                }, function() {
                    $state.go('contrat-detail.information');
                });
            }]
        })
        .state('contrat-detail.information.communicationSubscriptionOptin', {
            url: '/communication-subscription/{idCommunicationSubscription}/optin',
            data: {
                authorities: ['ROLE_DATA_OPERATOR', 'ROLE_AREA_MANAGEMENT', 'ROLE_AREA_CONFIGURATION', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Contrat', function($stateParams, $state, $uibModal, Contrat) {
                var subscriptionsPromise = Contrat.getCommunicationSubscriptions({idContrat: $stateParams.id}).$promise;
                $uibModal.open({
                    templateUrl: 'app/business/contrat/communication-subscription-optin-dialog.html',
                    controller: 'CommunicationSubscriptionOptinDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return subscriptionsPromise.then(function(result) {
                                return result.find(function(subscription) {
                                    return String(subscription.id) === String($stateParams.idCommunicationSubscription);
                                }) || {
                                    id: $stateParams.idCommunicationSubscription,
                                    contratId: $stateParams.id
                                };
                            });
                        }
                    }
                }).result.then(function() {
                    $state.go('contrat-detail.information', null, {reload: true});
                }, function() {
                    $state.go('^');
                });
            }]
        })

        .state('contrat-detail.services.billing', {
            url: '/billing',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/billing-contract-dialog.html',
                    controller: 'BillingContractDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity:  ['Contrat', function(Contrat) {
                        	return {id : $stateParams.id};
                        }]
                    }
                }).result.then(function(result) {                	
                    $state.go('contrat-detail.services',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('contrat-detail.services');
                });
            }]
        })
        
        .state('contrat-detail.services.standby', {
            url: '/standby/{idLigneContrat}',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/contrat-standby-dialog.html',
                    controller: 'ContratStandbyController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity:  ['LigneContrat', function(LigneContrat) {
                        	return {id :  $stateParams.idLigneContrat};
                        }]
                    }
                }).result.then(function(result) {                	
                    $state.go('contrat-detail.services',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('contrat-detail.services');
                });
            }]
        })
        
        .state('contrat-detail.services.reopen', {
            url: '/reopen/{idLigneContrat}',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/contrat-reopen-dialog.html',
                    controller: 'ContratReopenController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity:  ['LigneContrat', function(LigneContrat) {
                        	return {id :  $stateParams.idLigneContrat};
                        }]
                    }
                }).result.then(function(result) {                	
                    $state.go('contrat-detail.services',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('contrat-detail.services');
                });
            }]
        })
        .state('contrat-detail.services.billOutstandingCredit', {
            url: '/bill-outstanding-credit/{idLigneContrat}',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/contrat-billoutstandingcredit-dialog.html',
                    controller: 'ContratBillOutstandingCreditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity:  ['LigneContrat', function(LigneContrat) {
                        	return {id :  $stateParams.idLigneContrat};
                        }]
                    }
                }).result.then(function(result) {                	
                    $state.go('contrat-detail.services',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('contrat-detail.services');
                });
            }]
        })
        
        
        .state('contrat-detail.services.paiementinitial', {
            url: '/paiementinitial/{idLigneContrat}',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/paiement-initial-dialog.html',
                    controller: 'PaiementInitialDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LigneContrat', function(LigneContrat) {
                            return LigneContrat.get({id : $stateParams.idLigneContrat});
                        }]
                    }
                }).result.then(function(result) {                	
                    $state.go('contrat-detail.services',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('contrat-detail.services');
                });
            }]
        })
        .state('contrat-detail.paiements.paiementagence', {
            url: '/services/{idContrat}',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/paiement-agence-dialog.html',
                    controller: 'PaiementAgenceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                    ,
                    resolve: {
                        entity: ['Contrat', function(Contrat) {
                            return Contrat.get({id : $stateParams.idContrat});
                        }]
                    }
                }).result.then(function(result) {      
                    $state.go('contrat-detail.paiements',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('contrat-detail.paiements');
                });
            }]
        })
        
        
        .state('contrat-detail.paiements.deletePaiement', {
            url: '/payments/{idPaymentReceived}/delete',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/paiement-agence-delete-dialog.html',
                    controller: 'PaymentReceivedDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: {
                        	id:$stateParams.idPaymentReceived
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('contrat-detail.services',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
        
        .state('contrat-detail.services.addBalanceTransfer', {
            url: '/addbalancetransfer?debitedLigneContratId',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },        
               onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/transfer-balance-dialog.html',
                    controller: 'TransferBalanceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: { 
                        entity: function () {
                            return {
                                amount: null,
                                ligneContrat: $stateParams.debitedLigneContratId ? {id: $stateParams.debitedLigneContratId} : null,
                                ligneContratCible: null,
                                commentaire: null,
                                contrat:{id:$stateParams.id} ,
                                id:null
                            };
                        }
                    }
                }).result.then(function(result) {                	
                    $state.go('contrat-detail.services',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('contrat-detail.services');
                });
            }]
        })
        .state('contrat-detail.services.ajoutPenaliteRemiseRegulContrat', {
            url: '/ajoutpenaliteremiseregul-contrat/{type}',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/impact-penalit-remise-regul-contrat-dialog.html',
                    controller: 'ImpactPenalitRemiseRegulContratDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                montantTtc: null,
                                id: null,
                                type: $stateParams.type,
                                commentaire: null,
                                label: null,
                                lignes: [],
                                contrat: {id: $stateParams.id}
                            };
                        }
                    }
                }).result.then(function(result) {
                    $state.go('contrat-detail.services',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('contrat-detail.services');
                });
            }]
        })
        .state('contrat-detail.services.ajoutPenaliteRemiseRegul', {
            url: '/ajoutpenaliteremiseregul/{type}/{idLigneContrat}',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/impact-penalit-remise-regul-dialog.html',
                    controller: 'ImpactPenalitRemiseRegulDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: { 
                        entity: function () {
                            return {
                                montant: null,
                                id:null,
                                type: $stateParams.type,
                                contrat:{id:$stateParams.id} ,
                                ligneContrat: {id:$stateParams.idLigneContrat}
                            };
                        }
                    }
                }).result.then(function(result) {                	
                    $state.go('contrat-detail.services',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('contrat-detail.services');
                });
            }]
        })
        .state('contrat-detail.services.deletePenaliteRemiseRegul', {
            url: '/penaliteremiseregul/{idPenaliteRemiseRegul}/delete',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/impact-penalit-remise-regul-delete-dialog.html',
                    controller: 'ImpactPenalitRemiseRegulDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ImpactPenalitRemiseRegul', function(ImpactPenalitRemiseRegul) {
                            return ImpactPenalitRemiseRegul.get({id : $stateParams.idPenaliteRemiseRegul});
                        }]
                    
                    }
                }).result.then(function() {
                    $state.go('contrat-detail.services',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contrat-detail.information.change-status', {
            url: '/change-status',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/contrat-change-status-dialog.html',
                    controller: 'ContratChangeStatusDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Contrat', function(Contrat) {
                            return Contrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('contrat-detail.information',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contrat-detail.information.add-note', {
            url: '/add-note',
            data: {
                authorities: ['ROLE_DATA_OPERATOR', 'ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/contrat-add-note-dialog.html',
                    controller: 'ContratAddNoteDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Contrat', function(Contrat) {
                            return Contrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('contrat-detail.information',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contrat-detail.information.contract-history', {
            url: '/contract-history',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY','ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/contrat/contrat-history-dialog.html',
                    controller: 'ContratHistoryDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['Contrat', function(Contrat) {
                            return Contrat.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('contrat-detail.information',{id:$stateParams.id},{reload:true});
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratServicesDialogController', ContratServicesDialogController);

    ContratServicesDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity','Contrat', 'ServiceVendu','LigneContrat'];

    function ContratServicesDialogController ($scope, $stateParams, $uibModalInstance, entity,  Contrat, ServiceVendu,LigneContrat) {
        var vm = this;
        vm.showservice = null;
        vm.serviceVendus = ServiceVendu.query({ offset: 0,size: 1000});
      
        vm.ligneContrat =  entity ;

        vm.hasBilling = false;
        if(entity && entity.$promise){
            entity.$promise.then(function(value) {
                vm.hasBilling = ( value.derniereLignePaiement !== null && (typeof  value.derniereLignePaiement != "undefined") );
            });	
        }

        
        vm.selectService = function() {
            vm.ligneContrat.libelle=vm.ligneContrat.serviceVendu.clientLabel;
            vm.ligneContrat.unitPrice=vm.ligneContrat.serviceVendu.unitPrice;
            vm.ligneContrat.amountPerInstallment=vm.ligneContrat.serviceVendu.amountPerInstallment;
            vm.ligneContrat.totalCredit=vm.ligneContrat.serviceVendu.totalCredit;
        };

        
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:contratServiceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
           
            LigneContrat.save(vm.ligneContrat, onSaveSuccess, onSaveError);
            
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateCloture = false;
        vm.datePickerOpenStatus.dateActivation = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('Contrat', Contrat);

    Contrat.$inject = ['$resource', 'DateUtils'];

    function Contrat ($resource, DateUtils) {
        var resourceUrl =  'api/contrats/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            
            
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateCloture = DateUtils.convertLocalDateFromServer(data.dateCloture);
                    data.dateActivation = DateUtils.convertLocalDateFromServer(data.dateActivation);
                    data.lastStatusChangeDate = DateUtils.convertDateTimeFromServer(data.lastStatusChangeDate);
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.dateCloture = DateUtils.convertLocalDateToServer(data.dateCloture);
                	clonedData.dateActivation = DateUtils.convertLocalDateToServer(data.dateActivation);
                    return angular.toJson(clonedData);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.dateCloture = DateUtils.convertLocalDateToServer(data.dateCloture);
                	clonedData.dateActivation = DateUtils.convertLocalDateToServer(data.dateActivation);
                    return angular.toJson(clonedData);
                }
            },
//            'delete': {
//                method: 'DELETE',
//                transformRequest: function (data) {
//                    return angular.toJson(data);
//                }
//            },
            'cloturer': {
                method: 'POST',
              	url :'api/contrats/cloturer',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'createCorrectionWaterConsumption': {
                method: 'POST',
              	url :'api/contrats/create-correction-water-consumption',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                 	clonedData.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                 	clonedData.dateDebut = DateUtils.convertDateTimeFromServer(data.dateDebut);
                 	clonedData.dateFin = DateUtils.convertDateTimeFromServer(data.dateFin);
                    return angular.toJson(clonedData);
                }
            },
            'activer': {
                method: 'POST',
              	url :'api/contrats/activer',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.dateActivation = DateUtils.convertLocalDateToServer(data.dateActivation);
                    return angular.toJson(clonedData);
                }
            },
            'changeStatus': {
                method: 'POST',
                url: 'api/contrats/change-status',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'addNote': {
                method: 'POST',
                url: 'api/contrats/add-note',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'getHistory': {
                method: 'GET',
                isArray: true,
                url: 'api/contrats/:id/history',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    angular.forEach(data, function(item) {
                        item.eventDate = DateUtils.convertDateTimeFromServer(item.eventDate);
                    });
                    return data;
                }
            },
            'downloadcsv': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/contrats/downloadcsv',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },
            'downloadServicecsv': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/contrats/downloadDetailServicecsv',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },
            

            'downloadDetailServiceNotClosedcsv': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/contrats/downloadDetailServiceNotClosedcsv',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },

            'downloadImpayeMobileMoney': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/contrats/downloadimpayemobilemoney',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },
            'downloadContractJson': {
                method: 'GET',
                headers: {
                    accept: 'application/json'
                },
                responseType: 'arraybuffer',
                url :'api/contrats/:id/downloadjson',
                transformResponse: function (data,headers) {
                    var filename = headers('FileName');
                    var contentType = headers('ContentType');
                    var jsonFile;
                    if (data) {
                        jsonFile = new Blob([data], {
                            type: contentType || 'application/json'
                        });
                    }
                    return {
                        response: jsonFile,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },
            'chatAssistant': {
                method: 'POST',
                url: 'api/contrats/:id/assistant/chat',
                transformRequest: function(data) {
                    return angular.toJson(data);
                }
            },
            'getAssistantUsage': {
                method: 'GET',
                url: 'api/contrats/:id/assistant/usage'
            },
            'recoverAssistantResponse': {
                method: 'GET',
                url: 'api/contrats/:id/assistant/recover'
            },
            'submitAssistantFeedback': {
                method: 'POST',
                url: 'api/contrats/:id/assistant/feedback',
                transformRequest: function(data) {
                    return angular.toJson(data);
                }
            },
            'executeAssistantActions': {
                method: 'POST',
                url: 'api/contrats/:id/assistant/execute-actions',
                transformRequest: function(data) {
                    return angular.toJson(data);
                }
            },
            'addOnlinePayment': {
                method: 'POST',
              	url :'api/contrats/add-online-payment',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                 	clonedData.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                 	clonedData.deletedDate = DateUtils.convertLocalDateToServer(data.deletedDate);
                    return angular.toJson(clonedData);
                }
            },
            'getOnlinePayment': {
                method: 'GET',
              	url :'api/contrats/online-payment/:idOnlinePayment',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
//                    data.dateCloture = DateUtils.convertLocalDateFromServer(data.dateCloture);
//                    data.dateActivation = DateUtils.convertLocalDateFromServer(data.dateActivation);
                    return data;
                }
            },
            'updateOnlinePayment': {
                method: 'PUT',
                url: 'api/contrats/online-payment/:idOnlinePayment',
                params: {
                    idOnlinePayment: '@id'
                },
                transformRequest: function(data) {
                    return angular.toJson(data);
                }
            },
	        'deleteOnlinePayment': {
		          method: 'DELETE',
	              url :'api/contrats/online-payment/:idOnlinePayment',
		          transformRequest: function (data) {
		              return angular.toJson(data);
		          }
		      },
            'getListOnlinePayment': {
                method: 'GET',
              	url :'api/contrats/:idContrat/online-payment',
             	isArray: true
            },
            'getOnlinePaymentHistory': {
                method: 'GET',
                url: 'api/contrats/online-payment/:idOnlinePayment/history',
                isArray: true,
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    angular.forEach(data, function(item) {
                        item.revisionDate = DateUtils.convertDateTimeFromServer(item.revisionDate);
                        item.deletedDate = DateUtils.convertDateTimeFromServer(item.deletedDate);
                        item.createdDate = DateUtils.convertDateTimeFromServer(item.createdDate);
                        item.lastModifiedDate = DateUtils.convertDateTimeFromServer(item.lastModifiedDate);
                    });
                    return data;
                }
            },
            'getCommunicationSubscriptions': {
                method: 'GET',
                url: 'api/communication-subscriptions/by-contrat/:idContrat',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    angular.forEach(data, function(subscription) {
                        subscription.date = DateUtils.convertDateTimeFromServer(subscription.date);
                    });
                    return data;
                }
            },
            'addCommunicationSubscription': {
                method: 'POST',
                url: 'api/communication-subscriptions',
                transformRequest: function (data) {
                    var clonedData = Object.assign({}, data);
                    clonedData.date = DateUtils.convertDateTimeFromServer(data.date);
                    return angular.toJson(clonedData);
                }
            },
            'updateCommunicationSubscription': {
                method: 'PUT',
                url: 'api/communication-subscriptions',
                transformRequest: function (data) {
                    var clonedData = Object.assign({}, data);
                    clonedData.date = DateUtils.convertDateTimeFromServer(data.date);
                    return angular.toJson(clonedData);
                }
            }
            
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('ContratSearch', ContratSearch);

    ContratSearch.$inject = ['$resource'];

    function ContratSearch($resource) {
        var resourceUrl =  'api/contrats/searchcontrats/';

        return $resource(resourceUrl, {}, {
            'query': { 
            	method: 'GET',
                isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratController', ContratController);

    ContratController.$inject = ['$q', '$scope', '$state', '$filter', 'Contrat', 'Principal', 'ParseLinks', '$timeout', 'AlertService', 'pagingParams', 'paginationConstants', 'PortefeuilleContrat', 'ContratSearch', 'ContractType', 'ContractProfil', 'ServiceVendu'];

    function ContratController($q, $scope, $state, $filter, Contrat, Principal, ParseLinks, $timeout, AlertService, pagingParams, paginationConstants, PortefeuilleContrat, ContratSearch, ContractType, ContractProfil, ServiceVendu) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.getAppliedFilterCount = getAppliedFilterCount;
        vm.openCalendar = openCalendar;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.etat = $state.params.etat ? $state.params.etat.split(',') : [];
        vm.etatOptions = ['PROSPECT', 'ACTIVE', 'DORMANT', 'FIRST_REMINDER', 'SECOND_REMINDER', 'LITIGATION', 'CLOSED'];
        vm.etatsContrat = ['PROSPECT', 'ACTIVE', 'DORMANT', 'FIRST_REMINDER', 'SECOND_REMINDER', 'LITIGATION', 'CLOSED'];

        vm.portefeuilleContrats = PortefeuilleContrat.query({offset: 0, size: 1000, sort: 'libelle,asc'});
        vm.contractTypes = ContractType.query({offset: 0, size: 1000, sort: 'label,asc'});
        vm.contractProfils = ContractProfil.query({offset: 0, size: 1000, sort: 'libelle,asc'});
        vm.serviceVendus = ServiceVendu.queryInclDeleted({offset: 0, size: 1000, sort: 'libelle,asc'});

        vm.onlinePaymentType = $state.params.onlinePaymentType;
        vm.onlinePaymentQuery = $state.params.onlinePaymentQuery;
        vm.onlinePaymentActive = $state.params.onlinePaymentActive;
        vm.hasEmail = $state.params.hasEmail;
        vm.hasPhone = $state.params.hasPhone;
        vm.searchQuery = $state.params.searchQuery;
        vm.compteurFerme = $state.params.compteurFerme;
        vm.currentBalanceSigne = $state.params.currentBalanceSigne;
        vm.currentBalanceValue = $state.params.currentBalanceValue;
        vm.tooMuchPaid = $state.params.tooMuchPaid === 'true';
        vm.filterBalanceWithService = $state.params.filterBalanceWithService === 'true';
        vm.minAmountPaid = $state.params.minAmountPaid;
        vm.minAmountBilled = $state.params.minAmountBilled;
        vm.maxWaterConsumption = $state.params.maxWaterConsumption;
        vm.date = {
            startDate: $state.params.startDate ? new Date($state.params.startDate) : null,
            endDate: $state.params.endDate ? new Date($state.params.endDate) : null
        };
        vm.toDatePayment = $state.params.toDatePayment ? new Date($state.params.toDatePayment) : null;
        vm.toDateBilling = $state.params.toDateBilling ? new Date($state.params.toDateBilling) : null;
        vm.toDateWaterConsumption = $state.params.toDateWaterConsumption ? new Date($state.params.toDateWaterConsumption) : null;

        vm.datePickerOpenStatus = {
            toDatePayment: false,
            toDateBilling: false,
            toDateWaterConsumption: false
        };

        hydrateSelectedItems();
        hydrateAreaSelection();
        vm.loadAll();

        vm.download = function() {
            Contrat.downloadcsv({
                agenceId: vm.agenceId ? vm.agenceId.map(function(elem) { return elem.id; }).join(',') : null,
                nom: vm.searchQuery,
                compteurFerme: vm.compteurFerme,
                portefeuilleContrat: vm.portefeuilleContrat ? vm.portefeuilleContrat.map(function(elem) { return elem.id; }).join(',') : null,
                contractType: vm.contractType ? vm.contractType.map(function(elem) { return elem.id; }).join(',') : null,
                contractProfil: vm.contractProfil ? vm.contractProfil.map(function(elem) { return elem.id; }).join(',') : null,
                serviceVendu: vm.serviceVendu ? vm.serviceVendu.map(function(elem) { return elem.id; }).join(',') : null,
                etat: vm.etat && vm.etat.length ? vm.etat.join(',') : null,
                fromDate: $filter('date')(vm.date.startDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(vm.date.endDate, 'yyyy-MM-dd'),
                onlinePaymentType: vm.onlinePaymentType,
                onlinePaymentQuery: vm.onlinePaymentQuery,
                onlinePaymentActive: vm.onlinePaymentActive,
                hasEmail: vm.hasEmail,
                hasPhone: vm.hasPhone,
                currentBalanceSigne: vm.currentBalanceSigne,
                currentBalanceValue: vm.currentBalanceValue,
                tooMuchPaid: vm.tooMuchPaid,
                filterBalanceWithService: vm.filterBalanceWithService,
                minAmountPaid: vm.minAmountPaid,
                toDatePayment: $filter('date')(vm.toDatePayment, 'yyyy-MM-dd'),
                minAmountBilled: vm.minAmountBilled,
                toDateBilling: $filter('date')(vm.toDateBilling, 'yyyy-MM-dd'),
                maxWaterConsumption: vm.maxWaterConsumption,
                toDateWaterConsumption: $filter('date')(vm.toDateWaterConsumption, 'yyyy-MM-dd')
            }, function(content) {
                var url = URL.createObjectURL(content.response);
                var a = document.createElement('a');
                a.href = url;
                a.download = content.fileName;
                a.target = '_blank';
                a.click();
            });
        };

        vm.downloadService = function() {
            Contrat.downloadServicecsv({}, function(content) {
                var url = URL.createObjectURL(content.response);
                var a = document.createElement('a');
                a.href = url;
                a.download = content.fileName;
                a.target = '_blank';
                a.click();
            });
        };

        vm.downloadDetailServiceNotClosedcsv = function() {
            Contrat.downloadDetailServiceNotClosedcsv({}, function(content) {
                var url = URL.createObjectURL(content.response);
                var a = document.createElement('a');
                a.href = url;
                a.download = content.fileName;
                a.target = '_blank';
                a.click();
            });
        };

        function hydrateSelectedItems() {
            hydrateParamCollection('portefeuilleContrat', vm.portefeuilleContrats, 'portefeuilleContrat', 'portefeuilleContratNotPromise');
            hydrateParamCollection('contractType', vm.contractTypes, 'contractType', 'contractTypeNotPromise');
            hydrateParamCollection('contractProfil', vm.contractProfils, 'contractProfil', 'contractProfilNotPromise');
            hydrateParamCollection('serviceVendu', vm.serviceVendus, 'serviceVendu', 'serviceVenduNotPromise');
        }

        function hydrateParamCollection(paramName, resource, rawKey, selectedKey) {
            if (!$state.params[paramName]) {
                return;
            }

            vm[rawKey] = $state.params[paramName].split(',').map(function(elem) {
                return {id: elem};
            });

            if (resource && resource.$promise) {
                resource.$promise.then(function(values) {
                    vm[selectedKey] = [];
                    $state.params[paramName].split(',').forEach(function(item) {
                        var match = values.find(function(obj) {
                            return String(obj.id) === String(item);
                        });
                        if (match) {
                            vm[selectedKey].push(match);
                        }
                    });
                });
            }
        }

        function hydrateAreaSelection() {
            vm.agencesRattachement = [];
            vm.agenceIdNotPromise = [];

            if ($state.params.agenceId) {
                vm.agenceId = $state.params.agenceId.split(',').map(function(elem) {
                    return {id: elem};
                });
            }

            Principal.identity().then(function(account) {
                if (account && account.agencesRattachement && account.agencesRattachement.length) {
                    bindAreaSelection(account);
                    return;
                }

                Principal.identity(true).then(function(refreshedAccount) {
                    if (refreshedAccount && refreshedAccount.agencesRattachement && refreshedAccount.agencesRattachement.length) {
                        bindAreaSelection(refreshedAccount);
                    }
                });
            });

            function bindAreaSelection(account) {
                vm.agencesRattachement = account.agencesRattachement;
                vm.agenceIdNotPromise = [];

                if (vm.agenceId && vm.agenceId.length > 0) {
                    $state.params.agenceId.split(',').forEach(function(item) {
                        var match = account.agencesRattachement.find(function(obj) {
                            return String(obj.id) === String(item);
                        });
                        if (match) {
                            vm.agenceIdNotPromise.push(match);
                        }
                    });
                }
            }
        }

        function hasActiveFilters() {
            return !!(
                vm.searchQuery ||
                (vm.etat && vm.etat.length) ||
                vm.compteurFerme ||
                vm.portefeuilleContrat ||
                vm.contractType ||
                vm.contractProfil ||
                vm.serviceVendu ||
                vm.date.startDate ||
                vm.date.endDate ||
                vm.onlinePaymentType ||
                vm.onlinePaymentQuery ||
                vm.onlinePaymentActive ||
                vm.hasEmail ||
                vm.hasPhone ||
                vm.agenceId ||
                isCurrentBalanceApplied() ||
                vm.tooMuchPaid ||
                vm.filterBalanceWithService ||
                isThresholdApplied(vm.minAmountPaid, vm.toDatePayment) ||
                isThresholdApplied(vm.minAmountBilled, vm.toDateBilling) ||
                isThresholdApplied(vm.maxWaterConsumption, vm.toDateWaterConsumption)
            );
        }

        function isCurrentBalanceApplied() {
            return !!(vm.currentBalanceSigne && vm.currentBalanceValue !== null && vm.currentBalanceValue !== undefined && vm.currentBalanceValue !== '');
        }

        function isThresholdApplied(amount, date) {
            return !!(amount !== null && amount !== undefined && amount !== '' && date);
        }

        function getAppliedFilterCount(section) {
            var counters = {
                main: 0,
                reporting: 0,
                online: 0
            };

            if (vm.searchQuery) { counters.main++; }
            if (vm.etat && vm.etat.length) { counters.main++; }
            if (vm.compteurFerme) { counters.main++; }
            if (vm.portefeuilleContratNotPromise && vm.portefeuilleContratNotPromise.length) { counters.main++; }
            if (vm.contractTypeNotPromise && vm.contractTypeNotPromise.length) { counters.main++; }
            if (vm.contractProfilNotPromise && vm.contractProfilNotPromise.length) { counters.main++; }
            if (vm.agenceIdNotPromise && vm.agenceIdNotPromise.length) { counters.main++; }
            if (vm.date.startDate || vm.date.endDate) { counters.main++; }
            if (vm.hasEmail) { counters.main++; }
            if (vm.hasPhone) { counters.main++; }

            if (vm.serviceVenduNotPromise && vm.serviceVenduNotPromise.length) { counters.reporting++; }
            if (isCurrentBalanceApplied()) { counters.reporting++; }
            if (vm.filterBalanceWithService) { counters.reporting++; }
            if (vm.tooMuchPaid) { counters.reporting++; }
            if (isThresholdApplied(vm.minAmountPaid, vm.toDatePayment)) { counters.reporting++; }
            if (isThresholdApplied(vm.minAmountBilled, vm.toDateBilling)) { counters.reporting++; }
            if (isThresholdApplied(vm.maxWaterConsumption, vm.toDateWaterConsumption)) { counters.reporting++; }

            if (vm.onlinePaymentType) { counters.online++; }
            if (vm.onlinePaymentQuery) { counters.online++; }
            if (vm.onlinePaymentActive) { counters.online++; }

            return counters[section] || 0;
        }

        function loadAll() {
            vm.wait = true;
            vm.currentSearch = hasActiveFilters();

            ContratSearch.query({
                agenceId: vm.agenceId ? vm.agenceId.map(function(elem) { return elem.id; }).join(',') : null,
                nom: vm.searchQuery,
                compteurFerme: vm.compteurFerme,
                portefeuilleContrat: vm.portefeuilleContrat ? vm.portefeuilleContrat.map(function(elem) { return elem.id; }).join(',') : null,
                contractType: vm.contractType ? vm.contractType.map(function(elem) { return elem.id; }).join(',') : null,
                contractProfil: vm.contractProfil ? vm.contractProfil.map(function(elem) { return elem.id; }).join(',') : null,
                serviceVendu: vm.serviceVendu ? vm.serviceVendu.map(function(elem) { return elem.id; }).join(',') : null,
                etat: vm.etat && vm.etat.length ? vm.etat.join(',') : null,
                fromDate: $filter('date')(vm.date.startDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(vm.date.endDate, 'yyyy-MM-dd'),
                onlinePaymentType: vm.onlinePaymentType,
                onlinePaymentQuery: vm.onlinePaymentQuery,
                onlinePaymentActive: vm.onlinePaymentActive,
                hasEmail: vm.hasEmail,
                hasPhone: vm.hasPhone,
                currentBalanceSigne: vm.currentBalanceSigne || null,
                currentBalanceValue: vm.currentBalanceValue,
                tooMuchPaid: vm.tooMuchPaid || null,
                filterBalanceWithService: vm.filterBalanceWithService || null,
                minAmountPaid: vm.minAmountPaid,
                toDatePayment: $filter('date')(vm.toDatePayment, 'yyyy-MM-dd'),
                minAmountBilled: vm.minAmountBilled,
                toDateBilling: $filter('date')(vm.toDateBilling, 'yyyy-MM-dd'),
                maxWaterConsumption: vm.maxWaterConsumption,
                toDateWaterConsumption: $filter('date')(vm.toDateWaterConsumption, 'yyyy-MM-dd'),
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                return [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            }

            function onSuccess(data, headers) {
                vm.wait = false;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.contrats = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                vm.wait = false;
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                searchQuery: vm.searchQuery,
                compteurFerme: vm.compteurFerme,
                startDate: vm.date.startDate,
                endDate: vm.date.endDate,
                agenceId: vm.agenceIdNotPromise ? vm.agenceIdNotPromise.map(function(elem) { return elem.id; }).join(',') : null,
                contractType: vm.contractTypeNotPromise ? vm.contractTypeNotPromise.map(function(elem) { return elem.id; }).join(',') : null,
                contractProfil: vm.contractProfilNotPromise ? vm.contractProfilNotPromise.map(function(elem) { return elem.id; }).join(',') : null,
                serviceVendu: vm.serviceVenduNotPromise ? vm.serviceVenduNotPromise.map(function(elem) { return elem.id; }).join(',') : null,
                portefeuilleContrat: vm.portefeuilleContratNotPromise ? vm.portefeuilleContratNotPromise.map(function(elem) { return elem.id; }).join(',') : null,
                etat: vm.etat && vm.etat.length ? vm.etat.join(',') : null,
                currentSearch: vm.currentSearch,
                onlinePaymentType: vm.onlinePaymentType,
                onlinePaymentQuery: vm.onlinePaymentQuery,
                onlinePaymentActive: vm.onlinePaymentActive,
                hasEmail: vm.hasEmail,
                hasPhone: vm.hasPhone,
                currentBalanceSigne: vm.currentBalanceSigne || null,
                currentBalanceValue: vm.currentBalanceValue,
                tooMuchPaid: vm.tooMuchPaid || null,
                filterBalanceWithService: vm.filterBalanceWithService || null,
                minAmountPaid: vm.minAmountPaid,
                toDatePayment: vm.toDatePayment,
                minAmountBilled: vm.minAmountBilled,
                toDateBilling: vm.toDateBilling,
                maxWaterConsumption: vm.maxWaterConsumption,
                toDateWaterConsumption: vm.toDateWaterConsumption
            });
        }

        function search() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = '';
            vm.reverse = false;
            vm.currentSearch = true;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.compteurFerme = null;
            vm.date.startDate = null;
            vm.date.endDate = null;
            vm.portefeuilleContrat = null;
            vm.portefeuilleContratNotPromise = null;
            vm.contractType = null;
            vm.contractTypeNotPromise = null;
            vm.contractProfil = null;
            vm.contractProfilNotPromise = null;
            vm.serviceVendu = null;
            vm.serviceVenduNotPromise = null;
            vm.onlinePaymentType = null;
            vm.onlinePaymentQuery = null;
            vm.onlinePaymentActive = null;
            vm.hasEmail = null;
            vm.hasPhone = null;
            vm.agenceId = null;
            vm.agenceIdNotPromise = null;
            vm.currentBalanceSigne = null;
            vm.currentBalanceValue = null;
            vm.tooMuchPaid = false;
            vm.filterBalanceWithService = false;
            vm.minAmountPaid = null;
            vm.toDatePayment = null;
            vm.minAmountBilled = null;
            vm.toDateBilling = null;
            vm.maxWaterConsumption = null;
            vm.toDateWaterConsumption = null;
            vm.etat = [];
            vm.currentSearch = null;
            vm.transition();
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratStandbyController',ContratStandbyController);

    ContratStandbyController.$inject = ['$uibModalInstance', 'entity', 'LigneContrat'];

    function ContratStandbyController($uibModalInstance, entity, LigneContrat) {
        var vm = this;
        vm.ligneContrat = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmStandBy = function (id) {
        	LigneContrat.standBy({idLigneContrat: id},{},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratReopenController',ContratReopenController);

    ContratReopenController.$inject = ['$uibModalInstance', 'entity', 'LigneContrat'];

    function ContratReopenController($uibModalInstance, entity, LigneContrat) {
        var vm = this;
        vm.ligneContrat = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmReopen = function (id) {
        	LigneContrat.reopen({idLigneContrat: id},{},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratHistoryDialogController', ContratHistoryDialogController);

    ContratHistoryDialogController.$inject = ['$uibModalInstance', 'entity', 'Contrat'];

    function ContratHistoryDialogController($uibModalInstance, entity, Contrat) {
        var vm = this;
        vm.contrat = null;
        vm.historiques = [];
        vm.clear = clear;
        vm.isLoading = true;

        if (entity && entity.$promise && angular.isFunction(entity.$promise.then)) {
            entity.$promise.then(loadHistory, function() {
                vm.isLoading = false;
            });
        } else {
            loadHistory(entity);
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function loadHistory(loadedEntity) {
            vm.contrat = loadedEntity || {};
            if (!vm.contrat.id) {
                vm.isLoading = false;
                return;
            }
            Contrat.getHistory({id: vm.contrat.id}, function(result) {
                vm.historiques = result;
                vm.isLoading = false;
            }, function() {
                vm.isLoading = false;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratDetailController', ContratDetailController);

    ContratDetailController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', 'entity', 'Contrat','Principal','Agence', 'AlertService', 'AssistantPanelService', '$translate'];

    function ContratDetailController($scope, $rootScope, $state, $stateParams, entity, Contrat ,Principal,Agence, AlertService, AssistantPanelService, $translate ) {
        var vm = this;
        vm.idContrat = $stateParams.id;
        vm.contrat = entity;
		vm.$state = $state;
		vm.canEditContract = false;
        vm.canUseAssistant = false;
        vm.downloadContractJson = downloadContractJson;
        vm.openAssistantChat = openAssistantChat;
		  
        vm.load = function (id) {
            Contrat.get({id: id}, function(result) {
                vm.contrat = result;
                AssistantPanelService.updateContextEntity(result);
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:contratUpdate', function(event, result) {
            vm.contrat = result;
            AssistantPanelService.updateContextEntity(result);
        });
        $scope.$on('$destroy', unsubscribe);

		    Principal.identity().then(function(account) {
		    	if(account){
		            vm.canEditContract = account.authorities.indexOf('ROLE_DATA_OPERATOR') !== -1
					 ||  account.authorities.indexOf('ROLE_AREA_MANAGEMENT') !== -1
					 ||  account.authorities.indexOf('ROLE_ADMIN') !== -1;
                    vm.canUseAssistant = (account.modules || []).indexOf('AI_ASSISTANT') !== -1
                        && (account.authorities.indexOf('ROLE_ADMIN') !== -1
                        || account.authorities.indexOf('ROLE_SUPER_ADMIN') !== -1);
					
					    
		    		vm.onlinePaymentConf =  Agence.getOnlinePaymentConf({idArea:account.agence.id});
		        
		    	}
		    });
        function downloadContractJson() {
            Contrat.downloadContractJson({id: vm.idContrat}, function(content) {
                var url = URL.createObjectURL(content.response);
                var a = document.createElement('a');
                a.href = url;
                a.download = content.fileName || ('export-contract-' + vm.idContrat + '.json');
                a.click();
                URL.revokeObjectURL(url);
            }, function(error) {
                AlertService.error(error.data && error.data.message ? error.data.message : 'Unable to download contract JSON export');
            });
        }

        function openAssistantChat() {
            AssistantPanelService.open({
                contextType: 'CONTRACT',
                entityId: vm.idContrat,
                title: $translate.instant('global.assistant.contractTitle'),
                subtitle: vm.contrat && vm.contrat.referenceContrat ? ('#' + vm.contrat.referenceContrat) : null,
                promptPlaceholder: $translate.instant('global.assistant.contractPromptPlaceholder'),
                supportsActionProposal: true,
                supportsDataScopes: true,
                supportsAssistantFlowModes: true,
                defaultAllowAssistantToChooseData: false,
                defaultSelectedDataScopes: [],
                defaultResponseDetailLevel: 'SHORT',
                defaultSelectedModel: 'gpt-4.1-mini',
                defaultCreativityLevel: 'PRECISE',
                defaultAssistantFlowMode: 'OPTIMIZED',
                entity: vm.contrat,
                adapter: {
                    chat: function(payload, success, error) {
                        Contrat.chatAssistant({id: vm.idContrat}, payload, success, error);
                    },
                    getUsage: function(success, error) {
                        Contrat.getAssistantUsage({id: vm.idContrat}, success, error);
                    },
                    recoverLatestResponse: function(payload, success, error) {
                        Contrat.recoverAssistantResponse({id: vm.idContrat, conversationId: payload.conversationId}, success, error);
                    },
                    submitFeedback: function(payload, success, error) {
                        Contrat.submitAssistantFeedback({id: vm.idContrat}, payload, success, error);
                    },
                    executeActions: function(payload, success, error) {
                        Contrat.executeAssistantActions({id: vm.idContrat}, payload, success, error);
                    },
                    refreshContextEntity: function() {
                        Contrat.get({id: vm.idContrat}, function(refreshedEntity) {
                            AssistantPanelService.updateContextEntity(refreshedEntity);
                            $rootScope.$emit('wamasysApp:contratUpdate', refreshedEntity);
                        });
                    }
                }
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratDeleteController',ContratDeleteController);

    ContratDeleteController.$inject = ['$uibModalInstance', 'entity', 'Contrat', 'ClosingContractReason'];

    function ContratDeleteController($uibModalInstance, entity, Contrat,ClosingContractReason) {
        var vm = this;
        vm.contrat = entity;
        vm.closingContractReasons = ClosingContractReason.query({ offset: 0,size: 1000});
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Contrat.delete({id: id,closingContractReasonId:vm.contrat.closingContractReason.id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratCreateTicketController', ContratCreateTicketController);

    ContratCreateTicketController.$inject = ['$scope', '$stateParams', '$uibModalInstance',   'RedmineService','UserSearch'];

    function ContratCreateTicketController ($scope, $stateParams, $uibModalInstance,  RedmineService,UserSearch) {
        var vm = this;
//        vm.RedmineService = {bulkMeter: vm.bulkMeter,isCorrection: true,lastModifiedDate:Date.now() };
        vm.users = UserSearch.searchUserArea({ offset: 0,size: 1000});
        vm.contractRef=  $stateParams.ref;
        
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:redmineUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
//            customFields :;
            vm.redmineIssue.custom_fields =  [{"value": vm.contractRef,"id":1}];
            RedmineService.createIssue(vm.redmineIssue, onSaveSuccess, onSaveError);
          
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateSuppression = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratCreateDialogController', ContratDialogController);

    ContratDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Contrat',  'ContractType','ContractProfil','PortefeuilleContrat', 'ModeleContrat','IndividualMeter'];

    function ContratDialogController ($scope, $stateParams, $uibModalInstance, entity, Contrat, ContractType,ContractProfil, PortefeuilleContrat,ModeleContrat,IndividualMeter) {
        var vm = this;
        vm.contrat = entity;
        vm.isProspectCreation = vm.contrat && vm.contrat.etat === 'PROSPECT';
        vm.portefeuillecontrats = PortefeuilleContrat.query({ offset: 0,size: 1000});
        vm.modeleContrats = ModeleContrat.query();
        vm.contractTypes = ContractType.query();
        vm.contractProfils = ContractProfil.query();
        vm.individualmeters = IndividualMeter.queryNonSupprimeNonUtilise({ offset: 0,size: 1000});

        vm.load = function(id) {
            Contrat.get({id : id}, function(result) {
                vm.contrat = result;
            	vm.updateCoord ();
                
            });
        };
        


        vm.updateCoord = function(){
                 	
	        angular.extend($scope, {
	            defaults: {
	                scrollWheelZoom: false
	            },
	            markers: {
	            	contrat: {
	                    lat: vm.contrat.lat,
	                    lng: vm.contrat.lon,
//	                    message: "This is Madrid. But you can drag me to another position",
	                    focus: true,
	                    draggable: true
	                }
	            }
	        })
        }
 
        
        if(entity && entity.$promise){
            entity.$promise.then(function(value) {
            	vm.updateCoord ();
            });	
        }else{
        	vm.updateCoord();
        }

        $scope.$on("leafletDirectiveMarker.dragend", function(event, args){
        	 vm.contrat.lat = args.model.lat;
        	 vm.contrat.lon = args.model.lng;
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:contratUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
			
            if (vm.contrat.id !== null) {
                Contrat.update(vm.contrat, onSaveSuccess, onSaveError);
            } else {
				if(vm.isProspectCreation ===true){
					vm.contrat.dateActivation = Date.now();
				}
                Contrat.save(vm.contrat, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateCloture = false;
        vm.datePickerOpenStatus.dateActivation = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratChangeStatusDialogController', ContratChangeStatusDialogController);

    ContratChangeStatusDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'Contrat', 'ClosingContractReason'];

    function ContratChangeStatusDialogController($scope, $uibModalInstance, entity, Contrat, ClosingContractReason) {
        var vm = this;
        vm.contrat = null;
        vm.isLoading = true;
        vm.statusOptions = ['ACTIVE', 'DORMANT', 'FIRST_REMINDER', 'SECOND_REMINDER', 'LITIGATION'];
        vm.request = {
            contratId: null,
            newStatus: null,
            generateRecoveryNotice: false,
            createTicket: false,
            closingContractReasonId: null
        };
        vm.closingContractReasons = ClosingContractReason.query();
        vm.save = save;
        vm.clear = clear;
        resolveEntity(entity);

        vm.isReminderStatus = function() {
            return vm.request.newStatus === 'FIRST_REMINDER' || vm.request.newStatus === 'SECOND_REMINDER';
        };

        vm.isTicketEligibleStatus = function() {
            return vm.request.newStatus === 'LITIGATION' || vm.request.newStatus === 'CLOSED';
        };

        vm.isClosedStatus = function() {
            return vm.request.newStatus === 'CLOSED';
        };

        $scope.$watch(function() {
            return vm.request.newStatus;
        }, function(newValue) {
            if (newValue !== 'FIRST_REMINDER' && newValue !== 'SECOND_REMINDER') {
                vm.request.generateRecoveryNotice = false;
            }
            if (newValue !== 'LITIGATION' && newValue !== 'CLOSED') {
                vm.request.createTicket = false;
            }
            if (newValue !== 'CLOSED') {
                vm.request.closingContractReasonId = null;
            }
        });

        function save() {
            if (!vm.request.contratId) {
                return;
            }
            vm.isSaving = true;
            Contrat.changeStatus(vm.request, function(result) {
                $scope.$emit('wamasysApp:contratUpdate', result);
                vm.isSaving = false;
                $uibModalInstance.close(result);
            }, function() {
                vm.isSaving = false;
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function resolveEntity(loadedEntity) {
            if (loadedEntity && loadedEntity.$promise && angular.isFunction(loadedEntity.$promise.then)) {
                loadedEntity.$promise.then(applyEntity, function() {
                    vm.isLoading = false;
                });
                return;
            }
            applyEntity(loadedEntity);
        }

        function applyEntity(loadedEntity) {
            vm.contrat = loadedEntity || {};
            vm.request.contratId = vm.contrat.id || null;
            vm.request.newStatus = vm.contrat.etat || null;
            vm.request.closingContractReasonId = vm.contrat.closingContractReason ? vm.contrat.closingContractReason.id : null;
            vm.isLoading = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratBillOutstandingCreditController',ContratBillOutstandingCreditController);

    ContratBillOutstandingCreditController.$inject = ['$uibModalInstance', 'entity', 'Billing'];

    function ContratBillOutstandingCreditController($uibModalInstance, entity, Billing) {
        var vm = this;
        vm.ligneContrat = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirm  = function (id) {
        	Billing.billOutstandingCredit({idLigneContrat: id},{},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratAssistantDialogController', ContratAssistantDialogController);

    ContratAssistantDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'Contrat'];

    function ContratAssistantDialogController($scope, $uibModalInstance, entity, Contrat) {
        var vm = this;
        var CHAT_RECOVERY_DELAY_MS = 2000;
        var CHAT_RECOVERY_MAX_ATTEMPTS = 8;
        vm.contrat = entity;
        vm.prompt = '';
        vm.messages = [];
        vm.includeSystemInstructions = true;
        vm.latestUsage = null;
        vm.errorMessage = null;
        vm.isSending = false;
        vm.didExecuteActions = false;
        vm.conversationId = generateConversationId();

        vm.askQuestion = askQuestion;
        vm.proposeAction = proposeAction;
        vm.executeActions = executeActions;
        vm.clear = clear;

        function askQuestion() {
            send('QUESTION');
        }

        function proposeAction(message) {
            if (!message || vm.isSending) {
                return;
            }
            send('ACTION', message.actionContextType || 'GENERAL');
        }

        function send(mode, actionContextType) {
            var prompt = (vm.prompt || '').trim();
            if (!prompt || vm.isSending) {
                return;
            }

            vm.errorMessage = null;
            vm.messages.push({
                role: 'user',
                content: prompt
            });
            vm.prompt = '';
            vm.isSending = true;

            Contrat.chatAssistant({id: vm.contrat.id}, {
                mode: mode,
                includeSystemInstructions: vm.includeSystemInstructions,
                actionContextType: actionContextType,
                clientConversationId: vm.conversationId,
                messages: vm.messages.map(function(message) {
                    return {
                        role: message.role,
                        content: message.content
                    };
                })
            }, function(result) {
                applyAssistantResult(result);
            }, function(error) {
                attemptChatRecovery(error, 0);
            });
        }

        function executeActions(message) {
            if (!message || !message.proposedActions || !message.proposedActions.length || message.isExecutingActions) {
                return;
            }

            vm.errorMessage = null;
            message.isExecutingActions = true;

            Contrat.executeAssistantActions({id: vm.contrat.id}, {
                actions: message.proposedActions,
                conversationId: vm.conversationId
            }, function(result) {
                message.isExecutingActions = false;
                message.actionsExecuted = true;
                message.executedActionSummaries = result.executedActionSummaries || [];
                vm.conversationId = result.conversationId || vm.conversationId;
                vm.didExecuteActions = true;
                Contrat.get({id: vm.contrat.id}, function(refreshedContrat) {
                    $scope.$emit('wamasysApp:contratUpdate', refreshedContrat);
                });
            }, function(error) {
                message.isExecutingActions = false;
                vm.errorMessage = (error.headers && error.headers('X-wamasysApp-detail')) || 'Execution impossible';
            });
        }

        function clear() {
            $uibModalInstance.close({
                reload: vm.didExecuteActions
            });
        }

        function applyAssistantResult(result) {
            vm.latestUsage = result.usage;
            vm.conversationId = result.conversationId || vm.conversationId;
            vm.messages.push({
                role: 'assistant',
                content: result.assistantMessage,
                shouldSuggestAction: !!result.shouldSuggestAction,
                actionContextType: result.actionContextType,
                proposedActions: result.proposedActions || [],
                proposedActionSummaries: result.proposedActionSummaries || [],
                canExecuteActions: !!result.canExecuteActions,
                isExecutingActions: false,
                actionsExecuted: false,
                executedActionSummaries: []
            });
            vm.errorMessage = null;
            vm.isSending = false;
        }

        function attemptChatRecovery(originalError, attemptNumber) {
            Contrat.recoverAssistantResponse({id: vm.contrat.id, conversationId: vm.conversationId}, function(result) {
                if (result && result.assistantMessage) {
                    applyAssistantResult(result);
                    return;
                }
                scheduleChatRecovery(originalError, attemptNumber);
            }, function() {
                scheduleChatRecovery(originalError, attemptNumber);
            });
        }

        function scheduleChatRecovery(originalError, attemptNumber) {
            if (attemptNumber + 1 >= CHAT_RECOVERY_MAX_ATTEMPTS) {
                vm.isSending = false;
                vm.errorMessage = (originalError && originalError.headers && originalError.headers('X-wamasysApp-detail'))
                    || 'Assistant indisponible';
                return;
            }
            setTimeout(function() {
                $scope.$applyAsync(function() {
                    attemptChatRecovery(originalError, attemptNumber + 1);
                });
            }, CHAT_RECOVERY_DELAY_MS);
        }

        function generateConversationId() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(character) {
                var randomValue = Math.random() * 16 | 0;
                var value = character === 'x' ? randomValue : ((randomValue & 0x3) | 0x8);
                return value.toString(16);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratAddWaterCorrectionController', ContratAddWaterCorrectionController);

    ContratAddWaterCorrectionController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Contrat'];

    function ContratAddWaterCorrectionController ($scope, $stateParams, $uibModalInstance, entity, Contrat) {
        var vm = this;
        vm.contrat = entity;
        
        
        if(entity && entity.$promise){
            entity.$promise.then(function(value) {
            	vm.consommationEauContrat = {contrat: vm.contrat,
            			individualMeter: vm.contrat.individualMeter,
            			nombreFamille: vm.contrat.nombreFamille,
            			nombrePersonne: vm.contrat.nombrePersonne,
            			isCorrection: true,
            			lastModifiedDate:Date.now() };
            });	
        }
        
 

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:contratUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            
            Contrat.createCorrectionWaterConsumption(vm.consommationEauContrat, onSaveSuccess, onSaveError);
          
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateSuppression = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratAddPaymentCorrectionController', ContratAddPaymentCorrectionController);

    ContratAddPaymentCorrectionController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'CollectionListe'];

    function ContratAddPaymentCorrectionController ($scope, $stateParams, $uibModalInstance, entity, CollectionListe) {
        var vm = this;
        vm.payment = entity;
        vm.paymentCorrection = {};

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:contratUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };
        
        vm.save = function () {
            vm.isSaving = true;
            vm.paymentCorrection.paymentCorrectionId =    vm.payment.paymentReceipt.id;
          //  vm.paymentCorrection.newAmount = vm.payment.paidInclTax - vm.paymentCorrection.tmpNewAmount 
            CollectionListe.paymentCorrection(vm.paymentCorrection, onSaveSuccess, onSaveError);
          
        };
       
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

//        vm.datePickerOpenStatus = {};
//        vm.datePickerOpenStatus.dateSuppression = false;
//
//        vm.openCalendar = function(date) {
//            vm.datePickerOpenStatus[date] = true;
//        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratAddNoteDialogController', ContratAddNoteDialogController);

    ContratAddNoteDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'Contrat'];

    function ContratAddNoteDialogController($scope, $uibModalInstance, entity, Contrat) {
        var vm = this;
        vm.contrat = null;
        vm.isLoading = true;
        vm.request = {
            contratId: null,
            note: null
        };
        vm.save = save;
        vm.clear = clear;

        if (entity && entity.$promise && angular.isFunction(entity.$promise.then)) {
            entity.$promise.then(applyEntity, function() {
                vm.isLoading = false;
            });
        } else {
            applyEntity(entity);
        }

        function save() {
            if (!vm.request.contratId) {
                return;
            }
            vm.isSaving = true;
            Contrat.addNote(vm.request, function() {
                $scope.$emit('wamasysApp:contratUpdate', vm.contrat);
                vm.isSaving = false;
                $uibModalInstance.close();
            }, function() {
                vm.isSaving = false;
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function applyEntity(loadedEntity) {
            vm.contrat = loadedEntity || {};
            vm.request.contratId = vm.contrat.id || null;
            vm.isLoading = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractOnlinePaymentHistoryDialogController', ContractOnlinePaymentHistoryDialogController);

    ContractOnlinePaymentHistoryDialogController.$inject = ['$uibModalInstance', 'entity', 'Contrat'];

    function ContractOnlinePaymentHistoryDialogController($uibModalInstance, entity, Contrat) {
        var vm = this;

        vm.onlinePayment = entity;
        vm.histories = [];
        vm.isLoading = true;
        vm.clear = clear;

        loadHistory();

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function loadHistory() {
            Contrat.getOnlinePaymentHistory({idOnlinePayment: vm.onlinePayment.id}, function(result) {
                vm.histories = result;
                vm.isLoading = false;
            }, function() {
                vm.isLoading = false;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractOnlinePaymentDialogController', ContractOnlinePaymentDialogController);

    ContractOnlinePaymentDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Contrat','Principal','Agence'];

    function ContractOnlinePaymentDialogController ($scope, $stateParams, $uibModalInstance, entity,  Contrat,Principal,Agence) {
        var vm = this;
        vm.onlinePayment = {contrat : entity, active :true} ;
        vm.isSaving = false;
        
        Principal.identity().then(function(account) {
        	if(account){
        		vm.onlinePaymentConf =  Agence.getOnlinePaymentConf({idArea:account.agence.id});
        	}
        });

        var onSaveSuccess = function (result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;

                Contrat.addOnlinePayment(vm.onlinePayment, onSaveSuccess, onSaveError);
            
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractOnlinePaymentDeleteController',ContractOnlinePaymentDeleteController);

    ContractOnlinePaymentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Contrat'];

    function ContractOnlinePaymentDeleteController($uibModalInstance, entity, Contrat) {
        var vm = this;
        vm.onlinePayment = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
        	Contrat.deleteOnlinePayment({idOnlinePayment: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('ContractDocuments', ContractDocuments);

    ContractDocuments.$inject = ['$http', 'DateUtils'];

    function ContractDocuments($http, DateUtils) {
        return {
            query: query,
            upload: upload,
            download: download,
            deleteDocument: deleteDocument
        };

        function query(contractId) {
            return $http.get('api/contrats/' + contractId + '/documents').then(function(response) {
                angular.forEach(response.data || [], normalizeDocument);
                return response.data || [];
            });
        }

        function upload(contractId, file) {
            var formData = new FormData();
            formData.append('file', file);
            return $http.post('api/contrats/' + contractId + '/documents', formData, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(function(response) {
                return normalizeDocument(response.data);
            });
        }

        function download(contractId, documentId) {
            return $http({
                url: 'api/contrats/' + contractId + '/documents/' + documentId,
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(response) {
                return {
                    response: new Blob([response.data], {
                        type: response.headers('Content-Type') || 'application/octet-stream'
                    }),
                    fileName: extractFileName(response.headers('Content-Disposition')) || ('document-' + documentId)
                };
            });
        }

        function deleteDocument(contractId, documentId) {
            return $http.delete('api/contrats/' + contractId + '/documents/' + documentId).then(function(response) {
                return normalizeDocument(response.data);
            });
        }

        function normalizeDocument(document) {
            if (!document) {
                return document;
            }
            document.createdDate = DateUtils.convertDateTimeFromServer(document.createdDate);
            document.lastModifiedDate = DateUtils.convertDateTimeFromServer(document.lastModifiedDate);
            document.deletedDate = DateUtils.convertDateTimeFromServer(document.deletedDate);
            return document;
        }

        function extractFileName(contentDisposition) {
            if (!contentDisposition) {
                return null;
            }
            var match = /filename=\"([^\"]+)\"/i.exec(contentDisposition);
            return match && match[1] ? match[1] : null;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractDocumentsController', ContractDocumentsController);

    ContractDocumentsController.$inject = ['$stateParams', '$window', '$translate', 'entity', 'ContractDocuments', 'AlertService', 'Principal'];

    function ContractDocumentsController($stateParams, $window, $translate, entity, ContractDocuments, AlertService, Principal) {
        var vm = this;

        vm.contrat = entity;
        vm.idContrat = $stateParams.id;
        vm.documents = [];
        vm.canEdit = false;
        vm.selectedDocumentFile = null;
        vm.selectedDocumentFileName = null;
        vm.uploadInProgress = false;
        vm.maxDocumentSizeMb = 50;
        vm.maxDocumentSizeBytes = 50 * 1024 * 1024;

        vm.load = load;
        vm.setDocumentFile = setDocumentFile;
        vm.uploadDocument = uploadDocument;
        vm.downloadDocument = downloadDocument;
        vm.deleteDocument = deleteDocument;
        vm.isDeleted = isDeleted;
        vm.formatFileSize = formatFileSize;

        Principal.identity().then(function(account) {
            if (!account) {
                return;
            }
            vm.canEdit = account.authorities.indexOf('ROLE_DATA_OPERATOR') !== -1
                || account.authorities.indexOf('ROLE_AREA_MANAGEMENT') !== -1
                || account.authorities.indexOf('ROLE_ADMIN') !== -1;
        });

        load();

        function load() {
            ContractDocuments.query(vm.idContrat).then(function(result) {
                vm.documents = result;
            }, handleError);
        }

        function setDocumentFile(file) {
            vm.selectedDocumentFile = file || null;
            vm.selectedDocumentFileName = file && file.name ? file.name : null;
            if (file && file.size > vm.maxDocumentSizeBytes) {
                AlertService.error($translate.instant('wamasysApp.contrat.documents.maxSizeError', { size: vm.maxDocumentSizeMb }));
                clearFileSelection();
            }
        }

        function uploadDocument() {
            if (!vm.canEdit || !vm.selectedDocumentFile) {
                return;
            }
            vm.uploadInProgress = true;
            ContractDocuments.upload(vm.idContrat, vm.selectedDocumentFile).then(function() {
                vm.uploadInProgress = false;
                clearFileSelection();
                AlertService.success($translate.instant('wamasysApp.contrat.documents.addedSuccess'));
                load();
            }, function(error) {
                vm.uploadInProgress = false;
                handleError(error);
            });
        }

        function downloadDocument(contractDocument) {
            if (!contractDocument || !contractDocument.id || isDeleted(contractDocument)) {
                return;
            }
            ContractDocuments.download(vm.idContrat, contractDocument.id).then(function(result) {
                if ($window.navigator.msSaveOrOpenBlob) {
                    $window.navigator.msSaveOrOpenBlob(result.response, result.fileName);
                    return;
                }
                var url = ($window.URL || $window.webkitURL).createObjectURL(result.response);
                var link = angular.element('<a/>');
                link.attr('href', url);
                link.attr('download', result.fileName);
                angular.element(document.body).append(link);
                link[0].click();
                link.remove();
                ($window.URL || $window.webkitURL).revokeObjectURL(url);
            }, handleError);
        }

        function deleteDocument(contractDocument) {
            if (!vm.canEdit || !contractDocument || !contractDocument.id || isDeleted(contractDocument)) {
                return;
            }
            if (!$window.confirm($translate.instant('wamasysApp.contrat.documents.deleteConfirm'))) {
                return;
            }
            ContractDocuments.deleteDocument(vm.idContrat, contractDocument.id).then(function() {
                AlertService.success($translate.instant('wamasysApp.contrat.documents.deletedSuccess'));
                load();
            }, handleError);
        }

        function isDeleted(contractDocument) {
            return !!(contractDocument && contractDocument.deletedDate);
        }

        function clearFileSelection() {
            vm.selectedDocumentFile = null;
            vm.selectedDocumentFileName = null;
            angular.element('#contractDocumentFileInput').val(null);
        }

        function formatFileSize(sizeBytes) {
            var value = Number(sizeBytes || 0);
            var units = ['B', 'KB', 'MB', 'GB'];
            var unitIndex = 0;
            while (value >= 1024 && unitIndex < units.length - 1) {
                value = value / 1024;
                unitIndex++;
            }
            return (unitIndex === 0 ? Math.round(value) : value.toFixed(2)) + ' ' + units[unitIndex];
        }

        function handleError(error) {
            AlertService.error(resolveErrorMessage(error, $translate.instant('wamasysApp.contrat.documents.technicalError')));
        }

        function resolveErrorMessage(error, defaultMessage) {
            return error && error.data && error.data.message ? error.data.message : defaultMessage;
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ConsommationEauContrat', ConsommationEauContrat);

    ConsommationEauContrat.$inject = ['$resource', 'DateUtils'];

    function ConsommationEauContrat ($resource, DateUtils) {
        var resourceUrl =  'api/consommation-eau-contrats/:id';

        return $resource(resourceUrl, {}, {
      	  'byContrat': { method: 'GET', url:'api//consommation-eau-contrats/contrat/:id', isArray: true}
        
          /*  'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateDebut = DateUtils.convertDateTimeFromServer(data.dateDebut);
                    data.dateFin = DateUtils.convertDateTimeFromServer(data.dateFin);
                    return data;
                }
            },
            'update': { method:'PUT' }*/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationSubscriptionOptinDialogController', CommunicationSubscriptionOptinDialogController);

    CommunicationSubscriptionOptinDialogController.$inject = ['$uibModalInstance', 'entity', 'Contrat'];

    function CommunicationSubscriptionOptinDialogController($uibModalInstance, entity, Contrat) {
        var vm = this;

        vm.subscription = angular.copy(entity) || {};
        vm.isSaving = false;
        vm.clear = clear;
        vm.confirm = confirm;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirm() {
            vm.isSaving = true;
            vm.subscription.optin = !vm.subscription.optin;
            if (!vm.subscription.date) {
                vm.subscription.date = new Date();
            }
            Contrat.updateCommunicationSubscription(vm.subscription, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationSubscriptionDialogController', CommunicationSubscriptionDialogController);

    CommunicationSubscriptionDialogController.$inject = ['$uibModalInstance', 'entity', 'Contrat', 'CommunicationTopic', 'Principal', 'AlertService'];

    function CommunicationSubscriptionDialogController($uibModalInstance, entity, Contrat, CommunicationTopic, Principal, AlertService) {
        var vm = this;

        vm.subscription = angular.copy(entity);
        vm.communicationTopics = [];
        vm.availableCommunicationTopics = [];
        vm.existingSubscriptions = [];
        vm.contrat = null;
        vm.contactAlertKey = null;
        vm.duplicateAlertKey = null;
        vm.isSaving = false;
        vm.clear = clear;
        vm.onTopicChange = onTopicChange;
        vm.save = save;

        Principal.identity().then(function(account) {
            if (account && account.agence && account.agence.id) {
                vm.communicationTopics = CommunicationTopic.byAgence({agenceId: account.agence.id}, function() {
                    refreshAvailableTopics();
                    refreshContactAlert();
                });
            }
        });

        if (vm.subscription.contratId) {
            vm.contrat = Contrat.get({id: vm.subscription.contratId}, function() {
                refreshContactAlert();
            });
            Contrat.getCommunicationSubscriptions({idContrat: vm.subscription.contratId}, function(result) {
                vm.existingSubscriptions = result || [];
                refreshAvailableTopics();
                refreshContactAlert();
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            onTopicChange();
            if (vm.duplicateAlertKey) {
                AlertService.error(vm.duplicateAlertKey);
                return;
            }
            if (vm.contactAlertKey) {
                AlertService.warning(vm.contactAlertKey);
            }
            vm.isSaving = true;
            Contrat.addCommunicationSubscription(vm.subscription, onSaveSuccess, onSaveError);
        }

        function onTopicChange() {
            refreshAvailableTopics();
            refreshContactAlert();
        }

        function refreshContactAlert() {
            var selectedTopic;

            vm.contactAlertKey = null;
            vm.duplicateAlertKey = null;
            if (!vm.subscription || !vm.subscription.communicationTopicId || !vm.communicationTopics.length || !vm.contrat) {
                return;
            }

            if (isTopicAlreadySubscribed(vm.subscription.communicationTopicId)) {
                vm.duplicateAlertKey = 'error.business.communicationSubscription.duplicateTopic';
                return;
            }

            selectedTopic = vm.communicationTopics.find(function(topic) {
                return String(topic.id) === String(vm.subscription.communicationTopicId);
            });

            if (!selectedTopic || !selectedTopic.contractContact) {
                return;
            }

            if (selectedTopic.contractContact === 'PHONE' && !vm.contrat.phone) {
                vm.contactAlertKey = 'wamasysApp.contrat.communicationSubscription.missingPhoneWarning';
            } else if (selectedTopic.contractContact === 'EMAIL' && !vm.contrat.email) {
                vm.contactAlertKey = 'wamasysApp.contrat.communicationSubscription.missingEmailWarning';
            }
        }

        function refreshAvailableTopics() {
            if (!vm.communicationTopics || !vm.communicationTopics.length) {
                vm.availableCommunicationTopics = [];
                return;
            }

            vm.availableCommunicationTopics = vm.communicationTopics.filter(function(topic) {
                return !isTopicAlreadySubscribed(topic.id);
            });

            if (vm.subscription && vm.subscription.communicationTopicId && isTopicAlreadySubscribed(vm.subscription.communicationTopicId)) {
                vm.subscription.communicationTopicId = null;
            }
        }

        function isTopicAlreadySubscribed(topicId) {
            if (!topicId || !vm.existingSubscriptions || !vm.existingSubscriptions.length) {
                return false;
            }

            return vm.existingSubscriptions.some(function(subscription) {
                return String(subscription.communicationTopicId) === String(topicId);
            });
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CloturationContratDialogController', CloturationContratDialogController);

    CloturationContratDialogController.$inject = [
        '$scope', '$q', '$uibModalInstance', 'entity', 'Contrat', 'ClosingContractReason',
        'LigneContrat', 'Billing', 'ReleveCompteur', 'ImpactPenalitRemiseRegul'
    ];

    function CloturationContratDialogController(
        $scope, $q, $uibModalInstance, entity, Contrat, ClosingContractReason,
        LigneContrat, Billing, ReleveCompteur, ImpactPenalitRemiseRegul
    ) {
        var vm = this;

        vm.idContrat = entity.id;
        vm.step = 'input';
        vm.isPreparing = false;
        vm.isSaving = false;
        vm.functionalError = null;
        vm.closingContractReasons = ClosingContractReason.query({ offset: 0, size: 1000});
        vm.selectedClosingContractReason = null;
        vm.contrat = null;
        vm.activeLines = [];
        vm.autoResolution = {
            apply: false,
            label: null,
            commentaire: null
        };
        vm.review = emptyReview();
        vm.readingIndividualMeter = {
            releveCompteur: {id: -1},
            readingDate: new Date()
        };

        vm.nextStep = nextStep;
        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.canFinalize = canFinalize;
        vm.getPrimaryActionLabel = getPrimaryActionLabel;

        vm.datePickerOpenStatus = {
            readingDate: false
        };

        loadContractAndLines();

        function emptyReview() {
            return {
                lineStates: [],
                transfers: [],
                debtWaivers: [],
                windfallGains: [],
                totalBalance: 0,
                hasOutstandingBalances: false
            };
        }

        function loadContractAndLines() {
            return $q.all({
                contrat: Contrat.get({id: vm.idContrat}).$promise,
                lignes: LigneContrat.findActifByContrat({idContrat: vm.idContrat}).$promise
            }).then(function(result) {
                vm.contrat = result.contrat;
                vm.activeLines = result.lignes || [];
                initialiseReadingModel();
                return result;
            });
        }

        function initialiseReadingModel() {
            if (!vm.contrat || !vm.contrat.individualMeter) {
                return;
            }
            vm.readingIndividualMeter.individualMeter = vm.contrat.individualMeter;
            vm.readingIndividualMeter.datePrecedentReleveCompteur = vm.contrat.individualMeter.datePrecedenteLecture;
            vm.readingIndividualMeter.valeurPrecedentReleve = vm.contrat.individualMeter.valeurPrecedenteLecture;
            if (!vm.readingIndividualMeter.readingDate) {
                vm.readingIndividualMeter.readingDate = new Date();
            }
        }

        function nextStep() {
            vm.functionalError = null;
            if (vm.step === 'input') {
                prepareClosingReview();
                return;
            }
            finalizeClosing();
        }

        function prepareClosingReview() {
            vm.isPreparing = true;
            runPreparationFlow()
                .then(loadContractAndLines)
                .then(function(result) {
                    vm.review = buildReview(result.lignes || []);
                    vm.autoResolution.apply = vm.review.transfers.length > 0
                        || vm.review.debtWaivers.length > 0
                        || vm.review.windfallGains.length > 0;
                    vm.step = 'review';
                })
                .catch(handleFailure)
                .finally(function() {
                    vm.isPreparing = false;
                });
        }

        function runPreparationFlow() {
            return saveFinalMeterReadingIfNeeded()
                .then(function() {
                    return loadActiveLines();
                })
                .then(function(lines) {
                    return establishBilling(lines);
                });
        }

        function saveFinalMeterReadingIfNeeded() {
            if (!vm.contrat || !vm.contrat.individualMeter) {
                return $q.when();
            }
            vm.readingIndividualMeter.datePrecedentReleveCompteur = vm.contrat.individualMeter.datePrecedenteLecture;
            vm.readingIndividualMeter.valeurPrecedentReleve = vm.contrat.individualMeter.valeurPrecedenteLecture;
            vm.readingIndividualMeter.individualMeter = vm.contrat.individualMeter;
            return ReleveCompteur.addReading(vm.readingIndividualMeter).$promise;
        }

        function loadActiveLines() {
            return LigneContrat.findActifByContrat({idContrat: vm.idContrat}).$promise;
        }

        function establishBilling(lines) {
            var outstandingCreditLine = findOutstandingCreditLine(lines);
            if (outstandingCreditLine) {
                // POST without business payload: keep an explicit empty body so Angular preserves the path param.
                return Billing.billOutstandingCredit({idLigneContrat: outstandingCreditLine.id}, {}).$promise;
            }
            return Billing.createForContract({contractId: vm.idContrat}).$promise;
        }

        function findOutstandingCreditLine(lines) {
            var foundLine = null;
            angular.forEach(lines || [], function(line) {
                if (!foundLine
                        && !line.closed
                        && line.serviceVendu
                        && line.serviceVendu.typePaiement === 'A_PAYER_AVEC_ECHELONNEMENT') {
                    foundLine = line;
                }
            });
            return foundLine;
        }

        function buildReview(lines) {
            var review = emptyReview();
            var workingStates = [];

            angular.forEach(lines || [], function(line) {
                var currentBalance = roundAmount(calculateLineBalance(line));
                var lineState = {
                    line: line,
                    currentBalance: currentBalance,
                    remainingBalance: currentBalance,
                    transferIn: 0,
                    transferOut: 0,
                    proposedAdjustmentType: null,
                    proposedAdjustmentAmount: 0
                };
                workingStates.push(lineState);
                review.totalBalance = roundAmount(review.totalBalance + currentBalance);
            });

            applyTransferSuggestions(workingStates, review.transfers);

            angular.forEach(workingStates, function(state) {
                if (state.remainingBalance < -0.009) {
                    state.proposedAdjustmentType = 'DEBT_WAIVER';
                    state.proposedAdjustmentAmount = roundAmount(-state.remainingBalance);
                    review.debtWaivers.push({
                        line: state.line,
                        amount: state.proposedAdjustmentAmount
                    });
                } else if (state.remainingBalance > 0.009) {
                    state.proposedAdjustmentType = 'WINDFALL_GAIN';
                    state.proposedAdjustmentAmount = roundAmount(state.remainingBalance);
                    review.windfallGains.push({
                        line: state.line,
                        amount: state.proposedAdjustmentAmount
                    });
                }
            });

            review.lineStates = workingStates;
            review.hasOutstandingBalances = review.transfers.length > 0
                || review.debtWaivers.length > 0
                || review.windfallGains.length > 0;
            return review;
        }

        function applyTransferSuggestions(lineStates, transfers) {
            var positiveStates = lineStates.filter(function(state) {
                return state.remainingBalance > 0.009;
            });
            var negativeStates = lineStates.filter(function(state) {
                return state.remainingBalance < -0.009;
            });

            var positiveIndex = 0;
            var negativeIndex = 0;

            while (positiveIndex < positiveStates.length && negativeIndex < negativeStates.length) {
                var positiveState = positiveStates[positiveIndex];
                var negativeState = negativeStates[negativeIndex];
                var transferAmount = roundAmount(Math.min(positiveState.remainingBalance, -negativeState.remainingBalance));

                if (transferAmount <= 0) {
                    break;
                }

                transfers.push({
                    sourceLine: positiveState.line,
                    targetLine: negativeState.line,
                    amount: transferAmount
                });

                positiveState.transferOut = roundAmount(positiveState.transferOut + transferAmount);
                negativeState.transferIn = roundAmount(negativeState.transferIn + transferAmount);
                positiveState.remainingBalance = roundAmount(positiveState.remainingBalance - transferAmount);
                negativeState.remainingBalance = roundAmount(negativeState.remainingBalance + transferAmount);

                if (positiveState.remainingBalance <= 0.009) {
                    positiveIndex += 1;
                }
                if (negativeState.remainingBalance >= -0.009) {
                    negativeIndex += 1;
                }
            }
        }

        function calculateLineBalance(line) {
            if (!line) {
                return 0;
            }
            if (line.moneyboxApresPaiement !== null && line.moneyboxApresPaiement !== undefined) {
                return line.moneyboxApresPaiement;
            }
            if (line.serviceVendu
                    && line.serviceVendu.typePaiement === 'A_PAYER_AVEC_ECHELONNEMENT'
                    && line.derniereLignePaiement) {
                return roundAmount((line.derniereLignePaiement.montantTotalDejaPaye || 0)
                    - (line.derniereLignePaiement.montantTotalAPayer || 0));
            }
            return 0;
        }

        function finalizeClosing() {
            vm.isSaving = true;
            vm.functionalError = null;

            $q.when()
                .then(function() {
                    if (!vm.autoResolution.apply && vm.review.hasOutstandingBalances) {
                        throw new Error('Le contrat n\'est pas encore régularisé. Activez les ajustements automatiques ou régularisez manuellement avant de clôturer.');
                    }
                    if (vm.autoResolution.apply) {
                        validateAutoResolutionInputs();
                        return executeAutoResolution();
                    }
                })
                .then(loadContractAndLines)
                .then(function(result) {
                    vm.review = buildReview(result.lignes || []);
                    if (vm.review.hasOutstandingBalances) {
                        throw new Error('Le contrat n\'est pas à zéro après les ajustements automatiques.');
                    }
                    return Contrat.cloturer({
                        id: vm.idContrat,
                        closingContractReason: vm.selectedClosingContractReason ? {id: vm.selectedClosingContractReason.id} : null
                    }).$promise;
                })
                .then(function(result) {
                    $scope.$emit('wamasysApp:impactPenalitRemiseRegulUpdate', result);
                    $uibModalInstance.close(result);
                })
                .catch(handleFailure)
                .finally(function() {
                    vm.isSaving = false;
                });
        }

        function validateAutoResolutionInputs() {
            var hasFinancialAdjustments = vm.review.debtWaivers.length > 0 || vm.review.windfallGains.length > 0;
            var hasTransfers = vm.review.transfers.length > 0;
            if ((hasFinancialAdjustments && !vm.autoResolution.label) || ((hasFinancialAdjustments || hasTransfers) && !vm.autoResolution.commentaire)) {
                throw new Error('Le libellé et le commentaire sont obligatoires pour appliquer les ajustements automatiques.');
            }
        }

        function executeAutoResolution() {
            return runSequentially(vm.review.transfers, function(transfer) {
                return Billing.saveBalanceTransfer({
                    amount: transfer.amount,
                    commentaire: vm.autoResolution.commentaire,
                    ligneContrat: {id: transfer.sourceLine.id},
                    ligneContratCible: {id: transfer.targetLine.id}
                }).$promise;
            }).then(function() {
                return runSequentially(vm.review.debtWaivers, function(item) {
                    return createAdjustment(item.line.id, 'DEBT_WAIVER', item.amount);
                });
            }).then(function() {
                return runSequentially(vm.review.windfallGains, function(item) {
                    return createAdjustment(item.line.id, 'WINDFALL_GAIN', item.amount);
                });
            });
        }

        function createAdjustment(lineId, type, amount) {
            return ImpactPenalitRemiseRegul.save({
                ligneContrat: {id: lineId},
                type: type,
                montantTtc: amount,
                label: vm.autoResolution.label,
                commentaire: vm.autoResolution.commentaire
            }).$promise;
        }

        function runSequentially(items, callback) {
            var promise = $q.when();
            angular.forEach(items || [], function(item) {
                promise = promise.then(function() {
                    return callback(item);
                });
            });
            return promise;
        }

        function handleFailure(error) {
            vm.functionalError = resolveErrorMessage(error);
            return $q.reject(error);
        }

        function resolveErrorMessage(error) {
            if (!error) {
                return 'Une erreur est survenue.';
            }
            if (error.message) {
                return error.message;
            }
            if (error.data && error.data.message) {
                return error.data.message;
            }
            if (error.headers && angular.isFunction(error.headers)) {
                return error.headers('X-wamasysApp-error') || 'Une erreur est survenue.';
            }
            return 'Une erreur est survenue.';
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function canFinalize() {
            if (vm.step === 'input') {
                return true;
            }
            if (!vm.autoResolution.apply) {
                return !vm.review.hasOutstandingBalances;
            }
            return true;
        }

        function getPrimaryActionLabel() {
            if (vm.step === 'input') {
                return vm.isPreparing ? 'wamasysApp.contrat.closingAction.analyzing' : 'wamasysApp.contrat.closingAction.analyze';
            }
            return vm.isSaving ? 'wamasysApp.contrat.closingAction.closing' : 'wamasysApp.contrat.closingAction.confirm';
        }

        function roundAmount(value) {
            var numericValue = parseFloat(value || 0);
            return Math.round(numericValue * 100) / 100;
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('HistoriqueCompteurContrat', HistoriqueCompteurContrat);

    HistoriqueCompteurContrat.$inject = ['$resource', 'DateUtils'];

    function HistoriqueCompteurContrat ($resource, DateUtils) {
        var resourceUrl =  'api/historique-compteur-contrats/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateAjoutCompteur = DateUtils.convertDateTimeFromServer(data.dateAjoutCompteur);
                    return data;
                }
            },
            'getHistoriqueByContrat':  {
            	url :'api/historique-compteur-contrats/contrat/:id',
            	method: 'GET', 
            	isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ChangerCompteurContratDialogController', ChangerCompteurContratDialogController);

    ChangerCompteurContratDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'HistoriqueCompteurContrat', 'Contrat', 'IndividualMeter'];

    function ChangerCompteurContratDialogController ($scope, $stateParams, $uibModalInstance, entity, HistoriqueCompteurContrat, Contrat, IndividualMeter) {
        var vm = this;
        vm.historiqueCompteurContrat = {contrat : entity} ;
        //     $stateParams.id
        vm.individualmeters = IndividualMeter.queryNonSupprimeNonUtilise();
        vm.isSaving = false;
   /*     vm.load = function(id) {
            HistoriqueCompteurContrat.get({id : id}, function(result) {
                vm.historiqueCompteurContrat = result;
            });
        };*/

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:historiqueCompteurContratUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            
            HistoriqueCompteurContrat.save(vm.historiqueCompteurContrat, onSaveSuccess, onSaveError);
            
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

    }
})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('Billing', Billing);

    Billing.$inject = ['$resource', 'DateUtils'];

    function Billing ($resource, DateUtils) {
        var resourceUrl =  'api/billing';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'createForContract': {
                method: 'POST',
              	url :'/api/billing/contract',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
              //  	clonedData.dateFacturation = DateUtils.convertLocalDateToServer(data.dateFacturation);
                    return angular.toJson(clonedData);
                }
            },
            'createForPortfolio': {
                method: 'POST',
              	url :'/api/billing/portfolio',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
             //   	clonedData.dateFacturation = DateUtils.convertLocalDateToServer(data.dateFacturation);
                    return angular.toJson(clonedData);
                }
            },
            'savePayement': {
                method: 'PUT',
              	url :'/api/billing/payment',
//                transformRequest: function (data) {
//                    data.fromDate = DateUtils.convertLocalDateToServer(data.fromDate);
//                    return angular.toJson(data);
//                }
            },
            'billOutstandingCredit': {
                method: 'POST', 
                url :'api/billing/:idLigneContrat/bill_outstanding_credit'
            },
            
            'saveBalanceTransfer': {
                method: 'PUT',
              	url :'/api/billing/balance_transfer',
//                transformRequest: function (data) {
//                    data.fromDate = DateUtils.convertLocalDateToServer(data.fromDate);
//                    return angular.toJson(data);
//                }
            },
            'deletePayment': {
                method: 'DELETE',
              	url :'/api/billing/payment/:id'
            }
            
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('BillingContractDialogController', BillingContractDialogController );

    BillingContractDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity',  'Billing', 'UserSearch'];

    function BillingContractDialogController  ($scope, $stateParams, $uibModalInstance, entity, Billing, UserSearch) {
        var vm = this;
        vm.contrat = entity;
        
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:billingContractUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            Billing.createForContract(
            		{
            			contractId:vm.contrat.id
            		}
            		, onSaveSuccess, onSaveError);
        
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

//        vm.datePickerOpenStatus = {};
//        vm.datePickerOpenStatus.dateFacturation = false;
//
//        vm.openCalendar = function(date) {
//            vm.datePickerOpenStatus[date] = true;
//        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ActivationContratDialogController', ActivationContratDialogController);

    ActivationContratDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Contrat', 'TypeAvoir', 'TypeRemisecommerciale', 'LigneContrat'];

    function ActivationContratDialogController ($scope, $stateParams, $uibModalInstance, entity, Contrat, TypeAvoir, TypeRemisecommerciale, LigneContrat) {
        var vm = this;
        vm.idContrat = entity.id;
    //    vm.dateCloturation = new Date();

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:impactPenalitRemiseRegulUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
      //      Contrat.activer({id:vm.idContrat,dateActivation: vm.dateActivation}, onSaveSuccess, onSaveError);
			Contrat.activer({id:vm.idContrat}, onSaveSuccess, onSaveError);
            
        }; 

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

    /*    vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateFinPeriode = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };*/
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-dashboard', {
            parent: 'entity',
            url: '/event-dashboard?page&sort',
            data: {
                authenticate: true,
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'Tableaux de bord événement'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/event-dashboard/event-dashboards.html',
                    controller: 'EventDashboardController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'displayOrder,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-dashboard.new', {
            parent: 'event-dashboard',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$state', '$uibModal', function($state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-dashboard/event-dashboard-dialog.html',
                    controller: 'EventDashboardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                label: null,
                                description: null,
                                categoryIds: null,
                                subCategoryIds: null,
                                configJson: null,
                                showInNavbar: true,
                                active: true,
                                displayOrder: 0,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-dashboard', null, { reload: true });
                }, function() {
                    $state.go('event-dashboard');
                });
            }]
        })
        .state('event-dashboard.edit', {
            parent: 'event-dashboard',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-dashboard/event-dashboard-dialog.html',
                    controller: 'EventDashboardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventDashboard', function(EventDashboard) {
                            return EventDashboard.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-dashboard', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-dashboard-view', {
            parent: 'entity',
            url: '/event-dashboard-view/{id}',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN','ROLE_EVT_EDIT','ROLE_EVT_READ_ONLY'],
                pageTitle: 'Tableau de bord événement'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/event-dashboard/event-dashboard-view.html',
                    controller: 'EventDashboardViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('EventDashboard', EventDashboard);

    EventDashboard.$inject = ['$resource', 'DateUtils'];

    function EventDashboard ($resource, DateUtils) {
        var resourceUrl = 'api/event-dashboards/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': { method: 'GET' },
            'navbar': {
                method: 'GET',
                isArray: true,
                url: 'api/event-dashboards/navbar'
            },
            'viewData': {
                method: 'POST',
                url: 'api/event-dashboards/:id/view-data',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    if (data && angular.isArray(data.events)) {
                        angular.forEach(data.events, normalizeEvent);
                    }
                    return data;
                }
            },
            'exportData': {
                method: 'POST',
                isArray: true,
                url: 'api/event-dashboards/:id/export-data',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    if (angular.isArray(data)) {
                        angular.forEach(data, normalizeEvent);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' }
        });

        function normalizeEvent(eventForm) {
            if (!eventForm) {
                return eventForm;
            }
            eventForm.dateRecord = DateUtils.convertDateTimeFromServer(eventForm.dateRecord);
            eventForm.statusChangedDate = DateUtils.convertDateTimeFromServer(eventForm.statusChangedDate);
            eventForm.createdDate = DateUtils.convertDateTimeFromServer(eventForm.createdDate);
            eventForm.lastModifiedDate = DateUtils.convertDateTimeFromServer(eventForm.lastModifiedDate);
            return eventForm;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventDashboardController', EventDashboardController);

    EventDashboardController.$inject = ['$state', 'EventDashboard', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'EventConfigurationAssistant'];

    function EventDashboardController($state, EventDashboard, ParseLinks, AlertService, pagingParams, paginationConstants, EventConfigurationAssistant) {
        var vm = this;
        vm.openAssistant = function() { EventConfigurationAssistant.open('DASHBOARD', loadAll); };
        EventConfigurationAssistant.canUse('DASHBOARD').then(function(allowed) { vm.canUseAssistant = allowed; });

        vm.dashboards = [];
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.inclInactive = false;

        loadAll();

        function loadAll() {
            EventDashboard.query({
                inclInactive: vm.inclInactive,
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.dashboards = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventDashboardViewController', EventDashboardViewController);

    EventDashboardViewController.$inject = ['$filter', '$stateParams', '$window', 'EventDashboard', 'AlertService',
        'EventFormCategory', 'EntiteParente', 'Agence'];

    function EventDashboardViewController($filter, $stateParams, $window, EventDashboard, AlertService,
                                          EventFormCategory, EntiteParente, Agence) {
        var vm = this;

        vm.dashboard = {};
        vm.config = {};
        vm.tableColumns = [];
        vm.tableEvents = [];
        vm.tableSummaries = [];
        vm.metrics = [];
        vm.histograms = [];
        vm.pies = [];
        vm.timeHistograms = [];
        vm.activeFilters = [];
        vm.totalBaseResults = 0;
        vm.tableTotalResults = 0;
        vm.tablePage = 1;
        vm.tablePageSize = 50;
        vm.map = buildEmptyMapState();
        vm.mapMarkerCount = 0;
        vm.isExporting = false;
        vm.isLoading = false;
        vm.searchText = null;
        vm.date = defaultDateRange();
        vm.useEncodingPeriod = false;
        vm.validityDate = new Date();
        vm.validityStatus = 'ACTIVE';
        vm.listCategory = [];
        vm.listSubCategory = [];
        vm.agencies = [];
        vm.areas = [];
        vm.filteredAreas = [];
        vm.selectedAgencyId = null;
        vm.selectedAreaId = null;
        vm.selectedCategoryId = null;
        vm.selectedSubCategoryId = null;
        vm.allowedCategoryIds = [];
        vm.allowedSubCategoryIds = [];

        vm.load = load;
        vm.search = search;
        vm.resetFilters = resetFilters;
        vm.changePage = changePage;
        vm.maxValue = maxValue;
        vm.applyQuickFilter = applyQuickFilter;
        vm.removeFilter = removeFilter;
        vm.clearFilters = clearFilters;
        vm.exportAll = exportAll;
        vm.resolveDisplayValue = resolveDisplayValue;
        vm.resolveRawValue = resolveRawValue;
        vm.updateSubCategory = updateSubCategory;
        vm.updateAreaOptions = updateAreaOptions;
        vm.timeHistogramBaseType = timeHistogramBaseType;

        EventDashboard.get({id: $stateParams.id}, function(result) {
            vm.dashboard = result;
            vm.config = normalizeConfig(parseJson(result.configJson, {}));
            vm.tableColumns = resolveTableColumns(vm.config.table);
            vm.allowedCategoryIds = parseIds(result.categoryIds);
            vm.allowedSubCategoryIds = parseIds(result.subCategoryIds);
            loadReferenceData();
            load();
        }, onError);

        function loadReferenceData() {
            EntiteParente.query({
                page: 0,
                size: 500
            }, function(result) {
                vm.agencies = result || [];
            }, onError);

            Agence.currentOrganisation(function(result) {
                vm.areas = result || [];
                updateAreaOptions();
            }, onError);

            EventFormCategory.query({
                page: 0,
                size: 500
            }, function(result) {
                vm.listCategory = filterAllowedCategories(result || []);
            }, onError);
        }

        function load() {
            vm.isLoading = true;
            EventDashboard.viewData({id: vm.dashboard.id}, buildViewRequest(), function(result) {
                vm.tableEvents = prepareEvents(result.events || []);
                vm.totalBaseResults = result.totalBaseResults || 0;
                vm.tableTotalResults = result.totalFilteredResults || 0;
                vm.metrics = result.metrics || [];
                vm.histograms = result.histograms || [];
                vm.pies = result.pies || [];
                vm.tableSummaries = result.tableSummaries || [];
                vm.timeHistograms = prepareTimeHistograms(result.timeHistograms || []);
                vm.map = buildMapStateFromMarkers(result.mapMarkers || []);
                vm.mapMarkerCount = (result.mapMarkers || []).length;
                vm.isLoading = false;
            }, function(error) {
                vm.isLoading = false;
                onError(error);
            });
        }

        function search() {
            vm.tablePage = 1;
            load();
        }

        function resetFilters() {
            vm.searchText = null;
            vm.date = defaultDateRange();
            vm.useEncodingPeriod = false;
            vm.validityDate = new Date();
            vm.validityStatus = 'ACTIVE';
            vm.selectedAgencyId = null;
            vm.selectedAreaId = null;
            vm.selectedCategoryId = null;
            vm.selectedSubCategoryId = null;
            vm.listSubCategory = [];
            vm.activeFilters = [];
            updateAreaOptions();
            vm.tablePage = 1;
            load();
        }

        function changePage() {
            load();
        }

        function updateSubCategory() {
            vm.selectedSubCategoryId = null;
            if (!vm.selectedCategoryId) {
                vm.listSubCategory = [];
                return;
            }
            EventFormCategory.getListSubCategory({id: vm.selectedCategoryId}, function(result) {
                vm.listSubCategory = filterAllowedSubCategories(result || []);
            }, onError);
        }

        function updateAreaOptions() {
            vm.filteredAreas = (vm.areas || []).filter(function(area) {
                return !vm.selectedAgencyId || (area.entiteParente && area.entiteParente.id === vm.selectedAgencyId);
            });

            if (vm.selectedAreaId && !vm.filteredAreas.some(function(area) {
                return area.id === vm.selectedAreaId;
            })) {
                vm.selectedAreaId = null;
            }
        }

        function applyQuickFilter(fieldCode, rawValue, label, tokenOverride, valueLabelOverride) {
            var token = tokenOverride || normalizeFilterValue(rawValue, fieldCode);
            var valueLabel = valueLabelOverride || formatFilterValue(rawValue, fieldCode);
            var alreadyPresent = false;

            angular.forEach(vm.activeFilters, function(filter) {
                if (!alreadyPresent && filter.fieldCode === fieldCode && filter.token === token) {
                    alreadyPresent = true;
                }
            });

            if (alreadyPresent) {
                return;
            }

            vm.activeFilters.push({
                fieldCode: fieldCode,
                label: label || defaultFieldLabel(fieldCode),
                token: token,
                valueLabel: valueLabel
            });
            vm.tablePage = 1;
            load();
        }

        function removeFilter(index) {
            vm.activeFilters.splice(index, 1);
            vm.tablePage = 1;
            load();
        }

        function clearFilters() {
            vm.activeFilters = [];
            vm.tablePage = 1;
            load();
        }

        function exportAll() {
            vm.isExporting = true;
            EventDashboard.exportData({id: vm.dashboard.id}, buildViewRequest(false), function(result) {
                var exportEvents = prepareEvents(result || []);
                var csvContent = buildCsv(exportEvents, vm.tableColumns);
                downloadCsv(csvContent, buildExportFileName());
                vm.isExporting = false;
            }, function(error) {
                vm.isExporting = false;
                onError(error);
            });
        }

        function buildViewRequest(includePaging) {
            return {
                searchText: vm.searchText,
                fromDate: (!vm.config.validity.enabled || vm.useEncodingPeriod) && vm.date && vm.date.startDate
                    ? $filter('date')(vm.date.startDate, 'yyyy-MM-dd') : null,
                toDate: (!vm.config.validity.enabled || vm.useEncodingPeriod) && vm.date && vm.date.endDate
                    ? $filter('date')(vm.date.endDate, 'yyyy-MM-dd') : null,
                validityDate: vm.config.validity.enabled ? formatLocalDate(vm.validityDate) : null,
                validityStatus: vm.config.validity.enabled ? vm.validityStatus : null,
                categoryIds: vm.selectedCategoryId ? [vm.selectedCategoryId] : null,
                subCategoryIds: vm.selectedSubCategoryId ? [vm.selectedSubCategoryId] : null,
                agencyIds: vm.selectedAgencyId ? [vm.selectedAgencyId] : null,
                areaIds: vm.selectedAreaId ? [vm.selectedAreaId] : null,
                quickFilters: angular.copy(vm.activeFilters),
                page: includePaging === false ? 0 : vm.tablePage - 1,
                size: includePaging === false ? null : vm.tablePageSize
            };
        }

        function prepareEvents(events) {
            return (events || []).map(function(event) {
                event._answers = parseJson(event.answersJson, {});
                event._fieldMappings = buildFieldMappings(parseJson(event.subCategoryCustomFields, {}));
                addValidityFieldMappings(event._fieldMappings);
                return event;
            });
        }

        function resolveDisplayValue(event, column) {
            var fieldCode = angular.isObject(column) ? column.fieldCode : column;
            var format = angular.isObject(column) ? column.format : null;
            var value = resolveRawValue(event, fieldCode);

            if (value === null || value === undefined || value === '') {
                return '';
            }
            if (format === 'number') {
                return numericValue(value);
            }
            if (format === 'date') {
                return $filter('date')(value, 'yyyy-MM-dd');
            }
            if (format === 'datetime') {
                return $filter('date')(value, 'short');
            }
            if (isDateValue(fieldCode, value)) {
                return $filter('date')(value, 'short');
            }
            if (angular.isNumber(value)) {
                return value;
            }
            if (typeof value === 'boolean') {
                return value ? 'Oui' : 'Non';
            }
            if (angular.isObject(value)) {
                return angular.toJson(value);
            }
            return value;
        }

        function resolveRawValue(event, column) {
            var fieldCode = angular.isObject(column) ? column.fieldCode : column;
            return resolveFieldValue(event, fieldCode);
        }

        function resolveFieldValue(event, fieldCode) {
            var directValue;
            var candidateCodes;
            var mapping;
            var index;

            if (!event) {
                return null;
            }

            directValue = resolveBuiltInFieldValue(event, fieldCode);
            if (directValue !== undefined) {
                return directValue;
            }

            if (!event._answers) {
                return null;
            }
            if (event._answers[fieldCode] !== undefined) {
                return event._answers[fieldCode];
            }

            candidateCodes = [fieldCode];
            mapping = event._fieldMappings[fieldCode];
            if (mapping) {
                candidateCodes = candidateCodes.concat(mapping.candidateCodes);
            }

            for (index = 0; index < candidateCodes.length; index++) {
                if (event._answers[candidateCodes[index]] !== undefined) {
                    return event._answers[candidateCodes[index]];
                }
            }

            return null;
        }

        function resolveBuiltInFieldValue(event, fieldCode) {
            if (!fieldCode) {
                return undefined;
            }

            switch (fieldCode) {
            case 'id':
                return event.id;
            case 'dateRecord':
                return event.dateRecord;
            case 'category':
                return event.category;
            case 'categoryId':
                return event.categoryId;
            case 'subCategory':
                return event.subCategory;
            case 'subCategoryId':
                return event.subCategoryId;
            case 'title':
                return event.title;
            case 'comment':
                return event.comment;
            case 'author':
                return event.author;
            case 'workflowStatus':
                return event.workflowStatus;
            case 'documentVersion':
                return event.documentVersion;
            case 'statusChangedDate':
                return event.statusChangedDate;
            case 'statusChangedBy':
                return event.statusChangedBy;
            case 'lat':
                return event.lat;
            case 'lon':
                return event.lon;
            case 'gps':
                return event.lat !== null && event.lat !== undefined && event.lon !== null && event.lon !== undefined
                    ? event.lat + ', ' + event.lon : null;
            case 'area':
            case 'areaName':
                return event.areaName;
            case 'areaId':
                return event.areaId;
            case 'agency':
            case 'agencyName':
                return event.agencyName;
            case 'agencyId':
                return event.agencyId;
            default:
                return undefined;
            }
        }

        function buildFieldMappings(customFieldsConfig) {
            var mappings = {};

            angular.forEach((customFieldsConfig && customFieldsConfig.fields) || [], function(fieldConfig) {
                var dictionaryFieldCode = fieldConfig.dictionaryFieldCode || fieldConfig.fieldCode;
                var storageName = fieldConfig.name || fieldConfig.code || dictionaryFieldCode;
                var mappingKey = dictionaryFieldCode || storageName;

                if (!mappingKey) {
                    return;
                }

                mappings[mappingKey] = {
                    candidateCodes: uniqueCodes([storageName, dictionaryFieldCode].concat(parseLegacyNames(fieldConfig.legacyNames || fieldConfig.legacyCodes)))
                };
                if (storageName && !mappings[storageName]) {
                    mappings[storageName] = mappings[mappingKey];
                }
            });

            return mappings;
        }

        function addValidityFieldMappings(mappings) {
            if (!vm.config.validity.enabled) {
                return;
            }
            angular.forEach([
                {code: vm.config.validity.startFieldCode, names: vm.config.validity.startLegacyNames},
                {code: vm.config.validity.endFieldCode, names: vm.config.validity.endLegacyNames}
            ], function(field) {
                if (!field.code || !angular.isArray(field.names) || !field.names.length) {
                    return;
                }
                var existing = mappings[field.code] ? mappings[field.code].candidateCodes : [];
                mappings[field.code] = {candidateCodes: uniqueCodes(existing.concat(field.names))};
            });
        }

        function uniqueCodes(values) {
            var seen = {};
            var result = [];

            angular.forEach(values, function(value) {
                if (!value || seen[value]) {
                    return;
                }
                seen[value] = true;
                result.push(value);
            });

            return result;
        }

        function parseLegacyNames(value) {
            if (!value) {
                return [];
            }
            if (angular.isArray(value)) {
                return value;
            }
            return String(value).split(/[;,]/).map(function(item) {
                return item.trim();
            }).filter(function(item) {
                return item.length > 0;
            });
        }

        function buildCsv(events, columns) {
            var lines = [];
            var exportColumns = columns && columns.length ? columns : defaultTableColumns();

            lines.push(exportColumns.map(function(column) {
                return escapeCsvValue(column.label);
            }).join(';'));

            angular.forEach(events, function(event) {
                lines.push(exportColumns.map(function(column) {
                    return escapeCsvValue(resolveDisplayValue(event, column));
                }).join(';'));
            });

            return '\ufeff' + lines.join('\r\n');
        }

        function buildExportFileName() {
            var safeCode = vm.dashboard.code || 'dashboard-evenements';
            return safeCode + '-' + $filter('date')(new Date(), 'yyyyMMdd-HHmmss') + '.csv';
        }

        function downloadCsv(content, fileName) {
            var blob = new Blob([content], {type: 'text/csv;charset=utf-8;'});

            if ($window.navigator && $window.navigator.msSaveOrOpenBlob) {
                $window.navigator.msSaveOrOpenBlob(blob, fileName);
                return;
            }

            var url = $window.URL.createObjectURL(blob);
            var link = $window.document.createElement('a');
            link.href = url;
            link.download = fileName;
            $window.document.body.appendChild(link);
            link.click();
            $window.document.body.removeChild(link);
            $window.URL.revokeObjectURL(url);
        }

        function escapeCsvValue(value) {
            var text = value === null || value === undefined ? '' : String(value);
            return '"' + text.replace(/"/g, '""') + '"';
        }

        function normalizeFilterValue(value, fieldCode) {
            if (value === null || value === undefined || value === '') {
                return '__blank__';
            }
            if (isDateValue(fieldCode, value)) {
                return $filter('date')(value, 'yyyy-MM-dd');
            }
            if (typeof value === 'boolean') {
                return value ? 'true' : 'false';
            }
            if (angular.isObject(value)) {
                return angular.toJson(value);
            }
            return String(value).trim().toLowerCase();
        }

        function formatFilterValue(value, fieldCode) {
            if (value === null || value === undefined || value === '') {
                return 'Non renseigné';
            }
            if (isDateValue(fieldCode, value)) {
                return $filter('date')(value, 'yyyy-MM-dd');
            }
            if (typeof value === 'boolean') {
                return value ? 'Oui' : 'Non';
            }
            if (angular.isObject(value)) {
                return angular.toJson(value);
            }
            return String(value);
        }

        function normalizeConfig(rawConfig) {
            var config = angular.isObject(rawConfig) ? angular.copy(rawConfig) : {};
            config.metrics = normalizeMetricConfigs(config.metrics);
            config.histograms = normalizeChartConfigs(config.histograms);
            config.pies = normalizeChartConfigs(config.pies);
            config.table = normalizeTableConfig(config.table);
            config.map = normalizeMapConfig(config.map);
            config.validity = config.validity && config.validity.enabled ? config.validity : {enabled: false};
            return config;
        }

        function formatLocalDate(value) {
            if (!value) {
                return null;
            }
            return value.getFullYear() + '-' + ('0' + (value.getMonth() + 1)).slice(-2)
                + '-' + ('0' + value.getDate()).slice(-2);
        }

        function normalizeMetricConfigs(metrics) {
            var normalized = [];

            angular.forEach(metrics || [], function(metric) {
                normalized.push({
                    fieldCode: metric.fieldCode || null,
                    label: metric.label || null,
                    aggregation: metric.aggregation || 'sum'
                });
            });

            return normalized;
        }

        function normalizeChartConfigs(charts) {
            var normalized = [];

            angular.forEach(charts || [], function(chart) {
                var groupByFieldCode = chart.groupByFieldCode || chart.fieldCode;
                if (!groupByFieldCode) {
                    return;
                }
                normalized.push({
                    groupByFieldCode: groupByFieldCode,
                    valueFieldCode: chart.valueFieldCode || chart.metricFieldCode || null,
                    label: chart.label || null,
                    aggregation: chart.aggregation || 'count',
                    limit: toPositiveInteger(chart.limit, 20)
                });
            });

            return normalized;
        }

        function normalizeTableConfig(tableConfig) {
            if (tableConfig === false) {
                return {
                    enabled: false,
                    columns: [],
                    summaries: []
                };
            }

            if (tableConfig === true || tableConfig === null || tableConfig === undefined) {
                return {
                    enabled: true,
                    columns: defaultTableColumns(),
                    summaries: []
                };
            }

            return {
                enabled: tableConfig.enabled !== false,
                columns: angular.isArray(tableConfig.columns) ? tableConfig.columns : defaultTableColumns(),
                summaries: angular.isArray(tableConfig.summaries) ? tableConfig.summaries : []
            };
        }

        function normalizeMapConfig(mapConfig) {
            if (mapConfig === false) {
                return {enabled: false};
            }
            if (mapConfig === true || mapConfig === null || mapConfig === undefined) {
                return {enabled: true};
            }
            return {
                enabled: mapConfig.enabled !== false
            };
        }

        function resolveTableColumns(tableConfig) {
            var configuredColumns = (tableConfig && tableConfig.columns) || [];
            var columns = [];

            if (!configuredColumns.length) {
                return defaultTableColumns();
            }

            angular.forEach(configuredColumns, function(column) {
                var fieldCode = column.fieldCode || column.code;
                if (!fieldCode) {
                    return;
                }
                columns.push({
                    fieldCode: fieldCode,
                    label: column.label || defaultFieldLabel(fieldCode),
                    format: column.format || null
                });
            });

            return columns.length ? columns : defaultTableColumns();
        }

        function defaultTableColumns() {
            return [
                {fieldCode: 'dateRecord', label: 'Date'},
                {fieldCode: 'category', label: 'Catégorie'},
                {fieldCode: 'subCategory', label: 'Sous-catégorie'},
                {fieldCode: 'title', label: 'Titre'},
                {fieldCode: 'author', label: 'Auteur'}
            ];
        }

        function defaultFieldLabel(fieldCode) {
            switch (fieldCode) {
            case 'dateRecord':
                return 'Date';
            case 'category':
                return 'Catégorie';
            case 'subCategory':
                return 'Sous-catégorie';
            case 'title':
                return 'Titre';
            case 'author':
                return 'Auteur';
            case 'comment':
                return 'Commentaire';
            case 'workflowStatus':
                return 'État';
            case 'documentVersion':
                return 'Version';
            case 'statusChangedDate':
                return 'Date de changement d\'état';
            case 'statusChangedBy':
                return 'Modifié par';
            case 'gps':
                return 'Coordonnées GPS';
            case 'agency':
            case 'agencyName':
                return 'Agence';
            case 'area':
            case 'areaName':
                return 'Zone';
            default:
                return fieldCode;
            }
        }

        function isDateValue(fieldCode, value) {
            if (!value) {
                return false;
            }
            if (fieldCode === 'dateRecord' || fieldCode === 'statusChangedDate') {
                return true;
            }
            return angular.isDate(value) || /^\d{4}-\d{2}-\d{2}T/.test(String(value)) || /^\d{4}-\d{2}-\d{2}$/.test(String(value));
        }

        function parseJson(value, defaultValue) {
            if (!value) {
                return defaultValue;
            }
            try {
                return angular.fromJson(value);
            } catch (e) {
                return defaultValue;
            }
        }

        function numericValue(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }
            var parsed = Number(value);
            return isNaN(parsed) ? null : parsed;
        }

        function maxValue(values) {
            var max = 0;
            angular.forEach(values || [], function(value) {
                if (value.value > max) {
                    max = value.value;
                }
            });
            return max || 1;
        }

        function parseIds(value) {
            if (!value) {
                return [];
            }
            if (angular.isArray(value)) {
                return value.map(function(item) {
                    return parseInt(item, 10);
                }).filter(function(item) {
                    return !isNaN(item);
                });
            }
            return String(value).split(',').map(function(item) {
                return parseInt(item.trim(), 10);
            }).filter(function(item) {
                return !isNaN(item);
            });
        }

        function filterAllowedCategories(categories) {
            if (!vm.allowedCategoryIds.length) {
                return categories;
            }
            return (categories || []).filter(function(category) {
                return vm.allowedCategoryIds.indexOf(category.id) !== -1;
            });
        }

        function filterAllowedSubCategories(subCategories) {
            if (!vm.allowedSubCategoryIds.length) {
                return subCategories;
            }
            return (subCategories || []).filter(function(subCategory) {
                return vm.allowedSubCategoryIds.indexOf(subCategory.id) !== -1;
            });
        }

        function prepareTimeHistograms(histograms) {
            return (histograms || []).map(function(histogram) {
                var preparedHistogram = angular.copy(histogram);
                preparedHistogram.seriesLabels = [];
                preparedHistogram.data = [];
                preparedHistogram.datasetOverride = [];
                angular.forEach(preparedHistogram.series || [], function(series) {
                    preparedHistogram.seriesLabels.push(series.label);
                    preparedHistogram.data.push(series.values || []);
                    preparedHistogram.datasetOverride.push({
                        label: series.label,
                        type: series.displayType || 'bar',
                        fill: false,
                        borderWidth: series.displayType === 'line' ? 2 : 1
                    });
                });
                preparedHistogram.baseType = preparedHistogram.datasetOverride.length
                    ? (preparedHistogram.datasetOverride[0].type || 'bar') : 'bar';
                preparedHistogram.options = {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: true
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                };
                return preparedHistogram;
            });
        }

        function timeHistogramBaseType(histogram) {
            return histogram && histogram.baseType ? histogram.baseType : 'bar';
        }

        function buildMapStateFromMarkers(markers) {
            if (!markers || !markers.length) {
                return buildEmptyMapState();
            }

            var mapState = buildEmptyMapState();
            var firstMarker = null;
            var bounds = initBounds();

            angular.forEach(markers, function(marker, index) {
                var markerKey = 'event_' + index;
                mapState.markers[markerKey] = {
                    lat: marker.lat,
                    lng: marker.lng,
                    message: marker.message,
                    draggable: false
                };

                if (!firstMarker) {
                    firstMarker = mapState.markers[markerKey];
                }
                updateBounds(bounds, marker.lat, marker.lng);
            });

            mapState.center = {
                lat: firstMarker.lat,
                lng: firstMarker.lng,
                zoom: markers.length > 1 ? 12 : 16
            };

            if (markers.length > 1) {
                mapState.bounds = buildBoundsObject(bounds);
            }

            return mapState;
        }

        function buildEmptyMapState() {
            return {
                center: {
                    lat: 0,
                    lng: 0,
                    zoom: 2
                },
                bounds: null,
                markers: {},
                defaults: {
                    scrollWheelZoom: false
                },
                layers: {
                    baselayers: {
                        osm: {
                            name: 'OpenStreetMap',
                            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                            type: 'xyz'
                        },
                        satellite: {
                            name: 'Satellite',
                            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                            type: 'xyz'
                        }
                    }
                }
            };
        }

        function initBounds() {
            return {
                minLat: Number.POSITIVE_INFINITY,
                maxLat: Number.NEGATIVE_INFINITY,
                minLon: Number.POSITIVE_INFINITY,
                maxLon: Number.NEGATIVE_INFINITY
            };
        }

        function updateBounds(bounds, lat, lon) {
            bounds.minLat = Math.min(bounds.minLat, lat);
            bounds.maxLat = Math.max(bounds.maxLat, lat);
            bounds.minLon = Math.min(bounds.minLon, lon);
            bounds.maxLon = Math.max(bounds.maxLon, lon);
        }

        function buildBoundsObject(bounds) {
            return {
                northEast: {
                    lat: bounds.maxLat,
                    lng: bounds.maxLon
                },
                southWest: {
                    lat: bounds.minLat,
                    lng: bounds.minLon
                }
            };
        }

        function toPositiveInteger(value, defaultValue) {
            var parsed = parseInt(value, 10);
            return isNaN(parsed) || parsed <= 0 ? defaultValue : parsed;
        }

        function defaultDateRange() {
            var today = new Date();
            return {
                startDate: new Date(today.getFullYear(), today.getMonth() - 11, 1),
                endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate())
            };
        }

        function onError(error) {
            var message = error && error.data && error.data.message ? error.data.message : 'Erreur lors du chargement du tableau de bord.';
            AlertService.error(message);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventDashboardDialogController', EventDashboardDialogController);

    EventDashboardDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'EventDashboard'];

    function EventDashboardDialogController($scope, $uibModalInstance, entity, EventDashboard) {
        var vm = this;

        vm.dashboard = entity;
        vm.clear = clear;
        vm.save = save;
        vm.exampleJson = buildExampleJson();

        vm.dashboard.active = vm.dashboard.active !== false;
        vm.dashboard.showInNavbar = !!vm.dashboard.showInNavbar;
        vm.dashboard.displayOrder = vm.dashboard.displayOrder || 0;
        vm.dashboard.configJson = vm.dashboard.configJson || angular.toJson(vm.exampleJson, true);

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.dashboard.id !== null) {
                EventDashboard.update(vm.dashboard, onSaveSuccess, onSaveError);
            } else {
                EventDashboard.save(vm.dashboard, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('wamasysApp:eventDashboardUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function buildExampleJson() {
            return {
                table: {
                    enabled: true,
                    columns: [
                        {fieldCode: 'dateRecord', label: 'Date'},
                        {fieldCode: 'agency', label: 'Agence'},
                        {fieldCode: 'area', label: 'Zone'},
                        {fieldCode: 'category', label: 'Catégorie'},
                        {fieldCode: 'subCategory', label: 'Sous-catégorie'},
                        {fieldCode: 'title', label: 'Titre'},
                        {fieldCode: 'participantCount', label: 'Participants'}
                    ],
                    summaries: [
                        {fieldCode: 'participantCount', label: 'Somme participants', aggregation: 'sum'},
                        {fieldCode: 'participantCount', label: 'Moyenne participants', aggregation: 'avg'},
                        {fieldCode: 'participantCount', label: 'Médiane participants', aggregation: 'median'}
                    ]
                },
                map: {
                    enabled: true
                },
                metrics: [
                    {fieldCode: null, label: 'Nombre d’événements', aggregation: 'count'},
                    {fieldCode: 'participantCount', label: 'Participants', aggregation: 'sum'}
                ],
                timeHistograms: [
                    {
                        label: 'Évolution mensuelle',
                        interval: 'month',
                        dateFieldCode: 'dateRecord',
                        series: [
                            {fieldCode: null, label: 'Nombre d’événements', aggregation: 'count', displayType: 'bar'},
                            {fieldCode: 'participantCount', label: 'Participants', aggregation: 'sum', displayType: 'line'}
                        ]
                    }
                ],
                histograms: [
                    {groupByFieldCode: 'activity_type', label: 'Type d’activité', aggregation: 'count'},
                    {groupByFieldCode: 'zone', valueFieldCode: 'participantCount', label: 'Participants par zone', aggregation: 'sum'}
                ],
                pies: [
                    {groupByFieldCode: 'status', label: 'Statut', aggregation: 'count'},
                    {groupByFieldCode: 'responsible', valueFieldCode: 'clientUuid', label: 'Responsables uniques', aggregation: 'unique_count'}
                ]
            };
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('collecteur', {
            parent: 'entity',
            url: '/collecteur?page&sort&search',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                authenticate: true,
                pageTitle: 'wamasysApp.collecteur.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/collecteur/collecteurs.html',
                    controller: 'CollecteurController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('collecteur');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('collecteur-detail', {
            parent: 'entity',
            url: '/collecteur/{login}',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                authenticate: true,
                pageTitle: 'wamasysApp.collecteur.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/collecteur/collecteur-detail.html',
                    controller: 'CollecteurDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('collecteur');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'User', function($stateParams, User) {
                    return User.get({login : $stateParams.login});
                }]
            }
        
        
        })
        
        
        .state('collecteur.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/collecteur/collecteur-dialog.html',
                    controller: 'CollecteurDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                agence:null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('collecteur', null, { reload: true });
                }, function() {
                    $state.go('collecteur');
                });
            }]
        })
        .state('collecteur.edit', {
            parent: 'collecteur',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/collecteur/collecteur-dialog.html',
                    controller: 'CollecteurDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('collecteur', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('collecteur.delete', {
            parent: 'collecteur',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/collecteur/collecteur-delete-dialog.html',
                    controller: 'CollecteurDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('collecteur', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
        
    }

})();
;
(function () {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('Collecteur', Collecteur);

    Collecteur.$inject = ['$resource'];

    function Collecteur ($resource) {
        var service = $resource('api/collecteurs/:login', {}, {
        	'query': { method: 'GET', isArray: true, url:'api/users/searchCollecteur'},
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CollecteurController', CollecteurController);

    CollecteurController.$inject = ['$scope', '$state', 'UserSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CollecteurController ($scope, $state, UserSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
        	UserSearch.searchCollecteur({
        	
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.users = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CollecteurDialogController',CollecteurDialogController);

    CollecteurDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'Collecteur', 'JhiLanguageService'];

    function CollecteurDialogController ($stateParams, $uibModalInstance, entity, Collecteur, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN','ROLE_AREA_CONFIGURATION','ROLE_AREA_MANAGEMENT','ROLE_DATA_OPERATOR','ROLE_COLLECTOR','ROLE_READ_ONLY'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });


        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
            	Collecteur.update(vm.user, onSaveSuccess, onSaveError);
            } else {
            	Collecteur.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CollecteurDetailController', CollecteurDetailController);

    CollecteurDetailController.$inject = ['$scope', '$filter','$rootScope', '$stateParams', 'entity', 'User', 'CollectionListe'];

    function CollecteurDetailController($scope,$filter, $rootScope, $stateParams, entity, User, CollectionListe) {
        var vm = this;
        vm.user = entity;
        vm.reportCollectionList = [];
        vm.load = function (login) {
        	User.get({login: login}, function(result) {
                vm.user = result;
            });
        };
        vm.aucunResultatTrouve = false;
        
        vm.searchCollecteur = function (){
        	
			var dateDebutFiltre = $scope.date.startDate.format("YYYY-MM-DD");
			var dateFinFiltre=$scope.date.endDate.format("YYYY-MM-DD");
			CollectionListe.reportCollectionListeByCollecteur(
						{idCollecteur:vm.user.id,
						fromDate: dateDebutFiltre,
						toDate:dateFinFiltre}, 
						
						function (result){
							if(result && result.length >0){
								vm.aucunResultatTrouve = false;
								vm.reportCollectionList = result;
							}else{
								vm.aucunResultatTrouve = true;
								vm.reportCollectionList = [];
							}
						});
			
        }

        var unsubscribe = $rootScope.$on('wamasysApp:collecteurUpdate', function(event, result) {
            vm.user = result;
        });
        
        $scope.$on('$destroy', unsubscribe);

        
        $scope.date = {
                startDate: moment().subtract(1, "month"),
                endDate: moment()
            };

		      
		 $scope.openRangeDateTimePicker = function() {
					$('#daterange1').data('daterangepicker').toggle();
			}
		

		    $scope.opts = {
		    		eventHandlers:{'apply.daterangepicker':function(ev) {
		    		//	var dateDebutFiltredd =$scope.date.startDate.format("yyyy-MM-dd");
		    		//	var dateDesdfsdfbutFiltredd =new Date($scope.date.startDate);
		    		
		    			
		    			}
		    		}
		    };
	
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
   /*
    
       	.state('cluster', {
            parent: 'entity',
            url: '/cluster?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.cluster.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/cluster/clusters.html',
                    controller: 'ClusterController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cluster');
                    $translatePartialLoader.addPart('etatCluster');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        */
        .state('cluster-detail', {
            parent: 'entity',
            url: '/cluster/{id}?page&sort',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.cluster.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/cluster/cluster-detail.html',
                    controller: 'ClusterDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
            	pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cluster');
                    $translatePartialLoader.addPart('etatCluster');
                    $translatePartialLoader.addPart('individualMeter');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Cluster', function($stateParams, Cluster) {
                    return Cluster.get({id : $stateParams.id});
                }]
            }
        })
        .state('compteur.cluster.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cluster/cluster-dialog.html',
                    controller: 'ClusterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                numeroSerie: null,
                                dateCreation: null,
                                emplacement: null,
                                etat: null,
                                dateSuppression: null,
                                longitude: null,
                                latitude: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('compteur.cluster', null, { reload: true });
                }, function() {
                    $state.go('compteur.cluster');
                });
            }]
        })
        .state('compteur.cluster.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cluster/cluster-dialog.html',
                    controller: 'ClusterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Cluster', function(Cluster) {
                            return Cluster.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('compteur.cluster', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('compteur.cluster.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cluster/cluster-delete-dialog.html',
                    controller: 'ClusterDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Cluster', function(Cluster) {
                            return Cluster.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('compteur.cluster', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('Cluster', Cluster);

    Cluster.$inject = ['$resource', 'DateUtils'];

    function Cluster ($resource, DateUtils) {
        var resourceUrl =  'api/clusters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateCreation = DateUtils.convertDateTimeFromServer(data.dateCreation);
                    data.dateSuppression = DateUtils.convertDateTimeFromServer(data.dateSuppression);
                    return data;
                }
            },
            'update': { method:'PUT' },

            'queryActif': { method: 'GET', url:'api/clusters-actif', isArray: true},
            'clusterActifByCollecteur' :{
             	 method:'GET', 
             	isArray: true,
             	 url :'api/clusters-actif-by-collector/:idCollector'
             }
           
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ClusterController', ClusterController);

    ClusterController.$inject = ['$scope', '$state', 'Cluster', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ClusterController ($scope, $state, Cluster, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Cluster.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.clusters = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ClusterDialogController', ClusterDialogController);

    ClusterDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Cluster',  'UserSearch', 'IndividualMeter','WaterNetwork'];

    function ClusterDialogController ($scope, $stateParams, $uibModalInstance, entity, Cluster, UserSearch, IndividualMeter,WaterNetwork) {
        var vm = this;
        vm.cluster = entity;
        vm.users = UserSearch.searchCollecteur();
        vm.individualmeters = IndividualMeter.query();
        vm.waterNetworks = WaterNetwork.queryFilterArea();
        vm.load = function(id) {
            Cluster.get({id : id}, function(result) {
                vm.cluster = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:clusterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.cluster.id !== null) {
                Cluster.update(vm.cluster, onSaveSuccess, onSaveError);
            } else {
                Cluster.save(vm.cluster, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateCreation = false;
        vm.datePickerOpenStatus.dateSuppression = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ClusterDetailController', ClusterDetailController);

    ClusterDetailController.$inject = ['$scope', '$state', '$rootScope', '$stateParams', 'entity', 'Cluster', 'Agence', 'User', 'IndividualMeterSearch', 'pagingParams', 'paginationConstants', 'ParseLinks', 'AlertService', ];

    function ClusterDetailController($scope, $state, $rootScope, $stateParams, entity, Cluster, Agence, User, IndividualMeterSearch, pagingParams, paginationConstants, ParseLinks, AlertService) {
        var vm = this;
        vm.cluster = entity;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.load = function () {
        	IndividualMeterSearch.query({
        		cluster: $stateParams.id,
         	   page: pagingParams.page - 1,
               size: paginationConstants.itemsPerPage
        	}, function(result, headers) {
                vm.individualMeterList = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
            },  function (error) {
                AlertService.error(error.data.message);
            });
        };
        vm.load();
        var unsubscribe = $rootScope.$on('wamasysApp:clusterUpdate', function(event, result) {
            vm.cluster = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.transition = function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                id:$stateParams.id,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            });
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ClusterDeleteController',ClusterDeleteController);

    ClusterDeleteController.$inject = ['$uibModalInstance', 'entity', 'Cluster'];

    function ClusterDeleteController($uibModalInstance, entity, Cluster) {
        var vm = this;
        vm.cluster = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Cluster.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-form', {
            parent: 'entity',
            url: '/event-form?page&sort&search&categoryId&subCategoryId&agencyId&areaId&workflowStatus&startDate&endDate&searchText',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN','ROLE_EVT_EDIT','ROLE_EVT_READ_ONLY'],
                pageTitle: 'wamasysApp.eventForm.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/event-form/event-forms.html',
                    controller: 'EventFormController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventForm');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-form-detail', {
            parent: 'entity',
            url: '/event-form/{id}',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN','ROLE_EVT_EDIT','ROLE_EVT_READ_ONLY'],
                pageTitle: 'wamasysApp.eventForm.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/event-form/event-form-detail.html',
                    controller: 'EventFormDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventForm');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventForm', function($stateParams, EventForm) {
                    return EventForm.get({id : $stateParams.id});
                }]
            }
        })
        .state('event-form.new', {
            parent: 'event-form',
            url: '/new',
            data: {
                authorities: ['ROLE_EVT_EDIT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form/event-form-dialog.html',
                    controller: 'EventFormDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dateRecord: new Date(),
                                cout: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-form', null, { reload: true });
                }, function() {
                    $state.go('event-form');
                });
            }]
        })
        .state('event-form.edit', {
            parent: 'event-form',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_EVT_EDIT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form/event-form-dialog.html',
                    controller: 'EventFormDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventForm', function(EventForm) {
                            return EventForm.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-form', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-form-detail.edit', {
            parent: 'event-form-detail',
            url: '/edit',
            data: {
                authorities: ['ROLE_EVT_EDIT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form/event-form-dialog.html',
                    controller: 'EventFormDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventForm', function(EventForm) {
                            return EventForm.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-form-detail', {id: $stateParams.id}, { reload: true });
                }, function() {
                    $state.go('event-form-detail', {id: $stateParams.id});
                });
            }]
        })
        .state('event-form.delete', {
            parent: 'event-form',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_EVT_EDIT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form/event-form-delete-dialog.html',
                    controller: 'EventFormDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventForm', function(EventForm) {
                            return EventForm.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-form', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('EventForm', EventForm);

    EventForm.$inject = ['$resource', 'DateUtils', '$http', '$q'];

    function EventForm ($resource, DateUtils, $http, $q) {
        var resourceUrl =  'api/form-event/:id';

        var resource = $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateRecord = DateUtils.convertDateTimeFromServer(data.dateRecord);
                    return data;
                }
            },
            'history': {
                method: 'GET',
                isArray: true,
                url: 'api/form-event/:id/history'
            },
            'bulkStatus': { method: 'POST', url: 'api/form-event/bulk-status' },
            'update': { method:'PUT'}
        });

        resource.validateDocument = function(params, success, error) {
            return postAction(buildActionUrl(params, 'validate'), success, error);
        };

        resource.controlDocument = function(params, success, error) {
            return postAction(buildActionUrl(params, 'control'), success, error);
        };

        resource.createTicket = function(params, success, error) {
            return postAction(buildActionUrl(params, 'create-ticket'), success, error);
        };

        return resource;

        function buildActionUrl(params, actionName) {
            var eventId = params && params.id ? params.id : null;
            if (!eventId) {
                throw new Error('Identifiant de l’événement manquant.');
            }
            return 'api/form-event/' + encodeURIComponent(eventId) + '/' + actionName;
        }

        function postAction(url, success, error) {
            return $http.post(url).then(function(response) {
                if (angular.isFunction(success)) {
                    success(response.data, response.headers);
                }
                return response.data;
            }, function(response) {
                if (angular.isFunction(error)) {
                    error(response);
                }
                return $q.reject(response);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormController', EventFormController);

    EventFormController.$inject = ['$scope', '$state', 'EventForm', 'ParseLinks', '$filter', 'AlertService', 'EventFormCategory', 'pagingParams', 'paginationConstants', 'Principal', '$window', '$uibModal', '$translate'];

    function EventFormController($scope, $state, EventForm, ParseLinks, $filter, AlertService, EventFormCategory, pagingParams, paginationConstants, Principal, $window, $uibModal, $translate) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.updateSubCategory = updateSubCategory;
        vm.updateAreaFilter = updateAreaFilter;
        vm.statusLabel = statusLabel;
        vm.searchText = $state.params.searchText;
        vm.workflowStatus = $state.params.workflowStatus || null;
        vm.listSubCategory = [];
        vm.listAgency = [];
        vm.listArea = [];
        vm.allAreas = [];
        vm.selected = {};
        vm.allMatching = false;
        vm.bulkStatuses = [];
        vm.selectedCount = selectedCount;
        vm.togglePage = togglePage;
        vm.toggleMatching = toggleMatching;
        vm.changeStatuses = changeStatuses;
        vm.openBulkStatus = openBulkStatus;
        vm.showWorkflowHelp = function() {
            $uibModal.open({templateUrl: 'eventWorkflowHelp.html', size: 'sm'});
        };
        var loadedFilters;
        var selectionFilters;
        var bulkModal;

        vm.date = {
            startDate: $state.params.startDate ? new Date($state.params.startDate) : null,
            endDate: $state.params.endDate ? new Date($state.params.endDate) : null
        };

        if ($state.params.categoryId) {
            vm.category = {id: $state.params.categoryId};
            vm.updateSubCategory();
        }
        if ($state.params.subCategoryId) {
            vm.subCategory = {id: $state.params.subCategoryId};
        }

        EventFormCategory.query({
            page: 0,
            size: 100
        }, function(data) {
            vm.listCategory = data;
        }, onError);

        Principal.identity().then(function(account) {
            var authorities = (account && account.authorities) || [];
            vm.canEdit = authorities.indexOf('ROLE_EVT_EDIT') !== -1;
            vm.canValidate = authorities.indexOf('ROLE_FORM_VALIDATION') !== -1;
            vm.canBulkChange = vm.canEdit || vm.canValidate;
            angular.forEach(['DRAFT', 'SUBMITTED', 'VALIDATED', 'CONTROLLED'], function(status) {
                if ((status === 'DRAFT' || status === 'SUBMITTED') ? vm.canEdit : vm.canValidate) {
                    vm.bulkStatuses.push(status);
                }
            });
            hydrateAccessibleAreas(account);
            vm.loadAll();
        }, function() {
            vm.loadAll();
        });

        function hydrateAccessibleAreas(account) {
            var areas = (account && account.agencesRattachement) ? angular.copy(account.agencesRattachement) : [];
            if ((!areas || !areas.length) && account && account.agence) {
                areas = [angular.copy(account.agence)];
            }

            vm.allAreas = (areas || []).sort(function(left, right) {
                return String(left.nom || '').localeCompare(String(right.nom || ''));
            });
            vm.listAgency = buildAgencies(vm.allAreas);

            if ($state.params.agencyId) {
                vm.agency = findById(vm.listAgency, $state.params.agencyId);
            }
            if ($state.params.areaId) {
                vm.area = findById(vm.allAreas, $state.params.areaId);
                if (!vm.agency && vm.area && vm.area.entiteParente) {
                    vm.agency = {
                        id: vm.area.entiteParente.id,
                        nom: vm.area.entiteParente.nom
                    };
                }
            // Garder le choix « toutes les zones » lors d'une recherche explicite.
            } else if (!$state.params.search && account && account.agence) {
                vm.area = findById(vm.allAreas, account.agence.id);
                if (vm.area && vm.area.entiteParente) {
                    vm.agency = {
                        id: vm.area.entiteParente.id,
                        nom: vm.area.entiteParente.nom
                    };
                }
            }

            updateAreaFilter();
        }

        function buildAgencies(areas) {
            var byId = {};
            angular.forEach(areas || [], function(area) {
                if (!area || !area.entiteParente || !area.entiteParente.id) {
                    return;
                }
                byId[area.entiteParente.id] = {
                    id: area.entiteParente.id,
                    nom: area.entiteParente.nom
                };
            });
            return Object.keys(byId).map(function(key) {
                return byId[key];
            }).sort(function(left, right) {
                return String(left.nom || '').localeCompare(String(right.nom || ''));
            });
        }

        function findById(items, id) {
            var searchedId = String(id);
            return (items || []).find(function(item) {
                return item && String(item.id) === searchedId;
            }) || null;
        }

        function updateAreaFilter() {
            var selectedAgencyId = vm.agency ? String(vm.agency.id) : null;
            vm.listArea = (vm.allAreas || []).filter(function(area) {
                if (!selectedAgencyId) {
                    return true;
                }
                return area.entiteParente && String(area.entiteParente.id) === selectedAgencyId;
            });
            if (vm.area && !findById(vm.listArea, vm.area.id)) {
                vm.area = null;
            }
        }

        function updateSubCategory() {
            if (!vm.category || !vm.category.id) {
                vm.listSubCategory = [];
                vm.subCategory = null;
                return;
            }

            EventFormCategory.getListSubCategory({id: vm.category.id}, function(result) {
                vm.listSubCategory = result;
            }, onError);
        }

        function loadAll() {
            vm.currentSearch = true;
            vm.loading = true;
            vm.selected = {};
            vm.allMatching = false;
            vm.pageSelected = false;
            loadedFilters = currentFilters();
            EventForm.query(angular.extend({}, loadedFilters, {
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }), onLoadSuccess, function(error) {
                vm.loading = false;
                onError(error);
            });
        }

        function currentFilters() {
            return {
                searchText: vm.searchText,
                categoryId: vm.category ? vm.category.id : null,
                subCategoryId: vm.subCategory ? vm.subCategory.id : null,
                agencyId: vm.agency ? vm.agency.id : null,
                areaId: vm.area ? vm.area.id : null,
                workflowStatus: vm.workflowStatus || null,
                fromDate: vm.date ? $filter('date')(vm.date.startDate, 'yyyy-MM-dd') : null,
                toDate: vm.date ? $filter('date')(vm.date.endDate, 'yyyy-MM-dd') : null
            };
        }

        function selectedCount() {
            return vm.allMatching ? Number(vm.totalItems) : Object.keys(vm.selected).filter(function(id) {
                return vm.selected[id];
            }).length;
        }

        function togglePage() {
            angular.forEach(vm.eventForms, function(event) { vm.selected[event.id] = vm.pageSelected; });
        }

        function toggleMatching() {
            vm.selected = {};
            vm.pageSelected = false;
            // Conserver les filtres appliqués, jamais des filtres modifiés mais pas encore recherchés.
            selectionFilters = vm.allMatching ? angular.copy(loadedFilters) : null;
        }

        function openBulkStatus() {
            if (bulkModal || !vm.canBulkChange || vm.bulkBusy || vm.loading || !Number(vm.totalItems)) { return; }
            vm.bulkError = null;
            // Partager la sélection de la liste avec la fenêtre, sans ajouter de zone permanente.
            bulkModal = $uibModal.open({
                templateUrl: 'eventBulkStatus.html',
                scope: $scope,
                backdrop: 'static',
                keyboard: false
            });
            bulkModal.result.then(clearBulkModal, clearBulkModal);
        }

        function clearBulkModal() {
            bulkModal = null;
            // Une sélection globale doit toujours rester explicite dans la fenêtre de modification.
            vm.allMatching = false;
            selectionFilters = null;
        }

        function changeStatuses() {
            if (vm.bulkBusy || vm.loading || !selectedCount() || !vm.targetStatus) { return; }
            if (!angular.equals(currentFilters(), loadedFilters)) {
                vm.bulkError = $translate.instant('wamasysApp.eventForm.filtersChanged');
                AlertService.error(vm.bulkError);
                return;
            }
            if (!$window.confirm($translate.instant('wamasysApp.eventForm.confirmBulk', {count: selectedCount(), status: statusLabel(vm.targetStatus)}))) { return; }
            var payload = angular.extend({}, vm.allMatching ? selectionFilters : {}, {
                allMatching: vm.allMatching, targetStatus: vm.targetStatus, selectedVersions: {}
            });
            angular.forEach(vm.eventForms, function(event) {
                if (vm.selected[event.id]) { payload.selectedVersions[event.id] = event.documentVersion; }
            });
            vm.bulkBusy = true;
            vm.bulkError = null;
            vm.bulkResult = null;
            EventForm.bulkStatus(payload, function(result) {
                vm.bulkBusy = false;
                vm.bulkResult = result;
                if (bulkModal) { bulkModal.close(); }
                loadAll();
            }, function(error) {
                vm.bulkBusy = false;
                vm.bulkError = error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.technicalError');
                onError(error);
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function onLoadSuccess(data, headers) {
            vm.loading = false;
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.eventForms = data;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.technicalError'));
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                searchText: vm.searchText,
                categoryId: vm.category ? vm.category.id : null,
                subCategoryId: vm.subCategory ? vm.subCategory.id : null,
                agencyId: vm.agency ? vm.agency.id : null,
                areaId: vm.area ? vm.area.id : null,
                workflowStatus: vm.workflowStatus || null,
                startDate: vm.date ? $filter('date')(vm.date.startDate, 'yyyy-MM-dd') : null,
                endDate: vm.date ? $filter('date')(vm.date.endDate, 'yyyy-MM-dd') : null
            });
        }

        function search() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'dateRecord';
            vm.reverse = false;
            vm.currentSearch = true;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchText = null;
            vm.category = null;
            vm.subCategory = null;
            vm.agency = null;
            vm.area = null;
            vm.workflowStatus = null;
            vm.listSubCategory = [];
            vm.date.startDate = null;
            vm.date.endDate = null;
            vm.currentSearch = true;
            vm.updateAreaFilter();
            vm.transition();
        }

        function statusLabel(status) {
            var labels = {
                DRAFT: $translate.instant('wamasysApp.eventForm.statuses.DRAFT'),
                SUBMITTED: $translate.instant('wamasysApp.eventForm.statuses.SUBMITTED'),
                VALIDATED: $translate.instant('wamasysApp.eventForm.statuses.VALIDATED'),
                CONTROLLED: $translate.instant('wamasysApp.eventForm.statuses.CONTROLLED'),
                DELETED: $translate.instant('wamasysApp.eventForm.statuses.DELETED')
            };
            return labels[status] || status;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormDialogController', EventFormDialogController);

    EventFormDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'AlertService', 'EventForm', 'EventFormCategory', 'EventFieldDefinition', 'Principal', '$translate'];

    function EventFormDialogController($scope, $stateParams, $uibModalInstance, entity, AlertService, EventForm, EventFormCategory, EventFieldDefinition, Principal, $translate) {
        var vm = this;

        vm.eventForm = entity;
        vm.fieldDefinitionsByCode = {};
        vm.listSubCategory = [];
        vm.inputsCustomFields = [];
        vm.baseFieldConfig = defaultBaseFields();
        vm.isAdminUser = false;
        vm.hasFormValidationRight = false;
        vm.workflowStatusLocked = false;
        vm.allWorkflowStatuses = [
            {code: 'DRAFT', label: $translate.instant('wamasysApp.eventForm.statuses.DRAFT')},
            {code: 'SUBMITTED', label: $translate.instant('wamasysApp.eventForm.statuses.SUBMITTED')},
            {code: 'VALIDATED', label: $translate.instant('wamasysApp.eventForm.statuses.VALIDATED')},
            {code: 'CONTROLLED', label: $translate.instant('wamasysApp.eventForm.statuses.CONTROLLED')}
        ];
        vm.workflowStatuses = [];
        vm.changeReasons = [
            {code: 'MANUAL_CORRECTION', label: $translate.instant('wamasysApp.eventForm.reasons.MANUAL_CORRECTION')},
            {code: 'AUTO_CORRECTION', label: $translate.instant('wamasysApp.eventForm.reasons.AUTO_CORRECTION')},
            {code: 'COMPLEMENTARY_INFO_ADDED', label: $translate.instant('wamasysApp.eventForm.reasons.COMPLEMENTARY_INFO_ADDED')}
        ];

        vm.updateSubCategory = updateSubCategory;
        vm.onchangeSubCategory = onchangeSubCategory;
        vm.save = save;
        vm.saveAsDraft = saveAsDraft;
        vm.saveAndSubmit = saveAndSubmit;
        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.shouldShowBaseField = shouldShowBaseField;
        vm.isBaseFieldRequired = isBaseFieldRequired;
        vm.hasMissingRequiredGps = hasMissingRequiredGps;
        vm.subCategoryOptionLabel = subCategoryOptionLabel;
        vm.getSmileyOptions = getSmileyOptions;
        vm.canUseDraftSubmitActions = canUseDraftSubmitActions;
        vm.refreshWorkflowStatuses = refreshWorkflowStatuses;

        vm.eventForm.workflowStatus = vm.eventForm.workflowStatus || 'DRAFT';
        vm.eventForm.changeReason = 'MANUAL_CORRECTION';

        vm.datePickerOpenStatus = {
            dateRecord: false
        };

        Principal.identity().then(function(account) {
            var authorities = account && account.authorities ? account.authorities : [];
            vm.isAdminUser = authorities.indexOf('ROLE_ADMIN') !== -1 || authorities.indexOf('ROLE_SUPER_ADMIN') !== -1;
            vm.hasFormValidationRight = authorities.indexOf('ROLE_FORM_VALIDATION') !== -1;
            vm.refreshWorkflowStatuses();
            if (vm.eventForm && vm.eventForm.subCategory && vm.eventForm.subCategory.customFields) {
                vm.onchangeSubCategory();
            }
        });

        loadFieldDefinitions();

        if (vm.eventForm && vm.eventForm.$promise) {
            vm.eventForm.$promise.then(function(result) {
                vm.eventForm.category = {id: result.categoryId, label: result.category};
                vm.eventForm.subCategory = {
                    id: result.subCategoryId,
                    label: result.subCategory,
                    versionNumber: result.subCategoryVersionNumber,
                    customFields: result.subCategoryCustomFields
                };
                vm.eventForm.workflowStatus = result.workflowStatus || 'DRAFT';
                vm.eventForm.changeReason = 'MANUAL_CORRECTION';
                vm.refreshWorkflowStatuses();
                vm.updateSubCategory();
            });
        }

        EventFormCategory.query({
            page: 0,
            size: 100
        }, onCategoryLoadSuccess, onError);

        function updateSubCategory() {
            vm.listSubCategory = [];
            vm.inputsCustomFields = [];
            vm.baseFieldConfig = defaultBaseFields();

            if (!vm.eventForm.category || !vm.eventForm.category.id) {
                return;
            }

            EventFormCategory.getListSubCategory({id: vm.eventForm.category.id}, function(result) {
                vm.listSubCategory = result;
                if (vm.eventForm.subCategory) {
                    ensureCurrentSubCategoryExists();
                }
                if (vm.listSubCategory && vm.eventForm.subCategory && vm.eventForm.subCategory.id) {
                    angular.forEach(vm.listSubCategory, function(item) {
                        if (item.id === vm.eventForm.subCategory.id) {
                            vm.eventForm.subCategory.customFields = item.customFields;
                            vm.onchangeSubCategory();
                        }
                    });
                }
            }, onError);
        }

        function onchangeSubCategory() {
            vm.inputsCustomFields = [];
            vm.baseFieldConfig = defaultBaseFields();

            if (!vm.eventForm.subCategory || !vm.eventForm.subCategory.customFields) {
                return;
            }

            try {
                var customFields = angular.fromJson(vm.eventForm.subCategory.customFields);
                vm.baseFieldConfig = resolveBaseFieldConfig(customFields);
                angular.forEach(customFields.fields || [], function(fieldConfig) {
                    var inputField = buildInputField(fieldConfig);
                    if (!inputField.hidden) {
                        vm.inputsCustomFields.push(inputField);
                    }
                });
            } catch (e) {
                vm.inputsCustomFields = [];
                vm.baseFieldConfig = defaultBaseFields();
                return;
            }

            populateInputValues(vm.eventForm.answersJson);
        }

        function save(form) {
            if (canUseDraftSubmitActions()) {
                saveAndSubmit(form);
                return;
            }
            saveWithStatus(form, vm.eventForm.workflowStatus || 'SUBMITTED');
        }

        function saveAsDraft(form) {
            saveWithStatus(form, 'DRAFT');
        }

        function saveAndSubmit(form) {
            saveWithStatus(form, 'SUBMITTED');
        }

        function saveWithStatus(form, workflowStatus) {
            if (form) {
                form.$setSubmitted();
                if (form.$invalid || vm.hasMissingRequiredGps()) {
                    return;
                }
            }

            var customFieldValues = {};
            angular.forEach(vm.inputsCustomFields, function(inputField) {
                // Une date métier est stockée sans heure ni fuseau pour rester stable sur le Web et le mobile.
                customFieldValues[inputField.storageName] = inputField.type === 'date'
                    ? formatLocalDate(inputField.value) : inputField.value;
            });

            if (!vm.eventForm.category || !vm.eventForm.category.id || !vm.eventForm.subCategory || !vm.eventForm.subCategory.id) {
                AlertService.error($translate.instant('wamasysApp.eventForm.categoryRequired'));
                return;
            }

            var payload = angular.copy(vm.eventForm);
            payload.answersJson = customFieldValues;
            payload.workflowStatus = workflowStatus || vm.eventForm.workflowStatus || 'DRAFT';
            payload.changeReason = vm.eventForm.changeReason || 'MANUAL_CORRECTION';
            payload.categoryId = vm.eventForm.category.id;
            payload.subCategoryId = vm.eventForm.subCategory.id;
            payload.category = vm.eventForm.category.label;
            payload.subCategory = vm.eventForm.subCategory.label;

            vm.isSaving = true;
            if (payload.id !== null) {
                EventForm.update(payload, onSaveSuccess, onSaveError);
            } else {
                EventForm.save(payload, onSaveSuccess, onSaveError);
            }
        }

        function canUseDraftSubmitActions() {
            return !vm.eventForm.id
                || !vm.eventForm.workflowStatus
                || vm.eventForm.workflowStatus === 'DRAFT'
                || vm.eventForm.workflowStatus === 'SUBMITTED';
        }

        function refreshWorkflowStatuses() {
            var currentStatus = vm.eventForm.workflowStatus || 'DRAFT';
            if (vm.hasFormValidationRight) {
                vm.workflowStatuses = angular.copy(vm.allWorkflowStatuses);
                if (!vm.eventForm.id) {
                    vm.workflowStatuses = vm.workflowStatuses.filter(function(status) {
                        return status.code === 'DRAFT' || status.code === 'SUBMITTED';
                    });
                }
                vm.workflowStatusLocked = false;
                return;
            }

            vm.workflowStatuses = vm.allWorkflowStatuses.filter(function(status) {
                return status.code === 'DRAFT'
                    || status.code === 'SUBMITTED'
                    || status.code === currentStatus;
            });
            vm.workflowStatusLocked = currentStatus === 'VALIDATED' || currentStatus === 'CONTROLLED';

            if (!vm.workflowStatuses.some(function(status) { return status.code === vm.eventForm.workflowStatus; })) {
                vm.eventForm.workflowStatus = 'DRAFT';
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function shouldShowBaseField(fieldKey) {
            return !!(vm.baseFieldConfig[fieldKey] && vm.baseFieldConfig[fieldKey].visible);
        }

        function isBaseFieldRequired(fieldKey) {
            return !!(vm.baseFieldConfig[fieldKey] && vm.baseFieldConfig[fieldKey].visible && vm.baseFieldConfig[fieldKey].required);
        }

        function hasMissingRequiredGps() {
            if (!isBaseFieldRequired('gps')) {
                return false;
            }
            return vm.eventForm.lat === null || vm.eventForm.lat === undefined
                || vm.eventForm.lon === null || vm.eventForm.lon === undefined;
        }

        function loadFieldDefinitions() {
            EventFieldDefinition.query({
                inclInactive: false,
                page: 0,
                size: 2000,
                sort: ['fieldCode,asc']
            }, function(result) {
                angular.forEach(result, function(definition) {
                    vm.fieldDefinitionsByCode[definition.fieldCode] = definition;
                });
                if (vm.eventForm && vm.eventForm.subCategory && vm.eventForm.subCategory.customFields) {
                    vm.onchangeSubCategory();
                }
            }, function(error) {
                AlertService.error(error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.dictionaryLoadError'));
            });
        }

        function onCategoryLoadSuccess(data) {
            vm.listCategory = data;
            if (vm.eventForm.category) {
                var index = vm.listCategory.findIndex(function(element) {
                    return element.id === vm.eventForm.category.id;
                });
                if (index === -1) {
                    vm.listCategory.push(vm.eventForm.category);
                }
            }
        }

        function ensureCurrentSubCategoryExists() {
            var index = vm.listSubCategory.findIndex(function(element) {
                return element.id === vm.eventForm.subCategory.id;
            });
            if (index === -1) {
                vm.listSubCategory.push(vm.eventForm.subCategory);
            }
        }

        function buildInputField(fieldConfig) {
            var dictionaryFieldCode = fieldConfig.dictionaryFieldCode || fieldConfig.fieldCode;
            var definition = dictionaryFieldCode ? vm.fieldDefinitionsByCode[dictionaryFieldCode] : null;
            var storageName = fieldConfig.name || fieldConfig.code || dictionaryFieldCode;
            var name = storageName ? storageName.replace(/\./g, '_') : 'field_' + vm.inputsCustomFields.length;
            var hidden = fieldConfig.hidden !== undefined && fieldConfig.hidden !== null ? !!fieldConfig.hidden : false;

            if (!hidden && !vm.isAdminUser && definition && definition.hiddenForEncoder) {
                hidden = true;
            }

            return {
                required: fieldConfig.required !== undefined && fieldConfig.required !== null ? !!fieldConfig.required : !!(definition && definition.requiredByDefault),
                hidden: hidden,
                label: fieldConfig.label || (definition ? definition.label : storageName),
                unit: fieldConfig.unit || (definition ? definition.unit : null),
                name: name,
                storageName: storageName,
                dictionaryFieldCode: dictionaryFieldCode,
                type: normalizeFieldType(definition && definition.dataType ? definition.dataType : (fieldConfig.type || 'text')),
                tooltip: fieldConfig.tooltip || (definition ? definition.description : null),
                values: resolvePossibleValues(fieldConfig, definition),
                displayOptions: buildDisplayOptions(fieldConfig.type || (definition ? definition.dataType : 'text'),
                    resolvePossibleValues(fieldConfig, definition)),
                legacyNames: parseLegacyNames(fieldConfig.legacyNames || fieldConfig.legacyCodes)
            };
        }

        function resolveBaseFieldConfig(customFields) {
            var resolved = defaultBaseFields();
            var baseFields = customFields && customFields.baseFields ? customFields.baseFields : {};

            angular.forEach(resolved, function(defaultConfig, fieldKey) {
                var current = baseFields[fieldKey] || {};
                resolved[fieldKey] = {
                    visible: current.visible !== false,
                    required: current.visible === false ? false : (current.required === true || (defaultConfig.required && current.required !== false))
                };
            });

            return resolved;
        }

        function defaultBaseFields() {
            return {
                dateRecord: {visible: true, required: true},
                title: {visible: true, required: true},
                comment: {visible: true, required: false},
                gps: {visible: true, required: false}
            };
        }

        function normalizeFieldType(type) {
            if (!type) {
                return 'text';
            }
            if (type === 'datetime') {
                return 'text';
            }
            if (type === 'ref_contrat') {
                return 'text';
            }
            return type;
        }

        function resolvePossibleValues(fieldConfig, definition) {
            var sourceType = fieldConfig.type || (definition ? definition.dataType : null);
            if (sourceType === 'satisfaction_smiley') {
                return ['very_unhappy', 'neutral', 'somewhat_happy', 'very_happy'];
            }
            if (fieldConfig.values !== undefined && fieldConfig.values !== null && fieldConfig.values !== '') {
                return splitValues(fieldConfig.values);
            }
            if (fieldConfig.valuePossibleJson) {
                return parsePossibleValuesJson(fieldConfig.valuePossibleJson);
            }
            if (definition && definition.valuePossibleJson) {
                return parsePossibleValuesJson(definition.valuePossibleJson);
            }
            return null;
        }

        function parsePossibleValuesJson(value) {
            if (!value) {
                return null;
            }
            try {
                var parsed = angular.fromJson(value);
                return angular.isArray(parsed) ? parsed : null;
            } catch (e) {
                return splitValues(value);
            }
        }

        function parseLegacyNames(value) {
            if (!value) {
                return [];
            }
            if (angular.isArray(value)) {
                return value;
            }
            return splitValues(value);
        }

        function buildDisplayOptions(fieldType, values) {
            if (fieldType !== 'satisfaction_smiley') {
                return [];
            }
            var labels = {
                very_unhappy: $translate.instant('wamasysApp.eventForm.smileys.very_unhappy'),
                neutral: $translate.instant('wamasysApp.eventForm.smileys.neutral'),
                somewhat_happy: $translate.instant('wamasysApp.eventForm.smileys.somewhat_happy'),
                very_happy: $translate.instant('wamasysApp.eventForm.smileys.very_happy')
            };
            return (values || []).map(function(value) {
                return {
                    value: value,
                    label: labels[value] || value
                };
            });
        }

        function subCategoryOptionLabel(item) {
            if (!item) {
                return '';
            }
            return item.versionNumber ? item.label + ' (v' + item.versionNumber + ')' : item.label;
        }

        function getSmileyOptions(item) {
            return item && item.displayOptions ? item.displayOptions : [];
        }

        function splitValues(value) {
            return String(value).split(/[;,]/).map(function(item) {
                return item.trim();
            }).filter(function(item) {
                return item.length > 0;
            });
        }

        function populateInputValues(rawJson) {
            if (!rawJson) {
                return;
            }
            var answers;
            try {
                answers = angular.fromJson(rawJson);
            } catch (e) {
                return;
            }

            angular.forEach(vm.inputsCustomFields, function(inputField) {
                var candidateCodes = [inputField.storageName, inputField.dictionaryFieldCode].concat(inputField.legacyNames || []);
                for (var i = 0; i < candidateCodes.length; i++) {
                    var candidateCode = candidateCodes[i];
                    if (candidateCode !== undefined && candidateCode !== null && answers[candidateCode] !== undefined) {
                        inputField.value = inputField.type === 'date'
                            ? parseIsoDate(answers[candidateCode]) : answers[candidateCode];
                        break;
                    }
                }
            });
        }

        function parseIsoDate(value) {
            if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) {
                return null;
            }
            var parts = value.split('-');
            var date = new Date(+parts[0], +parts[1] - 1, +parts[2]);
            return date.getFullYear() === +parts[0] && date.getMonth() === +parts[1] - 1
                && date.getDate() === +parts[2] ? date : null;
        }

        function formatLocalDate(value) {
            if (!value) {
                return null;
            }
            var year = value.getFullYear();
            var month = ('0' + (value.getMonth() + 1)).slice(-2);
            var day = ('0' + value.getDate()).slice(-2);
            return year + '-' + month + '-' + day;
        }

        function onSaveSuccess(result) {
            $scope.$emit('wamasysApp:eventFormUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError(error) {
            vm.isSaving = false;
            AlertService.error(error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.saveError'));
        }

        function onError(error) {
            AlertService.error(error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.technicalError'));
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormDetailController', EventFormDetailController);

    EventFormDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'EventForm', 'EventFormAttachmentService', 'Principal', 'AlertService', '$window', 'EquipmentParc', '$translate'];

    function EventFormDetailController($scope, $rootScope, $stateParams, entity, EventForm, EventFormAttachmentService, Principal, AlertService, $window, EquipmentParc, $translate) {
        var vm = this;

        vm.eventForm = entity;
        vm.history = [];
        vm.linkedEquipment = [];
        vm.attachments = [];
        vm.eventLoaded = false;
        vm.hasFormValidationRight = false;
        vm.hasEditRight = false;
        vm.selectedAttachmentFile = null;
        vm.selectedAttachmentFileName = null;

        vm.statusLabel = statusLabel;
        vm.reasonLabel = reasonLabel;
        vm.validateDocument = validateDocument;
        vm.controlDocument = controlDocument;
        vm.createTicket = createTicket;
        vm.canValidate = canValidate;
        vm.canControl = canControl;
        vm.setAttachmentFile = setAttachmentFile;
        vm.uploadAttachment = uploadAttachment;
        vm.downloadAttachment = downloadAttachment;

        Principal.identity().then(function(account) {
            var authorities = account && account.authorities ? account.authorities : [];
            vm.canReadEquipment = account && account.modules && account.modules.indexOf('EQUIPMENT') >= 0 && ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_EQUIPMENT_READ', 'ROLE_EQUIPMENT_EDIT', 'ROLE_EQUIPMENT_SECRETS'].some(function (role) { return authorities.indexOf(role) >= 0; });
            vm.canCreateEquipment = vm.canReadEquipment && ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_EQUIPMENT_EDIT'].some(function (role) { return authorities.indexOf(role) >= 0; });
            loadLinkedEquipment(resolveEventId());
            vm.hasFormValidationRight = authorities.indexOf('ROLE_FORM_VALIDATION') !== -1;
            vm.hasEditRight = authorities.indexOf('ROLE_EVT_EDIT') !== -1
                || authorities.indexOf('ROLE_ADMIN') !== -1
                || authorities.indexOf('ROLE_SUPER_ADMIN') !== -1;
        });

        vm.load = function(id) {
            EventForm.get({id: id}, function(result) {
                setEventForm(result);
            });
            loadHistory(id);
            loadAttachments(id);
        };

        if (vm.eventForm && vm.eventForm.$promise) {
            vm.eventForm.$promise.then(function(result) {
                setEventForm(result);
            });
        } else if (vm.eventForm) {
            setEventForm(vm.eventForm);
        }

        var unsubscribe = $rootScope.$on('wamasysApp:eventFormUpdate', function(event, result) {
            setEventForm(result);
        });
        $scope.$on('$destroy', unsubscribe);

        function setEventForm(eventForm) {
            prepareEventForm(eventForm);
            vm.eventForm = eventForm;
            vm.eventLoaded = !!resolveEventId();
            if (vm.eventLoaded) {
                loadHistory(resolveEventId());
                loadAttachments(resolveEventId());
                loadLinkedEquipment(resolveEventId());
            }
        }

        function loadLinkedEquipment(id) {
            if (!id || !vm.canReadEquipment) { return; }
            EquipmentParc.get('for-event/' + id).then(function (links) { vm.linkedEquipment = links; }, angular.noop);
        }

        function loadHistory(id) {
            if (!id) {
                vm.history = [];
                return;
            }
            EventForm.history({id: id}, function(result) {
                vm.history = result;
            });
        }

        function loadAttachments(id) {
            if (!id) {
                vm.attachments = [];
                return;
            }
            EventFormAttachmentService.query(id).then(function(response) {
                vm.attachments = response.data || [];
            }, function(error) {
                vm.attachments = [];
                AlertService.error(error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.attachmentsLoadError'));
            });
        }

        function validateDocument() {
            var eventId = resolveEventId();
            if (!eventId) {
                return;
            }
            vm.statusActionInProgress = true;
            EventForm.validateDocument({id: eventId}, function(result) {
                vm.statusActionInProgress = false;
                AlertService.success($translate.instant('wamasysApp.eventForm.validated'));
                setEventForm(result);
            }, onActionError);
        }

        function controlDocument() {
            var eventId = resolveEventId();
            if (!eventId) {
                return;
            }
            vm.statusActionInProgress = true;
            EventForm.controlDocument({id: eventId}, function(result) {
                vm.statusActionInProgress = false;
                AlertService.success($translate.instant('wamasysApp.eventForm.controlled'));
                setEventForm(result);
            }, onActionError);
        }

        function createTicket() {
            var eventId = resolveEventId();
            if (!eventId) {
                return;
            }
            vm.ticketActionInProgress = true;
            EventForm.createTicket({id: eventId}, function(result) {
                vm.ticketActionInProgress = false;
                AlertService.success($translate.instant('wamasysApp.eventForm.ticketCreated'));
                if (result && result.url) {
                    $window.open(result.url, '_blank');
                }
            }, onActionError);
        }

        function setAttachmentFile(file) {
            vm.selectedAttachmentFile = file || null;
            vm.selectedAttachmentFileName = file && file.name ? file.name : null;
        }

        function uploadAttachment() {
            if (!vm.eventLoaded || !vm.selectedAttachmentFile) {
                return;
            }
            vm.attachmentUploadInProgress = true;
            EventFormAttachmentService.upload(vm.eventForm.id, vm.selectedAttachmentFile).then(function() {
                vm.attachmentUploadInProgress = false;
                vm.selectedAttachmentFile = null;
                vm.selectedAttachmentFileName = null;
                AlertService.success($translate.instant('wamasysApp.eventForm.attachmentAdded'));
                loadAttachments(vm.eventForm.id);
            }, function(error) {
                vm.attachmentUploadInProgress = false;
                AlertService.error(error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.attachmentUploadError'));
            });
        }

        function downloadAttachment(attachment) {
            if (!vm.eventLoaded || !attachment || !attachment.id) {
                return;
            }
            EventFormAttachmentService.download(vm.eventForm.id, attachment.id).then(function(result) {
                var fileName = result.fileName || attachment.fileName || 'piece-jointe';
                if ($window.navigator.msSaveOrOpenBlob) {
                    $window.navigator.msSaveOrOpenBlob(result.response, fileName);
                    return;
                }
                var url = ($window.URL || $window.webkitURL).createObjectURL(result.response);
                var link = angular.element('<a/>');
                link.attr('href', url);
                link.attr('download', fileName);
                angular.element(document.body).append(link);
                link[0].click();
                link.remove();
                ($window.URL || $window.webkitURL).revokeObjectURL(url);
            }, function(error) {
                AlertService.error(error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.attachmentDownloadError'));
            });
        }

        function onActionError(error) {
            vm.statusActionInProgress = false;
            vm.ticketActionInProgress = false;
            AlertService.error(error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.technicalError'));
        }

        function canValidate() {
            return vm.eventLoaded && vm.hasFormValidationRight && vm.eventForm.workflowStatus === 'SUBMITTED';
        }

        function canControl() {
            return vm.eventLoaded && vm.hasFormValidationRight && vm.eventForm.workflowStatus === 'VALIDATED';
        }

        function prepareEventForm(eventForm) {
            if (!eventForm) {
                return;
            }
            eventForm.answerFields = [];
            var fieldLabels = buildFieldLabels(eventForm.subCategoryCustomFields);
            var rawAnswers = eventForm.answersJson;
            if (!rawAnswers) {
                return;
            }
            try {
                var answers = angular.fromJson(rawAnswers);
                angular.forEach(answers, function(value, key) {
                    eventForm.answerFields.push({
                        label: fieldLabels[key] || key,
                        code: key,
                        value: value
                    });
                });
            } catch (e) {
                console.log(e);
            }
        }

        function statusLabel(status) {
            var labels = {
                DRAFT: $translate.instant('wamasysApp.eventForm.statuses.DRAFT'),
                SUBMITTED: $translate.instant('wamasysApp.eventForm.statuses.SUBMITTED'),
                VALIDATED: $translate.instant('wamasysApp.eventForm.statuses.VALIDATED'),
                CONTROLLED: $translate.instant('wamasysApp.eventForm.statuses.CONTROLLED'),
                DELETED: $translate.instant('wamasysApp.eventForm.statuses.DELETED')
            };
            return labels[status] || status;
        }

        function reasonLabel(reason) {
            var labels = {
                MANUAL_CORRECTION: $translate.instant('wamasysApp.eventForm.reasons.MANUAL_CORRECTION'),
                AUTO_CORRECTION: $translate.instant('wamasysApp.eventForm.reasons.AUTO_CORRECTION'),
                COMPLEMENTARY_INFO_ADDED: $translate.instant('wamasysApp.eventForm.reasons.COMPLEMENTARY_INFO_ADDED')
            };
            return labels[reason] || reason;
        }

        function resolveEventId() {
            if (vm.eventForm && vm.eventForm.id) {
                return vm.eventForm.id;
            }
            return $stateParams && $stateParams.id ? $stateParams.id : null;
        }

        function buildFieldLabels(customFieldsJson) {
            var labels = {};
            if (!customFieldsJson) {
                return labels;
            }
            try {
                var config = angular.fromJson(customFieldsJson);
                angular.forEach((config && config.fields) || [], function(field) {
                    var label = field.label || field.dictionaryFieldCode || field.name || field.code;
                    if (!label) {
                        return;
                    }
                    angular.forEach([field.name, field.code, field.dictionaryFieldCode].concat(parseLegacyNames(field.legacyNames || field.legacyCodes)), function(candidate) {
                        if (candidate && !labels[candidate]) {
                            labels[candidate] = label;
                        }
                    });
                });
            } catch (e) {
                console.log(e);
            }
            return labels;
        }

        function parseLegacyNames(value) {
            if (!value) {
                return [];
            }
            if (angular.isArray(value)) {
                return value;
            }
            return String(value).split(/[;,]/).map(function(item) {
                return item.trim();
            }).filter(function(item) {
                return item.length > 0;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormDeleteController',EventFormDeleteController);

    EventFormDeleteController.$inject = ['$uibModalInstance', 'entity', 'EventForm'];

    function EventFormDeleteController($uibModalInstance, entity, EventForm) {
        var vm = this;
        vm.eventForm = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            EventForm.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('EventFormAttachmentService', EventFormAttachmentService);

    EventFormAttachmentService.$inject = ['$http'];

    function EventFormAttachmentService($http) {
        return {
            query: query,
            upload: upload,
            download: download
        };

        function query(eventFormId) {
            return $http.get('api/form-event/' + eventFormId + '/attachments');
        }

        function upload(eventFormId, file) {
            var formData = new FormData();
            formData.append('file', file);
            return $http.post('api/form-event/' + eventFormId + '/attachments', formData, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }

        function download(eventFormId, attachmentId) {
            return $http({
                url: 'api/form-event/' + eventFormId + '/attachments/' + attachmentId,
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(response) {
                return {
                    response: new Blob([response.data], {
                        type: response.headers('Content-Type') || 'application/octet-stream'
                    }),
                    fileName: extractFileName(response.headers('Content-Disposition'))
                };
            });
        }

        function extractFileName(contentDisposition) {
            if (!contentDisposition) {
                return 'piece-jointe';
            }
            var match = /filename="([^"]+)"/i.exec(contentDisposition);
            return match && match[1] ? match[1] : 'piece-jointe';
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormSubCategoryDialogController', EventFormSubCategoryDialogController);

    EventFormSubCategoryDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'EventFormCategory', 'Principal', 'AlertService', 'EventFieldDefinition'];

    function EventFormSubCategoryDialogController($scope, $uibModalInstance, entity, EventFormCategory, Principal, AlertService, EventFieldDefinition) {
        var vm = this;

        vm.eventFormSubCategory = entity;
        vm.customFieldReadLony = true;
        vm.customFieldsConfig = {baseFields: {}, fields: [], rules: []};
        vm.baseFieldDefinitions = buildBaseFieldDefinitions();
        vm.fieldDefinitions = [];
        vm.fieldTypes = [
            {code: 'text', label: 'Texte'},
            {code: 'integer', label: 'Entier'},
            {code: 'decimal', label: 'Décimal'},
            {code: 'boolean', label: 'Booléen'},
            {code: 'list', label: 'Liste'},
            {code: 'satisfaction_smiley', label: 'Satisfaction smiley'},
            {code: 'ref_contrat', label: 'RefContrat'}
        ];
        vm.ruleTypes = ['REQUIRED_IF', 'MIN_IF', 'MAX_IF', 'VALUE_POSSIBLE_IF'];
        vm.conditionOperators = ['EQUALS', 'NOT_EQUALS', 'IN', 'NOT_IN', 'GREATER_THAN', 'GREATER_OR_EQUALS', 'LOWER_THAN', 'LOWER_OR_EQUALS', 'IS_TRUE', 'IS_FALSE', 'IS_BLANK', 'IS_NOT_BLANK'];
        vm.severities = ['ERROR', 'WARNING'];
        vm.showJsonEditor = false;

        vm.save = save;
        vm.clear = clear;
        vm.addField = addField;
        vm.removeField = removeField;
        vm.addRule = addRule;
        vm.removeRule = removeRule;
        vm.onReorder = onReorder;
        vm.onFieldDefinitionChange = onFieldDefinitionChange;
        vm.onFieldTypeChange = onFieldTypeChange;
        vm.requiresRuleValue = requiresRuleValue;
        vm.requiresRuleValues = requiresRuleValues;
        vm.conditionRequiresValue = conditionRequiresValue;
        vm.conditionRequiresValues = conditionRequiresValues;
        vm.getFieldReferenceOptions = getFieldReferenceOptions;
        vm.initCustomFields = initCustomFields;
        vm.updateCustomFieldsJson = updateCustomFieldsJson;
        vm.isListField = isListField;
        vm.isSmileyField = isSmileyField;
        vm.isDictionaryLinked = isDictionaryLinked;
        vm.toggleJsonEditor = toggleJsonEditor;
        vm.handleFormKeydown = handleFormKeydown;

        Principal.hasAuthority('ROLE_SUPER_ADMIN').then(function(result) {
            vm.customFieldReadLony = !result;
        });

        loadFieldDefinitions();

        if (entity && entity.$promise) {
            entity.$promise.then(function() {
                vm.initCustomFields();
            });
        } else {
            vm.initCustomFields();
        }

        function save() {
            var cfg = vm.customFieldsConfig;

            if (!cfg || !cfg.fields) {
                try {
                    cfg = angular.fromJson(vm.eventFormSubCategory.customFields);
                } catch (e) {
                    AlertService.error('Les champs personnalisés ne sont pas valides.');
                    vm.isSaving = false;
                    return;
                }
            }

            ensureBaseFieldsConfig(cfg);

            var fieldNames = {};
            for (var i = 0; i < cfg.fields.length; i++) {
                var field = cfg.fields[i];
                field.name = field.name || field.code;
                field.dictionaryFieldCode = field.dictionaryFieldCode || field.fieldCode;
                field.legacyNames = normalizeLegacyNames(field.legacyNames || field.legacyCodes);

                if (field.dictionaryFieldCode && !enforceDictionaryBinding(field)) {
                    AlertService.error('Le champ dictionnaire ' + field.dictionaryFieldCode + ' est introuvable.');
                    vm.isSaving = false;
                    return;
                }

                if (!field.label || field.label.trim().length === 0) {
                    AlertService.error('Un champ contient un libellé vide.');
                    vm.isSaving = false;
                    return;
                }
                if (!field.name || field.name.trim().length === 0) {
                    AlertService.error('Un champ contient un nom technique vide.');
                    vm.isSaving = false;
                    return;
                }
                if (!(field.name.indexOf('cf.') === 0 || field.name.indexOf('sf.') === 0)) {
                    AlertService.error('Le nom technique stocké doit commencer par cf. ou sf.');
                    vm.isSaving = false;
                    return;
                }
                if (!/^[a-z0-9_]+$/.test(field.name.replace('cf.', '').replace('sf.', ''))) {
                    AlertService.error('Le nom technique ' + field.name + ' est invalide. Utiliser uniquement des minuscules, chiffres ou underscores.');
                    vm.isSaving = false;
                    return;
                }
                if (!field.type || field.type.trim().length === 0) {
                    AlertService.error('Un champ contient un type vide.');
                    vm.isSaving = false;
                    return;
                }
                if (fieldNames[field.name]) {
                    AlertService.error('Le nom technique ' + field.name + ' est utilisé en double.');
                    vm.isSaving = false;
                    return;
                }
                fieldNames[field.name] = true;
            }

            for (var j = 0; j < (cfg.rules || []).length; j++) {
                var rule = cfg.rules[j];
                if (!rule.type || !rule.targetField || !rule.condition || !rule.condition.field || !rule.condition.operator) {
                    AlertService.error('Une règle conditionnelle est incomplète.');
                    vm.isSaving = false;
                    return;
                }
            }

            vm.updateCustomFieldsJson();

            if (vm.eventFormSubCategory.customFields && vm.eventFormSubCategory.customFields.length > 0) {
                try {
                    angular.fromJson(vm.eventFormSubCategory.customFields);
                } catch (e2) {
                    AlertService.error('La configuration JSON technique est invalide.');
                    vm.isSaving = false;
                    return;
                }
            }

            vm.isSaving = true;
            if (vm.eventFormSubCategory.id !== null) {
                EventFormCategory.updateSubCategory(vm.eventFormSubCategory, onSaveSuccess, onSaveError);
            } else {
                EventFormCategory.createSubCategory(vm.eventFormSubCategory, onSaveSuccess, onSaveError);
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function addField() {
            vm.customFieldsConfig.fields.push({
                label: '',
                tooltip: '',
                name: '',
                dictionaryFieldCode: '',
                legacyNamesText: '',
                required: false,
                hidden: false,
                type: 'text',
                values: ''
            });
            vm.updateCustomFieldsJson();
            return false;
        }

        function removeField(index) {
            vm.customFieldsConfig.fields.splice(index, 1);
            vm.updateCustomFieldsJson();
        }

        function addRule() {
            vm.customFieldsConfig.rules.push({
                type: 'REQUIRED_IF',
                targetField: '',
                severity: 'ERROR',
                condition: {
                    field: '',
                    operator: 'EQUALS',
                    value: ''
                },
                value: '',
                valuesText: ''
            });
            vm.updateCustomFieldsJson();
        }

        function removeRule(index) {
            vm.customFieldsConfig.rules.splice(index, 1);
            vm.updateCustomFieldsJson();
        }

        function onReorder() {
            vm.updateCustomFieldsJson();
        }

        function onFieldDefinitionChange(field) {
            if (!field || !field.dictionaryFieldCode) {
                vm.updateCustomFieldsJson();
                return;
            }

            enforceDictionaryBinding(field);
            vm.updateCustomFieldsJson();
        }

        function onFieldTypeChange() {
            vm.updateCustomFieldsJson();
        }

        function requiresRuleValue(rule) {
            return rule && (rule.type === 'MIN_IF' || rule.type === 'MAX_IF');
        }

        function requiresRuleValues(rule) {
            return rule && rule.type === 'VALUE_POSSIBLE_IF';
        }

        function conditionRequiresValue(rule) {
            return rule && rule.condition && (rule.condition.operator === 'EQUALS' || rule.condition.operator === 'NOT_EQUALS'
                    || rule.condition.operator === 'GREATER_THAN' || rule.condition.operator === 'GREATER_OR_EQUALS'
                    || rule.condition.operator === 'LOWER_THAN' || rule.condition.operator === 'LOWER_OR_EQUALS');
        }

        function conditionRequiresValues(rule) {
            return rule && rule.condition && (rule.condition.operator === 'IN' || rule.condition.operator === 'NOT_IN');
        }

        function getFieldReferenceOptions() {
            var options = [];
            angular.forEach(vm.customFieldsConfig.fields || [], function(field) {
                var referenceCode = field.dictionaryFieldCode || field.name;
                if (!referenceCode) {
                    return;
                }
                options.push({
                    code: referenceCode,
                    label: (field.label || field.name || referenceCode) + ' (' + referenceCode + ')'
                });
            });
            return options;
        }

        function initCustomFields() {
            vm.customFieldsConfig = {baseFields: {}, fields: [], rules: []};

            if (vm.eventFormSubCategory.customFields) {
                try {
                    vm.customFieldsConfig = angular.fromJson(vm.eventFormSubCategory.customFields);
                } catch (e) {
                    console.warn('Invalid JSON in customFields');
                }
            }

            if (!vm.customFieldsConfig.fields) {
                vm.customFieldsConfig.fields = [];
            }
            ensureBaseFieldsConfig(vm.customFieldsConfig);
            if (!vm.customFieldsConfig.rules) {
                vm.customFieldsConfig.rules = [];
            }

            angular.forEach(vm.customFieldsConfig.fields, function(field) {
                field.name = field.name || field.code;
                field.dictionaryFieldCode = field.dictionaryFieldCode || field.fieldCode;
                field.legacyNamesText = normalizeLegacyNames(field.legacyNames || field.legacyCodes).join(';');
            });

            angular.forEach(vm.customFieldsConfig.rules, function(rule) {
                rule.severity = rule.severity || 'ERROR';
                rule.condition = rule.condition || {
                    field: '',
                    operator: 'EQUALS',
                    value: ''
                };
                rule.condition.operator = rule.condition.operator || 'EQUALS';
                if (angular.isArray(rule.values)) {
                    rule.valuesText = rule.values.join(';');
                }
                if (rule.condition && angular.isArray(rule.condition.values)) {
                    rule.condition.valuesText = rule.condition.values.join(';');
                }
            });

            refreshDictionaryBoundFields();
            vm.updateCustomFieldsJson();
        }

        function updateCustomFieldsJson() {
            var serializedFields = angular.copy(vm.customFieldsConfig.fields || []);
            angular.forEach(serializedFields, function(field) {
                field.name = field.name || field.code;
                field.dictionaryFieldCode = field.dictionaryFieldCode || field.fieldCode;
                field.legacyNames = normalizeLegacyNames(field.legacyNamesText || field.legacyNames || field.legacyCodes);
                delete field.code;
                delete field.fieldCode;
                delete field.legacyCodes;
                delete field.legacyNamesText;
            });

            var serializedRules = angular.copy(vm.customFieldsConfig.rules || []);
            angular.forEach(serializedRules, function(rule) {
                if (rule.valuesText) {
                    rule.values = splitValues(rule.valuesText);
                } else {
                    delete rule.values;
                }
                delete rule.valuesText;

                if (rule.condition && rule.condition.valuesText) {
                    rule.condition.values = splitValues(rule.condition.valuesText);
                } else if (rule.condition) {
                    delete rule.condition.values;
                }
                if (rule.condition) {
                    delete rule.condition.valuesText;
                }
            });

            var serializedBaseFields = angular.copy(ensureBaseFieldsConfig(vm.customFieldsConfig));
            angular.forEach(serializedBaseFields, function(baseFieldConfig) {
                baseFieldConfig.visible = !!baseFieldConfig.visible;
                baseFieldConfig.required = !!baseFieldConfig.visible && !!baseFieldConfig.required;
            });

            vm.eventFormSubCategory.customFields = JSON.stringify({
                baseFields: serializedBaseFields,
                fields: serializedFields,
                rules: serializedRules
            }, null, 2);
        }

        function isListField(field) {
            return !!field && field.type === 'list';
        }

        function isSmileyField(field) {
            return !!field && field.type === 'satisfaction_smiley';
        }

        function isDictionaryLinked(field) {
            return !!(field && field.dictionaryFieldCode);
        }

        function toggleJsonEditor() {
            vm.showJsonEditor = !vm.showJsonEditor;
        }

        function handleFormKeydown($event) {
            if (!$event || $event.keyCode !== 13) {
                return;
            }
            var tagName = $event.target && $event.target.tagName ? $event.target.tagName.toUpperCase() : '';
            if (tagName !== 'TEXTAREA') {
                $event.preventDefault();
            }
        }

        function loadFieldDefinitions() {
            EventFieldDefinition.query({
                inclInactive: false,
                page: 0,
                size: 2000,
                sort: ['fieldCode,asc']
            }, function(result) {
                vm.fieldDefinitions = result || [];
                refreshDictionaryBoundFields();
                vm.updateCustomFieldsJson();
            }, function(error) {
                AlertService.error(error.data && error.data.message ? error.data.message : 'Erreur lors du chargement du dictionnaire.');
            });
        }

        function refreshDictionaryBoundFields() {
            angular.forEach(vm.customFieldsConfig.fields || [], function(field) {
                enforceDictionaryBinding(field);
            });
        }

        function enforceDictionaryBinding(field) {
            if (!field || !field.dictionaryFieldCode) {
                return true;
            }

            var definition = findDefinition(field.dictionaryFieldCode);
            if (!definition) {
                return false;
            }

            var previousName = trimToNull(field.name);
            var forcedStorageName = buildStorageNameFromDictionaryCode(definition.fieldCode || field.dictionaryFieldCode);

            if (previousName && previousName !== forcedStorageName) {
                field.legacyNamesText = mergeLegacyNames(field.legacyNamesText, previousName).join(';');
            }

            field.name = forcedStorageName;
            field.type = definition.dataType || field.type || 'text';

            if (!field.label) {
                field.label = definition.label;
            }
            if (!field.tooltip) {
                field.tooltip = definition.description;
            }
            if (field.type === 'list' && !field.values && definition.valuePossibleJson) {
                try {
                    var values = angular.fromJson(definition.valuePossibleJson);
                    if (angular.isArray(values)) {
                        field.values = values.join(';');
                    }
                } catch (e) {
                    field.values = definition.valuePossibleJson;
                }
            }

            return true;
        }

        function findDefinition(fieldCode) {
            var definition = null;
            angular.forEach(vm.fieldDefinitions, function(item) {
                if (!definition && item.fieldCode === fieldCode) {
                    definition = item;
                }
            });
            return definition;
        }

        function buildStorageNameFromDictionaryCode(fieldCode) {
            var rawCode = trimToNull(fieldCode) || 'field';
            var prefix = 'cf.';

            if (rawCode.indexOf('cf.') === 0 || rawCode.indexOf('sf.') === 0) {
                prefix = rawCode.substring(0, 3);
                rawCode = rawCode.substring(3);
            } else if (rawCode.indexOf('cf_') === 0 || rawCode.indexOf('sf_') === 0) {
                prefix = rawCode.substring(0, 2) + '.';
                rawCode = rawCode.substring(3);
            }

            rawCode = rawCode
                .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
                .replace(/[^a-zA-Z0-9]+/g, '_')
                .replace(/_+/g, '_')
                .replace(/^_+|_+$/g, '')
                .toLowerCase();

            if (!rawCode) {
                rawCode = 'field';
            }

            return prefix + rawCode;
        }

        function mergeLegacyNames(source, nameToAdd) {
            var values = normalizeLegacyNames(source);
            var normalizedName = trimToNull(nameToAdd);
            if (normalizedName && values.indexOf(normalizedName) === -1) {
                values.push(normalizedName);
            }
            return values;
        }

        function normalizeLegacyNames(value) {
            if (!value) {
                return [];
            }
            if (angular.isArray(value)) {
                return value.filter(function(item) {
                    return !!trimToNull(item);
                }).map(function(item) {
                    return trimToNull(item);
                });
            }
            return splitValues(value);
        }

        function splitValues(value) {
            return String(value).split(/[;,]/).map(function(item) {
                return item.trim();
            }).filter(function(item) {
                return item.length > 0;
            });
        }

        function trimToNull(value) {
            if (value === null || value === undefined) {
                return null;
            }
            value = String(value).trim();
            return value.length ? value : null;
        }

        function buildBaseFieldDefinitions() {
            return [
                {key: 'dateRecord', label: 'Date de l’événement', help: 'Champ de date principal du document.'},
                {key: 'title', label: 'Titre', help: 'Titre court affiché dans les listes et tableaux de bord.'},
                {key: 'comment', label: 'Commentaire', help: 'Zone de commentaire libre du document.'},
                {key: 'gps', label: 'Coordonnées GPS', help: 'Carte et coordonnées latitude / longitude du document.'}
            ];
        }

        function ensureBaseFieldsConfig(config) {
            if (!config.baseFields) {
                config.baseFields = {};
            }

            angular.forEach(defaultBaseFields(), function(defaultConfig, key) {
                if (!config.baseFields[key]) {
                    config.baseFields[key] = angular.copy(defaultConfig);
                } else {
                    config.baseFields[key].visible = config.baseFields[key].visible !== false;
                    config.baseFields[key].required = config.baseFields[key].required === true || !!defaultConfig.required && config.baseFields[key].required !== false;
                }
                if (!config.baseFields[key].visible) {
                    config.baseFields[key].required = false;
                }
            });

            return config.baseFields;
        }

        function defaultBaseFields() {
            return {
                dateRecord: {visible: true, required: true},
                title: {visible: true, required: true},
                comment: {visible: true, required: false},
                gps: {visible: true, required: false}
            };
        }

        function onSaveSuccess(result) {
            $scope.$emit('wamasysApp:EventFormSubCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError(error) {
            vm.isSaving = false;
            AlertService.error(error.data && error.data.message ? error.data.message : 'Erreur lors de l\'enregistrement du document.');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormSubCategoryDeleteController',EventFormSubCategoryDeleteController);

    EventFormSubCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'EventFormCategory'];

    function EventFormSubCategoryDeleteController($uibModalInstance, entity, EventFormCategory) {
        var vm = this;
        vm.EventFormCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            EventFormCategory.deleteSubCategory({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormCategoryController', EventFormCategoryController);

    EventFormCategoryController.$inject = ['$scope', '$state', 'EventFormCategory', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'EventConfigurationAssistant'];

    function EventFormCategoryController ($scope, $state, EventFormCategory, ParseLinks, AlertService, pagingParams, paginationConstants, EventConfigurationAssistant) {
        var vm = this;
        vm.openAssistant = function() { EventConfigurationAssistant.open('FIELDS', loadAll); };
        EventConfigurationAssistant.canUse('FIELDS').then(function(allowed) { vm.canUseAssistant = allowed; });
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            EventFormCategory.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.EventFormCategorys = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider 
        .state('event-form-category', {
            parent: 'entity',
            url: '/event-form-category?page&sort&search',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.EventFormCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/event-form-category/event-form-categorys.html',
                    controller: 'EventFormCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventFormCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-form-category-detail', {
            parent: 'entity',
            url: '/event-form-category/{id}',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.EventFormCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/event-form-category/event-form-category-detail.html',
                    controller: 'EventFormCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventFormCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventFormCategory', function($stateParams, EventFormCategory) {
                    return EventFormCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('event-form-category-matrix', {
            parent: 'entity',
            url: '/event-form-category-matrix',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.EventFormCategory.matrix.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/event-form-category/event-form-category-matrix.html',
                    controller: 'EventFormCategoryMatrixController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventFormCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })

        .state('event-form-category.new', {
            parent: 'event-form-category',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form-category/event-form-category-dialog.html',
                    controller: 'EventFormCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                visibleOnSmartphone: true,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-form-category', null, { reload: true });
                }, function() {
                    $state.go('event-form-category');
                });
            }]
        })
        .state('event-form-category.edit', {
            parent: 'event-form-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form-category/event-form-category-dialog.html',
                    controller: 'EventFormCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventFormCategory', function(EventFormCategory) {
                            return EventFormCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-form-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-form-category.delete', {
            parent: 'event-form-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form-category/event-form-category-delete-dialog.html',
                    controller: 'EventFormCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventFormCategory', function(EventFormCategory) {
                            return EventFormCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-form-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-form-category-detail.new-sub-category', {
            parent: 'event-form-category-detail',
            url: '/subcategory/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form-category/event-form-sub-category-dialog.html',
                    controller: 'EventFormSubCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                eventFormCategory:{id:$stateParams.id},
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-form-category-detail', {id: $stateParams.id}, { reload: true });
                }, function() {
                    $state.go('event-form-category-detail', {id: $stateParams.id});
                });
            }]
        })
        .state('event-form-category-detail.edit-sub-category', {
            parent: 'event-form-category-detail',
            url: '/subcategory/{idSubCategory}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form-category/event-form-sub-category-dialog.html',
                    controller: 'EventFormSubCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventFormCategory', function(EventFormCategory) {
                            return EventFormCategory.getSubCategory({id : $stateParams.idSubCategory});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-form-category-detail', {id: $stateParams.id}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
        .state('event-form-category-detail.delete-sub-category', {
            parent: 'event-form-category-detail',
            url: '/subcategory/{idSubCategory}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form-category/event-form-sub-category-delete-dialog.html',
                    controller: 'EventFormSubCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventFormCategory', function(EventFormCategory) {
                            return {id : $stateParams.idSubCategory};
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-form-category-detail', {id: $stateParams.id}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
        ;
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('EventFormCategory', EventFormCategory);

    EventFormCategory.$inject = ['$resource'];

    function EventFormCategory ($resource) {
        var resourceUrl =  'api/event-form-categorys/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            
            'queryInclDeleted': {

                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            
            'update': { method:'PUT' },
            
          
            'getListSubCategory': {
                method: 'GET',
              	url :'api/event-form-categorys/:id/sub-category',
              	 isArray: true
            },

            'queryListSubCategoryInclDeleted': {
              	url :'api/event-form-categorys/:id/sub-category',
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'getMatrix': {
                url: 'api/event-form-categorys/matrix',
                method: 'GET'
            },
            'getSubCategory': {
                method: 'GET',
              	url :'api/event-form-categorys/sub-category/:id',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getSubCategoryHistory': {
                method: 'GET',
                isArray: true,
                url: 'api/event-form-categorys/sub-category/:id/history'
            },
            'createSubCategory': { method:'POST', 
              	url :'api/event-form-category/sub-category'
             },
             'updateSubCategory': { method:'PUT', 
               	url :'api/event-form-category/sub-category'
              },
              'deleteSubCategory': { method:'DELETE', 
                 url :'api/event-form-categorys/sub-category/:id'
              }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormCategoryMatrixController', EventFormCategoryMatrixController);

    EventFormCategoryMatrixController.$inject = ['EventFormCategory', 'AlertService'];

    function EventFormCategoryMatrixController(EventFormCategory, AlertService) {
        var vm = this;

        vm.showArchived = false;
        vm.toggleArchived = toggleArchived;
        vm.matrix = {
            baseFields: [],
            fields: [],
            rows: []
        };

        load();

        function load() {
            EventFormCategory.getMatrix({inclDeleted: vm.showArchived}, function(result) {
                vm.matrix = result || vm.matrix;
            }, function(error) {
                AlertService.error(error.data && error.data.message ? error.data.message : 'Erreur lors du chargement de la matrice des formulaires.');
            });
        }

        function toggleArchived() {
            vm.showArchived = !vm.showArchived;
            load();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormCategoryDialogController', EventFormCategoryDialogController);

    EventFormCategoryDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'EventFormCategory'];

    function EventFormCategoryDialogController ($scope, $stateParams, $uibModalInstance, entity, EventFormCategory) {
        var vm = this;
        vm.EventFormCategory = entity;
        vm.EventFormCategory.visibleOnSmartphone = vm.EventFormCategory.visibleOnSmartphone !== false;
        vm.load = function(id) {
            EventFormCategory.get({id : id}, function(result) {
                vm.EventFormCategory = result;
                vm.EventFormCategory.visibleOnSmartphone = vm.EventFormCategory.visibleOnSmartphone !== false;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:EventFormCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.EventFormCategory.id !== null) {
                EventFormCategory.update(vm.EventFormCategory, onSaveSuccess, onSaveError);
            } else {
                EventFormCategory.save(vm.EventFormCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormCategoryDetailController', EventFormCategoryDetailController);

    EventFormCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'EventFormCategory'];

    function EventFormCategoryDetailController($scope, $rootScope, $stateParams, entity, EventFormCategory) {
        var vm = this;
        vm.EventFormCategory = entity;
        vm.subCategoryHistoryById = {};
        vm.toggleSubCategoryHistory = toggleSubCategoryHistory;
        
        EventFormCategory.queryListSubCategoryInclDeleted({id: $stateParams.id}, function(result) {
        	vm.EventFormCategory.listEventFormSubCategory =   result;
        	normalizeSubCategories(vm.EventFormCategory.listEventFormSubCategory);
           
        });

        vm.load = function (id) {
            EventFormCategory.get({id: id}, function(result) {
                vm.EventFormCategory = result;
                EventFormCategory.getListSubCategory({id: id}, function(result) {
                	vm.EventFormCategory.listEventFormSubCategory =   result;
                    normalizeSubCategories(vm.EventFormCategory.listEventFormSubCategory);
                });
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:EventFormCategoryUpdate', function(event, result) {
            vm.EventFormCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

        function toggleSubCategoryHistory(subCategory) {
            if (!subCategory || !subCategory.id) {
                return;
            }
            if (subCategory.showHistory) {
                subCategory.showHistory = false;
                return;
            }
            if (vm.subCategoryHistoryById[subCategory.id]) {
                subCategory.showHistory = true;
                return;
            }
            EventFormCategory.getSubCategoryHistory({id: subCategory.id}, function(result) {
                normalizeSubCategories(result);
                vm.subCategoryHistoryById[subCategory.id] = result;
                subCategory.showHistory = true;
            });
        }

        function normalizeSubCategories(subCategories) {
            angular.forEach(subCategories || [], function(subCategory) {
                if (!subCategory || !subCategory.customFields) {
                    return;
                }
                try {
                    subCategory.customFields = JSON.parse(subCategory.customFields);
                } catch (e) {
                    console.log(e);
                }
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormCategoryDeleteController',EventFormCategoryDeleteController);

    EventFormCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'EventFormCategory'];

    function EventFormCategoryDeleteController($uibModalInstance, entity, EventFormCategory) {
        var vm = this;
        vm.EventFormCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            EventFormCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CalendarControllerBis', CalendarControllerBis);

    CalendarControllerBis.$inject = ['$rootScope', '$state', '$timeout', 'Auth','$scope', 'Principal', 'LoginService','RedmineService','pagingParams','paginationConstants','ParseLinks'];

    function CalendarControllerBis ($rootScope,$state, $timeout, Auth,$scope, Principal, LoginService,RedmineService,pagingParams, paginationConstants,ParseLinks) {
        var vm = this;

//        $(document).on("dragover", function(event) {
//            event.preventDefault(); // Empêche le comportement par défaut du navigateur
//            console.log("Événement dragover détecté !");
//        });
//        $(document).on("drag", function(event) {
//            event.preventDefault(); // Empêche le comportement par défaut du navigateur
//            console.log("Événement dragover détecté !");
//        });
//        $(document).on("drop", function(event) {
//            event.preventDefault(); // Empêche le navigateur d'interrompre le drop
//            console.log("Événement drop détecté globalement !");
//        });
//        $(document).on("dropover", function(event) {
//            event.preventDefault(); // Empêche le navigateur d'interrompre le drop
//            console.log("Événement drop détecté globalement !");
//        });

        vm.days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
        vm.users = ['Utilisateur 1', 'Utilisateur 2', 'Utilisateur 3'];
        
        vm.tasks = [
            { label: 'Tickets A', duration: 3 },
            { label: 'Tickets B', duration: 5 },
            { label: 'Tickets C', duration: 2 }
        ];
        
        vm.planning = {};
        vm.users.forEach(function(user) {
        	vm.planning[user] = {};
        	vm.days.forEach(function(day) {
        		vm.planning[user][day] = [];
            });
        });
    	vm.planning['Utilisateur 1']['Mardi']=    [{ label: 'Tâche A', duration: 3 }];
    	
        vm.onSegmentDragStart  = function (event, ui,task) {
        	vm.currentTask = task;
        };

        vm.onDrop = function (data, event,  user, day) {
        //    console.log("onDrop appelé avec :", data, event,user, day);

            if (!vm.currentTask || typeof vm.currentTask !== 'object') {
                console.error("Erreur : Données incorrectes :", data);
                return;
            }

            
            if (!vm.planning[user][day]) {
                console.warn("La case de réception n'est pas initialisée !");
                vm.planning[user][day] = []; // On initialise la liste si elle n'existe pas
            }
            console.log("Tâche déposée :", data, "Utilisateur :", user, "Jour :", day);
           vm.planning[user][day].push(angular.copy(vm.currentTask));
           
           $(event.draggable).fadeOut(100, function () {
        	 
           });
//            vm.$apply(function () {
//            	vm.planning[user][day].push(data);
//            });
        };
        
        vm.getTotal = function (user, day) {
            return vm.planning[user][day].reduce(function(sum, task) { 
                return sum + task.duration; 
            }, 0);
        };
        
        

        function initCalendar() {
            $('#calendar').fullCalendar({
                defaultView: 'agendaWeek',
                editable: true,
                droppable: true,
                allDaySlot: false,
                slotDuration: '00:30:00',
                minTime: '08:00:00',
                maxTime: '18:00:00',
                columnFormat: 'dddd',
                header: {
                    left: '',
                    center: 'title',
                    right: ''
                },
                resources:  vm.users.map(function(user, index){
                		return {
                    id: index,
                    title: user
                }}),
                eventReceive: function (event) {
                    var dayEvents = $('#calendar').fullCalendar('clientEvents', function (ev) {
                        return ev.resourceId === event.resourceId && ev.start.isSame(event.start, 'day');
                    });

                    var totalDuration = dayEvents.reduce(function(sum, ev) {
                		return sum + ev.duration, 0
                		}
                    );

                    if (totalDuration > 8) {
                        alert("⚠️ Dépassement des 8 heures pour " + event.title + " !");
                        $('#calendar').fullCalendar('removeEvents', event._id);
                    }
                }
            });

            $('.task').each(function () {
                $(this).data('event', {
                    title: $(this).text(),
                    duration: parseInt($(this).attr('data-duration')),
                    stick: true
                }).draggable({
                    zIndex: 999,
                    revert: true,
                    revertDuration: 0,
                    helper: "clone"
                });
            });
        }
         
        $timeout(initCalendar, 0);

            
            
        
        vm.user = {} ;
        Principal.identity().then(function(account) {
        	if(account){
              vm.user =account ;
        	}
        });
        
        vm.transition = transition;
        vm.loadAll = loadAll;

        

        vm.loadAll();
        
        function loadAll() {
        	vm.issuefilter = pagingParams.issuefilter;
        	if(pagingParams.issuefilter == 'myissues'){
        		vm.indextab = 0;
        		 RedmineService.myIssues({
 	                page: pagingParams.page - 1,
 	                size: paginationConstants.itemsPerPage}, onSuccess, onError);
        	}else  if(pagingParams.issuefilter == 'createdbyme'){
        		vm.indextab = 2;
	            RedmineService.issuesCreatedByMe({
	                page: pagingParams.page - 1,
	                size: paginationConstants.itemsPerPage}, onSuccess, onError);	
        	}else  if(pagingParams.issuefilter == 'notassigned'){
        		vm.indextab = 1;
                RedmineService.issuesNotAssigned({
	                page: pagingParams.page - 1,
	                size: paginationConstants.itemsPerPage}, onSuccess, onError);
        	}
        }
        
        
        vm.issuesCreatedByMe = function () {
        	vm.issuefilter = 'createdbyme';
        	loadPage(1);
        }

        vm.myIssues = function () {
        	vm.issuefilter = 'myissues';
        	loadPage(1);
        }

        vm.issuesNotAssigned = function () {
        	vm.issuefilter = 'notassigned';
        	loadPage(1);
        }
        
        function onSuccess(data, headers) {
//            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = data.total_count;
            vm.queryCount = vm.totalItems;
            vm.listIssues = data;
//            vm.page = pagingParams.offset;
          vm.page = (data.offset/data.limit)+1;
            
        }
        
        function onError(error) {
            AlertService.error(error.data.message);
        }
        
        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }
        
        function transition () {
	        $state.transitionTo($state.$current, {
	            page: vm.page,
	            issuefilter: vm.issuefilter
	        	});
        }
        
        
        
    }
    
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('calendar', {
            parent: 'app',
            url: '/calendar',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/calendar/calendar.html',
                    controller: 'CalendarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('login');
                    $translatePartialLoader.addPart('calendar');
                    return $translate.refresh();
                }]
            }
        })
        ;
        
        
    }
})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('CalendarService', CalendarService);

    CalendarService.$inject = ['$resource','DateUtils'];

    function CalendarService ($resource,DateUtils) {
        var resourceUrl =  'api/calendar/';

        return $resource(resourceUrl, {}, {
             'saveEvent': {
                 method: 'POST',
                 url :'api/calendar/event'
              },
              
             'deleteEvent': {
                 method: 'DELETE',
                 url :'api/calendar/event/:id'
              },
              
             'findEvents': {
                 method: 'GET',
                 url :'api/calendar/find',
                 isArray: true,
                 params: {userLogin:'@userLogin', usersId: '@usersId', from: '@from', to: '@to' }
//              , 
//                 transformResponse: function (data) {
//                     data = angular.fromJson(data);
//
//                     // Si data est un tableau, on transforme chaque objet
//                     if (Array.isArray(data)) {
//                         return data.map(event => {
//                             event.start = DateUtils.convertLocalDateFromServer(event.start);
//                             event.end = DateUtils.convertLocalDateFromServer(event.end);
//                             return event;
//                         });
//                     }
//
//                     // Sinon, transformation d'un seul objet
//                     data.start = DateUtils.convertLocalDateFromServer(data.start);
//                     data.end = DateUtils.convertLocalDateFromServer(data.end);
//                     return data;
//                 }
              }
            		
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CalendarController',CalendarController);

    CalendarController.$inject = ['$rootScope', '$state',  '$timeout',  '$scope',   'Auth', 
                                  'Principal', 'AlertService','UserSearch', 'RedmineService', 'CalendarService','$filter'];

    function CalendarController ($rootScope,$state,$timeout,$scope,Auth,
    		Principal,AlertService,UserSearch,RedmineService,CalendarService,$filter){
    	
        var vm = this;

        var timeOutAppelServeur = 800;
        // Initial values for minTime and maxTime
        vm.minTime = 6;
        vm.maxTime =19;
       // vm.manualTimezoneOffset = -new Date().getTimezoneOffset() / 60;

      //  vm.selectedTimezone = 'local';
        
        vm.todayStr = new Date().toISOString().slice(0, 10); // Format YYYY-MM-DD
        
        vm.listeArea = [];
        vm.users = [];
        vm.userSelected = [];        
        vm.tasks = [];

        vm.openModal = function(){
        	vm.modalTitle = $filter('translate')('wamasysApp.calendar.ajouterEvenement');
        	vm.eventData = {};
            $('#eventModal').modal('show');
            $timeout(function() {
            	$('#field_title').focus();
            }, 500);
        }

        function initCalendar() {

        	var timezoneString = convertOffsetToTimezoneString(vm.manualTimezoneOffset);
        	timezoneString = 'local';
            vm.userSelected.forEach(function(user, index) {
            	$('#calendar-' + index).fullCalendar({
                    defaultView: 'agendaWeek',
                    editable: true,
                    allDaySlot: false, // Cache la partie all day en haut du calendrier vu semaine
                    droppable: true,
                    timezone: timezoneString,
                    selectable: true,
                    slotDuration: '00:30:00',
                    contentHeight:'auto',      
          
//                    minTime: vm.minTime.getHours()+":"+ vm.minTime.getMinutes()+":00",  // Initial minTime from model
//                    maxTime: vm.maxTime.getHours()+":"+ vm.minTime.getMinutes()+":00",  // Initial maxTime from model
                    minTime: vm.minTime+":00:00",  // Initial minTime from model
                    maxTime: vm.maxTime+":00:00",  // Initial maxTime from model
         //           header: false, // On masque l'entête
                    columnFormat: 'ddd',
                    views: {
                        day: {
                          columnFormat: 'dddd'
                        }
                    },
                    header: {
	                  left: 'prev,next today',
	                  center: 'title',
	                  right: 'agendaWeek,agendaDay'//month, on cache month sinon on ne peut pas gérer les heures
                    },

                    //  Gestion du Drop (choix de la colonne utilisateur)
                    drop: function(date, jsEvent, ui) {
              			console.log("debut drop  ");

                		console.log($('#calendar-0').fullCalendar('clientEvents'))
                       // var eventTitle = ui.helper.text().trim();
                        
                        var eventTitle = ui.helper.attr("data-title");
                        var eventDuration = parseInt(ui.helper.attr("data-duration"));
                        var eventIndex = parseInt(ui.helper.attr("data-index"));
                        var startDate = moment(date);
                        var endDate = moment(startDate).add(eventDuration, 'hours');
                        
                        // Vérifier si la tâche contient un `issue`
                        var task = vm.tasks[eventIndex];
                        var userData = user ? JSON.stringify(user) : null;
                        var uuidtp = uuidv4();
                        var colortmp = getColorByType( task.issue);
                        var event = {
                        		id:null,
                        		uuid:uuidtp,
                                title: eventTitle,
                                start: startDate,
                                end: endDate,
                                allDay: false,
                                color: colortmp,
                                user: userData,
                                teamworkId: task.issue.id 
                         }
                        
                         $('#calendar-' + index).fullCalendar('renderEvent', event, true);   
                        
                        // Chercher l'événement via son titre ou autre critère unique
                        var addedEvent = $('#calendar-' + index).fullCalendar('clientEvents', function(ev) {
                            return ev.uuid === event.uuid && ev.start.isSame(event.start);
                        });

                        // Si l'événement est trouvé, affiche son ID
                        if (addedEvent.length > 0) {
                            console.log('ID attribué par FullCalendar:'+ addedEvent[0]._id);
                            event._id = addedEvent[0]._id;
                        }
                     
                        $scope.$apply(function () {
                            vm.tasks.splice(eventIndex,1 );
                            vm.filterTasks();
                        });  
                        vm.updateEvent(event,index);
            			console.log("fin drop  "+"eventId:"+event.id +" _id:"+event._id);
                    },
                    select: function(datedeb, datefin ) {
                    	vm.modalTitle = $filter('translate')('wamasysApp.calendar.ajouterEvenement');
                        $scope.$apply(function () {
	                    	vm.eventData = {};
	                        if ( datedeb) {
	                      //  	vm.eventData.start = convertLocalDateToDateWithSpecificTimezone(datedeb);//new Date( datedeb); // Convertit la chaîne en objet Date
	                        	vm.eventData.start = new Date( datedeb); // Convertit la chaîne en objet Date
	                        }
	                        if ( datefin) {
	                    //	   vm.eventData.end = convertLocalDateToDateWithSpecificTimezone(datefin);//new Date(datefin);
	                    	   vm.eventData.end =new Date(datefin);
	                        }
	                        vm.eventData.user = user;
	                        vm.eventData.indexCalendar = index;
	                       
	                        $('#eventModal').modal('show');        
	                        $timeout(function() {
	                        	$('#field_title').focus();
	                        }, 500);
                        });  
                    },
                    events: function(start, end, timezone, callback) {
                        $('#calendar-' + index).fullCalendar('removeEvents');   
                    	vm.loadEvents(user,start, end, callback);
                    },
                    eventDrop: function(event) {
            			console.log("eventDrop  "+"eventId:"+event.id +" _id:"+event._id);
                        vm.updateEvent(event,index);
                    },
                    eventResize: function(event) {
                        vm.updateEvent(event,index);
                    },
                    eventClick: function(event) {
                        $scope.$apply(function() {

                        	vm.modalTitle = $filter('translate')('wamasysApp.calendar.modifierEvenement');
                            vm.eventData = angular.copy(event);
                            if ( vm.eventData.start) {
                            	 vm.eventData.start = new Date( vm.eventData.start); // Convertit la chaîne en objet Date
                            }
                            if ( vm.eventData.end) {
                            	 vm.eventData.end = new Date( vm.eventData.end);
                            }
                            vm.eventData.indexCalendar = index;
                            $('#eventModal').modal('show');
                        });
                    },
                    eventDragEnter: function (event, jsEvent, ui) {
                        $(".fc-highlight").css("background-color", "#ffcc80");
                    },
                    eventDragLeave: function (event, jsEvent, ui) {
                        $(".fc-highlight").css("background-color", "");
                    },
                    eventReceive: function (event) {
            			console.log("eventReceive  "+"eventId:"+event.id +" _id:"+event._id);
            		    if (event._id) {
            		        $('#calendar-' + index).fullCalendar('removeEvents', event._id);
            		    }
            		    
                        var eventElement = $("div.fc-event:contains('" + event.title + "')");
                        eventElement.addClass("highlight-event");

                        setTimeout(function () {
                            eventElement.removeClass("highlight-event");
                        }, 1000);
                        
                    },
                    eventRender: function(event, element) {
                        // Ajoute un bouton pour supprimer l'événement
                        var deleteBtn = $('<br/><span class="delete-event" style="cursor: pointer; margin-left: 5px;">❌</span>');
                        element.find('.fc-title').append(deleteBtn);
                        
                        if(event.teamworkId){
                        	  element.find('.fc-title').prepend('<a style="color:white;" href="'+event.teamworkUrl+'" target="_blank">#'+event.teamworkId+' </a> ');
                        }
                        
                        
                        element.css('background-color', getColorByType( event.teamworkId));
                        
                        // Supprime l'événement au clic et le remet dans la liste
                        deleteBtn.on('click', function () {
                        	 $('#calendar-' + index).fullCalendar('removeEvents', event._id);

                             CalendarService.deleteEvent({id:event.id},function(response) {},onError );
                             if(event.teamworkId){
      		                	$scope.$apply(function () {
      		                		$timeout(vm.loadAllIssues, timeOutAppelServeur);
      		                	});
      		                }
                        });
                    }
                });
//                setTimeout(function() {
//                    $('#calendar-' + index).fullCalendar('render');
//                }, 100);

                // Appeler cette fonction après l'initialisation des calendriers
                setTimeout(vm.syncCalendars, 500);
            });

      
        }
        
        function initTaskDroppable() {

            //  Rendre les tâches draggable
            $('.task').each(function () {
                $(this).data('event', {
                    title: $(this).text(),
                    duration: parseInt($(this).attr('data-duration')),
                    stick: true
                }).draggable({
                    zIndex: 999,
                  //  revert: true,
                    revertDuration: 100,
                    revert: "invalid",
                    helper: "clone",  // Permet d'afficher un clone et non l'élément original
                    start: function(event, ui) {
                        $(this).addClass("dragging");
                    },
                    stop: function(event, ui) {
                        $(this).removeClass("dragging");
                    }
                });
            });
        }
        
        // Fonction pour obtenir une couleur unique par user
        function getUserColor(user) {
            var colors = ["#ffadad", "#9bf6ff", "#ffd6a5", "#0033cc", "#337ab7"];
            return colors[vm.users.indexOf(user) % colors.length];
        }
        
        function getColorByType(issue) {
        	if(issue){
        		return "#0033cc";
        	}else{
        		return "#337ab7";
        	}
        }

        
        vm.showCalendar = function (){
        	if( vm.userSelected &&  vm.userSelected.length>0){
            	$("#divOptions").hide();
        	}else{
            	$("#divOptions").show();
        	}
        	$timeout(initCalendar, timeOutAppelServeur);
            $timeout(initTaskDroppable, timeOutAppelServeur);
    	}
    	
        vm.areaSelectedChanged = function (){
	     	if( vm.areaSelected &&  vm.areaSelected.length>0){
            	$("#selectUsers").show();
            
            	var listIdArea =  vm.areaSelected.map(function(area){return area.id});
                vm.users = UserSearch.searchUserByArea({ offset: 0, size: 1000, agenceId:listIdArea});
                vm.loadAllIssues();
        	}else{
            	$("#selectUsers").hide();
            	vm.userSelected = [];
            	vm.showCalendar();
        	}
    	}
        vm.areaSelectedChanged();
        
        // Charger les événements pour les utilisateurs sélectionnés
        vm.loadEvents = function(user,start, end, callback) {
            if (vm.userSelected.length === 0) {
                callback([]); // Aucune sélection, aucun événement
                return;
            }
            var listId = [];
        	listId.push(user.id);
            CalendarService.findEvents({
                usersId: listId.join(','), 
                from: moment(start.toISOString()).toISOString(true),
                to: moment(end.toISOString()).toISOString(true)
            },function(response) {
         
            	if(response && response.length>0){
            		callback(response);
            	}else{
            		callback([]);
            	}
            },onError);
        };
        

        // Mettre à jour un événement après un déplacement ou un redimensionnement
        vm.updateEvent = function(event,indexFullCalendar) {
        	console.log("appel updateEvent eventId:"+event.id +" _id:"+event._id);
        	var user= {};
        	if (typeof event.user === 'string' || event.user instanceof String){
        		 user= event.user ? JSON.parse(event.user) : null;
        	}else{
        		user = event.user;
        	}
//
//            var startAvecTimezone = convertLocalDateToDateWithSpecificTimezone(vm.eventData.start);
//            var endAvecTimezone =  convertLocalDateToDateWithSpecificTimezone(vm.eventData.end) ; 
        	
            var updatedEvent = {
                id: event.id,
                title: event.title,
                comment: event.comment,
                address: event.address,
           //     start: startAvecTimezone.toISOString(true),
        //        end: endAvecTimezone.toISOString(true),
                start:  moment(event.start.toISOString()).toISOString(true),
                end:  moment(event.end.toISOString()).toISOString(true),
                user: user,
                teamworkId : event.teamworkId
            };
            CalendarService.saveEvent(updatedEvent,
            		function(response) {
            	console.log($('#calendar-0').fullCalendar('clientEvents'))
            			console.log("réponse updateEvent "+response.id+" eventId:"+event.id +" _id:"+event._id);
		            	if(response && response.id ){
		            		event.id = response.id;
		            		
		            		if( event._id){
			            	  $('#calendar-' + indexFullCalendar).fullCalendar('removeEvents', event._id);
		            		}
		            		console.log($('#calendar-0').fullCalendar('clientEvents'))
		            		
			            	$('#calendar-' + indexFullCalendar).fullCalendar('renderEvent', event,true);
//		            		setTimeout(function() {
//			            		$('#calendar-0').fullCalendar('rerenderEvents');
//			            		console.log($('#calendar-0').fullCalendar('clientEvents'))
//		            			}, 100);
		            	}
            		},onError
            
            );
        };

        
        vm.saveEvent = function () {
        	vm.isSaving=true;

//            var startAvecTimezone = convertLocalDateToDateWithSpecificTimezone(vm.eventData.start);
//            var endAvecTimezone =  convertLocalDateToDateWithSpecificTimezone(vm.eventData.end) ; 
            
            var eventToSave = {
            		id:vm.eventData.id,
            		uuid:uuidv4(),
                    title: vm.eventData.title,
                    comment: vm.eventData.comment,
                    address: vm.eventData.address,
//                    start: startAvecTimezone.toISOString(true),
//                    end: endAvecTimezone.toISOString(true),
                    start:vm.eventData.start,
                    end: vm.eventData.end,
                    allDay: false,
                    user: vm.eventData.user, 
                    teamworkId: vm.eventData.teamworkId
                     ,
                    createdBy: vm.eventData.createdBy ,
                    createdDate: vm.eventData.createdDate ,
                    
                }
            
            
            CalendarService.saveEvent(eventToSave,
            		function(response) {
            			vm.isSaving=false;
		            	if(response && response.id ){
		            		if(vm.eventData.indexCalendar){
                            	$('#calendar-' + vm.eventData.indexCalendar).fullCalendar('refetchEvents');
		            		}else{
                                vm.userSelected.forEach(function(user, index) {
                                	$('#calendar-' + index).fullCalendar('refetchEvents');
                                	}
                                );
		            		}
		                    $('#eventModal').modal('hide');
//                                $scope.$apply(function () {
//                                	vm.showCalendar();
//                                });
		            	}
            		},onError
                
                );
        };

        vm.deleteEvent = function () {
            CalendarService.deleteEvent({id:vm.eventData.id},
            		function(response) {
	            		if(vm.eventData.teamworkId){
			                $timeout(vm.loadAllIssues, 200);
		                }
            		},onError
                
                );

       	 	$('#calendar-' + vm.eventData.indexCalendar).fullCalendar('removeEvents', vm.eventData._id);

            $('#eventModal').modal('hide');

 
        };

        
        
        vm.user = {} ;
        Principal.identity().then(function(account) {
        	if(account){
              vm.user =account ;
              if(account.agencesRattachement){
            	  vm.listeArea = account.agencesRattachement;
              }
        		
        	}
        });

        vm.loadAllIssues =  function () {

        	var listIdArea =  vm.areaSelected.map(function(area){return area.id});

        	RedmineService.issuesNotAssignedByArea({
                page: 0, size: 100, agenceId:listIdArea}, onSuccessLoadAllIssues, onError);
    	
        }

        
        function onSuccessLoadAllIssues(data, headers) {
            vm.totalItems = data.total_count;
            vm.queryCount = vm.totalItems;
            vm.displayedTasks = [];
            vm.tasks = [];
            vm.uniqueTrackers = [];
            vm.listIssues = data;

           	
           	vm.listIssues.issues.forEach(function(issue, index) {
           		var duration = issue.estimated_hours ?issue.estimated_hours :1;
           		vm.tasks.push({ label: issue.subject, duration: duration,issue:issue });
                if (vm.uniqueTrackers.indexOf(issue.tracker.name) === -1) {
                	vm.uniqueTrackers.push(issue.tracker.name);
                }
           	});
            vm.displayedTasks = angular.copy(vm.tasks);
            $timeout(initTaskDroppable, 200);
            vm.filterTasks();
            
        }
        
        // Extraction des trackers uniques 
        vm.uniqueTrackers = [];

        // Liste des trackers sélectionnés
        vm.selectedTrackers = [];
        
        // Fonction de filtrage
        vm.filterTasks = function() {
            if (vm.selectedTrackers.length === 0) {
            	vm.displayedTasks = angular.copy(vm.tasks); // Afficher toutes les tâches
            } else {
            	vm.displayedTasks = vm.tasks.filter(function(task) {
                    return vm.selectedTrackers.indexOf(task.issue.tracker.name) !== -1;
                });
            }
            $timeout(initTaskDroppable, 200);
        };
        
        function onError(error) {
        	//console.log(error);
			vm.isSaving=false;
            AlertService.error(error.data.message);
        }
        
        function uuidv4() {
        	  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function(c){
        	   return  (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16);}
        	  );
        }
        
        
        /** Ca c'est pour synchronisé les boutons week day et changement de jour entre tous les calendriers. */
        vm.syncCalendars = function () {
            $('.user-column').each(function (index) {
                var calendar = $('#calendar-' + index);

//                // Synchroniser changement de vue (mois/semaine/jour)
//                calendar.fullCalendar('option', 'viewRender', function (view) {
//                    $('.user-column').each(function (i) {
//                        if (i !== index) {
//                            $('#calendar-' + i).fullCalendar('changeView', view.name);
//                        }
//                    });
//                });

                // Synchroniser navigation entre semaines/jours/mois
                calendar.fullCalendar('', 'viewRender', function (view, element) {
                	var currentDate = calendar.fullCalendar('getDate');
                    $('.user-column').each(function (i) {
                        if (i !== index) {
                            $('#calendar-' + i).fullCalendar('gotoDate', currentDate);
                            $('#calendar-' + i).fullCalendar('changeView', view.name);
                        }
                    });
                });
            });
        };

    
        
	    vm.printCalendar = function() {
	        
	        if (vm.userSelected.length === 0) {
                callback([]); // Aucune sélection, aucun événement
                return;
            }
	        var listId = vm.userSelected.map(function(user) {return user.id;}); // Liste des IDs des utilisateurs sélectionnés
	        var view = $('#calendar-0').fullCalendar('getView');
	        var start = view.start;
	        var end = view.end;
	        
//	        var start = moment().startOf('week'); // Début de la semaine actuelle
//	        var end = moment().endOf('week'); // Fin de la semaine actuelle

            CalendarService.findEvents({
                usersId: listId.join(','), 
                from: moment(start.toISOString()).toISOString(true),
                to: moment(end.toISOString()).toISOString(true)
            },function(response) {
            	if(response && response.length>0){
                    generatePrintableCalendar(response,start,end);
            	}
            },onError);

	    };

	    function getRandomColor() {
	        return '#' + Math.floor(Math.random()*16777215).toString(16);
	    }
	    
	    function generatePrintableCalendar(events,start,end) {
	        var printWindow = window.open('', '_blank');
	        
	        
	        var userColors = {}; // Map UserId => Couleur
	        var availableColors = [ 
	            "#FF5733", "#33FF57", "#3357FF", "#F39C12", "#8E44AD", 
	            "#D35400", "#1ABC9C", "#C0392B", "#2C3E50", "#27AE60"
	        ]; // 10 couleurs prédéfinies
	        

	        var colorIndex = 0;
	        // Assigner une couleur unique à chaque utilisateur
	        events.forEach(function(event) {
	            if (!userColors[event.user.id]) {
	                userColors[event.user.id] = availableColors[colorIndex % availableColors.length];
	                colorIndex++;
	            }
	        });

	        var style = '<style>'/*
	              +'  body { font-family: Arial, sans-serif; margin: 10px; }'
	              +'  #calendar-print { max-width: 100%; margin: auto; }'
	              +' .fc-event { font-size: 12px; padding: 5px; border-radius: 4px; color: white; }'
	              +' .fc-day-grid-event { border-radius: 4px; }'
	              +' .fc-toolbar { display: none; }'
	              +' @media print {'
	              +'     body { margin: 0; }'
	              +'    .visible-print  { display: inherit !important; }' 
	              +'    .hidden-print   { display: none !important; }' 
	              +' }'*/
	              +'</style>';

	        printWindow.document.write('<html><head>'
	        		+'<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/fullcalendar/3.10.2/fullcalendar.min.css">'
	                +'<script src="https://cdnjs.cloudflare.com/ajax/libs/fullcalendar/3.10.2/fullcalendar.min.js"></script> '
	        		+'<link href="//cdnjs.cloudflare.com/ajax/libs/fullcalendar/3.10.2/fullcalendar.print.css " rel="stylesheet" type="text/css" media="print" />' 
//	        		+'<link href="//cdnjs.cloudflare.com/ajax/libs/fullcalendar/1.6.4/fullcalendar.css" rel="stylesheet" type="text/css" />' 
//	        		+'<link href="//cdnjs.cloudflare.com/ajax/libs/fullcalendar/1.6.4/fullcalendar.print.css " rel="stylesheet" type="text/css" media="print" />' 
	        		+'<title>Wamasys planning</title>' + style + '</head>'
	        //		+'<script type="text/javascript">  $(\'.printBtn\').on(\'click\', function (){   window.print(); });</script>'
	        		+'<body>');
	       // printWindow.document.write('<button class="printBtn hidden-print">Print</button><div id="calendar-print"></div>');
	        	printWindow.document.write('<div id="calendar-print"></div>');
	        printWindow.document.write('</body></html>');
	        printWindow.document.close();

	        setTimeout(function() {
	            var calendarElement = printWindow.document.getElementById('calendar-print');

	        	var timezoneString = convertOffsetToTimezoneString(vm.manualTimezoneOffset);
	        	timezoneString = 'local';
	        	
	            $(calendarElement).fullCalendar({
            	  customButtons: {
            		    myCustomButton: {
            		      text: 'Print !',
            		      click: function() {
            		    	  printWindow.print(); 
            		      }
            		    }
            		  },
            	  timezone : timezoneString,
        		  defaultDate: start,      
        		  visibleRange: {
        		    start: start,
        		    end: end
        		  },
	                header: {
		                  left: ' myCustomButton',//prev,next today
	                    center: 'title',
		                  right: 'agendaWeek,agendaDay'
	                },
                    minTime: vm.minTime+":00:00",  // Initial minTime from model
                    maxTime: vm.maxTime+":00:00",  // Initial maxTime from model
	                defaultView: 'agendaWeek',//
	                editable: false,
	                slotEventOverlap: false, // Éviter le chevauchement
	                eventOverlap: true,
	                events: events.map(function(event){
	                	return {
	                    title: event.title+' ('+event.user.firstName+' '+event.user.lastName+')',
	                    start: event.start,
	                    end: event.end,
	                    color: userColors[event.user.id]  // Appliquer la couleur assignée
	                };})
	            });

	         //   printWindow.print();
	           // printWindow.close();
	        }, 500);
	    }

    
	 // Convertit un offset en heures en string timezone de FullCalendar
	    function convertOffsetToTimezoneString(offset) {
	      var sign = offset >= 0 ? '+' : '-';
	      var absOffset = Math.abs(offset);
	      var hours = String(Math.floor(absOffset)).padStart(2, '0');
	      var minutes = String((absOffset % 1) * 60).padStart(2, '0');
	      return 'UTC'+sign+''+hours+':'+minutes;
	    }

	    function convertLocalDateToDateWithSpecificTimezone( dateAConvertir) {
	    	// Offset choisi dans ton input (ex: +2 => 2)
	    	var offset = parseInt(vm.manualTimezoneOffset ); // en heures
	    	var offsetInMs = offset * 60 * 60 * 1000;

	    	var dateTimestamp = Date.parse(dateAConvertir);
	    	var dateAvecTimezone = new Date(dateTimestamp - offsetInMs);
	    	return dateAvecTimezone;
		}



    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-field-definition', {
            parent: 'entity',
            url: '/event-field-definition?page&sort',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Dictionnaire des champs événement'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/event-field-definition/event-field-definitions.html',
                    controller: 'EventFieldDefinitionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'fieldCode,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-field-definition.new', {
            parent: 'event-field-definition',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$state', '$uibModal', function($state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-field-definition/event-field-definition-dialog.html',
                    controller: 'EventFieldDefinitionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fieldCode: null,
                                label: null,
                                dataType: 'text',
                                valuePossibleJson: '[]',
                                constraintsJson: '{}',
                                validationsJson: '[]',
                                exampleValuesJson: '[]',
                                requiredByDefault: false,
                                hiddenForEncoder: false,
                                active: true,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-field-definition', null, { reload: true });
                }, function() {
                    $state.go('event-field-definition');
                });
            }]
        })
        .state('event-field-definition.edit', {
            parent: 'event-field-definition',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-field-definition/event-field-definition-dialog.html',
                    controller: 'EventFieldDefinitionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventFieldDefinition', function(EventFieldDefinition) {
                            return EventFieldDefinition.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-field-definition', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('EventFieldDefinition', EventFieldDefinition);

    EventFieldDefinition.$inject = ['$resource'];

    function EventFieldDefinition ($resource) {
        var resourceUrl = 'api/event-field-definitions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': { method: 'GET' },
            'update': { method: 'PUT' },
            'versions': { method: 'GET', isArray: true, url: 'api/event-field-definitions/:id/versions' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFieldDefinitionController', EventFieldDefinitionController);

    EventFieldDefinitionController.$inject = ['$state', '$uibModal', 'EventFieldDefinition', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'EventConfigurationAssistant'];

    function EventFieldDefinitionController($state, $uibModal, EventFieldDefinition, ParseLinks, AlertService, pagingParams, paginationConstants, EventConfigurationAssistant) {
        var vm = this;
        vm.openAssistant = function() { EventConfigurationAssistant.open('FIELDS', loadAll); };
        EventConfigurationAssistant.canUse('FIELDS').then(function(allowed) { vm.canUseAssistant = allowed; });

        vm.fieldDefinitions = [];
        vm.inclInactive = false;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.openVersions = openVersions;
        vm.dataTypeLabel = dataTypeLabel;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        loadAll();

        function loadAll() {
            EventFieldDefinition.query({
                inclInactive: vm.inclInactive,
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.fieldDefinitions = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data && error.data.message ? error.data.message : 'Erreur lors du chargement du dictionnaire.');
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            });
        }

        function openVersions(fieldDefinition) {
            $uibModal.open({
                templateUrl: 'app/business/event-field-definition/event-field-definition-versions.html',
                controller: 'EventFieldDefinitionVersionsController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return fieldDefinition;
                    }
                }
            });
        }

        function dataTypeLabel(dataType) {
            var labels = {
                text: 'Texte',
                integer: 'Entier',
                decimal: 'Décimal',
                boolean: 'Booléen',
                date: 'Date',
                datetime: 'Date/heure',
                list: 'Liste',
                satisfaction_smiley: 'Satisfaction smiley',
                ref_contrat: 'RefContrat'
            };
            return labels[dataType] || dataType;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFieldDefinitionVersionsController', EventFieldDefinitionVersionsController);

    EventFieldDefinitionVersionsController.$inject = ['$uibModalInstance', 'entity', 'EventFieldDefinition', 'AlertService'];

    function EventFieldDefinitionVersionsController($uibModalInstance, entity, EventFieldDefinition, AlertService) {
        var vm = this;

        vm.fieldDefinition = entity;
        vm.versions = [];
        vm.clear = clear;

        EventFieldDefinition.versions({id: entity.id}, function(result) {
            vm.versions = result || [];
        }, function(error) {
            AlertService.error(error.data && error.data.message ? error.data.message : 'Erreur lors du chargement des versions.');
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFieldDefinitionDialogController', EventFieldDefinitionDialogController);

    EventFieldDefinitionDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'EventFieldDefinition', 'AlertService'];

    function EventFieldDefinitionDialogController($scope, $uibModalInstance, entity, EventFieldDefinition, AlertService) {
        var vm = this;

        vm.fieldDefinition = entity;
        vm.isEdit = !!vm.fieldDefinition.id;
        vm.dataTypeOptions = buildDataTypeOptions();
        vm.constraintDefinitions = buildConstraintDefinitions();
        vm.validationTypes = buildValidationTypes();

        vm.clear = clear;
        vm.save = save;
        vm.addValidationRule = addValidationRule;
        vm.removeValidationRule = removeValidationRule;
        vm.requiresSingleValue = requiresSingleValue;
        vm.requiresValuesList = requiresValuesList;
        vm.availableValidationTypes = availableValidationTypes;
        vm.validationTypeHelp = validationTypeHelp;
        vm.validationValuePlaceholder = validationValuePlaceholder;
        vm.onValidationTypeChange = onValidationTypeChange;
        vm.supportsConstraint = supportsConstraint;
        vm.addAdditionalConstraint = addAdditionalConstraint;
        vm.removeAdditionalConstraint = removeAdditionalConstraint;
        vm.hasVisibleConstraintDefinitions = hasVisibleConstraintDefinitions;
        vm.supportsPossibleValues = supportsPossibleValues;
        vm.onDataTypeChange = onDataTypeChange;

        vm.fieldDefinition.active = vm.fieldDefinition.active !== false;
        vm.fieldDefinition.requiredByDefault = !!vm.fieldDefinition.requiredByDefault;
        vm.fieldDefinition.hiddenForEncoder = !!vm.fieldDefinition.hiddenForEncoder;
        vm.fieldDefinition.constraintsJson = vm.fieldDefinition.constraintsJson || '{}';
        vm.fieldDefinition.exampleValuesJson = vm.fieldDefinition.exampleValuesJson || '[]';
        vm.fieldDefinition.valuePossibleJson = vm.fieldDefinition.valuePossibleJson || '[]';

        vm.validationRules = parseValidationRules(vm.fieldDefinition.validationsJson);
        vm.constraintsModel = parseConstraints(vm.fieldDefinition.constraintsJson);
        vm.valuePossibleText = joinLines(parseStringArray(vm.fieldDefinition.valuePossibleJson));
        vm.exampleValuesText = joinLines(parseStringArray(vm.fieldDefinition.exampleValuesJson));
        applyDataTypePreset(false);

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            try {
                vm.fieldDefinition.validationsJson = JSON.stringify(serializeValidationRules(vm.validationRules), null, 2);
                syncPossibleValuesFromRules();
                vm.fieldDefinition.valuePossibleJson = supportsPossibleValues()
                    ? JSON.stringify(resolveValueOptionsForSave(), null, 2)
                    : '[]';
                vm.fieldDefinition.exampleValuesJson = JSON.stringify(splitMultilineValues(vm.exampleValuesText), null, 2);
                vm.fieldDefinition.constraintsJson = JSON.stringify(serializeConstraints(), null, 2);
            } catch (e) {
                AlertService.error('Le paramétrage du dictionnaire contient une valeur invalide.');
                vm.isSaving = false;
                return;
            }

            if (vm.fieldDefinition.id !== null) {
                EventFieldDefinition.update(vm.fieldDefinition, onSaveSuccess, onSaveError);
            } else {
                EventFieldDefinition.save(vm.fieldDefinition, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('wamasysApp:eventFieldDefinitionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError(error) {
            vm.isSaving = false;
            AlertService.error(error.data && error.data.message ? error.data.message : 'Erreur lors de l\'enregistrement du champ.');
        }

        function addValidationRule() {
            vm.validationRules.push({
                type: defaultValidationTypeForCurrentField(),
                severity: 'ERROR',
                value: null,
                valuesText: ''
            });
        }

        function removeValidationRule(index) {
            vm.validationRules.splice(index, 1);
        }

        function requiresSingleValue(rule) {
            return getValidationType(rule.type).inputMode === 'single';
        }

        function requiresValuesList(rule) {
            return getValidationType(rule.type).inputMode === 'list';
        }

        function availableValidationTypes(rule) {
            return vm.validationTypes.filter(function(type) {
                return isCompatibleWithCurrentType(type) || (rule && rule.type === type.code);
            });
        }

        function validationTypeHelp(rule) {
            return getValidationType(rule.type).help;
        }

        function validationValuePlaceholder(rule) {
            return getValidationType(rule.type).placeholder || 'Valeur';
        }

        function onValidationTypeChange(rule) {
            if (!requiresSingleValue(rule)) {
                rule.value = null;
            }
            if (!requiresValuesList(rule)) {
                rule.valuesText = '';
            }
        }

        function supportsConstraint(constraint) {
            if (!constraint || !constraint.supportedDataTypes || !constraint.supportedDataTypes.length) {
                return true;
            }
            return constraint.supportedDataTypes.indexOf(effectiveDataType(vm.fieldDefinition.dataType)) !== -1;
        }

        function addAdditionalConstraint() {
            vm.constraintsModel.additional.push({key: '', value: ''});
        }

        function removeAdditionalConstraint(index) {
            vm.constraintsModel.additional.splice(index, 1);
        }

        function hasVisibleConstraintDefinitions() {
            var visible = false;
            angular.forEach(vm.constraintDefinitions, function(definition) {
                if (!visible && supportsConstraint(definition)) {
                    visible = true;
                }
            });
            return visible;
        }

        function buildConstraintDefinitions() {
            return [
                {key: 'min', label: 'Minimum', placeholder: '0', help: 'Borne technique minimale.', supportedDataTypes: ['integer', 'decimal'], valueType: 'number'},
                {key: 'max', label: 'Maximum', placeholder: '100000', help: 'Borne technique maximale.', supportedDataTypes: ['integer', 'decimal'], valueType: 'number'},
                {key: 'step', label: 'Pas conseillé', placeholder: '1 ou 0.01', help: 'Pas de saisie conseillé pour l\'interface.', supportedDataTypes: ['integer', 'decimal'], valueType: 'number'},
                {key: 'minDate', label: 'Date minimale', placeholder: '2026-01-01', help: 'Date minimale acceptée.', supportedDataTypes: ['date', 'datetime'], valueType: 'string'},
                {key: 'maxDate', label: 'Date maximale', placeholder: '2026-12-31', help: 'Date maximale acceptée.', supportedDataTypes: ['date', 'datetime'], valueType: 'string'},
                {key: 'maxSelections', label: 'Nombre maximal de choix', placeholder: '5', help: 'Limite le nombre de valeurs sélectionnables.', supportedDataTypes: ['list'], valueType: 'integer'}
            ];
        }

        function buildValidationTypes() {
            return [
                {code: 'MIN_VALUE', label: 'Valeur minimale', group: 'Numérique', inputMode: 'single', supportedDataTypes: ['integer', 'decimal'], placeholder: '0', help: 'La valeur doit être supérieure ou égale à ce seuil.'},
                {code: 'MAX_VALUE', label: 'Valeur maximale', group: 'Numérique', inputMode: 'single', supportedDataTypes: ['integer', 'decimal'], placeholder: '1000', help: 'La valeur doit être inférieure ou égale à ce seuil.'},
                {code: 'DECIMAL_SCALE_MAX', label: 'Nombre maximal de décimales', group: 'Numérique', inputMode: 'single', supportedDataTypes: ['decimal'], placeholder: '2', help: 'Limite le nombre de décimales autorisées.'},
                {code: 'INTEGER_ONLY', label: 'Entiers uniquement', group: 'Numérique', inputMode: 'none', supportedDataTypes: ['integer', 'decimal'], help: 'Refuse les valeurs décimales.'},
                {code: 'POSITIVE_ONLY', label: 'Valeurs strictement positives', group: 'Numérique', inputMode: 'none', supportedDataTypes: ['integer', 'decimal'], help: 'La valeur doit être strictement supérieure à zéro.'},
                {code: 'NEGATIVE_FORBIDDEN', label: 'Valeurs négatives interdites', group: 'Numérique', inputMode: 'none', supportedDataTypes: ['integer', 'decimal'], help: 'La valeur ne peut pas être négative.'},
                {code: 'MIN_LENGTH', label: 'Longueur minimale', group: 'Texte', inputMode: 'single', supportedDataTypes: ['text'], placeholder: '3', help: 'Le texte doit contenir au moins ce nombre de caractères.'},
                {code: 'MAX_LENGTH', label: 'Longueur maximale', group: 'Texte', inputMode: 'single', supportedDataTypes: ['text'], placeholder: '120', help: 'Le texte ne doit pas dépasser ce nombre de caractères.'},
                {code: 'REGEX', label: 'Expression régulière', group: 'Texte', inputMode: 'single', supportedDataTypes: ['text'], placeholder: '^[^<>]*$', help: 'Le texte doit respecter ce motif.'},
                {code: 'NOT_BLANK', label: 'Valeur non vide', group: 'Texte', inputMode: 'none', supportedDataTypes: ['text'], help: 'Refuse les chaînes vides ou composées uniquement d\'espaces.'},
                {code: 'FORBIDDEN_WORDS', label: 'Mots interdits', group: 'Texte', inputMode: 'list', supportedDataTypes: ['text'], placeholder: 'mot1;mot2', help: 'Refuse les textes contenant un des mots indiqués.'},
                {code: 'ALLOWED_VALUES', label: 'Valeurs texte autorisées', group: 'Texte', inputMode: 'list', supportedDataTypes: ['text'], placeholder: 'valeur1;valeur2', help: 'Limite le champ texte à cette liste fermée.'},
                {code: 'DATE_NOT_IN_FUTURE', label: 'Date non future', group: 'Date', inputMode: 'none', supportedDataTypes: ['date', 'datetime'], help: 'Refuse une date postérieure à aujourd\'hui.'},
                {code: 'DATE_NOT_BEFORE', label: 'Date minimale', group: 'Date', inputMode: 'single', supportedDataTypes: ['date', 'datetime'], placeholder: '2026-01-01', help: 'La date doit être postérieure ou égale à cette borne.'},
                {code: 'DATE_NOT_AFTER', label: 'Date maximale', group: 'Date', inputMode: 'single', supportedDataTypes: ['date', 'datetime'], placeholder: '2026-12-31', help: 'La date doit être antérieure ou égale à cette borne.'},
                {code: 'DATE_AGE_MAX_DAYS', label: 'Ancienneté maximale en jours', group: 'Date', inputMode: 'single', supportedDataTypes: ['date', 'datetime'], placeholder: '30', help: 'Déclenche si la date est trop ancienne.'},
                {code: 'DATE_AGE_MIN_DAYS', label: 'Ancienneté minimale en jours', group: 'Date', inputMode: 'single', supportedDataTypes: ['date', 'datetime'], placeholder: '1', help: 'Impose un nombre minimal de jours entre la date et aujourd\'hui.'},
                {code: 'VALUE_IN_ENUM', label: 'Valeur dans la liste', group: 'Liste de choix', inputMode: 'list', supportedDataTypes: ['list'], placeholder: 'A;B;C', help: 'La valeur sélectionnée doit appartenir à cette liste.'},
                {code: 'MULTISELECT_MIN_COUNT', label: 'Nombre minimal de choix', group: 'Liste de choix', inputMode: 'single', supportedDataTypes: ['list'], placeholder: '1', help: 'Impose un nombre minimal de choix sur un multi-sélecteur.'}
            ];
        }

        function getValidationType(code) {
            var result = null;
            angular.forEach(vm.validationTypes, function(item) {
                if (!result && item.code === code) {
                    result = item;
                }
            });
            return result || {inputMode: 'none'};
        }

        function parseValidationRules(validationsJson) {
            if (!validationsJson) {
                return [];
            }
            try {
                return angular.fromJson(validationsJson).map(function(rule) {
                    return {
                        type: rule.type,
                        severity: rule.severity || 'ERROR',
                        value: rule.value,
                        valuesText: angular.isArray(rule.values) ? rule.values.join(';') : ''
                    };
                });
            } catch (e) {
                return [];
            }
        }

        function serializeValidationRules(rules) {
            return (rules || []).filter(function(rule) {
                return !!rule.type;
            }).map(function(rule) {
                var serialized = {
                    type: rule.type,
                    severity: rule.severity || 'ERROR'
                };
                if (requiresSingleValue(rule) && rule.value !== null && rule.value !== undefined && rule.value !== '') {
                    serialized.value = rule.value;
                }
                if (requiresValuesList(rule)) {
                    serialized.values = splitInlineValues(rule.valuesText);
                }
                return serialized;
            });
        }

        function syncPossibleValuesFromRules() {
            if (!supportsPossibleValues()) {
                return;
            }
            if (splitMultilineValues(vm.valuePossibleText).length) {
                return;
            }

            var values = [];
            angular.forEach(vm.validationRules, function(rule) {
                if ((rule.type === 'VALUE_IN_ENUM' || rule.type === 'ALLOWED_VALUES') && rule.valuesText) {
                    values = splitInlineValues(rule.valuesText);
                }
            });

            if (values.length) {
                vm.valuePossibleText = joinLines(values);
            }
        }

        function parseConstraints(constraintsJson) {
            var source = parseJsonObject(constraintsJson);
            var model = {
                values: {},
                additional: []
            };

            angular.forEach(vm.constraintDefinitions, function(definition) {
                if (source.hasOwnProperty(definition.key)) {
                    model.values[definition.key] = formatConstraintValue(source[definition.key]);
                    delete source[definition.key];
                }
            });

            angular.forEach(source, function(value, key) {
                model.additional.push({
                    key: key,
                    value: formatConstraintValue(value)
                });
            });

            return model;
        }

        function serializeConstraints() {
            var serialized = {};

            angular.forEach(vm.constraintDefinitions, function(definition) {
                var rawValue = vm.constraintsModel.values[definition.key];
                if (isBlankValue(rawValue)) {
                    return;
                }
                serialized[definition.key] = normalizeConstraintValue(rawValue, definition.valueType);
            });

            angular.forEach(vm.constraintsModel.additional || [], function(item) {
                if (!item || isBlankValue(item.key) || isBlankValue(item.value)) {
                    return;
                }
                serialized[String(item.key).trim()] = parseLooseValue(item.value);
            });

            return serialized;
        }

        function parseStringArray(source) {
            if (!source) {
                return [];
            }
            try {
                var parsed = angular.fromJson(source);
                if (angular.isArray(parsed)) {
                    return parsed.map(function(item) {
                        return String(item).trim();
                    }).filter(function(item) {
                        return item.length > 0;
                    });
                }
            } catch (e) {
                return splitMultilineValues(source);
            }
            return splitMultilineValues(source);
        }

        function parseJsonObject(source) {
            if (!source) {
                return {};
            }
            try {
                var parsed = angular.fromJson(source);
                return angular.isObject(parsed) && !angular.isArray(parsed) ? parsed : {};
            } catch (e) {
                return {};
            }
        }

        function joinLines(values) {
            return (values || []).join('\n');
        }

        function splitMultilineValues(valuesText) {
            if (!valuesText) {
                return [];
            }
            return String(valuesText).split(/\r?\n|;/).map(function(item) {
                return item.trim();
            }).filter(function(item) {
                return item.length > 0;
            });
        }

        function splitInlineValues(valuesText) {
            if (!valuesText) {
                return [];
            }
            return String(valuesText).split(/[;,]/).map(function(item) {
                return item.trim();
            }).filter(function(item) {
                return item.length > 0;
            });
        }

        function formatConstraintValue(value) {
            if (value === null || value === undefined) {
                return '';
            }
            if (angular.isObject(value)) {
                return angular.toJson(value);
            }
            return String(value);
        }

        function normalizeConstraintValue(value, valueType) {
            var normalizedNumber;
            if (valueType === 'integer') {
                normalizedNumber = parseInt(value, 10);
                if (isNaN(normalizedNumber)) {
                    throw new Error('Invalid integer constraint');
                }
                return normalizedNumber;
            }
            if (valueType === 'number') {
                normalizedNumber = Number(value);
                if (isNaN(normalizedNumber)) {
                    throw new Error('Invalid numeric constraint');
                }
                return normalizedNumber;
            }
            return String(value);
        }

        function parseLooseValue(value) {
            if (value === null || value === undefined) {
                return value;
            }
            var trimmed = String(value).trim();
            if (!trimmed.length) {
                return trimmed;
            }
            if (trimmed === 'true') {
                return true;
            }
            if (trimmed === 'false') {
                return false;
            }
            if (trimmed === 'null') {
                return null;
            }
            if (/^-?\d+(\.\d+)?$/.test(trimmed)) {
                return Number(trimmed);
            }
            if ((trimmed.charAt(0) === '{' && trimmed.charAt(trimmed.length - 1) === '}')
                    || (trimmed.charAt(0) === '[' && trimmed.charAt(trimmed.length - 1) === ']')
                    || (trimmed.charAt(0) === '"' && trimmed.charAt(trimmed.length - 1) === '"')) {
                try {
                    return angular.fromJson(trimmed);
                } catch (e) {
                    return trimmed;
                }
            }
            return trimmed;
        }

        function isBlankValue(value) {
            return value === null || value === undefined || String(value).trim().length === 0;
        }

        function defaultValidationTypeForCurrentField() {
            var dataType = effectiveDataType(vm.fieldDefinition.dataType);
            if (dataType === 'integer' || dataType === 'decimal') {
                return 'MIN_VALUE';
            }
            if (dataType === 'date' || dataType === 'datetime') {
                return 'DATE_NOT_IN_FUTURE';
            }
            if (dataType === 'list') {
                return 'VALUE_IN_ENUM';
            }
            return 'NOT_BLANK';
        }

        function isCompatibleWithCurrentType(validationType) {
            if (!validationType || !validationType.supportedDataTypes || !validationType.supportedDataTypes.length) {
                return true;
            }
            return validationType.supportedDataTypes.indexOf(effectiveDataType(vm.fieldDefinition.dataType)) !== -1;
        }

        function supportsPossibleValues() {
            return effectiveDataType(vm.fieldDefinition.dataType) === 'list';
        }

        function onDataTypeChange() {
            applyDataTypePreset(true);
        }

        function applyDataTypePreset(overrideValues) {
            if (vm.fieldDefinition.dataType === 'satisfaction_smiley') {
                if (overrideValues || !splitMultilineValues(vm.valuePossibleText).length) {
                    vm.valuePossibleText = joinLines(defaultSmileyOptions());
                }
                return;
            }
            if (overrideValues && !supportsPossibleValues()) {
                vm.valuePossibleText = '';
            }
        }

        function buildDataTypeOptions() {
            return [
                {code: 'text', label: 'Texte'},
                {code: 'integer', label: 'Entier'},
                {code: 'decimal', label: 'Décimal'},
                {code: 'boolean', label: 'Booléen'},
                {code: 'date', label: 'Date'},
                {code: 'datetime', label: 'Date/heure'},
                {code: 'list', label: 'Liste'},
                {code: 'satisfaction_smiley', label: 'Satisfaction smiley'},
                {code: 'ref_contrat', label: 'RefContrat'}
            ];
        }

        function effectiveDataType(dataType) {
            if (dataType === 'satisfaction_smiley') {
                return 'list';
            }
            if (dataType === 'ref_contrat') {
                return 'text';
            }
            return dataType;
        }

        function defaultSmileyOptions() {
            return ['very_unhappy', 'neutral', 'somewhat_happy', 'very_happy'];
        }

        function resolveValueOptionsForSave() {
            if (vm.fieldDefinition.dataType === 'satisfaction_smiley') {
                return defaultSmileyOptions();
            }
            return splitMultilineValues(vm.valuePossibleText);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('channel-conf', {
            parent: 'entity',
            url: '/channel-conf?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUPER_ADMIN'],
                pageTitle: 'wamasysApp.channelConf.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/channel-conf/channel-confs.html',
                    controller: 'ChannelConfController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communication');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('channel-conf-detail', {
            parent: 'entity',
            url: '/channel-conf/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUPER_ADMIN'],
                authenticate: true,
                pageTitle: 'wamasysApp.channelConf.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/channel-conf/channel-conf-detail.html',
                    controller: 'ChannelConfDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communication');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ChannelConf', function($stateParams, ChannelConf) {
                    return ChannelConf.get({id : $stateParams.id});
                }]
            }
        })
        .state('channel-conf.new', {
            parent: 'channel-conf',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/channel-conf/channel-conf-dialog.html',
                    controller: 'ChannelConfDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('channel-conf', null, { reload: true });
                }, function() {
                    $state.go('channel-conf');
                });
            }]
        })
        .state('channel-conf.edit', {
            parent: 'channel-conf',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/channel-conf/channel-conf-dialog.html',
                    controller: 'ChannelConfDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ChannelConf', function(ChannelConf) {
                            return ChannelConf.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('channel-conf', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('channel-conf.delete', {
            parent: 'channel-conf',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/channel-conf/channel-conf-delete-dialog.html',
                    controller: 'ChannelConfDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ChannelConf', function(ChannelConf) {
                            return ChannelConf.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('channel-conf', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('channel-conf.test-message', {
                parent: 'channel-conf',
                url: '/{id}/test-message',
                data: {
                    authorities: ['ROLE_SUPER_ADMIN','ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal',
                    function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/business/channel-conf/channel-conf-test-message-dialog.html',
                            controller: 'ChannelConfTestMessageDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            resolve: {
                                channelConfId: function() { return $stateParams.id; }
                            }
                        }).result.then(function() {
                            $state.go('channel-conf', null, { reload: false });
                        }, function() {
                            $state.go('^');
                        });
                    }
                ]
            })
        
        
        ;
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ChannelConf', ChannelConf);

    ChannelConf.$inject = ['$resource'];

    function ChannelConf ($resource) {
        var resourceUrl =  'api/channel-conf/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getChannel': {
            	url:'api/channel',
                method: 'GET',
                isArray: true
            },
            'testMessage': {
            	url:'api/channel-conf/test-message',
                method: 'POST'
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ChannelConfController', ChannelConfController);

    ChannelConfController.$inject = ['$scope', '$state', 'ChannelConf', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ChannelConfController ($scope, $state, ChannelConf, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            ChannelConf.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.channelConfs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ChannelConfTestMessageDialogController', ChannelConfTestMessageDialogController);

    ChannelConfTestMessageDialogController.$inject = ['$uibModalInstance', 'channelConfId', 'ChannelConf'];

    function ChannelConfTestMessageDialogController($uibModalInstance, channelConfId, ChannelConf) {
        var vm = this;

        vm.channelConf = {};
        vm.form = {
            recipient: null,
            subject: null,
            messageText: null,
            messageHtml: null
        };

        vm.sending = false;
        vm.result = null;

        vm.clear = clear;
        vm.send = send;

        loadChannelConf(channelConfId);

        function loadChannelConf(id) {
            ChannelConf.get({id: id}, function(res) {
                vm.channelConf = res;
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function send() {
            vm.result = null;

            if (!vm.form.recipient ) {
                return; // show-validation fera le job
            }

            vm.sending = true;

            ChannelConf.testMessage({
                channelConfId: channelConfId,
                recipient: vm.form.recipient,
                subject: vm.form.subject,
                messageText: vm.form.messageText,
                messageHtml: vm.form.messageHtml
            }, function(res) {
                vm.result = res;
                vm.sending = false;
            }, function(err) {
                vm.result = {
                    success: false,
                    message: (err && err.data && err.data.message) ? err.data.message : 'Erreur lors de l’envoi'
                };
                vm.sending = false;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ChannelConfDialogController', ChannelConfDialogController);

    ChannelConfDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ChannelConf'];

    function ChannelConfDialogController ($scope, $stateParams, $uibModalInstance, entity, ChannelConf) {
        var vm = this;

        vm.channelConf = entity;
        vm.channels = [];
        vm.configurationFields = {};
        vm.configurationError = null;
        vm.providerFieldConfigs = {
            SMS_ORACOM: [
                { key: 'fromLabel', label: 'Sender / fromLabel', placeholder: 'Sender par defaut Oracom' },
                { key: 'userName', label: 'Login / userName', placeholder: 'Compte Oracom' },
                { key: 'token', label: 'Token / mot de passe', placeholder: 'Token Oracom', inputType: 'password' },
                { key: 'limit30Days', label: 'Quota 30 jours', placeholder: 'Ex: 200', inputType: 'number' }
            ],
            SMS_PHILSMS: [
                { key: 'fromLabel', label: 'Sender ID', placeholder: '11 caracteres max' },
                { key: 'token', label: 'API token', placeholder: 'Bearer token PhilSMS', inputType: 'password' },
                { key: 'limit30Days', label: 'Quota 30 jours', placeholder: 'Ex: 200', inputType: 'number' }
            ],
            SMS_BULKSMSBD: [
                { key: 'fromLabel', label: 'Sender ID', placeholder: 'Sender ID approuve' },
                { key: 'token', label: 'API key', placeholder: 'Cle API BulkSMSBD', inputType: 'password' },
                { key: 'limit30Days', label: 'Quota 30 jours', placeholder: 'Ex: 200', inputType: 'number' }
            ],
            SMS_AWS: [
                { key: 'accessKey', label: 'AWS access key', placeholder: 'AKIA...' },
                { key: 'secretKey', label: 'AWS secret key', placeholder: 'Secret key', inputType: 'password' },
                { key: 'region', label: 'AWS region', placeholder: 'eu-west-1' },
                { key: 'fromLabel', label: 'Sender ID', placeholder: '3-11 caracteres, optionnel' },
                { key: 'smsType', label: 'SMS type', placeholder: 'Transactional ou Promotional' },
                { key: 'originationNumber', label: 'Origination number', placeholder: '+33123456789' },
                { key: 'maxPrice', label: 'Prix max USD', placeholder: '0.50' },
                { key: 'entityId', label: 'Entity ID (Inde)', placeholder: 'Optionnel' },
                { key: 'templateId', label: 'Template ID (Inde)', placeholder: 'Optionnel' },
                { key: 'limit30Days', label: 'Quota 30 jours', placeholder: 'Ex: 200', inputType: 'number' }
            ],
            WHATSAPP: [
                { key: 'userName', label: 'Phone number sender ID', placeholder: 'Identifiant emetteur WhatsApp' },
                { key: 'token', label: 'Access token', placeholder: 'Token Meta', inputType: 'password' },
                { key: 'limit30Days', label: 'Quota 30 jours', placeholder: 'Ex: 200', inputType: 'number' }
            ],
            EMAIL_SENDBLUE: [
                { key: 'host', label: 'URL API', placeholder: 'https://api.brevo.com/v3/smtp/email' },
                { key: 'port', label: 'Port', placeholder: '443', inputType: 'number' },
                { key: 'fromLabel', label: 'Nom expediteur', placeholder: 'Support' },
                { key: 'fromEmail', label: 'Email expediteur', placeholder: 'support@example.com' },
                { key: 'token', label: 'API key', placeholder: 'Cle API Brevo/Sendblue', inputType: 'password' },
                { key: 'limit30Days', label: 'Quota 30 jours', placeholder: 'Ex: 200', inputType: 'number' }
            ],
            EMAIL_SMTP: [
                { key: 'host', label: 'Serveur SMTP', placeholder: 'smtp.example.com' },
                { key: 'port', label: 'Port', placeholder: '587', inputType: 'number' },
                { key: 'startTls', label: 'STARTTLS', inputType: 'checkbox' },
                { key: 'userName', label: 'Utilisateur', placeholder: 'login SMTP' },
                { key: 'password', label: 'Mot de passe', placeholder: 'Mot de passe SMTP', inputType: 'password' },
                { key: 'fromLabel', label: 'Nom expediteur', placeholder: 'Support' },
                { key: 'fromEmail', label: 'Email expediteur', placeholder: 'support@example.com' },
                { key: 'limit30Days', label: 'Quota 30 jours', placeholder: 'Ex: 200', inputType: 'number' }
            ],
            TEST: [
                { key: 'limit30Days', label: 'Quota 30 jours', placeholder: 'Ex: 200', inputType: 'number' }
            ]
        };
        vm.providerExamples = {
            SMS_ORACOM: '{"fromLabel":"ACME","userName":"login","token":"secret","limit30Days":200}',
            SMS_PHILSMS: '{"fromLabel":"ACME","token":"api-token","limit30Days":200}',
            SMS_BULKSMSBD: '{"fromLabel":"ACME","token":"api-key","limit30Days":200}',
            SMS_AWS: '{"accessKey":"AKIA...","secretKey":"secret","region":"eu-west-1","fromLabel":"ACME","smsType":"Transactional","originationNumber":"+33123456789","maxPrice":"0.50","entityId":"","templateId":"","limit30Days":200}',
            WHATSAPP: '{"userName":"phoneNumberSenderId","token":"accessToken","limit30Days":200}',
            EMAIL_SENDBLUE: '{"host":"https://api.brevo.com/v3/smtp/email","port":443,"fromLabel":"Support","fromEmail":"support@example.com","token":"api-key","limit30Days":200}',
            EMAIL_SMTP: '{"host":"smtp.example.com","port":587,"startTls":true,"userName":"login","password":"secret","fromLabel":"Support","fromEmail":"support@example.com","limit30Days":200}',
            TEST: '{"limit30Days":200}'
        };
        vm.load = load;
        vm.save = save;
        vm.clear = clear;
        vm.onChannelChange = onChannelChange;
        vm.onStructuredFieldChange = onStructuredFieldChange;
        vm.onConfigurationTextChange = onConfigurationTextChange;
        vm.getVisibleConfigurationFields = getVisibleConfigurationFields;
        vm.getCurrentExample = getCurrentExample;

        vm.channels = ChannelConf.getChannel();
        initializeChannelConf(entity);

        function load(id) {
            ChannelConf.get({id : id}, function(result) {
                initializeChannelConf(result);
            });
        }

        function initializeChannelConf(channelConf) {
            vm.channelConf = channelConf || {};
            syncFieldsFromConfiguration();

            if (vm.channelConf.$promise) {
                vm.channelConf.$promise.then(function(result) {
                    vm.channelConf = result;
                    syncFieldsFromConfiguration();
                });
            }
        }

        function save() {
            vm.isSaving = true;
            syncConfigurationFromFields();
            if (vm.channelConf.id !== null) {
                ChannelConf.update(vm.channelConf, onSaveSuccess, onSaveError);
            } else {
                ChannelConf.save(vm.channelConf, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('wamasysApp:channelConfUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onChannelChange() {
            syncConfigurationFromFields();
        }

        function onStructuredFieldChange() {
            syncConfigurationFromFields();
        }

        function onConfigurationTextChange() {
            syncFieldsFromConfiguration();
        }

        function getVisibleConfigurationFields() {
            return vm.providerFieldConfigs[vm.channelConf.channel] || [];
        }

        function getCurrentExample() {
            return vm.providerExamples[vm.channelConf.channel] || '{}';
        }

        function syncFieldsFromConfiguration() {
            var parsed = parseConfiguration(vm.channelConf.configuration);
            var knownKeys = getKnownKeys();
            var i;

            if (!parsed) {
                return;
            }

            vm.configurationError = null;
            for (i = 0; i < knownKeys.length; i++) {
                vm.configurationFields[knownKeys[i]] = angular.isDefined(parsed[knownKeys[i]]) ? parsed[knownKeys[i]] : null;
            }
        }

        function syncConfigurationFromFields() {
            var parsed = parseConfiguration(vm.channelConf.configuration) || {};
            var knownKeys = getKnownKeys();
            var i;
            var key;
            var value;

            for (i = 0; i < knownKeys.length; i++) {
                key = knownKeys[i];
                value = normalizeFieldValue(key, vm.configurationFields[key]);
                if (hasValue(value)) {
                    parsed[key] = value;
                } else {
                    delete parsed[key];
                }
            }

            vm.configurationError = null;
            vm.channelConf.configuration = angular.toJson(parsed, true);
        }

        function parseConfiguration(configurationText) {
            if (!configurationText || !configurationText.trim()) {
                return {};
            }

            try {
                return angular.fromJson(configurationText);
            } catch (e) {
                vm.configurationError = 'JSON invalide';
                return null;
            }
        }

        function getKnownKeys() {
            var keys = [];
            angular.forEach(vm.providerFieldConfigs, function(fields) {
                angular.forEach(fields, function(field) {
                    if (keys.indexOf(field.key) === -1) {
                        keys.push(field.key);
                    }
                });
            });
            return keys;
        }

        function normalizeFieldValue(key, value) {
            if (key === 'limit30Days' || key === 'port') {
                return hasValue(value) ? Number(value) : null;
            }
            if (key === 'startTls') {
                return value === true;
            }
            return value;
        }

        function hasValue(value) {
            return value !== null && value !== undefined && value !== '';
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ChannelConfDetailController', ChannelConfDetailController);

    ChannelConfDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ChannelConf'];

    function ChannelConfDetailController($scope, $rootScope, $stateParams, entity, ChannelConf) {
        var vm = this;
        vm.channelConf = entity;
        vm.load = function (id) {
            ChannelConf.get({id: id}, function(result) {
                vm.channelConf = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:channelConfUpdate', function(event, result) {
            vm.channelConf = result;
        });
        
        
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ChannelConfDeleteController',ChannelConfDeleteController);

    ChannelConfDeleteController.$inject = ['$uibModalInstance', 'entity', 'ChannelConf'];

    function ChannelConfDeleteController($uibModalInstance, entity, ChannelConf) {
        var vm = this;
        vm.channelConf = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ChannelConf.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').controller('EquipmentWorkstationController', EquipmentWorkstationController);
    EquipmentWorkstationController.$inject = ['$scope', '$window', '$translate', 'EquipmentParc', 'EquipmentMessages'];
    function EquipmentWorkstationController($scope, $window, $translate, api, messages) {
        var vm = this, parent = $scope.vm, loadVersion = 0;
        vm.scope = parent.isAdmin ? 'organisation' : 'area'; vm.model = {}; vm.data = {}; vm.software = []; vm.load = load; vm.save = save; vm.download = download; vm.selectedOffice = selectedOffice; vm.officeLabel = officeLabel; vm.toggleSoftware = toggleSoftware;
        function tr(key, values) { return $translate.instant('wamasysApp.equipmentParc.workstation.' + key, values); }
        vm.downloadAgencyOnly = function () { return (vm.data.downloadConfig || vm.model).attachmentScope === 'AGENCY'; };
        var selectedArea = parent.meta.areas && parent.meta.areas.filter(function (area) { return area.id === parent.meta.currentAreaId; })[0];
        vm.downloadOwnerId = selectedArea && selectedArea.ownerId || (parent.meta.owners && parent.meta.owners.length === 1 ? parent.meta.owners[0].id : null);
        function failure(error) { vm.error = messages.translate(error && error.data && (error.data.description || error.data.message)) || tr('failed'); }
        function areaId() { return vm.scope === 'area' ? parent.meta.currentAreaId : null; }
        function path() { return 'workstation-settings' + (areaId() ? '?areaId=' + encodeURIComponent(areaId()) : ''); }
        function assign(data) { data.version = angular.isDefined(data.version) ? data.version : null; vm.ready = true; vm.data = data; vm.model = angular.copy(data.effective); vm.software = data.software; vm.editions = data.office; vm.customArea = !data.inherited; vm.rescuePassword = ''; vm.json = angular.toJson(data.values, true); if (vm.form) { vm.form.$setPristine(); } }
        function load() {
            var version = ++loadVersion; vm.ready = false; vm.error = null; vm.success = null;
            if (vm.scope === 'area' && !areaId()) { vm.error = tr('selectArea'); return; }
            vm.busy = true;
            return api.get(path()).then(function (data) { if (version === loadVersion) { assign(data); } }).catch(function (error) { if (version === loadVersion) { failure(error); } }).finally(function () { if (version === loadVersion) { vm.busy = false; } });
        }
        function save() {
            if (!vm.ready) { return; }
            var version = ++loadVersion; vm.error = null; vm.success = null; vm.busy = true;
            var values = angular.copy(vm.model), request; values.wallpaperUrl = values.wallpaperUrl || '';
            if (vm.scope === 'area') {
                delete values.rescueAdminName;
                delete values.allowSelfServiceDownload;
                Object.keys(values).forEach(function (key) { if (angular.equals(values[key], vm.data.organisationDefaults[key])) { delete values[key]; } });
                if (!vm.customArea) { values = {}; }
            }
            // Une liste vide est un choix explicite lorsque l'organisation propose des logiciels.
            if (vm.scope === 'area' && !Object.keys(values).length) {
                request = vm.data.version !== null ? api.remove(path() + '&version=' + encodeURIComponent(vm.data.version)).then(function () { return api.get(path()); }) : api.get(path());
            } else { request = api.put(path(), {version: vm.data.version, values: values, rescuePassword: vm.scope === 'organisation' ? vm.rescuePassword : null}); }
            return request.then(function (data) { if (version === loadVersion) { assign(data); vm.success = tr('saved'); } }).catch(function (error) { if (version === loadVersion) { failure(error); } }).finally(function () { if (version === loadVersion) { vm.busy = false; vm.rescuePassword = ''; } });
        }
        function toggleSoftware(id) { var index = vm.model.software.indexOf(id); if (index < 0) { vm.model.software.push(id); } else { vm.model.software.splice(index, 1); } }
        function selectedOffice() { return (vm.editions || []).filter(function (edition) { return edition.id === vm.model.officeEdition; })[0] || {}; }
        function officeLabel(edition) { if (edition.id === 'NONE') { return tr('noOffice'); } if (edition.id.indexOf('STANDARD_') === 0) { return tr('standard', {year: edition.id.slice(-4)}); } if (edition.id.indexOf('PRO_PLUS_') === 0) { return tr('proPlus', {year: edition.id.slice(-4)}); } return edition.label; }
        function download() {
            if (vm.downloadAgencyOnly() ? !vm.downloadOwnerId || !parent.isAdmin : !parent.meta.currentAreaId) { vm.error = tr('selectAttachment'); return; }
            if (vm.form && vm.form.$dirty) { vm.error = tr('saveFirst'); return; }
            vm.error = null; vm.downloading = true;
            var baseUrl = ($window.location.origin + $window.location.pathname).replace(/\/index\.html$/, '').replace(/\/$/, '');
            return api.downloadPost('workstation-bundle', {apiBaseUrl: baseUrl, discoverNetwork: false, ownerEntiteParenteId: vm.downloadAgencyOnly() ? vm.downloadOwnerId : null}).then(function (bytes) {
                var url = $window.URL.createObjectURL(new $window.Blob([bytes], {type: 'application/zip'})), link = $window.document.createElement('a');
                link.href = url; link.download = 'windows-workstation-preparation.zip'; $window.document.body.appendChild(link); link.click(); $window.document.body.removeChild(link); $window.setTimeout(function () { $window.URL.revokeObjectURL(url); }, 1000); parent.itOverview();
            }).catch(function (error) { if (error && $window.ArrayBuffer && error.data instanceof $window.ArrayBuffer) { try { error.data = angular.fromJson(new $window.TextDecoder('utf-8').decode(error.data)); } catch (ignored) { error.data = null; } } failure(error); }).finally(function () { vm.downloading = false; });
        }
        load();
        $scope.$watch(function () { return parent.meta.currentAreaId; }, function (value, previous) { if (vm.scope === 'area' && value && value !== previous) { load(); } });
        $scope.$on('$destroy', function () { loadVersion++; vm.rescuePassword = ''; });
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').component('equipmentWorkOrders', {
        bindings: {equipmentId: '<', meterProfileId: '<', detail: '<', canEdit: '<', reload: '&', mode: '@'},
        templateUrl: 'app/business/equipment-parc/equipment-work-orders.html', controller: WorkOrdersController
    });
    WorkOrdersController.$inject = ['$uibModal', '$translate', 'EquipmentParc'];
    function WorkOrdersController($uibModal, $translate, api) {
        var ctrl = this;
        function tr(key) { return $translate.instant('wamasysApp.equipmentParc.evolution.' + key); }
        ctrl.tr = tr;
        ctrl.kinds = ['INSTALLATION', 'INSPECTION', 'BREAKDOWN', 'MAINTENANCE', 'RETIREMENT'];
        ctrl.statuses = ['PLANNED', 'IN_PROGRESS', 'COMPLETED', 'CANCELLED'];
        function field(key, title, type, options, required) { return {key: key, label: tr(title), type: type || 'text', options: options, required: required !== false}; }
        function options(values) { return values.map(function (value) { return {id: value, label: tr(value)}; }); }
        function dialog(title, fields, initial, save) {
            return $uibModal.open({templateUrl: 'app/business/equipment-parc/equipment-parc-dialog.html', backdrop: 'static', size: 'lg', controllerAs: 'form',
                controller: ['$uibModalInstance', function (modal) {
                    var form = this; form.title = title; form.fields = fields; form.model = angular.copy(initial); form.visible = function () { return true; }; form.options = function (f) { return f.options; }; form.change = angular.noop;
                    fields.forEach(function (f) { if (f.type === 'date' && form.model[f.key]) { form.model[f.key] = new Date(String(form.model[f.key]).substring(0, 10) + 'T12:00:00'); } });
                    form.close = function () { modal.dismiss('cancel'); };
                    form.submit = function () {
                        form.busy = true; form.error = null; var data = angular.copy(form.model);
                        fields.forEach(function (f) { var d = data[f.key]; if (f.type === 'date' && angular.isDate(d)) { data[f.key] = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); } });
                        save(data).then(function () { modal.close(); return ctrl.reload(); }).catch(function (error) { form.error = error.data && error.data.message || tr('failed'); }).finally(function () { form.busy = false; });
                    };
                }]
            }).result.catch(angular.noop);
        }
        ctrl.edit = function (current, plan) {
            var initial = current || {equipmentId: ctrl.equipmentId || null, meterProfileId: ctrl.meterProfileId || null, kind: plan ? 'MAINTENANCE' : 'INSPECTION', status: 'PLANNED', title: plan && plan.label, plannedDate: plan && plan.nextDueDate};
            return dialog(tr(current ? 'editIntervention' : 'addIntervention'), [
                field('title', 'designation'), field('kind', 'kind', 'select', options(ctrl.kinds)), field('status', 'status', 'select', options(ctrl.statuses)),
                field('plannedDate', 'plannedDate', 'date', null, false), field('performedDate', 'performedDate', 'date', null, false),
                field('technician', 'technician', 'text', null, false), field('report', 'report', 'textarea', null, false), field('cost', 'cost', 'number', null, false), field('currency', 'currency', 'text', null, false)
            ], initial, function (data) { return current ? api.put('interventions/' + current.id, data) : api.post('interventions', data); });
        };
        ctrl.plan = function (current) {
            var path = ctrl.equipmentId ? 'equipment/' + ctrl.equipmentId : 'meter-profiles/' + ctrl.meterProfileId;
            return dialog(tr('planMaintenance'), [field('label', 'designation'), field('instructions', 'instructions', 'textarea', null, false), field('intervalMonths', 'intervalMonths', 'number', null, false), field('nextDueDate', 'nextDueDate', 'date'), field('active', 'active', 'checkbox', null, false)], current || {active: true},
                function (data) { return current ? api.put(path + '/maintenance-plans/' + current.id, data) : api.post(path + '/maintenance-plans', data); });
        };
        ctrl.complete = function (plan) {
            var used = (ctrl.detail.maintenanceExecutions || ctrl.detail.executions || []).map(function (entry) { return entry.interventionId; });
            var work = (ctrl.detail.interventions || []).filter(function (entry) { return entry.kind === 'MAINTENANCE' && entry.status === 'COMPLETED' && used.indexOf(entry.id) < 0; });
            return dialog(tr('completeMaintenance'), [field('interventionId', 'completedIntervention', 'select', work.map(function (entry) { return {id: entry.id, label: entry.title + ' — ' + entry.performedDate}; })), field('nextDueDate', 'nextDueDate', 'date', null, false)], {version: plan.version},
                function (data) { var selected = work.filter(function (entry) { return entry.id === data.interventionId; })[0]; data.performedDate = selected && selected.performedDate; return api.post('maintenance-plans/' + plan.id + '/complete', data); });
        };
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').component('equipmentPosition', {
        bindings: {model: '='},
        template: '<map-leaflet contrat="$ctrl.position" height="360px" width="100%"></map-leaflet>',
        controller: ['$scope', function ($scope) {
            var ctrl = this;
            ctrl.$onInit = function () {
                ctrl.position = {lat: ctrl.model.latitude, lon: ctrl.model.longitude};
                $scope.$watchGroup(['$ctrl.model.latitude', '$ctrl.model.longitude'], function (values) { ctrl.position.lat = values[0]; ctrl.position.lon = values[1]; });
                $scope.$watchGroup(['$ctrl.position.lat', '$ctrl.position.lon'], function (values) { ctrl.model.latitude = values[0]; ctrl.model.longitude = values[1]; });
            };
        }]
    });
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').config(stateConfig);
    stateConfig.$inject = ['$stateProvider'];
    function stateConfig($stateProvider) {
        var pages = [
            {name: 'equipment-import', url: '/equipment-import', section: 'import', template: 'equipment-import.html', controller: 'EquipmentImportController'},
            {name: 'equipment-meters', url: '/equipment-meters?kind&meterId', section: 'meters', template: 'equipment-meters.html', controller: 'EquipmentMetersController'},
            {name: 'equipment-inventories', url: '/equipment-inventories?inventoryId', section: 'inventories', template: 'equipment-inventories.html', controller: 'EquipmentInventoriesController'},
            {name: 'equipment-dashboard', url: '/equipment-dashboard', section: 'dashboard', template: 'equipment-dashboard.html', controller: 'EquipmentDashboardController'},
            {name: 'equipment-parc', url: '/equipment-parc?equipmentId&sourceEventId', section: 'equipment', template: 'equipment-parc.html'},
            {name: 'equipment-consumables', url: '/equipment-consumables?consumableId', section: 'stock', template: 'equipment-stock.html'},
            {name: 'equipment-configuration', url: '/equipment-configuration', section: 'configuration', template: 'equipment-configuration.html'},
            {name: 'equipment-computers', url: '/equipment-computers?equipmentId', section: 'computers', template: 'equipment-parc.html'},
            {name: 'equipment-android', url: '/equipment-android', section: 'android', template: 'equipment-android.html'},
            {name: 'equipment-labels', url: '/equipment-labels?kind&id&locationId', section: 'labels', template: 'equipment-labels.html', controller: 'EquipmentLabelsController'}
        ];
        pages.forEach(function (page) {
            $stateProvider.state(page.name, {
                parent: 'entity', url: page.url,
                data: {authenticate: true, equipmentSection: page.section, authorities: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_EQUIPMENT_READ', 'ROLE_EQUIPMENT_EDIT', 'ROLE_EQUIPMENT_SECRETS', 'ROLE_EQUIPMENT_REMOTE_CONTROL'], pageTitle: 'wamasysApp.equipmentParc.title'},
                views: {'content@': {templateUrl: 'app/business/equipment-parc/' + page.template, controller: page.controller || 'EquipmentParcController', controllerAs: 'vm'}},
                resolve: {translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) { $translatePartialLoader.addPart('equipmentParc'); $translatePartialLoader.addPart('global'); return $translate.refresh(); }]}
            });
        });
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').factory('EquipmentParc', EquipmentParc);
    EquipmentParc.$inject = ['$http', '$window'];
    function EquipmentParc($http, $window) {
        var root = 'api/equipment-parc/';
        return {
            newUuid: function () { var bytes = new $window.Uint8Array(16); $window.crypto.getRandomValues(bytes); bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128; return Array.prototype.map.call(bytes, function (b, i) { return ([4, 6, 8, 10].indexOf(i) >= 0 ? '-' : '') + ('0' + b.toString(16)).slice(-2); }).join(''); },
            download: function (path) { return $http.get(root + path, {responseType: 'arraybuffer'}).then(function (r) { return r.data; }); },
            downloadPost: function (path, body) { return $http.post(root + path, body, {responseType: 'arraybuffer'}).then(function (r) { return r.data; }); },
            get: function (path, params) { return $http.get(root + path, {params: params}).then(function (r) { return r.data; }); },
            post: function (path, body) { return $http.post(root + path, body).then(function (r) { return r.data; }); },
            put: function (path, body) { return $http.put(root + path, body).then(function (r) { return r.data; }); },
            remove: function (path) { return $http.delete(root + path); }
        };
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').controller('EquipmentParcController', EquipmentParcController);
    EquipmentParcController.$inject = ['$scope', '$state', '$stateParams', '$uibModal', '$window', 'Principal', 'EquipmentParc', '$translate', 'EquipmentMessages'];
    function EquipmentParcController($scope, $state, $stateParams, $uibModal, $window, Principal, api, $translate, EquipmentMessages) {
        var vm = this, stockLoadVersion = 0;
        vm.message = EquipmentMessages.translate;
        vm.remoteActions = function () {
            var equipmentId = vm.selectedId, canRemote = vm.canRemote;
            $uibModal.open({templateUrl: 'app/business/equipment-parc/equipment-remote-actions.html', controllerAs: 'remote', size: 'lg',
                controller: ['$uibModalInstance', function ($uibModalInstance) {
                    var remote = this, root = 'equipment/' + equipmentId + '/remote-actions';
                    remote.rows = []; remote.canRemote = canRemote; remote.request = {kind: 'INSTALL_SOFTWARE'};
                    remote.changed = function () { remote.actionUuid = api.newUuid(); remote.error = false; };
                    remote.close = function () { $uibModalInstance.close(); };
                    remote.load = function (older) {
                        if (remote.loading) { return; } remote.loading = true; remote.error = false;
                        var last = older && remote.rows.length ? remote.rows[remote.rows.length - 1].id : null;
                        return api.get(root, last ? {beforeId: last} : {}).then(function (data) {
                            remote.rows = older ? remote.rows.concat(data.actions) : data.actions; remote.more = data.actions.length === 50;
                            remote.agent = data.agent; remote.updatesAvailable = data.updatesAvailable; remote.releaseVersion = data.releaseVersion; remote.software = data.software; remote.commands = data.commands;
                        }).catch(function () { remote.error = true; }).finally(function () { remote.loading = false; });
                    };
                    remote.enqueue = function () {
                        if (!remote.canRemote || !remote.agent || !remote.request.itemId || remote.busy) { return; }
                        remote.busy = true; remote.error = false; remote.queued = false;
                        var request = angular.extend({}, remote.request, {actionUuid: remote.actionUuid});
                        return api.post(root, request).then(function () { remote.changed(); remote.queued = true; return remote.load(false); })
                            .catch(function () { remote.error = true; }).finally(function () { remote.busy = false; });
                    };
                    remote.cancel = function (row) { remote.busy = true; return api.remove(root + '/' + row.id).then(function () { return remote.load(false); }).catch(function () { remote.error = true; }).finally(function () { remote.busy = false; }); };
                    remote.open = function (row) { remote.loadingLog = true; remote.selected = row; remote.logText = ''; return api.get(root + '/' + row.id).then(function (data) { remote.logText = data.logText; }).catch(function () { remote.error = true; }).finally(function () { remote.loadingLog = false; }); };
                    remote.changed(); remote.load(false);
                }]});
        };
        vm.preparationHistory = function () {
            var equipmentId = vm.selectedId;
            $uibModal.open({templateUrl: 'app/business/equipment-parc/equipment-preparation-history.html', controllerAs: 'history', size: 'lg',
                controller: ['$uibModalInstance', function ($uibModalInstance) {
                    var history = this, root = 'equipment/' + equipmentId + '/preparation-history';
                    history.rows = []; history.close = function () { $uibModalInstance.close(); };
                    history.load = function (older) {
                        if (history.loading) { return; }
                        history.loading = true; history.error = false;
                        var last = older && history.rows.length ? history.rows[history.rows.length - 1].id : null;
                        return api.get(root, last ? {beforeId: last} : {}).then(function (rows) { history.rows = older ? history.rows.concat(rows) : rows; history.more = rows.length === 50; })
                            .catch(function () { history.error = true; }).finally(function () { history.loading = false; });
                    };
                    history.open = function (row) {
                        history.loadingLog = true; history.error = false; history.selected = row; history.logText = '';
                        return api.get(root + '/' + row.id).then(function (data) { if (history.selected.id === row.id) { history.logText = data.logText; } })
                            .catch(function () { history.error = true; }).finally(function () { history.loadingLog = false; });
                    };
                    history.load(false);
                }]});
        };

        function tr(key) { return $translate.instant(key); }
        vm.section = $state.current && $state.current.data && $state.current.data.equipmentSection || 'equipment';
        vm.tab = vm.section === 'computers' ? 'equipment' : vm.section;
        vm.pageTitle = {equipment: 'wamasysApp.equipmentParc.text.equipment', stock: 'wamasysApp.equipmentParc.text.consumables_and_stock', configuration: 'wamasysApp.equipmentParc.text.types_and_locations', computers: 'wamasysApp.equipmentParc.text.it_inventory', android: 'wamasysApp.equipmentParc.text.registered_android_devices'}[vm.section];
        vm.tab = vm.tab || 'equipment'; vm.page = 0; vm.total = 0; vm.items = []; vm.meta = {types: [], locations: [], consumables: [], areas: [], owners: []};
        vm.assignmentFilters = [{id: true, label: 'wamasysApp.equipmentParc.text.allocated_or_on_loan'}, {id: false, label: 'wamasysApp.equipmentParc.text.no_open_assignment'}]; vm.openAssignments = []; vm.maintenancePlans = []; vm.currentHolder = currentHolder; vm.currentLocation = currentLocation; vm.nextMaintenance = nextMaintenance;
        vm.filter = vm.section === 'computers' ? {family: 'IT'} : {}; vm.label = label; vm.name = name; vm.load = load; vm.select = select; vm.back = back; vm.switchTab = switchTab;
        vm.equipmentForm = equipmentForm; vm.typeForm = typeForm; vm.locationForm = locationForm; vm.loanForm = loanForm; vm.returnForm = returnForm;
        vm.consumableForm = consumableForm; vm.categoryForm = categoryForm;
        vm.stockForm = stockForm; vm.thresholdForm = thresholdForm; vm.reverseForm = reverseForm;
        vm.enroll = enroll; vm.revoke = revoke; vm.accountForm = accountForm; vm.referenceForm = referenceForm; vm.credentialHistory = credentialHistory;
        vm.importAndroid = importAndroid; vm.refreshAndroid = refreshAndroid; vm.isLate = isLate; vm.hasAssignment = hasAssignment;
        vm.itLabel = function (value) { return value ? tr('wamasysApp.equipmentParc.it.types.' + value) : '—'; };
        vm.equipmentType = function (item) { return item.itType ? vm.itLabel(item.itType) : name(vm.meta.types, item.typeId); };
        vm.devices = []; vm.network = []; vm.packages = []; vm.itOverview = itOverview; vm.downloadCollector = downloadCollector; vm.revokePackage = revokePackage; vm.importNetwork = importNetwork; vm.revealPassword = revealPassword; vm.manualDeviceForm = manualDeviceForm;
        vm.lastSeen = function (id) { var device = vm.devices.filter(function (entry) { return entry.equipmentId === id; })[0]; return device && device.lastReceivedAt; };
        vm.licenses = []; vm.licensePage = 0; vm.licenseTotal = 0; vm.loadLicenses = loadLicenses; vm.licenseForm = licenseForm; vm.assignLicense = assignLicense; vm.releaseLicense = releaseLicense; vm.revealLicense = revealLicense; vm.licenseHistory = licenseHistory;
        vm.showMap = function () {
            $uibModal.open({templateUrl: 'app/business/equipment-parc/equipment-map.html', controller: 'EquipmentMapController', controllerAs: 'vm', size: 'lg', windowClass: 'equipment-map-modal', resolve: {filters: function () { return angular.copy(vm.filter); }}}).result.catch(angular.noop);
        };
        vm.showBarcode = function (kind, id) { $state.go('equipment-labels', {kind: kind, id: id}); };
        vm.storageAddress = function (setting) { return setting ? [setting.aisle, setting.row, setting.rack, setting.shelf, setting.bin].filter(Boolean).join(' / ') : '—'; };
        vm.stockFilter = {}; vm.stockTab = 'balances'; vm.configurationTab = 'types'; vm.itTab = 'equipment';
        vm.stockAreas = function () { return vm.meta.areas.filter(function (area) { return !vm.stockFilter.ownerId || area.ownerId === vm.stockFilter.ownerId; }); };
        vm.stockLocations = function () { return vm.meta.locations.filter(function (location) { return (!vm.stockFilter.ownerId || location.entiteParenteId === vm.stockFilter.ownerId) && (!vm.stockFilter.areaId || location.areaId === vm.stockFilter.areaId); }); };
        vm.changeStockScope = function () { if (!vm.stockAreas().some(function (area) { return area.id === vm.stockFilter.areaId; })) { vm.stockFilter.areaId = null; } if (!vm.stockLocations().some(function (location) { return location.id === vm.stockFilter.locationId; })) { vm.stockFilter.locationId = null; } return loadStock(); };
        vm.stockArticles = function () { if (!vm.stockFilter.ownerId && !vm.stockFilter.areaId && !vm.stockFilter.locationId) { return vm.meta.consumables; } return vm.meta.consumables.filter(function (article) { return vm.stockRows.some(function (row) { return row.consumableId === article.id; }); }); };
        vm.articleHistory = function (article) { return api.get('consumables/' + article.id + '/history').then(function (history) { prepareHistory(history); vm.articleChanges = history; vm.historyArticle = article; }).catch(failure); };
        vm.stockRows = []; vm.stock = {history: [], settings: [], balances: []}; vm.today = new Date();
        var labels = {
            IN_RESERVE: 'wamasysApp.equipmentParc.text.in_reserve', FIELD: 'wamasysApp.equipmentParc.text.field_equipment', TOOL: 'wamasysApp.equipmentParc.text.tools', IT: 'wamasysApp.equipmentParc.text.it_equipment', DEPOT: 'wamasysApp.equipmentParc.text.depot_or_warehouse', OFFICE: 'wamasysApp.equipmentParc.text.office', FIELD_SITE: 'wamasysApp.equipmentParc.text.field_site', VEHICLE: 'wamasysApp.equipmentParc.text.vehicle', OTHER: 'wamasysApp.equipmentParc.text.other',
            GOOD: 'wamasysApp.equipmentParc.text.good_condition', FAIR: 'wamasysApp.equipmentParc.text.fair_condition', DAMAGED: 'wamasysApp.equipmentParc.text.damaged', UNKNOWN: 'wamasysApp.equipmentParc.text.not_assessed', IN_SERVICE: 'wamasysApp.equipmentParc.text.in_service', OUT_OF_SERVICE: 'wamasysApp.equipmentParc.text.out_of_service', UNDER_MAINTENANCE: 'wamasysApp.equipmentParc.text.under_maintenance', LOST: 'wamasysApp.equipmentParc.text.lost', RETIRED: 'wamasysApp.equipmentParc.text.retired',
            ORIGINAL_RECORD: 'wamasysApp.equipmentParc.text.original_record', INSTALLATION: 'wamasysApp.equipmentParc.text.installation', INSPECTION: 'wamasysApp.equipmentParc.text.inspection', BREAKDOWN: 'wamasysApp.equipmentParc.text.breakdown', MAINTENANCE: 'wamasysApp.equipmentParc.text.maintenance', RETIREMENT: 'wamasysApp.equipmentParc.text.retirement',
            LOAN: 'wamasysApp.equipmentParc.text.temporary_loan', ALLOCATION: 'wamasysApp.equipmentParc.text.long_term_allocation', INITIAL_STOCK: 'wamasysApp.equipmentParc.text.initial_stock', RECEIPT: 'wamasysApp.equipmentParc.text.receipt', CONSUMPTION: 'wamasysApp.equipmentParc.text.consumption', RETURN: 'wamasysApp.equipmentParc.text.return_to_stock', TRANSFER: 'wamasysApp.equipmentParc.text.transfer', ADJUSTMENT: 'wamasysApp.equipmentParc.text.stock_adjustment', REVERSAL: 'wamasysApp.equipmentParc.text.extra_reversal',
            IN: 'wamasysApp.equipmentParc.text.incoming', OUT: 'wamasysApp.equipmentParc.text.stock_out', REVEAL: 'wamasysApp.equipmentParc.text.reference_access', UPDATE: 'wamasysApp.equipmentParc.text.update', DELETE: 'wamasysApp.equipmentParc.text.reference_deleted', CHANGE_REFERENCE: 'wamasysApp.equipmentParc.text.reference_updated', SUCCESS: 'wamasysApp.equipmentParc.text.success', DENIED: 'wamasysApp.equipmentParc.text.denied', ERROR: 'wamasysApp.equipmentParc.text.error', CONFIRMED: 'wamasysApp.equipmentParc.text.validated', CANCELLED: 'wamasysApp.equipmentParc.text.cancelled'
        };
        Principal.identity().then(function (account) {
            var roles = account && account.authorities || [];
            vm.moduleDisabled = !account || !account.modules || account.modules.indexOf('EQUIPMENT') < 0;
            if (vm.moduleDisabled) { vm.error = tr('wamasysApp.equipmentParc.text.enable_equipment_in_the_organisation_settings_first'); return; }
            vm.isAdmin = roles.indexOf('ROLE_ADMIN') >= 0 || roles.indexOf('ROLE_SUPER_ADMIN') >= 0;
            vm.canEdit = vm.isAdmin || roles.indexOf('ROLE_EQUIPMENT_EDIT') >= 0;
            vm.canSecrets = roles.indexOf('ROLE_SUPER_ADMIN') >= 0 || roles.indexOf('ROLE_EQUIPMENT_SECRETS') >= 0;
            vm.canRemote = roles.indexOf('ROLE_SUPER_ADMIN') >= 0 || roles.indexOf('ROLE_EQUIPMENT_REMOTE_CONTROL') >= 0;
            return metadata();
        }).then(function () {
            if (vm.moduleDisabled) { return; }
            if (vm.tab === 'stock') { loadStock(); }
            else if (vm.tab === 'android') { refreshAndroid(); }
            else if (vm.tab === 'equipment') { load(); }
            if (vm.section === 'computers') { itOverview(); }
            if ($stateParams.sourceEventId && vm.canEdit) { equipmentForm(); }
        }).catch(failure);
        function label(value) { return labels[value] ? tr(labels[value]) : value || '—'; }
        function name(list, id) { var found = (list || []).filter(function (x) { return x.id === id; })[0]; return found ? found.label || found.inventoryCode : '—'; }
        function failure(error) { vm.error = EquipmentMessages.translate(error && error.data && (error.data.message || error.data.description)) || tr('wamasysApp.equipmentParc.text.the_operation_failed_check_the_information_and_try_again'); }
        function metadata() { return api.get('metadata').then(function (data) { vm.meta = data; }); }
        function load() {
            vm.loading = true; vm.error = null;
            api.get('equipment', angular.extend({page: vm.page, size: 25}, vm.filter)).then(function (data) {
                vm.items = data.items; vm.total = data.total; vm.devices = data.devices || []; vm.openAssignments = data.openAssignments || []; vm.maintenancePlans = data.maintenancePlans || [];
                if ($stateParams.equipmentId) { select(Number($stateParams.equipmentId)); }
            }).catch(failure).finally(function () { vm.loading = false; });
        }
        function select(id) {
            vm.error = null;
            // Une fiche issue d’une découverte s’ouvre dans l’onglet Équipements.
            vm.itTab = 'equipment';
            return api.get('equipment/' + id).then(function (data) {
                if (data.equipment.itType) { vm.section = 'computers'; vm.filter.family = 'IT'; vm.pageTitle = 'wamasysApp.equipmentParc.text.it_inventory'; }
                prepareHistory(data.history || []);
                vm.detail = data; vm.detailPosition = {lat: data.equipment.latitude, lon: data.equipment.longitude}; try { vm.detail.disks = angular.fromJson(data.device && data.device.storageJson || '[]'); } catch (ignore) { vm.detail.disks = []; } try { vm.detail.diagnostics = angular.fromJson(data.device && data.device.diagnosticsJson || '{}'); } catch (ignoreDiagnostics) { vm.detail.diagnostics = {}; } (vm.detail.interfaces || []).forEach(function (network) { try { network.dnsServers = angular.fromJson(network.dnsServersJson || '[]'); } catch (invalidDns) { network.dnsServers = []; } network.addresses = (data.addresses || []).filter(function (address) { return address.interfaceId === network.id; }); if (!network.addresses.length) { network.addresses = [{id: 'none'}]; } }); vm.tab = 'equipment'; vm.selectedId = id;
                try { vm.detail.installedSoftware = angular.fromJson(data.device && data.device.softwareJson || '[]'); } catch (invalidSoftware) { vm.detail.installedSoftware = []; }
                $state.go(vm.section === 'computers' ? 'equipment-computers' : 'equipment-parc', {equipmentId: id, sourceEventId: null}, {notify: false, location: 'replace'});
            }).catch(failure);
        }
        vm.historyField = function (key) { var translated = tr('wamasysApp.equipmentParc.historyFields.' + key); return translated.indexOf('wamasysApp.') === 0 ? key : translated; };
        vm.historyValue = function (key, value) {
            if (value === null || angular.isUndefined(value) || value === '') { return '—'; }
            var references = {areaId: vm.meta.areas, ownerEntiteParenteId: vm.meta.owners, locationId: vm.meta.locations, destinationLocationId: vm.meta.locations, typeId: vm.meta.types, categoryId: vm.meta.consumableCategories};
            if (references[key]) { var found = references[key].filter(function (item) { return item.id === value; })[0]; return found ? found.label : '#' + value; }
            if (key === 'itType') { return vm.itLabel(value); } if (value === true || value === false) { return tr('wamasysApp.equipmentParc.text.' + (value ? 'yes' : 'no')); }
            if (angular.isNumber(value)) { return String(value); }
            return angular.isObject(value) ? angular.toJson(value) : vm.label(value);
        };
        function prepareHistory(history) {
            var ignored = ['id', 'version', 'organisationId', 'createdBy', 'createdDate', 'lastModifiedBy', 'lastModifiedDate', 'equipmentId', 'uploadUuid'];
            history.forEach(function (entry) { entry.diff = []; try { var changes = angular.fromJson(entry.changesJson), before = angular.isString(changes.before) ? angular.fromJson(changes.before) : changes.before || {}, after = angular.isString(changes.after) ? angular.fromJson(changes.after) : changes.after || {}; Object.keys(angular.extend({}, before, after)).forEach(function (key) { if (ignored.indexOf(key) < 0 && angular.toJson(before[key]) !== angular.toJson(after[key])) { entry.diff.push({key: key, before: before[key], after: after[key]}); } }); } catch (invalidHistory) { angular.noop(); } });
        }
        function back() { vm.detail = null; vm.selectedId = null; $stateParams.equipmentId = null; $state.go(vm.section === 'computers' ? 'equipment-computers' : 'equipment-parc', {equipmentId: null, sourceEventId: null}, {notify: false, location: 'replace'}); load(); }
        function switchTab(tab) { vm.tab = tab; vm.error = null; if (tab === 'stock') { loadStock(); } if (tab === 'android') { refreshAndroid(); } }
        function afterChange(id) { return metadata().then(function () { if (id) { return select(id); } if (vm.tab === 'stock') { return loadStock(); } load(); }); }
        function field(key, title, type, options, required) { return {key: key, label: title, type: type || 'text', options: options, required: required !== false}; }
        function enums(values) { return (values || []).map(function (v) { return {id: v, label: label(v)}; }); }
        function areas(model) { return vm.meta.areas.filter(function (area) { return !model.ownerEntiteParenteId && !model.entiteParenteId || area.ownerId === (model.ownerEntiteParenteId || model.entiteParenteId); }); }
        function locations(model) { return vm.meta.locations.filter(function (location) { return location.active && location.areaId === model.areaId && location.entiteParenteId === (model.ownerEntiteParenteId || model.entiteParenteId); }); }
        function defaults() {
            var area = vm.meta.areas.filter(function (a) { return a.id === vm.meta.currentAreaId; })[0];
            return {areaId: area && area.id, ownerEntiteParenteId: area && area.ownerId, entiteParenteId: area && area.ownerId};
        }
        function openForm(title, fields, initial, save, help) {
            var stockSettings = vm.stock.settings;
            return $uibModal.open({
                templateUrl: 'app/business/equipment-parc/equipment-parc-dialog.html', backdrop: 'static', size: 'lg',
                controllerAs: 'form', controller: ['$uibModalInstance', '$scope', function (modal, formScope) {
                    var vm = this; vm.hasMap = fields.some(function (f) { return f.key === 'latitude'; }); vm.title = title; vm.fields = fields; vm.model = angular.copy(initial || {}); vm.help = help;
                    fields.forEach(function (f) { if ((f.type === 'date' || f.type === 'datetime-local') && vm.model[f.key] && !angular.isDate(vm.model[f.key])) { vm.model[f.key] = new Date(f.type === 'date' ? vm.model[f.key].substring(0, 10) + 'T12:00:00' : vm.model[f.key]); } });
                    if (formScope) { formScope.$on('$destroy', function () { vm.model.password = null; vm.model.licenseKey = null; }); }
                    vm.options = function (f) { return angular.isFunction(f.options) ? f.options(vm.model) : f.options; };
                    vm.visible = function (f) { return !f.when || f.when(vm.model); };
                    vm.change = function (f) {
                        if (['consumableId', 'locationId'].indexOf(f.key) >= 0 && fields.some(function (x) { return x.key === 'minimumQuantity'; })) {
                            var current = stockSettings;
                            current = (current || []).filter(function (x) { return x.consumableId === vm.model.consumableId && x.locationId === vm.model.locationId; })[0];
                            ['aisle', 'row', 'rack', 'shelf', 'bin', 'version'].forEach(function (key) { vm.model[key] = current ? current[key] : null; });
                            vm.model.minimumQuantity = current ? current.minimumQuantity : 0;
                        }
                        if (['ownerEntiteParenteId', 'entiteParenteId', 'areaId'].indexOf(f.key) < 0) { return; }
                        if (vm.model.areaId && !areas(vm.model).some(function (a) { return a.id === vm.model.areaId; })) { vm.model.areaId = null; }
                        if (vm.model.locationId && !locations(vm.model).some(function (l) { return l.id === vm.model.locationId; })) { vm.model.locationId = null; }
                    };
                    vm.close = function () { modal.dismiss('cancel'); };
                    vm.submit = function () {
                        vm.busy = true; vm.error = null; var data = angular.copy(vm.model);
                        fields.forEach(function (f) {
                            if (f.type === 'date' && data[f.key] instanceof Date) { var d = data[f.key]; data[f.key] = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
                            if (f.type === 'datetime-local' && data[f.key] instanceof Date) { data[f.key] = data[f.key].toISOString(); }
                        });
                        save(data).then(function () { modal.close(); }, function (error) { vm.error = EquipmentMessages.translate(error && error.data && (error.data.message || error.data.description)) || tr('wamasysApp.equipmentParc.text.the_operation_was_refused_check_the_fields_and_reload_the'); }).finally(function () { data.password = null; vm.busy = false; });
                    };
                }]
            }).result.catch(angular.noop);
        }
        function equipmentForm(current) {
            var source = $stateParams.sourceEventId;
            var it = current ? !!current.itType : vm.section === 'computers';
            var values = current || angular.extend(defaults(), {condition: 'UNKNOWN', operationalStatus: 'IN_SERVICE'});
            var fields = [field('inventoryCode', tr('wamasysApp.equipmentParc.text.inventory_code')), field('label', tr('wamasysApp.equipmentParc.text.description_156')), field('typeId', tr('wamasysApp.equipmentParc.text.type'), 'select', vm.meta.types.filter(function (t) { return t.active || current && t.id === current.typeId; })),
                field('ownerEntiteParenteId', tr('wamasysApp.equipmentParc.text.owning_agency'), 'select', vm.meta.owners), field('areaId', tr('wamasysApp.equipmentParc.text.assigned_area'), 'select', areas, !vm.isAdmin),
                field('locationId', tr('wamasysApp.equipmentParc.text.location'), 'select', locations, false), field('serialNumber', tr('wamasysApp.equipmentParc.text.serial_number_360'), 'text', null, false), field('brand', tr('wamasysApp.equipmentParc.text.extra_brand'), 'text', null, false), field('model', tr('wamasysApp.equipmentParc.text.model'), 'text', null, false),
                field('acquisitionDate', tr('wamasysApp.equipmentParc.text.acquisition_date'), 'date', null, false), field('installationDate', tr('wamasysApp.equipmentParc.text.installation_date'), 'date', null, false), field('retirementDate', tr('wamasysApp.equipmentParc.text.retirement_date'), 'date', null, false),
                field('condition', tr('wamasysApp.equipmentParc.text.physical_condition'), 'select', enums(vm.meta.conditions)), field('operationalStatus', tr('wamasysApp.equipmentParc.text.operational_status'), 'select', enums(vm.meta.statuses)), field('latitude', tr('wamasysApp.equipmentParc.text.extra_latitude'), 'number', null, false), field('longitude', tr('wamasysApp.equipmentParc.text.extra_longitude'), 'number', null, false), field('comment', tr('wamasysApp.equipmentParc.text.extra_comments'), 'textarea', null, false)];
            if (it) { fields.push(field('oldIdentifier', tr('wamasysApp.equipmentParc.preparationHistory.oldIdentifier'), 'text', null, false)); }
            ['purchasePrice', 'purchaseCurrency', 'depreciationMonths', 'depreciationStartDate', 'residualValue'].forEach(function (key) { fields.push(field(key, tr('wamasysApp.equipmentParc.finance.' + key), key === 'purchaseCurrency' ? 'text' : key === 'depreciationStartDate' ? 'date' : 'number', null, false)); });
            if (it) { fields[2] = field('itType', tr('wamasysApp.equipmentParc.it.type'), 'select', (vm.meta.itTypes || []).map(function (value) { return {id: value, label: vm.itLabel(value)}; })); values = angular.extend({}, values, {typeId: null, itType: values.itType || 'COMPUTER'}); }
            if (current) { fields[3].disabled = !vm.isAdmin; fields[4].disabled = !vm.isAdmin; }
            openForm(current ? tr('wamasysApp.equipmentParc.text.edit_equipment') : tr('wamasysApp.equipmentParc.text.add_equipment'), fields, values, function (data) {
                if (data.purchaseCurrency) { data.purchaseCurrency = data.purchaseCurrency.trim().toUpperCase(); }
                return (current ? api.put('equipment/' + current.id, data) : api.post(source ? 'from-event/' + source : 'equipment', data)).then(function (saved) { $stateParams.sourceEventId = null; return afterChange(saved.id); });
            }, source ? tr('wamasysApp.equipmentParc.text.the_record_will_remain_linked_to_the_original_event_its') : tr('wamasysApp.equipmentParc.text.only_administrators_can_change_the_area_end_any_open_loan'));
        }
        function typeForm(current) {
            openForm(current ? tr('wamasysApp.equipmentParc.text.edit_type') : tr('wamasysApp.equipmentParc.text.add_an_equipment_type'), [field('code', tr('wamasysApp.equipmentParc.text.code')), field('label', tr('wamasysApp.equipmentParc.text.wording')), field('family', tr('wamasysApp.equipmentParc.text.family'), 'select', enums(vm.meta.families)), field('description', tr('wamasysApp.equipmentParc.text.description'), 'textarea', null, false), field('active', tr('wamasysApp.equipmentParc.text.active_type'), 'checkbox', null, false)], current || {family: 'FIELD', active: true}, function (data) { return (current ? api.put('types/' + current.id, data) : api.post('types', data)).then(function () { return afterChange(); }); });
        }
        function locationForm(current) {
            openForm(current ? tr('wamasysApp.equipmentParc.text.edit_location') : tr('wamasysApp.equipmentParc.text.add_a_location'), [field('code', tr('wamasysApp.equipmentParc.text.code')), field('label', tr('wamasysApp.equipmentParc.text.wording')), field('entiteParenteId', tr('wamasysApp.equipmentParc.text.owning_agency'), 'select', vm.meta.owners), field('areaId', tr('wamasysApp.equipmentParc.text.extra_area'), 'select', areas, !vm.isAdmin), field('locationType', tr('wamasysApp.equipmentParc.text.location_type'), 'select', enums(vm.meta.locationTypes)), field('address', tr('wamasysApp.equipmentParc.text.address'), 'textarea', null, false), field('latitude', tr('wamasysApp.equipmentParc.text.extra_latitude'), 'number', null, false), field('longitude', tr('wamasysApp.equipmentParc.text.extra_longitude'), 'number', null, false), field('active', tr('wamasysApp.equipmentParc.text.active_location'), 'checkbox', null, false)], current || angular.extend(defaults(), {locationType: 'DEPOT', active: true}), function (data) { return (current ? api.put('locations/' + current.id, data) : api.post('locations', data)).then(function () { return afterChange(); }); });
        }
        function loanForm() {
            var equipment = vm.detail.equipment;
            openForm(tr('wamasysApp.equipmentParc.text.check_out_or_assign_equipment'), [field('assignmentType', tr('wamasysApp.equipmentParc.text.assignment_type'), 'select', enums(['LOAN', 'ALLOCATION'])), field('beneficiaryName', tr('wamasysApp.equipmentParc.text.recipient_or_team')), field('destinationLocationId', tr('wamasysApp.equipmentParc.text.destination_location'), 'select', vm.meta.locations.filter(function (l) { return l.active; }), false), field('destinationDescription', tr('wamasysApp.equipmentParc.text.work_site_or_destination'), 'text', null, false), field('startedAt', tr('wamasysApp.equipmentParc.text.issue_date'), 'datetime-local'), field('expectedReturnAt', tr('wamasysApp.equipmentParc.text.expected_return'), 'datetime-local', null, false), field('conditionOut', tr('wamasysApp.equipmentParc.text.checkout_condition'), 'select', enums(vm.meta.conditions)), field('commentOut', tr('wamasysApp.equipmentParc.text.checkout_comments'), 'textarea', null, false)], {assignmentType: 'LOAN', startedAt: new Date(), conditionOut: equipment.condition}, function (data) { return api.post('equipment/' + equipment.id + '/assignments', data).then(function () { return select(equipment.id); }); });
        }
        function returnForm(assignment) {
            var equipment = vm.detail.equipment;
            openForm(tr('wamasysApp.equipmentParc.text.record_return'), [field('endedAt', tr('wamasysApp.equipmentParc.text.return_date'), 'datetime-local'), field('condition', tr('wamasysApp.equipmentParc.text.return_condition'), 'select', enums(vm.meta.conditions)), field('locationId', tr('wamasysApp.equipmentParc.text.storage_location'), 'select', locations(equipment), false), field('comment', tr('wamasysApp.equipmentParc.text.return_comments'), 'textarea', null, false)], {version: assignment.version, endedAt: new Date(), condition: assignment.conditionOut, locationId: equipment.locationId}, function (data) { return api.post('assignments/' + assignment.id + '/return', data).then(function () { return select(equipment.id); }); });
        }
        function isLate(date) { return date && new Date(date) < new Date(new Date().setHours(0, 0, 0, 0)); }
        function currentHolder(id) { var found = vm.openAssignments.filter(function (a) { return a.equipmentId === id; })[0]; return found ? found.beneficiaryName : '—'; }
        function currentLocation(equipment) {
            var assignment = vm.openAssignments.filter(function (a) { return a.equipmentId === equipment.id; })[0];
            if (!assignment) { return name(vm.meta.locations, equipment.locationId); }
            if (!assignment.destinationLocationId && !assignment.destinationDescription) { return tr('wamasysApp.equipmentParc.text.held_by') + assignment.beneficiaryName; }
            return (assignment.destinationLocationId ? name(vm.meta.locations, assignment.destinationLocationId) : '') + (assignment.destinationDescription ? ' ' + assignment.destinationDescription : '');
        }
        function nextMaintenance(id) { var dates = vm.maintenancePlans.filter(function (p) { return p.equipmentId === id; }).map(function (p) { return p.nextDueDate; }).sort(); return dates[0]; }
        function hasAssignment() { return vm.detail && vm.detail.assignments.some(function (a) { return !a.endedAt; }); }
        function categoryForm(current) {
            openForm(tr('wamasysApp.equipmentParc.text.consumable_category'), [field('label', tr('wamasysApp.equipmentParc.text.wording')), field('active', tr('wamasysApp.equipmentParc.text.active'), 'checkbox', null, false)], current || {active: true}, function (data) { return (current ? api.put('consumable-categories/' + current.id, data) : api.post('consumable-categories', data)).then(function () { return metadata(); }); });
        }
        function consumableForm(current) {
            openForm(current ? tr('wamasysApp.equipmentParc.text.edit_item') : tr('wamasysApp.equipmentParc.text.add_a_consumable'), [field('code', tr('wamasysApp.equipmentParc.text.code')), field('label', tr('wamasysApp.equipmentParc.text.description_156')), field('unit', tr('wamasysApp.equipmentParc.text.stock_unit')), field('categoryId', tr('wamasysApp.equipmentParc.text.consumable_category'), 'select', (vm.meta.consumableCategories || []).filter(function (category) { return category.active || current && category.id === current.categoryId; }), false), field('unitPrice', tr('wamasysApp.equipmentParc.text.unit_price'), 'number', null, false), field('priceCurrency', tr('wamasysApp.equipmentParc.text.price_currency'), 'text', null, false), field('description', tr('wamasysApp.equipmentParc.text.description'), 'textarea', null, false), field('active', tr('wamasysApp.equipmentParc.text.active_item'), 'checkbox', null, false)], current || {unit: tr('wamasysApp.equipmentParc.text.piece'), active: true, priceCurrency: 'EUR'}, function (data) { if (!data.categoryId) { data.category = null; } return (current ? api.put('consumables/' + current.id, data) : api.post('consumables', data)).then(function () { return afterChange(); }); }, tr('wamasysApp.equipmentParc.text.all_movements_use_the_same_unit_this_unit_cannot_change'));
        }
        function loadStock() {
            var version = ++stockLoadVersion; vm.error = null;
            return api.get('stock', angular.copy(vm.stockFilter)).then(function (data) {
                if (version !== stockLoadVersion) { return; }
                vm.stock = data; vm.stockRows = data.balances.map(function (b) { return angular.copy(b); });
                data.settings.forEach(function (s) { if (!vm.stockRows.some(function (r) { return r.consumableId === s.consumableId && r.locationId === s.locationId; })) { vm.stockRows.push({consumableId: s.consumableId, locationId: s.locationId, quantity: 0}); } });
                vm.stockRows.forEach(function (r) { r.setting = data.settings.filter(function (s) { return s.consumableId === r.consumableId && s.locationId === r.locationId; })[0]; r.low = r.setting && r.quantity < r.setting.minimumQuantity; });
            }).catch(function (error) { if (version === stockLoadVersion) { failure(error); } });
        }
        function uuid() {
            var bytes = new $window.Uint8Array(16); $window.crypto.getRandomValues(bytes); bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
            return Array.prototype.map.call(bytes, function (b, i) { return ([4, 6, 8, 10].indexOf(i) >= 0 ? '-' : '') + ('0' + b.toString(16)).slice(-2); }).join('');
        }
        function stockForm() {
            var operationUuid = uuid();
            var fields = [field('operationType', tr('wamasysApp.equipmentParc.text.operation'), 'select', enums(vm.meta.operationTypes.filter(function (v) { return v !== 'REVERSAL'; }))), field('consumableId', tr('wamasysApp.equipmentParc.text.item'), 'select', vm.meta.consumables.filter(function (c) { return c.active; })), field('locationId', tr('wamasysApp.equipmentParc.text.stock_location_or_source_location'), 'select', vm.meta.locations.filter(function (l) { return l.active; })), field('destinationLocationId', tr('wamasysApp.equipmentParc.text.destination_location_320'), 'select', vm.meta.locations.filter(function (l) { return l.active; })), field('quantity', tr('wamasysApp.equipmentParc.text.quantity_in_the_item_s_unit'), 'number'), field('direction', tr('wamasysApp.equipmentParc.text.adjustment_direction'), 'select', enums(['IN', 'OUT'])), field('occurredAt', tr('wamasysApp.equipmentParc.text.movement_date'), 'datetime-local'), field('beneficiaryName', tr('wamasysApp.equipmentParc.text.beneficiary'), 'text', null, false), field('equipmentId', tr('wamasysApp.equipmentParc.text.related_equipment'), 'select', vm.items, false), field('comment', tr('wamasysApp.equipmentParc.text.reason_or_comments'), 'textarea', null, false)];
            fields.push(field('adjustmentReason', tr('wamasysApp.equipmentParc.physical.adjustmentReason'), 'select', (vm.meta.adjustmentReasons || []).map(function (reason) { return {id: reason, label: tr('wamasysApp.equipmentParc.adjustmentReasons.' + reason)}; })));
            fields[fields.length - 1].when = function (m) { return m.operationType === 'ADJUSTMENT'; };
            fields[3].when = function (m) { return m.operationType === 'TRANSFER'; }; fields[5].when = function (m) { return m.operationType === 'ADJUSTMENT'; };
            openForm(tr('wamasysApp.equipmentParc.text.record_a_stock_movement'), fields, {operationType: 'RECEIPT', occurredAt: new Date(), direction: 'IN'}, function (data) {
                var direction = data.operationType === 'CONSUMPTION' || data.operationType === 'TRANSFER' ? 'OUT' : data.operationType === 'ADJUSTMENT' ? data.direction : 'IN';
                var request = {operationUuid: operationUuid, operationType: data.operationType, adjustmentReason: data.operationType === 'ADJUSTMENT' ? data.adjustmentReason : undefined, occurredAt: data.occurredAt, beneficiaryName: data.beneficiaryName, equipmentId: data.equipmentId, comment: data.comment, lines: [{consumableId: data.consumableId, locationId: data.locationId, direction: direction, quantity: data.quantity}]};
                if (data.operationType === 'TRANSFER') { request.lines.push({consumableId: data.consumableId, locationId: data.destinationLocationId, direction: 'IN', quantity: data.quantity}); }
                return api.post('stock-operations', request).then(loadStock);
            }, tr('wamasysApp.equipmentParc.text.posted_movements_are_retained_use_a_reversal_to_correct_an'));
        }
        function thresholdForm(row) {
            openForm(tr('wamasysApp.equipmentParc.text.storage_address_and_stock_threshold'), [field('consumableId', tr('wamasysApp.equipmentParc.text.item'), 'select', vm.meta.consumables), field('locationId', tr('wamasysApp.equipmentParc.text.location'), 'select', vm.meta.locations), field('minimumQuantity', tr('wamasysApp.equipmentParc.text.alert_threshold'), 'number'), field('aisle', tr('wamasysApp.equipmentParc.text.aisle'), 'text', null, false), field('row', tr('wamasysApp.equipmentParc.text.row'), 'text', null, false), field('rack', tr('wamasysApp.equipmentParc.text.rack'), 'text', null, false), field('shelf', tr('wamasysApp.equipmentParc.text.shelf'), 'text', null, false), field('bin', tr('wamasysApp.equipmentParc.text.bin'), 'text', null, false)], row ? angular.extend({}, row.setting || {}, {consumableId: row.consumableId, locationId: row.locationId}) : {minimumQuantity: 0}, function (data) { var current = vm.stock.settings.filter(function (s) { return s.consumableId === data.consumableId && s.locationId === data.locationId; })[0]; data.version = current ? current.version : null; return api.post('stock-settings', data).then(loadStock); });
        }
        function reverseForm(operation) { var operationUuid = uuid(); openForm(tr('wamasysApp.equipmentParc.text.reverse_a_stock_operation'), [field('comment', tr('wamasysApp.equipmentParc.text.correction_reason'), 'textarea')], {}, function (data) { return api.post('stock-operations/' + operation.id + '/reverse', {operationUuid: operationUuid, comment: data.comment}).then(loadStock); }, tr('wamasysApp.equipmentParc.text.all_movements_in_this_operation_will_be_compensated_the_operation')); }
        function enroll() {
            openForm(tr('wamasysApp.equipmentParc.text.enrol_collector'), [field('platform', tr('wamasysApp.equipmentParc.text.platform'), 'select', enums(['WINDOWS', 'ANDROID']))], {platform: vm.detail.device.platform === 'ANDROID' ? 'ANDROID' : 'WINDOWS'}, function (data) {
                return api.post('equipment/' + vm.selectedId + '/enrollment', data).then(function (result) {
                    $uibModal.open({templateUrl: 'app/business/equipment-parc/equipment-token.html', controller: ['$scope', function (scope) { scope.token = result.token; scope.$on('$destroy', function () { scope.token = null; }); }]}).result.catch(angular.noop);
                    return select(vm.selectedId);
                });
            }, tr('wamasysApp.equipmentParc.text.new_enrolment_revokes_the_previous_one_the_collector_updates_only'));
        }
        function revoke() { openForm(tr('wamasysApp.equipmentParc.text.revoke_collector'), [], {}, function () { return api.remove('equipment/' + vm.selectedId + '/enrollment').then(function () { return select(vm.selectedId); }); }, tr('wamasysApp.equipmentParc.text.the_current_token_will_no_longer_be_accepted_you_can')); }
        function accountForm() {
            credentialForm(null, {version: 0});
        }
        function credentialForm(account, data) {
            var fields = [field('label', tr('wamasysApp.equipmentParc.secrets.label'), 'text', null, false), field('accountName', tr('wamasysApp.equipmentParc.secrets.login')), field('password', tr('wamasysApp.equipmentParc.secrets.password'), 'password', null, false)];
            var external = data.mode === 'EXTERNAL_VAULT' || data.mode === 'WINDOWS_LAPS';
            // Une ancienne référence est consultable uniquement dans cette fenêtre protégée et ne peut plus être modifiée.
            if (data.reference) { var legacy = field('legacyReference', tr('wamasysApp.equipmentParc.secrets.legacyReference'), 'textarea', null, false); legacy.disabled = true; fields.push(legacy); }
            if (external) { var conversion = field('convertToStored', tr('wamasysApp.equipmentParc.secrets.convertToStored'), 'checkbox', null, true); conversion.when = function (model) { return !!model.password; }; fields.push(conversion); }
            openForm(tr('wamasysApp.equipmentParc.secrets.edit'), fields, {version: data.version, accountName: account && account.accountName, label: account && account.label, legacyReference: data.reference}, function (input) {
                var request = {version: input.version, accountName: input.accountName, label: input.label, password: input.password, convertToStored: input.convertToStored};
                return (account ? api.put('admin-accounts/' + account.id + '/reference', request) : api.post('equipment/' + vm.selectedId + '/credentials', request)).then(function () { return select(vm.selectedId); }).finally(function () { request.password = null; });
            }, tr('wamasysApp.equipmentParc.secrets.help'));
        }
        function referenceForm(account) { api.get('admin-accounts/' + account.id + '/reference').then(function (data) { credentialForm(account, angular.extend({}, data, {version: account.version})); }).catch(failure); }
        function revealPassword(account) {
            api.post('admin-accounts/' + account.id + '/reveal', {}).then(function (result) {
                $uibModal.open({templateUrl: 'app/business/equipment-parc/equipment-password.html', backdrop: 'static', controllerAs: 'secret', controller: ['$uibModalInstance', '$scope', function (modal, scope) {
                    var vm = this; vm.login = result.accountName; vm.password = result.password; result.password = null; vm.visible = true; vm.close = function () { vm.password = null; modal.close(); }; scope.$on('$destroy', function () { vm.password = null; });
                }]}).result.catch(angular.noop);
            }).catch(failure);
        }
        function manualDeviceForm() {
            var network = vm.detail.interfaces[0] || {}, address = vm.detail.addresses[0] || {};
            openForm(tr('wamasysApp.equipmentParc.it.manualInfo'), [field('hostname', tr('wamasysApp.equipmentParc.it.hostname'), 'text', null, false), field('ipAddress', tr('wamasysApp.equipmentParc.text.ip_address'), 'text', null, false), field('macAddress', tr('wamasysApp.equipmentParc.text.mac_address'), 'text', null, false)], {version: vm.detail.device.version, hostname: vm.detail.device.hostname, ipAddress: address.ipAddress, macAddress: network.macAddress}, function (input) { return api.put('equipment/' + vm.selectedId + '/manual-device', input).then(function () { return select(vm.selectedId); }); });
        }
        function itOverview() {
            api.get('network-observations').then(function (data) { vm.network = data; }).catch(failure);
            api.get('collector-packages').then(function (data) { vm.packages = data; }).catch(failure);
            loadLicenses();
        }
        function loadLicenses() {
            vm.licenseBusy = true;
            return api.get('licenses', {page: vm.licensePage}).then(function (data) { vm.licenses = data.items; vm.licenseTotal = data.total; }).catch(failure).finally(function () { vm.licenseBusy = false; });
        }
        function licenseForm(row) {
            var fields = [field('product', tr('wamasysApp.equipmentParc.licenses.product')), field('reference', tr('wamasysApp.equipmentParc.licenses.reference'), 'text', null, false), field('ownerEntiteParenteId', tr('wamasysApp.equipmentParc.text.extra_agency'), 'select', vm.meta.owners), field('areaId', tr('wamasysApp.equipmentParc.text.extra_area'), 'select', areas, !vm.isAdmin), field('purchasedAt', tr('wamasysApp.equipmentParc.licenses.purchasedAt'), 'date', null, false), field('expiresAt', tr('wamasysApp.equipmentParc.licenses.expiresAt'), 'date', null, false), field('seats', tr('wamasysApp.equipmentParc.licenses.seats'), 'number')];
            if (vm.canSecrets) { fields.push(field('licenseKey', tr('wamasysApp.equipmentParc.licenses.key'), 'password', null, false)); }
            fields.push(field('comment', tr('wamasysApp.equipmentParc.text.extra_comments'), 'textarea', null, false));
            openForm(tr('wamasysApp.equipmentParc.licenses.title'), fields, row ? row.license : angular.extend(defaults(), {seats: 1}), function (data) {
                return (row ? api.put('licenses/' + row.license.id, data) : api.post('licenses', data)).then(loadLicenses).finally(function () { data.licenseKey = null; });
            }, tr('wamasysApp.equipmentParc.licenses.keyHelp'));
        }
        function assignLicense(row) {
            openForm(tr('wamasysApp.equipmentParc.licenses.assign'), [field('inventoryCode', tr('wamasysApp.equipmentParc.licenses.computerReference'))], {version: row.license.version}, function (data) { return api.post('licenses/' + row.license.id + '/assignments', data).then(loadLicenses); }, tr('wamasysApp.equipmentParc.licenses.assignmentHelp'));
        }
        function releaseLicense(row, assignment) {
            openForm(tr('wamasysApp.equipmentParc.licenses.release'), [], {version: row.license.version}, function (data) { return api.post('licenses/' + row.license.id + '/assignments/' + assignment.id + '/release', data).then(loadLicenses); }, tr('wamasysApp.equipmentParc.licenses.releaseHelp'));
        }
        function revealLicense(row) {
            api.post('licenses/' + row.license.id + '/reveal', {}).then(function (result) {
                $uibModal.open({templateUrl: 'app/business/equipment-parc/equipment-license-key.html', backdrop: 'static', controllerAs: 'secret', controller: ['$uibModalInstance', '$scope', function (modal, scope) {
                    var secret = this; secret.password = result.licenseKey; result.licenseKey = null; secret.visible = false;
                    secret.close = function () { secret.password = null; modal.close(); }; scope.$on('$destroy', function () { secret.password = null; });
                }]});
            }).catch(failure);
        }
        function licenseHistory(row) { api.get('licenses/' + row.license.id + '/history').then(function (data) { vm.licenseEvents = data; vm.licenseHistoryId = row.license.id; }).catch(failure); }
        function downloadCollector(discover) {
            vm.collectorBusy = true;
            var baseUrl = ($window.location.origin + $window.location.pathname).replace(/\/index\.html$/, '').replace(/\/$/, '');
            api.downloadPost('collector-bundle', {apiBaseUrl: baseUrl, discoverNetwork: discover}).then(function (bytes) {
                var url = $window.URL.createObjectURL(new $window.Blob([bytes], {type: 'application/zip'})); var link = $window.document.createElement('a'); link.href = url; link.download = discover ? 'wamasys-analyse-reseau.zip' : 'install-wamasys-it.zip'; $window.document.body.appendChild(link); link.click(); $window.document.body.removeChild(link); $window.setTimeout(function () { $window.URL.revokeObjectURL(url); }, 1000); itOverview();
            }).catch(function (error) {
                if (error && $window.ArrayBuffer && error.data instanceof $window.ArrayBuffer) { try { error.data = angular.fromJson(new $window.TextDecoder('utf-8').decode(error.data)); } catch (ignored) { error.data = null; } } failure(error);
            }).finally(function () { vm.collectorBusy = false; });
        }
        function revokePackage(pack) { openForm(tr('wamasysApp.equipmentParc.it.revokeDownload'), [], {}, function () { return api.remove('collector-packages/' + pack.id).then(itOverview); }, tr('wamasysApp.equipmentParc.it.revokeHelp')); }
        function importNetwork(observation) {
            openForm(tr('wamasysApp.equipmentParc.it.confirmDiscovery'), [field('itType', tr('wamasysApp.equipmentParc.it.type'), 'select', (vm.meta.itTypes || []).map(function (value) { return {id: value, label: vm.itLabel(value)}; })), field('label', tr('wamasysApp.equipmentParc.text.description_156'))], {itType: observation.suggestedType, label: observation.hostname || observation.ipAddress}, function (input) { return api.post('network-observations/' + observation.id + '/import', input).then(function (item) { itOverview(); return afterChange(item.id); }); }, tr('wamasysApp.equipmentParc.it.discoveryHelp'));
        }
        function credentialHistory() { api.get('equipment/' + vm.selectedId + '/credential-history').then(function (data) { vm.credentialAccess = data; }).catch(failure); }
        function refreshAndroid() { api.get('android-registrations').then(function (data) { vm.android = data; }).catch(failure); }
        function importAndroid(registration) { openForm(tr('wamasysApp.equipmentParc.text.import_or_refresh_android_device'), [], {}, function () { return api.post('android-import', {registrationId: registration.id}).then(function (equipment) { return afterChange(equipment.id); }); }, tr('wamasysApp.equipmentParc.text.the_record_will_be_assigned_to_the_user_s_primary')); }
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').controller('EquipmentMetersController', EquipmentMetersController);
    EquipmentMetersController.$inject = ['$state', '$stateParams', 'EquipmentParc', '$translate'];
    function EquipmentMetersController($state, params, api, $translate) {
        var vm = this, generation = 0;
        vm.pageTitle = 'wamasysApp.equipmentParc.evolution.meters'; vm.kind = params.kind || 'INDIVIDUAL'; vm.page = 0;
        vm.tr = function (key) { return $translate.instant('wamasysApp.equipmentParc.evolution.' + key); };
        function fail(error) { vm.error = error.data && error.data.message || vm.tr('failed'); }
        function day(date) { return date ? date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) : null; }
        vm.load = function () {
            var current = ++generation; vm.error = null; vm.detail = null; vm.loading = true; vm.pagination = vm.page + 1;
            return api.get('meters', {kind: vm.kind, state: vm.state, search: vm.search, page: vm.page}).then(function (data) { if (current === generation) { vm.items = data.items; vm.total = data.total; } }).catch(fail).finally(function () { if (current === generation) { vm.loading = false; } });
        };
        vm.select = function (meter) {
            var current = ++generation; vm.meter = meter; vm.error = null;
            return api.get('meters/' + meter.kind + '/' + meter.id).then(function (data) {
                if (current !== generation) { return; } vm.meter = data.meter; vm.detail = data; vm.form = angular.copy(data.profile || {});
                ['acquisitionDate', 'warrantyEndDate', 'depreciationStartDate'].forEach(function (key) { if (vm.form[key]) { vm.form[key] = new Date(vm.form[key] + 'T12:00:00'); } });
                $state.go('equipment-meters', {kind: meter.kind, meterId: meter.id}, {notify: false, location: 'replace'});
            }).catch(fail);
        };
        vm.reload = function () { return vm.select(vm.meter); };
        vm.back = function () { $state.go('equipment-meters', {kind: vm.kind, meterId: null}, {notify: false, location: 'replace'}); return vm.load(); };
        vm.locations = function () { return (vm.meta.locations || []).filter(function (location) { return location.areaId === vm.meter.areaId && location.active; }); };
        vm.save = function () {
            vm.busy = true; vm.error = null; var data = angular.copy(vm.form);
            ['acquisitionDate', 'warrantyEndDate', 'depreciationStartDate'].forEach(function (key) { data[key] = day(data[key]); });
            return api.put('meters/' + vm.meter.kind + '/' + vm.meter.id, data).then(vm.reload).catch(fail).finally(function () { vm.busy = false; });
        };
        vm.meta = {};
        api.get('metadata').then(function (meta) { vm.meta = meta; vm.canEdit = meta.canEdit; return vm.load(); }).then(function () {
            if (params.meterId) {
                // La fiche reste accessible directement, même hors de la page courante.
                var found = (vm.items || []).filter(function (meter) { return meter.id === Number(params.meterId); })[0];
                return vm.select(found || {id: Number(params.meterId), kind: vm.kind});
            }
        }).catch(fail);
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').factory('EquipmentMessages', EquipmentMessages);
    EquipmentMessages.$inject = ['$translate'];
    function EquipmentMessages($translate) {
        var keys = {
            "Les paramètres sont obligatoires.": "wamasysApp.equipmentParc.workstationErrors.m0",
            "Le paramétrage a été modifié. Rechargez la page.": "wamasysApp.equipmentParc.workstationErrors.m1",
            "Le mot de passe de secours se règle sur l’organisation.": "wamasysApp.equipmentParc.workstationErrors.m2",
            "Le compte de secours se règle sur l’organisation.": "wamasysApp.equipmentParc.workstationErrors.m3",
            "Le mot de passe de secours doit contenir au moins huit caractères sans caractère de contrôle.": "wamasysApp.equipmentParc.workstationErrors.m4",
            "Configurez la clé de chiffrement IT avant d’activer les comptes administrateurs.": "wamasysApp.equipmentParc.workstationErrors.m5",
            "Configurez la clé de chiffrement IT avant de créer les comptes administrateurs.": "wamasysApp.equipmentParc.workstationErrors.m6",
            "Le paramétrage d’organisation ne peut pas être supprimé.": "wamasysApp.equipmentParc.workstationErrors.m7",
            "Seul un administrateur peut régler le profil de l’organisation.": "wamasysApp.equipmentParc.workstationErrors.m8",
            "Le paramétrage du poste est illisible.": "wamasysApp.equipmentParc.workstationErrors.m9",
            "Le paramétrage du poste ne peut pas être enregistré.": "wamasysApp.equipmentParc.workstationErrors.m10",
            "Trop de paramètres.": "wamasysApp.equipmentParc.workstationErrors.m11",
            "Paramètre du poste inconnu.": "wamasysApp.equipmentParc.workstationErrors.m12",
            "Une option du poste doit être vraie ou fausse.": "wamasysApp.equipmentParc.workstationErrors.m13",
            "Texte de paramétrage incorrect.": "wamasysApp.equipmentParc.workstationErrors.m14",
            "Version de paramétrage inconnue.": "wamasysApp.equipmentParc.workstationErrors.m15",
            "Liste de logiciels incorrecte.": "wamasysApp.equipmentParc.workstationErrors.m16",
            "Logiciel inconnu ou présent plusieurs fois.": "wamasysApp.equipmentParc.workstationErrors.m17",
            "Paramétrage du poste incorrect.": "wamasysApp.equipmentParc.workstationErrors.m18",
            "Les noms des comptes locaux doivent contenir 1 à 20 lettres, chiffres, tirets ou traits de soulignement et commencer par une lettre.": "wamasysApp.equipmentParc.workstationErrors.m19",
            "Les deux comptes administrateurs doivent avoir des noms différents.": "wamasysApp.equipmentParc.workstationErrors.m20",
            "Le fond d’écran doit utiliser une URL HTTPS sans identifiants.": "wamasysApp.equipmentParc.workstationErrors.m21",
            "URL du fond d’écran incorrecte.": "wamasysApp.equipmentParc.workstationErrors.m22",
            "Sélectionnez l’AREA avant de télécharger la préparation du poste.": "wamasysApp.equipmentParc.workstationErrors.m23",
            "Le programme de préparation ne peut pas être téléchargé.": "wamasysApp.equipmentParc.workstationErrors.m24",
            "Ce téléchargement autorise uniquement l’inventaire.": "wamasysApp.equipmentParc.workstationErrors.m25",
            "L’inscription du poste est incomplète.": "wamasysApp.equipmentParc.workstationErrors.m26",
            "Le stockage chiffré des mots de passe n’est pas configuré.": "wamasysApp.equipmentParc.workstationErrors.m27",
            "La préparation a expiré. Relancez le programme avant de retirer les droits administrateur.": "wamasysApp.equipmentParc.workstationErrors.m28",
            "La confirmation du poste est illisible.": "wamasysApp.equipmentParc.workstationErrors.m29",
            "Les deux comptes administrateurs doivent être vérifiés.": "wamasysApp.equipmentParc.workstationErrors.m30",
            "Compte Windows confirmé incorrect.": "wamasysApp.equipmentParc.workstationErrors.m31",
            "Compte inattendu dans la confirmation.": "wamasysApp.equipmentParc.workstationErrors.m32",
            "Le compte confirmé appartient à un autre poste.": "wamasysApp.equipmentParc.workstationErrors.m33",
            "Le mot de passe a changé pendant la préparation. Relancez le programme.": "wamasysApp.equipmentParc.workstationErrors.m34",
            "Application Windows confirmée par le programme du poste.": "wamasysApp.equipmentParc.workstationErrors.m35",
            "La préparation de ce poste n’est pas autorisée.": "wamasysApp.equipmentParc.workstationErrors.m36",
            "Préparation révoquée.": "wamasysApp.equipmentParc.workstationErrors.m37",
            "Plusieurs comptes portent ce nom dans Wamasys. Corrigez la fiche avant la préparation.": "wamasysApp.equipmentParc.workstationErrors.m38",
            "Un compte sélectionné dépend d’un coffre ou de LAPS. Choisissez un autre nom pour le programme de préparation.": "wamasysApp.equipmentParc.workstationErrors.m39",
            "Mot de passe réservé ; application Windows à confirmer.": "wamasysApp.equipmentParc.workstationErrors.m40",
            "Secret remis au programme autorisé de ce poste.": "wamasysApp.equipmentParc.workstationErrors.m41",
            "Le nom du détenteur est obligatoire (200 caractères maximum).": "wamasysApp.equipmentParc.collectorAssignment.m0",
            "Le lieu choisi n’est plus disponible dans l’AREA téléchargée. Téléchargez un nouveau script.": "wamasysApp.equipmentParc.collectorAssignment.m1",
            "Un prêt est en cours sur ce poste. Enregistrez son retour dans Wamasys avant de changer le détenteur ou le lieu.": "wamasysApp.equipmentParc.collectorAssignment.m2",
            "Le responsable de ce téléchargement n’est plus disponible. Téléchargez un nouveau script.": "wamasysApp.equipmentParc.collectorAssignment.m3",
            "Affectation déclarée à l’installation du collecteur.": "wamasysApp.equipmentParc.collectorAssignment.m4",
            "Choisissez un type terrain ou un type informatique, pas les deux.": "wamasysApp.equipmentParc.physicalErrors.e38",
            "Le responsable et le validateur doivent être des comptes actifs de l’organisation autorisés à modifier le parc.": "wamasysApp.equipmentParc.physicalErrors.e37",
            "Ce motif correspond à une sortie de stock.": "wamasysApp.equipmentParc.physicalErrors.e36",
            "Choisissez le motif de l’ajustement d’inventaire.": "wamasysApp.equipmentParc.physicalErrors.e35",
            "Le stock a évolué depuis l’ouverture. Validez sans correction automatique puis effectuez un ajustement séparé.": "wamasysApp.equipmentParc.physicalErrors.e34",
            "Renseignez une valeur unitaire positive ou nulle et sa devise.": "wamasysApp.equipmentParc.physicalErrors.e33",
            "Précisez la raison de l’ajustement dans le commentaire.": "wamasysApp.equipmentParc.physicalErrors.e32",
            "Choisissez le motif de chaque écart d’inventaire.": "wamasysApp.equipmentParc.physicalErrors.e31",
            "Renseignez l’état de l’équipement présent.": "wamasysApp.equipmentParc.physicalErrors.e30",
            "Un équipement est présent (1) ou absent (0).": "wamasysApp.equipmentParc.physicalErrors.e29",
            "La quantité comptée doit être positive ou nulle avec quatre décimales maximum.": "wamasysApp.equipmentParc.physicalErrors.e28",
            "Chaque ligne doit être comptée avant soumission.": "wamasysApp.equipmentParc.physicalErrors.e27",
            "Cette ligne a changé. Rechargez-la avant de réessayer.": "wamasysApp.equipmentParc.physicalErrors.e26",
            "Ligne d’inventaire inaccessible.": "wamasysApp.equipmentParc.physicalErrors.e25",
            "Les lignes sont figées hors du comptage en cours.": "wamasysApp.equipmentParc.physicalErrors.e24",
            "Cette ligne existe déjà dans l’inventaire.": "wamasysApp.equipmentParc.physicalErrors.e23",
            "Le lieu doit appartenir au périmètre actif de l’inventaire.": "wamasysApp.equipmentParc.physicalErrors.e22",
            "L’inventaire atteint la limite de 10 000 lignes.": "wamasysApp.equipmentParc.physicalErrors.e21",
            "Ajoutez les articles pendant le comptage des consommables.": "wamasysApp.equipmentParc.physicalErrors.e20",
            "Le périmètre dépasse 10 000 lignes. Limitez l’inventaire à un lieu.": "wamasysApp.equipmentParc.physicalErrors.e19",
            "Seul le validateur désigné, distinct du responsable, peut effectuer ce contrôle.": "wamasysApp.equipmentParc.physicalErrors.e18",
            "Action d’inventaire inconnue.": "wamasysApp.equipmentParc.physicalErrors.e17",
            "Précisez la raison de l’annulation.": "wamasysApp.equipmentParc.physicalErrors.e16",
            "Un inventaire figé ne peut plus être annulé.": "wamasysApp.equipmentParc.physicalErrors.e15",
            "Soumettez le comptage avant validation.": "wamasysApp.equipmentParc.physicalErrors.e14",
            "Précisez la raison du retour au comptage.": "wamasysApp.equipmentParc.physicalErrors.e13",
            "Seul un inventaire en contrôle peut être renvoyé au comptage.": "wamasysApp.equipmentParc.physicalErrors.e12",
            "L’inventaire doit contenir au moins une ligne.": "wamasysApp.equipmentParc.physicalErrors.e11",
            "Le comptage doit être en cours pour être soumis.": "wamasysApp.equipmentParc.physicalErrors.e10",
            "L’ouverture doit avoir lieu à la date de comptage prévue. Modifiez la date du brouillon si nécessaire.": "wamasysApp.equipmentParc.physicalErrors.e9",
            "Cet inventaire a déjà été ouvert.": "wamasysApp.equipmentParc.physicalErrors.e8",
            "Le libellé de l’inventaire est obligatoire.": "wamasysApp.equipmentParc.physicalErrors.e7",
            "L’inventaire a changé. Rechargez-le avant de réessayer.": "wamasysApp.equipmentParc.physicalErrors.e6",
            "Seul un inventaire planifié peut être reparamétré.": "wamasysApp.equipmentParc.physicalErrors.e5",
            "Le validateur doit être distinct du responsable du comptage.": "wamasysApp.equipmentParc.physicalErrors.e4",
            "La date du prochain inventaire doit être postérieure au comptage.": "wamasysApp.equipmentParc.physicalErrors.e3",
            "Le lieu doit appartenir à l’AREA de l’inventaire.": "wamasysApp.equipmentParc.physicalErrors.e2",
            "Sélectionnez les équipements ou les consommables à inventorier.": "wamasysApp.equipmentParc.physicalErrors.e1",
            "Seul le responsable du comptage ou un administrateur peut modifier cet inventaire.": "wamasysApp.equipmentParc.physicalErrors.e0",
            "Renseignez la devise du prix d’achat (exemple : EUR, XOF).": "wamasysApp.equipmentParc.mediaErrors.e0",
            "La valeur résiduelle doit être comprise entre zéro et le prix d’achat.": "wamasysApp.equipmentParc.mediaErrors.e1",
            "L’amortissement demande un prix d’achat et une date de début ou d’acquisition.": "wamasysApp.equipmentParc.mediaErrors.e2",
            "Le fichier et son nom sont obligatoires.": "wamasysApp.equipmentParc.mediaErrors.e3",
            "Le fichier dépasse la taille maximale autorisée.": "wamasysApp.equipmentParc.mediaErrors.e4",
            "Le contenu du fichier est incorrect.": "wamasysApp.equipmentParc.mediaErrors.e5",
            "Le fichier est vide ou dépasse la taille maximale autorisée.": "wamasysApp.equipmentParc.mediaErrors.e6",
            "Cet identifiant d’envoi a déjà été utilisé pour un autre fichier.": "wamasysApp.equipmentParc.mediaErrors.e7",
            "Le fichier n’a pas pu être enregistré. Réessayez l’envoi.": "wamasysApp.equipmentParc.mediaErrors.e8",
            "Cette pièce jointe n’est plus disponible.": "wamasysApp.equipmentParc.mediaErrors.e9",
            "Cette pièce jointe ne peut pas être chargée actuellement.": "wamasysApp.equipmentParc.mediaErrors.e10",
            "Pièce jointe inaccessible.": "wamasysApp.equipmentParc.mediaErrors.e11",
            "Le nom du fichier est incorrect.": "wamasysApp.equipmentParc.mediaErrors.e12",
            "Choisissez une photo JPEG ou PNG valide.": "wamasysApp.equipmentParc.mediaErrors.e13",
            "La photo est trop grande (32 mégapixels maximum).": "wamasysApp.equipmentParc.mediaErrors.e14",
            "Ajout d’une photo ou d’un document.": "wamasysApp.equipmentParc.mediaErrors.e15",
            "Suppression d’une photo ou d’un document.": "wamasysApp.equipmentParc.mediaErrors.e16",
            "Agence inaccessible.": "wamasysApp.equipmentParc.mediaErrors.e17",
            "L’AREA doit appartenir à l’Agence choisie.": "wamasysApp.equipmentParc.mediaErrors.e18",

            "\nSérie : ": "wamasysApp.equipmentParc.text.serial_number",
            " · archivé": "wamasysApp.equipmentParc.text.archived",
            " · aucune copie enregistrée": "wamasysApp.equipmentParc.text.no_saved_copy",
            " · retour prévu : ": "wamasysApp.equipmentParc.text.due_back",
            " équipement(s) affiché(s)": "wamasysApp.equipmentParc.text.equipment_item_s_shown",
            " équipement(s) sur la carte · touchez un repère pour ouvrir la fiche": "wamasysApp.equipmentParc.text.equipment_item_s_on_the_map_tap_a_marker_to",
            "Accès au parc refusé dans ce périmètre.": "wamasysApp.equipmentParc.text.access_to_the_asset_register_is_denied_for_this_scope",
            "Acquisition": "wamasysApp.equipmentParc.text.acquisition",
            "Actif": "wamasysApp.equipmentParc.text.active",
            "Action": "wamasysApp.equipmentParc.text.action",
            "Active": "wamasysApp.equipmentParc.text.active_10",
            "Activé": "wamasysApp.equipmentParc.text.activated",
            "Actualisation de la carte…": "wamasysApp.equipmentParc.text.refreshing_the_map",
            "Actualisation de la fiche…": "wamasysApp.equipmentParc.text.refreshing_the_record",
            "Actualisation des stocks…": "wamasysApp.equipmentParc.text.refreshing_stock",
            "Actualisation des équipements…": "wamasysApp.equipmentParc.text.refreshing_equipment",
            "Actualiser": "wamasysApp.equipmentParc.text.refresh",
            "Actualiser la fiche": "wamasysApp.equipmentParc.text.refresh_record",
            "Actualiser la liste": "wamasysApp.equipmentParc.text.refresh_list",
            "Actualiser les stocks": "wamasysApp.equipmentParc.text.refresh_stock",
            "Actualiser les équipements": "wamasysApp.equipmentParc.text.refresh_equipment",
            "Actualisez d'abord les équipements.": "wamasysApp.equipmentParc.text.refresh_the_equipment_list_first",
            "Adresse": "wamasysApp.equipmentParc.text.address",
            "Adresse IP": "wamasysApp.equipmentParc.text.ip_address",
            "Adresse IP incorrecte.": "wamasysApp.equipmentParc.text.invalid_ip_address",
            "Adresse IPv4 incorrecte.": "wamasysApp.equipmentParc.text.invalid_ipv4_address",
            "Adresse MAC": "wamasysApp.equipmentParc.text.mac_address",
            "Adresse du serveur invalide.": "wamasysApp.equipmentParc.text.invalid_server_address",
            "Adresse réseau vide.": "wamasysApp.equipmentParc.text.empty_network_address",
            "Affectation durable": "wamasysApp.equipmentParc.text.long_term_allocation",
            "Affecté ou emprunté": "wamasysApp.equipmentParc.text.allocated_or_on_loan",
            "Afficher les étiquettes": "wamasysApp.equipmentParc.text.preview_labels",
            "Agence propriétaire": "wamasysApp.equipmentParc.text.owning_agency",
            "Ajouter / enlever / transférer du stock": "wamasysApp.equipmentParc.text.receive_issue_transfer_stock",
            "Ajouter un article": "wamasysApp.equipmentParc.text.add_an_item",
            "Ajouter un compte": "wamasysApp.equipmentParc.text.add_an_account",
            "Ajouter un compte administrateur": "wamasysApp.equipmentParc.text.add_an_administrator_account",
            "Ajouter un consommable": "wamasysApp.equipmentParc.text.add_a_consumable",
            "Ajouter un lieu": "wamasysApp.equipmentParc.text.add_a_location",
            "Ajouter un type": "wamasysApp.equipmentParc.text.add_a_type",
            "Ajouter un type d’équipement": "wamasysApp.equipmentParc.text.add_an_equipment_type",
            "Ajouter un équipement": "wamasysApp.equipmentParc.text.add_equipment",
            "Ajustement": "wamasysApp.equipmentParc.text.adjustment",
            "Ajustement d’inventaire": "wamasysApp.equipmentParc.text.stock_adjustment",
            "Allée": "wamasysApp.equipmentParc.text.aisle",
            "Annuler": "wamasysApp.equipmentParc.text.cancel",
            "Annulée": "wamasysApp.equipmentParc.text.cancelled",
            "Aperçu des étiquettes": "wamasysApp.equipmentParc.text.label_preview",
            "Appareil Android": "wamasysApp.equipmentParc.text.android_device",
            "Appareils Android connus": "wamasysApp.equipmentParc.text.registered_android_devices",
            "Area (obligatoire)": "wamasysApp.equipmentParc.text.area_required",
            "Area de l'équipement": "wamasysApp.equipmentParc.text.equipment_area",
            "Area de rattachement": "wamasysApp.equipmentParc.text.assigned_area",
            "Article": "wamasysApp.equipmentParc.text.item",
            "Article (obligatoire)": "wamasysApp.equipmentParc.text.item_required",
            "Article actif": "wamasysApp.equipmentParc.text.active_item",
            "Article n°": "wamasysApp.equipmentParc.text.item_no",
            "Articles": "wamasysApp.equipmentParc.text.items",
            "Aucun stock enregistré. Créez un article et un lieu, puis saisissez le stock initial ou une réception.": "wamasysApp.equipmentParc.text.no_stock_recorded_create_an_item_and_a_location_then",
            "Aucun équipement ne correspond à la recherche.": "wamasysApp.equipmentParc.text.no_equipment_matches_your_search",
            "Aucune affectation enregistrée.": "wamasysApp.equipmentParc.text.no_allocation_recorded",
            "Aucune fiche en cache. Connectez-vous pour la charger.": "wamasysApp.equipmentParc.text.no_cached_record_connect_to_load_it",
            "Aucune intervention liée.": "wamasysApp.equipmentParc.text.no_linked_work_orders",
            "Auprès de ": "wamasysApp.equipmentParc.text.held_by",
            "Autorisez la fenêtre d’impression dans votre navigateur.": "wamasysApp.equipmentParc.text.allow_the_print_window_in_your_browser",
            "Autre": "wamasysApp.equipmentParc.text.other",
            "Bac": "wamasysApp.equipmentParc.text.bin",
            "Bon état": "wamasysApp.equipmentParc.text.good_condition",
            "Bureau": "wamasysApp.equipmentParc.text.office",
            "Bénéficiaire": "wamasysApp.equipmentParc.text.beneficiary",
            "Bénéficiaire (obligatoire)": "wamasysApp.equipmentParc.text.beneficiary_required",
            "Bénéficiaire / chantier (facultatif)": "wamasysApp.equipmentParc.text.beneficiary_work_site_optional",
            "Cadrez l’étiquette de l’équipement ou du consommable.": "wamasysApp.equipmentParc.text.position_the_equipment_or_consumable_label_inside_the_frame",
            "Caméra non autorisée. Vous pouvez saisir le code.": "wamasysApp.equipmentParc.text.camera_access_denied_you_can_enter_the_code_manually",
            "Capacité (Gio)": "wamasysApp.equipmentParc.text.capacity_gib",
            "Carte": "wamasysApp.equipmentParc.text.map",
            "Ce code-barres ne correspond pas à une étiquette du parc Wamasys.": "wamasysApp.equipmentParc.text.this_barcode_is_not_a_wamasys_asset_label",
            "Ce lieu est archivé.": "wamasysApp.equipmentParc.text.this_location_is_archived",
            "Ce type d'équipement est archivé.": "wamasysApp.equipmentParc.text.this_equipment_type_is_archived",
            "Cet identifiant a déjà été utilisé pour une autre opération.": "wamasysApp.equipmentParc.text.this_identifier_has_already_been_used_for_another_operation",
            "Cet équipement est déjà affecté ou emprunté.": "wamasysApp.equipmentParc.text.this_equipment_is_already_allocated_or_on_loan",
            "Cet équipement n'accepte plus de remontées.": "wamasysApp.equipmentParc.text.this_equipment_no_longer_accepts_inventory_reports",
            "Cet équipement n'appartient pas au parc informatique.": "wamasysApp.equipmentParc.text.this_equipment_is_not_part_of_the_it_inventory",
            "Cet équipement n'est pas informatique.": "wamasysApp.equipmentParc.text.this_equipment_is_not_an_it_device",
            "Cet événement possède déjà une fiche équipement d'origine.": "wamasysApp.equipmentParc.text.this_event_already_has_an_original_equipment_record",
            "Cette affectation est déjà terminée.": "wamasysApp.equipmentParc.text.this_allocation_has_already_ended",
            "Cette fiche n’est pas en cache. Connectez-vous pour la retrouver.": "wamasysApp.equipmentParc.text.this_record_is_not_cached_connect_to_find_it",
            "Cette opération a déjà été contre-passée.": "wamasysApp.equipmentParc.text.this_operation_has_already_been_reversed",
            "Cette opération doit entrer en stock.": "wamasysApp.equipmentParc.text.this_operation_must_increase_stock",
            "Cette étiquette appartient à une autre organisation.": "wamasysApp.equipmentParc.text.this_label_belongs_to_another_organisation",
            "Changer de zone": "wamasysApp.equipmentParc.text.change_area",
            "Chantier ou destination": "wamasysApp.equipmentParc.text.work_site_or_destination",
            "Chargement…": "wamasysApp.equipmentParc.text.loading",
            "Choisir la date": "wamasysApp.equipmentParc.text.choose_a_date",
            "Choisir…": "wamasysApp.equipmentParc.text.choose",
            "Choisissez Windows ou Android pour ce collecteur.": "wamasysApp.equipmentParc.text.choose_windows_or_android_for_this_collector",
            "Choisissez un autre lieu de destination.": "wamasysApp.equipmentParc.text.choose_a_different_destination",
            "Choisissez une intervention de maintenance de cet équipement.": "wamasysApp.equipmentParc.text.choose_a_maintenance_work_order_for_this_equipment",
            "Clôturer : ": "wamasysApp.equipmentParc.text.complete",
            "Code": "wamasysApp.equipmentParc.text.code",
            "Code (obligatoire)": "wamasysApp.equipmentParc.text.code_required",
            "Code d'inventaire (obligatoire)": "wamasysApp.equipmentParc.text.inventory_code_required",
            "Code d’inventaire": "wamasysApp.equipmentParc.text.inventory_code",
            "Code-barres": "wamasysApp.equipmentParc.text.barcode",
            "Coffre externe": "wamasysApp.equipmentParc.text.external_vault",
            "Collecteur": "wamasysApp.equipmentParc.text.collector",
            "Collecteur inaccessible.": "wamasysApp.equipmentParc.text.collector_is_inaccessible",
            "Collecteur non autorisé.": "wamasysApp.equipmentParc.text.collector_is_not_authorised",
            "Commencez par créer un type d’équipement dans « Types et lieux ». Ce paramétrage est réservé aux administrateurs.": "wamasysApp.equipmentParc.text.start_by_creating_an_equipment_type_on_the_types_and",
            "Commentaire de retour": "wamasysApp.equipmentParc.text.return_notes",
            "Commentaire de sortie": "wamasysApp.equipmentParc.text.issue_notes",
            "Compte": "wamasysApp.equipmentParc.text.account",
            "Compte activé": "wamasysApp.equipmentParc.text.account_enabled",
            "Compte administrateur vide.": "wamasysApp.equipmentParc.text.empty_administrator_account",
            "Comptes administrateurs": "wamasysApp.equipmentParc.text.administrator_accounts",
            "Configuration informatique": "wamasysApp.equipmentParc.text.it_configuration",
            "Confirmer": "wamasysApp.equipmentParc.text.confirm",
            "Confirmer la maintenance": "wamasysApp.equipmentParc.text.confirm_maintenance",
            "Connectez-vous pour charger les consommables et leurs stocks.": "wamasysApp.equipmentParc.text.connect_to_load_consumables_and_stock",
            "Consommables": "wamasysApp.equipmentParc.text.consumables",
            "Consommables et stocks": "wamasysApp.equipmentParc.text.consumables_and_stock",
            "Consommation": "wamasysApp.equipmentParc.text.consumption",
            "Consultation de référence": "wamasysApp.equipmentParc.text.reference_access",
            "Consulter ou modifier la référence": "wamasysApp.equipmentParc.text.view_or_edit_reference",
            "Contre-passer l'opération n°": "wamasysApp.equipmentParc.text.reverse_operation_no",
            "Contre-passer une opération de stock": "wamasysApp.equipmentParc.text.reverse_a_stock_operation",
            "Contrôle": "wamasysApp.equipmentParc.text.inspection",
            "Coordonnées": "wamasysApp.equipmentParc.text.coordinates",
            "Coordonnées incorrectes.": "wamasysApp.equipmentParc.text.invalid_coordinates",
            "Copie consultable hors connexion": "wamasysApp.equipmentParc.text.copy_available_offline",
            "Copiez ce jeton maintenant dans la configuration protégée du poste. Il ne sera plus affiché. L’authentification Wamasys reste nécessaire.": "wamasysApp.equipmentParc.text.copy_this_token_into_the_protected_device_configuration_now_it",
            "Créer un consommable": "wamasysApp.equipmentParc.text.create_a_consumable",
            "Date de retour": "wamasysApp.equipmentParc.text.return_date",
            "Date de réalisation": "wamasysApp.equipmentParc.text.completion_date",
            "Date de sortie": "wamasysApp.equipmentParc.text.issue_date",
            "Date de sortie du parc": "wamasysApp.equipmentParc.text.retirement_date",
            "Date du mouvement": "wamasysApp.equipmentParc.text.movement_date",
            "Date d’acquisition": "wamasysApp.equipmentParc.text.acquisition_date",
            "Date d’installation": "wamasysApp.equipmentParc.text.installation_date",
            "Derniers mouvements": "wamasysApp.equipmentParc.text.recent_movements",
            "Derniers mouvements (100 lignes maximum)": "wamasysApp.equipmentParc.text.recent_movements_up_to_100_lines",
            "Dernière collecte": "wamasysApp.equipmentParc.text.last_inventory_collection",
            "Dernière observation": "wamasysApp.equipmentParc.text.last_observed",
            "Dernière remontée": "wamasysApp.equipmentParc.text.last_report",
            "Dernière réception": "wamasysApp.equipmentParc.text.last_received",
            "Des champs obligatoires sont manquants ou leur format est incorrect.": "wamasysApp.equipmentParc.text.required_fields_are_missing_or_incorrectly_formatted",
            "Description": "wamasysApp.equipmentParc.text.description",
            "Destination": "wamasysApp.equipmentParc.text.destination",
            "Destination (transfert uniquement)": "wamasysApp.equipmentParc.text.destination_transfers_only",
            "Destination / chantier": "wamasysApp.equipmentParc.text.destination_work_site",
            "Disponibles uniquement": "wamasysApp.equipmentParc.text.available_only",
            "Définir un seuil": "wamasysApp.equipmentParc.text.set_a_threshold",
            "Définir un seuil d'alerte": "wamasysApp.equipmentParc.text.set_a_low_stock_alert",
            "Définir un seuil de stock": "wamasysApp.equipmentParc.text.set_a_stock_threshold",
            "Dépôt ou magasin": "wamasysApp.equipmentParc.text.depot_or_warehouse",
            "Désignation": "wamasysApp.equipmentParc.text.description_156",
            "Désignation (obligatoire)": "wamasysApp.equipmentParc.text.description_required",
            "Désignation, code ou numéro de série": "wamasysApp.equipmentParc.text.description_code_or_serial_number",
            "Désélectionner les résultats": "wamasysApp.equipmentParc.text.deselect_results",
            "Détenteur": "wamasysApp.equipmentParc.text.current_holder",
            "Empreinte indisponible.": "wamasysApp.equipmentParc.text.hash_unavailable",
            "Emprunter / affecter": "wamasysApp.equipmentParc.text.borrow_allocate",
            "En cours": "wamasysApp.equipmentParc.text.in_progress",
            "En maintenance": "wamasysApp.equipmentParc.text.under_maintenance",
            "En service": "wamasysApp.equipmentParc.text.in_service",
            "Endommagé": "wamasysApp.equipmentParc.text.damaged",
            "Enregistrement confirmé": "wamasysApp.equipmentParc.text.saved_successfully",
            "Enregistrement confirmé par le serveur.": "wamasysApp.equipmentParc.text.saved_and_confirmed_by_the_server",
            "Enregistrement en cours…": "wamasysApp.equipmentParc.text.saving",
            "Enregistrement inaccessible.": "wamasysApp.equipmentParc.text.record_is_inaccessible",
            "Enregistrement…": "wamasysApp.equipmentParc.text.saving_172",
            "Enregistrer la maintenance réalisée": "wamasysApp.equipmentParc.text.record_completed_maintenance",
            "Enregistrer la réalisation": "wamasysApp.equipmentParc.text.record_completion",
            "Enregistrer le retour": "wamasysApp.equipmentParc.text.record_return",
            "Enregistrer un mouvement": "wamasysApp.equipmentParc.text.record_a_movement",
            "Enregistrer un mouvement de stock": "wamasysApp.equipmentParc.text.record_a_stock_movement",
            "Enregistrez le retour du matériel avant de changer sa zone de rattachement.": "wamasysApp.equipmentParc.text.return_the_equipment_before_changing_its_assigned_area",
            "Enrôler le collecteur": "wamasysApp.equipmentParc.text.enrol_collector",
            "Enrôler ou renouveler le collecteur": "wamasysApp.equipmentParc.text.enrol_or_renew_collector",
            "Entrée": "wamasysApp.equipmentParc.text.incoming",
            "Entrée en stock": "wamasysApp.equipmentParc.text.stock_receipt",
            "Erreur": "wamasysApp.equipmentParc.text.error",
            "Espace libre (Gio)": "wamasysApp.equipmentParc.text.free_space_gib",
            "Exemplaires par article": "wamasysApp.equipmentParc.text.copies_per_item",
            "Famille": "wamasysApp.equipmentParc.text.family",
            "Fermer": "wamasysApp.equipmentParc.text.close",
            "Fiche d’origine": "wamasysApp.equipmentParc.text.original_record",
            "Fiche informatique absente.": "wamasysApp.equipmentParc.text.it_record_is_missing",
            "Fiche résumée : les détails seront chargés avec Internet.": "wamasysApp.equipmentParc.text.summary_record_connect_to_load_the_details",
            "GPS : ": "wamasysApp.equipmentParc.text.gps",
            "Gestion": "wamasysApp.equipmentParc.text.management",
            "Gestion du mot de passe": "wamasysApp.equipmentParc.text.password_management",
            "Historique": "wamasysApp.equipmentParc.text.historic",
            "Historique des accès aux références": "wamasysApp.equipmentParc.text.reference_access_history",
            "Hors connexion · consultation seule": "wamasysApp.equipmentParc.text.offline_read_only",
            "Hors service": "wamasysApp.equipmentParc.text.out_of_service",
            "IP vue du serveur": "wamasysApp.equipmentParc.text.ip_observed_by_the_server",
            "Identifiant Windows (SID)": "wamasysApp.equipmentParc.text.windows_identifier_sid",
            "Identifiant d'opération incorrect.": "wamasysApp.equipmentParc.text.invalid_operation_identifier",
            "Importer ou actualiser": "wamasysApp.equipmentParc.text.import_or_refresh",
            "Importer ou actualiser l’appareil Android": "wamasysApp.equipmentParc.text.import_or_refresh_android_device",
            "Impossible de conserver le reçu du mouvement. Aucun envoi n'a été effectué.": "wamasysApp.equipmentParc.text.the_movement_receipt_could_not_be_saved_nothing_was_sent",
            "Impression sur papier A4, trois colonnes. Vérifiez l’échelle à 100 % et désactivez les en-têtes et pieds de page du navigateur.": "wamasysApp.equipmentParc.text.print_on_a4_paper_in_three_columns_use_100_scale",
            "Inactive": "wamasysApp.equipmentParc.text.inactive",
            "Informatique": "wamasysApp.equipmentParc.text.it_equipment",
            "Installation": "wamasysApp.equipmentParc.text.installation",
            "Installation : ": "wamasysApp.equipmentParc.text.installed",
            "Installation Android inaccessible.": "wamasysApp.equipmentParc.text.android_installation_is_inaccessible",
            "Installation active": "wamasysApp.equipmentParc.text.installation_active",
            "Installations déjà connues de Wamasys. L’import crée une fiche informatique ; une installation déjà importée est actualisée.": "wamasysApp.equipmentParc.text.devices_already_registered_in_wamasys_importing_creates_an_it_record",
            "Interface": "wamasysApp.equipmentParc.text.interface",
            "Interface réseau vide.": "wamasysApp.equipmentParc.text.empty_network_interface",
            "Intervention de maintenance validée": "wamasysApp.equipmentParc.text.validated_maintenance_work_order",
            "Intervention de maintenance validée (obligatoire)": "wamasysApp.equipmentParc.text.validated_maintenance_work_order_required",
            "Interventions": "wamasysApp.equipmentParc.text.work_orders",
            "Inventaire trop volumineux.": "wamasysApp.equipmentParc.text.inventory_report_is_too_large",
            "Jeton d'inventaire manquant ou incorrect.": "wamasysApp.equipmentParc.text.inventory_token_is_missing_or_invalid",
            "Jeton du collecteur": "wamasysApp.equipmentParc.text.collector_token",
            "L'action n'a pas été confirmée. Actualisez avant de réessayer.": "wamasysApp.equipmentParc.text.the_action_was_not_confirmed_refresh_before_trying_again",
            "L'action n'a pas été confirmée. Actualisez la fiche avant de renouveler une modification.": "wamasysApp.equipmentParc.text.the_action_was_not_confirmed_refresh_the_record_before_submitting",
            "L'actualisation du parc Android a échoué ; l'enregistrement principal est conservé.": "wamasysApp.equipmentParc.text.the_android_inventory_refresh_failed_the_original_registration_is_retained",
            "L'affectation a été modifiée. Rechargez la fiche.": "wamasysApp.equipmentParc.text.the_allocation_has_changed_reload_the_record",
            "L'agence propriétaire est obligatoire.": "wamasysApp.equipmentParc.text.the_owning_agency_is_required",
            "L'area doit appartenir à l'agence sélectionnée.": "wamasysApp.equipmentParc.text.the_area_must_belong_to_the_selected_agency",
            "L'article de cette étiquette n'est pas accessible dans votre zone actuelle.": "wamasysApp.equipmentParc.text.the_labelled_item_is_not_accessible_in_your_current_area",
            "L'historique n'a pas pu être enregistré.": "wamasysApp.equipmentParc.text.the_history_could_not_be_saved",
            "L'horloge de l'appareil est trop avancée.": "wamasysApp.equipmentParc.text.the_device_clock_is_too_far_ahead",
            "L'intervention doit être validée avant de clôturer la maintenance.": "wamasysApp.equipmentParc.text.validate_the_work_order_before_completing_maintenance",
            "L'opération doit contenir de 1 à 100 lignes.": "wamasysApp.equipmentParc.text.an_operation_must_contain_between_1_and_100_lines",
            "L'opération n'a pas pu être préparée.": "wamasysApp.equipmentParc.text.the_operation_could_not_be_prepared",
            "L'unité d'un article ayant des mouvements ne peut plus être modifiée.": "wamasysApp.equipmentParc.text.the_unit_cannot_be_changed_after_the_item_has_stock",
            "L'utilisateur doit être rattaché à une area pour importer cet appareil.": "wamasysApp.equipmentParc.text.the_user_must_belong_to_an_area_to_import_this",
            "L'équipement et l'intervention doivent appartenir à la même agence.": "wamasysApp.equipmentParc.text.the_equipment_and_work_order_must_belong_to_the_same",
            "L'équipement n'est pas disponible pour une affectation.": "wamasysApp.equipmentParc.text.this_equipment_is_not_available_for_allocation",
            "L'événement doit appartenir à l'agence propriétaire de l'équipement.": "wamasysApp.equipmentParc.text.the_event_must_belong_to_the_equipment_s_owning_agency",
            "L'événement doit appartenir à l'area de l'équipement.": "wamasysApp.equipmentParc.text.the_event_must_belong_to_the_equipment_s_area",
            "La date de collecte est obligatoire.": "wamasysApp.equipmentParc.text.the_collection_date_is_required",
            "La date de retour ou l'état est incorrect.": "wamasysApp.equipmentParc.text.the_return_date_or_condition_is_invalid",
            "La date de retour prévue est obligatoire pour un prêt.": "wamasysApp.equipmentParc.text.an_expected_return_date_is_required_for_a_loan",
            "La date de réalisation ne peut pas être future.": "wamasysApp.equipmentParc.text.the_completion_date_cannot_be_in_the_future",
            "La date de sortie ne peut pas être future.": "wamasysApp.equipmentParc.text.the_issue_date_cannot_be_in_the_future",
            "La date doit être au format AAAA-MM-JJ.": "wamasysApp.equipmentParc.text.use_the_yyyy_mm_dd_date_format",
            "La date du mouvement ne peut pas être future.": "wamasysApp.equipmentParc.text.the_movement_date_cannot_be_in_the_future",
            "La famille d'un équipement existant ne peut pas être modifiée.": "wamasysApp.equipmentParc.text.the_family_of_existing_equipment_cannot_be_changed",
            "La fiche sera rattachée à l’area principale de l’utilisateur. Les prochaines remontées Android actualiseront les informations de l’appareil déjà importé.": "wamasysApp.equipmentParc.text.the_record_will_be_assigned_to_the_user_s_primary",
            "La fiche sera reliée à l’événement d’origine. Son Agence, son area et ses coordonnées seront repris ; les réponses et les pièces jointes existantes seront conservées.": "wamasysApp.equipmentParc.text.the_record_will_remain_linked_to_the_original_event_its",
            "La latitude et la longitude doivent être renseignées ensemble.": "wamasysApp.equipmentParc.text.enter_latitude_and_longitude_together",
            "La liste reçue est incomplète ou incohérente.": "wamasysApp.equipmentParc.text.the_received_list_is_incomplete_or_inconsistent",
            "La pagination a changé. Réessayez l'actualisation.": "wamasysApp.equipmentParc.text.pagination_has_changed_try_refreshing_again",
            "La prochaine échéance doit suivre la réalisation et l'échéance traitée.": "wamasysApp.equipmentParc.text.the_next_due_date_must_follow_both_completion_and_the",
            "La quantité doit être positive, avec au maximum quatre décimales.": "wamasysApp.equipmentParc.text.enter_a_positive_quantity_with_up_to_four_decimal_places",
            "La quantité doit être strictement positive avec au maximum quatre décimales.": "wamasysApp.equipmentParc.text.the_quantity_must_be_greater_than_zero_with_up_to",
            "La référence du coffre ou de LAPS est obligatoire.": "wamasysApp.equipmentParc.text.a_vault_or_laps_reference_is_required",
            "La réponse de consultation ne correspond pas au périmètre courant.": "wamasysApp.equipmentParc.text.the_response_does_not_match_the_current_scope",
            "La session doit être renouvelée avant de consulter les équipements.": "wamasysApp.equipmentParc.text.renew_your_session_before_opening_the_equipment_register",
            "La session ou le périmètre a changé. Rouvrez le module Équipements.": "wamasysApp.equipmentParc.text.your_session_or_scope_has_changed_reopen_equipment",
            "La sortie du parc précède l'installation.": "wamasysApp.equipmentParc.text.the_retirement_date_precedes_installation",
            "La source d'inventaire ne correspond pas à l'enrôlement.": "wamasysApp.equipmentParc.text.the_inventory_source_does_not_match_the_enrolment",
            "Laissez la périodicité vide pour une opération ponctuelle.": "wamasysApp.equipmentParc.text.leave_the_interval_blank_for_a_one_off_task",
            "Le bénéficiaire est obligatoire.": "wamasysApp.equipmentParc.text.the_beneficiary_is_required",
            "Le changement de zone est réservé aux administrateurs.": "wamasysApp.equipmentParc.text.only_administrators_can_change_the_assigned_area",
            "Le changement de zone est réservé aux administrateurs. Terminez d’abord le prêt en cours et choisissez un lieu de la nouvelle zone. Les interventions historiques conservent leur zone d’origine.": "wamasysApp.equipmentParc.text.only_administrators_can_change_the_area_end_any_open_loan",
            "Le code d'inventaire et la désignation sont obligatoires.": "wamasysApp.equipmentParc.text.the_inventory_code_and_description_are_required",
            "Le code de type ANDROID est déjà utilisé pour une autre famille.": "wamasysApp.equipmentParc.text.the_android_type_code_is_already_used_for_another_family",
            "Le code et le libellé sont obligatoires.": "wamasysApp.equipmentParc.text.the_code_and_label_are_required",
            "Le code, le libellé et l'unité sont obligatoires.": "wamasysApp.equipmentParc.text.the_code_label_and_unit_are_required",
            "Le compte a été modifié. Rechargez la fiche.": "wamasysApp.equipmentParc.text.the_account_has_changed_reload_the_record",
            "Le descriptif des disques est incorrect.": "wamasysApp.equipmentParc.text.invalid_disk_details",
            "Le jeton actuel cessera d’être accepté. Vous pourrez ensuite enrôler un nouveau collecteur.": "wamasysApp.equipmentParc.text.the_current_token_will_no_longer_be_accepted_you_can",
            "Le lieu de destination est archivé.": "wamasysApp.equipmentParc.text.the_destination_location_is_archived",
            "Le lieu de rangement sera effacé. Les événements historiques conservent leur zone d’origine.": "wamasysApp.equipmentParc.text.the_storage_location_will_be_cleared_historical_events_retain_their",
            "Le lieu de retour est incompatible avec le périmètre de l'équipement.": "wamasysApp.equipmentParc.text.the_return_location_is_outside_the_equipment_s_scope",
            "Le lieu doit appartenir au même périmètre que l'équipement.": "wamasysApp.equipmentParc.text.the_location_must_have_the_same_scope_as_the_equipment",
            "Le mode de gestion est obligatoire.": "wamasysApp.equipmentParc.text.the_management_mode_is_required",
            "Le module ou vos droits ne permettent plus cet accès.": "wamasysApp.equipmentParc.text.the_module_or_your_permissions_no_longer_allow_this_access",
            "Le module Équipements doit être activé dans les paramètres de l’organisation.": "wamasysApp.equipmentParc.text.enable_equipment_in_the_organisation_settings_first",
            "Le module Équipements n'est pas activé pour cette organisation.": "wamasysApp.equipmentParc.text.equipment_is_not_enabled_for_this_organisation",
            "Le module Équipements n'est pas disponible pour cette connexion.": "wamasysApp.equipmentParc.text.equipment_is_not_available_for_this_connection",
            "Le motif de la contre-passation est obligatoire.": "wamasysApp.equipmentParc.text.a_reason_is_required_to_reverse_an_operation",
            "Le nom du compte est obligatoire.": "wamasysApp.equipmentParc.text.the_account_name_is_required",
            "Le paramétrage des types est réservé aux administrateurs.": "wamasysApp.equipmentParc.text.only_administrators_can_configure_equipment_types",
            "Le plan de maintenance a changé ou est inactif.": "wamasysApp.equipmentParc.text.the_maintenance_plan_has_changed_or_is_inactive",
            "Le périmètre d'un lieu existant ne peut pas être modifié.": "wamasysApp.equipmentParc.text.the_scope_of_an_existing_location_cannot_be_changed",
            "Le périmètre du serveur a changé.": "wamasysApp.equipmentParc.text.the_server_scope_has_changed",
            "Le périmètre ne peut pas être préparé.": "wamasysApp.equipmentParc.text.the_scope_could_not_be_prepared",
            "Le retour prévu précède la sortie.": "wamasysApp.equipmentParc.text.the_expected_return_precedes_the_issue_date",
            "Le seuil doit être positif ou nul avec au maximum quatre décimales.": "wamasysApp.equipmentParc.text.the_threshold_must_be_zero_or_positive_with_up_to",
            "Lecture de la carte locale…": "wamasysApp.equipmentParc.text.loading_the_cached_map",
            "Lecture de la copie locale…": "wamasysApp.equipmentParc.text.loading_the_cached_copy",
            "Lecture de la dernière copie…": "wamasysApp.equipmentParc.text.loading_the_latest_cached_copy",
            "Lecture de la fiche locale…": "wamasysApp.equipmentParc.text.loading_the_cached_record",
            "Lecture du stock local…": "wamasysApp.equipmentParc.text.loading_cached_stock",
            "Les 100 dernières lignes du périmètre sont affichées. Une contre-passation compense toute l’opération.": "wamasysApp.equipmentParc.text.the_last_100_movement_lines_in_this_scope_are_shown",
            "Les 100 événements les plus récents du périmètre sont proposés. Le formulaire et ses pièces jointes restent accessibles depuis la fiche.": "wamasysApp.equipmentParc.text.the_latest_100_events_in_this_scope_are_available_their",
            "Les adresses ci-dessous correspondent au dernier inventaire complet reçu. Elles peuvent avoir changé depuis.": "wamasysApp.equipmentParc.text.these_addresses_come_from_the_last_complete_inventory_report_they",
            "Les codes-barres ouvrent la fiche dans l’application Android. Sélectionnez les articles, choisissez le nombre d’exemplaires, puis affichez et imprimez les étiquettes.": "wamasysApp.equipmentParc.text.barcodes_open_the_record_in_the_android_app_select_items",
            "Les disques doivent être fournis sous forme de tableau JSON.": "wamasysApp.equipmentParc.text.provide_disk_details_as_a_json_array",
            "Les données ont changé ou cette référence est déjà utilisée. Rechargez la fiche et vérifiez les codes.": "wamasysApp.equipmentParc.text.the_data_has_changed_or_this_reference_is_already_used",
            "Les données ont changé. Actualisez la fiche avant de réessayer.": "wamasysApp.equipmentParc.text.the_data_has_changed_refresh_the_record_before_trying_again",
            "Les données ont été modifiées. Rechargez la fiche avant de réessayer.": "wamasysApp.equipmentParc.text.the_data_has_changed_reload_the_record_before_trying_again",
            "Les lieux source et destination du transfert doivent être différents.": "wamasysApp.equipmentParc.text.the_source_and_destination_must_be_different",
            "Les modifications, prêts, retours et maintenances nécessitent Internet.": "wamasysApp.equipmentParc.text.an_internet_connection_is_required_for_changes_loans_returns_and",
            "Les mots de passe restent dans votre coffre externe ou dans Windows LAPS. Wamasys conserve uniquement leurs références.": "wamasysApp.equipmentParc.text.passwords_remain_in_your_external_vault_or_windows_laps_wamasys",
            "Les mouvements validés sont conservés. Pour corriger une erreur, utilisez une contre-passation.": "wamasysApp.equipmentParc.text.posted_movements_are_retained_use_a_reversal_to_correct_an",
            "Les quantités sont celles de la copie datée. Toute modification demande Internet.": "wamasysApp.equipmentParc.text.these_quantities_are_from_the_dated_cached_copy_an_internet",
            "Les étiquettes n'ont pas pu être générées.": "wamasysApp.equipmentParc.text.the_labels_could_not_be_generated",
            "Les étiquettes n’ont pas pu être chargées.": "wamasysApp.equipmentParc.text.the_labels_could_not_be_loaded",
            "Libellé": "wamasysApp.equipmentParc.text.wording",
            "Libellé (obligatoire)": "wamasysApp.equipmentParc.text.label_required",
            "Libellé ou périodicité incorrects.": "wamasysApp.equipmentParc.text.invalid_label_or_frequency",
            "Lier une intervention": "wamasysApp.equipmentParc.text.link_an_intervention",
            "Lieu": "wamasysApp.equipmentParc.text.location",
            "Lieu / origine (obligatoire)": "wamasysApp.equipmentParc.text.location_source_required",
            "Lieu : ": "wamasysApp.equipmentParc.text.location_315",
            "Lieu actif": "wamasysApp.equipmentParc.text.active_location",
            "Lieu de destination": "wamasysApp.equipmentParc.text.destination_location",
            "Lieu de rangement": "wamasysApp.equipmentParc.text.storage_location",
            "Lieu de retour": "wamasysApp.equipmentParc.text.return_location",
            "Lieu destination": "wamasysApp.equipmentParc.text.destination_location_320",
            "Lieu du stock ou lieu source": "wamasysApp.equipmentParc.text.stock_location_or_source_location",
            "Liste des équipements": "wamasysApp.equipmentParc.text.equipment_list",
            "Localisation / destination": "wamasysApp.equipmentParc.text.location_destination",
            "Localisation sur la carte": "wamasysApp.equipmentParc.text.location_on_the_map",
            "L’opération a échoué. Vérifiez les données et réessayez.": "wamasysApp.equipmentParc.text.the_operation_failed_check_the_information_and_try_again",
            "L’opération a été refusée. Vérifiez les champs et rechargez la fiche si nécessaire.": "wamasysApp.equipmentParc.text.the_operation_was_refused_check_the_fields_and_reload_the",
            "Maintenance": "wamasysApp.equipmentParc.text.maintenance",
            "Maintenance et interventions": "wamasysApp.equipmentParc.text.maintenance_and_interventions",
            "Maintenance prévue": "wamasysApp.equipmentParc.text.scheduled_maintenance",
            "Maintenance réalisée le ": "wamasysApp.equipmentParc.text.maintenance_completed_on",
            "Maintenance à réaliser aujourd’hui ou en retard": "wamasysApp.equipmentParc.text.maintenance_due_today_or_overdue",
            "Marque / modèle": "wamasysApp.equipmentParc.text.brand_model",
            "Mise à jour de la fiche équipement.": "wamasysApp.equipmentParc.text.equipment_record_updated",
            "Modification": "wamasysApp.equipmentParc.text.update",
            "Modification de référence": "wamasysApp.equipmentParc.text.reference_updated",
            "Modifier": "wamasysApp.equipmentParc.text.edit",
            "Modifier la fiche": "wamasysApp.equipmentParc.text.edit_record",
            "Modifier la maintenance prévue": "wamasysApp.equipmentParc.text.edit_scheduled_maintenance",
            "Modifier le lieu": "wamasysApp.equipmentParc.text.edit_location",
            "Modifier le seuil": "wamasysApp.equipmentParc.text.edit_threshold",
            "Modifier le type": "wamasysApp.equipmentParc.text.edit_type",
            "Modifier l’article": "wamasysApp.equipmentParc.text.edit_item",
            "Modifier l’équipement": "wamasysApp.equipmentParc.text.edit_equipment",
            "Modifier état, statut, lieu ou fiche": "wamasysApp.equipmentParc.text.edit_condition_status_location_or_record",
            "Modèle": "wamasysApp.equipmentParc.text.model",
            "Motif (obligatoire pour un ajustement)": "wamasysApp.equipmentParc.text.reason_required_for_an_adjustment",
            "Motif (obligatoire). Tous les mouvements seront inversés.": "wamasysApp.equipmentParc.text.reason_required_all_movements_will_be_reversed",
            "Motif de correction": "wamasysApp.equipmentParc.text.correction_reason",
            "Motif ou observations": "wamasysApp.equipmentParc.text.reason_or_comments",
            "Mouvement de consommable": "wamasysApp.equipmentParc.text.consumable_movement",
            "Mémoire": "wamasysApp.equipmentParc.text.memory",
            "Nature": "wamasysApp.equipmentParc.text.category",
            "Nature du lien": "wamasysApp.equipmentParc.text.link_type",
            "Nature du lieu": "wamasysApp.equipmentParc.text.location_type",
            "Nom du compte": "wamasysApp.equipmentParc.text.account_name",
            "Nom du poste": "wamasysApp.equipmentParc.text.computer_name",
            "Non": "wamasysApp.equipmentParc.text.no",
            "Non évalué": "wamasysApp.equipmentParc.text.not_assessed",
            "Nouvelle zone": "wamasysApp.equipmentParc.text.new_area",
            "Numéro de série": "wamasysApp.equipmentParc.text.serial_number_360",
            "Observations de retour": "wamasysApp.equipmentParc.text.return_comments",
            "Observations de sortie": "wamasysApp.equipmentParc.text.checkout_comments",
            "Opération": "wamasysApp.equipmentParc.text.operation",
            "Opération à réaliser": "wamasysApp.equipmentParc.text.operation_to_perform",
            "Oui": "wamasysApp.equipmentParc.text.yes",
            "Outillage": "wamasysApp.equipmentParc.text.tools",
            "Ouvrir la fiche": "wamasysApp.equipmentParc.text.open_record",
            "Page": "wamasysApp.equipmentParc.text.page",
            "Pagination incorrecte.": "wamasysApp.equipmentParc.text.invalid_pagination",
            "Panne": "wamasysApp.equipmentParc.text.breakdown",
            "Parc informatique": "wamasysApp.equipmentParc.text.it_inventory",
            "Passerelle": "wamasysApp.equipmentParc.text.gateway",
            "Perdu": "wamasysApp.equipmentParc.text.lost",
            "Personne ou équipe bénéficiaire": "wamasysApp.equipmentParc.text.recipient_or_team",
            "Plan actif": "wamasysApp.equipmentParc.text.active_plan",
            "Plan incompatible.": "wamasysApp.equipmentParc.text.incompatible_plan",
            "Planifier une maintenance": "wamasysApp.equipmentParc.text.schedule_maintenance",
            "Plateforme": "wamasysApp.equipmentParc.text.platform",
            "Plateforme de collecteur incorrecte.": "wamasysApp.equipmentParc.text.invalid_collector_platform",
            "Ponctuelle": "wamasysApp.equipmentParc.text.one_off",
            "Processeur": "wamasysApp.equipmentParc.text.processor",
            "Prochaine échéance": "wamasysApp.equipmentParc.text.next_due_date",
            "Prochaine échéance (obligatoire)": "wamasysApp.equipmentParc.text.next_due_date_required",
            "Précisez le motif de l'ajustement.": "wamasysApp.equipmentParc.text.please_specify_the_adjustment_reason",
            "Précédent": "wamasysApp.equipmentParc.text.previous",
            "Préfixe": "wamasysApp.equipmentParc.text.prefix",
            "Préfixe réseau incorrect.": "wamasysApp.equipmentParc.text.invalid_network_prefix",
            "Prévoir une maintenance": "wamasysApp.equipmentParc.text.schedule_maintenance_388",
            "Prêt": "wamasysApp.equipmentParc.text.loan",
            "Prêt temporaire": "wamasysApp.equipmentParc.text.temporary_loan",
            "Prêts et affectations": "wamasysApp.equipmentParc.text.loans_and_assignments",
            "Périmètre de connexion indisponible.": "wamasysApp.equipmentParc.text.connection_scope_unavailable",
            "Périodicité": "wamasysApp.equipmentParc.text.frequency",
            "Périodicité en mois": "wamasysApp.equipmentParc.text.frequency_in_months",
            "Périodicité en mois (vide : ponctuelle)": "wamasysApp.equipmentParc.text.frequency_in_months_empty_one_off",
            "Quantité": "wamasysApp.equipmentParc.text.quantity",
            "Quantité dans l’unité de l’article": "wamasysApp.equipmentParc.text.quantity_in_the_item_s_unit",
            "Quantité minimale (0 pour supprimer l'alerte)": "wamasysApp.equipmentParc.text.minimum_quantity_0_to_disable_the_alert",
            "Quantité positive (jusqu'à 4 décimales)": "wamasysApp.equipmentParc.text.positive_quantity_up_to_4_decimal_places",
            "Quantités par lieu": "wamasysApp.equipmentParc.text.quantities_by_location",
            "Rangement": "wamasysApp.equipmentParc.text.storage_address",
            "Rangement : ": "wamasysApp.equipmentParc.text.storage",
            "Rangement et seuil de stock": "wamasysApp.equipmentParc.text.storage_address_and_stock_threshold",
            "Rangée": "wamasysApp.equipmentParc.text.row",
            "Rayonnage": "wamasysApp.equipmentParc.text.rack",
            "Recherche": "wamasysApp.equipmentParc.text.search",
            "Recherche de la fiche…": "wamasysApp.equipmentParc.text.looking_up_the_record",
            "Recherche des interventions…": "wamasysApp.equipmentParc.text.looking_up_interventions",
            "Rechercher": "wamasysApp.equipmentParc.text.search_409",
            "Rechercher : désignation, code, série…": "wamasysApp.equipmentParc.text.search_name_code_serial_number",
            "Rechercher un équipement ou un consommable": "wamasysApp.equipmentParc.text.search_for_equipment_or_a_consumable",
            "Refus": "wamasysApp.equipmentParc.text.denied",
            "Relier une intervention": "wamasysApp.equipmentParc.text.link_an_intervention_413",
            "Reliez d’abord un événement de maintenance validé. La périodicité calcule la prochaine échéance si vous ne la renseignez pas.": "wamasysApp.equipmentParc.text.first_link_a_validated_maintenance_event_the_frequency_determines_the",
            "Rendu le ": "wamasysApp.equipmentParc.text.returned_on",
            "Renseignez ensemble latitude et longitude.": "wamasysApp.equipmentParc.text.enter_both_latitude_and_longitude",
            "Renseignez les champs obligatoires.": "wamasysApp.equipmentParc.text.fill_in_the_required_fields",
            "Renseignez un identifiant ou un lien de référence. Aucun mot de passe ne doit être saisi dans Wamasys.": "wamasysApp.equipmentParc.text.enter_a_reference_id_or_link_do_not_enter_any",
            "Retour de l'équipement": "wamasysApp.equipmentParc.text.return_equipment",
            "Retour de l'équipement.": "wamasysApp.equipmentParc.text.equipment_returned",
            "Retour effectif": "wamasysApp.equipmentParc.text.actual_return",
            "Retour en stock": "wamasysApp.equipmentParc.text.return_to_stock",
            "Retour prévu": "wamasysApp.equipmentParc.text.expected_return",
            "Retour prévu (obligatoire pour un prêt)": "wamasysApp.equipmentParc.text.expected_return_required_for_a_loan",
            "Réalisation": "wamasysApp.equipmentParc.text.completion",
            "Réalisation (obligatoire)": "wamasysApp.equipmentParc.text.completion_required",
            "Réalisations": "wamasysApp.equipmentParc.text.completions",
            "Réception": "wamasysApp.equipmentParc.text.receipt",
            "Référence dans le coffre ou dans LAPS": "wamasysApp.equipmentParc.text.vault_or_laps_reference",
            "Référence de gestion du compte ": "wamasysApp.equipmentParc.text.management_reference_for_account",
            "Résultat": "wamasysApp.equipmentParc.text.result",
            "Réussite": "wamasysApp.equipmentParc.text.success",
            "Révoquer le collecteur": "wamasysApp.equipmentParc.text.revoke_collector",
            "SDK ": "wamasysApp.equipmentParc.text.sdk",
            "Saisir ou lire le code avec un lecteur": "wamasysApp.equipmentParc.text.enter_a_code_or_use_a_barcode_reader",
            "Sans affectation ouverte": "wamasysApp.equipmentParc.text.no_open_assignment",
            "Sans référence": "wamasysApp.equipmentParc.text.no_reference",
            "Scanner un code-barres": "wamasysApp.equipmentParc.text.scan_a_barcode",
            "Sens (ajustement uniquement)": "wamasysApp.equipmentParc.text.direction_adjustment_only",
            "Sens de l’ajustement": "wamasysApp.equipmentParc.text.adjustment_direction",
            "Seuil": "wamasysApp.equipmentParc.text.threshold",
            "Seuil d’alerte": "wamasysApp.equipmentParc.text.alert_threshold",
            "Site terrain": "wamasysApp.equipmentParc.text.field_site",
            "Sorti du parc": "wamasysApp.equipmentParc.text.retired",
            "Sortie": "wamasysApp.equipmentParc.text.stock_out",
            "Sortie de l'équipement": "wamasysApp.equipmentParc.text.equipment_checkout",
            "Sortie du parc": "wamasysApp.equipmentParc.text.retirement",
            "Sortie du parc (obligatoire si sorti)": "wamasysApp.equipmentParc.text.retirement_date_required_if_retired",
            "Sortie ou affectation de l'équipement.": "wamasysApp.equipmentParc.text.equipment_checked_out_or_assigned",
            "Sortir ou affecter le matériel": "wamasysApp.equipmentParc.text.check_out_or_assign_equipment",
            "Sous le seuil": "wamasysApp.equipmentParc.text.below_threshold",
            "Statut": "wamasysApp.equipmentParc.text.status",
            "Statut opérationnel": "wamasysApp.equipmentParc.text.operational_status",
            "Stock initial": "wamasysApp.equipmentParc.text.initial_stock",
            "Stock insuffisant : l'opération entière a été refusée.": "wamasysApp.equipmentParc.text.insufficient_stock_the_entire_operation_was_refused",
            "Stock par lieu": "wamasysApp.equipmentParc.text.stock_by_location",
            "Stocks": "wamasysApp.equipmentParc.text.stock",
            "Suivant": "wamasysApp.equipmentParc.text.next",
            "Suppression de référence": "wamasysApp.equipmentParc.text.reference_deleted",
            "Système": "wamasysApp.equipmentParc.text.system",
            "Sélection d'étiquettes incorrecte.": "wamasysApp.equipmentParc.text.invalid_label_selection",
            "Sélectionner les résultats": "wamasysApp.equipmentParc.text.select_results",
            "Sélectionnez au maximum 200 équipements et 200 consommables, dans la limite de 1 000 étiquettes.": "wamasysApp.equipmentParc.text.select_up_to_200_equipment_items_and_200_consumables_with",
            "Sélectionnez entre 1 et 1 000 étiquettes par impression.": "wamasysApp.equipmentParc.text.select_between_1_and_1_000_labels_per_print_run",
            "Sélectionnez une valeur.": "wamasysApp.equipmentParc.text.select_a_value",
            "Terminez l'affectation en cours avant de changer le statut opérationnel.": "wamasysApp.equipmentParc.text.complete_the_current_assignment_before_changing_the_operational_status",
            "Terminée / inactive": "wamasysApp.equipmentParc.text.completed_inactive",
            "Tous": "wamasysApp.equipmentParc.text.all",
            "Tous les consommables": "wamasysApp.equipmentParc.text.all_consumables",
            "Tous les mouvements de cette opération seront compensés. L’opération sera refusée si elle rend un stock négatif.": "wamasysApp.equipmentParc.text.all_movements_in_this_operation_will_be_compensated_the_operation",
            "Tous les mouvements utilisent la même unité. Cette unité ne pourra plus changer après le premier mouvement.": "wamasysApp.equipmentParc.text.all_movements_use_the_same_unit_this_unit_cannot_change",
            "Toutes": "wamasysApp.equipmentParc.text.all_472",
            "Toutes les familles": "wamasysApp.equipmentParc.text.all_families",
            "Transfert": "wamasysApp.equipmentParc.text.transfer",
            "Trop d'adresses réseau.": "wamasysApp.equipmentParc.text.too_many_network_addresses",
            "Type": "wamasysApp.equipmentParc.text.type",
            "Type (obligatoire)": "wamasysApp.equipmentParc.text.type_required",
            "Type actif": "wamasysApp.equipmentParc.text.active_type",
            "Type d’affectation": "wamasysApp.equipmentParc.text.assignment_type",
            "Types d’équipements": "wamasysApp.equipmentParc.text.equipment_types",
            "Types et lieux": "wamasysApp.equipmentParc.text.types_and_locations",
            "Télécharger le script Windows": "wamasysApp.equipmentParc.text.download_windows_script",
            "Télécharger l’installateur": "wamasysApp.equipmentParc.text.download_installer",
            "Un article sélectionné est archivé.": "wamasysApp.equipmentParc.text.a_selected_item_is_archived",
            "Un compte administrateur est présent plusieurs fois.": "wamasysApp.equipmentParc.text.an_administrator_account_is_duplicated",
            "Un lieu sélectionné est archivé.": "wamasysApp.equipmentParc.text.a_selected_location_is_archived",
            "Un nouvel enrôlement révoque le précédent. Le collecteur met à jour uniquement la fiche de cet équipement.": "wamasysApp.equipmentParc.text.new_enrolment_revokes_the_previous_one_the_collector_updates_only",
            "Un stock initial ne peut être enregistré qu'avant tout mouvement de cet article dans ce lieu.": "wamasysApp.equipmentParc.text.initial_stock_can_only_be_entered_before_any_movement_of",
            "Un transfert doit équilibrer les entrées et les sorties de chaque article.": "wamasysApp.equipmentParc.text.a_transfer_must_balance_incoming_and_outgoing_quantities_for_each",
            "Un type utilisé ne peut plus changer de famille.": "wamasysApp.equipmentParc.text.a_type_in_use_cannot_change_family",
            "Une connexion Internet est nécessaire pour cette action.": "wamasysApp.equipmentParc.text.an_internet_connection_is_required_for_this_action",
            "Une consommation doit sortir du stock.": "wamasysApp.equipmentParc.text.consumption_must_remove_stock",
            "Une contre-passation ne peut pas être contre-passée.": "wamasysApp.equipmentParc.text.a_reversal_cannot_be_reversed",
            "Une interface réseau est présente plusieurs fois.": "wamasysApp.equipmentParc.text.a_network_interface_is_duplicated",
            "Une ligne de stock est présente plusieurs fois.": "wamasysApp.equipmentParc.text.a_stock_line_is_duplicated",
            "Une ligne de stock est vide.": "wamasysApp.equipmentParc.text.a_stock_line_is_empty",
            "Une sortie du parc doit avoir un statut et une date cohérents.": "wamasysApp.equipmentParc.text.retirement_must_have_a_consistent_status_and_date",
            "Unité": "wamasysApp.equipmentParc.text.unit",
            "Unité (obligatoire : pièce, litre…)": "wamasysApp.equipmentParc.text.unit_required_piece_litre",
            "Unité de stock": "wamasysApp.equipmentParc.text.stock_unit",
            "Utilisateur": "wamasysApp.equipmentParc.text.user",
            "Utilisateur inaccessible.": "wamasysApp.equipmentParc.text.user_unavailable",
            "Utilisateur non connecté.": "wamasysApp.equipmentParc.text.user_not_signed_in",
            "Utilisez l’action de contre-passation de l’opération d’origine.": "wamasysApp.equipmentParc.text.use_the_reversal_action_on_the_original_operation",
            "Validée": "wamasysApp.equipmentParc.text.validated",
            "Version Wamasys": "wamasysApp.equipmentParc.text.wamasys_version",
            "Voir la fiche et le code-barres": "wamasysApp.equipmentParc.text.view_record_and_barcode",
            "Voir le code-barres": "wamasysApp.equipmentParc.text.view_barcode",
            "Votre session a expiré. Reconnectez-vous.": "wamasysApp.equipmentParc.text.your_session_has_expired_sign_in_again",
            "Vous ne disposez pas du droit de consultation des équipements.": "wamasysApp.equipmentParc.text.you_do_not_have_permission_to_view_equipment",
            "Vous ne disposez pas du droit de modification des équipements.": "wamasysApp.equipmentParc.text.you_do_not_have_permission_to_edit_equipment",
            "Véhicule": "wamasysApp.equipmentParc.text.vehicle",
            "Vérifier et renvoyer le mouvement non confirmé": "wamasysApp.equipmentParc.text.check_and_resend_the_unconfirmed_movement",
            "Vérifiez ou renvoyez d'abord le mouvement de stock non confirmé.": "wamasysApp.equipmentParc.text.first_check_or_resend_the_unconfirmed_stock_movement",
            "Windows LAPS": "wamasysApp.equipmentParc.text.windows_laps",
            "article(s) sélectionné(s)": "wamasysApp.equipmentParc.text.item_s_selected",
            "pièce": "wamasysApp.equipmentParc.text.piece",
            "· ×": "wamasysApp.equipmentParc.text.symbol",
            "Échéance": "wamasysApp.equipmentParc.text.due_date",
            "Échéance : ": "wamasysApp.equipmentParc.text.due",
            "Échéance suivante": "wamasysApp.equipmentParc.text.next_due_date_521",
            "Échéance suivante (vide : calcul selon périodicité)": "wamasysApp.equipmentParc.text.next_due_date_empty_calculated_from_frequency",
            "Échéance traitée": "wamasysApp.equipmentParc.text.completed_due_date",
            "Équipement concerné": "wamasysApp.equipmentParc.text.related_equipment",
            "Équipement concerné (facultatif)": "wamasysApp.equipmentParc.text.related_equipment_optional",
            "Équipement terrain": "wamasysApp.equipmentParc.text.field_equipment",
            "Équipements": "wamasysApp.equipmentParc.text.equipment",
            "Équipements de terrain géolocalisés, hors éléments perdus ou sortis du parc. Sans Internet, le fond dépend des zones déjà consultées.": "wamasysApp.equipmentParc.text.geolocated_field_equipment_excluding_lost_and_retired_items_offline_map",
            "Équipements terrain, outillage, matériel informatique et consommables du périmètre autorisé.": "wamasysApp.equipmentParc.text.field_equipment_tools_it_devices_and_consumables_within_your_authorised",
            "Étagère": "wamasysApp.equipmentParc.text.shelf",
            "État": "wamasysApp.equipmentParc.text.status_531",
            "État au retour": "wamasysApp.equipmentParc.text.return_condition",
            "État moyen": "wamasysApp.equipmentParc.text.fair_condition",
            "État physique": "wamasysApp.equipmentParc.text.physical_condition",
            "État à la sortie": "wamasysApp.equipmentParc.text.checkout_condition",
            "Étiquettes": "wamasysApp.equipmentParc.text.labels",
            "Étiquettes et codes-barres": "wamasysApp.equipmentParc.text.labels_and_barcodes",
            "Événement": "wamasysApp.equipmentParc.text.event",
            "équipement(s)": "wamasysApp.equipmentParc.text.equipment_item_s",
            "Code-barres indisponible.": "wamasysApp.equipmentParc.text.barcode_unavailable",
            " (AAAA-MM-JJ, facultatif sauf indication)": "wamasysApp.equipmentParc.text.yyyy_mm_dd_optional_unless_indicated",
            "Rangement et seuil": "wamasysApp.equipmentParc.text.storage_address_and_threshold",
            "Affectation": "wamasysApp.equipmentParc.text.extra_assignment",
            "Agence": "wamasysApp.equipmentParc.text.extra_agency",
            "Area": "wamasysApp.equipmentParc.text.extra_area",
            "Contre-passer": "wamasysApp.equipmentParc.text.extra_reverse",
            "Date": "wamasysApp.equipmentParc.text.extra_date",
            "Disponible": "wamasysApp.equipmentParc.text.extra_available",
            "Disque": "wamasysApp.equipmentParc.text.extra_disk",
            "Imprimer": "wamasysApp.equipmentParc.text.extra_print",
            "Lieux": "wamasysApp.equipmentParc.text.extra_locations",
            "Mo": "wamasysApp.equipmentParc.text.extra_mb",
            "Sens": "wamasysApp.equipmentParc.text.extra_direction",
            "\nDestination : ": "wamasysApp.equipmentParc.text.extra_destination",
            "\nDepuis le ": "wamasysApp.equipmentParc.text.extra_since",
            " · seuil ": "wamasysApp.equipmentParc.text.extra_threshold",
            " · STOCK BAS": "wamasysApp.equipmentParc.text.extra_low_stock",
            "Commentaires": "wamasysApp.equipmentParc.text.extra_comments",
            "Consignes": "wamasysApp.equipmentParc.text.extra_instructions",
            "Contre-passation": "wamasysApp.equipmentParc.text.extra_reversal",
            "Intervention": "wamasysApp.equipmentParc.text.extra_intervention",
            "Latitude": "wamasysApp.equipmentParc.text.extra_latitude",
            "Longitude": "wamasysApp.equipmentParc.text.extra_longitude",
            "Marque": "wamasysApp.equipmentParc.text.extra_brand",
            "Terrain": "wamasysApp.equipmentParc.text.extra_field_equipment",
            "Sélectionnez un lieu pour réduire le nombre d'emplacements.": "wamasysApp.equipmentParc.errors.chooseLocation",
            "Un emplacement est vide.": "wamasysApp.equipmentParc.errors.emptyStorage",
            "Ce poste est déjà rattaché à une autre zone. Modifiez son rattachement dans Wamasys.": "wamasysApp.equipmentParc.errors.differentArea",
            "Ce téléchargement a atteint sa limite d'inscriptions. Téléchargez un nouveau script.": "wamasysApp.equipmentParc.errors.registrationLimit",
            "La zone doit être rattachée à une agence.": "wamasysApp.equipmentParc.errors.areaOwner",
            "Le collecteur Windows est indisponible.": "wamasysApp.equipmentParc.errors.collectorUnavailable",
            "Le serveur du collecteur doit utiliser HTTPS.": "wamasysApp.equipmentParc.errors.collectorHttps",
            "Sélectionnez la zone avant de télécharger le collecteur.": "wamasysApp.equipmentParc.errors.chooseArea",
            "Une zone est nécessaire pour analyser le réseau.": "wamasysApp.equipmentParc.errors.networkArea",
            "La clé de chiffrement IT doit contenir 16 ou 32 octets encodés en Base64.": "wamasysApp.equipmentParc.errors.invalidEncryptionKey",
            "Le mot de passe n'a pas pu être chiffré.": "wamasysApp.equipmentParc.errors.encryptFailed",
            "Le mot de passe n'a pas pu être déchiffré.": "wamasysApp.equipmentParc.errors.decryptFailed",
            "Le stockage chiffré des mots de passe n'est pas configuré sur ce serveur.": "wamasysApp.equipmentParc.errors.secretStorageMissing",
            "Seul le stockage chiffré dans Wamasys est proposé pour les nouveaux enregistrements.": "wamasysApp.equipmentParc.errors.storedOnly",
            "Confirmez le passage de ce compte au stockage chiffré dans Wamasys.": "wamasysApp.equipmentParc.errors.confirmConversion",
            "Aucun mot de passe n'est enregistré pour ce compte.": "wamasysApp.equipmentParc.errors.noStoredPassword",
            "Renseignez le mot de passe à enregistrer.": "wamasysApp.equipmentParc.errors.enterPassword",
            "Adresse MAC incorrecte.": "wamasysApp.equipmentParc.errors.invalidMac",
            "La date de démarrage est incorrecte.": "wamasysApp.equipmentParc.errors.invalidBootDate",
            "Le diagnostic réseau est incorrect.": "wamasysApp.equipmentParc.errors.invalidDiagnostics",
            "Les informations de ce poste sont mises à jour par son collecteur.": "wamasysApp.equipmentParc.errors.collectorManaged",
            "Liste de ports incorrecte.": "wamasysApp.equipmentParc.errors.invalidPorts",
            "Liste de serveurs DNS incorrecte.": "wamasysApp.equipmentParc.errors.invalidDns",
            "Observation réseau vide.": "wamasysApp.equipmentParc.errors.emptyObservation",
            "Port réseau incorrect.": "wamasysApp.equipmentParc.errors.invalidPort",
            "Périphérique vide.": "wamasysApp.equipmentParc.errors.emptyPeripheral",
            "Type de périphérique incorrect.": "wamasysApp.equipmentParc.errors.invalidPeripheral",
            "Un périphérique est présent plusieurs fois.": "wamasysApp.equipmentParc.errors.duplicatePeripheral",
            "Choisissez un type terrain ou un type IT, sans les mélanger.": "wamasysApp.equipmentParc.errors.chooseSingleType",
            "Les types IT sont fixes et indépendants des types terrain.": "wamasysApp.equipmentParc.errors.fixedItTypes",
            "Un équipement terrain ne peut pas devenir un appareil IT, ni l’inverse.": "wamasysApp.equipmentParc.errors.cannotChangeKind"
        };
        return {translate: function (message) { return keys[message] ? $translate.instant(keys[message]) : message; }};
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').component('equipmentMedia', {bindings: {equipmentId: '<', interventionId: '<', canEdit: '<'}, templateUrl: 'app/business/equipment-parc/equipment-media.html', controller: EquipmentMediaController});
    EquipmentMediaController.$inject = ['$scope', '$window', '$translate', 'EquipmentParc', 'EquipmentMessages'];
    function EquipmentMediaController($scope, $window, $translate, api, EquipmentMessages) {
        var ctrl = this, generation = 0;
        function tr(key) { return $translate.instant('wamasysApp.equipmentParc.media.' + key); }
        function path() { return ctrl.interventionId ? 'interventions/' + ctrl.interventionId : 'equipment/' + ctrl.equipmentId; }
        // AngularJS 1.5.2 expose $onInit ; les changements de liaison sont suivis explicitement.
        ctrl.$onInit = function () { $scope.$watchGroup([function () { return ctrl.equipmentId; }, function () { return ctrl.interventionId; }, function () { return ctrl.canEdit; }], function () { if (ctrl.equipmentId || ctrl.interventionId) { generation++; ctrl.images = {}; ctrl.pending = null; ctrl.busy = false; ctrl.error = null; ctrl.items = []; ctrl.stats = null; load(); } }); };
        $scope.$on('$destroy', function () { generation++; ctrl.pending = null; });
        function failed(error) { ctrl.error = EquipmentMessages.translate(error && error.data && error.data.message) || tr('failed'); }
        function load() { var current = generation; return api.get(path() + '/attachments').then(function (data) {
            if (current !== generation) { return; } ctrl.items = data.items; ctrl.stats = data.stats; var count = 0;
            ctrl.items.forEach(function (item) { if (item.kind === 'PHOTO' && count++ < 12 && !ctrl.images[item.id]) { ctrl.preview(item); } });
        }).catch(function (error) { if (current === generation) { failed(error); } }); }
        ctrl.preview = function (item) { var current = generation; api.get(path() + '/attachments/' + item.id + '/content').then(function (data) { if (current === generation) { ctrl.images[item.id] = 'data:image/jpeg;base64,' + data.contentBase64; } }).catch(function (error) { if (current === generation) { failed(error); } }); };
        ctrl.upload = function (files, kind) {
            if (!files || !files.length || ctrl.busy) { return; } var file = files[0], limit = (kind === 'PHOTO' ? 10 : 20) * 1024 * 1024;
            if (!file.size || file.size > limit) { ctrl.error = tr('sizeLimit'); return; }
            ctrl.busy = true; ctrl.error = null; var reader = new $window.FileReader(), current = generation;
            reader.onload = function () { $scope.$applyAsync(function () { if (current !== generation) { return; } ctrl.pending = {uploadUuid: api.newUuid(), kind: kind, fileName: file.name, contentType: file.type, contentBase64: String(reader.result).split(',')[1]}; ctrl.send(); }); };
            reader.onerror = function () { $scope.$applyAsync(function () { if (current === generation) { ctrl.busy = false; ctrl.error = tr('failed'); } }); }; reader.readAsDataURL(file);
        };
        ctrl.send = function () { if (!ctrl.pending) { return; } ctrl.busy = true; ctrl.error = null; var current = generation;
            api.post(path() + '/attachments', ctrl.pending).then(function () { if (current === generation) { ctrl.pending = null; return load(); } }).catch(function (error) { if (current === generation) { failed(error); } }).finally(function () { if (current === generation) { ctrl.busy = false; } });
        };
        ctrl.download = function (item) { api.download(path() + '/attachments/' + item.id + '/download').then(function (bytes) {
            var url = $window.URL.createObjectURL(new $window.Blob([bytes], {type: item.contentType})), link = $window.document.createElement('a'); link.href = url; link.download = item.fileName; link.click(); $window.setTimeout(function () { $window.URL.revokeObjectURL(url); }, 1000);
        }).catch(failed); };
        ctrl.remove = function (item) { if (!$window.confirm(tr('deleteConfirm') + ' ' + item.fileName)) { return; } var current = generation; ctrl.busy = true; api.remove(path() + '/attachments/' + item.id).then(function () { if (current === generation) { return load(); } }).catch(function (error) { if (current === generation) { failed(error); } }).finally(function () { if (current === generation) { ctrl.busy = false; } }); };
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').controller('EquipmentMapController', EquipmentMapController);
    EquipmentMapController.$inject = ['$scope', '$uibModalInstance', '$state', '$q', '$timeout', 'leafletData', 'EquipmentParc', '$translate', 'EquipmentMessages', 'filters'];
    function EquipmentMapController($scope, modal, $state, $q, $timeout, leafletData, api, $translate, EquipmentMessages, filters) {
        var vm = this, items = [], context = {areas: [], locations: []}, closed = false, resize;
        function tr(key) { return $translate.instant('wamasysApp.equipmentParc.map.' + key); }
        vm.mapId = 'equipment_map_' + $scope.$id; vm.loading = true; vm.loaded = 0; vm.total = 0; vm.located = 0;
        vm.showAreas = true; vm.showZones = true; vm.areas = []; vm.markers = {}; vm.center = {lat: 0, lng: 0, zoom: 2};
        vm.defaults = {scrollWheelZoom: false};
        vm.layers = {baselayers: {osm: {name: 'OpenStreetMap', url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', type: 'xyz', layerOptions: {attribution: '&copy; OpenStreetMap contributors'}}, satellite: {name: tr('satellite'), url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', type: 'xyz', layerOptions: {attribution: 'Tiles &copy; Esri'}}}};
        vm.close = function () { modal.close(); };
        vm.render = render;
        vm.fit = function () {
            resize = $timeout(function () { leafletData.getMap(vm.mapId).then(function (map) {
                if (closed) { return; } map.invalidateSize();
                if (vm.fitPoints.length) { map.fitBounds(vm.fitPoints, {padding: [30, 30], maxZoom: 16}); }
            }); }, 0);
        };
        $scope.$on('$destroy', function () { closed = true; if (resize) { $timeout.cancel(resize); } });
        $scope.$on('$stateChangeStart', function () { modal.close(); });
        // Le parcours conserve les filtres de la liste, mais charge aussi les pages non visibles.
        function page(after, upper) {
            if (closed) { return; }
            return api.get('map-items', angular.extend({}, filters, {size: 500, afterId: after || 0, upperId: upper})).then(function (data) {
                if (closed) { return; } items = items.concat(data.items); vm.loaded = items.length;
                return data.nextAfterId === null || angular.isUndefined(data.nextAfterId) ? null : page(data.nextAfterId, data.upperId);
            });
        }
        $q.all([api.get('map-context').then(function (data) { context = data; vm.areas = data.areas || []; }), page()]).then(function () {
            if (!closed) { vm.ready = true; render(true); }
        }).catch(function (error) {
            if (!closed) { vm.error = EquipmentMessages.translate(error && error.data && error.data.message) || tr('loadError'); }
        }).finally(function () { if (!closed) { vm.loading = false; } });

        function position(latitude, longitude) {
            return angular.isNumber(latitude) && angular.isNumber(longitude) && isFinite(latitude) && isFinite(longitude) && Math.abs(latitude) <= 90 && Math.abs(longitude) <= 180 ? {lat: latitude, lng: longitude} : null;
        }
        function escape(value) { return String(value === null || angular.isUndefined(value) ? '' : value).replace(/[&<>"']/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]; }); }
        function icon(area, count) {
            return {type: 'div', className: '', html: '<span style="display:block;width:' + (area ? 18 : 22) + 'px;height:' + (area ? 18 : 22) + 'px;border-radius:50%;background:' + (area ? '#64748b' : '#d9534f') + ';border:3px solid #fff;box-shadow:0 1px 4px #555;color:#fff;text-align:center;line-height:16px;font:bold 11px Arial">' + (count > 1 ? count : '') + '</span>', iconSize: area ? [18, 18] : [22, 22], iconAnchor: area ? [9, 9] : [11, 11]};
        }
        function areaSelected(id) { return !vm.areaId || id === vm.areaId; }
        function geometry(area) {
            try {
                var value = angular.isString(area.geometry) ? angular.fromJson(area.geometry) : area.geometry;
                value = value && (value.geometry || value);
                if (!value || ['Polygon', 'MultiPolygon'].indexOf(value.type) < 0 || !angular.isArray(value.coordinates)) { return null; }
                var polygons = value.type === 'Polygon' ? [value.coordinates] : value.coordinates;
                if (!polygons.length || !polygons.every(function (polygon) { return angular.isArray(polygon) && polygon.length && polygon.every(function (ring) { return angular.isArray(ring) && ring.length >= 4 && ring.every(function (point) { return angular.isArray(point) && point.length >= 2 && position(point[1], point[0]); }); }); })) { return null; }
                // Conserver les anneaux intérieurs : les trous des zones ne doivent pas être remplis.
                return {type: value.type, coordinates: angular.copy(value.coordinates)};
            } catch (invalidGeometry) { return null; }
        }
        function render(fit) {
            vm.markers = {}; vm.fitPoints = []; vm.total = 0; vm.located = 0; vm.invalidZones = 0;
            var locations = {}, areas = {}, features = [], groups = {};
            (context.locations || []).forEach(function (location) { locations[location.id] = location; });
            vm.areas.forEach(function (area) {
                areas[area.id] = area; if (!areaSelected(area.id)) { return; }
                var point = position(area.latitude, area.longitude);
                if (vm.showAreas && point) { vm.markers['area_' + area.id] = {lat: point.lat, lng: point.lng, icon: icon(true), zIndexOffset: -1000, draggable: false, compileMessage: false, message: '<strong>AREA · ' + escape(area.label) + '</strong>'}; vm.fitPoints.push([point.lat, point.lng]); }
                if (vm.showZones && area.geometry) {
                    var shape = geometry(area);
                    if (!shape) { vm.invalidZones++; return; }
                    features.push({type: 'Feature', properties: {label: area.label}, geometry: shape});
                    var polygons = shape.type === 'Polygon' ? [shape.coordinates] : shape.coordinates;
                    polygons.forEach(function (polygon) { polygon.forEach(function (ring) { ring.forEach(function (coordinate) { vm.fitPoints.push([coordinate[1], coordinate[0]]); }); }); });
                }
            });
            items.forEach(function (item) {
                if (!areaSelected(item.areaId)) { return; } vm.total++;
                var point = position(item.latitude, item.longitude), location = locations[item.locationId], area = areas[item.areaId];
                if (!point && (item.latitude === null || angular.isUndefined(item.latitude)) && (item.longitude === null || angular.isUndefined(item.longitude)) && location) { point = position(location.latitude, location.longitude); }
                if (!point) { return; } vm.located++;
                var key = point.lat.toFixed(6) + ':' + point.lng.toFixed(6);
                if (!groups[key]) { groups[key] = {item: item, point: point, messages: []}; }
                groups[key].messages.push('<strong>' + escape(item.inventoryCode) + '</strong><br>' + escape(item.label) + (area ? '<br>AREA · ' + escape(area.label) : '') + '<br><a href="' + escape($state.href('equipment-parc', {equipmentId: item.id})) + '">' + escape(tr('openRecord')) + '</a>');
            });
            // Les équipements d'un même lieu restent tous accessibles dans la fenêtre du repère commun.
            Object.keys(groups).forEach(function (key) {
                var group = groups[key], point = group.point;
                vm.markers['equipment_' + group.item.id] = {lat: point.lat, lng: point.lng, icon: icon(false, group.messages.length), zIndexOffset: 1000, draggable: false, compileMessage: false, message: '<div style="max-height:260px;overflow:auto">' + group.messages.join('<hr>') + '</div>'};
                vm.fitPoints.push([point.lat, point.lng]);
            });
            vm.geojson = {data: {type: 'FeatureCollection', features: features}, style: {color: '#64748b', weight: 2, opacity: 0.65, fillOpacity: 0.10}, onEachFeature: function (feature, layer) { layer.bindPopup('AREA · ' + escape(feature.properties.label)); }};
            if (fit) { vm.fit(); }
        }
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').controller('EquipmentLabelsController', EquipmentLabelsController);
    EquipmentLabelsController.$inject = ['$stateParams', '$window', '$translate', 'Principal', 'EquipmentParc', 'EquipmentMessages'];
    function EquipmentLabelsController(params, $window, $translate, Principal, api, EquipmentMessages) {
        var vm = this;
        function tr(key) { return $translate.instant('wamasysApp.equipmentParc.' + key); }
        vm.pageTitle = 'wamasysApp.equipmentParc.text.labels_and_barcodes'; vm.equipment = []; vm.consumables = []; vm.locations = []; vm.selected = {}; vm.labels = []; vm.copies = 1;
        vm.labelStep = 'selection'; vm.printOpened = false;
        vm.mode = params.kind === 'STORAGE' ? 'STORAGE' : 'ITEMS';
        vm.changeMode = function (mode) { vm.mode = mode; vm.labelStep = 'selection'; vm.printOpened = false; vm.labels = []; vm.notice = null; vm.error = null; vm.marked = false; };
        vm.levels = ['AISLE', 'ROW', 'RACK', 'SHELF', 'BIN'];
        vm.levelKeys = {AISLE: 'aisle', ROW: 'row', RACK: 'rack', SHELF: 'shelf', BIN: 'bin'};
        vm.storage = {locationId: params.locationId ? Number(params.locationId) : null, includeStockSettings: true, onlyUnprinted: true, levels: {AISLE: true, ROW: true, RACK: true, SHELF: true, BIN: true}, paths: []};
        vm.path = {}; vm.format = {width: 63, height: 30, font: 10, showBarcode: true};
        vm.levelName = function (level) { return tr('storage.' + vm.levelKeys[level]); };
        vm.describePath = function (path, end) { var parts = []; vm.levels.forEach(function (level, index) { if ((angular.isUndefined(end) || index <= end) && path[vm.levelKeys[level]]) { parts.push(vm.levelName(level) + ' ' + path[vm.levelKeys[level]]); } }); return parts.join(' / '); };
        vm.matches = function (item) { var query = (vm.search || '').toLowerCase(); return ((item.inventoryCode || item.code || '') + ' ' + item.label).toLowerCase().indexOf(query) >= 0; };
        vm.selectVisible = function (checked) { vm.equipment.filter(vm.matches).forEach(function (item) { vm.selected['EQUIPMENT:' + item.id] = checked; }); vm.consumables.filter(vm.matches).forEach(function (item) { vm.selected['CONSUMABLE:' + item.id] = checked; }); };
        vm.count = function () { return Object.keys(vm.selected).filter(function (key) { return vm.selected[key]; }).length; };
        vm.selectedLabels = function () { return vm.labels.filter(function (label) { return label.selected !== false; }); };
        function manualPath() { var path = angular.extend({}, vm.path, {locationId: vm.storage.locationId}); return vm.levels.some(function (level) { return path[vm.levelKeys[level]] && path[vm.levelKeys[level]].trim(); }) ? path : null; }
        vm.addPath = function () { var path = manualPath(); if (!path || !path.locationId) { vm.error = tr('storage.chooseLocationAndPath'); return; } vm.storage.paths.push(path); vm.path = {}; vm.error = null; };
        vm.preview = function () {
            var request = {equipmentIds: [], consumableIds: [], copies: vm.copies}; vm.error = null; vm.notice = null; vm.marked = false;
            if (!isFinite(vm.copies) || Math.floor(vm.copies) !== vm.copies || vm.copies < 1 || vm.copies > 50) { vm.error = tr('storage.invalidCopies'); return; }
            if (vm.mode === 'STORAGE') {
                request = {locationId: vm.storage.locationId || null, levels: vm.levels.filter(function (level) { return vm.storage.levels[level]; }), paths: angular.copy(vm.storage.paths), includeStockSettings: vm.storage.includeStockSettings, onlyUnprinted: vm.storage.onlyUnprinted, copies: vm.copies};
                var path = manualPath(); if (path) { if (!path.locationId) { vm.error = tr('storage.chooseLocationAndPath'); return; } request.paths.push(path); }
                if (!request.levels.length || !vm.canEdit) { vm.error = tr('storage.chooseLevels'); return; }
            } else {
                Object.keys(vm.selected).forEach(function (key) { if (vm.selected[key]) { var parts = key.split(':'); request[parts[0] === 'EQUIPMENT' ? 'equipmentIds' : 'consumableIds'].push(Number(parts[1])); } });
                if (!vm.count() || vm.count() * vm.copies > 1000 || request.equipmentIds.length > 200 || request.consumableIds.length > 200) { vm.error = tr('text.select_up_to_200_equipment_items_and_200_consumables_with'); return; }
            }
            try { if (vm.mode === 'STORAGE' && $window.localStorage) { $window.localStorage.setItem('equipment-storage-levels-' + vm.organisationId, angular.toJson(vm.storage.levels)); } } catch (ignoredPreferences) { angular.noop(); }
            vm.busy = true;
            api.post(vm.mode === 'STORAGE' ? 'storage-labels/preview' : 'labels', request).then(function (labels) {
                vm.labels = labels; vm.labelStep = labels.length ? 'preview' : 'selection'; vm.printOpened = false; labels.forEach(function (label) { label.selected = true; if (label.kind === 'STORAGE') { var index = vm.levels.indexOf(label.storage.level); label.code = vm.levelName(label.storage.level) + ' ' + label.storage[vm.levelKeys[label.storage.level]]; label.label = [label.locationLabel, vm.describePath(label.storage, index - 1)].filter(Boolean).join(' · '); } });
                if (!labels.length) { vm.notice = tr('storage.noNewLabels'); }
            }).catch(failed).finally(function () { vm.busy = false; });
        };
        vm.markPrinted = function () {
            var ids = vm.selectedLabels().filter(function (label) { return label.kind === 'STORAGE'; }).map(function (label) { return label.id; });
            if (!ids.length) { return; } vm.busy = true;
            api.post('storage-labels/printed', {ids: ids}).then(function () { vm.marked = true; vm.notice = tr('storage.marked'); }).catch(failed).finally(function () { vm.busy = false; });
        };
        vm.print = function () {
            var width = Number(vm.format.width), height = Number(vm.format.height), font = Number(vm.format.font);
            if (!isFinite(width) || !isFinite(height) || !isFinite(font) || width < 20 || width > 190 || height < 20 || height > 150 || font < 6 || font > 32) { vm.error = tr('storage.invalidFormat'); return; }
            if (!vm.selectedLabels().length || !isFinite(vm.copies) || Math.floor(vm.copies) !== vm.copies || vm.copies < 1 || vm.copies > 50 || vm.selectedLabels().length * vm.copies > 1000) { vm.error = tr('storage.invalidCopies'); return; }
            var popup = $window.open('', '_blank', 'width=1000,height=800');
            if (!popup) { vm.error = tr('text.allow_the_print_window_in_your_browser'); return; }
            vm.printOpened = true; popup.opener = null; var body = '';
            vm.selectedLabels().forEach(function (label) { for (var copy = 0; copy < vm.copies; copy++) {
                if (!/^data:image\/png;base64,[A-Za-z0-9+/=]+$/.test(label.image)) { continue; }
                body += '<section class="label"><strong>' + escape(label.code) + '</strong><div class="name">' + escape(label.label) + '</div>' + (vm.format.showBarcode ? '<img src="' + label.image + '" alt="' + escape(label.value) + '"><small>' + escape(label.value) + '</small>' : '') + '</section>';
            } });
            popup.document.write('<!doctype html><html><head><meta charset="utf-8"><title>' + escape($translate.instant(vm.pageTitle)) + '</title><style>@page{size:A4;margin:9mm}body{margin:0;font:' + font + 'pt Arial,sans-serif}.sheet{display:flex;flex-wrap:wrap;gap:1mm}.label{box-sizing:border-box;width:' + width + 'mm;height:' + height + 'mm;padding:1.5mm;text-align:center;border:1px dashed #ddd;break-inside:avoid;page-break-inside:avoid;overflow:hidden;display:flex;flex-direction:column;justify-content:center}.name{font-size:80%;overflow-wrap:anywhere}img{display:block;width:100%;height:' + Math.max(7, height - 15) + 'mm;object-fit:contain}small{font-size:7pt}@media print{.label{border:0}}</style></head><body onload="window.print()"><main class="sheet">' + body + '</main></body></html>'); popup.document.close();
            // Seuls les réglages de présentation sont mémorisés, jamais les données ni les codes d'accès.
            try { if ($window.localStorage) { $window.localStorage.setItem('equipment-label-format-' + vm.organisationId, angular.toJson(vm.format)); } } catch (ignored) { angular.noop(); }
        };
        function escape(value) { return String(value === null || angular.isUndefined(value) ? '' : value).replace(/[&<>"']/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]; }); }
        function failed(error) { vm.error = EquipmentMessages.translate(error && error.data && error.data.message) || tr('text.the_labels_could_not_be_loaded'); }
        function page(after, upper) { return api.get('mobile-snapshot', {size: 200, afterId: after || 0, upperId: upper}).then(function (data) { vm.equipment = vm.equipment.concat(data.items); return data.nextAfterId === null || angular.isUndefined(data.nextAfterId) ? null : page(data.nextAfterId, data.upperId); }); }
        Principal.identity().then(function (account) {
            vm.moduleDisabled = !account || (account.modules || []).indexOf('EQUIPMENT') < 0; var roles = account && account.authorities || [];
            vm.canEdit = roles.some(function (role) { return ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_EQUIPMENT_EDIT'].indexOf(role) >= 0; });
            if (vm.moduleDisabled) { vm.error = tr('text.enable_equipment_in_the_organisation_settings_first'); return; }
            return api.get('metadata').then(function (meta) { vm.organisationId = meta.organisationId; vm.consumables = meta.consumables; vm.locations = meta.locations || []; try { if ($window.localStorage) { angular.extend(vm.format, angular.fromJson($window.localStorage.getItem('equipment-label-format-' + vm.organisationId)) || {}); angular.extend(vm.storage.levels, angular.fromJson($window.localStorage.getItem('equipment-storage-levels-' + vm.organisationId)) || {}); } } catch (ignored) { angular.noop(); } return page(); }).then(function () { if (params.id && ['EQUIPMENT', 'CONSUMABLE'].indexOf(params.kind) >= 0) { vm.selected[params.kind + ':' + Number(params.id)] = true; vm.preview(); } });
        }).catch(failed);
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').controller('EquipmentInventoriesController', EquipmentInventoriesController);
    EquipmentInventoriesController.$inject = ['$state', '$stateParams', '$window', 'EquipmentParc', 'EquipmentMessages', '$translate'];
    function EquipmentInventoriesController($state, params, $window, api, messages, $translate) {
        var vm = this, base = 'physical-inventories'; vm.pageTitle = 'wamasysApp.equipmentParc.physical.title'; vm.meta = {areas: [], locations: []}; vm.listPage = 0; vm.linePage = 0; vm.items = []; vm.rows = []; vm.participants = []; vm.extra = {}; vm.newPlan = null;
        vm.tr = function (key) { return $translate.instant('wamasysApp.equipmentParc.physical.' + key); };
        vm.reason = function (code) { return code ? $translate.instant('wamasysApp.equipmentParc.adjustmentReasons.' + code) : '—'; };
        vm.condition = function (code) { return code ? $translate.instant('wamasysApp.equipmentParc.dashboard.conditions.' + code) : '—'; };
        vm.typeLabel = function (value) { return ['COMPUTER', 'ROUTER', 'PRINTER', 'SCANNER', 'OTHER_NETWORK_DEVICE'].indexOf(value) >= 0 ? $translate.instant('wamasysApp.equipmentParc.it.types.' + value) : value; };
        vm.status = function (code) { return vm.tr('statuses.' + code); };
        vm.name = function (rows, id) { var row = (rows || []).filter(function (r) { return r.id === id; })[0]; return row ? row.label : '—'; };
        function error(response) { vm.error = messages.translate(response && response.data && response.data.message) || vm.tr('failed'); }
        function run(command) { if (vm.busy) { return; } vm.busy = true; vm.error = null; return command().catch(error).finally(function () { vm.busy = false; }); }
        function date(value) { if (!value) { return null; } return value instanceof Date ? value.getFullYear() + '-' + ('0' + (value.getMonth() + 1)).slice(-2) + '-' + ('0' + value.getDate()).slice(-2) : value; }
        vm.locations = function (area) { return (vm.meta.locations || []).filter(function (location) { return location.active && location.areaId === area; }); };
        vm.canCount = function () { return vm.meta.canEdit && vm.current && vm.current.validatorLogin !== vm.meta.login && (vm.meta.canChangeArea || vm.current.responsibleLogin === vm.meta.login); };
        vm.canValidate = function () { return vm.meta.canEdit && vm.current && vm.current.validatorLogin === vm.meta.login; };
        function listing() { return api.get(base, {areaId: vm.areaId, page: vm.listPage}).then(function (data) { vm.items = data.items; vm.total = data.total; }); }
        vm.load = function () { return run(listing); };
        function detail(id, keepRows) { return api.get(base + '/' + id).then(function (data) { vm.current = data.inventory; vm.summary = data.summary; vm.events = data.events; return keepRows ? data : rows(); }); }
        function editor(row) { return {countedQuantity: row.countedQuantity, observedCondition: row.observedCondition, unitValue: row.unitValue, currency: row.currency, adjustmentReason: row.adjustmentReason, comment: row.comment}; }
        vm.hasEdits = function () { return vm.rows.some(function (row) { return !angular.equals(editor(row), row.edit); }); };
        function rows() { return api.get(base + '/' + vm.current.id + '/lines', {page: vm.linePage, kind: vm.kind, locationId: vm.lineLocationId, typeLabel: vm.lineType}).then(function (data) { vm.rows = data.items; vm.lineTotal = data.total; vm.lineLocations = data.locations || []; vm.lineTypes = data.types || []; vm.rows.forEach(function (row) { row.edit = editor(row); }); }); }
        vm.open = function (id) { vm.newPlan = null; vm.linePage = 0; vm.kind = null; vm.lineLocationId = null; vm.lineType = null; $state.go('equipment-inventories', {inventoryId: id}, {notify: false, location: 'replace'}); return run(function () { return detail(id); }); };
        vm.back = function () { if (vm.busy) { return; } vm.current = null; vm.newPlan = null; $state.go('equipment-inventories', {inventoryId: null}, {notify: false, location: 'replace'}); vm.load(); };
        vm.pageLines = function (delta) { if (vm.busy) { return; } vm.linePage = Math.max(0, vm.linePage + delta); return run(rows); };
        vm.filterLines = function () { vm.linePage = 0; return run(rows); };
        vm.pageList = function (delta) { vm.listPage = Math.max(0, vm.listPage + delta); vm.load(); };
        vm.plan = function (current) { if (vm.busy) { return; } vm.newPlan = current ? angular.copy(current) : {inventoryDate: new Date(), responsibleLogin: vm.meta.login, areaId: vm.meta.currentAreaId, includeEquipment: true, includeConsumables: true}; ['inventoryDate', 'nextInventoryDate'].forEach(function (key) { if (vm.newPlan[key] && !(vm.newPlan[key] instanceof Date)) { vm.newPlan[key] = new Date(vm.newPlan[key] + 'T12:00:00'); } }); };
        vm.savePlan = function () { return run(function () { var body = {}; ['version', 'label', 'areaId', 'locationId', 'inventoryDate', 'nextInventoryDate', 'responsibleLogin', 'validatorLogin', 'includeEquipment', 'includeConsumables'].forEach(function (key) { body[key] = vm.newPlan[key]; }); body.id = vm.newPlan.id; body.inventoryDate = date(body.inventoryDate); body.nextInventoryDate = date(body.nextInventoryDate); var id = body.id; delete body.id; var request = id ? api.put(base + '/' + id, body) : api.post(base, body); return request.then(function (data) { vm.newPlan = null; return detail(data.id); }); }); };
        vm.lineDirty = function (row) { return !angular.equals(editor(row), row.edit); };
        vm.lineIssue = function (row) {
            var e = row.edit, quantity = e.countedQuantity;
            if (quantity === null || angular.isUndefined(quantity) || !isFinite(quantity) || quantity < 0) { return vm.tr(row.kind === 'EQUIPMENT' ? 'equipmentQuantity' : 'missingQuantity'); }
            if (row.kind === 'EQUIPMENT' && quantity !== 0 && quantity !== 1) { return vm.tr('equipmentQuantity'); }
            if (Math.abs(quantity * 10000 - Math.round(quantity * 10000)) > 0.00001) { return vm.tr('quantityDecimals'); }
            if (row.kind === 'EQUIPMENT' && quantity === 1 && !e.observedCondition) { return vm.tr('missingCondition'); }
            if ((quantity !== Number(row.expectedQuantity) || e.observedCondition && row.expectedCondition && e.observedCondition !== row.expectedCondition) && !e.adjustmentReason) { return vm.tr('missingReason'); }
            if (e.adjustmentReason === 'OTHER' && !(e.comment || '').trim()) { return vm.tr('missingComment'); }
            if (e.unitValue !== null && angular.isDefined(e.unitValue) && (!isFinite(e.unitValue) || e.unitValue < 0 || !/^[A-Za-z]{3,10}$/.test((e.currency || '').trim()))) { return vm.tr('missingCurrency'); }
            return null;
        };
        vm.userName = function (login) { var person = vm.participants.filter(function (user) { return user.login === login; })[0]; return person ? person.label : login; };
        vm.validators = function () { return vm.participants.filter(function (user) { return !vm.newPlan || user.login !== vm.newPlan.responsibleLogin; }); };
        vm.saveLine = function (row) {
            row.feedback = null; row.saveError = vm.lineIssue(row); if (row.saveError || vm.busy) { return; }
            vm.busy = true; var e = row.edit, body = {version: row.version, countedQuantity: e.countedQuantity, observedCondition: e.observedCondition, unitValue: e.unitValue, currency: e.currency, adjustmentReason: e.adjustmentReason, comment: e.comment};
            return api.put(base + '/' + vm.current.id + '/lines/' + row.id, body).then(function (data) {
                angular.extend(row, data); row.edit = editor(row); row.feedback = vm.tr('lineSaved'); return detail(vm.current.id, true);
            }).catch(function (response) { row.saveError = messages.translate(response && response.data && response.data.message) || vm.tr('failed'); }).finally(function () { vm.busy = false; });
        };
        vm.addLine = function () { return run(function () { return api.post(base + '/' + vm.current.id + '/lines', vm.extra).then(function () { vm.extra = {}; return detail(vm.current.id); }); }); };
        vm.transition = function (action) { if (!$window.confirm(vm.tr(action === 'validate' ? 'validateConfirm' : 'actionConfirm'))) { return; } return run(function () { return api.post(base + '/' + vm.current.id + '/actions/' + action, {version: vm.current.version, comment: vm.actionComment, applyStockAdjustments: !!vm.applyStockAdjustments}).then(function () { vm.actionComment = null; return detail(vm.current.id); }); }); };
        vm.exportCsv = function () { return run(function () { var result = [], page = 0, total; function loadPage() { return api.get(base + '/' + vm.current.id + '/lines', {page: page}).then(function (data) { result = result.concat(data.items); total = data.total; page++; return result.length < total ? loadPage() : result; }); } return loadPage().then(function (items) {
            // Les cellules texte restent du texte même quand leur contenu ressemble à une formule Excel.
            function cell(value) { var text = value === null || angular.isUndefined(value) ? '' : String(value); if (!angular.isNumber(value) && /^[\s]*[=+@\-]/.test(text)) { text = "'" + text; } return '"' + text.replace(/"/g, '""') + '"'; }
            var data = [[vm.tr('title'), vm.current.id, vm.current.label], [vm.tr('date'), vm.current.inventoryDate], [vm.tr('captured'), vm.current.capturedAt], [vm.tr('status'), vm.status(vm.current.status)], [vm.tr('responsible'), vm.current.responsibleLogin], [vm.tr('validator'), vm.current.validatorLogin, vm.current.validatedAt], [], [vm.tr('code'), vm.tr('label'), vm.tr('location'), vm.tr('expected'), vm.tr('counted'), vm.tr('unit'), vm.tr('unitValue'), vm.tr('currency'), vm.tr('adjustmentReason'), vm.tr('comment'), vm.tr('countedBy'), vm.tr('countedAt')]].concat(items.map(function (line) { return [line.code, line.label, line.locationLabel, line.expectedQuantity, line.countedQuantity, line.unit === 'unit' ? vm.tr('unit') : line.unit, line.unitValue, line.currency, vm.reason(line.adjustmentReason), line.comment, line.countedBy, line.countedAt]; }));
            var url = $window.URL.createObjectURL(new $window.Blob(['\uFEFF' + data.map(function (row) { return row.map(cell).join(';'); }).join('\r\n')], {type: 'text/csv;charset=utf-8'})), link = $window.document.createElement('a'); link.href = url; link.download = 'inventaire-' + vm.current.id + '.csv'; link.click(); $window.setTimeout(function () { $window.URL.revokeObjectURL(url); }, 1000);
        }); }); };
        api.get('metadata').then(function (data) { vm.meta = data; if (data.canEdit) { api.get(base + '/participants').then(function (users) { vm.participants = users; }).catch(error); } if (params.inventoryId) { return detail(Number(params.inventoryId)); } return listing(); }).catch(error);
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').controller('EquipmentImportController', EquipmentImportController);
    EquipmentImportController.$inject = ['$scope', '$window', 'EquipmentParc', '$translate'];
    function EquipmentImportController($scope, $window, api, $translate) {
        var vm = this, generation = 0;
        vm.pageTitle = 'wamasysApp.equipmentParc.evolution.importTitle'; vm.kinds = ['Équipements', 'Articles', 'Stocks initiaux', 'Types', 'Lieux']; vm.request = {kind: 'Équipements', importUuid: api.newUuid()};
        function tr(key) { return $translate.instant('wamasysApp.equipmentParc.evolution.' + key); }
        function fail(error) { vm.error = error.data && error.data.message || tr('failed'); }
        vm.invalidate = function () { generation++; vm.preview = null; vm.done = null; vm.request.fingerprint = null; vm.request.importUuid = api.newUuid(); };
        vm.areas = function () { return (vm.meta.areas || []).filter(function (area) { return area.ownerId === vm.request.ownerId; }); };
        vm.scopeChanged = function () { if (!vm.areas().some(function (area) { return area.id === vm.request.areaId; })) { vm.request.areaId = null; } vm.invalidate(); };
        vm.choose = function (files) {
            if (!files || !files.length) { return; } vm.invalidate(); vm.error = null; vm.request.contentBase64 = null;
            var file = files[0], current = generation;
            if (!file.size || file.size > 5 * 1024 * 1024) { vm.error = tr('importLimit'); return; }
            vm.reading = true; var reader = new $window.FileReader();
            reader.onload = function () { $scope.$applyAsync(function () { if (current !== generation) { return; } vm.request.fileName = file.name; vm.request.contentBase64 = String(reader.result).split(',')[1]; vm.reading = false; }); };
            reader.onerror = function () { $scope.$applyAsync(function () { if (current === generation) { vm.error = tr('failed'); vm.reading = false; } }); }; reader.readAsDataURL(file);
        };
        vm.template = function () {
            return api.download('imports/template').then(function (bytes) { var url = $window.URL.createObjectURL(new $window.Blob([bytes])), link = $window.document.createElement('a'); link.href = url; link.download = 'modele-parc.xlsx'; link.click(); $window.setTimeout(function () { $window.URL.revokeObjectURL(url); }, 1000); }).catch(fail);
        };
        vm.inspect = function () {
            vm.busy = true; vm.error = null; vm.preview = null; vm.done = null;
            return api.post('imports/preview', vm.request).then(function (result) { vm.preview = result; vm.request.fingerprint = result.fingerprint; if (!result.valid) { vm.error = result.error; } }).catch(fail).finally(function () { vm.busy = false; });
        };
        vm.confirm = function () {
            vm.busy = true; vm.error = null;
            return api.post('imports/confirm', vm.request).then(function (result) { vm.done = result; vm.preview = null; }).catch(fail).finally(function () { vm.busy = false; });
        };
        vm.meta = {};
        api.get('metadata').then(function (meta) { vm.meta = meta; vm.canEdit = meta.canEdit; vm.request.areaId = meta.currentAreaId; var area = meta.areas.filter(function (entry) { return entry.id === meta.currentAreaId; })[0]; vm.request.ownerId = area && area.ownerId; }).catch(fail);
        $scope.$on('$destroy', function () { generation++; vm.request.contentBase64 = null; });
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').controller('EquipmentDashboardController', EquipmentDashboardController);
    EquipmentDashboardController.$inject = ['Principal', 'EquipmentParc', 'EquipmentMessages', '$translate'];
    function EquipmentDashboardController(Principal, api, EquipmentMessages, $translate) {
        var vm = this, loadVersion = 0; vm.pageTitle = 'wamasysApp.equipmentParc.dashboard.title'; vm.filter = {}; vm.meta = {owners: [], areas: []}; vm.data = {}; vm.message = EquipmentMessages.translate;
        var operationKeys = {INITIAL_STOCK: 'initial_stock', RECEIPT: 'receipt', CONSUMPTION: 'consumption', RETURN: 'return_to_stock', TRANSFER: 'transfer', ADJUSTMENT: 'stock_adjustment', REVERSAL: 'extra_reversal'};
        vm.operationLabel = function (code) { return operationKeys[code] ? $translate.instant('wamasysApp.equipmentParc.text.' + operationKeys[code]) : code; };
        function typeOptions() { return (vm.meta.types || []).map(function (type) { return {id: 'E:' + type.id, label: type.label}; }).concat((vm.meta.itTypes || []).map(function (type) { return {id: 'IT:' + type, label: $translate.instant('wamasysApp.equipmentParc.it.types.' + type)}; })); }
        vm.typeName = function (row) { if (row.itType) { return $translate.instant('wamasysApp.equipmentParc.it.types.' + row.itType); } var type = (vm.meta.types || []).filter(function (value) { return value.id === row.typeId; })[0]; return type ? type.label : '—'; };
        vm.reportRows = function () { return (vm.data.byType || []).slice().sort(function (a, b) { return vm.typeName(a).localeCompare(vm.typeName(b)); }); };
        vm.changeType = function () { delete vm.filter.typeId; delete vm.filter.itType; if (vm.selectedType) { if (vm.selectedType.indexOf('E:') === 0) { vm.filter.typeId = Number(vm.selectedType.substring(2)); } else { vm.filter.itType = vm.selectedType.substring(3); } } vm.load(); };
        vm.areas = function () { return vm.meta.areas.filter(function (area) { return !vm.filter.ownerId || area.ownerId === vm.filter.ownerId; }); };
        vm.changeOwner = function () { if (!vm.areas().some(function (area) { return area.id === vm.filter.areaId; })) { vm.filter.areaId = null; } vm.load(); };
        vm.load = function () { var version = ++loadVersion; vm.loading = true; vm.error = null; return api.get('dashboard', angular.copy(vm.filter)).then(function (data) { if (version === loadVersion) { vm.data = data; } }).catch(function (error) { if (version === loadVersion) { failed(error); } }).finally(function () { if (version === loadVersion) { vm.loading = false; } }); };
        function failed(error) { vm.error = EquipmentMessages.translate(error && error.data && error.data.message) || $translate.instant('wamasysApp.equipmentParc.dashboard.failed'); }
        Principal.identity().then(function (account) { vm.moduleDisabled = !account || (account.modules || []).indexOf('EQUIPMENT') < 0; if (vm.moduleDisabled) { return; } return api.get('metadata').then(function (data) { vm.meta = data; vm.typeOptions = typeOptions(); return vm.load(); }); }).catch(failed);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationTopicCategoryController', CommunicationTopicCategoryController);

    CommunicationTopicCategoryController.$inject = ['$scope', '$state', 'CommunicationTopicCategory', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CommunicationTopicCategoryController ($scope, $state, CommunicationTopicCategory, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            CommunicationTopicCategory.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.communicationTopicCategorys = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('communication-topic-category', {
            parent: 'entity',
            url: '/communication-topic-category?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.communicationTopicCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/communication-topic-category/communication-topic-categorys.html',
                    controller: 'CommunicationTopicCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communicationTopicCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('communication-topic-category-detail', {
            parent: 'entity',
            url: '/communication-topic-category/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.communicationTopicCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/communication-topic-category/communication-topic-category-detail.html',
                    controller: 'CommunicationTopicCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communicationTopicCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CommunicationTopicCategory', function($stateParams, CommunicationTopicCategory) {
                    return CommunicationTopicCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('communication-topic-category.new', {
            parent: 'communication-topic-category',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/communication-topic-category/communication-topic-category-dialog.html',
                    controller: 'CommunicationTopicCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('communication-topic-category', null, { reload: true });
                }, function() {
                    $state.go('communication-topic-category');
                });
            }]
        })
        .state('communication-topic-category.edit', {
            parent: 'communication-topic-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/communication-topic-category/communication-topic-category-dialog.html',
                    controller: 'CommunicationTopicCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CommunicationTopicCategory', function(CommunicationTopicCategory) {
                            return CommunicationTopicCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-topic-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('communication-topic-category.delete', {
            parent: 'communication-topic-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/communication-topic-category/communication-topic-category-delete-dialog.html',
                    controller: 'CommunicationTopicCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CommunicationTopicCategory', function(CommunicationTopicCategory) {
                            return CommunicationTopicCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-topic-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('CommunicationTopicCategory', CommunicationTopicCategory);

    CommunicationTopicCategory.$inject = ['$resource'];

    function CommunicationTopicCategory ($resource) {
        var resourceUrl =  'api/communication-topic-category/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationTopicCategoryDialogController', CommunicationTopicCategoryDialogController);

    CommunicationTopicCategoryDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'CommunicationTopicCategory'];

    function CommunicationTopicCategoryDialogController ($scope, $stateParams, $uibModalInstance, entity, CommunicationTopicCategory) {
        var vm = this;
        vm.communicationTopicCategory = entity;
        vm.load = function(id) {
            CommunicationTopicCategory.get({id : id}, function(result) {
                vm.communicationTopicCategory = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:communicationTopicCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.communicationTopicCategory.id !== null) {
                CommunicationTopicCategory.update(vm.communicationTopicCategory, onSaveSuccess, onSaveError);
            } else {
                CommunicationTopicCategory.save(vm.communicationTopicCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationTopicCategoryDetailController', CommunicationTopicCategoryDetailController);

    CommunicationTopicCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CommunicationTopicCategory'];

    function CommunicationTopicCategoryDetailController($scope, $rootScope, $stateParams, entity, CommunicationTopicCategory) {
        var vm = this;
        vm.communicationTopicCategory = entity;
        vm.load = function (id) {
            CommunicationTopicCategory.get({id: id}, function(result) {
                vm.communicationTopicCategory = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:communicationTopicCategoryUpdate', function(event, result) {
            vm.communicationTopicCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationTopicCategoryDeleteController',CommunicationTopicCategoryDeleteController);

    CommunicationTopicCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationTopicCategory'];

    function CommunicationTopicCategoryDeleteController($uibModalInstance, entity, CommunicationTopicCategory) {
        var vm = this;
        vm.communicationTopicCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CommunicationTopicCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('entite-parente', {
            parent: 'entity',
            url: '/entite-parente?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.entiteParente.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/entite-parente/entite-parentes.html',
                    controller: 'EntiteParenteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('entiteParente');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('entite-parente-detail', {
            parent: 'entity',
            url: '/entite-parente/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.entiteParente.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/entite-parente/entite-parente-detail.html',
                    controller: 'EntiteParenteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('entiteParente');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EntiteParente', function($stateParams, EntiteParente) {
                    return EntiteParente.get({id : $stateParams.id});
                }]
            }
        })
        .state('entite-parente.new', {
            parent: 'entite-parente',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/entite-parente/entite-parente-dialog.html',
                    controller: 'EntiteParenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nom: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('entite-parente', null, { reload: true });
                }, function() {
                    $state.go('entite-parente');
                });
            }]
        })
        .state('entite-parente.edit', {
            parent: 'entite-parente',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/entite-parente/entite-parente-dialog.html',
                    controller: 'EntiteParenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EntiteParente', function(EntiteParente) {
                            return EntiteParente.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('entite-parente', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('entite-parente.delete', {
            parent: 'entite-parente',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/entite-parente/entite-parente-delete-dialog.html',
                    controller: 'EntiteParenteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EntiteParente', function(EntiteParente) {
                            return EntiteParente.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('entite-parente', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('EntiteParente', EntiteParente);

    EntiteParente.$inject = ['$resource'];

    function EntiteParente ($resource) {
        var resourceUrl =  'api/entite-parentes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EntiteParenteController', EntiteParenteController);

    EntiteParenteController.$inject = ['$scope', '$state', 'EntiteParente', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function EntiteParenteController ($scope, $state, EntiteParente, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            EntiteParente.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.entiteParentes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EntiteParenteDialogController', EntiteParenteDialogController);

    EntiteParenteDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'EntiteParente', 'Agence'];

    function EntiteParenteDialogController ($scope, $stateParams, $uibModalInstance, entity, EntiteParente, Agence) {
        var vm = this;
        vm.entiteParente = entity;
        vm.agences = Agence.query();
        vm.load = function(id) {
            EntiteParente.get({id : id}, function(result) {
                vm.entiteParente = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:entiteParenteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.entiteParente.id !== null) {
                EntiteParente.update(vm.entiteParente, onSaveSuccess, onSaveError);
            } else {
                EntiteParente.save(vm.entiteParente, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EntiteParenteDetailController', EntiteParenteDetailController);

    EntiteParenteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'EntiteParente', 'Agence'];

    function EntiteParenteDetailController($scope, $rootScope, $stateParams, entity, EntiteParente, Agence) {
        var vm = this;
        vm.entiteParente = entity;
        vm.load = function (id) {
            EntiteParente.get({id: id}, function(result) {
                vm.entiteParente = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:entiteParenteUpdate', function(event, result) {
            vm.entiteParente = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EntiteParenteDeleteController',EntiteParenteDeleteController);

    EntiteParenteDeleteController.$inject = ['$uibModalInstance', 'entity', 'EntiteParente'];

    function EntiteParenteDeleteController($uibModalInstance, entity, EntiteParente) {
        var vm = this;
        vm.entiteParente = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            EntiteParente.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cout-achat-eau', {
            parent: 'entity',
            url: '/cout-achat-eau?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.coutAchatEau.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/cout-achat-eau/cout-achat-eaus.html',
                    controller: 'CoutAchatEauController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('coutAchatEau');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cout-achat-eau-detail', {
            parent: 'entity',
            url: '/cout-achat-eau/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.coutAchatEau.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/cout-achat-eau/cout-achat-eau-detail.html',
                    controller: 'CoutAchatEauDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('coutAchatEau');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CoutAchatEau', function($stateParams, CoutAchatEau) {
                    return CoutAchatEau.get({id : $stateParams.id});
                }]
            }
        })
        .state('cout-achat-eau.new', {
            parent: 'cout-achat-eau',
            url: '/new',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cout-achat-eau/cout-achat-eau-dialog.html',
                    controller: 'CoutAchatEauDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dateAjout: null,
                                cout: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cout-achat-eau', null, { reload: true });
                }, function() {
                    $state.go('cout-achat-eau');
                });
            }]
        })
        .state('cout-achat-eau.edit', {
            parent: 'cout-achat-eau',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cout-achat-eau/cout-achat-eau-dialog.html',
                    controller: 'CoutAchatEauDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CoutAchatEau', function(CoutAchatEau) {
                            return CoutAchatEau.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('cout-achat-eau', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cout-achat-eau.delete', {
            parent: 'cout-achat-eau',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cout-achat-eau/cout-achat-eau-delete-dialog.html',
                    controller: 'CoutAchatEauDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CoutAchatEau', function(CoutAchatEau) {
                            return CoutAchatEau.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('cout-achat-eau', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('CoutAchatEau', CoutAchatEau);

    CoutAchatEau.$inject = ['$resource', 'DateUtils'];

    function CoutAchatEau ($resource, DateUtils) {
        var resourceUrl =  'api/cout-achat-eaus/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateAjout = DateUtils.convertDateTimeFromServer(data.dateAjout);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CoutAchatEauController', CoutAchatEauController);

    CoutAchatEauController.$inject = ['$scope', '$state', 'CoutAchatEau', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CoutAchatEauController ($scope, $state, CoutAchatEau, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            CoutAchatEau.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.coutAchatEaus = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CoutAchatEauDialogController', CoutAchatEauDialogController);

    CoutAchatEauDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'CoutAchatEau'];

    function CoutAchatEauDialogController ($scope, $stateParams, $uibModalInstance, entity, CoutAchatEau) {
        var vm = this;
        vm.coutAchatEau = entity;
        vm.load = function(id) {
            CoutAchatEau.get({id : id}, function(result) {
                vm.coutAchatEau = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:coutAchatEauUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.coutAchatEau.id !== null) {
                CoutAchatEau.update(vm.coutAchatEau, onSaveSuccess, onSaveError);
            } else {
                CoutAchatEau.save(vm.coutAchatEau, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateAjout = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CoutAchatEauDetailController', CoutAchatEauDetailController);

    CoutAchatEauDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CoutAchatEau'];

    function CoutAchatEauDetailController($scope, $rootScope, $stateParams, entity, CoutAchatEau) {
        var vm = this;
        vm.coutAchatEau = entity;
        vm.load = function (id) {
            CoutAchatEau.get({id: id}, function(result) {
                vm.coutAchatEau = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:coutAchatEauUpdate', function(event, result) {
            vm.coutAchatEau = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CoutAchatEauDeleteController',CoutAchatEauDeleteController);

    CoutAchatEauDeleteController.$inject = ['$uibModalInstance', 'entity', 'CoutAchatEau'];

    function CoutAchatEauDeleteController($uibModalInstance, entity, CoutAchatEau) {
        var vm = this;
        vm.coutAchatEau = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CoutAchatEau.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('communication-campaign', {
                parent: 'entity',
                url: '/communication-campaign?page&sort&title&channel&cancelled&sendingDone&desiredSendDateFrom&desiredSendDateTo',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_AREA_MANAGEMENT', 'ROLE_READ_ONLY'],
                    pageTitle: 'wamasysApp.communicationCampaign.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/business/communication-campaign/communication-campaigns.html',
                        controller: 'CommunicationCampaignController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'createdDate,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('communication');
                        $translatePartialLoader.addPart('contrat');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('communication-campaign.new', {
                parent: 'communication-campaign',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_AREA_MANAGEMENT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/business/communication-campaign/communication-campaign-form.html',
                        controller: 'CommunicationCampaignFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function() {
                        return {
                            title: null,
                            channel: null,
                            desiredSendDate: null,
                            cancelled: false,
                            sendingDone: false,
                            templateTxt: null,
                            templateHtml: null,
                            templateSubject: null,
                            contratIds: [],
                            contratCount: 0,
                            id: null
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('communication');
                        $translatePartialLoader.addPart('contrat');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('communication-campaign.edit', {
                parent: 'communication-campaign',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_AREA_MANAGEMENT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/business/communication-campaign/communication-campaign-form.html',
                        controller: 'CommunicationCampaignFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'CommunicationCampaign', function($stateParams, CommunicationCampaign) {
                        return CommunicationCampaign.get({ id: $stateParams.id }).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('communication');
                        $translatePartialLoader.addPart('contrat');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('communication-campaign.cancel', {
                parent: 'communication-campaign',
                url: '/{id}/cancel',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_AREA_MANAGEMENT']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'CommunicationCampaign', function($stateParams, $state, $uibModal, CommunicationCampaign) {
                    $uibModal.open({
                        templateUrl: 'app/business/communication-campaign/communication-campaign-cancel-dialog.html',
                        controller: 'CommunicationCampaignCancelController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: function() {
                                return CommunicationCampaign.get({ id: $stateParams.id }).$promise;
                            }
                        }
                    }).result.then(function() {
                        $state.go('communication-campaign', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('CommunicationCampaign', CommunicationCampaign);

    CommunicationCampaign.$inject = ['$resource', 'DateUtils'];

    function CommunicationCampaign($resource, DateUtils) {
        var resourceUrl = 'api/communication-campaign/:id';

        function transformCampaignFromServer(data) {
            if (!data) {
                return data;
            }
            data = angular.fromJson(data);
            if (data) {
                data.desiredSendDate = DateUtils.convertDateTimeFromServer(data.desiredSendDate);
                data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
            }
            return data;
        }

        function transformCampaignToServer(data) {
            var clonedData = Object.assign({}, data);
            clonedData.desiredSendDate = data.desiredSendDate;
            clonedData.createdDate = data.createdDate;
            clonedData.lastModifiedDate = data.lastModifiedDate;
            return angular.toJson(clonedData);
        }

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                transformResponse: function(data) {
                    if (!data) {
                        return [];
                    }
                    data = angular.fromJson(data);
                    angular.forEach(data, function(item) {
                        item.desiredSendDate = DateUtils.convertDateTimeFromServer(item.desiredSendDate);
                        item.createdDate = DateUtils.convertDateTimeFromServer(item.createdDate);
                        item.lastModifiedDate = DateUtils.convertDateTimeFromServer(item.lastModifiedDate);
                    });
                    return data;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: transformCampaignFromServer
            },
            'save': {
                method: 'POST',
                transformRequest: transformCampaignToServer
            },
            'update': {
                method: 'PUT',
                transformRequest: transformCampaignToServer
            },
            'cancel': {
                method: 'POST',
                url: 'api/communication-campaign/:id/cancel'
            },
            'preview': {
                method: 'POST',
                url: 'api/communication-campaign/preview',
                transformRequest: transformCampaignToServer
            },
            'searchContracts': {
                method: 'GET',
                url: 'api/communication-campaign/search-contracts'
            },
            'downloadcsv': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
                url: 'api/communication-campaign/downloadcsv',
                transformResponse: function(data, headers) {
                    var filename = headers('FileName');
                    var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName: filename,
                        contentType: contentType
                    };
                }
            },
            'downloadCampaigncsv': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
                url: 'api/communication-campaign/:id/downloadcsv',
                transformResponse: function(data, headers) {
                    var filename = headers('FileName');
                    var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName: filename,
                        contentType: contentType
                    };
                }
            },
            'getChannel': {
                method: 'GET',
                url: 'api/channel',
                isArray: true
            },
            'chatAssistant': {
                method: 'POST',
                url: 'api/communication-campaign/assistant/chat'
            },
            'getAssistantUsage': {
                method: 'GET',
                url: 'api/communication-campaign/assistant/usage'
            },
            'submitAssistantFeedback': {
                method: 'POST',
                url: 'api/communication-campaign/assistant/feedback'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationCampaignController', CommunicationCampaignController);

    CommunicationCampaignController.$inject = ['$state', '$stateParams', '$filter', 'CommunicationCampaign', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CommunicationCampaignController($state, $stateParams, $filter, CommunicationCampaign, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.search = search;
        vm.clear = clear;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.searchTitle = $stateParams.title;
        vm.channel = $stateParams.channel;
        vm.cancelled = $stateParams.cancelled;
        vm.sendingDone = $stateParams.sendingDone;
        vm.date = {
            startDate: $stateParams.desiredSendDateFrom ? new Date($stateParams.desiredSendDateFrom) : null,
            endDate: $stateParams.desiredSendDateTo ? new Date($stateParams.desiredSendDateTo) : null
        };
        vm.channels = [];

        loadChannels();
        loadAll();

        function loadAll() {
            CommunicationCampaign.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                title: vm.searchTitle,
                channel: vm.channel,
                cancelled: vm.cancelled,
                sendingDone: vm.sendingDone,
                desiredSendDateFrom: $filter('date')(vm.date.startDate, 'yyyy-MM-dd'),
                desiredSendDateTo: $filter('date')(vm.date.endDate, 'yyyy-MM-dd')
            }, onSuccess, onError);
        }

        function loadChannels() {
            CommunicationCampaign.getChannel().$promise.then(function(result) {
                vm.channels = result || [];
            }, function() {
                vm.channels = [];
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.communicationCampaigns = data;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error && error.data && error.data.message ? error.data.message : 'Erreur lors du chargement des campagnes.');
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function search() {
            vm.page = 1;
            vm.transition();
        }

        function clear() {
            vm.page = 1;
            vm.predicate = 'createdDate';
            vm.reverse = false;
            vm.searchTitle = null;
            vm.channel = null;
            vm.cancelled = null;
            vm.sendingDone = null;
            vm.date.startDate = null;
            vm.date.endDate = null;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                title: vm.searchTitle,
                channel: vm.channel,
                cancelled: vm.cancelled,
                sendingDone: vm.sendingDone,
                desiredSendDateFrom: $filter('date')(vm.date.startDate, 'yyyy-MM-dd'),
                desiredSendDateTo: $filter('date')(vm.date.endDate, 'yyyy-MM-dd')
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationCampaignFormController', CommunicationCampaignFormController);

    CommunicationCampaignFormController.$inject = ['$scope', '$state', '$filter', '$window', '$timeout', '$sce', 'AlertService', 'entity', 'CommunicationCampaign',
        'ChannelConf', 'Agence', 'PortefeuilleContrat', 'ContractType', 'ContractProfil', 'ServiceVendu', 'CommunicationTopic',
        'CommunicationTopicCategory', 'Principal', 'AssistantPanelService', '$translate'];

    function CommunicationCampaignFormController($scope, $state, $filter, $window, $timeout, $sce, AlertService, entity, CommunicationCampaign, ChannelConf,
        Agence, PortefeuilleContrat, ContractType, ContractProfil, ServiceVendu, CommunicationTopic, CommunicationTopicCategory,
        Principal, AssistantPanelService, $translate) {
        var FILTERS_MARKER = '[CAMPAIGN_FILTERS_JSON]';
        var LIVE_PREVIEW_DELAY_MS = 500;
        var livePreviewPromise;
        var livePreviewRequestId = 0;
        var vm = this;
        vm.communicationCampaign = entity;
        vm.isEdit = !!vm.communicationCampaign.id;
        vm.isLocked = !!vm.communicationCampaign.sendingDone;
        vm.canUseAssistant = false;
        vm.channels = [];
        vm.agences = Agence.currentOrganisation();
        vm.datePickerOpenStatus = { desiredSendDate: false };
        vm.date = { startDate: null, endDate: null };
        vm.searchContracts = searchContracts;
        vm.download = download;
        vm.previewMessage = previewMessage;
        vm.save = save;
        vm.back = back;
        vm.isEmailChannel = isEmailChannel;
        vm.showTemplateHelp = false;
        vm.internalCommentNote = '';
        vm.savedFilters = null;
        vm.savedFiltersJson = '';
        vm.savedFiltersSummary = [];
        vm.livePreview = buildEmptyLivePreview();
        vm.templateVariables = [
            '${contractRef}',
            '${contractName}',
            '${contractAddress}',
            '${amountBilled}',
            '${totalToBePaid}',
            '${servicesToBePaid}',
            '${taxesToBePaid}',
            '${servicesToBePaidHtml}',
            '${taxesToBePaidHtml}',
            '${dateNow}'
        ];
        vm.openCalendar = function(date) { vm.datePickerOpenStatus[date] = true; };
        vm.toggleTemplateHelp = function() { vm.showTemplateHelp = !vm.showTemplateHelp; };
        vm.openAssistantChat = openAssistantChat;

        vm.portefeuilleContrats = PortefeuilleContrat.query({ offset: 0, size: 1000, sort: 'libelle,asc' });
        vm.contractTypes = ContractType.query({ offset: 0, size: 1000, sort: 'label,asc' });
        vm.contractProfils = ContractProfil.query({ offset: 0, size: 1000, sort: 'libelle,asc' });
        vm.serviceVendus = ServiceVendu.queryInclDeleted({ offset: 0, size: 1000, sort: 'libelle,asc' });
        vm.communicationTopics = CommunicationTopic.byAgence({ agenceId: -1 });
        vm.communicationTopicCategories = CommunicationTopicCategory.queryInclDeleted({ offset: 0, size: 1000, sort: 'label,asc' });
        vm.agenceNotPromise = [];
        vm.portefeuilleContratNotPromise = [];
        vm.contractTypeNotPromise = [];
        vm.contractProfilNotPromise = [];
        vm.serviceVenduNotPromise = [];
        vm.communicationTopicNotPromise = [];
        vm.communicationTopicCategoryNotPromise = [];

        parseStoredComment();

        if (!vm.communicationCampaign.agenceIds) {
            vm.communicationCampaign.agenceIds = [];
        }
        vm.contractSearchResult = {
            contractCount: vm.communicationCampaign.contratCount || 0,
            contratIds: angular.copy(vm.communicationCampaign.contratIds)
        };

        if (vm.isEdit && vm.communicationCampaign.agenceIds.length && vm.agences.$promise) {
            vm.agences.$promise.then(function(result) {
                vm.agenceNotPromise = result.filter(function(agence) {
                    return vm.communicationCampaign.agenceIds.indexOf(agence.id) >= 0;
                });
            });
        }

        loadChannels();
        Principal.identity().then(function(account) {
            if (account) {
                vm.canUseAssistant = (account.modules || []).indexOf('AI_ASSISTANT') !== -1
                    && (account.authorities.indexOf('ROLE_AI_ASSISTANT') !== -1
                    || account.authorities.indexOf('ROLE_ADMIN') !== -1
                    || account.authorities.indexOf('ROLE_SUPER_ADMIN') !== -1);
            }
        });
        registerPreviewWatchers();
        scheduleLivePreview();

        function buildSearchParams() {
            return {
             //   nom: vm.searchQuery,
                compteurFerme: vm.compteurFerme,
                agence: collectIds(vm.agenceNotPromise),
                portefeuilleContrat: collectIds(vm.portefeuilleContratNotPromise || vm.portefeuilleContrat),
                contractType: collectIds(vm.contractTypeNotPromise || vm.contractType),
                contractProfil: collectIds(vm.contractProfilNotPromise || vm.contractProfil),
                serviceVendu: collectIds(vm.serviceVenduNotPromise || vm.serviceVendu),
                communicationTopic: collectIds(vm.communicationTopicNotPromise || vm.communicationTopic),
                communicationTopicCategory: collectIds(vm.communicationTopicCategoryNotPromise || vm.communicationTopicCategory),
                etat: vm.etat,
                fromDate: $filter('date')(vm.date.startDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(vm.date.endDate, 'yyyy-MM-dd'),
                hasEmail: vm.hasEmail,
                hasPhone: vm.hasPhone
				//,
        //        onlinePaymentType: vm.onlinePaymentType,
        //        onlinePaymentQuery: vm.onlinePaymentQuery,
        //        onlinePaymentActive: vm.onlinePaymentActive
            };
        }

        function collectIds(values) {
            return values && values.length ? values.map(function(elem) { return elem.id; }).join(',') : null;
        }

        function loadChannels() {
            ChannelConf.query({ page: 0, size: 1000, sort: 'nom,asc' }).$promise.then(function(result) {
                vm.channels = extractDistinctChannels(result || []);
                if (!vm.channels.length) {
                    loadChannelEnumFallback();
                }
            }, function() {
                loadChannelEnumFallback();
            });
        }

        function loadChannelEnumFallback() {
            CommunicationCampaign.getChannel().$promise.then(function(result) {
                vm.channels = result || [];
            }, function() {
                vm.channels = [];
            });
        }

        function extractDistinctChannels(channelConfs) {
            var map = {};
            angular.forEach(channelConfs, function(channelConf) {
                if (channelConf && channelConf.channel && !map[channelConf.channel]) {
                    map[channelConf.channel] = {
                        name: channelConf.channel,
                        label: channelConf.nom ? channelConf.nom + ' (' + channelConf.channel + ')' : channelConf.channel
                    };
                }
            });
            return Object.keys(map).map(function(key) {
                return map[key];
            });
        }

        function searchContracts() {
            CommunicationCampaign.searchContracts(buildSearchParams()).$promise.then(function(result) {
                vm.contractSearchResult = result;
                vm.communicationCampaign.contratIds = angular.copy(result.contratIds || []);
                updateSavedFilters(buildCampaignFiltersSnapshot(result));
                scheduleLivePreview();
            }, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function download() {
            var action = vm.isEdit ? CommunicationCampaign.downloadCampaigncsv : CommunicationCampaign.downloadcsv;
            var params = vm.isEdit ? { id: vm.communicationCampaign.id } : buildSearchParams();
            action(params, function(content) {
                var url = URL.createObjectURL(content.response);
                var a = document.createElement('a');
                a.href = url;
                a.download = content.fileName;
                a.target = '_blank';
                a.click();
            });
        }

        function previewMessage() {
            CommunicationCampaign.preview(buildCampaignPreviewPayload()).$promise.then(function(preview) {
                if (preview.subject) {
                    openInNewWindow('<html><head><title>Subject preview</title></head><body><h2>Subject :</h2> ' + preview.subject + ' <hr/></body></html>');
                }
                if (preview.messageHtml) {
                    openInNewWindow(preview.messageHtml);
                }
                if (preview.messageText) {
                    openInNewWindow('<html><head><title>Preview</title></head><body><textarea rows="10" cols="80">' + preview.messageText + '</textarea></body></html>');
                }
            });
        }

        function openInNewWindow(content) {
            var newWindow = $window.open('', '_blank');
            newWindow.document.open();
            newWindow.document.write(content);
            newWindow.document.close();
        }

        function save() {
            if (vm.isLocked) {
                AlertService.error('Cette campagne a déjà été envoyée et ne peut plus être modifiée.');
                return;
            }
            if (vm.communicationCampaign.desiredSendDate && !isDesiredSendDateInFuture(vm.communicationCampaign.desiredSendDate)) {
                AlertService.error('La date d\'envoi doit être dans le futur.');
                return;
            }
            vm.isSaving = true;
            if (!vm.communicationCampaign.desiredSendDate) {
                vm.communicationCampaign.desiredSendDate = null;
            }
            vm.communicationCampaign.contratCount = vm.isEdit ? (vm.communicationCampaign.contratCount || 0) : (vm.communicationCampaign.contratIds ? vm.communicationCampaign.contratIds.length : 0);
            vm.communicationCampaign.agenceIds = vm.agenceNotPromise ? vm.agenceNotPromise.map(function(agence) { return agence.id; }) : [];
            updateSavedFilters(buildFiltersSnapshotForSave());
            vm.communicationCampaign.internalComment = composeStoredInternalComment(vm.internalCommentNote, vm.savedFilters);
            if (vm.isEdit) {
                vm.communicationCampaign.contratIds = null;
            }
            if (vm.communicationCampaign.id !== null) {
                CommunicationCampaign.update(vm.communicationCampaign, onSaveSuccess, onSaveError);
            } else {
                CommunicationCampaign.save(vm.communicationCampaign, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            $state.go('communication-campaign', null, { reload: true });
        }

        function onSaveError(error) {
            vm.isSaving = false;
            if (error && error.data && error.data.message) {
                AlertService.error(error.data.message);
            } else {
                AlertService.error('Impossible d\'enregistrer la campagne.');
            }
        }

        function back() {
            $state.go('communication-campaign');
        }

        function isEmailChannel() {
            return vm.communicationCampaign.channel === 'EMAIL_SENDBLUE' || vm.communicationCampaign.channel === 'EMAIL_SMTP';
        }

        function isDesiredSendDateInFuture(desiredSendDate) {
            return new Date(desiredSendDate).getTime() > new Date().getTime();
        }

        function openAssistantChat() {
            if (!vm.canUseAssistant || vm.isLocked) {
                return;
            }

            AssistantPanelService.open({
                contextType: 'COMMUNICATION_CAMPAIGN',
                entityId: vm.communicationCampaign.id || -1,
                title: $translate.instant('global.assistant.templateTitle'),
                subtitle: vm.communicationCampaign.title || 'Communication campaign',
                promptPlaceholder: $translate.instant('global.assistant.templatePromptPlaceholder'),
                supportsActionProposal: false,
                supportsDataScopes: false,
                adapter: {
                    chat: function(payload, success, error) {
                        CommunicationCampaign.chatAssistant(buildAssistantRequest(payload), success, error);
                    },
                    getUsage: function(success, error) {
                        CommunicationCampaign.getAssistantUsage(success, error);
                    },
                    submitFeedback: function(payload, success, error) {
                        CommunicationCampaign.submitAssistantFeedback(payload, success, error);
                    },
                    applyAssistantResponse: function(result) {
                        if (!result || !result.suggestedFieldValues) {
                            return;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template) && result.suggestedFieldValues.template !== null) {
                            vm.communicationCampaign.templateTxt = result.suggestedFieldValues.template;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template_html) && result.suggestedFieldValues.template_html !== null) {
                            vm.communicationCampaign.templateHtml = result.suggestedFieldValues.template_html;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template_subject) && result.suggestedFieldValues.template_subject !== null) {
                            vm.communicationCampaign.templateSubject = result.suggestedFieldValues.template_subject;
                        }
                        AssistantPanelService.invalidateConversationContext();
                        $scope.$evalAsync();
                    },
                    buildContextSignatureFragment: function() {
                        return [
                            vm.communicationCampaign.channel || '',
                            vm.communicationCampaign.title || '',
                            hashString(vm.internalCommentNote || ''),
                            hashString(vm.communicationCampaign.templateTxt || ''),
                            hashString(vm.communicationCampaign.templateHtml || ''),
                            hashString(vm.communicationCampaign.templateSubject || '')
                        ].join('|');
                    }
                }
            });
        }

        function buildAssistantRequest(payload) {
            return {
                assistantRequest: payload,
                communicationAutomationConf: {
                    id: vm.communicationCampaign.id,
                    type: 'COMMUNICATION_CAMPAIGN',
                    template: vm.communicationCampaign.templateTxt,
                    templateHtml: vm.communicationCampaign.templateHtml,
                    templateSubject: vm.communicationCampaign.templateSubject
                },
                availableVariables: angular.copy(vm.templateVariables),
                selectedChannel: vm.communicationCampaign.channel,
                contextType: 'COMMUNICATION_CAMPAIGN',
                contextEntityId: vm.communicationCampaign.id || null,
                contextLabel: vm.communicationCampaign.title || 'Communication campaign',
                contextMetadata: {
                    title: vm.communicationCampaign.title,
                    internalComment: vm.internalCommentNote,
                    desiredSendDate: vm.communicationCampaign.desiredSendDate,
                    contratCount: vm.isEdit ? vm.communicationCampaign.contratCount : (vm.communicationCampaign.contratIds || []).length
                }
            };
        }

        function registerPreviewWatchers() {
            $scope.$watchGroup([
                function() { return vm.communicationCampaign.channel; },
                function() { return vm.communicationCampaign.templateTxt; },
                function() { return vm.communicationCampaign.templateHtml; },
                function() { return vm.communicationCampaign.templateSubject; },
                function() { return (vm.communicationCampaign.contratIds || []).join(','); }
            ], function() {
                scheduleLivePreview();
            });

            $scope.$on('$destroy', function() {
                if (livePreviewPromise) {
                    $timeout.cancel(livePreviewPromise);
                }
            });
        }

        function scheduleLivePreview() {
            if (livePreviewPromise) {
                $timeout.cancel(livePreviewPromise);
            }
            if (!hasTemplateContent()) {
                vm.livePreview = buildEmptyLivePreview();
                return;
            }
            vm.livePreview.isLoading = true;
            livePreviewPromise = $timeout(refreshLivePreview, LIVE_PREVIEW_DELAY_MS);
        }

        function refreshLivePreview() {
            var requestId = ++livePreviewRequestId;
            CommunicationCampaign.preview(buildCampaignPreviewPayload()).$promise.then(function(preview) {
                if (requestId !== livePreviewRequestId) {
                    return;
                }
                vm.livePreview = {
                    isLoading: false,
                    hasContent: !!(preview && (preview.subject || preview.messageText || preview.messageHtml)),
                    error: null,
                    subject: preview && preview.subject ? preview.subject : '',
                    messageText: preview && preview.messageText ? preview.messageText : '',
                    messageHtml: preview && preview.messageHtml ? preview.messageHtml : '',
                    trustedMessageHtml: $sce.trustAsHtml(preview && preview.messageHtml ? preview.messageHtml : '')
                };
            }, function(response) {
                if (requestId !== livePreviewRequestId) {
                    return;
                }
                vm.livePreview = {
                    isLoading: false,
                    hasContent: false,
                    error: $translate.instant(response && response.data && response.data.message === 'error.unsafeTemplateHtml'
                        ? 'error.unsafeTemplateHtml' : 'wamasysApp.communicationCampaign.livePreviewError'),
                    subject: '',
                    messageText: '',
                    messageHtml: '',
                    trustedMessageHtml: $sce.trustAsHtml('')
                };
            });
        }

        function buildCampaignPreviewPayload() {
            var payload = angular.copy(vm.communicationCampaign);
            payload.internalComment = vm.internalCommentNote;
            return payload;
        }

        function buildEmptyLivePreview() {
            return {
                isLoading: false,
                hasContent: false,
                error: null,
                subject: '',
                messageText: '',
                messageHtml: '',
                trustedMessageHtml: $sce.trustAsHtml('')
            };
        }

        function hasTemplateContent() {
            return !!(vm.communicationCampaign.templateTxt || vm.communicationCampaign.templateHtml || vm.communicationCampaign.templateSubject);
        }

        function buildFiltersSnapshotForSave() {
            if (vm.isEdit && vm.savedFilters) {
                return vm.savedFilters;
            }
            return buildCampaignFiltersSnapshot(vm.contractSearchResult);
        }

        function buildCampaignFiltersSnapshot(searchResult) {
            var snapshot = {
                version: 1,
                contractCount: resolveContractCount(searchResult),
                filters: compactObject({
                    agence: buildSelectionSnapshot(vm.agenceNotPromise, 'nom'),
                    etat: emptyToNull(vm.etat),
                    compteurFerme: normalizeBoolean(vm.compteurFerme),
                    dateActivation: buildDateRangeSnapshot(),
                    hasEmail: normalizeBoolean(vm.hasEmail),
                    hasPhone: normalizeBoolean(vm.hasPhone),
                    portefeuilleContrat: buildSelectionSnapshot(vm.portefeuilleContratNotPromise, 'libelle'),
                    serviceVendu: buildSelectionSnapshot(vm.serviceVenduNotPromise, 'libelle'),
                    contractType: buildSelectionSnapshot(vm.contractTypeNotPromise, 'label'),
                    contractProfil: buildSelectionSnapshot(vm.contractProfilNotPromise, 'libelle'),
                    communicationTopic: buildSelectionSnapshot(vm.communicationTopicNotPromise, 'nomInterne'),
                    communicationTopicCategory: buildSelectionSnapshot(vm.communicationTopicCategoryNotPromise, 'label')
                })
            };
            if (!snapshot.filters) {
                snapshot.filters = {};
            }
            return snapshot;
        }

        function resolveContractCount(searchResult) {
            if (searchResult && angular.isDefined(searchResult.contractCount) && searchResult.contractCount !== null) {
                return searchResult.contractCount;
            }
            if (vm.communicationCampaign.contratCount) {
                return vm.communicationCampaign.contratCount;
            }
            return (vm.communicationCampaign.contratIds || []).length;
        }

        function buildSelectionSnapshot(values, labelField) {
            if (!values || !values.length) {
                return null;
            }
            return values.map(function(value) {
                return {
                    id: value.id,
                    label: value[labelField]
                };
            });
        }

        function buildDateRangeSnapshot() {
            var fromDate = $filter('date')(vm.date.startDate, 'yyyy-MM-dd');
            var toDate = $filter('date')(vm.date.endDate, 'yyyy-MM-dd');
            if (!fromDate && !toDate) {
                return null;
            }
            return {
                from: fromDate || null,
                to: toDate || null
            };
        }

        function normalizeBoolean(value) {
            if (value === '' || angular.isUndefined(value) || value === null) {
                return null;
            }
            return value === true || value === 'true';
        }

        function emptyToNull(value) {
            return value === '' || angular.isUndefined(value) ? null : value;
        }

        function compactObject(value) {
            var compacted = {};
            angular.forEach(value, function(entry, key) {
                if (angular.isArray(entry) && entry.length) {
                    compacted[key] = entry;
                    return;
                }
                if (angular.isObject(entry) && !angular.isArray(entry)) {
                    var nested = compactObject(entry);
                    if (nested) {
                        compacted[key] = nested;
                    }
                    return;
                }
                if (entry !== null && !angular.isUndefined(entry) && entry !== '') {
                    compacted[key] = entry;
                }
            });
            return Object.keys(compacted).length ? compacted : null;
        }

        function updateSavedFilters(filters) {
            vm.savedFilters = filters;
            vm.savedFiltersJson = filters ? angular.toJson(filters, true) : '';
            vm.savedFiltersSummary = buildSavedFiltersSummary(filters);
        }

        function buildSavedFiltersSummary(filters) {
            var summary = [];
            if (!filters) {
                return summary;
            }
            summary.push({
                label: 'Contrats',
                value: String(filters.contractCount || 0)
            });
            appendSummaryValue(summary, 'Zones', filters.filters && filters.filters.agence);
            appendSummaryValue(summary, 'Etat', filters.filters && filters.filters.etat);
            appendSummaryValue(summary, 'Compteur ferme', filters.filters && filters.filters.compteurFerme);
            appendSummaryValue(summary, 'Date activation', filters.filters && filters.filters.dateActivation);
            appendSummaryValue(summary, 'Email', filters.filters && filters.filters.hasEmail);
            appendSummaryValue(summary, 'Telephone', filters.filters && filters.filters.hasPhone);
            appendSummaryValue(summary, 'Portefeuilles', filters.filters && filters.filters.portefeuilleContrat);
            appendSummaryValue(summary, 'Services', filters.filters && filters.filters.serviceVendu);
            appendSummaryValue(summary, 'Types de contrat', filters.filters && filters.filters.contractType);
            appendSummaryValue(summary, 'Profils', filters.filters && filters.filters.contractProfil);
            appendSummaryValue(summary, 'Topics', filters.filters && filters.filters.communicationTopic);
            appendSummaryValue(summary, 'Categories', filters.filters && filters.filters.communicationTopicCategory);
            return summary;
        }

        function appendSummaryValue(summary, label, value) {
            var formatted = formatSummaryValue(value);
            if (!formatted) {
                return;
            }
            summary.push({
                label: label,
                value: formatted
            });
        }

        function formatSummaryValue(value) {
            if (angular.isArray(value)) {
                return value.map(function(item) {
                    return item.label || item.id;
                }).join(', ');
            }
            if (angular.isObject(value)) {
                if (angular.isDefined(value.from) || angular.isDefined(value.to)) {
                    return [value.from || '?', value.to || '?'].join(' -> ');
                }
                return angular.toJson(value);
            }
            if (value === true) {
                return 'Oui';
            }
            if (value === false) {
                return 'Non';
            }
            return value;
        }

        function parseStoredComment() {
            var parsed = parseStoredInternalComment(vm.communicationCampaign.internalComment);
            vm.internalCommentNote = parsed.note;
            updateSavedFilters(parsed.filters);
        }

        function parseStoredInternalComment(value) {
            var comment = value || '';
            var markerIndex = comment.indexOf(FILTERS_MARKER);
            var parsedFilters = null;
            var note = comment;

            if (markerIndex >= 0) {
                note = comment.substring(0, markerIndex).replace(/\s+$/, '');
                try {
                    parsedFilters = angular.fromJson(comment.substring(markerIndex + FILTERS_MARKER.length).trim());
                } catch (e) {
                    parsedFilters = null;
                }
            }

            return {
                note: note || '',
                filters: parsedFilters
            };
        }

        function composeStoredInternalComment(note, filters) {
            var parts = [];
            var trimmedNote = (note || '').replace(/\s+$/, '');
            if (trimmedNote) {
                parts.push(trimmedNote);
            }
            parts.push(FILTERS_MARKER + '\n' + angular.toJson(filters || { version: 1, contractCount: 0, filters: {} }, true));
            return parts.join('\n\n');
        }

        function hashString(value) {
            var stringValue = value || '';
            var hash = 0;
            var i;
            var chr;
            for (i = 0; i < stringValue.length; i++) {
                chr = stringValue.charCodeAt(i);
                hash = ((hash << 5) - hash) + chr;
                hash |= 0;
            }
            return hash;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationCampaignCancelController', CommunicationCampaignCancelController);

    CommunicationCampaignCancelController.$inject = ['$uibModalInstance', 'entity', 'CommunicationCampaign'];

    function CommunicationCampaignCancelController($uibModalInstance, entity, CommunicationCampaign) {
        var vm = this;
        vm.communicationCampaign = entity;
        vm.clear = clear;
        vm.confirmCancel = confirmCancel;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmCancel(id) {
            CommunicationCampaign.cancel({ id: id }, function() {
                $uibModalInstance.close(true);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('communication-topic', {
            parent: 'entity',
            url: '/communication-topic?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.communicationTopic.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/communication-topic/communication-topics.html',
                    controller: 'CommunicationTopicController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communication');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('communication-topic-detail', {
            parent: 'entity',
            url: '/communication-topic/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.communicationTopic.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/communication-topic/communication-topic-detail.html',
                    controller: 'CommunicationTopicDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communication');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CommunicationTopic', function($stateParams, CommunicationTopic) {
                    return CommunicationTopic.get({id : $stateParams.id});
                }]
            }
        })
        .state('communication-topic.new', {
            parent: 'communication-topic',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/communication-topic/communication-topic-dialog.html',
                    controller: 'CommunicationTopicDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('communication-topic', null, { reload: true });
                }, function() {
                    $state.go('communication-topic');
                });
            }]
        })
        .state('communication-topic.edit', {
            parent: 'communication-topic',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/communication-topic/communication-topic-dialog.html',
                    controller: 'CommunicationTopicDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CommunicationTopic', function(CommunicationTopic) {
                            return CommunicationTopic.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-topic', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('communication-topic.delete', {
            parent: 'communication-topic',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/communication-topic/communication-topic-delete-dialog.html',
                    controller: 'CommunicationTopicDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CommunicationTopic', function(CommunicationTopic) {
                            return CommunicationTopic.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-topic', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('CommunicationTopic', CommunicationTopic);

    CommunicationTopic.$inject = ['$resource'];

    function CommunicationTopic ($resource) {
        var resourceUrl =  'api/communication-topic/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getChannel': {
            	url:'api/channel',
                method: 'GET',
                isArray: true
            },
            'byAgence': {
                url: 'api/communication-topic/by-agence/:agenceId',
                method: 'GET',
                isArray: true
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationTopicController', CommunicationTopicController);

    CommunicationTopicController.$inject = ['$scope', '$state', 'CommunicationTopic', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CommunicationTopicController ($scope, $state, CommunicationTopic, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            CommunicationTopic.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.communicationTopics = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationTopicDialogController', CommunicationTopicDialogController);

    CommunicationTopicDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'CommunicationTopic', 'CommunicationTopicCategory'];

    function CommunicationTopicDialogController ($scope, $stateParams, $uibModalInstance, entity, CommunicationTopic, CommunicationTopicCategory) {
        var vm = this;
        vm.communicationTopic = entity;
        vm.contractContacts = [
            { value: 'PHONE' },
            { value: 'EMAIL' }
        ];
        vm.load = function(id) {
            CommunicationTopic.get({id : id}, function(result) {
                vm.communicationTopic = result;
            });
        };

        vm.communicationTopicCategorys  = CommunicationTopicCategory.query();
        
        
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:communicationTopicUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.communicationTopic.id !== null) {
                CommunicationTopic.update(vm.communicationTopic, onSaveSuccess, onSaveError);
            } else {
                CommunicationTopic.save(vm.communicationTopic, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationTopicDetailController', CommunicationTopicDetailController);

    CommunicationTopicDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CommunicationTopic'];

    function CommunicationTopicDetailController($scope, $rootScope, $stateParams, entity, CommunicationTopic) {
        var vm = this;
        vm.communicationTopic = entity;
        vm.load = function (id) {
            CommunicationTopic.get({id: id}, function(result) {
                vm.communicationTopic = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:communicationTopicUpdate', function(event, result) {
            vm.communicationTopic = result;
        });
        
        
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationTopicDeleteController',CommunicationTopicDeleteController);

    CommunicationTopicDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationTopic'];

    function CommunicationTopicDeleteController($uibModalInstance, entity, CommunicationTopic) {
        var vm = this;
        vm.communicationTopic = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CommunicationTopic.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('batch-jobs-monitoring', {
            parent: 'entity',
            url: '/batch-jobs-monitoring',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN'],
                pageTitle:'Suivi batch'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/batch-jobs/batch-jobs.html',
                    controller: 'BatchJobsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        
        
        
        ;
    }

})();
;
(function() {
    'use strict';
    angular
    .module('wamasysApp')
    .factory('BatchJobs', BatchJobs);
	
    BatchJobs.$inject = ['$resource'];
	
	function BatchJobs($resource) {
	    return $resource('api/batch-jobs/monitoring', {}, {
	        'query': { method: 'GET', isArray: true },
	        'summary': {
	            method: 'GET',
	            url: 'api/batch-jobs/monitoring-summary'
	        }
	    });
	}

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .controller('BatchJobsController', BatchJobsController);

    BatchJobsController.$inject = ['BatchJobs', '$interval', 'ParseLinks', 'paginationConstants'];

    function BatchJobsController(BatchJobs, $interval, ParseLinks, paginationConstants) {

        var vm = this;

        vm.batchJobs = [];
        vm.etat = null;
        vm.isLoading = false;
        vm.links = {};
        vm.page = 0;
        vm.summary = {};
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.refresh = refresh;
        vm.search = search;

        refresh();

        // Rafraichissement automatique toutes les 60s.
        $interval(refresh, 60000);

        function loadAll() {
            if (vm.isLoading) {
                return;
            }
            vm.isLoading = true;
            BatchJobs.query({
                page: vm.page,
                size: paginationConstants.itemsPerPage,
                etat: resolveEtatFilter()
            }, onSuccess, onError);
        }

        function loadPage(page) {
            if (angular.isDefined(page) && page !== vm.page) {
                vm.page = page;
                loadAll();
            }
        }

        function refresh() {
            vm.page = 0;
            vm.links = {};
            vm.totalItems = 0;
            vm.batchJobs = [];
            loadSummary();
            loadAll();
        }

        function search() {
            refresh();
        }

        function loadSummary() {
            BatchJobs.summary({
                etat: resolveEtatFilter()
            }, function(result) {
                vm.summary = result;
            });
        }

        function resolveEtatFilter() {
            return vm.etat ? vm.etat : null;
        }

        function onSuccess(result, headers) {
            var linkHeader = headers('link');
            vm.links = linkHeader ? ParseLinks.parse(linkHeader) : {};
            vm.totalItems = headers('X-Total-Count');
            vm.batchJobs = vm.batchJobs.concat(result);
            vm.isLoading = false;
        }

        function onError() {
            vm.isLoading = false;
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('communication-automation-conf', {
            parent: 'entity',
            url: '/communication-automation-conf?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_AREA_MANAGEMENT','ROLE_AREA_CONFIGURATION'],
                pageTitle: 'wamasysApp.communicationAutomationConf.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/communication-automation-conf/communication-automation-confs.html',
                    controller: 'CommunicationAutomationConfController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communication');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('communication-automation-conf-detail', {
            parent: 'entity',
            url: '/communication-automation-conf/{id}',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN','ROLE_AREA_MANAGEMENT','ROLE_AREA_CONFIGURATION'],
                pageTitle: 'wamasysApp.communicationAutomationConf.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/communication-automation-conf/communication-automation-conf-detail.html',
                    controller: 'CommunicationAutomationConfDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communication');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CommunicationAutomationConf', function($stateParams, CommunicationAutomationConf) {
                    return CommunicationAutomationConf.get({id : $stateParams.id});
                }]
            }
        })
        .state('communication-automation-conf.new', {
            parent: 'communication-automation-conf',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_AREA_MANAGEMENT']
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/communication-automation-conf/communication-automation-conf-form.html',
                    controller: 'CommunicationAutomationConfFormController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communication');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        delayHour: 1,
                        id: null,
                        type: 'BILLING_NOTICE'
                    };
                }
            }
        })
        .state('communication-automation-conf.edit', {
            parent: 'communication-automation-conf',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_AREA_MANAGEMENT']
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/communication-automation-conf/communication-automation-conf-form.html',
                    controller: 'CommunicationAutomationConfFormController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communication');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CommunicationAutomationConf', function($stateParams, CommunicationAutomationConf) {
                    return CommunicationAutomationConf.get({id : $stateParams.id});
                }]
            }
        })
        .state('communication-automation-conf.delete', {
            parent: 'communication-automation-conf',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/communication-automation-conf/communication-automation-conf-delete-dialog.html',
                    controller: 'CommunicationAutomationConfDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CommunicationAutomationConf', function(CommunicationAutomationConf) {
                            return CommunicationAutomationConf.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-automation-conf', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('CommunicationAutomationConf', CommunicationAutomationConf);

    CommunicationAutomationConf.$inject = ['$resource','DateUtils'];

    function CommunicationAutomationConf ($resource,DateUtils) {
        var resourceUrl =  'api/communication-automation-conf/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.frequencePeriodNextDate = DateUtils.convertLocalDateFromServer(data.frequencePeriodNextDate);
                    data.lastExecutionDate = DateUtils.convertLocalDateFromServer(data.lastExecutionDate);
                    return data;
                }
            },
            'getChannel': {
            	url:'api/channel',
                method: 'GET',
                isArray: true
            },
            'preview': {
                url: 'api/communication-automation-conf/preview',
                method: 'POST'
            },
            'chatAssistant': {
                url: 'api/communication-automation-conf/assistant/chat',
                method: 'POST',
                transformRequest: function(data) {
                    return angular.toJson(data);
                }
            },
            'getAssistantUsage': {
                url: 'api/communication-automation-conf/assistant/usage',
                method: 'GET'
            },
            'submitAssistantFeedback': {
                url: 'api/communication-automation-conf/assistant/feedback',
                method: 'POST',
                transformRequest: function(data) {
                    return angular.toJson(data);
                }
            },
            'update': { method:'PUT' ,
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.frequencePeriodNextDate = DateUtils.convertLocalDateToServer(data.frequencePeriodNextDate);
                	clonedData.lastExecutionDate = DateUtils.convertLocalDateToServer(data.lastExecutionDate);
                    return angular.toJson(clonedData);
                } }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationAutomationConfController', CommunicationAutomationConfController);

    CommunicationAutomationConfController.$inject = ['$scope', '$state', 'CommunicationAutomationConf', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CommunicationAutomationConfController ($scope, $state, CommunicationAutomationConf, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            CommunicationAutomationConf.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.communicationAutomationConfs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationAutomationConfFormController', CommunicationAutomationConfFormController);

    CommunicationAutomationConfFormController.$inject = ['$scope', '$state', '$timeout', '$sce', '$window', 'entity',
        'CommunicationAutomationConf', 'ChannelConf', 'Principal', 'AssistantPanelService', '$translate'];

    function CommunicationAutomationConfFormController($scope, $state, $timeout, $sce, $window, entity,
        CommunicationAutomationConf, ChannelConf, Principal, AssistantPanelService, $translate) {
        var LIVE_PREVIEW_DELAY_MS = 400;
        var livePreviewPromise;
        var livePreviewRequestId = 0;
        var vm = this;
        vm.communicationAutomationConf = entity;
        vm.isEdit = !!vm.communicationAutomationConf.id;
        vm.channels = [];
        vm.showTemplateHelp = false;
        vm.canUseAssistant = false;
        vm.livePreview = buildEmptyLivePreview();
        vm.channelConfs = ChannelConf.query({ page: 0, size: 1000, sort: 'nom,asc' });
        vm.save = save;
        vm.clear = clear;
        vm.getSelectedChannelConf = getSelectedChannelConf;
        vm.getSelectedChannel = getSelectedChannel;
        vm.toggleTemplateHelp = toggleTemplateHelp;
        vm.getAvailableVariables = getAvailableVariables;
        vm.previewMessage = previewMessage;
        vm.openAssistantChat = openAssistantChat;

        vm.channels = CommunicationAutomationConf.getChannel();

        Principal.identity().then(function(account) {
            if (account) {
                vm.canUseAssistant = (account.modules || []).indexOf('AI_ASSISTANT') !== -1
                    && (account.authorities.indexOf('ROLE_AI_ASSISTANT') !== -1
                    || account.authorities.indexOf('ROLE_ADMIN') !== -1
                    || account.authorities.indexOf('ROLE_SUPER_ADMIN') !== -1);
            }
        });

        registerPreviewWatchers();
        scheduleLivePreview();

        function save() {
            vm.isSaving = true;
            if (vm.communicationAutomationConf.id !== null) {
                CommunicationAutomationConf.update(vm.communicationAutomationConf, onSaveSuccess, onSaveError);
            } else {
                CommunicationAutomationConf.save(vm.communicationAutomationConf, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            $state.go('communication-automation-conf', null, { reload: true });
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function clear() {
            AssistantPanelService.close();
            $state.go('communication-automation-conf');
        }

        function getSelectedChannelConf() {
            if (!vm.communicationAutomationConf.channelConfId || !vm.channelConfs) {
                return null;
            }

            for (var i = 0; i < vm.channelConfs.length; i++) {
                if (vm.channelConfs[i].id === vm.communicationAutomationConf.channelConfId) {
                    return vm.channelConfs[i];
                }
            }
            return null;
        }

        function getSelectedChannel() {
            var channelConf = getSelectedChannelConf();
            return channelConf ? channelConf.channel : null;
        }

        function toggleTemplateHelp() {
            vm.showTemplateHelp = !vm.showTemplateHelp;
        }

        function getAvailableVariables() {
            var commonVariables = [
                '${contractRef}',
                '${contractName}',
                '${contractAddress}',
                '${amountBilled}',
                '${totalToBePaid}',
                '${servicesToBePaid}',
                '${taxesToBePaid}',
                '${servicesToBePaidHtml}',
                '${taxesToBePaidHtml}',
                '${dateNow}',
                '${billingDate}',
                '${billingPeriodStart}',
                '${billingPeriodEnd}'
            ];

            if (vm.communicationAutomationConf.type === 'PAYMENT_RECEIPT') {
                return commonVariables.concat([
                    '${paid}',
                    '${receiptId}',
                    '${paymentDate}'
                ]);
            }

            return commonVariables;
        }

        function previewMessage() {
            CommunicationAutomationConf.preview(vm.communicationAutomationConf).$promise.then(function(preview) {
                if (preview.subject) {
                    openInNewWindow('<html><head><title>Subject preview</title></head><body><h2>Subject :</h2> ' + preview.subject + ' <hr/></body></html>');
                }

                if (preview.messageHtml) {
                    openInNewWindow(preview.messageHtml);
                }

                if (preview.messageText) {
                    openInNewWindow('<html><head><title>Preview</title></head><body><textarea rows="10" cols="80">' + preview.messageText + '</textarea></body></html>');
                }
            });
        }

        function openAssistantChat() {
            if (!vm.canUseAssistant) {
                return;
            }

            AssistantPanelService.open({
                contextType: 'COMMUNICATION_TEMPLATE',
                entityId: vm.communicationAutomationConf.id || 0,
                title: $translate.instant('global.assistant.templateTitle'),
                subtitle: vm.communicationAutomationConf.type || 'Communication',
                promptPlaceholder: $translate.instant('global.assistant.templatePromptPlaceholder'),
                supportsActionProposal: false,
                supportsDataScopes: false,
                adapter: {
                    chat: function(payload, success, error) {
                        CommunicationAutomationConf.chatAssistant(buildAssistantRequest(payload), success, error);
                    },
                    getUsage: function(success, error) {
                        CommunicationAutomationConf.getAssistantUsage(success, error);
                    },
                    submitFeedback: function(payload, success, error) {
                        CommunicationAutomationConf.submitAssistantFeedback(payload, success, error);
                    },
                    applyAssistantResponse: function(result) {
                        if (!result || !result.suggestedFieldValues) {
                            return;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template) && result.suggestedFieldValues.template !== null) {
                            vm.communicationAutomationConf.template = result.suggestedFieldValues.template;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template_html) && result.suggestedFieldValues.template_html !== null) {
                            vm.communicationAutomationConf.templateHtml = result.suggestedFieldValues.template_html;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template_subject) && result.suggestedFieldValues.template_subject !== null) {
                            vm.communicationAutomationConf.templateSubject = result.suggestedFieldValues.template_subject;
                        }
                        AssistantPanelService.invalidateConversationContext();
                        $scope.$evalAsync();
                    },
                    buildContextSignatureFragment: function() {
                        return [
                            vm.communicationAutomationConf.type || '',
                            getSelectedChannel() || '',
                            hashString(vm.communicationAutomationConf.template || ''),
                            hashString(vm.communicationAutomationConf.templateHtml || ''),
                            hashString(vm.communicationAutomationConf.templateSubject || '')
                        ].join('|');
                    }
                }
            });
        }

        function buildAssistantRequest(payload) {
            return {
                assistantRequest: payload,
                communicationAutomationConf: angular.copy(vm.communicationAutomationConf),
                selectedChannel: getSelectedChannel(),
                availableVariables: getAvailableVariables(),
                contextType: 'COMMUNICATION_TEMPLATE',
                contextEntityId: vm.communicationAutomationConf.id || null,
                contextLabel: vm.communicationAutomationConf.type || 'Communication',
                contextMetadata: {
                    type: vm.communicationAutomationConf.type,
                    channel: getSelectedChannel()
                }
            };
        }

        function registerPreviewWatchers() {
            $scope.$watchGroup([
                function() { return vm.communicationAutomationConf.channelConfId; },
                function() { return vm.communicationAutomationConf.template; },
                function() { return vm.communicationAutomationConf.templateHtml; },
                function() { return vm.communicationAutomationConf.templateSubject; },
                function() { return vm.communicationAutomationConf.type; }
            ], function() {
                scheduleLivePreview();
            });

            $scope.$on('$destroy', function() {
                if (livePreviewPromise) {
                    $timeout.cancel(livePreviewPromise);
                }
            });
        }

        function scheduleLivePreview() {
            if (livePreviewPromise) {
                $timeout.cancel(livePreviewPromise);
            }
            if (!hasTemplateContent()) {
                vm.livePreview = buildEmptyLivePreview();
                return;
            }
            vm.livePreview.isLoading = true;
            livePreviewPromise = $timeout(refreshLivePreview, LIVE_PREVIEW_DELAY_MS);
        }

        function refreshLivePreview() {
            var requestId = ++livePreviewRequestId;
            CommunicationAutomationConf.preview(vm.communicationAutomationConf).$promise.then(function(preview) {
                if (requestId !== livePreviewRequestId) {
                    return;
                }
                vm.livePreview = {
                    isLoading: false,
                    hasContent: !!(preview && (preview.subject || preview.messageText || preview.messageHtml)),
                    error: null,
                    subject: preview && preview.subject ? preview.subject : '',
                    messageText: preview && preview.messageText ? preview.messageText : '',
                    messageHtml: preview && preview.messageHtml ? preview.messageHtml : '',
                    trustedMessageHtml: $sce.trustAsHtml(preview && preview.messageHtml ? preview.messageHtml : '')
                };
            }, function(response) {
                if (requestId !== livePreviewRequestId) {
                    return;
                }
                vm.livePreview = {
                    isLoading: false,
                    hasContent: false,
                    error: $translate.instant(response && response.data && response.data.message === 'error.unsafeTemplateHtml'
                        ? 'error.unsafeTemplateHtml' : 'wamasysApp.communicationCampaign.livePreviewError'),
                    subject: '',
                    messageText: '',
                    messageHtml: '',
                    trustedMessageHtml: $sce.trustAsHtml('')
                };
            });
        }

        function buildEmptyLivePreview() {
            return {
                isLoading: false,
                hasContent: false,
                error: null,
                subject: '',
                messageText: '',
                messageHtml: '',
                trustedMessageHtml: $sce.trustAsHtml('')
            };
        }

        function hasTemplateContent() {
            return !!(vm.communicationAutomationConf.template || vm.communicationAutomationConf.templateHtml || vm.communicationAutomationConf.templateSubject);
        }

        function hashString(value) {
            var stringValue = value || '';
            var hash = 0;
            var i;
            var chr;
            for (i = 0; i < stringValue.length; i++) {
                chr = stringValue.charCodeAt(i);
                hash = ((hash << 5) - hash) + chr;
                hash |= 0;
            }
            return hash;
        }

        function openInNewWindow(content) {
            var newWindow = $window.open('', '_blank');

            newWindow.document.open();
            newWindow.document.write(content);
            newWindow.document.close();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationAutomationConfDialogController', CommunicationAutomationConfDialogController);

    CommunicationAutomationConfDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', '$window', 'entity',
        'CommunicationAutomationConf', 'ChannelConf', 'Principal', 'AssistantPanelService', '$translate'];

    function CommunicationAutomationConfDialogController($scope, $stateParams, $uibModalInstance, $window, entity,
        CommunicationAutomationConf, ChannelConf, Principal, AssistantPanelService, $translate) {
        var vm = this;
        vm.communicationAutomationConf = entity;
        vm.channels = [];
        vm.showTemplateHelp = false;
        vm.canUseAssistant = false;
        vm.load = function(id) {
            CommunicationAutomationConf.get({id : id}, function(result) {
                vm.communicationAutomationConf = result;
            });
        };

        vm.channelConfs  = ChannelConf.query();
        vm.channels = CommunicationAutomationConf.getChannel();
        vm.save = save;
        vm.clear = clear;
        vm.getSelectedChannelConf = getSelectedChannelConf;
        vm.getSelectedChannel = getSelectedChannel;
        vm.toggleTemplateHelp = toggleTemplateHelp;
        vm.getAvailableVariables = getAvailableVariables;
        vm.previewMessage = previewMessage;
        vm.openAssistantChat = openAssistantChat;

        Principal.identity().then(function(account) {
            if (account) {
                vm.canUseAssistant = (account.modules || []).indexOf('AI_ASSISTANT') !== -1
                    && (account.authorities.indexOf('ROLE_AI_ASSISTANT') !== -1
                    || account.authorities.indexOf('ROLE_ADMIN') !== -1
                    || account.authorities.indexOf('ROLE_SUPER_ADMIN') !== -1);
            }
        });

        function save() {
            vm.isSaving = true;
            if (vm.communicationAutomationConf.id !== null) {
                CommunicationAutomationConf.update(vm.communicationAutomationConf, onSaveSuccess, onSaveError);
            } else {
                CommunicationAutomationConf.save(vm.communicationAutomationConf, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('wamasysApp:communicationAutomationConfUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function clear() {
            AssistantPanelService.close();
            $uibModalInstance.dismiss('cancel');
        }

        function getSelectedChannelConf() {
            if (!vm.communicationAutomationConf.channelConfId || !vm.channelConfs) {
                return null;
            }

            for (var i = 0; i < vm.channelConfs.length; i++) {
                if (vm.channelConfs[i].id === vm.communicationAutomationConf.channelConfId) {
                    return vm.channelConfs[i];
                }
            }
            return null;
        }

        function getSelectedChannel() {
            var channelConf = getSelectedChannelConf();
            return channelConf ? channelConf.channel : null;
        }

        function toggleTemplateHelp() {
            vm.showTemplateHelp = !vm.showTemplateHelp;
        }

        function getAvailableVariables() {
            var commonVariables = [
                '${contractRef}',
                '${contractName}',
                '${contractAddress}',
                '${amountBilled}',
                '${totalToBePaid}',
                '${servicesToBePaid}',
                '${taxesToBePaid}',
                '${servicesToBePaidHtml}',
                '${taxesToBePaidHtml}',
                '${dateNow}',
				'${billingDate}',
				'${billingPeriodStart}',
				'${billingPeriodEnd}'
            ];

            if (vm.communicationAutomationConf.type === 'PAYMENT_RECEIPT') {
                return commonVariables.concat([
                    '${paid}',
                    '${receiptId}',
                    '${paymentDate}'
                ]);
            }

            return commonVariables;
        }

        function previewMessage() {
            CommunicationAutomationConf.preview(vm.communicationAutomationConf).$promise.then(function(preview) {
                if (preview.subject) {
                    openInNewWindow(
                        '<html>' +
                        '<head><title>Subject preview</title></head>' +
                        '<body>' +
                        '<h2>Subject :</h2> ' + preview.subject + ' <hr/>' +
                        '</body>' +
                        '</html>'
                    );
                }

                if (preview.messageHtml) {
                    openInNewWindow(preview.messageHtml);
                }

                if (preview.messageText) {
                    openInNewWindow(
                        '<html>' +
                        '<head><title>Preview</title></head>' +
                        '<body>' +
                        '<textarea rows="10" cols="80">' + preview.messageText + '</textarea>' +
                        '</body>' +
                        '</html>'
                    );
                }
            });
        }

        function openAssistantChat() {
            if (!vm.canUseAssistant) {
                return;
            }

            AssistantPanelService.open({
                contextType: 'COMMUNICATION_TEMPLATE',
                entityId: vm.communicationAutomationConf.id || 0,
                title: $translate.instant('global.assistant.templateTitle'),
                subtitle: vm.communicationAutomationConf.type || 'Communication',
                promptPlaceholder: $translate.instant('global.assistant.templatePromptPlaceholder'),
                supportsActionProposal: false,
                supportsDataScopes: false,
                adapter: {
                    chat: function(payload, success, error) {
                        CommunicationAutomationConf.chatAssistant(buildAssistantRequest(payload), success, error);
                    },
                    getUsage: function(success, error) {
                        CommunicationAutomationConf.getAssistantUsage(success, error);
                    },
                    submitFeedback: function(payload, success, error) {
                        CommunicationAutomationConf.submitAssistantFeedback(payload, success, error);
                    },
                    applyAssistantResponse: function(result) {
                        if (!result || !result.suggestedFieldValues) {
                            return;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template) && result.suggestedFieldValues.template !== null) {
                            vm.communicationAutomationConf.template = result.suggestedFieldValues.template;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template_html) && result.suggestedFieldValues.template_html !== null) {
                            vm.communicationAutomationConf.templateHtml = result.suggestedFieldValues.template_html;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template_subject) && result.suggestedFieldValues.template_subject !== null) {
                            vm.communicationAutomationConf.templateSubject = result.suggestedFieldValues.template_subject;
                        }
                        AssistantPanelService.invalidateConversationContext();
                        $scope.$evalAsync();
                    },
                    buildContextSignatureFragment: function() {
                        return [
                            vm.communicationAutomationConf.type || '',
                            getSelectedChannel() || '',
                            hashString(vm.communicationAutomationConf.template || ''),
                            hashString(vm.communicationAutomationConf.templateHtml || ''),
                            hashString(vm.communicationAutomationConf.templateSubject || '')
                        ].join('|');
                    }
                }
            });
        }

        function buildAssistantRequest(payload) {
            return {
                assistantRequest: payload,
                communicationAutomationConf: angular.copy(vm.communicationAutomationConf),
                selectedChannel: getSelectedChannel(),
                availableVariables: getAvailableVariables(),
                contextType: 'COMMUNICATION_TEMPLATE',
                contextEntityId: vm.communicationAutomationConf.id || null,
                contextLabel: vm.communicationAutomationConf.type || 'Communication',
                contextMetadata: {
                    type: vm.communicationAutomationConf.type,
                    channel: getSelectedChannel()
                }
            };
        }

        function hashString(value) {
            var stringValue = value || '';
            var hash = 0;
            var i;
            var chr;
            for (i = 0; i < stringValue.length; i++) {
                chr = stringValue.charCodeAt(i);
                hash = ((hash << 5) - hash) + chr;
                hash |= 0;
            }
            return hash;
        }

        function openInNewWindow(content) {
            var newWindow = $window.open('', '_blank');

            newWindow.document.open();
            newWindow.document.write(content);
            newWindow.document.close();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationAutomationConfDetailController', CommunicationAutomationConfDetailController);

    CommunicationAutomationConfDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CommunicationAutomationConf'];

    function CommunicationAutomationConfDetailController($scope, $rootScope, $stateParams, entity, CommunicationAutomationConf) {
        var vm = this;
        vm.communicationAutomationConf = entity;
        vm.load = function (id) {
            CommunicationAutomationConf.get({id: id}, function(result) {
                vm.communicationAutomationConf = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:communicationAutomationConfUpdate', function(event, result) {
            vm.communicationAutomationConf = result;
        });
        
        
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationAutomationConfDeleteController',CommunicationAutomationConfDeleteController);

    CommunicationAutomationConfDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationAutomationConf'];

    function CommunicationAutomationConfDeleteController($uibModalInstance, entity, CommunicationAutomationConf) {
        var vm = this;
        vm.communicationAutomationConf = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CommunicationAutomationConf.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('collection-liste', {
            parent: 'entity',
            url: '/collection-liste?page&sort&search&etat&collecteur&startDate&endDate',
            data: {
                authenticate: true,
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.collectionListe.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/collection-liste/collection-listes.html',
                    controller: 'CollectionListeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'referenceCollectionList,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('collectionListe');
                    $translatePartialLoader.addPart('etatCollectionList');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('collection-liste-detail', {
            parent: 'entity',
            url: '/collection-liste/{id}',
            data: {
                authenticate: true,
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.collectionListe.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/collection-liste/collection-liste-detail.html',
                    controller: 'CollectionListeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('collectionListe');
                    $translatePartialLoader.addPart('etatCollectionList');
                    $translatePartialLoader.addPart('contrat');
                    return $translate.refresh();
                }]
            /*,
                entity: ['$stateParams', 'CollectionListe', function($stateParams, CollectionListe) {
                    return CollectionListe.get({id : $stateParams.id});
                }]*/
            }
        })
        .state('collection-liste-map', {
            parent: 'entity',
            url: '/collection-liste/{id}/map',
            data: {
                authenticate: true,
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.collectionListe.map.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/collection-liste/collection-liste-map.html',
                    controller: 'CollectionListeMapController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('collectionListe');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('collection-liste.new', {
            parent: 'collection-liste',
            url: '/new',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/collection-liste/collection-liste-dialog.html',
                    controller: 'CollectionListeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                            	collecteur: null,
                                dateFinPeriode: null,
                                listPortefeuilleContratDTO: null
                              //  etat: null,
                               // id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('collection-liste', null, { reload: true });
                }, function() {
                    $state.go('collection-liste');
                });
            }]
        })
        .state('collection-liste.delete', {
            parent: 'collection-liste',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/collection-liste/collection-liste-delete-dialog.html',
                    controller: 'CollectionListeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CollectionListe', function(CollectionListe) {
                            return {id : $stateParams.id};
                        }]
                    }
                }).result.then(function() {
                    $state.go('collection-liste', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('CollectionListe', CollectionListe);

    CollectionListe.$inject = ['$resource', 'DateUtils'];

    function CollectionListe ($resource, DateUtils) {
        var resourceUrl =  'api/collection-listes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateFinPeriode = DateUtils.convertLocalDateFromServer(data.dateFinPeriode);
                    return data;
                }
            },
            'getPaymentReceived' :{
           	 	method:'GET', 
           	 	url :'api/payment-received/:id'
           },
           'paymentCorrection': {
               method: 'POST',
          	    url :'api/payment-received/correction'
 
           },
           
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.dateFinPeriode = DateUtils.convertLocalDateToServer(data.dateFinPeriode);
                    return angular.toJson(clonedData);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.dateFinPeriode = DateUtils.convertLocalDateToServer(data.dateFinPeriode);
                    return angular.toJson(clonedData);
                }

            },
             'valider' :{
            	 method:'GET', 
            	 url :'api/collection-listes/valider/:id'
            },
           'collectionListeValideByContrat' :{
           	 method:'GET', 
           	isArray: true,
           	 url :'api/contrat/:id/collection-listes-valide'
           },
           'billingHistoryByContrat' :{
           	 method:'GET',
           	 isArray: true,
           	 url :'api/contrat/:id/billing-history'
           },
           'collectionListeEnCoursByContrat' :{
             	 method:'GET', 
             	isArray: true,
             	 url :'api/contrat/:id/collection-liste-en-cours'
             },
           'reportCollectionListeByCollecteur' :{
             	 method:'GET', 
             	 isArray: true,
             	 url :'api/collection-listes/par-collecteur'
             },
           'downloadSignature' :{
             	 method:'GET', 
             	 //isArray: true,
             	 responseType: 'arraybuffer',
                 headers: {
                 	'Content-Type': undefined
                 },
                 cache: false,
                 transformResponse: function (data) {
                     return {
                       response: new Blob([data], {type: 'image/jpeg'})
                     };
                 },
             	 url :'api/collection-listes/:idAgence/signature/:idCl/:idContratCl'
             }
            
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('CollectionListeSearch', CollectionListeSearch);

    CollectionListeSearch.$inject = ['$resource'];

    function CollectionListeSearch($resource) {
        var resourceUrl =  'api/collection-listes/search/';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CollectionListeController', CollectionListeController);

    CollectionListeController.$inject = ['$scope', '$state', '$filter', 'CollectionListeSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'Collecteur'];

    function CollectionListeController ($scope, $state, $filter, CollectionListeSearch, ParseLinks, AlertService, pagingParams, paginationConstants, Collecteur ) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.search = search;
        vm.clear = clear;
        vm.getMapUrl = getMapUrl;
        vm.collecteurs = Collecteur.query({sort: 'login,asc'});
        if($state.params.etat){
        	vm.etat = $state.params.etat;
        }else{
        //	vm.etat = "VALIDE";
        }
        if($state.params.collecteur){
        	vm.collecteur = {
        			id:$state.params.collecteur
        	};
            if (vm.collecteurs && vm.collecteurs.$promise) {
                vm.collecteurs.$promise.then(function(collecteurs) {
                    var collecteurSelectionne = collecteurs.find(function(collecteur) {
                        return String(collecteur.id) === String($state.params.collecteur);
                    });
                    if (collecteurSelectionne) {
                        vm.collecteur = collecteurSelectionne;
                    }
                });
            }
        }
	   	vm.date = {
	            startDate: $state.params.startDate?new Date($state.params.startDate):null,
	            endDate: $state.params.endDate?new Date($state.params.endDate):null
	    }
        vm.loadAll();


        function loadAll () {
        	CollectionListeSearch.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                etat:vm.etat,
                collecteur:vm.collecteur ? vm.collecteur.id : null,
         		fromDate:$filter('date')(vm.date.startDate, "yyyy-MM-dd"),
         		toDate:$filter('date')(vm.date.endDate, "yyyy-MM-dd"),
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.collectionListes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        
        function search () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = '';
            vm.reverse = false;
            vm.transition();
        }


        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }
        
        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.etat = null;
            vm.collecteur = null;
            vm.date.startDate = null;
            vm.date.endDate = null;
            vm.transition();
        }


        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                etat:vm.etat,
                collecteur:vm.collecteur?vm.collecteur.id:null,
                startDate: vm.date.startDate,
                endDate: vm.date.endDate
            });
        }

        function getMapUrl(id) {
            return $state.href('collection-liste-map', {id: id});
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CollectionListeMapController', CollectionListeMapController);

    CollectionListeMapController.$inject = ['$filter', '$stateParams', '$timeout', 'Agence', 'CollectionListe'];

    function CollectionListeMapController($filter, $stateParams, $timeout, Agence, CollectionListe) {
        var vm = this;

        vm.activePointKey = null;
        vm.areaGeometry = null;
        vm.collectionListe = {};
        vm.filteredRows = [];
        vm.mapPoints = [];
        vm.mapRefreshToken = 0;
        vm.openContractPopup = openContractPopup;
        vm.openPaymentPopup = openPaymentPopup;
        vm.rows = [];
        vm.showContractPopupAction = showContractPopupAction;
        vm.showContracts = true;
        vm.showPaymentPassage = true;
        vm.showPaymentPopupAction = showPaymentPopupAction;
        vm.showPaymentTime = true;
        vm.showPayments = true;
        vm.updateVisibility = updateVisibility;
		vm.mapFitBoundsToken = 0;
		
        if ($stateParams.id) {
            CollectionListe.get({id: $stateParams.id}, function(result) {
                vm.collectionListe = result;
                vm.rows = buildRows(result);
                updateVisibility();
                loadAgencyGeometry(result.agenceId);
            });
        }

        function updateVisibility() {
            vm.activePointKey = null;
            vm.filteredRows = vm.rows.filter(function(row) {
                return (vm.showPayments && row.hasPaymentPoint) || (vm.showContracts && row.hasContractPoint);
            });

            vm.mapPoints = buildVisiblePoints(vm.filteredRows);
            vm.mapRefreshToken += 1;
			vm.mapFitBoundsToken += 1;
        }

        function buildRows(collectionListe) {
            var rows = [];
            var rowIndex = 0;

            angular.forEach(collectionListe.contratCollectionLists || [], function(contratCollectionList) {
                var paymentCoords = buildCoords(contratCollectionList.coordLat, contratCollectionList.coordLon);
                var contractCoords = buildCoords(contratCollectionList.contrat && contratCollectionList.contrat.lat, contratCollectionList.contrat && contratCollectionList.contrat.lon);
                var paymentDate = contratCollectionList.paymentDate;
                var paymentTimestamp = resolveOrderTime(paymentDate, collectionListe.dateFinPeriode);
                var paymentDateLabel = formatDate(paymentDate, collectionListe.dateFinPeriode);
                var contractReference = getContractReference(contratCollectionList);
                var customerName = getCustomerName(contratCollectionList);
                var amountLabel = buildAmountLabel(contratCollectionList);
                var hasRecordedPayment = hasRecordedPaymentValue(contratCollectionList);

                if (!paymentCoords && !contractCoords) {
                    return;
                }

                rows.push({
                    amountLabel: amountLabel,
                    contractGpsLabel: formatCoordinateLabel(contractCoords),
                    contractId: contratCollectionList.contrat ? contratCollectionList.contrat.id : null,
                    contractPoint: contractCoords ? {
                        dateLabel: paymentDateLabel,
                        focusZoom: 17,
                        hasRecordedPayment: hasRecordedPayment,
                        key: 'contract-' + contratCollectionList.id,
                        kind: 'contract',
                        lat: contractCoords.lat,
                        lon: contractCoords.lon,
                        subtitle: customerName,
                        title: contractReference,
                        valueLabel: amountLabel
                    } : null,
                    contractReference: contractReference,
                    customerName: customerName,
                    hasContractPoint: !!contractCoords,
                    hasRecordedPayment: hasRecordedPayment,
                    hasPaymentPoint: !!paymentCoords,
                    id: contratCollectionList.id,
                    paymentDateLabel: paymentDateLabel,
                    paymentGpsLabel: formatCoordinateLabel(paymentCoords, contratCollectionList.coordPrecision),
                    paymentPoint: paymentCoords ? {
                        dateLabel: paymentDateLabel,
                        focusZoom: 17,
                        hasRecordedPayment: hasRecordedPayment,
                        key: 'payment-' + contratCollectionList.id,
                        kind: 'payment',
                        lat: paymentCoords.lat,
                        lon: paymentCoords.lon,
                        orderTime: paymentTimestamp,
                        subtitle: customerName,
                        title: contractReference,
                        valueLabel: amountLabel
                    } : null,
                    paymentTimestamp: paymentTimestamp,
                    rowIndex: rowIndex
                });

                rowIndex += 1;
            });

            rows.sort(function(a, b) {
                return compareOrder(a.paymentTimestamp, b.paymentTimestamp, a.rowIndex, b.rowIndex);
            });

            return rows;
        }

        function buildVisiblePoints(rows) {
            var points = [];
            var paymentSequence = 0;

            angular.forEach(rows || [], function(row) {
                if (vm.showPayments && row.paymentPoint) {
                    paymentSequence += 1;
                    points.push(buildPaymentPoint(row, paymentSequence));
                }

                if (vm.showContracts && row.contractPoint) {
                    points.push(buildContractPoint(row));
                }
            });

            return points;
        }

        function buildPaymentPoint(row, paymentSequence) {
            var point = angular.copy(row.paymentPoint);
            point.sequence = paymentSequence;
            point.markerHtml = buildPaymentMarkerHtml(paymentSequence, row.paymentDateLabel, row.hasRecordedPayment);
            point.iconSize = [68, vm.showPaymentTime ? 54 : 36];
            point.iconAnchor = [18, 18];
            point.popupAnchor = [0, -16];
            return point;
        }

        function buildContractPoint(row) {
            var point = angular.copy(row.contractPoint);
            var backgroundColor = row.hasRecordedPayment ? '#2f855a' : '#c05621';
            point.markerHtml = '<div style="' +
                'background:' + backgroundColor + ';color:#fff;border:2px solid #ffffff;border-radius:12px;' +
                'width:24px;height:24px;line-height:20px;text-align:center;font-weight:bold;' +
                'box-shadow:0 1px 5px rgba(0,0,0,0.35);font-size:12px;">C</div>';
            point.iconSize = [24, 24];
            point.iconAnchor = [12, 12];
            point.popupAnchor = [0, -12];
            return point;
        }

        function buildPaymentMarkerHtml(paymentSequence, paymentDateLabel, hasRecordedPayment) {
            var badgeLabel = vm.showPaymentPassage ? String(paymentSequence) : '$';
            var backgroundColor = hasRecordedPayment ? '#2f855a' : '#c05621';
            var html = '<div style="display:flex;flex-direction:column;align-items:center;">' +
                '<div style="' +
                'background:' + backgroundColor + ';color:#fff;border:2px solid #ffffff;border-radius:18px;' +
                'min-width:30px;height:30px;line-height:26px;text-align:center;font-weight:bold;' +
                'padding:0 6px;box-shadow:0 1px 5px rgba(0,0,0,0.35);font-size:12px;">' +
                escapeHtml(badgeLabel) +
                '</div>';

            if (vm.showPaymentTime && paymentDateLabel) {
                html += '<div style="' +
                    'margin-top:3px;background:rgba(255,255,255,0.92);color:#1a202c;border-radius:10px;' +
                    'padding:2px 6px;font-size:10px;line-height:1.2;white-space:nowrap;' +
                    'box-shadow:0 1px 3px rgba(0,0,0,0.25);">' + escapeHtml(paymentDateLabel) + '</div>';
            }

            html += '</div>';
            return html;
        }

        function openPaymentPopup(row) {
            if (!row || !row.paymentPoint) {
                return;
            }

            focusPoint(row.paymentPoint.key);
        }

        function openContractPopup(row) {
            if (!row || !row.contractPoint) {
                return;
            }

            focusPoint(row.contractPoint.key);
        }

        function focusPoint(pointKey) {
			vm.activePointKey = null;
	
			$timeout(function() {
			    vm.activePointKey = pointKey;
			}, 0);
        }

        function showPaymentPopupAction(row) {
            return vm.showPayments && row && row.hasPaymentPoint;
        }

        function showContractPopupAction(row) {
            return vm.showContracts && row && row.hasContractPoint;
        }

        function loadAgencyGeometry(agenceId) {
            vm.areaGeometry = null;

            if (!agenceId) {
                return;
            }

            Agence.get({id: agenceId}, function(agence) {
                vm.areaGeometry = agence ? agence.geographicCoord : null;
            });
        }

        function resolveOrderTime(paymentDate, fallbackDate) {
            if (paymentDate) {
                return new Date(paymentDate).getTime();
            }
            if (fallbackDate) {
                return new Date(fallbackDate).getTime();
            }
            return 0;
        }

        function formatDate(paymentDate, fallbackDate) {
            if (paymentDate) {
                return $filter('date')(paymentDate, 'shortTime');
            }
            if (fallbackDate) {
                return $filter('date')(fallbackDate, 'mediumDate');
            }
            return '';
        }

        function resolveAmountPaid(contratCollectionList) {
            var amountPaid = contratCollectionList.amountPaid;

            if ((amountPaid === null || amountPaid === undefined || amountPaid === '') && contratCollectionList.lignePaiementService && contratCollectionList.lignePaiementService.length) {
                amountPaid = contratCollectionList.lignePaiementService[0].montantPayeCollecteur;
            }

            return amountPaid;
        }

        function buildAmountLabel(contratCollectionList) {
            var amountPaid = resolveAmountPaid(contratCollectionList);

            if (amountPaid === null || amountPaid === undefined || amountPaid === '') {
                return $filter('translate')('wamasysApp.collectionListe.map.noAmount');
            }

            return $filter('translate')('wamasysApp.collectionListe.map.amount') + ': ' + $filter('number')(amountPaid, 2);
        }

        function hasRecordedPaymentValue(contratCollectionList) {
            var amountPaid = resolveAmountPaid(contratCollectionList);
            var numericAmount;

            if (amountPaid === null || amountPaid === undefined || amountPaid === '') {
                return false;
            }

            numericAmount = parseFloat(String(amountPaid).replace(',', '.'));
            return !isNaN(numericAmount) && numericAmount !== 0;
        }

        function buildCoords(latValue, lonValue) {
            var lat = parseCoordinate(latValue);
            var lon = parseCoordinate(lonValue);

            if (lat === null || lon === null) {
                return null;
            }

            return {
                lat: lat,
                lon: lon
            };
        }

        function formatCoordinateLabel(coords, precision) {
            if (!coords) {
                return '-';
            }

            var label = $filter('number')(coords.lat, 6) + ', ' + $filter('number')(coords.lon, 6);

            if (precision !== null && precision !== undefined && precision !== '') {
                label += ' (' + $filter('number')(precision, 1) + ' m)';
            }

            return label;
        }

        function compareOrder(firstTime, secondTime, firstIndex, secondIndex) {
            if (firstTime !== secondTime) {
                return firstTime - secondTime;
            }

            return firstIndex - secondIndex;
        }

        function parseCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = parseFloat(String(value).replace(',', '.'));
            return isNaN(parsedValue) ? null : parsedValue;
        }

        function getContractReference(contratCollectionList) {
            return contratCollectionList.contrat ? contratCollectionList.contrat.referenceContrat : '';
        }

        function getCustomerName(contratCollectionList) {
            return contratCollectionList.contrat ? contratCollectionList.contrat.nomPersonne : '';
        }

        function escapeHtml(value) {
            return String(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CollectionListeDialogController', CollectionListeDialogController);

    CollectionListeDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'CollectionListe', 'UserSearch','PortefeuilleContrat','Principal','$timeout'];

    function CollectionListeDialogController ($scope, $stateParams, $uibModalInstance, entity, CollectionListe, UserSearch,PortefeuilleContrat,Principal,$timeout) {
        var vm = this;
        vm.collectionListe = entity;
        vm.collectionListe.genererFacturation = false;
        vm.users = UserSearch.searchCollecteur();
        vm.listPortefeuilleContrat = [];
        
//        vm.isEauEtVie = false;
//        
//	    Principal.identity().then(function(account) {
//	    	if(account.organisationName == "Eau et Vie"){
//	    		 vm.isEauEtVie = true;	
//	    		 vm.collectionListe.genererFacturation = true;
//	    	}
//	    });
        
        vm.load = function(id) {
            CollectionListe.get({id : id}, function(result) {
                vm.collectionListe = result;
            });
        };
        
        vm.updateListePortefeuille = function() {
            vm.listPortefeuilleContrat = [];
            vm.collectionListe.listPortefeuilleContratDTO= null;
        	PortefeuilleContrat.portefeuilleContratByCollecteur(
    				{idCollector : vm.collectionListe.collecteur.id}, 
    				function(result) {
    						vm.listPortefeuilleContrat =  result;

    						
    						
    		});
        };
        
        
        
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:collectionListeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            
            CollectionListe.save(vm.collectionListe, onSaveSuccess, onSaveError);
            
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateFinPeriode = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
	'use strict';

	angular.module('wamasysApp').controller('CollectionListeDetailController',
			CollectionListeDetailController);

	CollectionListeDetailController.$inject = [ '$scope', '$filter',
			'$rootScope', '$state', '$stateParams', 'CollectionListe',
			'PortefeuilleContrat' ];

	function CollectionListeDetailController($scope, $filter, $rootScope,
			$state, $stateParams, CollectionListe, PortefeuilleContrat) {
		var vm = this;
		vm.disableBtnSaveCancel =false;
		vm.disableBtnEdition =false;
		vm.collectionListe = {};
		vm.errorValidation = false;
		vm.messageError ="";
        vm.getMapUrl = getMapUrl;
		vm.load = function(id) {
			CollectionListe.get({
				id : id
			}, function(result) {
				vm.collectionListe = result;
				$rootScope.$broadcast('updateLigneCollectionListe', result);
			});
		};
		if ($stateParams.id) {
			vm.load($stateParams.id);
		}
		var unsubscribe = $rootScope.$on('wamasysApp:collectionListeUpdate',
				function(event, result) {
					vm.collectionListe = result;
					vm.majTotalMontant(vm.collectionListe);
				});
		$scope.$on('$destroy', unsubscribe);

		 //Boite de dialog d'attente.
		var $dialog = $(
				'<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-hidden="true" style="padding-top:15%; overflow-y:visible;">' +
				'<div class="modal-dialog modal-m">' +
				'<div class="modal-content">' +
					'<div class="modal-header"><h3 style="margin:0;"></h3></div>' +
					'<div class="modal-body">' +
						'<div class="progress progress-striped active" style="margin-bottom:0;"><div class="progress-bar" style="width: 100%"></div></div>' +
					'</div>' +
				'</div></div></div>');

		var options = {};
		var message = 'Please wait ! Action in progress.';
		var settings = $.extend({
			dialogSize: 'm',
			progressType: '',
			onHide: null // This callback runs after the dialog was hidden
		}, options);
		$dialog.find('.modal-dialog').attr('class', 'modal-dialog').addClass('modal-' + settings.dialogSize);
		$dialog.find('.progress-bar').attr('class', 'progress-bar');
		$dialog.find('h3').text(message);
		
		
		
		vm.totalMontantACollecter = 0;
		vm.totalMontantCollecte = 0;
		vm.totalMontantCollecteAvecCorrection = 0;
//		vm.totalMontantCollecteEnAgence = 0;
		vm.totalMontantACollecterSansMoneyBox = 0;
		vm.totalMontantNonCollecte = 0;
		vm.totalPreviousArrears = 0;
		vm.totalCollectionRateBilled= 0;
		vm.totalCollectionRateGlobal = 0;
		
		vm.majTotalMontant = function(data) {

			vm.totalMontantACollecter = 0;
			vm.totalMontantCollecte = 0;
			vm.totalMontantCollecteAvecCorrection = 0;
//			vm.totalMontantCollecteEnAgence = 0;
			vm.totalMontantACollecterSansMoneyBox = 0;
			vm.totalMontantNonCollecte = 0;
			vm.totalPreviousArrears = 0;
			vm.totalCollectionRateBilled= 0;
			vm.totalCollectionRateGlobal = 0;

			if (data && data.contratCollectionLists) {
				for (var i = 0; i < data.contratCollectionLists.length; i++) {

					if (data.contratCollectionLists[i].lignePaiementService) {

						for (var x = 0; x < data.contratCollectionLists[i].lignePaiementService.length; x++) {
							vm.totalMontantACollecter += (parseFloat(data.contratCollectionLists[i].lignePaiementService[x].montantAPayerTtc) - parseFloat(data.contratCollectionLists[i].lignePaiementService[x].moneyboxAvantPaiement));
							vm.totalMontantACollecterSansMoneyBox += data.contratCollectionLists[i].lignePaiementService[x].montantAPayerTtc;
							vm.totalMontantCollecte += data.contratCollectionLists[i].lignePaiementService[x].montantPayeCollecteur;

							vm.totalPreviousArrears += parseFloat(data.contratCollectionLists[i].lignePaiementService[x].moneyboxAvantPaiement);
						}
					}
				}
			}

			vm.totalMontantCollecteAvecCorrection += vm.totalMontantCollecte;
			
			if (data && data.paymentCorrectionList) {
				for (var i = 0; i < data.paymentCorrectionList.length; i++) {

					vm.totalMontantCollecteAvecCorrection += parseFloat(data.paymentCorrectionList[i].montantTtc);
				
				}
			}
			

			vm.totalCollectionRateBilled=( vm.totalMontantCollecteAvecCorrection ) /  vm.totalMontantACollecterSansMoneyBox  * 100;
			
			vm.totalCollectionRateGlobal = ( vm.totalMontantCollecteAvecCorrection ) /  vm.totalMontantACollecter  * 100;
			
			
			vm.totalPreviousArrears = Number((vm.totalPreviousArrears).toFixed(2));
			
			
			vm.totalMontantNonCollecte = parseFloat(vm.totalMontantACollecter)	- parseFloat(vm.totalMontantCollecteAvecCorrection);

			vm.totalMontantCollecteAvecCorrection = Number((vm.totalMontantCollecteAvecCorrection).toFixed(2));

			vm.totalMontantACollecter = Number((vm.totalMontantACollecter)
					.toFixed(2));
			vm.totalMontantCollecte = Number((vm.totalMontantCollecte)
					.toFixed(2));
			
			vm.totalMontantACollecterSansMoneyBox = Number((vm.totalMontantACollecterSansMoneyBox)
					.toFixed(2));
			vm.totalMontantNonCollecte = Number((vm.totalMontantNonCollecte)
					.toFixed(2));
			

		}

		$scope.$on('updateLigneCollectionListe', function(event, data) {
			vm.majTotalMontant(data);
			vm.errorValidation = controleAvantValidation();
		});

		vm.valider = function() {
// TODO Controle annuler car sinon ça bloque sur les lignes invisibles (où le mojtant à payer est à 0) 
// et ça bloque sur les lignes où on a un seul installment.
//			if( ! controleAvantValidation()){
//				return ;
//			}
			
			vm.disableBtnEdition =true;
			
			
			$dialog.modal();
			
			CollectionListe.valider({
				id : vm.collectionListe.id
			}, function(result) {
				vm.disableBtnEdition =false;
				$scope.$emit('wamasysApp:collectionListeUpdate', result);
				vm.isSaving = false;
				$dialog.modal('hide');
			},function(error) {
				$dialog.modal('hide');
			}
			);
		}
		
		
		var controleAvantValidation = function(){
			vm.messageError = "";
			var errorValidation = false;
			
			if (vm.collectionListe && vm.collectionListe.contratCollectionLists) {
				for (var i = 0; i < vm.collectionListe.contratCollectionLists.length; i++) {

					if (vm.collectionListe.contratCollectionLists[i].lignePaiementService) {

						for (var x = 0; x < vm.collectionListe.contratCollectionLists[i].lignePaiementService.length; x++) {

							// vm.collectionListe.contratCollectionLists[i].contrat.referenceContrat


							if ("A_PAYER_AVEC_ECHELONNEMENT" == vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].ligneContrat.serviceVendu.typePaiement) {
								
								//On teste que le montant payé n'est pas supérieur au reste à papyer sur les services de type échelonnement.
								
								var montantBalanceCf = parseFloat(vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].montantTotalAPayer)
										- parseFloat(vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].montantTotalDejaPaye);

								var montantPayePourCetteCL = 0;

								if(vm.collectionListe.etat != 'VALIDE' ){
									if (vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].montantPayeCollecteur) {
										 montantPayePourCetteCL = montantPayePourCetteCL 
										 	+ vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].montantPayeCollecteur
									}
								}
								
								
								montantPayePourCetteCL =  Number(montantPayePourCetteCL.toFixed(2)) ;
								montantBalanceCf = Number(montantBalanceCf.toFixed(2));
								
								if ( montantPayePourCetteCL > montantBalanceCf ) {
									
									   
									     
									vm.messageError = vm.messageError 
									+ '<li>Error, the amount paid is higher than the total amount to be paid on : '
											+vm.collectionListe.contratCollectionLists[i].contrat.referenceContrat
											+' for service : '
											+vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].ligneContrat.serviceVendu.libelle
											+'<br/> '
											+' Paid amount : ' +montantPayePourCetteCL
											+' Remaining amount to be paid : '+montantBalanceCf
											+'.You should assign the excess amount to another service or apply a regulation. '
											+'</li>';
										
									errorValidation = true;
								}

							

							}
						}
					}
				}
				return errorValidation;
			}
		}

		vm.startEdit = function() {
			vm.disableBtnEdition =true;
			vm.disableBtnSaveCancel =false;
			jQuery("#btnSaveRows,#btnCancelRows").show();

			var grid = $("table[id^=jqgrid-table]");
			var ids = grid.jqGrid('getDataIDs');

			for (var i = 0; i < ids.length; i++) {
				grid.jqGrid('editRow', ids[i]);
			}

		};
		

		
		vm.print = function() {
			var printContents = document.getElementById('full-screen-widget').innerHTML;

			var content = '<strong>'
					+ $filter('translate')
							(
									'wamasysApp.collectionListe.titreListeCollecteImpression')
					+ ' '
					+ $filter('date')(vm.collectionListe.dateFinPeriode,
							"mediumDate")
					+ '</strong> '
					+ ' ID : '
					+ vm.collectionListe.referenceCollectionList
					+ ' '


					+ $filter('translate')(
							'wamasysApp.collectionListe.collecteur') + ' :  '
					+ vm.collectionListe.collecteur.firstName + ' '
					+ vm.collectionListe.collecteur.lastName + '<br>';

			content += '<table style=" ">';
			content += '<tr><td>'
					+ $filter('translate')(
							'wamasysApp.contrat.referenceContrat')
					+ '</td><td>'
					+ $filter('translate')('wamasysApp.contrat.nomPersonne')
					+ '</td><td>service</td><td>'
					+ $filter('translate')('wamasysApp.contrat.type')
					+ '</td><td>'
					+ $filter('translate')(
							'wamasysApp.contrat.dernierReleveCompteur')
					+ '</td><td>'
					+ $filter('translate')(
							'wamasysApp.collectionListe.quantity')
					+ '</td><td>'
					+ $filter('translate')(
							'wamasysApp.collectionListe.montantAPayer')
					+ '</td><td>'
					+ $filter('translate')(
							'wamasysApp.collectionListe.moneyBoxAvantPaiement')
					+ '</td>'
					+ '<td>'
					+ $filter('translate')(
							'wamasysApp.collectionListe.montantTotalAPayer')
					+ '</td>'
					+ '<td style="width:60px;"></td><td style="width:60px;"></td><td style="width:60px;">'
					+ $filter('translate')(
							'wamasysApp.collectionListe.signature')
					+ '</td></tr>';

			if (vm.collectionListe && vm.collectionListe.contratCollectionLists) {
				for (var i = 0; i < vm.collectionListe.contratCollectionLists.length; i++) {

					if (vm.collectionListe.contratCollectionLists[i].lignePaiementService) {

						for (var x = 0; x < vm.collectionListe.contratCollectionLists[i].lignePaiementService.length; x++) {

							content += '<tr>'
									+ '<td>'
									+ vm.collectionListe.contratCollectionLists[i].contrat.referenceContrat
									+ '</td><td>'
									+ vm.collectionListe.contratCollectionLists[i].contrat.nomPersonne;

							if ("A_PAYER_AVEC_ECHELONNEMENT" == vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].ligneContrat.serviceVendu.typePaiement) {
								var montantBalanceCf = parseFloat(vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].montantTotalAPayer)
										- parseFloat(vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].montantTotalDejaPaye);

								if (vm.collectionListe.etat == "VALIDE") {

									if (vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].montantPayeCollecteur) {
										montantBalanceCf = parseFloat(montantBalanceCf)
												- parseFloat(vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].montantPayeCollecteur);
									}
								}

								content += '</td><td>'
										+ vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].ligneContrat.serviceVendu.libelle
										+ " bal: " + montantBalanceCf;

							} else {
								content += '</td><td>'
										+ vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].ligneContrat.serviceVendu.libelle;
							}
							content += '</td><td>'
									+ vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].ligneContrat.serviceVendu.typeService.libelle;

							if ("A_PAYER_SUR_CONSO_EAU" == vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].ligneContrat.serviceVendu.typePaiement) {
								content += '</td><td>'
										+ vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].valeurCompteurReleve
										+ '</td><td>'
										+ vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].quantity;
							} else {
								content += '</td><td> </td><td> ';
							}
							content += '</td><td>'
									+ vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].montantAPayerTtc
									+ '</td><td>'
									+ vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].moneyboxAvantPaiement
									+ '</td><td>'
									+ (parseFloat(vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].montantAPayerTtc) - parseFloat(vm.collectionListe.contratCollectionLists[i].lignePaiementService[x].moneyboxAvantPaiement))
									+ '</td><td> </td><td> </td><td> </td></tr>';

						}

					}

				}
			}
			;

			content += "</table>";
			printContents = content;

			var popupWin = window.open('', '_blank');
			popupWin.document.open();

			popupWin.document
					.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" />'
							+ '<style type="text/css" media="print">@page { size: landscape; }    </style>'
							+ '<style type="text/css" > table {border-spacing: 0.5rem;border-collapse: collapse;} table, table td, table th { border: 1px solid black; }   </style>'
							+ '</head><body onload="window.print()">'
							+ printContents + '</body></html>');
			popupWin.document.close();
		}

		var onSaveSuccess = function(result) {
			$scope.$emit('wamasysApp:collectionListeUpdate', result);
			vm.isSaving = false;
			vm.disableBtnEdition =false;
			$dialog.modal('hide');
			vm.errorValidation = controleAvantValidation();
		};

		var onSaveError = function() {
			vm.isSaving = false;
			vm.disableBtnEdition =false;
			$dialog.modal('hide');
			vm.errorValidation = controleAvantValidation();
		};

		vm.saveRows = function(row) {
			//On désactive les boutons.
			$dialog.modal();
			vm.disableBtnSaveCancel =true;

			var grid = $("table[id^=jqgrid-table]");

			var ids = grid.jqGrid('getDataIDs');

			var erreur = false;
			for (var i = 0; i < ids.length; i++) {
				var success = grid.jqGrid('saveRow', ids[i]);
				erreur = erreur || (!success);

			}
			if (erreur) {
				alert('erreur dans la saisie, vérifier le tableau');
				for (var i = 0; i < ids.length; i++) {
					grid.jqGrid('editRow', ids[i]);
				}
				$dialog.modal('hide');
				return;
			}

			// TODO tester que les données sont bonnes, si elles ne le sont pas,
			// dans ce cas on affiche la ligne en rouge plus un message d'erreur
			// et on demande de confirmer la saisie.

			// Ensuite onn enregistre en appelant le WebService.

			var grid = $("table[id^=jqgrid-table]");
			var dataInGrid = grid.jqGrid('getRowData');

			for (var i = 0; i < dataInGrid.length; i++) {

				var id = dataInGrid[i].id;
				// var listTrouve =
				var keepGoing = true;
				angular.forEach(vm.collectionListe.contratCollectionLists,
								function(contratCollectionList, key1) {
									if (keepGoing) {
										angular.forEach(contratCollectionList.lignePaiementService,
														function(lignePaiementService,key2) {
															if (keepGoing) {
																if (id == lignePaiementService.idLignePaiementService) {
																	lignePaiementService.montantPayeCollecteur = dataInGrid[i].montantCollecte;
																	keepGoing = false;
																}
															}
														});
									}
								});

				/*
				 * jQuery.grep(, function(e){ return
				 * e.lignePaiementService[x].id == id; });
				 */

			}

			CollectionListe.update(vm.collectionListe, onSaveSuccess,
					onSaveError);
			jQuery("#btnSaveRows,#btnCancelRows").hide();
			vm.disableBtnSaveCancel =true;

		}

		vm.cancelEditRows = function(row) {

			jQuery("#btnSaveRows,#btnCancelRows").hide();
			vm.disableBtnEdition =false;

			var grid = $("table[id^=jqgrid-table]");

			var ids = grid.jqGrid('getDataIDs');

			for (var i = 0; i < ids.length; i++) {
				grid.jqGrid('restoreRow', ids[i]);
			}

		}

        function getMapUrl(id) {
            return $state.href('collection-liste-map', {id: id});
        }
	}
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CollectionListeDeleteController',CollectionListeDeleteController);

    CollectionListeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CollectionListe', '$rootScope'];

    function CollectionListeDeleteController($uibModalInstance, entity, CollectionListe,$rootScope) {
        var vm = this;
        vm.collectionListe = entity;
        vm.confirmReferenceCollectionList = null;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
        	if(! vm.confirmReferenceCollectionList || vm.confirmReferenceCollectionList != "yes"){
       		 $rootScope.$emit('wamasysApp.httpError', "Incorrect ! Write yes if you want to delete.");
        	}else{
        		
        		
        		  
    			var $dialog = $(
    					'<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-hidden="true" style="padding-top:15%; overflow-y:visible;">' +
    					'<div class="modal-dialog modal-m">' +
    					'<div class="modal-content">' +
    						'<div class="modal-header"><h3 style="margin:0;"></h3></div>' +
    						'<div class="modal-body">' +
    							'<div class="progress progress-striped active" style="margin-bottom:0;"><div class="progress-bar" style="width: 100%"></div></div>' +
    						'</div>' +
    					'</div></div></div>');

    			var options = {};
    			var message = 'Please wait ! Action in progress.';
    			var settings = $.extend({
    				dialogSize: 'm',
    				progressType: '',
    				onHide: null // This callback runs after the dialog was hidden
    			}, options);
    			$dialog.find('.modal-dialog').attr('class', 'modal-dialog').addClass('modal-' + settings.dialogSize);
    			$dialog.find('.progress-bar').attr('class', 'progress-bar');
    			$dialog.find('h3').text(message);
    			$dialog.modal();
    			
        		
                CollectionListe.delete({id: id},
                    function () {
    					$dialog.modal('hide');
                        $uibModalInstance.close(true);
                    },
                    function () {
    					$dialog.modal('hide');
                    });
        	}
        };
    }
})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ConsommationEauBulkMeter', ConsommationEauBulkMeter);

    ConsommationEauBulkMeter.$inject = ['$resource', 'DateUtils'];

    function ConsommationEauBulkMeter ($resource, DateUtils) {
        var resourceUrl =  'api/consommation-eau-bulk-meters/:id';

        return $resource(resourceUrl, {}, {
        	  'byBulkMeter': { method: 'GET', url:'api/consommation-eau-bulk-meters/bulk-meter/:id', isArray: true}
        
        	//{id}
           /* 'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateDebut = DateUtils.convertLocalDateFromServer(data.dateDebut);
                    data.dateFin = DateUtils.convertLocalDateFromServer(data.dateFin);
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.dateDebut = DateUtils.convertLocalDateToServer(data.dateDebut);
                    data.dateFin = DateUtils.convertLocalDateToServer(data.dateFin);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.dateDebut = DateUtils.convertLocalDateToServer(data.dateDebut);
                    data.dateFin = DateUtils.convertLocalDateToServer(data.dateFin);
                    return angular.toJson(data);
                }
            }*/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
       /* .state('bulk-meter', {
            parent: 'entity',
            url: '/bulk-meter?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.bulkMeter.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/bulk-meter/bulk-meters.html',
                    controller: 'BulkMeterController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('bulkMeter');
                    $translatePartialLoader.addPart('etatMeter');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })*/
        .state('bulk-meter-detail', {
            parent: 'entity',
            url: '/bulk-meter/{id}?page&sort&consoPage',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.bulkMeter.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/bulk-meter/bulk-meter-detail.html',
                    controller: 'BulkMeterDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                consoPage: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        consoPage: PaginationUtil.parsePage($stateParams.consoPage),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('bulkMeter');
                    $translatePartialLoader.addPart('etatMeter');
                    $translatePartialLoader.addPart('collectionListe');
                    $translatePartialLoader.addPart('etatCollectionList');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BulkMeter', function($stateParams, BulkMeter) {
                    return BulkMeter.get({id : $stateParams.id});
                }]
            }
        })
        .state('compteur.bulk-meter.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/bulk-meter/bulk-meter-dialog.html',
                    controller: 'BulkMeterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                numeroSerie: null,
                                dateCreation: null,
                                valeurInitiale: null,
                                etat: null,
                                dateSuppression: null,
                                longitude: null,
                                latitude: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('compteur.bulk-meter', null, { reload: true });
                }, function() {
                    $state.go('compteur.bulk-meter');
                });
            }]
        })
        .state('compteur.bulk-meter.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/bulk-meter/bulk-meter-dialog.html',
                    controller: 'BulkMeterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BulkMeter', function(BulkMeter) {
                            return BulkMeter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('compteur.bulk-meter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('compteur.bulk-meter.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/bulk-meter/bulk-meter-delete-dialog.html',
                    controller: 'BulkMeterDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BulkMeter', function(BulkMeter) {
                            return BulkMeter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('compteur.bulk-meter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('bulk-meter-detail.addcorrection', {
            url: '/addcorrection',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/bulk-meter/bulk-meter-addcorrection-dialog.html',
                    controller: 'BulkMeterAddCorrectionController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BulkMeter', function(BulkMeter) {
                            return BulkMeter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('bulk-meter-detail', {id : $stateParams.id}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('bulk-meter-detail.addreading', {
            url: '/addreading',
            data: {
                authorities: ['ROLE_AREA_MANAGEMENT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/bulk-meter/bulk-meter-addreading-dialog.html',
                    controller: 'BulkMeterAddReadingController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BulkMeter', function(BulkMeter) {
                            return BulkMeter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('bulk-meter-detail', {id : $stateParams.id}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
        
        
        ;
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('BulkMeter', BulkMeter);

    BulkMeter.$inject = ['$resource', 'DateUtils'];

    function BulkMeter ($resource, DateUtils) {
        var resourceUrl =  'api/bulk-meters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateMiseEnService = DateUtils.convertLocalDateFromServer(data.dateMiseEnService);
                    data.datePrecedenteLecture= DateUtils.convertDateTimeFromServer(data.datePrecedenteLecture);
                    data.dateSuppression = DateUtils.convertDateTimeFromServer(data.dateSuppression);
                    return data;
                }
            },
            'update': { method:'PUT',
            	transformRequest: function (data) {
                    var clonedData = Object.assign({}, data);
                	clonedData.dateMiseEnService = DateUtils.convertLocalDateToServer(data.dateMiseEnService);
                    return angular.toJson(clonedData);
                }
            } ,
            'save': { method:'POST',
            	transformRequest: function (data) {
            		var clonedData = Object.assign({}, data);
                	clonedData.dateMiseEnService = DateUtils.convertLocalDateToServer(data.dateMiseEnService);
                    return angular.toJson(clonedData);
                    
                }
            },
            'bulkMeterByCollecteur' :{
             	 method:'GET', 
             	isArray: true,
             	 url :'api/bulk-meters-by-collector/:idCollector'
             } ,
             'createCorrection': { 
            	 method:'POST',
             	 url :'api/bulk-meters/create-correction',
             	 transformRequest: function (data) {
             		var clonedData = Object.assign({}, data);
             		
                 	clonedData.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                 	clonedData.dateDebut = DateUtils.convertDateTimeFromServer(data.dateDebut);
                 	clonedData.dateFin = DateUtils.convertDateTimeFromServer(data.dateFin);
                    return angular.toJson(clonedData);
                     
                 }
             },
             'addReading': { 
            	 method:'POST',
             	 url :'api/bulk-meters/reading',
             	 transformRequest: function (data) {
             		var clonedData = Object.assign({}, data);
             		
                 	//clonedData.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                 	clonedData.readingDate = DateUtils.convertDateTimeFromServer(data.readingDate);
                    return angular.toJson(clonedData);
                     
                 }
             }
            
            
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('BulkMeterController', BulkMeterController);

    BulkMeterController.$inject = ['$scope', '$state', 'BulkMeter', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function BulkMeterController ($scope, $state, BulkMeter, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            BulkMeter.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.bulkMeters = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('BulkMeterDialogController', BulkMeterDialogController);

    BulkMeterDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'BulkMeter', 'UserSearch','ModelMeter','WaterNetwork'];

    function BulkMeterDialogController ($scope, $stateParams, $uibModalInstance, entity, BulkMeter, UserSearch,ModelMeter,WaterNetwork) {
        var vm = this;
        vm.bulkMeter = entity;
        vm.mapMeter = createMapMeter(vm.bulkMeter);
        vm.users = UserSearch.searchCollecteur();
        vm.modelMeters = ModelMeter.query({ offset: 0,size: 1000});
        vm.waterNetworks = WaterNetwork.queryFilterArea();
        vm.load = function(id) {
            BulkMeter.get({id : id}, function(result) {
                vm.bulkMeter = result;
                vm.mapMeter = createMapMeter(vm.bulkMeter);
            });
        };

        if (vm.bulkMeter && vm.bulkMeter.$promise) {
            vm.bulkMeter.$promise.then(function() {
                vm.mapMeter = createMapMeter(vm.bulkMeter);
            });
        }

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:bulkMeterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            syncMapMeter();
            if (vm.bulkMeter.id !== null) {
                BulkMeter.update(vm.bulkMeter, onSaveSuccess, onSaveError);
            } else {
                BulkMeter.save(vm.bulkMeter, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateSuppression = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        function createMapMeter(bulkMeter) {
            return {
                lat: parseCoordinate(bulkMeter && bulkMeter.latitude),
                lon: parseCoordinate(bulkMeter && bulkMeter.longitude),
                referenceContrat: bulkMeter && bulkMeter.numeroSerie ? bulkMeter.numeroSerie : ''
            };
        }

        function parseCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = Number(String(value).replace(',', '.'));
            return isNaN(parsedValue) ? null : parsedValue;
        }

        function formatCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            return String(value);
        }

        function syncMapMeter() {
            vm.bulkMeter.latitude = formatCoordinate(vm.mapMeter && vm.mapMeter.lat);
            vm.bulkMeter.longitude = formatCoordinate(vm.mapMeter && vm.mapMeter.lon);

            if (vm.mapMeter) {
                vm.mapMeter.referenceContrat = vm.bulkMeter.numeroSerie;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('BulkMeterDetailController', BulkMeterDetailController);

    BulkMeterDetailController.$inject = ['$scope', '$state' , '$rootScope', '$stateParams', 'entity', 'BulkMeter', 'ReleveCompteur', 'User','ConsommationEauBulkMeter', 'pagingParams', 'paginationConstants', 'AlertService', 'ParseLinks'];

    function BulkMeterDetailController($scope, $state,  $rootScope, $stateParams, entity, BulkMeter, ReleveCompteur, User,ConsommationEauBulkMeter, pagingParams, paginationConstants, AlertService, ParseLinks) {
        var vm = this;
        vm.bulkMeter = entity;
        vm.mapMeter = createMapMeter(vm.bulkMeter);
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.load = function (id) {
            ReleveCompteur.byBulkMeter({
            	id:id,
         	    page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage
            }, function(result, headers) {
         	   vm.listeCollectionList  = result;
               vm.links = ParseLinks.parse(headers('link'));
               vm.totalItems = headers('X-Total-Count');
               vm.queryCount = vm.totalItems;
               vm.page = pagingParams.page;
             },  function (error) {
                 AlertService.error(error.data.message);
             });
            ConsommationEauBulkMeter.byBulkMeter({
            	id:id,
          	    page: pagingParams.consoPage - 1,
                size: paginationConstants.itemsPerPage
            }, function(result, headers) {
          	   vm.consommationBulkMeter  = result;
               vm.links = ParseLinks.parse(headers('link'));
               vm.totalItemsConso = headers('X-Total-Count');
               vm.queryCountConso = vm.totalItemsConso;
               vm.consoPage = pagingParams.consoPage;
            },  function (error) {
                AlertService.error(error.data.message);
            });
        };
        
        if($stateParams.id){
            vm.load($stateParams.id);
        }

        if (vm.bulkMeter && vm.bulkMeter.$promise) {
            vm.bulkMeter.$promise.then(function() {
                vm.mapMeter = createMapMeter(vm.bulkMeter);
            });
        }
        
        var unsubscribe = $rootScope.$on('wamasysApp:bulkMeterUpdate', function(event, result) {
            vm.bulkMeter = result;
            vm.mapMeter = createMapMeter(vm.bulkMeter);
        });
        $scope.$on('$destroy', unsubscribe);

        vm.transition = function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                consoPage: vm.consoPage,
                id:$stateParams.id,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            });
        };

        function createMapMeter(bulkMeter) {
            return {
                lat: parseCoordinate(bulkMeter && bulkMeter.latitude),
                lon: parseCoordinate(bulkMeter && bulkMeter.longitude),
                referenceContrat: bulkMeter && bulkMeter.numeroSerie ? bulkMeter.numeroSerie : ''
            };
        }

        function parseCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = Number(String(value).replace(',', '.'));
            return isNaN(parsedValue) ? null : parsedValue;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('BulkMeterDeleteController',BulkMeterDeleteController);

    BulkMeterDeleteController.$inject = ['$uibModalInstance', 'entity', 'BulkMeter'];

    function BulkMeterDeleteController($uibModalInstance, entity, BulkMeter) {
        var vm = this;
        vm.bulkMeter = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            BulkMeter.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('BulkMeterAddReadingController', BulkMeterAddReadingController);

    BulkMeterAddReadingController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'BulkMeter','ReleveCompteur'];

    function BulkMeterAddReadingController ($scope, $stateParams, $uibModalInstance, entity, BulkMeter,ReleveCompteur) {
        var vm = this;
        vm.bulkMeter = entity;
        vm.readingBulkMeter = {bulkMeter: vm.bulkMeter,releveCompteur:{id:-1},valeurPrecedentReleve: vm.bulkMeter.valeurPrecedenteLecture };
        vm.load = function(id) {
            BulkMeter.get({id : id}, function(result) {
                vm.bulkMeter = result;
                vm.readingBulkMeter.valeurPrecedentReleve = vm.bulkMeter.valeurPrecedenteLecture;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:bulkMeterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            vm.readingBulkMeter.datePrecedentReleveCompteur= vm.bulkMeter.datePrecedenteLecture; 
            vm.readingBulkMeter.valeurPrecedentReleve = vm.bulkMeter.valeurPrecedenteLecture;
            ReleveCompteur.addReading(vm.readingBulkMeter, onSaveSuccess, onSaveError);
          
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.readingDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('BulkMeterAddCorrectionController', BulkMeterAddCorrectionController);

    BulkMeterAddCorrectionController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'BulkMeter'];

    function BulkMeterAddCorrectionController ($scope, $stateParams, $uibModalInstance, entity, BulkMeter) {
        var vm = this;
        vm.bulkMeter = entity;
        vm.consommationEauBulkMeter = {bulkMeter: vm.bulkMeter,isCorrection: true,lastModifiedDate:Date.now() };
        vm.load = function(id) {
            BulkMeter.get({id : id}, function(result) {
                vm.bulkMeter = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:bulkMeterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            
            BulkMeter.createCorrection(vm.consommationEauBulkMeter, onSaveSuccess, onSaveError);
          
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateSuppression = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
        

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-admin', {
            parent: 'admin',
            url: '/user-admin',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'user-admin.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-admin/user-admin.html',
                    controller: 'UserAdminController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('mfa');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-admin-detail', {
            parent: 'admin',
            url: '/user-admi/user/:login',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'user-admin.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-admin/user-admin-detail.html',
                    controller: 'UserAdminDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('mfa');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-admin.new', {
            parent: 'user-admin',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-admin/user-admin-dialog.html',
                    controller: 'UserAdminDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                agence:null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-admin', null, { reload: true });
                }, function() {
                    $state.go('user-admin');
                });
            }]
        })
        .state('user-admin.edit', {
            parent: 'user-admin',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-admin/user-admin-dialog.html',
                    controller: 'UserAdminDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserAdmin', function(UserAdmin) {
                            return UserAdmin.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-admin', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-admin.delete', {
            parent: 'user-admin',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-admin/user-admin-delete-dialog.html',
                    controller: 'UserAdminDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UserAdmin', function(UserAdmin) {
                            return UserAdmin.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-admin', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('UserAdmin', UserAdmin);

    UserAdmin.$inject = ['$resource'];

    function UserAdmin ($resource) {
        var service = $resource('api/admin/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'},
            'getAllAgency':{method:'GET', isArray: true, url:'api/admin/agences'},
            'bulkUpdate': { method:'POST', url:'api/admin/users/bulk-update' },
            'exportCsv': {
                method: 'GET',
                url: 'api/admin/users/export/csv',
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data, headersGetter) {
                    return {
                        response: new Blob([data], { type: headersGetter('Content-Type') || 'text/csv;charset=UTF-8' }),
                        fileName: getFileNameFromDisposition(headersGetter('Content-Disposition'))
                    };
                }
            }
        });

        return service;
    }

    function getFileNameFromDisposition(contentDisposition) {
        if (!contentDisposition) {
            return null;
        }
        var match = contentDisposition.match(/filename="(.+)"/);
        return match ? match[1] : null;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('UserAdminController', UserAdminController);

    UserAdminController.$inject = ['Principal', 'UserAdmin', 'ParseLinks', 'paginationConstants', 'JhiLanguageService', '$uibModal', '$window', 'AlertService', 'Mfa', '$translate', '$scope', '$interval'];

    function UserAdminController(Principal, UserAdmin, ParseLinks, paginationConstants, JhiLanguageService, $uibModal, $window, AlertService, Mfa, $translate, $scope, $interval) {
        var vm = this;

        vm.authorities = ['ROLE_WATER_QUALITY_READ', 'ROLE_WATER_QUALITY_EDIT', 'ROLE_EQUIPMENT_READ', 'ROLE_EQUIPMENT_EDIT', 'ROLE_EQUIPMENT_SECRETS', 'ROLE_EQUIPMENT_REMOTE_CONTROL', 'ROLE_USER', 'ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_AREA_MANAGEMENT', 'ROLE_DATA_OPERATOR', 'ROLE_COLLECTOR', 'ROLE_SPECIFIC_PRICE', 'ROLE_READ_ONLY', 'ROLE_EVT_EDIT', 'ROLE_EVT_READ_ONLY', 'ROLE_FORM_VALIDATION', 'ROLE_BUDGET_READ_ONLY', 'ROLE_BUDGET_EDIT', 'ROLE_AI_ASSISTANT'];
        vm.agences = UserAdmin.getAllAgency();
        vm.currentAccount = null;
        vm.languages = null;
        vm.links = null;
        vm.page = 1;
        vm.selection = {};
        vm.selectAllOnPage = false;
        vm.selectedActivated = null;
        vm.selectedAgenceId = null;
        vm.selectedRole = null;
        vm.selectedAndroidDevice = null;
        vm.selectedAppVersion = null;
        vm.selectedMfaEnabled = null;
        vm.totalItems = null;
        vm.users = [];

        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.applyFilters = applyFilters;
        vm.resetFilters = resetFilters;
        vm.setActive = setActive;
        vm.disableMfa = disableMfa;
        vm.toggleSelectAll = toggleSelectAll;
        vm.updateSelectAllState = updateSelectAllState;
        vm.hasSelection = hasSelection;
        vm.selectedCount = selectedCount;
        vm.openBulkEdit = openBulkEdit;
        vm.downloadCsv = downloadCsv;

        vm.stateOptions = [
            { value: null, labelKey: 'userManagement.filters.allStates' },
            { value: true, labelKey: 'userManagement.activated' },
            { value: false, labelKey: 'userManagement.deactivated' }
        ];

        vm.androidDeviceOptions = [
            { value: null, labelKey: 'userManagement.android.allDevices' },
            { value: true, labelKey: 'userManagement.android.yes' },
            { value: false, labelKey: 'userManagement.android.no' }
        ];

        vm.mfaOptions = [
            { value: null, labelKey: 'userManagement.mfa.all' },
            { value: true, labelKey: 'userManagement.mfa.enabled' },
            { value: false, labelKey: 'userManagement.mfa.disabled' }
        ];

        vm.loadAll();

        // Ne remplace pas les lignes : les sélections restent intactes pendant le suivi.
        var presenceRequestPending = false;
        var presenceTimer = $interval(function () {
            if (presenceRequestPending || !vm.users.length) return;
            var currentUsers = vm.users;
            presenceRequestPending = true;
            UserAdmin.query(buildQueryParams(true), function (result) {
                presenceRequestPending = false;
                if (vm.users !== currentUsers) return;
                var observations = {};
                angular.forEach(result, function (user) { observations[user.id] = user; });
                angular.forEach(currentUsers, function (user) {
                    var observation = observations[user.id];
                    if (!observation) { user.online = false; return; }
                    user.online = observation.online;
                    user.lastLoginDate = observation.lastLoginDate;
                    user.lastSeenDate = observation.lastSeenDate;
                });
            }, function () {
                presenceRequestPending = false;
                // Une présence non vérifiée ne doit pas rester affichée en ligne.
                angular.forEach(currentUsers, function (user) { user.online = false; });
            });
        }, 30000);
        $scope.$on('$destroy', function () { $interval.cancel(presenceTimer); });

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function loadAll () {
            UserAdmin.query(buildQueryParams(true), function (result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.users = result;
                resetSelectionState();
            });
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        function applyFilters() {
            vm.page = 1;
            vm.loadAll();
        }

        function resetFilters() {
            vm.filter = null;
            vm.selectedRole = null;
            vm.selectedAgenceId = null;
            vm.selectedActivated = null;
            vm.selectedAndroidDevice = null;
            vm.selectedAppVersion = null;
            vm.selectedMfaEnabled = null;
            vm.applyFilters();
        }

        function disableMfa(user) {
            if (!user.mfaEnabled || user.mfaBusy ||
                !$window.confirm($translate.instant('mfa.adminConfirm', {login: user.login}))) { return; }
            user.mfaBusy = true;
            user.mfaError = false;
            // Réutiliser le déblocage administratif et ses contrôles de périmètre côté serveur.
            Mfa.disableForUser(user.login).then(function(status) {
                user.mfaEnabled = status.enabled;
                // Actualiser aussi le total et les résultats lorsque le filtre MFA est actif.
                vm.loadAll();
            }).catch(function() {
                user.mfaError = true;
            }).finally(function() {
                user.mfaBusy = false;
            });
        }

        function setActive (user, isActivated) {
            user.activated = isActivated;
            UserAdmin.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
            if (vm.editForm) {
                vm.editForm.$setPristine();
                vm.editForm.$setUntouched();
            }
        }

        function toggleSelectAll() {
            angular.forEach(vm.users, function(user) {
                vm.selection[user.id] = vm.selectAllOnPage;
            });
        }

        function updateSelectAllState() {
            var allSelected = vm.users.length > 0;
            angular.forEach(vm.users, function(user) {
                if (!vm.selection[user.id]) {
                    allSelected = false;
                }
            });
            vm.selectAllOnPage = allSelected;
        }

        function hasSelection() {
            return selectedCount() > 0;
        }

        function selectedCount() {
            return getSelectedUserIds().length;
        }

        function openBulkEdit(action) {
            $uibModal.open({
                templateUrl: 'app/components/user-management-bulk-edit/user-management-bulk-edit-dialog.html',
                controller: 'UserManagementBulkEditDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    selectionCount: function () {
                        return selectedCount();
                    },
                    selectedUserIds: function () {
                        return getSelectedUserIds();
                    },
                    action: function () {
                        return action;
                    },
                    agences: function () {
                        return vm.agences;
                    },
                    authorities: function () {
                        return vm.authorities;
                    },
                    bulkService: function () {
                        return UserAdmin;
                    }
                }
            }).result.then(function () {
                vm.loadAll();
            });
        }

        function downloadCsv() {
            UserAdmin.exportCsv(buildQueryParams(false), function(result) {
                saveCsvFile(result, 'wamasys-users-admin.csv');
            }, function(error) {
                AlertService.error(resolveErrorMessage(error, 'Export CSV impossible.'));
            });
        }

        function buildQueryParams(includePaging) {
            var params = {};
            if (vm.filter) {
                params.filter = vm.filter;
            }
            if (vm.selectedRole) {
                params.role = vm.selectedRole;
            }
            if (vm.selectedAgenceId) {
                params.agenceId = vm.selectedAgenceId;
            }
            if (vm.selectedActivated === true || vm.selectedActivated === false) {
                params.activated = vm.selectedActivated;
            }
            // Conserver les mêmes critères Android pour la pagination et l’export CSV.
            if (vm.selectedAndroidDevice === true || vm.selectedAndroidDevice === false) {
                params.androidDevice = vm.selectedAndroidDevice;
            }
            if (vm.selectedAppVersion && vm.selectedAppVersion.trim()) {
                params.appVersion = vm.selectedAppVersion.trim();
            }
            // Le filtre MFA est commun au tableau paginé et à l’export.
            if (vm.selectedMfaEnabled === true || vm.selectedMfaEnabled === false) {
                params.mfaEnabled = vm.selectedMfaEnabled;
            }
            if (includePaging) {
                params.page = vm.page - 1;
                params.size = paginationConstants.itemsPerPage;
            }
            return params;
        }

        function getSelectedUserIds() {
            var selectedUserIds = [];
            angular.forEach(vm.users, function(user) {
                if (vm.selection[user.id]) {
                    selectedUserIds.push(user.id);
                }
            });
            return selectedUserIds;
        }

        function resetSelectionState() {
            vm.selection = {};
            vm.selectAllOnPage = false;
        }

        function saveCsvFile(result, defaultFileName) {
            var url = $window.URL || $window.webkitURL;
            var fileName = result.fileName || defaultFileName;

            if ($window.navigator && $window.navigator.msSaveOrOpenBlob) {
                $window.navigator.msSaveOrOpenBlob(result.response, fileName);
                return;
            }

            var downloadLink = angular.element('<a></a>');
            downloadLink.attr('href', url.createObjectURL(result.response));
            downloadLink.attr('download', fileName);
            downloadLink[0].click();
            downloadLink.remove();
        }

        function resolveErrorMessage(error, defaultMessage) {
            if (error && error.data && error.data.message) {
                return error.data.message;
            }
            return defaultMessage;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('UserAdminDialogController',UserAdminDialogController);

    UserAdminDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'UserAdmin', 'JhiLanguageService', 'Organisation'];

    function UserAdminDialogController ($stateParams, $uibModalInstance, entity, UserAdmin, JhiLanguageService, Organisation) {
        var vm = this;

        vm.authorities = ['ROLE_WATER_QUALITY_READ', 'ROLE_WATER_QUALITY_EDIT', 'ROLE_EQUIPMENT_READ', 'ROLE_EQUIPMENT_EDIT', 'ROLE_EQUIPMENT_SECRETS', 'ROLE_EQUIPMENT_REMOTE_CONTROL', 'ROLE_SUPER_ADMIN', 'ROLE_ADMIN','ROLE_AREA_CONFIGURATION','ROLE_AREA_MANAGEMENT','ROLE_DATA_OPERATOR','ROLE_COLLECTOR','ROLE_SPECIFIC_PRICE','ROLE_READ_ONLY','ROLE_EVT_EDIT','ROLE_EVT_READ_ONLY','ROLE_FORM_VALIDATION','ROLE_BUDGET_READ_ONLY','ROLE_BUDGET_EDIT','ROLE_AI_ASSISTANT'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        vm.organisations = Organisation.query();
        vm.agences = UserAdmin.getAllAgency();

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                UserAdmin.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                UserAdmin.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('UserAdminDetailController', UserAdminDetailController);

    UserAdminDetailController.$inject = ['$stateParams', 'UserAdmin', 'Mfa', '$window', '$translate'];

    function UserAdminDetailController ($stateParams, UserAdmin, Mfa, $window, $translate) {
        var vm = this;

        vm.load = load;
        vm.user = {};
        vm.disableMfa = disableMfa;

        vm.load($stateParams.login);

        function load (login) {
            UserAdmin.get({login: login}, function(result) {
                vm.user = result;
                Mfa.managedStatus(login).then(function(status) { vm.mfaStatus = status; })
                    .catch(function() { vm.mfaStatus = null; });
            });
        }

        function disableMfa() {
            if (vm.mfaBusy || !$window.confirm($translate.instant('mfa.adminConfirm', {login: vm.user.login}))) { return; }
            vm.mfaBusy = true;
            vm.mfaError = null;
            Mfa.disableForUser(vm.user.login).then(function(status) {
                vm.mfaStatus = status;
                vm.mfaSuccess = true;
            }).catch(function() { vm.mfaError = true; }).finally(function() { vm.mfaBusy = false; });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('UserAdminDeleteController', UserAdminDeleteController);

    UserAdminDeleteController.$inject = ['$uibModalInstance', 'entity', 'UserAdmin'];

    function UserAdminDeleteController ($uibModalInstance, entity, UserAdmin) {
        var vm = this;

        vm.user = entity;
        vm.deleteError = null;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            vm.deleteError = null;
            UserAdmin.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                },
                function (error) {
                    vm.deleteError = (error.headers && error.headers('X-wamasysApp-detail')) || 'Suppression impossible.';
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('api/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ClosingContractReasonController', ClosingContractReasonController);

    ClosingContractReasonController.$inject = ['$scope', '$state', 'ClosingContractReason', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ClosingContractReasonController ($scope, $state, ClosingContractReason, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            ClosingContractReason.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.closingContractReasons = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('closing-contract-reason', {
            parent: 'entity',
            url: '/closing-contract-reason?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.closingContractReason.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/closing-contract-reason/closing-contract-reasons.html',
                    controller: 'ClosingContractReasonController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('closingContractReason');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('closing-contract-reason-detail', {
            parent: 'entity',
            url: '/closing-contract-reason/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.closingContractReason.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/closing-contract-reason/closing-contract-reason-detail.html',
                    controller: 'ClosingContractReasonDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('closingContractReason');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ClosingContractReason', function($stateParams, ClosingContractReason) {
                    return ClosingContractReason.get({id : $stateParams.id});
                }]
            }
        })
        .state('closing-contract-reason.new', {
            parent: 'closing-contract-reason',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/closing-contract-reason/closing-contract-reason-dialog.html',
                    controller: 'ClosingContractReasonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('closing-contract-reason', null, { reload: true });
                }, function() {
                    $state.go('closing-contract-reason');
                });
            }]
        })
        .state('closing-contract-reason.edit', {
            parent: 'closing-contract-reason',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/closing-contract-reason/closing-contract-reason-dialog.html',
                    controller: 'ClosingContractReasonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ClosingContractReason', function(ClosingContractReason) {
                            return ClosingContractReason.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('closing-contract-reason', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('closing-contract-reason.delete', {
            parent: 'closing-contract-reason',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/closing-contract-reason/closing-contract-reason-delete-dialog.html',
                    controller: 'ClosingContractReasonDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ClosingContractReason', function(ClosingContractReason) {
                            return ClosingContractReason.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('closing-contract-reason', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ClosingContractReason', ClosingContractReason);

    ClosingContractReason.$inject = ['$resource'];

    function ClosingContractReason ($resource) {
        var resourceUrl =  'api/closing-contract-reasons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ClosingContractReasonDialogController', ClosingContractReasonDialogController);

    ClosingContractReasonDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ClosingContractReason'];

    function ClosingContractReasonDialogController ($scope, $stateParams, $uibModalInstance, entity, ClosingContractReason) {
        var vm = this;
        vm.closingContractReason = entity;
        vm.load = function(id) {
            ClosingContractReason.get({id : id}, function(result) {
                vm.closingContractReason = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:closingContractReasonUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.closingContractReason.id !== null) {
                ClosingContractReason.update(vm.closingContractReason, onSaveSuccess, onSaveError);
            } else {
                ClosingContractReason.save(vm.closingContractReason, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ClosingContractReasonDetailController', ClosingContractReasonDetailController);

    ClosingContractReasonDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ClosingContractReason'];

    function ClosingContractReasonDetailController($scope, $rootScope, $stateParams, entity, ClosingContractReason) {
        var vm = this;
        vm.closingContractReason = entity;
        vm.load = function (id) {
            ClosingContractReason.get({id: id}, function(result) {
                vm.closingContractReason = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:closingContractReasonUpdate', function(event, result) {
            vm.closingContractReason = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ClosingContractReasonDeleteController',ClosingContractReasonDeleteController);

    ClosingContractReasonDeleteController.$inject = ['$uibModalInstance', 'entity', 'ClosingContractReason'];

    function ClosingContractReasonDeleteController($uibModalInstance, entity, ClosingContractReason) {
        var vm = this;
        vm.closingContractReason = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ClosingContractReason.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';
    angular.module('wamasysApp').config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('ai-costs', {
            parent: 'entity', url: '/ai-costs',
            data: { authorities: ['ROLE_SUPER_ADMIN'], pageTitle: 'Coûts IA (USD)' },
            views: { 'content@': { templateUrl: 'app/business/ai-costs/ai-costs.html', controller: 'AiCostsController', controllerAs: 'vm' } }
        });
    }]);
})();
;
(function() {
    'use strict';
    angular.module('wamasysApp').controller('AiCostsController', ['$http', 'AlertService', function($http, AlertService) {
        var vm = this;
        vm.data = {settings: {}, prices: [], warnings: [], recentUsage: []};
        vm.loading = false;
        vm.saving = false;
        vm.price = null;
        vm.resolution = null;
        vm.load = load;
        vm.saveSettings = function() { save('/settings', vm.data.settings); };
        vm.editPrice = function(price) { vm.price = angular.copy(price || {provider: 'openai', model: '', enabled: true}); };
        vm.savePrice = function() { save('/prices', vm.price); };
        vm.resolveUsage = function(row) { vm.resolution = {id: row.id, costUsd: row.estimatedCostUsd, note: ''}; };
        vm.saveResolution = function() {
            vm.saving = true;
            $http.post('/api/admin/ai-costs/usage/' + vm.resolution.id + '/resolve', vm.resolution).then(function() {
                vm.resolution = null; load();
            }).catch(error).finally(function() { vm.saving = false; });
        };
        vm.priceStatus = function(price) {
            if (!price.enabled) { return 'Désactivé'; }
            if (!price.verifiedOn || price.inputUsdPerMillion == null || price.cachedInputUsdPerMillion == null || price.outputUsdPerMillion == null) { return 'Tarif manquant — appels bloqués'; }
            if (price.provider === 'ollama') { return 'Local — 0 USD fournisseur'; }
            var verified = new Date(price.verifiedOn + 'T00:00:00');
            var today = new Date(); today.setHours(0, 0, 0, 0);
            return Math.round((today.getTime() - verified.getTime()) / 86400000) > vm.data.settings.staleAfterDays ? 'À vérifier — tarif ancien' : 'À jour';
        };
        vm.usageStatus = function(status) {
            return {RESERVED: 'Réservé / en cours', SETTLED: 'Mesuré', UNCERTAIN: 'Coût incertain', REJECTED: 'Refusé — 0 USD', RESOLVED: 'Régularisé'}[status] || status;
        };
        vm.canResolve = function(row) { return row.status === 'UNCERTAIN' || (row.status === 'RESERVED' && new Date(row.createdAt).getTime() < Date.now() - 7200000); };
        function save(path, data) {
            vm.saving = true;
            $http.put('/api/admin/ai-costs' + path, data).then(function() {
                vm.price = null; vm.message = 'Paramétrage enregistré.'; load();
            }).catch(error).finally(function() { vm.saving = false; });
        }
        function load() {
            vm.loading = true;
            $http.get('/api/admin/ai-costs').then(function(response) { vm.data = response.data; })
                .catch(error).finally(function() { vm.loading = false; });
        }
        function error(response) {
            AlertService.error((response.headers && response.headers('X-wamasysApp-error')) || 'Impossible de traiter le paramétrage des coûts IA.');
        }
        load();
    }]);
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cas-non-releve', {
            parent: 'entity',
            url: '/cas-non-releve?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.casNonReleve.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/cas-non-releve/cas-non-releves.html',
                    controller: 'CasNonReleveController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('casNonReleve');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cas-non-releve-detail', {
            parent: 'entity',
            url: '/cas-non-releve/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.casNonReleve.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/cas-non-releve/cas-non-releve-detail.html',
                    controller: 'CasNonReleveDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('casNonReleve');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CasNonReleve', function($stateParams, CasNonReleve) {
                    return CasNonReleve.get({id : $stateParams.id});
                }]
            }
        })
        .state('cas-non-releve.new', {
            parent: 'cas-non-releve',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cas-non-releve/cas-non-releve-dialog.html',
                    controller: 'CasNonReleveDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cas-non-releve', null, { reload: true });
                }, function() {
                    $state.go('cas-non-releve');
                });
            }]
        })
        .state('cas-non-releve.edit', {
            parent: 'cas-non-releve',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cas-non-releve/cas-non-releve-dialog.html',
                    controller: 'CasNonReleveDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CasNonReleve', function(CasNonReleve) {
                            return CasNonReleve.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('cas-non-releve', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cas-non-releve.delete', {
            parent: 'cas-non-releve',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cas-non-releve/cas-non-releve-delete-dialog.html',
                    controller: 'CasNonReleveDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CasNonReleve', function(CasNonReleve) {
                            return CasNonReleve.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('cas-non-releve', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('CasNonReleve', CasNonReleve);

    CasNonReleve.$inject = ['$resource'];

    function CasNonReleve ($resource) {
        var resourceUrl =  'api/cas-non-releve/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'search': { method: 'GET', 
              	url :'/api/cas-non-releve/search',
              	isArray: true
            },
            'downloadcsv': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/cas-non-releve/downloadcsv',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CasNonReleveController', CasNonReleveController);

    CasNonReleveController.$inject = ['$scope', '$state', 'CasNonReleve', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CasNonReleveController ($scope, $state, CasNonReleve, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            CasNonReleve.queryInclDeleted({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.casNonReleves = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CasNonReleveDialogController', CasNonReleveDialogController);

    CasNonReleveDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'CasNonReleve'];

    function CasNonReleveDialogController ($scope, $stateParams, $uibModalInstance, entity, CasNonReleve) {
        var vm = this;
        vm.casNonReleve = entity;
        vm.load = function(id) {
            CasNonReleve.get({id : id}, function(result) {
                vm.casNonReleve = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:casNonReleveUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.casNonReleve.id !== null) {
                CasNonReleve.update(vm.casNonReleve, onSaveSuccess, onSaveError);
            } else {
                CasNonReleve.save(vm.casNonReleve, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CasNonReleveDetailController', CasNonReleveDetailController);

    CasNonReleveDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CasNonReleve'];

    function CasNonReleveDetailController($scope, $rootScope, $stateParams, entity, CasNonReleve) {
        var vm = this;
        vm.casNonReleve = entity;
        vm.load = function (id) {
            CasNonReleve.get({id: id}, function(result) {
                vm.casNonReleve = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:casNonReleveUpdate', function(event, result) {
            vm.casNonReleve = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CasNonReleveDeleteController',CasNonReleveDeleteController);

    CasNonReleveDeleteController.$inject = ['$uibModalInstance', 'entity', 'CasNonReleve'];

    function CasNonReleveDeleteController($uibModalInstance, entity, CasNonReleve) {
        var vm = this;
        vm.casNonReleve = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CasNonReleve.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('metrics/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('dump').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('area-setup', {
            parent: 'entity',
            url: '/area-setup/{id}',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION', 'ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.agence.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/agence/agence-setup.html',
                    controller: 'AgenceSetupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	entity: ['$stateParams', 'Agence', function ($stateParams, Agence) {
                        return Agence.get({id : $stateParams.id});
                  
                }],
                templateEntity: [function () {
                    return null;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agence');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('area-template-setup', {
            parent: 'entity',
            url: '/area-template-setup/{id}',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION', 'ROLE_READ_ONLY'],
                pageTitle: 'global.menu.areaTemplates'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/agence/agence-template-setup.html',
                    controller: 'AgenceSetupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Agence', function ($stateParams, Agence) {
                    return Agence.get({id : $stateParams.id});

                }],
                templateEntity: ['$stateParams', 'AgenceTemplate', function ($stateParams, AgenceTemplate) {
                    return AgenceTemplate.get({idArea : $stateParams.id}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agence');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('agence', {
            parent: 'entity',
            url: '/agence?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.agence.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/agence/agences.html',
                    controller: 'AgenceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agence');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('agence-detail', {
            parent: 'entity',
            url: '/agence/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.agence.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/agence/agence-detail.html',
                    controller: 'AgenceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agence');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Agence', function($stateParams, Agence) {
                    return Agence.get({id : $stateParams.id});
                }]
            }
        })
        .state('agence.new', {
            parent: 'agence',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/agence/agence-dialog.html',
                    controller: 'AgenceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nom: null,
                                codeAgence: null,
                                devise: null,
                                enteteFacture: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('agence', null, { reload: true });
                }, function() {
                    $state.go('agence');
                });
            }]
        })
        .state('agence.edit', {
            parent: 'agence',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/agence/agence-dialog.html',
                    controller: 'AgenceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Agence', function(Agence) {
                            return Agence.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('agence', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('agence.delete', {
            parent: 'agence',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/agence/agence-delete-dialog.html',
                    controller: 'AgenceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Agence', function(Agence) {
                            return Agence.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('agence', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('Agence', Agence);

    Agence.$inject = ['$resource','DateUtils'];

    function Agence ($resource,DateUtils) {
        var resourceUrl =  'api/agences/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'currentOrganisation': { method: 'GET', isArray: true, url: 'api/agences/current-organisation' },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateDebutDemarrage = DateUtils.convertLocalDateFromServer(data.dateDebutDemarrage);
                    return data;
                }
            },
            'update': { method:'PUT',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.dateDebutDemarrage = DateUtils.convertLocalDateToServer(data.dateDebutDemarrage);
                    return angular.toJson(clonedData);
                }
            }
            ,
            'saveClientPortalConf': { method:'PUT',
            	url:'api/agences/client-portal-conf',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
//                	clonedData.dateDebutDemarrage = DateUtils.convertLocalDateToServer(data.dateDebutDemarrage);
                    return angular.toJson(clonedData);
                }
            },
            'getClientPortalConf': {
                method: 'GET',
                url:'api/agences/:idArea/client-portal-conf',
                transformResponse: function (data) {
                	if(data){
                	     data = angular.fromJson(data);
//                       data.dateDebutDemarrage = DateUtils.convertLocalDateFromServer(data.dateDebutDemarrage);
                       return data;
                	}
                	 return data;
                }
            },
            'saveOnlinePaymentConf': { method:'PUT',
            	url:'api/agences/online-payment-conf',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
//                	clonedData.dateDebutDemarrage = DateUtils.convertLocalDateToServer(data.dateDebutDemarrage);
                    return angular.toJson(clonedData);
                }
            },
            'getOnlinePaymentConf': {
                method: 'GET',
                url:'api/agences/:idArea/online-payment-conf',
                transformResponse: function (data) {
                	if(data){
                	     data = angular.fromJson(data);
//                       data.dateDebutDemarrage = DateUtils.convertLocalDateFromServer(data.dateDebutDemarrage);
                       return data;
                	}
                	 return data;
                }
            },
            'saveGeometryConf': { method:'PUT',
            	url:'api/agences/geometry-conf/',
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
//                	clonedData.dateDebutDemarrage = DateUtils.convertLocalDateToServer(data.dateDebutDemarrage);
                    return angular.toJson(clonedData);
                }
            },
            'getTimezones': {
                method: 'GET',
                url:'api/timezones',
                isArray: true
            },
            'chatClientPortalAssistant': {
                method: 'POST',
                url: 'api/agences/client-portal-conf/assistant/chat'
            },
            'getClientPortalAssistantUsage': {
                method: 'GET',
                url: 'api/agences/client-portal-conf/assistant/usage'
            },
            'submitClientPortalAssistantFeedback': {
                method: 'POST',
                url: 'api/agences/client-portal-conf/assistant/feedback'
            },
            'previewPaymentRecoveryNotice': {
                method: 'POST',
                headers: {
                    accept: 'application/pdf'
                },
                responseType: 'arraybuffer',
                url: 'api/agences/payment-recovery-notice-preview',
                transformResponse: function (data, headers) {
                    var filename = headers('FileName');
                    var contentType = headers('ContentType');
                    var blob;
                    if (data) {
                        blob = new Blob([data], {
                            type: contentType || 'application/pdf'
                        });
                    }
                    return {
                        response: blob,
                        fileName: filename,
                        contentType: contentType
                    };
                }
            },
            'previewInvoice': {
                method: 'POST',
                headers: {
                    accept: 'application/pdf'
                },
                responseType: 'arraybuffer',
                url: 'api/agences/invoice-preview',
                transformResponse: function (data, headers) {
                    var filename = headers('FileName');
                    var contentType = headers('ContentType');
                    var blob;
                    if (data) {
                        blob = new Blob([data], {
                            type: contentType || 'application/pdf'
                        });
                    }
                    return {
                        response: blob,
                        fileName: filename,
                        contentType: contentType
                    };
                }
            }
            
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('AgenceController', AgenceController);

    AgenceController.$inject = ['$scope', '$state', 'Agence', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AgenceController ($scope, $state, Agence, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll();

        function loadAll () {
            Agence.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.agences = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('AgenceTemplate', AgenceTemplate);

    AgenceTemplate.$inject = ['$resource'];

    function AgenceTemplate($resource) {
        return $resource('api/agences/:idArea/template-conf', {}, {
            'validateHtml': {
                url: 'api/template-html/validate',
                method: 'POST'
            },
            'validateDocumentTemplate': {
                url: 'api/template-html/validate-document',
                method: 'POST'
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        return angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function(data) {
                    return angular.toJson(angular.copy(data));
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('AgenceSetupController', AgenceSetupController);

    AgenceSetupController.$inject = ['$scope', "leafletMapEvents",'$stateParams','$state', '$timeout', '$sce', '$window', 'entity', 'templateEntity', 'Agence', 'AgenceTemplate', 'WaterNetwork',
        'ChannelConf', 'Principal', 'AssistantPanelService', '$translate'];

    function AgenceSetupController ($scope, leafletMapEvents, $stateParams, $state, $timeout, $sce, $window, entity, templateEntity, Agence, AgenceTemplate, WaterNetwork, ChannelConf,
        Principal, AssistantPanelService, $translate) {
        var TEMPLATE_PREVIEW_DELAY_MS = 300;
        var globalCommunicationPreviewPromise;
        var clientPortalMessagePreviewPromise;
        var documentPreviewVersion = 0;
        var vm = this;
        vm.agence = entity;
        vm.agenceTemplate = buildEmptyAgenceTemplate();
        vm.waterNetworks = WaterNetwork.query({ offset: 0,size: 1000});
        vm.channelConfs = ChannelConf.query({ page: 0, size: 1000, sort: 'nom,asc' });
        vm.onlinePaymentTypes = [{code:'MTN_USSD_V1', label:'MTN USSD'},{code:'MPESA_PAYBILL_V1', label:'M-Pesa Paybill'}];
        vm.isEmailChannelConf = isEmailChannelConf;
        vm.isSmsChannelConf = isSmsChannelConf;
        vm.showClientPortalTemplateHelp = false;
        vm.canUseAssistant = false;
        vm.geometryMapRefreshToken = 0;
        vm.globalCommunicationPreview = buildEmptyTemplatePreview();
        vm.clientPortalMessagePreview = buildEmptyTemplatePreview();
        vm.previewInvoiceTemplate = previewInvoicePdfTemplate;
        vm.previewReceiptTemplate = previewReceiptTemplate;
        vm.previewBillingNoticePdfTemplate = previewBillingNoticePdfTemplate;
        vm.previewBillingNoticeTemplate = previewBillingNoticeTemplate;
        vm.clientPortalTemplateVariableDetails = [
            { name: '${contractRef}', description: 'Référence du contrat.' },
            { name: '${contractName}', description: 'Nom de la personne du contrat.' },
            { name: '${contractAddress}', description: 'Adresse du contrat.' },
            { name: '${amountBilled}', description: 'Montant de la dernière facturation.' },
            { name: '${totalToBePaid}', description: 'Solde total restant à payer.' },
            { name: '${servicesToBePaid}', description: 'Détail texte des services restant à payer.' },
            { name: '${taxesToBePaid}', description: 'Détail texte des taxes restant à payer.' },
            { name: '${servicesToBePaidHtml}', description: 'Détail HTML des services restant à payer.' },
            { name: '${taxesToBePaidHtml}', description: 'Détail HTML des taxes restant à payer.' },
            { name: '${dateNow}', description: 'Date du jour.' },
            { name: '${url}', description: 'Lien de réinitialisation du mot de passe portail client.' },
            { name: '${tokenTmp}', description: 'Code temporaire de réinitialisation envoyé par SMS.' },
            { name: '${clientPortalAreaName}', description: 'Nom de la zone affiché dans le portail client.' },
            { name: '${messageContent}', description: 'Contenu principal injecté dans un habillage global.' },
            { name: '${messageContentText}', description: 'Version texte brut du contenu principal.' },
            { name: '${areaName}', description: 'Nom de la zone.' },
            { name: '${urlLogo}', description: 'URL du logo de la zone.' },
            { name: '${contactAddress}', description: 'Adresse de contact affichée au client.' },
            { name: '${contactEmail}', description: 'Email de contact affiché au client.' },
            { name: '${contactTel}', description: 'Téléphone de contact affiché au client.' },
            { name: '${contactWebsite}', description: 'Site web de contact affiché au client.' }
        ];
        vm.clientPortalTemplateVariables = vm.clientPortalTemplateVariableDetails.map(function(variable) {
            return variable.name;
        });
        vm.toggleClientPortalTemplateHelp = function () {
            vm.showClientPortalTemplateHelp = !vm.showClientPortalTemplateHelp;
        };
        vm.openClientPortalAssistantChat = openClientPortalAssistantChat;
        vm.onGeometryTabSelect = function() {
            vm.geometryMapRefreshToken = vm.geometryMapRefreshToken + 1;
        };

        vm.timezones = Agence.getTimezones();
        initializeAgenceTemplate(templateEntity);
        vm.updateCoord = function(){
          	
        	//On remet à 0 en cas d'erreur sur le champs.
        	if(! vm.agence.lat ){
        		vm.agence.lat = 0;
        	}
        	if(! vm.agence.lon){
        		vm.agence.lon = 0;
        	}

        	if( vm.agence.geographicCoord){
        		vm.geometry = vm.agence.geographicCoord;
        	}
        	
	        angular.extend($scope, {
	            defaults: {
	                scrollWheelZoom: false
	            },
//	            events: {
//	                map: {
//	                    enable: [ 'drag', 'click'],
//	                    logic: 'emit'
//	                }
//	            },
	            markers: {
	                Area: {
	                    lat: vm.agence.lat,
	                    lng: vm.agence.lon,
//	                    message: "This is Madrid. But you can drag me to another position",
	                    focus: true,
	                    draggable: true
	                }
	            }
	        })
        }
        
        vm.load = function(id) {
            Agence.get({id : id}, function(result) {
                vm.agence = result;

            	vm.updateCoord ();
               
                
            });
        };
        
        if(entity && entity.$promise){
            entity.$promise.then(function(value) {
            	vm.updateCoord ();
                Agence.getClientPortalConf({idArea : vm.agence.id}, function(result) {
                	vm.agence.clientPortalConf =  result;
                    scheduleGlobalCommunicationPreview();
                    scheduleClientPortalMessagePreview();
                });

                Agence.getOnlinePaymentConf({idArea : vm.agence.id}, function(result) {
                	vm.agence.areaConfOnlinePayment =  result;
                },  function(error) {
                	//on ne fait rien en cas de 404
                });
            });	
        }else{
        	vm.updateCoord();
        }

        Principal.identity().then(function(account) {
            if (account) {
                vm.canUseAssistant = (account.modules || []).indexOf('AI_ASSISTANT') !== -1
                    && (account.authorities.indexOf('ROLE_AI_ASSISTANT') !== -1
                    || account.authorities.indexOf('ROLE_ADMIN') !== -1
                    || account.authorities.indexOf('ROLE_SUPER_ADMIN') !== -1);
            }
        });
        registerClientPortalPreviewWatchers();
        scheduleGlobalCommunicationPreview();
        scheduleClientPortalMessagePreview();

        $scope.$on("leafletDirectiveMarker.dragend", function(event, args){
            if (!args || args.modelName !== 'contrat') {
                return;
            }
            vm.agence.lat = args.model.lat;
            vm.agence.lon = args.model.lng;
        });


        vm.save = function () {
        	Agence.update(vm.agence, onSaveSuccess, onSaveError);
        };

        vm.saveTemplate = function () {
            vm.templateHtmlError = '';
            vm.isSavingTemplateForm = true;
            AgenceTemplate.update({idArea: vm.agence.id}, vm.agenceTemplate, onSaveSuccessTemplate, onSaveError);
        };

        vm.saveClientPortalConf = function () {
            vm.templateHtmlError = '';
            vm.agence.clientPortalConf.agence = {id: vm.agence.id};
        	Agence.saveClientPortalConf(vm.agence.clientPortalConf, onSaveSuccessClientPortalConf, onSaveError);
        };

        vm.saveOnlinePaymentConf = function () {
        	vm.agence.areaConfOnlinePayment.agence  = {id:vm.agence.id};
        	Agence.saveOnlinePaymentConf (vm.agence.areaConfOnlinePayment, onSaveSuccessOnlinePaymentConf, onSaveError);
        };
        var onSaveSuccessOnlinePaymentConf = function (result) {
            $scope.$emit('wamasysApp:onlinePaymentConfUpdate', result);
        	vm.agence.areaConfOnlinePayment =  result;
        };
        
        
        vm.saveGeometryConf = function () {
        	var data = {agence: vm.agence ,geometry: vm.geometry  };
        	Agence.saveGeometryConf (data, onSaveSuccessGeometryConf , onSaveError);
        };
        var onSaveSuccessGeometryConf = function (result) {
            $scope.$emit('wamasysApp:geometryConfUpdate', result);
        };

        var onSaveSuccessTemplate = function (result) {
            $scope.$emit('wamasysApp:agenceTemplateUpdate', result);
            vm.agenceTemplate = angular.extend(buildEmptyAgenceTemplate(), result || {});
            vm.isSavingTemplateForm = false;
            scheduleGlobalCommunicationPreview();
            scheduleClientPortalMessagePreview();
        };

        
        var onSaveSuccessClientPortalConf = function (result) {
            $scope.$emit('wamasysApp:clientPortalConfUpdate', result);
        	vm.agence.clientPortalConf =  result;
            scheduleGlobalCommunicationPreview();
            scheduleClientPortalMessagePreview();
        };
        
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:agenceUpdate', result);
         //   $state.go('area-setup', {id:vm.agence.id}, { reload: true });
        };

        var onSaveError = function (response) {
            if (response && response.data && response.data.message === 'error.unsafeTemplateHtml') {
                vm.templateHtmlError = $translate.instant('error.unsafeTemplateHtml');
            }
            vm.isSaving = false;
            vm.isSavingTemplateForm = false;
            vm.isSavingAreaConfForm = false;
            vm.isSavingOnlinePaymentConfForm = false;
            vm.isSavingEditGeometryForm = false;
        };
        
        vm.clear = function() {
            $state.go($state.current.name, {id:vm.agence.id}, { reload: true });
        };

        function isEmailChannelConf(channelConf) {
            return channelConf && (channelConf.channel === 'EMAIL_SMTP' || channelConf.channel === 'EMAIL_SENDBLUE');
        }

        function isSmsChannelConf(channelConf) {
            return channelConf && (
                channelConf.channel === 'SMS_ORACOM'
                || channelConf.channel === 'SMS_PHILSMS'
                || channelConf.channel === 'SMS_BULKSMSBD'
                || channelConf.channel === 'SMS_AWS'
            );
        }

        function initializeAgenceTemplate(resolvedTemplate) {
            if (!resolvedTemplate) {
                return;
            }

            vm.agenceTemplate = angular.extend(buildEmptyAgenceTemplate(), resolvedTemplate);
            scheduleGlobalCommunicationPreview();
            scheduleClientPortalMessagePreview();
        }

        function openClientPortalAssistantChat() {
            if (!vm.canUseAssistant || !vm.agence || !vm.agence.clientPortalConf) {
                return;
            }

            AssistantPanelService.open({
                contextType: 'CLIENT_PORTAL_CONF',
                entityId: vm.agence.clientPortalConf.id || vm.agence.id,
                title: $translate.instant('global.assistant.templateTitle'),
                subtitle: vm.agence.clientPortalConf.areaName || vm.agence.nom || 'Espace client',
                promptPlaceholder: $translate.instant('global.assistant.templatePromptPlaceholder'),
                supportsActionProposal: false,
                supportsDataScopes: false,
                adapter: {
                    chat: function(payload, success, error) {
                        Agence.chatClientPortalAssistant(buildClientPortalAssistantRequest(payload), success, error);
                    },
                    getUsage: function(success, error) {
                        Agence.getClientPortalAssistantUsage(success, error);
                    },
                    submitFeedback: function(payload, success, error) {
                        Agence.submitClientPortalAssistantFeedback(payload, success, error);
                    },
                    applyAssistantResponse: function(result) {
                        if (!result || !result.suggestedFieldValues) {
                            return;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template) && result.suggestedFieldValues.template !== null) {
                            vm.agence.clientPortalConf.templateTxt = result.suggestedFieldValues.template;
                            vm.agence.clientPortalConf.templateSms = result.suggestedFieldValues.template;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template_html) && result.suggestedFieldValues.template_html !== null) {
                            vm.agence.clientPortalConf.templateHtml = result.suggestedFieldValues.template_html;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template_subject) && result.suggestedFieldValues.template_subject !== null) {
                            vm.agence.clientPortalConf.templateSubject = result.suggestedFieldValues.template_subject;
                        }
                        AssistantPanelService.invalidateConversationContext();
                        $scope.$evalAsync();
                    },
                    buildContextSignatureFragment: function() {
                        return [
                            vm.agence.id || '',
                            hashString(vm.agenceTemplate.communicationGlobalSmsTemplate || ''),
                            hashString(vm.agenceTemplate.communicationGlobalEmailTemplateHtml || ''),
                            hashString(vm.agence.clientPortalConf.templateSms || ''),
                            hashString(vm.agence.clientPortalConf.templateTxt || ''),
                            hashString(vm.agence.clientPortalConf.templateHtml || ''),
                            hashString(vm.agence.clientPortalConf.templateSubject || '')
                        ].join('|');
                    }
                }
            });
        }

        function buildClientPortalAssistantRequest(payload) {
            return {
                assistantRequest: payload,
                communicationAutomationConf: {
                    id: vm.agence.clientPortalConf.id,
                    type: 'CLIENT_PORTAL_CONF',
                    template: vm.agence.clientPortalConf.templateTxt || vm.agence.clientPortalConf.templateSms,
                    templateHtml: vm.agence.clientPortalConf.templateHtml,
                    templateSubject: vm.agence.clientPortalConf.templateSubject
                },
                availableVariables: angular.copy(vm.clientPortalTemplateVariables),
                selectedChannel: vm.agence.clientPortalConf.emailChannelConf ? vm.agence.clientPortalConf.emailChannelConf.channel
                    : (vm.agence.clientPortalConf.smsChannelConf ? vm.agence.clientPortalConf.smsChannelConf.channel : 'EMAIL_SMTP'),
                contextType: 'CLIENT_PORTAL_CONF',
                contextEntityId: vm.agence.clientPortalConf.id || vm.agence.id,
                contextLabel: vm.agence.clientPortalConf.areaName || vm.agence.nom,
                contextMetadata: {
                    areaName: vm.agence.clientPortalConf.areaName,
                    pathUrl: vm.agence.clientPortalConf.pathUrl,
                    contactEmail: vm.agence.clientPortalConf.contactEmail,
                    contactTel: vm.agence.clientPortalConf.contactTel,
                    availableVariableDetails: angular.copy(vm.clientPortalTemplateVariableDetails),
                    communicationGlobalSmsTemplate: vm.agenceTemplate.communicationGlobalSmsTemplate,
                    communicationGlobalEmailTemplateHtml: vm.agenceTemplate.communicationGlobalEmailTemplateHtml,
                    showInvoice: vm.agence.clientPortalConf.showInvoice,
                    showReceipt: vm.agence.clientPortalConf.showReceipt
                }
            };
        }

        function registerClientPortalPreviewWatchers() {
            $scope.$watchGroup([
                function() { return vm.agenceTemplate && vm.agenceTemplate.communicationGlobalSmsTemplate; },
                function() { return vm.agenceTemplate && vm.agenceTemplate.communicationGlobalEmailTemplateHtml; }
            ], function() {
                scheduleGlobalCommunicationPreview();
            });

            $scope.$watchGroup([
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.areaName; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.urlLogo; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.contactAddress; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.contactEmail; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.contactTel; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.contactWebsite; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.templateSms; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.templateTxt; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.templateHtml; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.templateSubject; },
                function() { return vm.agenceTemplate && vm.agenceTemplate.communicationGlobalSmsTemplate; },
                function() { return vm.agenceTemplate && vm.agenceTemplate.communicationGlobalEmailTemplateHtml; }
            ], function() {
                scheduleClientPortalMessagePreview();
            });

            $scope.$on('$destroy', function() {
                if (globalCommunicationPreviewPromise) {
                    $timeout.cancel(globalCommunicationPreviewPromise);
                }
                if (clientPortalMessagePreviewPromise) {
                    $timeout.cancel(clientPortalMessagePreviewPromise);
                }
            });
        }

        function scheduleGlobalCommunicationPreview() {
            if (globalCommunicationPreviewPromise) {
                $timeout.cancel(globalCommunicationPreviewPromise);
            }
            globalCommunicationPreviewPromise = $timeout(refreshGlobalCommunicationPreview, TEMPLATE_PREVIEW_DELAY_MS);
        }

        function scheduleClientPortalMessagePreview() {
            if (clientPortalMessagePreviewPromise) {
                $timeout.cancel(clientPortalMessagePreviewPromise);
            }
            clientPortalMessagePreviewPromise = $timeout(refreshClientPortalMessagePreview, TEMPLATE_PREVIEW_DELAY_MS);
        }

        function refreshGlobalCommunicationPreview() {
            if (!vm.agenceTemplate) {
                vm.globalCommunicationPreview = buildEmptyTemplatePreview();
                return;
            }

            var variables = buildGlobalCommunicationPreviewVariables();
            var sampleMessage = buildGlobalCommunicationPreviewContent();
            var finalSms = applySmsGlobalTemplatePreview(sampleMessage.sms, variables);
            var finalHtml = applyEmailGlobalTemplatePreview(sampleMessage.text, sampleMessage.html, variables);

            vm.globalCommunicationPreview = {
                hasContent: !!(finalSms || finalHtml),
                sms: finalSms || '',
                subject: '',
                text: '',
                html: finalHtml || '',
                trustedHtml: $sce.trustAsHtml('')
            };
            validatePreviewHtml('globalCommunicationPreview', finalHtml);
        }

        function refreshClientPortalMessagePreview() {
            if (!vm.agence || !vm.agence.clientPortalConf) {
                vm.clientPortalMessagePreview = buildEmptyTemplatePreview();
                return;
            }

            var variables = buildClientPortalPreviewVariables();
            var previewText = processTemplate(vm.agence.clientPortalConf.templateTxt, variables);
            var previewHtmlContent = processTemplate(vm.agence.clientPortalConf.templateHtml, variables);
            var previewSmsContent = processTemplate(vm.agence.clientPortalConf.templateSms, variables);
            var previewSubject = processTemplate(vm.agence.clientPortalConf.templateSubject, variables);
            var finalSms = applySmsGlobalTemplatePreview(previewSmsContent, variables);
            var finalHtml = applyEmailGlobalTemplatePreview(previewText, previewHtmlContent, variables);

            vm.clientPortalMessagePreview = {
                hasContent: !!(finalSms || previewSubject || previewText || finalHtml),
                sms: finalSms || '',
                subject: previewSubject || '',
                text: previewText || '',
                html: finalHtml || '',
                trustedHtml: $sce.trustAsHtml('')
            };
            validatePreviewHtml('clientPortalMessagePreview', finalHtml);
        }

        // Ne jamais insérer le HTML saisi : seul le résultat contrôlé par OWASP est rendu.
        function validatePreviewHtml(previewName, html) {
            var preview = vm[previewName];
            if (!html) {
                return;
            }
            AgenceTemplate.validateHtml({html: html}, function(result) {
                // Une réponse ancienne ne doit pas remplacer l'aperçu d'une saisie plus récente.
                if (vm[previewName] === preview) {
                    preview.trustedHtml = $sce.trustAsHtml(result.html || '');
                }
            }, function(response) {
                if (vm[previewName] === preview) {
                    preview.error = $translate.instant(response && response.data
                        && response.data.message === 'error.unsafeTemplateHtml'
                        ? 'error.unsafeTemplateHtml' : 'error.templateHtmlValidationUnavailable');
                }
            });
        }

        function buildClientPortalPreviewVariables() {
            return {
                contractRef: 'CTR-2026-0042',
                contractName: 'Jean Dupont',
                contractAddress: '12 rue de la Paix, 75002 Paris',
                amountBilled: '1200.00 EUR',
                totalToBePaid: '960.00 EUR',
                servicesToBePaid: 'Water sales : 800.00 EUR\nInstallment : 160.00 EUR',
                taxesToBePaid: 'VAT : 40.00 EUR',
                servicesToBePaidHtml: '<tr><th scope="row">Water sales</th><td>800.00 EUR</td></tr><tr><th scope="row">Installment</th><td>160.00 EUR</td></tr>',
                taxesToBePaidHtml: '<tr><th scope="row">VAT</th><td>40.00 EUR</td></tr>',
                dateNow: new Date().toLocaleDateString(),
                url: 'https://my.wamasys.example/area/demo/reset-password',
                tokenTmp: '123456',
                clientPortalAreaName: (vm.agence.clientPortalConf.areaName || vm.agence.nom || 'Espace client'),
                areaName: (vm.agence.clientPortalConf.areaName || vm.agence.nom || 'Espace client'),
                urlLogo: vm.agence.clientPortalConf.urlLogo || '',
                contactAddress: vm.agence.clientPortalConf.contactAddress || '',
                contactEmail: vm.agence.clientPortalConf.contactEmail || '',
                contactTel: vm.agence.clientPortalConf.contactTel || '',
                contactWebsite: vm.agence.clientPortalConf.contactWebsite || ''
            };
        }

        function buildGlobalCommunicationPreviewVariables() {
            return {
                contractRef: 'CTR-2026-0042',
                contractName: 'Jean Dupont',
                contractAddress: '12 rue de la Paix, 75002 Paris',
                amountBilled: '1200.00 EUR',
                totalToBePaid: '960.00 EUR',
                servicesToBePaid: 'Water sales : 800.00 EUR\nInstallment : 160.00 EUR',
                taxesToBePaid: 'VAT : 40.00 EUR',
                servicesToBePaidHtml: '<tr><th scope="row">Water sales</th><td>800.00 EUR</td></tr><tr><th scope="row">Installment</th><td>160.00 EUR</td></tr>',
                taxesToBePaidHtml: '<tr><th scope="row">VAT</th><td>40.00 EUR</td></tr>',
                dateNow: new Date().toLocaleDateString(),
                url: 'https://my.wamasys.example/area/demo/reset-password',
                tokenTmp: '123456',
                clientPortalAreaName: 'Espace client démo',
                areaName: vm.agence.nom || 'Zone de démonstration',
                urlLogo: 'https://assets.wamasys.example/logo-demo.png',
                contactAddress: 'Avenue de la République, centre-ville',
                contactEmail: 'contact@example.com',
                contactTel: '+33 1 23 45 67 89',
                contactWebsite: 'https://www.example.com'
            };
        }

        function buildGlobalCommunicationPreviewContent() {
            return {
                sms: 'Bonjour Jean Dupont, votre facture d\'eau est disponible. Merci de régulariser votre solde avant le 10/05/2026.',
                text: 'Bonjour Jean Dupont,\nVotre facture d\'eau est disponible dans votre espace client.\nMerci de régulariser votre solde avant le 10/05/2026.',
                html: '<div class="message-content-text"><p>Bonjour Jean Dupont,</p><p>Votre facture d\'eau est disponible dans votre espace client.</p><p>Merci de régulariser votre solde avant le <strong>10/05/2026</strong>.</p></div>'
            };
        }

        function buildEmptyTemplatePreview() {
            return {
                hasContent: false,
                sms: '',
                subject: '',
                text: '',
                html: '',
                trustedHtml: $sce.trustAsHtml('')
            };
        }

        function processTemplate(template, variables) {
            if (!template) {
                return '';
            }
            return template.replace(/\$\{([^}]+)}|\$(\w+)/g, function(match, expression, alias) {
                var key = expression || alias;
                return angular.isDefined(variables[key]) && variables[key] !== null ? variables[key] : '';
            });
        }

        function applySmsGlobalTemplatePreview(messageContent, variables) {
            var globalTemplate = vm.agenceTemplate && vm.agenceTemplate.communicationGlobalSmsTemplate;
            if (!globalTemplate) {
                return messageContent || '';
            }
            return processTemplate(ensureMessagePlaceholder(globalTemplate, '\n'), angular.extend({}, variables || buildClientPortalPreviewVariables(), {
                messageContent: messageContent || '',
                messageContentText: messageContent || ''
            }));
        }

        function applyEmailGlobalTemplatePreview(messageText, messageHtml, variables) {
            var globalTemplate = vm.agenceTemplate && vm.agenceTemplate.communicationGlobalEmailTemplateHtml;
            var htmlContent = messageHtml || textToHtml(messageText || '');
            if (!globalTemplate) {
                return htmlContent;
            }
            return processTemplate(ensureMessagePlaceholder(globalTemplate, '<br/>'), angular.extend({}, variables || buildClientPortalPreviewVariables(), {
                messageContent: htmlContent || '',
                messageContentText: messageText || ''
            }));
        }

        function ensureMessagePlaceholder(template, separator) {
            if (!template || containsMessagePlaceholder(template)) {
                return template || '';
            }
            var lowerTemplate = template.toLowerCase();
            var bodyIndex = lowerTemplate.lastIndexOf('</body>');
            if (bodyIndex >= 0) {
                return template.substring(0, bodyIndex) + separator + '${messageContent}' + template.substring(bodyIndex);
            }
            return '${messageContent}' + separator + template;
        }

        function containsMessagePlaceholder(template) {
            return template && (template.indexOf('${messageContent}') >= 0 || template.indexOf('$messageContent') >= 0);
        }

        function textToHtml(value) {
            return '<div class="message-content-text">' + escapeHtml(value || '').replace(/\n/g, '<br/>') + '</div>';
        }

        function previewReceiptTemplate() {
            previewDocumentTemplate('Aperçu reçu', 'receiptTemplate');
        }

        function previewDocumentTemplate(title, fieldName) {
            var template = vm.agenceTemplate[fieldName] || '';
            var version = ++documentPreviewVersion;
            // Ouvrir une fenêtre vide pendant le clic évite le blocage des fenêtres après l'appel réseau.
            // Aucun contenu saisi n'y est inséré avant les deux validations serveur.
            var previewWindow = $window.open('', '_blank');
            vm.templateHtmlError = '';
            if (!previewWindow) {
                return;
            }
            function isCurrent() {
                return version === documentPreviewVersion && template === (vm.agenceTemplate[fieldName] || '');
            }
            AgenceTemplate.validateDocumentTemplate({template: template}, function(result) {
                if (!isCurrent() || previewWindow.closed) {
                    previewWindow.close();
                    return;
                }
                openPrintablePreview(title,
                    '<div class="document-preview document-preview--ticket">'
                        + renderReceiptTemplate(result.template, buildSampleReceiptPreviewData()) + '</div>',
                    previewWindow, isCurrent);
            }, function(response) {
                failDocumentPreview(response, previewWindow, isCurrent);
            });
        }

        function previewInvoiceTemplate() {
            openPrintablePreview(
                'Aperçu facture',
                renderInvoicePreview(buildSampleInvoicePreviewData())
            );
        }

        function previewInvoicePdfTemplate() {
            Agence.previewInvoice(buildAgenceTemplatePreviewPayload(), function(result) {
                openGeneratedPdf(result);
            });
        }

        function previewBillingNoticePdfTemplate() {
            Agence.previewPaymentRecoveryNotice(buildAgenceTemplatePreviewPayload(), function(result) {
                openGeneratedPdf(result);
            });
        }

        function previewBillingNoticeTemplate() {
            previewDocumentTemplate('Aperçu ordre de recouvrement', 'billingNoticeTemplate');
        }

        function openGeneratedPdf(result) {
            var url;
            var link;
            if (!result || !result.response) {
                return;
            }
            url = URL.createObjectURL(result.response);
            link = document.createElement('a');
            link.href = url;
            link.download = result.fileName || 'document.pdf';
            link.target = '_blank';
            link.click();
            $timeout(function() {
                URL.revokeObjectURL(url);
            }, 1000);
        }

        function unusedPreviewBillingNoticeTemplateLegacy() {
            var variables = buildClientPortalPreviewVariables();
            var bodyContent = processTemplate(vm.agenceTemplate.billingNoticeTemplate, variables);
            var preambule = escapeHtml(vm.agenceTemplate.preambuleOrdreRecouvrement || '').replace(/\n/g, '<br/>');
            var conclusion = escapeHtml(vm.agenceTemplate.conclusionOrdreRecouvrement || '').replace(/\n/g, '<br/>');

            openPrintablePreview(
                'Aperçu ordre de recouvrement',
                '<div class="document-preview document-preview--a4">'
                    + '<div class="document-preview__brand">' + escapeHtml(vm.agence.nom || 'Aperçu zone') + '</div>'
                    + (preambule ? '<div class="document-preview__section">' + preambule + '</div>' : '')
                    + '<div class="document-preview__section document-preview__section--main">' + (bodyContent || '<em>Aucun modèle configuré.</em>') + '</div>'
                    + (conclusion ? '<div class="document-preview__section">' + conclusion + '</div>' : '')
                    + '</div>'
            );
        }

        function failDocumentPreview(response, previewWindow, isCurrent) {
            previewWindow.close();
            if (!isCurrent || isCurrent()) {
                vm.templateHtmlError = $translate.instant(response && response.data
                    && response.data.message === 'error.unsafeTemplateHtml'
                    ? 'error.unsafeTemplateHtml' : 'error.templateHtmlValidationUnavailable');
            }
        }

        function openPrintablePreview(title, bodyHtml, previewWindow, isCurrent) {
            var newWindow = previewWindow || $window.open('', '_blank');
            if (!newWindow) {
                return;
            }
            // Toujours insérer la sortie OWASP, même lorsque le modèle était déjà en base.
            AgenceTemplate.validateHtml({html: bodyHtml}, function(result) {
                if ((isCurrent && !isCurrent()) || newWindow.closed) {
                    newWindow.close();
                    return;
                }
                newWindow.document.open();
                newWindow.document.write(
                    '<html><head><title>' + escapeHtml(title) + '</title>'
                    + '<style>'
                    + 'body{margin:0;padding:24px;background:#eef3f8;font-family:Georgia,serif;color:#1f2f3d;}'
                    + '.document-preview{margin:0 auto;background:#fff;box-shadow:0 24px 48px rgba(28,44,63,.16);}'
                    + '.document-preview--a4{width:794px;min-height:1123px;padding:56px 64px;}'
                    + '.document-preview--ticket{width:320px;padding:24px 20px;font-size:16px;line-height:1.45;}'
                    + '.document-preview__meta{display:flex;justify-content:space-between;gap:16px;margin-bottom:24px;padding:18px;border:1px solid #d9e2ec;border-radius:12px;background:#f8fbfe;}'
                    + '.document-preview__brand{margin-bottom:24px;font-size:20px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;}'
                    + '.document-preview__section{margin-bottom:24px;font-size:15px;line-height:1.65;}'
                    + '.document-preview__section--main{padding:24px;border:1px solid #d9e2ec;border-radius:18px;background:#fbfdff;}'
                    + '.document-preview__table{width:100%;border-collapse:collapse;font-size:14px;}'
                    + '.document-preview__table th,.document-preview__table td{padding:10px 12px;border:1px solid #d9e2ec;}'
                    + '.document-preview__table thead th{background:#eef5fb;}'
                    + '.document-preview__cell--number{text-align:right;white-space:nowrap;}'
                    + '.document-preview__table-total td{font-weight:700;background:#f7fbff;}'
                    + '.receipt-center{display:block;text-align:center;}.receipt-left{float:left;}.receipt-right{float:right;}'
                    + '.size2{font-size:20px;margin:0;}.size3{font-size:24px;margin:0;}'
                    + '@media print{body{background:#fff;padding:0}.document-preview{box-shadow:none}.document-preview--a4,.document-preview--ticket{width:auto;min-height:auto;padding:18px}}'
                    + '</style></head><body>'
                    + (result.html || '')
                    + '</body></html>'
                );
                newWindow.document.close();
                newWindow.print();
            }, function(response) {
                failDocumentPreview(response, newWindow, isCurrent);
            });
        }

        function buildSampleReceiptPreviewData() {
            return {
                paymentReceipt: {
                    checkId: 'CHK-2026-0042',
                    receiptNumber: 'RCT-2026-0042',
                    machineIdNumber: 'TERM-01',
                    originalPrinted: false
                },
                datePaiement: new Date(),
                paidAmount: 960.00,
                contrat: {
                    referenceContrat: 'CTR-2026-0042',
                    nomPersonne: 'Jean Dupont',
                    adresse: '12 rue de la Paix, 75002 Paris'
                },
                listPaymentReceived: [
                    {
                        serviceName: 'Water sales',
                        paidInclTax: 800.00,
                        paidExclTax: 760.00,
                        taxeName: 'VAT',
                        taxPaid: 40.00,
                        remainingBalanceAfterPayment: 0.00,
                        amountToBePaid: 800.00,
                        remainingBalanceBeforePayment: 800.00
                    },
                    {
                        serviceName: 'Installment',
                        paidInclTax: 160.00,
                        paidExclTax: 160.00,
                        taxeName: '',
                        taxPaid: 0.00,
                        remainingBalanceAfterPayment: 0.00,
                        amountToBePaid: 160.00,
                        remainingBalanceBeforePayment: 160.00
                    }
                ]
            };
        }

        function buildSampleInvoicePreviewData() {
            return {
                invoiceNumber: 'FAC-2026-0042',
                billingDate: new Date(),
                dueDate: new Date(new Date().getTime() + (10 * 24 * 60 * 60 * 1000)),
                customerName: 'Jean Dupont',
                customerAddress: '12 rue de la Paix, 75002 Paris',
                currency: vm.agence.devise || 'EUR',
                lines: [
                    { label: 'Abonnement eau', quantity: 1, unitPrice: 18.00 },
                    { label: 'Consommation 0 - 20 m3', quantity: 20, unitPrice: 1.75 },
                    { label: 'Frais d’entretien compteur', quantity: 1, unitPrice: 6.50 }
                ],
                discountLabel: 'Remise fidélité',
                discountAmount: 5.00,
                taxes: [
                    { label: 'TVA 18%', amount: 11.79 },
                    { label: 'Taxe communale', amount: 2.20 }
                ]
            };
        }

        function renderReceiptTemplate(textData, receiptData) {
            var result = '';
            // Les commandes produisent seules des balises ; le texte libre est toujours échappé.
            var remainingText = escapeHtml(textData || '');
            var commandState = {
                blockOpen: false,
                sizeOpen: false
            };

            remainingText = remainingText.replace(/\n/g, '<br/>').replace(/\s\s/g, ' &nbsp;');
            while (remainingText.length > 0) {
                var commandIndex = remainingText.indexOf('${');
                if (commandIndex < 0) {
                    result += remainingText;
                    remainingText = '';
                } else {
                    if (commandIndex > 0) {
                        result += remainingText.substring(0, commandIndex);
                        remainingText = remainingText.substring(commandIndex);
                    }
                    var endCommandIndex = remainingText.indexOf('}');
                    if (endCommandIndex < 0) {
                        result += remainingText;
                        remainingText = '';
                    } else {
                        var command = remainingText.substring(2, endCommandIndex);
                        result += executeReceiptCommand(command, receiptData, commandState);
                        remainingText = remainingText.substring(endCommandIndex + 1);
                    }
                }
            }

            if (commandState.blockOpen) {
                result += '</span>';
            }
            if (commandState.sizeOpen) {
                result += '</pre>';
            }
            return result || '<em>Aucun modèle configuré.</em>';
        }

        function renderInvoicePreview(invoiceData) {
            var subtotal = 0;
            var totalTaxes = 0;
            var total;
            var i;
            var lineTotal;
            var linesHtml = '';
            var taxesHtml = '';
            var invoiceHeader = escapeHtml(vm.agenceTemplate.enteteFacture || '').replace(/\n/g, '<br/>');

            for (i = 0; i < invoiceData.lines.length; i++) {
                lineTotal = invoiceData.lines[i].quantity * invoiceData.lines[i].unitPrice;
                subtotal += lineTotal;
                linesHtml += '<tr>'
                    + '<td>' + escapeHtml(invoiceData.lines[i].label) + '</td>'
                    + '<td class="document-preview__cell--number">' + formatNumber(invoiceData.lines[i].quantity) + '</td>'
                    + '<td class="document-preview__cell--number">' + formatMoney(invoiceData.lines[i].unitPrice, invoiceData.currency) + '</td>'
                    + '<td class="document-preview__cell--number">' + formatMoney(lineTotal, invoiceData.currency) + '</td>'
                    + '</tr>';
            }

            for (i = 0; i < invoiceData.taxes.length; i++) {
                totalTaxes += invoiceData.taxes[i].amount;
                taxesHtml += '<tr>'
                    + '<td colspan="3">' + escapeHtml(invoiceData.taxes[i].label) + '</td>'
                    + '<td class="document-preview__cell--number">' + formatMoney(invoiceData.taxes[i].amount, invoiceData.currency) + '</td>'
                    + '</tr>';
            }

            total = subtotal - invoiceData.discountAmount + totalTaxes;

            return '<div class="document-preview document-preview--a4 document-preview--invoice">'
                + '<div class="document-preview__brand">' + escapeHtml(vm.agence.nom || 'Zone') + '</div>'
                + (invoiceHeader ? '<div class="document-preview__section">' + invoiceHeader + '</div>' : '')
                + '<div class="document-preview__meta">'
                + '<div><strong>Facture</strong><br/>' + escapeHtml(invoiceData.invoiceNumber) + '</div>'
                + '<div><strong>Date</strong><br/>' + new Date(invoiceData.billingDate).toLocaleDateString() + '</div>'
                + '<div><strong>Échéance</strong><br/>' + new Date(invoiceData.dueDate).toLocaleDateString() + '</div>'
                + '</div>'
                + '<div class="document-preview__section">'
                + '<strong>Client</strong><br/>'
                + escapeHtml(invoiceData.customerName) + '<br/>'
                + escapeHtml(invoiceData.customerAddress)
                + '</div>'
                + '<table class="document-preview__table">'
                + '<thead><tr><th>Désignation</th><th>Qté</th><th>PU</th><th>Montant</th></tr></thead>'
                + '<tbody>' + linesHtml + '</tbody>'
                + '<tfoot>'
                + '<tr><td colspan="3">Sous-total</td><td class="document-preview__cell--number">' + formatMoney(subtotal, invoiceData.currency) + '</td></tr>'
                + '<tr><td colspan="3">' + escapeHtml(invoiceData.discountLabel) + '</td><td class="document-preview__cell--number">-' + formatMoney(invoiceData.discountAmount, invoiceData.currency) + '</td></tr>'
                + taxesHtml
                + '<tr class="document-preview__table-total"><td colspan="3">Total à payer</td><td class="document-preview__cell--number">' + formatMoney(total, invoiceData.currency) + '</td></tr>'
                + '</tfoot>'
                + '</table>'
                + '</div>';
        }

        function executeReceiptCommand(command, receiptData, commandState) {
            var result = '';
            var i;
            var map;
            var key;
            var total;
            if (!command) {
                return result;
            }

            switch (command) {
            case 'center':
                if (commandState.blockOpen) {
                    result += '</span>';
                }
                commandState.blockOpen = true;
                return result + '<span class="receipt-center">';
            case 'left':
                if (commandState.blockOpen) {
                    result += '</span>';
                }
                commandState.blockOpen = false;
                return result;
            case 'right':
                if (commandState.blockOpen) {
                    result += '</span>';
                }
                commandState.blockOpen = true;
                return result + '<span class="receipt-right">';
            case 's1':
                if (commandState.sizeOpen) {
                    result += '</pre>';
                }
                commandState.sizeOpen = false;
                return result;
            case 's2':
                if (commandState.sizeOpen) {
                    result += '</pre>';
                }
                commandState.sizeOpen = true;
                return result + '<pre class="size2">';
            case 's3':
                if (commandState.sizeOpen) {
                    result += '</pre>';
                }
                commandState.sizeOpen = true;
                return result + '<pre class="size3">';
            case 'checkId':
                return escapeHtml(receiptData.paymentReceipt.checkId);
            case 'receiptId':
                return escapeHtml(receiptData.paymentReceipt.receiptNumber);
            case 'dateReceipt':
                return new Date(receiptData.datePaiement).toLocaleDateString() + ' - ' + new Date(receiptData.datePaiement).toLocaleTimeString();
            case 'paid':
                return formatNumber(receiptData.paidAmount);
            case 'paidExclTax':
                total = 0;
                for (i = 0; i < receiptData.listPaymentReceived.length; i++) {
                    total += receiptData.listPaymentReceived[i].paidExclTax;
                }
                return formatNumber(total);
            case 'customerCopy':
                return 'Customer copy';
            case 'servicesPaid':
                return buildReceiptLineHtml(receiptData.listPaymentReceived, 'paidInclTax');
            case 'servicesPaidExclTaxes':
                return buildReceiptLineHtml(receiptData.listPaymentReceived, 'paidExclTax');
            case 'taxesPaid':
                map = {};
                for (i = 0; i < receiptData.listPaymentReceived.length; i++) {
                    if (receiptData.listPaymentReceived[i].taxeName) {
                        map[receiptData.listPaymentReceived[i].taxeName] = (map[receiptData.listPaymentReceived[i].taxeName] || 0) + receiptData.listPaymentReceived[i].taxPaid;
                    }
                }
                result = '';
                for (key in map) {
                    if (map.hasOwnProperty(key)) {
                        result += '<span class="receipt-left">' + escapeHtml(key) + '</span><span class="receipt-right">' + formatNumber(map[key]) + '</span><br/>';
                    }
                }
                return result;
            case 'remainingBalance':
                total = 0;
                for (i = 0; i < receiptData.listPaymentReceived.length; i++) {
                    total += receiptData.listPaymentReceived[i].remainingBalanceAfterPayment;
                }
                return formatNumber(total);
            case 'amountBilled':
                total = 0;
                for (i = 0; i < receiptData.listPaymentReceived.length; i++) {
                    total += receiptData.listPaymentReceived[i].amountToBePaid;
                }
                return formatNumber(total);
            case 'totalToBePaid':
                total = 0;
                for (i = 0; i < receiptData.listPaymentReceived.length; i++) {
                    total += receiptData.listPaymentReceived[i].amountToBePaid - receiptData.listPaymentReceived[i].remainingBalanceBeforePayment;
                }
                return formatNumber(total);
            case 'balanceBeforePayment':
                total = 0;
                for (i = 0; i < receiptData.listPaymentReceived.length; i++) {
                    total += receiptData.listPaymentReceived[i].remainingBalanceBeforePayment;
                }
                return formatNumber(total);
            case 'servicesToBePaid':
                return buildReceiptLineHtml(receiptData.listPaymentReceived, 'amountToBePaid');
            case 'taxesToBePaid':
                map = {};
                for (i = 0; i < receiptData.listPaymentReceived.length; i++) {
                    if (receiptData.listPaymentReceived[i].taxeName) {
                        map[receiptData.listPaymentReceived[i].taxeName] = (map[receiptData.listPaymentReceived[i].taxeName] || 0) + receiptData.listPaymentReceived[i].taxPaid;
                    }
                }
                result = '';
                for (key in map) {
                    if (map.hasOwnProperty(key)) {
                        result += '<span class="receipt-left">' + escapeHtml(key) + '</span><span class="receipt-right">' + formatNumber(map[key]) + '</span><br/>';
                    }
                }
                return result;
            case 'machineIdNumber':
                return escapeHtml(receiptData.paymentReceipt.machineIdNumber);
            case 'contractRef':
                return escapeHtml(receiptData.contrat.referenceContrat);
            case 'contractName':
                return escapeHtml(receiptData.contrat.nomPersonne);
            case 'contractAddress':
                return escapeHtml(receiptData.contrat.adresse);
            default:
                return result;
            }
        }

        function buildReceiptLineHtml(lines, amountField) {
            var result = '';
            var i;
            for (i = 0; i < lines.length; i++) {
                result += '<span class="receipt-left">' + escapeHtml(lines[i].serviceName) + '</span>'
                    + '<span class="receipt-right">' + formatNumber(lines[i][amountField]) + '</span><br/>';
            }
            return result;
        }

        function formatNumber(value) {
            return Number(value || 0).toFixed(2);
        }

        function formatMoney(value, currency) {
            return formatNumber(value) + ' ' + (currency || '');
        }

        function escapeHtml(value) {
            return (value || '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }

        function hashString(value) {
            var stringValue = value || '';
            var hash = 0;
            var i;
            var chr;
            for (i = 0; i < stringValue.length; i++) {
                chr = stringValue.charCodeAt(i);
                hash = ((hash << 5) - hash) + chr;
                hash |= 0;
            }
            return hash;
        }

        function buildEmptyAgenceTemplate() {
            return {
                enteteFacture: null,
                preambuleOrdreRecouvrement: null,
                conclusionOrdreRecouvrement: null,
                receiptTemplate: null,
                billingNoticeTemplate: null,
                communicationGlobalSmsTemplate: null,
                communicationGlobalEmailTemplateHtml: null
            };
        }

        function buildAgenceTemplatePreviewPayload() {
            var payload = angular.copy(vm.agence || {});

            payload.enteteFacture = vm.agenceTemplate.enteteFacture;
            payload.preambuleOrdreRecouvrement = vm.agenceTemplate.preambuleOrdreRecouvrement;
            payload.conclusionOrdreRecouvrement = vm.agenceTemplate.conclusionOrdreRecouvrement;
            payload.receiptTemplate = vm.agenceTemplate.receiptTemplate;
            payload.billingNoticeTemplate = vm.agenceTemplate.billingNoticeTemplate;

            return payload;
        }
        

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('AgenceDialogController', AgenceDialogController);

    AgenceDialogController.$inject = ['$scope', "leafletMapEvents",'$stateParams', '$uibModalInstance', 'entity', 'Agence', 'EntiteParente','WaterNetwork'];

    function AgenceDialogController ($scope, leafletMapEvents, $stateParams, $uibModalInstance, entity, Agence, EntiteParente,WaterNetwork) {
        var vm = this;
        vm.agence = entity;
        vm.entiteparentes = EntiteParente.query();
        vm.waterNetworks = WaterNetwork.query({ offset: 0,size: 1000});
        vm.timezones = Agence.getTimezones();
        
        vm.updateCoord = function(){
          	
        	//On remet à 0 en cas d'erreur sur le champs.
        	if(! vm.agence.lat ){
        		vm.agence.lat = 0;
        	}
        	if(! vm.agence.lon){
        		vm.agence.lon = 0;
        	}
        	
	        angular.extend($scope, {
	            defaults: {
	                scrollWheelZoom: false
	            },
//	            events: {
//	                map: {
//	                    enable: [ 'drag', 'click'],
//	                    logic: 'emit'
//	                }
//	            },
	            markers: {
	                Area: {
	                    lat: vm.agence.lat,
	                    lng: vm.agence.lon,
//	                    message: "This is Madrid. But you can drag me to another position",
	                    focus: true,
	                    draggable: true
	                }
	            }
	        })
        }
        
        vm.load = function(id) {
            Agence.get({id : id}, function(result) {
                vm.agence = result;

            	vm.updateCoord ();
               
                
            });
        };
        
        if(entity && entity.$promise){
            entity.$promise.then(function(value) {
            	vm.updateCoord ();
            });	
        }else{
        	vm.updateCoord();
        }

        $scope.$on("leafletDirectiveMarker.dragend", function(event, args){
        	 vm.agence.lat = args.model.lat;
        	 vm.agence.lon = args.model.lng;
        });

//        
//        $scope.$on('leafletDirectiveMap.drag', function(event){
//            $scope.eventDetected = "Drag";
//        });
        
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:agenceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.agence.id !== null) {
                Agence.update(vm.agence, onSaveSuccess, onSaveError);
            } else {
                Agence.save(vm.agence, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateDebutDemarrage = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('AgenceDetailController', AgenceDetailController);

    AgenceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Agence', 'EntiteParente'];

    function AgenceDetailController($scope, $rootScope, $stateParams, entity, Agence, EntiteParente) {
        var vm = this;
        vm.agence = entity;
        vm.load = function (id) {
            Agence.get({id: id}, function(result) {
                vm.agence = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:agenceUpdate', function(event, result) {
            vm.agence = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('AgenceDeleteController',AgenceDeleteController);

    AgenceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Agence'];

    function AgenceDeleteController($uibModalInstance, entity, Agence) {
        var vm = this;
        vm.agence = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Agence.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('AiAssistantSystemCommandsController', AiAssistantSystemCommandsController);

    AiAssistantSystemCommandsController.$inject = ['AiAssistantMonitoring', 'AlertService'];

    function AiAssistantSystemCommandsController(AiAssistantMonitoring, AlertService) {
        var vm = this;

        vm.loading = false;
        vm.catalog = {
            generatedAt: null,
            commands: []
        };

        activate();

        function activate() {
            vm.loading = true;
            AiAssistantMonitoring.getSystemCommands().then(function(response) {
                vm.catalog = response.data || vm.catalog;
            }).catch(function(error) {
                AlertService.error(error && error.data && error.data.message
                    ? error.data.message
                    : 'Impossible de charger les commandes systeme de l\'assistant IA.');
            }).finally(function() {
                vm.loading = false;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ai-assistant-monitoring', {
            parent: 'entity',
            url: '/ai-assistant-monitoring',
            data: {
                authorities: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
                pageTitle: 'wamasysApp.aiAssistantMonitoring.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/ai-assistant-monitoring/ai-assistant-monitoring.html',
                    controller: 'AiAssistantMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aiAssistantMonitoring');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ai-assistant-system-commands', {
            parent: 'entity',
            url: '/ai-assistant-monitoring/system-commands',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'Commandes systeme assistant IA'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/ai-assistant-monitoring/ai-assistant-system-commands.html',
                    controller: 'AiAssistantSystemCommandsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aiAssistantMonitoring');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('AiAssistantMonitoring', AiAssistantMonitoring);

    AiAssistantMonitoring.$inject = ['$http'];

    function AiAssistantMonitoring($http) {
        return {
            getOverview: function() {
                return $http.get('api/admin/ai-assistant-monitoring/overview');
            },
            getDetail: function(conversationKey) {
                return $http.get('api/admin/ai-assistant-monitoring/detail', {
                    params: {
                        conversationKey: conversationKey
                    }
                });
            },
            getSystemCommands: function() {
                return $http.get('api/admin/ai-assistant-monitoring/system-commands');
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('AiAssistantMonitoringController', AiAssistantMonitoringController);

    AiAssistantMonitoringController.$inject = ['AiAssistantMonitoring', 'AlertService', '$window', '$document', '$scope', 'Principal'];

    function AiAssistantMonitoringController(AiAssistantMonitoring, AlertService, $window, $document, $scope, Principal) {
        var vm = this;
        var CONVERSATION_PAGE_SIZE = 40;
        var DATA_SCOPE_LABELS = {
            billingMonthlyStats: 'Facturation mensuelle',
            billingDetails: 'Détail facturation',
            waterMonthlyStats: 'Consommation mensuelle',
            waterDetails: 'Détail consommation',
            contractHistory: 'Historique contrat',
            meterChanges: 'Changements compteur'
        };

        vm.filters = {
            feedbackStatus: 'ALL',
            userLogin: '',
            organisationName: '',
            contractReference: '',
            areaName: '',
            dateFrom: null,
            dateTo: null,
            hasExecutedActions: 'ALL',
            hasErrors: 'ALL'
        };
        vm.filteredConversations = [];
        vm.visibleConversations = [];
        vm.filteredTotalTokens = 0;
        vm.loadingOverview = false;
        vm.loadingDetail = false;
        vm.overview = {
            totalConversations: 0,
            satisfiedConversations: 0,
            unsatisfiedConversations: 0,
            noFeedbackConversations: 0,
            distinctUsers: 0,
            distinctOrganisations: 0,
            totalTokens: 0,
            conversations: []
        };
        vm.detail = null;
        vm.selectedConversation = null;
        vm.isSuperAdmin = false;

        vm.loadOverview = loadOverview;
        vm.applyFeedbackFilter = applyFeedbackFilter;
        vm.loadMoreConversations = loadMoreConversations;
        vm.selectConversation = selectConversation;
        vm.getFeedbackStatusClass = getFeedbackStatusClass;
        vm.isConversationSelected = isConversationSelected;
        vm.toggleJson = toggleJson;
        vm.copyConversationFlowJson = copyConversationFlowJson;
        vm.copyConversationApiExchangeJson = copyConversationApiExchangeJson;
        vm.getDataScopeLabels = getDataScopeLabels;
        vm.hasVisibleConversationContent = hasVisibleConversationContent;
        vm.copyFeedbackMessage = null;

        Principal.identity().then(function(account) {
            vm.isSuperAdmin = !!(account && account.authorities && account.authorities.indexOf('ROLE_SUPER_ADMIN') !== -1);
        });
        loadOverview();

        function loadOverview() {
            vm.loadingOverview = true;
            AiAssistantMonitoring.getOverview().then(function(response) {
                vm.overview = response.data || vm.overview;
                applyFeedbackFilter();
            }).catch(function(error) {
                AlertService.error(resolveErrorMessage(error, 'Impossible de charger la supervision de l\'assistant IA.'));
            }).finally(function() {
                vm.loadingOverview = false;
            });
        }

        function applyFeedbackFilter() {
            var conversations = angular.copy(vm.overview.conversations || []);
            if (vm.filters.feedbackStatus !== 'ALL') {
                conversations = conversations.filter(function(conversation) {
                    return conversation.feedbackStatus === vm.filters.feedbackStatus;
                });
            }
            if ((vm.filters.userLogin || '').trim()) {
                conversations = conversations.filter(function(conversation) {
                    return ((conversation.userLogin || '').toLowerCase()).indexOf(vm.filters.userLogin.toLowerCase()) !== -1;
                });
            }
            if ((vm.filters.organisationName || '').trim()) {
                conversations = conversations.filter(function(conversation) {
                    return ((conversation.organisationName || '').toLowerCase()).indexOf(vm.filters.organisationName.toLowerCase()) !== -1;
                });
            }
            if ((vm.filters.contractReference || '').trim()) {
                conversations = conversations.filter(function(conversation) {
                    return ((conversation.contractReference || '').toLowerCase()).indexOf(vm.filters.contractReference.toLowerCase()) !== -1;
                });
            }
            if ((vm.filters.areaName || '').trim()) {
                conversations = conversations.filter(function(conversation) {
                    return ((conversation.areaName || '').toLowerCase()).indexOf(vm.filters.areaName.toLowerCase()) !== -1;
                });
            }
            if (vm.filters.hasExecutedActions !== 'ALL') {
                conversations = conversations.filter(function(conversation) {
                    return String(!!conversation.hasExecutedActions) === vm.filters.hasExecutedActions;
                });
            }
            if (vm.filters.hasErrors !== 'ALL') {
                conversations = conversations.filter(function(conversation) {
                    return String(!!conversation.hasErrors) === vm.filters.hasErrors;
                });
            }
            if (vm.filters.dateFrom) {
                conversations = conversations.filter(function(conversation) {
                    return toDate(conversation.lastActivityAt) >= startOfDay(vm.filters.dateFrom);
                });
            }
            if (vm.filters.dateTo) {
                conversations = conversations.filter(function(conversation) {
                    return toDate(conversation.lastActivityAt) <= endOfDay(vm.filters.dateTo);
                });
            }
            vm.filteredConversations = conversations;
            vm.visibleConversations = vm.filteredConversations.slice(0, CONVERSATION_PAGE_SIZE);
            vm.filteredTotalTokens = vm.filteredConversations.reduce(function(total, conversation) {
                return total + (conversation && conversation.totalTokens ? conversation.totalTokens : 0);
            }, 0);
        }

        function loadMoreConversations() {
            var nextCount;
            if (!vm.filteredConversations || vm.visibleConversations.length >= vm.filteredConversations.length) {
                return;
            }
            nextCount = Math.min(vm.filteredConversations.length, vm.visibleConversations.length + CONVERSATION_PAGE_SIZE);
            vm.visibleConversations = vm.filteredConversations.slice(0, nextCount);
        }

        function selectConversation(conversation) {
            if (!conversation || !conversation.conversationId) {
                return;
            }
            vm.selectedConversation = conversation;
            vm.loadingDetail = true;
            AiAssistantMonitoring.getDetail(conversation.conversationId).then(function(response) {
                vm.detail = response.data;
                vm.copyFeedbackMessage = null;
            }).catch(function(error) {
                AlertService.error(resolveErrorMessage(error, 'Impossible de charger le detail de la conversation IA.'));
            }).finally(function() {
                vm.loadingDetail = false;
            });
        }

        function getFeedbackStatusClass(feedbackStatus) {
            if (feedbackStatus === 'OK') {
                return 'label label-success';
            }
            if (feedbackStatus === 'NON') {
                return 'label label-danger';
            }
            return 'label label-default';
        }

        function isConversationSelected(conversation) {
            return vm.selectedConversation && conversation && vm.selectedConversation.conversationId === conversation.conversationId;
        }

        function toggleJson(event) {
            if (!event) {
                return;
            }
            event.showJson = !event.showJson;
        }

        function copyConversationFlowJson() {
            var serializedFlow;
            if (!vm.detail || !vm.detail.events || !vm.detail.events.length) {
                return;
            }
            serializedFlow = angular.toJson(buildConversationFlowExport(vm.detail), true);
            copyTextToClipboard(serializedFlow);
        }

        function copyConversationApiExchangeJson() {
            var serializedExchange;
            if (!vm.detail || !vm.detail.events || !vm.detail.events.length) {
                return;
            }
            serializedExchange = angular.toJson(buildConversationApiExchangeExport(vm.detail), true);
            copyTextToClipboard(serializedExchange, 'Echange JSON copie.');
        }

        function getDataScopeLabels(selectedDataScopes) {
            if (!selectedDataScopes || !selectedDataScopes.length) {
                return ['Aucune catégorie'];
            }
            return selectedDataScopes.map(function(scope) {
                return DATA_SCOPE_LABELS[scope] || scope;
            });
        }

        // La vue admin simplifiée ne doit afficher que les échanges compréhensibles par l'utilisateur.
        function hasVisibleConversationContent(event) {
            return !!(event
                && (event.requestTotalTokens
                || event.sentMessage
                || event.receivedMessage
                || (event.clarificationQuestions && event.clarificationQuestions.length)
                || (event.actionSummaries && event.actionSummaries.length)
                || event.hasAction));
        }

        function buildConversationFlowExport(detail) {
            return {
                conversationId: detail.conversationId,
                conversationDisplayId: detail.conversationDisplayId,
                contextType: detail.contextType,
                entityId: detail.entityId,
                contextLabel: detail.contextLabel,
                contractReference: detail.contractReference,
                areaName: detail.areaName,
                userLogin: detail.userLogin,
                organisationName: detail.organisationName,
                feedbackStatus: detail.feedbackStatus,
                feedbackComment: detail.feedbackComment,
                totalTokens: detail.totalTokens,
                hasExecutedActions: !!detail.hasExecutedActions,
                hasErrors: !!detail.hasErrors,
                apiExchangeHistory: (detail.events || []).map(function(event) {
                    var eventJson = parseFormattedJson(event.formattedJson) || {};
                    return {
                        archivedAt: event.archivedAt,
                        stage: event.stage,
                        stageLabel: event.stageLabel,
                        flowLabel: event.flowLabel,
                        direction: resolveExchangeDirection(event.stage),
                        requestTotalTokens: event.requestTotalTokens,
                        feedbackComment: event.feedbackComment,
                        provider: eventJson.apiExchange ? eventJson.apiExchange.provider : null,
                        request: eventJson.apiExchange ? eventJson.apiExchange.request : null,
                        response: eventJson.apiExchange ? eventJson.apiExchange.response : null,
                        summary: eventJson.summary || {
                            sentMessage: event.sentMessage,
                            receivedMessage: event.receivedMessage,
                            clarificationQuestions: event.clarificationQuestions,
                            actionSummaries: event.actionSummaries
                        }
                    };
                })
            };
        }

        function buildConversationApiExchangeExport(detail) {
            return {
                conversationId: detail.conversationId,
                conversationDisplayId: detail.conversationDisplayId,
                totalTokens: detail.totalTokens,
                feedbackComment: detail.feedbackComment,
                apiExchangeHistory: (detail.events || []).map(function(event) {
                    var eventJson = parseFormattedJson(event.formattedJson) || {};
                    return {
                        archivedAt: event.archivedAt,
                        stage: event.stage,
                        stageLabel: event.stageLabel,
                        flowLabel: event.flowLabel,
                        direction: resolveExchangeDirection(event.stage),
                        requestTotalTokens: event.requestTotalTokens,
                        feedbackComment: event.feedbackComment,
                        apiRequest: eventJson.apiExchange ? eventJson.apiExchange.request : null,
                        apiResponse: eventJson.apiExchange ? eventJson.apiExchange.response : null
                    };
                }).filter(function(item) {
                    return item.apiRequest || item.apiResponse;
                })
            };
        }

        function resolveExchangeDirection(stage) {
            var normalizedStage = (stage || '').toLowerCase();
            if (normalizedStage.indexOf('planner') !== -1 || normalizedStage.indexOf('chat-request') !== -1) {
                return 'WAMASYS_TO_AI_API';
            }
            if (normalizedStage.indexOf('chat-response') !== -1) {
                return 'AI_API_TO_WAMASYS';
            }
            if (normalizedStage.indexOf('error') !== -1) {
                return 'ERROR';
            }
            return 'LOCAL_EVENT';
        }

        function parseFormattedJson(formattedJson) {
            if (!formattedJson) {
                return null;
            }
            try {
                return angular.fromJson(formattedJson);
            } catch (error) {
                return {
                    raw: formattedJson
                };
            }
        }

        function copyTextToClipboard(value, successMessage) {
            if ($window.navigator && $window.navigator.clipboard && $window.navigator.clipboard.writeText) {
                $window.navigator.clipboard.writeText(value).then(function() {
                    setCopyFeedbackMessage(successMessage || 'Flux JSON copie.');
                }).catch(function() {
                    fallbackCopyText(value, successMessage);
                });
                return;
            }
            fallbackCopyText(value, successMessage);
        }

        function fallbackCopyText(value, successMessage) {
            var textarea = $document[0].createElement('textarea');
            textarea.value = value;
            textarea.setAttribute('readonly', 'readonly');
            textarea.style.position = 'fixed';
            textarea.style.left = '-9999px';
            $document[0].body.appendChild(textarea);
            textarea.select();
            try {
                $document[0].execCommand('copy');
                setCopyFeedbackMessage(successMessage || 'Flux JSON copie.');
            } catch (error) {
                AlertService.error('Impossible de copier le flux JSON.');
            } finally {
                $document[0].body.removeChild(textarea);
            }
        }

        function setCopyFeedbackMessage(message) {
            vm.copyFeedbackMessage = message;
            $scope.$evalAsync();
        }

        function resolveErrorMessage(error, fallback) {
            return error && error.data && error.data.message ? error.data.message : fallback;
        }

        function toDate(value) {
            var date = new Date(value);
            return isNaN(date.getTime()) ? new Date(0) : date;
        }

        function startOfDay(value) {
            var date = new Date(value);
            date.setHours(0, 0, 0, 0);
            return date;
        }

        function endOfDay(value) {
            var date = new Date(value);
            date.setHours(23, 59, 59, 999);
            return date;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('admin-tools', {
            parent: 'entity',
            url: '/admin-tools',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'wamasysApp.admin-tools.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/admin-tools/admin-tools.html',
                    controller: 'AdminToolsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('organisation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('AdminTools', AdminTools);

    AdminTools.$inject = ['$resource','DateUtils'];

    function AdminTools ($resource,DateUtils) {
        var resourceUrl =  'api/admin-tools/';

        return $resource(resourceUrl, {}, {
            'createAreaTest': {
            	method: 'POST',
              	 url :'api/admin-tools/createAreaTest'
             },
             'anonymiserArea': {
                method: 'POST',
                url :'api/admin-tools/anonymiser_donnees'
             },
             'completerDonneesTest': {
                 method: 'GET',
                 url :'api/admin-tools/completer-donnees-test/:idOrga/:idAgence'
              }
             ,
             'majTeamwork': {
                 method: 'GET',
                 url :'api/admin-tools/init_user_teamwork/:idOrga'
              },
             'exportElkCheckexport': {
                method: 'POST',
                url :'api/export/checkexport?'
//                	,                params: {toDate: toDate}
             },
             'exportElkCreditNoteRefund': {
                 method: 'POST',
                 url :'api/export/credit_note_refund',
                 params: {fromDate: null, toDate: null}
              },
              'exportElkFacturation': {
                  method: 'POST',
                  url :'api/export/facturation'
//                	  ,
//                  params: {fromDate: null, toDate: null}
               },
               'exportElkconsommationeau': {
                   method: 'POST',
                   url :'api/export/consommationeau',
                   params: {fromDate: null, toDate: null}
                },
                'initialiserroleareaelastic': {
                    method: 'POST',
                    url :'api/export/initialiserroleareaelastic'
                 },
                 'exportAllEventInElastic': {
                      method: 'GET',
                      url :'api/form-event/exportAllEventInElastic'
                  },
                 'indexManualDocs': {
                      method: 'POST',
                      url: 'api/help/manual/index'
                   },
                 'clearClientPortalResetRateLimit': {
                      method: 'POST',
                      url: 'api/admin-tools/client-portal-reset-rate-limit/clear'
                   }
                
         });
    }
})();
;
(function() {
	'use strict';

	angular.module('wamasysApp').controller('AdminToolsController', AdminToolsController);

	AdminToolsController.$inject = [ '$scope', '$http', '$filter','$state', 'AdminTools', 'Organisation', 'AlertService', 'UserAdmin', 'Principal', '$interval' ];

	function AdminToolsController($scope, $http, $filter,$state, AdminTools, Organisation,	AlertService, UserAdmin, Principal, $interval) {
		var vm = this;
        // Les outils occasionnels restent repliés ; le suivi ouvre la réparation si nécessaire.
        vm.adminSections = [
            {id: 'diagnostic', title: 'Diagnostic Elasticsearch', description: 'Comparer les données et examiner les écarts.', open: true, template: 'app/business/admin-tools/diagnostic.html'},
            {id: 'recovery', title: 'Réparer les données Elasticsearch', description: 'Reprendre ou reconstruire les périodes de reporting.', open: false, template: 'app/business/admin-tools/recovery.html'},
            {id: 'support', title: 'Maintenance et support', description: 'Documentation et déblocage du portail client.', open: false, template: 'app/business/admin-tools/support.html'},
            {id: 'advanced', title: 'Intégrations et maintenance avancée', description: 'Exports immédiats, purge, rôles et comptes Redmine.', open: false, template: 'app/business/admin-tools/advanced.html'},
            {id: 'demo', title: 'Démonstration et tests', description: 'Créer, compléter ou anonymiser des données de test.', open: false, template: 'app/business/admin-tools/demo.html'}
        ];

		vm.numberOfContractByCluster = 50;
		vm.coefMultiplicateur = 1;
		vm.coefNbrYear = 2;
		vm.generationMode = 'JAVA_COHERENT';
		vm.sqlContractCount = 100000;
		vm.organisations = Organisation.query();
		vm.agences = UserAdmin.getAllAgency();

		vm.anonymiserArea = function() {
			if (vm.anonymisationNotProduction) {
				AdminTools.anonymiserArea({
					orgaId : vm.anonymisationOrganisationId,
					areaId : vm.anonymisationAreaId,
					password : vm.anonymisationPassword
				}, function (data){
					AlertService.success("Demande acceptée.");
				}, function (error){
					AlertService.error(error.data.message);
				});
			}
		};


		vm.createAreaTest = function() {
				AdminTools.createAreaTest({
					orgaName : vm.orgaName,
					orgaId : vm.orgaId,
					password : vm.generationPassword,
					codeArea : vm.codeArea,
					codeLangue :vm.codeLangue,
					areaName : vm.areaName, 
					agenceName : vm.agenceName, 
					numberOfContractByCluster : vm.numberOfContractByCluster,
					coefMultiplicateur : vm.coefMultiplicateur,
					coefNbrYear : vm.coefNbrYear,
					generationMode : vm.generationMode,
					sqlContractCount : vm.sqlContractCount
			}, function (data){
				AlertService.success("Demande acceptée.");
			}, function (error){
				AlertService.error(error.data.message);
			});
		};
		
		
		vm.injecterJeuTesta = function() {
			if (vm.injectionNotProduction) {
				AdminTools.completerDonneesTest({
						idOrga : vm.injectionOrganisationId,
						idAgence : vm.injectionAreaId
				}, function (data){
					AlertService.success("Demande acceptée.");
				}, function (error){
					AlertService.error(error.data.message);
				});
			}
		};
		

		vm.initialiserroleareaelastic = function() {
			
			AdminTools.initialiserroleareaelastic({}, function (data){
				AlertService.success("Demande acceptée.");
			}, function (error){
				AlertService.error(error.data.message);
			});
			
		};
		
		vm.exportEventsInElastic= function() {
            var period = getExportPeriod();

			AdminTools.exportAllEventInElastic({
                fromDate: period.fromDate,
                toDate: period.toDate,
                purgeBeforeExport: vm.purgeBeforeExport
            }, function (data){
				AlertService.success("Demande acceptée.");
			}, function (error){
				AlertService.error(error.data.message);
			});
			
		};

		vm.indexManualDocs = function() {
			AdminTools.indexManualDocs({}, function(data) {
				var message = 'Documentation indexée';
				if (data && data.chunkCount) {
					message += ' : ' + data.chunkCount + ' fragments';
				}
				AlertService.success(message);
			}, function(error) {
				AlertService.error((error.data && error.data.message) || 'Indexation documentation impossible');
			});
		};

		vm.clearClientPortalResetRateLimit = function() {
			AdminTools.clearClientPortalResetRateLimit({}, function(data) {
				AlertService.success('Blocages du portail client levés. Compteurs supprimés : ' + (data || 0));
			}, function(error) {
				AlertService.error((error.data && error.data.message) || 'Purge du rate limit impossible');
			});
		};

		vm.majTeamwork = function() {
			
			AdminTools.majTeamwork({idOrga : vm.teamworkOrgaId}, function (data){
				AlertService.success("Demande acceptée.");
			}, function (error){
				AlertService.error(error.data.message);
			});
			
		};
		
		
        $scope.openRangeDateTimePicker = function(inputId) {
				var picker = $('#' + inputId).data('daterangepicker');
				if (picker) {
					picker.toggle();
				}
		}

        
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.toDatecheckExport = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
		vm.datePeriod = {
                startDate: null,
                endDate: null
        };
        vm.elasticResult = null;
        vm.checkExportRows = [];
        vm.elasticActions = [];
        vm.elasticProcessing = false;
        vm.purgeBeforeExport = false;

        function getExportPeriod() {
            var dateFormat = 'yyyy-MM-dd';
            return {
                fromDate: $filter('date')(new Date(vm.datePeriod.startDate), dateFormat),
                toDate: $filter('date')(new Date(vm.datePeriod.endDate), dateFormat)
            };
        }

        function parseElasticResponse(data) {
            if (angular.isString(data)) {
                try {
                    return angular.fromJson(data);
                } catch (e) {
                    return {raw: data};
                }
            }
            return data;
        }

        function displayElasticResponse(data) {
            vm.elasticResult = parseElasticResponse(data);
            vm.checkExportRows = vm.elasticResult && vm.elasticResult.rows ? vm.elasticResult.rows : [];
            vm.elasticActions = vm.elasticResult && vm.elasticResult.actions ? vm.elasticResult.actions : [];
        }

        function postElasticExport(url, successMessage) {
            vm.elasticProcessing = true;
            return $http.post(url).then(function(msg) {
                displayElasticResponse(msg.data);
                AlertService.success(successMessage || 'Traitement Elastic terminé');
            }, function(error) {
                AlertService.error((error.data && error.data.message) || 'Traitement Elastic impossible');
            }).finally(function() {
                vm.elasticProcessing = false;
            });
        }

		vm.exportElkCheckexport = function(){

		    var url = 'api/export/checkexport?toDate=' + $filter('date')(new Date(vm.toDatecheckExport), "yyyy-MM-dd");
		    postElasticExport(url, 'Comparaison Elastic terminée');
			
//			AdminTools.exportElkCheckexport( {
//				toDate:$filter('date')(new Date(vm.toDatecheckExport), "yyyy-MM-dd")
//    			}, function (data){
//				AlertService.success("success, response:"+data);
//				}, function (error){
//					AlertService.error(error.data.message);
//				});
    	}
		
		
		vm.exportElkFacturation = function(){
			
            var period = getExportPeriod();
			
            
			 var url = 'api/export/facturation?fromDate='+period.fromDate+'&toDate=' + period.toDate;
		    postElasticExport(url, 'Export facturation terminé');
		    
//			AdminTools.exportElkFacturation( {
//        		fromDate:fromDate,
//        		toDate:toDate
//    			}, function (data){
//				AlertService.success("success, response:"+data);
//				}, function (error){
//					AlertService.error(error.data.message);
//				});
    	}
		
		
		vm.exportElkWaterConsumption = function(){
			
            var period = getExportPeriod();
			
            
			 var url = 'api/export/consommationeau?fromDate='+period.fromDate+'&toDate=' + period.toDate;
		    postElasticExport(url, 'Export consommation eau terminé');

    	}
		
		
		
		vm.exportElkStatContrat = function(){
			
            var period = getExportPeriod();
			
            
			 var url = 'api/export/stat_contrat?fromDate='+period.fromDate+'&toDate=' + period.toDate;
		    postElasticExport(url, 'Export statistiques contrats terminé');

    	}
		
		
		
		
		vm.exportElkContrat = function(){
			
            var period = getExportPeriod();
			
            
			 var url = 'api/export/contracts?fromDate='+period.fromDate+'&toDate=' + period.toDate;
		    postElasticExport(url, 'Export contrats terminé');

    	}

        vm.reexportCategories = [
            {code: 'RECEIPTS', label: 'Reçus de paiement', selected: true},
            {code: 'INVOICES', label: 'Factures PDF', selected: false},
            {code: 'BILLING', label: 'Facturations, paiements et ajustements', selected: false},
            {code: 'WATER', label: 'Consommations d’eau', selected: false},
            {code: 'STATS', label: 'Statistiques contrats', selected: false},
            {code: 'CONTRACTS', label: 'Contrats', selected: false}
        ];
        // ng-options préserve les valeurs numériques avec AngularJS 1.5.
        vm.reexportChunkOptions = [
            {days: 1, label: '1 jour — pour mesurer la durée'},
            {days: 3, label: '3 jours'},
            {days: 7, label: '7 jours'}
        ];
        vm.reexportPurgeBeforeExport = false;
        vm.reexportHasContractsSelected = function() {
            return vm.reexportCategories.some(function(category) { return category.code === 'CONTRACTS' && category.selected; });
        };
        vm.reexportChunkDays = 1;
        vm.reexportJobs = [];
        vm.reexportBusy = false;
        vm.reexportStatusLabel = function(status) {
            return {QUEUED: 'En attente', RUNNING: 'En cours', ERROR: 'En erreur', SUCCESS: 'Terminée'}[status] || status;
        };
        vm.reexportCategoryLabel = function(code) {
            for (var i = 0; i < vm.reexportCategories.length; i++) {
                if (vm.reexportCategories[i].code === code) { return vm.reexportCategories[i].label; }
            }
            return code;
        };
        var reexportAttentionKey;
        vm.refreshReexportJobs = function() {
            return $http.get('api/export/reexport-jobs').then(function(response) {
                vm.reexportJobs = response.data;
                // Ouvrir sur une nouvelle demande ou erreur, sans empêcher le repli pendant le suivi.
                var attentionKey = vm.reexportJobs.filter(function(job) {
                    return job.status === 'QUEUED' || job.status === 'RUNNING' || job.status === 'ERROR';
                }).map(function(job) {
                    return job.id + ':' + (job.status === 'ERROR' ? 'ERROR' : 'ACTIVE');
                }).join(',');
                if (attentionKey && attentionKey !== reexportAttentionKey) {
                    vm.adminSections[1].open = true;
                }
                reexportAttentionKey = attentionKey;
                vm.reexportActive = vm.reexportJobs.some(function(job) {
                    return job.status === 'QUEUED' || job.status === 'RUNNING';
                });
            }, function(error) {
                AlertService.error((error.data && error.data.message) || 'Chargement des reprises Elastic impossible');
            });
        };
        vm.startReexportJob = function() {
            if (!vm.datePeriod.startDate || !vm.datePeriod.endDate) {
                AlertService.error('Choisissez les dates de début et de fin de la période.');
                return;
            }
            var categories = vm.reexportCategories.filter(function(category) { return category.selected; })
                .map(function(category) { return category.code; });
            if (!categories.length) {
                AlertService.error('Sélectionnez au moins une catégorie.');
                return;
            }
            if (vm.reexportPurgeBeforeExport && vm.reexportHasContractsSelected()) {
                AlertService.error('La purge par période ne s’applique pas aux contrats. Décochez Contrats ou désactivez la purge.');
                return;
            }
            var period = getExportPeriod();
            vm.reexportBusy = true;
            return $http.post('api/export/reexport-jobs', null, {params: {
                fromDate: period.fromDate, toDate: period.toDate,
                categories: categories.join(','), chunkDays: vm.reexportChunkDays,
                purgeBeforeExport: vm.reexportPurgeBeforeExport
            }}).then(function() {
                AlertService.success('Reprise enregistrée' + (vm.reexportPurgeBeforeExport ? ' avec purge des périodes' : ' sans purge') + '. Le traitement continue en arrière-plan.');
                return vm.refreshReexportJobs();
            }, function(error) {
                AlertService.error((error.data && error.data.message) || 'Démarrage de la reprise impossible');
            }).finally(function() { vm.reexportBusy = false; });
        };
        vm.resumeReexportJob = function(job) {
            vm.reexportBusy = true;
            return $http.post('api/export/reexport-jobs/' + job.id + '/resume').then(function() {
                return vm.refreshReexportJobs();
            }, function(error) {
                AlertService.error((error.data && error.data.message) || 'Reprise du traitement impossible');
            }).finally(function() { vm.reexportBusy = false; });
        };
        var reexportTimer;
        var reexportDestroyed = false;
        Principal.hasAuthority('ROLE_SUPER_ADMIN').then(function(allowed) {
            if (!allowed || reexportDestroyed) { return; }
            vm.refreshReexportJobs();
            reexportTimer = $interval(function() {
                if (vm.reexportActive) { vm.refreshReexportJobs(); }
            }, 5000);
        });
        $scope.$on('$destroy', function() {
            reexportDestroyed = true;
            if (reexportTimer) { $interval.cancel(reexportTimer); }
        });

		vm.reexportElasticPeriod = function(){
            var period = getExportPeriod();
            var url = 'api/export/reexport-period?fromDate=' + period.fromDate + '&toDate=' + period.toDate + '&purgeBeforeExport=' + vm.purgeBeforeExport;
		    postElasticExport(url, 'Réexport Elastic terminé');

    	}
		
		vm.exportElkDiscountCreditNoteRefund = function(){
			
            var period = getExportPeriod();
			
            
			 var url = 'api/export/credit_note_refund?fromDate='+period.fromDate+'&toDate=' + period.toDate;
		    postElasticExport(url, 'Export avoirs, factures PDF et reçus terminé');

    	}
	}
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var service = {
            checkHealth: checkHealth
        };

        return service;

        function checkHealth () {
            return $http.get('health').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular.module('wamasysApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.addHealthObject = addHealthObject;
        vm.baseName = baseName;
        vm.flattenHealthData = flattenHealthData;
        vm.getLabelClass = getLabelClass;
        vm.getModuleName = getModuleName;
        vm.hasSubSystem = hasSubSystem;
        vm.isHealthObject = isHealthObject;
        vm.refresh = refresh;
        vm.updatingHealth = true;
        vm.separator = '.';
        vm.showHealth = showHealth;
        vm.subSystemName = subSystemName;
        vm.transformHealthData = transformHealthData;

        vm.refresh();


        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!vm.isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function baseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (vm.isHealthObject(value)) {
                    if (vm.hasSubSystem(value)) {
                        vm.addHealthObject(result, false, value, vm.getModuleName(path, key));
                        vm.flattenHealthData(result, vm.getModuleName(path, key), value);
                    } else {
                        vm.addHealthObject(result, true, value, vm.getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + vm.separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = vm.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  vm.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

        function subSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        function transformHealthData (data) {
            var response = [];
            vm.flattenHealthData(response, null, data);
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authenticate: true,
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('mfa');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate', 'Mfa'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate, Mfa) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;
        vm.mfaStatus = {enabled: false, available: false};
        vm.mfaLoading = true;
        vm.mfaBusy = false;
        vm.mfaProof = {};
        vm.startMfaSetup = startMfaSetup;
        vm.activateMfa = activateMfa;
        vm.disableMfa = disableMfa;
        vm.cancelMfaSetup = cancelMfaSetup;

        Mfa.status().then(function(status) { vm.mfaStatus = status; })
            .catch(mfaError).finally(function() { vm.mfaLoading = false; });

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function startMfaSetup() {
            if (vm.mfaBusy) { return; }
            vm.mfaBusy = true;
            vm.mfaError = null;
            vm.mfaSuccess = null;
            Mfa.setup(vm.mfaProof).then(function(setup) {
                vm.mfaSetup = setup;
                vm.mfaProof.code = null;
            }).catch(mfaError).finally(function() { vm.mfaBusy = false; });
        }

        function activateMfa() { changeMfa(Mfa.activate, 'mfa.activated'); }
        function disableMfa() { changeMfa(Mfa.disable, 'mfa.disabled'); }

        function changeMfa(operation, message) {
            if (vm.mfaBusy) { return; }
            vm.mfaBusy = true;
            vm.mfaError = null;
            operation(vm.mfaProof).then(function(status) {
                vm.mfaStatus = status;
                vm.mfaSuccess = message;
                cancelMfaSetup();
            }).catch(mfaError).finally(function() { vm.mfaBusy = false; });
        }

        function cancelMfaSetup() {
            vm.mfaSetup = null;
            vm.mfaProof = {};
        }

        function mfaError(error) {
            var key = error.data && error.data.message;
            vm.mfaError = key && key.indexOf('mfa.') === 0 ? key : 'mfa.failed';
            vm.mfaProof.code = null;
        }

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('api/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').config(stateConfig);
    stateConfig.$inject = ['$stateProvider'];
    function stateConfig($stateProvider) {
        $stateProvider.state('windows-preparation', {
            parent: 'account', url: '/windows-preparation',
            data: {authenticate: true, pageTitle: 'windowsPreparation.title'},
            views: {'content@': {templateUrl: 'app/account/windows-preparation/windows-preparation.html', controller: 'WindowsPreparationController', controllerAs: 'vm'}},
            resolve: {translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('windowsPreparation');
                return $translate.refresh();
            }]}
        });
    }
})();
;
(function () {
    'use strict';
    angular.module('wamasysApp').controller('WindowsPreparationController', WindowsPreparationController);
    WindowsPreparationController.$inject = ['$http', '$window', '$scope'];
    function WindowsPreparationController($http, $window, $scope) {
        var vm = this, endpoint = 'api/account/windows-preparation', active = true;
        vm.status = {}; vm.load = load; vm.download = download;
        function load() {
            vm.loading = true; vm.error = false; vm.status = {};
            return $http.get(endpoint).then(function (response) { if (active) { vm.status = response.data; } })
                .catch(function () { if (active) { vm.error = true; } })
                .finally(function () { if (active) { vm.loading = false; } });
        }
        function download() {
            if (!vm.status.allowed || vm.loading || vm.downloading) { return; }
            vm.error = false; vm.downloaded = false; vm.downloading = true;
            var baseUrl = ($window.location.origin + $window.location.pathname).replace(/\/index\.html$/, '').replace(/\/$/, '');
            // Le serveur vérifie à nouveau l’autorisation et détermine le rattachement du poste.
            return $http.post(endpoint, {apiBaseUrl: baseUrl}, {responseType: 'arraybuffer'}).then(function (response) {
                if (!active) { return; }
                var url = $window.URL.createObjectURL(new $window.Blob([response.data], {type: 'application/zip'})), link = $window.document.createElement('a');
                link.href = url; link.download = 'windows-workstation-preparation.zip';
                $window.document.body.appendChild(link); link.click(); $window.document.body.removeChild(link);
                $window.setTimeout(function () { $window.URL.revokeObjectURL(url); }, 1000);
                vm.downloaded = true;
            }).catch(function (error) {
                if (active) { vm.error = true; if (error.status === 403) { vm.status.allowed = false; vm.status.reason = 'DISABLED'; } }
            }).finally(function () { if (active) { vm.downloading = false; } });
        }
        $scope.$on('$destroy', function () { active = false; });
        load();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('[ng-model="vm.registerAccount.login"]').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
            	authenticate: true,
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                vm.isSaving = true;
                Auth.changePassword(vm.currentPassword, vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.isSaving = false;
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                    vm.isSaving = false;
                });
            }
        }
    }
})();
;
/* globals $ */
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('ai-assistant-history', {
            parent: 'account',
            url: '/ai-assistant-history',
            data: {
                authorities: ['ROLE_AI_ASSISTANT', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                pageTitle: 'global.menu.account.assistantHistory'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/ai-assistant-history/ai-assistant-history.html',
                    controller: 'AiAssistantHistoryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aiAssistantHistory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('AiAssistantHistory', AiAssistantHistory);

    AiAssistantHistory.$inject = ['$http'];

    function AiAssistantHistory($http) {
        return {
            getOverview: function() {
                return $http.get('api/ai-assistant-history/overview');
            },
            getDetail: function(conversationKey) {
                return $http.get('api/ai-assistant-history/detail', {
                    params: {
                        conversationKey: conversationKey
                    }
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('AiAssistantHistoryController', AiAssistantHistoryController);

    AiAssistantHistoryController.$inject = ['AiAssistantHistory', 'AlertService'];

    function AiAssistantHistoryController(AiAssistantHistory, AlertService) {
        var vm = this;

        vm.loadingOverview = false;
        vm.loadingDetail = false;
        vm.selectedConversation = null;
        vm.detail = null;
        vm.overview = {
            totalConversations: 0,
            totalTokens: 0,
            conversations: []
        };

        vm.loadOverview = loadOverview;
        vm.selectConversation = selectConversation;
        vm.isConversationSelected = isConversationSelected;
        vm.getActionBadgeClass = getActionBadgeClass;
        vm.hasVisibleConversationContent = hasVisibleConversationContent;

        loadOverview();

        function loadOverview() {
            vm.loadingOverview = true;
            AiAssistantHistory.getOverview().then(function(response) {
                vm.overview = response.data || vm.overview;
                if (vm.selectedConversation) {
                    syncSelectedConversation();
                }
            }).catch(function(error) {
                AlertService.error(resolveErrorMessage(error, 'Impossible de charger votre historique assistant IA.'));
            }).finally(function() {
                vm.loadingOverview = false;
            });
        }

        function selectConversation(conversation) {
            if (!conversation || !conversation.conversationId) {
                return;
            }
            vm.selectedConversation = conversation;
            vm.loadingDetail = true;
            vm.detail = null;
            AiAssistantHistory.getDetail(conversation.conversationId).then(function(response) {
                vm.detail = response.data || null;
            }).catch(function(error) {
                AlertService.error(resolveErrorMessage(error, 'Impossible de charger le detail de cette conversation.'));
            }).finally(function() {
                vm.loadingDetail = false;
            });
        }

        function syncSelectedConversation() {
            var updatedConversation = null;
            angular.forEach(vm.overview.conversations || [], function(conversation) {
                if (!updatedConversation && vm.selectedConversation
                    && conversation.conversationId === vm.selectedConversation.conversationId) {
                    updatedConversation = conversation;
                }
            });
            if (updatedConversation) {
                vm.selectedConversation = updatedConversation;
            }
        }

        function isConversationSelected(conversation) {
            return vm.selectedConversation && conversation && vm.selectedConversation.conversationId === conversation.conversationId;
        }

        function getActionBadgeClass(hasExecutedActions) {
            return hasExecutedActions ? 'label label-warning' : 'label label-default';
        }

        function hasVisibleConversationContent(event) {
            return !!(event
                && (event.requestTotalTokens
                || event.sentMessage
                || event.receivedMessage
                || (event.clarificationQuestions && event.clarificationQuestions.length)
                || (event.actionSummaries && event.actionSummaries.length)
                || event.hasAction));
        }

        function resolveErrorMessage(error, fallbackMessage) {
            return (error && error.headers && error.headers('X-wamasysApp-detail')) || fallbackMessage;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ReportingDashboard', ReportingDashboard);

    ReportingDashboard.$inject = ['$resource'];

    function ReportingDashboard ($resource) {
        var resourceUrl =  'api/elastic/dashboard';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false}
        });
        
    }
    
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                issuefilter: {
                    value: 'myissues',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        issuefilter: $stateParams.issuefilter,
         
                        search: $stateParams.search
                    };
                }],
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('login');
                    return $translate.refresh();
                }]
            }
        })
        .state('home.new_issue', {
            parent: 'home',
            url: '/new_issue',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/home/redmine-createticket-dialog.controller.html',
                    controller: 'RedmineCreateTicketController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nom: null,
                                codeAgence: null,
                                devise: null,
                                enteteFacture: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('home', null, { reload: true });
                }, function() {
                    $state.go('home');
                });
            }]
        });
        
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$rootScope', '$state', '$timeout', 'Auth','$scope', 'AlertService','Principal', 'LoginService','ReportingDashboard','RedmineService','CalendarService','pagingParams','paginationConstants','ParseLinks'];

    function HomeController ($rootScope,$state, $timeout, Auth,$scope,AlertService, Principal, LoginService,ReportingDashboard,RedmineService,CalendarService ,pagingParams, paginationConstants,ParseLinks) {
        var vm = this;

        
        vm.idDashboard = "d0f660b0-c7ac-11e8-8320-c93d887536a8";
	    vm.filtreagence = true;
	    vm.periodKibana = true;
	    
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        $scope.$on('authenticationSuccess', function() {
            getAccount();

        	vm.loadAll();
            loadGraphic();
        	
        });

        getAccount();
        
        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
    	        vm.loadEvents();
                
//                if( vm.isAuthenticated ){
//                	vm.myIssues();
//                	                	
//                }
        
            });
        }
   

        vm.transition = transition;
        vm.loadAll = loadAll;

    	vm.loadAll();

        
        function loadAll() {
        	vm.issuefilter = pagingParams.issuefilter;
        	if(pagingParams.issuefilter == 'myissues'){
        		vm.indextab = 0;
        		 RedmineService.myIssues({
 	                page: pagingParams.page - 1,
 	                size: 10}, onSuccess, onError);
        	}
        }
        vm.myIssues = function () {
        	vm.issuefilter = 'myissues';
        	loadPage(1);
        }

        
        function onSuccess(data, headers) {
//            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = data.total_count;
            vm.queryCount = vm.totalItems;
            vm.listIssues = data;
//            vm.page = pagingParams.offset;
          vm.page = (data.offset/data.limit)+1;
            
        }
        
        function onError(error) {
        	if(error.data && error.data.message)
        		AlertService.error(error.data.message);
        	else if(error)
        		AlertService.error(error);
        }
        
        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }
        
        function transition () {
	        $state.transitionTo($state.$current, {
	            page: vm.page,
	            issuefilter: vm.issuefilter
	        	});
        }
        
        /////////////////////////////////
        


        
        function loadGraphic() {
            vm.reporting =  ReportingDashboard.get();
        	 if( vm.reporting &&  vm.reporting.$promise){
             	
             	vm.reporting.$promise.then(function(value)  {
             
     	        	var billingLabels = [];
     	        	var billingData = [];
     	
     	        	for (var i = 0 ; i < vm.reporting.billing.aggregations.aggregation.buckets.length; i++) {
     	        		billingLabels.push( vm.reporting.billing.aggregations.aggregation.buckets[i].key_as_string);
     	        		billingData.push( parseFloat(vm.reporting.billing.aggregations.aggregation.buckets[i].balance.value).toFixed( 2 ));
     	        	}
     	
     	        	var paymentLabels = [];
     	        	var paymentData = [];
     	        	for (var i = 0 ; i < vm.reporting.payment.aggregations.aggregation.buckets.length; i++) {
     	        		paymentLabels.push( vm.reporting.payment.aggregations.aggregation.buckets[i].key_as_string);
     	        		paymentData.push( parseFloat(vm.reporting.payment.aggregations.aggregation.buckets[i].balance.value).toFixed( 2 ));
     	        	}
     	        	
     	            $scope.billingLabels = billingLabels;
     	            $scope.billingData = [billingData,paymentData];
     	            $scope.billingSeries = ['Billing','Payments'];
     	            
     	            $scope.paymentLabels = paymentLabels;
     	            $scope.paymentData = [billingData,paymentData];
     	            
     	        	var statLabels = [];
     	        	var statData = [];
     	        	for (var i = 0 ; i < vm.reporting.statistic.aggregations.aggregation.buckets.length; i++) {
     	        		statLabels.push( vm.reporting.statistic.aggregations.aggregation.buckets[i].key_as_string);
     	        		statData.push( parseFloat(vm.reporting.statistic.aggregations.aggregation.buckets[i].maxBalance.value).toFixed( 2 ));
     	        	}
     	            $scope.statLabels = statLabels;
     	            $scope.statData = [statData];

     	        	var balanceLabels = [];
     	        	var balanceData = [];
     	        	for (var i = 0 ; i < vm.reporting.balance.aggregations.aggregation.buckets.length; i++) {
     	        		balanceLabels.push( vm.reporting.balance.aggregations.aggregation.buckets[i].key_as_string);
     	        		balanceData.push( parseFloat(vm.reporting.balance.aggregations.aggregation.buckets[i].maxBalance.value).toFixed( 2 ));
     	        	}
     	            $scope.balanceLabels = balanceLabels;
     	            $scope.balanceData = [balanceData];
     	            
             	});
             }
        }


        loadGraphic();
      
        $scope.onClick = function (points, evt) {
          console.log(points, evt);
        };
        $scope.datasetOverride = [{ yAxisID: 'y-axis-1' }, { yAxisID: 'y-axis-2' }];
        $scope.options = {
          scales: {
            yAxes: [
              {
                id: 'y-axis-1',
                type: 'linear',
                display: true,
                position: 'left'
              }
            ]
          }
        };

        
        $scope.labels3 = ["January", "February", "March", "April", "May", "June", "July"];
        $scope.series3 = ['Series A'];
        $scope.data3 = [
          [90, 95, 93, 97, 100, 98, 95]
        ];
        $scope.onClick = function (points, evt) {
          console.log(points, evt);
        };
        $scope.datasetOverride = [{ yAxisID: 'y-axis-1' }, { yAxisID: 'y-axis-2' }];
        $scope.options3 = {
          scales: {
            yAxes: [
              {
                id: 'y-axis-1',
                type: 'linear',
                display: true,
                position: 'left',
                min:0
              }
            ]
          }
        };
        
        ///
        ///
        $scope.labels2 = ["Download Sales", "In-Store Sales", "Mail-Order Sales"];
        $scope.data2 = [80,20];
        $scope.options2 = {
                circumference: 3.14,
                rotation: -3.14
              };
        
        /////////////////////////////////
       
	    //Code utilisé pour le login
	    vm.textErreur = 'login.messages.error.authentication';
	    vm.authenticationError = false;
	    vm.cancel = cancel;
	    vm.credentials = {};
	    vm.login = login;
	    vm.password = null;
	    vm.rememberMe = true;
	    vm.requestResetPassword = requestResetPassword;
	    vm.username = null;
        vm.mfaRequired = false;
        vm.mfaCode = null;
        vm.submitting = false;
	
	    $timeout(function (){angular.element('[ng-model="vm.username"]').focus();});
	
	    function cancel () {
            vm.password = null;
            vm.mfaCode = null;
            vm.mfaRequired = false;
	        vm.credentials = {
	            username: null,
	            password: null,
	            rememberMe: true
	        };
	        vm.authenticationError = false;
	    }
	
        // Même parcours MFA que la fenêtre de connexion.
        function login (event) {
            event.preventDefault();
            if (vm.submitting) { return; }
            vm.submitting = true;
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe,
                mfaCode: vm.mfaCode
            }).then(function () {
                vm.authenticationError = false;
                vm.password = null;
                vm.mfaCode = null;
                vm.mfaRequired = false;
                // If we're redirected to login, our
                // previousState is already set in the authExpiredInterceptor. When login succesful go to stored state
                if ($rootScope.redirected && $rootScope.previousStateName) {
                    $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
                    $rootScope.redirected = false;
                } else {
                    $rootScope.$broadcast('authenticationSuccess');
                }
            }).catch(function (erreur) {
                var errorKey = erreur.data && erreur.data.errorKey;
                vm.textErreur = errorKey || erreur.headers('X-wamasysApp-error') || 'login.messages.error.authentication';
                vm.mfaRequired = !!(erreur.data && erreur.data.mfa_required);
                vm.mfaCode = null;
                // Le premier code demandé est une étape normale, pas une erreur de mot de passe.
                vm.authenticationError = vm.textErreur !== 'login.messages.error.mfaRequired';
                if (vm.mfaRequired) {
                    $timeout(function() { angular.element('[ng-model="vm.mfaCode"]').focus(); });
                }
            }).finally(function() {
                vm.submitting = false;
            });
        }

	    function requestResetPassword () {
	        $state.go('requestReset');
	    }
	    
	    ///////////////////////////
	    
	    vm.nextDays = [];
	    vm.currentTimePosition = 0;
	    
	    vm.events =     [];   
	    // Charger les événements pour les utilisateurs sélectionnés
        vm.loadEvents = function(start, end) {
            CalendarService.findEvents({
                userLogin: vm.account.login, 
                from: moment().startOf('day').toISOString(true),
                to: moment().add(10, 'days').toISOString(true)
            },function(response) {
            	if(response && response.length>0){
            		 vm.events = [];
            		 vm.events =  response;
            		 vm.loadNextDays();
            	}
            },onError);
        };

	    // Fonction pour récupérer les 5 prochains jours avec événements
	    vm.loadNextDays = function() {
	        var now = moment().startOf('day');

	        for (var i = 0; i < 5; i++) {
	            var date = moment().add(i, 'days');
	            var isToday = moment().isSame(date, 'day');

	            vm.nextDays.push({
	                date: date.toDate(),
	                isToday: isToday,
	                events: vm.getEventsForDay(date)
	            });
	        }

	        // Mettre à jour la position de la barre rouge
	        vm.updateCurrentTimeBar();
	    };

	    // Fonction pour récupérer les événements d'un jour donné
	    vm.getEventsForDay = function(date) {
	        return vm.events.filter(
	        		function(event){ 
	        			return moment(event.start).isSame(date, 'day');
	        		}
	        	);
	    };

	    // Mettre à jour la position de la ligne rouge
	    vm.updateCurrentTimeBar = function() {
	        var now = moment();
	        var startOfDay = moment().startOf('day');
	        var totalMinutes = now.diff(startOfDay, 'minutes');
	        
	        vm.currentTimePosition = (totalMinutes / 1440) * 100; // 1440 minutes dans une journée
	    };

	    // Rafraîchir la barre rouge toutes les 10 minutes
	    setInterval(vm.updateCurrentTimeBar, 600000);
	    
	    
	    // Charger les jours au démarrage
	    if(vm.isAuthenticated){
	        vm.loadEvents();
	    }
    }
    
})();
;
(function () {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
/**!
 * The MIT License
 *
 * Copyright (c) the ui-leaflet Team, http://angular-ui.github.io/ui-leaflet
 *
 * Original Copyright (c) https://github.com/angular-ui/ui-leaflet
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 * ui-leaflet
 * https://github.com/angular-ui/ui-leaflet
 *
 * @authors https://github.com/angular-ui/ui-leaflet/graphs/contributors
 */

/*!
*  ui-leaflet 1.0.3 2017-01-26
*  ui-leaflet - An AngularJS directive to easily interact with Leaflet maps
*  git: https://github.com/angular-ui/ui-leaflet
*/
!function(angular){"use strict";angular.module("ui-leaflet",["nemLogging"]).directive("leaflet",["$q","leafletData","leafletMapDefaults","leafletHelpers","leafletMapEvents",function(a,b,c,d,e){return{restrict:"EA",replace:!0,scope:{center:"=",lfCenter:"=",defaults:"=",maxbounds:"=",bounds:"=",markers:"=",legend:"=",geojson:"=",paths:"=",tiles:"=",layers:"=",controls:"=",decorations:"=",eventBroadcast:"=",markersWatchOptions:"=",geojsonWatchOptions:"="},transclude:!0,template:'<div class="angular-leaflet-map"><div ng-transclude></div></div>',controller:["$scope",function(b){this._leafletMap=a.defer(),this.getMap=function(){return this._leafletMap.promise},this.getLeafletScope=function(){return b}}],link:function(a,f,g,h){function i(){isNaN(g.width)?f.css("width",g.width):f.css("width",g.width+"px")}function j(){isNaN(g.height)?f.css("height",g.height):f.css("height",g.height+"px")}var k=d.isDefined,l=c.setDefaults(a.defaults,g.id),m=e.getAvailableMapEvents(),n=e.addEvents;a.mapId=g.id,b.setDirectiveControls({},g.id),k(g.width)&&(i(),a.$watch(function(){return f[0].getAttribute("width")},function(){i(),o.invalidateSize()})),k(g.height)&&(j(),a.$watch(function(){return f[0].getAttribute("height")},function(){j(),o.invalidateSize()}));var o=new L.Map(f[0],c.getMapCreationDefaults(g.id));if(h._leafletMap.resolve(o),k(g.center)||k(g.lfCenter)||o.setView([l.center.lat,l.center.lng],l.center.zoom),!k(g.tiles)&&!k(g.layers)){var p=L.tileLayer(l.tileLayer,l.tileLayerOptions);p.addTo(o),b.setTiles(p,g.id)}if(k(o.zoomControl)&&k(l.zoomControlPosition)&&o.zoomControl.setPosition(l.zoomControlPosition),k(o.zoomControl)&&l.zoomControl===!1&&o.zoomControl.removeFrom(o),k(o.zoomsliderControl)&&k(l.zoomsliderControl)&&l.zoomsliderControl===!1&&o.zoomsliderControl.removeFrom(o),!k(g.eventBroadcast)){var q="broadcast";n(o,m,"eventName",a,q)}o.whenReady(function(){b.setMap(o,g.id)}),a.$on("$destroy",function(){c.reset(),o.remove(),b.unresolveMap(g.id)}),a.$on("invalidateSize",function(){o.invalidateSize()})}}}]),angular.module("ui-leaflet").factory("leafletBoundsHelpers",["leafletLogger","leafletHelpers",function(a,b){function c(a){return angular.isDefined(a)&&angular.isDefined(a.southWest)&&angular.isDefined(a.northEast)&&angular.isNumber(a.southWest.lat)&&angular.isNumber(a.southWest.lng)&&angular.isNumber(a.northEast.lat)&&angular.isNumber(a.northEast.lng)}var d=b.isArray,e=b.isNumber,f=b.isFunction,g=b.isDefined,h=a;return{createLeafletBounds:function(a){return c(a)?L.latLngBounds([a.southWest.lat,a.southWest.lng],[a.northEast.lat,a.northEast.lng]):void 0},isValidBounds:c,createBoundsFromArray:function(a){return d(a)&&2===a.length&&d(a[0])&&d(a[1])&&2===a[0].length&&2===a[1].length&&e(a[0][0])&&e(a[0][1])&&e(a[1][0])&&e(a[1][1])?{northEast:{lat:a[0][0],lng:a[0][1]},southWest:{lat:a[1][0],lng:a[1][1]}}:void h.error("[AngularJS - Leaflet] The bounds array is not valid.")},createBoundsFromLeaflet:function(a){if(!(g(a)&&f(a.getNorthEast)&&f(a.getSouthWest)))return void h.error("[AngularJS - Leaflet] The leaflet bounds is not valid object.");var b=a.getNorthEast(),c=a.getSouthWest();return{northEast:{lat:b.lat,lng:b.lng},southWest:{lat:c.lat,lng:c.lng}}}}}]),angular.module("ui-leaflet").factory("leafletControlHelpers",["$rootScope","leafletLogger","leafletHelpers","leafletLayerHelpers","leafletMapDefaults",function(a,b,c,d,e){var f=c.isDefined,g=c.isObject,h=c.get,i=d.createLayer,j={},k=c.errorHeader+" [Controls] ",l=b,m=function(a,b,c){var d=e.getDefaults(c);if(!h(d,"controls.layers.visible"))return!1;var i=!1;return g(a)&&Object.keys(a).forEach(function(b){var c=a[b];f(c.layerOptions)&&c.layerOptions.showOnSelector===!1||(i=!0)}),g(b)&&Object.keys(b).forEach(function(a){var c=b[a];f(c.layerParams)&&c.layerParams.showOnSelector===!1||(i=!0)}),i},n=function(a){var b=e.getDefaults(a),c={collapsed:b.controls.layers.collapsed,position:b.controls.layers.position,autoZIndex:!1};angular.extend(c,b.controls.layers.options);var d;return d=h(b,"controls.layers.control")?b.controls.layers.control.apply(this,[[],[],c]):new L.control.layers([],[],c)},o={draw:{isPluginLoaded:function(){return angular.isDefined(L.Control.Draw)?!0:(l.error(k+" Draw plugin is not loaded."),!1)},checkValidParams:function(){return!0},createControl:function(a){return new L.Control.Draw(a)}},scale:{isPluginLoaded:function(){return!0},checkValidParams:function(){return!0},createControl:function(a){return new L.control.scale(a)}},fullscreen:{isPluginLoaded:function(){return angular.isDefined(L.Control.Fullscreen)?!0:(l.error(k+" Fullscreen plugin is not loaded."),!1)},checkValidParams:function(){return!0},createControl:function(a){return new L.Control.Fullscreen(a)}},search:{isPluginLoaded:function(){return angular.isDefined(L.Control.Search)?!0:(l.error(k+" Search plugin is not loaded."),!1)},checkValidParams:function(){return!0},createControl:function(a){return new L.Control.Search(a)}},custom:{},minimap:{isPluginLoaded:function(){return angular.isDefined(L.Control.MiniMap)?!0:(l.error(k+" Minimap plugin is not loaded."),!1)},checkValidParams:function(a){return f(a.layer)?!0:(l.warn(k+' minimap "layer" option should be defined.'),!1)},createControl:function(a){var b=i(a.layer);return f(b)?new L.Control.MiniMap(b,a):void l.warn(k+' minimap control "layer" could not be created.')}}};return{layersControlMustBeVisible:m,isValidControlType:function(a){return-1!==Object.keys(o).indexOf(a)},createControl:function(a,b){return o[a].checkValidParams(b)?o[a].createControl(b):void 0},updateLayersControl:function(a,b,c,d,e,g){var h,i=j[b],k=m(d,e,b);if(f(i)&&c){for(h in g.baselayers)i.removeLayer(g.baselayers[h]);for(h in g.overlays)i.removeLayer(g.overlays[h]);a.removeControl(i),delete j[b]}if(k){i=n(b),j[b]=i;for(h in d){var l=f(d[h].layerOptions)&&d[h].layerOptions.showOnSelector===!1;!l&&f(g.baselayers[h])&&i.addBaseLayer(g.baselayers[h],d[h].name)}for(h in e){var o=f(e[h].layerParams)&&e[h].layerParams.showOnSelector===!1;!o&&f(g.overlays[h])&&i.addOverlay(g.overlays[h],e[h].name)}a.addControl(i)}return k}}}]),angular.module("ui-leaflet").service("leafletData",["leafletLogger","$q","leafletHelpers",function(a,b,c){var d=c.getDefer,e=c.getUnresolvedDefer,f=c.setResolvedDefer,g={},h=this,i=function(a){return a.charAt(0).toUpperCase()+a.slice(1)},j=["map","tiles","layers","paths","markers","geoJSON","UTFGrid","decorations","directiveControls"];j.forEach(function(a){g[a]={}}),this.unresolveMap=function(a){var b=c.obtainEffectiveMapId(g.map,a);j.forEach(function(a){g[a][b]=void 0})},j.forEach(function(a){var b=i(a);h["set"+b]=function(b,c){var d=e(g[a],c);d.resolve(b),f(g[a],c)},h["get"+b]=function(b){var c=d(g[a],b);return c.promise}})}]),angular.module("ui-leaflet").service("leafletDirectiveControlsHelpers",["leafletLogger","leafletData","leafletHelpers",function(a,b,c){var d=c.isDefined,e=c.isString,f=c.isObject,g=c.errorHeader,h=a,i=g+"[leafletDirectiveControlsHelpers",j=function(a,c,g,j){var k=i+".extend] ",l={};if(!d(c))return void h.error(k+"thingToAddName cannot be undefined");if(e(c)&&d(g)&&d(j))l[c]={create:g,clean:j};else{if(!f(c)||d(g)||d(j))return void h.error(k+"incorrect arguments");l=c}b.getDirectiveControls(a).then(function(c){angular.extend(c,l),b.setDirectiveControls(c,a)})};return{extend:j}}]),angular.module("ui-leaflet").service("leafletGeoJsonHelpers",["leafletHelpers","leafletIterators",function(a,b){var c=a,d=b,e=function(a,b){return this.lat=a,this.lng=b,this},f=function(a){return Array.isArray(a)&&2===a.length?a[1]:c.isDefined(a.type)&&"Point"===a.type?+a.coordinates[1]:+a.lat},g=function(a){return Array.isArray(a)&&2===a.length?a[0]:c.isDefined(a.type)&&"Point"===a.type?+a.coordinates[0]:+a.lng},h=function(a){if(c.isUndefined(a))return!1;if(c.isArray(a)){if(2===a.length&&c.isNumber(a[0])&&c.isNumber(a[1]))return!0}else if(c.isDefined(a.type)&&"Point"===a.type&&c.isArray(a.coordinates)&&2===a.coordinates.length&&c.isNumber(a.coordinates[0])&&c.isNumber(a.coordinates[1]))return!0;var b=d.all(["lat","lng"],function(b){return c.isDefined(a[b])&&c.isNumber(a[b])});return b},i=function(a){if(a&&h(a)){var b=null;if(Array.isArray(a)&&2===a.length)b=new e(a[1],a[0]);else{if(!c.isDefined(a.type)||"Point"!==a.type)return a;b=new e(a.coordinates[1],a.coordinates[0])}return angular.extend(a,b)}};return{getLat:f,getLng:g,validateCoords:h,getCoords:i}}]),angular.module("ui-leaflet").service("leafletHelpers",["$q","$log",function(a,b){function c(a,b){var c,d=Object.keys(a);if(angular.isDefined(b))c=b;else{if(0!==d.length&&(1!==d.length||"main"!==d[0]))throw new Error(e+"- You have more than 1 map on the DOM, you must provide the map ID to the leafletData.getXXX call. Where one of the following mapIds "+Object.keys(a).join(",")+" are available.");c="main"}return c}function d(b,d){var e,f=c(b,d);return angular.isDefined(b[f])&&b[f].resolvedDefer!==!0?e=b[f].defer:(e=a.defer(),b[f]={defer:e,resolvedDefer:!1}),e}var e="[AngularJS - Leaflet] ",f=angular.copy,g=f,h=function(a,b){if(a){b=b.split(".");for(var c=a[b.shift()];c&&b.length;)c=c[b.shift()];return c}},i=function(a){return a.split(".").reduce(function(a,b){return a+'["'+b+'"]'})},j=function(a){return a.reduce(function(a,b){return a+"."+b})},k=function(a){return angular.isDefined(a)&&null!==a},l=function(a){return!k(a)},m=/([\:\-\_]+(.))/g,n=/^moz([A-Z])/,o=/^((?:x|data)[\:\-_])/i,p=function(a){return a.replace(m,function(a,b,c,d){return d?c.toUpperCase():c}).replace(n,"Moz$1")},q=function(a){return p(a.replace(o,""))};return{camelCase:p,directiveNormalize:q,copy:f,clone:g,errorHeader:e,getObjectValue:h,get:h,getObjectArrayPath:i,getObjectDotPath:j,defaultTo:function(a,b){return k(a)?a:b},isTruthy:function(a){return"true"===a||a===!0},isEmpty:function(a){return 0===Object.keys(a).length},isUndefinedOrEmpty:function(a){return angular.isUndefined(a)||null===a||0===Object.keys(a).length},isDefined:k,isUndefined:l,isNumber:angular.isNumber,isString:angular.isString,isArray:angular.isArray,isObject:angular.isObject,isFunction:angular.isFunction,equals:angular.equals,isValidCenter:function(a){return angular.isDefined(a)&&angular.isNumber(a.lat)&&angular.isNumber(a.lng)&&angular.isNumber(a.zoom)},isValidPoint:function(a){return angular.isDefined(a)?angular.isArray(a)?2===a.length&&angular.isNumber(a[0])&&angular.isNumber(a[1]):angular.isNumber(a.lat)&&angular.isNumber(a.lng):!1},isSameCenterOnMap:function(a,b){var c=b.getCenter(),d=b.getZoom();return a.lat&&a.lng&&c.lat.toFixed(4)===a.lat.toFixed(4)&&c.lng.toFixed(4)===a.lng.toFixed(4)&&d===a.zoom?!0:!1},safeApply:function(a,b){var c=a.$root.$$phase;"$apply"===c||"$digest"===c?a.$eval(b):a.$evalAsync(b)},obtainEffectiveMapId:c,getDefer:function(a,b){var e,f=c(a,b);return e=angular.isDefined(a[f])&&a[f].resolvedDefer!==!1?a[f].defer:d(a,b)},getUnresolvedDefer:d,setResolvedDefer:function(a,b){var d=c(a,b);a[d].resolvedDefer=!0},rangeIsSupported:function(){var a=document.createElement("input");return a.setAttribute("type","range"),"range"===a.type},FullScreenControlPlugin:{isLoaded:function(){return angular.isDefined(L.Control.Fullscreen)}},MiniMapControlPlugin:{isLoaded:function(){return angular.isDefined(L.Control.MiniMap)}},AwesomeMarkersPlugin:{isLoaded:function(){return angular.isDefined(L.AwesomeMarkers)&&angular.isDefined(L.AwesomeMarkers.Icon)},is:function(a){return this.isLoaded()?a instanceof L.AwesomeMarkers.Icon:!1},equal:function(a,b){return this.isLoaded()&&this.is(a)?angular.equals(a,b):!1}},VectorMarkersPlugin:{isLoaded:function(){return angular.isDefined(L.VectorMarkers)&&angular.isDefined(L.VectorMarkers.Icon)},is:function(a){return this.isLoaded()?a instanceof L.VectorMarkers.Icon:!1},equal:function(a,b){return this.isLoaded()&&this.is(a)?angular.equals(a,b):!1}},DomMarkersPlugin:{isLoaded:function(){return angular.isDefined(L.DomMarkers)&&angular.isDefined(L.DomMarkers.Icon)?!0:!1},is:function(a){return this.isLoaded()?a instanceof L.DomMarkers.Icon:!1},equal:function(a,b){return this.isLoaded()&&this.is(a)?angular.equals(a,b):!1}},PolylineDecoratorPlugin:{isLoaded:function(){return angular.isDefined(L.PolylineDecorator)?!0:!1},is:function(a){return this.isLoaded()?a instanceof L.PolylineDecorator:!1},equal:function(a,b){return this.isLoaded()&&this.is(a)?angular.equals(a,b):!1}},MakiMarkersPlugin:{isLoaded:function(){return angular.isDefined(L.MakiMarkers)&&angular.isDefined(L.MakiMarkers.Icon)?!0:!1},is:function(a){return this.isLoaded()?a instanceof L.MakiMarkers.Icon:!1},equal:function(a,b){return this.isLoaded()&&this.is(a)?angular.equals(a,b):!1}},ExtraMarkersPlugin:{isLoaded:function(){return angular.isDefined(L.ExtraMarkers)&&angular.isDefined(L.ExtraMarkers.Icon)?!0:!1},is:function(a){return this.isLoaded()?a instanceof L.ExtraMarkers.Icon:!1},equal:function(a,b){return this.isLoaded()&&this.is(a)?angular.equals(a,b):!1}},LabelPlugin:{isLoaded:function(){return angular.isDefined(L.Label)},is:function(a){return this.isLoaded()?a instanceof L.MarkerClusterGroup:!1}},MarkerClusterPlugin:{isLoaded:function(){return angular.isDefined(L.MarkerClusterGroup)},is:function(a){return this.isLoaded()?a instanceof L.MarkerClusterGroup:!1}},GoogleLayerPlugin:{isLoaded:function(){return angular.isDefined(L.Google)},is:function(a){return this.isLoaded()?a instanceof L.Google:!1}},LeafletProviderPlugin:{isLoaded:function(){return angular.isDefined(L.TileLayer.Provider)},is:function(a){return this.isLoaded()?a instanceof L.TileLayer.Provider:!1}},ChinaLayerPlugin:{isLoaded:function(){return angular.isDefined(L.tileLayer.chinaProvider)}},HeatLayerPlugin:{isLoaded:function(){return angular.isDefined(L.heatLayer)}},WebGLHeatMapLayerPlugin:{isLoaded:function(){return angular.isDefined(L.TileLayer.WebGLHeatMap)}},BingLayerPlugin:{isLoaded:function(){return angular.isDefined(L.BingLayer)},is:function(a){return this.isLoaded()?a instanceof L.BingLayer:!1}},WFSLayerPlugin:{isLoaded:function(){return void 0!==L.GeoJSON.WFS},is:function(a){return this.isLoaded()?a instanceof L.GeoJSON.WFS:!1}},AGSBaseLayerPlugin:{isLoaded:function(){return void 0!==L.esri&&void 0!==L.esri.basemapLayer},is:function(a){return this.isLoaded()?a instanceof L.esri.basemapLayer:!1}},AGSLayerPlugin:{isLoaded:function(){return void 0!==lvector&&void 0!==lvector.AGS},is:function(a){return this.isLoaded()?a instanceof lvector.AGS:!1}},AGSFeatureLayerPlugin:{isLoaded:function(){return void 0!==L.esri&&void 0!==L.esri.featureLayer},is:function(a){return this.isLoaded()?a instanceof L.esri.featureLayer:!1}},AGSTiledMapLayerPlugin:{isLoaded:function(){return void 0!==L.esri&&void 0!==L.esri.tiledMapLayer},is:function(a){return this.isLoaded()?a instanceof L.esri.tiledMapLayer:!1}},AGSDynamicMapLayerPlugin:{isLoaded:function(){return void 0!==L.esri&&void 0!==L.esri.dynamicMapLayer},is:function(a){return this.isLoaded()?a instanceof L.esri.dynamicMapLayer:!1}},AGSImageMapLayerPlugin:{isLoaded:function(){return void 0!==L.esri&&void 0!==L.esri.imageMapLayer},is:function(a){return this.isLoaded()?a instanceof L.esri.imageMapLayer:!1}},AGSClusteredLayerPlugin:{isLoaded:function(){return void 0!==L.esri&&void 0!==L.esri.clusteredFeatureLayer},is:function(a){return this.isLoaded()?a instanceof L.esri.clusteredFeatureLayer:!1}},AGSHeatmapLayerPlugin:{isLoaded:function(){return void 0!==L.esri&&void 0!==L.esri.heatmapFeatureLayer},is:function(a){return this.isLoaded()?a instanceof L.esri.heatmapFeatureLayer:!1}},YandexLayerPlugin:{isLoaded:function(){return angular.isDefined(L.Yandex)},is:function(a){return this.isLoaded()?a instanceof L.Yandex:!1}},GeoJSONPlugin:{isLoaded:function(){return angular.isDefined(L.TileLayer.GeoJSON)},is:function(a){return this.isLoaded()?a instanceof L.TileLayer.GeoJSON:!1}},UTFGridPlugin:{isLoaded:function(){return angular.isDefined(L.UtfGrid)},is:function(a){return this.isLoaded()?a instanceof L.UtfGrid:(b.error("[AngularJS - Leaflet] No UtfGrid plugin found."),!1)}},CartoDB:{isLoaded:function(){return cartodb},is:function(){return!0}},Leaflet:{DivIcon:{is:function(a){return a instanceof L.DivIcon},equal:function(a,b){return this.is(a)?angular.equals(a,b):!1}},Icon:{is:function(a){return a instanceof L.Icon},equal:function(a,b){return this.is(a)?angular.equals(a,b):!1}}},watchOptions:{doWatch:!0,isDeep:!0,individual:{doWatch:!0,isDeep:!0}}}}]),angular.module("ui-leaflet").service("leafletIterators",["leafletLogger","leafletHelpers",function(a,b){var c,d=b,e=b.errorHeader+"leafletIterators: ",f=Object.keys,g=d.isFunction,h=d.isObject,i=a,j=Math.pow(2,53)-1,k=function(a){var b=null!==a&&a.length;return d.isNumber(b)&&b>=0&&j>=b},l=function(a){return a},m=function(a){return function(b){return null===b?void 0:b[a]}},n=function(a,b,c){if(void 0===b)return a;switch(null===c?3:c){case 1:return function(c){return a.call(b,c)};case 2:return function(c,d){return a.call(b,c,d)};case 3:return function(c,d,e){return a.call(b,c,d,e)};case 4:return function(c,d,e,f){return a.call(b,c,d,e,f)}}return function(){return a.apply(b,arguments)}},o=function(a,b){return function(c){var d=arguments.length;if(2>d||null===c)return c;for(var e=1;d>e;e++)for(var f=arguments[e],g=a(f),h=g.length,i=0;h>i;i++){var j=g[i];b&&void 0!==c[j]||(c[j]=f[j])}return c}},p=null;c=p=o(f);var q,r=function(a,b){var c=f(b),d=c.length;if(null===a)return!d;for(var e=Object(a),g=0;d>g;g++){var h=c[g];if(b[h]!==e[h]||!(h in e))return!1}return!0},s=null;q=s=function(a){return a=c({},a),function(b){return r(b,a)}};var t,u=function(a,b,c){return null===a?l:g(a)?n(a,b,c):h(a)?q(a):m(a)},v=null;t=v=function(a,b,c){b=u(b,c);for(var d=!k(a)&&f(a),e=(d||a).length,g=0;e>g;g++){var h=d?d[g]:g;if(!b(a[h],h,a))return!1}return!0};var w=function(a,b,c,f){return c||d.isDefined(a)&&d.isDefined(b)?d.isFunction(b)?!1:(f=d.defaultTo(b,"cb"),i.error(e+f+" is not a function"),!0):!0},x=function(a,b,c){if(!w(void 0,c,!0,"internalCb")&&!w(a,b))for(var d in a)a.hasOwnProperty(d)&&c(a[d],d)},y=function(a,b){x(a,b,function(a,c){b(a,c)})};return{each:y,forEach:y,every:t,all:v}}]),angular.module("ui-leaflet").factory("leafletLayerHelpers",["$rootScope","$q","leafletLogger","leafletHelpers","leafletIterators",function($rootScope,$q,leafletLogger,leafletHelpers,leafletIterators){function isValidLayerType(a){return isString(a.type)?-1===Object.keys(layerTypes).indexOf(a.type)?($log.error("[AngularJS - Leaflet] A layer must have a valid type: "+Object.keys(layerTypes)),!1):layerTypes[a.type].mustHaveUrl&&!isString(a.url)?($log.error("[AngularJS - Leaflet] A base layer must have an url"),!1):layerTypes[a.type].mustHaveData&&!isDefined(a.data)?($log.error('[AngularJS - Leaflet] The base layer must have a "data" array attribute'),!1):layerTypes[a.type].mustHaveLayer&&!isDefined(a.layer)?($log.error("[AngularJS - Leaflet] The type of layer "+a.type+" must have an layer defined"),!1):layerTypes[a.type].mustHaveBounds&&!isDefined(a.bounds)?($log.error("[AngularJS - Leaflet] The type of layer "+a.type+" must have bounds defined"),!1):layerTypes[a.type].mustHaveKey&&!isDefined(a.key)?($log.error("[AngularJS - Leaflet] The type of layer "+a.type+" must have key defined"),!1):!0:($log.error("[AngularJS - Leaflet] A layer must have a valid type defined."),!1)}function createLayer(a){if(isValidLayerType(a)){if(!isString(a.name))return void $log.error("[AngularJS - Leaflet] A base layer must have a name");isObject(a.layerParams)||(a.layerParams={}),isObject(a.layerOptions)||(a.layerOptions={});for(var b in a.layerParams)a.layerOptions[b]=a.layerParams[b];var c={url:a.url,data:a.data,options:a.layerOptions,layer:a.layer,icon:a.icon,type:a.layerType,bounds:a.bounds,key:a.key,apiKey:a.apiKey,pluginOptions:a.pluginOptions,user:a.user};return layerTypes[a.type].createLayer(c)}}function safeAddLayer(a,b){b&&"function"==typeof b.addTo?b.addTo(a):a.addLayer(b)}function safeRemoveLayer(a,b,c){if(isDefined(c)&&isDefined(c.loadedDefer))if(angular.isFunction(c.loadedDefer)){var d=c.loadedDefer();$log.debug("Loaded Deferred",d);var e=d.length;if(e>0)for(var f=function(){e--,0===e&&a.removeLayer(b)},g=0;g<d.length;g++)d[g].promise.then(f);else a.removeLayer(b)}else c.loadedDefer.promise.then(function(){a.removeLayer(b)});else a.removeLayer(b)}var Helpers=leafletHelpers,isString=leafletHelpers.isString,isObject=leafletHelpers.isObject,isArray=leafletHelpers.isArray,isDefined=leafletHelpers.isDefined,errorHeader=leafletHelpers.errorHeader,$it=leafletIterators,$log=leafletLogger,utfGridCreateLayer=function(a){if(!Helpers.UTFGridPlugin.isLoaded())return void $log.error("[AngularJS - Leaflet] The UTFGrid plugin is not loaded.");var b=new L.UtfGrid(a.url,a.pluginOptions);return b.on("mouseover",function(a){$rootScope.$broadcast("leafletDirectiveMap.utfgridMouseover",a)}),b.on("mouseout",function(a){$rootScope.$broadcast("leafletDirectiveMap.utfgridMouseout",a)}),b.on("click",function(a){$rootScope.$broadcast("leafletDirectiveMap.utfgridClick",a)}),b.on("mousemove",function(a){$rootScope.$broadcast("leafletDirectiveMap.utfgridMousemove",a)}),b},layerTypes={xyz:{mustHaveUrl:!0,createLayer:function(a){return L.tileLayer(a.url,a.options)}},mapbox:{mustHaveKey:!0,createLayer:function(a){var b=3;isDefined(a.options.version)&&4===a.options.version&&(b=a.options.version);var c=3===b?"//{s}.tiles.mapbox.com/v3/"+a.key+"/{z}/{x}/{y}.png":"//api.tiles.mapbox.com/v4/"+a.key+"/{z}/{x}/{y}.png?access_token="+a.apiKey;return L.tileLayer(c,a.options)}},geoJSON:{mustHaveUrl:!0,createLayer:function(a){return Helpers.GeoJSONPlugin.isLoaded()?new L.TileLayer.GeoJSON(a.url,a.pluginOptions,a.options):void 0}},geoJSONShape:{mustHaveUrl:!1,createLayer:function(a){return new L.GeoJSON(a.data,a.options)}},geoJSONAwesomeMarker:{mustHaveUrl:!1,createLayer:function(a){return new L.geoJson(a.data,{pointToLayer:function(b,c){return L.marker(c,{icon:L.AwesomeMarkers.icon(a.icon)})}})}},geoJSONVectorMarker:{mustHaveUrl:!1,createLayer:function(a){return new L.geoJson(a.data,{pointToLayer:function(b,c){return L.marker(c,{icon:L.VectorMarkers.icon(a.icon)})}})}},utfGrid:{mustHaveUrl:!0,createLayer:utfGridCreateLayer},cartodbTiles:{mustHaveKey:!0,createLayer:function(a){var b="//"+a.user+".cartodb.com/api/v1/map/"+a.key+"/{z}/{x}/{y}.png";return L.tileLayer(b,a.options)}},cartodbUTFGrid:{mustHaveKey:!0,mustHaveLayer:!0,createLayer:function(a){return a.url="//"+a.user+".cartodb.com/api/v1/map/"+a.key+"/"+a.layer+"/{z}/{x}/{y}.grid.json",utfGridCreateLayer(a)}},cartodbInteractive:{mustHaveKey:!0,mustHaveLayer:!0,createLayer:function(a){var b="//"+a.user+".cartodb.com/api/v1/map/"+a.key+"/{z}/{x}/{y}.png",c=L.tileLayer(b,a.options);a.url="//"+a.user+".cartodb.com/api/v1/map/"+a.key+"/"+a.layer+"/{z}/{x}/{y}.grid.json";var d=utfGridCreateLayer(a);return L.layerGroup([c,d])}},wms:{mustHaveUrl:!0,createLayer:function(a){return L.tileLayer.wms(a.url,a.options)}},wmts:{mustHaveUrl:!0,createLayer:function(a){return L.tileLayer.wmts(a.url,a.options)}},wfs:{mustHaveUrl:!0,mustHaveLayer:!0,createLayer:function(params){if(Helpers.WFSLayerPlugin.isLoaded()){var options=angular.copy(params.options);return options.crs&&"string"==typeof options.crs&&(options.crs=eval(options.crs)),new L.GeoJSON.WFS(params.url,params.layer,options)}}},group:{mustHaveUrl:!1,createLayer:function(a){var b=[];return $it.each(a.options.layers,function(a){b.push(createLayer(a))}),a.options.loadedDefer=function(){var b=[];if(isDefined(a.options.layers))for(var c=0;c<a.options.layers.length;c++){var d=a.options.layers[c].layerOptions.loadedDefer;isDefined(d)&&b.push(d)}return b},L.layerGroup(b)}},featureGroup:{mustHaveUrl:!1,createLayer:function(){return L.featureGroup()}},google:{mustHaveUrl:!1,createLayer:function(a){var b=a.type||"SATELLITE";if(Helpers.GoogleLayerPlugin.isLoaded())return new L.Google(b,a.options)}},here:{mustHaveUrl:!1,createLayer:function(a){var b=a.provider||"HERE.terrainDay";if(Helpers.LeafletProviderPlugin.isLoaded())return new L.TileLayer.Provider(b,a.options)}},china:{mustHaveUrl:!1,createLayer:function(a){var b=a.type||"";if(Helpers.ChinaLayerPlugin.isLoaded())return L.tileLayer.chinaProvider(b,a.options)}},agsBase:{mustHaveLayer:!0,createLayer:function(a){return Helpers.AGSBaseLayerPlugin.isLoaded()?L.esri.basemapLayer(a.layer,a.options):void 0}},ags:{mustHaveUrl:!0,createLayer:function(a){if(Helpers.AGSLayerPlugin.isLoaded()){var b=angular.copy(a.options);angular.extend(b,{url:a.url});var c=new lvector.AGS(b);return c.onAdd=function(a){this.setMap(a)},c.onRemove=function(){this.setMap(null)},c}}},agsFeature:{mustHaveUrl:!0,createLayer:function(a){if(!Helpers.AGSFeatureLayerPlugin.isLoaded())return void $log.warn(errorHeader+" The esri plugin is not loaded.");a.options.url=a.url;var b=L.esri.featureLayer(a.options),c=function(){isDefined(a.options.loadedDefer)&&a.options.loadedDefer.resolve()};return b.on("loading",function(){a.options.loadedDefer=$q.defer(),b.off("load",c),b.on("load",c)}),b}},agsTiled:{mustHaveUrl:!0,createLayer:function(a){return Helpers.AGSTiledMapLayerPlugin.isLoaded()?(a.options.url=a.url,L.esri.tiledMapLayer(a.options)):void $log.warn(errorHeader+" The esri plugin is not loaded.")}},agsDynamic:{mustHaveUrl:!0,createLayer:function(a){return Helpers.AGSDynamicMapLayerPlugin.isLoaded()?(a.options.url=a.url,L.esri.dynamicMapLayer(a.options)):void $log.warn(errorHeader+" The esri plugin is not loaded.")}},agsImage:{mustHaveUrl:!0,createLayer:function(a){return Helpers.AGSImageMapLayerPlugin.isLoaded()?(a.options.url=a.url,L.esri.imageMapLayer(a.options)):void $log.warn(errorHeader+" The esri plugin is not loaded.")}},agsClustered:{mustHaveUrl:!0,createLayer:function(a){return Helpers.AGSClusteredLayerPlugin.isLoaded()?Helpers.MarkerClusterPlugin.isLoaded()?L.esri.clusteredFeatureLayer(a.url,a.options):void $log.warn(errorHeader+" The markercluster plugin is not loaded."):void $log.warn(errorHeader+" The esri clustered layer plugin is not loaded.")}},agsHeatmap:{mustHaveUrl:!0,createLayer:function(a){return Helpers.AGSHeatmapLayerPlugin.isLoaded()?Helpers.HeatLayerPlugin.isLoaded()?L.esri.heatmapFeatureLayer(a.url,a.options):void $log.warn(errorHeader+" The heatlayer plugin is not loaded."):void $log.warn(errorHeader+" The esri heatmap layer plugin is not loaded.")}},markercluster:{mustHaveUrl:!1,createLayer:function(a){return Helpers.MarkerClusterPlugin.isLoaded()?new L.MarkerClusterGroup(a.options):void $log.warn(errorHeader+" The markercluster plugin is not loaded.")}},bing:{mustHaveUrl:!1,createLayer:function(a){return Helpers.BingLayerPlugin.isLoaded()?new L.BingLayer(a.key,a.options):void 0}},webGLHeatmap:{mustHaveUrl:!1,mustHaveData:!0,createLayer:function(a){if(Helpers.WebGLHeatMapLayerPlugin.isLoaded()){var b=new L.TileLayer.WebGLHeatMap(a.options);return isDefined(a.data)&&b.setData(a.data),b}}},heat:{mustHaveUrl:!1,mustHaveData:!0,createLayer:function(a){if(Helpers.HeatLayerPlugin.isLoaded()){var b=new L.heatLayer;return isArray(a.data)&&b.setLatLngs(a.data),isObject(a.options)&&b.setOptions(a.options),b}}},yandex:{mustHaveUrl:!1,createLayer:function(a){var b=a.type||"map";if(Helpers.YandexLayerPlugin.isLoaded())return new L.Yandex(b,a.options)}},imageOverlay:{mustHaveUrl:!0,mustHaveBounds:!0,createLayer:function(a){return L.imageOverlay(a.url,a.bounds,a.options)}},iip:{mustHaveUrl:!0,createLayer:function(a){return L.tileLayer.iip(a.url,a.options)}},custom:{createLayer:function(a){return a.layer instanceof L.Class?angular.copy(a.layer):void $log.error("[AngularJS - Leaflet] A custom layer must be a leaflet Class")}},cartodb:{mustHaveUrl:!0,createLayer:function(a){return cartodb.createLayer(a.map,a.url)}}};return{createLayer:createLayer,safeAddLayer:safeAddLayer,safeRemoveLayer:safeRemoveLayer}}]),angular.module("ui-leaflet").factory("leafletLegendHelpers",["$http","$q","$log","leafletHelpers",function(a,b,c,d){var e={},f=d.isDefined,g=function(b){var c=e[b],d=c[0];a(d.c).then(function(a){c.shift(),d.d.resolve(a),c.length>0&&g(b)},function(a){c.shift(),d.d.reject(a),c.length>0&&g(b)})},h=function(a,b,c,d){if(a.innerHTML="",b.error)a.innerHTML+='<div class="info-title alert alert-danger">'+b.error.message+"</div>";else if("arcgis"===c)for(var e=0;e<b.layers.length;e++){var f=b.layers[e];a.innerHTML+='<div class="info-title" data-layerid="'+f.layerId+'">'+f.layerName+"</div>";for(var g=0;g<f.legend.length;g++){var h=f.legend[g];a.innerHTML+='<div class="inline" data-layerid="'+f.layerId+'"><img src="data:'+h.contentType+";base64,"+h.imageData+'" /></div><div class="info-label" data-layerid="'+f.layerId+'">'+h.label+"</div>"}}else"image"===c&&(a.innerHTML='<img src="'+d+'"/>')},i=function(a,b,c,d){return function(){var e=L.DomUtil.create("div",b);return L.Browser.touch?L.DomEvent.on(e,"click",L.DomEvent.stopPropagation):(L.DomEvent.disableClickPropagation(e),L.DomEvent.on(e,"mousewheel",L.DomEvent.stopPropagation)),h(e,a,c,d),e}},j=function(a,b){return function(){for(var c=L.DomUtil.create("div",b),d=0;d<a.colors.length;d++)c.innerHTML+='<div class="outline"><i style="background:'+a.colors[d]+'"></i></div><div class="info-label">'+a.labels[d]+"</div>";return L.Browser.touch?L.DomEvent.on(c,"click",L.DomEvent.stopPropagation):(L.DomEvent.disableClickPropagation(c),L.DomEvent.on(c,"mousewheel",L.DomEvent.stopPropagation)),c}};return{getOnAddLegend:i,getOnAddArrayLegend:j,updateLegend:h,addLegendURL:function(a,c){var d=b.defer();return f(e[a])||(e[a]=[]),e[a].push({c:c,d:d}),1===e[a].length&&g(a),d.promise}}}]),angular.module("ui-leaflet").factory("leafletMapDefaults",["$q","leafletHelpers",function(a,b){function c(){return{keyboard:!0,dragging:!0,worldCopyJump:!1,doubleClickZoom:!0,scrollWheelZoom:!0,tap:!0,touchZoom:!0,zoomControl:!0,zoomsliderControl:!1,zoomControlPosition:"topleft",attributionControl:!0,controls:{layers:{visible:!0,position:"topright",collapsed:!0}},nominatim:{server:" http://nominatim.openstreetmap.org/search"},crs:L.CRS.EPSG3857,tileLayer:"//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",tileLayerOptions:{attribution:'&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'},path:{weight:10,opacity:1,color:"#0000ff"},center:{lat:0,lng:0,zoom:1}}}var d=b.isDefined,e=b.isObject,f=b.obtainEffectiveMapId,g={};return{reset:function(){g={}},getDefaults:function(a){var b=f(g,a);return g[b]},getMapCreationDefaults:function(a){var b=f(g,a),c=g[b],e={maxZoom:c.maxZoom,keyboard:c.keyboard,dragging:c.dragging,zoomControl:c.zoomControl,doubleClickZoom:c.doubleClickZoom,scrollWheelZoom:c.scrollWheelZoom,tap:c.tap,touchZoom:c.touchZoom,attributionControl:c.attributionControl,worldCopyJump:c.worldCopyJump,crs:c.crs};if(d(c.minZoom)&&(e.minZoom=c.minZoom),d(c.zoomAnimation)&&(e.zoomAnimation=c.zoomAnimation),d(c.fadeAnimation)&&(e.fadeAnimation=c.fadeAnimation),d(c.markerZoomAnimation)&&(e.markerZoomAnimation=c.markerZoomAnimation),c.map)for(var h in c.map)e[h]=c.map[h];return e},setDefaults:function(a,b){var h=c();d(a)&&(h.doubleClickZoom=d(a.doubleClickZoom)?a.doubleClickZoom:h.doubleClickZoom,h.scrollWheelZoom=d(a.scrollWheelZoom)?a.scrollWheelZoom:h.doubleClickZoom,h.tap=d(a.tap)?a.tap:h.tap,h.touchZoom=d(a.touchZoom)?a.touchZoom:h.doubleClickZoom,h.zoomControl=d(a.zoomControl)?a.zoomControl:h.zoomControl,h.zoomsliderControl=d(a.zoomsliderControl)?a.zoomsliderControl:h.zoomsliderControl,h.attributionControl=d(a.attributionControl)?a.attributionControl:h.attributionControl,h.tileLayer=d(a.tileLayer)?a.tileLayer:h.tileLayer,h.zoomControlPosition=d(a.zoomControlPosition)?a.zoomControlPosition:h.zoomControlPosition,h.keyboard=d(a.keyboard)?a.keyboard:h.keyboard,h.dragging=d(a.dragging)?a.dragging:h.dragging,d(a.controls)&&angular.extend(h.controls,a.controls),e(a.crs)?h.crs=a.crs:d(L.CRS[a.crs])&&(h.crs=L.CRS[a.crs]),d(a.center)&&angular.copy(a.center,h.center),d(a.tileLayerOptions)&&angular.copy(a.tileLayerOptions,h.tileLayerOptions),d(a.maxZoom)&&(h.maxZoom=a.maxZoom),d(a.minZoom)&&(h.minZoom=a.minZoom),d(a.zoomAnimation)&&(h.zoomAnimation=a.zoomAnimation),d(a.fadeAnimation)&&(h.fadeAnimation=a.fadeAnimation),d(a.markerZoomAnimation)&&(h.markerZoomAnimation=a.markerZoomAnimation),
d(a.worldCopyJump)&&(h.worldCopyJump=a.worldCopyJump),d(a.map)&&(h.map=a.map),d(a.path)&&(h.path=a.path));var i=f(g,b);return g[i]=h,h}}}]),angular.module("ui-leaflet").service("leafletMarkersHelpers",["$rootScope","$timeout","leafletHelpers","leafletLogger","$compile","leafletGeoJsonHelpers",function(a,b,c,d,e,f){var g=c.isDefined,h=c.defaultTo,i=c.MarkerClusterPlugin,j=c.AwesomeMarkersPlugin,k=c.VectorMarkersPlugin,l=c.MakiMarkersPlugin,m=c.ExtraMarkersPlugin,n=c.DomMarkersPlugin,o=c.safeApply,p=c,q=c.isString,r=c.isNumber,s=c.isObject,t={},u=f,v=c.errorHeader,w=d,x=function(a){var b="";return["_icon","_latlng","_leaflet_id","_map","_shadow"].forEach(function(c){b+=c+": "+h(a[c],"undefined")+" \n"}),"[leafletMarker] : \n"+b},y=function(a,b){var c=b?console:w;c.debug(x(a))},z=function(b){if(g(b)&&g(b.type)&&"awesomeMarker"===b.type)return j.isLoaded()||w.error(v+" The AwesomeMarkers Plugin is not loaded."),new L.AwesomeMarkers.icon(b);if(g(b)&&g(b.type)&&"vectorMarker"===b.type)return k.isLoaded()||w.error(v+" The VectorMarkers Plugin is not loaded."),new L.VectorMarkers.icon(b);if(g(b)&&g(b.type)&&"makiMarker"===b.type)return l.isLoaded()||w.error(v+"The MakiMarkers Plugin is not loaded."),new L.MakiMarkers.icon(b);if(g(b)&&g(b.type)&&"extraMarker"===b.type)return m.isLoaded()||w.error(v+"The ExtraMarkers Plugin is not loaded."),new L.ExtraMarkers.icon(b);if(g(b)&&g(b.type)&&"div"===b.type)return new L.divIcon(b);if(g(b)&&g(b.type)&&"dom"===b.type){n.isLoaded()||w.error(v+"The DomMarkers Plugin is not loaded.");var c=angular.isFunction(b.getMarkerScope)?b.getMarkerScope():a,d=e(b.template)(c),f=angular.copy(b);return f.element=d[0],new L.DomMarkers.icon(f)}if(g(b)&&g(b.type)&&"icon"===b.type)return b.icon;var h="data:image/png;base64,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",i="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAYAAACoYAD2AAAC5ElEQVRYw+2YW4/TMBCF45S0S1luXZCABy5CgLQgwf//S4BYBLTdJLax0fFqmB07nnQfEGqkIydpVH85M+NLjPe++dcPc4Q8Qh4hj5D/AaQJx6H/4TMwB0PeBNwU7EGQAmAtsNfAzoZkgIa0ZgLMa4Aj6CxIAsjhjOCoL5z7Glg1JAOkaicgvQBXuncwJAWjksLtBTWZe04CnYRktUGdilALppZBOgHGZcBzL6OClABvMSVIzyBjazOgrvACf1ydC5mguqAVg6RhdkSWQFj2uxfaq/BrIZOLEWgZdALIDvcMcZLD8ZbLC9de4yR1sYMi4G20S4Q/PWeJYxTOZn5zJXANZHIxAd4JWhPIloTJZhzMQduM89WQ3MUVAE/RnhAXpTycqys3NZALOBbB7kFrgLesQl2h45Fcj8L1tTSohUwuxhy8H/Qg6K7gIs+3kkaigQCOcyEXCHN07wyQazhrmIulvKMQAwMcmLNqyCVyMAI+BuxSMeTk3OPikLY2J1uE+VHQk6ANrhds+tNARqBeaGc72cK550FP4WhXmFmcMGhTwAR1ifOe3EvPqIegFmF+C8gVy0OfAaWQPMR7gF1OQKqGoBjq90HPMP01BUjPOqGFksC4emE48tWQAH0YmvOgF3DST6xieJgHAWxPAHMuNhrImIdvoNOKNWIOcE+UXE0pYAnkX6uhWsgVXDxHdTfCmrEEmMB2zMFimLVOtiiajxiGWrbU52EeCdyOwPEQD8LqyPH9Ti2kgYMf4OhSKB7qYILbBv3CuVTJ11Y80oaseiMWOONc/Y7kJYe0xL2f0BaiFTxknHO5HaMGMublKwxFGzYdWsBF174H/QDknhTHmHHN39iWFnkZx8lPyM8WHfYELmlLKtgWNmFNzQcC1b47gJ4hL19i7o65dhH0Negbca8vONZoP7doIeOC9zXm8RjuL0Gf4d4OYaU5ljo3GYiqzrWQHfJxA6ALhDpVKv9qYeZA8eM3EhfPSCmpuD0AAAAASUVORK5CYII=";return g(b)&&g(b.iconUrl)?new L.Icon(b):new L.Icon.Default({iconUrl:h,shadowUrl:i,iconSize:[25,41],iconAnchor:[12,41],popupAnchor:[1,-34],shadowSize:[41,41]})},A=function(a){g(t[a])&&t.splice(a,1)},B=function(){t={}},C=function(a,b,c){if(a.closePopup(),g(c)&&g(c.overlays))for(var d in c.overlays)if((c.overlays[d]instanceof L.LayerGroup||c.overlays[d]instanceof L.FeatureGroup)&&c.overlays[d].hasLayer(a))return void c.overlays[d].removeLayer(a);if(g(t))for(var e in t)t[e].hasLayer(a)&&t[e].removeLayer(a);b.hasLayer(a)&&b.removeLayer(a)},D=function(a,b){var c=a._popup._container.offsetHeight,d=new L.Point(a._popup._containerLeft,-c-a._popup._containerBottom),e=b.layerPointToContainerPoint(d);null!==e&&a._popup._adjustPan()},E=function(a,b){e(a._popup._contentNode)(b)},F=function(a,c,d){var e=a._popup._contentNode.innerText||a._popup._contentNode.textContent;e.length<1&&b(function(){F(a,c,d)});var f=a._popup._contentNode.offsetWidth;return a._popup._updateLayout(),a._popup._updatePosition(),a._popup.options.autoPan&&D(a,d),f},G=function(b,c,d){var e=angular.isFunction(c.getMessageScope)?c.getMessageScope():a,f=g(c.compileMessage)?c.compileMessage:!0;if(f){if(!g(b._popup)||!g(b._popup._contentNode))return w.error(v+"Popup is invalid or does not have any content."),!1;E(b,e),F(b,c,d)}},H=function(b,c){var d=angular.isFunction(c.getMessageScope)?c.getMessageScope():a,f=angular.isFunction(c.getLabelScope)?c.getLabelScope():d,h=g(c.compileMessage)?c.compileMessage:!0;p.LabelPlugin.isLoaded()&&g(c.label)&&(g(c.label.options)&&c.label.options.noHide===!0&&b.showLabel(),h&&g(b.label)&&e(b.label._container)(f))},I=function(a,b,c,d,e,f,h){if(g(b)){if(!u.validateCoords(a))return w.warn("There are problems with lat-lng data, please verify your marker model"),void C(c,h,f);var i=a===b;if(g(a.iconAngle)&&b.iconAngle!==a.iconAngle&&c.setIconAngle(a.iconAngle),q(a.layer)||q(b.layer)&&(g(f.overlays[b.layer])&&f.overlays[b.layer].hasLayer(c)&&(f.overlays[b.layer].removeLayer(c),c.closePopup()),h.hasLayer(c)||h.addLayer(c)),(r(a.opacity)||r(parseFloat(a.opacity)))&&a.opacity!==b.opacity&&c.setOpacity(a.opacity),q(a.layer)&&b.layer!==a.layer){if(q(b.layer)&&g(f.overlays[b.layer])&&f.overlays[b.layer].hasLayer(c)&&f.overlays[b.layer].removeLayer(c),c.closePopup(),h.hasLayer(c)&&h.removeLayer(c),!g(f.overlays[a.layer]))return void w.error(v+"You must use a name of an existing layer");var j=f.overlays[a.layer];if(!(j instanceof L.LayerGroup||j instanceof L.FeatureGroup))return void w.error(v+'A marker can only be added to a layer of type "group" or "featureGroup"');j.addLayer(c),h.hasLayer(c)&&a.focus===!0&&c.openPopup()}if(a.draggable!==!0&&b.draggable===!0&&g(c.dragging)&&c.dragging.disable(),a.draggable===!0&&b.draggable!==!0&&(c.dragging?c.dragging.enable():L.Handler.MarkerDrag&&(c.dragging=new L.Handler.MarkerDrag(c),c.options.draggable=!0,c.dragging.enable())),s(a.icon)||s(b.icon)&&(c.setIcon(z()),c.closePopup(),c.unbindPopup(),q(a.message)&&c.bindPopup(a.message,a.popupOptions)),s(a.icon)&&s(b.icon)&&!angular.equals(a.icon,b.icon)){var k=!1;c.dragging&&(k=c.dragging.enabled()),c.setIcon(z(a.icon)),k&&c.dragging.enable(),c.closePopup(),c.unbindPopup(),q(a.message)&&(c.bindPopup(a.message,a.popupOptions),h.hasLayer(c)&&a.focus===!0&&c.openPopup())}!q(a.message)&&q(b.message)&&(c.closePopup(),c.unbindPopup()),p.LabelPlugin.isLoaded()&&(g(a.label)&&g(a.label.message)?"label"in b&&"message"in b.label&&!angular.equals(a.label.message,b.label.message)?c.updateLabelContent(a.label.message):!angular.isFunction(c.getLabel)||angular.isFunction(c.getLabel)&&!g(c.getLabel())?(c.bindLabel(a.label.message,a.label.options),H(c,a)):H(c,a):(!("label"in a)||"message"in a.label)&&angular.isFunction(c.unbindLabel)&&c.unbindLabel()),q(a.message)&&!q(b.message)&&c.bindPopup(a.message,a.popupOptions),q(a.message)&&q(b.message)&&a.message!==b.message&&c.setPopupContent(a.message);var l=!1;a.focus!==!0&&b.focus===!0&&(c.closePopup(),l=!0),(a.focus===!0&&(!g(b.focus)||b.focus===!1)||i&&a.focus===!0)&&(c.openPopup(),l=!0),b.zIndexOffset!==a.zIndexOffset&&c.setZIndexOffset(a.zIndexOffset);var m=c.getLatLng(),n=q(a.layer)&&p.MarkerClusterPlugin.is(f.overlays[a.layer]);n?l?(a.lat!==b.lat||a.lng!==b.lng)&&(f.overlays[a.layer].removeLayer(c),c.setLatLng([a.lat,a.lng]),f.overlays[a.layer].addLayer(c)):m.lat!==a.lat||m.lng!==a.lng?(f.overlays[a.layer].removeLayer(c),c.setLatLng([a.lat,a.lng]),f.overlays[a.layer].addLayer(c)):a.lat!==b.lat||a.lng!==b.lng?(f.overlays[a.layer].removeLayer(c),c.setLatLng([a.lat,a.lng]),f.overlays[a.layer].addLayer(c)):s(a.icon)&&s(b.icon)&&!angular.equals(a.icon,b.icon)&&(f.overlays[a.layer].removeLayer(c),f.overlays[a.layer].addLayer(c)):(m.lat!==a.lat||m.lng!==a.lng)&&c.setLatLng([a.lat,a.lng])}},J=function(a,b){return g(a)?b?a[b]:a:void 0},K=function(a,b,c){return g(a)?b?c?a[c][b]:a[b]:void w.error(v+"marker id missing in getMarker"):void 0};return{resetMarkerGroup:A,resetMarkerGroups:B,deleteMarker:C,manageOpenPopup:G,manageOpenLabel:H,createMarker:function(a){if(!g(a)||!u.validateCoords(a))return void w.error(v+"The marker definition is not valid.");var b=u.getCoords(a);if(!g(b))return void w.error(v+"Unable to get coordinates from markerData.");var c={icon:z(a.icon),title:g(a.title)?a.title:"",draggable:g(a.draggable)?a.draggable:!1,clickable:g(a.clickable)?a.clickable:!0,riseOnHover:g(a.riseOnHover)?a.riseOnHover:!1,zIndexOffset:g(a.zIndexOffset)?a.zIndexOffset:0,iconAngle:g(a.iconAngle)?a.iconAngle:0};for(var d in a)a.hasOwnProperty(d)&&!c.hasOwnProperty(d)&&(c[d]=a[d]);var e=new L.marker(b,c);return q(a.message)||e.unbindPopup(),e},addMarkerToGroup:function(a,b,c,d){return q(b)?i.isLoaded()?(g(t[b])||(t[b]=new L.MarkerClusterGroup(c),d.addLayer(t[b])),void t[b].addLayer(a)):void w.error(v+"The MarkerCluster plugin is not loaded."):void w.error(v+"The marker group you have specified is invalid.")},listenMarkerEvents:function(a,b,c,d,e){a.on("popupopen",function(){o(c,function(){(g(a._popup)||g(a._popup._contentNode))&&(b.focus=!0,G(a,b,e))})}),a.on("popupclose",function(){o(c,function(){b.focus=!1})}),a.on("add",function(){o(c,function(){"label"in b&&H(a,b)})})},updateMarker:I,addMarkerWatcher:function(a,b,c,d,e,f){var i=p.getObjectArrayPath("markers."+b);f=h(f,!0);var j=c.$watch(i,function(f,h){return g(f)?void I(f,h,a,b,c,d,e):(C(a,e,d),void j())},f)},string:x,log:y,getModelFromModels:K,getLayerModels:J}}]),angular.module("ui-leaflet").factory("leafletPathsHelpers",["$rootScope","leafletLogger","leafletHelpers",function(a,b,c){function d(a){return a.filter(function(a){return k(a)}).map(function(a){return e(a)})}function e(a){return i(a)?new L.LatLng(a[0],a[1]):new L.LatLng(a.lat,a.lng)}function f(a){return a.map(function(a){return d(a)})}function g(a,b){for(var c={},d=0;d<m.length;d++){var e=m[d];h(a[e])?c[e]=a[e]:h(b.path[e])&&(c[e]=b.path[e])}return c}var h=c.isDefined,i=c.isArray,j=c.isNumber,k=c.isValidPoint,l=b,m=["stroke","weight","color","opacity","fill","fillColor","fillOpacity","dashArray","lineCap","lineJoin","clickable","pointerEvents","className","smoothFactor","noClip"],n=function(a,b){for(var c={},d=0;d<m.length;d++){var e=m[d];h(b[e])&&(c[e]=b[e])}a.setStyle(b)},o=function(a){if(!i(a))return!1;for(var b=0;b<a.length;b++){var c=a[b];if(!k(c))return!1}return!0},p={polyline:{isValid:function(a){var b=a.latlngs;return o(b)},createPath:function(a){return new L.Polyline([],a)},setPath:function(a,b){a.setLatLngs(d(b.latlngs)),n(a,b)}},multiPolyline:{isValid:function(a){var b=a.latlngs;if(!i(b))return!1;for(var c in b){var d=b[c];if(!o(d))return!1}return!0},createPath:function(a){return new L.multiPolyline([[[0,0],[1,1]]],a)},setPath:function(a,b){a.setLatLngs(f(b.latlngs)),n(a,b)}},polygon:{isValid:function(a){var b=a.latlngs;return o(b)},createPath:function(a){return new L.Polygon([],a)},setPath:function(a,b){a.setLatLngs(d(b.latlngs)),n(a,b)}},multiPolygon:{isValid:function(a){var b=a.latlngs;if(!i(b))return!1;for(var c in b){var d=b[c];if(!o(d))return!1}return!0},createPath:function(a){return new L.MultiPolygon([[[0,0],[1,1],[0,1]]],a)},setPath:function(a,b){a.setLatLngs(f(b.latlngs)),n(a,b)}},rectangle:{isValid:function(a){var b=a.latlngs;if(!i(b)||2!==b.length)return!1;for(var c in b){var d=b[c];if(!k(d))return!1}return!0},createPath:function(a){return new L.Rectangle([[0,0],[1,1]],a)},setPath:function(a,b){a.setBounds(new L.LatLngBounds(d(b.latlngs))),n(a,b)}},circle:{isValid:function(a){var b=a.latlngs;return k(b)&&j(a.radius)},createPath:function(a){return new L.Circle([0,0],1,a)},setPath:function(a,b){a.setLatLng(e(b.latlngs)),h(b.radius)&&a.setRadius(b.radius),n(a,b)}},circleMarker:{isValid:function(a){var b=a.latlngs;return k(b)&&j(a.radius)},createPath:function(a){return new L.CircleMarker([0,0],a)},setPath:function(a,b){a.setLatLng(e(b.latlngs)),h(b.radius)&&a.setRadius(b.radius),n(a,b)}}},q=function(a){var b={};return a.latlngs&&(b.latlngs=a.latlngs),a.radius&&(b.radius=a.radius),b};return{setPathOptions:function(a,b,c){h(b)||(b="polyline"),p[b].setPath(a,c)},createPath:function(a,b,c){h(b.type)||(b.type="polyline");var d=g(b,c),e=q(b);return p[b.type].isValid(e)?p[b.type].createPath(d):void l.error("[AngularJS - Leaflet] Invalid data passed to the "+b.type+" path")}}}]),angular.module("ui-leaflet").service("leafletWatchHelpers",function(){var a=function(a,b,c,d,e){var f=a[b](c,function(a,b){e(a,b),d.doWatch||f()},d.isDeep);return f},b=function(b,c,d,e){return a(b,"$watch",c,d,e)},c=function(b,c,d,e){return a(b,"$watchCollection",c,d,e)};return{maybeWatch:b,maybeWatchCollection:c}}),angular.module("ui-leaflet").service("leafletLogger",["nemSimpleLogger",function(a){return a.spawn()}]),angular.module("ui-leaflet").factory("nominatimService",["$q","$http","leafletHelpers","leafletMapDefaults",function(a,b,c,d){var e=c.isDefined;return{query:function(c,f){var g=d.getDefaults(f),h=g.nominatim.server,i=a.defer();return b.get(h,{params:{format:"json",limit:1,q:c}}).success(function(a){a.length>0&&e(a[0].boundingbox)?i.resolve(a[0]):i.reject("[Nominatim] Invalid address")}),i.promise}}}]),angular.module("ui-leaflet").directive("bounds",["leafletLogger","$timeout","$http","leafletHelpers","nominatimService","leafletBoundsHelpers",function(a,b,c,d,e,f){var g=a;return{restrict:"A",scope:!1,replace:!1,require:["leaflet"],link:function(a,c,h,i){var j=d.isDefined,k=f.createLeafletBounds,l=i[0].getLeafletScope(),m=i[0],n=d.errorHeader+" [Bounds] ",o=function(a){return 0===a._southWest.lat&&0===a._southWest.lng&&0===a._northEast.lat&&0===a._northEast.lng};m.getMap().then(function(c){l.$on("boundsChanged",function(a){var d=a.currentScope,e=c.getBounds();if(!o(e)&&!d.settingBoundsFromScope){d.settingBoundsFromLeaflet=!0;var f={northEast:{lat:e._northEast.lat,lng:e._northEast.lng},southWest:{lat:e._southWest.lat,lng:e._southWest.lng},options:e.options};angular.equals(d.bounds,f)||(d.bounds=f),b(function(){d.settingBoundsFromLeaflet=!1})}});var d;l.$watch("bounds",function(f){if(!a.settingBoundsFromLeaflet){if(j(f.address)&&f.address!==d)return a.settingBoundsFromScope=!0,e.query(f.address,h.id).then(function(a){var b=a.boundingbox,d=[[b[0],b[2]],[b[1],b[3]]];c.fitBounds(d)},function(a){g.error(n+" "+a+".")}),d=f.address,void b(function(){a.settingBoundsFromScope=!1});var i=k(f);i&&!c.getBounds().equals(i)&&(a.settingBoundsFromScope=!0,c.fitBounds(i,f.options),b(function(){a.settingBoundsFromScope=!1}))}},!0)})}}}]);var centerDirectiveTypes=["center","lfCenter"],centerDirectives={};centerDirectiveTypes.forEach(function(a){centerDirectives[a]=["leafletLogger","$q","$location","$timeout","leafletMapDefaults","leafletHelpers","leafletBoundsHelpers","leafletMapEvents",function(b,c,d,e,f,g,h,i){var j,k=g.isDefined,l=g.isNumber,m=g.isSameCenterOnMap,n=g.safeApply,o=g.isValidCenter,p=h.isValidBounds,q=g.isUndefinedOrEmpty,r=g.errorHeader,s=b,t=function(a,b){return k(a)&&p(a)&&q(b)};return{restrict:"A",scope:!1,replace:!1,require:"leaflet",controller:function(){j=c.defer(),this.getCenter=function(){return j.promise}},link:function(b,c,g,p){var q=p.getLeafletScope(),u=q[a];p.getMap().then(function(b){var c=f.getDefaults(g.id);if(-1!==g[a].search("-"))return s.error(r+' The "center" variable can\'t use a "-" on its key name: "'+g[a]+'".'),void b.setView([c.center.lat,c.center.lng],c.center.zoom);if(t(q.bounds,u))b.fitBounds(h.createLeafletBounds(q.bounds),q.bounds.options),u=b.getCenter(),n(q,function(c){angular.extend(c[a],{lat:b.getCenter().lat,lng:b.getCenter().lng,zoom:b.getZoom(),autoDiscover:!1})}),n(q,function(a){var c=b.getBounds();a.bounds={northEast:{lat:c._northEast.lat,lng:c._northEast.lng},southWest:{lat:c._southWest.lat,lng:c._southWest.lng}}});else{if(!k(u))return s.error(r+' The "center" property is not defined in the main scope'),void b.setView([c.center.lat,c.center.lng],c.center.zoom);k(u.lat)&&k(u.lng)||k(u.autoDiscover)||angular.copy(c.center,u)}var p,v;if("yes"===g.urlHashCenter){var w=function(){var a,b=d.search();if(k(b.c)){var c=b.c.split(":");3===c.length&&(a={lat:parseFloat(c[0]),lng:parseFloat(c[1]),zoom:parseInt(c[2],10)})}return a};p=w(),q.$on("$locationChangeSuccess",function(c){var d=c.currentScope,e=w();k(e)&&!m(e,b)&&angular.extend(d[a],{lat:e.lat,lng:e.lng,zoom:e.zoom})})}q.$watch(a,function(a){return q.settingCenterFromLeaflet?void 0:(k(p)&&(angular.copy(p,a),p=void 0),o(a)||a.autoDiscover===!0?a.autoDiscover===!0?(l(a.zoom)||b.setView([c.center.lat,c.center.lng],c.center.zoom),void(l(a.zoom)&&a.zoom>c.center.zoom?b.locate({setView:!0,maxZoom:a.zoom}):k(c.maxZoom)?b.locate({setView:!0,maxZoom:c.maxZoom}):b.locate({setView:!0}))):void(v&&m(a,b)||(q.settingCenterFromScope=!0,b.setView([a.lat,a.lng],a.zoom),i.notifyCenterChangedToBounds(q,b),e(function(){q.settingCenterFromScope=!1}))):void s.warn(r+" invalid 'center'"))},!0),b.whenReady(function(){v=!0}),b.on("moveend",function(){j.resolve(),i.notifyCenterUrlHashChanged(q,b,g,d.search()),m(u,b)||q.settingCenterFromScope||(q.settingCenterFromLeaflet=!0,n(q,function(c){q.settingCenterFromScope||angular.extend(c[a],{lat:b.getCenter().lat,lng:b.getCenter().lng,zoom:b.getZoom(),autoDiscover:!1}),i.notifyCenterChangedToBounds(q,b),e(function(){q.settingCenterFromLeaflet=!1})}))}),u.autoDiscover===!0&&b.on("locationerror",function(){s.warn(r+" The Geolocation API is unauthorized on this page."),o(u)?(b.setView([u.lat,u.lng],u.zoom),i.notifyCenterChangedToBounds(q,b)):(b.setView([c.center.lat,c.center.lng],c.center.zoom),i.notifyCenterChangedToBounds(q,b))})})}}}]}),centerDirectiveTypes.forEach(function(a){angular.module("ui-leaflet").directive(a,centerDirectives[a])}),angular.module("ui-leaflet").directive("controls",["leafletLogger","leafletHelpers","leafletControlHelpers",function(a,b,c){var d=a;return{restrict:"A",scope:!1,replace:!1,require:"?^leaflet",link:function(a,e,f,g){if(g){var h=c.createControl,i=c.isValidControlType,j=g.getLeafletScope(),k=b.isDefined,l=b.isArray,m={},n=b.errorHeader+" [Controls] ";g.getMap().then(function(a){j.$watchCollection("controls",function(b){for(var c in m)k(b[c])||(a.hasControl(m[c])&&a.removeControl(m[c]),delete m[c]);for(var e in b){var f,g=k(b[e].type)?b[e].type:e;if(!i(g))return void d.error(n+" Invalid control type: "+g+".");if("custom"!==g)f=h(g,b[e]),a.addControl(f),m[e]=f;else{var j=b[e];if(l(j))for(var o in j){var p=j[o];a.addControl(p),m[e]=k(m[e])?m[e].concat([p]):[p]}else a.addControl(j),m[e]=j}}})})}}}}]),angular.module("ui-leaflet").directive("decorations",["leafletLogger","leafletHelpers",function(a,b){var c=a;return{restrict:"A",scope:!1,replace:!1,require:"leaflet",link:function(a,d,e,f){function g(a){return k(a)&&k(a.coordinates)&&(j.isLoaded()||c.error("[AngularJS - Leaflet] The PolylineDecorator Plugin is not loaded.")),L.polylineDecorator(a.coordinates)}function h(a,b){return k(a)&&k(b)&&k(b.coordinates)&&k(b.patterns)?(a.setPaths(b.coordinates),a.setPatterns(b.patterns),a):void 0}var i=f.getLeafletScope(),j=b.PolylineDecoratorPlugin,k=b.isDefined,l={};f.getMap().then(function(a){i.$watch("decorations",function(b){for(var c in l)k(b[c])&&angular.equals(b[c],l)||(a.removeLayer(l[c]),delete l[c]);for(var d in b){var e=b[d],f=g(e);k(f)&&(l[d]=f,a.addLayer(f),h(f,e))}},!0)})}}}]),angular.module("ui-leaflet").directive("eventBroadcast",["leafletLogger","$rootScope","leafletHelpers","leafletMapEvents","leafletIterators",function(a,b,c,d,e){var f=a;return{restrict:"A",scope:!1,replace:!1,require:"leaflet",link:function(a,b,g,h){var i=c.isObject,j=c.isDefined,k=h.getLeafletScope(),l=k.eventBroadcast,m=d.getAvailableMapEvents(),n=d.addEvents;h.getMap().then(function(a){var b=[],c="broadcast";j(l.map)?i(l.map)?("emit"!==l.map.logic&&"broadcast"!==l.map.logic?f.warn("[AngularJS - Leaflet] Available event propagation logic are: 'emit' or 'broadcast'."):c=l.map.logic,i(l.map.enable)&&l.map.enable.length>=0?e.each(l.map.enable,function(a){-1===b.indexOf(a)&&-1!==m.indexOf(a)&&b.push(a)}):f.warn("[AngularJS - Leaflet] event-broadcast.map.enable must be an object check your model.")):f.warn("[AngularJS - Leaflet] event-broadcast.map must be an object check your model."):b=m,n(a,b,"eventName",k,c)})}}}]),angular.module("ui-leaflet").directive("geojson",["leafletLogger","$rootScope","leafletData","leafletHelpers","leafletWatchHelpers","leafletDirectiveControlsHelpers","leafletIterators","leafletGeoJsonEvents",function(a,b,c,d,e,f,g,h){var i=e.maybeWatch,j=d.watchOptions,k=f.extend,l=d,m=g;return{restrict:"A",scope:!1,replace:!1,require:"leaflet",link:function(a,b,e,f){var g=d.isDefined,n=f.getLeafletScope(),o={},p=!1;f.getMap().then(function(a){var b=n.geojsonWatchOptions||j,f=function(a,b){var c;return c=angular.isFunction(a.onEachFeature)?a.onEachFeature:function(c,f){d.LabelPlugin.isLoaded()&&g(c.properties.description)&&f.bindLabel(c.properties.description),h.bindEvents(e.id,f,null,c,n,b,{resetStyleOnMouseout:a.resetStyleOnMouseout,mapId:e.id})}},q=l.isDefined(e.geojsonNested)&&l.isTruthy(e.geojsonNested),r=function(){if(o){var b=function(b){g(b)&&a.hasLayer(b)&&a.removeLayer(b)};return q?void m.each(o,function(a){b(a)}):void b(o)}},s=function(b,d){var h=angular.copy(b);if(g(h)&&g(h.data)){var i=f(h,d);g(h.options)||(h.options={style:h.style,filter:h.filter,onEachFeature:i,pointToLayer:h.pointToLayer});var j=L.geoJson(h.data,h.options);d&&l.isString(d)?o[d]=j:o=j,j.addTo(a),p||(p=!0,c.setGeoJSON(o,e.id))}},t=function(a){if(r(),q){if(!a||!Object.keys(a).length)return;return void m.each(a,function(a,b){s(a,b)})}s(a)};k(e.id,"geojson",t,r),i(n,"geojson",b,function(a){t(a)})})}}}]),angular.module("ui-leaflet").directive("layercontrol",["$filter","leafletLogger","leafletData","leafletHelpers",function(a,b,c,d){var e=b;return{restrict:"E",scope:{icons:"=?",autoHideOpacity:"=?",showGroups:"=?",title:"@",baseTitle:"@",overlaysTitle:"@"},replace:!0,transclude:!1,require:"^leaflet",controller:["$scope","$element","$sce",function(a,b,f){e.debug("[Angular Directive - Layers] layers",a,b);var g=d.safeApply,h=d.isDefined;angular.extend(a,{baselayer:"",oldGroup:"",layerProperties:{},groupProperties:{},rangeIsSupported:d.rangeIsSupported(),changeBaseLayer:function(b,e){d.safeApply(a,function(d){d.baselayer=b,c.getMap().then(function(e){c.getLayers().then(function(c){if(!e.hasLayer(c.baselayers[b])){for(var f in d.layers.baselayers)d.layers.baselayers[f].icon=d.icons.unradio,e.hasLayer(c.baselayers[f])&&e.removeLayer(c.baselayers[f]);e.addLayer(c.baselayers[b]),d.layers.baselayers[b].icon=a.icons.radio}})})}),e.preventDefault()},moveLayer:function(b,c,d){var e=Object.keys(a.layers.baselayers).length;if(c>=1+e&&c<=a.overlaysArray.length+e){var f;for(var h in a.layers.overlays)if(a.layers.overlays[h].index===c){f=a.layers.overlays[h];break}f&&g(a,function(){f.index=b.index,b.index=c})}d.stopPropagation(),d.preventDefault()},initIndex:function(b,c){var d=Object.keys(a.layers.baselayers).length;b.index=h(b.index)?b.index:c+d+1},initGroup:function(b){a.groupProperties[b]=a.groupProperties[b]?a.groupProperties[b]:{}},toggleOpacity:function(b,c){if(c.visible){if(a.autoHideOpacity&&!a.layerProperties[c.name].opacityControl)for(var d in a.layerProperties)a.layerProperties[d].opacityControl=!1;a.layerProperties[c.name].opacityControl=!a.layerProperties[c.name].opacityControl}b.stopPropagation(),b.preventDefault()},toggleLegend:function(b){a.layerProperties[b.name].showLegend=!a.layerProperties[b.name].showLegend},showLegend:function(b){return b.legend&&a.layerProperties[b.name].showLegend},unsafeHTML:function(a){return f.trustAsHtml(a)},getOpacityIcon:function(b){return b.visible&&a.layerProperties[b.name].opacityControl?a.icons.close:a.icons.open},getGroupIcon:function(b){return b.visible?a.icons.check:a.icons.uncheck},changeOpacity:function(b){var d=a.layerProperties[b.name].opacity;c.getMap().then(function(e){c.getLayers().then(function(c){var f;for(var g in a.layers.overlays)if(a.layers.overlays[g]===b){f=c.overlays[g];break}e.hasLayer(f)&&(f.setOpacity&&f.setOpacity(d/100),f.getLayers&&f.eachLayer&&f.eachLayer(function(a){a.setOpacity&&a.setOpacity(d/100)}))})})},changeGroupVisibility:function(b){if(h(a.groupProperties[b])){var c=a.groupProperties[b].visible;for(var d in a.layers.overlays){var e=a.layers.overlays[d];e.group===b&&(e.visible=c)}}}});var i=b.get(0);L.Browser.touch?L.DomEvent.on(i,"click",L.DomEvent.stopPropagation):(L.DomEvent.disableClickPropagation(i),L.DomEvent.on(i,"mousewheel",L.DomEvent.stopPropagation))}],template:'<div class="angular-leaflet-control-layers" ng-show="overlaysArray.length"><h4 ng-if="title">{{ title }}</h4><div class="lf-baselayers"><h5 class="lf-title" ng-if="baseTitle">{{ baseTitle }}</h5><div class="lf-row" ng-repeat="(key, layer) in baselayersArray"><label class="lf-icon-bl" ng-click="changeBaseLayer(key, $event)"><input class="leaflet-control-layers-selector" type="radio" name="lf-radio" ng-show="false" ng-checked="baselayer === key" ng-value="key" /> <i class="lf-icon lf-icon-radio" ng-class="layer.icon"></i><div class="lf-text">{{layer.name}}</div></label></div></div><div class="lf-overlays"><h5 class="lf-title" ng-if="overlaysTitle">{{ overlaysTitle }}</h5><div class="lf-container"><div class="lf-row" ng-repeat="layer in (o = (overlaysArray | orderBy:\'index\':order))" ng-init="initIndex(layer, $index)"><label class="lf-icon-ol-group" ng-if="showGroups &amp;&amp; layer.group &amp;&amp; layer.group != o[$index-1].group"><input class="lf-control-layers-selector" type="checkbox" ng-show="false" ng-change="changeGroupVisibility(layer.group)" ng-model="groupProperties[layer.group].visible"/> <i class="lf-icon lf-icon-check" ng-class="getGroupIcon(groupProperties[layer.group])"></i><div class="lf-text">{{ layer.group }}</div></label><label class="lf-icon-ol"><input class="lf-control-layers-selector" type="checkbox" ng-show="false" ng-model="layer.visible"/> <i class="lf-icon lf-icon-check" ng-class="layer.icon"></i><div class="lf-text">{{layer.name}}</div></label><div class="lf-icons"><i class="lf-icon lf-up" ng-class="icons.up" ng-click="moveLayer(layer, layer.index - orderNumber, $event)"></i> <i class="lf-icon lf-down" ng-class="icons.down" ng-click="moveLayer(layer, layer.index + orderNumber, $event)"></i> <i class="lf-icon lf-toggle-legend" ng-class="icons.toggleLegend" ng-if="layer.legend" ng-click="toggleLegend(layer)"></i> <i class="lf-icon lf-open" ng-class="getOpacityIcon(layer)" ng-click="toggleOpacity($event, layer)"></i></div><div class="lf-legend" ng-if="showLegend(layer)" ng-bind-html="unsafeHTML(layer.legend)"></div><div class="lf-opacity clearfix" ng-if="layer.visible &amp;&amp; layerProperties[layer.name].opacityControl"><label ng-if="rangeIsSupported" class="pull-left" style="width: 50%">0</label><label ng-if="rangeIsSupported" class="pull-left text-right" style="width: 50%">100</label><input ng-if="rangeIsSupported" class="clearfix" type="range" min="0" max="100" class="lf-opacity-control" ng-model="layerProperties[layer.name].opacity" ng-change="changeOpacity(layer)"/><h6 ng-if="!rangeIsSupported">Range is not supported in this browser</h6></div></div></div></div></div>',link:function(a,b,e,f){var g=d.isDefined,h=f.getLeafletScope(),i=h.layers;a.$watch("icons",function(){var b={uncheck:"fa fa-square-o",check:"fa fa-check-square-o",radio:"fa fa-dot-circle-o",unradio:"fa fa-circle-o",up:"fa fa-angle-up",down:"fa fa-angle-down",open:"fa fa-angle-double-down",close:"fa fa-angle-double-up",toggleLegend:"fa fa-pencil-square-o"};g(a.icons)?(angular.extend(b,a.icons),angular.extend(a.icons,b)):a.icons=b}),e.order=!g(e.order)||"normal"!==e.order&&"reverse"!==e.order?"normal":e.order,a.order="normal"===e.order,a.orderNumber="normal"===e.order?-1:1,a.layers=i,f.getMap().then(function(b){h.$watch("layers.baselayers",function(d){var e={};c.getLayers().then(function(c){var f;for(f in d){var g=d[f];g.icon=a.icons[b.hasLayer(c.baselayers[f])?"radio":"unradio"],e[f]=g}a.baselayersArray=e})}),h.$watch("layers.overlays",function(b){var d=[],e={};c.getLayers().then(function(c){var f;for(f in b){var h=b[f];h.icon=a.icons[h.visible?"check":"uncheck"],d.push(h),g(a.layerProperties[h.name])||(a.layerProperties[h.name]={opacity:g(h.layerOptions.opacity)?100*h.layerOptions.opacity:100,opacityControl:!1,showLegend:!0}),g(h.group)&&(g(a.groupProperties[h.group])||(a.groupProperties[h.group]={visible:!1}),e[h.group]=g(e[h.group])?e[h.group]:{count:0,visibles:0},e[h.group].count++,h.visible&&e[h.group].visibles++),g(h.index)&&c.overlays[f].setZIndex&&c.overlays[f].setZIndex(b[f].index)}for(f in e)a.groupProperties[f].visible=e[f].visibles===e[f].count;a.overlaysArray=d})},!0)})}}}]),angular.module("ui-leaflet").directive("layers",["leafletLogger","$q","leafletData","leafletHelpers","leafletLayerHelpers","leafletControlHelpers",function(a,b,c,d,e,f){return{restrict:"A",scope:!1,replace:!1,require:"leaflet",controller:["$scope",function(a){a._leafletLayers=b.defer(),this.getLayers=function(){return a._leafletLayers.promise}}],link:function(a,b,g,h){var i=d.isDefined,j={},k=h.getLeafletScope(),l=k.layers,m=e.createLayer,n=e.safeAddLayer,o=e.safeRemoveLayer,p=f.updateLayersControl,q=!1;h.getMap().then(function(b){a._leafletLayers.resolve(j),c.setLayers(j,g.id),j.baselayers={},j.overlays={};var d=g.id,e=!1;for(var f in l.baselayers){var h=m(l.baselayers[f]);i(h)?(j.baselayers[f]=h,l.baselayers[f].top===!0&&(n(b,j.baselayers[f]),e=!0)):delete l.baselayers[f]}!e&&Object.keys(j.baselayers).length>0&&n(b,j.baselayers[Object.keys(l.baselayers)[0]]);for(f in l.overlays){"cartodb"===l.overlays[f].type;var r=m(l.overlays[f]);i(r)?(j.overlays[f]=r,l.overlays[f].visible===!0&&n(b,j.overlays[f])):delete l.overlays[f]}k.$watch("layers.baselayers",function(a,c){if(angular.equals(a,c))return q=p(b,d,q,a,l.overlays,j),!0;for(var e in j.baselayers)(!i(a[e])||a[e].doRefresh)&&(b.hasLayer(j.baselayers[e])&&b.removeLayer(j.baselayers[e]),
delete j.baselayers[e],a[e]&&a[e].doRefresh&&(a[e].doRefresh=!1));for(var f in a)if(i(j.baselayers[f]))a[f].top!==!0||b.hasLayer(j.baselayers[f])?a[f].top===!1&&b.hasLayer(j.baselayers[f])&&b.removeLayer(j.baselayers[f]):n(b,j.baselayers[f]);else{var g=m(a[f]);i(g)&&(j.baselayers[f]=g,a[f].top===!0&&n(b,j.baselayers[f]))}var h=!1;for(var k in j.baselayers)if(b.hasLayer(j.baselayers[k])){h=!0;break}!h&&Object.keys(j.baselayers).length>0&&n(b,j.baselayers[Object.keys(j.baselayers)[0]]),q=p(b,d,q,a,l.overlays,j)},!0),k.$watch("layers.overlays",function(a,c){if(angular.equals(a,c))return q=p(b,d,q,l.baselayers,a,j),!0;for(var e in j.overlays)if(!i(a[e])||a[e].doRefresh){if(b.hasLayer(j.overlays[e])){var f=i(a[e])?a[e].layerOptions:null;o(b,j.overlays[e],f)}delete j.overlays[e],a[e]&&a[e].doRefresh&&(a[e].doRefresh=!1)}for(var g in a){if(i(j.overlays[g]))a[g].visible&&!b.hasLayer(j.overlays[g])?n(b,j.overlays[g]):a[g].visible===!1&&b.hasLayer(j.overlays[g])&&o(b,j.overlays[g],a[g].layerOptions);else{var h=m(a[g]);if(!i(h))continue;j.overlays[g]=h,a[g].visible===!0&&n(b,j.overlays[g])}a[g].visible&&b._loaded&&a[g].data&&"heatmap"===a[g].type&&(j.overlays[g].setData(a[g].data),j.overlays[g].update())}q=p(b,d,q,l.baselayers,a,j)},!0)})}}}]),angular.module("ui-leaflet").directive("legend",["leafletLogger","$http","$timeout","leafletHelpers","leafletLegendHelpers",function(a,b,c,d,e){var f=a,g=d.errorHeader+" [Legend] ";return{restrict:"A",scope:!1,replace:!1,require:"leaflet",transclude:!1,link:function(a,b,c,h){var i,j,k,l,m=d.isArray,n=d.isString,o=d.isDefined,p=d.isFunction,q=h.getLeafletScope(),r=q.legend;q.$watch("legend",function(a){o(a)&&(i=a.legendClass?a.legendClass:"legend",j=a.position||"bottomright",l=a.type||"arcgis")},!0);var s=function(a,b,c){b&&b.layers&&b.layers.length>0&&(o(k)?e.updateLegend(k.getContainer(),b,l,c):(k=L.control({position:j}),k.onAdd=e.getOnAddLegend(b,i,l,c),k.addTo(a)),o(r.loadedData)&&p(r.loadedData)&&r.loadedData())};h.getMap().then(function(a){q.$watch("legend",function(b){return o(b)?o(b.url)||"arcgis"!==l||m(b.colors)&&m(b.labels)&&b.colors.length===b.labels.length?o(b.url)?void f.info(g+" loading legend service."):(o(k)&&(k.removeFrom(a),k=null),k=L.control({position:j}),"arcgis"===l&&(k.onAdd=e.getOnAddArrayLegend(b,i)),void k.addTo(a)):void f.warn(g+" legend.colors and legend.labels must be set."):void(o(k)&&(k.removeFrom(a),k=null))}),q.$watch("legend.url",function(b){if(o(b)){if(!m(b)&&!n(b))return void f.warn(g+" legend.url must be an array or string.");for(var d,h=n(b)?[b]:b,i=function(c,e){return function(i){o(i.data.error)?f.warn(g+"Error loadin legend from: "+e,i.data.error.message):d&&d.layers&&d.layers.length>0?d.layers=d.layers.concat(i.data.layers):d=i.data,c===h.length-1&&s(a,d,b)}},j=function(a){f.warn(g+" legend.url not loaded.",a)},k=0;k<h.length;k++)e.addLegendURL(c.id,{url:h[k],method:"GET"}).then(i(k))["catch"](j)}}),q.$watch("legend.legendData",function(b){f.debug("legendData",b),!o(q.legend.url)&&o(b)&&s(a,b)},!0)})}}}]),angular.module("ui-leaflet").directive("markers",["leafletLogger","$rootScope","$q","leafletData","leafletHelpers","leafletMapDefaults","leafletMarkersHelpers","leafletMarkerEvents","leafletIterators","leafletWatchHelpers","leafletDirectiveControlsHelpers",function(a,b,c,d,e,f,g,h,i,j,k){var l=e.isDefined,m=e.errorHeader,n=e,o=e.isString,p=g.addMarkerWatcher,q=g.updateMarker,r=g.listenMarkerEvents,s=g.addMarkerToGroup,t=g.createMarker,u=g.deleteMarker,v=g.getModelFromModels,w=g.getLayerModels,x=i,y=e.watchOptions,z=j.maybeWatch,A=k.extend,B=a,C=function(a,b,c){if(Object.keys(a).length){if(c&&o(c)){if(!a[c]||!Object.keys(a[c]).length)return;return a[c][b]}return a[b]}},D=function(a,b,c,d){return d&&o(d)?(l(b[d])||(b[d]={}),b[d][c]=a):b[c]=a,a},E=function(a,b,c,d,e,f){if(!o(a))return B.error(m+" A layername must be a string"),!1;if(!l(b))return B.error(m+" You must add layers to the directive if the markers are going to use this functionality."),!1;if(!l(b.overlays)||!l(b.overlays[a]))return B.error(m+' A marker can only be added to a layer of type "group"'),!1;var g=b.overlays[a];return g instanceof L.LayerGroup||g instanceof L.FeatureGroup?(g.addLayer(d),!e&&f.hasLayer(d)&&c.focus===!0&&d.openPopup(),!0):(B.error(m+' Adding a marker to an overlay needs a overlay of the type "group" or "featureGroup"'),!1)},F=function(a,b,c,d,e,f,g,i,j,k){for(var o in b)if(!k[o])if(-1===o.search("-")){var u=n.copy(b[o]),w=n.getObjectDotPath(j?[j,o]:[o]),x=C(f,o,j);if(l(x)){var y=v(c,o,j);q(u,y,x,w,g,e,d)}else{var z=t(u),A=(u?u.layer:void 0)||j;if(!l(z)){B.error(m+" Received invalid data on the marker "+o+".");continue}if(D(z,f,o,j),l(u.message)&&z.bindPopup(u.message,u.popupOptions),l(u.group)){var F=l(u.groupOption)?u.groupOption:null;s(z,u.group,F,d)}if(n.LabelPlugin.isLoaded()&&l(u.label)&&l(u.label.message)&&z.bindLabel(u.label.message,u.label.options),l(u)&&(l(u.layer)||l(j))){var G=E(A,e,u,z,i.individual.doWatch,d);if(!G)continue}else l(u.group)||(d.addLayer(z),i.individual.doWatch||u.focus!==!0||z.openPopup());i.individual.doWatch&&p(z,w,g,e,d,i.individual.isDeep),r(z,u,g,i.individual.doWatch,d),h.bindEvents(a,z,w,u,g,A)}}else B.error('The marker can\'t use a "-" on his key name: "'+o+'".')},G=function(a,b,c,d,e){var f,g,h=!1,i=!1,j=l(b);for(var k in c)h||(B.debug(m+"[markers] destroy: "),h=!0),j&&(g=a[k],f=b[k],i=angular.equals(g,f)&&d),l(a)&&Object.keys(a).length&&l(a[k])&&Object.keys(a[k]).length&&!i||e&&n.isFunction(e)&&e(g,f,k)},H=function(a,b,c,d,e){G(a,b,c,!1,function(a,b,f){B.debug(m+"[marker] is deleting marker: "+f),u(c[f],d,e),delete c[f]})},I=function(a,b,c){var d={};return G(a,b,c,!0,function(a,b,c){B.debug(m+"[marker] is already rendered, marker: "+c),d[c]=a}),d};return{restrict:"A",scope:!1,replace:!1,require:["leaflet","?layers"],link:function(a,b,e,f){var g=f[0],h=g.getLeafletScope();g.getMap().then(function(a){var b,g={};b=l(f[1])?f[1].getLayers:function(){var a=c.defer();return a.resolve(),a.promise};var i=h.markersWatchOptions||y;l(e.watchMarkers)&&(i.doWatch=i.individual.doWatch=!l(e.watchMarkers)||n.isTruthy(e.watchMarkers));var j=l(e.markersNested)&&n.isTruthy(e.markersNested);b().then(function(b){var c=function(c,d){return j?void x.each(c,function(c,e){var f=w(d,e);H(c,f,g[e],a,b)}):void H(c,d,g,a,b)},f=function(d,f){c(d,f);var k=null;return j?void x.each(d,function(c,j){var l=w(f,j),m=w(d,j);k=I(m,l,g[j]),F(e.id,c,f,a,b,g,h,i,j,k)}):(k=I(d,f,g),void F(e.id,d,f,a,b,g,h,i,void 0,k))};A(e.id,"markers",f,c),d.setMarkers(g,e.id),z(h,"markers",i,function(a,b){f(a,b)})})})}}}]),angular.module("ui-leaflet").directive("maxbounds",["leafletLogger","leafletMapDefaults","leafletBoundsHelpers","leafletHelpers",function(a,b,c,d){return{restrict:"A",scope:!1,replace:!1,require:"leaflet",link:function(a,b,e,f){var g=f.getLeafletScope(),h=c.isValidBounds,i=d.isNumber;f.getMap().then(function(a){g.$watch("maxbounds",function(b){if(!h(b))return void a.setMaxBounds();var d=c.createLeafletBounds(b);i(b.pad)&&(d=d.pad(b.pad)),a.setMaxBounds(d),e.center||e.lfCenter||a.fitBounds(d)})})}}}]),angular.module("ui-leaflet").directive("paths",["leafletLogger","$q","leafletData","leafletMapDefaults","leafletHelpers","leafletPathsHelpers","leafletPathEvents",function(a,b,c,d,e,f,g){var h=a;return{restrict:"A",scope:!1,replace:!1,require:["leaflet","?layers"],link:function(a,i,j,k){var l=k[0],m=e.isDefined,n=e.isString,o=l.getLeafletScope(),p=o.paths,q=f.createPath,r=g.bindPathEvents,s=f.setPathOptions;l.getMap().then(function(a){var f,g=d.getDefaults(j.id);f=m(k[1])?k[1].getLayers:function(){var a=b.defer();return a.resolve(),a.promise},m(p)&&f().then(function(b){var d={};c.setPaths(d,j.id);var f=!m(j.watchPaths)||"true"===j.watchPaths,i=function(c,d){var e=o.$watch('paths["'+d+'"]',function(d,f){if(!m(d)){if(m(f.layer))for(var g in b.overlays){var h=b.overlays[g];h.removeLayer(c)}return a.removeLayer(c),void e()}s(c,d.type,d)},!0)};o.$watchCollection("paths",function(c){for(var k in d)m(c[k])||(a.removeLayer(d[k]),delete d[k]);for(var l in c)if(0!==l.search("\\$"))if(-1===l.search("-")){if(!m(d[l])){var p=c[l],t=q(l,c[l],g);if(m(t)&&m(p.message)&&t.bindPopup(p.message,p.popupOptions),e.LabelPlugin.isLoaded()&&m(p.label)&&m(p.label.message)&&t.bindLabel(p.label.message,p.label.options),m(p)&&m(p.layer)){if(!n(p.layer)){h.error("[AngularJS - Leaflet] A layername must be a string");continue}if(!m(b)){h.error("[AngularJS - Leaflet] You must add layers to the directive if the markers are going to use this functionality.");continue}if(!m(b.overlays)||!m(b.overlays[p.layer])){h.error('[AngularJS - Leaflet] A path can only be added to a layer of type "group"');continue}var u=b.overlays[p.layer];if(!(u instanceof L.LayerGroup||u instanceof L.FeatureGroup)){h.error('[AngularJS - Leaflet] Adding a path to an overlay needs a overlay of the type "group" or "featureGroup"');continue}d[l]=t,u.addLayer(t),f?i(t,l):s(t,p.type,p)}else m(t)&&(d[l]=t,a.addLayer(t),f?i(t,l):s(t,p.type,p));r(j.id,t,l,p,o)}}else h.error('[AngularJS - Leaflet] The path name "'+l+'" is not valid. It must not include "-" and a number.')})})})}}}]),angular.module("ui-leaflet").directive("tiles",["leafletLogger","leafletData","leafletMapDefaults","leafletHelpers",function(a,b,c,d){var e=a;return{restrict:"A",scope:!1,replace:!1,require:"leaflet",link:function(a,f,g,h){var i=d.isDefined,j=h.getLeafletScope(),k=j.tiles;return i(k)&&i(k.url)?void h.getMap().then(function(a){var d,e=c.getDefaults(g.id);j.$watch("tiles",function(c){var f=e.tileLayerOptions,h=e.tileLayer;return!i(c.url)&&i(d)?void a.removeLayer(d):i(d)?i(c.url)&&i(c.options)&&!angular.equals(c.options,f)?(a.removeLayer(d),f=e.tileLayerOptions,angular.copy(c.options,f),h=c.url,d=L.tileLayer(h,f),d.addTo(a),void b.setTiles(d,g.id)):void(i(c.url)&&d.setUrl(c.url)):(i(c.options)&&angular.copy(c.options,f),i(c.url)&&(h=c.url),d=L.tileLayer(h,f),d.addTo(a),void b.setTiles(d,g.id))},!0)}):void e.warn("[AngularJS - Leaflet] The 'tiles' definition doesn't have the 'url' property.")}}}]),["markers","geojson"].forEach(function(a){angular.module("ui-leaflet").directive(a+"WatchOptions",["$log","$rootScope","$q","leafletData","leafletHelpers",function(b,c,d,e,f){var g=f.isDefined,h=f.errorHeader,i=f.isObject,j=f.watchOptions,k=b;return{restrict:"A",scope:!1,replace:!1,require:["leaflet"],link:function(b,c,d,e){var f=e[0],l=f.getLeafletScope();f.getMap().then(function(){g(b[a+"WatchOptions"])&&(i(b[a+"WatchOptions"])?angular.extend(j,b[a+"WatchOptions"]):k.error(h+"["+a+"WatchOptions] is not an object"),l[a+"WatchOptions"]=j)})}}}])}),angular.module("ui-leaflet").factory("leafletEventsHelpersFactory",["$rootScope","$q","leafletLogger","leafletHelpers",function(a,b,c,d){var e=d.safeApply,f=d.isDefined,g=d.isObject,h=d.isArray,i=d.errorHeader,j=c,k=function(a,b){this.rootBroadcastName=a,j.debug("leafletEventsHelpersFactory: lObjectType: "+b+"rootBroadcastName: "+a),this.lObjectType=b};return k.prototype.getAvailableEvents=function(){return[]},k.prototype.genDispatchEvent=function(a,b,c,d,e,f,g,h,i){var k=this;return a=a||"",a&&(a="."+a),function(l){var m=k.rootBroadcastName+a+"."+b;j.debug(m),k.fire(d,m,c,l,l.target||e,g,f,h,i)}},k.prototype.fire=function(b,c,d,g,h,i,j,k,l){e(b,function(){var e={leafletEvent:g,leafletObject:h,modelName:j,model:i};f(k)&&angular.extend(e,{layerName:k}),"emit"===d?b.$emit(c,e):a.$broadcast(c,e)})},k.prototype.bindEvents=function(a,b,c,d,e,k,l){var m=[],n="emit",o=this;if(f(e.eventBroadcast))if(g(e.eventBroadcast))if(f(e.eventBroadcast[o.lObjectType]))if(g(e.eventBroadcast[o.lObjectType])){f(e.eventBroadcast[this.lObjectType].logic)&&"emit"!==e.eventBroadcast[o.lObjectType].logic&&"broadcast"!==e.eventBroadcast[o.lObjectType].logic&&j.warn(i+"Available event propagation logic are: 'emit' or 'broadcast'.");var p=!1,q=!1;f(e.eventBroadcast[o.lObjectType].enable)&&h(e.eventBroadcast[o.lObjectType].enable)&&(p=!0),f(e.eventBroadcast[o.lObjectType].disable)&&h(e.eventBroadcast[o.lObjectType].disable)&&(q=!0),p&&q?j.warn(i+"can not enable and disable events at the same time"):p||q?p?e.eventBroadcast[this.lObjectType].enable.forEach(function(a){-1!==m.indexOf(a)?j.warn(i+"This event "+a+" is already enabled"):-1===o.getAvailableEvents().indexOf(a)?j.warn(i+"This event "+a+" does not exist"):m.push(a)}):(m=this.getAvailableEvents(),e.eventBroadcast[o.lObjectType].disable.forEach(function(a){var b=m.indexOf(a);-1===b?j.warn(i+"This event "+a+" does not exist or has been already disabled"):m.splice(b,1)})):j.warn(i+"must enable or disable events")}else j.warn(i+"event-broadcast."+[o.lObjectType]+" must be an object check your model.");else m=this.getAvailableEvents();else j.error(i+"event-broadcast must be an object check your model.");else m=this.getAvailableEvents();return m.forEach(function(f){b.on(f,o.genDispatchEvent(a,f,n,e,b,c,d,k,l))}),n},k}]).service("leafletEventsHelpers",["leafletEventsHelpersFactory",function(a){return new a}]),angular.module("ui-leaflet").factory("leafletGeoJsonEvents",["$rootScope","$q","leafletLogger","leafletHelpers","leafletEventsHelpersFactory","leafletData",function(a,b,c,d,e,f){var g=d.safeApply,h=e,i=function(){h.call(this,"leafletDirectiveGeoJson","geojson")};return i.prototype=new h,i.prototype.genDispatchEvent=function(b,c,d,e,i,j,k,l,m){var n=h.prototype.genDispatchEvent.call(this,b,c,d,e,i,j,k,l),o=this;return function(b){"mouseout"===c&&(m.resetStyleOnMouseout&&f.getGeoJSON(m.mapId).then(function(a){var c=l?a[l]:a;c.resetStyle(b.target)}),g(e,function(){a.$broadcast(o.rootBroadcastName+".mouseout",b)})),n(b)}},i.prototype.getAvailableEvents=function(){return["click","dblclick","mouseover","mouseout"]},new i}]),angular.module("ui-leaflet").factory("leafletLabelEvents",["$rootScope","$q","leafletLogger","leafletHelpers","leafletEventsHelpersFactory",function(a,b,c,d,e){var f=d,g=e,h=function(){g.call(this,"leafletDirectiveLabel","markers")};return h.prototype=new g,h.prototype.genDispatchEvent=function(a,b,c,d,e,f,h,i){var j=f.replace("markers.","");return g.prototype.genDispatchEvent.call(this,a,b,c,d,e,j,h,i)},h.prototype.getAvailableEvents=function(){return["click","dblclick","mousedown","mouseover","mouseout","contextmenu"]},h.prototype.genEvents=function(a,b,c,d,e,g,h,i){var j=this,k=this.getAvailableEvents(),l=f.getObjectArrayPath("markers."+g);k.forEach(function(b){e.label.on(b,j.genDispatchEvent(a,b,c,d,e.label,l,h,i))})},h.prototype.bindEvents=function(a,b,c,d,e,f){},new h}]),angular.module("ui-leaflet").factory("leafletMapEvents",["$rootScope","$q","leafletLogger","leafletHelpers","leafletEventsHelpers","leafletIterators",function(a,b,c,d,e,f){var g=d.isDefined,h=e.fire,i=function(){return["click","dblclick","mousedown","mouseup","mouseover","mouseout","mousemove","contextmenu","focus","blur","preclick","load","unload","viewreset","movestart","move","moveend","dragstart","drag","dragend","zoomstart","zoomanim","zoomend","zoomlevelschange","resize","autopanstart","layeradd","layerremove","baselayerchange","overlayadd","overlayremove","locationfound","locationerror","popupopen","popupclose","draw:created","draw:edited","draw:deleted","draw:drawstart","draw:drawstop","draw:editstart","draw:editstop","draw:deletestart","draw:deletestop"]},j=function(a,b,d,e){return e&&(e+="."),function(f){var g="leafletDirectiveMap."+e+b;c.debug(g),h(a,g,d,f,f.target,a)}},k=function(a){a.$broadcast("boundsChanged")},l=function(a,b,c,d){if(g(c.urlHashCenter)){var e=b.getCenter(),f=e.lat.toFixed(4)+":"+e.lng.toFixed(4)+":"+b.getZoom();g(d.c)&&d.c===f||a.$emit("centerUrlHash",f)}},m=function(a,b,c,d,e){f.each(b,function(b){var f={};f[c]=b,a.on(b,j(d,b,e,a._container.id||""),f)})};return{getAvailableMapEvents:i,genDispatchMapEvent:j,notifyCenterChangedToBounds:k,notifyCenterUrlHashChanged:l,addEvents:m}}]),angular.module("ui-leaflet").factory("leafletMarkerEvents",["$rootScope","$q","leafletLogger","leafletHelpers","leafletEventsHelpersFactory","leafletLabelEvents",function(a,b,c,d,e,f){var g=d.safeApply,h=d.isDefined,i=d,j=f,k=e,l=function(){k.call(this,"leafletDirectiveMarker","markers")};return l.prototype=new k,l.prototype.genDispatchEvent=function(b,c,d,e,f,h,i,j){var l=k.prototype.genDispatchEvent.call(this,b,c,d,e,f,h,i,j);return function(b){"click"===c?g(e,function(){a.$broadcast("leafletDirectiveMarkersClick",h)}):"dragend"===c&&(g(e,function(){i.lat=f.getLatLng().lat,i.lng=f.getLatLng().lng}),i.message&&i.focus===!0&&f.openPopup()),l(b)}},l.prototype.getAvailableEvents=function(){return["click","dblclick","mousedown","mouseover","mouseout","contextmenu","dragstart","drag","dragend","move","remove","popupopen","popupclose","touchend","touchstart","touchmove","touchcancel","touchleave"]},l.prototype.bindEvents=function(a,b,c,d,e,f){var g=k.prototype.bindEvents.call(this,a,b,c,d,e,f);i.LabelPlugin.isLoaded()&&h(b.label)&&j.genEvents(a,c,g,e,b,d,f)},new l}]),angular.module("ui-leaflet").factory("leafletPathEvents",["$rootScope","$q","leafletLogger","leafletHelpers","leafletLabelEvents","leafletEventsHelpers",function(a,b,c,d,e,f){var g=d.isDefined,h=d.isObject,i=d,j=d.errorHeader,k=e,l=f.fire,m=c,n=function(a,b,c,d,e,f,g,h){return a=a||"",a&&(a="."+a),function(i){var j="leafletDirectivePath"+a+"."+b;m.debug(j),l(d,j,c,i,i.target||e,g,f,h)}},o=function(a,b,c,d,e){var f,l,o=[],q="broadcast";if(g(e.eventBroadcast))if(h(e.eventBroadcast))if(g(e.eventBroadcast.path))if(h(e.eventBroadcast.paths))m.warn(j+"event-broadcast.path must be an object check your model.");else{void 0!==e.eventBroadcast.path.logic&&null!==e.eventBroadcast.path.logic&&("emit"!==e.eventBroadcast.path.logic&&"broadcast"!==e.eventBroadcast.path.logic?m.warn(j+"Available event propagation logic are: 'emit' or 'broadcast'."):"emit"===e.eventBroadcast.path.logic&&(q="emit"));var r=!1,s=!1;if(void 0!==e.eventBroadcast.path.enable&&null!==e.eventBroadcast.path.enable&&"object"==typeof e.eventBroadcast.path.enable&&(r=!0),void 0!==e.eventBroadcast.path.disable&&null!==e.eventBroadcast.path.disable&&"object"==typeof e.eventBroadcast.path.disable&&(s=!0),r&&s)m.warn(j+"can not enable and disable events at the same time");else if(r||s)if(r)for(f=0;f<e.eventBroadcast.path.enable.length;f++)l=e.eventBroadcast.path.enable[f],-1!==o.indexOf(l)?m.warn(j+"This event "+l+" is already enabled"):-1===p().indexOf(l)?m.warn(j+"This event "+l+" does not exist"):o.push(l);else for(o=p(),f=0;f<e.eventBroadcast.path.disable.length;f++){l=e.eventBroadcast.path.disable[f];var t=o.indexOf(l);-1===t?m.warn(j+"This event "+l+" does not exist or has been already disabled"):o.splice(t,1)}else m.warn(j+"must enable or disable events")}else o=p();else m.error(j+"event-broadcast must be an object check your model.");else o=p();for(f=0;f<o.length;f++)l=o[f],b.on(l,n(a,l,q,e,o,c));i.LabelPlugin.isLoaded()&&g(b.label)&&k.genEvents(a,c,q,e,b,d)},p=function(){return["click","dblclick","mousedown","mouseover","mouseout","contextmenu","add","remove","popupopen","popupclose"]};return{getAvailablePathEvents:p,bindPathEvents:o}}])}(angular);;
;
/*!
 * ui-select
 * http://github.com/angular-ui/ui-select
 * Version: 0.19.8 - 2017-04-18T05:43:43.673Z
 * License: MIT
 */


(function () { 
"use strict";
var KEY = {
    TAB: 9,
    ENTER: 13,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    HOME: 36,
    END: 35,
    BACKSPACE: 8,
    DELETE: 46,
    COMMAND: 91,

    MAP: { 91 : "COMMAND", 8 : "BACKSPACE" , 9 : "TAB" , 13 : "ENTER" , 16 : "SHIFT" , 17 : "CTRL" , 18 : "ALT" , 19 : "PAUSEBREAK" , 20 : "CAPSLOCK" , 27 : "ESC" , 32 : "SPACE" , 33 : "PAGE_UP", 34 : "PAGE_DOWN" , 35 : "END" , 36 : "HOME" , 37 : "LEFT" , 38 : "UP" , 39 : "RIGHT" , 40 : "DOWN" , 43 : "+" , 44 : "PRINTSCREEN" , 45 : "INSERT" , 46 : "DELETE", 48 : "0" , 49 : "1" , 50 : "2" , 51 : "3" , 52 : "4" , 53 : "5" , 54 : "6" , 55 : "7" , 56 : "8" , 57 : "9" , 59 : ";", 61 : "=" , 65 : "A" , 66 : "B" , 67 : "C" , 68 : "D" , 69 : "E" , 70 : "F" , 71 : "G" , 72 : "H" , 73 : "I" , 74 : "J" , 75 : "K" , 76 : "L", 77 : "M" , 78 : "N" , 79 : "O" , 80 : "P" , 81 : "Q" , 82 : "R" , 83 : "S" , 84 : "T" , 85 : "U" , 86 : "V" , 87 : "W" , 88 : "X" , 89 : "Y" , 90 : "Z", 96 : "0" , 97 : "1" , 98 : "2" , 99 : "3" , 100 : "4" , 101 : "5" , 102 : "6" , 103 : "7" , 104 : "8" , 105 : "9", 106 : "*" , 107 : "+" , 109 : "-" , 110 : "." , 111 : "/", 112 : "F1" , 113 : "F2" , 114 : "F3" , 115 : "F4" , 116 : "F5" , 117 : "F6" , 118 : "F7" , 119 : "F8" , 120 : "F9" , 121 : "F10" , 122 : "F11" , 123 : "F12", 144 : "NUMLOCK" , 145 : "SCROLLLOCK" , 186 : ";" , 187 : "=" , 188 : "," , 189 : "-" , 190 : "." , 191 : "/" , 192 : "`" , 219 : "[" , 220 : "\\" , 221 : "]" , 222 : "'"
    },

    isControl: function (e) {
        var k = e.which;
        switch (k) {
        case KEY.COMMAND:
        case KEY.SHIFT:
        case KEY.CTRL:
        case KEY.ALT:
            return true;
        }

        if (e.metaKey || e.ctrlKey || e.altKey) return true;

        return false;
    },
    isFunctionKey: function (k) {
        k = k.which ? k.which : k;
        return k >= 112 && k <= 123;
    },
    isVerticalMovement: function (k){
      return ~[KEY.UP, KEY.DOWN].indexOf(k);
    },
    isHorizontalMovement: function (k){
      return ~[KEY.LEFT,KEY.RIGHT,KEY.BACKSPACE,KEY.DELETE].indexOf(k);
    },
    toSeparator: function (k) {
      var sep = {ENTER:"\n",TAB:"\t",SPACE:" "}[k];
      if (sep) return sep;
      // return undefined for special keys other than enter, tab or space.
      // no way to use them to cut strings.
      return KEY[k] ? undefined : k;
    }
  };

function isNil(value) {
  return angular.isUndefined(value) || value === null;
}

/**
 * Add querySelectorAll() to jqLite.
 *
 * jqLite find() is limited to lookups by tag name.
 * TODO This will change with future versions of AngularJS, to be removed when this happens
 *
 * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
 * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
 */
if (angular.element.prototype.querySelectorAll === undefined) {
  angular.element.prototype.querySelectorAll = function(selector) {
    return angular.element(this[0].querySelectorAll(selector));
  };
}

/**
 * Add closest() to jqLite.
 */
if (angular.element.prototype.closest === undefined) {
  angular.element.prototype.closest = function( selector) {
    var elem = this[0];
    var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;

    while (elem) {
      if (matchesSelector.bind(elem)(selector)) {
        return elem;
      } else {
        elem = elem.parentElement;
      }
    }
    return false;
  };
}

var latestId = 0;

var uis = angular.module('ui.select', [])

.constant('uiSelectConfig', {
  theme: 'bootstrap',
  searchEnabled: true,
  sortable: false,
  placeholder: '', // Empty by default, like HTML tag <select>
  refreshDelay: 1000, // In milliseconds
  closeOnSelect: true,
  skipFocusser: false,
  dropdownPosition: 'auto',
  removeSelected: true,
  resetSearchInput: true,
  generateId: function() {
    return latestId++;
  },
  appendToBody: false,
  spinnerEnabled: false,
  spinnerClass: 'glyphicon glyphicon-refresh ui-select-spin',
  backspaceReset: true
})

// See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
.service('uiSelectMinErr', function() {
  var minErr = angular.$$minErr('ui.select');
  return function() {
    var error = minErr.apply(this, arguments);
    var message = error.message.replace(new RegExp('\nhttp://errors.angularjs.org/.*'), '');
    return new Error(message);
  };
})

// Recreates old behavior of ng-transclude. Used internally.
.directive('uisTranscludeAppend', function () {
  return {
    link: function (scope, element, attrs, ctrl, transclude) {
        transclude(scope, function (clone) {
          element.append(clone);
        });
      }
    };
})

/**
 * Highlights text that matches $select.search.
 *
 * Taken from AngularUI Bootstrap Typeahead
 * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
 */
.filter('highlight', function() {
  function escapeRegexp(queryToEscape) {
    return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
  }

  return function(matchItem, query) {
    return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
  };
})

/**
 * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
 *
 * Taken from AngularUI Bootstrap Position:
 * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
 */
.factory('uisOffset',
  ['$document', '$window',
  function ($document, $window) {

  return function(element) {
    var boundingClientRect = element[0].getBoundingClientRect();
    return {
      width: boundingClientRect.width || element.prop('offsetWidth'),
      height: boundingClientRect.height || element.prop('offsetHeight'),
      top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
      left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
    };
  };
}]);

uis.directive('uiSelectChoices',
  ['uiSelectConfig', 'uisRepeatParser', 'uiSelectMinErr', '$compile', '$window',
  function(uiSelectConfig, RepeatParser, uiSelectMinErr, $compile, $window) {

  return {
    restrict: 'EA',
    require: '^uiSelect',
    replace: true,
    transclude: true,
    templateUrl: function(tElement) {
      // Needed so the uiSelect can detect the transcluded content
      tElement.addClass('ui-select-choices');

      // Gets theme attribute from parent (ui-select)
      var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
      return theme + '/choices.tpl.html';
    },

    compile: function(tElement, tAttrs) {

      if (!tAttrs.repeat) throw uiSelectMinErr('repeat', "Expected 'repeat' expression.");

      // var repeat = RepeatParser.parse(attrs.repeat);
      var groupByExp = tAttrs.groupBy;
      var groupFilterExp = tAttrs.groupFilter;

      if (groupByExp) {
        var groups = tElement.querySelectorAll('.ui-select-choices-group');
        if (groups.length !== 1) throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length);
        groups.attr('ng-repeat', RepeatParser.getGroupNgRepeatExpression());
      }

      var parserResult = RepeatParser.parse(tAttrs.repeat);

      var choices = tElement.querySelectorAll('.ui-select-choices-row');
      if (choices.length !== 1) {
        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length);
      }

      choices.attr('ng-repeat', parserResult.repeatExpression(groupByExp))
             .attr('ng-if', '$select.open'); //Prevent unnecessary watches when dropdown is closed


      var rowsInner = tElement.querySelectorAll('.ui-select-choices-row-inner');
      if (rowsInner.length !== 1) {
        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length);
      }
      rowsInner.attr('uis-transclude-append', ''); //Adding uisTranscludeAppend directive to row element after choices element has ngRepeat

      // If IE8 then need to target rowsInner to apply the ng-click attr as choices will not capture the event.
      var clickTarget = $window.document.addEventListener ? choices : rowsInner;
      clickTarget.attr('ng-click', '$select.select(' + parserResult.itemName + ',$select.skipFocusser,$event)');

      return function link(scope, element, attrs, $select) {


        $select.parseRepeatAttr(attrs.repeat, groupByExp, groupFilterExp); //Result ready at $select.parserResult
        $select.disableChoiceExpression = attrs.uiDisableChoice;
        $select.onHighlightCallback = attrs.onHighlight;
        $select.minimumInputLength = parseInt(attrs.minimumInputLength) || 0;
        $select.dropdownPosition = attrs.position ? attrs.position.toLowerCase() : uiSelectConfig.dropdownPosition;

        scope.$watch('$select.search', function(newValue) {
          if(newValue && !$select.open && $select.multiple) $select.activate(false, true);
          $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
          if (!attrs.minimumInputLength || $select.search.length >= attrs.minimumInputLength) {
            $select.refresh(attrs.refresh);
          } else {
            $select.items = [];
          }
        });

        attrs.$observe('refreshDelay', function() {
          // $eval() is needed otherwise we get a string instead of a number
          var refreshDelay = scope.$eval(attrs.refreshDelay);
          $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
        });

        scope.$watch('$select.open', function(open) {
          if (open) {
            tElement.attr('role', 'listbox');
            $select.refresh(attrs.refresh);
          } else {
            element.removeAttr('role');
          }
        });
      };
    }
  };
}]);

/**
 * Contains ui-select "intelligence".
 *
 * The goal is to limit dependency on the DOM whenever possible and
 * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
 */
uis.controller('uiSelectCtrl',
  ['$scope', '$element', '$timeout', '$filter', '$$uisDebounce', 'uisRepeatParser', 'uiSelectMinErr', 'uiSelectConfig', '$parse', '$injector', '$window',
  function($scope, $element, $timeout, $filter, $$uisDebounce, RepeatParser, uiSelectMinErr, uiSelectConfig, $parse, $injector, $window) {

  var ctrl = this;

  var EMPTY_SEARCH = '';

  ctrl.placeholder = uiSelectConfig.placeholder;
  ctrl.searchEnabled = uiSelectConfig.searchEnabled;
  ctrl.sortable = uiSelectConfig.sortable;
  ctrl.refreshDelay = uiSelectConfig.refreshDelay;
  ctrl.paste = uiSelectConfig.paste;
  ctrl.resetSearchInput = uiSelectConfig.resetSearchInput;
  ctrl.refreshing = false;
  ctrl.spinnerEnabled = uiSelectConfig.spinnerEnabled;
  ctrl.spinnerClass = uiSelectConfig.spinnerClass;
  ctrl.removeSelected = uiSelectConfig.removeSelected; //If selected item(s) should be removed from dropdown list
  ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
  ctrl.skipFocusser = false; //Set to true to avoid returning focus to ctrl when item is selected
  ctrl.search = EMPTY_SEARCH;

  ctrl.activeIndex = 0; //Dropdown of choices
  ctrl.items = []; //All available choices

  ctrl.open = false;
  ctrl.focus = false;
  ctrl.disabled = false;
  ctrl.selected = undefined;

  ctrl.dropdownPosition = 'auto';

  ctrl.focusser = undefined; //Reference to input element used to handle focus events
  ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
  ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
  ctrl.tagging = {isActivated: false, fct: undefined};
  ctrl.taggingTokens = {isActivated: false, tokens: undefined};
  ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
  ctrl.clickTriggeredSelect = false;
  ctrl.$filter = $filter;
  ctrl.$element = $element;

  // Use $injector to check for $animate and store a reference to it
  ctrl.$animate = (function () {
    try {
      return $injector.get('$animate');
    } catch (err) {
      // $animate does not exist
      return null;
    }
  })();

  ctrl.searchInput = $element.querySelectorAll('input.ui-select-search');
  if (ctrl.searchInput.length !== 1) {
    throw uiSelectMinErr('searchInput', "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length);
  }

  ctrl.isEmpty = function() {
    return isNil(ctrl.selected) || ctrl.selected === '' || (ctrl.multiple && ctrl.selected.length === 0);
  };

  function _findIndex(collection, predicate, thisArg){
    if (collection.findIndex){
      return collection.findIndex(predicate, thisArg);
    } else {
      var list = Object(collection);
      var length = list.length >>> 0;
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return i;
        }
      }
      return -1;
    }
  }

  // Most of the time the user does not want to empty the search input when in typeahead mode
  function _resetSearchInput() {
    if (ctrl.resetSearchInput) {
      ctrl.search = EMPTY_SEARCH;
      //reset activeIndex
      if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
        ctrl.activeIndex = _findIndex(ctrl.items, function(item){
          return angular.equals(this, item);
        }, ctrl.selected);
      }
    }
  }

    function _groupsFilter(groups, groupNames) {
      var i, j, result = [];
      for(i = 0; i < groupNames.length ;i++){
        for(j = 0; j < groups.length ;j++){
          if(groups[j].name == [groupNames[i]]){
            result.push(groups[j]);
          }
        }
      }
      return result;
    }

  // When the user clicks on ui-select, displays the dropdown list
  ctrl.activate = function(initSearchValue, avoidReset) {
    if (!ctrl.disabled  && !ctrl.open) {
      if(!avoidReset) _resetSearchInput();

      $scope.$broadcast('uis:activate');
      ctrl.open = true;
      ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;
      // ensure that the index is set to zero for tagging variants
      // that where first option is auto-selected
      if ( ctrl.activeIndex === -1 && ctrl.taggingLabel !== false ) {
        ctrl.activeIndex = 0;
      }

      var container = $element.querySelectorAll('.ui-select-choices-content');
      var searchInput = $element.querySelectorAll('.ui-select-search');
      if (ctrl.$animate && ctrl.$animate.on && ctrl.$animate.enabled(container[0])) {
        var animateHandler = function(elem, phase) {
          if (phase === 'start' && ctrl.items.length === 0) {
            // Only focus input after the animation has finished
            ctrl.$animate.off('removeClass', searchInput[0], animateHandler);
            $timeout(function () {
              ctrl.focusSearchInput(initSearchValue);
            });
          } else if (phase === 'close') {
            // Only focus input after the animation has finished
            ctrl.$animate.off('enter', container[0], animateHandler);
            $timeout(function () {
              ctrl.focusSearchInput(initSearchValue);
            });
          }
        };

        if (ctrl.items.length > 0) {
          ctrl.$animate.on('enter', container[0], animateHandler);
        } else {
          ctrl.$animate.on('removeClass', searchInput[0], animateHandler);
        }
      } else {
        $timeout(function () {
          ctrl.focusSearchInput(initSearchValue);
          if(!ctrl.tagging.isActivated && ctrl.items.length > 1) {
            _ensureHighlightVisible();
          }
        });
      }
    }
    else if (ctrl.open && !ctrl.searchEnabled) {
      // Close the selection if we don't have search enabled, and we click on the select again
      ctrl.close();
    }
  };

  ctrl.focusSearchInput = function (initSearchValue) {
    ctrl.search = initSearchValue || ctrl.search;
    ctrl.searchInput[0].focus();
  };

  ctrl.findGroupByName = function(name) {
    return ctrl.groups && ctrl.groups.filter(function(group) {
      return group.name === name;
    })[0];
  };

  ctrl.parseRepeatAttr = function(repeatAttr, groupByExp, groupFilterExp) {
    function updateGroups(items) {
      var groupFn = $scope.$eval(groupByExp);
      ctrl.groups = [];
      angular.forEach(items, function(item) {
        var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
        var group = ctrl.findGroupByName(groupName);
        if(group) {
          group.items.push(item);
        }
        else {
          ctrl.groups.push({name: groupName, items: [item]});
        }
      });
      if(groupFilterExp){
        var groupFilterFn = $scope.$eval(groupFilterExp);
        if( angular.isFunction(groupFilterFn)){
          ctrl.groups = groupFilterFn(ctrl.groups);
        } else if(angular.isArray(groupFilterFn)){
          ctrl.groups = _groupsFilter(ctrl.groups, groupFilterFn);
        }
      }
      ctrl.items = [];
      ctrl.groups.forEach(function(group) {
        ctrl.items = ctrl.items.concat(group.items);
      });
    }

    function setPlainItems(items) {
      ctrl.items = items || [];
    }

    ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;

    ctrl.parserResult = RepeatParser.parse(repeatAttr);

    ctrl.isGrouped = !!groupByExp;
    ctrl.itemProperty = ctrl.parserResult.itemName;

    //If collection is an Object, convert it to Array

    var originalSource = ctrl.parserResult.source;

    //When an object is used as source, we better create an array and use it as 'source'
    var createArrayFromObject = function(){
      var origSrc = originalSource($scope);
      $scope.$uisSource = Object.keys(origSrc).map(function(v){
        var result = {};
        result[ctrl.parserResult.keyName] = v;
        result.value = origSrc[v];
        return result;
      });
    };

    if (ctrl.parserResult.keyName){ // Check for (key,value) syntax
      createArrayFromObject();
      ctrl.parserResult.source = $parse('$uisSource' + ctrl.parserResult.filters);
      $scope.$watch(originalSource, function(newVal, oldVal){
        if (newVal !== oldVal) createArrayFromObject();
      }, true);
    }

    ctrl.refreshItems = function (data){
      data = data || ctrl.parserResult.source($scope);
      var selectedItems = ctrl.selected;
      //TODO should implement for single mode removeSelected
      if (ctrl.isEmpty() || (angular.isArray(selectedItems) && !selectedItems.length) || !ctrl.multiple || !ctrl.removeSelected) {
        ctrl.setItemsFn(data);
      }else{
        if ( data !== undefined && data !== null ) {
          var filteredItems = data.filter(function(i) {
            return angular.isArray(selectedItems) ? selectedItems.every(function(selectedItem) {
              return !angular.equals(i, selectedItem);
            }) : !angular.equals(i, selectedItems);
          });
          ctrl.setItemsFn(filteredItems);
        }
      }
      if (ctrl.dropdownPosition === 'auto' || ctrl.dropdownPosition === 'up'){
        $scope.calculateDropdownPos();
      }
      $scope.$broadcast('uis:refresh');
    };

    // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
    $scope.$watchCollection(ctrl.parserResult.source, function(items) {
      if (items === undefined || items === null) {
        // If the user specifies undefined or null => reset the collection
        // Special case: items can be undefined if the user did not initialized the collection on the scope
        // i.e $scope.addresses = [] is missing
        ctrl.items = [];
      } else {
        if (!angular.isArray(items)) {
          throw uiSelectMinErr('items', "Expected an array but got '{0}'.", items);
        } else {
          //Remove already selected items (ex: while searching)
          //TODO Should add a test
          ctrl.refreshItems(items);

          //update the view value with fresh data from items, if there is a valid model value
          if(angular.isDefined(ctrl.ngModel.$modelValue)) {
            ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
          }
        }
      }
    });

  };

  var _refreshDelayPromise;

  /**
   * Typeahead mode: lets the user refresh the collection using his own function.
   *
   * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
   */
  ctrl.refresh = function(refreshAttr) {
    if (refreshAttr !== undefined) {
      // Debounce
      // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
      // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
      if (_refreshDelayPromise) {
        $timeout.cancel(_refreshDelayPromise);
      }
      _refreshDelayPromise = $timeout(function() {
        if ($scope.$select.search.length >= $scope.$select.minimumInputLength) {
          var refreshPromise = $scope.$eval(refreshAttr);
          if (refreshPromise && angular.isFunction(refreshPromise.then) && !ctrl.refreshing) {
            ctrl.refreshing = true;
            refreshPromise.finally(function() {
              ctrl.refreshing = false;
            });
          }
        }
      }, ctrl.refreshDelay);
    }
  };

  ctrl.isActive = function(itemScope) {
    if ( !ctrl.open ) {
      return false;
    }
    var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
    var isActive =  itemIndex == ctrl.activeIndex;

    if ( !isActive || itemIndex < 0 ) {
      return false;
    }

    if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
      itemScope.$eval(ctrl.onHighlightCallback);
    }

    return isActive;
  };

  var _isItemSelected = function (item) {
    return (ctrl.selected && angular.isArray(ctrl.selected) &&
        ctrl.selected.filter(function (selection) { return angular.equals(selection, item); }).length > 0);
  };

  var disabledItems = [];

  function _updateItemDisabled(item, isDisabled) {
    var disabledItemIndex = disabledItems.indexOf(item);
    if (isDisabled && disabledItemIndex === -1) {
      disabledItems.push(item);
    }

    if (!isDisabled && disabledItemIndex > -1) {
      disabledItems.splice(disabledItemIndex, 1);
    }
  }

  function _isItemDisabled(item) {
    return disabledItems.indexOf(item) > -1;
  }

  ctrl.isDisabled = function(itemScope) {

    if (!ctrl.open) return;

    var item = itemScope[ctrl.itemProperty];
    var itemIndex = ctrl.items.indexOf(item);
    var isDisabled = false;

    if (itemIndex >= 0 && (angular.isDefined(ctrl.disableChoiceExpression) || ctrl.multiple)) {

      if (item.isTag) return false;

      if (ctrl.multiple) {
        isDisabled = _isItemSelected(item);
      }

      if (!isDisabled && angular.isDefined(ctrl.disableChoiceExpression)) {
        isDisabled = !!(itemScope.$eval(ctrl.disableChoiceExpression));
      }

      _updateItemDisabled(item, isDisabled);
    }

    return isDisabled;
  };


  // When the user selects an item with ENTER or clicks the dropdown
  ctrl.select = function(item, skipFocusser, $event) {
    if (isNil(item) || !_isItemDisabled(item)) {

      if ( ! ctrl.items && ! ctrl.search && ! ctrl.tagging.isActivated) return;

      if (!item || !_isItemDisabled(item)) {
        // if click is made on existing item, prevent from tagging, ctrl.search does not matter
        ctrl.clickTriggeredSelect = false;
        if($event && ($event.type === 'click' || $event.type === 'touchend') && item)
          ctrl.clickTriggeredSelect = true;

        if(ctrl.tagging.isActivated && ctrl.clickTriggeredSelect === false) {
          // if taggingLabel is disabled and item is undefined we pull from ctrl.search
          if ( ctrl.taggingLabel === false ) {
            if ( ctrl.activeIndex < 0 ) {
              if (item === undefined) {
                item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;
              }
              if (!item || angular.equals( ctrl.items[0], item ) ) {
                return;
              }
            } else {
              // keyboard nav happened first, user selected from dropdown
              item = ctrl.items[ctrl.activeIndex];
            }
          } else {
            // tagging always operates at index zero, taggingLabel === false pushes
            // the ctrl.search value without having it injected
            if ( ctrl.activeIndex === 0 ) {
              // ctrl.tagging pushes items to ctrl.items, so we only have empty val
              // for `item` if it is a detected duplicate
              if ( item === undefined ) return;

              // create new item on the fly if we don't already have one;
              // use tagging function if we have one
              if ( ctrl.tagging.fct !== undefined && typeof item === 'string' ) {
                item = ctrl.tagging.fct(item);
                if (!item) return;
              // if item type is 'string', apply the tagging label
              } else if ( typeof item === 'string' ) {
                // trim the trailing space
                item = item.replace(ctrl.taggingLabel,'').trim();
              }
            }
          }
          // search ctrl.selected for dupes potentially caused by tagging and return early if found
          if (_isItemSelected(item)) {
            ctrl.close(skipFocusser);
            return;
          }
        }
        _resetSearchInput();
        $scope.$broadcast('uis:select', item);

        if (ctrl.closeOnSelect) {
          ctrl.close(skipFocusser);
        }
      }
    }
  };

  // Closes the dropdown
  ctrl.close = function(skipFocusser) {
    if (!ctrl.open) return;
    if (ctrl.ngModel && ctrl.ngModel.$setTouched) ctrl.ngModel.$setTouched();
    ctrl.open = false;
    _resetSearchInput();
    $scope.$broadcast('uis:close', skipFocusser);

  };

  ctrl.setFocus = function(){
    if (!ctrl.focus) ctrl.focusInput[0].focus();
  };

  ctrl.clear = function($event) {
    ctrl.select(null);
    $event.stopPropagation();
    $timeout(function() {
      ctrl.focusser[0].focus();
    }, 0, false);
  };

  // Toggle dropdown
  ctrl.toggle = function(e) {
    if (ctrl.open) {
      ctrl.close();
      e.preventDefault();
      e.stopPropagation();
    } else {
      ctrl.activate();
    }
  };

  // Set default function for locked choices - avoids unnecessary
  // logic if functionality is not being used
  ctrl.isLocked = function () {
    return false;
  };

  $scope.$watch(function () {
    return angular.isDefined(ctrl.lockChoiceExpression) && ctrl.lockChoiceExpression !== "";
  }, _initaliseLockedChoices);

  function _initaliseLockedChoices(doInitalise) {
    if(!doInitalise) return;

    var lockedItems = [];

    function _updateItemLocked(item, isLocked) {
      var lockedItemIndex = lockedItems.indexOf(item);
      if (isLocked && lockedItemIndex === -1) {
        lockedItems.push(item);
        }

      if (!isLocked && lockedItemIndex > -1) {
        lockedItems.splice(lockedItemIndex, 1);
      }
    }

    function _isItemlocked(item) {
      return lockedItems.indexOf(item) > -1;
    }

    ctrl.isLocked = function (itemScope, itemIndex) {
      var isLocked = false,
          item = ctrl.selected[itemIndex];

      if(item) {
        if (itemScope) {
          isLocked = !!(itemScope.$eval(ctrl.lockChoiceExpression));
          _updateItemLocked(item, isLocked);
        } else {
          isLocked = _isItemlocked(item);
        }
      }

      return isLocked;
    };
  }


  var sizeWatch = null;
  var updaterScheduled = false;
  ctrl.sizeSearchInput = function() {

    var input = ctrl.searchInput[0],
        container = ctrl.$element[0],
        calculateContainerWidth = function() {
          // Return the container width only if the search input is visible
          return container.clientWidth * !!input.offsetParent;
        },
        updateIfVisible = function(containerWidth) {
          if (containerWidth === 0) {
            return false;
          }
          var inputWidth = containerWidth - input.offsetLeft;
          if (inputWidth < 50) inputWidth = containerWidth;
          ctrl.searchInput.css('width', inputWidth+'px');
          return true;
        };

    ctrl.searchInput.css('width', '10px');
    $timeout(function() { //Give tags time to render correctly
      if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
        sizeWatch = $scope.$watch(function() {
          if (!updaterScheduled) {
            updaterScheduled = true;
            $scope.$$postDigest(function() {
              updaterScheduled = false;
              if (updateIfVisible(calculateContainerWidth())) {
                sizeWatch();
                sizeWatch = null;
              }
            });
          }
        }, angular.noop);
      }
    });
  };

  function _handleDropDownSelection(key) {
    var processed = true;
    switch (key) {
      case KEY.DOWN:
        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
        else if (ctrl.activeIndex < ctrl.items.length - 1) {
          var idx = ++ctrl.activeIndex;
          while(_isItemDisabled(ctrl.items[idx]) && idx < ctrl.items.length) {
            ctrl.activeIndex = ++idx;
          }
        }
        break;
      case KEY.UP:
        var minActiveIndex = (ctrl.search.length === 0 && ctrl.tagging.isActivated) ? -1 : 0;
        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
        else if (ctrl.activeIndex > minActiveIndex) {
          var idxmin = --ctrl.activeIndex;
          while(_isItemDisabled(ctrl.items[idxmin]) && idxmin > minActiveIndex) {
            ctrl.activeIndex = --idxmin;
          }
        }
        break;
      case KEY.TAB:
        if (!ctrl.multiple || ctrl.open) ctrl.select(ctrl.items[ctrl.activeIndex], true);
        break;
      case KEY.ENTER:
        if(ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0)){
          ctrl.select(ctrl.items[ctrl.activeIndex], ctrl.skipFocusser); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
        } else {
          ctrl.activate(false, true); //In case its the search input in 'multiple' mode
        }
        break;
      case KEY.ESC:
        ctrl.close();
        break;
      default:
        processed = false;
    }
    return processed;
  }

  // Bind to keyboard shortcuts
  ctrl.searchInput.on('keydown', function(e) {

    var key = e.which;

    if (~[KEY.ENTER,KEY.ESC].indexOf(key)){
      e.preventDefault();
      e.stopPropagation();
    }

    $scope.$apply(function() {

      var tagged = false;

      if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
        if(!_handleDropDownSelection(key) && !ctrl.searchEnabled) {
          e.preventDefault();
          e.stopPropagation();
        }
        if ( ctrl.taggingTokens.isActivated ) {
          for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
            if ( ctrl.taggingTokens.tokens[i] === KEY.MAP[e.keyCode] ) {
              // make sure there is a new value to push via tagging
              if ( ctrl.search.length > 0 ) {
                tagged = true;
              }
            }
          }
          if ( tagged ) {
            $timeout(function() {
              ctrl.searchInput.triggerHandler('tagged');
              var newItem = ctrl.search.replace(KEY.MAP[e.keyCode],'').trim();
              if ( ctrl.tagging.fct ) {
                newItem = ctrl.tagging.fct( newItem );
              }
              if (newItem) ctrl.select(newItem, true);
            });
          }
        }
      }

    });

    if(KEY.isVerticalMovement(key) && ctrl.items.length > 0){
      _ensureHighlightVisible();
    }

    if (key === KEY.ENTER || key === KEY.ESC) {
      e.preventDefault();
      e.stopPropagation();
    }

  });

  ctrl.searchInput.on('paste', function (e) {
    var data;

    if (window.clipboardData && window.clipboardData.getData) { // IE
      data = window.clipboardData.getData('Text');
    } else {
      data = (e.originalEvent || e).clipboardData.getData('text/plain');
    }

    // Prepend the current input field text to the paste buffer.
    data = ctrl.search + data;

    if (data && data.length > 0) {
      // If tagging try to split by tokens and add items
      if (ctrl.taggingTokens.isActivated) {
        var items = [];
        for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {  // split by first token that is contained in data
          var separator = KEY.toSeparator(ctrl.taggingTokens.tokens[i]) || ctrl.taggingTokens.tokens[i];
          if (data.indexOf(separator) > -1) {
            items = data.split(separator);
            break;  // only split by one token
          }
        }
        if (items.length === 0) {
          items = [data];
        }
        var oldsearch = ctrl.search;
        angular.forEach(items, function (item) {
          var newItem = ctrl.tagging.fct ? ctrl.tagging.fct(item) : item;
          if (newItem) {
            ctrl.select(newItem, true);
          }
        });
        ctrl.search = oldsearch || EMPTY_SEARCH;
        e.preventDefault();
        e.stopPropagation();
      } else if (ctrl.paste) {
        ctrl.paste(data);
        ctrl.search = EMPTY_SEARCH;
        e.preventDefault();
        e.stopPropagation();
      }
    }
  });

  ctrl.searchInput.on('tagged', function() {
    $timeout(function() {
      _resetSearchInput();
    });
  });

  // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
  function _ensureHighlightVisible() {
    var container = $element.querySelectorAll('.ui-select-choices-content');
    var choices = container.querySelectorAll('.ui-select-choices-row');
    if (choices.length < 1) {
      throw uiSelectMinErr('choices', "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length);
    }

    if (ctrl.activeIndex < 0) {
      return;
    }

    var highlighted = choices[ctrl.activeIndex];
    var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
    var height = container[0].offsetHeight;

    if (posY > height) {
      container[0].scrollTop += posY - height;
    } else if (posY < highlighted.clientHeight) {
      if (ctrl.isGrouped && ctrl.activeIndex === 0)
        container[0].scrollTop = 0; //To make group header visible when going all the way up
      else
        container[0].scrollTop -= highlighted.clientHeight - posY;
    }
  }

  var onResize = $$uisDebounce(function() {
    ctrl.sizeSearchInput();
  }, 50);

  angular.element($window).bind('resize', onResize);

  $scope.$on('$destroy', function() {
    ctrl.searchInput.off('keyup keydown tagged blur paste');
    angular.element($window).off('resize', onResize);
  });

  $scope.$watch('$select.activeIndex', function(activeIndex) {
    if (activeIndex)
      $element.find('input').attr(
        'aria-activedescendant',
        'ui-select-choices-row-' + ctrl.generatedId + '-' + activeIndex);
  });

  $scope.$watch('$select.open', function(open) {
    if (!open)
      $element.find('input').removeAttr('aria-activedescendant');
  });
}]);

uis.directive('uiSelect',
  ['$document', 'uiSelectConfig', 'uiSelectMinErr', 'uisOffset', '$compile', '$parse', '$timeout',
  function($document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout) {

  return {
    restrict: 'EA',
    templateUrl: function(tElement, tAttrs) {
      var theme = tAttrs.theme || uiSelectConfig.theme;
      return theme + (angular.isDefined(tAttrs.multiple) ? '/select-multiple.tpl.html' : '/select.tpl.html');
    },
    replace: true,
    transclude: true,
    require: ['uiSelect', '^ngModel'],
    scope: true,

    controller: 'uiSelectCtrl',
    controllerAs: '$select',
    compile: function(tElement, tAttrs) {

      // Allow setting ngClass on uiSelect
      var match = /{(.*)}\s*{(.*)}/.exec(tAttrs.ngClass);
      if(match) {
        var combined = '{'+ match[1] +', '+ match[2] +'}';
        tAttrs.ngClass = combined;
        tElement.attr('ng-class', combined);
      }

      //Multiple or Single depending if multiple attribute presence
      if (angular.isDefined(tAttrs.multiple))
        tElement.append('<ui-select-multiple/>').removeAttr('multiple');
      else
        tElement.append('<ui-select-single/>');

      if (tAttrs.inputId)
        tElement.querySelectorAll('input.ui-select-search')[0].id = tAttrs.inputId;

      return function(scope, element, attrs, ctrls, transcludeFn) {

        var $select = ctrls[0];
        var ngModel = ctrls[1];

        $select.generatedId = uiSelectConfig.generateId();
        $select.baseTitle = attrs.title || 'Select box';
        $select.focusserTitle = $select.baseTitle + ' focus';
        $select.focusserId = 'focusser-' + $select.generatedId;

        $select.closeOnSelect = function() {
          if (angular.isDefined(attrs.closeOnSelect)) {
            return $parse(attrs.closeOnSelect)();
          } else {
            return uiSelectConfig.closeOnSelect;
          }
        }();

        scope.$watch('skipFocusser', function() {
            var skipFocusser = scope.$eval(attrs.skipFocusser);
            $select.skipFocusser = skipFocusser !== undefined ? skipFocusser : uiSelectConfig.skipFocusser;
        });

        $select.onSelectCallback = $parse(attrs.onSelect);
        $select.onRemoveCallback = $parse(attrs.onRemove);

        //Set reference to ngModel from uiSelectCtrl
        $select.ngModel = ngModel;

        $select.choiceGrouped = function(group){
          return $select.isGrouped && group && group.name;
        };

        if(attrs.tabindex){
          attrs.$observe('tabindex', function(value) {
            $select.focusInput.attr('tabindex', value);
            element.removeAttr('tabindex');
          });
        }

        scope.$watch(function () { return scope.$eval(attrs.searchEnabled); }, function(newVal) {
          $select.searchEnabled = newVal !== undefined ? newVal : uiSelectConfig.searchEnabled;
        });

        scope.$watch('sortable', function() {
            var sortable = scope.$eval(attrs.sortable);
            $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
        });

        attrs.$observe('backspaceReset', function() {
          // $eval() is needed otherwise we get a string instead of a boolean
          var backspaceReset = scope.$eval(attrs.backspaceReset);
          $select.backspaceReset = backspaceReset !== undefined ? backspaceReset : true;
        });

        attrs.$observe('limit', function() {
          //Limit the number of selections allowed
          $select.limit = (angular.isDefined(attrs.limit)) ? parseInt(attrs.limit, 10) : undefined;
        });

        scope.$watch('removeSelected', function() {
            var removeSelected = scope.$eval(attrs.removeSelected);
            $select.removeSelected = removeSelected !== undefined ? removeSelected : uiSelectConfig.removeSelected;
        });

        attrs.$observe('disabled', function() {
          // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
          $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
        });

        attrs.$observe('resetSearchInput', function() {
          // $eval() is needed otherwise we get a string instead of a boolean
          var resetSearchInput = scope.$eval(attrs.resetSearchInput);
          $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
        });

        attrs.$observe('paste', function() {
          $select.paste = scope.$eval(attrs.paste);
        });

        attrs.$observe('tagging', function() {
          if(attrs.tagging !== undefined)
          {
            // $eval() is needed otherwise we get a string instead of a boolean
            var taggingEval = scope.$eval(attrs.tagging);
            $select.tagging = {isActivated: true, fct: taggingEval !== true ? taggingEval : undefined};
          }
          else
          {
            $select.tagging = {isActivated: false, fct: undefined};
          }
        });

        attrs.$observe('taggingLabel', function() {
          if(attrs.tagging !== undefined )
          {
            // check eval for FALSE, in this case, we disable the labels
            // associated with tagging
            if ( attrs.taggingLabel === 'false' ) {
              $select.taggingLabel = false;
            }
            else
            {
              $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
            }
          }
        });

        attrs.$observe('taggingTokens', function() {
          if (attrs.tagging !== undefined) {
            var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split('|') : [',','ENTER'];
            $select.taggingTokens = {isActivated: true, tokens: tokens };
          }
        });

        attrs.$observe('spinnerEnabled', function() {
          // $eval() is needed otherwise we get a string instead of a boolean
          var spinnerEnabled = scope.$eval(attrs.spinnerEnabled);
          $select.spinnerEnabled = spinnerEnabled !== undefined ? spinnerEnabled : uiSelectConfig.spinnerEnabled;
        });

        attrs.$observe('spinnerClass', function() {
          var spinnerClass = attrs.spinnerClass;
          $select.spinnerClass = spinnerClass !== undefined ? attrs.spinnerClass : uiSelectConfig.spinnerClass;
        });

        //Automatically gets focus when loaded
        if (angular.isDefined(attrs.autofocus)){
          $timeout(function(){
            $select.setFocus();
          });
        }

        //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
        if (angular.isDefined(attrs.focusOn)){
          scope.$on(attrs.focusOn, function() {
              $timeout(function(){
                $select.setFocus();
              });
          });
        }

        function onDocumentClick(e) {
          if (!$select.open) return; //Skip it if dropdown is close

          var contains = false;

          if (window.jQuery) {
            // Firefox 3.6 does not support element.contains()
            // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
            contains = window.jQuery.contains(element[0], e.target);
          } else {
            contains = element[0].contains(e.target);
          }

          if (!contains && !$select.clickTriggeredSelect) {
            var skipFocusser;
            if (!$select.skipFocusser) {
              //Will lose focus only with certain targets
              var focusableControls = ['input','button','textarea','select'];
              var targetController = angular.element(e.target).controller('uiSelect'); //To check if target is other ui-select
              skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select
              if (!skipFocusser) skipFocusser =  ~focusableControls.indexOf(e.target.tagName.toLowerCase()); //Check if target is input, button or textarea
            } else {
              skipFocusser = true;
            }
            $select.close(skipFocusser);
            scope.$digest();
          }
          $select.clickTriggeredSelect = false;
        }

        // See Click everywhere but here event http://stackoverflow.com/questions/12931369
        $document.on('click', onDocumentClick);

        scope.$on('$destroy', function() {
          $document.off('click', onDocumentClick);
        });

        // Move transcluded elements to their correct position in main template
        transcludeFn(scope, function(clone) {
          // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html

          // One day jqLite will be replaced by jQuery and we will be able to write:
          // var transcludedElement = clone.filter('.my-class')
          // instead of creating a hackish DOM element:
          var transcluded = angular.element('<div>').append(clone);

          var transcludedMatch = transcluded.querySelectorAll('.ui-select-match');
          transcludedMatch.removeAttr('ui-select-match'); //To avoid loop in case directive as attr
          transcludedMatch.removeAttr('data-ui-select-match'); // Properly handle HTML5 data-attributes
          if (transcludedMatch.length !== 1) {
            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length);
          }
          element.querySelectorAll('.ui-select-match').replaceWith(transcludedMatch);

          var transcludedChoices = transcluded.querySelectorAll('.ui-select-choices');
          transcludedChoices.removeAttr('ui-select-choices'); //To avoid loop in case directive as attr
          transcludedChoices.removeAttr('data-ui-select-choices'); // Properly handle HTML5 data-attributes
          if (transcludedChoices.length !== 1) {
            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length);
          }
          element.querySelectorAll('.ui-select-choices').replaceWith(transcludedChoices);

          var transcludedNoChoice = transcluded.querySelectorAll('.ui-select-no-choice');
          transcludedNoChoice.removeAttr('ui-select-no-choice'); //To avoid loop in case directive as attr
          transcludedNoChoice.removeAttr('data-ui-select-no-choice'); // Properly handle HTML5 data-attributes
          if (transcludedNoChoice.length == 1) {
            element.querySelectorAll('.ui-select-no-choice').replaceWith(transcludedNoChoice);
          }
        });

        // Support for appending the select field to the body when its open
        var appendToBody = scope.$eval(attrs.appendToBody);
        if (appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody) {
          scope.$watch('$select.open', function(isOpen) {
            if (isOpen) {
              positionDropdown();
            } else {
              resetDropdown();
            }
          });

          // Move the dropdown back to its original location when the scope is destroyed. Otherwise
          // it might stick around when the user routes away or the select field is otherwise removed
          scope.$on('$destroy', function() {
            resetDropdown();
          });
        }

        // Hold on to a reference to the .ui-select-container element for appendToBody support
        var placeholder = null,
            originalWidth = '';

        function positionDropdown() {
          // Remember the absolute position of the element
          var offset = uisOffset(element);

          // Clone the element into a placeholder element to take its original place in the DOM
          placeholder = angular.element('<div class="ui-select-placeholder"></div>');
          placeholder[0].style.width = offset.width + 'px';
          placeholder[0].style.height = offset.height + 'px';
          element.after(placeholder);

          // Remember the original value of the element width inline style, so it can be restored
          // when the dropdown is closed
          originalWidth = element[0].style.width;

          // Now move the actual dropdown element to the end of the body
          $document.find('body').append(element);

          element[0].style.position = 'absolute';
          element[0].style.left = offset.left + 'px';
          element[0].style.top = offset.top + 'px';
          element[0].style.width = offset.width + 'px';
        }

        function resetDropdown() {
          if (placeholder === null) {
            // The dropdown has not actually been display yet, so there's nothing to reset
            return;
          }

          // Move the dropdown element back to its original location in the DOM
          placeholder.replaceWith(element);
          placeholder = null;

          element[0].style.position = '';
          element[0].style.left = '';
          element[0].style.top = '';
          element[0].style.width = originalWidth;

          // Set focus back on to the moved element
          $select.setFocus();
        }

        // Hold on to a reference to the .ui-select-dropdown element for direction support.
        var dropdown = null,
            directionUpClassName = 'direction-up';

        // Support changing the direction of the dropdown if there isn't enough space to render it.
        scope.$watch('$select.open', function() {

          if ($select.dropdownPosition === 'auto' || $select.dropdownPosition === 'up'){
            scope.calculateDropdownPos();
          }

        });

        var setDropdownPosUp = function(offset, offsetDropdown){

          offset = offset || uisOffset(element);
          offsetDropdown = offsetDropdown || uisOffset(dropdown);

          dropdown[0].style.position = 'absolute';
          dropdown[0].style.top = (offsetDropdown.height * -1) + 'px';
          element.addClass(directionUpClassName);

        };

        var setDropdownPosDown = function(offset, offsetDropdown){

          element.removeClass(directionUpClassName);

          offset = offset || uisOffset(element);
          offsetDropdown = offsetDropdown || uisOffset(dropdown);

          dropdown[0].style.position = '';
          dropdown[0].style.top = '';

        };

        var calculateDropdownPosAfterAnimation = function() {
          // Delay positioning the dropdown until all choices have been added so its height is correct.
          $timeout(function() {
            if ($select.dropdownPosition === 'up') {
              //Go UP
              setDropdownPosUp();
            } else {
              //AUTO
              element.removeClass(directionUpClassName);

              var offset = uisOffset(element);
              var offsetDropdown = uisOffset(dropdown);

              //https://code.google.com/p/chromium/issues/detail?id=342307#c4
              var scrollTop = $document[0].documentElement.scrollTop || $document[0].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).

              // Determine if the direction of the dropdown needs to be changed.
              if (offset.top + offset.height + offsetDropdown.height > scrollTop + $document[0].documentElement.clientHeight) {
                //Go UP
                setDropdownPosUp(offset, offsetDropdown);
              }else{
                //Go DOWN
                setDropdownPosDown(offset, offsetDropdown);
              }
            }

            // Display the dropdown once it has been positioned.
            dropdown[0].style.opacity = 1;
          });
        };

        var opened = false;
        
        scope.calculateDropdownPos = function() {
          if ($select.open) {
            dropdown = angular.element(element).querySelectorAll('.ui-select-dropdown');

            if (dropdown.length === 0) {
              return;
            }

           // Hide the dropdown so there is no flicker until $timeout is done executing.
           if ($select.search === '' && !opened) {
              dropdown[0].style.opacity = 0;
              opened = true;
           }

            if (!uisOffset(dropdown).height && $select.$animate && $select.$animate.on && $select.$animate.enabled(dropdown)) {
              var needsCalculated = true;

              $select.$animate.on('enter', dropdown, function (elem, phase) {
                if (phase === 'close' && needsCalculated) {
                  calculateDropdownPosAfterAnimation();
                  needsCalculated = false;
                }
              });
            } else {
              calculateDropdownPosAfterAnimation();
            }
          } else {
            if (dropdown === null || dropdown.length === 0) {
              return;
            }

            // Reset the position of the dropdown.
            dropdown[0].style.opacity = 0;
            dropdown[0].style.position = '';
            dropdown[0].style.top = '';
            element.removeClass(directionUpClassName);
          }
        };
      };
    }
  };
}]);

uis.directive('uiSelectMatch', ['uiSelectConfig', function(uiSelectConfig) {
  return {
    restrict: 'EA',
    require: '^uiSelect',
    replace: true,
    transclude: true,
    templateUrl: function(tElement) {
      // Needed so the uiSelect can detect the transcluded content
      tElement.addClass('ui-select-match');

      var parent = tElement.parent();
      // Gets theme attribute from parent (ui-select)
      var theme = getAttribute(parent, 'theme') || uiSelectConfig.theme;
      var multi = angular.isDefined(getAttribute(parent, 'multiple'));

      return theme + (multi ? '/match-multiple.tpl.html' : '/match.tpl.html');      
    },
    link: function(scope, element, attrs, $select) {
      $select.lockChoiceExpression = attrs.uiLockChoice;
      attrs.$observe('placeholder', function(placeholder) {
        $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
      });

      function setAllowClear(allow) {
        $select.allowClear = (angular.isDefined(allow)) ? (allow === '') ? true : (allow.toLowerCase() === 'true') : false;
      }

      attrs.$observe('allowClear', setAllowClear);
      setAllowClear(attrs.allowClear);

      if($select.multiple){
        $select.sizeSearchInput();
      }

    }
  };

  function getAttribute(elem, attribute) {
    if (elem[0].hasAttribute(attribute))
      return elem.attr(attribute);

    if (elem[0].hasAttribute('data-' + attribute))
      return elem.attr('data-' + attribute);

    if (elem[0].hasAttribute('x-' + attribute))
      return elem.attr('x-' + attribute);
  }
}]);

uis.directive('uiSelectMultiple', ['uiSelectMinErr','$timeout', function(uiSelectMinErr, $timeout) {
  return {
    restrict: 'EA',
    require: ['^uiSelect', '^ngModel'],

    controller: ['$scope','$timeout', function($scope, $timeout){

      var ctrl = this,
          $select = $scope.$select,
          ngModel;

      if (angular.isUndefined($select.selected))
        $select.selected = [];

      //Wait for link fn to inject it
      $scope.$evalAsync(function(){ ngModel = $scope.ngModel; });

      ctrl.activeMatchIndex = -1;

      ctrl.updateModel = function(){
        ngModel.$setViewValue(Date.now()); //Set timestamp as a unique string to force changes
        ctrl.refreshComponent();
      };

      ctrl.refreshComponent = function(){
        //Remove already selected items
        //e.g. When user clicks on a selection, the selected array changes and
        //the dropdown should remove that item
        if($select.refreshItems){
          $select.refreshItems();
        }
        if($select.sizeSearchInput){
          $select.sizeSearchInput();
        }
      };

      // Remove item from multiple select
      ctrl.removeChoice = function(index){

        // if the choice is locked, don't remove it
        if($select.isLocked(null, index)) return false;

        var removedChoice = $select.selected[index];

        var locals = {};
        locals[$select.parserResult.itemName] = removedChoice;

        $select.selected.splice(index, 1);
        ctrl.activeMatchIndex = -1;
        $select.sizeSearchInput();

        // Give some time for scope propagation.
        $timeout(function(){
          $select.onRemoveCallback($scope, {
            $item: removedChoice,
            $model: $select.parserResult.modelMapper($scope, locals)
          });
        });

        ctrl.updateModel();

        return true;
      };

      ctrl.getPlaceholder = function(){
        //Refactor single?
        if($select.selected && $select.selected.length) return;
        return $select.placeholder;
      };


    }],
    controllerAs: '$selectMultiple',

    link: function(scope, element, attrs, ctrls) {

      var $select = ctrls[0];
      var ngModel = scope.ngModel = ctrls[1];
      var $selectMultiple = scope.$selectMultiple;

      //$select.selected = raw selected objects (ignoring any property binding)

      $select.multiple = true;

      //Input that will handle focus
      $select.focusInput = $select.searchInput;

      //Properly check for empty if set to multiple
      ngModel.$isEmpty = function(value) {
        return !value || value.length === 0;
      };

      //From view --> model
      ngModel.$parsers.unshift(function () {
        var locals = {},
            result,
            resultMultiple = [];
        for (var j = $select.selected.length - 1; j >= 0; j--) {
          locals = {};
          locals[$select.parserResult.itemName] = $select.selected[j];
          result = $select.parserResult.modelMapper(scope, locals);
          resultMultiple.unshift(result);
        }
        return resultMultiple;
      });

      // From model --> view
      ngModel.$formatters.unshift(function (inputValue) {
        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
            locals = {},
            result;
        if (!data) return inputValue;
        var resultMultiple = [];
        var checkFnMultiple = function(list, value){
          if (!list || !list.length) return;
          for (var p = list.length - 1; p >= 0; p--) {
            locals[$select.parserResult.itemName] = list[p];
            result = $select.parserResult.modelMapper(scope, locals);
            if($select.parserResult.trackByExp){
                var propsItemNameMatches = /(\w*)\./.exec($select.parserResult.trackByExp);
                var matches = /\.([^\s]+)/.exec($select.parserResult.trackByExp);
                if(propsItemNameMatches && propsItemNameMatches.length > 0 && propsItemNameMatches[1] == $select.parserResult.itemName){
                  if(matches && matches.length>0 && result[matches[1]] == value[matches[1]]){
                      resultMultiple.unshift(list[p]);
                      return true;
                  }
                }
            }
            if (angular.equals(result,value)){
              resultMultiple.unshift(list[p]);
              return true;
            }
          }
          return false;
        };
        if (!inputValue) return resultMultiple; //If ngModel was undefined
        for (var k = inputValue.length - 1; k >= 0; k--) {
          //Check model array of currently selected items
          if (!checkFnMultiple($select.selected, inputValue[k])){
            //Check model array of all items available
            if (!checkFnMultiple(data, inputValue[k])){
              //If not found on previous lists, just add it directly to resultMultiple
              resultMultiple.unshift(inputValue[k]);
            }
          }
        }
        return resultMultiple;
      });

      //Watch for external model changes
      scope.$watchCollection(function(){ return ngModel.$modelValue; }, function(newValue, oldValue) {
        if (oldValue != newValue){
          //update the view value with fresh data from items, if there is a valid model value
          if(angular.isDefined(ngModel.$modelValue)) {
            ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
          }
          $selectMultiple.refreshComponent();
        }
      });

      ngModel.$render = function() {
        // Make sure that model value is array
        if(!angular.isArray(ngModel.$viewValue)){
          // Have tolerance for null or undefined values
          if (isNil(ngModel.$viewValue)){
            ngModel.$viewValue = [];
          } else {
            throw uiSelectMinErr('multiarr', "Expected model value to be array but got '{0}'", ngModel.$viewValue);
          }
        }
        $select.selected = ngModel.$viewValue;
        $selectMultiple.refreshComponent();
        scope.$evalAsync(); //To force $digest
      };

      scope.$on('uis:select', function (event, item) {
        if($select.selected.length >= $select.limit) {
          return;
        }
        $select.selected.push(item);
        var locals = {};
        locals[$select.parserResult.itemName] = item;

        $timeout(function(){
          $select.onSelectCallback(scope, {
            $item: item,
            $model: $select.parserResult.modelMapper(scope, locals)
          });
        });
        $selectMultiple.updateModel();
      });

      scope.$on('uis:activate', function () {
        $selectMultiple.activeMatchIndex = -1;
      });

      scope.$watch('$select.disabled', function(newValue, oldValue) {
        // As the search input field may now become visible, it may be necessary to recompute its size
        if (oldValue && !newValue) $select.sizeSearchInput();
      });

      $select.searchInput.on('keydown', function(e) {
        var key = e.which;
        scope.$apply(function() {
          var processed = false;
          // var tagged = false; //Checkme
          if(KEY.isHorizontalMovement(key)){
            processed = _handleMatchSelection(key);
          }
          if (processed  && key != KEY.TAB) {
            //TODO Check si el tab selecciona aun correctamente
            //Crear test
            e.preventDefault();
            e.stopPropagation();
          }
        });
      });
      function _getCaretPosition(el) {
        if(angular.isNumber(el.selectionStart)) return el.selectionStart;
        // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
        else return el.value.length;
      }
      // Handles selected options in "multiple" mode
      function _handleMatchSelection(key){
        var caretPosition = _getCaretPosition($select.searchInput[0]),
            length = $select.selected.length,
            // none  = -1,
            first = 0,
            last  = length-1,
            curr  = $selectMultiple.activeMatchIndex,
            next  = $selectMultiple.activeMatchIndex+1,
            prev  = $selectMultiple.activeMatchIndex-1,
            newIndex = curr;

        if(caretPosition > 0 || ($select.search.length && key == KEY.RIGHT)) return false;

        $select.close();

        function getNewActiveMatchIndex(){
          switch(key){
            case KEY.LEFT:
              // Select previous/first item
              if(~$selectMultiple.activeMatchIndex) return prev;
              // Select last item
              else return last;
              break;
            case KEY.RIGHT:
              // Open drop-down
              if(!~$selectMultiple.activeMatchIndex || curr === last){
                $select.activate();
                return false;
              }
              // Select next/last item
              else return next;
              break;
            case KEY.BACKSPACE:
              // Remove selected item and select previous/first
              if(~$selectMultiple.activeMatchIndex){
                if($selectMultiple.removeChoice(curr)) {
                  return prev;
                } else {
                  return curr;
                }

              } else {
                // If nothing yet selected, select last item
                return last;
              }
              break;
            case KEY.DELETE:
              // Remove selected item and select next item
              if(~$selectMultiple.activeMatchIndex){
                $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);
                return curr;
              }
              else return false;
          }
        }

        newIndex = getNewActiveMatchIndex();

        if(!$select.selected.length || newIndex === false) $selectMultiple.activeMatchIndex = -1;
        else $selectMultiple.activeMatchIndex = Math.min(last,Math.max(first,newIndex));

        return true;
      }

      $select.searchInput.on('keyup', function(e) {

        if ( ! KEY.isVerticalMovement(e.which) ) {
          scope.$evalAsync( function () {
            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
          });
        }
        // Push a "create new" item into array if there is a search string
        if ( $select.tagging.isActivated && $select.search.length > 0 ) {

          // return early with these keys
          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || KEY.isVerticalMovement(e.which) ) {
            return;
          }
          // always reset the activeIndex to the first item when tagging
          $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
          // taggingLabel === false bypasses all of this
          if ($select.taggingLabel === false) return;

          var items = angular.copy( $select.items );
          var stashArr = angular.copy( $select.items );
          var newItem;
          var item;
          var hasTag = false;
          var dupeIndex = -1;
          var tagItems;
          var tagItem;

          // case for object tagging via transform `$select.tagging.fct` function
          if ( $select.tagging.fct !== undefined) {
            tagItems = $select.$filter('filter')(items,{'isTag': true});
            if ( tagItems.length > 0 ) {
              tagItem = tagItems[0];
            }
            // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
            if ( items.length > 0 && tagItem ) {
              hasTag = true;
              items = items.slice(1,items.length);
              stashArr = stashArr.slice(1,stashArr.length);
            }
            newItem = $select.tagging.fct($select.search);
            // verify the new tag doesn't match the value of a possible selection choice or an already selected item.
            if (
              stashArr.some(function (origItem) {
                 return angular.equals(origItem, newItem);
              }) ||
              $select.selected.some(function (origItem) {
                return angular.equals(origItem, newItem);
              })
            ) {
              scope.$evalAsync(function () {
                $select.activeIndex = 0;
                $select.items = items;
              });
              return;
            }
            if (newItem) newItem.isTag = true;
          // handle newItem string and stripping dupes in tagging string context
          } else {
            // find any tagging items already in the $select.items array and store them
            tagItems = $select.$filter('filter')(items,function (item) {
              return item.match($select.taggingLabel);
            });
            if ( tagItems.length > 0 ) {
              tagItem = tagItems[0];
            }
            item = items[0];
            // remove existing tag item if found (should only ever be one tag item)
            if ( item !== undefined && items.length > 0 && tagItem ) {
              hasTag = true;
              items = items.slice(1,items.length);
              stashArr = stashArr.slice(1,stashArr.length);
            }
            newItem = $select.search+' '+$select.taggingLabel;
            if ( _findApproxDupe($select.selected, $select.search) > -1 ) {
              return;
            }
            // verify the the tag doesn't match the value of an existing item from
            // the searched data set or the items already selected
            if ( _findCaseInsensitiveDupe(stashArr.concat($select.selected)) ) {
              // if there is a tag from prev iteration, strip it / queue the change
              // and return early
              if ( hasTag ) {
                items = stashArr;
                scope.$evalAsync( function () {
                  $select.activeIndex = 0;
                  $select.items = items;
                });
              }
              return;
            }
            if ( _findCaseInsensitiveDupe(stashArr) ) {
              // if there is a tag from prev iteration, strip it
              if ( hasTag ) {
                $select.items = stashArr.slice(1,stashArr.length);
              }
              return;
            }
          }
          if ( hasTag ) dupeIndex = _findApproxDupe($select.selected, newItem);
          // dupe found, shave the first item
          if ( dupeIndex > -1 ) {
            items = items.slice(dupeIndex+1,items.length-1);
          } else {
            items = [];
            if (newItem) items.push(newItem);
            items = items.concat(stashArr);
          }
          scope.$evalAsync( function () {
            $select.activeIndex = 0;
            $select.items = items;

            if ($select.isGrouped) {
              // update item references in groups, so that indexOf will work after angular.copy
              var itemsWithoutTag = newItem ? items.slice(1) : items;
              $select.setItemsFn(itemsWithoutTag);
              if (newItem) {
                // add tag item as a new group
                $select.items.unshift(newItem);
                $select.groups.unshift({name: '', items: [newItem], tagging: true});
              }
            }
          });
        }
      });
      function _findCaseInsensitiveDupe(arr) {
        if ( arr === undefined || $select.search === undefined ) {
          return false;
        }
        var hasDupe = arr.filter( function (origItem) {
          if ( $select.search.toUpperCase() === undefined || origItem === undefined ) {
            return false;
          }
          return origItem.toUpperCase() === $select.search.toUpperCase();
        }).length > 0;

        return hasDupe;
      }
      function _findApproxDupe(haystack, needle) {
        var dupeIndex = -1;
        if(angular.isArray(haystack)) {
          var tempArr = angular.copy(haystack);
          for (var i = 0; i <tempArr.length; i++) {
            // handle the simple string version of tagging
            if ( $select.tagging.fct === undefined ) {
              // search the array for the match
              if ( tempArr[i]+' '+$select.taggingLabel === needle ) {
              dupeIndex = i;
              }
            // handle the object tagging implementation
            } else {
              var mockObj = tempArr[i];
              if (angular.isObject(mockObj)) {
                mockObj.isTag = true;
              }
              if ( angular.equals(mockObj, needle) ) {
                dupeIndex = i;
              }
            }
          }
        }
        return dupeIndex;
      }

      $select.searchInput.on('blur', function() {
        $timeout(function() {
          $selectMultiple.activeMatchIndex = -1;
        });
      });

    }
  };
}]);

uis.directive('uiSelectNoChoice',
    ['uiSelectConfig', function (uiSelectConfig) {
        return {
            restrict: 'EA',
            require: '^uiSelect',
            replace: true,
            transclude: true,
            templateUrl: function (tElement) {
                // Needed so the uiSelect can detect the transcluded content
                tElement.addClass('ui-select-no-choice');
      
                // Gets theme attribute from parent (ui-select)
                var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
                return theme + '/no-choice.tpl.html';
            }
        };
    }]);

uis.directive('uiSelectSingle', ['$timeout','$compile', function($timeout, $compile) {
  return {
    restrict: 'EA',
    require: ['^uiSelect', '^ngModel'],
    link: function(scope, element, attrs, ctrls) {

      var $select = ctrls[0];
      var ngModel = ctrls[1];

      //From view --> model
      ngModel.$parsers.unshift(function (inputValue) {
        // Keep original value for undefined and null
        if (isNil(inputValue)) {
          return inputValue;
        }

        var locals = {},
            result;
        locals[$select.parserResult.itemName] = inputValue;
        result = $select.parserResult.modelMapper(scope, locals);
        return result;
      });

      //From model --> view
      ngModel.$formatters.unshift(function (inputValue) {
        // Keep original value for undefined and null
        if (isNil(inputValue)) {
          return inputValue;
        }

        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
            locals = {},
            result;
        if (data){
          var checkFnSingle = function(d){
            locals[$select.parserResult.itemName] = d;
            result = $select.parserResult.modelMapper(scope, locals);
            return result === inputValue;
          };
          //If possible pass same object stored in $select.selected
          if ($select.selected && checkFnSingle($select.selected)) {
            return $select.selected;
          }
          for (var i = data.length - 1; i >= 0; i--) {
            if (checkFnSingle(data[i])) return data[i];
          }
        }
        return inputValue;
      });

      //Update viewValue if model change
      scope.$watch('$select.selected', function(newValue) {
        if (ngModel.$viewValue !== newValue) {
          ngModel.$setViewValue(newValue);
        }
      });

      ngModel.$render = function() {
        $select.selected = ngModel.$viewValue;
      };

      scope.$on('uis:select', function (event, item) {
        $select.selected = item;
        var locals = {};
        locals[$select.parserResult.itemName] = item;

        $timeout(function() {
          $select.onSelectCallback(scope, {
            $item: item,
            $model: isNil(item) ? item : $select.parserResult.modelMapper(scope, locals)
          });
        });
      });

      scope.$on('uis:close', function (event, skipFocusser) {
        $timeout(function(){
          $select.focusser.prop('disabled', false);
          if (!skipFocusser) $select.focusser[0].focus();
        },0,false);
      });

      scope.$on('uis:activate', function () {
        focusser.prop('disabled', true); //Will reactivate it on .close()
      });

      //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
      var focusser = angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");
      $compile(focusser)(scope);
      $select.focusser = focusser;

      //Input that will handle focus
      $select.focusInput = focusser;

      element.parent().append(focusser);
      focusser.bind("focus", function(){
        scope.$evalAsync(function(){
          $select.focus = true;
        });
      });
      focusser.bind("blur", function(){
        scope.$evalAsync(function(){
          $select.focus = false;
        });
      });
      focusser.bind("keydown", function(e){

        if (e.which === KEY.BACKSPACE && $select.backspaceReset !== false) {
          e.preventDefault();
          e.stopPropagation();
          $select.select(undefined);
          scope.$apply();
          return;
        }

        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
          return;
        }

        if (e.which == KEY.DOWN  || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE){
          e.preventDefault();
          e.stopPropagation();
          $select.activate();
        }

        scope.$digest();
      });

      focusser.bind("keyup input", function(e){

        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE) {
          return;
        }

        $select.activate(focusser.val()); //User pressed some regular key, so we pass it to the search input
        focusser.val('');
        scope.$digest();

      });


    }
  };
}]);

// Make multiple matches sortable
uis.directive('uiSelectSort', ['$timeout', 'uiSelectConfig', 'uiSelectMinErr', function($timeout, uiSelectConfig, uiSelectMinErr) {
  return {
    require: ['^^uiSelect', '^ngModel'],
    link: function(scope, element, attrs, ctrls) {
      if (scope[attrs.uiSelectSort] === null) {
        throw uiSelectMinErr('sort', 'Expected a list to sort');
      }

      var $select = ctrls[0];
      var $ngModel = ctrls[1];

      var options = angular.extend({
          axis: 'horizontal'
        },
        scope.$eval(attrs.uiSelectSortOptions));

      var axis = options.axis;
      var draggingClassName = 'dragging';
      var droppingClassName = 'dropping';
      var droppingBeforeClassName = 'dropping-before';
      var droppingAfterClassName = 'dropping-after';

      scope.$watch(function(){
        return $select.sortable;
      }, function(newValue){
        if (newValue) {
          element.attr('draggable', true);
        } else {
          element.removeAttr('draggable');
        }
      });

      element.on('dragstart', function(event) {
        element.addClass(draggingClassName);

        (event.dataTransfer || event.originalEvent.dataTransfer).setData('text', scope.$index.toString());
      });

      element.on('dragend', function() {
        removeClass(draggingClassName);
      });

      var move = function(from, to) {
        /*jshint validthis: true */
        this.splice(to, 0, this.splice(from, 1)[0]);
      };

      var removeClass = function(className) {
        angular.forEach($select.$element.querySelectorAll('.' + className), function(el){
          angular.element(el).removeClass(className);
        });
      };

      var dragOverHandler = function(event) {
        event.preventDefault();

        var offset = axis === 'vertical' ? event.offsetY || event.layerY || (event.originalEvent ? event.originalEvent.offsetY : 0) : event.offsetX || event.layerX || (event.originalEvent ? event.originalEvent.offsetX : 0);

        if (offset < (this[axis === 'vertical' ? 'offsetHeight' : 'offsetWidth'] / 2)) {
          removeClass(droppingAfterClassName);
          element.addClass(droppingBeforeClassName);

        } else {
          removeClass(droppingBeforeClassName);
          element.addClass(droppingAfterClassName);
        }
      };

      var dropTimeout;

      var dropHandler = function(event) {
        event.preventDefault();

        var droppedItemIndex = parseInt((event.dataTransfer || event.originalEvent.dataTransfer).getData('text'), 10);

        // prevent event firing multiple times in firefox
        $timeout.cancel(dropTimeout);
        dropTimeout = $timeout(function() {
          _dropHandler(droppedItemIndex);
        }, 20);
      };

      var _dropHandler = function(droppedItemIndex) {
        var theList = scope.$eval(attrs.uiSelectSort);
        var itemToMove = theList[droppedItemIndex];
        var newIndex = null;

        if (element.hasClass(droppingBeforeClassName)) {
          if (droppedItemIndex < scope.$index) {
            newIndex = scope.$index - 1;
          } else {
            newIndex = scope.$index;
          }
        } else {
          if (droppedItemIndex < scope.$index) {
            newIndex = scope.$index;
          } else {
            newIndex = scope.$index + 1;
          }
        }

        move.apply(theList, [droppedItemIndex, newIndex]);

        $ngModel.$setViewValue(Date.now());

        scope.$apply(function() {
          scope.$emit('uiSelectSort:change', {
            array: theList,
            item: itemToMove,
            from: droppedItemIndex,
            to: newIndex
          });
        });

        removeClass(droppingClassName);
        removeClass(droppingBeforeClassName);
        removeClass(droppingAfterClassName);

        element.off('drop', dropHandler);
      };

      element.on('dragenter', function() {
        if (element.hasClass(draggingClassName)) {
          return;
        }

        element.addClass(droppingClassName);

        element.on('dragover', dragOverHandler);
        element.on('drop', dropHandler);
      });

      element.on('dragleave', function(event) {
        if (event.target != element) {
          return;
        }

        removeClass(droppingClassName);
        removeClass(droppingBeforeClassName);
        removeClass(droppingAfterClassName);

        element.off('dragover', dragOverHandler);
        element.off('drop', dropHandler);
      });
    }
  };
}]);

/**
 * Debounces functions
 *
 * Taken from UI Bootstrap $$debounce source code
 * See https://github.com/angular-ui/bootstrap/blob/master/src/debounce/debounce.js
 *
 */
uis.factory('$$uisDebounce', ['$timeout', function($timeout) {
  return function(callback, debounceTime) {
    var timeoutPromise;

    return function() {
      var self = this;
      var args = Array.prototype.slice.call(arguments);
      if (timeoutPromise) {
        $timeout.cancel(timeoutPromise);
      }

      timeoutPromise = $timeout(function() {
        callback.apply(self, args);
      }, debounceTime);
    };
  };
}]);

uis.directive('uisOpenClose', ['$parse', '$timeout', function ($parse, $timeout) {
  return {
    restrict: 'A',
    require: 'uiSelect',
    link: function (scope, element, attrs, $select) {
      $select.onOpenCloseCallback = $parse(attrs.uisOpenClose);

      scope.$watch('$select.open', function (isOpen, previousState) {
        if (isOpen !== previousState) {
          $timeout(function () {
            $select.onOpenCloseCallback(scope, {
              isOpen: isOpen
            });
          });
        }
      });
    }
  };
}]);

/**
 * Parses "repeat" attribute.
 *
 * Taken from AngularJS ngRepeat source code
 * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
 *
 * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
 * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
 */

uis.service('uisRepeatParser', ['uiSelectMinErr','$parse', function(uiSelectMinErr, $parse) {
  var self = this;

  /**
   * Example:
   * expression = "address in addresses | filter: {street: $select.search} track by $index"
   * itemName = "address",
   * source = "addresses | filter: {street: $select.search}",
   * trackByExp = "$index",
   */
  self.parse = function(expression) {


    var match;
    //var isObjectCollection = /\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(expression);
    // If an array is used as collection

    // if (isObjectCollection){
    // 000000000000000000000000000000111111111000000000000000222222222222220033333333333333333333330000444444444444444444000000000000000055555555555000000000000000000000066666666600000000
    match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

    // 1 Alias
    // 2 Item
    // 3 Key on (key,value)
    // 4 Value on (key,value)
    // 5 Source expression (including filters)
    // 6 Track by

    if (!match) {
      throw uiSelectMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
              expression);
    }
    
    var source = match[5], 
        filters = '';

    // When using (key,value) ui-select requires filters to be extracted, since the object
    // is converted to an array for $select.items 
    // (in which case the filters need to be reapplied)
    if (match[3]) {
      // Remove any enclosing parenthesis
      source = match[5].replace(/(^\()|(\)$)/g, '');
      // match all after | but not after ||
      var filterMatch = match[5].match(/^\s*(?:[\s\S]+?)(?:[^\|]|\|\|)+([\s\S]*)\s*$/);
      if(filterMatch && filterMatch[1].trim()) {
        filters = filterMatch[1];
        source = source.replace(filters, '');
      }      
    }

    return {
      itemName: match[4] || match[2], // (lhs) Left-hand side,
      keyName: match[3], //for (key, value) syntax
      source: $parse(source),
      filters: filters,
      trackByExp: match[6],
      modelMapper: $parse(match[1] || match[4] || match[2]),
      repeatExpression: function (grouped) {
        var expression = this.itemName + ' in ' + (grouped ? '$group.items' : '$select.items');
        if (this.trackByExp) {
          expression += ' track by ' + this.trackByExp;
        }
        return expression;
      } 
    };

  };

  self.getGroupNgRepeatExpression = function() {
    return '$group in $select.groups track by $group.name';
  };

}]);

}());
angular.module("ui.select").run(["$templateCache", function($templateCache) {$templateCache.put("bootstrap/choices.tpl.html","<ul class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\" ng-show=\"$select.open && $select.items.length > 0\"><li class=\"ui-select-choices-group\" id=\"ui-select-choices-{{ $select.generatedId }}\"><div class=\"divider\" ng-show=\"$select.isGrouped && $index > 0\"></div><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label dropdown-header\" ng-bind=\"$group.name\"></div><div ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\" role=\"option\"><span class=\"ui-select-choices-row-inner\"></span></div></li></ul>");
$templateCache.put("bootstrap/match-multiple.tpl.html","<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected track by $index\"><span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span> <span uis-transclude-append=\"\"></span></span></span></span>");
$templateCache.put("bootstrap/match.tpl.html","<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focus\':$select.focus}\"><span tabindex=\"-1\" class=\"btn btn-default form-control ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");
$templateCache.put("bootstrap/no-choice.tpl.html","<ul class=\"ui-select-no-choice dropdown-menu\" ng-show=\"$select.items.length == 0\"><li ng-transclude=\"\"></li></ul>");
$templateCache.put("bootstrap/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control\" ng-class=\"{open: $select.open}\"><div><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search input-xs\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" ng-model=\"$select.search\" role=\"combobox\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{$select.baseTitle}}\" ng-class=\"{\'spinner\': $select.refreshing}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
$templateCache.put("bootstrap/select.tpl.html","<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><span ng-show=\"$select.open && $select.refreshing && $select.spinnerEnabled\" class=\"ui-select-refreshing {{$select.spinnerClass}}\"></span> <input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" class=\"form-control ui-select-search\" ng-class=\"{ \'ui-select-search-hidden\' : !$select.searchEnabled }\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-show=\"$select.open\"><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
$templateCache.put("select2/choices.tpl.html","<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
$templateCache.put("select2/match-multiple.tpl.html","<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected track by $index\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
$templateCache.put("select2/match.tpl.html","<a class=\"select2-choice ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></a>");
$templateCache.put("select2/no-choice.tpl.html","<div class=\"ui-select-no-choice dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("select2/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
$templateCache.put("select2/select.tpl.html","<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"search-container\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled, \'select2-search\':$select.searchEnabled}\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" ng-class=\"{\'select2-active\': $select.refreshing}\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div></div>");
$templateCache.put("selectize/choices.tpl.html","<div ng-show=\"$select.open\" class=\"ui-select-choices ui-select-dropdown selectize-dropdown\" ng-class=\"{\'single\': !$select.multiple, \'multi\': $select.multiple}\"><div class=\"ui-select-choices-content selectize-dropdown-content\"><div class=\"ui-select-choices-group optgroup\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label optgroup-header\" ng-bind=\"$group.name\"></div><div role=\"option\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner\" data-selectable=\"\"></div></div></div></div></div>");
$templateCache.put("selectize/match-multiple.tpl.html","<div class=\"ui-select-match\" data-value=\"\" ng-repeat=\"$item in $select.selected track by $index\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'active\':$selectMultiple.activeMatchIndex === $index}\" ui-select-sort=\"$select.selected\"><span class=\"ui-select-match-item\" ng-class=\"{\'select-locked\':$select.isLocked(this, $index)}\"><span uis-transclude-append=\"\"></span> <span class=\"remove ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&times;</span></span></div>");
$templateCache.put("selectize/match.tpl.html","<div ng-hide=\"$select.searchEnabled && ($select.open || $select.isEmpty())\" class=\"ui-select-match\"><span ng-show=\"!$select.searchEnabled && ($select.isEmpty() || $select.open)\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty() || $select.open\" ng-transclude=\"\"></span></div>");
$templateCache.put("selectize/no-choice.tpl.html","<div class=\"ui-select-no-choice selectize-dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"selectize-dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("selectize/select-multiple.tpl.html","<div class=\"ui-select-container selectize-control multi plugin-remove_button\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-model=\"$select.search\" ng-disabled=\"$select.disabled\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{ $select.baseTitle }}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
$templateCache.put("selectize/select.tpl.html","<div class=\"ui-select-container selectize-control single\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search ui-select-toggle\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" ng-click=\"$select.toggle($event)\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-hide=\"!$select.isEmpty() && !$select.open\" ng-disabled=\"$select.disabled\" aria-label=\"{{ $select.baseTitle }}\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");}]);;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('MainController', MainController);

    MainController.$inject = ['$location', '$scope', 'Principal'];

    function MainController ($location, $scope, Principal) {

        $scope.isAuthenticated = Principal.isAuthenticated;
        
        // Obtenez l'URL actuelle
        var currentUrl = $location.absUrl();
        
        // Vérifiez si l'URL contient 'localhost' ou 'integration'
        if (currentUrl.indexOf('localhost') !== -1 || currentUrl.indexOf('integration.wamasys.com') !== -1) {
            // Si l'URL contient 'localhost' ou 'integration', définissez ENV sur 'dev'
            $scope.RIBBON_TEST = true;
      //      $scope.ENV = 'dev';
        } else {
            // Sinon, définissez ENV sur une autre valeur ou laissez-le non défini selon vos besoins
            // Par exemple, si vous voulez cacher quelque chose dans d'autres environnements
            $scope.RIBBON_TEST = false;
        }
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'header@': {
                    templateUrl: 'app/layouts/header/header.html',
                    controller: 'HeaderController',
                    controllerAs: 'vm'
                },
            
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();
;
(function () {
    "use strict";
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular.module("wamasysApp")

.constant("ENV", "prod")

.constant("MODE", "simple")

.constant("VERSION", "1.4.123-SNAPSHOT")

;
})();
;
!function e(r,n,o){function t(i,u){if(!n[i]){if(!r[i]){var a="function"==typeof require&&require;if(!u&&a)return a(i,!0);if(s)return s(i,!0);var c=new Error("Cannot find module '"+i+"'");throw c.code="MODULE_NOT_FOUND",c}var l=n[i]={exports:{}};r[i][0].call(l.exports,function(e){var n=r[i][1][e];return t(n?n:e)},l,l.exports,e,r,n,o)}return n[i].exports}for(var s="function"==typeof require&&require,i=0;i<o.length;i++)t(o[i]);return t}({1:[function(e,r,n){angular.module("nemLogging",[]),angular.module("nemLogging").provider("nemDebug",function(){var r=null;return r=e("debug"),this.$get=function(){return r},this.debug=r,this});var o=function(e,r){return function(){return e.apply(r,arguments)}},t=[].slice;angular.module("nemLogging").provider("nemSimpleLogger",["nemDebugProvider",function(e){var r,n,s,i,u,a,c,l,f,g,d,h;for(d=e.debug,s={},i=["debug","info","warn","error","log"],r={},f=l=0,g=i.length;g>l;f=++l)h=i[f],r[h]=f;return a=function(e,r,n){return e>=r?n():void 0},u=function(e){var r,n,o;if(r=!1,!e)return r;for(n=0,o=i.length;o>n&&(h=i[n],r=null!=e[h]&&"function"==typeof e[h],r);n++);return r},c=function(e,r){var n,o,t,u;for(null==s[e]&&(s[e]=d(e)),n=s[e],u={},o=0,t=i.length;t>o;o++)h=i[o],u[h]="debug"===h?n:r[h];return u},n=function(){function e(e){var n,s,c,l,f;if(this.$log=e,this.spawn=o(this.spawn,this),!this.$log)throw"internalLogger undefined";if(!u(this.$log))throw"@$log is invalid";for(this.doLog=!0,f={},n=function(e){return function(n){return f[n]=function(){var o;return o=1<=arguments.length?t.call(arguments,0):[],e.doLog?a(r[n],e.currentLevel,function(){var r;return(r=e.$log)[n].apply(r,o)}):void 0},e[n]=f[n]}}(this),s=0,c=i.length;c>s;s++)l=i[s],n(l);this.LEVELS=r,this.currentLevel=r.error}return e.prototype.spawn=function(r){if("string"==typeof r){if(!u(this.$log))throw"@$log is invalid";if(!d)throw"nemDebug is undefined this is probably the light version of this library sep debug logggers is not supported!";return c(r,this.$log)}return new e(r||this.$log)},e}(),this.decorator=["$log",function(e){var o;return o=new n(e),o.currentLevel=r.debug,o}],this.$get=["$log",function(e){return new n(e)}],this}])},{debug:2}],2:[function(e,r,n){function o(){return"WebkitAppearance"in document.documentElement.style||window.console&&(console.firebug||console.exception&&console.table)||navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)&&parseInt(RegExp.$1,10)>=31}function t(){var e=arguments,r=this.useColors;if(e[0]=(r?"%c":"")+this.namespace+(r?" %c":" ")+e[0]+(r?"%c ":" ")+"+"+n.humanize(this.diff),!r)return e;var o="color: "+this.color;e=[e[0],o,"color: inherit"].concat(Array.prototype.slice.call(e,1));var t=0,s=0;return e[0].replace(/%[a-z%]/g,function(e){"%%"!==e&&(t++,"%c"===e&&(s=t))}),e.splice(s,0,o),e}function s(){return"object"==typeof console&&console.log&&Function.prototype.apply.call(console.log,console,arguments)}function i(e){try{null==e?n.storage.removeItem("debug"):n.storage.debug=e}catch(r){}}function u(){var e;try{e=n.storage.debug}catch(r){}return e}function a(){try{return window.localStorage}catch(e){}}n=r.exports=e("./debug"),n.log=s,n.formatArgs=t,n.save=i,n.load=u,n.useColors=o,n.storage="undefined"!=typeof chrome&&"undefined"!=typeof chrome.storage?chrome.storage.local:a(),n.colors=["lightseagreen","forestgreen","goldenrod","dodgerblue","darkorchid","crimson"],n.formatters.j=function(e){return JSON.stringify(e)},n.enable(u())},{"./debug":3}],3:[function(e,r,n){function o(){return n.colors[l++%n.colors.length]}function t(e){function r(){}function t(){var e=t,r=+new Date,s=r-(c||r);e.diff=s,e.prev=c,e.curr=r,c=r,null==e.useColors&&(e.useColors=n.useColors()),null==e.color&&e.useColors&&(e.color=o());var i=Array.prototype.slice.call(arguments);i[0]=n.coerce(i[0]),"string"!=typeof i[0]&&(i=["%o"].concat(i));var u=0;i[0]=i[0].replace(/%([a-z%])/g,function(r,o){if("%%"===r)return r;u++;var t=n.formatters[o];if("function"==typeof t){var s=i[u];r=t.call(e,s),i.splice(u,1),u--}return r}),"function"==typeof n.formatArgs&&(i=n.formatArgs.apply(e,i));var a=t.log||n.log||console.log.bind(console);a.apply(e,i)}r.enabled=!1,t.enabled=!0;var s=n.enabled(e)?t:r;return s.namespace=e,s}function s(e){n.save(e);for(var r=(e||"").split(/[\s,]+/),o=r.length,t=0;o>t;t++)r[t]&&(e=r[t].replace(/\*/g,".*?"),"-"===e[0]?n.skips.push(new RegExp("^"+e.substr(1)+"$")):n.names.push(new RegExp("^"+e+"$")))}function i(){n.enable("")}function u(e){var r,o;for(r=0,o=n.skips.length;o>r;r++)if(n.skips[r].test(e))return!1;for(r=0,o=n.names.length;o>r;r++)if(n.names[r].test(e))return!0;return!1}function a(e){return e instanceof Error?e.stack||e.message:e}n=r.exports=t,n.coerce=a,n.disable=i,n.enable=s,n.enabled=u,n.humanize=e("ms"),n.names=[],n.skips=[],n.formatters={};var c,l=0},{ms:4}],4:[function(e,r,n){function o(e){if(e=""+e,!(e.length>1e4)){var r=/^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(e);if(r){var n=parseFloat(r[1]),o=(r[2]||"ms").toLowerCase();switch(o){case"years":case"year":case"yrs":case"yr":case"y":return n*f;case"days":case"day":case"d":return n*l;case"hours":case"hour":case"hrs":case"hr":case"h":return n*c;case"minutes":case"minute":case"mins":case"min":case"m":return n*a;case"seconds":case"second":case"secs":case"sec":case"s":return n*u;case"milliseconds":case"millisecond":case"msecs":case"msec":case"ms":return n}}}}function t(e){return e>=l?Math.round(e/l)+"d":e>=c?Math.round(e/c)+"h":e>=a?Math.round(e/a)+"m":e>=u?Math.round(e/u)+"s":e+"ms"}function s(e){return i(e,l,"day")||i(e,c,"hour")||i(e,a,"minute")||i(e,u,"second")||e+" ms"}function i(e,r,n){return r>e?void 0:1.5*r>e?Math.floor(e/r)+" "+n:Math.ceil(e/r)+" "+n+"s"}var u=1e3,a=60*u,c=60*a,l=24*c,f=365.25*l;r.exports=function(e,r){return r=r||{},"string"==typeof e?o(e):r["long"]?s(e):t(e)}},{}]},{},[1]);;(function(){angular.module("wamasysApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/home/home.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-12\" ng-switch=\"vm.isAuthenticated()\"><!--             <h1 translate=\"home.title\">Wamasys</h1> --><!--   <p class=\"lead\" translate=\"home.authentifiezVous\" ng-switch-when=\"false\">Veuillez vous authentifier</p> --><div class=\"row\" ng-switch-when=\"true\"><div class=\"col-md-10\"><div class=\"row\" has-any-authority=\"ROLE_AREA_MANAGEMENT,ROLE_DATA_OPERATOR,ROLE_READ_ONLY\"><div class=\"col-md-4\"><style>.border-left-info {\r\n	    border-left: .25rem solid #36b9cc!important;\r\n	}         \r\n	.border-left-primary {\r\n	    border-left: .25rem solid #017ebb!important;\r\n	}\r\n	.pb-2, .py-2 {\r\n	    padding-bottom: .5rem!important;\r\n	}\r\n	.pt-2, .py-2 {\r\n	    padding-top: .5rem!important;\r\n	}\r\n	.h-100 {\r\n	    height: 100%!important;\r\n	}\r\n	.shadow {\r\n	    box-shadow: 0 .15rem 1.75rem 0 rgba(58,59,69,.15)!important;\r\n	}\r\n	.card {\r\n	    position: relative;\r\n	    display: flex;\r\n	    flex-direction: column;\r\n	    min-width: 0;\r\n	    word-wrap: break-word;\r\n	    background-color: #fff;\r\n	    background-clip: border-box;\r\n	    border: 1px solid #e3e6f0;\r\n	    border-radius: .35rem;\r\n	}\r\n		  .card-body {\r\n	    flex: 1 1 auto;\r\n	    min-height: 1px;\r\n	    padding: 1.25rem;\r\n	}     \r\n	.align-items-center {\r\n	    align-items: center!important;\r\n	}\r\n	.no-gutters {\r\n	    margin-right: 0;\r\n	    margin-left: 0;\r\n	}     \r\n	.text-xs {\r\n	    font-size: .7rem;\r\n	}\r\n	.text-primary {\r\n	    color: #017ebb!important;\r\n	}\r\n	.font-weight-bold {\r\n	    font-weight: 700!important;\r\n	}\r\n	.uppercase {\r\n	    text-transform: uppercase!important;\r\n	}\r\n	.mb-1, .my-1 {\r\n	    margin-bottom: .25rem!important;\r\n	}\r\n	.col-auto {\r\n		position: relative;\r\n	    flex: 0 0 auto;\r\n	    width: auto;\r\n	    max-width: 100%;\r\n	}\r\n	.mr-3, .mx-3 {\r\n	    margin-right: 1rem!important;\r\n	}\r\n	.mb-0, .my-0 {\r\n	    margin-bottom: 0!important;\r\n	}\r\n	.no-gutters>.col, .no-gutters>[class*=col-] {\r\n	    padding-right: 0;\r\n	    padding-left: 0;\r\n	}\r\n	\r\n	.mr-2, .mx-2 {\r\n	    margin-right: .5rem!important;\r\n	}\r\n	.col {\r\n	    position: relative;\r\n	    flex-basis: 0;\r\n	    flex-grow: 1;\r\n	    min-width: 0;\r\n	    max-width: 100%;\r\n	    width: 100%;\r\n	}    \r\n	.rowbis {\r\n	    display: flex;\r\n	    flex-wrap: wrap;\r\n	    }\r\n	.text-gray-300 {\r\n	    color: #dddfeb!important;\r\n	}\r\n	.align-items-center {\r\n	    align-items: center!important;\r\n	}\r\n	\r\n	.progress2 {\r\n	    display: flex;\r\n	    height: 1rem;\r\n	    overflow: hidden;\r\n	    line-height: 0;\r\n	    font-size: .75rem;\r\n	    background-color: #eaecf4;\r\n	    border-radius: .35rem;\r\n	}\r\n	.progress2-sm {\r\n	    height: .5rem;\r\n	}\r\n	.progress2-bar {\r\n	    display: flex;\r\n	    flex-direction: column;\r\n	    justify-content: center;\r\n	    overflow: hidden;\r\n	    color: #fff;\r\n	    text-align: center;\r\n	    white-space: nowrap;\r\n	    background-color: #4e73df;\r\n	    transition: width .6s ease;\r\n	}\r\n	\r\n	/*  On affiche toujours la barre latéralle pour éviter les problèmes de tremblement au chargement de la page */\r\n	html {\r\n  		overflow-y: scroll; \r\n	}</style><div class=\"card border-left-primary shadow h-100 py-2\"><div class=\"card-body\"><div class=\"rowbis no-gutters align-items-center\"><div class=\"col mr-2\"><div class=\"font-weight-bold text-primary text-uppercase mb-1\">Number of contracts</div><!-- 		                      <div class=\"h5 mb-0 font-weight-bold text-gray-800\">8,000</div> --><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"statData\" chart-labels=\"statLabels\" chart-options=\"options\"><!-- 							chart-dataset-override=\"datasetOverride\"	 chart-click=\"onClick\"	chart-series=\"series\"  --></canvas></div><!-- 		                    <div class=\"col-auto\"> --><!-- 		                      <i class=\"fa fa-lg fa-fw  fa-bar-chart-o text-gray-300\"></i> --><!-- 		                    </div> --></div></div></div></div><div class=\"col-md-4\"><div class=\"card border-left-primary shadow h-100 py-2\"><div class=\"card-body\"><div class=\"rowbis no-gutters align-items-center\"><div class=\"col mr-2\"><div class=\"font-weight-bold text-primary text-uppercase mb-1\">Billing and payments</div><!-- 		                      <div class=\"h5 mb-0 font-weight-bold text-gray-800\">80,000 PHP</div> --><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"billingData\" chart-labels=\"billingLabels\" chart-series=\"billingSeries\" chart-options=\"options3\"></canvas><!-- chart-dataset-override=\"datasetOverride\" chart-click=\"onClick\" --></div><!-- 		                    <div class=\"col-auto\"> --><!-- 		                      <i class=\"fa fa-lg fa-fw  fa-bar-chart-o text-gray-300\"></i> --><!-- 		                    </div> --></div></div></div></div><div class=\"col-md-4\"><div class=\"card border-left-primary shadow h-100 py-2\"><div class=\"card-body\"><div class=\"rowbis no-gutters align-items-center\"><div class=\"col mr-2\"><div class=\"font-weight-bold text-primary text-uppercase mb-1\">Balance</div><!-- 		                      <div class=\"h5 mb-0 font-weight-bold text-gray-800\">80,000 PHP</div> --><canvas id=\"line\" class=\"chart chart-bar\" chart-data=\"balanceData\" chart-labels=\"balanceLabels\" chart-options=\"options3\"></canvas><!-- chart-series=\"series3\"chart-dataset-override=\"datasetOverride\" chart-click=\"onClick\" --></div><!-- 		                    <div class=\"col-auto\"> --><!-- 		                      <i class=\"fa fa-lg fa-fw  fa-bar-chart-o text-gray-300\"></i> --><!-- 		                    </div> --></div></div></div></div><!-- 					<div class=\"col-md-4 \"> --><!-- 		              <div class=\"card border-left-info shadow h-100 py-2\"> --><!-- 		                <div class=\"card-body\"> --><!-- 		                  <div class=\"rowbis no-gutters align-items-center\"> --><!-- 		                    <div class=\"col mr-2\"> --><!-- 		                      <div class=\"font-weight-bold text-info text-uppercase mb-1\">Taux de collecte (30 derniers jours)</div> --><!-- 		                      <div class=\"rowbis no-gutters align-items-center\"> --><!-- 		                        <div class=\"col-auto\"> --><!-- 		                          <div class=\"h5 mb-0 mr-3 font-weight-bold text-gray-800\">90%</div> --><!-- 		                        </div> --><!-- 		                        <div class=\"col\"> --><!-- 		                          <div class=\"progress2 progress2-sm mr-2\"> --><!-- 		                            <div class=\"progress2-bar bg-info\" role=\"progressbar\" style=\"width: 90%\" aria-valuenow=\"90\" aria-valuemin=\"0\" aria-valuemax=\"100\"></div> --><!-- 		                          </div> --><!-- 		                        </div> --><!-- 		                      </div> --><!-- 		                    </div> --><!-- 		                    <div class=\"col-auto\"> --><!-- 		                      <i class=\"fa fa-lg fa-fw  fa-bar-chart-o text-gray-300 fa-2x \"></i> --><!-- 		                    </div> --><!-- 		                  </div> --><!-- 		                </div> --><!-- 		              </div> --><!-- 		            </div> --></div><div class=\"row\" style=\"margin-top: 10px\" has-module=\"TEAM\"><div class=\"col-md-12\"><div jarvis-widget id=\"chartjs-line-chart\" data-widget-editbutton=\"false\"><header><span class=\"widget-icon\"><i class=\"fa fa-bar-chart-o\"></i></span><h2>Tickets assigned to me</h2><div _ngcontent-c4=\"\" class=\"widget-toolbar\" role=\"menu\"><button class=\"btn btn-xs btn-default\" ui-sref=\"teamwork\"><i class=\"fa fa-location-arrow ng-star-inserted\"></i> Tickets dashboard</button></div></header><!-- 		                    <div> --><div class=\"widget-body\" style=\"padding : 0px\"><div class=\"table-responsive no-margin custom-scroll\" style=\"height:340px; overflow-y: scroll\"><table class=\"table highlight table-border-0 table-hover table-condensed\"><thead><tr><th>Subject</th><th class=\"\">Priority</th><th class=\"\">Status</th><th class=\"\">Tracker</th><th ng-show=\"vm.issuefilter != \'createdbyme\'\">Author</th><th ng-show=\"vm.issuefilter != \'myissues\'\">Assigned to</th><th class=\"\">Last updated</th></tr></thead><tbody><tr ng-repeat=\"issue in vm.listIssues.issues track by issue.id\"><td class=\"v-align-m\"><a href=\"{{vm.account.teamworkUrl}}/issues/{{issue.id}}\" target=\"_blank\">{{issue.subject}}</a></td><td class=\"v-align-m\">{{issue.priority.name}}</td><td class=\"v-align-m\">{{issue.status.name}}</td><td class=\"v-align-m\">{{issue.tracker.name}}</td><td ng-show=\"vm.issuefilter != \'createdbyme\'\" class=\"v-align-m\">{{issue.author.name}}</td><td ng-show=\"vm.issuefilter != \'myissues\'\" class=\"v-align-m\">{{issue.assigned_to.name}}</td><td class=\"v-align-m\">{{issue.updated_on}}</td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div><!-- 		                    </div> --></div></div><!--                 	</div> --><!--                 	 <div class=\"alert alert-success\"  translate=\"home.logged.message\" translate-values=\"{username: \'{{vm.account.login}}\'}\"> --><!--                 	    You are logged in as user \"{{vm.account.login}}\". --><!--                 	</div> --><!-- 				<div class=\"row\" id=\"content\" > --></div></div><!--                 	<div class=\"col-md-10\" 	has-module=\"ELK\" > --><!--                 	  <my-iframe iddashboard=\"{{vm.idDashboard}}\"  periodKibana=\"{{vm.periodKibana}}\" idcontrat=\"\" filtreagence=\"{{vm.filtreagence}}\" height=\"800px\" width=\"100%\" scrolling=\"auto\"></my-iframe> --><!--                 	</div> --><div class=\"col-md-2\"><h2 translate=\"home.actionRapide\">Action rapide</h2><a class=\"\" translate=\"home.creerContrat\" ui-sref=\"contrat.new\">Créer un contrat</a><br><a class=\"\" translate=\"home.creerIndividualMeter\" ui-sref=\"compteur.individual-meter.new\">Créer un individual meter</a><br><a class=\"\" translate=\"home.creerCollectionList\" ui-sref=\"collection-liste.new\">Créer une collection list</a><br><a class=\"\" translate=\"home.creerReleveCompteur\" ui-sref=\"releve-compteur.new\">Créer un relevé de compteur</a></div><style>.planning-container {\r\n    background: #f5f5f5;\r\n    padding: 10px;\r\n    border-radius: 6px;\r\n    overflow-y: auto;\r\n    max-height: 100vh;\r\n}\r\n\r\n.day-header {\r\n    font-weight: bold;\r\n    background: #3292E2;\r\n    color: white;\r\n    padding: 5px;\r\n    text-align: center;\r\n    border-radius: 4px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.event-list {\r\n    position: relative;\r\n    padding: 5px;\r\n    border-left: 2px solid #ccc;\r\n}\r\n\r\n.current-time-bar {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    height: 2px;\r\n    background: red;\r\n    z-index: 10;\r\n}\r\n\r\n.event-item {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 5px;\r\n    border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.event-time {\r\n    font-weight: bold;\r\n    width: 50px;\r\n    color: #555;\r\n}\r\n\r\n.event-detail {\r\n    flex-grow: 1;\r\n    padding-left: 10px;\r\n}</style><div class=\"planning-container\" has-module=\"TEAM\"><div class=\"day-column\" ng-repeat=\"day in vm.nextDays\"><!-- Affichage du jour --><div class=\"day-header\">{{ day.date | date:\'EEEE dd/MM\' }}</div><div class=\"event-list\"><!-- Ligne rouge pour l\'heure actuelle --><!--    <div class=\"current-time-bar\" ng-if=\"day.isToday\" ng-style=\"{\'top\': vm.currentTimePosition + \'px\'}\"></div>\r\n						 --><!-- Boucle sur les événements du jour --><div class=\"event-item\" ng-repeat=\"event in day.events\"><div class=\"event-time\">{{ event.start | date:\'HH:mm\' }} {{ event.end | date:\'HH:mm\'}}</div><div class=\"event-detail\">{{ event.title }}<br>{{ event.comment}}</div></div></div></div></div></div><!--  <a class=\"btn btn-default\" href=\"\" ng-switch-when=\"false\"  ng-click=\"vm.login()\">Sign in</a><br/><br/>--><div class=\"row\" ng-switch-when=\"false\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"login.title\" class=\"text-center\">Sign in</h1></div><div class=\"col-md-8 col-md-offset-2\"><div class=\"alert alert-danger\" ng-show=\"vm.authenticationError\">{{ vm.textErreur | translate}}<!-- \r\n			                <strong>Failed to sign in!</strong> Please check your credentials and try again.\r\n			                 --></div></div><div class=\"col-md-8 col-md-offset-2\"><form class=\"form\" role=\"form\" ng-submit=\"vm.login($event)\"><div class=\"form-group\"><label for=\"username\" translate=\"global.form.username\">Login</label><input type=\"text\" class=\"form-control\" id=\"username\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.username\"></div><div class=\"form-group\"><label for=\"password\" translate=\"login.form.password\">Password</label><input type=\"password\" class=\"form-control\" id=\"password\" placeholder=\"{{\'login.form.password.placeholder\' | translate}}\" ng-model=\"vm.password\"></div><div class=\"form-group\" ng-if=\"vm.mfaRequired\"><label for=\"mfaCode\" translate=\"login.form.mfaCode\">Code de double authentification</label><input type=\"text\" class=\"form-control\" id=\"mfaCode\" ng-model=\"vm.mfaCode\" inputmode=\"numeric\" autocomplete=\"one-time-code\" maxlength=\"6\" ng-pattern=\"/^[0-9]{6}$/\" required><p class=\"help-block\" translate=\"login.form.mfaHelp\">Saisissez le code à six chiffres de Google Authenticator.</p></div><div class=\"form-group\"><label for=\"rememberMe\"><input type=\"checkbox\" id=\"rememberMe\" ng-model=\"vm.rememberMe\" checked=\"checked\"> <span translate=\"login.form.rememberme\">Remember me</span></label></div><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.submitting\" translate=\"login.form.button\">Sign in</button></form><br><div class=\"row\"><div class=\"col-md-6\"><div class=\"alert alert-warning\"><a class=\"alert-link\" href=\"\" ng-click=\"vm.requestResetPassword()\" translate=\"login.password.forgot\">Did you forget your password?</a></div></div><div class=\"col-md-6\"><div class=\"alert alert-success\"><a class=\"alert-link\" href=\"\" ng-click=\"vm.requestResetPassword()\" translate=\"global.messages.info.activate\">Activate your account</a></div></div></div></div></div><div ng-show=\"{{ENV === \'dev\'}}\" class=\"alert alert-warning\" ng-switch-when=\"false\"><!-- translate=\"global.messages.info.authenticated\" translate-compile --> Vous pouvez tester l\'application avec ces comptes :<br><br>- Administrator (login=\"administrateur\" and password=\"admin\")<br>=> L\'admnistrateur est le seul à avoir accès à l\'ensemble de l\'application, je vous recommande d\'utiliser ce compte si vous ne souhaitez pas gérer les droits.<br><br>- Program manager (login=\"programmanager\" and password=\"user\").<br>- Branch manager (login=\"branchmanager\" and password=\"user\").<br>- Operator (login=\"operator\" and password=\"user\").<br><br>- Head office (login=\"headoffice\" and password=\"user\").<br><br>- Collector (login=\"collector\" and password=\"user\")<br>=> Le collecteur n\'a pas accès aux écrans, son compte donne uniquement un accès via l\'application Smartphone.</div><br><!--          		<img ng-switch-when=\"false\"  src=\"/content/images/logo_cleversquare.png\" /> --><!--  --></div></div></div>");
$templateCache.put("app/admin/configuration/configuration.html","<div><h2 translate=\"configuration.title\">Configuration</h2><span translate=\"configuration.filter\">Filter (by prefix)</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><label ng-hide=\"filteredConfig.length == 0\">Spring configuration</label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filteredConfig.length == 0\"><thead><tr><th ng-click=\"predicate = \'prefix\'; reverse=!reverse\" class=\"col-sm-4\"><span translate=\"configuration.table.prefix\">Prefix</span></th><th translate=\"configuration.table.properties\" class=\"col-sm-8\">Properties</th></tr></thead><tr ng-repeat=\"entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)\"><td><span>{{entry.prefix}}</span></td><td><div class=\"row\" ng-repeat=\"(key, value) in entry.properties\"><div class=\"col-md-4\">{{key}}</div><div class=\"col-md-8\"><span class=\"pull-right label label-default break\">{{value}}</span></div></div></td></tr></table><div ng-repeat=\"(key, value) in vm.allConfiguration\"><label ng-hide=\"filtered.length == 0\"><span>{{key}}</span></label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filtered.length == 0\"><thead><tr><th class=\"col-sm-4\">Property</th><th class=\"col-sm-8\">Value</th></tr></thead><tbody><tr ng-repeat=\"item in filtered = (value | filter:filter)\"><td class=\"break\">{{item.key}}</td><td class=\"break\"><span class=\"pull-right label label-default break\">{{item.val}}</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/audits/audits.html","<div><h2 translate=\"audits.title\">Audits</h2><div class=\"row\"><div class=\"col-md-5\"><h4 translate=\"audits.filter.title\">Filter by date</h4><p class=\"input-group\"><span class=\"input-group-addon\" translate=\"audits.filter.from\">from</span> <input type=\"date\" class=\"input-sm form-control\" name=\"start\" ng-model=\"vm.fromDate\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-addon\" translate=\"audits.filter.to\">to</span> <input type=\"date\" class=\"input-sm form-control\" name=\"end\" ng-model=\"vm.toDate\" ng-change=\"vm.onChangeDate()\" required></p></div></div><table class=\"table table-condensed table-striped table-bordered table-responsive\"><thead><tr><th ng-click=\"predicate = \'timestamp\'; reverse=!reverse\"><span translate=\"audits.table.header.date\">Date</span></th><th ng-click=\"predicate = \'principal\'; reverse=!reverse\"><span translate=\"audits.table.header.principal\">User</span></th><th ng-click=\"predicate = \'type\'; reverse=!reverse\"><span translate=\"audits.table.header.status\">State</span></th><th ng-click=\"predicate = \'data.message\'; reverse=!reverse\"><span translate=\"audits.table.header.data\">Extra data</span></th></tr></thead><tr ng-repeat=\"audit in vm.audits | filter:filter | orderBy:predicate:reverse\" ng-hide=\"audit.filtered\"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show=\"audit.data.message\">{{audit.data.message}}</span> <span ng-show=\"audit.data.remoteAddress\"><span translate=\"audits.table.data.remoteAddress\">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadPage(page)\"></uib-pagination></div></div>");
$templateCache.put("app/admin/logs/logs.html","<div><h2 translate=\"logs.title\">Logs</h2><p translate=\"logs.nbloggers\" translate-values=\"{total: \'{{ vm.loggers.length }}\'}\">There are {{ vm.loggers.length }} loggers.</p><span translate=\"logs.filter\">Filter</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><table class=\"table table-condensed table-striped table-bordered table-responsive\"><thead><tr title=\"click to order\"><th ng-click=\"predicate = \'name\'; reverse=!reverse\"><span translate=\"logs.table.name\">Name</span></th><th ng-click=\"predicate = \'level\'; reverse=!reverse\"><span translate=\"logs.table.level\">Level</span></th></tr></thead><tr ng-repeat=\"logger in vm.loggers | filter:filter | orderBy:predicate:reverse\"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click=\"vm.changeLevel(logger.name, \'TRACE\')\" ng-class=\"(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">TRACE</button> <button ng-click=\"vm.changeLevel(logger.name, \'DEBUG\')\" ng-class=\"(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">DEBUG</button> <button ng-click=\"vm.changeLevel(logger.name, \'INFO\')\" ng-class=\"(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">INFO</button> <button ng-click=\"vm.changeLevel(logger.name, \'WARN\')\" ng-class=\"(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">WARN</button> <button ng-click=\"vm.changeLevel(logger.name, \'ERROR\')\" ng-class=\"(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">ERROR</button></td></tr></table></div>");
$templateCache.put("app/admin/health/health.html","<div><h2 translate=\"health.title\">Health Checks</h2><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"health.refresh.button\">Refresh</span></button></p><table id=\"healthCheck\" class=\"table table-striped\"><thead><tr><th class=\"col-md-7\" translate=\"health.table.service\">Service Name</th><th class=\"col-md-2 text-center\" translate=\"health.table.status\">Status</th><th class=\"col-md-2 text-center\" translate=\"health.details.details\">Details</th></tr></thead><tbody><tr ng-repeat=\"health in vm.healthData\"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class=\"text-center\"><span class=\"label\" ng-class=\"vm.getLabelClass(health.status)\">{{\'health.status.\' + health.status | translate}}</span></td><td class=\"text-center\"><a class=\"hand\" ng-click=\"vm.showHealth(health)\" ng-show=\"health.details || health.error\"><i class=\"glyphicon glyphicon-eye-open\"></i></a></td></tr></tbody></table></div>");
$templateCache.put("app/admin/health/health.modal.html","<div class=\"modal-header\"><button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"showHealthLabel\">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class=\"modal-body pad\"><div ng-show=\"vm.currentHealth.details\"><h4 translate=\"health.details.properties\">Properties</h4><table class=\"table table-striped\"><thead><tr><th class=\"col-md-6 text-left\" translate=\"health.details.name\">Name</th><th class=\"col-md-6 text-left\" translate=\"health.details.value\">Value</th></tr></thead><tbody><tr ng-repeat=\"(k,v) in vm.currentHealth.details\"><td class=\"col-md-6 text-left\">{{k}}</td><td class=\"col-md-6 text-left\">{{v}}</td></tr></tbody></table></div><div ng-show=\"vm.currentHealth.error\"><h4 translate=\"health.details.error\">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class=\"modal-footer\"><button data-dismiss=\"modal\" class=\"btn btn-default pull-left\" type=\"button\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/account/ai-assistant-history/ai-assistant-history.html","<div><h2 translate=\"wamasysApp.aiAssistantHistory.home.title\">Historique assistant IA</h2><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-sm-3\"><div class=\"well text-center\"><div class=\"h3\">{{vm.overview.totalConversations || 0}}</div><div translate=\"wamasysApp.aiAssistantHistory.summary.total\">Conversations</div></div></div><div class=\"col-sm-3\"><div class=\"well text-center\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.loadOverview()\" ng-disabled=\"vm.loadingOverview\"><span class=\"glyphicon glyphicon-refresh\"></span> <span translate=\"wamasysApp.aiAssistantHistory.actions.refresh\">Actualiser</span></button></div></div></div><div class=\"row\"><div class=\"col-md-5\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong translate=\"wamasysApp.aiAssistantHistory.table.title\">Mes conversations</strong> <span class=\"pull-right text-muted\">{{(vm.overview.conversations || []).length || 0}}</span></div><div class=\"panel-body\" ng-if=\"vm.loadingOverview\"><span translate=\"wamasysApp.aiAssistantHistory.loading.overview\">Chargement des conversations...</span></div><div class=\"table-responsive ai-assistant-history__conversation-list\" ng-if=\"!vm.loadingOverview\"><table class=\"table table-striped table-hover\"><thead><tr><th translate=\"wamasysApp.aiAssistantHistory.table.action\">Action</th><th translate=\"wamasysApp.aiAssistantHistory.table.date\">Date</th><th translate=\"wamasysApp.aiAssistantHistory.table.contract\">Ref contrat</th><th translate=\"wamasysApp.aiAssistantHistory.table.context\">Contexte</th></tr></thead><tbody><tr ng-repeat=\"conversation in vm.overview.conversations\" ng-click=\"vm.selectConversation(conversation)\" ng-class=\"{\'info\': vm.isConversationSelected(conversation)}\" style=\"cursor: pointer\"><td><span ng-class=\"vm.getActionBadgeClass(conversation.hasExecutedActions)\"><span ng-if=\"conversation.hasExecutedActions\" translate=\"wamasysApp.aiAssistantHistory.table.actionDone\">Oui</span> <span ng-if=\"!conversation.hasExecutedActions\" translate=\"wamasysApp.aiAssistantHistory.table.actionNone\">Non</span></span></td><td><div>{{conversation.lastActivityAt | date:\'dd/MM/yyyy HH:mm:ss\'}}</div><small class=\"text-muted\">{{conversation.eventCount || 0}} <span translate=\"wamasysApp.aiAssistantHistory.table.events\">etapes</span></small></td><td>{{conversation.contractReference || \'-\'}}</td><td>{{conversation.contextLabel || conversation.contextType || \'-\'}}</td></tr><tr ng-if=\"!(vm.overview.conversations || []).length\"><td colspan=\"4\" class=\"text-center text-muted\" translate=\"wamasysApp.aiAssistantHistory.empty\">Aucune conversation archivee.</td></tr></tbody></table></div></div></div><div class=\"col-md-7\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong translate=\"wamasysApp.aiAssistantHistory.detail.title\">Detail de la conversation</strong></div><div class=\"panel-body\" ng-if=\"vm.loadingDetail\"><span translate=\"wamasysApp.aiAssistantHistory.loading.detail\">Chargement du detail...</span></div><div class=\"panel-body\" ng-if=\"!vm.loadingDetail && !vm.detail\"><span class=\"text-muted\" translate=\"wamasysApp.aiAssistantHistory.detail.empty\">Selectionnez une conversation pour voir son historique.</span></div><div class=\"panel-body\" ng-if=\"!vm.loadingDetail && vm.detail\"><p><strong translate=\"wamasysApp.aiAssistantHistory.detail.context\">Contexte</strong>: <span>{{vm.detail.contextLabel || vm.detail.contextType || \'-\'}}</span></p><p><strong translate=\"wamasysApp.aiAssistantHistory.detail.contract\">Reference contrat</strong>: <span>{{vm.detail.contractReference || \'-\'}}</span> <span>, <strong translate=\"wamasysApp.aiAssistantHistory.detail.totalTokens\">Tokens conversation</strong>: {{vm.detail.totalTokens || 0}}</span> <span ng-if=\"vm.detail.hasExecutedActions\">, <span class=\"label label-warning\" translate=\"wamasysApp.aiAssistantHistory.detail.executed\">Action executee</span></span></p><p ng-if=\"vm.detail.feedbackComment\"><strong translate=\"wamasysApp.aiAssistantHistory.detail.feedbackComment\">Commentaire feedback</strong>: <span>{{vm.detail.feedbackComment}}</span></p><div class=\"panel panel-default ai-assistant-history__event-card\" ng-repeat=\"event in vm.detail.events\" ng-if=\"vm.hasVisibleConversationContent(event)\"><div class=\"panel-heading\"><strong>{{event.stageLabel || event.stage}}</strong> <span class=\"pull-right\">{{event.archivedAt | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></div><div class=\"panel-body\"><p class=\"text-muted\" ng-if=\"event.requestTotalTokens\"><strong translate=\"wamasysApp.aiAssistantHistory.detail.tokens\">Tokens utilises</strong>: {{event.requestTotalTokens}}</p><p ng-if=\"event.feedbackComment\"><strong translate=\"wamasysApp.aiAssistantHistory.detail.feedbackComment\">Commentaire feedback</strong>: {{event.feedbackComment}}</p><div class=\"ai-assistant-history__message-block\" ng-if=\"event.sentMessage\"><div class=\"ai-assistant-history__message-label\" translate=\"wamasysApp.aiAssistantHistory.detail.sentMessage\">Message envoye</div><div class=\"ai-assistant-history__message-content\">{{event.sentMessage}}</div></div><div class=\"ai-assistant-history__message-block\" ng-if=\"event.receivedMessage\"><div class=\"ai-assistant-history__message-label\" translate=\"wamasysApp.aiAssistantHistory.detail.receivedMessage\">Message recu</div><div class=\"ai-assistant-history__message-content\">{{event.receivedMessage}}</div></div><div class=\"ai-assistant-history__message-block\" ng-if=\"event.clarificationQuestions.length\"><div class=\"ai-assistant-history__message-label\" translate=\"wamasysApp.aiAssistantHistory.detail.questions\">Questions posees</div><ul class=\"ai-assistant-monitoring__highlights\"><li ng-repeat=\"question in event.clarificationQuestions track by $index\">{{question}}</li></ul></div><div class=\"ai-assistant-history__message-block\" ng-if=\"event.hasAction\"><div class=\"ai-assistant-history__message-label\"><span ng-if=\"event.actionExecuted\" translate=\"wamasysApp.aiAssistantHistory.detail.actionsDone\">Actions effectuees</span> <span ng-if=\"!event.actionExecuted\" translate=\"wamasysApp.aiAssistantHistory.detail.actionsPlanned\">Actions prevues</span></div><ul class=\"ai-assistant-monitoring__highlights\" ng-if=\"event.actionSummaries.length\"><li ng-repeat=\"summary in event.actionSummaries track by $index\">{{summary}}</li></ul><div class=\"text-muted\" ng-if=\"!event.actionSummaries.length\"><span ng-if=\"event.actionExecuted\" translate=\"wamasysApp.aiAssistantHistory.detail.actionsDoneNoDetail\">Une action a ete executee.</span> <span ng-if=\"!event.actionExecuted\" translate=\"wamasysApp.aiAssistantHistory.detail.actionsPlannedNoDetail\">Une action avait ete proposee.</span></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/admin/metrics/metrics.html","<div><h2 translate=\"metrics.title\">Application Metrics</h2><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"metrics.refresh.button\">Refresh</span></button></p><h3 translate=\"metrics.jvm.title\">JVM Metrics</h3><div class=\"row\" ng-hide=\"vm.updatingMetrics\"><div class=\"col-md-4\"><b translate=\"metrics.jvm.memory.title\">Memory</b><p><span translate=\"metrics.jvm.memory.total\">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.total.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.total.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.heap\">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.heap.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.nonheap\">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.threads.title\">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class=\"hand\" ng-click=\"vm.refreshThreadDumpData()\" data-toggle=\"modal\" data-target=\"#threadDump\"><i class=\"glyphicon glyphicon-eye-open\"></i></a><p><span translate=\"metrics.jvm.threads.runnable\">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.runnable.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.timedwaiting\">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.waiting\">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.blocked\">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.blocked.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.gc.title\">Garbage collections</b><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweepcount\">Mark Sweep count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweeptime\">Mark Sweep time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengecount\">Scavenge count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengetime\">Scavenge time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class=\"well well-lg\" ng-show=\"vm.updatingMetrics\" translate=\"metrics.updating\">Updating...</div><h3 translate=\"metrics.jvm.http.title\">HTTP requests (events per second)</h3><p><span translate=\"metrics.jvm.http.active\">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate=\"metrics.jvm.http.total\">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.jvm.http.table.code\">Code</th><th translate=\"metrics.jvm.http.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.jvm.http.table.mean\">Mean</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (1 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (5 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate=\"metrics.jvm.http.code.ok\">OK</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.notfound\">Not Found</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.servererror\">Server error</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate=\"metrics.servicesstats.title\">Services statistics (time in millisecond)</h3><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.servicesstats.table.name\">Service name</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.min\">Min</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p50\">p50</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p75\">p75</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p95\">p95</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p99\">p99</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.max\">Max</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in vm.servicesStats\"><td>{{k}}</td><td class=\"text-right\">{{v.count}}</td><td class=\"text-right\">{{v.mean * 1000 | number:0}}</td><td class=\"text-right\">{{v.min * 1000 | number:0}}</td><td class=\"text-right\">{{v.p50 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p75 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p95 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p99 * 1000 | number:0}}</td><td class=\"text-right\">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate=\"metrics.ehcache.title\">Ehcache statistics</h3><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.ehcache.cachename\">Cache name</th><th class=\"text-right\" translate=\"metrics.ehcache.objects\">Objects</th><th class=\"text-right\" translate=\"metrics.ehcache.hits\">Hits</th><th class=\"text-right\" translate=\"metrics.ehcache.misses\">Misses</th><th class=\"text-right\" translate=\"metrics.ehcache.evictioncount\">Eviction count</th><th class=\"text-right\" translate=\"metrics.ehcache.mean\">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in vm.cachesStats\" ng-once><td>{{v.name}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 translate=\"metrics.datasource.title\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\">DataSource statistics (time in millisecond)</h3><div class=\"table-responsive\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\"><table class=\"table table-striped\"><thead><tr><th><span translate=\"metrics.datasource.usage\">Usage</span> ({{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class=\"text-right\" translate=\"metrics.datasource.count\">Count</th><th class=\"text-right\" translate=\"metrics.datasource.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.datasource.min\">Min</th><th class=\"text-right\" translate=\"metrics.datasource.p50\">p50</th><th class=\"text-right\" translate=\"metrics.datasource.p75\">p75</th><th class=\"text-right\" translate=\"metrics.datasource.p95\">p95</th><th class=\"text-right\" translate=\"metrics.datasource.p99\">p99</th><th class=\"text-right\" translate=\"metrics.datasource.max\">Max</th></tr></thead><tbody><tr><td><div class=\"progress progress-striped\"><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value\" value=\"vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/metrics/metrics.modal.html","<!-- Modal used to display the threads dump --><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" translate=\"metrics.jvm.threads.dump.title\">Threads dump</h4></div><div class=\"modal-body pad\"><span class=\"label label-primary\" ng-click=\"threadDumpFilter = {}\">All&nbsp;<span class=\"badge\">{{vm.threadDumpAll}}</span></span>&nbsp; <span class=\"label label-success\" ng-click=\"threadDumpFilter = {threadState: \'RUNNABLE\'}\">Runnable&nbsp;<span class=\"badge\">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class=\"label label-info\" ng-click=\"threadDumpFilter = {threadState: \'WAITING\'}\">Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class=\"label label-warning\" ng-click=\"threadDumpFilter = {threadState: \'TIMED_WAITING\'}\">Timed Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class=\"label label-danger\" ng-click=\"threadDumpFilter = {threadState: \'BLOCKED\'}\">Blocked&nbsp;<span class=\"badge\">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class=\"voffset2\">&nbsp;</div>Filter <input type=\"text\" ng-model=\"threadDumpFilter\" class=\"form-control\"><div class=\"row pad\" ng-repeat=\"(k, v) in vm.threadDump | filter:threadDumpFilter\"><h5><span class=\"label\" ng-class=\"vm.getLabelClass(v.threadState)\">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click=\"show = !show\"><span ng-show=\"!show\" translate=\"metrics.jvm.threads.dump.show\">Show StackTrace</span> <span ng-show=\"show\" translate=\"metrics.jvm.threads.dump.hide\">Hide StackTrace</span></a></h5><div class=\"well\" ng-show=\"show\"><div ng-repeat=\"(stK, stV) in v.stackTrace\">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class=\"voffset1\"></span></div></div><table class=\"table table-condensed\"><thead><tr><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedtime\">Blocked Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedcount\">Blocked Count</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedtime\">Waited Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedcount\">Waited Count</th><th translate=\"metrics.jvm.threads.dump.lockname\">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/docs/docs.html","<iframe src=\"swagger-ui/index.html\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("app/admin/user-admin/user-admin-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.user.login)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"alert alert-danger\" ng-if=\"vm.deleteError\">{{vm.deleteError}}</div><p translate=\"userManagement.delete.question\" translate-values=\"{login: \'{{vm.user.login}}\'}\">Are you sure you want to delete this User?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/admin/user-admin/user-admin-detail.html","<div><h2><span translate=\"userManagement.detail.title\">User</span> \"{{vm.user.login}}\"</h2><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"entity.detail.field\">Field</th><th translate=\"entity.detail.value\">Value</th></tr></thead><tbody><tr><td><span translate=\"userManagement.login\">Login</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.login}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.firstName\">FirstName</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.firstName}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.lastName\">LastName</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.lastName}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.email\">Email</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.email}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.agency\">Agency</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.agence.nom}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.agencesRattachement\">Agences rattachement</span></td><td><ul class=\"list-unstyled\"><li ng-repeat=\"agence in vm.user.agencesRattachement\"><span>{{agence.nom}}</span></li></ul></td></tr><tr><td><span translate=\"userManagement.activated\">Activated</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.activated}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.langKey\">LangKey</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.langKey}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.createdBy\">CreatedBy</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.createdBy}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.createdDate\">CreatedDate</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.lastModifiedBy\">LastModifiedBy</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.lastModifiedBy}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.lastModifiedDate\">LastCreatedDate</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.profiles\">Profiles</span></td><td><ul class=\"list-unstyled\"><li ng-repeat=\"authority in vm.user.authorities\"><span>{{authority}}</span></li></ul></td></tr><tr><td><span translate=\"userManagement.organisationName\">organisationName</span></td><td><a ui-sref=\"organisation-detail({id:vm.user.organisationId})\">{{vm.user.organisationName}}</a><!--                     <input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.organisationName}}\" readonly> --></td></tr><tr><td><span translate=\"userManagement.redmineUserId\">redmineUserId</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.redmineUserId}}\" readonly=\"readonly\"></td></tr></tbody></table></div><div has-any-authority=\"ROLE_ADMIN,ROLE_SUPER_ADMIN\" ng-if=\"vm.mfaStatus\"><h3 translate=\"mfa.title\">Double authentification</h3><p>{{(vm.mfaStatus.enabled ? \'mfa.enabledStatus\' : \'mfa.disabledStatus\') | translate}}</p><div class=\"alert alert-success\" ng-if=\"vm.mfaSuccess\" translate=\"mfa.adminDisabled\">La double authentification a été désactivée pour ce compte.</div><div class=\"alert alert-danger\" ng-if=\"vm.mfaError\" translate=\"mfa.adminFailed\">La double authentification n\'a pas pu être désactivée. Vérifiez votre périmètre autorisé.</div><button type=\"button\" class=\"btn btn-warning\" ng-if=\"vm.mfaStatus.enabled\" ng-click=\"vm.disableMfa()\" ng-disabled=\"vm.mfaBusy\" translate=\"mfa.adminDisable\">Désactiver la double authentification</button><p class=\"help-block\" ng-if=\"vm.mfaStatus.enabled\" translate=\"mfa.adminHelp\">Vérifiez l\'identité de l\'utilisateur avant de débloquer son compte après la perte de son téléphone.</p></div><!-- Diagnostic des installations connues : la date provient de leur dernier enregistrement. --><h3 translate=\"userManagement.android.title\">Appareils Android liés au compte</h3><p><strong translate=\"userManagement.android.latestVersion\">Dernière version de l’application Smartphone vue</strong> : <span>{{vm.user.lastSmartphoneAppVersion || (\'userManagement.android.unknown\' | translate)}}</span> <span ng-if=\"vm.user.lastSmartphoneAppVersionDate\">({{vm.user.lastSmartphoneAppVersionDate | date:\'dd/MM/yyyy HH:mm\'}})</span></p><p class=\"text-muted\" translate=\"userManagement.android.explanation\">Informations déclarées lors du dernier enregistrement de chaque installation, y compris les installations inactives.</p><p ng-if=\"vm.user.androidDevices.length === 0\" translate=\"userManagement.android.empty\">Aucun appareil Android enregistré pour ce compte.</p><div class=\"table-responsive\" ng-if=\"vm.user.androidDevices.length\"><table class=\"table table-striped\"><thead><tr><th translate=\"userManagement.android.model\">Modèle</th><th translate=\"userManagement.android.installation\">Identifiant d’installation</th><th translate=\"userManagement.android.sdk\">Android (niveau SDK)</th><th translate=\"userManagement.android.version\">Version de l’application</th><th translate=\"userManagement.android.state\">État</th><th translate=\"userManagement.android.registrationType\">Mode de notification</th><th translate=\"userManagement.android.permission\">Notifications autorisées</th><th translate=\"userManagement.android.lastSeen\">Dernier enregistrement</th></tr></thead><tbody><tr ng-repeat=\"device in vm.user.androidDevices track by device.id\"><td>{{device.deviceModel || (\'userManagement.android.unknown\' | translate)}}</td><td>{{device.installationId}}</td><td>{{device.androidSdk == null ? (\'userManagement.android.unknown\' | translate) : device.androidSdk}}</td><td>{{device.appVersion || (\'userManagement.android.unknown\' | translate)}}</td><td>{{(device.active ? \'userManagement.android.active\' : \'userManagement.android.inactive\') | translate}}</td><td>{{device.registrationType || (\'userManagement.android.unknown\' | translate)}}</td><td>{{(device.notificationPermission == null ? \'userManagement.android.unknown\' : (device.notificationPermission ? \'userManagement.android.yes\' : \'userManagement.android.no\')) | translate}}</td><td>{{device.lastRegisteredDate | date:\'dd/MM/yyyy HH:mm\'}}</td></tr></tbody></table></div><button type=\"submit\" ui-sref=\"user-admin\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/admin/user-admin/user-admin-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myUserLabel\" translate=\"userManagement.home.createOrEditLabel\">Create or edit a User</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" name=\"id\" ng-model=\"vm.user.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.login\">Login</label><input type=\"text\" class=\"form-control\" name=\"login\" ng-pattern=\"/^[_.@a-z0-9-]*$/\" ng-model=\"vm.user.login\" ng-required=\"vm.user.id == null\" ng-maxlength=\"50\"><div ng-show=\"editForm.login.$invalid\"><p class=\"help-block\" ng-show=\"editForm.login.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.login.$error.pattern\" translate=\"error.user.loginPattern\">Your username can only contain lower-case letters and digits.</p><p class=\"help-block\" ng-show=\"editForm.login.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.firstName\">FirstName</label><input type=\"text\" class=\"form-control\" name=\"firstName\" ng-model=\"vm.user.firstName\" ng-maxlength=\"50\"><div ng-show=\"editForm.firstName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.firstName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"userManagement.lastName\">LastName</label><input type=\"text\" class=\"form-control\" name=\"lastName\" ng-model=\"vm.user.lastName\" ng-maxlength=\"50\"><div ng-show=\"editForm.lastName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"userManagement.organisation\">organisation</label><select class=\"form-control\" name=\"organisationId\" ng-model=\"vm.user.organisationId\" ng-options=\"organisation.id as organisation.name for organisation in vm.organisations \"><!--       			<option ng-repeat=\"organisation in vm.organisations\"  ng-value=\"organisation.id\">{{organisation.name}}</option> --></select></div><div class=\"form-group\"><label translate=\"userManagement.agency\">Agency</label><select class=\"form-control\" name=\"agence\" ng-model=\"vm.user.agence\" ng-options=\"agence as agence.nom for agence in vm.agences track by agence.id\"></select></div><div class=\"form-group\"><label translate=\"userManagement.agencesRattachement\">agencesRattachement</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.user.agencesRattachement\" theme=\"selectize\" title=\"{{\'userManagement.agencesRattachement\' | translate}}\"><ui-select-match placeholder=\"{{\'userManagement.agencesRattachement\' | translate}}\">{{$item.nom}}</ui-select-match><ui-select-choices repeat=\"agence in vm.agences | filter: $select.search  track by agence.id\">{{agence.nom}}</ui-select-choices></ui-select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.email\">Email</label><input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"vm.user.email\" required ng-maxlength=\"100\"><div ng-show=\"editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p></div></div><div class=\"form-group\"><label for=\"activated\"><input ng-disabled=\"vm.user.id === null\" type=\"checkbox\" id=\"activated\" ng-model=\"vm.user.activated\"> <span translate=\"userManagement.activated\">Activated</span></label></div><div class=\"form-group\"><label translate=\"userManagement.langKey\">LangKey</label><select class=\"form-control\" name=\"langKey\" ng-model=\"vm.user.langKey\" ng-options=\"language as language for language in vm.languages track by language\"></select></div><div class=\"form-group\" ng-if=\"vm.user.id != null\"><label class=\"control-label\" translate=\"userManagement.redmineUserId\" for=\"field_redmineUserId\">redmineUserId</label><input type=\"number\" class=\"form-control\" name=\"redmineUserId\" id=\"field_redmineUserId\" ng-model=\"vm.user.redmineUserId\" min=\"0\" max=\"9999999\"><div ng-show=\"editForm.redmineUserId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.redmineUserId.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.redmineUserId.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"9999999\">This field cannot be more than 9999999.</p><p class=\"help-block\" ng-show=\"editForm.redmineUserId.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.assistantMonthlyCostLimitUsd\" for=\"field_assistantMonthlyCostLimitUsd\">Plafond mensuel USD assistant IA</label><p class=\"help-block\">Vide : hérite du plafond par défaut. Zéro : sans plafond. Montants en USD.</p><input type=\"number\" class=\"form-control\" name=\"assistantMonthlyCostLimitUsd\" id=\"field_assistantMonthlyCostLimitUsd\" ng-model=\"vm.user.assistantMonthlyCostLimitUsd\" min=\"0\" step=\"0.01\"></div><div class=\"form-group\"><label translate=\"userManagement.profiles\">Profiles</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.user.authorities\" theme=\"selectize\" title=\"{{\'userManagement.profiles\' | translate}}\"><ui-select-match placeholder=\"{{\'userManagement.profiles\' | translate}}\">{{$item === \'ROLE_EQUIPMENT_REMOTE_CONTROL\' ? (\'userManagement.remoteControl\' | translate) : $item}}</ui-select-match><ui-select-choices repeat=\"authority in vm.authorities | filter: $select.search \">{{authority === \'ROLE_EQUIPMENT_REMOTE_CONTROL\' ? (\'userManagement.remoteControl\' | translate) : authority}}</ui-select-choices></ui-select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/admin/user-admin/user-admin.html","<div><h2 translate=\"userManagement.home.title\">Users</h2><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-12 text-right\"><div class=\"btn-group\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.downloadCsv()\"><span class=\"glyphicon glyphicon-download-alt\"></span> <span translate=\"userManagement.actions.downloadCsv\">Télécharger CSV</span></button><div class=\"btn-group\" uib-dropdown><button class=\"btn btn-default dropdown-toggle\" type=\"button\" uib-dropdown-toggle ng-disabled=\"!vm.hasSelection()\"><span class=\"glyphicon glyphicon-edit\"></span> <span translate=\"userManagement.bulk.menu\">Modifier</span> <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu><li><a href=\"\" ng-click=\"vm.openBulkEdit(\'ADD_AUTHORITY\')\">{{ \'userManagement.bulk.actions.ADD_AUTHORITY\' | translate }}</a></li><li><a href=\"\" ng-click=\"vm.openBulkEdit(\'REMOVE_AUTHORITY\')\">{{ \'userManagement.bulk.actions.REMOVE_AUTHORITY\' | translate }}</a></li><li><a href=\"\" ng-click=\"vm.openBulkEdit(\'ADD_AGENCE\')\">{{ \'userManagement.bulk.actions.ADD_AGENCE\' | translate }}</a></li><li><a href=\"\" ng-click=\"vm.openBulkEdit(\'REMOVE_AGENCE\')\">{{ \'userManagement.bulk.actions.REMOVE_AGENCE\' | translate }}</a></li></ul></div><button class=\"btn btn-primary\" ui-sref=\"user-admin.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"userManagement.home.createLabel\">Create a new User</span></button></div></div></div><div class=\"row\"><div class=\"col-md-3\"><label translate=\"userManagement.home.filter\">Filtre</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.filter\" ng-change=\"vm.applyFilters()\" ng-model-options=\"{debounce: 400}\"></div><div class=\"col-md-3\"><label translate=\"userManagement.filters.role\">Rôle</label><select class=\"form-control\" ng-model=\"vm.selectedRole\" ng-change=\"vm.applyFilters()\" ng-options=\"role as role for role in vm.authorities\"><option value=\"\" translate=\"userManagement.filters.allRoles\">Tous les rôles</option></select></div><div class=\"col-md-3\"><label translate=\"userManagement.filters.agencyAccess\">Droit d\'accès zone</label><select class=\"form-control\" ng-model=\"vm.selectedAgenceId\" ng-change=\"vm.applyFilters()\" ng-options=\"agence.id as agence.nom for agence in vm.agences track by agence.id\"><option value=\"\" translate=\"userManagement.filters.allAreas\">Toutes les zones</option></select></div><div class=\"col-md-2\"><label translate=\"userManagement.filters.state\">État</label><select class=\"form-control\" ng-model=\"vm.selectedActivated\" ng-change=\"vm.applyFilters()\" ng-options=\"option.value as (option.labelKey | translate) for option in vm.stateOptions\"></select></div><div class=\"col-md-1\"><label>&nbsp;</label><button class=\"btn btn-default btn-block\" type=\"button\" ng-click=\"vm.resetFilters()\"><span translate=\"entity.action.reset\">Reset</span></button></div></div><div class=\"row\"><div class=\"col-md-3\"><label translate=\"userManagement.android.registered\">Appareil Android enregistré</label><select class=\"form-control\" ng-model=\"vm.selectedAndroidDevice\" ng-change=\"vm.applyFilters()\" ng-options=\"option.value as (option.labelKey | translate) for option in vm.androidDeviceOptions\"></select></div><div class=\"col-md-3\"><label translate=\"userManagement.android.exactVersion\">Version de l’application Android =</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedAppVersion\" ng-change=\"vm.applyFilters()\" ng-model-options=\"{debounce: 400}\"></div><div class=\"col-md-3\"><label translate=\"userManagement.mfa.title\">MFA</label><select class=\"form-control\" ng-model=\"vm.selectedMfaEnabled\" ng-change=\"vm.applyFilters()\" ng-options=\"option.value as (option.labelKey | translate) for option in vm.mfaOptions\"></select></div></div><p class=\"help-block\" translate=\"userManagement.presence.help\">Présence estimée à partir des échanges Web et Android des deux dernières minutes. Actualisation toutes les 30 secondes.</p><p class=\"help-block\" translate=\"userManagement.android.filterHelp\">Les filtres incluent les installations inactives. La version doit correspondre exactement à celle d’une installation liée au compte.</p><p ng-if=\"vm.totalItems !== null\"><strong translate=\"userManagement.resultCount\" translate-values=\"{count: vm.totalItems}\">{{vm.totalItems}} utilisateur(s) trouvé(s)</strong></p><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th class=\"text-center\" style=\"width: 40px\"><input type=\"checkbox\" ng-model=\"vm.selectAllOnPage\" ng-change=\"vm.toggleSelectAll()\"></th><th translate=\"userManagement.login\">Login</th><th translate=\"userManagement.email\">Email</th><th translate=\"userManagement.agency\">Agency</th><th translate=\"userManagement.organisation\">Organisation</th><th translate=\"userManagement.state\">État</th><th translate=\"userManagement.profiles\">Profiles</th><th translate=\"userManagement.assistantMonthlyCostLimitUsd\">Plafond mensuel USD assistant IA</th><th translate=\"userManagement.mfa.title\">MFA</th><th translate=\"userManagement.android.latestVersion\">Dernière version de l’application Smartphone vue</th><th translate=\"userManagement.presence.status\">Présence</th><th translate=\"userManagement.presence.lastLogin\">Dernière connexion</th><th translate=\"userManagement.presence.lastSeen\">Dernière activité</th><th></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users track by user.id\"><td class=\"text-center\"><input type=\"checkbox\" ng-model=\"vm.selection[user.id]\" ng-change=\"vm.updateSelectAllState()\"></td><td><a ui-sref=\"user-admin-detail({login:user.login})\">{{user.login}}</a></td><td>{{user.email}}</td><td><div ng-repeat=\"agence in user.agencesRattachement\"><span class=\"label label-info\">{{ agence.nom }}</span></div></td><td><a ui-sref=\"organisation-detail({id:user.organisationId})\">{{user.organisationName}}</a></td><td><span class=\"label label-danger\" ng-click=\"vm.setActive(user, true)\" ng-show=\"!user.activated\" translate=\"userManagement.deactivated\" style=\"cursor: pointer\">Desactivated</span> <span class=\"label label-success\" ng-click=\"vm.setActive(user, false)\" ng-show=\"user.activated\" translate=\"userManagement.activated\" style=\"cursor: pointer\">Activated</span></td><td><div ng-repeat=\"authority in user.authorities\"><span class=\"label label-info\">{{ authority }}</span></div></td><td>{{user.assistantMonthlyCostLimitUsd == null ? \"Défaut\" : (user.assistantMonthlyCostLimitUsd === 0 ? \"Illimité\" : user.assistantMonthlyCostLimitUsd)}}</td><td><div>{{(user.mfaEnabled ? \'userManagement.mfa.enabled\' : \'userManagement.mfa.disabled\') | translate}}</div><button type=\"button\" class=\"btn btn-warning btn-xs\" ng-if=\"user.mfaEnabled\" has-any-authority=\"ROLE_ADMIN,ROLE_SUPER_ADMIN\" ng-click=\"vm.disableMfa(user)\" ng-disabled=\"user.mfaBusy\" translate=\"mfa.adminDisableShort\">Désactiver</button><div class=\"text-danger\" ng-if=\"user.mfaError\" translate=\"mfa.adminFailed\">La double authentification n\'a pas pu être désactivée. Vérifiez votre périmètre autorisé.</div></td><td>{{user.lastSmartphoneAppVersion || (\'userManagement.android.unknown\' | translate)}}<div class=\"text-muted\" ng-if=\"user.lastSmartphoneAppVersionDate\">{{user.lastSmartphoneAppVersionDate | date:\'dd/MM/yyyy HH:mm\'}}</div></td><td><span class=\"label\" ng-class=\"user.online ? \'label-success\' : \'label-default\'\" translate=\"{{user.online ? \'userManagement.presence.online\' : \'userManagement.presence.offline\'}}\"></span></td><td>{{user.lastLoginDate ? (user.lastLoginDate | date:\'dd/MM/yyyy HH:mm:ss\') : (\'userManagement.presence.unknown\' | translate)}}</td><td>{{user.lastSeenDate ? (user.lastSeenDate | date:\'dd/MM/yyyy HH:mm:ss\') : (\'userManagement.presence.unknown\' | translate)}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"user-admin-detail({login:user.login})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"user-admin.edit({login:user.login})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"user-admin.delete({login:user.login})\" class=\"btn btn-danger btn-sm\" ng-disabled=\"vm.currentAccount.login==user.login\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div>");
$templateCache.put("app/account/activate/activate.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"activate.title\">Activation</h1><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"activate.messages.success\" translate-compile><strong>Your user has been activated.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login\">sign in</a>.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"activate.messages.error\"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>");
$templateCache.put("app/account/windows-preparation/windows-preparation.html","<div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h2><i class=\"fa fa-desktop\" aria-hidden=\"true\"></i> <span translate=\"windowsPreparation.title\"></span></h2><p class=\"lead\" translate=\"windowsPreparation.introduction\"></p><p translate=\"windowsPreparation.changes\"></p><p class=\"alert alert-info\" ng-if=\"vm.loading\" role=\"status\" translate=\"windowsPreparation.loading\"></p><p class=\"alert alert-danger\" ng-if=\"vm.error\" role=\"alert\" translate=\"windowsPreparation.error\"></p><div ng-if=\"!vm.loading &amp;&amp; !vm.error &amp;&amp; !vm.status.allowed\" class=\"alert alert-info\" role=\"status\"><p ng-if=\"vm.status.reason === \'AREA\'\" translate=\"windowsPreparation.selectArea\"></p><p ng-if=\"vm.status.reason !== \'AREA\'\" translate=\"windowsPreparation.contactAdmin\"></p></div><div ng-if=\"vm.status.allowed\"><p><strong translate=\"windowsPreparation.agency\"></strong> {{vm.status.agencyName}}<span ng-if=\"vm.status.areaName\"> — <strong>AREA :</strong> {{vm.status.areaName}}</span></p><ol><li><strong translate=\"windowsPreparation.stepDownload\"></strong><p translate=\"windowsPreparation.downloadHelp\"></p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.download()\" ng-disabled=\"vm.downloading || vm.loading\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> <span translate=\"windowsPreparation.download\"></span></button></li><li><strong translate=\"windowsPreparation.stepRun\"></strong><p translate=\"windowsPreparation.runHelp\"></p></li><li><strong translate=\"windowsPreparation.stepCheck\"></strong><p translate=\"windowsPreparation.checkHelp\"></p></li></ol><p class=\"alert alert-success\" ng-if=\"vm.downloaded\" role=\"status\" translate=\"windowsPreparation.downloaded\"></p><p class=\"text-muted\" translate=\"windowsPreparation.authorization\"></p></div><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.load()\" ng-disabled=\"vm.loading || vm.downloading\" translate=\"windowsPreparation.refresh\"></button></div></div>");
$templateCache.put("app/account/register/register.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"register.title\">Registration</h1><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"register.messages.success\"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"register.messages.error.fail\"><strong>Registration failed!</strong> Please try again later.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorUserExists\" translate=\"register.messages.error.userexists\"><strong>Login name already registered!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorEmailExists\" translate=\"register.messages.error.emailexists\"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div></div><div class=\"col-md-8 col-md-offset-2\"><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.register()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"login\" translate=\"global.form.username\">Username</label><input type=\"text\" class=\"form-control\" id=\"login\" name=\"login\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.login\" ng-minlength=\"1\" ng-maxlength=\"50\" ng-pattern=\"/^[a-z0-9]*$/\" required><div ng-show=\"form.login.$dirty && form.login.$invalid\"><p class=\"help-block\" ng-show=\"form.login.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-show=\"form.login.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.login.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-show=\"form.login.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.password\" ng-minlength=\"5\" ng-maxlength=\"50\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.pattern\" translate=\"global.messages.validate.confirmpassword.pattern\">Password should contain one number, one upper case and one lower case character.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.registerAccount.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"5\" ng-maxlength=\"50\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.pattern\" translate=\"global.messages.validate.confirmpassword.pattern\">Password should contain one number, one upper case and one lower case character.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"register.form.button\">Register</button></form><p></p><div class=\"alert alert-warning\" translate=\"global.messages.info.authenticated\" translate-compile>If you want to <a class=\"alert-link\" href=\"\" ng-click=\"login()\">sign in</a>, you can try the default accounts:<br>- Administrator (login=\"admin\" and password=\"admin\")<br>- User (login=\"user\" and password=\"user\").</div></div></div></div>");
$templateCache.put("app/account/settings/settings.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h2 translate=\"settings.title\" translate-values=\"{username: \'{{vm.settingsAccount.login}}\'}\">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"settings.messages.success\"><strong>Settings saved!</strong></div><div class=\"alert alert-danger\" ng-show=\"vm.errorEmailExists\" translate=\"settings.messages.error.emailexists\"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"settings.messages.error.fail\"><strong>An error has occurred!</strong> Settings could not be saved.</div><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"firstName\" translate=\"settings.form.firstname\">First Name</label><input type=\"text\" class=\"form-control\" id=\"firstName\" name=\"firstName\" placeholder=\"{{\'settings.form.firstname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.firstName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.firstName.$dirty && form.firstName.$invalid\"><p class=\"help-block\" ng-show=\"form.firstName.$error.required\" translate=\"settings.messages.validate.firstname.required\">Your first name is required.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.minlength\" translate=\"settings.messages.validate.firstname.minlength\">Your first name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.maxlength\" translate=\"settings.messages.validate.firstname.maxlength\">Your first name cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"lastName\" translate=\"settings.form.lastname\">Last Name</label><input type=\"text\" class=\"form-control\" id=\"lastName\" name=\"lastName\" placeholder=\"{{\'settings.form.lastname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.lastName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.lastName.$dirty && form.lastName.$invalid\"><p class=\"help-block\" ng-show=\"form.lastName.$error.required\" translate=\"settings.messages.validate.lastname.required\">Your last name is required.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.minlength\" translate=\"settings.messages.validate.lastname.minlength\">Your last name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.maxlength\" translate=\"settings.messages.validate.lastname.maxlength\">Your last name cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required maxlength=\"100\"><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label for=\"langKey\" translate=\"settings.form.language\">Language</label><select id=\"langKey\" name=\"langKey\" class=\"form-control\" ng-model=\"vm.settingsAccount.langKey\" ng-controller=\"JhiLanguageController as languageVm\" ng-options=\"code as (code | findLanguageFromKey) for code in languageVm.languages\"></select></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"settings.form.button\">Save</button></form><hr><h3 translate=\"mfa.title\">Double authentification</h3><p translate=\"mfa.description\">Ajoutez un code Google Authenticator à votre mot de passe lors des prochaines connexions sur le web et sur Android.</p><div class=\"alert alert-success\" ng-if=\"vm.mfaSuccess\">{{vm.mfaSuccess | translate}}</div><div class=\"alert alert-danger\" ng-if=\"vm.mfaError\">{{vm.mfaError | translate}}</div><p ng-if=\"vm.mfaLoading\" translate=\"mfa.loading\">Chargement…</p><p ng-if=\"!vm.mfaLoading\"><strong>{{(vm.mfaStatus.enabled ? \'mfa.enabledStatus\' : \'mfa.disabledStatus\') | translate}}</strong></p><div class=\"alert alert-info\" ng-if=\"!vm.mfaLoading && !vm.mfaStatus.available\" translate=\"mfa.unavailable\">La double authentification n\'est pas disponible. Contactez un administrateur.</div><form name=\"mfaForm\" ng-if=\"!vm.mfaLoading && vm.mfaStatus.available\" ng-submit=\"vm.mfaStatus.enabled ? vm.disableMfa() : (vm.mfaSetup ? vm.activateMfa() : vm.startMfaSetup())\"><div class=\"form-group\"><label for=\"mfaCurrentPassword\" translate=\"mfa.currentPassword\">Mot de passe actuel</label><input id=\"mfaCurrentPassword\" type=\"password\" class=\"form-control\" ng-model=\"vm.mfaProof.currentPassword\" autocomplete=\"current-password\" maxlength=\"100\" required></div><div ng-if=\"vm.mfaSetup\"><p translate=\"mfa.scanQr\">Dans Google Authenticator, ajoutez un compte en scannant ce QR code.</p><img ng-src=\"{{vm.mfaSetup.qrCode}}\" alt=\"QR code Google Authenticator\" width=\"240\" height=\"240\"><p><span translate=\"mfa.manualKey\">Clé pour une saisie manuelle :</span> <code>{{vm.mfaSetup.secret}}</code></p><p translate=\"mfa.confirmHelp\">Saisissez un premier code pour terminer l\'activation. Cette configuration expire après dix minutes.</p></div><div class=\"form-group\" ng-if=\"vm.mfaSetup || vm.mfaStatus.enabled\"><label for=\"mfaSettingsCode\" translate=\"mfa.code\">Code à six chiffres</label><input id=\"mfaSettingsCode\" type=\"text\" class=\"form-control\" ng-model=\"vm.mfaProof.code\" inputmode=\"numeric\" autocomplete=\"one-time-code\" maxlength=\"6\" ng-pattern=\"/^[0-9]{6}$/\" required></div><button type=\"submit\" class=\"btn\" ng-class=\"vm.mfaStatus.enabled ? \'btn-danger\' : \'btn-primary\'\" ng-disabled=\"mfaForm.$invalid || vm.mfaBusy\">{{(vm.mfaStatus.enabled ? \'mfa.disable\' : (vm.mfaSetup ? \'mfa.confirm\' : \'mfa.enable\')) | translate}}</button> <button type=\"button\" class=\"btn btn-default\" ng-if=\"vm.mfaSetup\" ng-click=\"vm.cancelMfaSetup()\" ng-disabled=\"vm.mfaBusy\" translate=\"mfa.cancel\">Annuler</button></form><p class=\"help-block\" translate=\"mfa.lostPhone\">Si vous perdez votre téléphone, contactez un administrateur pour désactiver la double authentification de votre compte.</p></div></div></div>");
$templateCache.put("app/account/password/password.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h2 translate=\"password.title\" translate-values=\"{username: \'{{vm.account.login}}\'}\">Password for [<b>{{vm.account.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"password.messages.success\"><strong>Password changed!</strong></div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"password.messages.error\"><strong>An error has occurred!</strong> The password could not be changed.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.changePassword()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"currentPassword\" translate=\"global.form.currentPassword\">current password</label><input type=\"password\" class=\"form-control\" id=\"currentPassword\" name=\"currentPassword\" placeholder=\"{{\'global.form.currentPassword.placeholder\' | translate}}\" ng-model=\"vm.currentPassword\" ng-minlength=\"5\" ng-maxlength=\"50\" required><div ng-show=\"form.currentPassword.$dirty && form.currentPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.currentPassword.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.currentPassword.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.currentPassword.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.password\" ng-minlength=\"5\" ng-maxlength=\"50\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.pattern\" translate=\"global.messages.validate.confirmpassword.pattern\">Password should contain one number, one upper case and one lower case character.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"5\" ng-maxlength=\"50\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.pattern\" translate=\"global.messages.validate.confirmpassword.pattern\">Password should contain one number, one upper case and one lower case character.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid ||   vm.isSaving \" class=\"btn btn-primary\" translate=\"password.form.button\">Save</button></form></div></div></div>");
$templateCache.put("app/entities/num-reference-contrat/num-reference-contrat-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.numReferenceContrat.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.numReferenceContrat.delete.question\" translate-values=\"{id: \'{{vm.numReferenceContrat.id}}\'}\">Are you sure you want to delete this NumReferenceContrat?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/num-reference-contrat/num-reference-contrat-detail.html","<div><h2><span translate=\"wamasysApp.numReferenceContrat.detail.title\">NumReferenceContrat</span> {{vm.numReferenceContrat.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.numReferenceContrat.numeroActuel\">NumeroActuel</span></dt><dd><span>{{vm.numReferenceContrat.numeroActuel}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.numReferenceContrat.agence\">agence</span></dt><dd><a ui-sref=\"agence-detail({id:vm.numReferenceContrat.agence.id})\">{{vm.numReferenceContrat.agence.id}}</a></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/num-reference-contrat/num-reference-contrat-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myNumReferenceContratLabel\" translate=\"wamasysApp.numReferenceContrat.home.createOrEditLabel\">Create or edit a NumReferenceContrat</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.numReferenceContrat.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.numReferenceContrat.numeroActuel\" for=\"field_numeroActuel\">NumeroActuel</label><input type=\"text\" class=\"form-control\" name=\"numeroActuel\" id=\"field_numeroActuel\" ng-model=\"vm.numReferenceContrat.numeroActuel\" required ng-maxlength=\"13\"><div ng-show=\"editForm.numeroActuel.$invalid\"><p class=\"help-block\" ng-show=\"editForm.numeroActuel.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.numeroActuel.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"13\">This field cannot be longer than 13 characters.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.numReferenceContrat.agence\" for=\"field_agence\">agence</label><select class=\"form-control\" id=\"field_agence\" name=\"agence\" ng-model=\"vm.numReferenceContrat.agence\" ng-options=\"agence as agence.id for agence in vm.agences track by agence.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/num-reference-contrat/num-reference-contrats.html","<div><h2 translate=\"wamasysApp.numReferenceContrat.home.title\">NumReferenceContrats</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"num-reference-contrat.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.numReferenceContrat.home.createLabel\">Create new NumReferenceContrat</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"numeroActuel\"><span translate=\"wamasysApp.numReferenceContrat.numeroActuel\">NumeroActuel</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agence.id\"><span translate=\"wamasysApp.numReferenceContrat.agence\">agence</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"numReferenceContrat in vm.numReferenceContrats track by numReferenceContrat.id\"><td><a ui-sref=\"num-reference-contrat-detail({id:numReferenceContrat.id})\">{{numReferenceContrat.id}}</a></td><td>{{numReferenceContrat.numeroActuel}}</td><td><a ui-sref=\"agence-detail({id:numReferenceContrat.agence.id})\">{{numReferenceContrat.agence.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"num-reference-contrat-detail({id:numReferenceContrat.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"num-reference-contrat.edit({id:numReferenceContrat.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"num-reference-contrat.delete({id:numReferenceContrat.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/layouts/header/header.html","<header id=\"header\" ng-switch=\"vm.isAuthenticated()\"><div id=\"logo-group\" class=\"hidden-xs\"><span id=\"logo\"><img src=\"content/images/logo_wamasys.png\" alt=\"Wamasys\" style=\"width:95px\"></span></div><current-agence ng-switch-when=\"true\"></current-agence><!-- pulled right: nav area --><div class=\"pull-right\"><ul class=\"header-dropdown-list\" ng-switch-when=\"true\" style=\"display:block !important\"><li class=\"dropdown\"><a href=\"\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" ng-click=\"vm.refreshNotifications()\" title=\"Mes messages\" aria-label=\"Mes messages, {{vm.notifications.unreadCount}} non lus\"><i class=\"fa fa-bell\" aria-hidden=\"true\"></i> <span class=\"badge\" ng-if=\"vm.notifications.unreadCount\">{{vm.notifications.unreadCount}}</span></a><ul class=\"dropdown-menu pull-right\" style=\"min-width:280px;max-width:360px\"><li ng-repeat=\"message in vm.notifications.messages | limitTo:5\"><a ui-sref=\"notification-detail({id:message.id})\" style=\"white-space:normal\"><strong ng-if=\"!message.read\">● </strong>{{message.title || \'Message Wamasys\'}}<br><small>{{message.sentDate | date:\'short\'}}</small></a></li><li ng-if=\"!vm.notifications.messages.length\"><span class=\"padding-10\">Aucun message.</span></li><li class=\"divider\"></li><li><a ui-sref=\"notifications\">Voir tous mes messages</a></li></ul></li></ul><div class=\"alert alert-info\" ng-if=\"vm.notifications.toast\" role=\"status\" aria-live=\"polite\" style=\"position:fixed;right:15px;top:65px;z-index:1100;max-width:320px\"><button type=\"button\" class=\"close\" aria-label=\"Fermer\" ng-click=\"vm.notifications.toast=null\">×</button><p>Vous avez reçu un nouveau message.</p><a ui-sref=\"notification-detail({id:vm.notifications.toast.id})\">Ouvrir le message</a></div><!-- collapse menu button --><div id=\"hide-menu\" class=\"btn-header pull-right visible-xs visible-sm\" ng-switch-when=\"true\"><span><a toggle-menu title=\"Collapse Menu\"><i class=\"fa fa-reorder\"></i></a></span></div><!-- end collapse menu --><!-- #MOBILE --><!-- Top menu profile link : this shows only when top menu is active --><ul id=\"mobile-profile-img\" class=\"header-dropdown-list hidden-xs\" style=\"display:block !important\" ng-switch-when=\"true\"><li class=\"btn-header\"><span><a href=\"\" class=\"dropdown-toggle\" data-toggle=\"dropdown\"><i class=\"fa fa-toggle-down\"></i><!--    <div class=\"\"></div> --></a><ul class=\"dropdown-menu pull-right\"><li><a ui-sref=\"settings\" class=\"padding-10 padding-top-0 padding-bottom-0\"><i class=\"glyphicon glyphicon-wrench\"></i> <span translate=\"global.menu.account.settings\">Settings</span></a></li><li class=\"divider\"></li><li><a ui-sref=\"password\" class=\"padding-10 padding-top-0 padding-bottom-0\"><i class=\"fa fa-user\"></i> <span translate=\"global.menu.account.password\">Mot de passe</span></a></li><li class=\"divider\"></li><li><a ui-sref=\"windows-preparation\" class=\"padding-10 padding-top-0 padding-bottom-0\"><i class=\"fa fa-desktop\" aria-hidden=\"true\"></i> <span translate=\"global.menu.account.windowsPreparation\">Préparer un poste Windows</span></a></li><li class=\"divider\"></li><li has-any-authority=\"ROLE_ADMIN,ROLE_AREA_CONFIGURATION,ROLE_AREA_MANAGEMENT,ROLE_DATA_OPERATOR,ROLE_READ_ONLY,ROLE_SUPER_ADMIN\"><a ui-sref=\"test-plan-runner\" class=\"padding-10 padding-top-0 padding-bottom-0\"><i class=\"fa fa-check-square-o\"></i> <span translate=\"global.menu.account.testPlan\">Plans de test</span></a></li><li class=\"divider\"></li><li has-module=\"AI_ASSISTANT\" has-any-authority=\"ROLE_AI_ASSISTANT,ROLE_ADMIN,ROLE_SUPER_ADMIN\"><a ui-sref=\"ai-assistant-history\" class=\"padding-10 padding-top-0 padding-bottom-0\"><i class=\"fa fa-comments-o\"></i> <span translate=\"global.menu.account.assistantHistory\">Historique assistant IA</span></a></li><li class=\"divider\" has-module=\"AI_ASSISTANT\" has-any-authority=\"ROLE_AI_ASSISTANT,ROLE_ADMIN,ROLE_SUPER_ADMIN\"></li><li><a ng-click=\"logout()\" class=\"padding-10 padding-top-5 padding-bottom-5\"><i class=\"fa fa-sign-out fa-lg\"></i> <strong><span translate=\"global.menu.account.logout\"><u>L</u>ogout</span></strong></a></li></ul></span></li></ul><!-- logout button --><!--\r\n    <div id=\"logout\" class=\"btn-header transparent pull-right\">\r\n        <span> <a ui-sref=\"login\" title=\"Sign Out\"  ng-click=\"logout()\" \r\n                  data-logout-msg=\"You can improve your security further after logging out by closing this opened browser\"><i\r\n                class=\"fa fa-sign-out\"></i></a> </span>\r\n    </div>\r\n    --><!-- end logout button --><!-- search mobile button (this is hidden till mobile view port) --><div id=\"search-mobile\" class=\"btn-header transparent pull-right hidden-xs\" data-search-mobile ng-switch-when=\"true\"><span><a href=\"#\" title=\"Search\"><i class=\"fa fa-search\"></i></a></span></div><!-- end search mobile button --><!-- Help button --><ul id=\"help-ul\" class=\"header-dropdown-list hidden-xs\" style=\"display:block !important\" ng-switch-when=\"true\" ng-if=\"vm.canSeeNewFeatures\"><li class=\"btn-header\"><span><a href=\"\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" title=\"Help\"><i class=\"glyphicon glyphicon-question-sign\"></i></a><ul class=\"dropdown-menu pull-right\"><li><a ui-sref=\"manual-help({doc: \'user-guide\'})\" class=\"padding-10 padding-top-0 padding-bottom-0\"><span translate=\"global.menu.help.userGuide\">User guide</span></a></li><li><a ui-sref=\"manual-help({doc: \'smartphone-guide\'})\" class=\"padding-10 padding-top-0 padding-bottom-0\"><span translate=\"global.menu.help.smartphoneGuide\">Smartphone guide</span></a></li><li><a ui-sref=\"manual-help({doc: \'configuration-guide\'})\" class=\"padding-10 padding-top-0 padding-bottom-0\"><span translate=\"global.menu.help.configurationGuide\">Configuration guide</span></a></li><li ng-if=\"vm.isSuperAdmin\"><a ui-sref=\"manual-help({doc: \'dat\'})\" class=\"padding-10 padding-top-0 padding-bottom-0\"><span translate=\"global.menu.help.datGuide\">DAT</span></a></li></ul></span></li></ul><!-- end Help button --><!-- input: search field --><form class=\"header-search pull-right\" ng-switch-when=\"true\"><input id=\"search-contrat-header\" ng-model=\"vm.searchContratHeader\" type=\"text\" my-enter=\"vm.searchContrat()\" name=\"param\" placeholder=\"{{\'global.header.findContracts\' | translate}}\"> <button ng-click=\"vm.searchContrat()\"><i class=\"fa fa-search\"></i></button> <a href=\"$\" id=\"cancel-search-js\" title=\"Cancel Search\"><i class=\"fa fa-times\"></i></a></form><!-- end input: search field --><!-- fullscreen button --><div id=\"fullscreen\" class=\"btn-header transparent pull-right\" ng-switch-when=\"true\"><span><a full-screen title=\"Full Screen\"><i class=\"fa fa-arrows-alt\"></i></a></span></div><!-- end fullscreen button --><!-- multiple lang dropdown : find all flags in the flags page --><ul class=\"header-dropdown-list hidden-xs ng-cloak\"><li ui-sref-active=\"active\" class=\"dropdown pointer\" ng-controller=\"JhiLanguageController as languageVm\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"\" ng-if=\"languageVm.languages.length > 1\"><span><span class=\"glyphicon glyphicon-flag\"></span> <span class=\"hidden-sm\" translate=\"global.menu.language\"></span><!--{{currentLanguage | findLanguageFromKey}}  --> <b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" ng-if=\"languageVm.languages.length > 1\"><li active-menu=\"{{language}}\" ng-repeat=\"language in languageVm.languages\"><a href=\"\" ng-click=\"languageVm.changeLanguage(language)\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\">{{language | findLanguageFromKey}}</a></li></ul></li></ul><!-- end multiple lang --><div id=\"help-chat\" class=\"btn-header transparent pull-right\" style=\"margin-right: 10px\" ng-if=\"vm.canSeeNewFeatures && vm.canSearchManualHelp\"><span><a title=\"Help chat\" ng-click=\"vm.openAssistant()\"><i class=\"fa fa-comments-o\"></i></a></span></div></div><!-- end pulled right: nav area has-module=\"TEAM\" --><div class=\"\" style=\"margin-left: 40px\" ng-show=\"vm.showteamwork\"><ul class=\"header-dropdown-list\"><li ui-sref-active=\"active\" class=\"dropdown pointer\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"\"><span><i class=\"fa fa-ticket\"></i> <span class=\"hidden-xs\">Teamwork</span> <b class=\"caret\"></b> </span><!-- 	               <span class=\"badge bg-color-blue txt-color-white\">10</span>  --></a><ul class=\"dropdown-menu\"><li><a ui-sref=\"native-tickets\">Tickets et tâches Wama</a></li><li><a href=\"#\" ui-sref=\"teamwork.new_issue\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\">Create an office work</a> <a href=\"{{vm.user.teamworkUrl+\'projects/\'+vm.user.agence.redmineProjetId+\'/issues/new\'}}?username={{vm.username}}\" target=\"_blank\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\">Create an other ticket</a> <a href=\"#\" ui-sref=\"teamwork\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\">Show tickets</a> <a href=\"#\" ui-sref=\"calendar\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\">Calendar</a><!-- 	                   <a href=\"#\"   ui-sref=\"home.new_issue\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\">Create contract feedback</a> --><!-- 	                   <a href=\"#\"   ui-sref=\"home.new_issue\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\">Create assistance ticket</a> --> <a href=\"{{vm.user.teamworkUrl}}?username={{vm.username}}\" target=\"_blank\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\">Open Teamwork</a></li></ul></li></ul></div><!--  	 <div class=\"btn-header hidden-xs\" style=\" margin-left: 40px;\" 	has-module=\"TEAM\" > --><!-- 		<span >  --><!-- 			<a class=\" btn btn-info btn-xs txt-color-red\" href=\"http://{{vm.user.teamworkUrl}}?username={{vm.username}}\" title=\"Wamasys TeamWork\" target=\"_blank\"> --><!-- 			<i class=\"fa fa-ticket\"></i> --><!-- 			Teamwork  --><!-- 			</a> btn btn-sm btn-default --><!-- 			 fa-support fa-group fa-support fa-ticket glyphicon glyphicon-send .glyphicon .glyphicon-question-sign--><!-- 		</span> --><!-- 	</div> --></header>");
$templateCache.put("app/layouts/error/accessdenied.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-12\"><h1 translate=\"error.title\">Error Page!</h1><div class=\"alert alert-danger\" translate=\"error.403\">You are not authorized to access the page.</div><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div></div>");
$templateCache.put("app/layouts/error/error.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-12\"><h1 translate=\"error.title\">Error Page!</h1><div ng-show=\"errorMessage\"><div class=\"alert alert-danger\">{{errorMessage}}</div></div><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></div></div>");
$templateCache.put("app/business/admin-tools/admin-tools.html","<div class=\"admin-tools-page\"><h2>Outils d’administration</h2><p class=\"text-muted\">Diagnostic, réparation des données de reporting et maintenance technique.</p><jhi-alert></jhi-alert><!-- ng-show conserve les formulaires et leur sélection lorsque les panneaux sont repliés. --><section class=\"panel panel-default\" ng-repeat=\"section in vm.adminSections track by section.id\"><div class=\"panel-heading\"><button type=\"button\" class=\"admin-tools-toggle\" ng-click=\"section.open = !section.open\" aria-expanded=\"{{section.open}}\" aria-controls=\"admin-tools-{{section.id}}\"><span class=\"glyphicon\" ng-class=\"section.open ? \'glyphicon-chevron-down\' : \'glyphicon-chevron-right\'\" aria-hidden=\"true\"></span> <span class=\"admin-tools-section-title\">{{section.title}}</span> <span class=\"admin-tools-section-description\">{{section.description}}</span></button></div><div class=\"panel-body\" id=\"admin-tools-{{section.id}}\" ng-show=\"section.open\" ng-include=\"section.template\"></div></section></div>");
$templateCache.put("app/business/admin-tools/advanced.html","<div class=\"admin-tools-operation\"><h3>Export immédiat avancé</h3><p>Les boutons ci-dessous exécutent une demande immédiate, sans le suivi par tranches de la reprise en arrière-plan. Pour une longue période, utilisez le panneau Réparer les données Elasticsearch.</p><p class=\"text-muted\">La période est partagée avec le panneau de reprise. La purge ne concerne que le réexport complet et les événements.</p><div class=\"row\"><div class=\"col-sm-8 col-md-6 form-group\"><label for=\"elasticImmediateDateRange\">Période d’export</label><div class=\"input-group\"><input date-range-picker id=\"elasticImmediateDateRange\" name=\"elasticImmediateDateRange\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.datePeriod\" options=\"vm.opts\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openRangeDateTimePicker(\'elasticImmediateDateRange\')\" aria-label=\"Choisir la période d’export\"><span class=\"glyphicon glyphicon-calendar\"></span></button></span></div></div></div><label class=\"admin-tools-category\"><input type=\"checkbox\" ng-model=\"vm.purgeBeforeExport\"> Purger avant le réexport complet ou l’export des événements</label><div class=\"alert alert-warning\" ng-if=\"vm.purgeBeforeExport\">La purge supprime des documents Elasticsearch avant leur réexport. Elle ne s’applique ni aux boutons par catégorie ni à la reprise en arrière-plan.</div><div class=\"admin-tools-actions\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.reexportElasticPeriod()\" ng-disabled=\"vm.elasticProcessing\">Réexporter la période</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.exportElkWaterConsumption()\" ng-disabled=\"vm.elasticProcessing\">Consommations d’eau</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.exportElkFacturation()\" ng-disabled=\"vm.elasticProcessing\">Facturation</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.exportElkStatContrat()\" ng-disabled=\"vm.elasticProcessing\">Statistiques contrats</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.exportElkContrat()\" ng-disabled=\"vm.elasticProcessing\">Contrats</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.exportElkDiscountCreditNoteRefund()\" ng-disabled=\"vm.elasticProcessing\">Avoirs, factures PDF et reçus</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.exportEventsInElastic()\" ng-disabled=\"vm.elasticProcessing\">Réexporter les événements</button></div><div class=\"table-responsive\" ng-if=\"vm.elasticActions.length\"><h4>Actions exécutées</h4><table class=\"table table-condensed\"><thead><tr><th>Action</th><th>Champ</th><th class=\"text-right\">Supprimés</th><th>Statut</th></tr></thead><tbody><tr ng-repeat=\"action in vm.elasticActions\"><td>{{action.action}}</td><td>{{action.field}}</td><td class=\"text-right\">{{action.deleted}}</td><td>{{action.status}}</td></tr></tbody></table></div></div><div class=\"admin-tools-operation\"><h3>Rôles d’accès Elasticsearch</h3><p>Recréez les rôles des zones après une restauration ou une perte de configuration. Ils sont déjà initialisés lors de l’enregistrement des zones.</p><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.initialiserroleareaelastic()\">Initialiser les rôles zone</button></div><div class=\"admin-tools-operation\"><h3>Comptes et droits Redmine (Teamwork)</h3><p>Cette fonction va créer les comptes dans Redmine si besoin ou mettre à jour les droits si le compte existe déjà. Par contre elle ne met pas à jour les mots de passe, pour ça il faut que l’utilisateur modifie son mot de passe dans Wamasys.</p><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Organisation</label><select class=\"form-control\" name=\"teamworkOrgaId\" ng-model=\"vm.teamworkOrgaId\" required ng-options=\"organisation.id as organisation.name for organisation in vm.organisations \"><option></option></select></div></div><div class=\"col-md-2\"><div class=\"pull-right\"><button class=\"btn-primary pull-right\" ng-click=\"vm.majTeamwork()\">Mettre à jour les comptes Redmine</button></div></div></div></div>");
$templateCache.put("app/business/admin-tools/anonymisation.html","<h3>Anonymisation données d\'une zone</h3><form name=\"anonymisationForm\" class=\"admin-tools-form\"><p>Important l\'affichage du message Succès ne veut pas dire que la tâche est terminée. Elle s’exécute en arrière-plan et peut durer un certain temps.</p><fieldset><div class=\"row\"><div class=\"col-sm-6 col-md-3\"><label class=\"control-label\">Votre mot de passe</label><section class=\"admin-tools-field\"><input type=\"password\" class=\"form-control\" ng-model=\"vm.anonymisationPassword\" id=\"anonymisation_password\"></section></div><div class=\"col-sm-6 col-md-3\"><div class=\"form-group\"><label>Organisation</label><select class=\"form-control\" name=\"anomymisationOrgaId\" ng-model=\"vm.anonymisationOrganisationId\" required ng-options=\"organisation.id as organisation.name for organisation in vm.organisations \"><option value=\"\">Sélectionnez une organisation</option></select></div></div><div class=\"col-sm-6 col-md-3\"><div class=\"form-group\"><label>Zone</label><select class=\"form-control\" name=\"anomymisationAreaId\" ng-model=\"vm.anonymisationAreaId\" required ng-options=\"agence.id as agence.nom for agence in vm.agences \"></select></div></div><div class=\"col-sm-6 col-md-3\"><label class=\"control-label\" for=\"anonymisation_pasEnProd\">Je ne suis pas en production : <input type=\"checkbox\" class=\"form-control\" ng-model=\"vm.anonymisationNotProduction\" id=\"anonymisation_pasEnProd\"></label></div><div class=\"col-sm-6 col-md-3\"><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.anonymiserArea()\">Anonymiser</button></div></div></div></fieldset></form><div class=\"alert alert-warning\">Attention cette fonction va anonymiser les prénoms, nom des contrats, les login des comptes collecteur liés à la zone et modifier les prix de vente.<br>Néanmoins cela n\'anonymise pas les données contenues dans les factures PDF, ni les différents commentaires (sur les discounts, avoir, les changements de prix, etc).<br>Cette fonction est utile pour les démos, mais elle n\'est pas parfaite et on ne doit pas donner un accès direct à une zone anonymisée.</div>");
$templateCache.put("app/business/admin-tools/demo.html","<p>Ces outils créent ou transforment des données de démonstration. Vérifiez l’environnement et la zone avant toute action.</p><div class=\"admin-tools-operation\" ng-include=\"\'app/business/admin-tools/generation.html\'\"></div><div class=\"admin-tools-operation\" ng-include=\"\'app/business/admin-tools/injection.html\'\"></div><div class=\"admin-tools-operation\" ng-include=\"\'app/business/admin-tools/anonymisation.html\'\"></div>");
$templateCache.put("app/business/admin-tools/diagnostic.html","<p>Comparez les données PostgreSQL et Elasticsearch jusqu’à la date choisie pour repérer les écarts à examiner.</p><div class=\"row\"><div class=\"col-sm-6 col-md-4 form-group\"><label for=\"adminComparisonDate\">Date de comparaison</label><div class=\"input-group\"><input id=\"adminComparisonDate\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.toDatecheckExport\" is-open=\"vm.datePickerOpenStatus.toDatecheckExport\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDatecheckExport\')\" aria-label=\"Choisir la date de comparaison\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.exportElkCheckexport()\" ng-disabled=\"vm.elasticProcessing\">Comparer</button><p class=\"text-muted\" ng-if=\"vm.elasticProcessing\">Traitement Elastic en cours…</p><div class=\"table-responsive\" ng-if=\"vm.checkExportRows.length\"><h4>Écarts de comparaison</h4><table class=\"table table-striped table-condensed\"><thead><tr><th>Domaine</th><th>Indicateur</th><th class=\"text-right\">PostgreSQL</th><th class=\"text-right\">Elastic</th><th class=\"text-right\">Écart</th><th class=\"text-right\">Écart %</th><th>Statut</th></tr></thead><tbody><tr ng-repeat=\"row in vm.checkExportRows\" ng-class=\"{\'danger\': row.status === \'ECART\'}\"><td>{{row.category}}</td><td>{{row.metric}}</td><td class=\"text-right\">{{row.postgresql}}</td><td class=\"text-right\">{{row.elastic}}</td><td class=\"text-right\">{{row.difference}}</td><td class=\"text-right\">{{row.differencePercent}}</td><td><span class=\"label\" ng-class=\"{\'label-success\': row.status === \'OK\', \'label-danger\': row.status === \'ECART\'}\">{{row.status}}</span> <span ng-if=\"row.note\" class=\"small text-muted\">{{row.note}}</span></td></tr></tbody></table></div>");
$templateCache.put("app/business/admin-tools/generation.html","<h3>Création d\'une zone avec des données de test</h3><details class=\"admin-tools-help\"><summary>Comprendre les données générées</summary><div>Cette fonction va créer une nouvelle Organisation, une nouvelle agence et une nouvelle zone. Les données référentielles (type discount, type de client, etc) sont créées automatiquement.<br>La zone possède 2 types de contrat : Particulier et borne fontaine.<br>Les données créées dans la zone sont :<br><ul><li>2 Bulk</li><li>2 Cluster</li><li>Le nombre de contrats et de compteurs par cluster est paramétrable.</li><li>Le coefficient multiplicateur permet de multiplier le nombre de cluster et donc ainsi le nombre de contrat, compteurs, etc .</li><li>Le mode Java crée un historique de relevés, de consommations d’eau et de facturations, avec un relevé tous les sept jours. La durée est définie par le champ Historique (années).</li><li>Le coefficient multiplicateur Année permet de multiplier le nombre d\'année d\'historique qu\'on souhaite.</li></ul><br>Le traitement peut être long (plusieurs dizaines de minutes). Dès le départ vous pouvez consulter les données, attention cependant si vous modifiez des données (génération de facture) cela peut interrompre le traitement.<br>À la fin du traitement un export vers la base bigdata est lancé. Donc si vous voyez des données de l\'agence dans le reporting bigData c\'est que la création des données est terminée.</div></details><form name=\"generationForm\" class=\"admin-tools-form\"><fieldset><div class=\"row\"><div class=\"col-sm-6 col-md-3\"><label class=\"control-label\">Nom de l’organisation</label><section class=\"admin-tools-field\"><input type=\"text\" maxlength=\"50\" class=\"form-control\" ng-model=\"vm.orgaName\" id=\"generation_orgaName\"></section></div><div class=\"col-sm-6 col-md-3\"><label class=\"control-label\">Code de la zone</label><section class=\"admin-tools-field\"><input type=\"text\" maxlength=\"4\" class=\"form-control\" ng-model=\"vm.codeArea\" id=\"generation_codeArea\"></section></div><div class=\"col-sm-6 col-md-3\"><label class=\"control-label\">Nom de la zone</label><section class=\"admin-tools-field\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.areaName\" id=\"generation_areaName\"></section></div><div class=\"col-sm-6 col-md-3\"><label class=\"control-label\">Nom de l’agence</label><section class=\"admin-tools-field\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.agenceName\" id=\"generation_agenceName\"></section></div><div class=\"col-sm-6 col-md-3\"><label class=\"control-label\">Langue</label><section class=\"admin-tools-field\"><select class=\"form-control\" ng-model=\"vm.codeLangue\" id=\"generation_codeLangue\"><option value=\"en\">English</option><option value=\"fr\">Français</option></select></section></div></div><div class=\"row\" style=\"margin-top:10px\"><div class=\"col-md-6\"><div class=\"admin-tools-help\" style=\"margin-bottom:0\">Le mode <strong>Java cohérent</strong> garde des données métier réalistes. Le mode <strong>SQL massif</strong> sert aux charges volumineuses, avec environ <strong>2 ans</strong> d\'historique paramétrable.</div></div><div class=\"col-md-6\"><div class=\"admin-tools-help\" style=\"margin-bottom:0\">Pour plusieurs millions de contrats, commencer par le mode SQL massif et augmenter progressivement le volume cible par zone.</div></div></div><div class=\"row\"><div class=\"col-sm-6 col-md-3\"><label class=\"control-label\">Mode</label><section class=\"admin-tools-field\"><select class=\"form-control\" ng-model=\"vm.generationMode\" id=\"generation_generationMode\"><option value=\"JAVA_COHERENT\">Java cohérent</option><option value=\"SQL_MASSIVE\">SQL massif</option><option value=\"HYBRID\">Hybride</option></select></section></div><div class=\"col-sm-6 col-md-3\"><label class=\"control-label\">Historique (années)</label><section class=\"admin-tools-field\"><input type=\"number\" min=\"1\" class=\"form-control\" ng-model=\"vm.coefNbrYear\" id=\"generation_coefNbrYear\"></section></div><div class=\"col-md-6\"><div class=\"admin-tools-help\" style=\"margin-bottom:0\">Le mode hybride combine la création métier cohérente et l\'injection SQL massive sur la même zone.</div></div></div><div class=\"row\"><div class=\"col-sm-6 col-md-3\"><label class=\"control-label\">Votre mot de passe</label><section class=\"admin-tools-field\"><input type=\"password\" class=\"form-control\" ng-model=\"vm.generationPassword\" id=\"generation_password\"></section></div><div class=\"col-sm-6 col-md-3\" ng-if=\"vm.generationMode === \'JAVA_COHERENT\' || vm.generationMode === \'HYBRID\'\"><label class=\"control-label\">Contrats / cluster</label><section class=\"admin-tools-field\"><input type=\"number\" class=\"form-control\" ng-model=\"vm.numberOfContractByCluster\" id=\"generation_numberOfContractByCluster\"></section></div><div class=\"col-sm-6 col-md-3\" ng-if=\"vm.generationMode === \'JAVA_COHERENT\' || vm.generationMode === \'HYBRID\'\"><label class=\"control-label\">Coefficient clusters</label><section class=\"admin-tools-field\"><input type=\"number\" class=\"form-control\" ng-model=\"vm.coefMultiplicateur\" id=\"generation_coefMultiplicateur\"></section></div><div class=\"col-sm-6 col-md-3\" ng-if=\"vm.generationMode === \'SQL_MASSIVE\' || vm.generationMode === \'HYBRID\'\"><label class=\"control-label\">Contrats SQL</label><section class=\"admin-tools-field\"><input type=\"number\" min=\"1\" class=\"form-control\" ng-model=\"vm.sqlContractCount\" id=\"generation_sqlContractCount\"></section></div><div class=\"col-sm-6 col-md-3\"><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.createAreaTest()\">Créer la zone</button></div></div></div></fieldset></form><div class=\"alert alert-warning\">Vous devez vous déconnecter et vous reconnecter pour voir la nouvelle organisation.<br>Votre compte sera relié à la nouvelle organisation, pour changer l\'organisation sur votre compte vous devez aller dans Technical supervision > User management et modifier l\'organisation sur votre compte.</div>");
$templateCache.put("app/business/admin-tools/injection.html","<h3>Injecter jeu de données sur zone existante</h3><form name=\"injectionForm\" class=\"admin-tools-form\"><p>Cette fonction va créer depuis les dernières lectures de compteur et collection list, des relevés, facturation et paiement jusqu’à aujourd\'hui (sur la base d\'un relevé par semaine).<br>Attention la fonction ne fonctionne que pour un collecteur et part du principe que la date du dernier relevé sur le 1er bulk est la date du dernier relevé (ça ne marchera pas si il y a des relevés des compteurs individuels).</p><fieldset><div class=\"row\"><div class=\"col-sm-6 col-md-3\"><div class=\"form-group\"><label>Organisation</label><select class=\"form-control\" name=\"anomymisationOrgaId\" ng-model=\"vm.injectionOrganisationId\" required ng-options=\"organisation.id as organisation.name for organisation in vm.organisations \"><option value=\"\">Sélectionnez une organisation</option></select></div></div><div class=\"col-sm-6 col-md-3\"><div class=\"form-group\"><label>Zone</label><select class=\"form-control\" name=\"anomymisationAreaId\" ng-model=\"vm.injectionAreaId\" required ng-options=\"agence.id as agence.nom for agence in vm.agences \"></select></div></div><div class=\"col-sm-6 col-md-3\"><label class=\"control-label\" for=\"injection_pasEnProd\">Je ne suis pas en production : <input type=\"checkbox\" class=\"form-control\" ng-model=\"vm.injectionNotProduction\" id=\"injection_pasEnProd\"></label></div><div class=\"col-sm-6 col-md-3\"><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.injecterJeuTesta()\">Injecter données</button></div></div></div></fieldset></form>");
$templateCache.put("app/business/admin-tools/recovery.html","<div class=\"row\"><div class=\"col-sm-8 col-md-6 form-group\"><label for=\"elasticDateRange\">Période d’export</label><div class=\"input-group\"><input date-range-picker id=\"elasticDateRange\" name=\"elasticDateRange\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.datePeriod\" options=\"vm.opts\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openRangeDateTimePicker(\'elasticDateRange\')\" aria-label=\"Choisir la période d’export\"><span class=\"glyphicon glyphicon-calendar\"></span></button></span></div></div></div><p><strong>Périmètre : toutes les organisations de cet environnement.</strong> Cette reprise actualise la copie Elasticsearch, sans modifier les facturations ni les paiements de Wamasys.</p><p>Choisissez la période et les catégories à reprendre depuis PostgreSQL. Par défaut, les documents existants sont actualisés sans purge. Vous pouvez reconstruire les catégories datées avec une purge préalable de chaque tranche. Le traitement continue après fermeture de cet écran.</p><p>Sans purge, la période porte sur les dates de création ou de modification. Avec purge, elle porte sur les dates métier : opération, paiement, fin de facture ou jours de consommation. Les statistiques reprennent le dernier état disponible de chaque mois concerné, jusqu’à aujourd’hui pour le mois courant.</p><div class=\"row\"><div class=\"col-md-7 admin-tools-categories\"><label class=\"admin-tools-category\" ng-repeat=\"category in vm.reexportCategories\"><input type=\"checkbox\" ng-model=\"category.selected\" ng-disabled=\"vm.reexportPurgeBeforeExport && category.code === \'CONTRACTS\'\"> {{category.label}}</label></div><div class=\"col-md-5\"><label>Taille des tranches</label><select class=\"form-control\" ng-model=\"vm.reexportChunkDays\" ng-disabled=\"vm.reexportBusy\" ng-options=\"option.days as option.label for option in vm.reexportChunkOptions\"></select><p>Les statistiques sont traitées par mois.</p><label class=\"admin-tools-category\"><input type=\"checkbox\" ng-model=\"vm.reexportPurgeBeforeExport\" ng-disabled=\"vm.reexportBusy || vm.reexportHasContractsSelected()\"> Purger chaque période avant reconstruction</label><p class=\"text-muted\">Les contrats restent disponibles uniquement sans purge : leur index représente l’état courant.</p><div class=\"alert alert-warning\" ng-if=\"vm.reexportPurgeBeforeExport\">Les documents des catégories choisies sont supprimés dans Elasticsearch puis reconstruits depuis PostgreSQL. Le reporting peut être incomplet pendant le traitement ou après un échec. Les statistiques sont purgées et reconstruites par mois entier. Cette option concerne toutes les organisations de cet environnement.</div><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.startReexportJob()\" ng-disabled=\"vm.reexportBusy || vm.reexportActive\">{{vm.reexportPurgeBeforeExport ? \'Démarrer avec purge et reconstruction\' : \'Démarrer la reprise sans purge\'}}</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.refreshReexportJobs()\">Actualiser</button></div></div><div class=\"table-responsive\" ng-if=\"vm.reexportJobs.length\"><table class=\"table table-condensed\"><thead><tr><th>Période</th><th>Mode</th><th>État</th><th>Progression</th><th>Prochaine tranche</th><th>Durée cumulée</th><th></th></tr></thead><tbody><tr ng-repeat=\"job in vm.reexportJobs track by job.id\"><td>{{job.fromDate}} — {{job.toDate}}</td><td>{{job.purgeBeforeExport ? \'Purge et reconstruction\' : \'Sans purge\'}}</td><td>{{vm.reexportStatusLabel(job.status)}}<p ng-if=\"job.errorMessage\">{{job.errorMessage}}</p></td><td>{{job.completedChunks}} / {{job.totalChunks}} tranches</td><td><span ng-if=\"job.status !== \'SUCCESS\'\">{{vm.reexportCategoryLabel(job.categories[job.categoryIndex])}} : {{job.nextDate}}</span></td><td>{{job.durationMillis / 1000 | number:1}} s</td><td><button type=\"button\" class=\"btn btn-default\" ng-if=\"job.status === \'ERROR\'\" ng-click=\"vm.resumeReexportJob(job)\" ng-disabled=\"vm.reexportBusy || vm.reexportActive\">Reprendre</button></td></tr></tbody></table></div><p class=\"text-muted\" ng-if=\"!vm.reexportJobs.length\">Aucune reprise enregistrée.</p><details class=\"admin-tools-help\"><summary>Comprendre le suivi et la reprise après erreur</summary><p>Une seule reprise peut être active. Chaque tranche réussie enregistre son avancement. Après un redémarrage du serveur, la dernière tranche non confirmée est rejouée automatiquement.</p><p>En cas d’erreur, faites vérifier les journaux techniques, puis cliquez sur Reprendre après résolution. Les tranches déjà confirmées sont conservées. Avec purge, la tranche non confirmée est à nouveau purgée puis reconstruite ; une suppression incomplète bloque la reprise. La durée cumulée exclut l’attente entre les traitements ; elle ne donne pas une heure de fin.</p><p>Les statistiques reprennent chaque mois concerné avec son dernier état disponible. Une reprise terminée doit être suivie d’une nouvelle comparaison après visibilité des données dans Elasticsearch.</p></details>");
$templateCache.put("app/business/admin-tools/support.html","<div class=\"admin-tools-operation\"><h3>Documentation de l’assistant</h3><p>Actualisez l’index utilisé par l’aide et l’assistant après une modification des manuels.</p><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.indexManualDocs()\">Indexer la documentation</button></div><div class=\"admin-tools-operation\"><h3>Réinitialisation du mot de passe du portail client</h3><div class=\"alert alert-warning\">Cette action supprime tous les compteurs de limitation des demandes de réinitialisation de mot de passe. Elle lève les blocages liés à un trop grand nombre de demandes, pour l’ensemble du portail client.</div><button type=\"button\" class=\"btn btn-warning\" ng-click=\"vm.clearClientPortalResetRateLimit()\">Lever les blocages de réinitialisation</button></div>");
$templateCache.put("app/business/ai-assistant-monitoring/ai-assistant-monitoring.html","<div><h2 translate=\"wamasysApp.aiAssistantMonitoring.home.title\">Supervision assistant IA</h2><p has-any-authority=\"ROLE_SUPER_ADMIN\"><a ui-sref=\"ai-assistant-system-commands\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-list-alt\"></span> Commandes systeme IA</a></p><jhi-alert></jhi-alert><div class=\"row\" ng-if=\"vm.isSuperAdmin\"><div class=\"col-sm-3\"><div class=\"well text-center\"><div class=\"h3\">{{vm.overview.totalConversations || 0}}</div><div translate=\"wamasysApp.aiAssistantMonitoring.summary.total\">Conversations</div></div></div><div class=\"col-sm-3\"><div class=\"well text-center\"><div class=\"h3 text-success\">{{vm.overview.satisfiedConversations || 0}}</div><div translate=\"wamasysApp.aiAssistantMonitoring.summary.ok\">Satisfaites</div></div></div><div class=\"col-sm-3\"><div class=\"well text-center\"><div class=\"h3 text-danger\">{{vm.overview.unsatisfiedConversations || 0}}</div><div translate=\"wamasysApp.aiAssistantMonitoring.summary.non\">Insatisfaites</div></div></div><div class=\"col-sm-3\"><div class=\"well text-center\"><div class=\"h3 text-muted\">{{vm.overview.noFeedbackConversations || 0}}</div><div translate=\"wamasysApp.aiAssistantMonitoring.summary.noFeedback\">Sans reponse</div></div></div><div class=\"col-sm-3\"><div class=\"well text-center\"><div class=\"h3\">{{vm.filteredTotalTokens || 0}}</div><div translate=\"wamasysApp.aiAssistantMonitoring.summary.filteredTokens\">Tokens filtres</div></div></div><div class=\"col-sm-3\"><div class=\"well text-center\"><div class=\"h3\">{{vm.overview.distinctUsers || 0}}</div><div>Users distincts</div></div></div><div class=\"col-sm-3\"><div class=\"well text-center\"><div class=\"h3\">{{vm.overview.distinctOrganisations || 0}}</div><div>Organisations distinctes</div></div></div></div><div class=\"row\" ng-if=\"!vm.isSuperAdmin\"><div class=\"col-sm-3\"><div class=\"well text-center\"><div class=\"h3\">{{vm.filteredTotalTokens || 0}}</div><div translate=\"wamasysApp.aiAssistantMonitoring.summary.filteredTokens\">Tokens filtrés</div></div></div></div><div class=\"row margin-bottom-10\" ng-if=\"vm.isSuperAdmin\"><div class=\"col-sm-3\"><label class=\"control-label\" translate=\"wamasysApp.aiAssistantMonitoring.filters.feedbackStatus\">Satisfaction</label><select class=\"form-control\" ng-model=\"vm.filters.feedbackStatus\" ng-change=\"vm.applyFeedbackFilter()\"><option value=\"ALL\" translate=\"wamasysApp.aiAssistantMonitoring.filters.all\">Toutes</option><option value=\"OK\" translate=\"wamasysApp.aiAssistantMonitoring.filters.ok\">Satisfaites</option><option value=\"NON\" translate=\"wamasysApp.aiAssistantMonitoring.filters.non\">Insatisfaites</option><option value=\"SANS_REPONSE\" translate=\"wamasysApp.aiAssistantMonitoring.filters.noFeedback\">Sans reponse</option></select></div><div class=\"col-sm-3\"><label class=\"control-label\">Utilisateur</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.filters.userLogin\" ng-change=\"vm.applyFeedbackFilter()\" placeholder=\"login\"></div><div class=\"col-sm-3\"><label class=\"control-label\">Organisation</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.filters.organisationName\" ng-change=\"vm.applyFeedbackFilter()\" placeholder=\"organisation\"></div><div class=\"col-sm-3\"><label class=\"control-label\">Reference contrat</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.filters.contractReference\" ng-change=\"vm.applyFeedbackFilter()\" placeholder=\"reference contrat\"></div></div><div class=\"row margin-bottom-10\"><div class=\"col-sm-3\"><label class=\"control-label\">Date debut</label><input type=\"date\" class=\"form-control\" ng-model=\"vm.filters.dateFrom\" ng-change=\"vm.applyFeedbackFilter()\"></div><div class=\"col-sm-3\"><label class=\"control-label\">Date fin</label><input type=\"date\" class=\"form-control\" ng-model=\"vm.filters.dateTo\" ng-change=\"vm.applyFeedbackFilter()\"></div><div class=\"col-sm-2\" ng-if=\"vm.isSuperAdmin\"><label class=\"control-label\">Action executee</label><select class=\"form-control\" ng-model=\"vm.filters.hasExecutedActions\" ng-change=\"vm.applyFeedbackFilter()\"><option value=\"ALL\">Toutes</option><option value=\"true\">Oui</option><option value=\"false\">Non</option></select></div><div class=\"col-sm-2\" ng-if=\"vm.isSuperAdmin\"><label class=\"control-label\">Erreur</label><select class=\"form-control\" ng-model=\"vm.filters.hasErrors\" ng-change=\"vm.applyFeedbackFilter()\"><option value=\"ALL\">Toutes</option><option value=\"true\">Oui</option><option value=\"false\">Non</option></select></div><div class=\"col-sm-2\" ng-if=\"vm.isSuperAdmin\"><label class=\"control-label\">Area</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.filters.areaName\" ng-change=\"vm.applyFeedbackFilter()\" placeholder=\"area\"></div><div class=\"col-sm-3\" ng-if=\"!vm.isSuperAdmin\"><label class=\"control-label\">&nbsp;</label><div class=\"well well-sm text-center\">{{vm.filteredConversations.length || 0}} conversation(s)</div></div><div class=\"col-sm-2\"><label class=\"control-label\">&nbsp;</label><button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"vm.loadOverview()\" ng-disabled=\"vm.loadingOverview\"><span class=\"glyphicon glyphicon-refresh\"></span> <span translate=\"wamasysApp.aiAssistantMonitoring.actions.refresh\">Actualiser</span></button></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong translate=\"wamasysApp.aiAssistantMonitoring.table.title\">Conversations archivees</strong> <span class=\"pull-right text-muted\">{{vm.filteredConversations.length || 0}}</span></div><div class=\"panel-body\" ng-if=\"vm.loadingOverview\"><span translate=\"wamasysApp.aiAssistantMonitoring.loading.overview\">Chargement des conversations...</span></div><div class=\"table-responsive ai-assistant-monitoring__conversation-list\" ng-if=\"!vm.loadingOverview\" infinite-scroll=\"vm.loadMoreConversations()\" infinite-scroll-distance=\"1\"><table class=\"table table-striped table-hover\"><thead><tr><th ng-if=\"vm.isSuperAdmin\" translate=\"wamasysApp.aiAssistantMonitoring.table.status\">Statut</th><th translate=\"wamasysApp.aiAssistantMonitoring.table.context\">Contexte</th><th>Catégories envoyées</th><th ng-if=\"vm.isSuperAdmin\">Reference / contexte</th><th ng-if=\"vm.isSuperAdmin\">Area</th><th ng-if=\"vm.isSuperAdmin\" translate=\"wamasysApp.aiAssistantMonitoring.table.user\">Utilisateur</th><th ng-if=\"vm.isSuperAdmin\" translate=\"wamasysApp.aiAssistantMonitoring.table.organisation\">Organisation</th><th translate=\"wamasysApp.aiAssistantMonitoring.table.tokens\">Jetons</th><th translate=\"wamasysApp.aiAssistantMonitoring.table.lastActivity\">Derniere activite</th></tr></thead><tbody><tr ng-repeat=\"conversation in vm.visibleConversations\" ng-click=\"vm.selectConversation(conversation)\" ng-class=\"{\'info\': vm.isConversationSelected(conversation)}\" style=\"cursor: pointer\"><td ng-if=\"vm.isSuperAdmin\"><span ng-class=\"vm.getFeedbackStatusClass(conversation.feedbackStatus)\"><span ng-if=\"conversation.feedbackStatus === \'OK\'\" translate=\"wamasysApp.aiAssistantMonitoring.filters.ok\">Satisfaites</span> <span ng-if=\"conversation.feedbackStatus === \'NON\'\" translate=\"wamasysApp.aiAssistantMonitoring.filters.non\">Insatisfaites</span> <span ng-if=\"conversation.feedbackStatus === \'SANS_REPONSE\'\" translate=\"wamasysApp.aiAssistantMonitoring.filters.noFeedback\">Sans reponse</span></span></td><td><div><strong>{{conversation.contextType || \'-\'}}</strong></div><small class=\"text-muted\">{{conversation.conversationDisplayId}}</small><div ng-if=\"vm.isSuperAdmin\"><span class=\"label label-warning\" ng-if=\"conversation.hasExecutedActions\">Action</span> <span class=\"label label-danger\" ng-if=\"conversation.hasErrors\">Error</span></div></td><td><span class=\"label label-info\" ng-repeat=\"scopeLabel in vm.getDataScopeLabels(conversation.selectedDataScopes) track by $index\" style=\"margin-right: 4px\">{{scopeLabel}}</span></td><td ng-if=\"vm.isSuperAdmin\"><div>{{conversation.contractReference || conversation.contextLabel || \'-\'}}</div><small class=\"text-muted\" ng-if=\"conversation.entityId\">ID {{conversation.entityId}}</small></td><td ng-if=\"vm.isSuperAdmin\">{{conversation.areaName || \'-\'}}</td><td ng-if=\"vm.isSuperAdmin\">{{conversation.userLogin || \'-\'}}</td><td ng-if=\"vm.isSuperAdmin\">{{conversation.organisationName || \'-\'}}</td><td>{{conversation.totalTokens || 0}}</td><td><div>{{conversation.lastActivityAt | date:\'dd/MM/yyyy HH:mm:ss\'}}</div><small class=\"text-muted\">{{conversation.eventCount || 0}} <span translate=\"wamasysApp.aiAssistantMonitoring.table.events\">echanges</span></small></td></tr><tr ng-if=\"!vm.filteredConversations.length\"><td colspan=\"{{vm.isSuperAdmin ? 9 : 4}}\" class=\"text-center text-muted\" translate=\"wamasysApp.aiAssistantMonitoring.empty\">Aucune conversation archivee.</td></tr></tbody></table><div class=\"text-center text-muted\" ng-if=\"vm.visibleConversations.length && vm.visibleConversations.length < vm.filteredConversations.length\">{{vm.visibleConversations.length}} / {{vm.filteredConversations.length}} conversations affichees. Continuez a scroller pour charger la suite.</div></div></div></div><div class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong translate=\"wamasysApp.aiAssistantMonitoring.detail.title\">Historique des echanges</strong> <span class=\"pull-right\" ng-if=\"vm.detail\"><button has-any-authority=\"ROLE_SUPER_ADMIN\" type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.copyConversationFlowJson()\" ng-disabled=\"!vm.detail.events.length\"><span class=\"glyphicon glyphicon-copy\"></span> <span>Copier flux JSON</span></button> <button has-any-authority=\"ROLE_SUPER_ADMIN\" type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.copyConversationApiExchangeJson()\" ng-disabled=\"!vm.detail.events.length\"><span class=\"glyphicon glyphicon-transfer\"></span> <span>Copier echange JSON</span></button> <span ng-class=\"vm.getFeedbackStatusClass(vm.detail.feedbackStatus)\">{{vm.detail.feedbackStatus}}</span></span></div><div class=\"panel-body\" ng-if=\"vm.loadingDetail\"><span translate=\"wamasysApp.aiAssistantMonitoring.loading.detail\">Chargement du detail...</span></div><div class=\"panel-body\" ng-if=\"!vm.loadingDetail && !vm.detail\"><span class=\"text-muted\" translate=\"wamasysApp.aiAssistantMonitoring.detail.empty\">Selectionnez une conversation pour voir les echanges et le JSON archive.</span></div><div class=\"panel-body\" ng-if=\"!vm.loadingDetail && vm.detail\"><p><strong translate=\"wamasysApp.aiAssistantMonitoring.detail.conversationId\">Conversation</strong>: <span>{{vm.detail.conversationDisplayId}}</span></p><p ng-if=\"vm.isSuperAdmin\"><strong translate=\"wamasysApp.aiAssistantMonitoring.detail.meta\">Contexte</strong>: <span>{{vm.detail.contextType || \'-\'}}</span>, <strong>Reference / contexte</strong>: <span>{{vm.detail.contractReference || vm.detail.contextLabel || \'-\'}}</span>, <strong translate=\"wamasysApp.aiAssistantMonitoring.table.entity\">Id entite</strong>: <span>{{vm.detail.entityId || \'-\'}}</span>, <strong>Area</strong>: <span>{{vm.detail.areaName || \'-\'}}</span>, <strong translate=\"wamasysApp.aiAssistantMonitoring.table.user\">Utilisateur</strong>: <span>{{vm.detail.userLogin || \'-\'}}</span> <span>, <strong translate=\"wamasysApp.aiAssistantMonitoring.detail.tokens\">Tokens conversation</strong>: {{vm.detail.totalTokens || 0}}</span> <span ng-if=\"vm.detail.hasExecutedActions\">, <span class=\"label label-warning\">Action</span></span> <span ng-if=\"vm.detail.hasErrors\">, <span class=\"label label-danger\">Error</span></span></p><p ng-if=\"!vm.isSuperAdmin\"><strong translate=\"wamasysApp.aiAssistantMonitoring.detail.meta\">Contexte</strong>: <span>{{vm.detail.contextLabel || vm.detail.contextType || \'-\'}}</span>, <strong translate=\"wamasysApp.aiAssistantMonitoring.detail.contract\">Référence contrat</strong>: <span>{{vm.detail.contractReference || \'-\'}}</span>, <strong translate=\"wamasysApp.aiAssistantMonitoring.detail.tokens\">Jetons de la conversation</strong>: <span>{{vm.detail.totalTokens || 0}}</span></p><p ng-if=\"!vm.isSuperAdmin\"><strong>Catégories envoyées</strong>: <span class=\"label label-info\" ng-repeat=\"scopeLabel in vm.getDataScopeLabels(vm.detail.selectedDataScopes) track by $index\" style=\"margin-right: 4px\">{{scopeLabel}}</span></p><p ng-if=\"vm.isSuperAdmin && vm.detail.feedbackComment\"><strong translate=\"wamasysApp.aiAssistantMonitoring.detail.feedbackComment\">Commentaire feedback</strong>: <span>{{vm.detail.feedbackComment}}</span></p><div class=\"alert alert-success\" ng-if=\"vm.copyFeedbackMessage\">{{vm.copyFeedbackMessage}}</div><div class=\"panel panel-default ai-assistant-history__event-card\" ng-repeat=\"event in vm.detail.events\" ng-if=\"vm.isSuperAdmin || vm.hasVisibleConversationContent(event)\"><div class=\"panel-heading\"><strong>{{vm.isSuperAdmin ? event.stage : (event.stageLabel || event.stage)}}</strong> <span class=\"pull-right\">{{event.archivedAt | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></div><div class=\"panel-body\"><p class=\"text-muted\" ng-if=\"vm.isSuperAdmin\"><span>{{event.contextType || \'-\'}}</span> <span ng-if=\"event.contractReference || event.contextLabel\">| {{event.contractReference || event.contextLabel}}</span> <span ng-if=\"event.entityId\">| ID {{event.entityId}}</span> <span ng-if=\"event.areaName\">| {{event.areaName}}</span> <span ng-if=\"event.userLogin\">| {{event.userLogin}}</span> <span ng-if=\"event.organisationName\">| {{event.organisationName}}</span></p><p ng-if=\"!vm.isSuperAdmin\"><strong>Catégories envoyées</strong>: <span class=\"label label-info\" ng-repeat=\"scopeLabel in vm.getDataScopeLabels(event.selectedDataScopes) track by $index\" style=\"margin-right: 4px\">{{scopeLabel}}</span></p><div class=\"alert alert-info\" ng-if=\"vm.isSuperAdmin && event.flowLines.length\"><strong>{{event.flowLabel || \'Flux lisible\'}}</strong><ul class=\"ai-assistant-monitoring__highlights\"><li ng-repeat=\"line in event.flowLines track by $index\">{{line}}</li></ul></div><ul class=\"ai-assistant-monitoring__highlights\" ng-if=\"vm.isSuperAdmin && event.highlights.length\"><li ng-repeat=\"highlight in event.highlights track by $index\">{{highlight}}</li></ul><p class=\"text-muted\" ng-if=\"vm.isSuperAdmin && event.requestTotalTokens\"><strong translate=\"wamasysApp.aiAssistantMonitoring.detail.eventTokens\">Tokens evenement</strong>: {{event.requestTotalTokens}}</p><p class=\"text-muted\" ng-if=\"!vm.isSuperAdmin && event.requestTotalTokens\"><strong translate=\"wamasysApp.aiAssistantMonitoring.detail.tokensUsed\">Jetons utilisés</strong>: {{event.requestTotalTokens}}</p><div ng-if=\"!vm.isSuperAdmin\"><div class=\"ai-assistant-history__message-block\" ng-if=\"event.sentMessage\"><div class=\"ai-assistant-history__message-label\" translate=\"wamasysApp.aiAssistantMonitoring.detail.sentMessage\">Message envoyé</div><div class=\"ai-assistant-history__message-content\">{{event.sentMessage}}</div></div><div class=\"ai-assistant-history__message-block\" ng-if=\"event.receivedMessage\"><div class=\"ai-assistant-history__message-label\" translate=\"wamasysApp.aiAssistantMonitoring.detail.receivedMessage\">Message reçu</div><div class=\"ai-assistant-history__message-content\">{{event.receivedMessage}}</div></div><div class=\"ai-assistant-history__message-block\" ng-if=\"event.clarificationQuestions.length\"><div class=\"ai-assistant-history__message-label\" translate=\"wamasysApp.aiAssistantMonitoring.detail.questions\">Questions posées</div><ul class=\"ai-assistant-monitoring__highlights\"><li ng-repeat=\"question in event.clarificationQuestions track by $index\">{{question}}</li></ul></div><div class=\"ai-assistant-history__message-block\" ng-if=\"event.hasAction\"><div class=\"ai-assistant-history__message-label\"><span ng-if=\"event.actionExecuted\" translate=\"wamasysApp.aiAssistantMonitoring.detail.actionsDone\">Actions effectuées</span> <span ng-if=\"!event.actionExecuted\" translate=\"wamasysApp.aiAssistantMonitoring.detail.actionsPlanned\">Actions prévues</span></div><ul class=\"ai-assistant-monitoring__highlights\" ng-if=\"event.actionSummaries.length\"><li ng-repeat=\"summary in event.actionSummaries track by $index\">{{summary}}</li></ul><div class=\"text-muted\" ng-if=\"!event.actionSummaries.length\"><span ng-if=\"event.actionExecuted\" translate=\"wamasysApp.aiAssistantMonitoring.detail.actionsDoneNoDetail\">Une action a été exécutée.</span> <span ng-if=\"!event.actionExecuted\" translate=\"wamasysApp.aiAssistantMonitoring.detail.actionsPlannedNoDetail\">Une action avait été proposée.</span></div></div></div><p ng-if=\"vm.isSuperAdmin && event.feedbackComment\"><strong translate=\"wamasysApp.aiAssistantMonitoring.detail.feedbackComment\">Commentaire feedback</strong>: {{event.feedbackComment}}</p><button has-any-authority=\"ROLE_SUPER_ADMIN\" type=\"button\" class=\"btn btn-default btn-xs ai-assistant-monitoring__json-toggle\" ng-if=\"event.formattedJson\" ng-click=\"vm.toggleJson(event)\"><span class=\"glyphicon\" ng-class=\"event.showJson ? \'glyphicon-chevron-up\' : \'glyphicon-chevron-down\'\"></span> <span ng-if=\"!event.showJson\">Voir le flux JSON</span> <span ng-if=\"event.showJson\">Masquer le flux JSON</span></button><pre class=\"pre-scrollable ai-assistant-monitoring__json\" ng-if=\"event.showJson && event.formattedJson\">{{event.formattedJson}}</pre></div></div></div></div></div></div></div>");
$templateCache.put("app/business/ai-assistant-monitoring/ai-assistant-system-commands.html","<div><h2>Commandes systeme assistant IA</h2><jhi-alert></jhi-alert><p class=\"text-muted\">Cette page documente ce que Wamasys construit et envoie reellement aux API IA. Les payloads affiches plus bas sont generes depuis le code applicatif avec des placeholders pour les valeurs runtime.</p><p class=\"text-muted\">Le bloc <strong>Textes systeme et notions</strong> isole les morceaux de prompt importants: leur texte exact, le moment ou Wamasys les ajoute, et ce qu\'ils encadrent fonctionnellement.</p><p class=\"text-muted\" ng-if=\"vm.catalog.generatedAt\">Generation: {{vm.catalog.generatedAt | date:\'dd/MM/yyyy HH:mm:ss\'}}</p><div class=\"alert alert-info\" ng-if=\"vm.loading\">Chargement des commandes systeme...</div><div class=\"panel panel-info\"><div class=\"panel-heading\"><strong>Vue d\'ensemble</strong></div><div class=\"panel-body\"><p>Wamasys prepare toujours la requete cote serveur. Le modele ne parle jamais directement a la base, aux ecrans Wamasys ni aux droits applicatifs. Il ne voit que les blocs de contexte que Wamasys choisit et les champs que Wamasys a explicitement autorises dans le code et dans <code>ai-assistant-config.json</code>.</p><table class=\"table table-condensed table-bordered\"><thead><tr><th>Etat / option</th><th>Effet cote Wamasys</th><th>Ce qui part a l\'API</th></tr></thead><tbody><tr><td><code>contextType = CONTRACT</code> + <code>mode = QUESTION</code></td><td>Flux contrat compact</td><td>Instructions systeme + contexte contrat compact + historique recent + dernier prompt</td></tr><tr><td><code>contextType = CONTRACT</code> + <code>mode = ACTION</code></td><td>Flux contrat detaille</td><td>Instructions systeme + contexte contrat detaille + parametres d\'action autorises + historique recent</td></tr><tr><td><code>allowAssistantToChooseData = true</code></td><td>Planner optionnel avant l\'appel principal</td><td>Un 1er payload compact choisit les scopes. Si l\'option est desactivee, Wamasys envoie directement les <code>selectedDataScopes</code> choisis manuellement.</td></tr><tr><td><code>selectedInstructionDomains</code></td><td>Filtre metier explicite</td><td>Wamasys limite les regles et les actions exposees aux domaines choisis: financier, paiements, consommation eau, statut contrat.</td></tr><tr><td><code>responseDetailLevel = SHORT / DETAILED</code></td><td>Variation du meme flux</td><td>Meme structure de payload. Ce qui change surtout: le texte d\'instruction, la limite de <code>assistant_message</code> et le plancher de tokens.</td></tr><tr><td><code>assistantFlowMode = OPTIMIZED</code></td><td>Flux enrichi</td><td>Contexte au format <code>assistant-ready context</code> avec <code>contractSummary</code>, <code>computedContext</code>, <code>businessRules</code>, <code>availableActions</code> et <code>resolvedEntities</code></td></tr><tr><td><code>model = ollama/*</code></td><td>Provider Ollama local</td><td>Payload chat completions compatible Ollama. Le planner utilise <code>response_format</code>; l\'assistant principal repose sur une consigne JSON stricte dans le prompt puis une validation backend.</td></tr><tr><td>Autre modele supporte</td><td>Provider OpenAI</td><td>Payload Responses API: <code>input</code> + <code>text.format</code> + <code>max_output_tokens</code></td></tr></tbody></table><h4>Flux d\'execution</h4><pre class=\"pre-scrollable\">DEBUT\n  |\n  v\nNormaliser la demande utilisateur\n  - contextType / mode / model / detail / creativity / flags\n  |\n  +--> Si CONTRACT et allowAssistantToChooseData = true\n  |      construire un planner compact\n  |      envoyer le planner au provider choisi\n  |      parser les scopes retenus\n  |      si erreur planner => repli sur les flags manuels\n  |\n  +--> Sinon\n  |      utiliser directement selectedDataScopes\n  |\n  v\nConstruire le payload principal\n  - instructions systeme\n  - assistant-ready context retenu par Wamasys\n  - historique recent (max 12 messages)\n  - selectedInstructionDomains\n  - eventuel triggerActionProposal\n  |\n  v\nChoisir le provider selon le modele\n  - ollama/*    => Ollama local\n  - sinon       => OpenAI\n  |\n  v\nEnvoyer la requete\n  |\n  v\nExtraire le JSON texte de reponse\n  - OpenAI  : output_text ou output[].content[].text\n  - Ollama  : choices[0].message.content\n  |\n  v\nNettoyer / parser le JSON retourne\n  |\n  +--> Si interruption max tokens\n  |      OpenAI: retry 1 fois avec SHORT + instruction ultra courte\n  |      Ollama: pas de retry automatique\n  |\n  v\nGarder uniquement les champs geres par Wamasys\n  |\n  v\nArchiver requete, reponse, erreurs et usage\n  |\n  v\nFIN</pre><h4>Ce qui est vraiment envoye</h4><ul><li><strong>Contrat / QUESTION :</strong> assistant-ready context compact avec coeur du contrat, indicateurs calcules, regles filtrees et entites resolues selon les scopes.</li><li><strong>Contrat / ACTION :</strong> assistant-ready context detaille avec actions autorisees, parametres utiles, derniers statuts, derniere facturation et dernier paiement.</li><li><strong>Communication :</strong> pas de planner. Wamasys envoie directement le contexte de template: type, canal, variables autorisees, contenu actuel et metadonnees utiles.</li><li><strong><code>SHORT</code> / <code>DETAILED</code> :</strong> cela change surtout le texte d\'instruction, la longueur max de <code>assistant_message</code> et les bornes de tokens, pas la structure generale du protocole. La page montre donc un seul exemple representatif par mode.</li><li><strong><code>previousResponseId</code> :</strong> le champ existe dans le DTO mais le flux courant ne le reutilise pas encore; aujourd\'hui Wamasys renvoie l\'historique recent au lieu d\'un vrai chainage provider natif.</li></ul><h4>Comment Wamasys gere les retours</h4><ul><li><strong>Contrat :</strong> Wamasys ne conserve et n\'exploite que <code>assistant_message</code>, <code>should_suggest_action</code>, <code>awaiting_user_input</code>, <code>clarification_questions</code> et <code>proposed_actions</code>.</li><li><strong>Communication :</strong> Wamasys ne conserve et n\'exploite que <code>assistant_message</code>, <code>awaiting_user_input</code>, <code>clarification_questions</code> et <code>suggested_field_values</code>.</li><li><strong>Validation :</strong> Wamasys parse le JSON, archive le brut, compte les tokens, expose les scopes/domaines reellement envoyes a l\'IHM et ne laisse jamais le modele executer une action directement.</li><li><strong>Execution d\'action :</strong> meme si l\'IA propose <code>proposed_actions</code>, Wamasys affiche, controle les droits, verifie les champs et n\'execute qu\'apres confirmation explicite.</li></ul><h4>Differences OpenAI / Ollama</h4><table class=\"table table-condensed table-bordered\"><thead><tr><th>Provider</th><th>Forme du payload</th><th>Controle du JSON reponse</th></tr></thead><tbody><tr><td>OpenAI</td><td><code>model</code> + <code>input</code> + <code>text.format</code> + <code>max_output_tokens</code></td><td>Schema JSON strict dans la requete</td></tr><tr><td>Ollama</td><td><code>model</code> + <code>messages</code> + <code>max_tokens</code></td><td>Planner: schema JSON via <code>response_format</code>. Assistant principal: JSON guide par le prompt, puis validation backend.</td></tr></tbody></table><h4>Exemples de reponses provider</h4><p class=\"text-muted\">Les exemples ci-dessous montrent la forme generale des retours API. Wamasys parse ensuite le JSON utile et ne garde que les champs autorises.</p><div class=\"row\"><div class=\"col-md-6\"><h5>OpenAI / ChatGPT Responses API</h5><pre class=\"pre-scrollable\">{\n  \"id\": \"resp_123\",\n  \"status\": \"completed\",\n  \"output_text\": \"{\\\"assistant_message\\\":\\\"No significant debt appears on this contract. The current amount due is 0.4.\\\",\\\"should_suggest_action\\\":false,\\\"awaiting_user_input\\\":false,\\\"clarification_questions\\\":[],\\\"proposed_actions\\\":[]}\",\n  \"usage\": {\n    \"input_tokens\": 812,\n    \"output_tokens\": 74\n  }\n}</pre></div><div class=\"col-md-6\"><h5>Ollama / chat completions</h5><pre class=\"pre-scrollable\">{\n  \"id\": \"chatcmpl-560\",\n  \"choices\": [\n    {\n      \"message\": {\n        \"role\": \"assistant\",\n        \"content\": \"{\\\"assistant_message\\\":\\\"No significant debt appears on this contract. The current amount due is 0.4.\\\",\\\"should_suggest_action\\\":false,\\\"awaiting_user_input\\\":false,\\\"clarification_questions\\\":[],\\\"proposed_actions\\\":[]}\"\n      },\n      \"finish_reason\": \"stop\"\n    }\n  ],\n  \"usage\": {\n    \"prompt_tokens\": 579,\n    \"completion_tokens\": 38,\n    \"total_tokens\": 617\n  }\n}</pre></div></div><h4>Exemple de flux assistant principal</h4><pre class=\"pre-scrollable\">1. Wamasys construit le contexte et l\'historique recent.\n2. OpenAI:\n   - envoie un schema JSON strict dans la requete\n   - lit ensuite output_text\n3. Ollama:\n   - envoie une instruction systeme imposant un JSON valide\n   - lit ensuite choices[0].message.content\n4. Wamasys retire les fences markdown si necessaire.\n5. Wamasys parse le JSON retourne et valide les champs exploites.\n6. Wamasys archive la requete, la reponse, l\'usage et l\'erreur eventuelle.</pre></div></div><div class=\"panel panel-default\" ng-repeat=\"command in vm.catalog.commands track by command.key\"><div class=\"panel-heading\"><strong>{{command.title}}</strong> <span class=\"pull-right text-muted\">{{command.contextType}}</span></div><div class=\"panel-body\"><p><strong>Quand Wamasys l\'envoie :</strong> {{command.whenUsed}}</p><p><strong>Champs retour geres par Wamasys :</strong></p><ul class=\"ai-assistant-monitoring__highlights\"><li ng-repeat=\"field in command.managedReturnFields track by $index\">{{field}}</li></ul><div ng-if=\"command.systemTexts.length\"><h4>Textes systeme et notions</h4><div class=\"panel panel-default\" ng-repeat=\"systemText in command.systemTexts track by $index\"><div class=\"panel-heading\"><strong>{{systemText.title}}</strong></div><div class=\"panel-body\"><p><strong>Utilise quand :</strong> {{systemText.whenUsed}}</p><p><strong>Contient :</strong> {{systemText.contains}}</p><pre class=\"pre-scrollable ai-assistant-monitoring__json\">{{systemText.text}}</pre></div></div></div><div class=\"row\"><div class=\"col-md-6\"><h4>Payload OpenAI</h4><pre class=\"pre-scrollable ai-assistant-monitoring__json\">{{command.openAiRequestJson}}</pre></div><div class=\"col-md-6\"><h4>Payload Ollama</h4><pre class=\"pre-scrollable ai-assistant-monitoring__json\">{{command.ollamaRequestJson}}</pre></div></div></div></div></div>");
$templateCache.put("app/layouts/navbar/navbar.html","<aside id=\"left-panel\" ng-switch=\"vm.isAuthenticated()\"><!-- User info --><div login-info></div><!-- end user info --><nav ng-switch-when=\"true\"><ul data-smart-menu><li data-ui-sref-active=\"active\"><a data-ui-sref=\"home\"><i class=\"fa fa-lg fa-fw fa-home\"></i> <span class=\"menu-item-parent\" translate=\"global.menu.dashboard\">Dashboard</span></a></li><li data-menu-collapse class=\"top-menu-invisible\" has-any-authority=\"ROLE_AREA_MANAGEMENT,ROLE_DATA_OPERATOR,ROLE_READ_ONLY\"><a href=\"#\"><i class=\"fa fa-lg fa-fw fa-briefcase\"></i> <span class=\"menu-item-parent\" translate=\"global.menu.contrats\">Contrats</span></a><ul><li ng-class=\"{active: $state.includes(\'contratsclient\')}\" data-ui-sref-active=\"active\"><a data-ui-sref=\"contrat\"><i class=\"fa fa-folder-open\"></i> <span translate=\"global.menu.listeclients\">Liste clients</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"collection-liste\"><i class=\"fa fa-money\"></i> <span translate=\"global.menu.collectepaiement\">Collecte Paiement</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"portefeuille-contrat\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.portefeuilleContrat\">Portefeuille Contrat</span></a></li></ul></li><li data-menu-collapse class=\"top-menu-invisible\" has-any-authority=\"ROLE_AREA_MANAGEMENT,ROLE_DATA_OPERATOR,ROLE_READ_ONLY\"><a href=\"#\"><i class=\"fa-lg fa-fw glyphicon glyphicon-tint\"></i> <span class=\"menu-item-parent\" translate=\"global.menu.compteurs\">Compteurs</span></a><ul><li data-ui-sref-active=\"active\"><a ui-sref=\"compteur.individual-meter\"><i class=\"fa fa-folder-open\"></i> <span translate=\"global.menu.listecompteurs\">Liste Compteurs</span></a></li><li data-ui-sref-active=\"active\"><a ui-sref=\"releve-compteur\"><i class=\"glyphicon glyphicon-list-alt\"></i> <span translate=\"global.menu.relevecompteurs\">Relevé compteurs</span></a></li></ul></li><li data-menu-collapse class=\"top-menu-invisible\" has-any-authority=\"ROLE_AREA_MANAGEMENT,ROLE_DATA_OPERATOR,ROLE_READ_ONLY\"><a href=\"#\"><i class=\"fa fa-lg fa-fw fa-bar-chart-o\"></i> <span class=\"menu-item-parent\" translate=\"global.menu.reportingagence\">Reporting agence</span></a><ul><li data-ui-sref-active=\"active\"><a data-ui-sref=\"reporting-agence\"><i class=\"fa fa-line-chart\"></i> <span translate=\"global.menu.reportingfinancier\">Reporting financier</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"reporting-paiement\"><i class=\"fa fa-money\"></i> <span translate=\"global.menu.reportingpaiement\">Reporting paiement</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"reporting-taxe\"><i class=\"fa fa-institution\"></i> <span translate=\"global.menu.reportingtaxe\">Reporting Taxe</span></a></li><!--                     <li data-ui-sref-active=\"active\"> --><!--                         <a data-ui-sref=\"reporting-fuite-eau\"><i class=\"fa fa-recycle\"></i> --><!--                              <span translate=\"global.menu.suiviperteeau\" >     Suivi perte Eau</span></a> --><!--                     </li> --><li ui-sref-active=\"active\"><a data-ui-sref=\"reporting-payment-arrears\"><i class=\"fa fa-database\"></i> &#xA0;<span translate=\"global.menu.anomaliefinance\">Payment arrears </span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"reporting-collection-list\"><i class=\"fa fa-table\"></i> <span translate=\"global.menu.reportingcomptable\">Reporting collectionlist</span></a></li><li data-ui-sref-active=\"active\" has-any-authority=\"ROLE_AREA_MANAGEMENT,ROLE_DATA_OPERATOR,ROLE_READ_ONLY,ROLE_ADMIN,ROLE_SUPER_ADMIN\"><a data-ui-sref=\"reporting-pending-field-documents\"><i class=\"fa fa-tasks\"></i> <span translate=\"global.menu.pendingFieldDocuments\">CL et RF en attente</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"reporting-consommation-eau\"><i class=\"fa-lg fa-fw glyphicon glyphicon-tint\"></i> <span translate=\"global.menu.consommationeau\">Consommation eau</span></a></li><li data-ui-sref-active=\"active\" has-any-authority=\"ROLE_AREA_MANAGEMENT,ROLE_DATA_OPERATOR,ROLE_READ_ONLY\"><a data-ui-sref=\"reporting-casnonreleve\"><span class=\"glyphicon glyphicon-exclamation-sign\"></span> <span class=\"menu-item-parent\" translate=\"global.menu.reportingCasNonReleve\">reportingCasNonReleve</span></a></li><li data-ui-sref-active=\"active\" has-any-authority=\"ROLE_AREA_MANAGEMENT,ROLE_ADMIN,ROLE_SUPER_ADMIN\" has-module=\"NEW_FEATURES_VISIBILITY\"><a data-ui-sref=\"reporting-area-activity\"><i class=\"fa fa-area-chart\"></i> <span class=\"menu-item-parent\" translate=\"global.menu.reportingAreaActivity\">Area activity reporting</span></a></li><li data-ui-sref-active=\"active\" ng-if=\"vm.user.canViewMonitoringRuleHistory\"><a data-ui-sref=\"monitoring-rule-history\"><i class=\"fa fa-lg fa-fw fa-users\"></i> <span translate=\"global.menu.monitoringRuleHistory\">Monitoring rule history</span></a></li><li data-ui-sref-active=\"active\" has-any-authority=\"ROLE_AREA_MANAGEMENT,ROLE_DATA_OPERATOR,ROLE_READ_ONLY\"><a data-ui-sref=\"collecteur\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"menu-item-parent\" translate=\"global.menu.collecteur\">Collecteurs</span></a></li><li data-ui-sref-active=\"active\" has-module=\"ACCOUNTING_EXPORT\" has-any-authority=\"ROLE_AREA_MANAGEMENT,ROLE_DATA_OPERATOR,ROLE_READ_ONLY\"><a data-ui-sref=\"reporting-accounting\"><i class=\"fa fa-lg fa-fw fa-legal\"></i> <span class=\"menu-item-parent\" translate=\"global.menu.accountingReporting\">accountingReporting</span></a></li></ul></li><li data-ui-sref-active=\"active\" ng-if=\"vm.user.canViewMonitoringRuleHistory && !vm.hasAnyAuthority([\'ROLE_AREA_MANAGEMENT\',\'ROLE_DATA_OPERATOR\',\'ROLE_READ_ONLY\'])\"><a data-ui-sref=\"monitoring-rule-history\"><i class=\"fa fa-lg fa-fw fa-users\"></i> <span translate=\"global.menu.monitoringRuleHistory\">Monitoring rule history</span></a></li><li data-menu-collapse class=\"top-menu-invisible\" has-module=\"WATER_QUALITY\" has-any-authority=\"ROLE_ADMIN,ROLE_SUPER_ADMIN,ROLE_WATER_QUALITY_READ,ROLE_WATER_QUALITY_EDIT\"><a href=\"#\"><i class=\"fa fa-lg fa-fw fa-tint\"></i> <span class=\"menu-item-parent\">Qualité de l’eau</span></a><ul><li data-ui-sref-active=\"active\"><a data-ui-sref=\"water-quality\">Planification des prélèvements</a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"water-quality-records\">Suivi des contrôles</a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"water-quality-schedules\">Récurrences</a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"water-quality-locations\">Lieux de prélèvement</a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"water-quality-parameters\">Paramètres</a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"water-quality-thresholds\">Seuils</a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"water-quality-alerts\">Alertes</a></li></ul></li><li data-menu-collapse class=\"top-menu-invisible\" has-module=\"EQUIPMENT\" has-any-authority=\"ROLE_ADMIN,ROLE_SUPER_ADMIN,ROLE_EQUIPMENT_READ,ROLE_EQUIPMENT_EDIT,ROLE_EQUIPMENT_SECRETS,ROLE_EQUIPMENT_REMOTE_CONTROL\"><a href=\"#\"><i class=\"fa fa-lg fa-fw fa-cubes\"></i> <span class=\"menu-item-parent\" translate=\"global.menu.equipmentParc\">Parc et équipements</span></a><ul><li data-ui-sref-active=\"active\"><a data-ui-sref=\"equipment-dashboard\"><i class=\"fa fa-dashboard\"></i> <span translate=\"global.menu.equipmentDashboard\">Tableau de bord du parc</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"equipment-parc\"><i class=\"fa fa-cubes\"></i> <span translate=\"global.menu.equipment\">Équipements</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"equipment-meters\"><i class=\"fa fa-tachometer\"></i> <span translate=\"global.menu.equipmentMeters\">Compteurs d’eau</span></a></li><li data-ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN,ROLE_SUPER_ADMIN,ROLE_EQUIPMENT_EDIT\"><a data-ui-sref=\"equipment-import\"><i class=\"fa fa-upload\"></i> <span translate=\"global.menu.equipmentImport\">Importer Excel / CSV</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"equipment-consumables\"><i class=\"fa fa-archive\"></i> <span translate=\"global.menu.equipmentStock\">Consommables et stocks</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"equipment-inventories\"><i class=\"fa fa-list-alt\"></i> <span translate=\"global.menu.equipmentInventories\">Inventaires</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"equipment-configuration\"><i class=\"fa fa-map-marker\"></i> <span translate=\"global.menu.equipmentConfiguration\">Types et lieux</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"equipment-computers\"><i class=\"fa fa-desktop\"></i> <span translate=\"global.menu.equipmentComputers\">Parc informatique</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"equipment-android\"><i class=\"fa fa-android\"></i> <span translate=\"global.menu.equipmentAndroid\">Appareils Android connus</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"equipment-labels\"><i class=\"fa fa-barcode\"></i> <span translate=\"global.menu.equipmentLabels\">Étiquettes et codes-barres</span></a></li></ul></li><li data-menu-collapse class=\"top-menu-invisible\" has-any-authority=\"ROLE_EVT_READ_ONLY,ROLE_EVT_EDIT\" has-module=\"EVENT_FORM\"><a href=\"#\"><i class=\"fa fa-lg fa-fw fa-inbox\"></i> <span class=\"menu-item-parent\">Events</span></a><ul><li data-ui-sref-active=\"active\"><a data-ui-sref=\"event-form\"><i class=\"fa fa fa-folder-open\"></i> <span>Form</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-evenement\"><i class=\"fa fa-line-chart\"></i> <span>Reporting</span></a></li><li data-ui-sref-active=\"active\" has-any-authority=\"ROLE_SUPER_ADMIN\"><a data-ui-sref=\"event-dashboard\"><i class=\"fa fa-dashboard\"></i> <span>Tableaux de bord</span></a></li><li data-ui-sref-active=\"active\" ng-repeat=\"dashboard in vm.eventDashboards track by dashboard.id\"><a ui-sref=\"event-dashboard-view({id:dashboard.id})\"><i class=\"fa fa-area-chart\"></i> <span>{{dashboard.label}}</span></a></li><!-- has-any-authority=\"ROLE_ADMIN,ROLE_AREA_CONFIGURATION\"  --><li data-menu-collapse class=\"top-menu-invisible\" ui-sref-active=\"active\" has-authority=\"ROLE_SUPER_ADMIN\"><a href=\"#\"><span class=\"menu-item-parent\">Configuration</span></a><ul><li data-ui-sref-active=\"active\" has-any-authority=\"ROLE_SUPER_ADMIN\"><a data-ui-sref=\"event-field-definition\"><i class=\"fa fa-book\"></i> <span>Dictionnaire des champs</span></a></li><li ui-sref-active=\"active\" has-module=\"EVENT_FORM\"><a ui-sref=\"event-form-category\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.formEventCategory\">formEventCategory</span></a></li></ul></li></ul></li><li data-menu-collapse class=\"top-menu-invisible\" has-any-authority=\"ROLE_BUDGET_READ_ONLY,ROLE_BUDGET_EDIT\" has-module=\"BUDGET\"><!--    		       fa-tags \r\n           \r\n	                <a href=\"#\"><i class=\"fa  fa-lg fa-fw fa-database \"></i> <span class=\"menu-item-parent\"  >Expense</span></a>\r\n	                <a href=\"#\"><i class=\"fa  fa-lg fa-fw fa-tags\"></i> <span class=\"menu-item-parent\"  >Expense</span></a>\r\n	                <a href=\"#\"><i class=\"fa  fa-lg fa-fw  fa-briefcase \"></i> <span class=\"menu-item-parent\"  >Expense</span></a>\r\n	                \r\n	                <a href=\"#\"><i class=\"fa  fa-lg fa-fw fa-balance-scale\"></i> <span class=\"menu-item-parent\"  >Expense</span></a>\r\n	                <a href=\"#\"><i class=\"fa  fa-lg fa-fw fa-wpforms\"></i> <span class=\"menu-item-parent\"  >Expense</span></a>\r\n	                <a href=\"#\"><i class=\"fa  fa-lg fa-fw fa-legal\"></i> <span class=\"menu-item-parent\"  >Expense</span></a>\r\n	                <a href=\"#\"><i class=\"fa  fa-lg fa-fw fa-bank \"></i> <span class=\"menu-item-parent\"  >Expense</span></a>\r\n            --> <a href=\"#\"><i class=\"fa fa-lg fa-fw fa-book\"></i><span class=\"menu-item-parent\">Budget monitoring</span></a><ul><li data-ui-sref-active=\"active\"><a data-ui-sref=\"expense\"><i class=\"fa fa fa-folder-open\"></i> <span>Expense</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"reporting-budget\"><i class=\"fa fa-line-chart\"></i> <span>Area reporting</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"reporting-budget-global\"><i class=\"fa fa-line-chart\"></i> <span>Global reporting</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"expense-type\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><i class=\"fa fa-lg fa-fw fa-gears\"></i> &#xA0;<span translate=\"global.menu.expenseType\">Expense Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"global-expense-type\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><i class=\"fa fa-lg fa-fw fa-gears\"></i> &#xA0;<span translate=\"global.menu.globalExpenseType\">Global Expense Type</span></a></li></ul></li><li data-menu-collapse class=\"top-menu-invisible\" has-module=\"COMMUNICATION\" has-any-authority=\"ROLE_ADMIN,ROLE_AREA_CONFIGURATION,ROLE_AREA_MANAGEMENT,ROLE_READ_ONLY\"><a href=\"#\"><i class=\"fa fa-lg fa-fw fa-comments-o\"></i><span class=\"menu-item-parent\" translate=\"global.menu.communication\">Communication</span></a><ul><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN,ROLE_AREA_CONFIGURATION,ROLE_AREA_MANAGEMENT,ROLE_READ_ONLY\"><a ui-sref=\"communication-campaign\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><i class=\"fa fa-lg fa-fw fa-bullhorn\"></i> &#xA0;<span translate=\"global.menu.communicationCampaign\">communication campaign</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN,ROLE_AREA_CONFIGURATION,ROLE_AREA_MANAGEMENT\"><a ui-sref=\"communication-automation-conf\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><i class=\"fa fa-lg fa-fw fa-calendar-check-o\"></i> &#xA0;<span translate=\"global.menu.communicationAutomationConf\">communication Automation Conf</span></a></li><li ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-communication-reporting\"><i class=\"fa fa-line-chart\"></i> &#xA0;<span translate=\"global.menu.communicationReporting\">communicationReporting</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"communication-topic\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><i class=\"fa fa-lg fa-fw fa-bell-o\"></i> &#xA0;<span translate=\"global.menu.communicationTopic\">communication topic</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN,ROLE_AREA_CONFIGURATION,ROLE_AREA_MANAGEMENT\"><a ui-sref=\"communication-topic-category\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>&#xA0;<span translate=\"global.menu.communicationTopicCategory\">communicationTopicCategory</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN\"><a ui-sref=\"channel-conf\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><i class=\"fa fa-lg fa-fw fa-sliders\"></i> &#xA0;<span translate=\"global.menu.channelConf\">Channel conf</span></a></li></ul></li><!--                <li data-ui-sref-active=\"active\" has-module=\"TEAM\" > --><!-- 	                <a data-ui-sref=\"teamwork\"  > --><!-- 	                    <i class=\"fa fa-lg fa-fw fa-ticket\"></i> <span class=\"menu-item-parent\">Teamwork</span>  --><!-- 	                   </a> --><!-- 	            </li> --><li has-module=\"ELK\" data-menu-collapse class=\"top-menu-invisible\" ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN,ROLE_AREA_CONFIGURATION,ROLE_AREA_MANAGEMENT,ROLE_READ_ONLY,ROLE_EVT_READ_ONLY\"><a href=\"#\"><span class=\"fa fa-lg fa-fw fa-globe\"></span> <span class=\"menu-item-parent\" translate=\"global.menu.reportingsmart\">Data analyse</span></a><ul><li data-menu-collapse class=\"top-menu-invisible\" ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN,ROLE_AREA_CONFIGURATION,ROLE_AREA_MANAGEMENT,ROLE_READ_ONLY\"><a href=\"#\"><span class=\"menu-item-parent\" translate=\"global.menu.reportingagence\">Reporting zone</span></a><ul><li ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-graph-synthese\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.synthesezone\">Synthèse zone </span></a></li><li ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-graph-synthese-hebdo\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.synthesezonehebdo\">Synthèse zone hedbo</span></a></li><li ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-graph-anomalie-finances\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.anomaliefinance\">Payment arrears </span></a></li><li ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-graph-anomalie-water\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.anomaliewater\">Water anomalies </span></a></li><li ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-discount\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.discountReporting\">Discounts</span></a></li><li ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-graph-eau\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.consommationeaucluster\">Water consumption</span></a></li><li ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-graph-search-payment\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.recherchePaiement\">recherche Paiement</span></a></li><li has-module=\"IOT_WATER\" ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-iot-smart-water-meter\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.iotSmartWaterMeter\">IOT smart water meter</span></a></li><li has-module=\"IOT_WATER\" ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-iot-alert-meter\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.iotAlertWaterMeter\">IOT alert water meter</span></a></li></ul></li><li data-menu-collapse class=\"top-menu-invisible\" ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN,ROLE_AREA_CONFIGURATION,ROLE_READ_ONLY\"><a href=\"#\"><span class=\"menu-item-parent\" translate=\"global.menu.reportingglobal\">Reporting global</span></a><ul><li ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-graph-summary-global\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.globalSummary\">Global summary</span></a></li><li ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-graph-summary-annual-global\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.annualSummary\">Annual summary</span></a></li><li ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-geolocation\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.geolocation\">Geolocation </span></a></li><li ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-graph-interagence\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.interagency\">Inter agency</span></a></li><!-- \r\n				                      <li  ui-sref-active=\"active\" ><a data-ui-sref=\"reporting-global-graph-interagence\">\r\n				                      <span class=\"glyphicon glyphicon-asterisk\"></span>\r\n				                            &#xA0;<span >Inter agency</span></a></li>\r\n				                             --></ul></li><li data-menu-collapse class=\"top-menu-invisible\" ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN,ROLE_AREA_CONFIGURATION,ROLE_READ_ONLY\"><a href=\"#\"><span class=\"menu-item-parent\">Statistic reporting</span></a><ul><li ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-graph-consoeauglobal\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.waterConsumptionStat\">Water consumption</span></a></li><li ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-graph-stat-financial\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.financialStat\">Financial</span></a></li><li ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-graph-stat-contrat\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.contractStat\">Contracts statistic</span></a></li><!-- \r\n				                      <li  ui-sref-active=\"active\" ><a data-ui-sref=\"reporting-global-graph-stat-contrat\">\r\n				                      <span class=\"glyphicon glyphicon-asterisk\"></span>\r\n				                            &#xA0;<span >Stat contrat</span></a></li>\r\n				                             --></ul></li><div ng-show=\"vm.user.listDashboardKibana.dashboardsmenu\" ng-repeat=\"dashboardsmenu in vm.user.listDashboardKibana.dashboardsmenu track by dashboardsmenu.index  \" has-any-authority=\"ROLE_ADMIN,ROLE_AREA_CONFIGURATION,ROLE_AREA_MANAGEMENT,ROLE_READ_ONLY,ROLE_EVT_READ_ONLY\"><li ng-if=\"dashboardsmenu.items\" data-menu-collapse class=\"top-menu-invisible\" ui-sref-active=\"active\"><a href=\"#\"><span class=\"menu-item-parent\">{{dashboardsmenu.label}}</span></a><ul><li ng-repeat=\"dashboard in dashboardsmenu.items track by dashboard.index  \" ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-my-dashboard({index:dashboard.index})\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span>{{dashboard.label}}</span></a></li></ul></li></div><li ng-show=\"vm.user.listDashboardKibana.dashboards\" data-menu-collapse class=\"top-menu-invisible\" ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN,ROLE_AREA_CONFIGURATION,ROLE_AREA_MANAGEMENT,ROLE_READ_ONLY,ROLE_EVT_READ_ONLY\"><a href=\"#\"><span class=\"menu-item-parent\">My dashboards</span></a><ul><li ng-repeat=\"dashboard in vm.user.listDashboardKibana.dashboards track by dashboard.index  \" ui-sref-active=\"active\"><a data-ui-sref=\"reporting-global-my-dashboard({index:dashboard.index})\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span>{{dashboard.label}}</span></a></li></ul></li><li ui-sref-active=\"active\"><a href=\"{{vm.user.kibanaUrl}}\" target=\"_blank\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span>Open Kibana</span></a></li><!-- \r\n				         	<li data-ui-sref-active=\"active\"  has-any-authority=\"ROLE_ADMIN,ROLE_READ_ONLY\" >\r\n				                        <a data-ui-sref=\"reporting-global\"><i class=\"glyphicon glyphicon-asterisk\"></i>\r\n				                 <span class=\"menu-item-parent\" translate=\"global.menu.reportingglobal\" >   Reporting global</span></a>\r\n				            </li>  \r\n				             --></ul></li><li data-menu-collapse class=\"top-menu-invisible\" ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN,ROLE_READ_ONLY,ROLE_DATA_OPERATOR,ROLE_AREA_CONFIGURATION,ROLE_AREA_MANAGEMENT\"><a href=\"#\"><span class=\"fa fa-lg fa-fw fa-wrench\"></span> <span class=\"menu-item-parent\" translate=\"global.menu.administrationagence\">Administration agence</span></a><ul><!-- \r\n                      <li  ui-sref-active=\"active\" ><a data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                            &#xA0;<span >Objectifs</span></a></li>\r\n       --><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN,ROLE_AREA_CONFIGURATION,ROLE_AREA_MANAGEMENT,ROLE_READ_ONLY\"><a ui-sref=\"mobile-message\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><i class=\"fa fa-envelope\"></i> <span translate=\"global.menu.mobileMessage\">Envoyer des messages</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_READ_ONLY,ROLE_AREA_CONFIGURATION\"><a ui-sref=\"area-setup({id:vm.user.agence.id})\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.parametragezone\">Paramétrage zone</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_READ_ONLY,ROLE_AREA_CONFIGURATION\"><a ui-sref=\"area-template-setup({id:vm.user.agence.id})\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.areaTemplates\">Modèles</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"modele-contrat.liste-contrat\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.parametragecontrats\">Configuration des ventes</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_READ_ONLY,ROLE_AREA_CONFIGURATION\"><a ui-sref=\"cout-achat-eau\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.coutAchatEau\">Cout Achat Eau</span></a></li><li data-ui-sref-active=\"active\" has-any-authority=\"ROLE_AREA_CONFIGURATION\"><a data-ui-sref=\"importation\"><i class=\"fa fa-upload\"></i> <span translate=\"global.menu.importation\">Importation des données</span></a></li></ul></li><li data-menu-collapse class=\"top-menu-invisible\" ng-class=\"{active: $state.includes(\'entite-parente\')}\" has-any-authority=\"ROLE_ADMIN,ROLE_SUPER_ADMIN\"><a href=\"#\"><span class=\"fa fa-lg fa-fw fa-gears\"></span> <span class=\"menu-item-parent\" translate=\"global.menu.administrationglobal\">Administration global</span></a><ul><li ui-sref-active=\"active\"><a ui-sref=\"user-management\"><span class=\"glyphicon glyphicon-user\"></span> &#xA0;<span translate=\"global.menu.admin.userManagement\">User management</span></a></li><li ui-sref-active=\"active\"><a data-ui-sref=\"ai-assistant-monitoring\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"fa fa-comments-o\"></span> &#xA0; <span class=\"menu-item-parent\" translate=\"global.menu.aiAssistantMonitoring\">Assistant IA</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"monitoring-rule\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-eye-open\"></span> &#xA0;<span translate=\"global.menu.monitoringRule\">monitoring rules</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"io-mobile-money\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span>Export import mobile money</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"entite-parente\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.entiteparente\">Entite parente</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"agence\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.agence\">Agences</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"water-network\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.waterNetwork\">water network</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"type-contrat\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.contractType\">Type Contrat</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"profil-contrat\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.contractProfil\">profil Contrat</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"type-service\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.typeservice\">Type service</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"type-avoir\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.typeAvoir\">Type Avoir</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"model-meter\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.modelMeter\">Modèles de compteur</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"cas-non-releve\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.casNonReleve\">Cas non releve</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"type-remisecommerciale\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.typeRemisecommerciale\">Type Remise commerciale</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"closing-contract-reason\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span> &#xA0;<span translate=\"global.menu.closingContractReason\">Type closingContractReason</span></a></li></ul></li><li data-menu-collapse class=\"top-menu-invisible\" ng-class=\"{active: $state.includes(\'admin\')}\" has-authority=\"ROLE_SUPER_ADMIN\"><a href=\"#\"><span class=\"fa fa-code\"></span> <span class=\"menu-item-parent\" translate=\"global.menu.admin.main\">Supervision technique</span></a><ul><li data-ui-sref-active=\"active\"><a data-ui-sref=\"admin-tools\"><i class=\"fa fa-lg fa-fw fa-wrench\"></i> <span translate=\"global.menu.adminTools\">admin-tools</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"ai-assistant-monitoring\"><i class=\"fa fa-lg fa-fw fa-comments-o\"></i> <span translate=\"global.menu.aiAssistantMonitoring\">Assistant IA</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"ai-costs\"><i class=\"fa fa-lg fa-fw fa-usd\"></i> <span>Coûts IA (USD)</span></a></li><li data-ui-sref-active=\"active\"><a data-ui-sref=\"ai-assistant-system-commands\"><i class=\"fa fa-lg fa-fw fa-list-alt\"></i> <span>Assistant IA - commandes systeme</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"user-admin\"><span class=\"glyphicon glyphicon-user\"></span> &#xA0;<span translate=\"global.menu.admin.userManagement\">User management</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"organisation\"><span class=\"fa fa-folder-open\"></span> &#xA0;<span translate=\"global.menu.admin.organisation\">organisation</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"batch-jobs-monitoring\"><span class=\"glyphicon glyphicon-bell\"></span> &#xA0;<span>Batch jobs monitoring</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"test-plan-monitoring\"><span class=\"glyphicon glyphicon-check\"></span> &#xA0;<span>Plans de test</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"stored-document-stats\"><span class=\"fa fa-database\"></span> &#xA0;<span>Statistiques S3</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"file-explorer\"><span class=\"glyphicon glyphicon-user\"></span> &#xA0;<span>S3 file explorer</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-metrics\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-dashboard\"></span> &#xA0;<span translate=\"global.menu.admin.metrics\">Metrics</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-health\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-heart\"></span> &#xA0;<span translate=\"global.menu.admin.health\">Health</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-configuration\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-list-alt\"></span> &#xA0;<span translate=\"global.menu.admin.configuration\">Configuration</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"logs\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-tasks\"></span> &#xA0;<span translate=\"global.menu.admin.logs\">Logs</span></a></li><li ng-hide=\"vm.inProduction\" ui-sref-active=\"active\"><a ui-sref=\"docs\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-book\"></span> &#xA0;<span translate=\"global.menu.admin.apidocs\">API</span></a></li><li ng-hide=\"vm.inProduction\"><a href=\"/h2-console\" target=\"_tab\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-hdd\"></span> &#xA0;<span translate=\"global.menu.admin.database\">Database</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"audits\"><span class=\"glyphicon glyphicon-bell\"></span> &#xA0;<span translate=\"global.menu.admin.audits\">Audits</span></a></li></ul></li><!-- <li ng-hide=\"vm.inProduction\" data-menu-collapse class=\"top-menu-invisible\"  has-authority=\"ROLE_ADMIN\">\r\n                <a href=\"#\"><span class=\"menu-item-parent\"> Entite</span></a>\r\n                <ul>    \r\n<li ui-sref-active=\"active\" ><a ui-sref=\"ligne-releve-compteur\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.ligneReleveCompteur\">Ligne Releve Compteur</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"consommation-eau-bulk-meter\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.consommationEauBulkMeter\">Consommation Eau Bulk Meter</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"consommation-eau-contrat\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.consommationEauContrat\">Consommation Eau Contrat</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"historique-compteur-contrat\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.historiqueCompteurContrat\">Historique Compteur Contrat</span></a></li>\r\n                        \r\n\r\n             <li ui-sref-active=\"active\" ><a ui-sref=\"ligne-contrat\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.ligneContrat\">Ligne Contrat</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"num-reference-contrat\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.numReferenceContrat\">Num Reference Contrat</span></a></li>\r\n                        \r\n\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"collection-liste\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.collectionListe\">Collection Liste</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"contrat-collection-list\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.contratCollectionList\">Contrat Collection List</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"ligne-paiement-service-eau\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.lignePaiementServiceEau\">Ligne Paiement Service Eau</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"ligne-paiement-service\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.lignePaiementService\">Ligne Paiement Service</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"ligne-paiement\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.lignePaiement\">Ligne Paiement</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"paiement-initial\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.paiementInitial\">Paiement Initial</span></a></li>\r\n                        \r\n<li ui-sref-active=\"active\" ><a ui-sref=\"historique-cout-contrat\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.historiqueCoutContrat\">Historique Cout Contrat</span></a></li>\r\n                        \r\n                                              <li ><a ui-sref=\"bulk-meter\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                            &#xA0;<span >Bulk Meter</span></a></li>\r\n                            \r\n                      <li ><a ui-sref=\"cluster\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                            &#xA0;<span >Cluster</span></a></li>\r\n                                        \r\n                      <li ><a ui-sref=\"service-eau\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                            &#xA0;<span >Service eau</span></a></li>\r\n                            \r\n                      <li ><a ui-sref=\"service-autre\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                            &#xA0;<span >Service autre</span></a></li>\r\n                            \r\n       </ul>\r\n            </li>\r\n             --></ul></nav><span class=\"minifyme\" data-action=\"minifyMenu\" minify-menu><i class=\"fa fa-arrow-circle-left hit\"></i></span></aside><!-- TODO TFE Ancienne Nav bar à supprimer quand on aura fini le dev de la nav bar actuelle--><!-- <nav class=\"navbar navbar-default\" role=\"navigation\"> --><!--     <div class=\"container\"> --><!--         <div class=\"navbar-header\"> --><!--             <button type=\"button\" class=\"navbar-toggle\" ng-click=\"vm.navCollapsed = !vm.navCollapsed\"> --><!--                 <span class=\"sr-only\">Toggle navigation</span> --><!--                 <span class=\"icon-bar\"></span> --><!--                 <span class=\"icon-bar\"></span> --><!--                 <span class=\"icon-bar\"></span> --><!--             </button> --><!--             <a class=\"navbar-brand\" href=\"#/\"><span translate=\"global.title\">Wamasys</span> <span class=\"navbar-version\">v{{VERSION}}</span></a> --><!--         </div> --><!--         <div class=\"collapse navbar-collapse\" id=\"navbar-collapse\" uib-collapse=\"vm.navCollapsed\" ng-switch=\"vm.isAuthenticated()\"> --><!--             <ul class=\"nav navbar-nav navbar-right\"> --><!--                 <li ui-sref-active=\"active\"> --><!--                     <a ui-sref=\"home\" ng-click=\"vm.navCollapsed = true\"> --><!--                         <span class=\"glyphicon glyphicon-home\"></span> --><!--                         <span class=\"hidden-sm\" translate=\"global.menu.home\">Home</span> --><!--                     </a> --><!--                 </li>  --><!--                 jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><!--                 <li ng-class=\"{active: vm.$state.includes(\'entity\')}\" ng-switch-when=\"true\" uib-dropdown class=\"dropdown pointer\"> --><!--                     <a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"entity-menu\"> --><!--                         <span> --><!--                             <span class=\"glyphicon glyphicon-th-list\"></span> --><!--                             <span class=\"hidden-sm\" translate=\"global.menu.entities.main\"> --><!--                                 Entities --><!--                             </span> --><!--                             <b class=\"caret\"></b> --><!--                         </span> --><!--                     </a> --><!--                     <ul class=\"dropdown-menu\" uib-dropdown-menu> --><!-- <li ui-sref-active=\"active\" ><a ui-sref=\"entite-parente\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.entiteParente\">Entite Parente</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"agence\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.agence\">Agence</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"collecteur\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.collecteur\">Collecteur</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"bulk-meter\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.bulkMeter\">Bulk Meter</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"cluster\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.cluster\">Cluster</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"individual-meter\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.individualMeter\">Individual Meter</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"type-service\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.typeService\">Type Service</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"service-eau\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.serviceEau\">Service Eau</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"service-autre\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.serviceVendu\">Service Autre</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"contrat\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.contrat\">Contrat</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"ligne-contrat\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.ligneContrat\">Ligne Contrat</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"modele-contrat\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.modeleContrat\">Modele Contrat</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"releve-compteur\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.releveCompteur\">Releve Compteur</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"ligne-releve-compteur\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.ligneReleveCompteur\">Ligne Releve Compteur</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"consommation-eau-bulk-meter\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.consommationEauBulkMeter\">Consommation Eau Bulk Meter</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"consommation-eau-contrat\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.consommationEauContrat\">Consommation Eau Contrat</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"historique-compteur-contrat\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.historiqueCompteurContrat\">Historique Compteur Contrat</span></a></li> \r\n<li ui-sref-active=\"active\" ><a ui-sref=\"portefeuille-contrat\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.portefeuilleContrat\">Portefeuille Contrat</span></a></li>\r\n<li ui-sref-active=\"active\" ><a ui-sref=\"num-reference-contrat\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-asterisk\"></span>\r\n                        &#xA0;<span translate=\"global.menu.entities.numReferenceContrat\">Num Reference Contrat</span></a></li>--><!--                         jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --><!--                     </ul> --><!--                 </li> --><!--                 <li ng-class=\"{active: vm.$state.includes(\'account\')}\" uib-dropdown class=\"dropdown pointer\"> --><!--                     <a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"account-menu\"> --><!--                         <span> --><!--                             <span class=\"glyphicon glyphicon-user\"></span> --><!--                             <span class=\"hidden-sm\" translate=\"global.menu.account.main\"> --><!--                                 Account --><!--                             </span> --><!--                             <b class=\"caret\"></b> --><!--                         </span> --><!--                     </a> --><!--                     <ul class=\"dropdown-menu\" uib-dropdown-menu> --><!--                         <li ui-sref-active=\"active\" ng-switch-when=\"true\"><a ui-sref=\"settings\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-wrench\"></span> --><!--                             &#xA0;<span translate=\"global.menu.account.settings\">Settings</span></a></li> --><!--                         <li ui-sref-active=\"active\" ng-switch-when=\"true\"><a ui-sref=\"password\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-lock\"></span> --><!--                             &#xA0;<span translate=\"global.menu.account.password\">Password</span></a></li> --><!--                         <li ui-sref-active=\"active\" ng-switch-when=\"true\"><a href=\"\" ng-click=\"vm.logout()\" id=\"logout\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-log-out\"></span> --><!--                             &#xA0;<span translate=\"global.menu.account.logout\">Sign out</span></a></li> --><!--                         <li ui-sref-active=\"active\" ng-switch-when=\"false\"><a href=\"\" ng-click=\"vm.login()\" id=\"login\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-log-in\"></span> --><!--                             &#xA0;<span translate=\"global.menu.account.login\">Sign in</span></a></li> --><!--                         <li ui-sref-active=\"active\" ng-switch-when=\"false\"><a ui-sref=\"register\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-plus-sign\"></span> --><!--                             &#xA0;<span translate=\"global.menu.account.register\">Register</span></a></li> --><!--                     </ul> --><!--                 </li> --><!--                 <li ng-class=\"{active: vm.vm.$state.includes(\'admin\')}\"  ng-switch-when=\"true\" has-authority=\"ROLE_ADMIN\" uib-dropdown class=\"dropdown pointer\"> --><!--                     <a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"admin-menu\"> --><!--                         <span> --><!--                             <span class=\"glyphicon glyphicon-tower\"></span> --><!--                             <span class=\"hidden-sm\" translate=\"global.menu.admin.main\">Administration</span> --><!--                             <b class=\"caret\"></b> --><!--                         </span> --><!--                     </a> --><!--                     <ul class=\"dropdown-menu\" uib-dropdown-menu> --><!--                         <li ui-sref-active=\"active\"><a ui-sref=\"user-management\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-user\"></span> --><!--                             &#xA0;<span translate=\"global.menu.admin.userManagement\">User management</span></a></li> --><!--                         <li ui-sref-active=\"active\"><a ui-sref=\"jhi-metrics\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-dashboard\"></span> --><!--                             &#xA0;<span translate=\"global.menu.admin.metrics\">Metrics</span></a></li> --><!--                         <li ui-sref-active=\"active\"><a ui-sref=\"jhi-health\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-heart\"></span> --><!--                             &#xA0;<span translate=\"global.menu.admin.health\">Health</span></a></li> --><!--                         <li ui-sref-active=\"active\"><a ui-sref=\"jhi-configuration\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-list-alt\"></span> --><!--                             &#xA0;<span translate=\"global.menu.admin.configuration\">Configuration</span></a></li> --><!--                         <li ui-sref-active=\"active\"><a ui-sref=\"audits\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-bell\"></span> --><!--                             &#xA0;<span translate=\"global.menu.admin.audits\">Audits</span></a></li> --><!--                         <li ui-sref-active=\"active\"><a ui-sref=\"logs\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-tasks\"></span> --><!--                             &#xA0;<span translate=\"global.menu.admin.logs\">Logs</span></a></li> --><!--                         <li ng-hide=\"vm.inProduction\" ui-sref-active=\"active\"><a ui-sref=\"docs\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-book\"></span> --><!--                             &#xA0;<span translate=\"global.menu.admin.apidocs\">API</span></a></li> --><!--                         jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --><!--                         <li ng-hide=\"vm.inProduction\"><a href=\'/h2-console\' target=\"_tab\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\"><span class=\"glyphicon glyphicon-hdd\"></span> --><!--                             &#xA0;<span translate=\"global.menu.admin.database\">Database</span></a></li> --><!--                     </ul> --><!--                 </li> --><!--                 <li ui-sref-active=\"active\" uib-dropdown class=\"dropdown pointer\" ng-controller=\"JhiLanguageController as languageVm\"> --><!--                     <a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" ng-if=\"languageVm.languages.length > 1\"> --><!--                         <span> --><!--                             <span class=\"glyphicon glyphicon-flag\"></span> --><!--                             <span class=\"hidden-sm\" translate=\"global.menu.language\">Language</span> --><!--                             <b class=\"caret\"></b> --><!--                         </span> --><!--                     </a> --><!--                     <ul class=\"dropdown-menu\" uib-dropdown-menu ng-if=\"languageVm.languages.length > 1\"> --><!--                         <li active-menu=\"{{language}}\" ng-repeat=\"language in languageVm.languages\"> --><!--                             <a href=\"\" ng-click=\"languageVm.changeLanguage(language)\" data-toggle=\"collapse\" data-target=\".navbar-collapse.in\">{{language | findLanguageFromKey}}</a> --><!--                         </li> --><!--                     </ul> --><!--                 </li> --><!--             </ul> --><!--         </div> --><!--     </div> --> <!-- </nav> -->");
$templateCache.put("app/business/batch-jobs/batch-jobs.html","<div><h2>Suivi des traitements batch</h2><div class=\"row\"><div class=\"col-md-2 col-sm-4 col-xs-6\"><div class=\"well well-sm\"><strong>TODO</strong><div>{{vm.summary.todoCount || 0}}</div></div></div><div class=\"col-md-2 col-sm-4 col-xs-6\"><div class=\"well well-sm\"><strong>WIP</strong><div>{{vm.summary.wipCount || 0}}</div></div></div><div class=\"col-md-2 col-sm-4 col-xs-6\"><div class=\"well well-sm\"><strong>SUCCESS</strong><div>{{vm.summary.successCount || 0}}</div></div></div><div class=\"col-md-2 col-sm-4 col-xs-6\"><div class=\"well well-sm\"><strong>Erreurs</strong><div>{{vm.summary.errorCount || 0}}</div></div></div><div class=\"col-md-2 col-sm-4 col-xs-6\"><div class=\"well well-sm\"><strong>Plus ancienne cr&eacute;ation</strong><div>{{vm.summary.oldestInsertedDate ? (vm.summary.oldestInsertedDate | date:\'yyyy-MM-dd HH:mm:ss\') : \'-\'}}</div></div></div><div class=\"col-md-2 col-sm-4 col-xs-12\"><div class=\"well well-sm\"><label for=\"field_etat\">&Eacute;tat</label><select id=\"field_etat\" class=\"form-control\" ng-model=\"vm.etat\" ng-change=\"vm.search()\"><option value=\"\">Tous</option><option value=\"TODO\">TODO</option><option value=\"WIP\">WIP</option><option value=\"SUCCESS\">SUCCESS</option><option value=\"ERROR\">ERROR</option></select></div></div></div><div class=\"table-responsive\" infinite-scroll=\"vm.loadPage(vm.links.next)\" infinite-scroll-disabled=\"vm.isLoading || !vm.links.next\" infinite-scroll-distance=\"1\"><table class=\"table table-striped table-bordered\"><thead><tr><th>ID</th><th>Organisation</th><th>Type</th><th>Objet</th><th>&Eacute;tat</th><th>Cr&eacute;ation</th><th>Derni&egrave;re mise &agrave; jour</th><th>Pas avant</th><th>Message erreur</th></tr></thead><tbody><tr ng-repeat=\"job in vm.batchJobs track by job.id\"><td>{{job.id}}</td><td>{{job.idOrga}}</td><td>{{job.type}}</td><td>{{job.objectId}}</td><td><span class=\"label\" ng-class=\"{\n                                  \'label-danger\': job.etat === \'ERROR\',\n                                  \'label-warning\': job.etat === \'WIP\',\n                                  \'label-info\': job.etat === \'TODO\',\n                                  \'label-success\': job.etat === \'SUCCESS\'\n                              }\">{{job.etat}}</span></td><td>{{job.insertedDate | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td>{{job.lastUpdatedDate | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td>{{job.notBeforeDate | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td><span ng-if=\"job.messageErreur\">{{job.messageErreur}}</span> <span ng-if=\"!job.messageErreur\">Erreur technique sans d&eacute;tail enregistr&eacute;</span></td></tr><tr ng-if=\"!vm.batchJobs.length && !vm.isLoading\"><td colspan=\"9\" class=\"text-center text-muted\">Aucun traitement batch trouv&eacute;.</td></tr></tbody></table></div><div class=\"text-center\" ng-show=\"vm.isLoading\">Chargement...</div></div>");
$templateCache.put("app/business/cas-non-releve/cas-non-releve-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.casNonReleve.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.casNonReleve.delete.question\" translate-values=\"{id: \'{{vm.casNonReleve.id}}\'}\">Are you sure you want to delete this CasNonReleve?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/cas-non-releve/cas-non-releve-detail.html","<div><h2><span translate=\"wamasysApp.casNonReleve.detail.title\">CasNonReleve</span> {{vm.casNonReleve.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"global.field.code\">Code</span></dt><dd><span>{{vm.casNonReleve.code}}</span></dd><hr><dt><span translate=\"wamasysApp.casNonReleve.libelle\">Libelle</span></dt><dd><span>{{vm.casNonReleve.libelle}}<span></span></span></dd><hr><dt><span translate=\"global.field.isDeleted\">isDeleted</span></dt><dd><span>{{vm.casNonReleve.deleted}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/cas-non-releve/cas-non-releve-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCasNonReleveLabel\" translate=\"wamasysApp.casNonReleve.home.createOrEditLabel\">Create or edit a CasNonReleve</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"global.field.code\" for=\"field_code\">Code</label><input ng-readonly=\"vm.casNonReleve.id != null\" required type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.casNonReleve.code\" ng-maxlength=\"64\" ng-pattern=\"/^[_.A-Z0-9-]*$/\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.pattern\" translate=\"wamasysApp.casNonReleve.codeFormatError\">The article code can only contain upper-case letters and digits.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"64\">This field cannot be longer than 64 characters.</p></div></div><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.casNonReleve.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.casNonReleve.libelle\" for=\"field_libelle\">Libelle</label><input type=\"text\" class=\"form-control\" name=\"libelle\" id=\"field_libelle\" ng-model=\"vm.casNonReleve.libelle\" required ng-maxlength=\"50\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.libelle.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.libelle.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.casNonReleve.id\"><label class=\"control-deleted\" translate=\"global.field.isDeleted\" for=\"field_deleted\">deleted</label><input type=\"checkbox\" class=\"form-control\" name=\"deleted\" id=\"field_deleted\" ng-model=\"vm.casNonReleve.deleted\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/cas-non-releve/cas-non-releves.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.casNonReleve.home.title\">CasNonReleves</span> <small class=\"text-muted\" translate=\"global.configurationScope.organization\">Paramétrage commun à toute l\'organisation</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"cas-non-releve.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.casNonReleve.home.createLabel\">Create new CasNonReleve</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"libelle\"><span translate=\"wamasysApp.casNonReleve.libelle\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"global.field.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deleted\"><span translate=\"global.field.isDeleted\">isDeleted</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"casNonReleve in vm.casNonReleves track by casNonReleve.id\"><td><a ui-sref=\"cas-non-releve-detail({id:casNonReleve.id})\">{{casNonReleve.id}}</a></td><td>{{casNonReleve.libelle}}</td><td>{{casNonReleve.code}}</td><td>{{casNonReleve.deleted}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"cas-non-releve-detail({id:casNonReleve.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"cas-non-releve.edit({id:casNonReleve.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"cas-non-releve.delete({id:casNonReleve.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/closing-contract-reason/closing-contract-reason-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.closingContractReason.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.closingContractReason.delete.question\" translate-values=\"{id: \'{{vm.closingContractReason.id}}\'}\">Are you sure you want to delete this ClosingContractReason?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/closing-contract-reason/closing-contract-reason-detail.html","<div><h2><span translate=\"wamasysApp.closingContractReason.detail.title\">ClosingContractReason</span> {{vm.closingContractReason.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"global.field.code\">Code</span></dt><dd><span>{{vm.closingContractReason.code}}</span></dd><hr><dt><span translate=\"wamasysApp.closingContractReason.label\">Label</span></dt><dd><span>{{vm.closingContractReason.label}}<span></span></span></dd><hr><dt><span translate=\"global.field.isDeleted\">isDeleted</span></dt><dd><span>{{vm.closingContractReason.deleted}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/closing-contract-reason/closing-contract-reason-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myClosingContractReasonLabel\" translate=\"wamasysApp.closingContractReason.home.createOrEditLabel\">Create or edit a ClosingContractReason</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"global.field.code\" for=\"field_code\">Code</label><input ng-readonly=\"vm.closingContractReason.id != null\" required type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.closingContractReason.code\" ng-maxlength=\"64\" ng-pattern=\"/^[_.A-Z0-9-]*$/\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.pattern\" translate=\"wamasysApp.closingContractReason.codeArticleFormatError\">The article code can only contain upper-case letters and digits.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"64\">This field cannot be longer than 64 characters.</p></div></div><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.closingContractReason.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.closingContractReason.label\" for=\"field_label\">Libelle</label><input type=\"text\" class=\"form-control\" name=\"label\" id=\"field_label\" ng-model=\"vm.closingContractReason.label\" required ng-maxlength=\"50\"><div ng-show=\"editForm.label.$invalid\"><p class=\"help-block\" ng-show=\"editForm.label.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.label.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.closingContractReason.id\"><label class=\"control-deleted\" translate=\"global.field.isDeleted\" for=\"field_deleted\">deleted</label><input type=\"checkbox\" class=\"form-control\" name=\"deleted\" id=\"field_deleted\" ng-model=\"vm.closingContractReason.deleted\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/closing-contract-reason/closing-contract-reasons.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.closingContractReason.home.title\">ClosingContractReasons</span> <small class=\"text-muted\" translate=\"global.configurationScope.organization\">Paramétrage commun à toute l\'organisation</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"closing-contract-reason.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.closingContractReason.home.createLabel\">Create new ClosingContractReason</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"label\"><span translate=\"wamasysApp.closingContractReason.label\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"global.field.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deleted\"><span translate=\"global.field.isDeleted\">isDeleted</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"closingContractReason in vm.closingContractReasons track by closingContractReason.id\"><td><a ui-sref=\"closing-contract-reason-detail({id:closingContractReason.id})\">{{closingContractReason.id}}</a></td><td>{{closingContractReason.label}}</td><td>{{closingContractReason.code}}</td><td>{{closingContractReason.deleted}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"closing-contract-reason-detail({id:closingContractReason.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"closing-contract-reason.edit({id:closingContractReason.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"closing-contract-reason.delete({id:closingContractReason.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/agence/agence-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.agence.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.agence.delete.question\" translate-values=\"{id: \'{{vm.agence.id}}\'}\">Are you sure you want to delete this Agence?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/agence/agence-detail.html","<div><h2><span translate=\"wamasysApp.agence.detail.title\">Agence</span> {{vm.agence.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.agence.nom\">Nom</span></dt><dd><span>{{vm.agence.nom}}</span></dd><hr><dt><span translate=\"wamasysApp.agence.dateDebutDemarrage\">dateDebutDemarrage</span></dt><dd><span>{{vm.agence.dateDebutDemarrage | date:\'mediumDate\'}}</span></dd><hr><dt><span translate=\"wamasysApp.agence.codeAgence\">CodeAgence</span></dt><dd><span>{{vm.agence.codeAgence}}</span></dd><hr><dt><span translate=\"wamasysApp.agence.waterNetworks\">waterNetwork</span></dt><dd><ul class=\"list-unstyled\"><li ng-repeat=\"waterNetwork in vm.agence.waterNetwork\"><span>{{waterNetwork.label}}</span></li></ul></dd><hr><dt><span translate=\"wamasysApp.agence.langue\">langue</span></dt><dd><span>{{vm.agence.langue}}</span></dd><hr><hr><dt><span translate=\"wamasysApp.agence.devise\">Devise</span></dt><dd><span>{{vm.agence.devise}}</span></dd><hr><dt><span translate=\"wamasysApp.agence.maxDailyIndividualMeterConsumption\">maxDailyIndividualMeterConsumption</span></dt><dd><span>{{vm.agence.maxDailyIndividualMeterConsumption}}</span></dd><hr><dt><span translate=\"wamasysApp.agence.maxDailyBulkMeterConsumption\">maxDailyBulkMeterConsumption</span></dt><dd><span>{{vm.agence.maxDailyBulkMeterConsumption}}</span></dd><hr><dt><span translate=\"wamasysApp.agence.timezone\">timezone</span></dt><dd><span>{{vm.agence.timezone}}</span></dd><hr><dt><span translate=\"wamasysApp.agence.entiteParente\">entiteParente</span></dt><dd><a ui-sref=\"entite-parente-detail({id:vm.agence.entiteParente.id})\">{{vm.agence.entiteParente.nom}}</a></dd><hr><dt><span translate=\"wamasysApp.agence.enteteFacture\">enteteFacture</span></dt><dd><span>{{vm.agence.enteteFacture}}</span></dd><hr><dt><span translate=\"wamasysApp.agence.preambuleOrdreRecouvrement\">preambuleOrdreRecouvrement</span></dt><dd><span>{{vm.agence.preambuleOrdreRecouvrement}}</span></dd><hr><dt><span translate=\"wamasysApp.agence.conclusionOrdreRecouvrement\">conclusionOrdreRecouvrement</span></dt><dd><span>{{vm.agence.conclusionOrdreRecouvrement}}</span></dd><hr><dt><span translate=\"wamasysApp.agence.commentaire\">commentaire</span></dt><dd><span>{{vm.agence.commentaire}}</span></dd><hr><dt><span translate=\"wamasysApp.agence.redmineProjetId\">redmineProjetId</span></dt><dd><span>{{vm.agence.redmineProjetId}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/agence/agence-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAgenceLabel\" translate=\"wamasysApp.agence.home.createOrEditLabel\">Create or edit a Agence</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.agence.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.nom\" for=\"field_nom\">Nom</label><input type=\"text\" class=\"form-control\" name=\"nom\" id=\"field_nom\" ng-model=\"vm.agence.nom\" required ng-maxlength=\"50\"><div ng-show=\"editForm.nom.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nom.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nom.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.dateDebutDemarrage\" for=\"field_dateDebutDemarrage\">dateDebutDemarrage</label><div class=\"input-group\"><input id=\"field_dateDebutDemarrage\" type=\"text\" class=\"form-control\" name=\"dateDebutDemarrage\" ng-click=\"vm.openCalendar(\'dateDebutDemarrage\')\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.agence.dateDebutDemarrage\" is-open=\"vm.datePickerOpenStatus.dateDebutDemarrage\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateDebutDemarrage\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.dateDebutDemarrage.$invalid\"></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.codeAgence\" for=\"field_codeAgence\">CodeAgence</label><input type=\"text\" class=\"form-control\" name=\"codeAgence\" id=\"field_codeAgence\" ng-model=\"vm.agence.codeAgence\" required ng-maxlength=\"4\"><div ng-show=\"editForm.codeAgence.$invalid\"><p class=\"help-block\" ng-show=\"editForm.codeAgence.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.codeAgence.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"4\">This field cannot be longer than 4 characters.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.agence.waterNetworks\">waterNetwork</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.agence.waterNetwork\" theme=\"selectize\" title=\"{{\'wamasysApp.agence.waterNetworks\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.agence.waterNetworks\' | translate}}\">{{$item.label}}</ui-select-match><ui-select-choices repeat=\"waterNetwork in vm.waterNetworks | filter: $select.search track by waterNetwork.id\">{{waterNetwork.label}}</ui-select-choices></ui-select></div><div class=\"form-group\"><label translate=\"wamasysApp.agence.langue\" for=\"field_langue\">langue</label><select required class=\"form-control\" id=\"field_langue\" name=\"langue\" ng-model=\"vm.agence.langue\"><option value=\"en\">English</option><option value=\"fr\">Français</option><option value=\"fr_CI\">Français Côte d\'Ivoire</option></select><div ng-show=\"editForm.langue.$invalid\"><p class=\"help-block\" ng-show=\"editForm.langue.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.langue.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"4\">This field cannot be longer than 4 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.devise\" for=\"field_devise\">Devise</label><input type=\"text\" class=\"form-control\" name=\"devise\" id=\"field_devise\" ng-model=\"vm.agence.devise\" required ng-maxlength=\"50\"><div ng-show=\"editForm.devise.$invalid\"><p class=\"help-block\" ng-show=\"editForm.devise.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.devise.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.maxDailyIndividualMeterConsumption\" for=\"field_maxDailyIndividualMeterConsumption\">maxDailyIndividualMeterConsumption</label><input type=\"number\" class=\"form-control\" name=\"maxDailyIndividualMeterConsumption\" id=\"field_maxDailyIndividualMeterConsumption\" ng-model=\"vm.agence.maxDailyIndividualMeterConsumption\" max=\"999999999999\"><div ng-show=\"editForm.maxDailyIndividualMeterConsumption.$invalid\"><p class=\"help-block\" ng-show=\"editForm.maxDailyIndividualMeterConsumption.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999999999\">This field cannot be more than 999999999999.</p><p class=\"help-block\" ng-show=\"editForm.maxDailyIndividualMeterConsumption.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.maxDailyBulkMeterConsumption\" for=\"field_maxDailyBulkMeterConsumption\">maxDailyBulkMeterConsumption</label><input type=\"number\" class=\"form-control\" name=\"maxDailyBulkMeterConsumption\" id=\"field_maxDailyBulkMeterConsumption\" ng-model=\"vm.agence.maxDailyBulkMeterConsumption\" max=\"999999999999\"><div ng-show=\"editForm.maxDailyBulkMeterConsumption.$invalid\"><p class=\"help-block\" ng-show=\"editForm.maxDailyBulkMeterConsumption.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999999999\">This field cannot be more than 999999999999.</p><p class=\"help-block\" ng-show=\"editForm.maxDailyBulkMeterConsumption.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.enteteFacture\" for=\"field_enteteFacture\">EnteteFacture</label><textarea class=\"form-control\" name=\"enteteFacture\" id=\"field_enteteFacture\" ng-model=\"vm.agence.enteteFacture\" rows=\"3\" ng-maxlength=\"256\"></textarea><div ng-show=\"editForm.enteteFacture.$invalid\"><p class=\"help-block\" ng-show=\"editForm.enteteFacture.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.receiptTemplate\" for=\"field_receiptTemplate\">receiptTemplate</label><textarea class=\"form-control\" name=\"receiptTemplate\" id=\"field_receiptTemplate\" ng-model=\"vm.agence.receiptTemplate\" rows=\"3\" ng-maxlength=\"4096\"></textarea><div ng-show=\"editForm.receiptTemplate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.receiptTemplate.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"4096\">This field cannot be longer than 4096 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.preambuleOrdreRecouvrement\" for=\"field_preambuleOrdreRecouvrement\">preambuleOrdreRecouvrement</label><textarea class=\"form-control\" name=\"preambuleOrdreRecouvrement\" id=\"field_preambuleOrdreRecouvrement\" ng-model=\"vm.agence.preambuleOrdreRecouvrement\" rows=\"3\" ng-maxlength=\"1024\"></textarea><div ng-show=\"editForm.preambuleOrdreRecouvrement.$invalid\"><p class=\"help-block\" ng-show=\"editForm.preambuleOrdreRecouvrement.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"1024\">This field cannot be longer than 1024 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.conclusionOrdreRecouvrement\" for=\"field_conclusionOrdreRecouvrement\">conclusionOrdreRecouvrement</label><textarea class=\"form-control\" name=\"conclusionOrdreRecouvrement\" id=\"field_conclusionOrdreRecouvrement\" ng-model=\"vm.agence.conclusionOrdreRecouvrement\" rows=\"3\" ng-maxlength=\"1024\"></textarea><div ng-show=\"editForm.conclusionOrdreRecouvrement.$invalid\"><p class=\"help-block\" ng-show=\"editForm.conclusionOrdreRecouvrement.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"1024\">This field cannot be longer than 1024 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.commentaire\" for=\"field_commentaire\">Commentaire</label><textarea class=\"form-control\" name=\"commentaire\" id=\"field_commentaire\" ng-model=\"vm.agence.commentaire\" rows=\"3\" ng-maxlength=\"2048\"></textarea><div ng-show=\"editForm.commentaire.$invalid\"><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"2048\">This field cannot be longer than 2048 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.redmineProjetId\" for=\"field_redmineProjetId\">redmineProjetId</label><input type=\"text\" class=\"form-control\" name=\"redmineProjetId\" id=\"field_redmineProjetId\" ng-model=\"vm.agence.redmineProjetId\" ng-maxlength=\"255\" readonly=\"readonly\"><div ng-show=\"editForm.redmineProjetId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.redmineProjetId.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.agence.entiteParente\" for=\"field_entiteParente\">entiteParente</label><select class=\"form-control\" id=\"field_entiteParente\" name=\"entiteParente\" ng-model=\"vm.agence.entiteParente\" ng-options=\"entiteParente as entiteParente.nom for entiteParente in vm.entiteparentes track by entiteParente.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"wamasysApp.agence.timezone\" for=\"field_timezone\">timezone</label><ui-select ng-model=\"vm.agence.timezone\" theme=\"selectize\"><!--  title=\"{{\'wamasysApp.agence.timezone\' | translate}}\" --><ui-select-match placeholder=\"{{\'wamasysApp.agence.timezone\' | translate}}\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.timezones | filter: $select.search \">{{item.label}}</ui-select-choices></ui-select><!--             <select class=\"form-control\" id=\"field_timezone\" name=\"timezone\" ng-model=\"vm.agence.timezone\" ng-options=\"timezone.id as timezone.label for timezone in vm.timezones \"> --><!--                  <option value=\"\"></option> --><!--             </select> --></div><map-leaflet contrat=\"vm.agence\" has-module=\"GEO\" height=\"480px\" width=\"100%\"><!--         <leaflet defaults=\"defaults\"    markers=\"markers\"  	></leaflet> --><!--         <div class=\"form-group row\" 	has-module=\"GEO\"> --><!--             <label class=\"control-label col-md-2\" translate=\"wamasysApp.agence.lat\" for=\"field_lat\">lat</label> --><!--             <div class=\" col-md-4\"> --><!-- 				<input type=\"number\" class=\"form-control\" name=\"lat\" id=\"field_lat\" --><!-- 					ng-model=\"vm.agence.lat\" required min=\"-99\" max=\"99\" ng-change=\"vm.updateCoord()\"/> --><!-- 				<div ng-show=\"editForm.lat.$invalid\"> --><!-- 					<p class=\"help-block\" ng-show=\"editForm.lat.$error.required\" --><!-- 						translate=\"entity.validation.required\">This field is required. --><!-- 					</p> --><!-- 					<p class=\"help-block\" ng-show=\"editForm.lat.$error.min\" --><!-- 						translate=\"entity.validation.min\" translate-value-min=\"0\"> --><!-- 						This field should be more than 0.</p> --><!-- 					<p class=\"help-block\" ng-show=\"editForm.lat.$error.max\" --><!-- 						translate=\"entity.validation.max\" translate-value-max=\"999\"> --><!-- 						This field cannot be more than 999.</p> --><!-- 					<p class=\"help-block\" ng-show=\"editForm.lat.$error.number\" --><!-- 						translate=\"entity.validation.number\">This field should be a --><!-- 						number.</p> --><!-- 				</div> --><!-- 			</div> --><!--             <label class=\"control-label col-md-2\" translate=\"wamasysApp.agence.lon\" for=\"field_lon\">lon</label> --><!--             <div class=\" col-md-4\"> --><!-- 				<input type=\"number\" class=\"form-control\" name=\"lon\" id=\"field_lon\" --><!-- 					ng-model=\"vm.agence.lon\" required min=\"-200\" max=\"200\"  ng-change=\"vm.updateCoord()\"/> --><!-- 				<div ng-show=\"editForm.lon.$invalid\"> --><!-- 					<p class=\"help-block\" ng-show=\"editForm.lon.$error.required\" --><!-- 						translone=\"entity.validation.required\">This field is required. --><!-- 					</p> --><!-- 					<p class=\"help-block\" ng-show=\"editForm.lon.$error.min\" --><!-- 						translone=\"entity.validation.min\" translone-value-min=\"0\"> --><!-- 						This field should be more than 0.</p> --><!-- 					<p class=\"help-block\" ng-show=\"editForm.lon.$error.max\" --><!-- 						translone=\"entity.validation.max\" translone-value-max=\"999\"> --><!-- 						This field cannot be more than 999.</p> --><!-- 					<p class=\"help-block\" ng-show=\"editForm.lon.$error.number\" --><!-- 						translone=\"entity.validation.number\">This field should be a --><!-- 						number.</p> --><!-- 				</div> --><!-- 			</div> --><!--         </div> --></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/agence/agence-setup.html","<!-- \r\n				<h2>\r\n					<span translate=\"wamasysApp.agence.home.editLabel\">Agence</span>\r\n\r\n				</h2> --><uib-tabset><uib-tab><uib-tab-heading><span translate=\"wamasysApp.agence.home.mainTab\"></span></uib-tab-heading><uib-tab-content><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><br><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.nom\" for=\"field_nom\">Nom</label><input type=\"text\" class=\"form-control\" name=\"nom\" id=\"field_nom\" ng-model=\"vm.agence.nom\" required ng-maxlength=\"50\" readonly=\"readonly\"><!--\r\n			            <div ng-show=\"editForm.nom.$invalid\">\r\n			                <p class=\"help-block\"\r\n			                    ng-show=\"editForm.nom.$error.required\" translate=\"entity.validation.required\">\r\n			                    This field is required.\r\n			                </p>\r\n			                <p class=\"help-block\"\r\n			                    ng-show=\"editForm.nom.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">\r\n			                    This field cannot be longer than 50 characters.\r\n			                </p>\r\n			            </div>\r\n			             --></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.codeAgence\" for=\"field_codeAgence\">CodeAgence</label><input type=\"text\" class=\"form-control\" name=\"codeAgence\" id=\"field_codeAgence\" ng-model=\"vm.agence.codeAgence\" required ng-maxlength=\"4\" readonly=\"readonly\"><!--\r\n				            <div ng-show=\"editForm.codeAgence.$invalid\">\r\n				                <p class=\"help-block\"\r\n				                    ng-show=\"editForm.codeAgence.$error.required\" translate=\"entity.validation.required\">\r\n				                    This field is required.\r\n				                </p>\r\n				                <p class=\"help-block\"\r\n				                    ng-show=\"editForm.codeAgence.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"4\">\r\n				                    This field cannot be longer than 4 characters.\r\n				                </p>\r\n				            </div> --></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.agence.waterNetworks\">waterNetwork</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.agence.waterNetwork\" theme=\"selectize\" title=\"{{\'wamasysApp.agence.waterNetworks\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.agence.waterNetworks\' | translate}}\">{{$item.label}}</ui-select-match><ui-select-choices repeat=\"waterNetwork in vm.waterNetworks | filter: $select.search track by waterNetwork.id\">{{waterNetwork.label}}</ui-select-choices></ui-select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.devise\" for=\"field_devise\">Devise</label><input type=\"text\" class=\"form-control\" name=\"devise\" id=\"field_devise\" ng-model=\"vm.agence.devise\" required ng-maxlength=\"50\"><div ng-show=\"editForm.devise.$invalid\"><p class=\"help-block\" ng-show=\"editForm.devise.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.devise.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div></div></div><!--			    <div class=\"row\"> --><!--				<div class=\"col-md-6\"> --><!--				        <div class=\"form-group\"> --><!--				            <label class=\"control-label\" translate=\"wamasysApp.agence.enteteFacture\" for=\"field_enteteFacture\">EnteteFacture</label> --><!--				            <textarea class=\"form-control\" name=\"enteteFacture\" id=\"field_enteteFacture\" --><!--				                    ng-model=\"vm.agence.enteteFacture\" --><!--				                    rows=\"3\" ng-maxlength=\"256\" ></textarea> --><!--				            <div ng-show=\"editForm.enteteFacture.$invalid\"> --><!--				                <p class=\"help-block\" --><!--				                    ng-show=\"editForm.enteteFacture.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\"> --><!--				                    This field cannot be longer than 256 characters. --><!--				                </p> --><!--				            </div> --><!--				        </div> --><!--				</div> --><!--				<div class=\"col-md-6\"> --><!--				        <div class=\"form-group\"> --><!--				            <label class=\"control-label\" translate=\"wamasysApp.agence.receiptTemplate\" for=\"field_receiptTemplate\">receiptTemplate</label> --><!--				            <textarea class=\"form-control\" name=\"receiptTemplate\" id=\"field_receiptTemplate\" --><!--				                    ng-model=\"vm.agence.receiptTemplate\" --><!--				                    rows=\"3\" ng-maxlength=\"4096\" ></textarea> --><!--				            <div ng-show=\"editForm.receiptTemplate.$invalid\"> --><!--				                <p class=\"help-block\" --><!--				                    ng-show=\"editForm.receiptTemplate.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"4096\"> --><!--				                    This field cannot be longer than 4096 characters. --><!--				                </p> --><!--				            </div> --><!--				        </div> --><!--			        </div> --><!--			    </div> --><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.agence.timezone\" for=\"field_timezone\">timezone</label><ui-select ng-model=\"vm.agence.timezone\" theme=\"selectize\"><!--  title=\"{{\'wamasysApp.agence.timezone\' | translate}}\" --><ui-select-match placeholder=\"{{\'wamasysApp.agence.timezone\' | translate}}\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"item.id as item in vm.timezones | filter: $select.search \">{{item.label}}</ui-select-choices></ui-select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.agence.langue\" for=\"field_langue\">langue</label><select required class=\"form-control\" id=\"field_langue\" name=\"langue\" ng-model=\"vm.agence.langue\"><option value=\"en\">English</option><option value=\"fr\">Français</option><option value=\"fr_ci\">Français Côte d\'Ivoire</option></select><div ng-show=\"editForm.langue.$invalid\"><p class=\"help-block\" ng-show=\"editForm.langue.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.langue.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"4\">This field cannot be longer than 4 characters.</p></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.maxDailyIndividualMeterConsumption\" for=\"field_maxDailyIndividualMeterConsumption\">maxDailyIndividualMeterConsumption</label><input type=\"number\" class=\"form-control\" name=\"maxDailyIndividualMeterConsumption\" id=\"field_maxDailyIndividualMeterConsumption\" ng-model=\"vm.agence.maxDailyIndividualMeterConsumption\" max=\"999999999999\"><div ng-show=\"editForm.maxDailyIndividualMeterConsumption.$invalid\"><p class=\"help-block\" ng-show=\"editForm.maxDailyIndividualMeterConsumption.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999999999\">This field cannot be more than 999999999999.</p><p class=\"help-block\" ng-show=\"editForm.maxDailyIndividualMeterConsumption.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.maxDailyBulkMeterConsumption\" for=\"field_maxDailyBulkMeterConsumption\">maxDailyBulkMeterConsumption</label><input type=\"number\" class=\"form-control\" name=\"maxDailyBulkMeterConsumption\" id=\"field_maxDailyBulkMeterConsumption\" ng-model=\"vm.agence.maxDailyBulkMeterConsumption\" max=\"999999999999\"><div ng-show=\"editForm.maxDailyBulkMeterConsumption.$invalid\"><p class=\"help-block\" ng-show=\"editForm.maxDailyBulkMeterConsumption.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999999999\">This field cannot be more than 999999999999.</p><p class=\"help-block\" ng-show=\"editForm.maxDailyBulkMeterConsumption.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.dateDebutDemarrage\" for=\"field_dateDebutDemarrage\">dateDebutDemarrage</label><input id=\"field_dateDebutDemarrage\" type=\"text\" class=\"form-control\" name=\"dateDebutDemarrage\" value=\"{{vm.agence.dateDebutDemarrage | date:\'mediumDate\'}}\" readonly=\"readonly\"></div></div><div class=\"col-md-6\"><!--\r\n				        <div class=\"form-group\">\r\n				            <label class=\"control-label\" translate=\"wamasysApp.agence.redmineProjetId\" for=\"field_redmineProjetId\">redmineProjetId</label>\r\n				            <input type=\"text\" class=\"form-control\" name=\"redmineProjetId\" id=\"field_redmineProjetId\"\r\n				                    ng-model=\"vm.agence.redmineProjetId\"\r\n				                     ng-maxlength=\"255\" readlony/>\r\n				            <div ng-show=\"editForm.redmineProjetId.$invalid\">\r\n				                <p class=\"help-block\"\r\n				                    ng-show=\"editForm.redmineProjetId.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">\r\n				                    This field cannot be longer than 255 characters.\r\n				                </p>\r\n				            </div>\r\n				        </div>\r\n				          --><div class=\"form-group\"><label translate=\"wamasysApp.agence.entiteParente\" for=\"field_entiteParente\">entiteParente</label><input type=\"text\" class=\"form-control\" name=\"redmineProjetId\" id=\"field_entiteParente\" ng-model=\"vm.agence.entiteParente.nom\" readonly=\"readonly\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_contractAnonymizationEnabled\"><input type=\"checkbox\" name=\"contractAnonymizationEnabled\" id=\"field_contractAnonymizationEnabled\" ng-model=\"vm.agence.contractAnonymizationEnabled\"> <span translate=\"wamasysApp.agence.contractAnonymizationEnabled\">Activer l\'anonymisation des contrats fermés</span></label><p class=\"help-block\" translate=\"wamasysApp.agence.contractAnonymizationHelp\"></p></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.contractAnonymizationInactivityYears\" for=\"field_contractAnonymizationInactivityYears\">Durée d\'inactivité avant anonymisation (années)</label><input type=\"number\" class=\"form-control\" name=\"contractAnonymizationInactivityYears\" id=\"field_contractAnonymizationInactivityYears\" ng-model=\"vm.agence.contractAnonymizationInactivityYears\" min=\"1\" ng-required=\"vm.agence.contractAnonymizationEnabled\" ng-disabled=\"!vm.agence.contractAnonymizationEnabled\"><div ng-show=\"editForm.contractAnonymizationInactivityYears.$invalid\"><p class=\"help-block\" ng-show=\"editForm.contractAnonymizationInactivityYears.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.contractAnonymizationInactivityYears.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"1\">This field should be at least 1.</p><p class=\"help-block\" ng-show=\"editForm.contractAnonymizationInactivityYears.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.commentaire\" for=\"field_commentaire\">Commentaire</label><textarea class=\"form-control\" name=\"commentaire\" id=\"field_commentaire\" ng-model=\"vm.agence.commentaire\" rows=\"12\" ng-maxlength=\"2048\"></textarea><div ng-show=\"editForm.commentaire.$invalid\"><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"2048\">This field cannot be longer than 2048 characters.</p></div></div></div><div class=\"col-md-6\"><map-leaflet contrat=\"vm.agence\" has-module=\"GEO\" height=\"480px\" width=\"100%\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form></uib-tab-content></uib-tab><uib-tab has-module=\"CLIENT_PORTAL\"><uib-tab-heading><span translate=\"wamasysApp.agence.home.clientPortalConf\"></span></uib-tab-heading><uib-tab-content><form name=\"editAreaConfForm\" role=\"form\" novalidate ng-submit=\"vm.saveClientPortalConf()\" show-validation><br><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group smart-form\"><label class=\"toggle\"><input type=\"checkbox\" id=\"field_active\" name=\"active\" ng-model=\"vm.agence.clientPortalConf.active\" class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=\"false\"> <i data-swchon-text=\"ON\" data-swchoff-text=\"OFF\"></i> <span translate=\"wamasysApp.agence.clientPortalConf.active\">Active</span></label></div></div><!--				<div class=\"col-md-8\"> --><!--					Your URL will be https://my.wamasys.com/area/$area_code$/.<br/> --><!--					You can change the areaCode but please note before that your old link will unlink.<br/> --><!--				</div> --></div><div class=\"alert alert-warning area-template-shell__portal-note\" ng-show=\"vm.agence.clientPortalConf.active\">Pour activer l\'espace client, vous devez configurer le canal email et/ou le canal SMS dans la page Modèles > Messages espace client, puis renseigner le template correspondant.</div><hr ng-show=\"vm.agence.clientPortalConf.active\"><div class=\"row\" ng-show=\"vm.agence.clientPortalConf.active\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.clientPortalConf.areaName\" for=\"field_areaName\">areaName</label><input type=\"text\" class=\"form-control\" name=\"areaName\" id=\"field_areaName\" ng-model=\"vm.agence.clientPortalConf.areaName\" ng-maxlength=\"50\"><div ng-show=\"editAreaConfForm.areaName.$invalid\"><p class=\"help-block\" ng-show=\"editAreaConfForm.areaName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.clientPortalConf.pathUrl\" for=\"field_pathUrl\">pathUrl</label><input type=\"text\" class=\"form-control\" name=\"pathUrl\" id=\"field_pathUrl\" ng-model=\"vm.agence.clientPortalConf.pathUrl\" ng-maxlength=\"256\"><div ng-show=\"editAreaConfForm.pathUrl.$invalid\"><!--				                <p class=\"help-block\" --><!--				                    ng-show=\"editAreaConfForm.pathUrl.$error.required\" translate=\"entity.validation.required\"> --><!--				                    This field is required. --><!--				                </p> --><p class=\"help-block\" ng-show=\"editAreaConfForm.pathUrl.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.clientPortalConf.urlLogo\" for=\"field_urlLogo\">urlLogo</label><input type=\"text\" class=\"form-control\" name=\"urlLogo\" id=\"field_urlLogo\" ng-model=\"vm.agence.clientPortalConf.urlLogo\" ng-maxlength=\"256\"><div ng-show=\"editAreaConfForm.urlLogo.$invalid\"><p class=\"help-block\" ng-show=\"editAreaConfForm.urlLogo.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div></div></div><div class=\"row\" ng-if=\"vm.agence.clientPortalConf.active && vm.agence.clientPortalConf.clientPortalBaseUrl && vm.agence.clientPortalConf.pathUrl\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.clientPortalConf.portalUrl\">URL de l\'espace client</label><p class=\"form-control-static\"><!-- Réutilise la même adresse que le lien du portail affiché ci-dessous. --> <a class=\"btn btn-default\" ng-href=\"{{vm.agence.clientPortalConf.clientPortalBaseUrl + \'/area/\' + vm.agence.clientPortalConf.pathUrl}}\" target=\"_blank\" rel=\"noopener noreferrer\"><span class=\"glyphicon glyphicon-new-window\" aria-hidden=\"true\"></span> <span translate=\"wamasysApp.agence.clientPortalConf.openPortal\">Accéder à l\'espace client</span> </a><a ng-href=\"{{vm.agence.clientPortalConf.clientPortalBaseUrl + \'/area/\' + vm.agence.clientPortalConf.pathUrl}}\" target=\"_blank\" rel=\"noopener noreferrer\">{{vm.agence.clientPortalConf.clientPortalBaseUrl + \'/area/\' + vm.agence.clientPortalConf.pathUrl}} <span class=\"glyphicon glyphicon-new-window\"></span></a></p></div></div></div><div class=\"row\" ng-show=\"vm.agence.clientPortalConf.active\"><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.clientPortalConf.contactAddress\" for=\"field_contactAddress\">contactAddress</label><input type=\"text\" class=\"form-control\" name=\"contactAddress\" id=\"field_contactAddress\" ng-model=\"vm.agence.clientPortalConf.contactAddress\" ng-maxlength=\"256\"><div ng-show=\"editAreaConfForm.contactAddress.$invalid\"><p class=\"help-block\" ng-show=\"editAreaConfForm.contactAddress.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.clientPortalConf.contactEmail\" for=\"field_contactEmail\">contactEmail</label><input type=\"text\" class=\"form-control\" name=\"contactEmail\" id=\"field_contactEmail\" ng-model=\"vm.agence.clientPortalConf.contactEmail\" ng-maxlength=\"256\"><div ng-show=\"editAreaConfForm.contactEmail.$invalid\"><p class=\"help-block\" ng-show=\"editAreaConfForm.contactEmail.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.clientPortalConf.contactTel\" for=\"field_contactTel\">contactTel</label><input type=\"text\" class=\"form-control\" name=\"contactTel\" id=\"field_contactTel\" ng-model=\"vm.agence.clientPortalConf.contactTel\" ng-maxlength=\"256\"><div ng-show=\"editAreaConfForm.contactTel.$invalid\"><p class=\"help-block\" ng-show=\"editAreaConfForm.contactTel.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.clientPortalConf.contactWebsite\" for=\"field_contactWebsite\">contactWebsite</label><input type=\"text\" class=\"form-control\" name=\"contactWebsite\" id=\"field_contactWebsite\" ng-model=\"vm.agence.clientPortalConf.contactWebsite\" ng-maxlength=\"256\"><div ng-show=\"editAreaConfForm.contactWebsite.$invalid\"><p class=\"help-block\" ng-show=\"editAreaConfForm.contactWebsite.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div></div></div><div class=\"row\" ng-show=\"vm.agence.clientPortalConf.active\"><div class=\"col-md-3\"><div class=\"form-group smart-form\"><label class=\"toggle\"><input type=\"checkbox\" id=\"field_showInvoice\" name=\"showInvoice\" ng-model=\"vm.agence.clientPortalConf.showInvoice\" class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=\"false\"> <i data-swchon-text=\"ON\" data-swchoff-text=\"OFF\"></i> <span translate=\"wamasysApp.agence.clientPortalConf.showInvoice\">showInvoice</span></label></div></div><div class=\"col-md-3\"><div class=\"form-group smart-form\"><label class=\"toggle\"><input type=\"checkbox\" id=\"field_showReceipt\" name=\"showReceipt\" ng-model=\"vm.agence.clientPortalConf.showReceipt\" class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=\"false\"> <i data-swchon-text=\"ON\" data-swchoff-text=\"OFF\"></i> <span translate=\"wamasysApp.agence.clientPortalConf.showReceipt\">showReceipt</span></label></div></div><div class=\"col-md-3\"><div class=\"form-group smart-form\"><label class=\"toggle\"><input type=\"checkbox\" id=\"field_showFacebookNotification\" name=\"showFacebookNotification\" ng-model=\"vm.agence.clientPortalConf.showFacebookNotification\" class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=\"false\"> <i data-swchon-text=\"ON\" data-swchoff-text=\"OFF\"></i> <span translate=\"wamasysApp.agence.clientPortalConf.showFacebookNotification\">showFacebookNotification</span></label></div></div><br></div><div class=\"alert alert-info area-template-shell__portal-note\" ng-show=\"vm.agence.clientPortalConf.active\">Les templates sont maintenant séparés sur la page Modèles : la communication globale dépend du module Communication, et les messages espace client restent disponibles uniquement si le portail est activé.</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editAreaConfForm.$invalid || vm.isSavingAreaConfForm\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form></uib-tab-content></uib-tab><uib-tab has-module=\"ONLINE_PAYMENT\"><uib-tab-heading><span translate=\"wamasysApp.agence.home.onlinePaymentConf\"></span></uib-tab-heading><uib-tab-content><form name=\"editOnlinePaymentConfForm\" role=\"form\" ng-submit=\"vm.saveOnlinePaymentConf()\" show-validation><br><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group smart-form\"><label class=\"toggle\"><input type=\"checkbox\" id=\"field_active\" name=\"active\" ng-model=\"vm.agence.areaConfOnlinePayment.active\" class=\"ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=\"false\"> <i data-swchon-text=\"ON\" data-swchoff-text=\"OFF\"></i> <span translate=\"wamasysApp.agence.areaConfOnlinePayment.active\">Active</span></label></div></div><!--				<div class=\"col-md-8\"> --><!--					Your URL will be https://my.wamasys.com/area/$area_code$/.<br/> --><!--					You can change the areaCode but please note before that your old link will unlink.<br/> --><!--				</div> --></div><hr ng-show=\"vm.agence.areaConfOnlinePayment.active\"><div class=\"row\" ng-show=\"vm.agence.areaConfOnlinePayment.active\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.areaConfOnlinePayment.code\" for=\"field_code\">code</label><input type=\"text\" required class=\"form-control\" name=\"code\" id=\"field_code\" ng-pattern=\"/^[_.@a-z0-9-]*$/\" ng-model=\"vm.agence.areaConfOnlinePayment.code\" ng-maxlength=\"50\"><div ng-show=\"editOnlinePaymentConfForm.code.$invalid\"><p class=\"help-block\" ng-show=\"editOnlinePaymentConfForm.code.$error.pattern\" translate=\"wamasysApp.agence.areaConfOnlinePayment.patternCode\">The code can only contain lower-case letters and digits.</p><p class=\"help-block\" ng-show=\"editOnlinePaymentConfForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.agence.areaConfOnlinePayment.type\" for=\"field_type\">type</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.agence.areaConfOnlinePayment.type\" theme=\"selectize\" title=\"{{\'wamasysApp.agence.areaConfOnlinePayment.type\' | translate}}\"><ui-select-match placeholder=\"{{\'userManagement.agencesRattachement\' | translate}}\">{{$item.label}}</ui-select-match><ui-select-choices repeat=\"onlinePaymentType.code as onlinePaymentType  in vm.onlinePaymentTypes | filter: $select.search  track by onlinePaymentType.code\">{{onlinePaymentType.label}}</ui-select-choices></ui-select><div ng-show=\"editForm.type.$invalid\"><p class=\"help-block\" ng-show=\"editForm.type.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.type.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div></div></div><hr><div class=\"alert alert-warning\" translate=\"wamasysApp.agence.areaConfOnlinePayment.messageConf\" translate-compile translate-value-code=\"{{vm.agence.areaConfOnlinePayment.code}}\"></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editOnlinePaymentConfForm.$invalid || vm.isSavingOnlinePaymentConfForm\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form></uib-tab-content></uib-tab><uib-tab has-module=\"ELK\" select=\"vm.onGeometryTabSelect()\"><uib-tab-heading><span translate=\"wamasysApp.agence.geometry\"></span></uib-tab-heading><uib-tab-content><form name=\"editGeometryForm\" role=\"form\" ng-submit=\"vm.saveGeometryConf()\" show-validation><br><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-12\"><map-leaflet contrat=\"vm.agence\" geometry=\"vm.geometry\" geometry-editable=\"true\" refresh-token=\"vm.geometryMapRefreshToken\" has-module=\"GEO\" height=\"480px\" width=\"100%\"></map-leaflet></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.agence.geometry\" for=\"field_geometry\">geometry</label><textarea class=\"form-control\" name=\"geometry\" id=\"field_geometry\" ng-model=\"vm.geometry\" ng-maxlength=\"10240\" rows=\"12\">\n				                    </textarea><div ng-show=\"editGeometryForm.geometry.$invalid\"><p class=\"help-block\" ng-show=\"editGeometryForm.geometry.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"10240\">This field cannot be longer than 10240 characters.</p></div></div></div></div><div class=\"alert alert-warning\" translate=\"wamasysApp.agence.geometryHelp\" translate-compile></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editGeometryForm.$invalid || vm.isSavingEditGeometryForm\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form></uib-tab-content></uib-tab></uib-tabset>");
$templateCache.put("app/business/agence/agence-template-setup.html","<br><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.templateHtmlError\">{{vm.templateHtmlError}}</div><div class=\"area-template-shell\"><uib-tabset class=\"area-template-subtabs\"><uib-tab heading=\"{{ \'wamasysApp.agence.templates.invoicePdfTab\' | translate }}\"><uib-tab-content><form name=\"editDocumentTemplateForm\" role=\"form\" novalidate ng-submit=\"vm.saveTemplate()\" show-validation><div class=\"row area-template-layout\"><div class=\"col-md-5\"><div class=\"panel campaign-template-card area-template-card area-template-card--summary\"><div class=\"campaign-template-card__heading\"><div class=\"campaign-template-card__title\">Entête facture</div></div><div class=\"panel-body\"><p class=\"area-template-card__summary\">Conservez ici l\'entête commun affiché sur les factures PDF de la zone.</p><div class=\"form-group campaign-template-card__last-group\"><label class=\"control-label\" for=\"field_enteteFacture\">Entête facture</label><textarea class=\"form-control\" name=\"enteteFacture\" id=\"field_enteteFacture\" ng-model=\"vm.agenceTemplate.enteteFacture\" rows=\"6\" ng-maxlength=\"256\"></textarea></div><div class=\"area-template-card__toolbar area-template-card__toolbar--footer\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.previewInvoiceTemplate()\"><span class=\"glyphicon glyphicon-file\"></span> Tester le rendu facture</button></div><p class=\"help-block margin-bottom-0\">L\'aperçu génère une facture de démonstration avec 3 lignes, une remise et des taxes.</p></div></div></div><div class=\"col-md-7\"><div class=\"panel campaign-template-card area-template-card area-template-card--summary\"><div class=\"campaign-template-card__heading\"><div class=\"campaign-template-card__title\" translate=\"wamasysApp.agence.templates.billingNoticePdf.title\">Template ordre de recouvrement</div></div><div class=\"panel-body\"><p class=\"area-template-card__summary\" translate=\"wamasysApp.agence.templates.billingNoticePdf.summary\">Le préambule et la conclusion du PDF client d\'ordre de recouvrement se configurent ici. Le template smartphone reste dans son onglet dédié.</p><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_preambuleOrdreRecouvrement\" translate=\"wamasysApp.agence.preambuleOrdreRecouvrement\">Préambule</label><textarea class=\"form-control\" name=\"preambuleOrdreRecouvrement\" id=\"field_preambuleOrdreRecouvrement\" ng-model=\"vm.agenceTemplate.preambuleOrdreRecouvrement\" rows=\"7\" ng-maxlength=\"1024\"></textarea></div></div><div class=\"col-md-6\"><div class=\"form-group campaign-template-card__last-group\"><label class=\"control-label\" for=\"field_conclusionOrdreRecouvrement\" translate=\"wamasysApp.agence.conclusionOrdreRecouvrement\">Conclusion</label><textarea class=\"form-control\" name=\"conclusionOrdreRecouvrement\" id=\"field_conclusionOrdreRecouvrement\" ng-model=\"vm.agenceTemplate.conclusionOrdreRecouvrement\" rows=\"7\" ng-maxlength=\"1024\"></textarea></div></div></div><div class=\"row\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.previewBillingNoticePdfTemplate()\"><span class=\"glyphicon glyphicon-print\"></span> <span translate=\"wamasysApp.agence.templates.billingNoticePdf.testButton\">Tester l\'ordre de recouvrement</span></button></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editDocumentTemplateForm.$invalid || vm.isSavingTemplateForm\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form></uib-tab-content></uib-tab><uib-tab heading=\"{{ \'wamasysApp.agence.templates.receiptSmartphoneTab\' | translate }}\"><uib-tab-content><form name=\"editReceiptTemplateForm\" role=\"form\" novalidate ng-submit=\"vm.saveTemplate()\" show-validation><div class=\"row area-template-layout\"><div class=\"col-md-4\"><div class=\"panel campaign-template-card area-template-card area-template-card--summary\"><div class=\"campaign-template-card__heading\"><div class=\"campaign-template-card__title\" translate=\"wamasysApp.agence.templates.receiptSmartphone.title\">Reçu paiement smartphone</div></div><div class=\"panel-body\"><p class=\"area-template-card__summary\" translate=\"wamasysApp.agence.templates.receiptSmartphone.summary\">Le modèle de reçu reste isolé pour garder l\'écran lisible et faciliter les tests sur smartphone.</p><div class=\"area-template-card__toolbar area-template-card__toolbar--stacked\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.previewReceiptTemplate()\"><span class=\"glyphicon glyphicon-print\"></span> <span translate=\"wamasysApp.agence.templates.receiptSmartphone.testButton\">Tester le reçu</span></button></div><p class=\"help-block margin-bottom-0\" translate=\"wamasysApp.agence.templates.receiptSmartphone.help\">Le bouton de test ouvre un aperçu imprimable avec des données de démonstration.</p></div></div></div><div class=\"col-md-8\"><div class=\"panel campaign-template-card area-template-card\"><div class=\"campaign-template-card__heading\"><div class=\"campaign-template-card__title\" translate=\"wamasysApp.agence.templates.receiptSmartphone.editorTitle\">Template reçu paiement</div></div><div class=\"panel-body\"><div class=\"form-group campaign-template-card__last-group\"><label class=\"control-label\" for=\"field_receiptTemplate\" translate=\"wamasysApp.agence.templates.receiptSmartphone.editorLabel\">Template reçu</label><textarea class=\"form-control area-template-card__editor area-template-card__editor--ticket\" name=\"receiptTemplate\" id=\"field_receiptTemplate\" ng-model=\"vm.agenceTemplate.receiptTemplate\" rows=\"20\" ng-maxlength=\"4096\"></textarea></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editReceiptTemplateForm.$invalid || vm.isSavingTemplateForm\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form></uib-tab-content></uib-tab><uib-tab heading=\"{{ \'wamasysApp.agence.templates.billingNoticeSmartphoneTab\' | translate }}\"><uib-tab-content><form name=\"editBillingNoticeTemplateForm\" role=\"form\" novalidate ng-submit=\"vm.saveTemplate()\" show-validation><div class=\"row area-template-layout\"><div class=\"col-md-4\"><div class=\"panel campaign-template-card area-template-card area-template-card--summary\"><div class=\"campaign-template-card__heading\"><div class=\"campaign-template-card__title\">Ordre recouvrement smartphone</div></div><div class=\"panel-body\"><p class=\"area-template-card__summary\">Le bouton de test réutilise maintenant la même page d\'aperçu imprimable que le reçu paiement smartphone.</p><div class=\"area-template-card__toolbar area-template-card__toolbar--stacked\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.previewBillingNoticeTemplate()\"><span class=\"glyphicon glyphicon-print\"></span> <span translate=\"wamasysApp.agence.templates.billingNoticePdf.testButton\">Tester l\'ordre de recouvrement</span></button></div><p class=\"help-block margin-bottom-0\" translate=\"wamasysApp.agence.templates.billingNoticeSmartphone.help\">L\'aperçu reprend le même format de page que le reçu paiement smartphone pour tester plus vite le template.</p></div></div></div><div class=\"col-md-8\"><div class=\"panel campaign-template-card area-template-card\"><div class=\"campaign-template-card__heading\"><div class=\"campaign-template-card__title\" translate=\"wamasysApp.agence.templates.billingNoticeSmartphone.title\">Template ordre de recouvrement</div></div><div class=\"panel-body\"><div class=\"form-group campaign-template-card__last-group\"><label class=\"control-label\" for=\"field_billingNoticeTemplate\" translate=\"wamasysApp.agence.templates.billingNoticeSmartphone.editorLabel\">Template ordre de recouvrement</label><textarea class=\"form-control area-template-card__editor\" name=\"billingNoticeTemplate\" id=\"field_billingNoticeTemplate\" ng-model=\"vm.agenceTemplate.billingNoticeTemplate\" rows=\"16\" ng-maxlength=\"4096\"></textarea><p class=\"help-block margin-bottom-0\" translate=\"wamasysApp.agence.templates.billingNoticeSmartphone.editorHelp\">Ce template reste utilisé uniquement pour l\'ordre de recouvrement smartphone.</p></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editBillingNoticeTemplateForm.$invalid || vm.isSavingTemplateForm\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form></uib-tab-content></uib-tab><uib-tab heading=\"{{ \'wamasysApp.agence.templates.globalCommunicationTab\' | translate }}\" has-module=\"COMMUNICATION\"><uib-tab-content><form name=\"editGlobalCommunicationTemplateForm\" role=\"form\" novalidate ng-submit=\"vm.saveTemplate()\" show-validation><div class=\"row area-template-layout\"><div class=\"col-md-6\"><div class=\"panel campaign-template-card area-template-card\"><div class=\"campaign-template-card__heading\"><div class=\"campaign-template-card__title\" translate=\"wamasysApp.agence.templates.globalCommunication.title\">Habillage global</div></div><div class=\"panel-body\"><p class=\"area-template-card__summary\" translate=\"wamasysApp.agence.templates.globalCommunication.summary\">Ces modèles enveloppent les contenus envoyés par l\'espace client. Les canaux email et SMS sont configurés dans l\'onglet Messages espace client.</p><div class=\"form-group\"><label class=\"control-label\" for=\"field_communicationGlobalSmsTemplate\" translate=\"wamasysApp.agence.templates.globalCommunication.smsTemplate\">Template global SMS</label><textarea class=\"form-control\" name=\"communicationGlobalSmsTemplate\" id=\"field_communicationGlobalSmsTemplate\" ng-model=\"vm.agenceTemplate.communicationGlobalSmsTemplate\" rows=\"4\" ng-maxlength=\"4096\"></textarea><p class=\"help-block\"><span translate=\"wamasysApp.agence.templates.globalCommunication.smsHelpBefore\">Utilisez</span> <code>${messageContent}</code> <span translate=\"wamasysApp.agence.templates.globalCommunication.smsHelpAfter\">pour placer le contenu du SMS. Sans placeholder, il est ajouté automatiquement.</span></p></div><div class=\"form-group campaign-template-card__last-group\"><label class=\"control-label\" for=\"field_communicationGlobalEmailTemplateHtml\" translate=\"wamasysApp.agence.templates.globalCommunication.emailTemplate\">Enveloppe HTML globale email</label><textarea class=\"form-control area-template-card__editor\" name=\"communicationGlobalEmailTemplateHtml\" id=\"field_communicationGlobalEmailTemplateHtml\" ng-model=\"vm.agenceTemplate.communicationGlobalEmailTemplateHtml\" rows=\"12\"></textarea><p class=\"help-block\"><span translate=\"wamasysApp.agence.templates.globalCommunication.emailHelpBefore\">Utilisez</span> <code>${messageContent}</code> <span translate=\"wamasysApp.agence.templates.globalCommunication.emailHelpAfter\">pour injecter le contenu HTML du message dans l\'enveloppe globale.</span></p></div></div></div></div><div class=\"col-md-6\"><div class=\"panel campaign-template-card campaign-template-preview-card area-template-card\"><div class=\"campaign-template-card__heading\"><div class=\"campaign-template-card__title\" translate=\"wamasysApp.agence.templates.preview.title\">Aperçu final</div></div><div class=\"panel-body campaign-template-preview-card__body\"><p class=\"campaign-template-preview-card__hint text-muted\" translate=\"wamasysApp.agence.templates.globalCommunication.previewHint\">Le rendu ci-dessous prévisualise uniquement l\'habillage global avec un message de démonstration.</p><div class=\"campaign-template-preview-card__empty\" ng-if=\"!vm.globalCommunicationPreview.hasContent\" translate=\"wamasysApp.agence.templates.preview.empty\">Commencez à renseigner les templates pour afficher le rendu.</div><div class=\"campaign-template-preview-card__section\" ng-if=\"vm.globalCommunicationPreview.sms\"><div class=\"campaign-template-preview-card__label\" translate=\"wamasysApp.agence.templates.preview.smsFinal\">SMS final</div><pre class=\"campaign-template-preview-card__text\">{{vm.globalCommunicationPreview.sms}}</pre></div><div class=\"campaign-template-preview-card__section\" ng-if=\"vm.globalCommunicationPreview.html\"><div class=\"campaign-template-preview-card__label\" translate=\"wamasysApp.agence.templates.preview.emailHtmlFinal\">Email HTML final</div><div class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.globalCommunicationPreview.error\">{{vm.globalCommunicationPreview.error}}</div><div class=\"campaign-template-preview-card__html\" ng-if=\"!vm.globalCommunicationPreview.error\" ng-bind-html=\"vm.globalCommunicationPreview.trustedHtml\"></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editGlobalCommunicationTemplateForm.$invalid || vm.isSavingTemplateForm\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form></uib-tab-content></uib-tab><uib-tab heading=\"{{ \'wamasysApp.agence.templates.clientPortal.tab\' | translate }}\" ng-if=\"vm.agence.clientPortalConf && vm.agence.clientPortalConf.active\"><uib-tab-content><form name=\"editPortalMessageTemplateForm\" role=\"form\" novalidate ng-submit=\"vm.saveClientPortalConf()\" show-validation><div class=\"row area-template-layout\"><div class=\"col-md-6\"><div class=\"panel campaign-template-card area-template-card\"><div class=\"campaign-template-card__heading\"><div class=\"campaign-template-card__title\" translate=\"wamasysApp.agence.templates.clientPortal.title\">Message espace client</div><div class=\"campaign-template-card__actions\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"vm.canUseAssistant\" ng-click=\"vm.openClientPortalAssistantChat()\"><span class=\"glyphicon glyphicon-comment\"></span> <span translate=\"wamasysApp.agence.templates.clientPortal.assistantButton\">Assistant IA</span></button></div></div><div class=\"panel-body\"><p class=\"area-template-card__summary\" translate=\"wamasysApp.agence.templates.clientPortal.summary\">Définissez ici les canaux et le contenu métier spécifique à l\'espace client. Les habillages globaux restent dans l\'onglet voisin.</p><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.agence.clientPortalConf.emailChannelConf\">Canal email</label><ui-select ng-model=\"vm.agence.clientPortalConf.emailChannelConf\" theme=\"selectize\"><ui-select-match placeholder=\"{{ \'wamasysApp.agence.clientPortalConf.emailChannelConf\' | translate }}\">{{$select.selected.nom}} ({{$select.selected.channel}})</ui-select-match><ui-select-choices repeat=\"channelConf in vm.channelConfs | filter: vm.isEmailChannelConf | filter: $select.search track by channelConf.id\">{{channelConf.nom}} ({{channelConf.channel}})</ui-select-choices></ui-select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.agence.clientPortalConf.smsChannelConf\">Canal SMS</label><ui-select ng-model=\"vm.agence.clientPortalConf.smsChannelConf\" theme=\"selectize\"><ui-select-match placeholder=\"{{ \'wamasysApp.agence.clientPortalConf.smsChannelConf\' | translate }}\">{{$select.selected.nom}} ({{$select.selected.channel}})</ui-select-match><ui-select-choices repeat=\"channelConf in vm.channelConfs | filter: vm.isSmsChannelConf | filter: $select.search track by channelConf.id\">{{channelConf.nom}} ({{channelConf.channel}})</ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_templateSubject\" translate=\"wamasysApp.agence.clientPortalConf.templateSubject\">Sujet email</label><input type=\"text\" class=\"form-control\" name=\"templateSubject\" id=\"field_templateSubject\" ng-model=\"vm.agence.clientPortalConf.templateSubject\" ng-maxlength=\"255\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_templateSms\" translate=\"wamasysApp.agence.clientPortalConf.templateSms\">Modèle SMS</label><textarea class=\"form-control\" name=\"templateSms\" id=\"field_templateSms\" ng-model=\"vm.agence.clientPortalConf.templateSms\" rows=\"5\" ng-maxlength=\"4096\"></textarea></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_templateTxt\" translate=\"wamasysApp.agence.clientPortalConf.templateTxt\">Modèle email texte</label><textarea class=\"form-control\" name=\"templateTxt\" id=\"field_templateTxt\" ng-model=\"vm.agence.clientPortalConf.templateTxt\" rows=\"7\" ng-maxlength=\"4096\"></textarea></div></div><div class=\"col-md-6\"><div class=\"form-group campaign-template-card__last-group\"><label class=\"control-label\" for=\"field_templateHtml\" translate=\"wamasysApp.agence.clientPortalConf.templateHtml\">Modèle email HTML</label><textarea class=\"form-control area-template-card__editor\" name=\"templateHtml\" id=\"field_templateHtml\" ng-model=\"vm.agence.clientPortalConf.templateHtml\" rows=\"10\"></textarea></div></div></div></div></div></div><div class=\"col-md-6\"><div class=\"panel campaign-template-card campaign-template-preview-card area-template-card\"><div class=\"campaign-template-card__heading\"><div class=\"campaign-template-card__title\" translate=\"wamasysApp.agence.templates.preview.title\">Aperçu final</div></div><div class=\"panel-body campaign-template-preview-card__body\"><div class=\"campaign-template-card__heading\"><div class=\"campaign-template-card__title\" translate=\"wamasysApp.agence.templates.clientPortal.variablesTitle\">Variables du portail</div><div class=\"campaign-template-card__actions\"><button type=\"button\" class=\"btn btn-link btn-sm\" ng-click=\"vm.toggleClientPortalTemplateHelp()\"><span class=\"glyphicon\" ng-class=\"vm.showClientPortalTemplateHelp ? \'glyphicon-resize-small\' : \'glyphicon-resize-full\'\"></span> <span ng-if=\"vm.showClientPortalTemplateHelp\" translate=\"wamasysApp.agence.templates.clientPortal.reduce\">Réduire</span> <span ng-if=\"!vm.showClientPortalTemplateHelp\" translate=\"wamasysApp.agence.templates.clientPortal.expand\">Agrandir</span></button></div></div><!--                                <p class=\"area-template-card__summary\" translate=\"wamasysApp.agence.templates.clientPortal.variablesSummary\">Variables utilisables dans les SMS, le sujet, le texte et le HTML.</p> --><div class=\"well well-sm\" ng-show=\"vm.showClientPortalTemplateHelp\"><ul class=\"list-unstyled margin-bottom-0 area-template-variable-list\"><li ng-repeat=\"variable in vm.clientPortalTemplateVariableDetails track by variable.name\"><code>{{variable.name}}</code> : {{variable.description}}</li></ul></div><p class=\"campaign-template-preview-card__hint text-muted\" translate=\"wamasysApp.agence.templates.clientPortal.previewHint\">Le rendu final combine le message espace client et l\'habillage global.</p><div class=\"campaign-template-preview-card__empty\" ng-if=\"!vm.clientPortalMessagePreview.hasContent\" translate=\"wamasysApp.agence.templates.preview.empty\">Commencez à renseigner les templates pour afficher le rendu.</div><div class=\"campaign-template-preview-card__section\" ng-if=\"vm.clientPortalMessagePreview.sms\"><div class=\"campaign-template-preview-card__label\" translate=\"wamasysApp.agence.templates.preview.smsFinal\">SMS final</div><pre class=\"campaign-template-preview-card__text\">{{vm.clientPortalMessagePreview.sms}}</pre></div><div class=\"campaign-template-preview-card__section\" ng-if=\"vm.clientPortalMessagePreview.subject\"><div class=\"campaign-template-preview-card__label\" translate=\"wamasysApp.agence.templates.preview.subject\">Sujet</div><div class=\"campaign-template-preview-card__content\">{{vm.clientPortalMessagePreview.subject}}</div></div><div class=\"campaign-template-preview-card__section\" ng-if=\"vm.clientPortalMessagePreview.text\"><div class=\"campaign-template-preview-card__label\" translate=\"wamasysApp.agence.templates.preview.emailText\">Email texte</div><pre class=\"campaign-template-preview-card__text\">{{vm.clientPortalMessagePreview.text}}</pre></div><div class=\"campaign-template-preview-card__section\" ng-if=\"vm.clientPortalMessagePreview.html\"><div class=\"campaign-template-preview-card__label\" translate=\"wamasysApp.agence.templates.preview.emailHtmlFinal\">Email HTML final</div><div class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.clientPortalMessagePreview.error\">{{vm.clientPortalMessagePreview.error}}</div><div class=\"campaign-template-preview-card__html\" ng-if=\"!vm.clientPortalMessagePreview.error\" ng-bind-html=\"vm.clientPortalMessagePreview.trustedHtml\"></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editPortalMessageTemplateForm.$invalid || vm.isSavingAreaConfForm\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form></uib-tab-content></uib-tab></uib-tabset><div class=\"alert alert-info area-template-shell__portal-note\" ng-if=\"vm.agence.clientPortalConf && !vm.agence.clientPortalConf.active\">Activez d\'abord l\'espace client dans Paramétrage zone > Espace client pour configurer les messages espace client.</div></div>");
$templateCache.put("app/business/agence/agences.html","<div><h2 translate=\"wamasysApp.agence.home.title\">Agences</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"agence.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.agence.home.createLabel\">Create new Agence</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nom\"><span translate=\"wamasysApp.agence.nom\">Nom</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dateDebutDemarrage\"><span translate=\"wamasysApp.agence.dateDebutDemarrage\">dateDebutDemarrage</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"codeAgence\"><span translate=\"wamasysApp.agence.codeAgence\">CodeAgence</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"devise\"><span translate=\"wamasysApp.agence.devise\">Devise</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"timezone\"><span translate=\"wamasysApp.agence.timezone\">timezone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"langue\"><span translate=\"wamasysApp.agence.langue\">langue</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"entiteParente.id\"><span translate=\"wamasysApp.agence.entiteParente\">entiteParente</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"entiteParente.id\"><span translate=\"wamasysApp.agence.redmineProjetId\">redmineProjetId</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"agence in vm.agences track by agence.id\"><td><a ui-sref=\"agence-detail({id:agence.id})\">{{agence.id}}</a></td><td>{{agence.nom}}</td><td>{{agence.dateDebutDemarrage}}</td><td>{{agence.codeAgence}}</td><td>{{agence.devise}}</td><td>{{agence.timezone}}</td><td>{{agence.langue}}</td><td><a ui-sref=\"entite-parente-detail({id:agence.entiteParente.id})\">{{agence.entiteParente.nom}}</a></td><td>{{agence.redmineProjetId}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"agence-detail({id:agence.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"agence.edit({id:agence.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"agence.delete({id:agence.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/bulk-meter/bulk-meter-addcorrection-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myBulkMeterLabel\" translate=\"wamasysApp.bulkMeter.home.addCorrection\">add correction</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"alert alert-warning\"><span translate=\"wamasysApp.bulkMeter.messageCorrection\"></span></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.numeroSerie\" for=\"field_numeroSerie\">NumeroSerie</label><input readonly=\"readonly\" type=\"text\" class=\"form-control\" name=\"numeroSerie\" id=\"field_numeroSerie\" ng-model=\"vm.bulkMeter.numeroSerie\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.dateDebut\" for=\"field_dateDebut\">dateDebut</label><div class=\"input-group\"><input id=\"field_dateDebut\" type=\"text\" class=\"form-control\" name=\"dateDebut\" ng-click=\"vm.openCalendar(\'dateDebut\')\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.consommationEauBulkMeter.dateDebut\" is-open=\"vm.datePickerOpenStatus.dateDebut\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateDebut\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.dateDebut.$invalid\"><p class=\"help-block\" ng-show=\"editForm.dateDebut.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.dateFin\" for=\"field_dateFin\">dateFin</label><div class=\"input-group\"><input id=\"field_dateFin\" type=\"text\" class=\"form-control\" name=\"dateFin\" ng-click=\"vm.openCalendar(\'dateFin\')\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.consommationEauBulkMeter.dateFin\" is-open=\"vm.datePickerOpenStatus.dateFin\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateFin\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.dateFin.$invalid\"><p class=\"help-block\" ng-show=\"editForm.dateFin.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.mettreCubeConsomme\" for=\"field_mettreCubeConsomme\">mettreCubeConsomme</label><input type=\"number\" class=\"form-control\" name=\"mettreCubeConsomme\" id=\"field_mettreCubeConsomme\" ng-model=\"vm.consommationEauBulkMeter.mettreCubeConsomme\" required max=\"999999999999\"><div ng-show=\"editForm.mettreCubeConsomme.$invalid\"><p class=\"help-block\" ng-show=\"editForm.mettreCubeConsomme.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.mettreCubeConsomme.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999999999\">This field cannot be more than 999999999999.</p><p class=\"help-block\" ng-show=\"editForm.mettreCubeConsomme.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.commentaire\" for=\"field_commentaire\">commentaire</label><textarea class=\"form-control\" name=\"commentaire\" id=\"field_commentaire\" ng-model=\"vm.consommationEauBulkMeter.commentaire\" required></textarea><div ng-show=\"editForm.commentaire.$invalid\"><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/bulk-meter/bulk-meter-addreading-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myBulkMeterLabel\" translate=\"wamasysApp.bulkMeter.home.addReading\">add Reading</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"alert alert-warning\"><span translate=\"wamasysApp.bulkMeter.messageAddReading\"></span></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.numeroSerie\" for=\"field_numeroSerie\">NumeroSerie</label><input readonly=\"readonly\" type=\"text\" class=\"form-control\" name=\"numeroSerie\" id=\"field_numeroSerie\" ng-model=\"vm.bulkMeter.numeroSerie\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.datePrecedenteLecture\" for=\"field_datePrecedenteLecture\">datePrecedenteLecture</label><input readonly=\"readonly\" type=\"text\" class=\"form-control\" name=\"datePrecedenteLecture\" id=\"field_datePrecedenteLecture\" value=\"{{vm.bulkMeter.datePrecedenteLecture| date:\'medium\'}}\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.valeurPrecedenteLecture\" for=\"field_valeurPrecedenteLecture\">valeurPrecedenteLecture</label><input readonly=\"readonly\" type=\"text\" class=\"form-control\" name=\"numeroSerie\" id=\"field_valeurPrecedenteLecture\" ng-model=\"vm.bulkMeter.valeurPrecedenteLecture\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.readingDate\" for=\"field_readingDate\">readingDate</label><div class=\"input-group\"><!--        <input id=\"field_readingDate\" type=\"text\" class=\"form-control\" name=\"readingDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.readingBulkMeter.readingDate\" is-open=\"vm.datePickerOpenStatus.readingDate\"\n                    required/>\n                     --> <input id=\"field_readingDate\" type=\"text\" class=\"form-control\" name=\"readingDate\" ng-click=\"vm.openCalendar(\'readingDate\')\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.readingBulkMeter.readingDate\" is-open=\"vm.datePickerOpenStatus.readingDate\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'readingDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.readingDate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.readingDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.valeurReleve\" for=\"field_valeurReleve\">valeurReleve</label><input type=\"number\" class=\"form-control\" name=\"valeurReleve\" id=\"field_valeurReleve\" ng-model=\"vm.readingBulkMeter.valeurReleve\" required max=\"999999999999\"><div ng-show=\"editForm.valeurReleve.$invalid\"><p class=\"help-block\" ng-show=\"editForm.valeurReleve.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.valeurReleve.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999999999\">This field cannot be more than 999999999999.</p><p class=\"help-block\" ng-show=\"editForm.valeurReleve.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/bulk-meter/bulk-meter-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.bulkMeter.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.bulkMeter.delete.question\" translate-values=\"{id: \'{{vm.bulkMeter.id}}\'}\">Are you sure you want to delete this BulkMeter?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/bulk-meter/bulk-meter-detail.html","<div><button class=\"pull-right btn-xs btn-primary\" ui-sref=\"bulk-meter-detail.addcorrection({id:vm.bulkMeter.id})\" translate=\"wamasysApp.bulkMeter.actionAddCorrection\">add correction</button> <button class=\"pull-right btn-xs btn-primary\" ui-sref=\"bulk-meter-detail.addreading({id:vm.bulkMeter.id})\" translate=\"wamasysApp.bulkMeter.actionAddReading\">add reading</button><h2><span translate=\"wamasysApp.bulkMeter.detail.title\">BulkMeter</span> {{vm.bulkMeter.id}}</h2><hr><div class=\"row\"><div class=\"col-md-8\"><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.bulkMeter.numeroSerie\">NumeroSerie</span></dt><dd><span>{{vm.bulkMeter.numeroSerie}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.bulkMeter.waterNetwork\">waterNetwork</span></dt><dd><span>{{vm.bulkMeter.waterNetwork.label}}</span></dd><hr><dt><span translate=\"wamasysApp.bulkMeter.dateMiseEnService\">DateMiseEnService</span></dt><dd><span>{{vm.bulkMeter.dateMiseEnService | date:\'mediumDate\'}}</span></dd><hr><dt><span translate=\"wamasysApp.bulkMeter.valeurInitiale\">ValeurInitiale</span></dt><dd><span>{{vm.bulkMeter.valeurInitiale | number : 3}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.bulkMeter.datePrecedenteLecture\">DatePrecedenteLecture</span></dt><dd><span>{{vm.bulkMeter.datePrecedenteLecture | date:\'medium\'}}</span></dd><hr><dt><span translate=\"wamasysApp.bulkMeter.valeurPrecedenteLecture\">ValeurPrecedenteLecture</span></dt><dd><span>{{vm.bulkMeter.valeurPrecedenteLecture | number : 3}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.bulkMeter.etat\">Etat</span></dt><dd><span translate=\"{{\'wamasysApp.EtatMeter.\' + vm.bulkMeter.etat}}\">{{vm.bulkMeter.etat}}</span></dd><hr><div ng-show=\"vm.bulkMeter.etat == \'ARCHIVED\'\"><dt><span translate=\"wamasysApp.bulkMeter.dateSuppression\">DateSuppression</span></dt><dd><span>{{vm.bulkMeter.dateSuppression | date:\'medium\'}}</span></dd><hr></div><!-- \r\n        <dt><span translate=\"wamasysApp.bulkMeter.longitude\">Longitude</dt></dt>\r\n        <dd>\r\n            <span>{{vm.bulkMeter.longitude}}<span>\r\n        </dd>\r\n        <hr>\r\n        <dt><span translate=\"wamasysApp.bulkMeter.latitude\">Latitude</dt></dt>\r\n        <dd>\r\n            <span>{{vm.bulkMeter.latitude}}<span>\r\n        </dd>\r\n        <hr> --><dt><span translate=\"wamasysApp.bulkMeter.collecteur\">collecteur</span></dt><dd>{{vm.bulkMeter.collecteur.firstName + \' \' + vm.bulkMeter.collecteur.lastName}}</dd><hr><dt><span translate=\"wamasysApp.bulkMeter.modelMeter\">modelMeter</span></dt><dd><span>{{vm.bulkMeter.modelMeter.label}}</span></dd><hr><dt><span translate=\"wamasysApp.individualMeter.disableCheckMaxValue\">disableCheckMaxValue</span></dt><dd><span>{{vm.bulkMeter.disableCheckMaxValue}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.bulkMeter.commentaire\">Commentaire</span></dt><dd><span>{{vm.bulkMeter.commentaire }}</span></dd><hr has-module=\"IOT_WATER\"><dt has-module=\"IOT_WATER\"><span translate=\"wamasysApp.bulkMeter.isIOT\"></span></dt><dd has-module=\"IOT_WATER\"><input type=\"checkbox\" readonly=\"true\" disabled=\"disabled\" class=\"form-control\" name=\"isIOT\" id=\"field_isIOT\" ng-model=\"vm.bulkMeter.isIOT\"></dd><hr ng-show=\"vm.bulkMeter.isIOT\"><dt ng-show=\"vm.bulkMeter.isIOT\"><span translate=\"wamasysApp.bulkMeter.deveui\"></span></dt><dd ng-show=\"vm.bulkMeter.isIOT\"><span>{{vm.bulkMeter.deveui}}</span></dd><hr ng-show=\"vm.bulkMeter.isIOT\"><dt ng-show=\"vm.bulkMeter.isIOT\"><span translate=\"wamasysApp.bulkMeter.appeui\"></span></dt><dd ng-show=\"vm.bulkMeter.isIOT\"><span>{{vm.bulkMeter.appeui}}</span></dd><hr ng-show=\"vm.bulkMeter.isIOT\"><dt ng-show=\"vm.bulkMeter.isIOT\"><span translate=\"wamasysApp.bulkMeter.appkey\"></span></dt><dd ng-show=\"vm.bulkMeter.isIOT\"><span>{{vm.bulkMeter.appkey}}</span></dd><hr ng-show=\"vm.bulkMeter.isIOT\"><dt ng-show=\"vm.bulkMeter.isIOT\"><span translate=\"wamasysApp.bulkMeter.metersModel\"></span></dt><dd ng-show=\"vm.bulkMeter.isIOT\"><span>{{vm.bulkMeter.metersModel}}</span></dd><hr></dl></div><div class=\"col-md-4\" has-module=\"GEO\"><map-leaflet contrat=\"vm.mapMeter\" readonly=\"true\"></map-leaflet></div></div><br><div jarvis-widget id=\"hide-show-columns-table-widget\" data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"><header><span class=\"widget-icon\"><i class=\"fa fa-table\"></i></span><h2 translate=\"wamasysApp.bulkMeter.detail.readingListTitle\">Liste releve compteur</h2></header><div><div class=\"widget-body no-padding table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th translate=\"wamasysApp.collectionListe.dateFinPeriode\">Date releve</th><th translate=\"wamasysApp.collectionListe.etat\">Etat</th><th translate=\"wamasysApp.collectionListe.collecteur\">Collecteur</th><th translate=\"wamasysApp.bulkMeter.valeurReleve\">Valeur releve</th></tr></thead><tbody><tr ng-repeat=\"collectionList in vm.listeCollectionList\"><td ng-if=\"collectionList.releveCompteurEtat !=null \"><a ui-sref=\"releve-compteur-detail({id:collectionList.releveCompteurId})\">{{collectionList.readingDate | date:\'medium\'}} </a></td><td ng-if=\"collectionList.releveCompteurEtat ==null\">{{collectionList.readingDate | date:\'medium\'}}</td><td ng-if=\"collectionList.releveCompteurEtat !=null\" translate=\"{{\'wamasysApp.EtatCollectionList.\' +  collectionList.releveCompteurEtat}}\">{{collectionList.releveCompteurEtat}}</td><td ng-if=\"collectionList.releveCompteurEtat ==null \">Validated (Manually created)</td><td ng-if=\"collectionList.collecteur !=null\">{{collectionList.collecteur.firstName + \' \' + collectionList.collecteur.lastName}}</td><td ng-if=\"collectionList.collecteur ==null\">{{collectionList.createdBy}}</td><td>{{collectionList.valeurReleve | number : 3}}</td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div><!-- end widget content --></div><!-- end widget div --><hr><div jarvis-widget data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"><header><span class=\"widget-icon\"><i class=\"fa fa-table\"></i></span><h2 translate=\"wamasysApp.bulkMeter.detail.consumptionListTitle\">Liste consommation</h2></header><div><div class=\"widget-body no-padding table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th translate=\"wamasysApp.bulkMeter.dateDebut\">Date debut</th><th translate=\"wamasysApp.bulkMeter.dateFin\">Date fin</th><th translate=\"wamasysApp.bulkMeter.metreCubeConsomme\">Mètre cube consommé</th><th translate=\"wamasysApp.bulkMeter.lastModifiedDate\">lastModifiedDate</th><th translate=\"wamasysApp.bulkMeter.correction\">Est une correction</th></tr></thead><tbody><tr ng-repeat=\"consommationBulkMeter in vm.consommationBulkMeter\"><td>{{consommationBulkMeter.dateDebut | date:\'medium\'}}</td><td>{{consommationBulkMeter.dateFin | date:\'medium\'}}</td><td>{{consommationBulkMeter.mettreCubeConsomme | number : 3}}</td><td>{{consommationBulkMeter.lastModifiedDate | date:\'mediumDate\'}}</td><td ng-if=\"consommationBulkMeter.isCorrection\">{{consommationBulkMeter.isCorrection}} by {{consommationBulkMeter.createdBy}}<br>{{consommationBulkMeter.commentaire}}</td><td ng-if=\"! consommationBulkMeter.isCorrection\"></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.consoPage\" total=\"vm.queryCountConso\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItemsConso\" ng-model=\"vm.consoPage\" ng-change=\"vm.transition()\"></uib-pagination></div></div><!-- end widget content --></div><!-- end widget div --> <button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/bulk-meter/bulk-meter-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myBulkMeterLabel\" translate=\"wamasysApp.bulkMeter.home.createOrEditLabel\">Create or edit a BulkMeter</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.numeroSerie\" for=\"field_numeroSerie\">NumeroSerie</label><input required type=\"text\" class=\"form-control\" name=\"numeroSerie\" id=\"field_numeroSerie\" ng-model=\"vm.bulkMeter.numeroSerie\" ng-maxlength=\"50\"><div ng-show=\"editForm.numeroSerie.$invalid\"><p class=\"help-block\" ng-show=\"editForm.numeroSerie.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.numeroSerie.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.bulkMeter.waterNetwork\">waterNetwork</label><select required class=\"form-control\" id=\"field_waterNetwork\" name=\"waterNetwork\" ng-model=\"vm.bulkMeter.waterNetwork\" ng-options=\"waterNetwork as waterNetwork.label for waterNetwork in vm.waterNetworks track by waterNetwork.id\"><option value=\"\"></option></select><div ng-show=\"editForm.waterNetwork.$invalid\"><p class=\"help-block\" ng-show=\"editForm.waterNetwork.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.dateMiseEnService\" for=\"field_dateMiseEnService\">DateMiseEnService</label><div class=\"input-group\"><input id=\"field_dateMiseEnService\" type=\"text\" class=\"form-control\" name=\"dateMiseEnService\" ng-click=\"vm.openCalendar(\'dateMiseEnService\')\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.bulkMeter.dateMiseEnService\" is-open=\"vm.datePickerOpenStatus.dateMiseEnService\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateMiseEnService\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.dateMiseEnService.$invalid\"><p class=\"help-block\" ng-show=\"editForm.dateMiseEnService.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.valeurInitiale\" for=\"field_valeurInitiale\">ValeurInitiale</label><input type=\"number\" class=\"form-control\" name=\"valeurInitiale\" id=\"field_valeurInitiale\" ng-model=\"vm.bulkMeter.valeurInitiale\" required max=\"999999999999\"><div ng-show=\"editForm.valeurInitiale.$invalid\"><p class=\"help-block\" ng-show=\"editForm.valeurInitiale.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.valeurInitiale.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999999999\">This field cannot be more than 999999999999.</p><p class=\"help-block\" ng-show=\"editForm.valeurInitiale.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><!-- \n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"wamasysApp.bulkMeter.etat\" for=\"field_etat\">Etat</label>\n            <select class=\"form-control\" name=\"etat\" ng-model=\"vm.bulkMeter.etat\" id=\"field_etat\">\n                <option value=\"ACTIVE\" translate=\"wamasysApp.EtatMeter.ACTIVE\">ACTIVE</option>\n                <option value=\"AVAILABLE\" translate=\"wamasysApp.EtatMeter.AVAILABLE\">AVAILABLE</option>\n                <option value=\"ARCHIVED\" translate=\"wamasysApp.EtatMeter.ARCHIVED\">ARCHIVED</option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"wamasysApp.bulkMeter.dateSuppression\" for=\"field_dateSuppression\">DateSuppression</label>\n                <div class=\"input-group\">\n                    <input id=\"field_dateSuppression\" type=\"text\" class=\"form-control\" name=\"dateSuppression\" ng-click=\"vm.openCalendar(\'dateSuppression\')\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.bulkMeter.dateSuppression\" is-open=\"vm.datePickerOpenStatus.dateSuppression\"\n                      />\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateSuppression\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n                    </span>\n                </div>\n        </div>\n         --><!-- \n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"wamasysApp.bulkMeter.longitude\" for=\"field_longitude\">Longitude</label>\n            <input type=\"text\" class=\"form-control\" name=\"longitude\" id=\"field_longitude\"\n                    ng-model=\"vm.bulkMeter.longitude\"\n                    ng-maxlength=\"20\" />\n            <div ng-show=\"editForm.longitude.$invalid\">\n                <p class=\"help-block\"\n                    ng-show=\"editForm.longitude.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"20\">\n                    This field cannot be longer than 20 characters.\n                </p>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"wamasysApp.bulkMeter.latitude\" for=\"field_latitude\">Latitude</label>\n            <input type=\"text\" class=\"form-control\" name=\"latitude\" id=\"field_latitude\"\n                    ng-model=\"vm.bulkMeter.latitude\"\n                    ng-maxlength=\"20\" />\n            <div ng-show=\"editForm.latitude.$invalid\">\n                <p class=\"help-block\"\n                    ng-show=\"editForm.latitude.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"20\">\n                    This field cannot be longer than 20 characters.\n                </p>\n            </div>\n        </div>\n --><div class=\"form-group\"><label translate=\"wamasysApp.bulkMeter.collecteur\" for=\"field_collecteur\">collecteur</label><select required class=\"form-control\" id=\"field_collecteur\" name=\"collecteur\" ng-model=\"vm.bulkMeter.collecteur\" ng-options=\"user as (user.firstName + \' \' + user.lastName) for user in vm.users track by user.id\"><option value=\"\"></option></select><div ng-show=\"editForm.collecteur.$invalid\"><p class=\"help-block\" ng-show=\"editForm.collecteur.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.individualMeter.disableCheckMaxValue\" for=\"field_disableCheckMaxValue\">disableCheckMaxValue</label><input type=\"checkbox\" class=\"form-control\" name=\"disableCheckMaxValue\" id=\"field_disableCheckMaxValue\" ng-model=\"vm.bulkMeter.disableCheckMaxValue\"></div><div class=\"form-group\"><label translate=\"wamasysApp.bulkMeter.modelMeter\" for=\"field_modelMeter\">modelMeter</label><select class=\"form-control\" id=\"field_modelMeter\" name=\"modelMeter\" ng-model=\"vm.bulkMeter.modelMeter\" ng-options=\"modelMeter as modelMeter.label for modelMeter in vm.modelMeters track by modelMeter.id\"><option value=\"\"></option></select></div><div class=\"form-group\" has-module=\"IOT_WATER\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.isIOT\" for=\"field_isIOT\">isIOT</label><input type=\"checkbox\" class=\"form-control\" name=\"isIOT\" id=\"field_isIOT\" ng-model=\"vm.bulkMeter.isIOT\"></div><div class=\"form-group\" ng-if=\"vm.bulkMeter.isIOT\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.deveui\" for=\"field_deveui\">deveui</label><input required type=\"text\" class=\"form-control\" name=\"deveui\" id=\"field_deveui\" ng-model=\"vm.bulkMeter.deveui\" ng-maxlength=\"128\"><div ng-show=\"editForm.deveui.$invalid\"><p class=\"help-block\" ng-show=\"editForm.deveui.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.deveui.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"128\">This field cannot be longer than 128 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.bulkMeter.isIOT\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.appeui\" for=\"field_appeui\">appeui</label><input type=\"text\" class=\"form-control\" name=\"appeui\" id=\"field_appeui\" ng-model=\"vm.bulkMeter.appeui\" ng-maxlength=\"128\"><div ng-show=\"editForm.appeui.$invalid\"><p class=\"help-block\" ng-show=\"editForm.appeui.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"128\">This field cannot be longer than 128 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.bulkMeter.isIOT\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.appkey\" for=\"field_appkey\">appkey</label><input type=\"text\" class=\"form-control\" name=\"appkey\" id=\"field_appkey\" ng-model=\"vm.bulkMeter.appkey\" ng-maxlength=\"128\"><div ng-show=\"editForm.appkey.$invalid\"><p class=\"help-block\" ng-show=\"editForm.appkey.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"128\">This field cannot be longer than 128 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.bulkMeter.isIOT\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.metersModel\" for=\"field_metersModel\">metersModel</label><select class=\"form-control\" required name=\"metersModel\" ng-model=\"vm.bulkMeter.metersModel\" id=\"field_metersModel\"><option value=\"DIEHL_HRL_C_G3\">Lora Diehl HRL-C G3</option><option value=\"AXIOMA_QALCOSONIC_W1_V1\">Lora Axioma QALCOSONIC W1</option><option value=\"BOVETECH_BECOX_V1\">Lora BoveTech BECO X / B6 Lite VW</option><option value=\"TALKPOOL_OY1300_V1\">Lora Talkpool OY1300</option><option value=\"MBUS_DIEHL_IZAR_RC_I_R4\">M-BUS Diehl Izar RC-I-R4</option></select><div ng-show=\"editForm.metersModel.$invalid\"><p class=\"help-block\" ng-show=\"editForm.metersModel.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\" has-module=\"GEO\"><map-leaflet contrat=\"vm.mapMeter\"></map-leaflet></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.bulkMeter.commentaire\" for=\"field_commentaire\">Commentaire</label><textarea type=\"text\" class=\"form-control\" name=\"commentaire\" id=\"field_commentaire\" ng-model=\"vm.bulkMeter.commentaire\" ng-maxlength=\"256\"></textarea><div ng-show=\"editForm.commentaire.$invalid\"><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/bulk-meter/bulk-meters.html","<div><div class=\"container-fluid padding-top-10\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"compteur.bulk-meter.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.bulkMeter.home.createLabel\">Create new BulkMeter</span></button></div></div></div><div class=\"table-responsive padding-top-10\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"numeroSerie\"><span translate=\"wamasysApp.bulkMeter.numeroSerie\">NumeroSerie</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"etat\"><span translate=\"wamasysApp.bulkMeter.etat\">Etat</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"collecteur.login\"><span translate=\"wamasysApp.bulkMeter.collecteur\">collecteur</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"wamasysApp.bulkMeter.modelMeter\">modelMeter</span></th><th jh-sort-by=\"waterNetwork\"><span translate=\"wamasysApp.bulkMeter.waterNetwork\">waterNetwork</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"bulkMeter in vm.bulkMeters track by bulkMeter.id\"><td><a ui-sref=\"bulk-meter-detail({id:bulkMeter.id})\">{{bulkMeter.numeroSerie}}</a></td><td translate=\"{{\'wamasysApp.EtatMeter.\' + bulkMeter.etat}}\">{{bulkMeter.etat}}</td><td>{{bulkMeter.collecteur.firstName + \' \' + bulkMeter.collecteur.lastName}}</td><td>{{bulkMeter.modelMeter.label}}</td><td>{{bulkMeter.waterNetwork.label}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"bulk-meter-detail({id:bulkMeter.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"compteur.bulk-meter.edit({id:bulkMeter.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"compteur.bulk-meter.delete({id:bulkMeter.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/ai-costs/ai-costs.html","<div><h2>Coûts IA — USD</h2><jhi-alert></jhi-alert><p>Les plafonds mensuels sont exprimés en dollars américains. Les tokens restent mesurés à titre de diagnostic ; ils ne limitent plus l’accès à l’assistant.</p><div class=\"alert alert-success\" ng-if=\"vm.message\">{{vm.message}}</div><button class=\"btn btn-default\" ng-click=\"vm.load()\" ng-disabled=\"vm.loading || vm.saving\"><span class=\"glyphicon glyphicon-refresh\"></span> Actualiser</button><div class=\"alert alert-danger\" ng-if=\"vm.data.warnings.length\" style=\"margin-top:15px\"><strong>Attention : les coûts IA ne sont plus à jour.</strong><ul><li ng-repeat=\"warning in vm.data.warnings track by $index\">{{warning}}</li></ul><p>Les derniers tarifs connus restent utilisés. Les modèles sans tarif sont bloqués. Vérifiez les tarifs auprès du fournisseur puis confirmez-les ci-dessous.</p></div><h3>Plafonds par défaut et surveillance</h3><form name=\"settingsForm\" ng-submit=\"vm.saveSettings()\" novalidate><div class=\"row\"><div class=\"col-sm-3 form-group\"><label>Plafond utilisateur mensuel (USD)</label><input class=\"form-control\" type=\"number\" ng-model=\"vm.data.settings.defaultUserLimitUsd\" min=\"0\" step=\"0.01\" required></div><div class=\"col-sm-3 form-group\"><label>Plafond organisation mensuel (USD)</label><input class=\"form-control\" type=\"number\" ng-model=\"vm.data.settings.defaultOrganisationLimitUsd\" min=\"0\" step=\"0.01\" required></div><div class=\"col-sm-3 form-group\"><label>Marge de sécurité (%)</label><input class=\"form-control\" type=\"number\" ng-model=\"vm.data.settings.safetyMarginPercent\" min=\"0\" max=\"100\" step=\"0.01\" required></div><div class=\"col-sm-3 form-group\"><label>Alerte après combien de jours sans vérification ?</label><input class=\"form-control\" type=\"number\" ng-model=\"vm.data.settings.staleAfterDays\" min=\"1\" max=\"365\" step=\"1\" required></div></div><div class=\"form-group\"><label>Destinataires des alertes mail</label><input class=\"form-control\" type=\"text\" ng-model=\"vm.data.settings.alertRecipients\" maxlength=\"1000\" required><p class=\"help-block\">Séparez les adresses par une virgule ou un point-virgule. Contrôle automatique toutes les heures ; rappel au maximum une fois par jour pour un même problème après un envoi réussi.</p></div><p class=\"help-block\">Zéro signifie sans plafond. Les limites spécifiques se règlent dans les fiches utilisateur et organisation. Le plafond utilisateur spécifique prime sur le défaut de son organisation, puis sur le défaut global. La limite de l’organisation s’applique en plus.</p><p>Dernière alerte envoyée : {{(vm.data.settings.lastAlertAt | date:\'dd/MM/yyyy HH:mm\') || \'Aucune\'}}</p><button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"settingsForm.$invalid || vm.saving || vm.loading\">Enregistrer les paramètres</button></form><h3>Tarifs fournisseur par million de tokens (USD)</h3><p>Vérifiez les prix chaque mois. Enregistrer un tarif confirme sa vérification à la date du jour. Les dépenses passées conservent leurs tarifs d’origine.</p><button class=\"btn btn-default\" ng-click=\"vm.editPrice()\" ng-disabled=\"vm.saving\">Ajouter un modèle</button><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th>Fournisseur / modèle</th><th>Entrée USD</th><th>Entrée en cache USD</th><th>Sortie USD</th><th>Vérifié le / par</th><th>État</th><th></th></tr></thead><tbody><tr ng-repeat=\"price in vm.data.prices track by price.id\"><td>{{price.provider}} / {{price.model}}</td><td>{{price.inputUsdPerMillion == null ? \'—\' : (price.inputUsdPerMillion | number:6)}}</td><td>{{price.cachedInputUsdPerMillion == null ? \'—\' : (price.cachedInputUsdPerMillion | number:6)}}</td><td>{{price.outputUsdPerMillion == null ? \'—\' : (price.outputUsdPerMillion | number:6)}}</td><td>{{price.verifiedOn || \'Jamais\'}}<br>{{price.verifiedBy}}</td><td>{{vm.priceStatus(price)}}</td><td><button class=\"btn btn-default btn-sm\" ng-click=\"vm.editPrice(price)\" ng-disabled=\"vm.saving\">Vérifier / modifier</button></td></tr></tbody></table></div><form name=\"priceForm\" ng-if=\"vm.price\" ng-submit=\"vm.savePrice()\" class=\"well\" novalidate><h4>Tarif vérifié</h4><div class=\"row\"><div class=\"col-sm-3 form-group\"><label>Fournisseur</label><select class=\"form-control\" ng-model=\"vm.price.provider\" ng-disabled=\"vm.price.id\" required><option value=\"openai\">OpenAI</option><option value=\"gemini\">Gemini</option><option value=\"ollama\">Ollama local</option></select></div><div class=\"col-sm-6 form-group\"><label>Identifiant exact du modèle</label><input class=\"form-control\" ng-model=\"vm.price.model\" ng-disabled=\"vm.price.id\" maxlength=\"150\" required></div><div class=\"col-sm-3 checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.price.enabled\"> Autoriser ce modèle</label></div></div><div class=\"row\"><div class=\"col-sm-4 form-group\"><label>Entrée (USD / million)</label><input class=\"form-control\" type=\"number\" ng-model=\"vm.price.inputUsdPerMillion\" min=\"0\" step=\"0.00000001\" required></div><div class=\"col-sm-4 form-group\"><label>Entrée en cache (USD / million)</label><input class=\"form-control\" type=\"number\" ng-model=\"vm.price.cachedInputUsdPerMillion\" min=\"0\" step=\"0.00000001\" required></div><div class=\"col-sm-4 form-group\"><label>Sortie (USD / million)</label><input class=\"form-control\" type=\"number\" ng-model=\"vm.price.outputUsdPerMillion\" min=\"0\" step=\"0.00000001\" required></div></div><div class=\"form-group\"><label>Source des tarifs vérifiés (lien ou référence)</label><input class=\"form-control\" ng-model=\"vm.price.sourceUrl\" maxlength=\"1000\" required></div><button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"priceForm.$invalid || vm.saving\">Enregistrer et confirmer les tarifs vérifiés aujourd’hui</button> <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.price = null\">Annuler</button></form><h3>Derniers appels et montants réservés</h3><p>Le coût estimé correspond aux tokens mesurés. Le montant décompté du budget inclut la marge de sécurité. Les appels en cours et les coûts incertains conservent leur réservation. Une réservation de plus de deux heures peut être régularisée après vérification auprès du fournisseur. Les anciennes consommations de tokens ne sont pas converties rétroactivement en dollars.</p><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th>Date</th><th>Organisation / utilisateur</th><th>Fournisseur / modèle</th><th>État</th><th>Coût estimé USD</th><th>Budget décompté USD</th><th>Tarif vérifié le</th><th></th></tr></thead><tbody><tr ng-repeat=\"usage in vm.data.recentUsage track by usage.id\"><td>{{usage.createdAt | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{usage.organisationName}} / {{usage.userLogin}}</td><td>{{usage.provider}} / {{usage.model}}</td><td>{{vm.usageStatus(usage.status)}}<br><small>{{usage.resolutionNote}}</small></td><td>{{usage.estimatedCostUsd == null ? \'—\' : (usage.estimatedCostUsd | number:8)}}</td><td>{{usage.budgetCostUsd | number:8}}</td><td>{{usage.priceVerifiedOn}}</td><td><button class=\"btn btn-default btn-sm\" ng-if=\"vm.canResolve(usage)\" ng-click=\"vm.resolveUsage(usage)\">Régulariser</button></td></tr></tbody></table></div><form name=\"resolutionForm\" ng-if=\"vm.resolution\" ng-submit=\"vm.saveResolution()\" class=\"well\" novalidate><h4>Régulariser l’appel {{vm.resolution.id}}</h4><div class=\"form-group\"><label>Coût estimé confirmé auprès du fournisseur (USD, sans marge)</label><input class=\"form-control\" type=\"number\" ng-model=\"vm.resolution.costUsd\" min=\"0\" step=\"0.00000001\" required></div><div class=\"form-group\"><label>Motif et référence du contrôle</label><textarea class=\"form-control\" ng-model=\"vm.resolution.note\" minlength=\"5\" maxlength=\"900\" required></textarea></div><button class=\"btn btn-primary\" ng-disabled=\"resolutionForm.$invalid || vm.saving\" type=\"submit\">Enregistrer la régularisation</button><button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.resolution = null\">Annuler</button></form></div>");
$templateCache.put("app/business/collection-liste/collection-liste-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.collectionListe.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"wamasysApp.collectionListe.delete.title\">Confirm voided operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.collectionListe.delete.question\" translate-values=\"{id: \'{{vm.collectionListe.id}}\'}\">Are you sure you want to delete this CollectionListe?</p><div class=\"alert alert-warning\" ng-if=\"vm.collectionListe.etat == \'ENCOURS\'\"><strong translate=\"wamasysApp.collectionListe.delete.smartphonePaymentWarningTitle\">Attention :</strong> <span translate=\"wamasysApp.collectionListe.delete.smartphonePaymentWarning\">les paiements enregistrés dans le smartphone ne seront pas annulés.</span></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.collectionListe.confirmDelete\" for=\"field_referenceCollectionList\">DateFinPeriode</label><input id=\"field_dateFinPeriode\" type=\"text\" class=\"form-control\" name=\"referenceCollectionList\" ng-model=\"vm.confirmReferenceCollectionList\" required><div ng-show=\"deleteForm.referenceCollectionList.$invalid\"><p class=\"help-block\" ng-show=\"editForm.dateFinPeriode.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.void\">Voided</span></button></div></form>");
$templateCache.put("app/business/collection-liste/collection-liste-detail.html","<div><h2><span translate=\"wamasysApp.collectionListe.detail.title\">CollectionListe</span> {{vm.collectionListe.referenceCollectionList}}</h2><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><smartphone-handoffs document-type=\"CL\" document-id=\"vm.collectionListe.id\" document=\"vm.collectionListe\" on-updated=\"vm.load(vm.collectionListe.id)\" on-status=\"vm.handoffReceived = received\"></smartphone-handoffs><div class=\"alert alert-warning\" ng-if=\"vm.collectionListe.etat == \'ENCOURS\' && !vm.handoffReceived\"><strong translate=\"wamasysApp.collectionListe.detail.inProgressWarningTitle\">Attention :</strong> <span translate=\"wamasysApp.collectionListe.detail.inProgressWarning\">Cette collecte est encore en cours. Elle n\'est pas encore validée, toutes les données ne sont pas encore disponibles et il faut attendre le transfert des données depuis le smartphone.</span></div><div class=\"row dl-horizontal\"><div class=\"col-md-3\"><dt><span class=\"pull-left\" translate=\"wamasysApp.collectionListe.dateFinPeriode\">DateFinPeriode</span></dt><dd><span>{{vm.collectionListe.dateFinPeriode | date:\'mediumDate\'}}</span></dd></div><div class=\"col-md-3\"><dt><span class=\"pull-left\" translate=\"wamasysApp.collectionListe.totalPreviousArrears\">totalPreviousArrears</span></dt><dd><span>{{ - vm.totalPreviousArrears | number:2}}</span></dd></div><div class=\"col-md-3\"><dt><span class=\"pull-left\" translate=\"wamasysApp.collectionListe.totalCollecte\">totalCollecte</span></dt><dd><span>{{ vm.totalMontantCollecte | number:2}}</span></dd></div><div class=\"col-md-3\"></div></div><div class=\"row dl-horizontal\"><div class=\"col-md-3\"><dt><span class=\"pull-left\" translate=\"wamasysApp.collectionListe.collecteur\">Collecteur</span></dt><dd>{{vm.collectionListe.collecteur.firstName + \' \' + vm.collectionListe.collecteur.lastName}}</dd></div><div class=\"col-md-3\"><dt><span class=\"pull-left\" translate=\"wamasysApp.collectionListe.totalACollecterSansMoneyBox\">totalACollecterSansMoneyBox</span></dt><dd>{{ vm.totalMontantACollecterSansMoneyBox | number:2}}</dd></div><div class=\"col-md-3\"><dt><span class=\"pull-left\" translate=\"wamasysApp.collectionListe.totalMontantCollecteAvecCorrection\">totalMontantCollecteAvecCorrection</span></dt><dd><span>{{ vm.totalMontantCollecteAvecCorrection | number:2}}</span></dd></div><div class=\"col-md-3\"><dt><span class=\"pull-left\" translate=\"wamasysApp.collectionListe.totalCollectionRateBilled\">totalCollectionRateBilled</span></dt><dd><span>{{ vm.totalCollectionRateBilled | number:0}}%</span></dd></div></div><div class=\"row dl-horizontal\"><div class=\"col-md-3\"><dt><span class=\"pull-left\" translate=\"wamasysApp.collectionListe.etat\">Etat</span></dt><dd><span class=\"pull-left\" translate=\"{{\'wamasysApp.EtatCollectionList.\' + vm.collectionListe.etat}}\">{{vm.collectionListe.etat}}</span></dd></div><div class=\"col-md-3\"><dt><span class=\"pull-left\" translate=\"wamasysApp.collectionListe.totalACollecter\">totalACollecter</span></dt><dd><span>{{ vm.totalMontantACollecter | number:2}}</span></dd></div><div class=\"col-md-3\"><dt><span class=\"pull-left\" translate=\"wamasysApp.collectionListe.totalNonCollecte\">totalNonCollecte</span></dt><dd><span class=\"pull-left\">{{ vm.totalMontantNonCollecte | number:2}}</span></dd></div><div class=\"col-md-3\"><dt><span class=\"pull-left\" translate=\"wamasysApp.collectionListe.totalCollectionRateGlobal\">totalCollectionRateGlobal</span></dt><dd><span>{{ vm.totalCollectionRateGlobal | number:0}}%</span></dd></div></div><div ng-if=\"vm.errorValidation\" class=\"alert alert-warning alert-dismissible\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</button><ul><span ng-bind-html=\"vm.messageError\"></span></ul></div><div class=\"padding-10 row\"><div class=\"pull-right\"><button has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" ng-disabled=\"vm.disableBtnEdition\" ng-show=\"vm.collectionListe.etat == \'AVALIDER\'\" class=\"btn btn-primary\" ng-click=\"vm.valider()\"><span translate=\"wamasysApp.collectionListe.detail.valider\">Valider le relevé</span></button> <button has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" id=\"btnEditRows\" ng-disabled=\"vm.disableBtnEdition\" ng-click=\"vm.startEdit()\" ng-show=\"vm.collectionListe.etat == \'ACOLLECTER\' || vm.collectionListe.etat == \'AVALIDER\' \" class=\"btn btn-primary\"><span translate=\"wamasysApp.collectionListe.detail.modifier\">Modifier le relevé</span></button> <button has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" ng-disabled=\"vm.disableBtnEdition\" ng-show=\"vm.collectionListe.etat == \'ACOLLECTER\' || vm.collectionListe.etat == \'AVALIDER\' \" class=\"btn btn-primary\" ui-sref=\"collection-liste.delete({id:vm.collectionListe.id})\"><span translate=\"wamasysApp.collectionListe.detail.annuler\">Annuler le relevé</span></button> <a ng-show=\"vm.collectionListe.etat == \'ACOLLECTER\' || vm.collectionListe.etat == \'AVALIDER\' \" ng-disabled=\"vm.disableBtnEdition\" class=\"btn btn-primary\" ng-click=\"vm.print()\"><span translate=\"wamasysApp.collectionListe.detail.imprimer\">Imprimer feuille de collecte </span></a><a class=\"btn btn-default\" ng-href=\"{{vm.getMapUrl(vm.collectionListe.id)}}\" has-module=\"NEW_FEATURES_VISIBILITY\"><span class=\"fa fa-map-marker\"></span> <span translate=\"wamasysApp.collectionListe.detail.showMap\">Voir la carte</span> </a><!-- Etat possible ACOLLECTER AVALIDER VALIDE \"ANNULE --></div></div><!-- Widget ID (each widget will need unique ID)--><div id=\"full-screen-widget\" data-widget-colorbutton=\"false\" data-widget-editbutton=\"false\" data-widget-togglebutton=\"false\" data-widget-deletebutton=\"false\" data-widget-color=\"blue\" data-jarvis-widget><header><span class=\"widget-icon\"><i class=\"fa fa-table\"></i></span><h2 translate=\"wamasysApp.collectionListe.listeCollecte\">Liste collecte</h2></header><!-- widget div--><div><!-- widget content --><div class=\"widget-body no-padding\"><div class=\"row\"><article class=\"col-sm-12\"><input type=\"button\" has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" id=\"btnSaveRows\" class=\"btn btn-primary\" style=\"display:none\" value=\"{{\'wamasysApp.collectionListe.detail.sauvegarder\' | translate}}\" ng-click=\"vm.saveRows()\"> <input type=\"button\" has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" id=\"btnCancelRows\" class=\"btn btn-primary\" style=\"display:none\" value=\"{{\'wamasysApp.collectionListe.detail.annuler\' | translate}}\" ng-click=\"vm.cancelEditRows()\"><br><jq-grid-collection-list grid-data=\"gridData\" collection-list=\"vm.collectionListe\"></jq-grid-collection-list></article></div></div></div></div><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/collection-liste/collection-liste-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCollectionListeLabel\" translate=\"wamasysApp.collectionListe.home.createOrEditLabel\">Create or edit a CollectionListe</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.collectionListe.dateFinPeriode\" for=\"field_dateFinPeriode\">DateFinPeriode</label><div class=\"input-group\"><input id=\"field_dateFinPeriode\" type=\"text\" class=\"form-control\" name=\"dateFinPeriode\" ng-click=\"vm.openCalendar(\'dateFinPeriode\')\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.collectionListe.dateFinPeriode\" is-open=\"vm.datePickerOpenStatus.dateFinPeriode\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateFinPeriode\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.dateFinPeriode.$invalid\"><p class=\"help-block\" ng-show=\"editForm.dateFinPeriode.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><!-- \n        <div class=\"form-group\" ng-if=\"vm.isEauEtVie == true\">\n        \n								<label class=\"toggle\"> <input type=\"checkbox\"\n									id=\"field_genererFacturation\" name=\"genererFacturation\"\n									ng-model=\"vm.collectionListe.genererFacturation\"> <i\n									data-swchon-text=\"ON\" data-swchoff-text=\"OFF\"></i> <span\n									translate=\"wamasysApp.collectionListe.genererFacturation\">genererFacturation</span>\n								</label>\n						\n	\n            <div ng-show=\"editForm.genererFacturation.$invalid\">\n                <p class=\"help-block\"\n                    ng-show=\"editForm.genererFacturation.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n            </div>\n        </div> \n        <input type=\"hidden\" ng-if=\"! vm.isEauEtVie || vm.isEauEtVie == false\"\n									id=\"field_genererFacturation_hidden\" name=\"genererFacturation\"\n									ng-model=\" vm.collectionListe.genererFacturation\" value=\"false\">\n			--><div class=\"form-group\"><label translate=\"wamasysApp.collectionListe.collecteur\" for=\"field_collecteur\">collecteur</label><select ng-change=\"vm.updateListePortefeuille()\" class=\"form-control\" id=\"field_collecteur\" name=\"collecteur\" ng-model=\"vm.collectionListe.collecteur\" ng-options=\"user as (user.firstName + \' \' + user.lastName) for user in vm.users track by user.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.collectionListe.portefeuilleContrat\" for=\"field_listPortefeuilleContratDTO\">Portefeuille Contrat</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.collectionListe.listPortefeuilleContratDTO\" theme=\"selectize\" title=\"{{\'wamasysApp.collectionListe.portefeuilleContrat\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.collectionListe.portefeuilleContrat\' | translate}}\">{{$item.libelle}}</ui-select-match><ui-select-choices repeat=\"portefeuilleContrat in vm.listPortefeuilleContrat | filter: $select.search  track by portefeuilleContrat.id\">{{portefeuilleContrat.libelle}}</ui-select-choices></ui-select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/collection-liste/collection-liste-map.html","<div><h2><span translate=\"wamasysApp.collectionListe.map.title\">Carte de collecte</span> <small ng-if=\"vm.collectionListe.referenceCollectionList\">- {{vm.collectionListe.referenceCollectionList}}</small></h2><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><div class=\"row margin-bottom-10\"><div class=\"col-md-12\"><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"vm.showPayments\" ng-change=\"vm.updateVisibility()\"> <span translate=\"wamasysApp.collectionListe.map.showPayment\">Paiements</span></label><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"vm.showContracts\" ng-change=\"vm.updateVisibility()\"> <span translate=\"wamasysApp.collectionListe.map.showContract\">Contrats associes</span></label></div></div><journey-map points=\"vm.mapPoints\" active-point-key=\"vm.activePointKey\" refresh-token=\"vm.mapRefreshToken\" fit-bounds-token=\"vm.mapFitBoundsToken\" show-route=\"false\" geometry=\"vm.areaGeometry\" height=\"460px\"></journey-map><div class=\"alert alert-info margin-top-10\" ng-if=\"!vm.mapPoints.length\" translate=\"wamasysApp.collectionListe.map.empty\">Aucun point GPS disponible pour cette collecte.</div><div class=\"table-responsive margin-top-10\" ng-if=\"vm.filteredRows.length\"><table class=\"table table-striped table-bordered\"><thead><tr><th translate=\"wamasysApp.collectionListe.map.time\">Heure</th><th translate=\"wamasysApp.collectionListe.map.contract\">Contrat</th><th translate=\"wamasysApp.collectionListe.map.customer\">Client</th><th translate=\"wamasysApp.collectionListe.map.amount\">Montant paye</th><th translate=\"wamasysApp.collectionListe.map.paymentGps\">GPS paiement</th><th translate=\"wamasysApp.collectionListe.map.contractGps\">GPS contrat</th><th translate=\"wamasysApp.collectionListe.map.actions\">Carte</th></tr></thead><tbody><tr ng-repeat=\"row in vm.filteredRows track by row.id\"><td>{{row.paymentDateLabel}}</td><td><a ng-if=\"row.contractId\" ng-href=\"#/contrat/{{row.contractId}}/dataanalyse\" target=\"_blank\">{{row.contractReference}}</a> <span ng-if=\"!row.contractId\">{{row.contractReference}}</span></td><td>{{row.customerName}}</td><td>{{row.amountLabel}}</td><td>{{row.paymentGpsLabel}}</td><td>{{row.contractGpsLabel}}</td><td style=\"min-width: 160px\"><div class=\"btn-group btn-group-xs\"><button type=\"button\" class=\"btn btn-default\" ng-if=\"vm.showPaymentPopupAction(row)\" ng-click=\"vm.openPaymentPopup(row)\" translate=\"wamasysApp.collectionListe.map.openPaymentPopup\">Paiement</button> <button type=\"button\" class=\"btn btn-default\" ng-if=\"vm.showContractPopupAction(row)\" ng-click=\"vm.openContractPopup(row)\" translate=\"wamasysApp.collectionListe.map.openContractPopup\">Contrat</button></div></td></tr></tbody></table></div><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\">Back</span></button></div>");
$templateCache.put("app/business/collection-liste/collection-listes.html","<div class=\"app-entity-shell\"><div class=\"app-entity-header\"><h2 class=\"app-entity-title\" translate=\"wamasysApp.collectionListe.home.title\">CollectionListes</h2><div class=\"app-entity-actions\"><button class=\"btn btn-primary\" ui-sref=\"collection-liste.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.collectionListe.home.createLabel\">Create new CollectionListe</span></button></div></div><jhi-alert-error></jhi-alert-error><div class=\"app-filter-panel\"><form name=\"searchForm\" class=\"smart-form\" novalidate><div class=\"app-filter-grid\"><div class=\"app-filter-field\"><label class=\"app-filter-label\" translate=\"wamasysApp.collectionListe.etat\" for=\"field_etat\">Etat</label><select class=\"form-control\" name=\"etat\" ng-model=\"vm.etat\" id=\"field_etat\"><option value=\"\"></option><option value=\"ACOLLECTER\" translate=\"wamasysApp.EtatCollectionList.ACOLLECTER\">ACOLLECTER</option><option value=\"AVALIDER\" translate=\"wamasysApp.EtatCollectionList.AVALIDER\">AVALIDER</option><option value=\"ENCOURS\" translate=\"wamasysApp.EtatCollectionList.ENCOURS\">ENCOURS</option><option value=\"VALIDE\" translate=\"wamasysApp.EtatCollectionList.VALIDE\">VALIDE</option><option value=\"ANNULE\" translate=\"wamasysApp.EtatCollectionList.ANNULE\">ANNULE</option></select></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" translate=\"wamasysApp.collectionListe.collecteur\" for=\"field_collecteur\">Collecteur</label><select class=\"form-control\" id=\"field_collecteur\" name=\"collecteur\" ng-model=\"vm.collecteur\" ng-options=\"collecteur as (collecteur.firstName + \' \' + collecteur.lastName) for collecteur in vm.collecteurs track by collecteur.id\"><option value=\"\"></option></select></div><div class=\"app-filter-field app-filter-field--wide\"><label class=\"app-filter-label\" for=\"daterange1\" translate=\"wamasysApp.collectionListe.dateFinPeriode\">Date fin p&eacute;riode</label><input date-range-picker id=\"daterange1\" name=\"daterange1\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" options=\"vm.opts\" placeholder=\"yyyy-mm-dd - yyyy-mm-dd\"></div></div><div class=\"app-filter-actions\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.clear()\" translate=\"entity.action.reset\">reset</button> <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"vm.search()\" translate=\"entity.action.chercher\">search</button></div></form></div><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"referenceCollectionList\"><span translate=\"global.field.id\">Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dateFinPeriode\"><span translate=\"wamasysApp.collectionListe.dateFinPeriode\">DateFinPeriode</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"etat\"><span translate=\"wamasysApp.collectionListe.etat\">Etat</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"collecteur.id\"><span translate=\"wamasysApp.collectionListe.collecteur\">Collecteur</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"collectionListe in vm.collectionListes track by collectionListe.id\"><td><a ui-sref=\"collection-liste-detail({id:collectionListe.id})\">{{collectionListe.referenceCollectionList}}</a></td><td>{{collectionListe.dateFinPeriode | date:\'mediumDate\'}}</td><td translate=\"{{\'wamasysApp.EtatCollectionList.\' + collectionListe.etat}}\">{{collectionListe.etat}}</td><td>{{collectionListe.collecteur.firstName + \' \' + collectionListe.collecteur.lastName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"collection-liste-detail({id:collectionListe.id})\" class=\"btn btn-info btn-sm\"><span ng-show=\"collectionListe.etat == \'VALIDE\' || collectionListe.etat == \'ANNULE\'\" class=\"glyphicon glyphicon-eye-open\"></span> <span ng-show=\"collectionListe.etat == \'ACOLLECTER\' || collectionListe.etat == \'AVALIDER\' || collectionListe.etat == \'ENCOURS\'\" class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <a ng-href=\"{{vm.getMapUrl(collectionListe.id)}}\" has-module=\"NEW_FEATURES_VISIBILITY\" class=\"btn btn-warning btn-sm\"><span class=\"fa fa-map-marker\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"wamasysApp.collectionListe.detail.showMap\">Voir la carte</span> </a><button type=\"submit\" ng-show=\"collectionListe.etat == \'ACOLLECTER\' || collectionListe.etat == \'AVALIDER\' || collectionListe.etat == \'ENCOURS\'\" ui-sref=\"collection-liste.delete({id:collectionListe.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.void\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/communication-automation-conf/communication-automation-conf-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.communicationAutomationConf.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.communicationAutomationConf.delete.question\" translate-values=\"{id: \'{{vm.communicationAutomationConf.id}}\'}\">Are you sure you want to delete this CommunicationAutomationConf?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/communication-automation-conf/communication-automation-conf-detail.html","<div><h2><span translate=\"wamasysApp.communicationAutomationConf.detail.title\">CommunicationAutomationConf</span> {{vm.communicationAutomationConf.id}}</h2><hr><dl class=\"dl-horizontal\"><!-- 		\n        <dt><span translate=\"wamasysApp.communicationAutomationConf.nom\">nom</dt></dt>\n        <dd>\n            <span>{{vm.communicationAutomationConf.nom}}<span>\n        </dd>\n        <hr>\n        <dt><span translate=\"wamasysApp.communicationAutomationConf.channel\">channel</dt></dt>\n        <dd>\n            <span>{{vm.communicationAutomationConf.channel}}</span>\n        </dd>\n		<hr>\n		\n        <dt><span translate=\"global.field.code\">code</dt></dt>\n        <dd>\n            <span>{{vm.communicationAutomationConf.code}}</span>\n        </dd>\n		<hr> --><dt><span translate=\"wamasysApp.communicationAutomationConf.type\">type</span></dt><dd><span>{{vm.communicationAutomationConf.type}}</span></dd><hr><dt><span translate=\"wamasysApp.communicationAutomationConf.channelConf\">channelConf</span></dt><dd><span>{{vm.communicationAutomationConf.channelConfNom}}</span></dd><hr><dt><span translate=\"wamasysApp.communicationAutomationConf.template\">template</span></dt><dd><span>{{vm.communicationAutomationConf.template}}</span></dd><hr><dt><span translate=\"wamasysApp.communicationAutomationConf.templateHtml\">templateHtml</span></dt><dd><span>{{vm.communicationAutomationConf.templateHtml}}</span></dd><hr><dt><span translate=\"wamasysApp.communicationAutomationConf.templateSubject\">templateSubject</span></dt><dd><span>{{vm.communicationAutomationConf.templateSubject}}</span></dd><hr><dt><span translate=\"wamasysApp.communicationAutomationConf.templateId\">templateId</span></dt><dd><span>{{vm.communicationAutomationConf.templateId}}</span></dd><hr><dt><span translate=\"wamasysApp.communicationAutomationConf.delayHour\">delayHour</span></dt><dd><span>{{vm.communicationAutomationConf.delayHour}}</span></dd><hr><dt><span translate=\"wamasysApp.communicationAutomationConf.lastDateBillingNotified\">lastDateBillingNotified</span></dt><dd><span>{{vm.communicationAutomationConf.lastDateBillingNotified}}</span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/communication-automation-conf/communication-automation-conf-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCommunicationAutomationConfLabel\" translate=\"wamasysApp.communicationAutomationConf.home.createOrEditLabel\">Create or edit a CommunicationAutomationConf</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><libelle for=\"id\" translate=\"global.field.id\">ID</libelle><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.communicationAutomationConf.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label translate=\"wamasysApp.communicationAutomationConf.type\" for=\"field_type\">type</label><select class=\"form-control\" name=\"type\" ng-model=\"vm.communicationAutomationConf.type\" id=\"field_type\"><option value=\"BILLING_NOTICE\">Billing notice</option><option value=\"PAYMENT_RECEIPT\">Payment receipt</option></select></div><p ng-if=\"vm.communicationAutomationConf.type == \'BILLING_NOTICE\'\">Billing notice : Envoi un message pour les contrats qui ont eu une génération de facturation (automatique via la programmatino du portofolio) depuis la dernière execution de cette tâche.</p><p ng-if=\"vm.communicationAutomationConf.type == \'PAYMENT_RECEIPT\'\">Payment receipt : Envoi un message pour les contrats qui ont eu une génération de facturation (automatique via la programmatino du portofolio) depuis la dernière execution de cette tâche.</p><div class=\"form-group\"><label translate=\"wamasysApp.communicationAutomationConf.channelConf\" for=\"field_channelConfId\">channelConf</label><select required class=\"form-control\" id=\"field_channelConf\" name=\"channelConfId\" ng-model=\"vm.communicationAutomationConf.channelConfId\" ng-options=\"channelConf.id as channelConf.nom for channelConf in vm.channelConfs \"><option value=\"\"></option></select><div ng-show=\"editForm.channelConfId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.channelConfId.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div><div class=\"form-group\"><button type=\"button\" class=\"btn btn-link btn-sm\" ng-click=\"vm.toggleTemplateHelp()\"><span class=\"glyphicon\" ng-class=\"vm.showTemplateHelp ? \'glyphicon-chevron-down\' : \'glyphicon-chevron-right\'\"></span> <span translate=\"wamasysApp.communicationAutomationConf.templateHelp.toggle\">Variables disponibles dans le message</span></button><div class=\"well well-sm\" ng-show=\"vm.showTemplateHelp\"><p class=\"margin-bottom-10\" translate=\"wamasysApp.communicationAutomationConf.templateHelp.description\">Variables utilisables dans le sujet, le texte et le HTML :</p><ul class=\"list-unstyled margin-bottom-0\"><li ng-repeat=\"variable in vm.getAvailableVariables() track by variable\"><code>{{variable}}</code></li></ul></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.communicationAutomationConf.template\" for=\"field_template\">template</label><textarea type=\"text\" class=\"form-control\" name=\"template\" id=\"field_template\" ng-model=\"vm.communicationAutomationConf.template\" required ng-maxlength=\"256000\">\n            </textarea><div ng-show=\"editForm.template.$invalid\"><p class=\"help-block\" ng-show=\"editForm.template.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.template.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256000\">This field cannot be longer than 256000 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.getSelectedChannel() == \'EMAIL_SENDBLUE\' || vm.getSelectedChannel() == \'EMAIL_SMTP\'\"><label class=\"control-label\" translate=\"wamasysApp.communicationAutomationConf.templateHtml\" for=\"field_templateHtml\">templateHtml</label>(only for email)<textarea type=\"text\" class=\"form-control\" name=\"templateHtml\" id=\"field_templateHtml\" ng-model=\"vm.communicationAutomationConf.templateHtml\" ng-maxlength=\"256000\">\n            </textarea><div ng-show=\"editForm.templateHtml.$invalid\"><p class=\"help-block\" ng-show=\"editForm.templateHtml.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256000\">This field cannot be longer than 256000 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.getSelectedChannel() == \'EMAIL_SENDBLUE\' || vm.getSelectedChannel() == \'EMAIL_SMTP\'\"><label class=\"control-label\" translate=\"wamasysApp.communicationAutomationConf.templateSubject\" for=\"field_templateSubject\">templateSubject</label>(only for email) <input type=\"text\" class=\"form-control\" name=\"templateSubject\" id=\"field_templateSubject\" ng-model=\"vm.communicationAutomationConf.templateSubject\" ng-maxlength=\"255\"><div ng-show=\"editForm.templateSubject.$invalid\"><p class=\"help-block\" ng-show=\"editForm.templateSubject.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div><!--         \n        <div class=\"form-group\"  ng-if=\"vm.getSelectedChannel() == \'EMAIL_SENDBLUE\' || vm.getSelectedChannel() == \'EMAIL_SMTP\'\">\n            <label class=\"control-label\" translate=\"wamasysApp.communicationAutomationConf.templateId\" for=\"field_templateId\">templateId</label>\n            <input type=\"text\" class=\"form-control\" name=\"templateId\" id=\"field_templateId\"\n                    ng-model=\"vm.communicationAutomationConf.templateId\"\n                    ng-maxlength=\"255\" />\n            <div ng-show=\"editForm.templateId.$invalid\">\n            \n                <p class=\"help-block\"\n                    ng-show=\"editForm.templateId.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">\n                    This field cannot be longer than 255 characters.\n                </p>\n            </div>\n        </div> --> <input type=\"hidden\" class=\"form-control\" name=\"lastDateBillingNotified\" id=\"field_lastDateBillingNotified\" ng-model=\"vm.communicationAutomationConf.lastDateBillingNotified\"><!--         <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"wamasysApp.communicationAutomationConf.lastDateBillingNotified\" for=\"field_lastDateBillingNotified\">lastDateBillingNotified</label>  \n            <input type=\"text\" class=\"form-control\" id=\"lastDateBillingNotified\" name=\"lastDateBillingNotified\"  ng-model=\"vm.communicationAutomationConf.lastDateBillingNotified\" readonly />\n        </div> --><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.communicationAutomationConf.delayHour\" for=\"field_delayHour\">delayHour</label><input type=\"number\" class=\"form-control\" name=\"delayHour\" id=\"field_delayHour\" min=\"1\" max=\"240\" ng-model=\"vm.communicationAutomationConf.delayHour\" required><div ng-show=\"editForm.delayHour.$invalid\"><p class=\"help-block\" ng-show=\"editForm.delayHour.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.delayHour.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.delayHour.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\">This field cannot be more than 999999.</p><p class=\"help-block\" ng-show=\"editForm.delayHour.$error.number\" translate=\"entity.validation.number\">This field should be a num</p></div></div><!-- \n            <input type=\"hidden\" class=\"form-control\" name=\"lastExecutionDate\" id=\"field_lastExecutionDate\"\n                    ng-model=\"vm.communicationAutomationConf.lastExecutionDate\" />\n\n        <div class=\"row\">\n	     \n			<div class=\"form-group col-md-4\">\n				<label translate=\"wamasysApp.communicationAutomationConf.frequencePeriodNextDate\" for=\"field_frequencePeriodNextDate\">frequencePeriodNextDate</label>\n	             <div class=\"input-group\">\n	                 <input  \n                          placeholder=\"{{ \'wamasysApp.communicationAutomationConf.frequencePeriodNextDate\' | translate }}\"  id=\"field_frequencePeriodNextDate\" type=\"text\" class=\"form-control\" name=\"frequencePeriodNextDate\"\n                           ng-click=\"vm.openCalendar(\'frequencePeriodNextDate\')\" uib-datepicker-popup=\"{{dateformat}}\" \n                           ng-model=\"vm.communicationAutomationConf.frequencePeriodNextDate\" is-open=\"vm.datePickerOpenStatus.frequencePeriodNextDate\" />\n	                 <span class=\"input-group-btn\">\n	                     <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'frequencePeriodNextDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n	                 </span>\n	             </div>\n	         \n	        </div>\n	        \n	        <div class=\"form-group col-md-4\" >\n	            <label class=\"control-label\" translate=\"wamasysApp.communicationAutomationConf.frequencePeriodType\" for=\"field_frequencePeriodType\">frequencePeriodType</label>\n	            <select  class=\"form-control\" name=\"frequencePeriodType\" ng-model=\"vm.communicationAutomationConf.frequencePeriodType\" id=\"field_frequencePeriodType\">\n	                \n	                <option value=\"DAY\" translate=\"wamasysApp.communicationAutomationConf.periodType.DAY\">DAY</option>\n	                <option value=\"MONTH\" translate=\"wamasysApp.communicationAutomationConf.periodType.MONTH\">MONTH</option>\n	                <option value=\"WEEKDAY\" translate=\"wamasysApp.communicationAutomationConf.periodType.WEEKDAY\">WEEKDAY</option>\n	            </select>\n	        </div>\n	\n	\n	        <div class=\"form-group col-md-4\" ng-if=\"vm.communicationAutomationConf.frequencePeriodType != \'WEEKDAY\'\" >\n					<label translate=\"wamasysApp.communicationAutomationConf.frequencePeriodInterval\"\n								for=\"field_frequencePeriodInterval\">frequencePeriodInterval</label>\n						\n							<input    type=\"number\" class=\"form-control\" name=\"frequencePeriodInterval\"\n							id=\"field_frequencePeriodInterval\" ng-model=\"vm.communicationAutomationConf.frequencePeriodInterval\"\n							 min=\"0\" max=\"999999\"\n							placeholder=\"{{ \'wamasysApp.communicationAutomationConf.frequencePeriodInterval\' | translate }}\" />\n					\n						<div ng-show=\"editForm.frequencePeriodInterval.$invalid\">\n							<p class=\"help-block\"\n								ng-show=\"editForm.frequencePeriodInterval.$error.required\"\n								translate=\"entity.validation.required\">This field is\n								required.</p>\n							<p class=\"help-block\" ng-show=\"editForm.frequencePeriodInterval.$error.min\"\n								translate=\"entity.validation.min\" translate-value-min=\"0\">\n								This field should be more than 0.</p>\n							<p class=\"help-block\" ng-show=\"editForm.frequencePeriodInterval.$error.max\"\n								translate=\"entity.validation.max\" translate-value-max=\"999999\">\n								This field cannot be more than 999999.</p>\n							<p class=\"help-block\"\n								ng-show=\"editForm.frequencePeriodInterval.$error.number\"\n								translate=\"entity.validation.number\">This field should be a\n								number.</p>\n						</div>\n	        </div>\n	\n	        <div class=\"form-group col-md-4\" ng-if=\"vm.communicationAutomationConf.frequencePeriodType == \'WEEKDAY\'\" >\n					<label translate=\"wamasysApp.communicationAutomationConf.frequencePeriodInterval\"\n								for=\"field_frequencePeriodInterval\">frequencePeriodInterval</label>\n							\n				<select ng-change=\"vm.onUpdateBillingWeekday()\"   class=\"form-control\" multiple=\"multiple\" name=\"billingWeekday\" ng-model=\"vm.billingWeekday\" id=\"field_billingWeekday\">\n	                \n	                <option value=\"1\" translate=\"wamasysApp.communicationAutomationConf.periodType.monday\">DAY</option>\n	                <option value=\"2\" translate=\"wamasysApp.communicationAutomationConf.periodType.tuesday\">DAY</option>\n	                <option value=\"4\" translate=\"wamasysApp.communicationAutomationConf.periodType.wednesday\">DAY</option>\n	                <option value=\"8\" translate=\"wamasysApp.communicationAutomationConf.periodType.thursday\">DAY</option>\n	                <option value=\"16\" translate=\"wamasysApp.communicationAutomationConf.periodType.friday\">DAY</option>\n	                <option value=\"32\" translate=\"wamasysApp.communicationAutomationConf.periodType.saturday\">DAY</option>\n	                <option value=\"64\" translate=\"wamasysApp.communicationAutomationConf.periodType.sunday\">DAY</option>\n	\n	            </select>\n					\n\n	        </div> --></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-if=\"vm.canUseAssistant\" ng-click=\"vm.openAssistantChat()\"><span class=\"glyphicon glyphicon-comment\"></span> Assistant IA</button> <a class=\"btn btn-default\" ng-click=\"vm.previewMessage()\">Prévisualiser le message </a><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/communication-automation-conf/communication-automation-conf-form.html","<div class=\"communication-automation-conf-form\"><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"row\"><div class=\"col-md-8\"><h2 translate=\"wamasysApp.communicationAutomationConf.home.createOrEditLabel\">Create or edit a CommunicationAutomationConf</h2><p class=\"text-muted\">Le template global email/SMS défini dans le client portal est appliqué automatiquement au rendu final.</p></div><div class=\"col-md-4 text-right communication-automation-conf-form__header-actions\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-chevron-left\"></span>&nbsp;Retour</button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></div><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-3\" ng-if=\"vm.communicationAutomationConf.id\"><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.communicationAutomationConf.id\" readonly=\"readonly\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label translate=\"wamasysApp.communicationAutomationConf.type\" for=\"field_type\">type</label><select class=\"form-control\" name=\"type\" ng-model=\"vm.communicationAutomationConf.type\" id=\"field_type\"><option value=\"BILLING_NOTICE\">Billing notice</option><option value=\"PAYMENT_RECEIPT\">Payment receipt</option></select></div></div><div class=\"col-md-5\"><div class=\"form-group\"><label translate=\"wamasysApp.communicationAutomationConf.channelConf\" for=\"field_channelConfId\">channelConf</label><select required class=\"form-control\" id=\"field_channelConf\" name=\"channelConfId\" ng-model=\"vm.communicationAutomationConf.channelConfId\" ng-options=\"channelConf.id as channelConf.nom for channelConf in vm.channelConfs\"><option value=\"\"></option></select></div></div></div><div class=\"alert alert-info\" ng-if=\"vm.communicationAutomationConf.type == \'BILLING_NOTICE\'\">Billing notice : envoi un message pour les contrats ayant une nouvelle facturation depuis la dernière exécution.</div><div class=\"alert alert-info\" ng-if=\"vm.communicationAutomationConf.type == \'PAYMENT_RECEIPT\'\">Payment receipt : envoi un message après un paiement avec les variables de reçu disponibles.</div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.communicationAutomationConf.delayHour\" for=\"field_delayHour\">delayHour</label><input type=\"number\" class=\"form-control\" name=\"delayHour\" id=\"field_delayHour\" min=\"1\" max=\"240\" ng-model=\"vm.communicationAutomationConf.delayHour\" required></div></div></div><div class=\"row campaign-template-layout\"><div class=\"col-md-7\"><div class=\"panel campaign-template-card\"><div class=\"campaign-template-card__heading\"><div class=\"campaign-template-card__title\">Edition du message</div><div class=\"campaign-template-card__actions\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"vm.canUseAssistant\" ng-click=\"vm.openAssistantChat()\"><span class=\"glyphicon glyphicon-comment\"></span> Assistant IA</button> <button type=\"button\" class=\"btn btn-link btn-sm\" ng-click=\"vm.toggleTemplateHelp()\"><span class=\"glyphicon\" ng-class=\"vm.showTemplateHelp ? \'glyphicon-chevron-down\' : \'glyphicon-chevron-right\'\"></span> <span translate=\"wamasysApp.communicationAutomationConf.templateHelp.toggle\">Variables disponibles dans le message</span></button></div></div><div class=\"panel-body\"><div class=\"well well-sm\" ng-show=\"vm.showTemplateHelp\"><p class=\"margin-bottom-10\" translate=\"wamasysApp.communicationAutomationConf.templateHelp.description\">Variables utilisables dans le sujet, le texte et le HTML :</p><ul class=\"list-unstyled margin-bottom-0\"><li ng-repeat=\"variable in vm.getAvailableVariables() track by variable\"><code>{{variable}}</code></li></ul></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.communicationAutomationConf.template\" for=\"field_template\">template</label><textarea class=\"form-control\" name=\"template\" id=\"field_template\" ng-model=\"vm.communicationAutomationConf.template\" required rows=\"8\" ng-maxlength=\"256000\"></textarea></div><div class=\"form-group\" ng-if=\"vm.getSelectedChannel() == \'EMAIL_SENDBLUE\' || vm.getSelectedChannel() == \'EMAIL_SMTP\'\"><label class=\"control-label\" translate=\"wamasysApp.communicationAutomationConf.templateSubject\" for=\"field_templateSubject\">templateSubject</label><input type=\"text\" class=\"form-control\" name=\"templateSubject\" id=\"field_templateSubject\" ng-model=\"vm.communicationAutomationConf.templateSubject\" ng-maxlength=\"255\"></div><div class=\"form-group campaign-template-card__last-group\" ng-if=\"vm.getSelectedChannel() == \'EMAIL_SENDBLUE\' || vm.getSelectedChannel() == \'EMAIL_SMTP\'\"><label class=\"control-label\" translate=\"wamasysApp.communicationAutomationConf.templateHtml\" for=\"field_templateHtml\">templateHtml</label><textarea class=\"form-control campaign-template-card__html-input\" name=\"templateHtml\" id=\"field_templateHtml\" ng-model=\"vm.communicationAutomationConf.templateHtml\" rows=\"12\" ng-maxlength=\"256000\"></textarea></div></div></div></div><div class=\"col-md-5\"><div class=\"panel campaign-template-card campaign-template-preview-card\"><div class=\"campaign-template-card__heading\"><div class=\"campaign-template-card__title\" translate=\"wamasysApp.communicationCampaign.livePreview\">Apercu en direct</div><div class=\"campaign-template-card__actions\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.previewMessage()\"><span class=\"glyphicon glyphicon-new-window\"></span> <span translate=\"wamasysApp.communicationCampaign.preview\">Tester le modèle de message</span></button></div></div><div class=\"panel-body campaign-template-preview-card__body\"><p class=\"campaign-template-preview-card__hint text-muted\" translate=\"wamasysApp.communicationCampaign.livePreviewHelp\">Le contenu se met a jour automatiquement pendant la saisie.</p><div class=\"campaign-template-preview-card__empty\" ng-if=\"!vm.livePreview.hasContent && !vm.livePreview.isLoading && !vm.livePreview.error\"><span translate=\"wamasysApp.communicationCampaign.livePreviewEmpty\">Commencez a renseigner le template pour voir le rendu.</span></div><div class=\"campaign-template-preview-card__empty\" ng-if=\"vm.livePreview.isLoading\"><span translate=\"wamasysApp.communicationCampaign.previewLoading\">Mise a jour...</span></div><div class=\"campaign-template-preview-card__empty text-danger\" ng-if=\"vm.livePreview.error\">{{vm.livePreview.error}}</div><div class=\"campaign-template-preview-card__section\" ng-if=\"vm.livePreview.subject\"><div class=\"campaign-template-preview-card__label\" translate=\"wamasysApp.communicationCampaign.previewSubject\">Sujet</div><div class=\"campaign-template-preview-card__content\">{{vm.livePreview.subject}}</div></div><div class=\"campaign-template-preview-card__section\" ng-if=\"vm.livePreview.messageText\"><div class=\"campaign-template-preview-card__label\" translate=\"wamasysApp.communicationCampaign.previewText\">Texte</div><pre class=\"campaign-template-preview-card__text\">{{vm.livePreview.messageText}}</pre></div><div class=\"campaign-template-preview-card__section\" ng-if=\"vm.livePreview.messageHtml\"><div class=\"campaign-template-preview-card__label\" translate=\"wamasysApp.communicationCampaign.previewHtml\">HTML rendu</div><div class=\"campaign-template-preview-card__html\" ng-bind-html=\"vm.livePreview.trustedMessageHtml\"></div></div></div></div></div></div></form></div>");
$templateCache.put("app/business/communication-automation-conf/communication-automation-confs.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.communicationAutomationConf.home.title\">CommunicationAutomationConfs</span> <small class=\"text-muted\" translate=\"global.configurationScope.zone\">Paramétrage propre à la zone</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"communication-automation-conf.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.communicationAutomationConf.home.createLabel\">Create new CommunicationAutomationConf</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"type\"><span translate=\"wamasysApp.communicationAutomationConf.type\">type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--         <th jh-sort-by=\"frequencePeriodType\"><span translate=\"wamasysApp.communicationAutomationConf.frequencePeriodType\">frequence_period_type</span> <span class=\"glyphicon glyphicon-sort\"></span></th>\n                    <th jh-sort-by=\"frequencePeriodInterval\"><span translate=\"wamasysApp.communicationAutomationConf.frequencePeriodInterval\">frequence_period_interval</span> <span class=\"glyphicon glyphicon-sort\"></span></th>\n                    <th jh-sort-by=\"frequencePeriodNextDate\" ><span translate=\"wamasysApp.communicationAutomationConf.frequencePeriodNextDate\">frequence_period_next_date</span> <span class=\"glyphicon glyphicon-sort\"></span></th>\n                    <th jh-sort-by=\"lastExecutionDate\" ><span translate=\"wamasysApp.communicationAutomationConf.lastExecutionDate\">last_execution_date</span> <span class=\"glyphicon glyphicon-sort\"></span></th> --><th jh-sort-by=\"lastDateBillingNotified\"><span translate=\"wamasysApp.communicationAutomationConf.lastDateBillingNotified\">lastDateBillingNotified</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"delayHour\"><span translate=\"wamasysApp.communicationAutomationConf.delayHour\">delayHour</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"channelConfId\"><span translate=\"wamasysApp.communicationAutomationConf.channelConf\">communication_topic_id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"communicationAutomationConf in vm.communicationAutomationConfs track by communicationAutomationConf.id\"><td><a ui-sref=\"communication-automation-conf-detail({id:communicationAutomationConf.id})\">{{communicationAutomationConf.id}}</a></td><td>{{communicationAutomationConf.type}}</td><td>{{communicationAutomationConf.lastDateBillingNotified}}</td><td>{{communicationAutomationConf.delayHour}}</td><td>{{communicationAutomationConf.channelConfNom}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"communication-automation-conf-detail({id:communicationAutomationConf.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"communication-automation-conf.edit({id:communicationAutomationConf.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"communication-automation-conf.delete({id:communicationAutomationConf.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/communication-campaign/communication-campaign-cancel-dialog.html","<form name=\"deleteForm\" ng-submit=\"!vm.communicationCampaign.sendingDone && vm.confirmCancel(vm.communicationCampaign.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><p ng-if=\"!vm.communicationCampaign.sendingDone\" translate=\"wamasysApp.communicationCampaign.cancel.question\" translate-values=\"{ title: vm.communicationCampaign.title }\">Etes-vous certain de vouloir annuler cette campagne ?</p><p ng-if=\"vm.communicationCampaign.sendingDone\">Cette campagne a déjà été envoyée. Elle ne peut plus être annulée.</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" class=\"btn btn-danger\" ng-if=\"!vm.communicationCampaign.sendingDone\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/business/communication-campaign/communication-campaign-form.html","<div class=\"communication-campaign-form\"><h2 ng-if=\"!vm.communicationCampaign.id\" translate=\"wamasysApp.communicationCampaign.home.createLabel\">Creer une campagne</h2><h2 ng-if=\"vm.communicationCampaign.id\" translate=\"wamasysApp.communicationCampaign.home.createOrEditLabel\">Creer ou modifier une campagne</h2><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class=\"alert alert-warning\" ng-if=\"vm.isLocked\">Cette campagne a deja ete envoyee. Elle ne peut plus etre modifiee ni annulee.</div><form name=\"editForm\" role=\"form\" novalidate show-validation><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.communicationCampaign.title\" for=\"field_title\">Titre</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.communicationCampaign.title\" required ng-maxlength=\"255\" ng-disabled=\"vm.isLocked\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.communicationCampaign.internalComment\" for=\"field_internalComment\">Commentaire interne</label><textarea class=\"form-control\" name=\"internalComment\" id=\"field_internalComment\" ng-model=\"vm.internalCommentNote\" rows=\"3\" ng-disabled=\"vm.isLocked\"></textarea><p class=\"help-block\" translate=\"wamasysApp.communicationCampaign.internalCommentHelp\">Les filtres de recherche sont ajoutes automatiquement dans le commentaire en JSON apres l\'enregistrement.</p><div class=\"campaign-comment-preview\" ng-if=\"vm.savedFiltersSummary.length\"><div class=\"campaign-comment-preview__header\"><span translate=\"wamasysApp.communicationCampaign.savedFilters\">Filtres sauvegardes</span></div><div class=\"campaign-comment-preview__summary\"><span class=\"label label-default campaign-comment-preview__tag\" ng-repeat=\"item in vm.savedFiltersSummary track by item.label\">{{item.label}} : {{item.value}}</span></div><pre class=\"campaign-comment-preview__json\" ng-if=\"vm.savedFiltersJson\">{{vm.savedFiltersJson}}</pre></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.communicationCampaign.desiredSendDate\" for=\"field_desiredSendDate\">Date d\'envoi souhaitee</label><div class=\"input-group\"><input id=\"field_desiredSendDate\" type=\"text\" class=\"form-control\" name=\"desiredSendDate\" ng-click=\"vm.openCalendar(\'desiredSendDate\')\" datetime-picker=\"yyyy-MM-dd HH:mm\" ng-model=\"vm.communicationCampaign.desiredSendDate\" is-open=\"vm.datePickerOpenStatus.desiredSendDate\" placeholder=\"yyyy-mm-dd hh:mm\" ng-disabled=\"vm.isLocked\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'desiredSendDate\')\" ng-disabled=\"vm.isLocked\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.communicationCampaign.channel\" for=\"field_channel\">Canal</label><select class=\"form-control\" id=\"field_channel\" name=\"channel\" ng-model=\"vm.communicationCampaign.channel\" ng-options=\"channel.name as channel.label for channel in vm.channels track by channel.name\" required ng-disabled=\"vm.isLocked\"><option value=\"\"></option></select></div></div></div><fieldset class=\"padding-top-10\" ng-if=\"!vm.isEdit\"><legend translate=\"global.header.findContracts\">Recherche contrat</legend><div class=\"row\"><div class=\"col-md-6\" ng-if=\"!vm.isEdit\"><div class=\"form-group\"><label translate=\"global.menu.agence\">Zone</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.agenceNotPromise\" theme=\"selectize\"><ui-select-match placeholder=\"{{\'global.menu.agence\' | translate}}\">{{$item.nom}}</ui-select-match><ui-select-choices repeat=\"agence in vm.agences | filter: $select.search track by agence.id\">{{agence.nom}}</ui-select-choices></ui-select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.etat\">Etat</label><select class=\"form-control\" ng-model=\"vm.etat\"><option value=\"\"></option><option value=\"ACTIVE\" translate=\"wamasysApp.EtatContrat.ACTIVE\">ACTIVE</option><option value=\"CLOSED\" translate=\"wamasysApp.EtatContrat.CLOSED\">CLOSED</option></select></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.compteurFerme\">compteurFerme</label><select class=\"form-control\" ng-model=\"vm.compteurFerme\"><option value=\"\"></option><option value=\"true\" translate=\"entity.value.true\">true</option><option value=\"false\" translate=\"entity.value.false\">false</option></select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.dateActivation\">Date d\'activation</label><input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" options=\"vm.opts\" placeholder=\"yyyy-mm-dd - yyyy-mm-dd\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.hasEmail\">Possede un email</label><select class=\"form-control\" ng-model=\"vm.hasEmail\"><option value=\"\"></option><option value=\"true\" translate=\"entity.value.true\">true</option><option value=\"false\" translate=\"entity.value.false\">false</option></select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.hasPhone\">Possede un numero de telephone</label><select class=\"form-control\" ng-model=\"vm.hasPhone\"><option value=\"\"></option><option value=\"true\" translate=\"entity.value.true\">true</option><option value=\"false\" translate=\"entity.value.false\">false</option></select></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.portefeuilleContrat\">Portefeuille client</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.portefeuilleContratNotPromise\" theme=\"selectize\"><ui-select-match placeholder=\"{{\'wamasysApp.contrat.portefeuilleContrat\' | translate}}\">{{$item.libelle}}</ui-select-match><ui-select-choices repeat=\"portefeuilleContrat in vm.portefeuilleContrats | filter: $select.search track by portefeuilleContrat.id\">{{portefeuilleContrat.libelle}}</ui-select-choices></ui-select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.serviceVendu\">serviceVendu</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.serviceVenduNotPromise\" theme=\"selectize\"><ui-select-match placeholder=\"{{\'wamasysApp.contrat.serviceVendu\' | translate}}\">{{$item.libelle}}</ui-select-match><ui-select-choices repeat=\"serviceVendu in vm.serviceVendus | filter: $select.search track by serviceVendu.id\">{{(serviceVendu.deleted==true)?\"&#x274c; \":\"\"}}{{serviceVendu.libelle}}</ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.contractType\">ContractType</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.contractTypeNotPromise\" theme=\"selectize\"><ui-select-match placeholder=\"{{\'wamasysApp.contrat.contractType\' | translate}}\">{{$item.label}}</ui-select-match><ui-select-choices repeat=\"contractType in vm.contractTypes | filter: $select.search track by contractType.id\">{{(contractType.deleted==true)?\"&#x274c; \":\"\"}}{{contractType.label}}</ui-select-choices></ui-select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.contractProfil\">ContractProfil</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.contractProfilNotPromise\" theme=\"selectize\"><ui-select-match placeholder=\"{{\'wamasysApp.contrat.contractProfil\' | translate}}\">{{$item.libelle}}</ui-select-match><ui-select-choices repeat=\"contractProfil in vm.contractProfils | filter: $select.search track by contractProfil.id\">{{(contractProfil.deleted==true)?\"&#x274c; \":\"\"}}{{contractProfil.libelle}}</ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.communicationCampaign.communicationTopic\">Communication topic</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.communicationTopicNotPromise\" theme=\"selectize\"><ui-select-match placeholder=\"{{\'wamasysApp.communicationCampaign.communicationTopic\' | translate}}\">{{$item.nomInterne}}</ui-select-match><ui-select-choices repeat=\"communicationTopic in vm.communicationTopics | filter: $select.search track by communicationTopic.id\">{{communicationTopic.nomInterne}}</ui-select-choices></ui-select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.communicationCampaign.communicationTopicCategory\">Topic category</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.communicationTopicCategoryNotPromise\" theme=\"selectize\"><ui-select-match placeholder=\"{{\'wamasysApp.communicationCampaign.communicationTopicCategory\' | translate}}\">{{$item.label}}</ui-select-match><ui-select-choices repeat=\"communicationTopicCategory in vm.communicationTopicCategories | filter: $select.search track by communicationTopicCategory.id\">{{communicationTopicCategory.label}}</ui-select-choices></ui-select></div></div></div><div class=\"form-group\"><button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"vm.searchContracts()\"><span class=\"glyphicon glyphicon-search\"></span> <span translate=\"entity.action.chercher\">search</span></button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.download()\"><span class=\"glyphicon glyphicon-download\"></span> <span translate=\"wamasysApp.communicationCampaign.downloadContracts\">Telecharger le CSV des contrats</span></button></div><div class=\"well well-sm\"><strong translate=\"wamasysApp.communicationCampaign.contractCount\">Nombre de contrats</strong>: {{vm.contractSearchResult.contractCount || 0}}</div></fieldset><fieldset class=\"padding-top-10\" ng-if=\"vm.isEdit\"><legend translate=\"global.header.findContracts\">Recherche contrat</legend><div class=\"well well-sm\"><strong translate=\"wamasysApp.communicationCampaign.contractCount\">Nombre de contrats</strong>: {{vm.communicationCampaign.contratCount || 0}}</div><div class=\"well well-sm\" ng-if=\"vm.savedFiltersJson\"><strong translate=\"wamasysApp.communicationCampaign.savedFilters\">Filtres sauvegardes</strong><pre class=\"campaign-comment-preview__json campaign-comment-preview__json--compact\">{{vm.savedFiltersJson}}</pre></div><div class=\"form-group\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.download()\"><span class=\"glyphicon glyphicon-download\"></span> <span translate=\"wamasysApp.communicationCampaign.downloadContracts\">Telecharger le CSV des contrats</span></button></div></fieldset><fieldset class=\"padding-top-10\"><legend translate=\"global.menu.communication\">Communication</legend><div class=\"row campaign-template-layout\"><div class=\"col-md-7\"><div class=\"panel panel-default campaign-template-card\"><div class=\"panel-heading campaign-template-card__heading\"><div class=\"campaign-template-card__title\"><span translate=\"global.menu.communication\">Communication</span></div><div class=\"campaign-template-card__actions\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"vm.canUseAssistant && !vm.isLocked\" ng-click=\"vm.openAssistantChat()\"><span class=\"glyphicon glyphicon-comment\"></span> Assistant IA</button> <button type=\"button\" class=\"btn btn-link btn-sm\" ng-click=\"vm.toggleTemplateHelp()\"><span class=\"glyphicon\" ng-class=\"vm.showTemplateHelp ? \'glyphicon-chevron-down\' : \'glyphicon-chevron-right\'\"></span> <span translate=\"wamasysApp.communicationCampaign.templateHelp.toggle\">Variables disponibles dans le message</span></button></div></div><div class=\"panel-body\"><div class=\"well well-sm\" ng-show=\"vm.showTemplateHelp\"><p class=\"margin-bottom-10\" translate=\"wamasysApp.communicationCampaign.templateHelp.description\">Variables utilisables dans le sujet, le texte et le HTML :</p><ul class=\"list-unstyled margin-bottom-0\"><li ng-repeat=\"variable in vm.templateVariables track by variable\"><code>{{variable}}</code></li></ul></div><p class=\"text-muted\">Le client portal applique automatiquement la signature SMS et l\'enveloppe HTML globale. Renseignez ici uniquement le contenu du message.</p><div class=\"form-group\"><label translate=\"wamasysApp.communicationCampaign.templateTxt\" for=\"field_templateTxt\">Template texte</label><textarea class=\"form-control\" name=\"templateTxt\" id=\"field_templateTxt\" ng-model=\"vm.communicationCampaign.templateTxt\" rows=\"7\" ng-required=\"!vm.isEmailChannel()\" ng-maxlength=\"256000\" ng-disabled=\"vm.isLocked\"></textarea></div><div class=\"form-group\" ng-if=\"vm.isEmailChannel()\"><label translate=\"wamasysApp.communicationCampaign.templateSubject\" for=\"field_templateSubject\">Sujet</label><input type=\"text\" class=\"form-control\" name=\"templateSubject\" id=\"field_templateSubject\" ng-model=\"vm.communicationCampaign.templateSubject\" ng-maxlength=\"255\" ng-disabled=\"vm.isLocked\"></div><div class=\"form-group campaign-template-card__last-group\" ng-if=\"vm.isEmailChannel()\"><label translate=\"wamasysApp.communicationCampaign.templateHtml\" for=\"field_templateHtml\">Template HTML</label><textarea class=\"form-control campaign-template-card__html-input\" name=\"templateHtml\" id=\"field_templateHtml\" ng-model=\"vm.communicationCampaign.templateHtml\" rows=\"10\" ng-maxlength=\"256000\" ng-disabled=\"vm.isLocked\"></textarea></div></div></div></div><div class=\"col-md-5\"><div class=\"panel panel-default campaign-template-card campaign-template-preview-card\"><div class=\"panel-heading campaign-template-card__heading\"><div class=\"campaign-template-card__title\"><span translate=\"wamasysApp.communicationCampaign.livePreview\">Apercu en direct</span></div><span class=\"label label-info\" ng-if=\"vm.livePreview.isLoading\" translate=\"wamasysApp.communicationCampaign.previewLoading\">Mise a jour...</span></div><div class=\"panel-body campaign-template-preview-card__body\"><p class=\"text-muted campaign-template-preview-card__hint\" translate=\"wamasysApp.communicationCampaign.livePreviewHelp\">Le contenu se met a jour automatiquement pendant la saisie.</p><div class=\"alert alert-warning\" ng-if=\"vm.livePreview.error\">{{vm.livePreview.error}}</div><div class=\"campaign-template-preview-card__empty\" ng-if=\"!vm.livePreview.error && !vm.livePreview.hasContent && !vm.livePreview.isLoading\"><span translate=\"wamasysApp.communicationCampaign.livePreviewEmpty\">Commencez a renseigner le template pour voir le rendu.</span></div><div class=\"campaign-template-preview-card__section\" ng-if=\"vm.livePreview.subject\"><div class=\"campaign-template-preview-card__label\" translate=\"wamasysApp.communicationCampaign.previewSubject\">Sujet</div><div class=\"campaign-template-preview-card__content\">{{vm.livePreview.subject}}</div></div><div class=\"campaign-template-preview-card__section\" ng-if=\"vm.livePreview.messageText\"><div class=\"campaign-template-preview-card__label\" translate=\"wamasysApp.communicationCampaign.previewText\">Texte</div><pre class=\"campaign-template-preview-card__text\">{{vm.livePreview.messageText}}</pre></div><div class=\"campaign-template-preview-card__section\" ng-if=\"vm.livePreview.messageHtml\"><div class=\"campaign-template-preview-card__label\" translate=\"wamasysApp.communicationCampaign.previewHtml\">HTML rendu</div><div class=\"campaign-template-preview-card__html\" ng-bind-html=\"vm.livePreview.trustedMessageHtml\"></div></div></div></div></div></div></fieldset><div class=\"form-group\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.previewMessage()\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span translate=\"wamasysApp.communicationCampaign.preview\">Tester le modele de message</span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.back()\"><span class=\"glyphicon glyphicon-arrow-left\"></span> <span translate=\"entity.action.back\">Back</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"vm.isLocked || editForm.$invalid || vm.isSaving || (vm.isEdit ? (vm.communicationCampaign.contratCount || 0) === 0 : !vm.communicationCampaign.contratIds || vm.communicationCampaign.contratIds.length === 0)\" ng-click=\"vm.save()\"><span class=\"glyphicon glyphicon-save\"></span> <span translate=\"entity.action.save\">Save</span></button></div></form></div>");
$templateCache.put("app/business/communication-campaign/communication-campaigns.html","<div class=\"app-entity-shell\"><div class=\"app-entity-header\"><h2 class=\"app-entity-title\" translate=\"wamasysApp.communicationCampaign.home.title\">Campagnes</h2><div class=\"app-entity-actions\"><button class=\"btn btn-primary\" ui-sref=\"communication-campaign.new\" has-any-authority=\"ROLE_ADMIN,ROLE_AREA_CONFIGURATION,ROLE_AREA_MANAGEMENT\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.communicationCampaign.home.createLabel\">Cr&eacute;er une campagne</span></button></div></div><jhi-alert></jhi-alert><div class=\"app-filter-panel\"><form name=\"searchForm\" class=\"smart-form\" novalidate><div class=\"app-filter-grid\"><div class=\"app-filter-field\"><label class=\"app-filter-label\" translate=\"wamasysApp.communicationCampaign.title\">Titre</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchTitle\" placeholder=\"{{ \'wamasysApp.communicationCampaign.title\' | translate }}\"></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" translate=\"wamasysApp.communicationCampaign.channel\">Canal</label><select class=\"form-control\" ng-model=\"vm.channel\"><option value=\"\"></option><option ng-repeat=\"channel in vm.channels track by channel\" value=\"{{channel}}\">{{channel}}</option></select></div><div class=\"app-filter-field app-filter-field--wide\"><label class=\"app-filter-label\" translate=\"wamasysApp.communicationCampaign.desiredSendDate\">Date d\'envoi souhait&eacute;e</label><input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" placeholder=\"yyyy-mm-dd - yyyy-mm-dd\"></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" translate=\"wamasysApp.communicationCampaign.cancelled\">Annul&eacute;e</label><select class=\"form-control\" ng-model=\"vm.cancelled\"><option value=\"\"></option><option value=\"true\" translate=\"entity.value.true\">true</option><option value=\"false\" translate=\"entity.value.false\">false</option></select></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" translate=\"wamasysApp.communicationCampaign.sendingDone\">Envoi effectu&eacute;</label><select class=\"form-control\" ng-model=\"vm.sendingDone\"><option value=\"\"></option><option value=\"true\" translate=\"entity.value.true\">true</option><option value=\"false\" translate=\"entity.value.false\">false</option></select></div></div><div class=\"app-filter-actions\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.clear()\" translate=\"entity.action.reset\">reset</button> <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"vm.search()\" translate=\"entity.action.chercher\">search</button></div></form></div><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"title\"><span translate=\"wamasysApp.communicationCampaign.title\">Titre</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"channel\"><span translate=\"wamasysApp.communicationCampaign.channel\">Canal</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"desiredSendDate\"><span translate=\"wamasysApp.communicationCampaign.desiredSendDate\">Date d\'envoi souhait&eacute;e</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"contratCount\"><span translate=\"wamasysApp.communicationCampaign.contratCount\">Contrats</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"cancelled\"><span translate=\"wamasysApp.communicationCampaign.cancelled\">Annul&eacute;e</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sendingDone\"><span translate=\"wamasysApp.communicationCampaign.sendingDone\">Envoi effectu&eacute;</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createdDate\"><span translate=\"global.field.dateCreation\">Date cr&eacute;ation</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastModifiedDate\"><span translate=\"global.field.dateModification\">Date modification</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"communicationCampaign in vm.communicationCampaigns track by communicationCampaign.id\"><td>{{communicationCampaign.title}}</td><td>{{communicationCampaign.channel}}</td><td>{{communicationCampaign.desiredSendDate | date:\'medium\'}}</td><td>{{communicationCampaign.contratCount}}</td><td translate=\"{{\'entity.value.\' + communicationCampaign.cancelled}}\">{{communicationCampaign.cancelled}}</td><td translate=\"{{\'entity.value.\' + communicationCampaign.sendingDone}}\">{{communicationCampaign.sendingDone}}</td><td>{{communicationCampaign.createdDate | date:\'medium\'}}<br><small>{{communicationCampaign.createdBy}}</small></td><td>{{communicationCampaign.lastModifiedDate | date:\'medium\'}}<br><small>{{communicationCampaign.lastModifiedBy}}</small></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\" has-any-authority=\"ROLE_ADMIN,ROLE_AREA_CONFIGURATION,ROLE_AREA_MANAGEMENT\"><button type=\"submit\" ui-sref=\"communication-campaign.edit({id:communicationCampaign.id})\" class=\"btn btn-primary btn-sm\" ng-disabled=\"communicationCampaign.sendingDone\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"communication-campaign.cancel({id:communicationCampaign.id})\" class=\"btn btn-danger btn-sm\" ng-disabled=\"communicationCampaign.cancelled || communicationCampaign.sendingDone\"><span class=\"glyphicon glyphicon-ban-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.cancel\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/communication-topic/communication-topic-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.communicationTopic.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.communicationTopic.delete.question\" translate-values=\"{id: \'{{vm.communicationTopic.id}}\'}\">Are you sure you want to delete this CommunicationTopic?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/communication-topic/communication-topic-detail.html","<div><h2><span translate=\"wamasysApp.communicationTopic.detail.title\">CommunicationTopic</span> {{vm.communicationTopic.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.communicationTopic.nom\">nom</span></dt><dd><span>{{vm.communicationTopic.nom}}<span></span></span></dd><hr><dt><span translate=\"global.field.code\">code</span></dt><dd><span>{{vm.communicationTopic.code}}</span></dd><hr><dt><span translate=\"wamasysApp.communicationTopic.nomInterne\">nomInterne</span></dt><dd><span>{{vm.communicationTopic.nomInterne}}</span></dd><hr><dt><span translate=\"wamasysApp.communicationTopic.nomClient\">nomClient</span></dt><dd><span>{{vm.communicationTopic.nomClient}}</span></dd><hr><dt><span translate=\"wamasysApp.communicationTopic.contractContact\">contractContact</span></dt><dd><span>{{ (\'wamasysApp.ContractContact.\' + vm.communicationTopic.contractContact) | translate }}</span></dd><hr><dt><span translate=\"wamasysApp.communicationTopic.description_interne\">description_interne</span></dt><dd><span>{{vm.communicationTopic.description_interne}}</span></dd><hr><dt><span translate=\"wamasysApp.communicationTopic.description_client\">description_client</span></dt><dd><span>{{vm.communicationTopic.description_client}}</span></dd><hr><dt><span translate=\"wamasysApp.communicationTopic.deleted\">deleted</span></dt><dd><span>{{vm.communicationTopic.deleted}}</span></dd><hr><dt><span translate=\"global.field.configuration\">configuration</span></dt><dd><span>{{vm.communicationTopic.configuration}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/communication-topic/communication-topic-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCommunicationTopicLabel\" translate=\"wamasysApp.communicationTopic.home.createOrEditLabel\">Create or edit a CommunicationTopic</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><libelle for=\"id\" translate=\"global.field.id\">ID</libelle><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.communicationTopic.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"global.field.code\" for=\"field_code\">Code</label><input ng-readonly=\"vm.communicationTopic.id != null\" required type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.communicationTopic.code\" ng-maxlength=\"64\" ng-pattern=\"/^[_.A-Z0-9-]*$/\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.pattern\" translate=\"wamasysApp.communicationTopic.codeFormatError\">The article code can only contain upper-case letters and digits.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"64\">This field cannot be longer than 64 characters.</p></div></div><div class=\"form-group\"><libelle class=\"control-label\" translate=\"wamasysApp.communicationTopic.nomInterne\" for=\"field_nomInterne\">nomInterne</libelle><input type=\"text\" class=\"form-control\" name=\"nomInterne\" id=\"field_nomInterne\" ng-model=\"vm.communicationTopic.nomInterne\" required ng-maxlength=\"50\"><div ng-show=\"editForm.nomInterne.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nomInterne.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nomInterne.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><libelle class=\"control-label\" translate=\"wamasysApp.communicationTopic.nomClient\" for=\"field_nomClient\">nomClient</libelle><input type=\"text\" class=\"form-control\" name=\"nomClient\" id=\"field_nomClient\" ng-model=\"vm.communicationTopic.nomClient\" required ng-maxlength=\"50\"><div ng-show=\"editForm.nomClient.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nomClient.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nomClient.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.communicationTopic.contractContact\" for=\"field_contractContact\">contractContact</label><select required class=\"form-control\" id=\"field_contractContact\" name=\"contractContact\" ng-model=\"vm.communicationTopic.contractContact\"><option value=\"\"></option><option ng-repeat=\"contractContact in vm.contractContacts track by contractContact.value\" value=\"{{contractContact.value}}\">{{ (\'wamasysApp.ContractContact.\' + contractContact.value) | translate }}</option></select><div ng-show=\"editForm.contractContact.$invalid\"><p class=\"help-block\" ng-show=\"editForm.contractContact.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.communicationTopic.communicationTopicCategory\" for=\"field_communicationTopicCategoryId\">communicationTopicCategory</label><select required class=\"form-control\" id=\"field_communicationTopicCategory\" name=\"communicationTopicCategoryId\" ng-model=\"vm.communicationTopic.communicationTopicCategoryId\" ng-options=\"communicationTopicCategory.id as communicationTopicCategory.label for communicationTopicCategory in vm.communicationTopicCategorys \"><option value=\"\"></option></select><div ng-show=\"editForm.communicationTopicCategoryId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.communicationTopicCategoryId.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.communicationTopic.description_interne\" for=\"field_description_interne\">description_interne</label><textarea type=\"text\" class=\"form-control\" name=\"description_interne\" id=\"field_description_interne\" ng-model=\"vm.communicationTopic.description_interne\" ng-maxlength=\"1024\">\n                    </textarea><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.description_interne.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"1024\">This field cannot be longer than 1024 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.communicationTopic.description_client\" for=\"field_description_client\">description_client</label><textarea type=\"text\" class=\"form-control\" name=\"description_client\" id=\"field_description_client\" ng-model=\"vm.communicationTopic.description_client\" ng-maxlength=\"1024\">\n                    </textarea><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.description_client.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"1024\">This field cannot be longer than 1024 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.communicationTopic.id\"><label class=\"control-deleted\" translate=\"global.field.isDeleted\" for=\"field_deleted\">deleted</label><input type=\"checkbox\" class=\"form-control\" name=\"deleted\" id=\"field_deleted\" ng-model=\"vm.communicationTopic.deleted\"></div><input type=\"hidden\" class=\"form-control\" id=\"deleted\" name=\"deleted\" ng-model=\"vm.communicationTopic.deleted\" readonly=\"readonly\"></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/communication-topic/communication-topics.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.communicationTopic.home.title\">CommunicationTopics</span> <small class=\"text-muted\" translate=\"global.configurationScope.zone\">Paramétrage propre à la zone</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"communication-topic.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.communicationTopic.home.createLabel\">Create new CommunicationTopic</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"nomInterne\"><span translate=\"wamasysApp.communicationTopic.nomInterne\">nomInterne</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nomClient\"><span translate=\"wamasysApp.communicationTopic.nomClient\">nomClient</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"global.field.code\">code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"contractContact\"><span translate=\"wamasysApp.communicationTopic.contractContact\">contractContact</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deleted\"><span translate=\"wamasysApp.communicationTopic.deleted\">deleted</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"communicationTopic in vm.communicationTopics track by communicationTopic.id\"><td><a ui-sref=\"communication-topic-detail({id:communicationTopic.id})\">{{communicationTopic.nomInterne}}</a></td><td>{{communicationTopic.nomClient}}</td><td>{{communicationTopic.code}}</td><td>{{ (\'wamasysApp.ContractContact.\' + communicationTopic.contractContact) | translate }}</td><td>{{communicationTopic.deleted}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"communication-topic-detail({id:communicationTopic.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"communication-topic.edit({id:communicationTopic.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"communication-topic.delete({id:communicationTopic.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/calendar/calendar.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-12\" has-module=\"TEAM\"><div class=\"sortable-grid ui-sortable\"><jhi-alert-error></jhi-alert-error><style>.task-list-container { display: flex; }\r\n.list {  border: 1px solid black; padding: 10px; }\r\n        \r\n#task-list-container-OFF {\r\n    position: sticky;\r\n    top: 0;\r\n    background: white;\r\n    z-index: 100;\r\n    padding: 10px;\r\n    border-right: 1px solid #ccc;\r\n    height: 100vh; /* S\'étend sur toute la hauteur */\r\n    overflow-y: auto; /* Active le scroll si la liste est longue */\r\n}\r\n\r\n.task {\r\n    cursor: move; \r\n    padding: 5px; \r\n    margin: 5px; \r\n    background: lightblue;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n}\r\n\r\n.task:active {\r\n    cursor: grabbing;\r\n}\r\n\r\n.task.ui-draggable-dragging {\r\n    opacity: 0.7;\r\n    transform: scale(1.1);\r\n    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* Qd on passe un élément sur le calendrier*/\r\n.fc-highlight {\r\n    background-color: #ffcc80 !important;\r\n    border: 2px dashed #ff9800 !important;\r\n    transition: background-color 0.3s ease-in-out;\r\n}\r\n.with-background-red {\r\n    background-color: red;\r\n    \r\n}\r\n.with-background-red .text-danger {\r\n    color: white;\r\n    font-weight: bold;\r\n}</style><div class=\"row\"><div class=\"col-md-2\" id=\"task-list-container\"><div id=\"divOptions\" class=\"form-inline\"><div><label class=\"control-label\" for=\"minTime\" translate=\"wamasysApp.calendar.heureDebut\">Heure de début :</label><input type=\"number\" min=\"0\" max=\"24\" class=\"form-control\" id=\"minTime\" ng-model=\"vm.minTime\"></div><div><label class=\"control-label\" for=\"maxTime\" translate=\"wamasysApp.calendar.heureFin\">Heure de fin :</label><input type=\"number\" min=\"0\" max=\"24\" class=\"form-control\" id=\"maxTime\" ng-model=\"vm.maxTime\"></div><!-- 						<div>\r\n							<label class=\"control-label\" for=\"timezoneOffset\">Fuseau horaire :</label>  \r\n							 <input type=\"number\"\r\n							         class=\"form-control\"\r\n							         id=\"timezoneOffset\"\r\n							         ng-model=\"vm.manualTimezoneOffset\"\r\n							         step=\"1\"\r\n							         min=\"-12\"\r\n							         max=\"14\">\r\n							</div> --></div><ui-select tagging multiple=\"multiple\" ng-model=\"vm.areaSelected\" theme=\"selectize\" ng-change=\"vm.areaSelectedChanged()\"><ui-select-match placeholder=\"Area\">{{$item.nom }}</ui-select-match><ui-select-choices repeat=\" area in vm.listeArea | filter: $select.search track by area.id\">{{area.nom }}</ui-select-choices></ui-select><div id=\"selectUsers\"><ui-select tagging multiple=\"multiple\" ng-model=\"vm.userSelected\" theme=\"selectize\" ng-change=\"vm.showCalendar()\"><ui-select-match placeholder=\"User\">{{$item.firstName }} {{$item.lastName }}</ui-select-match><ui-select-choices repeat=\" user in vm.users | filter: $select.search track by user.id\">{{user.firstName }} {{user.lastName }}</ui-select-choices></ui-select><h3><span translate=\"wamasysApp.calendar.tickets\">Tickets</span> <button class=\"btn btn-sm\" ng-click=\"vm.loadAllIssues()\"><span class=\"glyphicon glyphicon-refresh\"></span></button> <button class=\"btn btn-sm\" ng-click=\"vm.printCalendar()\"><span class=\"glyphicon glyphicon-print\"></span></button> <button class=\"btn btn-sm btn-primary\" ng-click=\"vm.openModal()\"><span class=\"glyphicon glyphicon-plus\"></span></button></h3><div><!-- Liste déroulante pour filtrer par tracker \r\n							    <label for=\"trackerFilter\">Filtrer par type :</label>--><ui-select id=\"trackerFilter\" tagging multiple=\"multiple\" ng-model=\"vm.selectedTrackers\" theme=\"selectize\" ng-change=\"vm.filterTasks()\"><ui-select-match placeholder=\"Tracker\">{{$item }}</ui-select-match><ui-select-choices repeat=\" tracker in vm.uniqueTrackers | filter: $select.search \">{{tracker }}</ui-select-choices></ui-select></div><div ng-repeat=\"task in vm.displayedTasks \" class=\"task\" data-duration=\"{{task.duration}}\" data-title=\"{{task.label}}\" data-index=\"{{$index}}\" ng-class=\"{\'with-background-red\': task.issue.priority.id === 13}\">{{task.issue.priority.name}} - {{task.issue.status.name}}<br><span ng-if=\"task.issue.due_date\" ng-class=\"{\'text-danger\': task.issue.due_date <= vm.todayStr}\">{{task.issue.due_date}}<br></span><a style=\"color:white\" href=\"{{vm.user.teamworkUrl}}issues/{{task.issue.id}}\" target=\"_blank\">#{{task.issue.id}}</a> - <small>{{task.issue.project.name}}</small><br>{{task.label}} ({{task.duration}}h)</div></div></div><style><!-- CSS pour simuler des colonnes par utilisateu-->\r\n\r\n \r\n#calendar-container {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr); /* 2 colonnes pour 2 utilisateurs */\r\n    gap: 10px;\r\n}\r\n\r\n.user-column {\r\n    border: 1px solid #ccc;\r\n    padding: 0px;\r\n    background: #f9f9f9;\r\n    position: relative;\r\n}\r\n\r\n.user-header {\r\n    font-weight: bold;\r\n    text-align: center;\r\n    margin: 5px;\r\n    background: #3292E2;\r\n  	border-radius: 6px;\r\n}</style><div class=\"col-md-10 calendar-container\"><div class=\"row\"><div class=\"user-column\" ng-class=\"{\'col-lg-6\': vm.userSelected.length > 1, \'col-lg-12\': vm.userSelected.length === 1}\" ng-repeat=\"user in vm.userSelected\" data-user=\"{{user}}\" ng-drop=\"true\" ng-drop-success=\"vm.onDrop($event, $data, user)\"><div class=\"user-header\">{{ user.firstName }} {{ user.lastName }}</div><div id=\"calendar-{{ $index }}\"></div><!-- Chaque user a un calendrier --></div></div></div></div><!-- MODALE --><div class=\"modal fade\" id=\"eventModal\"><form name=\"editForm\" role=\"form\" novalidate show-validation><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><h5 class=\"modal-title\">{{vm.modalTitle}}</h5><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><input readonly=\"readonly\" type=\"text\" class=\"form-control\" ng-model=\"vm.eventData.id\" maxlength=\"255\"><label translate=\"wamasysApp.calendar.edit.titre\">Titre :</label><input required name=\"title\" id=\"field_title\" type=\"text\" class=\"form-control\" ng-model=\"vm.eventData.title\" maxlength=\"255\"><div ng-show=\"editForm.title.$invalid\"><p class=\"help-block\" ng-show=\"editForm.title.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.title.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div><label translate=\"wamasysApp.calendar.edit.commentaire\">Commentaire :</label><textarea class=\"form-control\" ng-model=\"vm.eventData.comment\"></textarea><!--                     <label>Type :</label>\r\n			                    <select class=\"form-control\" ng-model=\"vm.eventData.type\">\r\n			                        <option value=\"evenement_individuel\">Événement Individuel</option>\r\n			                        <option value=\"evenement_groupe\">Événement Groupe</option>\r\n			                        <option value=\"calendar_client\">Calendar Client</option>\r\n			                    </select>\r\n			 --><label translate=\"wamasysApp.calendar.edit.dateDebut\">Date début :</label><input required name=\"start\" type=\"datetime-local\" class=\"form-control\" ng-model=\"vm.eventData.start\"><div ng-show=\"editForm.start.$invalid\"><p class=\"help-block\" ng-show=\"editForm.start.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><label translate=\"wamasysApp.calendar.edit.dateFin\">Date fin :</label><input required name=\"end\" type=\"datetime-local\" class=\"form-control\" ng-model=\"vm.eventData.end\"><div ng-show=\"editForm.end.$invalid\"><p class=\"help-block\" ng-show=\"editForm.end.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><label translate=\"wamasysApp.calendar.edit.adresse\">Adresse :</label><textarea class=\"form-control\" ng-model=\"vm.eventData.address\"></textarea><label>User :</label><select required name=\"user\" id=\"field_user\" class=\"form-control\" ng-model=\"vm.eventData.user\" ng-options=\"user as (user.firstName + \' \' + user.lastName) for user in vm.users track by user.id\"></select><div ng-show=\"editForm.user.$invalid\"><p class=\"help-block\" ng-show=\"editForm.user.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><label>Teamwork ID :</label><input readonly=\"readonly\" type=\"number\" class=\"form-control\" ng-model=\"vm.eventData.teamworkId\"><label>Teamwork URL :</label><input readonly=\"readonly\" type=\"url\" class=\"form-control\" ng-model=\"vm.eventData.teamworkUrl\"></div><div class=\"modal-footer\"><button class=\"btn btn-success\" ng-click=\"vm.saveEvent()\" ng-disabled=\"editForm.$invalid || vm.isSaving\" translate=\"entity.action.save\">Enregistrer</button> <button class=\"btn btn-danger\" ng-show=\"vm.eventData.id\" ng-click=\"vm.deleteEvent()\" translate=\"entity.action.delete\">Supprimer</button> <button class=\"btn btn-secondary\" data-dismiss=\"modal\" translate=\"entity.action.cancel\">Annuler</button></div></div></div></form></div></div></div></div></div>");
$templateCache.put("app/business/calendar/teamwork-bis.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-12\"><div><div class=\"row\"><div class=\"col-md-12\" has-module=\"TEAM\"><uib-tabset active=\"vm.indextab\"><uib-tab ng-click=\"vm.myIssues()\" index=\"0\"><uib-tab-heading><span>Tickets assigned to me</span></uib-tab-heading></uib-tab><uib-tab ng-click=\"vm.issuesNotAssigned()\" index=\"1\"><uib-tab-heading><span>Tickets not assigned</span></uib-tab-heading></uib-tab><uib-tab ng-click=\"vm.issuesCreatedByMe()\" index=\"2\"><uib-tab-heading><span>Tickets created by me</span></uib-tab-heading></uib-tab></uib-tabset><div class=\"sortable-grid ui-sortable\"><style>.container { display: flex; }\r\n        .list { width: 200px; border: 1px solid black; padding: 10px; }\r\n        .table { flex: 1; margin-left: 20px; }\r\n        table { width: 100%; border-collapse: collapse; }\r\n        th, td { border: 1px solid black; padding: 10px; text-align: center; min-width: 100px; }\r\n        .task { background: lightblue; padding: 5px; margin: 5px; cursor: move; }\r\n        .task {\r\n    cursor: grab;\r\n}\r\n[ng-model] {\r\n    border: 2px dashed red;\r\n    min-height: 50px;\r\n}\r\n        .alert { color: red; font-weight: bold; }</style><div class=\"container\"><div class=\"list\"><select name=\"pets\" id=\"pet-select\"><option value=\"dog\">Area 1</option><option value=\"cat\">Area 2</option></select><select name=\"pets\" id=\"pet-select\"><option value=\"dog\">Tracker 1</option><option value=\"cat\">Tracker 2</option></select><select name=\"pets\" id=\"pet-select\"><option value=\"dog\">User 1 - role worker</option><option value=\"cat\">Tracker 2</option></select><button>ajouter autre Tache</button><h3>Tickets</h3><!-- \r\n		     ng-drag=\"true\"\r\n		     ng-drag-data=\"task\"\r\n		     ng-drag-start=\"vm.onDragStart($data, $event)\"\r\n	    	 --><div ng-repeat=\"task in vm.tasks\" class=\"task\" data-drag=\"true\" data-jqyoui-options=\"{revert: \'invalid\'}\" data-jqyoui-draggable=\"{ onStart: \'vm.onSegmentDragStart(task)\',animate:true, revert: \'invalid\'}\" data-duration=\"{{task.duration}}\">{{task.label}} ({{task.duration}}h)</div></div><div class=\"table\"><table><thead><tr><th>Utilisateur / Jour</th><th ng-repeat=\"day in vm.days\">{{day}}</th></tr></thead><tbody><tr ng-repeat=\"user in vm.users\"><td>{{user}}</td><!-- \r\n						    jqyoui-droppable=\"{onDrop: \'vm.onDrop(task,user, day)\'}\"\r\n						    \r\n						    jqyoui-droppable=\"{onDrop: \'vm.onDrop\'}\"\r\n						    ng-drop=\"true\"\r\n    						ng-drop-success=\"vm.onDrop($data, $event, user, day)\"\r\n						     --><td ng-repeat=\"day in vm.days\" ng-model=\"vm.planning[user][day]\" data-drop=\"true\" jqyoui-droppable=\"{onDrop: \'vm.onDrop(user, day)\'}\" index><div ng-repeat=\"task in vm.planning[user][day]\" class=\"task\" data-drag=\"true\" data-jqyoui-options=\"{revert: \'invalid\'}\" data-jqyoui-draggable=\"{ onStart: \'vm.onSegmentDragStart(task)\',animate:true, revert: \'invalid\'}\">{{task.label}} ({{task.duration}}h)</div><div class=\"alert\" ng-show=\"vm.getTotal(user, day) > 8\">Total: {{vm.getTotal(user, day)}}h (Dépassement!)</div><div ng-hide=\"vm.getTotal(user, day) > 8\">Total: {{vm.getTotal(user, day)}}h</div></td></tr></tbody></table></div></div>jjjj<style>.container { display: flex; }\r\n        .list { width: 200px; border: 1px solid black; padding: 10px; }\r\n        .task { background: lightblue; padding: 5px; margin: 5px; cursor: move; }\r\n        .calendar-container { flex: 1; margin-left: 20px; }\r\n        .alert { color: red; font-weight: bold; margin-top: 10px; }</style><div class=\"calendar-container\"><div id=\"calendar\"></div></div>5555<div class=\"\" id=\"wid-id-5\" data-widget-colorbutton=\"false\" data-widget-editbutton=\"false\" data-widget-togglebutton=\"false\" data-widget-deletebutton=\"false\" data-widget-fullscreenbutton=\"false\" data-widget-custombutton=\"false\" data-widget-collapsed=\"false\" data-widget-sortable=\"false\" role=\"widget\"><br><div role=\"content\"><div class=\"widget-body no-padding\"><div class=\"table-responsive no-margin custom-scroll\" style=\"height:500px; overflow-y: scroll\"><table class=\"table highlight table-border-0 table-hover table-condensed\"><thead><tr><th>subject</th><th class=\"\">priority</th><th class=\"\">status</th><th class=\"\">tracker</th><th ng-show=\"vm.issuefilter != \'createdbyme\'\">author</th><th ng-show=\"vm.issuefilter != \'myissues\'\">Assigned to</th><th class=\"\">Last updated</th></tr></thead><tbody><tr ng-repeat=\"issue in vm.listIssues.issues track by issue.id\"><td class=\"v-align-m\"><a href=\"{{vm.user.calendarUrl}}/issues/{{issue.id}}\" target=\"_blank\">{{issue.subject}}</a></td><td class=\"v-align-m\">{{issue.priority.name}}</td><td class=\"v-align-m\">{{issue.status.name}}</td><td class=\"v-align-m\">{{issue.tracker.name}}</td><td ng-show=\"vm.issuefilter != \'createdbyme\'\" class=\"v-align-m\">{{issue.author.name}}</td><td ng-show=\"vm.issuefilter != \'myissues\'\" class=\"v-align-m\">{{issue.assigned_to.name}}</td><td class=\"v-align-m\">{{issue.updated_on}}</td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/business/communication-topic-category/communication-topic-category-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.communicationTopicCategory.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.communicationTopicCategory.delete.question\" translate-values=\"{id: \'{{vm.communicationTopicCategory.id}}\'}\">Are you sure you want to delete this CommunicationTopicCategory?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/communication-topic-category/communication-topic-category-detail.html","<div><h2><span translate=\"wamasysApp.communicationTopicCategory.detail.title\">CommunicationTopicCategory</span> {{vm.communicationTopicCategory.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"global.field.code\">Code</span></dt><dd><span>{{vm.communicationTopicCategory.code}}</span></dd><hr><dt><span translate=\"wamasysApp.communicationTopicCategory.label\">Libelle</span></dt><dd><span>{{vm.communicationTopicCategory.label}}<span></span></span></dd><hr><dt><span translate=\"global.field.isDeleted\">isDeleted</span></dt><dd><span>{{vm.communicationTopicCategory.deleted}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/communication-topic-category/communication-topic-category-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCommunicationTopicCategoryLabel\" translate=\"wamasysApp.communicationTopicCategory.home.createOrEditLabel\">Create or edit a CommunicationTopicCategory</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"global.field.code\" for=\"field_code\">Code</label><input ng-readonly=\"vm.communicationTopicCategory.id != null\" required type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.communicationTopicCategory.code\" ng-maxlength=\"64\" ng-pattern=\"/^[_.A-Z0-9-]*$/\"><div ng-show=\"editForm.label.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.pattern\" translate=\"wamasysApp.communicationTopicCategory.codeArticleFormatError\">The article code can only contain upper-case letters and digits.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"64\">This field cannot be longer than 64 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.communicationTopicCategory.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.communicationTopicCategory.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.communicationTopicCategory.label\" for=\"field_label\">Libelle</label><input type=\"text\" class=\"form-control\" name=\"label\" id=\"field_label\" ng-model=\"vm.communicationTopicCategory.label\" required ng-maxlength=\"50\"><div ng-show=\"editForm.label.$invalid\"><p class=\"help-block\" ng-show=\"editForm.label.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.label.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.communicationTopicCategory.id\"><label class=\"control-deleted\" translate=\"global.field.isDeleted\" for=\"field_deleted\">deleted</label><input type=\"checkbox\" class=\"form-control\" name=\"deleted\" id=\"field_deleted\" ng-model=\"vm.communicationTopicCategory.deleted\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/communication-topic-category/communication-topic-categorys.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.communicationTopicCategory.home.title\">CommunicationTopicCategorys</span> <small class=\"text-muted\" translate=\"global.configurationScope.organization\">Paramétrage commun à toute l\'organisation</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"communication-topic-category.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.communicationTopicCategory.home.createLabel\">Create new CommunicationTopicCategory</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"label\"><span translate=\"wamasysApp.communicationTopicCategory.label\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"global.field.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deleted\"><span translate=\"global.field.isDeleted\">isDeleted</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"communicationTopicCategory in vm.communicationTopicCategorys track by communicationTopicCategory.id\"><td><a ui-sref=\"communication-topic-category-detail({id:communicationTopicCategory.id})\">{{communicationTopicCategory.id}}</a></td><td>{{communicationTopicCategory.label}}</td><td>{{communicationTopicCategory.code}}</td><td>{{communicationTopicCategory.deleted}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"communication-topic-category-detail({id:communicationTopicCategory.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"communication-topic-category.edit({id:communicationTopicCategory.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"communication-topic-category.delete({id:communicationTopicCategory.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/cout-achat-eau/cout-achat-eau-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.coutAchatEau.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.coutAchatEau.delete.question\" translate-values=\"{id: \'{{vm.coutAchatEau.id}}\'}\">Are you sure you want to delete this CoutAchatEau?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/cout-achat-eau/cout-achat-eau-detail.html","<div><h2><span translate=\"wamasysApp.coutAchatEau.detail.title\">CoutAchatEau</span> {{vm.coutAchatEau.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.coutAchatEau.dateAjout\">DateAjout</span></dt><dd><span>{{vm.coutAchatEau.dateAjout | date:\'medium\'}}</span></dd><hr><dt><span translate=\"wamasysApp.coutAchatEau.cout\">Cout</span></dt><dd><span>{{vm.coutAchatEau.cout}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.coutAchatEau.distributeur\">distributeur</span></dt><dd><span>{{vm.coutAchatEau.distributeur}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.coutAchatEau.commentaire\">commentaire</span></dt><dd><span>{{vm.coutAchatEau.commentaire}}<span></span></span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/cout-achat-eau/cout-achat-eau-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCoutAchatEauLabel\" translate=\"wamasysApp.coutAchatEau.home.createOrEditLabel\">Create or edit a CoutAchatEau</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.coutAchatEau.dateAjout\" for=\"field_dateAjout\">DateAjout</label><div class=\"input-group\"><input id=\"field_dateAjout\" type=\"text\" class=\"form-control\" name=\"dateAjout\" datetime-picker=\"{{dateformat}}\" ng-click=\"vm.openCalendar(\'dateAjout\')\" ng-model=\"vm.coutAchatEau.dateAjout\" is-open=\"vm.datePickerOpenStatus.dateAjout\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateAjout\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.dateAjout.$invalid\"><p class=\"help-block\" ng-show=\"editForm.dateAjout.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.dateAjout.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.coutAchatEau.distributeur\" for=\"field_distributeur\">Distributeur</label><input type=\"text\" class=\"form-control\" name=\"distributeur\" id=\"field_distributeur\" ng-model=\"vm.coutAchatEau.distributeur\" required ng-maxlength=\"256\"><div ng-show=\"editForm.distributeur.$invalid\"><p class=\"help-block\" ng-show=\"editForm.distributeur.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.coutAchatEau.commentaire\" for=\"field_commentaire\">Commentaire</label><textarea class=\"form-control\" name=\"commentaire\" id=\"field_commentaire\" ng-model=\"vm.coutAchatEau.commentaire\" rows=\"3\" ng-maxlength=\"2048\"></textarea><div ng-show=\"editForm.commentaire.$invalid\"><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"2048\">This field cannot be longer than 2048 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.coutAchatEau.cout\" for=\"field_cout\">Cout</label><input type=\"number\" class=\"form-control\" name=\"cout\" id=\"field_cout\" ng-model=\"vm.coutAchatEau.cout\" required min=\"0\" max=\"999999999\"><div ng-show=\"editForm.cout.$invalid\"><p class=\"help-block\" ng-show=\"editForm.cout.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.cout.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.cout.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999999\">This field cannot be more than 999999999.</p><p class=\"help-block\" ng-show=\"editForm.cout.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"alert alert-warning\"><span translate=\"wamasysApp.coutAchatEau.explicationCoutAchatEau\"></span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/cout-achat-eau/cout-achat-eaus.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.coutAchatEau.home.title\">CoutAchatEaus</span> <small class=\"text-muted\" translate=\"global.configurationScope.zone\">Paramétrage propre à la zone</small></h2><jhi-alert></jhi-alert><div class=\"alert alert-info\" translate=\"wamasysApp.coutAchatEau.explicationCoutAchatEau\"></div><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"cout-achat-eau.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.coutAchatEau.home.createLabel\">Create new CoutAchatEau</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"dateAjout\"><span translate=\"wamasysApp.coutAchatEau.dateAjout\">DateAjout</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"cout\"><span translate=\"wamasysApp.coutAchatEau.cout\">Cout</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"distributeur\"><span translate=\"wamasysApp.coutAchatEau.distributeur\">distributeur</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"coutAchatEau in vm.coutAchatEaus track by coutAchatEau.id\"><td><a ui-sref=\"cout-achat-eau-detail({id:coutAchatEau.id})\">{{coutAchatEau.dateAjout | date:\'medium\'}}</a></td><td>{{coutAchatEau.cout}}</td><td>{{coutAchatEau.distributeur}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"cout-achat-eau-detail({id:coutAchatEau.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"cout-achat-eau.edit({id:coutAchatEau.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"cout-achat-eau.delete({id:coutAchatEau.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/channel-conf/channel-conf-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.channelConf.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.channelConf.delete.question\" translate-values=\"{id: \'{{vm.channelConf.id}}\'}\">Are you sure you want to delete this ChannelConf?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/channel-conf/channel-conf-detail.html","<div><h2><span translate=\"wamasysApp.channelConf.detail.title\">ChannelConf</span> {{vm.channelConf.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.channelConf.nom\">nom</span></dt><dd><span>{{vm.channelConf.nom}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.channelConf.channel\">channel</span></dt><dd><span>{{vm.channelConf.channel}}</span></dd><hr><dt><span translate=\"wamasysApp.channelConf.configuration\">configuration</span></dt><dd><span>{{vm.channelConf.configuration}}<span></span></span></dd><hr><dt>Quota 30 jours</dt><dd><span>Limite configuree: {{vm.channelConf.limit30Days || \'non definie\'}}</span><br><span>Utilises sur les 30 derniers jours: {{vm.channelConf.used30Days || 0}}</span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/channel-conf/channel-conf-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myChannelConfLabel\" translate=\"wamasysApp.channelConf.home.createOrEditLabel\">Create or edit a ChannelConf</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><libelle for=\"id\" translate=\"global.field.id\">ID</libelle><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.channelConf.id\" readonly=\"readonly\"></div><div class=\"form-group\"><libelle class=\"control-label\" translate=\"wamasysApp.channelConf.nom\" for=\"field_nom\">nom</libelle><input type=\"text\" class=\"form-control\" name=\"nom\" id=\"field_nom\" ng-model=\"vm.channelConf.nom\" required ng-maxlength=\"50\"><div ng-show=\"editForm.nom.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nom.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nom.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label for=\"field_channel\">Channel</label><select class=\"form-control\" id=\"field_channel\" ng-model=\"vm.channelConf.channel\" ng-change=\"vm.onChannelChange()\" ng-options=\"c.name as c.label for c in vm.channels\"></select></div><div class=\"row\" ng-if=\"vm.getVisibleConfigurationFields().length\"><div class=\"col-md-6\" ng-repeat=\"field in vm.getVisibleConfigurationFields() track by field.key\"><div class=\"form-group\" ng-if=\"field.inputType !== \'checkbox\'\"><label class=\"control-label\">{{field.label}}</label><input class=\"form-control\" type=\"{{field.inputType || \'text\'}}\" ng-model=\"vm.configurationFields[field.key]\" ng-change=\"vm.onStructuredFieldChange()\" placeholder=\"{{field.placeholder}}\"></div><div class=\"checkbox\" ng-if=\"field.inputType === \'checkbox\'\"><label><input type=\"checkbox\" ng-model=\"vm.configurationFields[field.key]\" ng-change=\"vm.onStructuredFieldChange()\"> {{field.label}}</label></div></div></div><div class=\"alert alert-info\" ng-if=\"vm.channelConf.id\"><strong>Quota 30 jours</strong><br>Limite configuree: {{vm.channelConf.limit30Days || \'non definie\'}}<br>Utilises sur les 30 derniers jours: {{vm.channelConf.used30Days || 0}}</div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.channelConf.configuration\" for=\"field_configuration\">configuration</label><textarea required type=\"text\" class=\"form-control\" name=\"configuration\" id=\"field_configuration\" ng-model=\"vm.channelConf.configuration\" ng-change=\"vm.onConfigurationTextChange()\" ng-maxlength=\"4098\">\n                    </textarea><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.configuration.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.configuration.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"4098\">This field cannot be longer than 4098 characters.</p></div><p class=\"help-block\">Les champs ci-dessus alimentent automatiquement ce JSON. Vous pouvez aussi ajouter manuellement des cles complementaires ici.</p><p class=\"help-block\"><strong>Exemple :</strong> <code>{{vm.getCurrentExample()}}</code></p></div><div class=\"alert alert-danger\" ng-if=\"vm.configurationError\">{{vm.configurationError}}</div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/channel-conf/channel-conf-test-message-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.send()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\">Test d’envoi - {{vm.channelConf.nom || (\'...\' )}}</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Channel</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.channelConf.nom\" readonly=\"readonly\"></div><div class=\"form-group\" ng-class=\"{\'has-error\': editForm.recipient.$invalid && editForm.$submitted}\"><label>Destinataire</label><input type=\"text\" class=\"form-control\" name=\"recipient\" ng-model=\"vm.form.recipient\" ng-required=\"true\" maxlength=\"255\" placeholder=\"Téléphone ou email selon le channel\"><div ng-show=\"editForm.recipient.$invalid && editForm.$submitted\" class=\"help-block\">Destinataire obligatoire.</div></div><div class=\"form-group\" ng-class=\"{\'has-error\': editForm.subject.$invalid && editForm.$submitted}\" ng-if=\"vm.channelConf.channel == \'EMAIL_SENDBLUE\' || vm.channelConf.channel == \'EMAIL_SMTP\'\"><label>Titre</label><input type=\"text\" class=\"form-control\" name=\"subject\" ng-model=\"vm.form.subject\" maxlength=\"255\" placeholder=\"Sujet (email) ou titre (notification)\"><div ng-show=\"editForm.subject.$invalid && editForm.$submitted\" class=\"help-block\">Titre obligatoire.</div></div><div class=\"form-group\"><label>Message (texte)</label><textarea class=\"form-control\" rows=\"6\" ng-model=\"vm.form.messageText\" maxlength=\"4000\" placeholder=\"Message texte...\"></textarea></div><div class=\"form-group\" ng-if=\"vm.channelConf.channel == \'EMAIL_SENDBLUE\' || vm.channelConf.channel == \'EMAIL_SMTP\'\"><label>Message (HTML)</label><textarea class=\"form-control\" rows=\"8\" ng-model=\"vm.form.messageHtml\" maxlength=\"20000\" placeholder=\"<h1>...</h1>\"></textarea><p class=\"help-block\">Si rempli, le backend peut prioriser le HTML pour l’email (avec alternative texte).</p></div><div class=\"alert alert-success\" ng-if=\"vm.result && vm.result.success\">{{vm.result.message}}</div><div class=\"alert alert-danger\" ng-if=\"vm.result && !vm.result.success\">{{vm.result.message}}</div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;Annuler</button> <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.sending\"><span class=\"glyphicon glyphicon-send\"></span>&nbsp;Envoyer</button></div></form>");
$templateCache.put("app/business/channel-conf/channel-confs.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.channelConf.home.title\">ChannelConfs</span> <small class=\"text-muted\" translate=\"global.configurationScope.organization\">Paramétrage commun à toute l\'organisation</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"channel-conf.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.channelConf.home.createLabel\">Create new ChannelConf</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nom\"><span translate=\"wamasysApp.channelConf.nom\">nom</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"channel\"><span translate=\"wamasysApp.channelConf.channel\">channel</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th translate=\"wamasysApp.channelConf.limit30Days\">Limite sur 30 jours</th><th translate=\"wamasysApp.channelConf.used30Days\">Utilisation sur les 30 derniers jours</th><!-- <th jh-sort-by=\"configuration\" ><span translate=\"wamasysApp.channelConf.configuration\">configuration</span> <span class=\"glyphicon glyphicon-sort\"></span></th> --><th></th></tr></thead><tbody><tr ng-repeat=\"channelConf in vm.channelConfs track by channelConf.id\"><td><a ui-sref=\"channel-conf-detail({id:channelConf.id})\">{{channelConf.id}}</a></td><td>{{channelConf.nom}}</td><td>{{channelConf.channel}}</td><td>{{channelConf.limit30Days || \'-\'}}</td><td>{{channelConf.used30Days || 0}}</td><!-- <td > {{channelConf.configuration}}</td> --><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"channel-conf.test-message({id:channelConf.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"wamasysApp.channelConf.btnTest\"></span></button> <button type=\"submit\" ui-sref=\"channel-conf-detail({id:channelConf.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"channel-conf.edit({id:channelConf.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"channel-conf.delete({id:channelConf.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/entite-parente/entite-parente-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.entiteParente.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.entiteParente.delete.question\" translate-values=\"{id: \'{{vm.entiteParente.id}}\'}\">Are you sure you want to delete this EntiteParente?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/entite-parente/entite-parente-detail.html","<div><h2><span translate=\"wamasysApp.entiteParente.detail.title\">EntiteParente</span> {{vm.entiteParente.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"global.field.code\">Code</span></dt><dd><span>{{vm.entiteParente.code}}</span></dd><hr><dt><span translate=\"wamasysApp.entiteParente.nom\">Nom</span></dt><dd><span>{{vm.entiteParente.nom}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/entite-parente/entite-parente-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myEntiteParenteLabel\" translate=\"wamasysApp.entiteParente.home.createOrEditLabel\">Create or edit a EntiteParente</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"global.field.code\" for=\"field_code\">Code</label><input ng-readonly=\"vm.entiteParente.id != null\" required type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.entiteParente.code\" ng-maxlength=\"64\" ng-pattern=\"/^[_.A-Z0-9-]*$/\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.pattern\" translate=\"wamasysApp.entiteParente.codeArticleFormatError\">The article code can only contain upper-case letters and digits.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"64\">This field cannot be longer than 64 characters.</p></div></div><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.entiteParente.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.entiteParente.nom\" for=\"field_nom\">Nom</label><input type=\"text\" class=\"form-control\" name=\"nom\" id=\"field_nom\" ng-model=\"vm.entiteParente.nom\" required ng-maxlength=\"50\"><div ng-show=\"editForm.nom.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nom.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nom.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/entite-parente/entite-parentes.html","<div><h2 translate=\"wamasysApp.entiteParente.home.title\">EntiteParentes</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"entite-parente.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.entiteParente.home.createLabel\">Create new EntiteParente</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nom\"><span translate=\"wamasysApp.entiteParente.nom\">Nom</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"global.field.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"entiteParente in vm.entiteParentes track by entiteParente.id\"><td><a ui-sref=\"entite-parente-detail({id:entiteParente.id})\">{{entiteParente.id}}</a></td><td>{{entiteParente.nom}}</td><td>{{entiteParente.code}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"entite-parente-detail({id:entiteParente.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"entite-parente.edit({id:entiteParente.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"entite-parente.delete({id:entiteParente.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/cluster/cluster-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.cluster.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.cluster.delete.question\" translate-values=\"{id: \'{{vm.cluster.id}}\'}\">Are you sure you want to delete this Cluster?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/cluster/cluster-detail.html","<div><h2><span translate=\"wamasysApp.cluster.detail.title\">Cluster</span> {{vm.cluster.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.cluster.numeroSerie\">NumeroSerie</span></dt><dd><span>{{vm.cluster.numeroSerie}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.cluster.emplacement\">Emplacement</span></dt><dd><span>{{vm.cluster.emplacement}}<span></span></span></dd><dt><span translate=\"wamasysApp.bulkMeter.waterNetwork\">waterNetwork</span></dt><dd><span>{{vm.bulkMeter.waterNetwork.label}}</span></dd><hr><hr><dt><span translate=\"wamasysApp.cluster.etat\">Etat</span></dt><dd><span translate=\"{{\'wamasysApp.EtatCluster.\' + vm.cluster.etat}}\">{{vm.cluster.etat}}</span></dd><hr><div ng-show=\"vm.cluster.etat == \'DELETED\'\"><dt><span translate=\"wamasysApp.cluster.dateSuppression\">DateSuppression</span></dt><dd><span>{{vm.cluster.dateSuppression | date:\'medium\'}}</span></dd><hr></div><!-- \n        <dt><span translate=\"wamasysApp.cluster.longitude\">Longitude</dt></dt>\n        <dd>\n            <span>{{vm.cluster.longitude}}<span>\n        </dd>\n        <hr>\n        <dt><span translate=\"wamasysApp.cluster.latitude\">Latitude</dt></dt>\n        <dd>\n            <span>{{vm.cluster.latitude}}<span>\n        </dd>\n        <hr>\n --><dt><span translate=\"wamasysApp.cluster.collecteur\">collecteur</span></dt><dd>{{vm.cluster.collecteur.firstName + \' \' + vm.cluster.collecteur.lastName}}</dd><hr><dt><span translate=\"wamasysApp.cluster.commentaire\">Commentaire</span></dt><dd><span>{{vm.cluster.commentaire }}</span></dd><hr><dt><span translate=\"global.field.code\">Code</span></dt><dd><span>{{vm.cluster.code}}</span></dd><hr><div jarvis-widget id=\"hide-show-columns-table-widget\" data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"><header><span class=\"widget-icon\"><i class=\"fa fa-table\"></i></span><h2 translate=\"wamasysApp.cluster.meterslist\">Liste compteurs</h2></header><div><div class=\"widget-body no-padding table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th translate=\"wamasysApp.individualMeter.numeroSerie\">Numero Serie</th><!-- 		<th translate=\"wamasysApp.individualMeter.contrat\">contrat référence</th>\n										<th translate=\"wamasysApp.individualMeter.nomContrat\">nom contrat</th>\n										 --><th translate=\"wamasysApp.individualMeter.runningOrder\">runningOrder</th><th translate=\"wamasysApp.individualMeter.etat\">Etat</th></tr></thead><tbody><tr ng-repeat=\"individualMeter in vm.individualMeterList\"><td><a ui-sref=\"individual-meter-detail({id:individualMeter.id})\">{{individualMeter.numeroSerie}}</a></td><!-- <td><a ui-sref=\"contrat-detail.information({id:individualMeter.contrat.id})\">{{individualMeter.contrat.referenceContrat}}</a></td>\n										<td>{{individualMeter.contrat.nomPersonne}}</td> --><td>{{individualMeter.runningOrder}}</td><td translate=\"{{\'wamasysApp.EtatMeter.\' + individualMeter.etat}}\">{{individualMeter.etat}}</td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div><!-- end widget content --></div><!-- end widget div --><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/cluster/cluster-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myClusterLabel\" translate=\"wamasysApp.cluster.home.createOrEditLabel\">Create or edit a Cluster</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.cluster.numeroSerie\" for=\"field_numeroSerie\">NumeroSerie</label><input required type=\"text\" class=\"form-control\" name=\"numeroSerie\" id=\"field_numeroSerie\" ng-model=\"vm.cluster.numeroSerie\" ng-maxlength=\"50\"><div ng-show=\"editForm.numeroSerie.$invalid\"><p class=\"help-block\" ng-show=\"editForm.numeroSerie.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.numeroSerie.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.cluster.waterNetwork\">waterNetwork</label><select required class=\"form-control\" id=\"field_waterNetwork\" name=\"waterNetwork\" ng-model=\"vm.cluster.waterNetwork\" ng-options=\"waterNetwork as waterNetwork.label for waterNetwork in vm.waterNetworks track by waterNetwork.id\"><option value=\"\"></option></select><div ng-show=\"editForm.waterNetwork.$invalid\"><p class=\"help-block\" ng-show=\"editForm.waterNetwork.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.cluster.emplacement\" for=\"field_emplacement\">Emplacement</label><input type=\"text\" class=\"form-control\" name=\"emplacement\" id=\"field_emplacement\" ng-model=\"vm.cluster.emplacement\" ng-maxlength=\"256\"><div ng-show=\"editForm.emplacement.$invalid\"><p class=\"help-block\" ng-show=\"editForm.emplacement.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div><!-- \n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"wamasysApp.cluster.etat\" for=\"field_etat\">Etat</label>\n            <select class=\"form-control\" name=\"etat\" ng-model=\"vm.cluster.etat\" id=\"field_etat\">\n                <option value=\"ACTIVE\" translate=\"wamasysApp.EtatCluster.ACTIVE\">ACTIVE</option>\n                <option value=\"DELETED\" translate=\"wamasysApp.EtatCluster.DELETED\">DELETED</option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"wamasysApp.cluster.dateSuppression\" for=\"field_dateSuppression\">DateSuppression</label>\n                <div class=\"input-group\">\n                    <input id=\"field_dateSuppression\" type=\"text\" class=\"form-control\" name=\"dateSuppression\" ng-click=\"vm.openCalendar(\'dateSuppression\')\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.cluster.dateSuppression\" is-open=\"vm.datePickerOpenStatus.dateSuppression\"\n                      />\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateSuppression\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n                    </span>\n                </div>\n        </div> --><!-- \n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"wamasysApp.cluster.longitude\" for=\"field_longitude\">Longitude</label>\n            <input type=\"text\" class=\"form-control\" name=\"longitude\" id=\"field_longitude\"\n                    ng-model=\"vm.cluster.longitude\"\n                    ng-maxlength=\"20\" />\n            <div ng-show=\"editForm.longitude.$invalid\">\n                <p class=\"help-block\"\n                    ng-show=\"editForm.longitude.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"20\">\n                    This field cannot be longer than 20 characters.\n                </p>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"wamasysApp.cluster.latitude\" for=\"field_latitude\">Latitude</label>\n            <input type=\"text\" class=\"form-control\" name=\"latitude\" id=\"field_latitude\"\n                    ng-model=\"vm.cluster.latitude\"\n                    ng-maxlength=\"20\" />\n            <div ng-show=\"editForm.latitude.$invalid\">\n                <p class=\"help-block\"\n                    ng-show=\"editForm.latitude.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"20\">\n                    This field cannot be longer than 20 characters.\n                </p>\n            </div>\n        </div>\n         --><!-- \n        <div class=\"form-group\">\n            <label translate=\"wamasysApp.cluster.agence\" for=\"field_agence\">agence</label>\n            <select class=\"form-control\" id=\"field_agence\" name=\"agence\" ng-model=\"vm.cluster.agence\" ng-options=\"agence as agence.id for agence in vm.agences track by agence.id\">\n                <option value=\"\"></option>\n            </select>\n        </div>\n        --><div class=\"form-group\"><label translate=\"wamasysApp.cluster.collecteur\" for=\"field_collecteur\">collecteur</label><select required class=\"form-control\" id=\"field_collecteur\" name=\"collecteur\" ng-model=\"vm.cluster.collecteur\" ng-options=\"user as (user.firstName + \' \' + user.lastName) for user in vm.users track by user.id\"><option value=\"\"></option></select><div ng-show=\"editForm.collecteur.$invalid\"><p class=\"help-block\" ng-show=\"editForm.collecteur.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.cluster.commentaire\" for=\"field_commentaire\">Commentaire</label><textarea type=\"text\" class=\"form-control\" name=\"commentaire\" id=\"field_commentaire\" ng-model=\"vm.cluster.commentaire\" ng-maxlength=\"256\"></textarea><div ng-show=\"editForm.commentaire.$invalid\"><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/cluster/clusters.html","<div><div class=\"container-fluid padding-top-10\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"compteur.cluster.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.cluster.home.createLabel\">Create new Cluster</span></button></div></div></div><div class=\"table-responsive padding-top-10\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"numeroSerie\"><span translate=\"wamasysApp.cluster.numeroSerie\">NumeroSerie</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--     <th jh-sort-by=\"emplacement\"><span translate=\"wamasysApp.cluster.emplacement\">Emplacement</span> <span class=\"glyphicon glyphicon-sort\"></span></th>   --><th jh-sort-by=\"etat\"><span translate=\"wamasysApp.cluster.etat\">Etat</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"collecteur.login\"><span translate=\"wamasysApp.cluster.collecteur\">collecteur</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"waterNetwork\"><span translate=\"wamasysApp.cluster.waterNetwork\">waterNetwork</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"cluster in vm.clusters track by cluster.id\"><td><a ui-sref=\"cluster-detail({id:cluster.id})\">{{cluster.numeroSerie}}</a></td><!--     <td>{{cluster.emplacement}}</td>     --><td translate=\"{{\'wamasysApp.EtatCluster.\' + cluster.etat}}\">{{cluster.etat}}</td><td>{{cluster.collecteur.firstName + \' \' + cluster.collecteur.lastName}}</td><td>{{cluster.waterNetwork.label}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"cluster-detail({id:cluster.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"compteur.cluster.edit({id:cluster.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"compteur.cluster.delete({id:cluster.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/collecteur/collecteur-detail.html","<div><h2><span translate=\"wamasysApp.collecteur.detail.title\">Collecteur</span> {{vm.user.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"userManagement.login\">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><hr><dt><span translate=\"userManagement.firstName\">First Name</span></dt><dd><span>{{vm.user.firstName}}</span></dd><hr><dt><span translate=\"userManagement.lastName\">Last Name</span></dt><dd><span>{{vm.user.lastName}}</span></dd><!-- 		<hr> --><!-- 		<dt> --><!-- 			<span translate=\"wamasysApp.collecteur.agence\">agence</span> --><!-- 		</dt> --><!-- 		<dd> --><!-- 			<a ui-sref=\"agence-detail({id:vm.user.agence.id})\">{{vm.user.agence.nom}}</a> --><!-- 		</dd> --><hr></dl><br><!-- Widget ID (each widget will need unique ID)--><div jarvis-widget id=\"form-grid-widget\" data-widget-colorbutton=\"false\" data-widget-editbutton=\"false\" data-widget-custombutton=\"false\"><header><h2 translate=\"wamasysApp.collecteur.argentcollecte\">Suivi argent collecté</h2></header><!-- widget div--><div><!-- widget content --><div class=\"widget-body\"><form class=\"form-horizontal\"><br><fieldset><div class=\"form-group\"><label class=\"control-label col-md-2\" for=\"daterange1\" translate=\"wamasysApp.collecteur.perioderecherche\">Période recherchée</label><div class=\"col-md-8\"><div class=\"input-group\"><input date-range-picker id=\"daterange1\" name=\"daterange1\" class=\"form-control date-picker\" type=\"text\" ng-model=\"date\" required options=\"opts\"><div class=\"input-group-btn\"><button ng-click=\"openRangeDateTimePicker()\" class=\"btn btn-default\" type=\"button\"><span class=\"glyphicon glyphicon-calendar\"></span></button></div></div></div><div class=\"col-md-2\"><button class=\"btn btn-primary\" ng-click=\"vm.searchCollecteur()\">Search</button></div></div></fieldset></form><div id=\"msgAucunResultatTrouve\" class=\"alert alert-warning\" ng-show=\"vm.aucunResultatTrouve == true\" translate=\"wamasysApp.collecteur.aucunresultattrouve\">Aucun résultat n\'a été trouvé.</div><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th translate=\"wamasysApp.collecteur.typeservice\">Type service</th><th translate=\"wamasysApp.collecteur.service\">Service</th><th translate=\"wamasysApp.collecteur.totalCorrectionPayement\">Total correction Payment</th><th translate=\"wamasysApp.collecteur.totalcollecte\">Total collecte</th></tr></thead><tbody><tr ng-repeat=\"reportCollectionList in vm.reportCollectionList track by reportCollectionList.serviceVendu.id\"><td>{{reportCollectionList.typeService.libelle}}</td><td>{{reportCollectionList.serviceVendu.libelle}}</td><td>{{reportCollectionList.totalCorrectionPaiement}}</td><td>{{reportCollectionList.totalCollecte + reportCollectionList.totalCorrectionPaiement}}</td></tr></tbody></table></div></div></div></div><hr><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/collecteur/collecteur-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myUserLabel\" translate=\"\">Create or edit a Collecteur</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.login\">Login</label><input type=\"text\" class=\"form-control\" name=\"login\" ng-model=\"vm.user.login\" ng-required=\"vm.user.id == null\" ng-maxlength=\"50\" ng-pattern=\"\'^[a-z0-9]*$|(anonymousUser)\'\"><div ng-show=\"editForm.login.$invalid\"><p class=\"help-block\" ng-show=\"editForm.login.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.login.$error.pattern\" translate=\"error.user.loginPattern\">Erreur le loggin ne doit pas contenir d\'espace</p><p class=\"help-block\" ng-show=\"editForm.login.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.firstName\">FirstName</label><input type=\"text\" class=\"form-control\" name=\"firstName\" ng-model=\"vm.user.firstName\" ng-maxlength=\"50\"><div ng-show=\"editForm.firstName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.firstName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"userManagement.lastName\">LastName</label><input type=\"text\" class=\"form-control\" name=\"lastName\" ng-model=\"vm.user.lastName\" ng-maxlength=\"50\"><div ng-show=\"editForm.lastName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.email\">Email</label><input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"vm.user.email\" required ng-maxlength=\"100\"><div ng-show=\"editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p></div></div><div class=\"form-group\"><label for=\"activated\"><input ng-disabled=\"vm.user.id === null\" type=\"checkbox\" id=\"activated\" ng-model=\"vm.user.activated\"> <span translate=\"userManagement.activated\">Activated</span></label></div><div class=\"form-group\"><label translate=\"userManagement.langKey\">LangKey</label><select class=\"form-control\" name=\"langKey\" ng-model=\"vm.user.langKey\" ng-options=\"language as language for language in vm.languages track by language\"></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/collecteur/collecteurs.html","<div><h2 translate=\"wamasysApp.collecteur.home.title\">Collecteurs</h2><jhi-alert></jhi-alert><!-- \r\n        <div class=\"container-fluid\">\r\n        <div class=\"row\">\r\n            <div class=\"col-xs-12 no-padding-left pull-right\">\r\n                <button class=\"btn btn-primary\" ui-sref=\"collecteur.new\" >\r\n                    <span class=\"glyphicon glyphicon-plus\"></span>\r\n                    <span  translate=\"wamasysApp.collecteur.home.createLabel\">\r\n                        Create new Collecteur\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n     --><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"login\"><span translate=\"userManagement.login\">login</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastName\"><span translate=\"userManagement.firstName\">Nom</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"firstName\"><span translate=\"userManagement.lastName\">Prenom</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agence.id\"><span translate=\"wamasysApp.collecteur.agence\">agence</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users track by user.id\"><td><a ui-sref=\"collecteur-detail({login:user.login})\">{{user.login}}</a></td><td>{{user.firstName}}</td><td>{{user.lastName}}</td><td><a ui-sref=\"agence-detail({id:user.agence.id})\">{{user.agence.nom}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"collecteur-detail({login:user.login})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/contrat/activation-contrat-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myImpactPenalitRemiseRegulLabel\" translate=\"wamasysApp.contrat.informationContrat.titreActivationContrat\">Confirmation activation contrat</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!--          <div class=\"alert alert-warning\" translate=\"wamasysApp.contrat.informationContrat.texteActivationContrat\">\n           La date d\'activation est utilisée sur les lignes de contrat, elle est utile pour les contrats ayant une facturation à la journée pour indiquer le jour de reprise.\n          <br> Attention la date d\'activation initiale sur le contrat n\'est pas modifiée.\n   </div> --><!--         <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"wamasysApp.contrat.dateActivation\" for=\"field_dateActivation\">Nouvelle date d\'activation sur les lignes de service</label>\n                <div class=\"input-group\">\n                    <input id=\"field_dateActivation\" type=\"text\" class=\"form-control\" name=\"dateActivation\" ng-click=\"vm.openCalendar(\'dateActivation\')\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.dateActivation\" is-open=\"vm.datePickerOpenStatus.dateActivation\"\n                    required/>\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateActivation\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n                    </span>\n                </div>\n            <div ng-show=\"editForm.dateActivation.$invalid\">\n                <p class=\"help-block\"\n                    ng-show=\"editForm.dateActivation.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n            </div>\n        </div> --></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.ok\">Save</span></button></div></form>");
$templateCache.put("app/business/contrat/billing-contract-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPaiementInitialLabel\" translate=\"wamasysApp.contrat.service.etablirFacturation\">etablirFacturation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!--         <div class=\"form-group\"> --><!--             <label class=\"control-label\" translate=\"wamasysApp.contrat.service.dateFacturation\" for=\"field_dateFacturation\">dateFacturation</label> --><!--                 <div class=\"input-group\"> --><!--                     <input id=\"field_dateFacturation\" type=\"text\" class=\"form-control\" name=\"dateFacturation\"  uib-datepicker-popup=\"{{dateformat}}\"  ng-model=\"vm.dateFacturation\" is-open=\"vm.datePickerOpenStatus.dateFacturation\" --><!--                     required  /> --><!--                     <span class=\"input-group-btn\"> --><!--                         <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateFacturation\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button> --><!--                     </span> --><!--                 </div> --><!--             <div ng-show=\"editForm.datePaiement.$invalid\"> --><!--                 <p class=\"help-block\" --><!--                     ng-show=\"editForm.dateFacturation.$error.required\" translate=\"entity.validation.required\"> --><!--                     This field is required. --><!--                 </p> --><!--                 <p class=\"help-block\" --><!--                     ng-show=\"editForm.dateFacturation.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\"> --><!--                     This field should be a date and time. --><!--                 </p> --><!--             </div> --><!--         </div> --><p translate=\"wamasysApp.contrat.service.confirmBilling\">Etes vous sûr de vouloir générer une mise en facturation?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.ok\">Ok</span></button></div></form>");
$templateCache.put("app/business/contrat/changer-compteur-contrat-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myHistoriqueCompteurContratLabel\" translate=\"wamasysApp.contrat.informationContrat.titreChangementCompteur\">Create or edit a HistoriqueCompteurContrat</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"wamasysApp.contrat.individualMeter\" for=\"field_individualMeter\">individualMeter</label><select class=\"form-control\" id=\"field_individualMeter\" name=\"individualMeter\" ng-model=\"vm.historiqueCompteurContrat.individualMeter\" ng-options=\"individualMeter as individualMeter.numeroSerie  for individualMeter in vm.individualmeters track by individualMeter.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"wamasysApp.contrat.informationContrat.valeurPrecedenteLecture\">valeurPrecedenteLecture</label>:<label>{{vm.historiqueCompteurContrat.individualMeter.valeurPrecedenteLecture}}</label></div><div class=\"form-group\"><label translate=\"wamasysApp.contrat.informationContrat.valeurInitialeFacturation\" for=\"field_valeurInitialeFacturation\">valeurInitialeFacturation</label><input type=\"number\" class=\"form-control\" name=\"valeurInitialeFacturation\" id=\"field_valeurInitialeFacturation\" ng-model=\"vm.historiqueCompteurContrat.valeurInitialeFacturation\" required min=\"0\" max=\"999999999999\" placeholder=\"{{ \'wamasysApp.contrat.informationContrat.valeurInitialeFacturation\' | translate }}\"><div ng-show=\"editForm.valeurInitialeFacturation.$invalid\"><p class=\"help-block\" ng-show=\"editForm.valeurInitialeFacturation.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.valeurInitialeFacturation.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.valeurInitialeFacturation.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999999999\">This field cannot be more than 999999999999.</p><p class=\"help-block\" ng-show=\"editForm.valeurInitialeFacturation.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/contrat/cloturation-contrat-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.nextStep()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myImpactPenalitRemiseRegulLabel\" translate=\"wamasysApp.contrat.informationContrat.titreCloturationContrat\">Confirmation de résiliation du contrat</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"alert alert-danger\" ng-if=\"vm.functionalError\">{{vm.functionalError}}</div><div ng-if=\"vm.step === \'input\'\"><span translate=\"wamasysApp.contrat.informationContrat.texteCloturationContrat\">Êtes-vous sûr de vouloir résilier le contrat ?<br>Les relevés de compteur déjà générés ne seront pas impactés par la résiliation. Ce contrat n\'apparaîtra plus dans les futurs relevés de compteur.</span><div class=\"alert alert-warning\" style=\"margin-top: 15px\" translate=\"wamasysApp.contrat.informationContrat.textePreparationCloturation\">La pr&eacute;paration de la cl&ocirc;ture enregistre le relev&eacute; final si besoin et &eacute;tablit la facturation avant l\'&eacute;tape de revue.</div><hr><div class=\"form-group\"><label translate=\"wamasysApp.contrat.closingContractReason\" for=\"field_closingContractReason\">closingContractReason</label><select class=\"form-control\" id=\"field_closingContractReason\" required name=\"closingContractReason\" ng-model=\"vm.selectedClosingContractReason\" ng-options=\"closingContractReason as closingContractReason.label for closingContractReason in vm.closingContractReasons track by closingContractReason.id\"><option value=\"\"></option></select><div ng-show=\"editForm.closingContractReason.$invalid\"><p class=\"help-block\" ng-show=\"editForm.closingContractReason.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div ng-if=\"vm.contrat && vm.contrat.individualMeter\"><hr><div class=\"alert alert-info\"><span translate=\"wamasysApp.contrat.closingReview.lastKnownIndex\">Dernier index connu :</span> <strong>{{vm.contrat.individualMeter.valeurPrecedenteLecture || 0}}</strong> <span ng-if=\"vm.contrat.individualMeter.datePrecedenteLecture\">({{vm.contrat.individualMeter.datePrecedenteLecture | date:\'medium\'}})</span></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.closingReview.finalReadingDate\">Date du relevé final</label><div class=\"input-group\"><input id=\"field_readingDate\" type=\"text\" class=\"form-control\" name=\"readingDate\" datetime-picker=\"{{dateformat}}\" ng-click=\"vm.openCalendar(\'readingDate\')\" ng-model=\"vm.readingIndividualMeter.readingDate\" is-open=\"vm.datePickerOpenStatus.readingDate\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'readingDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.readingDate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.readingDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.closingReview.finalIndex\">Index final</label><input type=\"number\" class=\"form-control\" name=\"valeurReleve\" id=\"field_valeurReleve\" ng-model=\"vm.readingIndividualMeter.valeurReleve\" required max=\"999999999999\"><div ng-show=\"editForm.valeurReleve.$invalid\"><p class=\"help-block\" ng-show=\"editForm.valeurReleve.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div></div></div></div><div ng-if=\"vm.step === \'review\'\"><div class=\"alert alert-info\"><span translate=\"wamasysApp.contrat.closingReview.currentBalanceAfterBilling\">Solde courant du contrat après facturation :</span> <strong>{{vm.review.totalBalance | number:2}}</strong></div><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th translate=\"wamasysApp.contrat.closingReview.service\">Service</th><th translate=\"wamasysApp.contrat.closingReview.balance\">Solde</th><th translate=\"wamasysApp.contrat.closingReview.proposedTransfer\">Transfert proposé</th><th translate=\"wamasysApp.contrat.closingReview.balanceAfterTransfer\">Solde après transfert</th><th translate=\"wamasysApp.contrat.closingReview.proposedAdjustment\">Ajustement proposé</th></tr></thead><tbody><tr ng-repeat=\"state in vm.review.lineStates track by state.line.id\"><td>{{state.line.libelle || (state.line.serviceVendu && state.line.serviceVendu.libelleClient) || (\'Ligne #\' + state.line.id)}}</td><td>{{state.currentBalance | number:2}}</td><td><span ng-if=\"state.transferIn\">+{{state.transferIn | number:2}}</span> <span ng-if=\"state.transferIn && state.transferOut\">/ </span><span ng-if=\"state.transferOut\">-{{state.transferOut | number:2}}</span> <span ng-if=\"!state.transferIn && !state.transferOut\">-</span></td><td>{{state.remainingBalance | number:2}}</td><td><span ng-if=\"state.proposedAdjustmentType\">{{(\'wamasysApp.contrat.paiement.TypePenalitRemiseRegul.\' + state.proposedAdjustmentType) | translate}} {{state.proposedAdjustmentAmount | number:2}}</span> <span ng-if=\"!state.proposedAdjustmentType\">-</span></td></tr></tbody></table></div><div class=\"checkbox\" ng-if=\"vm.review.transfers.length || vm.review.debtWaivers.length || vm.review.windfallGains.length\"><label><input type=\"checkbox\" ng-model=\"vm.autoResolution.apply\"> <span translate=\"wamasysApp.contrat.closingReview.applyAutoResolution\">Appliquer automatiquement les transferts et ajustements proposés</span></label></div><div class=\"alert alert-warning\" ng-if=\"vm.review.hasOutstandingBalances && !vm.autoResolution.apply\"><span translate=\"wamasysApp.contrat.closingReview.outstandingBalanceWarning\">Le contrat ne peut pas être clôturé tant que le solde n\'est pas régularisé.</span></div><div ng-if=\"vm.autoResolution.apply && (vm.review.transfers.length || vm.review.debtWaivers.length || vm.review.windfallGains.length)\"><div class=\"row\"><div class=\"col-md-5\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.closingReview.label\">Libellé</label><input type=\"text\" class=\"form-control\" name=\"autoResolutionLabel\" ng-model=\"vm.autoResolution.label\" ng-required=\"vm.autoResolution.apply && (vm.review.debtWaivers.length || vm.review.windfallGains.length)\" ng-maxlength=\"50\"></div></div><div class=\"col-md-7\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.closingReview.comment\">Commentaire</label><textarea class=\"form-control\" rows=\"2\" name=\"autoResolutionCommentaire\" ng-model=\"vm.autoResolution.commentaire\" ng-required=\"vm.autoResolution.apply && (vm.review.transfers.length || vm.review.debtWaivers.length || vm.review.windfallGains.length)\" ng-maxlength=\"512\"></textarea></div></div></div><p class=\"text-muted\" ng-if=\"vm.review.debtWaivers.length > 1\"><span translate=\"wamasysApp.contrat.closingReview.reuseLabelAndComment\">Le même libellé et le même commentaire seront réutilisés pour tous les abandons de dette générés.</span></p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isPreparing || vm.isSaving || !vm.canFinalize()\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-ok\"></span>&nbsp;<span>{{vm.getPrimaryActionLabel() | translate}}</span></button></div></form>");
$templateCache.put("app/business/contrat/communication-subscription-dialog.html","<form name=\"editForm\" ng-submit=\"vm.save()\" novalidate show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"wamasysApp.contrat.communicationSubscription.titre\"></h4></div><div class=\"modal-body\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_communication_topic\" translate=\"wamasysApp.contrat.communicationSubscription.topic\"></label><select class=\"form-control\" id=\"field_communication_topic\" name=\"communicationTopicId\" ng-model=\"vm.subscription.communicationTopicId\" ng-change=\"vm.onTopicChange()\" ng-options=\"topic.id as (topic.nomClient || topic.nomInterne) for topic in vm.availableCommunicationTopics track by topic.id\" required><option value=\"\">{{ \'wamasysApp.contrat.communicationSubscription.topicPlaceholder\' | translate }}</option></select></div><div class=\"alert alert-info\" ng-if=\"!vm.availableCommunicationTopics.length\">{{ \'wamasysApp.contrat.communicationSubscription.noAvailableTopics\' | translate }}</div><div class=\"alert alert-danger\" ng-if=\"vm.duplicateAlertKey\">{{ vm.duplicateAlertKey | translate }}</div><div class=\"alert alert-warning\" ng-if=\"vm.contactAlertKey\">{{ vm.contactAlertKey | translate }}</div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\"></span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving || !vm.availableCommunicationTopics.length\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"wamasysApp.contrat.communicationSubscription.save\"></span></button></div></form>");
$templateCache.put("app/business/contrat/communication-subscription-optin-dialog.html","<form name=\"editForm\" ng-submit=\"vm.confirm()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"wamasysApp.contrat.communicationSubscription.optinConfirmTitle\"></h4></div><div class=\"modal-body\"><p><strong>{{vm.subscription.communicationTopicNomClient || vm.subscription.communicationTopicNomInterne}}</strong></p><p ng-if=\"vm.subscription.optin\" translate=\"wamasysApp.contrat.communicationSubscription.optinDisableQuestion\"></p><p ng-if=\"!vm.subscription.optin\" translate=\"wamasysApp.contrat.communicationSubscription.optinEnableQuestion\"></p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\"></span></button> <button type=\"submit\" ng-disabled=\"vm.isSaving\" class=\"btn btn-primary\"><span ng-if=\"vm.subscription.optin\" class=\"glyphicon glyphicon-remove-circle\"></span> <span ng-if=\"!vm.subscription.optin\" class=\"glyphicon glyphicon-ok-circle\"></span> &nbsp; <span ng-if=\"vm.subscription.optin\" translate=\"wamasysApp.contrat.communicationSubscription.disable\"></span> <span ng-if=\"!vm.subscription.optin\" translate=\"wamasysApp.contrat.communicationSubscription.enable\"></span></button></div></form>");
$templateCache.put("app/business/contrat/contract-documents.html","<div class=\"panel panel-default\"><div class=\"panel-heading\"><strong translate=\"wamasysApp.contrat.documents.otherTitle\"></strong></div><div class=\"panel-body\"><div class=\"well\" ng-if=\"vm.canEdit\"><div class=\"row\"><div class=\"col-sm-8\"><input id=\"contractDocumentFileInput\" type=\"file\" class=\"form-control\" file-model=\"contractDocumentFile\" set-file-data=\"vm.setDocumentFile(value)\"><p class=\"help-block\" translate=\"wamasysApp.contrat.documents.maxSize\" translate-values=\"{size: vm.maxDocumentSizeMb}\"></p><p class=\"help-block\" ng-if=\"vm.selectedDocumentFileName\" translate=\"wamasysApp.contrat.documents.selectedFile\" translate-values=\"{fileName: vm.selectedDocumentFileName}\"></p></div><div class=\"col-sm-4 text-right\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.uploadDocument()\" ng-disabled=\"!vm.selectedDocumentFile || vm.uploadInProgress\"><span class=\"glyphicon glyphicon-upload\"></span> <span translate=\"wamasysApp.contrat.documents.add\"></span></button></div></div></div><div class=\"table-responsive\" ng-if=\"vm.documents.length\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th translate=\"wamasysApp.contrat.documents.fileName\"></th><th translate=\"wamasysApp.contrat.documents.size\"></th><th translate=\"wamasysApp.contrat.documents.type\"></th><th translate=\"wamasysApp.contrat.documents.addedBy\"></th><th translate=\"wamasysApp.contrat.documents.addedDate\"></th><th translate=\"wamasysApp.contrat.documents.deletedBy\"></th><th translate=\"wamasysApp.contrat.documents.deletedDate\"></th><th class=\"text-right\" translate=\"wamasysApp.contrat.service.actions\"></th></tr></thead><tbody><tr ng-repeat=\"document in vm.documents track by document.id\" ng-class=\"{\'text-muted\': vm.isDeleted(document)}\"><td>{{document.fileName}}</td><td>{{vm.formatFileSize(document.sizeBytes)}}</td><td>{{document.contentType || \'application/octet-stream\'}}</td><td>{{document.createdBy}}</td><td>{{document.createdDate | date:\'medium\'}}</td><td>{{document.deletedBy || \'-\'}}</td><td>{{document.deletedDate ? (document.deletedDate | date:\'medium\') : \'-\'}}</td><td class=\"text-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.downloadDocument(document)\" ng-disabled=\"vm.isDeleted(document)\" translate=\"wamasysApp.contrat.documents.download\"></button> <button type=\"button\" class=\"btn btn-danger btn-xs\" ng-if=\"vm.canEdit\" ng-click=\"vm.deleteDocument(document)\" ng-disabled=\"vm.isDeleted(document)\" translate=\"wamasysApp.contrat.documents.deleteDocument\"></button></td></tr></tbody></table></div><p class=\"text-muted\" ng-if=\"!vm.documents.length\" translate=\"wamasysApp.contrat.documents.emptyOther\"></p></div></div>");
$templateCache.put("app/business/contrat/contract-online-payment-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.onlinePayment.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"wamasysApp.contrat.onlinePayment.titreConfirmationSuppressionOnlinePayment\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.contrat.onlinePayment.texteConfirmationSuppressionOnlinePayment\" translate-values=\"{id: \'{{vm.contrat.id}}\'}\">Are you sure you want to delete this Online payment?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"wamasysApp.contrat.onlinePayment.titreCloseBouton\">Close</span></button></div></form>");
$templateCache.put("app/business/contrat/contract-online-payment-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myonlinePaymentLabel\" translate=\"wamasysApp.contrat.onlinePayment.titre\">Create or edit a onlinePayment</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"wamasysApp.contrat.onlinePayment.type\" for=\"field_type\">type</label><select class=\"form-control\" id=\"field_type\" name=\"type\" ng-model=\"vm.onlinePayment.type\" ng-options=\"type for type in vm.onlinePaymentConf.type \"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"wamasysApp.contrat.onlinePayment.idExterne\" for=\"field_idExterne\">idExterne</label><input type=\"text\" class=\"form-control\" name=\"idExterne\" id=\"field_idExterne\" ng-model=\"vm.onlinePayment.idExterne\" required ng-maxlength=\"255\"><div ng-show=\"editForm.idExterne.$invalid\"><p class=\"help-block\" ng-show=\"editForm.idExterne.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.idExterne.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div><div ng-show=\"vm.onlinePayment.type == \'MTN_USSD_V1\' \" class=\"alert alert-warning\" translate=\"wamasysApp.contrat.onlinePayment.messageMTNUSSD\" translate-compile>Pour MTN l\'id (le numéro) doit être à ce format 22500000000. Attention cela ne fonctionnera pas avec un format de ce type +22500000000 ou 225 00 00 00 00</div><div ng-show=\"vm.onlinePayment.type == \'MPESA_PAYBILL_V1\' \" class=\"alert alert-warning\" translate=\"wamasysApp.contrat.onlinePayment.messageMPesaPayBill\" translate-compile>TODO</div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></div></form>");
$templateCache.put("app/business/contrat/contract-online-payment-history-dialog.html","<form name=\"historyForm\" role=\"form\" novalidate><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\">Historique du paiement en ligne</h4></div><div class=\"modal-body\"><div ng-if=\"vm.onlinePayment\"><p><strong>Type:</strong> {{vm.onlinePayment.type}}<br><strong>Identifiant:</strong> {{vm.onlinePayment.idExterne}}</p></div><div ng-if=\"vm.isLoading\" class=\"text-muted\">Chargement de l\'historique...</div><div class=\"table-responsive\" ng-if=\"!vm.isLoading\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th>Date revision</th><th>Action</th><th>Type</th><th>Identifiant</th><th>Metadata</th><th>Actif</th><th>Supprime le</th><th>Maj par</th></tr></thead><tbody><tr ng-repeat=\"history in vm.histories track by $index\"><td>{{history.revisionDate | date:\'medium\'}}</td><td>{{history.revisionType}}</td><td>{{history.type}}</td><td>{{history.idExterne}}</td><td>{{history.metadata}}</td><td>{{history.active}}</td><td>{{history.deletedDate | date:\'medium\'}}</td><td>{{history.lastModifiedBy || history.createdBy}}</td></tr><tr ng-if=\"!vm.histories.length\"><td colspan=\"8\" class=\"text-center text-muted\">Aucun historique</td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.close\">Close</span></button></div></form>");
$templateCache.put("app/business/contrat/contrat-add-note-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\">Creer une note</h4></div><div class=\"modal-body\"><div class=\"alert alert-info\" ng-if=\"vm.isLoading\">Chargement du contrat...</div><div class=\"form-group\"><label for=\"field_note\">Note</label><textarea class=\"form-control\" id=\"field_note\" name=\"note\" ng-model=\"vm.request.note\" rows=\"6\" maxlength=\"2000\" ng-disabled=\"vm.isLoading\" required></textarea></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clear()\" translate=\"entity.action.cancel\">Cancel</button> <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.isLoading || editForm.$invalid || vm.isSaving || !vm.request.contratId\" translate=\"entity.action.save\">Save</button></div></form>");
$templateCache.put("app/business/contrat/contrat-addpaymentcorrection-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mycontratLabel\" translate=\"wamasysApp.contrat.paiement.addCorrection\">add correction</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"alert alert-warning\"><span translate=\"wamasysApp.contrat.paiement.messageCorrection\"></span></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.paiement.oldAmountPaid\" for=\"field_amountPaid\">amountPaid</label><input readonly=\"readonly\" type=\"text\" class=\"form-control\" name=\"amountPaid\" id=\"field_amountPaid\" ng-model=\"vm.payment.paymentReceipt.amountPaid\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.paiement.date\" for=\"field_paymentDate\">paymentDate</label><input readonly=\"readonly\" type=\"text\" class=\"form-control\" name=\"paymentDate\" id=\"field_paymentDate\" value=\"{{ vm.payment.paymentReceipt.paymentDate | date:\'medium\'}}\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.paiement.tmpNewAmount\" for=\"field_newAmount\">newAmount</label><input type=\"number\" class=\"form-control\" name=\"newAmount\" id=\"field_newAmount\" ng-model=\"vm.paymentCorrection.tmpNewAmount\" ng-change=\"vm.paymentCorrection.newAmount =  vm.paymentCorrection.tmpNewAmount  -vm.payment.paymentReceipt.amountPaid;vm.paymentCorrection.newAmount = vm.paymentCorrection.newAmount.toFixed(2); \" required max=\"999999999999\" step=\"0.01\"><div ng-show=\"editForm.newAmount.$invalid\"><p class=\"help-block\" ng-show=\"editForm.newAmount.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.newAmount.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999999999\">This field cannot be more than 999999999999.</p><p class=\"help-block\" ng-show=\"editForm.newAmount.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.paiement.newAmount\" for=\"field_paymentDate\">paymentDate</label><input readonly=\"readonly\" type=\"text\" class=\"form-control\" name=\"paymentDate\" id=\"field_paymentDate\" ng-model=\"vm.paymentCorrection.newAmount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.commentaire\" for=\"field_comment\">commentaire</label><textarea class=\"form-control\" name=\"comment\" id=\"field_comment\" ng-model=\"vm.paymentCorrection.comment\" required></textarea><div ng-show=\"editForm.commentaire.$invalid\"><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/contrat/contrat-addwatercorrection-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mycontratLabel\" translate=\"wamasysApp.contrat.histoConsoEau.addCorrection\">add correction</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"alert alert-warning\"><span translate=\"wamasysApp.contrat.histoConsoEau.messageCorrection\"></span></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.referenceContrat\" for=\"field_referenceContrat\">referenceContrat</label><input readonly=\"readonly\" type=\"text\" class=\"form-control\" name=\"referenceContrat\" id=\"field_referenceContrat\" ng-model=\"vm.contrat.referenceContrat\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.histoConsoEau.dateDebut\" for=\"field_dateDebut\">dateDebut</label><div class=\"input-group\"><input id=\"field_dateDebut\" type=\"text\" class=\"form-control\" name=\"dateDebut\" ng-click=\"vm.openCalendar(\'dateDebut\')\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.consommationEauContrat.dateDebut\" is-open=\"vm.datePickerOpenStatus.dateDebut\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateDebut\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.dateDebut.$invalid\"><p class=\"help-block\" ng-show=\"editForm.dateDebut.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.histoConsoEau.dateFin\" for=\"field_dateFin\">dateFin</label><div class=\"input-group\"><input id=\"field_dateFin\" type=\"text\" class=\"form-control\" name=\"dateFin\" ng-click=\"vm.openCalendar(\'dateFin\')\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.consommationEauContrat.dateFin\" is-open=\"vm.datePickerOpenStatus.dateFin\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateFin\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.dateFin.$invalid\"><p class=\"help-block\" ng-show=\"editForm.dateFin.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.histoConsoEau.metreCubeConsomme\" for=\"field_mettreCubeConsomme\">mettreCubeConsomme</label><input type=\"number\" class=\"form-control\" name=\"mettreCubeConsomme\" id=\"field_mettreCubeConsomme\" ng-model=\"vm.consommationEauContrat.mettreCubeConsomme\" required max=\"999999999999\"><div ng-show=\"editForm.mettreCubeConsomme.$invalid\"><p class=\"help-block\" ng-show=\"editForm.mettreCubeConsomme.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.mettreCubeConsomme.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999999999\">This field cannot be more than 999999999999.</p><p class=\"help-block\" ng-show=\"editForm.mettreCubeConsomme.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.commentaire\" for=\"field_commentaire\">commentaire</label><textarea class=\"form-control\" name=\"commentaire\" id=\"field_commentaire\" ng-model=\"vm.consommationEauContrat.commentaire\" required></textarea><div ng-show=\"editForm.commentaire.$invalid\"><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/contrat/contrat-assistant-dialog.html","<form name=\"assistantForm\" role=\"form\" novalidate ng-submit=\"vm.askQuestion()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\"><span translate=\"wamasysApp.contrat.detailAssistant.assistantTitle\">Assistant contrat</span> <small class=\"text-muted\">#{{vm.contrat.referenceContrat}}</small></h4></div><div class=\"modal-body\"><div class=\"alert alert-danger\" ng-if=\"vm.errorMessage\">{{vm.errorMessage}}</div><div class=\"well well-sm\" ng-if=\"vm.latestUsage\"><strong translate=\"wamasysApp.contrat.detailAssistant.assistantUsage\">Usage tokens</strong>: {{vm.latestUsage.requestTotalTokens}} tokens pour cette requête <span ng-if=\"vm.latestUsage.currentMonthUserCostUsd != null\">| Utilisateur : {{vm.latestUsage.currentMonthUserCostUsd | number:4}} / {{vm.latestUsage.monthlyUserCostLimitUsd || \"illimité\"}} USD</span> <span ng-if=\"vm.latestUsage.currentMonthOrganisationCostUsd != null\">| Organisation : {{vm.latestUsage.currentMonthOrganisationCostUsd | number:4}} / {{vm.latestUsage.monthlyOrganisationCostLimitUsd || \"illimité\"}} USD</span></div><div class=\"panel panel-default\" style=\"max-height: 420px; overflow-y: auto\"><div class=\"panel-body\"><div class=\"text-muted\" ng-if=\"!vm.messages.length\" translate=\"wamasysApp.contrat.detailAssistant.assistantEmpty\">Pose une question sur le contrat ou sur une correction possible.</div><div ng-repeat=\"message in vm.messages track by $index\" style=\"margin-bottom: 16px\"><div class=\"label\" ng-class=\"message.role === \'user\' ? \'label-primary\' : \'label-default\'\">{{message.role === \'user\' ? \'Vous\' : \'Assistant\'}}</div><div style=\"white-space: pre-wrap; margin-top: 8px\">{{message.content}}</div><div class=\"alert alert-info\" ng-if=\"message.role === \'assistant\' && message.shouldSuggestAction && !message.proposedActionSummaries.length\"><div translate=\"wamasysApp.contrat.detailAssistant.assistantCanSuggestAction\">Une correction semble pertinente.</div><button type=\"button\" class=\"btn btn-default btn-sm\" ng-disabled=\"vm.isSending\" ng-click=\"vm.proposeAction(message)\"><span class=\"glyphicon glyphicon-wrench\"></span> <span translate=\"wamasysApp.contrat.detailAssistant.assistantProposeAction\">Proposer une action</span></button></div><div class=\"alert alert-warning\" ng-if=\"message.role === \'assistant\' && message.proposedActionSummaries.length\"><strong translate=\"wamasysApp.contrat.detailAssistant.assistantProposedActions\">Actions proposées</strong><ul style=\"margin-top: 8px\"><li ng-repeat=\"summary in message.proposedActionSummaries track by $index\">{{summary}}</li></ul><button type=\"button\" class=\"btn btn-primary btn-sm\" ng-if=\"message.canExecuteActions && !message.actionsExecuted\" ng-disabled=\"message.isExecutingActions\" ng-click=\"vm.executeActions(message)\"><span class=\"glyphicon glyphicon-ok\"></span> <span translate=\"wamasysApp.contrat.detailAssistant.assistantExecuteActions\">Exécuter ces actions</span></button> <span class=\"text-success\" ng-if=\"message.actionsExecuted\" translate=\"wamasysApp.contrat.detailAssistant.assistantActionsDone\">Actions exécutées</span><ul class=\"text-success\" style=\"margin-top: 8px\" ng-if=\"message.executedActionSummaries.length\"><li ng-repeat=\"summary in message.executedActionSummaries track by $index\">{{summary}}</li></ul></div></div></div></div><div class=\"form-group\"><label translate=\"wamasysApp.contrat.detailAssistant.assistantPrompt\">Votre question</label><textarea class=\"form-control\" rows=\"4\" ng-model=\"vm.prompt\" placeholder=\"Exemple: pourquoi y a-t-il un avoir sur ce contrat ?\"></textarea></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.includeSystemInstructions\"> <span translate=\"wamasysApp.contrat.detailAssistant.includeSystemInstructions\">Envoyer system instruction</span></label></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.close\">Close</span></button> <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.isSending || !vm.prompt || !vm.prompt.trim()\"><span translate=\"wamasysApp.contrat.detailAssistant.assistantSend\">Poser une question</span></button></div></form>");
$templateCache.put("app/business/contrat/contrat-billoutstandingcredit-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirm(vm.ligneContrat.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"wamasysApp.contrat.billOutstandingCredit.title\">Confirm</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.contrat.billOutstandingCredit.question\" translate-values=\"{id: \'{{vm.ligneContrat.id}}\'}\">Are you sure you want to stand by this service ?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">save</span></button></div></form>");
$templateCache.put("app/business/contrat/contrat-change-status-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\">Changer l\'etat</h4></div><div class=\"modal-body\"><div class=\"alert alert-info\" ng-if=\"vm.isLoading\">Chargement du contrat...</div><div class=\"form-group\"><label translate=\"wamasysApp.contrat.etat\" for=\"field_newStatus\">Etat</label><select class=\"form-control\" id=\"field_newStatus\" name=\"newStatus\" ng-model=\"vm.request.newStatus\" ng-disabled=\"vm.isLoading\" required><option ng-repeat=\"status in vm.statusOptions\" value=\"{{status}}\" translate=\"{{\'wamasysApp.EtatContrat.\' + status}}\">{{status}}</option></select></div><div class=\"checkbox\" ng-if=\"vm.isReminderStatus()\"><label><input type=\"checkbox\" ng-model=\"vm.request.generateRecoveryNotice\"> <span>Generer un bon de recouvrement</span></label></div><div class=\"checkbox\" ng-if=\"vm.isTicketEligibleStatus()\"><label><input type=\"checkbox\" ng-model=\"vm.request.createTicket\"> <span>Creer un ticket automatiquement</span></label></div><div class=\"form-group\" ng-if=\"vm.isClosedStatus()\"><label translate=\"wamasysApp.contrat.closingContractReason\" for=\"field_closingContractReason\">Motif</label><select class=\"form-control\" id=\"field_closingContractReason\" name=\"closingContractReason\" ng-model=\"vm.request.closingContractReasonId\" ng-options=\"reason.id as reason.label for reason in vm.closingContractReasons track by reason.id\" ng-disabled=\"vm.isLoading\" ng-required=\"vm.isClosedStatus()\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clear()\" translate=\"entity.action.cancel\">Cancel</button> <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.isLoading || editForm.$invalid || vm.isSaving || !vm.request.contratId\" translate=\"entity.action.save\">Save</button></div></form>");
$templateCache.put("app/business/contrat/contrat-create-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myContratLabel\">{{vm.isProspectCreation ? \'Créer un prospect\' : \'Créer un nouveau contrat\'}}</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"row\"><section class=\"col col-md-4\" ng-if=\"!vm.isProspectCreation\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.dateActivation\" for=\"field_dateActivation\">dateActivation</label><div class=\"input-group\"><input placeholder=\"{{ \'wamasysApp.contrat.dateActivation\' | translate }}\" id=\"field_dateActivation\" type=\"text\" class=\"form-control\" name=\"dateActivation\" ng-click=\"vm.openCalendar(\'dateActivation\')\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.contrat.dateActivation\" is-open=\"vm.datePickerOpenStatus.dateActivation\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateActivation\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.dateActivation.$invalid\"><p class=\"help-block\" ng-show=\"editForm.dateActivation.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></section><section class=\"col col-md-4\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.modeleContrat\" for=\"field_modeleContrats\">Model contract</label><select required class=\"form-control\" id=\"field_modeleContrats\" name=\"modeleContrat\" ng-model=\"vm.contrat.modeleContrat\" ng-options=\"modeleContrat as modeleContrat.libelle for modeleContrat in vm.modeleContrats track by modeleContrat.id\"><option value=\"\"></option></select><div ng-show=\"editForm.modeleContrat.$invalid\"><p class=\"help-block\" ng-show=\"editForm.modeleContrat.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></section><section class=\"col col-md-4\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.portefeuilleContrat\" for=\"field_portefeuilleContrat\">portefeuilleContrat</label><select class=\"form-control\" id=\"field_portefeuilleContrat\" required name=\"portefeuilleContrat\" ng-model=\"vm.contrat.portefeuilleContrat\" ng-options=\"portefeuilleContrat as portefeuilleContrat.libelle for portefeuilleContrat in vm.portefeuillecontrats track by portefeuilleContrat.id\"><option value=\"\"></option></select><div ng-show=\"editForm.portefeuilleContrat.$invalid\"><p class=\"help-block\" ng-show=\"editForm.portefeuilleContrat.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></section></div><div class=\"row\"><section class=\"col col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.contractType\" for=\"field_contractType\">Type contrat</label><select required class=\"form-control\" id=\"field_contractType\" name=\"contractType\" ng-model=\"vm.contrat.contractType\" ng-options=\"contractType as contractType.label for contractType in vm.contractTypes track by contractType.id\"><option value=\"\"></option></select><div ng-show=\"editForm.contractType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.contractType.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></section><section class=\"col col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.contractProfil\" for=\"field_contractProfil\">Type contrat</label><select required class=\"form-control\" id=\"field_contractProfil\" name=\"contractProfil\" ng-model=\"vm.contrat.contractProfil\" ng-options=\"contractProfil as contractProfil.libelle for contractProfil in vm.contractProfils track by contractProfil.id\"><option value=\"\"></option></select><div ng-show=\"editForm.contractProfil.$invalid\"><p class=\"help-block\" ng-show=\"editForm.contractProfil.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></section></div><hr><fieldset class=\"smart-form\"><div class=\"row\"><section class=\"col col-9\"><label class=\"input\"><i class=\"icon-prepend fa fa-user\"></i> <input type=\"text\" class=\"form-control\" name=\"nomPersonne\" id=\"field_nomPersonne\" ng-model=\"vm.contrat.nomPersonne\" required ng-maxlength=\"50\" placeholder=\"{{ \'wamasysApp.contrat.nomPersonne\' | translate }}\"></label><div ng-show=\"editForm.nomPersonne.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nomPersonne.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nomPersonne.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></section><section class=\"col col-3\"><label class=\"input\"><i class=\"icon-prepend fa fa-globe\"></i> <input type=\"number\" class=\"form-control\" name=\"indexAdresse\" id=\"field_indexAdresse\" ng-model=\"vm.contrat.indexAdresse\" min=\"0\" max=\"999999\" placeholder=\"{{ \'wamasysApp.contrat.indexAdresse\' | translate }}\"></label><div ng-show=\"editForm.indexAdresse.$invalid\"><p class=\"help-block\" ng-show=\"editForm.indexAdresse.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.indexAdresse.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\">This field cannot be more than 999999.</p><p class=\"help-block\" ng-show=\"editForm.indexAdresse.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></section></div></fieldset><div class=\"form-group\"><textarea class=\"form-control\" name=\"adresse\" id=\"field_adresse\" ng-model=\"vm.contrat.adresse\" required ng-maxlength=\"256\" cols=\"50\" placeholder=\"{{ \'wamasysApp.contrat.adresse\' | translate }}\">\r\n                    </textarea><div ng-show=\"editForm.adresse.$invalid\"><p class=\"help-block\" ng-show=\"editForm.adresse.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.adresse.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div><div has-module=\"GEO\"><map-leaflet contrat=\"vm.contrat\"></map-leaflet></div><fieldset class=\"smart-form\"><div class=\"row\"><section class=\"col col-6\"><label class=\"input\"><i class=\"icon-prepend fa fa-phone\"></i> <input type=\"text\" class=\"form-control\" name=\"phone\" id=\"field_phone\" ng-model=\"vm.contrat.phone\" ng-maxlength=\"30\" placeholder=\"{{ \'wamasysApp.contrat.phone\' | translate }}\"><div ng-show=\"editForm.phone.$invalid\"><p class=\"help-block\" ng-show=\"editForm.phone.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"30\">This field cannot be longer than 30 characters.</p></div></label></section><section class=\"col col-6\"><label class=\"input\"><i class=\"icon-prepend fa fa-envelope-o\"></i> <input type=\"text\" class=\"form-control\" name=\"email\" id=\"field_email\" ng-model=\"vm.contrat.email\" ng-maxlength=\"256\" placeholder=\"{{ \'wamasysApp.contrat.email\' | translate }}\"><div ng-show=\"editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></label></section></div></fieldset><fieldset class=\"smart-form\"><div class=\"row\"><section class=\"col col-md-6\"><label translate=\"wamasysApp.contrat.nombreFamille\" for=\"field_nombreFamille\">Nombre famille</label><label class=\"input\"><i class=\"icon-prepend fa fa-group\"></i> <input type=\"number\" class=\"form-control\" name=\"nombreFamille\" id=\"field_nombreFamille\" ng-model=\"vm.contrat.nombreFamille\" required min=\"0\" max=\"999999\" placeholder=\"{{ \'wamasysApp.contrat.nombreFamille\' | translate }}\"></label><div ng-show=\"editForm.nombreFamille.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nombreFamille.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nombreFamille.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.nombreFamille.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\">This field cannot be more than 999999.</p><p class=\"help-block\" ng-show=\"editForm.nombreFamille.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></section><section class=\"col col-md-6\"><label translate=\"wamasysApp.contrat.nombrePersonne\" for=\"field_nombrePersonne\">Nombre personne</label><label class=\"input\"><i class=\"icon-prepend fa fa-male\"></i> <input type=\"number\" class=\"form-control\" name=\"nombrePersonne\" id=\"field_nombrePersonne\" ng-model=\"vm.contrat.nombrePersonne\" required min=\"0\" max=\"999999\" placeholder=\"{{ \'wamasysApp.contrat.nombrePersonne\' | translate }}\"></label><div ng-show=\"editForm.nombrePersonne.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nombrePersonne.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nombrePersonne.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.nombrePersonne.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\">This field cannot be more than 999999.</p><p class=\"help-block\" ng-show=\"editForm.nombrePersonne.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></section></div></fieldset><hr><fieldset class=\"smart-form\"><div class=\"row\"><section class=\"col col-md-4\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.individualMeter\" for=\"field_individualMeter\">individualMeter</label><select class=\"form-control\" id=\"field_individualMeter\" name=\"individualMeter\" ng-model=\"vm.contrat.individualMeter\" ng-options=\"individualMeter as individualMeter.numeroSerie for individualMeter in vm.individualmeters track by individualMeter.id\"><option value=\"\"></option></select></div></section><section class=\"col col-md-4\" ng-show=\"vm.contrat.individualMeter && !vm.isProspectCreation\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.informationContrat.valeurPrecedenteLecture\">valeurPrecedenteLecture</label>:<label>{{vm.contrat.individualMeter.valeurPrecedenteLecture}}</label></div></section><section class=\"col col-md-4\" ng-if=\"vm.contrat.individualMeter && !vm.isProspectCreation\"><label translate=\"wamasysApp.contrat.informationContrat.valeurInitialeFacturation\" for=\"field_valeurInitialeFacturation\">valeurInitialeFacturation</label><label class=\"input\"><input type=\"number\" class=\"form-control\" name=\"valeurInitialeFacturation\" id=\"field_valeurInitialeFacturation\" ng-model=\"vm.contrat.valeurInitialeFacturation\" required min=\"0\" max=\"999999999999\" placeholder=\"{{ \'wamasysApp.contrat.informationContrat.valeurInitialeFacturation\' | translate }}\"></label><div ng-show=\"editForm.valeurInitialeFacturation.$invalid\"><p class=\"help-block\" ng-show=\"editForm.valeurInitialeFacturation.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.valeurInitialeFacturation.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.valeurInitialeFacturation.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999999999\">This field cannot be more than 999999999999.</p><p class=\"help-block\" ng-show=\"editForm.valeurInitialeFacturation.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></section></div></fieldset><hr><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.commentaire\" for=\"field_commentaire\">Commentaire</label><textarea type=\"text\" class=\"form-control\" name=\"commentaire\" id=\"field_commentaire\" ng-model=\"vm.contrat.commentaire\" ng-maxlength=\"256\"></textarea><div ng-show=\"editForm.commentaire.$invalid\"><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/contrat/contrat-createticket-dialog.controller.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-subject\" id=\"myRedmineLabel\" translate=\"wamasysApp.redmine.titleAdd\">add ticket</h4><label translate=\"wamasysApp.redmine.contract\">contract</label>: {{vm.contractRef}}</div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.redmine.subject\" for=\"field_subject\">subject</label><input type=\"text\" required class=\"form-control\" name=\"subject\" id=\"field_subject\" maxlength=\"256\" ng-model=\"vm.redmineIssue.subject\"><div ng-show=\"editForm.subject.$invalid\"><p class=\"help-block\" ng-show=\"editForm.subject.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.subject.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"256\">This field cannot be more than 256.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.redmine.tracker\" for=\"field_tracker_id\">Tracker</label><select class=\"form-control\" id=\"field_tracker_id\" name=\"tracker_id\" ng-model=\"vm.redmineIssue.tracker_id\"><option value=\"\">Client ticket</option><option value=\"8\">Feedback ticket</option></select></div><div class=\"form-group\"><label translate=\"wamasysApp.redmine.user\" for=\"field_user\">user</label><ui-select tagging ng-model=\"vm.redmineIssue.assigned_to_id\" theme=\"selectize\"><ui-select-match>{{$select.selected.firstName}} {{$select.selected.lastName}} ({{$select.selected.login}} )</ui-select-match><ui-select-choices repeat=\"user.redmineUserId as user in vm.users | filter: $select.search  track by user.id\">{{user.firstName}} {{user.lastName}} ({{user.login}} )</ui-select-choices></ui-select><!--            <select  class=\"form-control\" id=\"field_user\" name=\"user\" ng-model=\"vm.redmineIssue.assigned_to_id\" ng-options=\"user.redmineUserId as user.login for user in vm.users track by user.id\">\n                <option value=\"\"></option>\n            </select> --></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.redmine.description\" for=\"field_description\">description</label><textarea class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.redmineIssue.description\" maxlength=\"20000\" required></textarea><div ng-show=\"editForm.description.$invalid\"><p class=\"help-block\" ng-show=\"editForm.description.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.description.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"20000\">This field cannot be more than 20000.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/contrat/contrat-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.contrat.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.contrat.delete.question\" translate-values=\"{id: \'{{vm.contrat.referenceContrat}}\'}\">Are you sure you want to delete this Contrat?</p><!--   <p translate=\"wamasysApp.contrat.delete.question\" >Are you sure you want to delete this Contrat?</p> --><div class=\"form-group\"><label translate=\"wamasysApp.contrat.closingContractReason\" for=\"field_closingContractReason\">closingContractReason</label><select class=\"form-control\" id=\"field_closingContractReason\" required name=\"closingContractReason\" ng-model=\"vm.contrat.closingContractReason\" ng-options=\"closingContractReason as closingContractReason.label for closingContractReason in vm.closingContractReasons track by closingContractReason.id\"><option value=\"\"></option></select><div ng-show=\"editForm.closingContractReason.$invalid\"><p class=\"help-block\" ng-show=\"editForm.closingContractReason.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/contrat/contrat-detail.html","<div><h2><span translate=\"wamasysApp.contrat.detail.title\">Contrat</span> {{vm.contrat.referenceContrat}} <button has-any-authority=\"ROLE_SUPER_ADMIN\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.downloadContractJson()\"><span class=\"glyphicon glyphicon-download-alt\"></span> <span translate=\"wamasysApp.contrat.detail.downloadJson\">Télécharger JSON</span></button> <button type=\"button\" class=\"btn btn-default pull-right\" style=\"margin-right: 8px\" has-any-authority=\"ROLE_ADMIN,ROLE_SUPER_ADMIN\" ng-if=\"vm.canUseAssistant\" ng-click=\"vm.openAssistantChat()\"><span class=\"glyphicon glyphicon-comment\"></span> <span translate=\"wamasysApp.contrat.detailAssistant.openAssistant\">Assistant</span></button></h2><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><uib-tabset><uib-tab ui-sref-active=\"active\" ui-sref=\"contrat-detail.information({id:vm.idContrat})\"><uib-tab-heading><span translate=\"wamasysApp.contrat.informationContrat.title\">Information contrat</span></uib-tab-heading></uib-tab><uib-tab ui-sref-active=\"active\" ui-sref=\"contrat-detail.services({id:vm.idContrat})\"><uib-tab-heading><span translate=\"wamasysApp.contrat.service.title\">Vente</span></uib-tab-heading></uib-tab><uib-tab has-module=\"NEW_FEATURES_VISIBILITY\" ui-sref-active=\"active\" ng-if=\"vm.canEditContract\" ui-sref=\"contrat-detail.devis({id:vm.idContrat})\"><uib-tab-heading><span translate=\"wamasysApp.contrat.quote.title\">Devis</span></uib-tab-heading></uib-tab><uib-tab ui-sref-active=\"active\" ng-if=\"vm.canEditContract\" ui-sref=\"contrat-detail.paiements({id:vm.idContrat})\"><uib-tab-heading><span translate=\"wamasysApp.contrat.paiement.title\">Paiement</span></uib-tab-heading></uib-tab><uib-tab ui-sref-active=\"active\" ui-sref=\"contrat-detail.historiquepaiements({id:vm.idContrat})\"><uib-tab-heading><span translate=\"wamasysApp.contrat.histoPaiements.title\">Historique paiements</span></uib-tab-heading></uib-tab><uib-tab ng-class=\"{active: vm.$state.includes(\'contrat-detail.documents\')}\" ng-if=\"vm.canEditContract\" ui-sref=\"contrat-detail.documents.autres({id:vm.idContrat})\"><uib-tab-heading><span translate=\"wamasysApp.contrat.documents.title\">Documents</span></uib-tab-heading></uib-tab><uib-tab ui-sref-active=\"active\" ng-if=\"vm.canEditContract\" ui-sref=\"contrat-detail.dataanalyse({id:vm.idContrat})\" has-module=\"ELK\"><uib-tab-heading><span translate=\"wamasysApp.contrat.dataAnalyse.title\">Data analyse</span></uib-tab-heading></uib-tab><uib-tab ui-sref-active=\"active\" ng-if=\"vm.canEditContract\" ui-sref=\"contrat-detail.tickets({ref:vm.contrat.referenceContrat})\" has-module=\"TEAM\"><uib-tab-heading><span translate=\"wamasysApp.contrat.issues.title\">Tickets</span></uib-tab-heading></uib-tab></uib-tabset><div ui-view=\"panneau@content\"></div><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/contrat/contrat-history-dialog.html","<form name=\"historyForm\" role=\"form\" novalidate><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\">Historique des changements</h4></div><div class=\"modal-body\"><div class=\"alert alert-info\" ng-if=\"vm.isLoading\">Chargement de l\'historique...</div><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th translate=\"global.field.date\">Date</th><th>Type</th><th>Champ</th><th>Utilisateur</th><th>Ancienne valeur</th><th>Nouvelle valeur</th></tr></thead><tbody><tr ng-repeat=\"historique in vm.historiques track by historique.id\"><td>{{historique.eventDate | date:\'medium\'}}</td><td>{{historique.type}}</td><td>{{historique.fieldName || \'\'}}</td><td>{{historique.userLogin}}</td><td>{{historique.ancienneValeur}}</td><td>{{historique.nouvelleValeur}}</td></tr><tr ng-if=\"!vm.isLoading && !vm.historiques.length\"><td colspan=\"6\">Aucun historique</td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clear()\" translate=\"entity.action.close\">Close</button></div></form>");
$templateCache.put("app/business/contrat/contrat-reopen-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmReopen(vm.ligneContrat.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"wamasysApp.contrat.reopen.title\">Confirm</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.contrat.reopen.question\" translate-values=\"{id: \'{{vm.ligneContrat.id}}\'}\">Are you sure you want to stand by this service ?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">save</span></button></div></form>");
$templateCache.put("app/business/contrat/contrat-standby-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmStandBy(vm.ligneContrat.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"wamasysApp.contrat.standby.title\">Confirm</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.contrat.standby.question\" translate-values=\"{id: \'{{vm.ligneContrat.id}}\'}\">Are you sure you want to stand by this service ?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">save</span></button></div></form>");
$templateCache.put("app/business/contrat/contrat-status-help.html","<div class=\"container-fluid\"><h3>Aide sur les états contrat</h3><div class=\"well\"><p>Les nouveaux états permettent de suivre les relances, le litige, le dormant et la phase prospect.</p></div><table class=\"table table-striped\"><thead><tr><th translate=\"wamasysApp.contrat.etat\">État</th><th>Usage</th><th>Impacts</th></tr></thead><tbody><tr><td translate=\"wamasysApp.EtatContrat.PROSPECT\">Prospect</td><td>Avant activation commerciale.</td><td>Pas de facturation, pas de paiement, pas de paiement en ligne, pas de rattachement compteur, exclu des monitoring rules et des stats actives.</td></tr><tr><td translate=\"wamasysApp.EtatContrat.ACTIVE\">Actif</td><td>Contrat opérationnel normal.</td><td>Facturation, paiements, monitoring et reporting standard.</td></tr><tr><td translate=\"wamasysApp.EtatContrat.DORMANT\">Dormant</td><td>Contrat à surveiller moins fortement.</td><td>Exclu des monitoring rules seulement. La facturation et le reporting continuent.</td></tr><tr><td translate=\"wamasysApp.EtatContrat.FIRST_REMINDER\">1ère relance</td><td>Première relance de recouvrement.</td><td>Bon de recouvrement possible. Retour automatique à actif si paiement ramenant le solde global à 0.</td></tr><tr><td translate=\"wamasysApp.EtatContrat.SECOND_REMINDER\">2nde relance</td><td>Relance aggravée.</td><td>Mêmes règles que la première relance avec monitoring dédié.</td></tr><tr><td translate=\"wamasysApp.EtatContrat.LITIGATION\">Litige</td><td>Contrat passé en contentieux ou litige.</td><td>Ticket automatique possible, monitoring dédié, suivi du solde depuis l’entrée en litige.</td></tr><tr><td translate=\"wamasysApp.EtatContrat.CLOSED\">Clôt</td><td>Contrat fermé.</td><td>Utilise la date de clôture et le motif de clôture. Ticket automatique possible lors du changement d’état.</td></tr></tbody></table><div class=\"panel panel-default\"><div class=\"panel-heading\">Monitoring rules</div><div class=\"panel-body\"><ul><li>Les états sont disponibles dans les filtres de recherche contrat et dans les monitoring rules.</li><li>`DORMANT` et `PROSPECT` sont exclus des monitoring rules.</li><li>Des règles dédiées existent pour relances, litige, hausse de dette, litige sans compteur fermé et litige avec solde à 0 ou positif.</li></ul></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\">Historique</div><div class=\"panel-body\"><p>Chaque changement d’état et chaque modification de champ ou relation du contrat crée une ligne d’historique.</p><p>La fiche contrat affiche aussi la date du dernier changement d’état.</p></div></div></div>");
$templateCache.put("app/business/contrat/contrat.services-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 ng-if=\"! vm.ligneContrat.id\" class=\"modal-title\" id=\"myIndividualMeterLabel\" translate=\"wamasysApp.contrat.service.ajouter\">Create a service</h4><h4 ng-if=\"vm.ligneContrat.id\" class=\"modal-title\" id=\"myIndividualMeterLabel\" translate=\"wamasysApp.contrat.service.editer\">Edit a service</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!-- \n      <h2><span translate=\"wamasysApp.contrat.referenceContrat\">ReferenceContrat</span> {{vm.contrat.referenceContrat}}</h2>\n --><div class=\"form-group\"><label translate=\"wamasysApp.contrat.service.service\" for=\"field_serviceVenduAdd\">Service Autre</label><select ng-if=\"! vm.ligneContrat.id\" class=\"form-control\" id=\"field_serviceVenduAdd\" ng-change=\"vm.selectService()\" name=\"serviceVendu\" ng-model=\"vm.ligneContrat.serviceVendu\" ng-options=\"serviceVendu as serviceVendu.libelle for serviceVendu in vm.serviceVendus track by serviceVendu.id\"><option value=\"\"></option></select><label ng-if=\"vm.ligneContrat.id\" readonly=\"readonly\" class=\"form-control\" id=\"field_serviceVenduAdd\" name=\"serviceVendu\">{{vm.ligneContrat.serviceVendu.libelle}}</label></div><div class=\"form-group\" ng-if=\"vm.ligneContrat.serviceVendu && ! vm.hasBilling\"><div class=\"input-group\"><input placeholder=\"{{ \'wamasysApp.contrat.service.dateActivation\' | translate }}\" id=\"field_dateActivation\" type=\"text\" class=\"form-control\" name=\"dateActivation\" ng-click=\"vm.openCalendar(\'dateActivation\')\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.ligneContrat.dateActivation\" is-open=\"vm.datePickerOpenStatus.dateActivation\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateActivation\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.dateActivation.$invalid\"><p class=\"help-block\" ng-show=\"editForm.dateActivation.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\" ng-if=\"vm.ligneContrat.serviceVendu\"><label translate=\"wamasysApp.contrat.service.invoiceLabel\" for=\"field_libelle\">Libellé</label><input id=\"field_libelle\" type=\"text\" class=\"form-control\" name=\"libelle\" ng-model=\"vm.ligneContrat.libelle\" required><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.libelle.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div ng-if=\"vm.ligneContrat.serviceVendu.typePaiement === \'A_PAYER_EN_UNE_FOIS\'  && ! vm.hasBilling\" class=\"form-group\"><label translate=\"wamasysApp.contrat.service.quantite\" for=\"field_quantite\">Quantité</label><input id=\"field_quantite\" type=\"number\" min=\"0\" class=\"form-control\" name=\"quantite\" ng-model=\"vm.ligneContrat.quantite\" required></div><div ng-if=\"! vm.hasBilling &&vm.ligneContrat.serviceVendu.typePaiement === \'A_PAYER_EN_UNE_FOIS\' \" class=\"form-group\" has-any-authority=\"ROLE_SPECIFIC_PRICE\"><label translate=\"wamasysApp.serviceVendu.unitPrice\" for=\"field_unitPrice\">unitPrice</label><input id=\"field_unitPrice\" type=\"number\" min=\"0\" step=\".01\" class=\"form-control\" name=\"unitPrice\" ng-model=\"vm.ligneContrat.unitPrice\"></div><div ng-if=\"! vm.hasBilling && (vm.ligneContrat.serviceVendu.typePaiement === \'A_PAYER_AVEC_ECHELONNEMENT\' || vm.ligneContrat.serviceVendu.typePaiement === \'A_PAYER_PAR_JOUR\') \" class=\"form-group\" has-any-authority=\"ROLE_SPECIFIC_PRICE\"><label translate=\"wamasysApp.serviceVendu.amountPerInstallment\" for=\"field_amountPerInstallment\">amountPerInstallment</label><input id=\"field_amountPerInstallment\" type=\"number\" min=\"0\" step=\".01\" class=\"form-control\" name=\"amountPerInstallment\" ng-model=\"vm.ligneContrat.amountPerInstallment\"></div><div ng-if=\"! vm.hasBilling && vm.ligneContrat.serviceVendu.typePaiement === \'A_PAYER_AVEC_ECHELONNEMENT\' \" class=\"form-group\" has-any-authority=\"ROLE_SPECIFIC_PRICE\"><label translate=\"wamasysApp.serviceVendu.totalCredit\" for=\"field_totalCredit\">totalCredit</label><input id=\"field_totalCredit\" type=\"number\" min=\"0\" step=\".01\" class=\"form-control\" name=\"totalCredit\" ng-model=\"vm.ligneContrat.totalCredit\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/contrat/contrats.html","<div><style>.contract-page-shell {\n            padding-left: 6px;\n            padding-right: 6px;\n        }\n\n        .contract-page-header {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            gap: 12px;\n            margin-bottom: 10px;\n        }\n\n        .contract-page-title {\n            margin: 0;\n            color: #202124;\n            font-size: 28px;\n            font-weight: 400;\n            letter-spacing: -0.01em;\n        }\n\n        .contract-page-actions {\n            display: flex;\n            align-items: center;\n            justify-content: flex-end;\n            gap: 8px;\n            flex-wrap: wrap;\n        }\n\n        .contract-page-actions .btn {\n            border-radius: 999px;\n            font-weight: 500;\n            box-shadow: none;\n            transition: background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, color 0.18s ease;\n        }\n\n        .contract-page-actions .btn-primary {\n            border-color: #1a73e8;\n            background: #1a73e8;\n        }\n\n        .contract-page-actions .btn-primary:hover,\n        .contract-page-actions .btn-primary:focus {\n            border-color: #1765cc;\n            background: #1765cc;\n            box-shadow: 0 1px 2px rgba(26, 115, 232, 0.24);\n        }\n\n        .contract-page-actions .btn-default {\n            border-color: #d2d7de;\n            background: #fff;\n            color: #3c4043;\n        }\n\n        .contract-page-actions .btn-default:hover,\n        .contract-page-actions .btn-default:focus {\n            border-color: #c5d7f2;\n            background: #f6fafe;\n            color: #1a73e8;\n        }\n\n        .contract-filters-panel {\n            margin: 0;\n            padding: 0;\n            border: 0;\n            min-width: 0;\n        }\n\n        .contract-filter-accordion {\n            margin: 0;\n        }\n\n        .contract-filter-panel {\n            margin-bottom: 8px;\n            border: 1px solid #dde3ea;\n            border-radius: 16px;\n            background: linear-gradient(180deg, #ffffff 0%, #fbfcff 100%);\n            box-shadow: 0 6px 16px rgba(31, 41, 55, 0.06);\n            overflow: visible;\n            transition: box-shadow 0.18s ease, border-color 0.18s ease, transform 0.18s ease;\n        }\n\n        .contract-filter-panel:hover {\n            border-color: #d4dce6;\n            box-shadow: 0 10px 24px rgba(31, 41, 55, 0.08);\n        }\n\n        .contract-filter-panel:last-child {\n            margin-bottom: 0;\n        }\n\n        .contract-filter-panel-heading {\n            position: relative;\n            z-index: 1;\n            padding: 0;\n            border: 0;\n            background: transparent;\n            overflow: hidden;\n            border-radius: 14px 14px 0 0;\n        }\n\n        .contract-filter-panel-toggle {\n            position: relative;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            gap: 12px;\n            width: 100%;\n            box-sizing: border-box;\n            padding: 12px 22px 12px 14px;\n            border: 0;\n            background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);\n            color: #202124;\n            text-align: left;\n            transition: background-color 0.18s ease, box-shadow 0.18s ease;\n        }\n\n        .contract-filter-panel-toggle:hover,\n        .contract-filter-panel-toggle:focus {\n            background: #f5f9ff;\n            color: #202124;\n            outline: none;\n        }\n\n        .contract-filter-panel-toggle[aria-expanded=\"true\"] {\n            box-shadow: inset 0 -1px 0 rgba(26, 115, 232, 0.08);\n        }\n\n        .contract-filter-panel-title {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            font-size: 14px;\n            font-weight: 500;\n            line-height: 1.2;\n        }\n\n        .contract-filter-count {\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            min-width: 22px;\n            height: 22px;\n            padding: 0 7px;\n            border-radius: 999px;\n            background: #eef3fd;\n            color: #185abc;\n            font-size: 11px;\n            font-weight: 700;\n            line-height: 1;\n        }\n\n        .contract-filter-panel-subtitle {\n            display: block;\n            margin-top: 2px;\n            color: #5f6368;\n            font-size: 11px;\n            font-weight: 500;\n            line-height: 1.3;\n        }\n\n        .contract-filter-panel-icon {\n            flex: 0 0 auto;\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            width: 20px;\n            height: 20px;\n            margin-right: 2px;\n            border-radius: 999px;\n            background: transparent;\n            color: #80868b;\n            font-size: 10px;\n            line-height: 1;\n            pointer-events: none;\n            transition: transform 0.2s ease, color 0.2s ease, background-color 0.2s ease;\n        }\n\n        .contract-filter-panel-toggle[aria-expanded=\"true\"] .contract-filter-panel-icon {\n            color: #1a73e8;\n            transform: rotate(180deg);\n        }\n\n        .contract-filter-panel-body {\n            padding: 8px 12px 12px;\n            border-top: 1px solid #edf1f4;\n            position: relative;\n            overflow: visible;\n            /* Ne pas créer de contexte d\'empilement : une liste ui-select ouverte doit recouvrir les panneaux suivants. */\n            z-index: auto;\n            background: #fff;\n        }\n\n        .contract-filter-panel-body.collapse {\n            transition: height 0.18s ease;\n        }\n\n        .contract-filter-panel-body.collapse:not(.in) {\n            display: block;\n            height: 0 !important;\n            padding-top: 0;\n            padding-bottom: 0;\n            overflow: hidden;\n            border-top-color: transparent;\n        }\n\n        .contract-filter-panel-body.collapsing {\n            overflow: hidden;\n            padding-top: 0;\n            padding-bottom: 0;\n            border-top-color: transparent;\n            transition: height 0.18s ease;\n        }\n\n        .contract-filters-grid {\n            display: grid;\n            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n            gap: 8px 12px;\n            align-items: start;\n        }\n\n        .contract-filter-field {\n            min-width: 0;\n            display: grid;\n            grid-template-columns: minmax(96px, 126px) minmax(0, 1fr);\n            gap: 0 8px;\n            align-items: center;\n        }\n\n        .contract-filter-field--wide {\n            grid-column: span 2;\n        }\n\n        .contract-filter-field--multiline {\n            align-items: start;\n        }\n\n        .contract-filter-field--multiline .contract-filter-label {\n            padding-top: 8px;\n        }\n\n        .contract-filter-field--stacked {\n            align-items: start;\n        }\n\n        .contract-filter-field--stacked .contract-filter-label {\n            padding-top: 8px;\n        }\n\n        .contract-filter-inline-group {\n            display: grid;\n            grid-template-columns: minmax(0, 1fr) minmax(150px, 170px);\n            gap: 8px;\n            min-width: 0;\n        }\n\n        .contract-filter-inline-group--balance {\n            grid-template-columns: 82px minmax(0, 1fr);\n        }\n\n        .contract-filter-checkbox {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            min-height: 34px;\n            color: #334155;\n            font-size: 13px;\n            font-weight: 500;\n        }\n\n        .contract-filter-checkbox input[type=\"checkbox\"] {\n            margin: 0;\n            width: 16px;\n            height: 16px;\n            flex: 0 0 auto;\n        }\n\n        .contract-filter-actions {\n            grid-column: 1 / -1;\n        }\n\n        .contract-filter-label {\n            display: block;\n            margin: 0;\n            color: #5f6368;\n            font-size: 12px;\n            font-weight: 600;\n            line-height: 1.25;\n            white-space: normal;\n        }\n\n        .contract-filter-label {\n            text-align: right;\n        }\n\n        .contract-filter-field > :not(.contract-filter-label) {\n            min-width: 0;\n        }\n\n        .contract-filters-panel .form-control,\n        .contract-filters-panel .ui-select-container,\n        .contract-filters-panel .ui-select-bootstrap,\n        .contract-filters-panel .input-group,\n        .contract-filters-panel .date-picker {\n            width: 100%;\n            max-width: 100%;\n        }\n\n        .contract-filters-panel .ui-select-container,\n        .contract-filters-panel .ui-select-bootstrap {\n            position: relative;\n        }\n\n        .contract-filters-panel .form-control,\n        .contract-filters-panel .ui-select-multiple.ui-select-bootstrap,\n        .contract-filters-panel .ui-select-match {\n            min-height: 34px;\n        }\n\n        .contract-filters-panel .form-control,\n        .contract-filters-panel .ui-select-multiple.ui-select-bootstrap,\n        .contract-filters-panel .input-group .form-control {\n            border: 1px solid #dadce0;\n            border-radius: 12px;\n            background: #fcfdff;\n            box-shadow: none;\n            color: #202124;\n            font-size: 13px;\n            transition: border-color 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;\n        }\n\n        .contract-filters-panel .form-control:hover,\n        .contract-filters-panel .ui-select-multiple.ui-select-bootstrap:hover,\n        .contract-filters-panel .input-group .form-control:hover {\n            border-color: #c7d2e0;\n            background: #fff;\n        }\n\n        .contract-filters-panel .form-control:focus,\n        .contract-filters-panel .ui-select-multiple.ui-select-bootstrap.open,\n        .contract-filters-panel .ui-select-bootstrap.open .ui-select-search,\n        .contract-filters-panel .date-picker:focus {\n            border-color: #1a73e8 !important;\n            box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.14);\n            background: #fff;\n        }\n\n        .contract-filters-panel .ui-select-multiple.ui-select-bootstrap {\n            padding: 5px 8px 4px;\n            height: auto;\n            overflow: visible;\n            position: relative;\n        }\n\n        .contract-filters-panel .ui-select-container.open,\n        .contract-filters-panel .ui-select-bootstrap.open {\n            z-index: 200;\n        }\n\n        .contract-filters-panel .ui-select-multiple.ui-select-bootstrap input.ui-select-search {\n            height: 26px;\n            margin: 2px 0;\n            color: #202124;\n            font-size: 13px;\n        }\n\n        .contract-filters-panel .ui-select-multiple.ui-select-bootstrap .ui-select-match-item {\n            display: inline-flex;\n            align-items: center;\n            gap: 4px;\n            margin: 2px 4px 2px 0;\n            padding: 4px 10px;\n            border: 1px solid #d7e3f4;\n            border-radius: 999px;\n            background: #f4f7fb;\n            color: #334155;\n            font-size: 12px;\n            font-weight: 500;\n            line-height: 1.2;\n            box-shadow: none;\n            max-width: 100%;\n            white-space: normal;\n            word-break: break-word;\n        }\n\n        .contract-filters-panel .ui-select-multiple.ui-select-bootstrap .ui-select-match-item.btn-default {\n            background: #f4f7fb;\n            border-color: #d7e3f4;\n            color: #334155;\n        }\n\n        .contract-filters-panel .ui-select-match-close,\n        .contract-filters-panel .ui-select-match-item .close {\n            margin-left: 2px;\n            color: #5f6368;\n            font-size: 16px;\n            line-height: 0.9;\n            opacity: 0.68;\n            text-decoration: none;\n        }\n\n        .contract-filters-panel .ui-select-bootstrap > .ui-select-choices,\n        .contract-filters-panel .ui-select-dropdown {\n            position: absolute;\n            z-index: 210;\n            border: 1px solid #d2dbe8;\n            border-radius: 12px;\n            background: #fff;\n            box-shadow: 0 8px 24px rgba(32, 33, 36, 0.12);\n            max-height: 320px;\n            overflow-x: hidden;\n            overflow-y: auto;\n            margin-top: 6px;\n        }\n\n        .contract-filters-panel .ui-select-choices-row > span {\n            padding: 9px 12px;\n            color: #2d3136;\n            font-size: 13px;\n            white-space: normal;\n        }\n\n        .contract-filters-panel .ui-select-choices-row.active > span,\n        .contract-filters-panel .ui-select-choices-row > span:hover {\n            background: #e8f0fe;\n            color: #174ea6;\n        }\n\n        .contract-filter-actions {\n            display: flex;\n            justify-content: flex-end;\n            gap: 6px;\n            padding-top: 12px;\n        }\n\n        .contract-filter-actions .btn {\n            min-width: 104px;\n            border-radius: 999px;\n            font-weight: 500;\n            transition: background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, color 0.18s ease;\n        }\n\n        .contract-filter-actions .btn-primary {\n            border-color: #1a73e8;\n            background: #1a73e8;\n            box-shadow: 0 1px 2px rgba(26, 115, 232, 0.2);\n        }\n\n        .contract-filter-actions .btn-primary:hover,\n        .contract-filter-actions .btn-primary:focus {\n            border-color: #1765cc;\n            background: #1765cc;\n            box-shadow: 0 2px 6px rgba(26, 115, 232, 0.24);\n        }\n\n        .contract-filter-actions .btn-default {\n            border-color: #d2d7de;\n            background: #fff;\n            color: #3c4043;\n        }\n\n        .contract-filter-actions .btn-default:hover,\n        .contract-filter-actions .btn-default:focus {\n            border-color: #c5d7f2;\n            background: #f6fafe;\n            color: #1a73e8;\n        }\n\n        .contract-balance-cell,\n        .contract-balance-header {\n            white-space: nowrap;\n            text-align: right;\n        }\n\n        @media (max-width: 991px) {\n            .contract-filter-field--wide {\n                grid-column: span 1;\n            }\n        }\n\n        @media (max-width: 767px) {\n            .contract-page-shell {\n                padding-left: 0;\n                padding-right: 0;\n            }\n\n            .contract-page-header {\n                align-items: stretch;\n                flex-direction: column;\n                gap: 8px;\n            }\n\n            .contract-page-actions {\n                justify-content: stretch;\n                flex-direction: column;\n            }\n\n            .contract-page-actions .btn {\n                width: 100%;\n                margin-left: 0 !important;\n            }\n\n            .contract-filter-panel-toggle {\n                padding: 9px 10px;\n            }\n\n            .contract-filter-panel-body {\n                padding: 6px 8px 8px;\n            }\n\n            .contract-filters-grid {\n                grid-template-columns: 1fr;\n                gap: 8px;\n            }\n\n            .contract-filter-field {\n                grid-template-columns: 1fr;\n                gap: 4px;\n            }\n\n            .contract-filter-label {\n                text-align: left;\n            }\n\n            .contract-filter-field--multiline .contract-filter-label {\n                padding-top: 0;\n            }\n\n            .contract-filter-field--stacked .contract-filter-label {\n                padding-top: 0;\n            }\n\n            .contract-filter-inline-group,\n            .contract-filter-inline-group--balance {\n                grid-template-columns: 1fr;\n            }\n\n            .contract-filter-actions {\n                justify-content: stretch;\n                flex-direction: column-reverse;\n            }\n\n            .contract-filter-actions .btn {\n                width: 100%;\n            }\n        }</style><div class=\"container-fluid contract-page-shell\"><div class=\"contract-page-header\"><h2 class=\"contract-page-title\" translate=\"wamasysApp.contrat.home.title\">Contrats</h2><div class=\"contract-page-actions\"><button class=\"btn btn-primary\" ui-sref=\"contrat.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.contrat.home.createLabel\">Create new Contrat</span></button> <button class=\"btn btn-default btn-sm\" ui-sref=\"contrat.new-prospect\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.contrat.home.createProspectLabel\">Créer un prospect</span></button></div></div><jhi-alert></jhi-alert><div class=\"padding-top-10\"><form name=\"searchForm\" class=\"\"><fieldset class=\"contract-filters-panel\"><div class=\"panel-group contract-filter-accordion\" id=\"contractFiltersAccordion\"><div class=\"contract-filter-panel\"><div class=\"contract-filter-panel-heading\"><button type=\"button\" class=\"contract-filter-panel-toggle\" data-toggle=\"collapse\" data-target=\"#contractMainFilters\" aria-expanded=\"false\" aria-controls=\"contractMainFilters\"><span><span class=\"contract-filter-panel-title\"><span translate=\"wamasysApp.contrat.filterSections.mainTitle\">Filtres de recherche</span> <span class=\"contract-filter-count\">{{vm.getAppliedFilterCount(\'main\')}}</span></span> <span class=\"contract-filter-panel-subtitle\" translate=\"wamasysApp.contrat.filterSections.mainSubtitle\">Critères principaux du contrat</span> </span><span class=\"contract-filter-panel-icon glyphicon glyphicon-chevron-down\"></span></button></div><div id=\"contractMainFilters\" class=\"collapse contract-filter-panel-body\"><div class=\"contract-filters-grid\"><div class=\"contract-filter-field contract-filter-field--wide contract-filter-field--multiline\"><label class=\"contract-filter-label\" translate=\"wamasysApp.contrat.agence\">Zone</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.agenceIdNotPromise\" theme=\"bootstrap\" title=\"{{\'wamasysApp.contrat.agence\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.contrat.agence\' | translate}}\">{{$item.nom}}</ui-select-match><ui-select-choices repeat=\"agence in vm.agencesRattachement | filter: $select.search track by agence.id\">{{agence.nom}}</ui-select-choices></ui-select></div><div class=\"contract-filter-field\"><label class=\"contract-filter-label\" translate=\"wamasysApp.contrat.etat\" for=\"field_etat\">Etat</label><ui-select theme=\"bootstrap\" multiple=\"multiple\" name=\"etat\" ng-model=\"vm.etat\" id=\"field_etat\"><ui-select-match placeholder=\"{{\'wamasysApp.contrat.etat\' | translate}}\">{{ (\'wamasysApp.EtatContrat.\' + $item) | translate }}</ui-select-match><ui-select-choices repeat=\"etat as etat in vm.etatsContrat | filter: $select.search track by etat\">{{ (\'wamasysApp.EtatContrat.\' + etat) | translate }}</ui-select-choices></ui-select></div><div class=\"contract-filter-field\"><label class=\"contract-filter-label\" for=\"compteurFerme\" translate=\"wamasysApp.contrat.compteurFerme\">compteurFerme</label><select class=\"form-control\" id=\"compteurFerme\" ng-model=\"vm.compteurFerme\"><option value=\"\"></option><option value=\"true\" translate=\"entity.value.true\">true</option><option value=\"false\" translate=\"entity.value.false\">false</option></select></div><div class=\"contract-filter-field contract-filter-field--wide contract-filter-field--multiline\"><label class=\"contract-filter-label\" translate=\"wamasysApp.contrat.contractType\">ContractType</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.contractTypeNotPromise\" theme=\"bootstrap\" title=\"{{\'wamasysApp.contrat.contractType\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.contrat.contractType\' | translate}}\">{{$item.label}}</ui-select-match><ui-select-choices repeat=\"contractType in vm.contractTypes | filter: $select.search track by contractType.id\">{{(contractType.deleted==true)?\"&#x274c; \":\"\"}} {{contractType.label}}</ui-select-choices></ui-select></div><div class=\"contract-filter-field contract-filter-field--wide contract-filter-field--multiline\"><label class=\"contract-filter-label\" translate=\"wamasysApp.contrat.contractProfil\">ContractProfil</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.contractProfilNotPromise\" theme=\"bootstrap\" title=\"{{\'wamasysApp.contrat.contractProfil\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.contrat.contractProfil\' | translate}}\">{{$item.libelle}}</ui-select-match><ui-select-choices repeat=\"contractProfil in vm.contractProfils | filter: $select.search track by contractProfil.id\">{{(contractProfil.deleted==true)?\"&#x274c; \":\"\"}} {{contractProfil.libelle}}</ui-select-choices></ui-select></div><div class=\"contract-filter-field contract-filter-field--wide contract-filter-field--multiline\"><label class=\"contract-filter-label\" translate=\"wamasysApp.contrat.portefeuilleContrat\">Portefeuille client</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.portefeuilleContratNotPromise\" theme=\"bootstrap\" title=\"{{\'wamasysApp.contrat.portefeuilleContrat\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.contrat.portefeuilleContrat\' | translate}}\">{{$item.libelle}}</ui-select-match><ui-select-choices repeat=\"portefeuilleContrat in vm.portefeuilleContrats | filter: $select.search track by portefeuilleContrat.id\">{{portefeuilleContrat.libelle}}</ui-select-choices></ui-select></div><div class=\"contract-filter-field\"><label class=\"contract-filter-label\" translate=\"wamasysApp.contrat.hasEmail\">Poss&egrave;de un email</label><select class=\"form-control\" ng-model=\"vm.hasEmail\"><option value=\"\"></option><option value=\"true\" translate=\"entity.value.true\">true</option><option value=\"false\" translate=\"entity.value.false\">false</option></select></div><div class=\"contract-filter-field\"><label class=\"contract-filter-label\" translate=\"wamasysApp.contrat.hasPhone\">Poss&egrave;de un num&eacute;ro de t&eacute;l&eacute;phone</label><select class=\"form-control\" ng-model=\"vm.hasPhone\"><option value=\"\"></option><option value=\"true\" translate=\"entity.value.true\">true</option><option value=\"false\" translate=\"entity.value.false\">false</option></select></div><div class=\"contract-filter-field contract-filter-field--wide\"><label class=\"contract-filter-label\" for=\"searchQuery\" translate=\"wamasysApp.contrat.nomRefEmail\">Nom, r&eacute;f&eacute;rence contrat ou email</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'wamasysApp.contrat.nomRefEmail\' | translate }}\"></div><div class=\"contract-filter-field\"><label class=\"contract-filter-label\" for=\"daterange1\" translate=\"wamasysApp.contrat.dateActivation\">Date d\'activation</label><div class=\"input-group\"><input date-range-picker id=\"daterange1\" name=\"daterange1\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" options=\"vm.opts\" placeholder=\"yyyy-mm-dd - yyyy-mm-dd\"></div></div></div></div></div><div class=\"contract-filter-panel\"><div class=\"contract-filter-panel-heading\"><button type=\"button\" class=\"contract-filter-panel-toggle\" data-toggle=\"collapse\" data-target=\"#contractReportingFilters\" aria-expanded=\"false\" aria-controls=\"contractReportingFilters\"><span><span class=\"contract-filter-panel-title\"><span translate=\"wamasysApp.contrat.filterSections.financialTitle\">Filtres financiers</span> <span class=\"contract-filter-count\">{{vm.getAppliedFilterCount(\'reporting\')}}</span></span> <span class=\"contract-filter-panel-subtitle\" translate=\"wamasysApp.contrat.filterSections.financialSubtitle\">Services, solde et impayés</span> </span><span class=\"contract-filter-panel-icon glyphicon glyphicon-chevron-down\"></span></button></div><div id=\"contractReportingFilters\" class=\"collapse contract-filter-panel-body\"><div class=\"contract-filters-grid\"><div class=\"contract-filter-field contract-filter-field--wide contract-filter-field--multiline\"><label class=\"contract-filter-label\" translate=\"wamasysApp.contrat.serviceVendu\">serviceVendu</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.serviceVenduNotPromise\" theme=\"bootstrap\" title=\"{{\'wamasysApp.contrat.serviceVendu\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.contrat.serviceVendu\' | translate}}\">{{$item.libelle}}</ui-select-match><ui-select-choices repeat=\"serviceVendu in vm.serviceVendus | filter: $select.search track by serviceVendu.id\">{{(serviceVendu.deleted==true)?\"&#x274c; \":\"\"}} {{serviceVendu.libelle}}</ui-select-choices></ui-select></div><div class=\"contract-filter-field contract-filter-field--wide contract-filter-field--stacked\"><label class=\"contract-filter-label\" translate=\"wamasysApp.contrat.balance\">Balance</label><div class=\"contract-filter-inline-group contract-filter-inline-group--balance\"><select class=\"form-control\" ng-model=\"vm.currentBalanceSigne\" id=\"field_currentBalanceSigne\"><option value=\"\"></option><option value=\"<\">&#60;</option><option value=\">\">&#62;</option><option value=\"<>\">&#8800;</option><option value=\"=\">&#61;</option></select><input type=\"text\" class=\"form-control\" ng-model=\"vm.currentBalanceValue\" id=\"currentBalanceValue\"></div></div><div class=\"contract-filter-field contract-filter-field--wide\"><label class=\"contract-filter-label\"></label><label class=\"contract-filter-checkbox\" for=\"field_filterBalanceWithService\"><input type=\"checkbox\" id=\"field_filterBalanceWithService\" ng-model=\"vm.filterBalanceWithService\" name=\"filterBalanceWithService\"> <span translate=\"wamasysApp.contrat.filterBalanceWithService\">filterBalanceWithService</span></label></div><div class=\"contract-filter-field contract-filter-field--wide\"><label class=\"contract-filter-label\"></label><label class=\"contract-filter-checkbox\" for=\"field_tooMuchPaid\"><input type=\"checkbox\" id=\"field_tooMuchPaid\" ng-model=\"vm.tooMuchPaid\" name=\"tooMuchPaid\"> <span translate=\"wamasysApp.contrat.tooMuchPaid\">tooMuchPaid</span></label></div><div class=\"contract-filter-field contract-filter-field--wide contract-filter-field--stacked\"><label class=\"contract-filter-label\" translate=\"wamasysApp.contrat.minAmountPaid\">Sum of payment less than</label><div class=\"contract-filter-inline-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.minAmountPaid\" id=\"minAmountPaid\"><div class=\"input-group\"><input placeholder=\"{{ \'wamasysApp.contrat.since\' | translate }}\" id=\"field_toDatePayment\" type=\"text\" class=\"form-control\" name=\"toDatePayment\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.toDatePayment\" is-open=\"vm.datePickerOpenStatus.toDatePayment\" ng-click=\"vm.openCalendar(\'toDatePayment\')\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDatePayment\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"contract-filter-field contract-filter-field--wide contract-filter-field--stacked\"><label class=\"contract-filter-label\" translate=\"wamasysApp.contrat.minAmountBilled\">Sum of billing less than</label><div class=\"contract-filter-inline-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.minAmountBilled\" id=\"minAmountBilled\"><div class=\"input-group\"><input placeholder=\"{{ \'wamasysApp.contrat.since\' | translate }}\" id=\"field_toDateBilling\" type=\"text\" class=\"form-control\" name=\"toDateBilling\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.toDateBilling\" is-open=\"vm.datePickerOpenStatus.toDateBilling\" ng-click=\"vm.openCalendar(\'toDateBilling\')\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDateBilling\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"contract-filter-field contract-filter-field--wide contract-filter-field--stacked\"><label class=\"contract-filter-label\" translate=\"wamasysApp.contrat.maxWaterConsumption\">Sum of water consumption less than</label><div class=\"contract-filter-inline-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.maxWaterConsumption\" id=\"maxWaterConsumption\"><div class=\"input-group\"><input placeholder=\"{{ \'wamasysApp.contrat.since\' | translate }}\" id=\"field_toDateWaterConsumption\" type=\"text\" class=\"form-control\" name=\"toDateWaterConsumption\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.toDateWaterConsumption\" is-open=\"vm.datePickerOpenStatus.toDateWaterConsumption\" ng-click=\"vm.openCalendar(\'toDateWaterConsumption\')\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDateWaterConsumption\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div></div><div class=\"contract-filter-panel\" has-module=\"ONLINE_PAYMENT\"><div class=\"contract-filter-panel-heading\"><button type=\"button\" class=\"contract-filter-panel-toggle\" data-toggle=\"collapse\" data-target=\"#contractOnlinePaymentFilters\" aria-expanded=\"false\" aria-controls=\"contractOnlinePaymentFilters\"><span><span class=\"contract-filter-panel-title\"><span translate=\"wamasysApp.contrat.onlinePayment.searchTitle\">onlinePayment.titre</span> <span class=\"contract-filter-count\">{{vm.getAppliedFilterCount(\'online\')}}</span></span> <span class=\"contract-filter-panel-subtitle\" translate=\"wamasysApp.contrat.filterSections.onlinePaymentSubtitle\">Filtres dédiés au paiement en ligne</span> </span><span class=\"contract-filter-panel-icon glyphicon glyphicon-chevron-down\"></span></button></div><div id=\"contractOnlinePaymentFilters\" class=\"collapse contract-filter-panel-body\"><div class=\"contract-filters-grid\"><div class=\"contract-filter-field\"><label class=\"contract-filter-label\" for=\"onlinePaymentActive\" translate=\"wamasysApp.contrat.onlinePayment.active\">onlinePayment.active</label><select class=\"form-control\" id=\"onlinePaymentActive\" ng-model=\"vm.onlinePaymentActive\"><option value=\"\"></option><option value=\"true\" translate=\"entity.value.true\">true</option><option value=\"false\" translate=\"entity.value.false\">false</option></select></div><div class=\"contract-filter-field\"><label class=\"contract-filter-label\" for=\"field_onlinePaymentType\" translate=\"wamasysApp.contrat.onlinePayment.type\">Type</label><select class=\"form-control\" id=\"field_onlinePaymentType\" name=\"onlinePaymentType\" ng-model=\"vm.onlinePaymentType\"><option value=\"\"></option><option value=\"MTN_USSD_V1\">MTN USSD</option><option value=\"MPESA_PAYBILL_V1\">M-Pesa Paybill</option></select></div><div class=\"contract-filter-field contract-filter-field--wide\"><label class=\"contract-filter-label\" for=\"onlinePaymentQuery\" translate=\"wamasysApp.contrat.onlinePayment.idExterne\">id</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.onlinePaymentQuery\" id=\"onlinePaymentQuery\" placeholder=\"{{ \'wamasysApp.contrat.onlinePayment.idPlaceholder\' | translate }}\"></div></div></div></div></div><div class=\"contract-filter-actions\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.clear()\" ng-if=\"vm.currentSearch\" translate=\"entity.action.reset\">reset</button> <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"vm.search()\" translate=\"entity.action.chercher\">search</button></div></fieldset></form></div><div class=\"table-responsive padding-top-10\"><!--  	<button class=\" pull-right btn-xs btn-primary\" ng-click=\"vm.download()\"  target=\"_blank\"  translate=\"entity.action.download\">download CSV</button>\n     	<button class=\" pull-left btn-xs btn-primary\" ng-click=\"vm.downloadService()\"  target=\"_blank\"  translate=\"entity.action.downloadServiceDetailCSV\" >download detail service CSV</button>\n \n        <button class=\" pull-left btn-xs btn-primary\" ng-click=\"vm.downloadDetailServiceNotClosedcsv()\"  target=\"_blank\"  translate=\"entity.action.downloadDetailServiceNotClosedcsv\" >download detail service Not Closed CSV</button>\n  --><div class=\"btn-group btn-xs pull-right\"><button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\">{{\'entity.action.download\' | translate}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\"><li><a ng-click=\"vm.download()\" target=\"_blank\" translate=\"wamasysApp.contrat.downloadContract\">Download receipts</a></li><li><a ng-click=\"vm.downloadService()\" target=\"_blank\" translate=\"wamasysApp.contrat.downloadServiceDetailCSV\">Download receipts</a></li><li><a ng-click=\"vm.downloadDetailServiceNotClosedcsv()\" target=\"_blank\" translate=\"wamasysApp.contrat.downloadDetailServiceNotClosedcsv\">Download payments</a></li></ul></div><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"nomPersonne\"><span translate=\"wamasysApp.contrat.nomPersonne\">NomPersonne</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"referenceContrat\"><span translate=\"wamasysApp.contrat.referenceContrat\">ReferenceContrat</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"indexAdresse\"><span translate=\"wamasysApp.contrat.indexAdresse\">IndexAdresse</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"adresse\"><span translate=\"wamasysApp.contrat.adresse\">Adresse</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"etat\"><span translate=\"wamasysApp.contrat.etat\">Etat</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dateActivation\"><span translate=\"wamasysApp.contrat.dateActivation\">Date Activation</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"compteurFerme\"><span translate=\"wamasysApp.contrat.compteurFerme\">compteurFerme</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"portefeuilleContrat.id\"><span translate=\"wamasysApp.contrat.portefeuilleContrat\">portefeuilleContrat</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"balance\" class=\"contract-balance-header\"><span translate=\"wamasysApp.contrat.balance\">Balance</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"contrat in vm.contrats track by contrat.id\"><td><a ui-sref=\"contrat-detail.information({id:contrat.id})\">{{contrat.nomPersonne}}</a></td><td>{{contrat.referenceContrat}}<br><small ng-if=\"contrat.ancienneReferenceContrat != null\">({{contrat.ancienneReferenceContrat}})</small></td><td>{{contrat.indexAdresse}}</td><td>{{contrat.adresse}}</td><td translate=\"{{\'wamasysApp.EtatContrat.\' + contrat.etat}}\">{{contrat.etat}}</td><td>{{contrat.dateActivation | date:\'mediumDate\'}}</td><td ng-show=\"contrat.compteurFerme != null\" translate=\"{{\'entity.value.\' + contrat.compteurFerme}}\">{{contrat.compteurFerme}}</td><td ng-show=\"contrat.compteurFerme == null\" translate=\"entity.value.false\">false</td><td><a ng-if=\"contrat.portefeuilleContrat\" ui-sref=\"portefeuille-contrat-detail({id:contrat.portefeuilleContrat.id})\">{{contrat.portefeuilleContrat.libelle}}</a> <a ng-if=\"contrat.portefeuilleContratId\" ui-sref=\"portefeuille-contrat-detail({id:contrat.portefeuilleContratId})\">{{contrat.portefeuilleContratLabel}}</a></td><td class=\"contract-balance-cell\">{{contrat.balance}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"contrat-detail.information({id:contrat.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"contrat.delete({id:contrat.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div></div>");
$templateCache.put("app/business/contrat/dataanalyse-contrat.html","<div class=\"container-fluid\"><!--   <h2 translate=\"wamasysApp.reportingGlobal.titre\" >Reporting global</h2>\n    <jhi-alert-error></jhi-alert-error>\n --><my-iframe ng-if=\"vm.dataLoaded\" iddashboard=\"71921710-f3b1-11e7-8990-9b3d26ec283c\" idcontrat=\"{{vm.referenceContrat}}\" codeagence=\"\" height=\"800px\" width=\"100%\" scrolling=\"auto\"></my-iframe></div><!-- Dashboard sur un contrat.\n --> <!-- \nDashboard sur une agence\n  <my-iframe iddashboard=\"03848d60-ecaf-11e7-8569-d570740c277c\"  idcontrat=\"\" codeagence=\"CAS\" height=\"800px\" width=\"100%\" scrolling=\"auto\"></my-iframe>\n\n -->");
$templateCache.put("app/business/contrat/devis-contrat.html","<br><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-default\"><div class=\"panel-heading clearfix\"><strong translate=\"wamasysApp.contrat.quote.titlePanel\"></strong> <button type=\"button\" class=\"btn btn-primary btn-sm pull-right\" ng-click=\"vm.openCreate()\" ng-disabled=\"!vm.canEdit || vm.isContractClosed()\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.contrat.quote.create\"></span></button></div><div class=\"panel-body\"><div class=\"alert alert-warning\" ng-if=\"vm.isContractClosed()\" translate=\"wamasysApp.contrat.quote.closedWarning\"></div><div class=\"table-responsive\" ng-if=\"vm.devisList.length\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th translate=\"wamasysApp.contrat.quote.reference\"></th><th translate=\"wamasysApp.contrat.quote.quoteDate\"></th><th translate=\"wamasysApp.contrat.quote.validUntil\"></th><th translate=\"wamasysApp.contrat.quote.state\"></th><th translate=\"wamasysApp.contrat.quote.creation\"></th><th translate=\"wamasysApp.contrat.quote.acceptance\"></th><th translate=\"wamasysApp.contrat.quote.totalTtc\"></th><th class=\"text-right\" translate=\"wamasysApp.contrat.service.actions\"></th></tr></thead><tbody><tr ng-repeat=\"devis in vm.devisList track by devis.id\"><td>{{devis.referenceDevis || \'-\'}}</td><td>{{devis.dateDevis | date:\'shortDate\'}}</td><td>{{devis.validUntil | date:\'shortDate\'}}</td><td>{{vm.statusLabelKey(devis.etat) | translate}}</td><td><div>{{devis.createdBy || \'-\'}}</div><small>{{devis.createdDate ? (devis.createdDate | date:\'medium\') : \'-\'}}</small></td><td><div>{{devis.acceptedBy || \'-\'}}</div><small>{{devis.acceptedDate ? (devis.acceptedDate | date:\'medium\') : \'-\'}}</small></td><td>{{devis.totalTtc | currency:\'\':2}}</td><td class=\"text-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.openView(devis)\" translate=\"wamasysApp.contrat.quote.view\"></button> <button type=\"button\" class=\"btn btn-primary btn-xs\" ng-click=\"vm.openEdit(devis)\" ng-disabled=\"!vm.canEditQuote(devis)\">{{vm.editActionLabelKey(devis) | translate}}</button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-if=\"vm.canDownloadPdf(devis)\" ng-click=\"vm.downloadPdf(devis)\" translate=\"wamasysApp.contrat.quote.pdf\"></button> <button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"vm.transform(devis)\" ng-disabled=\"!vm.canTransform(devis)\" translate=\"wamasysApp.contrat.quote.transformToSale\"></button></td></tr></tbody></table></div><p class=\"text-muted\" ng-if=\"!vm.devisList.length\" translate=\"wamasysApp.contrat.quote.empty\"></p></div></div></div></div>");
$templateCache.put("app/business/contrat/devis-dialog.html","<form name=\"editForm\" novalidate><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\">{{vm.dialogTitleKey() | translate}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-4\"><label translate=\"wamasysApp.contrat.quote.referenceLabel\"></label><p class=\"form-control-static\">{{vm.devis.referenceDevis || (\'wamasysApp.contrat.quote.draftReferencePlaceholder\' | translate)}}</p></div><div class=\"col-sm-4\"><label translate=\"wamasysApp.contrat.quote.createdBy\"></label><p class=\"form-control-static\">{{vm.devis.createdBy || \'-\'}}</p></div><div class=\"col-sm-4\"><label translate=\"wamasysApp.contrat.quote.createdDate\"></label><p class=\"form-control-static\">{{vm.devis.createdDate ? (vm.devis.createdDate | date:\'medium\') : \'-\'}}</p></div></div><div class=\"row\"><div class=\"col-sm-4\"><label for=\"field_dateDevis\" translate=\"wamasysApp.contrat.quote.quoteDateLabel\"></label><div class=\"input-group\"><input id=\"field_dateDevis\" type=\"text\" class=\"form-control\" name=\"dateDevis\" ng-click=\"vm.openCalendar(\'dateDevis\')\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.devis.dateDevis\" is-open=\"vm.datePickerOpenStatus.dateDevis\" ng-disabled=\"!vm.canEditContent()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateDevis\')\" ng-disabled=\"!vm.canEditContent()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-sm-4\"><label for=\"field_validUntil\" translate=\"wamasysApp.contrat.quote.validUntil\"></label><div class=\"input-group\"><input id=\"field_validUntil\" type=\"text\" class=\"form-control\" name=\"validUntil\" ng-click=\"vm.openCalendar(\'validUntil\')\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.devis.validUntil\" is-open=\"vm.datePickerOpenStatus.validUntil\" ng-disabled=\"!vm.canEditContent()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'validUntil\')\" ng-disabled=\"!vm.canEditContent()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-sm-4\"><label for=\"field_etat\" translate=\"wamasysApp.contrat.quote.state\"></label><p class=\"form-control-static\" ng-if=\"vm.readOnly\">{{vm.statusLabelKey(vm.devis.etat) | translate}}</p><select id=\"field_etat\" class=\"form-control\" ng-if=\"!vm.readOnly\" ng-model=\"vm.devis.etat\" ng-options=\"etat.value as (etat.labelKey | translate) for etat in vm.etatsDevis\"></select></div></div><div class=\"row\"><div class=\"col-sm-6\"><label translate=\"wamasysApp.contrat.quote.acceptedBy\"></label><p class=\"form-control-static\">{{vm.devis.acceptedBy || \'-\'}}</p></div><div class=\"col-sm-6\"><label translate=\"wamasysApp.contrat.quote.acceptedDate\"></label><p class=\"form-control-static\">{{vm.devis.acceptedDate ? (vm.devis.acceptedDate | date:\'medium\') : \'-\'}}</p></div></div><div class=\"row\"><div class=\"col-sm-12\"><label for=\"field_commentaireInterne\" translate=\"wamasysApp.contrat.quote.internalComment\"></label><textarea id=\"field_commentaireInterne\" class=\"form-control\" rows=\"3\" maxlength=\"4000\" ng-model=\"vm.devis.commentaireInterne\" ng-disabled=\"!vm.canEditContent()\"></textarea></div></div><hr><div class=\"clearfix\"><strong translate=\"wamasysApp.contrat.quote.linesTitle\"></strong> <button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"vm.addLine()\" ng-if=\"vm.canEditContent()\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.contrat.quote.addLine\"></span></button></div><div class=\"table-responsive\" style=\"margin-top: 12px\"><table class=\"table table-striped table-bordered table-condensed\"><thead><tr><th style=\"width: 18%\" translate=\"wamasysApp.contrat.quote.service\"></th><th translate=\"wamasysApp.contrat.quote.label\"></th><th style=\"width: 8%\" translate=\"wamasysApp.contrat.quote.quantity\"></th><th style=\"width: 12%\" translate=\"wamasysApp.contrat.quote.unitPriceExclTax\"></th><th style=\"width: 10%\" translate=\"wamasysApp.contrat.quote.vatRate\"></th><th style=\"width: 12%\" translate=\"wamasysApp.contrat.quote.totalHt\"></th><th style=\"width: 12%\" translate=\"wamasysApp.contrat.quote.totalTtc\"></th><th style=\"width: 8%\" ng-if=\"vm.canEditContent()\"></th></tr></thead><tbody><tr ng-repeat=\"line in vm.devis.lignes track by $index\"><td><span ng-if=\"!vm.canEditContent()\">{{vm.resolveServiceLabel(line)}}</span><select ng-if=\"vm.canEditContent()\" class=\"form-control\" ng-model=\"line.serviceVenduId\" ng-change=\"vm.onServiceChange(line)\" ng-options=\"service.id as vm.serviceLabel(service) for service in vm.serviceVendus track by service.id\"><option value=\"\" translate=\"wamasysApp.contrat.quote.selectService\"></option></select></td><td><input type=\"text\" class=\"form-control\" ng-model=\"line.libelle\" ng-disabled=\"!vm.canEditContent()\" maxlength=\"255\"></td><td><input type=\"number\" step=\"0.001\" min=\"0.001\" class=\"form-control\" ng-model=\"line.quantite\" ng-disabled=\"!vm.canEditContent()\" ng-change=\"vm.recalculateLine(line)\"></td><td><p class=\"form-control-static\">{{line.prixUnitaireHt | currency:\'\':2}}</p></td><td><p class=\"form-control-static\">{{line.tauxTva | number:2}} %</p></td><td>{{line.montantHt | currency:\'\':2}}</td><td>{{line.montantTtc | currency:\'\':2}}</td><td ng-if=\"vm.canEditContent()\" class=\"text-right\"><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"vm.removeLine($index)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr></tbody></table></div><div class=\"clearfix\" style=\"margin-top: 18px\"><strong translate=\"wamasysApp.contrat.quote.discountsTitle\"></strong> <button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"vm.addDiscount()\" ng-if=\"vm.canEditContent()\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.contrat.quote.addDiscount\"></span></button></div><div class=\"table-responsive\" style=\"margin-top: 12px\" ng-if=\"vm.devis.remisesCommerciales.length\"><table class=\"table table-striped table-bordered table-condensed\"><thead><tr><th style=\"width: 24%\" translate=\"wamasysApp.contrat.quote.discountReason\"></th><th style=\"width: 22%\" translate=\"wamasysApp.contrat.quote.discountService\"></th><th style=\"width: 12%\" translate=\"wamasysApp.contrat.quote.discountAmountTtc\"></th><th style=\"width: 10%\" translate=\"wamasysApp.contrat.quote.vatRate\"></th><th style=\"width: 12%\" translate=\"wamasysApp.contrat.quote.totalHt\"></th><th style=\"width: 12%\" translate=\"wamasysApp.contrat.quote.totalTva\"></th><th style=\"width: 8%\" ng-if=\"vm.canEditContent()\"></th></tr></thead><tbody><tr ng-repeat=\"discount in vm.devis.remisesCommerciales track by $index\"><td><span ng-if=\"!vm.canEditContent()\">{{vm.resolveDiscountTypeLabel(discount)}}</span><select ng-if=\"vm.canEditContent()\" class=\"form-control\" ng-model=\"discount.typeRemisecommercialeId\" ng-change=\"vm.onDiscountTypeChange(discount)\" ng-options=\"typeRemisecommerciale.id as typeRemisecommerciale.libelle for typeRemisecommerciale in vm.typeRemisecommerciales track by typeRemisecommerciale.id\"><option value=\"\"></option></select></td><td><span ng-if=\"!vm.canEditContent()\">{{discount.serviceVenduLabel}}</span><select ng-if=\"vm.canEditContent()\" class=\"form-control\" ng-model=\"discount.serviceVenduId\" ng-change=\"vm.onDiscountServiceChange(discount)\" ng-options=\"service.id as vm.serviceLabel(service) for service in vm.discountServices track by service.id\"><option value=\"\"></option></select></td><td><span ng-if=\"!vm.canEditContent()\">{{discount.montantTtc | currency:\'\':2}}</span> <input ng-if=\"vm.canEditContent()\" type=\"number\" step=\"0.01\" min=\"0.01\" class=\"form-control\" ng-model=\"discount.montantTtc\" ng-change=\"vm.recalculateDiscount(discount)\"></td><td>{{discount.tauxTva | number:2}} %</td><td>{{discount.montantHt | currency:\'\':2}}</td><td>{{discount.montantTva | currency:\'\':2}}</td><td ng-if=\"vm.canEditContent()\" class=\"text-right\"><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"vm.removeDiscount($index)\"><span class=\"glyphicon glyphicon-remove\"></span></button></td></tr></tbody></table></div><p class=\"text-muted\" ng-if=\"!vm.devis.remisesCommerciales.length\" translate=\"wamasysApp.contrat.quote.emptyDiscount\"></p><div class=\"table-responsive\" style=\"margin-top: 12px\"><table class=\"table table-bordered table-condensed\"><tbody><tr><th class=\"text-right\" translate=\"wamasysApp.contrat.quote.totalLines\"></th><td style=\"width: 140px\">{{vm.lineTotalHt | currency:\'\':2}}</td><td style=\"width: 140px\">{{vm.lineTotalTva | currency:\'\':2}}</td><td style=\"width: 140px\">{{vm.lineTotalTtc | currency:\'\':2}}</td></tr><tr><th class=\"text-right\" translate=\"wamasysApp.contrat.quote.totalDiscounts\"></th><td>- {{vm.discountTotalHt | currency:\'\':2}}</td><td>- {{vm.discountTotalTva | currency:\'\':2}}</td><td>- {{vm.discountTotalTtc | currency:\'\':2}}</td></tr><tr><th class=\"text-right\" translate=\"wamasysApp.contrat.quote.netTotals\"></th><td>{{vm.devis.totalHt | currency:\'\':2}}</td><td>{{vm.devis.totalTva | currency:\'\':2}}</td><td>{{vm.devis.totalTtc | currency:\'\':2}}</td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clear()\"><span translate=\"wamasysApp.contrat.quote.close\"></span></button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.save()\" ng-if=\"!vm.readOnly\" ng-disabled=\"vm.isSaving\"><span>{{vm.saveButtonLabelKey() | translate}}</span></button></div></form>");
$templateCache.put("app/business/contrat/documents-contrat.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-primary\" ui-sref=\"contrat-detail.documents.autres.print({id:vm.contrat.id})\"><span class=\"glyphicon glyphicon-print\"></span> <span translate=\"wamasysApp.contrat.imprimer.titre\"></span></button> <button type=\"button\" class=\"btn btn-primary\" ui-sref=\"contrat-detail.documents.autres.generatePaymentRecoveryNotice({id:vm.contrat.id})\"><span class=\"glyphicon glyphicon-print\"></span> <span translate=\"wamasysApp.contrat.generatePaymentRecoveryNotice.titre\"></span></button></div></div></div><div class=\"tabs-left\"><ul class=\"nav nav-tabs tabs-left\"><!-- nav nav-pills nav-stacked  --><li ui-sref-active=\"active\" has-module=\"NEW_FEATURES_VISIBILITY\"><a ui-sref=\"contrat-detail.documents.autres({id:vm.idContrat})\" translate=\"wamasysApp.contrat.documents.other\"></a></li><li ui-sref-active=\"active\"><a ui-sref=\"contrat-detail.documents.factures({id:vm.idContrat})\" translate=\"wamasysApp.contrat.documents.invoices\"></a></li><li ui-sref-active=\"active\"><a ui-sref=\"contrat-detail.documents.receipts({id:vm.idContrat})\" translate=\"wamasysApp.contrat.documents.receipts\"></a></li></ul><div class=\"tab-content\" ui-view=\"documentsTab\"></div></div>");
$templateCache.put("app/business/contrat/factures-contrat.html","<div class=\"panel panel-default\"><div class=\"panel-heading\"><strong translate=\"wamasysApp.contrat.documents.invoices\"></strong></div><div class=\"panel-body\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th translate=\"wamasysApp.contrat.documents.refFacture\">Reference</th><th translate=\"wamasysApp.contrat.documents.type\">Type</th><th translate=\"wamasysApp.contrat.documents.toDate\">Date</th><th translate=\"wamasysApp.contrat.documents.totalAmount\">Total amount</th><th></th></tr></thead><tbody><tr ng-repeat=\"facture in vm.factures\"><td>{{facture.refFacture}}</td><td>{{facture.type}}</td><td>{{facture.toDate}}</td><td>{{facture.totalAmount | currency :\'\':2 }}</td><td><a ng-if=\"facture.refFacture !== \'null\'\" ng-click=\"downloadFacture(vm.contrat.agence.id,vm.contrat.id,facture.refFacture)\" translate=\"wamasysApp.contrat.documents.download\"></a></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div></div>");
$templateCache.put("app/business/contrat/generate-payment-recoverynotice-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.print()\" show-validation><div class=\"modal-header\"><!-- 		<button type=\"button\" class=\"close\" data-dismiss=\"modal\"\n			aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button> --><h4 class=\"modal-title\" id=\"printContratLabel\" translate=\"wamasysApp.contrat.generatePaymentRecoveryNotice.titre\">Print Contract</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!-- 		<div class=\"form-group\"> --><!-- 			<div class=\"input-group\"> --><!-- 				<input placeholder=\"{{ \'wamasysApp.contrat.generatePaymentRecoveryNotice.dateFrom\' | translate }}\" --><!-- 					id=\"field_dateFrom\" type=\"text\" class=\"form-control\" --><!-- 					name=\"dateFrom\" uib-datepicker-popup=\"{{dateformat}}\" --><!-- 					ng-model=\"vm.dateFrom\" is-open=\"vm.datePickerOpenStatus.dateFrom\" --><!-- 					required /> <span class=\"input-group-btn\"> --><!-- 					<button type=\"button\" class=\"btn btn-default\" --><!-- 						ng-click=\"vm.openCalendar(\'dateFrom\')\"> --><!-- 						<i class=\"glyphicon glyphicon-calendar\"></i> --><!-- 					</button> --><!-- 				</span> --><!-- 			</div> --><!-- 			<div ng-show=\"editForm.dateFrom.$invalid\"> --><!-- 				<p class=\"help-block\" ng-show=\"editForm.dateFrom.$error.required\" --><!-- 					translate=\"entity.validation.required\">This field is required. --><!-- 				</p> --><!-- 			</div> --><!-- 		</div> --><!-- 		<div class=\"form-group\"> --><!-- 			<div class=\"input-group\"> --><!-- 				<input placeholder=\"{{ \'wamasysApp.contrat.generatePaymentRecoveryNotice.dateTo\' | translate }}\" --><!-- 					id=\"field_dateTo\" type=\"text\" class=\"form-control\" --><!-- 					name=\"dateTo\" uib-datepicker-popup=\"{{dateformat}}\" --><!-- 					ng-model=\"vm.dateTo\" is-open=\"vm.datePickerOpenStatus.dateTo\" --><!-- 					required /> <span class=\"input-group-btn\"> --><!-- 					<button type=\"button\" class=\"btn btn-default\" --><!-- 						ng-click=\"vm.openCalendar(\'dateTo\')\"> --><!-- 						<i class=\"glyphicon glyphicon-calendar\"></i> --><!-- 					</button> --><!-- 				</span> --><!-- 			</div> --><!-- 			<div ng-show=\"editForm.dateFrom.$invalid\"> --><!-- 				<p class=\"help-block\" ng-show=\"editForm.dateFrom.$error.required\" --><!-- 					translate=\"entity.validation.required\">This field is required. --><!-- 				</p> --><!-- 			</div> --><!-- 		</div> --></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isPrinting\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-print\"></span>&nbsp;<span translate=\"entity.action.print\">Print</span></button></div></form>");
$templateCache.put("app/business/contrat/historique-changement-compteur-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myImpactPenalitRemiseRegulLabel\" translate=\"wamasysApp.contrat.informationContrat.titreHistoriqueCompteur\">Create or edit a ImpactPenalitRemiseRegul</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th translate=\"wamasysApp.contrat.informationContrat.dateAjoutCompteur\">dateAjoutCompteur</th><th translate=\"wamasysApp.contrat.informationContrat.valeurInitialeFacturation\">valeurInitialeFacturation</th><!-- 						<th translate=\"wamasysApp.contrat.informationContrat.valeurRelevePrecedentCompteur\">valeurRelevePrecedentCompteur</th> --><th translate=\"wamasysApp.contrat.individualMeter\">individualMeter</th><th translate=\"wamasysApp.contrat.informationContrat.etatCompteur\">individualMeter etat</th><th translate=\"wamasysApp.contrat.informationContrat.individualMeterDerniereValeur\">individualMeter dernière valeur</th></tr></thead><tbody><tr ng-repeat=\"historiqueCompteurContrat in vm.listHistoriqueCompteurContrat\"><td>{{historiqueCompteurContrat.dateAjoutCompteur | date:\'medium\'}}</td><td>{{historiqueCompteurContrat.valeurInitialeFacturation}}</td><!-- 						<td>{{historiqueCompteurContrat.valeurRelevePrecedentCompteur}}</td> --><td><a target=\"_blank\" ui-sref=\"individual-meter-detail({id:historiqueCompteurContrat.individualMeter.id})\">{{historiqueCompteurContrat.individualMeter.numeroSerie}}</a></td><td translate=\"{{\'wamasysApp.EtatMeter.\' + historiqueCompteurContrat.individualMeter.etat}}\">{{historiqueCompteurContrat.individualMeter.etat}}</td><td>{{historiqueCompteurContrat.individualMeter.valeurPrecedenteLecture}}</td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/business/contrat/historiqueconso-contrat-dialog.html","<!-- 		<div jarvis-widget id=\"hide-show-columns-table-widget\" data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"> --><!-- 					<header> --><!-- 						<span class=\"widget-icon\"> <i class=\"fa fa-table\"></i> --><!-- 						</span> --><!-- 						<h2 translate=\"wamasysApp.contrat.histoConsoEau.listeConso\">Liste Consommation</h2> --><!-- 					</header> --><!-- 					<div> --><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"wamasysApp.contrat.histoConsoEau.listeConso\">Liste Consommation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"widget-body no-padding table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th translate=\"wamasysApp.contrat.histoConsoEau.numeroSerie\">Date debut</th><th translate=\"wamasysApp.contrat.histoConsoEau.dateDebut\">Date debut</th><th translate=\"wamasysApp.contrat.histoConsoEau.dateFin\">Date fin</th><th translate=\"wamasysApp.contrat.histoConsoEau.metreCubeConsomme\">mètre cube consommé</th><th translate=\"wamasysApp.contrat.histoConsoEau.lastModifiedDate\">lastModifiedDate</th><th translate=\"wamasysApp.contrat.histoConsoEau.correction\">correction</th></tr></thead><tbody><tr ng-repeat=\"consommationEau in vm.listeConsommationEau\"><td>{{consommationEau.individualMeter.numeroSerie}}</td><td>{{consommationEau.dateDebut| date:\'medium\'}}</td><td>{{consommationEau.dateFin| date:\'medium\'}}</td><td>{{consommationEau.mettreCubeConsomme}}</td><td>{{consommationEau.lastModifiedDate | date:\'mediumDate\'}}</td><td ng-if=\"consommationEau.isCorrection\">{{consommationEau.isCorrection}} by {{consommationEau.createdBy}}<br>{{consommationEau.commentaire}}</td><td ng-if=\"! consommationEau.isCorrection\"></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div><!-- 					</div> --><!-- 				</div> --></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button></div>");
$templateCache.put("app/business/contrat/historiquepaiements-contrat.html","<style>.billing-history-table {\n            table-layout: fixed;\n        }\n\n        .billing-history-table th,\n        .billing-history-table td {\n            vertical-align: top;\n        }\n\n        .billing-history-table col.billing-history-table__type {\n            width: 7%;\n        }\n\n        .billing-history-table col.billing-history-table__label {\n            width: 21%;\n        }\n\n        .billing-history-table col.billing-history-table__date {\n            width: 14%;\n        }\n\n        .billing-history-table col.billing-history-table__quantity {\n            width: 8%;\n        }\n\n        .billing-history-table col.billing-history-table__amount {\n            width: 8%;\n        }\n\n        .billing-history-table col.billing-history-table__actions {\n            width: 110px;\n        }\n\n        .billing-history-table th:nth-child(n+4):nth-child(-n+9),\n        .billing-history-table td:nth-child(n+4):nth-child(-n+9) {\n            text-align: right;\n            white-space: nowrap;\n        }\n\n        .billing-history-table th:nth-child(10),\n        .billing-history-table td:nth-child(10) {\n            text-align: center;\n            white-space: nowrap;\n        }\n\n        .billing-history-table__label-cell {\n            overflow: hidden;\n        }\n\n        .billing-history-table__label-text {\n            display: block;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n        }\n\n        .billing-history-table__secondary {\n            display: block;\n            margin-top: 4px;\n            white-space: normal;\n        }</style><div class=\"container-fluid padding-top-10\"><form name=\"searchForm\" class=\"smart-form form-inline\"><div class=\"row\"><div class=\"col-md-6 col-lg-5\"><fieldset><label class=\"label col-md-2\" translate=\"wamasysApp.collectionListe.service\" for=\"field_ligneContrat\">Service</label><section class=\"col-md-10\"><label class=\"\"><select class=\"form-control\" id=\"field_ligneContrat\" name=\"ligneContrat\" ng-model=\"vm.ligneContrat\" ng-change=\"vm.onFiltersChanged()\" ng-options=\"ligneContrat as ligneContrat.libelle + \' (\' + ligneContrat.serviceVendu.libelle + \')\' for ligneContrat in vm.ligneContrats track by ligneContrat.id\"><option value=\"\"></option></select></label></section></fieldset></div><div class=\"col-md-4 col-lg-5\"><fieldset><div class=\"form-group\"><label class=\"label col-md-4\" for=\"daterange1\" translate=\"wamasysApp.collectionListe.dateFacturation\">Date de facturation</label><div class=\"col-md-8\"><div class=\"input-group\"><input date-range-picker id=\"daterange1\" name=\"daterange1\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" options=\"vm.opts\" placeholder=\"yyyy-mm-dd - yyyy-mm-dd\"></div></div></div></fieldset></div><div class=\"col-md-2 col-lg-2\"><div class=\"pull-right\"><fieldset><button class=\"btn btn-primary btn-sm\" ng-click=\"vm.clear()\" ng-if=\"vm.currentSearch\">reset</button></fieldset></div></div></div></form></div><!-- Widget ID (each widget will need unique ID)--><div jarvis-widget id=\"form-grid-widget\" data-widget-colorbutton=\"false\" data-widget-editbutton=\"false\" data-widget-custombutton=\"false\"><div><!-- widget content --><div class=\"widget-body no-padding\"><div jarvis-widget id=\"hide-show-columns-table-widget\" data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"><header><span class=\"widget-icon\"><i class=\"fa fa-table\"></i></span><h2 translate=\"wamasysApp.contrat.paiement.titrePrecedentPaiement\">Precedent Paiement</h2></header><div><div class=\"widget-body no-padding table-responsive\"><table class=\"table table-striped table-bordered table-hover billing-history-table\" width=\"100%\" ng-if=\"!vm.isBillingDisplayMode()\"><colgroup><col class=\"billing-history-table__type\"><col class=\"billing-history-table__label\"><col class=\"billing-history-table__date\"><col class=\"billing-history-table__quantity\"><col class=\"billing-history-table__amount\"><col class=\"billing-history-table__amount\"><col class=\"billing-history-table__amount\"><col class=\"billing-history-table__amount\"><col class=\"billing-history-table__amount\"><col class=\"billing-history-table__actions\"></colgroup><thead><tr><th translate=\"wamasysApp.contrat.service.type\">type</th><th translate=\"wamasysApp.contrat.paiement.label\">Label</th><th translate=\"wamasysApp.collectionListe.dateFacturation\">Date facturation</th><th translate=\"wamasysApp.collectionListe.quantity\">Quantity</th><th translate=\"wamasysApp.collectionListe.moneyBoxAvantPaiement\">Money box avant paiement</th><th translate=\"wamasysApp.collectionListe.montantAPayer\">montantAPayer</th><th translate=\"wamasysApp.collectionListe.totalACollecter\">totalACollecter</th><th translate=\"wamasysApp.collectionListe.totalPaye\">totalPaye</th><th translate=\"wamasysApp.collectionListe.moneyBoxApresPaiement\">Money box après paiement</th><th></th></tr></thead><tbody ng-repeat=\"collectionListePaye in vm.collectionListeValide\"><tr><td>BILLING</td><td class=\"billing-history-table__label-cell\" data-line-id=\"{{collectionListePaye.idLignePaiementService}}\"><span class=\"billing-history-table__label-text\" title=\"{{collectionListePaye.ligneContrat.serviceVendu.libelle}}\">{{collectionListePaye.ligneContrat.serviceVendu.libelle}} </span><small class=\"billing-history-table__secondary\" ng-if=\"collectionListePaye.ligneContrat.serviceVendu.typePaiement===\'A_PAYER_AVEC_ECHELONNEMENT\'\">Total Paid {{collectionListePaye.montantTotalDejaPaye}} / {{collectionListePaye.montantTotalAPayer}} </small><small class=\"billing-history-table__secondary\" ng-if=\"collectionListePaye.ligneContrat.serviceVendu.typePaiement===\'A_PAYER_SUR_CONSO_EAU\' && collectionListePaye.valeurCompteurReleve !== null && collectionListePaye.valeurCompteurReleve !== undefined\">{{\'wamasysApp.contrat.paiement.usedBillingIndex\' | translate}} : {{collectionListePaye.valeurCompteurReleve | number:3}}</small></td><td>{{collectionListePaye.datePaiement | date:\'medium\'}}</td><td>{{collectionListePaye.quantity | currency:\"\":3}}</td><td>{{collectionListePaye.moneyboxAvantPaiement | currency:\"\":2}}</td><td>{{collectionListePaye.montantAPayerTtc | currency:\"\":2}}</td><td>{{(collectionListePaye.montantAPayerTtc - collectionListePaye.moneyboxAvantPaiement )| currency:\"\":2}}</td><td>{{collectionListePaye.totalPayeTtc | currency:\"\":2}}</td><td>{{collectionListePaye.moneyboxApresPaiement | currency:\"\":2}}</td><td><button type=\"submit\" ng-click=\"vm.modalDetailPayment(collectionListePaye.listPaymentReceived)\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm ng-scope\" translate=\"entity.action.view\">View</span></button></td></tr><tr ng-repeat=\"impactPenalitRemiseRegul in collectionListePaye.listImpactPenalitRemiseRegul\" class=\"warning small\"><td colspan=\"2\">{{impactPenalitRemiseRegul.type}} / {{impactPenalitRemiseRegul.label}}</td><td>{{impactPenalitRemiseRegul.createdDate | date:\'medium\'}}</td><td></td><td></td><td ng-if=\"impactPenalitRemiseRegul.type == \'DISCOUNT\'\">- {{impactPenalitRemiseRegul.montantTtc | currency:\"\":2}}</td><td ng-if=\"impactPenalitRemiseRegul.type != \'DISCOUNT\'\"></td><td></td><td></td><td ng-if=\"impactPenalitRemiseRegul.type != \'DISCOUNT\' && impactPenalitRemiseRegul.type != \'REFUND\' && impactPenalitRemiseRegul.type != \'REFUND_BALANCE_TRANSFER\'\">{{impactPenalitRemiseRegul.montantTtc | currency:\"\":2}}</td><td ng-if=\"impactPenalitRemiseRegul.type == \'REFUND\' || impactPenalitRemiseRegul.type == \'REFUND_BALANCE_TRANSFER\'\">{{- impactPenalitRemiseRegul.montantTtc | currency:\"\":2}}</td><td ng-if=\"impactPenalitRemiseRegul.type == \'DISCOUNT\'\"></td><td></td></tr><tr class=\"success small\" ng-repeat=\"payment in collectionListePaye.listPaymentReceived track by payment.id\"><td colspan=\"2\">{{\"wamasysApp.contrat.paiement.paymentInOrigin\" | translate }} {{\'wamasysApp.contrat.paiement.origin.\'+payment.codeOrigin | translate }}, record by {{payment.refOrigin}}, method {{payment.paymentMethod}}</td><td>{{payment.paymentDate | date:\'medium\'}}</td><td></td><td></td><td></td><td></td><td>{{payment.paidInclTax | currency:\"\":2}}</td><td></td><td><button ng-if=\"vm.canEditContract\" type=\"submit\" ui-sref=\"contrat-detail.historiquepaiements.paymentcorrection({idPayment:payment.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm ng-scope\" translate=\"entity.action.edit\">edit</span></button></td></tr></tbody></table><table class=\"table table-striped table-bordered table-hover billing-history-table\" width=\"100%\" ng-if=\"vm.isBillingDisplayMode()\"><colgroup><col class=\"billing-history-table__type\"><col class=\"billing-history-table__label\"><col class=\"billing-history-table__date\"><col class=\"billing-history-table__quantity\"><col class=\"billing-history-table__amount\"><col class=\"billing-history-table__amount\"><col class=\"billing-history-table__amount\"><col class=\"billing-history-table__amount\"><col class=\"billing-history-table__amount\"><col class=\"billing-history-table__actions\"></colgroup><thead><tr><th translate=\"wamasysApp.contrat.service.type\">type</th><th translate=\"wamasysApp.contrat.paiement.label\">Label</th><th translate=\"wamasysApp.collectionListe.dateFacturation\">Date facturation</th><th translate=\"wamasysApp.collectionListe.quantity\">Quantity</th><th translate=\"wamasysApp.collectionListe.moneyBoxAvantPaiement\">Money box avant paiement</th><th translate=\"wamasysApp.collectionListe.montantAPayer\">montantAPayer</th><th translate=\"wamasysApp.collectionListe.totalACollecter\">totalACollecter</th><th translate=\"wamasysApp.collectionListe.totalPaye\">totalPaye</th><th translate=\"wamasysApp.collectionListe.moneyBoxApresPaiement\">Money box après paiement</th><th></th></tr></thead><tbody ng-repeat=\"groupedBilling in vm.groupedCollectionListeValide track by (groupedBilling.billingId || $index)\"><tr><td>BILLING</td><td class=\"billing-history-table__label-cell\">#{{groupedBilling.billingId}} <small class=\"billing-history-table__secondary\">{{groupedBilling.lineCount}} {{\'wamasysApp.contrat.paiement.billingServiceCount\' | translate}}</small></td><td>{{groupedBilling.billingDate | date:\'medium\'}}</td><td class=\"text-center\">-</td><td>{{groupedBilling.moneyboxAvantPaiement | currency:\"\":2}}</td><td>{{groupedBilling.montantAPayerTtc | currency:\"\":2}}</td><td>{{groupedBilling.totalACollecter | currency:\"\":2}}</td><td>{{groupedBilling.totalPayeTtc | currency:\"\":2}}</td><td>{{groupedBilling.moneyboxApresPaiement | currency:\"\":2}}</td><td><button type=\"button\" ng-click=\"vm.toggleBillingDetails(groupedBilling)\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon\" ng-class=\"groupedBilling.detailsVisible ? \'glyphicon-chevron-up\' : \'glyphicon-chevron-down\'\"></span> <span ng-bind=\"groupedBilling.detailsVisible ? (\'wamasysApp.contrat.paiement.hideDetails\' | translate) : (\'wamasysApp.contrat.paiement.showDetails\' | translate)\">Détail</span></button></td></tr><tr ng-if=\"groupedBilling.detailsVisible\"><td colspan=\"10\" style=\"padding: 0\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover billing-history-table\" style=\"margin-bottom: 0\"><colgroup><col class=\"billing-history-table__type\"><col class=\"billing-history-table__label\"><col class=\"billing-history-table__date\"><col class=\"billing-history-table__quantity\"><col class=\"billing-history-table__amount\"><col class=\"billing-history-table__amount\"><col class=\"billing-history-table__amount\"><col class=\"billing-history-table__amount\"><col class=\"billing-history-table__amount\"><col class=\"billing-history-table__actions\"></colgroup><tbody ng-repeat=\"collectionListePaye in groupedBilling.lines track by collectionListePaye.idLignePaiementService\"><tr><td>BILLING</td><td class=\"billing-history-table__label-cell\" data-line-id=\"{{collectionListePaye.idLignePaiementService}}\"><span class=\"billing-history-table__label-text\" title=\"{{collectionListePaye.ligneContrat.serviceVendu.libelle}}\">{{collectionListePaye.ligneContrat.serviceVendu.libelle}} </span><small class=\"billing-history-table__secondary\" ng-if=\"collectionListePaye.ligneContrat.serviceVendu.typePaiement===\'A_PAYER_AVEC_ECHELONNEMENT\'\">Total Paid {{collectionListePaye.montantTotalDejaPaye}} / {{collectionListePaye.montantTotalAPayer}} </small><small class=\"billing-history-table__secondary\" ng-if=\"collectionListePaye.ligneContrat.serviceVendu.typePaiement===\'A_PAYER_SUR_CONSO_EAU\' && collectionListePaye.valeurCompteurReleve !== null && collectionListePaye.valeurCompteurReleve !== undefined\">{{\'wamasysApp.contrat.paiement.usedBillingIndex\' | translate}} : {{collectionListePaye.valeurCompteurReleve | number:3}}</small></td><td>{{collectionListePaye.datePaiement | date:\'medium\'}}</td><td>{{collectionListePaye.quantity | currency:\"\":3}}</td><td>{{collectionListePaye.moneyboxAvantPaiement | currency:\"\":2}}</td><td>{{collectionListePaye.montantAPayerTtc | currency:\"\":2}}</td><td>{{(collectionListePaye.montantAPayerTtc - collectionListePaye.moneyboxAvantPaiement )| currency:\"\":2}}</td><td>{{collectionListePaye.totalPayeTtc | currency:\"\":2}}</td><td>{{collectionListePaye.moneyboxApresPaiement | currency:\"\":2}}</td><td><button type=\"submit\" ng-click=\"vm.modalDetailPayment(collectionListePaye.listPaymentReceived)\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm ng-scope\" translate=\"entity.action.view\">View</span></button></td></tr><tr ng-repeat=\"impactPenalitRemiseRegul in collectionListePaye.listImpactPenalitRemiseRegul\" class=\"warning small\"><td colspan=\"2\">{{impactPenalitRemiseRegul.type}} / {{impactPenalitRemiseRegul.label}}</td><td>{{impactPenalitRemiseRegul.createdDate | date:\'medium\'}}</td><td></td><td></td><td ng-if=\"impactPenalitRemiseRegul.type == \'DISCOUNT\'\">- {{impactPenalitRemiseRegul.montantTtc | currency:\"\":2}}</td><td ng-if=\"impactPenalitRemiseRegul.type != \'DISCOUNT\'\"></td><td></td><td></td><td ng-if=\"impactPenalitRemiseRegul.type != \'DISCOUNT\' && impactPenalitRemiseRegul.type != \'REFUND\' && impactPenalitRemiseRegul.type != \'REFUND_BALANCE_TRANSFER\'\">{{impactPenalitRemiseRegul.montantTtc | currency:\"\":2}}</td><td ng-if=\"impactPenalitRemiseRegul.type == \'REFUND\' || impactPenalitRemiseRegul.type == \'REFUND_BALANCE_TRANSFER\'\">{{- impactPenalitRemiseRegul.montantTtc | currency:\"\":2}}</td><td ng-if=\"impactPenalitRemiseRegul.type == \'DISCOUNT\'\"></td><td></td></tr><tr class=\"success small\" ng-repeat=\"payment in collectionListePaye.listPaymentReceived track by payment.id\"><td colspan=\"2\">{{\"wamasysApp.contrat.paiement.paymentInOrigin\" | translate }} {{\'wamasysApp.contrat.paiement.origin.\'+payment.codeOrigin | translate }}, record by {{payment.refOrigin}}, method {{payment.paymentMethod}}</td><td>{{payment.paymentDate | date:\'medium\'}}</td><td></td><td></td><td></td><td></td><td>{{payment.paidInclTax | currency:\"\":2}}</td><td></td><td><button ng-if=\"vm.canEditContract\" type=\"submit\" ui-sref=\"contrat-detail.historiquepaiements.paymentcorrection({idPayment:payment.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm ng-scope\" translate=\"entity.action.edit\">edit</span></button></td></tr></tbody></table></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div><!-- end widget content --></div><!-- end widget div --></div><!-- end widget --></div></div><div id=\"modalPaymentReceived\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" translate=\"wamasysApp.contrat.paiement.title\">Payment received</h4></div><div class=\"modal-body\"><div class=\"widget-body no-padding table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th translate=\"wamasysApp.contrat.paiement.date\">date</th><th translate=\"wamasysApp.contrat.paiement.codeOrigin\">codeOrigin</th><th translate=\"wamasysApp.contrat.paiement.refOrigin\">refOrigin</th><th translate=\"wamasysApp.contrat.paiement.paymentMethode\">paymentMethod</th><th translate=\"wamasysApp.contrat.paiement.paidInclTax\">paidInclTax</th><th translate=\"wamasysApp.contrat.paiement.paidExclTax\">paidExclTax</th><th translate=\"wamasysApp.contrat.paiement.taxPaid\">taxPaid</th><th translate=\"wamasysApp.contrat.paiement.metadata\">metadata</th><!-- 										<th translate=\"wamasysApp.contrat.paiement.receiptDate\">receiptDate</th> --></tr></thead><tbody><tr ng-repeat=\"paymentReceived in vm.detailListPaymentReceived\"><td>{{paymentReceived.paymentDate}}</td><td>{{paymentReceived.codeOrigin}}</td><td>{{paymentReceived.refOrigin}}</td><td>{{paymentReceived.paymentMethod}}</td><td>{{paymentReceived.paidInclTax}}</td><td>{{paymentReceived.paidExclTax}}</td><td>{{paymentReceived.taxPaid}}</td><td>{{paymentReceived.metadataPayment}}</td><!-- 										<td>{{paymentReceived.receiptDate}}</td> --></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button><!--         <button type=\"button\" class=\"btn btn-primary\">Save changes</button> --></div></div></div></div>");
$templateCache.put("app/business/contrat/impact-penalit-remise-regul-contrat-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myImpactPenalitRemiseRegulContratLabel\" translate=\"wamasysApp.contrat.paiement.titreAjoutPenalite.{{vm.impactPenalitRemiseRegul.type}}\">Create or edit a ImpactPenalitRemiseRegul</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.paiement.montantTtc\" for=\"field_montantTtcContrat\">Montant</label><input type=\"number\" class=\"form-control\" name=\"montantTtc\" id=\"field_montantTtcContrat\" ng-model=\"vm.impactPenalitRemiseRegul.montantTtc\" ng-change=\"vm.updateSuggestedAllocations()\" required min=\"0\" max=\"999999999\"></div></div><div class=\"col-md-4\" ng-if=\"vm.impactPenalitRemiseRegul.type != \'REFUND\' \"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.paiement.label\" for=\"field_labelContrat\">label</label><input required type=\"text\" class=\"form-control\" name=\"label\" id=\"field_labelContrat\" ng-model=\"vm.impactPenalitRemiseRegul.label\" ng-maxlength=\"50\"></div></div><div class=\"col-md-5\" ng-if=\"vm.impactPenalitRemiseRegul.type != \'REFUND\' \"><div class=\"form-group\" ng-if=\"vm.impactPenalitRemiseRegul.type == \'CREDIT_NOTE\' \"><label translate=\"wamasysApp.contrat.paiement.raison\" for=\"field_typeAvoirContrat\">typeAvoir</label><select ng-required=\"vm.impactPenalitRemiseRegul.type == \'CREDIT_NOTE\' \" class=\"form-control\" id=\"field_typeAvoirContrat\" name=\"typeAvoir\" ng-model=\"vm.impactPenalitRemiseRegul.typeAvoir\" ng-options=\"typeAvoir as typeAvoir.libelle for typeAvoir in vm.typeAvoirs track by typeAvoir.id\"><option value=\"\"></option></select></div><div class=\"form-group\" ng-if=\"vm.impactPenalitRemiseRegul.type == \'DISCOUNT\'\"><label translate=\"wamasysApp.contrat.paiement.raison\" for=\"field_typeRemisecommercialeContrat\">typeRemisecommerciale</label><select ng-required=\"vm.impactPenalitRemiseRegul.type == \'DISCOUNT\'\" class=\"form-control\" id=\"field_typeRemisecommercialeContrat\" name=\"typeRemisecommerciale\" ng-model=\"vm.impactPenalitRemiseRegul.typeRemisecommerciale\" ng-options=\"typeRemisecommerciale as typeRemisecommerciale.libelle for typeRemisecommerciale in vm.typeremisecommerciales track by typeRemisecommerciale.id\"><option value=\"\"></option></select></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.paiement.commentaire\" for=\"field_commentaireContrat\">Commentaire</label><textarea required rows=\"2\" cols=\"50\" type=\"text\" class=\"form-control\" name=\"commentaire\" id=\"field_commentaireContrat\" ng-model=\"vm.impactPenalitRemiseRegul.commentaire\" ng-maxlength=\"512\"></textarea></div></div></div><div class=\"row\" ng-if=\"vm.lignecontrats.length > 0\"><div class=\"col-md-12\"><h5 translate=\"wamasysApp.contrat.paiement.proposedAllocation\">Répartition proposée</h5><table class=\"table table-condensed table-bordered table-striped\"><thead><tr><th translate=\"wamasysApp.collectionListe.service\">Service</th><th translate=\"wamasysApp.contrat.service.resteAPayer\">resteAPayer</th><th translate=\"wamasysApp.contrat.paiement.amountToAllocate\">Montant à affecter</th></tr></thead><tbody><tr ng-repeat=\"ligneContrat in vm.lignecontrats track by ligneContrat.id\"><td>{{ligneContrat.libelle}} ({{ligneContrat.serviceVendu.libelle}})</td><td>{{vm.getRemainingToBePaid(ligneContrat) | currency:\"\":2}}</td><td style=\"width: 180px\"><input type=\"number\" class=\"form-control input-sm\" ng-model=\"ligneContrat.montantAffecte\" min=\"0\" max=\"999999999\" step=\"0.01\"></td></tr></tbody></table><div class=\"text-right\"><strong translate=\"wamasysApp.contrat.paiement.allocatedTotal\">Total affecté</strong> : <span ng-class=\"{\'text-danger\': !vm.hasValidAllocatedTotal(), \'text-success\': vm.hasValidAllocatedTotal()}\">{{vm.getAllocatedTotal() | currency:\"\":2}}</span><br><small class=\"text-muted\"><span translate=\"wamasysApp.contrat.paiement.currentBaseTotal\">Total de la base actuelle</span> : {{vm.getCurrentBaseTotal() | currency:\"\":2}}</small></div></div></div><div class=\"alert alert-info\" ng-if=\"vm.lignecontrats.length === 0\"><span translate=\"wamasysApp.contrat.paiement.noEligibleService\">Aucun service n\'est disponible pour cette action.</span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving || !vm.hasValidAllocatedTotal()\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/contrat/impact-penalit-remise-regul-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.impactPenalitRemiseRegul.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"wamasysApp.contrat.paiement.titreDeletePenalite\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p ng-if=\"! vm.impactPenalitRemiseRegul.lignePaiementServiceId \" translate=\"wamasysApp.contrat.paiement.questionDeletePenalite\" translate-values=\"{label: \'{{vm.impactPenalitRemiseRegul.label}}\'}\">Are you sure you want to delete this ImpactPenalitRemiseRegul?</p><p ng-if=\" vm.impactPenalitRemiseRegul.lignePaiementServiceId \" translate=\"wamasysApp.contrat.paiement.cancelQuestion\" translate-values=\"{label: \'{{vm.impactPenalitRemiseRegul.label}}\'}\">Are you sure you want to delete this ImpactPenalitRemiseRegul?</p><div class=\"row\" ng-if=\" vm.impactPenalitRemiseRegul.lignePaiementServiceId \"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.paiement.commentaire\" for=\"field_commentaire\">Commentaire</label><textarea required rows=\"2\" cols=\"50\" type=\"text\" class=\"form-control\" name=\"commentaire\" id=\"field_commentaire\" ng-model=\"vm.commentaire\" ng-maxlength=\"512\"></textarea><div ng-show=\"editForm.commentaire.$invalid\"><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"512\">This field cannot be longer than 512 characters.</p></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/contrat/impact-penalit-remise-regul-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myImpactPenalitRemiseRegulLabel\" translate=\"wamasysApp.contrat.paiement.titreAjoutPenalite.{{vm.impactPenalitRemiseRegul.type}}\">Create or edit a ImpactPenalitRemiseRegul</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-3\"><!--         <div class=\"form-group\"> --><!--             <label class=\"control-label\" translate=\"wamasysApp.contrat.paiement.type\" for=\"field_type\">Type</label> --><!--             <select class=\"form-control\" name=\"type\" ng-model=\"vm.impactPenalitRemiseRegul.type\" id=\"field_type\" required> --><!--                 <option value=\"PENALITE\" translate=\"wamasysApp.contrat.paiement.TypePenalitRemiseRegul.PENALITE\">PENALITE</option> --><!--                 <option value=\"REMISE\" translate=\"wamasysApp.contrat.paiement.TypePenalitRemiseRegul.REMISE\">REMISE</option> --><!--                 <option value=\"REGULATION\" translate=\"wamasysApp.contrat.paiement.TypePenalitRemiseRegul.REGULATION\">REGULATION</option> --><!--             </select> --><!--             <div ng-show=\"editForm.type.$invalid\"> --><!--                 <p class=\"help-block\" --><!--                     ng-show=\"editForm.type.$error.required\" translate=\"entity.validation.required\"> --><!--                     This field is required. --><!--                 </p> --><!--             </div> --><!--         </div> --><div class=\"alert alert-warning\" ng-show=\"vm.impactPenalitRemiseRegul.type == \'REMISE\'\"><span translate=\"wamasysApp.contrat.paiement.explicationRegulation\"></span></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.paiement.montantTtc\" for=\"field_montantTtc\">Montant</label><input type=\"number\" class=\"form-control\" name=\"montantTtc\" id=\"field_montantTtc\" ng-model=\"vm.impactPenalitRemiseRegul.montantTtc\" required min=\"0\" max=\"999999999\"><div ng-show=\"editForm.montantTtc.$invalid\"><p class=\"help-block\" ng-show=\"editForm.montantTtc.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.montantTtc.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.montantTtc.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"9999999999\">This field cannot be more than 999999999.</p><p class=\"help-block\" ng-show=\"editForm.montantTtc.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></div><div class=\"col-md-4\" ng-if=\"vm.impactPenalitRemiseRegul.type != \'REFUND\' \"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.paiement.label\" for=\"field_label\">label</label><input required type=\"text\" class=\"form-control\" name=\"label\" id=\"field_label\" ng-model=\"vm.impactPenalitRemiseRegul.label\" ng-maxlength=\"50\"><div ng-show=\"editForm.label.$invalid\"><p class=\"help-block\" ng-show=\"editForm.label.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.label.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div></div><div class=\"col-md-5\" ng-if=\"vm.impactPenalitRemiseRegul.type != \'REFUND\' \"><div class=\"form-group\" ng-if=\"vm.impactPenalitRemiseRegul.type == \'CREDIT_NOTE\' \"><!-- || vm.impactPenalitRemiseRegul.type == \'DEBT_WAIVER\' --><label translate=\"wamasysApp.contrat.paiement.raison\" for=\"field_typeAvoir\">typeAvoir</label><select ng-required=\"vm.impactPenalitRemiseRegul.type == \'CREDIT_NOTE\' \" class=\"form-control\" id=\"field_typeAvoir\" name=\"typeAvoir\" ng-model=\"vm.impactPenalitRemiseRegul.typeAvoir\" ng-options=\"typeAvoir as typeAvoir.libelle for typeAvoir in vm.typeAvoirs track by typeAvoir.id\"><option value=\"\"></option></select><div ng-show=\"editForm.typeAvoir.$invalid\"><p class=\"help-block\" ng-show=\"editForm.typeAvoir.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\" ng-if=\"vm.impactPenalitRemiseRegul.type == \'DISCOUNT\'\"><label translate=\"wamasysApp.contrat.paiement.raison\" for=\"field_typeRemisecommerciale\">typeRemisecommerciale</label><select ng-required=\"vm.impactPenalitRemiseRegul.type == \'DISCOUNT\'\" class=\"form-control\" id=\"field_typeRemisecommerciale\" name=\"typeRemisecommerciale\" ng-model=\"vm.impactPenalitRemiseRegul.typeRemisecommerciale\" ng-options=\"typeRemisecommerciale as typeRemisecommerciale.libelle for typeRemisecommerciale in vm.typeremisecommerciales track by typeRemisecommerciale.id\"><option value=\"\"></option></select><div ng-show=\"editForm.typeRemisecommerciale.$invalid\"><p class=\"help-block\" ng-show=\"editForm.typeRemisecommerciale.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.paiement.commentaire\" for=\"field_commentaire\">Commentaire</label><textarea required rows=\"2\" cols=\"50\" type=\"text\" class=\"form-control\" name=\"commentaire\" id=\"field_commentaire\" ng-model=\"vm.impactPenalitRemiseRegul.commentaire\" ng-maxlength=\"512\"></textarea><div ng-show=\"editForm.commentaire.$invalid\"><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"512\">This field cannot be longer than 512 characters.</p></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/contrat/information-contrat.html","<br><div class=\"row\"><div class=\"col-md-3\"><dt><span translate=\"wamasysApp.contrat.referenceContrat\">ReferenceContrat</span></dt><dd>{{vm.contrat.referenceContrat}} <small ng-show=\"vm.contrat.ancienneReferenceContrat\">( <span translate=\"wamasysApp.contrat.ancienneReferenceContrat\">ReferenceContrat</span>: {{vm.contrat.ancienneReferenceContrat}} )</small></dd></div><!-- 	<div class=\"col-md-2\"  ng-show=\"vm.contrat.ancienneReferenceContrat\">\n		<dt>\n			<span translate=\"wamasysApp.contrat.ancienneReferenceContrat\">ReferenceContrat</span>\n		</dt>\n		<dd>{{vm.contrat.ancienneReferenceContrat}}</dd>\n	</div>	 --><div class=\"col-md-2\"><dt><span translate=\"wamasysApp.contrat.etat\">Etat Contrat</span><div class=\"btn-group btn-group-xs\" style=\"margin-left: 6px\"><a ui-sref=\"contrat-detail.information.contract-history({id:vm.contrat.id})\" class=\"btn btn-default\" has-module=\"NEW_FEATURES_VISIBILITY\" title=\"Voir historique\"><i class=\"fa fa-history\"></i> </a><a ui-sref=\"contrat-detail.information.change-status({id:vm.contrat.id})\" class=\"btn btn-default\" has-module=\"NEW_FEATURES_VISIBILITY\" title=\"Modifier\"><span class=\"glyphicon glyphicon-pencil\"></span></a></div></dt><dd><span translate=\"{{\'wamasysApp.EtatContrat.\' + vm.contrat.etat}}\">{{vm.contrat.etat}}</span> <small ng-if=\"vm.contrat.lastStatusChangeDate\">({{vm.contrat.lastStatusChangeDate | date:\'medium\'}})</small></dd></div><div class=\"col-md-3\"><dt><span translate=\"wamasysApp.contrat.dateActivation\">Date Activation</span></dt><dd><span>{{vm.contrat.dateActivation | date:\'mediumDate\'}}</span></dd></div><div class=\"col-md-1\"><div ng-show=\"vm.contrat.etat == \'CLOSED\'\"><dt><span translate=\"wamasysApp.contrat.dateCloture\">DateCloture</span></dt><dd><span>{{vm.contrat.dateCloture | date:\'mediumDate\'}}</span></dd></div></div><div class=\"col-md-1\"><div ng-show=\"vm.contrat.etat == \'CLOSED\'\"><dt><span translate=\"wamasysApp.contrat.closingContractReason\">closingContractReason</span></dt><dd><span>{{vm.contrat.closingContractReasonLabel}}</span></dd></div></div><div class=\"col-md-2\"><div class=\"pull-right\"><div class=\"btn-group\"><button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\"><span translate=\"wamasysApp.contrat.actions.title\">Action</span> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-if=\"vm.canEditContract\" ng-show=\"vm.contrat.etat != \'CLOSED\'\"><a ui-sref=\"contrat-detail.information.cloturer({id:vm.contrat.id})\" translate=\"wamasysApp.contrat.cloturer\">Résilier le contrat</a></li><li ng-if=\"vm.canEditContract\" ng-show=\"vm.contrat.etat == \'CLOSED\'\"><a ui-sref=\"contrat-detail.information.activer({id:vm.contrat.id})\" translate=\"wamasysApp.contrat.activer\">Activer	le contrat</a></li><li ng-if=\"vm.canEditContract\" class=\"divider\" has-module=\"NEW_FEATURES_VISIBILITY\"></li><li ng-if=\"vm.canEditContract\" ng-show=\"vm.contrat.etat != \'CLOSED\'\"><a ui-sref=\"contrat-detail.information.change-status({id:vm.contrat.id})\" has-module=\"NEW_FEATURES_VISIBILITY\" translate=\"wamasysApp.contrat.actions.changeStatus\">Changer l\'état</a></li><li ng-if=\"vm.canEditContract\"><a ui-sref=\"contrat-detail.information.add-note({id:vm.contrat.id})\" has-module=\"NEW_FEATURES_VISIBILITY\" translate=\"wamasysApp.contrat.actions.addNote\">Créer une note</a></li><li><a ui-sref=\"contrat-detail.information.contract-history({id:vm.contrat.id})\" has-module=\"NEW_FEATURES_VISIBILITY\" translate=\"wamasysApp.contrat.actions.contractHistory\">Historique des changements</a></li><li><a ui-sref=\"contrat-detail.information.status-help({id:vm.contrat.id})\" translate=\"wamasysApp.contrat.actions.statusHelp\">Aide sur les états</a></li><li ng-if=\"vm.canEditContract\" class=\"divider\"></li><li ng-if=\"vm.canEditContract\"><a translate=\"wamasysApp.contrat.changerCompteur\" ui-sref=\"contrat-detail.information.changercompteur({id:vm.contrat.id})\">Changer le compteur individuel</a></li><li><a translate=\"wamasysApp.contrat.informationContrat.historiqueCompteur\" ui-sref=\"contrat-detail.information.historique-changement-compteur({id:vm.contrat.id})\">historique compteur</a></li><li><a translate=\"wamasysApp.contrat.informationContrat.historiqueConsommationEau\" ui-sref=\"contrat-detail.information.historiqueconsoeau({id:vm.contrat.id})\">historique conso eau</a></li><li ng-if=\"vm.canEditContract && vm.contrat.individualMeter\"><a translate=\"wamasysApp.contrat.informationContrat.correctionConsommationEau\" ui-sref=\"contrat-detail.information.add-water-correction({id:vm.contrat.id})\">Correction conso eau</a></li></ul></div></div></div></div><br><div class=\"row\"><div class=\"col-md-3\"><dt><span translate=\"wamasysApp.contrat.numeroSerieCompteur\">Numero serie compteur</span></dt><dd><span><a ui-sref=\"individual-meter-detail({id:vm.contrat.individualMeter.id})\">{{vm.contrat.individualMeter.numeroSerie}}</a><span></span></span></dd></div><div class=\"col-md-2\"><dt><span translate=\"wamasysApp.contrat.etatCompteur\">Etat compteur</span></dt><dd><span ng-show=\"vm.contrat.individualMeter != null\" translate=\"{{\'wamasysApp.EtatMeter.\' + vm.contrat.individualMeter.etat}}\">{{vm.contrat.individualMeter.etat}}<span></span></span></dd></div><div class=\"col-md-3\"></div><div class=\"col-md-4\"><dt><span translate=\"global.field.dateCreation\">DateCreation</span></dt><dd><span>{{vm.contrat.createdDate | date:\'medium\'}} by {{vm.contrat.createdBy}}</span></dd></div></div><hr><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><fieldset ng-disabled=\"!vm.canEditContract\"><div class=\"row\"><div css-col-if-has-module=\"GEO\"><fieldset class=\"smart-form\"><div class=\"row\"><section class=\"col col-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.nomPersonne\" for=\"field_nomPersonne\">NomPersonne</label><label class=\"input\"><i class=\"icon-prepend fa fa-user\"></i><input type=\"text\" class=\"form-control\" name=\"nomPersonne\" id=\"field_nomPersonne\" ng-model=\"vm.contrat.nomPersonne\" required ng-maxlength=\"50\"></label><div ng-show=\"editForm.nomPersonne.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nomPersonne.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nomPersonne.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div></section><section class=\"col col-2\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.indexAdresse\" for=\"field_indexAdresse\">IndexAdresse</label><label class=\"input\"><i class=\"icon-prepend fa fa-globe\"></i> <input type=\"number\" class=\"form-control\" name=\"indexAdresse\" id=\"field_indexAdresse\" ng-model=\"vm.contrat.indexAdresse\" min=\"0\" max=\"999999\"></label><div ng-show=\"editForm.indexAdresse.$invalid\"><p class=\"help-block\" ng-show=\"editForm.indexAdresse.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.indexAdresse.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\">This field cannot be more than 999999.</p><p class=\"help-block\" ng-show=\"editForm.indexAdresse.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></section><section class=\"col col-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.phone\" for=\"field_phone\">Phone</label><label class=\"input\"><i class=\"icon-prepend fa fa-phone\"></i> <input type=\"text\" class=\"form-control\" name=\"phone\" id=\"field_phone\" ng-model=\"vm.contrat.phone\" ng-maxlength=\"30\"></label><div ng-show=\"editForm.phone.$invalid\"><p class=\"help-block\" ng-show=\"editForm.phone.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"30\">This field cannot be longer than 30 characters.</p></div></div></section><section class=\"col col-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.email\" for=\"field_email\">Email</label><label class=\"input\"><i class=\"icon-prepend fa fa-envelope-o\"></i> <input type=\"text\" class=\"form-control\" name=\"email\" id=\"field_email\" ng-model=\"vm.contrat.email\" ng-maxlength=\"256\"></label><div ng-show=\"editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div></section></div></fieldset><fieldset class=\"smart-form\"><div class=\"row\"><section class=\"col col-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.adresse\" for=\"field_adresse\">Adresse</label><textarea ng-maxlength=\"256\" cols=\"50\" type=\"text\" class=\"form-control\" name=\"adresse\" id=\"field_adresse\" ng-model=\"vm.contrat.adresse\" required></textarea><div ng-show=\"editForm.adresse.$invalid\"><p class=\"help-block\" ng-show=\"editForm.adresse.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.adresse.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div></section><section class=\"col col-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.nombreFamille\" for=\"field_nombreFamille\">NombreFamille</label><input type=\"number\" class=\"form-control\" name=\"nombreFamille\" id=\"field_nombreFamille\" ng-model=\"vm.contrat.nombreFamille\" required min=\"0\" max=\"999999\"><div ng-show=\"editForm.nombreFamille.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nombreFamille.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nombreFamille.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.nombreFamille.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\">This field cannot be more than 999999.</p><p class=\"help-block\" ng-show=\"editForm.nombreFamille.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></section><section class=\"col col-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.nombrePersonne\" for=\"field_nombrePersonne\">NombrePersonne</label><input type=\"number\" class=\"form-control\" name=\"nombrePersonne\" id=\"field_nombrePersonne\" ng-model=\"vm.contrat.nombrePersonne\" required min=\"0\" max=\"999999\"><div ng-show=\"editForm.nombrePersonne.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nombrePersonne.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nombrePersonne.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.nombrePersonne.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\">This field cannot be more than 999999.</p><p class=\"help-block\" ng-show=\"editForm.nombrePersonne.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></section></div></fieldset><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.commentaire\" for=\"field_commentaire\">Commentaire</label><textarea type=\"text\" class=\"form-control\" name=\"commentaire\" id=\"field_commentaire\" ng-model=\"vm.contrat.commentaire\" ng-maxlength=\"256\"></textarea><div ng-show=\"editForm.commentaire.$invalid\"><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div><fieldset class=\"smart-form\"><div class=\"row\"><section class=\"col col-3\"><div class=\"form-group\"><label class=\"toggle\"><input type=\"checkbox\" id=\"field_compteurFerme\" name=\"compteurFerme\" ng-model=\"vm.contrat.compteurFerme\"> <i data-swchon-text=\"ON\" data-swchoff-text=\"OFF\"></i> <span translate=\"wamasysApp.contrat.compteurFerme\">Compteur ferme</span></label></div></section><section class=\"col col-3\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.contractType\" for=\"field_contractType\">type contrat</label><select class=\"form-control\" id=\"field_contractType\" name=\"contractType\" ng-model=\"vm.contrat.contractType\" ng-options=\"contractType as contractType.label for contractType in vm.contractTypes track by contractType.id\"><option value=\"\"></option></select></div></section><section class=\"col col-3\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.contractProfil\" for=\"field_contractProfil\">profil contrat</label><select class=\"form-control\" id=\"field_contractProfil\" name=\"contractProfil\" ng-model=\"vm.contrat.contractProfil\" ng-options=\"contractProfil as contractProfil.libelle for contractProfil in vm.contractProfils track by contractProfil.id\"><option value=\"\"></option></select></div></section><section class=\"col col-3\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.portefeuilleContrat\" for=\"field_portefeuilleContrat\">portefeuilleContrat</label><select class=\"form-control\" id=\"field_portefeuilleContrat\" name=\"portefeuilleContrat\" ng-model=\"vm.contrat.portefeuilleContrat\" ng-options=\"portefeuilleContrat as portefeuilleContrat.libelle for portefeuilleContrat in vm.portefeuillecontrats track by portefeuilleContrat.id\"><option value=\"\"></option></select></div></section></div></fieldset><fieldset has-module=\"ONLINE_PAYMENT\" ng-if=\"vm.onlinePaymentConf.active && vm.onlinePaymentConf.type && vm.onlinePaymentConf.type.indexOf(\'MTN_USSD_V1\') !== -1\"><div><div jarvis-widget id=\"form-grid-widget\" data-widget-colorbutton=\"false\" data-widget-editbutton=\"false\" data-widget-custombutton=\"false\"><div><!-- widget content --><div class=\"widget-body no-padding\"><div jarvis-widget id=\"hide-show-columns-table-widget\" data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"><header><span class=\"widget-icon\"><i class=\"fa fa-table\"></i></span><h2 translate=\"wamasysApp.contrat.onlinePayment.tableau\">Tableau</h2><button ng-if=\"vm.canEditContract\" class=\"btn-sm pull-right btn btn-primary\" ui-sref=\"contrat-detail.information.onlinePaymentCreate({id:vm.contrat.id})\"><!-- 								<span class=\"glyphicon glyphicon-print\"></span>  --> <span translate=\"wamasysApp.contrat.onlinePayment.add\">add</span></button></header><div><div class=\"widget-body no-padding table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th translate=\"wamasysApp.contrat.onlinePayment.type\"></th><th translate=\"wamasysApp.contrat.onlinePayment.idExterne\"></th><th translate=\"wamasysApp.contrat.onlinePayment.metadata\"></th><th translate=\"wamasysApp.contrat.onlinePayment.creationDate\"></th><th translate=\"wamasysApp.contrat.onlinePayment.createdBy\"></th><th translate=\"wamasysApp.contrat.onlinePayment.active\"></th><th translate=\"wamasysApp.contrat.onlinePayment.deletedDate\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"onlinePayment in vm.onlinePaymentList\"><td>{{onlinePayment.type}}</td><td>{{onlinePayment.idExterne}}</td><td>{{onlinePayment.metadata}}</td><td>{{onlinePayment.creationDate | date:\'medium\'}}</td><td>{{onlinePayment.author}}</td><td>{{onlinePayment.active}}</td><td>{{onlinePayment.deletedDate | date:\'medium\'}}</td><td><a ng-if=\"vm.canManageOnlinePayment && onlinePayment.active == true\" ui-sref=\"contrat-detail.information.onlinePaymentDelete({idOnlinepayment:onlinePayment.id})\" translate=\"wamasysApp.contrat.onlinePayment.cloturer\"></a></td></tr></tbody></table></div><!-- 									    <div class=\"text-center\"> --><!-- 									        <jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count> --><!-- 									        <uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination> --><!-- 									    </div> --></div></div></div></div></div></div></fieldset><fieldset has-module=\"COMMUNICATION\"><div><div jarvis-widget id=\"communication-subscriptions-widget\" data-widget-colorbutton=\"false\" data-widget-editbutton=\"false\" data-widget-custombutton=\"false\"><div><div class=\"widget-body no-padding\"><div jarvis-widget id=\"communication-subscriptions-table-widget\" data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"><header><span class=\"widget-icon\"><i class=\"fa fa-bullhorn\"></i></span><h2 translate=\"wamasysApp.contrat.communicationSubscription.tableau\">Tableau</h2><button ng-if=\"vm.canManageCommunicationSubscriptions\" class=\"btn-sm pull-right btn btn-primary\" ui-sref=\"contrat-detail.information.communicationSubscriptionCreate({id:vm.contrat.id})\"><span translate=\"wamasysApp.contrat.communicationSubscription.add\">Ajouter</span></button></header><div><div class=\"widget-body no-padding table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th translate=\"wamasysApp.contrat.communicationSubscription.topic\"></th><th translate=\"wamasysApp.contrat.communicationSubscription.code\"></th><th translate=\"wamasysApp.contrat.communicationSubscription.category\"></th><th translate=\"wamasysApp.contrat.communicationSubscription.contractContact\"></th><th translate=\"wamasysApp.contrat.communicationSubscription.date\"></th><th translate=\"wamasysApp.contrat.communicationSubscription.origine\"></th><th translate=\"wamasysApp.contrat.communicationSubscription.verified\"></th><th translate=\"wamasysApp.contrat.communicationSubscription.optin\"></th><th translate=\"wamasysApp.contrat.communicationSubscription.proofData\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"subscription in vm.communicationSubscriptions\"><td>{{subscription.communicationTopicNomClient || subscription.communicationTopicNomInterne}}</td><td>{{subscription.communicationTopicCode}}</td><td>{{subscription.communicationTopicCategoryNom}}</td><td>{{ (\'wamasysApp.ContractContact.\' + subscription.contractContact) | translate }}</td><td>{{subscription.date | date:\'medium\'}}</td><td>{{subscription.origine}}</td><td>{{subscription.verified}}</td><td>{{subscription.optin}}</td><td>{{subscription.proofData}}</td><td><a class=\"btn btn-xs btn-warning\" ng-if=\"vm.canManageCommunicationSubscriptions && subscription.optin\" ui-sref=\"contrat-detail.information.communicationSubscriptionOptin({idCommunicationSubscription:subscription.id})\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span translate=\"wamasysApp.contrat.communicationSubscription.disable\"></span> </a><a class=\"btn btn-xs btn-success\" ng-if=\"vm.canManageCommunicationSubscriptions && !subscription.optin\" ui-sref=\"contrat-detail.information.communicationSubscriptionOptin({idCommunicationSubscription:subscription.id})\"><span class=\"glyphicon glyphicon-ok-circle\"></span> <span translate=\"wamasysApp.contrat.communicationSubscription.enable\"></span></a></td></tr><tr ng-if=\"!vm.communicationSubscriptions.length\"><td colspan=\"10\" class=\"text-center\" translate=\"wamasysApp.contrat.communicationSubscription.empty\"></td></tr></tbody></table></div></div></div></div></div></div></div></fieldset></div><div class=\"col-md-4\" has-module=\"GEO\"><map-leaflet contrat=\"vm.contrat\"></div></div></fieldset><div class=\"pull-right\" ng-if=\"vm.canEditContract\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form><br>");
$templateCache.put("app/business/contrat/paiement-agence-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.paymentReceived.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"wamasysApp.contrat.paiement.titreDeletePayment\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.contrat.paiement.questionDeletePayment\" translate-values=\"{id: \'{{vm.paymentReceived.id}}\'}\">Are you sure you want to delete this paymentReceived?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/contrat/paiement-agence-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.onSavePayment()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPaiementAgenceLabel\" translate=\"wamasysApp.contrat.paiement.titrePaiementAgence\">Create or edit a PaiementAgence</h4></div><div class=\"modal-body\" id=\"bodyPaiement\"><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><div class=\"well well-md bg-color-green txt-color-white no-border\"><div class=\"fa-lg\">&nbsp; <span class=\"pull-right\"><span translate=\"wamasysApp.contrat.service.montantAPayer\">Montant à payer</span> : <strong>{{vm.calculTotalToBePaid() | currency :\'\':2}}</strong></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.paiement.montant\" for=\"field_montantPayeCollecteur\">MontantPaiementAgence</label><input type=\"number\" class=\"form-control\" name=\"paidAmount\" id=\"field_montantPayeCollecteur\" ng-model=\"vm.paymentDTO.paidAmount\" required min=\"0\" max=\"999999\"><div ng-show=\"editForm.paidAmount.$invalid\"><p class=\"help-block\" ng-show=\"editForm.paidAmount.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.paidAmount.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.paidAmount.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\">This field cannot be more than 999999.</p><p class=\"help-block\" ng-show=\"editForm.paidAmount.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\" ng-if=\"vm.showDetail\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th translate=\"wamasysApp.contrat.service.libelle\">Libelle</th><!-- 								<th translate=\"wamasysApp.contrat.service.dateDerniereFacturation\">dateDerniereFacturation</th> --><th translate=\"wamasysApp.contrat.service.montantAPayer\">montantAPayer</th><th translate=\"wamasysApp.contrat.paiement.montant\">Paid</th></tr></thead><tbody ng-repeat=\"ligneContrat in vm.contrat.ligneContrats track by ligneContrat.id\" ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement\"><tr><td>{{ligneContrat.serviceVendu.libelle }}<br>({{ligneContrat.libelle}})<br><span ng-if=\"ligneContrat.serviceVendu.typePaiement === \'A_PAYER_AVEC_ECHELONNEMENT\' \"><b translate=\"wamasysApp.contrat.service.resteAPayer\"></b> : {{ligneContrat.derniereLignePaiement.montantTotalAPayer - ligneContrat.derniereLignePaiement.montantTotalDejaPaye | currency :\'\':3}}<br></span></td><!-- 								<td >{{ligneContrat.derniereLignePaiement.datePaiement | date:\'mediumDate\'}}</td> --><td>{{- ligneContrat.derniereLignePaiement.moneyboxApresPaiement | currency :\'\':3}}</td><td><input type=\"number\" class=\"form-control\" name=\"paidAmount\" ng-model=\"ligneContrat.derniereLignePaiement.montantPayeCollecteur\" required min=\"0.00\" max=\"999999.99\"><div ng-if=\"ligneContrat.serviceVendu.typePaiement === \'A_PAYER_AVEC_ECHELONNEMENT\' && ligneContrat.derniereLignePaiement.montantPayeCollecteur> (ligneContrat.derniereLignePaiement.montantTotalAPayer - 	ligneContrat.derniereLignePaiement.montantTotalDejaPaye)\" class=\"alert alert-warning\" ng-show=\"! vm.collectionListeEnCours.length\" translate=\"wamasysApp.contrat.paiement.alerteMontantPayeSuperieurAuDu\">Alerte montant payé supérieur au montant dû.</div><div ng-if=\"ligneContrat.serviceVendu.typePaiement === \'A_PAYER_EN_UNE_FOIS\' && ligneContrat.derniereLignePaiement.montantPayeCollecteur > -ligneContrat.derniereLignePaiement.moneyboxApresPaiement\" class=\"alert alert-warning\" ng-show=\"! vm.collectionListeEnCours.length\" translate=\"wamasysApp.contrat.paiement.alerteMontantPayeSuperieurAuDu\">Alerte montant payé supérieur au montant dû.</div></td></tr></tbody></table></div></div><div class=\"modal-body text-center\" id=\"bodyPaiementEffectue\" style=\"display: none\"><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><a class=\"btn btn-default\" href=\"#\" class=\"pull-right\" ng-click=\"vm.printReceipt()\"><span translate=\"wamasysApp.contrat.paiement.printReceipt\">Imprimer le reçu</span> <i class=\"fa fa-3x fa-print\"></i></a><!--  <a href-void=\"\" class=\"btn btn-primary btn-circle btn-xl\" href=\"#\"><i class=\"fa fa-print\"></i></a>--></div><div class=\"modal-footer\" id=\"btnSavePayment\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/contrat/paiement-initial-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPaiementInitialLabel\" translate=\"wamasysApp.contrat.service.titrePaiementInitial\">Create or edit a PaiementInitial</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.service.datePaiementInitial\" for=\"field_datePaiementInitial\">datePaiementInitial</label><div class=\"input-group\"><input id=\"field_datePaiementInitial\" type=\"text\" class=\"form-control\" name=\"datePaiementInitial\" ng-click=\"vm.openCalendar(\'datePaiementInitial\')\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.ligneContrat.datePaiementInitial\" is-open=\"vm.datePickerOpenStatus.datePaiementInitial\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'datePaiementInitial\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.datePaiement.$invalid\"><p class=\"help-block\" ng-show=\"editForm.datePaiementInitial.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.datePaiementInitial.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.service.montantPaiementInitial\" for=\"field_montantPaiementInitial\">MontantPaiementInitial</label><input type=\"number\" class=\"form-control\" name=\"montantPaiementInitial\" id=\"field_montantPaiementInitial\" ng-model=\"vm.ligneContrat.montantPaiementInitial\" required min=\"0\" max=\"999999\"><div ng-show=\"editForm.montantPaiementInitial.$invalid\"><p class=\"help-block\" ng-show=\"editForm.montantPaiementInitial.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.montantPaiementInitial.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.montantPaiementInitial.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\">This field cannot be more than 999999.</p><p class=\"help-block\" ng-show=\"editForm.montantPaiementInitial.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/contrat/paiements-contrat.html","<!-- <div class=\"row\"> --><!-- 	<div class=\"col-md-12 widget-body\"> --><!-- 		<div class=\"tabs-left\"> --><!-- 			<ul class=\"nav nav-tabs tabs-left\" id=\"demo-pill-nav\"> --><!-- 				<li ng-class=\"{\'active\':  vm.activeTab==1 }\"> --><!-- 					<a ng-click=\"vm.setActiveTab(1)\" data-toggle=\"tab\" aria-expanded=\"false\"> --><!-- 					<span class=\"badge bg-color-blueDark txt-color-white\">{{vm.countService}}</span> {{\'wamasysApp.ligneContrat.synthese\' | translate}} </a> --><!-- 				</li> --><!-- 				<li  ng-class=\"{\'active\':  vm.activeTab==2 }\"> --><!-- 					<a ng-click=\"vm.setActiveTab(2)\" data-toggle=\"tab\" aria-expanded=\"false\"> --><!-- 					<span class=\"badge bg-color-blue txt-color-white\">{{vm.countVenteUnitaire}}</span> Collection list en cours</a> --><!-- 				</li> --><!-- 				</ul> --><!-- 			<div class=\"tab-content\"> --><!-- 				<div class=\"tab-pane\" id=\"tab-r1\"  ng-class=\"{\'active\':  vm.activeTab==1 }\"> --><br><div class=\"row\" ng-if=\"vm.hasActiveLine()\"><div class=\"col-md-10\"><div class=\"well well-md bg-color-green txt-color-white no-border\"><div class=\"fa-lg\">&nbsp; <span class=\"pull-right\"><span translate=\"wamasysApp.contrat.service.montantAPayer\">Montant à payer</span> : <strong>{{vm.calculTotalToBePaid() | currency :\'\':2}}</strong></span></div></div></div><div class=\"col-md-2\"><button class=\"btn btn-info btn-lg pull-right\" ui-sref=\"contrat-detail.paiements.paiementagence({idContrat:vm.contrat.id})\" translate=\"wamasysApp.contrat.paiement.paiementenAgence\">Paiement en agence</button></div></div><div class=\"row\" ng-if=\"! vm.hasActiveLine()\"><div class=\"col-md-12\"><span class=\"bg-color-red badge\" translate=\"wamasysApp.contrat.service.pasDeFactureEnCours\"></span></div></div><hr><h2 class=\"row-seperator-header\" translate=\"wamasysApp.contrat.paiement.billingDetail\">Billing detail</h2><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th translate=\"wamasysApp.contrat.service.libelle\">Type</th><th translate=\"wamasysApp.contrat.service.invoiceLabel\">Libelle</th><th translate=\"wamasysApp.contrat.service.dateDerniereFacturation\">dateDerniereFacturation</th><th translate=\"wamasysApp.contrat.service.montantAPayer\">montantAPayer</th><!-- 								<th translate=\"wamasysApp.contrat.service.payment\">Payment</th> --><!-- 								<th translate=\"wamasysApp.contrat.service.remainingBalance\">RemainingBalance</th> --><!-- 								<th></th> --></tr></thead><tbody ng-repeat=\"ligneContrat in vm.contrat.ligneContrats track by ligneContrat.id\" ng-if=\"ligneContrat.closed == false\"><tr><td ng-if=\"ligneContrat.serviceVendu.id\"><a ui-sref=\"service-autre-detail({id:ligneContrat.serviceVendu.id})\">{{ligneContrat.serviceVendu.libelle}}</a><br>[ {{ligneContrat.serviceVendu.typeService.libelle}}]</td><td>{{ligneContrat.libelle}}</td><td>{{ligneContrat.derniereLignePaiement.datePaiement | date:\'mediumDate\'}}</td><!-- 								<td> --><!-- 								{{ligneContrat.derniereLignePaiement.montantAPayerTtc - ligneContrat.derniereLignePaiement.moneyboxAvantPaiement --><!-- 								| currency :\'\':3}} --><!-- 								</td> --><!-- 						<td>{{vm.calculPayment(ligneContrat.listPaymentReceived) | currency :\'\':3}}	</td> --><td>{{vm.calculRemainingBalance(ligneContrat) | currency :\'\':3}} <span ng-if=\"! ligneContrat.closed && ! ligneContrat.derniereLignePaiement\" data-popover-placement=\"top\" data-popover-trigger=\"mouseenter\" data-uib-popover=\"{{\'wamasysApp.contrat.service.pasDeFactureEnCours\' | translate}}\"><i class=\"badge bg-color-orange fa fa-warning\"></i></span></td><!-- 								<td  > --><!-- \r\n									<div class=\"pull-right\">\r\n													<button \r\n													 ng-show=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"  \r\n													class=\"btn btn-info\"	\r\n													ui-sref=\"contrat-detail.paiements.paiementagence({idLigneContrat:ligneContrat.id})\"\r\n													 translate=\"wamasysApp.contrat.paiement.paiementenAgence\">\r\n														 Paiement en agence\r\n													 </button>\r\n										</div>\r\n										 --><!-- 	                          </td> --></tr><tr class=\"success\" ng-repeat=\"payment in ligneContrat.derniereLignePaiement.listPaymentReceived track by payment.id\"><td></td><td colspan=\"3\">{{\"wamasysApp.contrat.paiement.paymentInOrigin\" | translate }} {{\'wamasysApp.contrat.paiement.origin.\'+payment.codeOrigin | translate }} {{\'wamasysApp.contrat.paiement.paiementLe\' | translate}} {{payment.paymentDate | date:\'mediumDate\'}}</td><td>{{payment.paidInclTax}}</td><td></td><td><!-- 								<a ng-show=\"! impactPenalitRemiseRegul.lignePaiementServiceId\"  --><!-- 										ui-sref=\"contrat-detail.paiements.deletePaiement({idPaymentReceived:payment.id})\" type=\"submit\" class=\"btn btn-danger\"> --><!-- 									<span class=\"glyphicon glyphicon-remove-circle\"></span>	 --><!-- 									<span 	 translate=\"wamasysApp.contrat.paiement.supprimerPenaliteRemiseRegul\">Supprimer</span> --><!-- 									</a> --></td></tr></tbody></table><!-- 				</div> --><!-- 				<div class=\"tab-pane\" id=\"tab-r2\"  ng-class=\"{\'active\':  vm.activeTab==2 }\"> --><h2 class=\"row-seperator-header\" translate=\"wamasysApp.contrat.paiement.collectionListeEncours\">Collection list en cours</h2><div class=\"alert alert-warning\" ng-show=\"! vm.collectionListeEnCours.length\" translate=\"wamasysApp.contrat.paiement.aucuneListeTrouve\">Aucune liste trouvée</div><div class=\"no-padding table-responsive\" ng-show=\"vm.collectionListeEnCours.length\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead></thead><thead><tr><th translate=\"wamasysApp.collectionListe.service\">Service</th><th translate=\"wamasysApp.contrat.service.libelle\">type</th><th translate=\"wamasysApp.collectionListe.datePaiement\">Date paiement</th><!--  <th translate=\"wamasysApp.collectionListe.detail.title\">Collection list</th>--><!-- 										<th translate=\"wamasysApp.collectionListe.valeurReleveCompteur\">valeur releve compteur</th> --><!-- 										<th translate=\"wamasysApp.collectionListe.moneyBoxAvantPaiement\">Money box avant paiement</th> --><th translate=\"wamasysApp.collectionListe.montantAPayer\">montantAPayer</th><!-- 										<th translate=\"wamasysApp.collectionListe.payeEnAgence\">montantPayeAgence</th> --><!-- 										<th translate=\"wamasysApp.collectionListe.montantCollecte\">montantPayeCollecteur</th> --><!-- 										<th data-hide=\"\"></th> --></tr></thead><tbody><tr ng-repeat=\"collectionListe in vm.collectionListeEnCours\"><td>{{collectionListe.ligneContrat.libelle}}</td><td>{{collectionListe.ligneContrat.serviceVendu.typeService.libelle}}</td><td>{{collectionListe.datePaiement | date:\'mediumDate\'}}</td><!--  <td>TODO ajouter lien</td>--><!-- 										<td>{{collectionListe.valeurCompteurReleve}}</td> --><!-- 										<td>{{}}</td> --><td>{{(collectionListe.montantAPayerTtc - collectionListe.moneyboxAvantPaiement )| currency:\"\":2}}</td><!-- 										<td>{{collectionListe.montantPayeAgence}}</td> --><!-- 										<td>{{collectionListe.montantPayeCollecteur}}</td> --><!-- 										<td> --><!-- 										<button  --><!-- 											translate=\"wamasysApp.contrat.paiement.paiementenAgence\" --><!-- 											ui-sref=\"contrat-detail.paiements.paiementagence({idLignePaiementService:collectionListe.idLignePaiementService})\"  --><!-- 										type=\"submit\" class=\"btn btn-info\"> --><!-- 										Paiement en agence</button> --><!-- 										</td> --></tr></tbody></table></div><!-- 				</div> --><!-- 				<div class=\"tab-pane\" id=\"tab-r3\"  ng-class=\"{\'active\':  vm.activeTab==3 }\"> --><!-- 				</div> --><!-- 				<div class=\"tab-pane\" id=\"tab-r4\"  ng-class=\"{\'active\':  vm.activeTab==4 }\"> --><!-- 				</div> --><!-- 		</div> --><!-- 	</div> --> <!-- </div> -->");
$templateCache.put("app/business/contrat/print-contrat-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.print()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"printContratLabel\" translate=\"wamasysApp.contrat.imprimer.titre\">Print Contract</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!-- 		<div class=\"form-group\"> --><!-- 			<div class=\"input-group\"> --><!-- 				<input placeholder=\"{{ \'wamasysApp.contrat.imprimer.dateFrom\' | translate }}\" --><!-- 					id=\"field_dateFrom\" type=\"text\" class=\"form-control\" --><!-- 					name=\"dateFrom\" uib-datepicker-popup=\"{{dateformat}}\" --><!-- 					ng-model=\"vm.dateFrom\" is-open=\"vm.datePickerOpenStatus.dateFrom\" --><!-- 					required /> <span class=\"input-group-btn\"> --><!-- 					<button type=\"button\" class=\"btn btn-default\" --><!-- 						ng-click=\"vm.openCalendar(\'dateFrom\')\"> --><!-- 						<i class=\"glyphicon glyphicon-calendar\"></i> --><!-- 					</button> --><!-- 				</span> --><!-- 			</div> --><!-- 			<div ng-show=\"editForm.dateFrom.$invalid\"> --><!-- 				<p class=\"help-block\" ng-show=\"editForm.dateFrom.$error.required\" --><!-- 					translate=\"entity.validation.required\">This field is required. --><!-- 				</p> --><!-- 			</div> --><!-- 		</div> --><!-- 		<div class=\"form-group\"> --><!-- 			<div class=\"input-group\"> --><!-- 				<input placeholder=\"{{ \'wamasysApp.contrat.imprimer.dateTo\' | translate }}\" --><!-- 					id=\"field_dateTo\" type=\"text\" class=\"form-control\" --><!-- 					name=\"dateTo\" uib-datepicker-popup=\"{{dateformat}}\" --><!-- 					ng-model=\"vm.dateTo\" is-open=\"vm.datePickerOpenStatus.dateTo\" --><!-- 					required /> <span class=\"input-group-btn\"> --><!-- 					<button type=\"button\" class=\"btn btn-default\" --><!-- 						ng-click=\"vm.openCalendar(\'dateTo\')\"> --><!-- 						<i class=\"glyphicon glyphicon-calendar\"></i> --><!-- 					</button> --><!-- 				</span> --><!-- 			</div> --><!-- 			<div ng-show=\"editForm.dateFrom.$invalid\"> --><!-- 				<p class=\"help-block\" ng-show=\"editForm.dateFrom.$error.required\" --><!-- 					translate=\"entity.validation.required\">This field is required. --><!-- 				</p> --><!-- 			</div> --><!-- 		</div> --></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isPrinting\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-print\"></span>&nbsp;<span translate=\"entity.action.print\">Print</span></button></div></form>");
$templateCache.put("app/business/contrat/receipts-contrat.html","<div class=\"panel panel-default\"><div class=\"panel-heading\"><strong translate=\"wamasysApp.contrat.documents.receipts\"></strong></div><div class=\"panel-body\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th translate=\"wamasysApp.contrat.documents.receiptNumber\">Receipt number</th><th translate=\"wamasysApp.contrat.documents.paymentDate\">Payment date</th><th translate=\"wamasysApp.contrat.documents.machineIdNumber\">Machine</th><th translate=\"wamasysApp.contrat.documents.checkId\">Check</th><th translate=\"wamasysApp.contrat.documents.totalAmount\">Total amount</th><th translate=\"wamasysApp.contrat.documents.createdBy\">Created by</th><th translate=\"wamasysApp.contrat.documents.wasPrinted\">Already printed</th><th></th></tr></thead><tbody><tr ng-repeat=\"receipt in vm.factures\"><td>{{receipt.receiptNumber}}</td><td>{{receipt.paymentDate | date:\'medium\'}}</td><td>{{receipt.machineIdNumber}}</td><td>{{receipt.checkId}}</td><td>{{receipt.amountPaid}}</td><td>{{receipt.createdByVal}}</td><td>{{receipt.originalPrinted}}</td><td><a class=\"btn-sm btn-primary\" ng-if=\"receipt.id\" ng-click=\"downloadReceipt(receipt.id)\" translate=\"wamasysApp.contrat.documents.download\"></a></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div></div>");
$templateCache.put("app/business/contrat/service-contrat-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.contrat.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"wamasysApp.contrat.service.titreConfirmationSuppressionService\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.contrat.service.texteConfirmationSuppressionService\" translate-values=\"{id: \'{{vm.contrat.id}}\'}\">Are you sure you want to delete this Ligne Contrat?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"wamasysApp.contrat.service.titreCloseBouton\">Close</span></button></div></form>");
$templateCache.put("app/business/contrat/services-contrat.html","<br><div class=\"row\"><div class=\"col-md-2\" id=\"tabsParent\"><ul class=\"nav nav-tabs\" id=\"demo-pill-nav\"><li ng-class=\"{\'active\':  vm.activeTab==1 }\"><a ng-click=\"vm.setActiveTab(1)\" data-toggle=\"tab\" aria-expanded=\"false\"><span class=\"badge bg-color-blueDark txt-color-white\">{{vm.countService}}</span> {{\'wamasysApp.ligneContrat.synthese\' | translate}}</a></li><li ng-class=\"{\'active\':  vm.activeTab==2 }\"><a ng-click=\"vm.setActiveTab(2)\" data-toggle=\"tab\" aria-expanded=\"false\"><span class=\"badge bg-color-blue txt-color-white\">{{vm.countVenteUnitaire}}</span> {{\'wamasysApp.ligneContrat.venteUnitaire\' | translate}}</a></li><li ng-class=\"{\'active\':  vm.activeTab==5 }\"><a ng-click=\"vm.setActiveTab(5)\" data-toggle=\"tab\" aria-expanded=\"false\"><span class=\"badge bg-color-blue txt-color-white\">{{vm.countServiceEau}}</span> {{\'wamasysApp.ligneContrat.venteEau\' | translate}}</a></li><li ng-class=\"{\'active\':  vm.activeTab==3 }\"><a ng-click=\"vm.setActiveTab(3)\" data-toggle=\"tab\" aria-expanded=\"false\"><span class=\"badge bg-color-blue txt-color-white\">{{vm.countAboJournalier}}</span> {{\'wamasysApp.ligneContrat.aboJournalier\' | translate}}</a></li><li ng-class=\"{\'active\':  vm.activeTab==4 }\"><a ng-click=\"vm.setActiveTab(4)\" data-toggle=\"tab\" aria-expanded=\"false\"><span class=\"badge bg-color-blue txt-color-white\">{{vm.countCredit}}</span> {{\'wamasysApp.ligneContrat.credit\' | translate}}</a></li><li class=\"dropdown\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\" aria-expanded=\"false\">Adjustment <b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li ng-class=\"{\'active\':  vm.activeTab==6 }\"><a ng-click=\"vm.setActiveTab(6)\" data-toggle=\"tab\">{{\'wamasysApp.ligneContrat.discount\' | translate}}</a></li><li ng-class=\"{\'active\':  vm.activeTab==7 }\"><a ng-click=\"vm.setActiveTab(7)\" data-toggle=\"tab\">{{\'wamasysApp.ligneContrat.creditNote\' | translate}}</a></li><li ng-class=\"{\'active\':  vm.activeTab==8  }\"><a ng-click=\"vm.setActiveTab(8 )\" data-toggle=\"tab\">{{\'wamasysApp.ligneContrat.debtWaiver\' | translate}}</a></li><li ng-class=\"{\'active\':  vm.activeTab==11  }\"><a ng-click=\"vm.setActiveTab(11 )\" data-toggle=\"tab\">{{\'wamasysApp.contrat.paiement.TypePenalitRemiseRegul.WINDFALL_GAIN\' | translate}}</a></li><li ng-class=\"{\'active\':  vm.activeTab==9  }\"><a ng-click=\"vm.setActiveTab(9 )\" data-toggle=\"tab\">{{\'wamasysApp.ligneContrat.refund\' | translate}}</a></li><li ng-class=\"{\'active\':  vm.activeTab==10  }\"><a ng-click=\"vm.setActiveTab(10 )\" data-toggle=\"tab\">{{\'wamasysApp.contrat.paiement.TypePenalitRemiseRegul.REFUND_BALANCE_TRANSFER\' | translate}}</a></li><li ng-class=\"{\'active\':  vm.activeTab==12  }\"><a ng-click=\"vm.setActiveTab(12 )\" data-toggle=\"tab\">{{\'wamasysApp.contrat.paiement.TypePenalitRemiseRegul.PAYMENT_CORRECTION\' | translate}}</a></li></ul></li></ul></div><div class=\"col-md-10\"><div class=\"tab-content\"><div class=\"row\" ng-class=\"{\'hidden\':  vm.activeTab!=1 }\" style=\"margin-bottom: 5px\"><div class=\"col-md-11\"><div class=\"pull-left well well-sm bg-color-green txt-color-white no-border\"><div class=\"fa-lg\">&nbsp; <span class=\"pull-right\"><span translate=\"wamasysApp.contrat.service.montantAPayer\">Montant à payer</span> : <strong>{{vm.calculTotalToBePaid() | currency :\'\':2}}</strong></span></div></div><div class=\"pull-right\" ng-if=\"vm.canEditContract\"><a class=\"btn btn-info\" ui-sref=\"contrat-detail.services.newservice({id:vm.contrat.id})\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.contrat.service.ajouter\">Ajouter un service</span> </a><a class=\"btn btn-info\" ui-sref=\"contrat-detail.services.billing({id:vm.contrat.id})\"><span translate=\"wamasysApp.contrat.service.etablirFacturation\">Etablir facturation</span></a><div class=\"btn-group\"><button class=\"btn btn-info dropdown-toggle\" data-toggle=\"dropdown\" type=\"button\"><span translate=\"wamasysApp.contrat.service.actions\">Actions</span> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\"><li><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegulContrat({id:vm.contrat.id,type:\'DISCOUNT\'})\" translate=\"wamasysApp.contrat.service.addDiscount\">Add discount</a></li><li><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegulContrat({id:vm.contrat.id,type:\'CREDIT_NOTE\'})\" translate=\"wamasysApp.contrat.service.addCreditNote\">Add credit Note</a></li><li><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegulContrat({id:vm.contrat.id,type:\'REFUND\'})\" translate=\"wamasysApp.contrat.service.addRefund\">Refund client</a></li></ul></div></div></div></div><div class=\"tab-pane\" id=\"tab-r1\" ng-class=\"{\'active\':  vm.activeTab==1 }\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover\" style=\"width: 95%; !important\"><thead><tr><!-- 								<th translate=\"wamasysApp.contrat.service.globalService\">globalService</th> --><th translate=\"wamasysApp.contrat.service.libelle\">Type</th><th translate=\"wamasysApp.contrat.service.invoiceLabel\">Libelle</th><!-- 								<th translate=\"wamasysApp.contrat.service.dateActivation\">Date activation</th> --><th translate=\"wamasysApp.contrat.service.dateDerniereFacturation\">dateDerniereFacturation</th><!-- 								<th translate=\"wamasysApp.contrat.service.quantite\">Quantité</th> --><!-- 									<th translate=\"wamasysApp.contrat.service.montantTotalAPayer\">montantTotalAPayer</th> --><!-- 									<th translate=\"wamasysApp.contrat.service.accompte\">Accompte</th> --><!-- 									<th translate=\"wamasysApp.contrat.service.paiementInitial\">Paiement initial</th> --><!-- 									<th translate=\"wamasysApp.contrat.service.datePaiementInitial\">Date paiement initial</th> --><!-- 								<th translate=\"wamasysApp.contrat.service.montantTotalDejaPaye\">montantTotalDejaPaye</th> --><!-- 								<th translate=\"wamasysApp.contrat.service.moneyBoxCourrante\">Money box courrante</th> --><th translate=\"wamasysApp.contrat.service.montantAPayer\">montantAPayer</th><!-- 								<th translate=\"wamasysApp.contrat.service.moneyBoxCourrante\">Money box courrante</th> --><th translate=\"wamasysApp.contrat.service.state\">state</th><th></th></tr></thead><tbody ng-repeat=\"ligneContrat in vm.contrat.ligneContrats track by ligneContrat.id\" ng-if=\"! ligneContrat.closed \"><tr><!-- 								<td ng-if=\"ligneContrat.serviceVendu.typeService.id\"> --><!-- 									<a ui-sref=\"type-service-detail({id:ligneContrat.serviceVendu.typeService.id})\"> --><!-- 										{{ligneContrat.serviceVendu.typeService.libelle}} --><!-- 									</a> --><!-- 								</td> --><td><a ui-sref=\"service-autre-detail({id:ligneContrat.serviceVendu.id})\">{{ligneContrat.serviceVendu.libelle}}</a><br>[ {{ligneContrat.serviceVendu.typeService.libelle}}]</td><td>{{ligneContrat.libelle}}</td><td>{{ligneContrat.derniereLignePaiement.datePaiement | date:\'mediumDate\'}}</td><td>{{- ligneContrat.derniereLignePaiement.moneyboxApresPaiement | currency :\'\':3}}</td><td ng-if=\"vm.canEditContract\"><span ng-if=\"ligneContrat.standBy === true \" class=\"badge bg-color-orange\" data-popover-placement=\"top\" data-popover-trigger=\"mouseenter\" data-uib-popover=\"{{\'wamasysApp.contrat.service.ligneContratStandBy\' | translate}}  {{ligneContrat.standByDate | date:\'mediumDate\'}}\"><i class=\"fa-fw fa fa-pause\"></i> </span><span ng-if=\"ligneContrat.closed\" class=\"badge bg-color-darken\" title=\"{{\'wamasysApp.ligneContrat.desactivated\' | translate}}\"><i class=\"fa-fw fa fa-times\"></i></span> <span ng-if=\"!ligneContrat.standBy === true  && ! ligneContrat.closed && ! ligneContrat.derniereLignePaiement\" data-popover-placement=\"top\" data-popover-trigger=\"mouseenter\" data-uib-popover=\"{{\'wamasysApp.contrat.service.pasDeFactureEnCours\' | translate}}\" class=\"badge bg-color-orange\"><i class=\"fa fa-warning\"></i> </span><span ng-if=\"!ligneContrat.standBy === true  && ! ligneContrat.closed && ligneContrat.derniereLignePaiement\" class=\"badge bg-color-green\" title=\"{{\'wamasysApp.ligneContrat.activated\' | translate}}\"><i class=\"fa-fw fa fa-check\"></i> </span><small ng-if=\"vm.getDateFromString(ligneContrat.dateActivation)  >  vm.today\" data-popover-placement=\"top\" data-popover-trigger=\"mouseenter\" data-uib-popover=\"{{\'wamasysApp.contrat.service.dateActivationDansFuturDetail\' | translate}}\" class=\"badge bg-color-orange\" translate=\"wamasysApp.contrat.service.dateActivationDansFutur\">Date d\'activation dans le futur</small></td><td ng-if=\"vm.canEditContract\"><div class=\"\"><div class=\"btn-group\"><button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\"><i class=\"fa fa-wrench\"></i><span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\"><li><a ui-sref=\"contrat-detail.historiquepaiements({id:vm.contrat.id,ligneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.viewPaymentsHisto\">View payement histo</a></li><li class=\"divider\"></li><!-- 												<li  ng-if=\"ligneContrat.closed == false && ! ligneContrat.derniereLignePaiement.id\"  > --><li ng-if=\"ligneContrat.closed == false && ligneContrat.serviceVendu.typePaiement != \'A_PAYER_AVEC_ECHELONNEMENT\'\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'DISCOUNT\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addDiscount\">Add discount</a></li><!-- 												<li  ng-if=\"ligneContrat.closed == true ||  ligneContrat.derniereLignePaiement.id\"  class=\"disabled\"> --><li ng-if=\"ligneContrat.closed == true  && ligneContrat.serviceVendu.typePaiement != \'A_PAYER_AVEC_ECHELONNEMENT\'\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addDiscount\">Add discount</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'CREDIT_NOTE\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addCreditNote\">Add credit Note</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addCreditNote\">Add credit Note</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'DEBT_WAIVER\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addDebtWaiver\">Add DEBT_WAIVER</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addDebtWaiver\">Add DEBT_WAIVER</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'WINDFALL_GAIN\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addWindfallGain\">Add WINDFALL_GAIN</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addWindfallGain\">Add WINDFALL_GAIN</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.addBalanceTransfer({id:vm.contrat.id,debitedLigneContratId:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addBalanceTransfer\">addBalanceTransfer</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addBalanceTransfer\">addBalanceTransfer</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'REFUND\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addRefund\">Refund client</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addRefund\">Refund client</a></li><li class=\"divider\"></li><li ng-if=\"ligneContrat.closed == false \"><a ui-sref=\"contrat-detail.services.editService({id:vm.contrat.id,idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.editService\">Edit</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id &&  ligneContrat.serviceVendu.typePaiement == \'A_PAYER_AVEC_ECHELONNEMENT\'\"><a ui-sref=\"contrat-detail.services.billOutstandingCredit({idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.billOutstandingCredit\">billOutstandingCredit</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id &&  ligneContrat.serviceVendu.typePaiement == \'A_PAYER_AVEC_ECHELONNEMENT\'\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.billOutstandingCredit\">billOutstandingCredit</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.standby({idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.standByService\">Stand by service</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.standByService\">Stand by service</a></li><li ng-if=\"ligneContrat.closed == false\"><a ui-sref=\"contrat-detail.services.delete({idLignecontrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.closeAction\">Cloturer	le contrat</a></li><li ng-if=\"ligneContrat.closed == true \" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.closeAction\">Cloturer	le contrat</a></li></ul></div></div></td></tr><tr class=\"warning\" ng-repeat=\"impactPenalitRemiseRegul in ligneContrat.listImpactPenalitRemiseRegul\" ng-if=\"! impactPenalitRemiseRegul.lignePaiementServiceId\"><td colspan=\"3\">[ {{\"wamasysApp.contrat.paiement.TypePenalitRemiseRegul.\"+impactPenalitRemiseRegul.type | translate}} ] : {{impactPenalitRemiseRegul.typeRemisecommerciale.libelle}} {{impactPenalitRemiseRegul.typeAvoir.libelle}} : {{impactPenalitRemiseRegul.label}} : {{impactPenalitRemiseRegul.commentaire}} ({{impactPenalitRemiseRegul.montantHt}} {{\"wamasysApp.contrat.paiement.HT\"| translate}})</td><!-- 										<td ng-show=\"impactPenalitRemiseRegul.type == \'CREDIT_NOTE\' || impactPenalitRemiseRegul.type == \'DEBT_WAIVER\'\">{{impactPenalitRemiseRegul.typeAvoir.libelle}}</td> --><!-- 										<td ng-show=\"impactPenalitRemiseRegul.type == \'DISCOUNT\'\">>{{impactPenalitRemiseRegul.typeRemisecommerciale.libelle}}</td> --><!-- 										<td ng-show=\"impactPenalitRemiseRegul.type == \'REFUND\'\"></td> --><td>{{impactPenalitRemiseRegul.montantTtc}}</td><td><span data-popover-placement=\"top\" data-popover-trigger=\"mouseenter\" data-uib-popover=\"{{\'wamasysApp.contrat.paiement.NotImpacted\' | translate}}\" class=\"badge bg-color-orange\"><i class=\"fa fa-pause\"></i></span></td><td><div class=\"\"><a ng-show=\"! impactPenalitRemiseRegul.lignePaiementServiceId\" ui-sref=\"contrat-detail.services.deletePenaliteRemiseRegul({idPenaliteRemiseRegul:impactPenalitRemiseRegul.id})\" type=\"submit\" class=\"btn btn-danger\"><!-- 									<span class=\" glyphicon glyphicon-remove-circle\"></span> \r\n													<span 	 translate=\"wamasysApp.contrat.paiement.supprimerPenaliteRemiseRegul\">Supprimer</span>--> <span class=\"fa fa-trash\"></span></a></div></td></tr></tbody></table></div><!--  affichage tableauy liste des discount/avoir, etc --><!-- 							<table  --><!-- 								class=\"table table-striped table-bordered table-hover\" --><!-- 								style=\"width: 95%; !important\"> --><!-- 								<thead> --><!-- 									<tr> --><!-- 										<th translate=\"wamasysApp.contrat.paiement.type\">type</th> --><!-- 										<th translate=\"wamasysApp.contrat.paiement.ligneContrat\">ligneContrat</th> --><!-- 										<th translate=\"wamasysApp.contrat.paiement.label\">ligneContrat</th> --><!-- 										<th translate=\"wamasysApp.contrat.paiement.raison\">raison</th> --><!-- 										<th translate=\"wamasysApp.contrat.paiement.commentaire\">commentaire</th> --><!-- 										<th translate=\"wamasysApp.contrat.paiement.impactedDate\">Impacté dans collection list</th> --><!-- 										<th translate=\"wamasysApp.contrat.paiement.montantTtc\">Montant ttc</th> --><!-- 										<th translate=\"wamasysApp.contrat.paiement.montantHt\">Montant ht</th> --><!-- 										<th data-hide=\"\"></th> --><!-- 									</tr> --><!-- 								</thead> --><!-- 								<tbody> --><!-- 									<tr ng-repeat=\"impactPenalitRemiseRegul in vm.impactPenalitRemiseRegul\" ng-if=\"! impactPenalitRemiseRegul.lignePaiementServiceId\"> --><!-- 										<td  translate=\"wamasysApp.contrat.paiement.TypePenalitRemiseRegul.{{impactPenalitRemiseRegul.type}}\">{{impactPenalitRemiseRegul.type}}</td> --><!-- 										<td>{{impactPenalitRemiseRegul.libelleLignecontrat}}</td> --><!-- 										<td >{{impactPenalitRemiseRegul.label}}</td> --><!-- 										<td ng-show=\"impactPenalitRemiseRegul.type == \'CREDIT_NOTE\' || impactPenalitRemiseRegul.type == \'DEBT_WAIVER\'\">{{impactPenalitRemiseRegul.typeAvoir.libelle}}</td> --><!-- 										<td ng-show=\"impactPenalitRemiseRegul.type == \'DISCOUNT\'\">>{{impactPenalitRemiseRegul.typeRemisecommerciale.libelle}}</td> --><!-- 										<td ng-show=\"impactPenalitRemiseRegul.type == \'REFUND\'\"></td> --><!-- 										<td>{{impactPenalitRemiseRegul.commentaire}}</td> --><!-- 										<td><div  ng-show=\" impactPenalitRemiseRegul.lignePaiementServiceId\" > --><!-- 										{{impactPenalitRemiseRegul.collectionListDate | date:\'mediumDate\'}}</div> --><!-- 										<div ng-show=\"! impactPenalitRemiseRegul.lignePaiementServiceId\"  translate=\"wamasysApp.contrat.paiement.NotImpacted\">NON impacted</div> --><!-- 										</td> --><!-- 										<td>{{impactPenalitRemiseRegul.montantTtc}}</td> --><!-- 										<td>{{impactPenalitRemiseRegul.montantHt}}</td> --><!-- 										<td> --><!-- 										<button  --><!-- 										 translate=\"wamasysApp.contrat.paiement.supprimerPenaliteRemiseRegul\" --><!-- 										ui-sref=\"contrat-detail.paiements.deletePenaliteRemiseRegul({idPenaliteRemiseRegul:impactPenalitRemiseRegul.id})\" type=\"submit\" class=\"btn btn-info\"> --><!-- 										Supprimer</button> --><!-- 										</td> --><!-- 									</tr> --><!-- 								</tbody> --><!-- 							</table> --></div><div class=\"tab-pane table-responsive\" id=\"tab-r2\" ng-class=\"{\'active\':  vm.activeTab==2 }\"><table class=\"table table-striped table-bordered table-hover\" style=\"width: auto;!important\"><thead><tr><th translate=\"wamasysApp.contrat.service.libelle\">Type</th><th translate=\"wamasysApp.contrat.service.invoiceLabel\">Libelle</th><th translate=\"wamasysApp.contrat.service.dateActivation\">Date activation</th><th translate=\"wamasysApp.contrat.service.quantite\">Quantité</th><!-- 									<th translate=\"wamasysApp.contrat.service.montantTotalAPayer\">montantTotalAPayer</th> --><th translate=\"wamasysApp.contrat.service.prixUnitaire\">prixUnitaire</th><!-- 										<th translate=\"wamasysApp.contrat.service.paiementInitial\">Paiement initial</th> --><!-- 										<th translate=\"wamasysApp.contrat.service.datePaiementInitial\">Date paiement initial</th> --><!-- 										<th translate=\"wamasysApp.contrat.service.montantTotalDejaPaye\">montantTotalDejaPaye</th> --><!-- 										<th translate=\"wamasysApp.contrat.service.moneyBoxCourrante\">Money box courrante</th> --><th translate=\"wamasysApp.contrat.service.montantAPayer\">montantAPayer</th><th translate=\"wamasysApp.contrat.service.state\">state</th><th></th></tr></thead><tbody><tr ng-repeat=\"ligneContrat in vm.contrat.ligneContrats track by ligneContrat.id\" ng-if=\"ligneContrat.serviceVendu.typePaiement === \'A_PAYER_EN_UNE_FOIS\' \"><td><a ui-sref=\"service-autre-detail({id:ligneContrat.serviceVendu.id})\">{{ligneContrat.serviceVendu.libelle}}</a> [ {{ligneContrat.serviceVendu.typeService.libelle}} ]</td><td>{{ligneContrat.libelle}}</td><td>{{ligneContrat.dateActivation | date:\'mediumDate\'}}</td><td>{{ligneContrat.quantite}}</td><td>{{ligneContrat.unitPrice}}</td><td ng-if=\"ligneContrat.derniereLignePaiement.moneyboxApresPaiement !== undefined  && ligneContrat.derniereLignePaiement.moneyboxApresPaiement !== null \">{{ - ligneContrat.derniereLignePaiement.moneyboxApresPaiement | currency :\'\':3}}</td><td ng-if=\"ligneContrat.derniereLignePaiement.moneyboxApresPaiement === undefined  || ligneContrat.derniereLignePaiement.moneyboxApresPaiement === null \">{{ 0 | currency :\'\':3}}</td><td><span ng-if=\"ligneContrat.standBy === true \" class=\"badge bg-color-orange\" data-popover-placement=\"top\" data-popover-trigger=\"mouseenter\" data-uib-popover=\"{{\'wamasysApp.contrat.service.ligneContratStandBy\' | translate}}  {{ligneContrat.standByDate | date:\'mediumDate\'}}\"><i class=\"fa-fw fa fa-pause\"></i> </span><span ng-if=\"ligneContrat.closed\" class=\"badge bg-color-darken\" title=\"{{\'wamasysApp.ligneContrat.desactivated\' | translate}}\"><i class=\"fa-fw fa fa-times\"></i></span> <span ng-if=\"!ligneContrat.standBy === true  && ! ligneContrat.closed && ! ligneContrat.derniereLignePaiement\" data-popover-placement=\"top\" data-popover-trigger=\"mouseenter\" data-uib-popover=\"{{\'wamasysApp.contrat.service.pasDeFactureEnCours\' | translate}}\" class=\"badge bg-color-orange\"><i class=\"fa fa-warning\"></i> </span><span ng-if=\"!ligneContrat.standBy === true  && ! ligneContrat.closed && ligneContrat.derniereLignePaiement\" class=\"badge bg-color-green\" title=\"{{\'wamasysApp.ligneContrat.activated\' | translate}}\"><i class=\"fa-fw fa fa-check\"></i></span></td><td><div class=\"pull-right\"><div class=\"btn-group\"><button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\"><i class=\"fa fa-wrench\"></i><span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\"><li><a ui-sref=\"contrat-detail.historiquepaiements({id:vm.contrat.id,ligneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.viewPaymentsHisto\">View payement histo</a></li><li class=\"divider\"></li><li ng-if=\"ligneContrat.closed == false \"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'DISCOUNT\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addDiscount\">Add discount</a></li><li ng-if=\"ligneContrat.closed == true \" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addDiscount\">Add discount</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'CREDIT_NOTE\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addCreditNote\">Add credit Note</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addCreditNote\">Add credit Note</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'DEBT_WAIVER\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addDebtWaiver\">Add DEBT_WAIVER</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addDebtWaiver\">Add DEBT_WAIVER</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'WINDFALL_GAIN\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addWindfallGain\">Add WINDFALL_GAIN</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addWindfallGain\">Add WINDFALL_GAIN</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.addBalanceTransfer({id:vm.contrat.id,debitedLigneContratId:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addBalanceTransfer\">addBalanceTransfer</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addBalanceTransfer\">addBalanceTransfer</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'REFUND\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addRefund\">Refund client</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addRefund\">Refund client</a></li><li class=\"divider\"></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.standby({idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.standByService\">Stand by service</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.standByService\">Stand by service</a></li><li ng-if=\"ligneContrat.closed == false\"><a ui-sref=\"contrat-detail.services.delete({idLignecontrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.closeAction\">Cloturer	le contrat</a></li><li ng-if=\"ligneContrat.closed == true \" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.closeAction\">Cloturer	le contrat</a></li><li ng-if=\"ligneContrat.closed == true \"><a ui-sref=\"contrat-detail.services.reopen({id:vm.contrat.id,idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.reopenAction\">Reopen</a></li></ul></div></div></td></tr></tbody></table></div><div class=\"tab-pane table-responsive\" id=\"tab-r3\" ng-class=\"{\'active\':  vm.activeTab==3 }\"><table class=\"table table-striped table-bordered table-hover\" style=\"width: auto;!important\"><thead><tr><th translate=\"wamasysApp.contrat.service.libelle\">Type</th><th translate=\"wamasysApp.contrat.service.invoiceLabel\">Libelle</th><th translate=\"wamasysApp.contrat.service.dateActivation\">Date activation</th><th translate=\"wamasysApp.contrat.service.lastBillingDate\">LastBillingDate</th><th translate=\"wamasysApp.contrat.service.amountPerInstallment\">amountPerInstallment</th><th translate=\"wamasysApp.contrat.service.montantTotalDejaPaye\">montantTotalDejaPaye</th><th translate=\"wamasysApp.contrat.service.montantAPayer\">montantAPayer</th><th translate=\"wamasysApp.contrat.service.state\">state</th><th></th></tr></thead><tbody><tr ng-repeat=\"ligneContrat in vm.contrat.ligneContrats track by ligneContrat.id\" ng-if=\"ligneContrat.serviceVendu.typePaiement === \'A_PAYER_PAR_JOUR\' \"><td><a ui-sref=\"service-autre-detail({id:ligneContrat.serviceVendu.id})\">{{ligneContrat.serviceVendu.libelle}}</a> [ {{ligneContrat.serviceVendu.typeService.libelle}} ]</td><td>{{ligneContrat.libelle}}</td><td>{{ligneContrat.dateActivation | date:\'mediumDate\'}}</td><td>{{ligneContrat.lastBillingDate | date:\'mediumDate\'}}</td><td>{{ligneContrat.amountPerInstallment}} / ( {{ligneContrat.serviceVendu.frequency}} {{ligneContrat.serviceVendu.intervalType}} )</td><td>{{ligneContrat.derniereLignePaiement.montantTotalDejaPaye}}</td><td>{{- ligneContrat.derniereLignePaiement.moneyboxApresPaiement | currency :\'\':3}}</td><td><span ng-if=\"ligneContrat.standBy === true \" class=\"badge bg-color-orange\" data-popover-placement=\"top\" data-popover-trigger=\"mouseenter\" data-uib-popover=\"{{\'wamasysApp.contrat.service.ligneContratStandBy\' | translate}}  {{ligneContrat.standByDate | date:\'mediumDate\'}}\"><i class=\"fa-fw fa fa-pause\"></i> </span><span ng-if=\"ligneContrat.closed\" class=\"badge bg-color-darken\" title=\"{{\'wamasysApp.ligneContrat.desactivated\' | translate}}\"><i class=\"fa-fw fa fa-times\"></i></span> <span ng-if=\"!ligneContrat.standBy === true  && ! ligneContrat.closed && ! ligneContrat.derniereLignePaiement\" data-popover-placement=\"top\" data-popover-trigger=\"mouseenter\" data-uib-popover=\"{{\'wamasysApp.contrat.service.pasDeFactureEnCours\' | translate}}\" class=\"badge bg-color-orange\"><i class=\"fa fa-warning\"></i> </span><span ng-if=\"!ligneContrat.standBy === true  && ! ligneContrat.closed && ligneContrat.derniereLignePaiement\" class=\"badge bg-color-green\" title=\"{{\'wamasysApp.ligneContrat.activated\' | translate}}\"><i class=\"fa-fw fa fa-check\"></i></span></td><td><div class=\"pull-right\"><div class=\"btn-group\"><button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\"><i class=\"fa fa-wrench\"></i><span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\"><li><a ui-sref=\"contrat-detail.historiquepaiements({id:vm.contrat.id,ligneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.viewPaymentsHisto\">View payement histo</a></li><li class=\"divider\"></li><li ng-if=\"ligneContrat.closed == false \"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'DISCOUNT\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addDiscount\">Add discount</a></li><li ng-if=\"ligneContrat.closed == true \" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addDiscount\">Add discount</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'CREDIT_NOTE\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addCreditNote\">Add credit Note</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addCreditNote\">Add credit Note</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'DEBT_WAIVER\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addDebtWaiver\">Add DEBT_WAIVER</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addDebtWaiver\">Add DEBT_WAIVER</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'WINDFALL_GAIN\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addWindfallGain\">Add WINDFALL_GAIN</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addWindfallGain\">Add WINDFALL_GAIN</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.addBalanceTransfer({id:vm.contrat.id,debitedLigneContratId:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addBalanceTransfer\">addBalanceTransfer</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addBalanceTransfer\">addBalanceTransfer</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'REFUND\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addRefund\">Refund client</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addRefund\">Refund client</a></li><li class=\"divider\"></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.standby({idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.standByService\">Stand by service</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.standByService\">Stand by service</a></li><li ng-if=\"ligneContrat.closed == false\"><a ui-sref=\"contrat-detail.services.delete({idLignecontrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.closeAction\">Cloturer	le contrat</a></li><li ng-if=\"ligneContrat.closed == true \" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.closeAction\">Cloturer	le contrat</a></li><li ng-if=\"ligneContrat.closed == true \"><a ui-sref=\"contrat-detail.services.reopen({id:vm.contrat.id,idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.reopenAction\">Reopen</a></li></ul></div></div></td></tr></tbody></table></div><div class=\"tab-pane table-responsive\" id=\"tab-r4\" ng-class=\"{\'active\':  vm.activeTab==4 }\"><table class=\"table table-striped table-bordered table-hover\" style=\"width: auto;!important\"><thead><tr><th translate=\"wamasysApp.contrat.service.libelle\">Type</th><th translate=\"wamasysApp.contrat.service.invoiceLabel\">Libelle</th><th translate=\"wamasysApp.contrat.service.dateActivation\">Date activation</th><th translate=\"wamasysApp.contrat.service.lastBillingDate\">LastBillingDate</th><th translate=\"wamasysApp.contrat.service.amountPerInstallment\">amountPerInstallment</th><th translate=\"wamasysApp.contrat.service.montantTotalAPayer\">montantTotalAPayer</th><th translate=\"wamasysApp.contrat.service.montantTotalDejaPaye\">montantTotalDejaPaye</th><th translate=\"wamasysApp.contrat.service.resteAPayer\">resteAPayer</th><th translate=\"wamasysApp.contrat.service.montantAPayer\">montantAPayer</th><th translate=\"wamasysApp.contrat.service.state\">state</th><th></th></tr></thead><tbody><tr ng-repeat=\"ligneContrat in vm.contrat.ligneContrats track by ligneContrat.id\" ng-if=\"ligneContrat.serviceVendu.typePaiement === \'A_PAYER_AVEC_ECHELONNEMENT\' \"><td><a ui-sref=\"service-autre-detail({id:ligneContrat.serviceVendu.id})\">{{ligneContrat.serviceVendu.libelle}}</a> [{{ligneContrat.serviceVendu.typeService.libelle}}]</td><td>{{ligneContrat.libelle}}</td><td>{{ligneContrat.dateActivation | date:\'mediumDate\'}}</td><td>{{ligneContrat.lastBillingDate | date:\'mediumDate\'}}</td><td>{{ligneContrat.amountPerInstallment}} / ( {{ligneContrat.serviceVendu.frequency}} {{ligneContrat.serviceVendu.intervalType}} )</td><td>{{ligneContrat.derniereLignePaiement.montantTotalAPayer}}</td><!-- 										<td> {{ligneContrat.serviceVendu.amountPerInstallment}} </td> --><!-- 										<td>{{ligneContrat.serviceVendu.unitPrice}}</td> --><!-- 										<td>{{ligneContrat.montantPaiementInitial}}</td> --><!-- 										<td>{{ligneContrat.datePaiementInitial}}</td> --><td>{{ligneContrat.derniereLignePaiement.montantTotalDejaPaye}}</td><td>{{ligneContrat.derniereLignePaiement.montantTotalAPayer - ligneContrat.derniereLignePaiement.montantTotalDejaPaye | currency :\'\':3}}</td><td>{{ - ligneContrat.derniereLignePaiement.moneyboxApresPaiement | currency :\'\':3}}</td><td><span ng-if=\"ligneContrat.standBy === true \" class=\"badge bg-color-orange\" data-popover-placement=\"top\" data-popover-trigger=\"mouseenter\" data-uib-popover=\"{{\'wamasysApp.contrat.service.ligneContratStandBy\' | translate}}  {{ligneContrat.standByDate | date:\'mediumDate\'}}\"><i class=\"fa-fw fa fa-pause\"></i> </span><span ng-if=\"ligneContrat.closed\" class=\"badge bg-color-darken\" title=\"{{\'wamasysApp.ligneContrat.desactivated\' | translate}}\"><i class=\"fa-fw fa fa-times\"></i></span> <span ng-if=\"!ligneContrat.standBy === true  && ! ligneContrat.closed && ! ligneContrat.derniereLignePaiement\" data-popover-placement=\"top\" data-popover-trigger=\"mouseenter\" data-uib-popover=\"{{\'wamasysApp.contrat.service.pasDeFactureEnCours\' | translate}}\" class=\"badge bg-color-orange\"><i class=\"fa fa-warning\"></i> </span><span ng-if=\"!ligneContrat.standBy === true  && ! ligneContrat.closed && ligneContrat.derniereLignePaiement\" class=\"badge bg-color-green\" title=\"{{\'wamasysApp.ligneContrat.activated\' | translate}}\"><i class=\"fa-fw fa fa-check\"></i></span></td><td><div class=\"pull-right\"><div class=\"btn-group\"><button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\"><i class=\"fa fa-wrench\"></i><span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\"><li><a ui-sref=\"contrat-detail.historiquepaiements({id:vm.contrat.id,ligneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.viewPaymentsHisto\">View payement histo</a></li><li class=\"divider\"></li><!-- 												<li  ng-if=\"ligneContrat.closed == false \"  > --><!-- 													<a  --><!-- 													ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'DISCOUNT\',idLigneContrat:ligneContrat.id})\" --><!-- 													translate=\"wamasysApp.contrat.service.addDiscount\" >Add discount</a> --><!-- 												</li> --><!-- 												<li  ng-if=\"ligneContrat.closed == true \"  class=\"disabled\"> --><!-- 													<a 	translate=\"wamasysApp.contrat.service.addDiscount\"  >Add discount</a> --><!-- 												</li> --><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'CREDIT_NOTE\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addCreditNote\">Add credit Note</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addCreditNote\">Add credit Note</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'DEBT_WAIVER\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addDebtWaiver\">Add DEBT_WAIVER</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addDebtWaiver\">Add DEBT_WAIVER</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'WINDFALL_GAIN\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addWindfallGain\">Add WINDFALL_GAIN</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addWindfallGain\">Add WINDFALL_GAIN</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.addBalanceTransfer({id:vm.contrat.id,debitedLigneContratId:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addBalanceTransfer\">addBalanceTransfer</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addBalanceTransfer\">addBalanceTransfer</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'REFUND\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addRefund\">Refund client</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addRefund\">Refund client</a></li><li class=\"divider\"></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.standby({idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.standByService\">Stand by service</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.standByService\">Stand by service</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.billOutstandingCredit({idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.billOutstandingCredit\">billOutstandingCredit</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.billOutstandingCredit\">billOutstandingCredit</a></li><li ng-if=\"ligneContrat.closed == false\"><a ui-sref=\"contrat-detail.services.delete({idLignecontrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.closeAction\">Cloturer	le contrat</a></li><li ng-if=\"ligneContrat.closed == true \" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.closeAction\">Cloturer	le contrat</a></li><li ng-if=\"ligneContrat.closed == true \"><a ui-sref=\"contrat-detail.services.reopen({id:vm.contrat.id,idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.reopenAction\">Reopen</a></li></ul></div></div></td></tr></tbody></table></div><div class=\"tab-pane table-responsive\" id=\"tab-r5\" ng-class=\"{\'active\':  vm.activeTab==5 }\"><table class=\"table table-striped table-bordered table-hover\" style=\"width: auto;!important\"><thead><tr><th translate=\"wamasysApp.contrat.service.libelle\">Type</th><th translate=\"wamasysApp.contrat.service.invoiceLabel\">Libelle</th><th translate=\"wamasysApp.contrat.service.dateActivation\">Date activation</th><th translate=\"wamasysApp.contrat.service.prixUnitaire\">unitPrice</th><th translate=\"wamasysApp.contrat.service.montantAPayer\">montantAPayer</th><th translate=\"wamasysApp.contrat.service.state\">state</th><th></th></tr></thead><tbody><tr ng-repeat=\"ligneContrat in vm.contrat.ligneContrats track by ligneContrat.id\" ng-if=\"ligneContrat.serviceVendu.typePaiement === \'A_PAYER_SUR_CONSO_EAU\' \"><td><a ui-sref=\"service-autre-detail({id:ligneContrat.serviceVendu.id})\">{{ligneContrat.serviceVendu.libelle}}</a> [{{ligneContrat.serviceVendu.typeService.libelle}}]</td><td>{{ligneContrat.libelle}}</td><td>{{ligneContrat.dateActivation | date:\'mediumDate\'}}</td><td>{{ligneContrat.serviceVendu.unitPrice}}</td><td>{{- ligneContrat.derniereLignePaiement.moneyboxApresPaiement | currency :\'\':3}}</td><td><span ng-if=\"ligneContrat.standBy === true \" class=\"badge bg-color-orange\" data-popover-placement=\"top\" data-popover-trigger=\"mouseenter\" data-uib-popover=\"{{\'wamasysApp.contrat.service.ligneContratStandBy\' | translate}}  {{ligneContrat.standByDate | date:\'mediumDate\'}}\"><i class=\"fa-fw fa fa-pause\"></i> </span><span ng-if=\"ligneContrat.closed\" class=\"badge bg-color-darken\" title=\"{{\'wamasysApp.ligneContrat.desactivated\' | translate}}\"><i class=\"fa-fw fa fa-times\"></i></span> <span ng-if=\"!ligneContrat.standBy === true  && ! ligneContrat.closed && ! ligneContrat.derniereLignePaiement\" data-popover-placement=\"top\" data-popover-trigger=\"mouseenter\" data-uib-popover=\"{{\'wamasysApp.contrat.service.pasDeFactureEnCours\' | translate}}\" class=\"badge bg-color-orange\"><i class=\"fa fa-warning\"></i> </span><span ng-if=\"!ligneContrat.standBy === true  && ! ligneContrat.closed && ligneContrat.derniereLignePaiement\" class=\"badge bg-color-green\" title=\"{{\'wamasysApp.ligneContrat.activated\' | translate}}\"><i class=\"fa-fw fa fa-check\"></i></span></td><td><div class=\"pull-right\"><div class=\"btn-group\"><button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\"><i class=\"fa fa-wrench\"></i><span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\"><li><a ui-sref=\"contrat-detail.historiquepaiements({id:vm.contrat.id,ligneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.viewPaymentsHisto\">View payement histo</a></li><li class=\"divider\"></li><li ng-if=\"ligneContrat.closed == false \"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'DISCOUNT\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addDiscount\">Add discount</a></li><li ng-if=\"ligneContrat.closed == true \" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addDiscount\">Add discount</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'CREDIT_NOTE\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addCreditNote\">Add credit Note</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addCreditNote\">Add credit Note</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'DEBT_WAIVER\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addDebtWaiver\">Add DEBT_WAIVER</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addDebtWaiver\">Add DEBT_WAIVER</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'WINDFALL_GAIN\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addWindfallGain\">Add WINDFALL_GAIN</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addWindfallGain\">Add WINDFALL_GAIN</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.addBalanceTransfer({id:vm.contrat.id,debitedLigneContratId:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addBalanceTransfer\">addBalanceTransfer</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addBalanceTransfer\">addBalanceTransfer</a></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.ajoutPenaliteRemiseRegul({id:vm.contrat.id,type:\'REFUND\',idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.addRefund\">Refund client</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.addRefund\">Refund client</a></li><li class=\"divider\"></li><li ng-if=\"ligneContrat.closed == false && ligneContrat.derniereLignePaiement.id\"><a ui-sref=\"contrat-detail.services.standby({idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.standByService\">Stand by service</a></li><li ng-if=\"ligneContrat.closed == true || ! ligneContrat.derniereLignePaiement.id\" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.standByService\">Stand by service</a></li><li ng-if=\"ligneContrat.closed == false\"><a ui-sref=\"contrat-detail.services.delete({idLignecontrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.closeAction\">Cloturer	le contrat</a></li><li ng-if=\"ligneContrat.closed == true \" class=\"disabled\"><a translate=\"wamasysApp.contrat.service.closeAction\">Cloturer	le contrat</a></li><li ng-if=\"ligneContrat.closed == true \"><a ui-sref=\"contrat-detail.services.reopen({id:vm.contrat.id,idLigneContrat:ligneContrat.id})\" translate=\"wamasysApp.contrat.service.reopenAction\">Reopen</a></li></ul></div></div></td></tr></tbody></table></div><div class=\"tab-pane table-responsive\" id=\"tab-r6\" ng-class=\"{\'active\':  vm.activeTab==6}\"><table class=\"table table-striped table-bordered table-hover\" style=\"width: 95%; !important\"><thead><tr><!-- 										<th translate=\"wamasysApp.contrat.paiement.type\">type</th> --><th translate=\"wamasysApp.contrat.service.invoiceLabel\">Wording</th><th translate=\"wamasysApp.contrat.paiement.label\">label</th><th translate=\"wamasysApp.contrat.paiement.raison\">raison</th><th translate=\"wamasysApp.contrat.paiement.commentaire\">commentaire</th><th translate=\"wamasysApp.contrat.paiement.createdDate\">createdDate</th><th translate=\"wamasysApp.contrat.paiement.impactedDate\">Impacté dans collection list</th><th translate=\"wamasysApp.contrat.paiement.montantTtc\">Montant ttc</th><th translate=\"wamasysApp.contrat.paiement.montantHt\">Montant ht</th><th data-hide=\"\"></th></tr></thead><tbody><tr ng-repeat=\"impactPenalitRemiseRegul in vm.impactPenalitRemiseRegul\" ng-if=\"impactPenalitRemiseRegul.type == \'DISCOUNT\'\"><td>{{impactPenalitRemiseRegul.libelleLignecontrat}}</td><!-- 										<td  translate=\"wamasysApp.contrat.paiement.TypePenalitRemiseRegul.{{impactPenalitRemiseRegul.type}}\">{{impactPenalitRemiseRegul.type}}</td> --><td>{{impactPenalitRemiseRegul.label}}</td><td ng-show=\"impactPenalitRemiseRegul.type == \'CREDIT_NOTE\'\">{{impactPenalitRemiseRegul.typeAvoir.libelle}}</td><td ng-show=\"impactPenalitRemiseRegul.type == \'DISCOUNT\'\">{{impactPenalitRemiseRegul.typeRemisecommerciale.libelle}}</td><td ng-show=\"impactPenalitRemiseRegul.type == \'REFUND\'\"></td><td>{{impactPenalitRemiseRegul.commentaire}}</td><td>{{impactPenalitRemiseRegul.createdDate | date:\'mediumDate\'}}</td><td><div ng-show=\" impactPenalitRemiseRegul.lignePaiementServiceId\">{{impactPenalitRemiseRegul.collectionListDate | date:\'mediumDate\'}}</div><div ng-show=\"! impactPenalitRemiseRegul.lignePaiementServiceId\" translate=\"wamasysApp.contrat.paiement.NotImpacted\">NON impacted</div></td><td>{{impactPenalitRemiseRegul.montantTtc}}</td><td>{{impactPenalitRemiseRegul.montantHt}}</td><td><a ng-show=\"! impactPenalitRemiseRegul.lignePaiementServiceId\" ui-sref=\"contrat-detail.paiements.deletePenaliteRemiseRegul({idPenaliteRemiseRegul:impactPenalitRemiseRegul.id})\" class=\"btn btn-danger\"><span class=\"fa fa-trash\"></span> <span translate=\"wamasysApp.contrat.paiement.supprimerPenaliteRemiseRegul\">Supprimer</span></a></td></tr></tbody></table></div><div class=\"tab-pane table-responsive\" id=\"tab-r7\" ng-class=\"{\'active\':  vm.activeTab==7}\"><table class=\"table table-striped table-bordered table-hover\" style=\"width: 95%; !important\"><thead><tr><!-- 										<th translate=\"wamasysApp.contrat.paiement.type\">type</th> --><th translate=\"wamasysApp.contrat.service.invoiceLabel\">Wording</th><th translate=\"wamasysApp.contrat.paiement.label\">ligneContrat</th><th translate=\"wamasysApp.contrat.paiement.raison\">raison</th><th translate=\"wamasysApp.contrat.paiement.commentaire\">commentaire</th><th translate=\"wamasysApp.contrat.paiement.createdDate\">createdDate</th><th translate=\"wamasysApp.contrat.paiement.impactedDate\">Impacté dans collection list</th><th translate=\"wamasysApp.contrat.paiement.montantTtc\">Montant ttc</th><th translate=\"wamasysApp.contrat.paiement.montantHt\">Montant ht</th><th data-hide=\"\"></th></tr></thead><tbody><tr ng-repeat=\"impactPenalitRemiseRegul in vm.impactPenalitRemiseRegul\" ng-if=\"impactPenalitRemiseRegul.type == \'CREDIT_NOTE\'\"><td>{{impactPenalitRemiseRegul.libelleLignecontrat}}</td><!-- 										<td  translate=\"wamasysApp.contrat.paiement.TypePenalitRemiseRegul.{{impactPenalitRemiseRegul.type}}\">{{impactPenalitRemiseRegul.type}}</td> --><td>{{impactPenalitRemiseRegul.label}}</td><td ng-show=\"impactPenalitRemiseRegul.type == \'CREDIT_NOTE\' || impactPenalitRemiseRegul.type == \'DEBT_WAIVER\'\">{{impactPenalitRemiseRegul.typeAvoir.libelle}}</td><td ng-show=\"impactPenalitRemiseRegul.type == \'DISCOUNT\'\">>{{impactPenalitRemiseRegul.typeRemisecommerciale.libelle}}</td><td ng-show=\"impactPenalitRemiseRegul.type == \'REFUND\'\"></td><td>{{impactPenalitRemiseRegul.commentaire}}</td><td>{{impactPenalitRemiseRegul.createdDate | date:\'mediumDate\'}}</td><td><div ng-show=\" impactPenalitRemiseRegul.lignePaiementServiceId\">{{impactPenalitRemiseRegul.collectionListDate | date:\'mediumDate\'}}</div><div ng-show=\"! impactPenalitRemiseRegul.lignePaiementServiceId\" translate=\"wamasysApp.contrat.paiement.NotImpacted\">NON impacted</div></td><td>{{impactPenalitRemiseRegul.montantTtc}}</td><td>{{impactPenalitRemiseRegul.montantHt}}</td><td><a ng-show=\"! impactPenalitRemiseRegul.lignePaiementServiceId\" ui-sref=\"contrat-detail.services.deletePenaliteRemiseRegul({idPenaliteRemiseRegul:impactPenalitRemiseRegul.id})\" class=\"btn btn-danger\"><span class=\"fa fa-trash\"></span> <span translate=\"wamasysApp.contrat.paiement.supprimerPenaliteRemiseRegul\">Supprimer</span> </a><a ng-show=\"impactPenalitRemiseRegul.lignePaiementServiceId\" ui-sref=\"contrat-detail.services.deletePenaliteRemiseRegul({idPenaliteRemiseRegul:impactPenalitRemiseRegul.id})\" class=\"btn btn-danger\"><span class=\"fa fa-trash\"></span> <span translate=\"wamasysApp.contrat.paiement.supprimerPenaliteRemiseRegul\">Annuler</span></a></td></tr></tbody></table></div><div class=\"tab-pane table-responsive\" id=\"tab-r8\" ng-class=\"{\'active\':  vm.activeTab==8}\"><table class=\"table table-striped table-bordered table-hover\" style=\"width: 95%; !important\"><thead><tr><!-- 										<th translate=\"wamasysApp.contrat.paiement.type\">type</th> --><th translate=\"wamasysApp.contrat.service.invoiceLabel\">Wording</th><th translate=\"wamasysApp.contrat.paiement.label\">ligneContrat</th><th translate=\"wamasysApp.contrat.paiement.raison\">raison</th><th translate=\"wamasysApp.contrat.paiement.commentaire\">commentaire</th><th translate=\"wamasysApp.contrat.paiement.createdDate\">createdDate</th><th translate=\"wamasysApp.contrat.paiement.impactedDate\">Impacté dans collection list</th><th translate=\"wamasysApp.contrat.paiement.montantTtc\">Montant ttc</th><th translate=\"wamasysApp.contrat.paiement.montantHt\">Montant ht</th><th data-hide=\"\"></th></tr></thead><tbody><tr ng-repeat=\"impactPenalitRemiseRegul in vm.impactPenalitRemiseRegul\" ng-if=\"impactPenalitRemiseRegul.type == \'DEBT_WAIVER\'\"><td>{{impactPenalitRemiseRegul.libelleLignecontrat}}</td><!-- 										<td  translate=\"wamasysApp.contrat.paiement.TypePenalitRemiseRegul.{{impactPenalitRemiseRegul.type}}\">{{impactPenalitRemiseRegul.type}}</td> --><td>{{impactPenalitRemiseRegul.label}}</td><td ng-show=\"impactPenalitRemiseRegul.type == \'CREDIT_NOTE\' || impactPenalitRemiseRegul.type == \'DEBT_WAIVER\'\">{{impactPenalitRemiseRegul.typeAvoir.libelle}}</td><td ng-show=\"impactPenalitRemiseRegul.type == \'DISCOUNT\'\">>{{impactPenalitRemiseRegul.typeRemisecommerciale.libelle}}</td><td ng-show=\"impactPenalitRemiseRegul.type == \'REFUND\'\"></td><td>{{impactPenalitRemiseRegul.commentaire}}</td><td>{{impactPenalitRemiseRegul.createdDate | date:\'mediumDate\'}}</td><td><div ng-show=\" impactPenalitRemiseRegul.lignePaiementServiceId\">{{impactPenalitRemiseRegul.collectionListDate | date:\'mediumDate\'}}</div><div ng-show=\"! impactPenalitRemiseRegul.lignePaiementServiceId\" translate=\"wamasysApp.contrat.paiement.NotImpacted\">NON impacted</div></td><td>{{impactPenalitRemiseRegul.montantTtc}}</td><td>{{impactPenalitRemiseRegul.montantHt}}</td><td><a ng-show=\"! impactPenalitRemiseRegul.lignePaiementServiceId\" ui-sref=\"contrat-detail.services.deletePenaliteRemiseRegul({idPenaliteRemiseRegul:impactPenalitRemiseRegul.id})\" class=\"btn btn-danger\"><span class=\"fa fa-trash\"></span> <span translate=\"wamasysApp.contrat.paiement.supprimerPenaliteRemiseRegul\">Supprimer</span> </a><a ng-show=\"impactPenalitRemiseRegul.lignePaiementServiceId\" ui-sref=\"contrat-detail.services.deletePenaliteRemiseRegul({idPenaliteRemiseRegul:impactPenalitRemiseRegul.id})\" class=\"btn btn-danger\"><span class=\"fa fa-trash\"></span> <span translate=\"wamasysApp.contrat.paiement.supprimerPenaliteRemiseRegul\">Annuler</span></a></td></tr></tbody></table></div><div class=\"tab-pane table-responsive\" id=\"tab-r9\" ng-class=\"{\'active\':  vm.activeTab==9}\"><table class=\"table table-striped table-bordered table-hover\" style=\"width: 95%; !important\"><thead><tr><!-- 										<th translate=\"wamasysApp.contrat.paiement.type\">type</th> --><th translate=\"wamasysApp.contrat.service.invoiceLabel\">Wording</th><th translate=\"wamasysApp.contrat.paiement.label\">ligneContrat</th><th translate=\"wamasysApp.contrat.paiement.raison\">raison</th><th translate=\"wamasysApp.contrat.paiement.commentaire\">commentaire</th><th translate=\"wamasysApp.contrat.paiement.createdDate\">createdDate</th><th translate=\"wamasysApp.contrat.paiement.impactedDate\">Impacté dans collection list</th><th translate=\"wamasysApp.contrat.paiement.montantTtc\">Montant ttc</th><th translate=\"wamasysApp.contrat.paiement.montantHt\">Montant ht</th><th data-hide=\"\"></th></tr></thead><tbody><tr ng-repeat=\"impactPenalitRemiseRegul in vm.impactPenalitRemiseRegul\" ng-if=\"impactPenalitRemiseRegul.type == \'REFUND\'\"><td>{{impactPenalitRemiseRegul.libelleLignecontrat}}</td><!-- 										<td  translate=\"wamasysApp.contrat.paiement.TypePenalitRemiseRegul.{{impactPenalitRemiseRegul.type}}\">{{impactPenalitRemiseRegul.type}}</td> --><td>{{impactPenalitRemiseRegul.label}}</td><td ng-show=\"impactPenalitRemiseRegul.type == \'CREDIT_NOTE\' || impactPenalitRemiseRegul.type == \'DEBT_WAIVER\'\">{{impactPenalitRemiseRegul.typeAvoir.libelle}}</td><td ng-show=\"impactPenalitRemiseRegul.type == \'DISCOUNT\'\">>{{impactPenalitRemiseRegul.typeRemisecommerciale.libelle}}</td><td ng-show=\"impactPenalitRemiseRegul.type == \'REFUND\'\"></td><td>{{impactPenalitRemiseRegul.commentaire}}</td><td>{{impactPenalitRemiseRegul.createdDate | date:\'mediumDate\'}}</td><td><div ng-show=\" impactPenalitRemiseRegul.lignePaiementServiceId\">{{impactPenalitRemiseRegul.collectionListDate | date:\'mediumDate\'}}</div><div ng-show=\"! impactPenalitRemiseRegul.lignePaiementServiceId\" translate=\"wamasysApp.contrat.paiement.NotImpacted\">NON impacted</div></td><td>{{impactPenalitRemiseRegul.montantTtc}}</td><td>{{impactPenalitRemiseRegul.montantHt}}</td><td><a ng-show=\"! impactPenalitRemiseRegul.lignePaiementServiceId\" ui-sref=\"contrat-detail.paiements.deletePenaliteRemiseRegul({idPenaliteRemiseRegul:impactPenalitRemiseRegul.id})\" class=\"btn btn-danger\"><span class=\"fa fa-trash\"></span> <span translate=\"wamasysApp.contrat.paiement.supprimerPenaliteRemiseRegul\">Supprimer</span> </a><a ng-show=\"impactPenalitRemiseRegul.lignePaiementServiceId\" ui-sref=\"contrat-detail.services.deletePenaliteRemiseRegul({idPenaliteRemiseRegul:impactPenalitRemiseRegul.id})\" class=\"btn btn-danger\"><span class=\"fa fa-trash\"></span> <span translate=\"wamasysApp.contrat.paiement.supprimerPenaliteRemiseRegul\">Annuler</span></a></td></tr></tbody></table></div><div class=\"tab-pane table-responsive\" id=\"tab-r10\" ng-class=\"{\'active\':  vm.activeTab==10}\"><table class=\"table table-striped table-bordered table-hover\" style=\"width: 95%; !important\"><thead><tr><!-- 										<th translate=\"wamasysApp.contrat.paiement.type\">type</th> --><th translate=\"wamasysApp.contrat.service.invoiceLabel\">Wording</th><!-- 										<th translate=\"wamasysApp.contrat.paiement.ligneContratCible\">ligneContratCible</th> --><th translate=\"wamasysApp.contrat.paiement.commentaire\">commentaire</th><th translate=\"wamasysApp.contrat.paiement.createdDate\">createdDate</th><th translate=\"wamasysApp.contrat.paiement.impactedDate\">Impacté dans collection list</th><th translate=\"wamasysApp.contrat.paiement.montantTtc\">Montant ttc</th><th translate=\"wamasysApp.contrat.paiement.montantHt\">Montant ht</th><th data-hide=\"\"></th></tr></thead><tbody><tr ng-repeat=\"impactPenalitRemiseRegul in vm.impactPenalitRemiseRegul\" ng-if=\"impactPenalitRemiseRegul.type == \'REFUND_BALANCE_TRANSFER\'\"><td>{{impactPenalitRemiseRegul.libelleLignecontrat}}</td><!-- 										<td>{{impactPenalitRemiseRegul.libelleLignecontratCible}}</td> --><td>{{impactPenalitRemiseRegul.commentaire}}</td><td>{{impactPenalitRemiseRegul.createdDate | date:\'mediumDate\'}}</td><td><div ng-show=\" impactPenalitRemiseRegul.lignePaiementServiceId\">{{impactPenalitRemiseRegul.collectionListDate | date:\'mediumDate\'}}</div><div ng-show=\"! impactPenalitRemiseRegul.lignePaiementServiceId\" translate=\"wamasysApp.contrat.paiement.NotImpacted\">NON impacted</div></td><td>{{impactPenalitRemiseRegul.montantTtc}}</td><td>{{impactPenalitRemiseRegul.montantHt}}</td><td><a ng-show=\"! impactPenalitRemiseRegul.lignePaiementServiceId\" ui-sref=\"contrat-detail.paiements.deletePenaliteRemiseRegul({idPenaliteRemiseRegul:impactPenalitRemiseRegul.id})\" class=\"btn btn-danger\"><span class=\"fa fa-trash\"></span> <span translate=\"wamasysApp.contrat.paiement.supprimerPenaliteRemiseRegul\">Supprimer</span></a></td></tr></tbody></table></div><div class=\"tab-pane table-responsive\" id=\"tab-r12\" ng-class=\"{\'active\':  vm.activeTab==12}\"><table class=\"table table-striped table-bordered table-hover\" style=\"width: 95%; !important\"><thead><tr><th translate=\"wamasysApp.contrat.service.invoiceLabel\">Wording</th><th translate=\"wamasysApp.contrat.paiement.label\">ligneContrat</th><th translate=\"wamasysApp.contrat.paiement.commentaire\">commentaire</th><th translate=\"wamasysApp.contrat.paiement.createdDate\">createdDate</th><th translate=\"wamasysApp.contrat.paiement.impactedDate\">Impacté dans collection list</th><th translate=\"wamasysApp.contrat.paiement.montantTtc\">Montant ttc</th><th translate=\"wamasysApp.contrat.paiement.montantHt\">Montant ht</th><th data-hide=\"\"></th></tr></thead><tbody><tr ng-repeat=\"impactPenalitRemiseRegul in vm.impactPenalitRemiseRegul\" ng-if=\"impactPenalitRemiseRegul.type == \'PAYMENT_CORRECTION\'\"><td>{{impactPenalitRemiseRegul.libelleLignecontrat}}</td><td>{{impactPenalitRemiseRegul.label}}</td><td>{{impactPenalitRemiseRegul.commentaire}}</td><td>{{impactPenalitRemiseRegul.createdDate | date:\'mediumDate\'}}</td><td><div ng-show=\" impactPenalitRemiseRegul.lignePaiementServiceId\">{{impactPenalitRemiseRegul.collectionListDate | date:\'mediumDate\'}}</div><div ng-show=\"! impactPenalitRemiseRegul.lignePaiementServiceId\" translate=\"wamasysApp.contrat.paiement.NotImpacted\">NON impacted</div></td><td>{{impactPenalitRemiseRegul.montantTtc}}</td><td>{{impactPenalitRemiseRegul.montantHt}}</td><td><!-- \r\n										<a ng-show=\"! impactPenalitRemiseRegul.lignePaiementServiceId\" \r\n										ui-sref=\"contrat-detail.paiements.deletePenaliteRemiseRegul({idPenaliteRemiseRegul:impactPenalitRemiseRegul.id})\" \r\n										class=\"btn btn-danger\">\r\n			 									<span class=\"fa fa-trash\"></span> \r\n												<span 	 translate=\"wamasysApp.contrat.paiement.supprimerPenaliteRemiseRegul\">Supprimer</span>\r\n										</a> --></td></tr></tbody></table></div><div class=\"tab-pane table-responsive\" id=\"tab-r10\" ng-class=\"{\'active\':  vm.activeTab==11}\"><table class=\"table table-striped table-bordered table-hover\" style=\"width: 95%; !important\"><thead><tr><!-- 										<th translate=\"wamasysApp.contrat.paiement.type\">type</th> --><th translate=\"wamasysApp.contrat.service.invoiceLabel\">Wording</th><th translate=\"wamasysApp.contrat.paiement.label\">label</th><th translate=\"wamasysApp.contrat.paiement.commentaire\">commentaire</th><th translate=\"wamasysApp.contrat.paiement.createdDate\">createdDate</th><th translate=\"wamasysApp.contrat.paiement.impactedDate\">Impacté dans collection list</th><th translate=\"wamasysApp.contrat.paiement.montantTtc\">Montant ttc</th><th translate=\"wamasysApp.contrat.paiement.montantHt\">Montant ht</th><th data-hide=\"\"></th></tr></thead><tbody><tr ng-repeat=\"impactPenalitRemiseRegul in vm.impactPenalitRemiseRegul\" ng-if=\"impactPenalitRemiseRegul.type == \'WINDFALL_GAIN\'\"><td>{{impactPenalitRemiseRegul.libelleLignecontrat}}</td><td>{{impactPenalitRemiseRegul.label}}</td><td>{{impactPenalitRemiseRegul.commentaire}}</td><td>{{impactPenalitRemiseRegul.createdDate | date:\'mediumDate\'}}</td><td><div ng-show=\" impactPenalitRemiseRegul.lignePaiementServiceId\">{{impactPenalitRemiseRegul.collectionListDate | date:\'mediumDate\'}}</div><div ng-show=\"! impactPenalitRemiseRegul.lignePaiementServiceId\" translate=\"wamasysApp.contrat.paiement.NotImpacted\">NON impacted</div></td><td>{{impactPenalitRemiseRegul.montantTtc}}</td><td>{{impactPenalitRemiseRegul.montantHt}}</td><td><a ng-show=\"! impactPenalitRemiseRegul.lignePaiementServiceId\" ui-sref=\"contrat-detail.services.deletePenaliteRemiseRegul({idPenaliteRemiseRegul:impactPenalitRemiseRegul.id})\" class=\"btn btn-danger\"><span class=\"fa fa-trash\"></span> <span translate=\"wamasysApp.contrat.paiement.supprimerPenaliteRemiseRegul\">Supprimer</span> </a><a ng-show=\"impactPenalitRemiseRegul.lignePaiementServiceId\" ui-sref=\"contrat-detail.services.deletePenaliteRemiseRegul({idPenaliteRemiseRegul:impactPenalitRemiseRegul.id})\" class=\"btn btn-danger\"><span class=\"fa fa-trash\"></span> <span translate=\"wamasysApp.contrat.paiement.supprimerPenaliteRemiseRegul\">Annuler</span></a></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/business/contrat/tickets-contrat.html","<br><p><a class=\"btn btn-default\" ui-sref=\"native-tickets({contractId:vm.contract.id,areaId:vm.contract.agence.id})\">Tickets et tâches Wama de ce contrat</a></p><div class=\"container-fluid padding-top-10\"><div class=\"pull-right no-padding-left\"><button class=\"btn btn-primary pull-right\" ui-sref=\"contrat-detail.tickets.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.redmine.titleAdd\">Create new ticket</span></button></div></div><div class=\"container-fluid padding-top-10\"><div class=\"sortable-grid ui-sortable\"><div class=\"\"><div role=\"content\"><div class=\"\"><div class=\"table-responsive no-margin custom-scroll\" style=\"height:500px; overflow-y: scroll\"><table class=\"table highlight table-border-0 table-hover table-condensed\"><thead><tr><th>Subject</th><!-- 														<th class=\"hidden-xs\" colspan=\"2\">Views</th> --><!-- 														<th class=\"\">project</th> --><th class=\"\">Priority</th><th class=\"\">Status</th><th class=\"\">Tracker</th><th class=\"\">Author</th><th class=\"\">Assign to</th><th class=\"\">Created on</th><th class=\"\">Updated on</th><!-- 														<th class=\"\">done_ratio</th> --></tr></thead><tbody><tr ng-repeat=\"issue in vm.listIssues.issues track by issue.id\"><!-- 														<td class=\"v-align-m\">{{issue}}</td> --><td class=\"v-align-m\"><a href=\"{{vm.user.teamworkUrl}}/issues/{{issue.id}}\" target=\"_blank\">{{issue.subject}}</a></td><!-- 														<td class=\"v-align-m\">{{issue.project.name}}</td> --><td class=\"v-align-m\">{{issue.priority.name}}</td><td class=\"v-align-m\">{{issue.status.name}}</td><td class=\"v-align-m\">{{issue.tracker.name}}</td><td class=\"v-align-m\">{{issue.author.name}}</td><td class=\"v-align-m\">{{issue.assigned_to.name}}</td><td class=\"v-align-m\">{{issue.created_on}}</td><td class=\"v-align-m\">{{issue.updated_on}}</td><!-- 														<td class=\"v-align-m\">{{issue.done_ratio}}</td> --><!-- 														<td class=\"hidden-xs v-align-m\"> <span class=\"icon-color-good\"><i class=\"fa fa-caret-up\"></i> 1%</span> </td> --><!-- 														<td class=\"v-align-m\"> --><!-- 															<div class=\"progress progress-xs no-margin\"> --><!-- 																<div class=\"progress-bar progress-primary\" role=\"progressbar\" style=\"width: {{issue.done_ratio}}%;\"></div> --><!-- 															</div> --><!-- 														</td> --></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/business/contrat/transfer-balance-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myImpactPenalitRemiseRegulLabel\" translate=\"wamasysApp.contrat.paiement.titreAddBalanceTransfer\">AddBalanceTransfer</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"alert alert-warning\"><span translate=\"wamasysApp.contrat.paiement.explicationBalanceTransfer\"></span></div><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.paiement.montant\" for=\"field_amount\">Montant</label><input type=\"number\" class=\"form-control\" name=\"amount\" id=\"field_amount\" ng-model=\"vm.balanceTransfer.amount\" required min=\"0\" max=\"999999999\"><div ng-show=\"editForm.amount.$invalid\"><p class=\"help-block\" ng-show=\"editForm.amount.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.amount.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.amount.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"9999999999\">This field cannot be more than 999999999.</p><p class=\"help-block\" ng-show=\"editForm.amount.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></div><div class=\"col-md-5\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.paiement.ligneContratCredit\" for=\"field_ligneContrat\">ligneContrat</label><select required class=\"form-control\" id=\"field_ligneContrat\" name=\"ligneContrat\" ng-model=\"vm.balanceTransfer.ligneContrat\" ng-options=\"ligneContrat as ligneContrat.libelle + \' (\' + ligneContrat.serviceVendu.libelle + \')\' + \' [\' + ligneContrat.moneyboxApresPaiement + \']\'   for ligneContrat in vm.lignecontrats track by ligneContrat.id\"><option value=\"\"></option></select><div ng-show=\"editForm.ligneContrat.$invalid\"><p class=\"help-block\" ng-show=\"editForm.ligneContrat.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"col-md-5\"><div class=\"form-group\"><label translate=\"wamasysApp.contrat.paiement.ligneContratCible\" for=\"field_ligneContratCible\">ligneContratCible</label><select required class=\"form-control\" id=\"field_ligneContratCible\" name=\"ligneContratCible\" ng-model=\"vm.balanceTransfer.ligneContratCible\" ng-options=\"ligneContrat as ligneContrat.libelle + \' (\' + ligneContrat.serviceVendu.libelle + \')\'  + \' [\' + ligneContrat.moneyboxApresPaiement + \']\'   for ligneContrat in vm.lignecontrats track by ligneContrat.id\"><option value=\"\"></option></select><div ng-show=\"editForm.ligneContratCible.$invalid\"><p class=\"help-block\" ng-show=\"editForm.ligneContratCible.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"well well-sm\" ng-if=\"vm.hasTransferPreview()\"><table class=\"table table-condensed table-bordered\" style=\"margin-bottom: 0\"><thead><tr><th translate=\"wamasysApp.collectionListe.service\">Service</th><th translate=\"wamasysApp.collectionListe.moneyBoxApresPaiement\">Solde actuel</th><th translate=\"wamasysApp.contrat.paiement.balancePreview\">Solde prévu</th></tr></thead><tbody><tr><td>{{vm.balanceTransfer.ligneContrat.libelle}} ({{vm.balanceTransfer.ligneContrat.serviceVendu.libelle}})</td><td>{{vm.getCurrentBalance(vm.balanceTransfer.ligneContrat) | currency:\"\":2}}</td><td>{{vm.getBalanceAfterTransfer(vm.balanceTransfer.ligneContrat, \'DEBIT\') | currency:\"\":2}}</td></tr><tr><td>{{vm.balanceTransfer.ligneContratCible.libelle}} ({{vm.balanceTransfer.ligneContratCible.serviceVendu.libelle}})</td><td>{{vm.getCurrentBalance(vm.balanceTransfer.ligneContratCible) | currency:\"\":2}}</td><td>{{vm.getBalanceAfterTransfer(vm.balanceTransfer.ligneContratCible, \'CREDIT\') | currency:\"\":2}}</td></tr></tbody></table></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contrat.paiement.commentaire\" for=\"field_commentaire\">Commentaire</label><textarea required rows=\"2\" cols=\"50\" type=\"text\" class=\"form-control\" name=\"commentaire\" id=\"field_commentaire\" ng-model=\"vm.balanceTransfer.commentaire\" ng-maxlength=\"512\"></textarea><div ng-show=\"editForm.commentaire.$invalid\"><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"512\">This field cannot be longer than 512 characters.</p></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/event-dashboard/event-dashboard-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\">Créer ou modifier un tableau de bord événement</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><input type=\"hidden\" name=\"id\" ng-model=\"vm.dashboard.id\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.dashboard.code\" required ng-maxlength=\"120\"></div></div><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_label\">Libellé</label><input type=\"text\" class=\"form-control\" name=\"label\" id=\"field_label\" ng-model=\"vm.dashboard.label\" required ng-maxlength=\"255\"></div></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"field_description\">Description</label><textarea class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.dashboard.description\" rows=\"2\" ng-maxlength=\"2048\"></textarea></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_categoryIds\">Catégories incluses</label><input type=\"text\" class=\"form-control\" name=\"categoryIds\" id=\"field_categoryIds\" ng-model=\"vm.dashboard.categoryIds\" placeholder=\"Exemple : 12,18\"><p class=\"help-block\">Liste d’identifiants séparés par des virgules. Laisser vide pour ne pas filtrer.</p></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_subCategoryIds\">Sous-catégories incluses</label><input type=\"text\" class=\"form-control\" name=\"subCategoryIds\" id=\"field_subCategoryIds\" ng-model=\"vm.dashboard.subCategoryIds\" placeholder=\"Exemple : 42,43,44\"><p class=\"help-block\">Permet de cibler un ou plusieurs formulaires précis.</p></div></div></div><div class=\"row\"><div class=\"col-md-4\"><label><input type=\"checkbox\" ng-model=\"vm.dashboard.showInNavbar\"> Afficher dans la navbar</label></div><div class=\"col-md-4\"><label><input type=\"checkbox\" ng-model=\"vm.dashboard.active\"> Actif</label></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_displayOrder\">Ordre</label><input type=\"number\" class=\"form-control\" name=\"displayOrder\" id=\"field_displayOrder\" ng-model=\"vm.dashboard.displayOrder\"></div></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"field_configJson\">Configuration JSON</label><textarea class=\"form-control\" name=\"configJson\" id=\"field_configJson\" ng-model=\"vm.dashboard.configJson\" rows=\"20\"></textarea><p class=\"help-block\">Le tableau de bord calcule maintenant ses métriques, histogrammes, répartitions et cartes sur l’ensemble des événements filtrés en base, puis n’affiche que la page courante dans le tableau.</p><p class=\"help-block\">Les filtres du haut sont : agence, zone, catégorie, sous-catégorie, texte et période. Le tableau est paginé par 50 lignes. Les calculs de bas de tableau restent limités à la page affichée.</p><p class=\"help-block\">Pour un inventaire actif à une date donnée, ajouter <code>validity: {\"enabled\": true, \"startFieldCode\": \"activeFrom\", \"endFieldCode\": \"activeUntil\"}</code>. Ces codes désignent des champs <code>date</code> du dictionnaire ; la date de fin est facultative dans le formulaire. Pour les anciens formulaires sans code dictionnaire, ajouter au besoin <code>startLegacyNames</code> et <code>endLegacyNames</code> avec les anciens noms techniques. La période d\'encodage est facultative et distincte de « Situation au ».</p><p class=\"help-block\"><code>table.columns</code> définit les colonnes visibles. <code>table.summaries</code> définit les calculs affichés en bas de la page du tableau. L’export télécharge toutes les lignes filtrées, avec une limite de <code>10 000</code> lignes.</p><p class=\"help-block\">Les agrégations disponibles sont <code>count</code>, <code>unique_count</code>, <code>sum</code>, <code>avg</code>, <code>min</code>, <code>max</code> et <code>median</code>. Pour les histogrammes et répartitions, utiliser <code>groupByFieldCode</code> et, pour <code>sum</code> ou <code>unique_count</code>, renseigner aussi <code>valueFieldCode</code>.</p><p class=\"help-block\">Utiliser <code>timeHistograms</code> pour tracer l’évolution dans le temps à partir de la date de l’événement. Chaque série peut choisir son agrégation et son type d’affichage (<code>bar</code> ou <code>line</code>).</p><p class=\"help-block\">Exemple :</p><pre style=\"max-height: 360px; overflow: auto\">{{vm.exampleJson | json}}</pre></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/event-dashboard/event-dashboard-view.html","<div class=\"app-entity-shell\"><div class=\"app-entity-header\"><h2 class=\"app-entity-title\">{{vm.dashboard.label}}</h2><div class=\"app-entity-actions\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.load()\" ng-disabled=\"vm.isLoading\"><span class=\"glyphicon glyphicon-refresh\"></span> <span>Actualiser</span></button></div></div><p class=\"text-muted\" ng-if=\"vm.dashboard.description\">{{vm.dashboard.description}}</p><jhi-alert></jhi-alert><div class=\"app-filter-panel\"><form name=\"searchForm\" class=\"smart-form\" novalidate><div class=\"app-filter-grid\"><div class=\"app-filter-field\"><label class=\"app-filter-label\" for=\"event_dashboard_agency\">Agence</label><select id=\"event_dashboard_agency\" class=\"form-control\" ng-model=\"vm.selectedAgencyId\" ng-change=\"vm.updateAreaOptions()\" ng-options=\"agency.id as agency.nom for agency in vm.agencies track by agency.id\"><option value=\"\">Toutes les agences</option></select></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" for=\"event_dashboard_area\">Zone</label><select id=\"event_dashboard_area\" class=\"form-control\" ng-model=\"vm.selectedAreaId\" ng-options=\"area.id as area.nom for area in vm.filteredAreas track by area.id\"><option value=\"\">Toutes les zones</option></select></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" for=\"event_dashboard_category\">Catégorie</label><select id=\"event_dashboard_category\" class=\"form-control\" ng-model=\"vm.selectedCategoryId\" ng-change=\"vm.updateSubCategory()\" ng-options=\"category.id as category.label for category in vm.listCategory track by category.id\"><option value=\"\">Toutes les catégories</option></select></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" for=\"event_dashboard_subCategory\">Sous-catégorie</label><select id=\"event_dashboard_subCategory\" class=\"form-control\" ng-model=\"vm.selectedSubCategoryId\" ng-disabled=\"!vm.listSubCategory.length\" ng-options=\"subCategory.id as subCategory.label for subCategory in vm.listSubCategory track by subCategory.id\"><option value=\"\">Toutes les sous-catégories</option></select></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" for=\"event_dashboard_search\">Texte</label><input type=\"text\" ng-model=\"vm.searchText\" id=\"event_dashboard_search\" class=\"form-control\"></div><div class=\"app-filter-field\" ng-if=\"vm.config.validity.enabled\"><label class=\"app-filter-label\" for=\"event_dashboard_use_encoding_period\">Période d\'encodage</label><label><input id=\"event_dashboard_use_encoding_period\" type=\"checkbox\" ng-model=\"vm.useEncodingPeriod\"> Filtrer aussi la période d\'encodage</label></div><div class=\"app-filter-field\" ng-if=\"!vm.config.validity.enabled || vm.useEncodingPeriod\"><label class=\"app-filter-label\" for=\"event_dashboard_daterange\">{{vm.config.validity.enabled ? \"Période d\'encodage\" : \'Période\'}}</label><input date-range-picker id=\"event_dashboard_daterange\" name=\"daterange\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" placeholder=\"yyyy-mm-dd - yyyy-mm-dd\"></div><div class=\"app-filter-field\" ng-if=\"vm.config.validity.enabled\"><label class=\"app-filter-label\" for=\"event_dashboard_validity_date\">Situation au</label><input id=\"event_dashboard_validity_date\" name=\"validityDate\" type=\"date\" class=\"form-control\" ng-model=\"vm.validityDate\" required></div><div class=\"app-filter-field\" ng-if=\"vm.config.validity.enabled\"><label class=\"app-filter-label\" for=\"event_dashboard_validity_status\">Situation</label><select id=\"event_dashboard_validity_status\" class=\"form-control\" ng-model=\"vm.validityStatus\"><option value=\"ACTIVE\">Actifs</option><option value=\"INACTIVE\">Inactifs</option><option value=\"ALL\">Tous</option></select></div></div><div class=\"app-filter-actions\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.resetFilters()\" ng-disabled=\"vm.isLoading\">Réinitialiser</button> <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"vm.search()\" ng-disabled=\"vm.isLoading || searchForm.$invalid\">Filtrer</button></div></form></div><div class=\"alert alert-info\" ng-if=\"vm.activeFilters.length\"><strong>Filtres rapides appliqués :</strong> <span class=\"label label-default\" style=\"margin-left: 6px; margin-right: 6px\" ng-repeat=\"filter in vm.activeFilters track by $index\">{{filter.label}} = {{filter.valueLabel}} <button type=\"button\" class=\"btn btn-link btn-xs\" style=\"color: #fff; padding: 0 0 0 4px\" ng-click=\"vm.removeFilter($index)\">×</button> </span><button type=\"button\" class=\"btn btn-link btn-xs\" ng-click=\"vm.clearFilters()\">Tout retirer</button></div><div class=\"row\" ng-if=\"vm.metrics.length\"><div class=\"col-md-3 col-sm-6\" ng-repeat=\"metric in vm.metrics track by metric.label\"><div class=\"well text-center\"><div class=\"text-muted\">{{metric.label}}</div><h3>{{metric.value | number:2}}</h3></div></div></div><div class=\"row\" ng-if=\"vm.timeHistograms.length\"><div class=\"col-md-12\" ng-repeat=\"timeHistogram in vm.timeHistograms track by (timeHistogram.label + \'-\' + $index)\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong>{{timeHistogram.label}}</strong></div><div class=\"panel-body\"><div style=\"height: 320px\"><canvas class=\"chart\" ng-class=\"\'chart-\' + vm.timeHistogramBaseType(timeHistogram)\" chart-data=\"timeHistogram.data\" chart-labels=\"timeHistogram.labels\" chart-series=\"timeHistogram.seriesLabels\" chart-dataset-override=\"timeHistogram.datasetOverride\" chart-options=\"timeHistogram.options\"></canvas></div><p class=\"text-muted\" ng-if=\"!timeHistogram.labels.length\">Aucune donnée.</p></div></div></div></div><div class=\"row\" ng-if=\"vm.histograms.length || vm.pies.length\"><div class=\"col-md-6\" ng-repeat=\"histogram in vm.histograms track by histogram.label\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong>{{histogram.label}}</strong></div><div class=\"panel-body\"><div ng-repeat=\"item in histogram.values track by (item.token + \'-\' + $index)\"><div class=\"clearfix\"><span>{{item.label}}</span> <span class=\"pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.applyQuickFilter(histogram.fieldCode, null, histogram.label, item.token, item.valueLabel)\"><span class=\"glyphicon glyphicon-plus\"></span></button> <span>{{item.value | number:2}}</span></span></div><div class=\"progress\"><div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{width: ((item.value / vm.maxValue(histogram.values)) * 100) + \'%\'}\"></div></div></div><p class=\"text-muted\" ng-if=\"!histogram.values.length\">Aucune donnée.</p></div></div></div><div class=\"col-md-6\" ng-repeat=\"pie in vm.pies track by pie.label\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong>{{pie.label}}</strong></div><div class=\"table-responsive\"><table class=\"table table-condensed\"><tbody><tr ng-repeat=\"item in pie.values track by (item.token + \'-\' + $index)\"><td><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.applyQuickFilter(pie.fieldCode, null, pie.label, item.token, item.valueLabel)\"><span class=\"glyphicon glyphicon-plus\"></span></button> <span style=\"margin-left: 6px\">{{item.label}}</span></td><td class=\"text-right\">{{item.value | number:2}}</td></tr></tbody></table></div><div class=\"panel-body\" ng-if=\"!pie.values.length\"><p class=\"text-muted\">Aucune donnée.</p></div></div></div></div><div class=\"panel panel-default\" ng-if=\"vm.config.map.enabled\"><div class=\"panel-heading\"><strong>Carte des événements</strong> <span class=\"text-muted\">({{vm.mapMarkerCount}} point(s) visible(s))</span></div><div class=\"panel-body\"><leaflet width=\"100%\" height=\"420px\" center=\"vm.map.center\" bounds=\"vm.map.bounds\" markers=\"vm.map.markers\" defaults=\"vm.map.defaults\" layers=\"vm.map.layers\"></leaflet></div></div><div class=\"panel panel-default\" ng-if=\"vm.config.table.enabled\"><div class=\"panel-heading\"><strong>Événements</strong> <span class=\"text-muted\">({{vm.tableTotalResults}} résultat(s) <span ng-if=\"vm.activeFilters.length\">après filtres rapides sur {{vm.totalBaseResults}}</span>)</span><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.exportAll()\" ng-disabled=\"vm.isExporting || vm.isLoading\"><span class=\"glyphicon glyphicon-download-alt\"></span> <span>{{vm.isExporting ? \'Export en cours…\' : \'Télécharger toutes les données\'}}</span></button></div></div><div class=\"table-responsive\"><table class=\"table table-striped table-condensed\"><thead><tr><th ng-repeat=\"column in vm.tableColumns track by column.fieldCode\">{{column.label}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"eventForm in vm.tableEvents track by eventForm.id\"><td ng-repeat=\"column in vm.tableColumns track by column.fieldCode\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.applyQuickFilter(column.fieldCode, vm.resolveRawValue(eventForm, column), column.label)\"><span class=\"glyphicon glyphicon-plus\"></span></button> <span style=\"margin-left: 6px\">{{vm.resolveDisplayValue(eventForm, column)}}</span></td><td class=\"text-right\"><a ui-sref=\"event-form-detail({id:eventForm.id})\" class=\"btn btn-info btn-xs\"><span class=\"glyphicon glyphicon-eye-open\"></span></a></td></tr><tr ng-if=\"!vm.tableEvents.length\"><td class=\"text-muted text-center\" colspan=\"{{vm.tableColumns.length + 1}}\">Aucune donnée.</td></tr></tbody></table></div><div class=\"panel-footer\" ng-if=\"vm.tableSummaries.length\"><strong>Calculs sur la page affichée :</strong> <span class=\"label label-primary\" style=\"margin-left: 6px; margin-right: 6px\" ng-repeat=\"summary in vm.tableSummaries track by summary.label\">{{summary.label}} : {{summary.value | number:2}}</span></div><div class=\"panel-body\" ng-if=\"vm.tableTotalResults > vm.tablePageSize\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.tableTotalResults\" items-per-page=\"vm.tablePageSize\" ng-model=\"vm.tablePage\" max-size=\"7\" boundary-links=\"true\" ng-change=\"vm.changePage()\"></uib-pagination></div></div></div>");
$templateCache.put("app/business/event-dashboard/event-dashboards.html","<div class=\"app-entity-shell\"><div class=\"app-entity-header\"><!-- Précise le périmètre du paramétrage. --><h2 class=\"app-entity-title\"><span>Tableaux de bord événement</span> <small class=\"text-muted\" translate=\"global.configurationScope.organization\">Paramétrage commun à toute l\'organisation</small></h2><div class=\"app-entity-actions\"><button type=\"button\" class=\"btn btn-default\" ng-if=\"vm.canUseAssistant\" ng-click=\"vm.openAssistant()\">Créer avec l’assistant IA</button> <button class=\"btn btn-primary\" ui-sref=\"event-dashboard.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span>Créer un tableau de bord</span></button></div></div><jhi-alert></jhi-alert><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"displayOrder\">Ordre <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\">Code <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"label\">Libellé <span class=\"glyphicon glyphicon-sort\"></span></th><th>Catégories</th><th>Sous-catégories</th><th>Navbar</th><th>Actif</th><th></th></tr></thead><tbody><tr ng-repeat=\"dashboard in vm.dashboards track by dashboard.id\"><td>{{dashboard.displayOrder}}</td><td>{{dashboard.code}}</td><td>{{dashboard.label}}</td><td>{{dashboard.categoryIds}}</td><td>{{dashboard.subCategoryIds}}</td><td><span class=\"glyphicon glyphicon-ok text-success\" ng-if=\"dashboard.showInNavbar\"></span></td><td><span class=\"glyphicon glyphicon-ok text-success\" ng-if=\"dashboard.active\"></span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"event-dashboard-view({id:dashboard.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\">Voir</span></button> <button type=\"submit\" ui-sref=\"event-dashboard.edit({id:dashboard.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\">Modifier</span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/event-field-definition/event-field-definition-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation class=\"event-field-definition-editor\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\">Créer ou modifier un champ événement</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><input type=\"hidden\" name=\"id\" ng-model=\"vm.fieldDefinition.id\"><div class=\"row\" ng-if=\"vm.isEdit\"><div class=\"col-md-3\"><strong>Version</strong><div>{{vm.fieldDefinition.versionNumber}}</div></div><div class=\"col-md-3\"><strong>Créé par</strong><div>{{vm.fieldDefinition.createdBy}}</div></div><div class=\"col-md-3\"><strong>Créé le</strong><div>{{vm.fieldDefinition.createdDate | date:\'medium\'}}</div></div><div class=\"col-md-3\"><strong>Modifié par</strong><div>{{vm.fieldDefinition.lastModifiedBy}}</div></div></div><div class=\"row\" ng-if=\"vm.isEdit\" style=\"margin-top: 10px\"><div class=\"col-md-3\"><strong>Modifié le</strong><div>{{vm.fieldDefinition.lastModifiedDate | date:\'medium\'}}</div></div><div class=\"col-md-3\"><strong>Dernière version</strong><div>{{vm.fieldDefinition.latestVersion ? \'Oui\' : \'Non\'}}</div></div></div><hr ng-if=\"vm.isEdit\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_fieldCode\">Code technique</label><input type=\"text\" class=\"form-control\" name=\"fieldCode\" id=\"field_fieldCode\" ng-model=\"vm.fieldDefinition.fieldCode\" required ng-maxlength=\"120\" ng-readonly=\"vm.isEdit\"><p class=\"help-block\" ng-if=\"vm.isEdit\">Le code technique est immuable. Une modification crée une nouvelle version.</p></div></div><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_label\">Libellé</label><input type=\"text\" class=\"form-control\" name=\"label\" id=\"field_label\" ng-model=\"vm.fieldDefinition.label\" required ng-maxlength=\"255\"></div></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"field_description\">Description</label><textarea class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.fieldDefinition.description\" rows=\"2\" ng-maxlength=\"2048\"></textarea></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_dataType\">Type de donnée</label><select class=\"form-control\" name=\"dataType\" id=\"field_dataType\" ng-model=\"vm.fieldDefinition.dataType\" ng-change=\"vm.onDataTypeChange()\" ng-options=\"type.code as type.label for type in vm.dataTypeOptions\" required></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_unit\">Unité</label><input type=\"text\" class=\"form-control\" name=\"unit\" id=\"field_unit\" ng-model=\"vm.fieldDefinition.unit\" ng-maxlength=\"50\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><label><input type=\"checkbox\" ng-model=\"vm.fieldDefinition.requiredByDefault\"> Obligatoire</label></div><div class=\"col-md-4\"><label><input type=\"checkbox\" ng-model=\"vm.fieldDefinition.hiddenForEncoder\"> Masqué encodeur</label></div><div class=\"col-md-4\"><label><input type=\"checkbox\" ng-model=\"vm.fieldDefinition.active\"> Actif</label></div></div><hr><div class=\"row\"><div class=\"col-md-6\" ng-if=\"vm.supportsPossibleValues()\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_valuePossibleText\">Valeurs possibles par défaut</label><textarea class=\"form-control\" name=\"valuePossibleText\" id=\"field_valuePossibleText\" ng-model=\"vm.valuePossibleText\" rows=\"4\" placeholder=\"Une valeur par ligne\" ng-readonly=\"vm.fieldDefinition.dataType === \'satisfaction_smiley\'\"></textarea><p class=\"help-block\" ng-if=\"vm.fieldDefinition.dataType !== \'satisfaction_smiley\'\">Utilisé surtout pour les listes de choix. Une valeur par ligne.</p><p class=\"help-block\" ng-if=\"vm.fieldDefinition.dataType === \'satisfaction_smiley\'\">Les 4 niveaux de satisfaction sont imposés automatiquement.</p></div></div><div ng-class=\"vm.supportsPossibleValues() ? \'col-md-6\' : \'col-md-12\'\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_exampleValuesText\">Exemples de valeurs</label><textarea class=\"form-control\" name=\"exampleValuesText\" id=\"field_exampleValuesText\" ng-model=\"vm.exampleValuesText\" rows=\"4\" placeholder=\"Exemple 1&#10;Exemple 2\"></textarea><p class=\"help-block\">Exemples affichables dans l’aide ou pour guider l’encodage.</p></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong>Contrôles du champ</strong> <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" ng-click=\"vm.addValidationRule()\"><span class=\"glyphicon glyphicon-plus\"></span> Ajouter</button></div><div class=\"panel-body\"><p class=\"text-muted\">Configurez ici les contrôles unitaires du dictionnaire. Les règles croisées <code>REQUIRED_IF</code>, <code>MIN_IF</code>, <code>MAX_IF</code>, <code>VALUE_POSSIBLE_IF</code> se configurent dans la sous-catégorie.</p><p class=\"text-muted\">Les contrôles proposés sont filtrés selon le type du champ pour accélérer la saisie.</p><div class=\"row\" ng-repeat=\"rule in vm.validationRules track by $index\" style=\"margin-bottom: 10px\"><div class=\"col-md-4\"><select class=\"form-control\" ng-model=\"rule.type\" ng-change=\"vm.onValidationTypeChange(rule)\" ng-options=\"type.code as (type.group + \' - \' + type.code + \' - \' + type.label) for type in vm.availableValidationTypes(rule)\"></select></div><div class=\"col-md-2\"><select class=\"form-control\" ng-model=\"rule.severity\"><option value=\"ERROR\">Erreur</option><option value=\"WARNING\">Avertissement</option></select></div><div class=\"col-md-3\" ng-if=\"vm.requiresSingleValue(rule)\"><input class=\"form-control\" ng-model=\"rule.value\" ng-attr-placeholder=\"{{vm.validationValuePlaceholder(rule)}}\"></div><div class=\"col-md-5\" ng-if=\"vm.requiresValuesList(rule)\"><input class=\"form-control\" ng-model=\"rule.valuesText\" ng-attr-placeholder=\"{{vm.validationValuePlaceholder(rule)}}\"></div><div class=\"col-md-1\"><button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"vm.removeValidationRule($index)\"><span class=\"glyphicon glyphicon-trash\"></span></button></div><div class=\"col-md-12\" ng-if=\"rule.type\"><p class=\"text-muted small\" style=\"margin-top: 6px\">{{vm.validationTypeHelp(rule)}}</p></div></div><p class=\"text-muted\" ng-if=\"!vm.validationRules.length\">Aucun contrôle défini.</p></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong>Contraintes avancées</strong></div><div class=\"panel-body\"><p class=\"text-muted\">Ces contraintes servent à borner le champ. Les contrôles bloquants restent dans le bloc ci-dessus.</p><div class=\"row\"><div class=\"col-md-4\" ng-repeat=\"constraint in vm.constraintDefinitions track by constraint.key\" ng-if=\"vm.supportsConstraint(constraint)\"><div class=\"form-group\"><label>{{constraint.label}}</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.constraintsModel.values[constraint.key]\" ng-attr-placeholder=\"{{constraint.placeholder}}\"><p class=\"help-block\">{{constraint.help}}</p></div></div></div><p class=\"text-muted\" ng-if=\"!vm.hasVisibleConstraintDefinitions()\">Aucune contrainte avancée spécifique à ce type. Utilisez surtout les contrôles du champ.</p><div class=\"event-field-definition-extra-constraints\"><div class=\"event-field-definition-extra-constraints__header\"><strong>Autres contraintes</strong> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.addAdditionalConstraint()\"><span class=\"glyphicon glyphicon-plus\"></span> Ajouter</button></div><div class=\"row\" ng-repeat=\"constraint in vm.constraintsModel.additional track by $index\" style=\"margin-bottom: 10px\"><div class=\"col-md-4\"><input type=\"text\" class=\"form-control\" ng-model=\"constraint.key\" placeholder=\"Clé JSON\"></div><div class=\"col-md-7\"><input type=\"text\" class=\"form-control\" ng-model=\"constraint.value\" placeholder=\"Valeur\"></div><div class=\"col-md-1\"><button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"vm.removeAdditionalConstraint($index)\"><span class=\"glyphicon glyphicon-trash\"></span></button></div></div><p class=\"text-muted\" ng-if=\"!vm.constraintsModel.additional.length\">Aucune contrainte complémentaire.</p></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Annuler</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Enregistrer</span></button></div></form>");
$templateCache.put("app/business/event-field-definition/event-field-definition-versions.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\">Anciennes versions - {{vm.fieldDefinition.fieldCode}}</h4></div><div class=\"modal-body\"><div class=\"table-responsive\"><table class=\"table table-striped table-condensed\"><thead><tr><th>Version</th><th>Libellé</th><th>Actif</th><th>Dernière</th><th>Créé par</th><th>Créé le</th><th>Modifié par</th><th>Modifié le</th></tr></thead><tbody><tr ng-repeat=\"version in vm.versions track by version.id\"><td>{{version.versionNumber}}</td><td>{{version.label}}</td><td><span class=\"glyphicon glyphicon-ok text-success\" ng-if=\"version.active\"></span></td><td><span class=\"glyphicon glyphicon-ok text-success\" ng-if=\"version.latestVersion\"></span></td><td>{{version.createdBy}}</td><td>{{version.createdDate | date:\'medium\'}}</td><td>{{version.lastModifiedBy}}</td><td>{{version.lastModifiedDate | date:\'medium\'}}</td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Annuler</span></button></div>");
$templateCache.put("app/business/event-field-definition/event-field-definitions.html","<div class=\"app-entity-shell\"><div class=\"app-entity-header\"><!-- Précise le périmètre du paramétrage. --><h2 class=\"app-entity-title\"><span>Dictionnaire des champs événement</span> <small class=\"text-muted\" translate=\"global.configurationScope.organization\">Paramétrage commun à toute l\'organisation</small></h2><div class=\"app-entity-actions\"><button type=\"button\" class=\"btn btn-default\" ng-if=\"vm.canUseAssistant\" ng-click=\"vm.openAssistant()\">Créer avec l’assistant IA</button> <button class=\"btn btn-primary\" ui-sref=\"event-field-definition.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span>Créer un champ</span></button></div></div><jhi-alert></jhi-alert><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.inclInactive\" ng-change=\"vm.loadAll()\"> Inclure les champs inactifs</label></div><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"fieldCode\">Code <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"versionNumber\">Version <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"label\">Libellé <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dataType\">Type <span class=\"glyphicon glyphicon-sort\"></span></th><th>Obligatoire</th><th>Masqué encodeur</th><th>Actif</th><th>Créé par</th><th>Créé le</th><th></th></tr></thead><tbody><tr ng-repeat=\"fieldDefinition in vm.fieldDefinitions track by fieldDefinition.id\"><td>{{fieldDefinition.fieldCode}}</td><td>{{fieldDefinition.versionNumber}}</td><td>{{fieldDefinition.label}}</td><td>{{vm.dataTypeLabel(fieldDefinition.dataType)}}</td><td><span class=\"glyphicon glyphicon-ok text-success\" ng-if=\"fieldDefinition.requiredByDefault\"></span></td><td><span class=\"glyphicon glyphicon-ok text-success\" ng-if=\"fieldDefinition.hiddenForEncoder\"></span></td><td><span class=\"glyphicon glyphicon-ok text-success\" ng-if=\"fieldDefinition.active\"></span></td><td>{{fieldDefinition.createdBy}}</td><td>{{fieldDefinition.createdDate | date:\'short\'}}</td><td class=\"text-right\"><button type=\"button\" ng-click=\"vm.openVersions(fieldDefinition)\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-time\"></span> <span class=\"hidden-xs hidden-sm\">Anciennes versions</span></button> <button type=\"submit\" ui-sref=\"event-field-definition.edit({id:fieldDefinition.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\">Modifier</span></button></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/event-form-category/event-form-category-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.EventFormCategory.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\">Confirmer l’archivage</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p>Voulez-vous vraiment archiver la catégorie d’événement {{vm.EventFormCategory.id}} ?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span>Archiver</span></button></div></form>");
$templateCache.put("app/business/event-form-category/event-form-category-detail.html","<div><h2><span translate=\"wamasysApp.EventFormCategory.detail.title\">EventFormCategory</span> {{vm.EventFormCategory.id}}</h2><jhi-alert></jhi-alert><hr><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.EventFormCategory.label\">label</span></dt><dd><span>{{vm.EventFormCategory.label}}</span></dd><dt><span translate=\"wamasysApp.EventFormCategory.visibleOnSmartphone\">Visible smartphone</span></dt><dd><span>{{vm.EventFormCategory.visibleOnSmartphone}}</span></dd><dt><span translate=\"wamasysApp.EventFormCategory.isDeleted\">Archivée</span></dt><dd><span class=\"label label-warning\" ng-if=\"vm.EventFormCategory.deleted\">Archivée</span> <span class=\"label label-success\" ng-if=\"!vm.EventFormCategory.deleted\">Active</span></dd><hr></dl><div class=\"widget-body\"><div class=\"container-fluid\"><div class=\"row\" style=\"margin-bottom:5px\"><div class=\"col-xs-12\"><button class=\"btn btn-primary pull-right\" ui-sref=\"event-form-category-detail.new-sub-category({id:vm.EventFormCategory.id})\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.EventFormCategory.home.createLabel\">Create new EventFormCategory</span></button> <button class=\"btn btn-default pull-right\" style=\"margin-right: 10px\" ui-sref=\"event-form-category-matrix\"><span class=\"glyphicon glyphicon-th\"></span> <span translate=\"wamasysApp.EventFormCategory.matrix.open\">Matrice des champs</span></button></div></div></div><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th><span translate=\"wamasysApp.EventFormCategory.label\">label</span></th><th><span translate=\"wamasysApp.eventFormSubCategory.version\">Version</span></th><th><span translate=\"wamasysApp.EventFormCategory.isDeleted\">Archivé</span></th><th><span translate=\"wamasysApp.eventFormSubCategory.customFields\">customFields</span></th><th></th></tr></thead><tbody><tr ng-repeat-start=\"eventFormSubCategory in vm.EventFormCategory.listEventFormSubCategory track by eventFormSubCategory.id\"><td>{{eventFormSubCategory.label}}</td><td>{{eventFormSubCategory.versionNumber}}</td><td><span class=\"label label-warning\" ng-if=\"eventFormSubCategory.deleted\">Archivé</span> <span class=\"label label-success\" ng-if=\"!eventFormSubCategory.deleted\">Actif</span></td><td><ul><li ng-repeat=\"field in eventFormSubCategory.customFields.fields track by (field.name || field.code || $index)\"><strong>{{field.label}}</strong> <span class=\"text-muted\">[{{field.name || field.code}}]</span> <span class=\"text-muted\" ng-if=\"field.dictionaryFieldCode && field.dictionaryFieldCode !== (field.name || field.code)\">&#8594; {{field.dictionaryFieldCode}}</span> <span class=\"text-muted\">({{field.type}})</span></li></ul></td><td><button type=\"submit\" ui-sref=\"event-form-category-detail.edit-sub-category({id:eventFormSubCategory.eventFormCategory.id,idSubCategory:eventFormSubCategory.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"event-form-category-detail.delete-sub-category({id:eventFormSubCategory.eventFormCategory.id,idSubCategory:eventFormSubCategory.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\">Archiver</span></button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.toggleSubCategoryHistory(eventFormSubCategory)\"><span class=\"glyphicon glyphicon-time\"></span> <span class=\"hidden-xs hidden-sm\">Historique</span></button></td></tr><tr ng-repeat-end ng-if=\"eventFormSubCategory.showHistory\"><td colspan=\"5\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong>Historique des versions</strong></div><div class=\"table-responsive\"><table class=\"table table-condensed table-striped\"><thead><tr><th>Version</th><th>État</th><th>Créé le</th><th>Créé par</th><th>Dernière modification</th><th>Dernier auteur</th><th>Modifications</th></tr></thead><tbody><tr ng-repeat=\"historyItem in vm.subCategoryHistoryById[eventFormSubCategory.id] track by historyItem.id\"><td>{{historyItem.versionNumber}}</td><td><span class=\"label label-warning\" ng-if=\"historyItem.deleted\">Archivé</span> <span class=\"label label-success\" ng-if=\"!historyItem.deleted\">Actif</span></td><td>{{historyItem.createdDate | date:\'medium\'}}</td><td>{{historyItem.createdBy}}</td><td>{{historyItem.lastModifiedDate | date:\'medium\'}}</td><td>{{historyItem.lastModifiedBy}}</td><td><ul class=\"list-unstyled\" ng-if=\"historyItem.changeMessages && historyItem.changeMessages.length\"><li ng-repeat=\"message in historyItem.changeMessages track by $index\">{{message}}</li></ul><span class=\"text-muted\" ng-if=\"!historyItem.changeMessages || !historyItem.changeMessages.length\">Aucune différence détectée</span></td></tr></tbody></table></div></div></td></tr></tbody></table></div></div><button type=\"submit\" ui-sref=\"event-form-category\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/event-form-category/event-form-category-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myEventFormCategoryLabel\" translate=\"wamasysApp.EventFormCategory.home.createOrEditLabel\">Create or edit a EventFormCategory</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!--         <div class=\"form-group\"> --><!--             <label for=\"id\" translate=\"global.field.id\">ID</label> --><!--             <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" --><!--                     ng-model=\"vm.EventFormCategory.id\" readonly /> --><!--         </div> --><div class=\"alert alert-warning\" ng-show=\"vm.EventFormCategory.id\" translate=\"wamasysApp.EventFormCategory.home.warningNePasModifierLabel\">Attention ne modifiez pas le libellé si vous utilisez cette catégorie d\'événement dans des reportings spécifiques, les événements n\'apparaitraient plus dans le reporting.</div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.EventFormCategory.label\" for=\"field_label\">label</label><input type=\"text\" class=\"form-control\" name=\"label\" id=\"field_label\" ng-model=\"vm.EventFormCategory.label\" required ng-maxlength=\"50\"><div ng-show=\"editForm.label.$invalid\"><p class=\"help-block\" ng-show=\"editForm.label.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.label.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"checkbox-inline\"><input type=\"checkbox\" name=\"visibleOnSmartphone\" id=\"field_visibleOnSmartphone\" ng-model=\"vm.EventFormCategory.visibleOnSmartphone\"> <span translate=\"wamasysApp.EventFormCategory.visibleOnSmartphone\">Visible smartphone</span></label></div><div class=\"form-group\" ng-if=\"vm.EventFormCategory.id\"><label class=\"control-deleted\" translate=\"global.field.isDeleted\" for=\"field_deleted\">deleted</label><input type=\"checkbox\" class=\"form-control\" name=\"deleted\" id=\"field_deleted\" ng-model=\"vm.EventFormCategory.deleted\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/event-form-category/event-form-category-matrix.html","<div class=\"app-entity-shell\"><div class=\"app-entity-header\"><div><!-- Précise le périmètre du paramétrage. --><h2 class=\"app-entity-title\"><span translate=\"wamasysApp.EventFormCategory.matrix.title\">Matrice des catégories événement</span> <small class=\"text-muted\" translate=\"global.configurationScope.organization\">Paramétrage commun à toute l\'organisation</small></h2><p class=\"text-muted\" translate=\"wamasysApp.EventFormCategory.matrix.help\">Chaque ligne représente une sous-catégorie active. Les colonnes indiquent si le champ est visible et obligatoire.</p></div><div class=\"app-entity-actions\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.toggleArchived()\"><span class=\"glyphicon\" ng-class=\"vm.showArchived ? \'glyphicon-eye-close\' : \'glyphicon-eye-open\'\"></span> <span ng-if=\"!vm.showArchived\">Afficher les archivés</span> <span ng-if=\"vm.showArchived\">Masquer les archivés</span></button> <button type=\"button\" ui-sref=\"event-form-category\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-arrow-left\"></span> <span translate=\"entity.action.back\">Retour</span></button></div></div><jhi-alert></jhi-alert><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-condensed\"><thead><tr><th translate=\"wamasysApp.EventFormCategory.label\">Catégorie</th><th>Catégorie archivée</th><th translate=\"wamasysApp.eventFormSubCategory.label\">Sous-catégorie</th><th translate=\"wamasysApp.eventFormSubCategory.version\">Version</th><th>Sous-catégorie archivée</th><th translate=\"wamasysApp.EventFormCategory.visibleOnSmartphone\">Visible smartphone</th><th ng-repeat=\"baseField in vm.matrix.baseFields track by baseField.key\">{{baseField.label}}</th><th ng-repeat=\"field in vm.matrix.fields track by field.fieldCode\">{{field.label}}<br><small class=\"text-muted\">{{field.fieldCode}}</small></th></tr></thead><tbody><tr ng-repeat=\"row in vm.matrix.rows track by row.subCategoryId\"><td>{{row.categoryLabel}}</td><td><span class=\"label label-warning\" ng-if=\"row.categoryArchived\">Archivée</span> <span class=\"label label-success\" ng-if=\"!row.categoryArchived\">Active</span></td><td>{{row.subCategoryLabel}}</td><td>{{row.subCategoryVersionNumber}}</td><td><span class=\"label label-warning\" ng-if=\"row.subCategoryArchived\">Archivée</span> <span class=\"label label-success\" ng-if=\"!row.subCategoryArchived\">Active</span></td><td><span class=\"label label-success\" ng-if=\"row.visibleOnSmartphone\">Oui</span> <span class=\"label label-default\" ng-if=\"!row.visibleOnSmartphone\">Non</span></td><td ng-repeat=\"baseField in vm.matrix.baseFields track by baseField.key\"><span class=\"label label-default\" ng-if=\"!row.baseFieldStatuses[baseField.key] || !row.baseFieldStatuses[baseField.key].visible\">-</span> <span class=\"label label-info\" ng-if=\"row.baseFieldStatuses[baseField.key] && row.baseFieldStatuses[baseField.key].visible\">V</span> <span class=\"label label-success\" ng-if=\"row.baseFieldStatuses[baseField.key] && row.baseFieldStatuses[baseField.key].required\">O</span></td><td ng-repeat=\"field in vm.matrix.fields track by field.fieldCode\"><span class=\"label label-default\" ng-if=\"!row.fieldStatuses[field.fieldCode] || !row.fieldStatuses[field.fieldCode].visible\">-</span> <span class=\"label label-info\" ng-if=\"row.fieldStatuses[field.fieldCode] && row.fieldStatuses[field.fieldCode].visible\">V</span> <span class=\"label label-success\" ng-if=\"row.fieldStatuses[field.fieldCode] && row.fieldStatuses[field.fieldCode].required\">O</span></td></tr></tbody></table></div><p class=\"text-muted\"><span class=\"label label-info\">V</span> <span translate=\"wamasysApp.EventFormCategory.matrix.visible\">Visible</span> <span class=\"label label-success\">O</span> <span translate=\"wamasysApp.EventFormCategory.matrix.required\">Obligatoire</span></p></div>");
$templateCache.put("app/business/event-form-category/event-form-categorys.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.EventFormCategory.home.title\">EventFormCategorys</span> <small class=\"text-muted\" translate=\"global.configurationScope.organization\">Paramétrage commun à toute l\'organisation</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-8 no-padding-left\"><button type=\"button\" class=\"btn btn-default\" ng-if=\"vm.canUseAssistant\" ng-click=\"vm.openAssistant()\">Créer avec l’assistant IA</button> <button class=\"btn btn-primary\" ui-sref=\"event-form-category.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.EventFormCategory.home.createLabel\">Create new EventFormCategory</span></button> <button class=\"btn btn-default\" ui-sref=\"event-form-category-matrix\"><span class=\"glyphicon glyphicon-th\"></span> <span translate=\"wamasysApp.EventFormCategory.matrix.open\">Matrice des champs</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"label\"><span translate=\"wamasysApp.EventFormCategory.label\">label</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"visibleOnSmartphone\"><span translate=\"wamasysApp.EventFormCategory.visibleOnSmartphone\">Visible smartphone</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deleted\"><span translate=\"wamasysApp.EventFormCategory.isDeleted\">Archivé</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"EventFormCategory in vm.EventFormCategorys track by EventFormCategory.id\"><td><a ui-sref=\"event-form-category-detail({id:EventFormCategory.id})\">{{EventFormCategory.id}}</a></td><td>{{EventFormCategory.label}}</td><td>{{EventFormCategory.visibleOnSmartphone}}</td><td><span class=\"label label-warning\" ng-if=\"EventFormCategory.deleted\">Archivée</span> <span class=\"label label-success\" ng-if=\"!EventFormCategory.deleted\">Active</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"event-form-category-detail({id:EventFormCategory.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"event-form-category.edit({id:EventFormCategory.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"event-form-category.delete({id:EventFormCategory.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\">Archiver</span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/event-form-category/event-form-sub-category-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.EventFormCategory.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\">Confirmer l’archivage</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p>Voulez-vous vraiment archiver cette sous-catégorie d’événement ?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span>Archiver</span></button></div></form>");
$templateCache.put("app/business/event-form-category/event-form-sub-category-dialog.html","<form name=\"editForm\" role=\"form\" novalidate onsubmit=\"return false\" ng-keydown=\"vm.handleFormKeydown($event)\" show-validation class=\"event-subcategory-editor\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myeventFormSubCategoryLabel\" translate=\"wamasysApp.eventFormSubCategory.home.createOrEditLabel\">Créer ou modifier une sous-catégorie de formulaire</h4></div><div class=\"modal-body\"><jhi-alert></jhi-alert><div class=\"alert alert-warning\" ng-show=\"vm.eventFormSubCategory.id\" translate=\"wamasysApp.EventFormCategory.home.warningNePasModifierLabel\">Attention, ne modifiez pas le libellé si vous utilisez cette catégorie d\'événement dans des reportings spécifiques.</div><div class=\"row\"><div class=\"col-sm-7\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.eventFormSubCategory.label\" for=\"field_label\">Libellé</label><input type=\"text\" class=\"form-control\" name=\"label\" id=\"field_label\" ng-model=\"vm.eventFormSubCategory.label\" required ng-maxlength=\"50\"><div ng-show=\"editForm.label.$invalid\"><p class=\"help-block\" ng-show=\"editForm.label.$error.required\" translate=\"entity.validation.required\">Ce champ est obligatoire.</p><p class=\"help-block\" ng-show=\"editForm.label.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">Ce champ ne peut pas dépasser 50 caractères.</p></div></div></div><div class=\"col-sm-2\" ng-if=\"vm.eventFormSubCategory.id\"><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.eventFormSubCategory.version\">Version</label><div class=\"form-control-static\">{{vm.eventFormSubCategory.versionNumber || 1}}</div></div></div><div class=\"col-sm-3\" ng-if=\"vm.eventFormSubCategory.id\"><div class=\"form-group event-subcategory-editor__deleted\"><label class=\"control-label\" translate=\"global.field.isDeleted\" for=\"field_deleted\">Supprimé</label><div><label class=\"checkbox-inline\"><input type=\"checkbox\" name=\"deleted\" id=\"field_deleted\" ng-model=\"vm.eventFormSubCategory.deleted\"> Marquer comme supprimé</label></div></div></div></div><div class=\"form-group\" ng-if=\"vm.customFieldReadLony\"><input ng-model=\"vm.eventFormSubCategory.customFields\" name=\"customFields\" hidden=\"true\"></div><div ng-if=\"!vm.customFieldReadLony\"><div class=\"event-subcategory-toolbar\"><div class=\"event-subcategory-toolbar__intro\"><h4>Champs du formulaire</h4><p class=\"text-muted\"><code>dictionaryFieldCode</code> reste le lien métier vers le dictionnaire. Le <code>name</code> stocké et le <code>type</code> sont forcés automatiquement quand un champ dictionnaire est choisi.</p></div><div class=\"event-subcategory-toolbar__actions\"><button class=\"btn btn-primary btn-sm\" type=\"button\" ng-click=\"vm.addField()\"><span class=\"glyphicon glyphicon-plus\"></span> Ajouter un champ</button> <button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"vm.toggleJsonEditor()\"><span class=\"glyphicon glyphicon-console\"></span> {{vm.showJsonEditor ? \'Masquer le JSON\' : \'Voir le JSON\'}}</button></div></div><div class=\"panel panel-default event-subcategory-card\"><div class=\"panel-heading event-subcategory-card__heading\"><div class=\"event-subcategory-card__title\">Champs de base</div></div><div class=\"panel-body\"><p class=\"text-muted\">Définissez ici si les champs standards du document restent visibles et obligatoires pour cette sous-catégorie.</p><div class=\"row event-subcategory-row\" ng-repeat=\"baseField in vm.baseFieldDefinitions track by baseField.key\"><div class=\"col-sm-5\"><strong>{{baseField.label}}</strong><p class=\"help-block\">{{baseField.help}}</p></div><div class=\"col-sm-7\"><div class=\"event-subcategory-flags\"><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"vm.customFieldsConfig.baseFields[baseField.key].visible\" ng-change=\"vm.updateCustomFieldsJson()\"> Visible</label><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"vm.customFieldsConfig.baseFields[baseField.key].required\" ng-disabled=\"!vm.customFieldsConfig.baseFields[baseField.key].visible\" ng-change=\"vm.updateCustomFieldsJson()\"> Obligatoire</label></div></div></div></div></div><div dragula=\'\"fields-bag\"\' dragula-model=\"vm.customFieldsConfig.fields\" dragula-on-drop=\"vm.onReorder()\" class=\"event-subcategory-list\"><div class=\"panel panel-default event-subcategory-card\" ng-repeat=\"f in vm.customFieldsConfig.fields track by $index\"><div class=\"panel-heading event-subcategory-card__heading\"><div class=\"event-subcategory-card__title\"><span class=\"glyphicon glyphicon-move event-subcategory-card__move\"></span> Champ {{$index + 1}}</div><button class=\"btn btn-danger btn-xs\" type=\"button\" ng-click=\"vm.removeField($index)\"><span class=\"glyphicon glyphicon-trash\"></span> Supprimer</button></div><div class=\"panel-body\"><div class=\"row event-subcategory-row\"><div class=\"col-sm-4\"><label>Champ dictionnaire</label><select class=\"form-control\" ng-model=\"f.dictionaryFieldCode\" ng-change=\"vm.onFieldDefinitionChange(f)\" ng-options=\"definition.fieldCode as (definition.fieldCode + \' - \' + definition.label) for definition in vm.fieldDefinitions\"><option value=\"\">Champ libre / legacy</option></select></div><div class=\"col-sm-4\"><label>Libellé</label><input class=\"form-control\" placeholder=\"Ex. Nombre de participants\" ng-model=\"f.label\" ng-change=\"vm.updateCustomFieldsJson()\"></div><div class=\"col-sm-4\"><label>Nom technique stocké</label><input class=\"form-control\" placeholder=\"cf.mon_champ\" ng-model=\"f.name\" ng-disabled=\"vm.isDictionaryLinked(f)\" ng-change=\"vm.updateCustomFieldsJson()\"><p class=\"help-block\" ng-if=\"vm.isDictionaryLinked(f)\">Nom généré automatiquement depuis le champ dictionnaire.</p></div></div><div class=\"row event-subcategory-row\"><div class=\"col-sm-3\"><label>Type</label><select class=\"form-control\" ng-model=\"f.type\" ng-disabled=\"vm.isDictionaryLinked(f)\" ng-change=\"vm.onFieldTypeChange(f)\" ng-options=\"type.code as type.label for type in vm.fieldTypes\"><option value=\"\">Choisir un type</option></select><p class=\"help-block\" ng-if=\"vm.isDictionaryLinked(f)\">Type imposé par le dictionnaire.</p></div><div class=\"col-sm-9\"><label>Aide / tooltip</label><input class=\"form-control\" placeholder=\"Texte d\'aide affiché à l\'utilisateur\" ng-model=\"f.tooltip\" ng-change=\"vm.updateCustomFieldsJson()\"></div></div><div class=\"row event-subcategory-row\"><div class=\"col-sm-8\" ng-if=\"vm.isListField(f)\"><label>Valeurs de liste surchargées</label><input class=\"form-control\" placeholder=\"valeur1;valeur2;valeur3\" ng-model=\"f.values\" ng-change=\"vm.updateCustomFieldsJson()\"></div><div class=\"col-sm-8\" ng-if=\"vm.isSmileyField(f)\"><label>Valeurs imposées</label><p class=\"form-control-static\">😡 Très mécontent, 😐 Neutre, 🙂 Un peu content, 😄 Très content</p></div><div class=\"col-sm-4\" ng-class=\"{\'col-sm-offset-8\': !vm.isListField(f) && !vm.isSmileyField(f)}\"><label>Comportement</label><div class=\"event-subcategory-flags\"><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"f.required\" ng-change=\"vm.updateCustomFieldsJson()\"> Obligatoire</label><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"f.hidden\" ng-change=\"vm.updateCustomFieldsJson()\"> Masqué</label></div></div></div></div></div></div><p class=\"text-muted\" ng-if=\"!vm.customFieldsConfig.fields.length\">Aucun champ configuré pour cette sous-catégorie.</p><div class=\"panel panel-default event-subcategory-card\"><div class=\"panel-heading event-subcategory-card__heading\"><div class=\"event-subcategory-card__title\">Règles conditionnelles</div><button type=\"button\" class=\"btn btn-primary btn-xs\" ng-click=\"vm.addRule()\"><span class=\"glyphicon glyphicon-plus\"></span> Ajouter</button></div><div class=\"panel-body\"><p class=\"text-muted\">Exemples : <code>participantCount</code> obligatoire si <code>activityType = DISTRIBUTION_KIT</code>, ou date trop ancienne en avertissement.</p><div class=\"panel panel-info event-subcategory-rule-card\" ng-repeat=\"rule in vm.customFieldsConfig.rules track by $index\"><div class=\"panel-body\"><div class=\"row event-subcategory-row\"><div class=\"col-sm-3\"><label>Type de règle</label><select class=\"form-control\" ng-model=\"rule.type\" ng-options=\"type for type in vm.ruleTypes\" ng-change=\"vm.updateCustomFieldsJson()\"></select></div><div class=\"col-sm-4\"><label>Champ cible</label><select class=\"form-control\" ng-model=\"rule.targetField\" ng-options=\"item.code as item.label for item in vm.getFieldReferenceOptions()\" ng-change=\"vm.updateCustomFieldsJson()\"><option value=\"\">Choisir un champ</option></select></div><div class=\"col-sm-3\"><label>Sévérité</label><select class=\"form-control\" ng-model=\"rule.severity\" ng-options=\"severity for severity in vm.severities\" ng-change=\"vm.updateCustomFieldsJson()\"></select></div><div class=\"col-sm-2\"><label>&nbsp;</label><button type=\"button\" class=\"btn btn-danger btn-sm form-control\" ng-click=\"vm.removeRule($index)\"><span class=\"glyphicon glyphicon-trash\"></span> Supprimer</button></div></div><div class=\"row event-subcategory-row\"><div class=\"col-sm-3\"><label>Champ condition</label><select class=\"form-control\" ng-model=\"rule.condition.field\" ng-options=\"item.code as item.label for item in vm.getFieldReferenceOptions()\" ng-change=\"vm.updateCustomFieldsJson()\"><option value=\"\">Choisir un champ</option></select></div><div class=\"col-sm-3\"><label>Opérateur</label><select class=\"form-control\" ng-model=\"rule.condition.operator\" ng-options=\"operator for operator in vm.conditionOperators\" ng-change=\"vm.updateCustomFieldsJson()\"></select></div><div class=\"col-sm-3\" ng-if=\"vm.conditionRequiresValue(rule)\"><label>Valeur condition</label><input class=\"form-control\" ng-model=\"rule.condition.value\" ng-change=\"vm.updateCustomFieldsJson()\"></div><div class=\"col-sm-3\" ng-if=\"vm.conditionRequiresValues(rule)\"><label>Valeurs condition</label><input class=\"form-control\" placeholder=\"valeur1;valeur2\" ng-model=\"rule.condition.valuesText\" ng-change=\"vm.updateCustomFieldsJson()\"></div></div><div class=\"row event-subcategory-row\" ng-if=\"vm.requiresRuleValue(rule) || vm.requiresRuleValues(rule)\"><div class=\"col-sm-3\" ng-if=\"vm.requiresRuleValue(rule)\"><label>Valeur de la règle</label><input class=\"form-control\" ng-model=\"rule.value\" ng-change=\"vm.updateCustomFieldsJson()\"></div><div class=\"col-sm-6\" ng-if=\"vm.requiresRuleValues(rule)\"><label>Valeurs autorisées</label><input class=\"form-control\" placeholder=\"valeur1;valeur2;valeur3\" ng-model=\"rule.valuesText\" ng-change=\"vm.updateCustomFieldsJson()\"></div></div></div></div><p class=\"text-muted\" ng-if=\"!vm.customFieldsConfig.rules.length\">Aucune règle conditionnelle définie.</p></div></div><div class=\"panel panel-default event-subcategory-json-panel\" ng-if=\"vm.showJsonEditor\"><div class=\"panel-heading\"><strong>Configuration JSON technique</strong></div><div class=\"panel-body\"><p class=\"text-muted\">Cette zone reste disponible pour contrôle ou copier-coller avancé, mais l\'édition courante doit se faire avec les formulaires ci-dessus.</p><label class=\"control-label\" translate=\"wamasysApp.eventFormSubCategory.customFields\" for=\"field_customFields\">Configuration</label><textarea rows=\"10\" class=\"form-control event-subcategory-json-panel__editor\" name=\"customFields\" id=\"field_customFields\" ng-readonly=\"vm.customFieldReadLony\" ng-model=\"vm.eventFormSubCategory.customFields\" ng-maxlength=\"12000\"></textarea><div ng-show=\"editForm.customFields.$invalid\"><p class=\"help-block\" ng-show=\"editForm.customFields.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"12000\">Ce champ ne peut pas dépasser 12000 caractères.</p><p class=\"help-block\" ng-show=\"editForm.customFields.$error.pattern\" translate=\"entity.validation.pattern\">Format invalide.</p></div></div></div><jhi-alert-error></jhi-alert-error></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Annuler</span></button> <button type=\"button\" ng-click=\"vm.save()\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Enregistrer</span></button></div></form>");
$templateCache.put("app/business/global-expense-type/global-expense-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.globalExpenseType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.globalExpenseType.delete.question\" translate-values=\"{id: \'{{vm.globalExpenseType.id}}\'}\">Are you sure you want to delete this GlobalExpenseType?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/global-expense-type/global-expense-type-detail.html","<div><h2><span translate=\"wamasysApp.globalExpenseType.detail.title\">GlobalExpenseType</span> {{vm.globalExpenseType.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.globalExpenseType.label\">Libelle</span></dt><dd><span>{{vm.globalExpenseType.label}}<span></span></span></dd><hr><dt><span translate=\"global.field.isDeleted\">isDeleted</span></dt><dd><span>{{vm.globalExpenseType.deleted}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/global-expense-type/global-expense-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myGlobalExpenseTypeLabel\" translate=\"wamasysApp.globalExpenseType.home.createOrEditLabel\">Create or edit a GlobalExpenseType</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!--         <div class=\"form-group\">\r\n            <label for=\"id\" translate=\"global.field.id\">ID</label>\r\n            <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"\r\n                    ng-model=\"vm.globalExpenseType.id\" readonly />\r\n        </div> --><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.globalExpenseType.label\" for=\"field_label\">Libelle</label><input type=\"text\" class=\"form-control\" name=\"label\" id=\"field_label\" ng-model=\"vm.globalExpenseType.label\" required ng-maxlength=\"50\"><div ng-show=\"editForm.label.$invalid\"><p class=\"help-block\" ng-show=\"editForm.label.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.label.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.globalExpenseType.id\"><label class=\"control-deleted\" translate=\"global.field.isDeleted\" for=\"field_deleted\">deleted</label><input type=\"checkbox\" class=\"form-control\" name=\"deleted\" id=\"field_deleted\" ng-model=\"vm.globalExpenseType.deleted\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/global-expense-type/global-expense-types.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.globalExpenseType.home.title\">GlobalExpenseTypes</span> <small class=\"text-muted\" translate=\"global.configurationScope.organization\">Paramétrage commun à toute l\'organisation</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"global-expense-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.globalExpenseType.home.createLabel\">Create new GlobalExpenseType</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"label\"><span translate=\"wamasysApp.globalExpenseType.label\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deleted\"><span translate=\"global.field.isDeleted\">isDeleted</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"globalExpenseType in vm.globalExpenseTypes track by globalExpenseType.id\"><td><a ui-sref=\"global-expense-type-detail({id:globalExpenseType.id})\">{{globalExpenseType.id}}</a></td><td>{{globalExpenseType.label}}</td><td>{{globalExpenseType.deleted}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"global-expense-type-detail({id:globalExpenseType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"global-expense-type.edit({id:globalExpenseType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"global-expense-type.delete({id:globalExpenseType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/equipment-parc/equipment-android.html","<div class=\"equipment-page\"><div ng-include=\"\'app/business/equipment-parc/equipment-header.html\'\"></div><div class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</div><div ng-if=\"!vm.moduleDisabled\"><div ng-if=\"vm.tab === \'android\'\"><p>{{\'wamasysApp.equipmentParc.text.devices_already_registered_in_wamasys_importing_creates_an_it_record\' | translate}}</p><button class=\"btn btn-default\" ng-click=\"vm.refreshAndroid()\">{{\'wamasysApp.equipmentParc.text.refresh_list\' | translate}}</button><table class=\"table table-striped\"><thead><tr><th>{{\'wamasysApp.equipmentParc.text.model\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.user\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.wamasys_version\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.last_report\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.installation_active\' | translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"a in vm.android track by a.id\"><td>{{a.model || (\'wamasysApp.equipmentParc.text.android_device\' | translate)}}</td><td>{{a.user}}</td><td>{{a.version}}</td><td>{{a.lastSeen | date:\'medium\'}}</td><td>{{a.active ? (\'wamasysApp.equipmentParc.text.yes\' | translate) : (\'wamasysApp.equipmentParc.text.no\' | translate)}}</td><td><button ng-if=\"vm.canEdit\" class=\"btn btn-primary btn-sm\" ng-click=\"vm.importAndroid(a)\">{{\'wamasysApp.equipmentParc.text.import_or_refresh\' | translate}}</button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/business/equipment-parc/equipment-collector-packages.html","<!-- Les autorisations de préparation sont distinctes des téléchargements du collecteur. --><h4 translate=\"wamasysApp.equipmentParc.it.downloads\"></h4><table class=\"table table-condensed\"><thead><tr><th translate=\"wamasysApp.equipmentParc.text.extra_agency\"></th><th translate=\"wamasysApp.equipmentParc.text.extra_area\"></th><th translate=\"wamasysApp.equipmentParc.text.user\"></th><th translate=\"wamasysApp.equipmentParc.it.validUntil\"></th><th translate=\"wamasysApp.equipmentParc.it.lastUse\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"pack in vm.packages | filter:{workstationSetup: (vm.itTab === \'workstation\')} track by pack.id\"><td>{{vm.name(vm.meta.owners, pack.ownerEntiteParenteId)}}</td><td>{{vm.name(vm.meta.areas, pack.areaId)}}</td><td>{{pack.createdBy}}</td><td>{{pack.expiresAt | date:\'medium\'}}</td><td>{{pack.lastUsedAt | date:\'medium\'}}</td><td><span ng-if=\"pack.revokedAt\" translate=\"wamasysApp.equipmentParc.it.revoked\"></span><button ng-if=\"vm.canEdit &amp;&amp; !pack.revokedAt\" class=\"btn btn-default btn-xs\" ng-click=\"vm.revokePackage(pack)\" translate=\"wamasysApp.equipmentParc.it.revokeDownload\"></button></td></tr></tbody></table>");
$templateCache.put("app/business/equipment-parc/equipment-configuration.html","<div class=\"equipment-page\"><div ng-include=\"\'app/business/equipment-parc/equipment-header.html\'\"></div><div class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</div><div ng-if=\"!vm.moduleDisabled\"><div ng-if=\"vm.tab === \'configuration\'\"><ul class=\"nav nav-tabs equipment-local-tabs\"><li ng-class=\"{active:vm.configurationTab===\'types\'}\"><a href=\"\" ng-click=\"vm.configurationTab=\'types\'\" translate=\"wamasysApp.equipmentParc.text.equipment_types\"></a></li><li ng-class=\"{active:vm.configurationTab===\'locations\'}\"><a href=\"\" ng-click=\"vm.configurationTab=\'locations\'\" translate=\"wamasysApp.equipmentParc.text.extra_locations\"></a></li><li ng-class=\"{active:vm.configurationTab===\'categories\'}\"><a href=\"\" ng-click=\"vm.configurationTab=\'categories\'\" translate=\"wamasysApp.equipmentParc.text.consumable_categories\"></a></li></ul><section class=\"equipment-tab-body\" ng-if=\"vm.configurationTab===\'types\'\"><h3>{{\'wamasysApp.equipmentParc.text.equipment_types\' | translate}}</h3><p><button class=\"btn btn-primary\" ng-if=\"vm.isAdmin\" ng-click=\"vm.typeForm()\">{{\'wamasysApp.equipmentParc.text.add_a_type\' | translate}}</button></p><table class=\"table table-striped\"><thead><tr><th>{{\'wamasysApp.equipmentParc.text.code\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.wording\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.family\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.active\' | translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"t in vm.meta.types track by t.id\"><td>{{t.code}}</td><td>{{t.label}}</td><td>{{vm.label(t.family)}}</td><td>{{t.active ? (\'wamasysApp.equipmentParc.text.yes\' | translate) : (\'wamasysApp.equipmentParc.text.no\' | translate)}}</td><td><button ng-if=\"vm.isAdmin\" class=\"btn btn-default btn-sm\" ng-click=\"vm.typeForm(t)\">{{\'wamasysApp.equipmentParc.text.edit\' | translate}}</button></td></tr></tbody></table></section><section class=\"equipment-tab-body\" ng-if=\"vm.configurationTab===\'locations\'\"><h3>{{\'wamasysApp.equipmentParc.text.extra_locations\' | translate}}</h3><p><button class=\"btn btn-primary\" ng-if=\"vm.canEdit\" ng-click=\"vm.locationForm()\">{{\'wamasysApp.equipmentParc.text.add_a_location\' | translate}}</button></p><table class=\"table table-striped\"><thead><tr><th>{{\'wamasysApp.equipmentParc.text.code\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.wording\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.category\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.extra_agency\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.extra_area\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.active\' | translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"l in vm.meta.locations track by l.id\"><td>{{l.code}}</td><td>{{l.label}}</td><td>{{vm.label(l.locationType)}}</td><td>{{vm.name(vm.meta.owners, l.entiteParenteId)}}</td><td>{{vm.name(vm.meta.areas, l.areaId)}}</td><td>{{l.active ? (\'wamasysApp.equipmentParc.text.yes\' | translate) : (\'wamasysApp.equipmentParc.text.no\' | translate)}}</td><td><button ng-if=\"vm.canEdit\" class=\"btn btn-default btn-sm\" ng-click=\"vm.locationForm(l)\">{{\'wamasysApp.equipmentParc.text.edit\' | translate}}</button></td></tr></tbody></table></section><section class=\"equipment-tab-body\" ng-if=\"vm.configurationTab===\'categories\'\"><h3 translate=\"wamasysApp.equipmentParc.text.consumable_categories\"></h3><p><button class=\"btn btn-primary\" ng-if=\"vm.canEdit\" ng-click=\"vm.categoryForm()\" translate=\"wamasysApp.equipmentParc.text.add_consumable_category\"></button></p><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.text.consumable_categories_help\"></p><table class=\"table table-striped\"><thead><tr><th translate=\"wamasysApp.equipmentParc.text.wording\"></th><th translate=\"wamasysApp.equipmentParc.text.active\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"category in vm.meta.consumableCategories | orderBy:\'label\' track by category.id\"><td>{{category.label}}</td><td>{{category.active ? (\'wamasysApp.equipmentParc.text.yes\' | translate) : (\'wamasysApp.equipmentParc.text.no\' | translate)}}</td><td><button class=\"btn btn-default btn-sm\" ng-if=\"vm.canEdit\" ng-click=\"vm.categoryForm(category)\" translate=\"wamasysApp.equipmentParc.text.edit\"></button></td></tr></tbody></table></section></div></div></div>");
$templateCache.put("app/business/equipment-parc/equipment-dashboard.html","<div class=\"equipment-page\"><div ng-include=\"\'app/business/equipment-parc/equipment-header.html\'\"></div><div ng-if=\"!vm.moduleDisabled\"><p class=\"alert alert-danger\" ng-if=\"vm.error\">{{vm.error}}</p><div class=\"row\"><div class=\"col-sm-4 form-group\"><label translate=\"wamasysApp.equipmentParc.text.owning_agency\"></label><select class=\"form-control\" ng-model=\"vm.filter.ownerId\" ng-options=\"owner.id as owner.label for owner in vm.meta.owners\" ng-change=\"vm.changeOwner()\"><option value=\"\" translate=\"wamasysApp.equipmentParc.dashboard.allAgencies\"></option></select></div><div class=\"col-sm-4 form-group\"><label>AREA</label><select class=\"form-control\" ng-model=\"vm.filter.areaId\" ng-options=\"area.id as area.label for area in vm.areas()\" ng-change=\"vm.load()\"><option value=\"\" translate=\"wamasysApp.equipmentParc.map.allAreas\"></option></select></div><div class=\"col-sm-4 form-group\"><label translate=\"wamasysApp.equipmentParc.text.type\"></label><select class=\"form-control\" ng-model=\"vm.selectedType\" ng-options=\"type.id as type.label for type in vm.typeOptions\" ng-change=\"vm.changeType()\"><option value=\"\" translate=\"wamasysApp.equipmentParc.physical.allTypes\"></option></select></div><div class=\"col-sm-12\" style=\"padding-bottom:15px\"><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.physical.typeScope\"></p><button class=\"btn btn-default\" ng-disabled=\"vm.loading\" ng-click=\"vm.load()\" translate=\"wamasysApp.equipmentParc.text.refresh\"></button></div></div><p class=\"text-muted\">{{vm.data.asOf | date:\'medium\'}}</p><div class=\"row\"><div class=\"col-sm-3\"><div class=\"well\"><h3>{{vm.data.total || 0}}</h3><span translate=\"wamasysApp.equipmentParc.text.equipment\"></span></div></div><div class=\"col-sm-3\"><div class=\"well\"><h3>{{vm.data.borrowed || 0}}</h3><span translate=\"wamasysApp.equipmentParc.dashboard.borrowed\"></span></div></div><div class=\"col-sm-3\"><div class=\"well text-danger\"><h3>{{vm.data.maintenanceDue || 0}}</h3><span translate=\"wamasysApp.equipmentParc.dashboard.due\"></span></div></div><div class=\"col-sm-3\"><div class=\"well text-danger\"><h3>{{vm.data.lowStockCount || 0}}</h3><span translate=\"wamasysApp.equipmentParc.dashboard.lowStock\"></span></div></div></div><section class=\"panel panel-default\"><div class=\"panel-heading\"><h3 class=\"panel-title\" translate=\"wamasysApp.equipmentParc.ui.typeReport\"></h3></div><div class=\"table-responsive\"><table class=\"table equipment-report\"><thead><tr><th translate=\"wamasysApp.equipmentParc.text.type\"></th><th translate=\"wamasysApp.equipmentParc.ui.total\"></th><th translate=\"wamasysApp.equipmentParc.text.status\"></th><th translate=\"wamasysApp.equipmentParc.text.physical_condition\"></th></tr></thead><tbody><tr ng-repeat=\"row in vm.reportRows()\"><td><strong>{{vm.typeName(row)}}</strong></td><td><strong>{{row.total}}</strong></td><td><span class=\"equipment-stat\" ng-repeat=\"status in vm.meta.statuses\" ng-if=\"row.statuses[status]\">{{(\'wamasysApp.equipmentParc.dashboard.statuses.\'+status) | translate}} <strong>{{row.statuses[status]}}</strong></span></td><td><span class=\"equipment-stat\" ng-repeat=\"condition in vm.meta.conditions\" ng-if=\"row.conditions[condition]\">{{(\'wamasysApp.equipmentParc.dashboard.conditions.\'+condition) | translate}} <strong>{{row.conditions[condition]}}</strong></span></td></tr><tr ng-if=\"!vm.data.byType.length\"><td colspan=\"4\" translate=\"wamasysApp.equipmentParc.ui.noEquipment\"></td></tr></tbody></table></div></section><div class=\"row equipment-dashboard-panels\"><div class=\"col-md-6\"><section class=\"panel panel-info\"><div class=\"panel-heading\"><h3 class=\"panel-title\"><i class=\"fa fa-wrench\"></i> <span translate=\"wamasysApp.equipmentParc.dashboard.maintenance\"></span><span class=\"badge pull-right\">{{vm.data.maintenanceCount || 0}}</span></h3></div><div class=\"panel-body\"><p>{{vm.data.maintenanceCount || 0}} <span translate=\"wamasysApp.equipmentParc.dashboard.next30\"></span></p><table class=\"table table-striped\"><thead><tr><th translate=\"wamasysApp.equipmentParc.text.equipment\"></th><th translate=\"wamasysApp.equipmentParc.text.operation\"></th><th translate=\"wamasysApp.equipmentParc.text.next_due_date\"></th></tr></thead><tbody><tr ng-repeat=\"plan in vm.data.maintenance\" ng-class=\"{\'text-danger\': plan.overdue}\"><td><a ui-sref=\"equipment-parc({equipmentId:plan.equipmentId})\">{{plan.inventoryCode}} · {{plan.equipmentLabel}}</a></td><td>{{plan.label}}</td><td>{{plan.dueDate | date:\'shortDate\'}}</td></tr></tbody></table><p class=\"text-muted\" ng-if=\"!vm.data.maintenance.length\" translate=\"wamasysApp.equipmentParc.ui.noMaintenance\"></p></div></section></div><div class=\"col-md-6\"><section class=\"panel panel-warning\"><div class=\"panel-heading\"><h3 class=\"panel-title\"><i class=\"fa fa-exclamation-triangle\"></i> <span translate=\"wamasysApp.equipmentParc.dashboard.lowStock\"></span><span class=\"badge pull-right\">{{vm.data.lowStockCount || 0}}</span></h3></div><div class=\"panel-body\"><p>{{vm.data.stockPositions || 0}} <span translate=\"wamasysApp.equipmentParc.dashboard.stockPositions\"></span> · <a ui-sref=\"equipment-consumables\" translate=\"wamasysApp.equipmentParc.text.consumables_and_stock\"></a></p><table class=\"table table-striped\"><thead><tr><th translate=\"wamasysApp.equipmentParc.text.item\"></th><th translate=\"wamasysApp.equipmentParc.text.location\"></th><th translate=\"wamasysApp.equipmentParc.text.quantity\"></th><th translate=\"wamasysApp.equipmentParc.text.alert_threshold\"></th></tr></thead><tbody><tr ng-repeat=\"row in vm.data.stockAlerts\"><td>{{row.label}}</td><td>{{row.location}}</td><td>{{row.quantity}} {{row.unit}}</td><td>{{row.minimum}} {{row.unit}}</td></tr></tbody></table><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.dashboard.limit\"></p><p class=\"text-muted\" ng-if=\"!vm.data.stockAlerts.length\" translate=\"wamasysApp.equipmentParc.ui.noStockAlert\"></p></div></section></div></div><h3 translate=\"wamasysApp.equipmentParc.dashboard.activity\"></h3><table class=\"table table-striped\"><tbody><tr ng-repeat=\"activity in vm.data.activities\"><td>{{activity.date | date:\'medium\'}}</td><td>{{activity.actor}}</td><td><a ng-if=\"activity.equipmentId\" ui-sref=\"equipment-parc({equipmentId:activity.equipmentId})\">{{activity.label}}</a><span ng-if=\"!activity.equipmentId\">{{activity.label}} · {{vm.operationLabel(activity.operationType)}}</span></td><td>{{vm.message(activity.reason)}}</td></tr></tbody></table><p>{{vm.data.fileCount || 0}} <span translate=\"wamasysApp.equipmentParc.dashboard.files\"></span> · {{vm.data.fileSizeBytes / 1048576 | number:2}} <span translate=\"wamasysApp.equipmentParc.media.megabytes\"></span></p></div></div>");
$templateCache.put("app/business/equipment-parc/equipment-header.html","<header class=\"equipment-page-heading\"><h2><i class=\"fa fa-cubes\"></i> {{vm.pageTitle | translate}}</h2><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.text.field_equipment_tools_it_devices_and_consumables_within_your_authorised\"></p></header>");
$templateCache.put("app/business/equipment-parc/equipment-import.html","<div class=\"equipment-page\"><div ng-include=\"\'app/business/equipment-parc/equipment-header.html\'\"></div><p class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</p><p translate=\"wamasysApp.equipmentParc.evolution.importHelp\"></p><p><button class=\"btn btn-default\" ng-click=\"vm.template()\" translate=\"wamasysApp.equipmentParc.evolution.downloadTemplate\"></button></p><fieldset ng-disabled=\"vm.busy || vm.reading || !vm.canEdit\"><div class=\"row\"><div class=\"col-sm-6 form-group\"><label for=\"import-owner\" translate=\"wamasysApp.equipmentParc.evolution.defaultOwner\"></label><select id=\"import-owner\" class=\"form-control\" ng-model=\"vm.request.ownerId\" ng-options=\"owner.id as owner.label for owner in vm.meta.owners\" ng-change=\"vm.scopeChanged()\"><option value=\"\"></option></select></div><div class=\"col-sm-6 form-group\"><label for=\"import-area\" translate=\"wamasysApp.equipmentParc.evolution.defaultArea\"></label><select id=\"import-area\" class=\"form-control\" ng-model=\"vm.request.areaId\" ng-options=\"area.id as area.label for area in vm.areas()\" ng-change=\"vm.invalidate()\"><option value=\"\"></option></select></div><div class=\"col-sm-6 form-group\"><label for=\"import-kind\" translate=\"wamasysApp.equipmentParc.evolution.csvKind\"></label><select id=\"import-kind\" class=\"form-control\" ng-model=\"vm.request.kind\" ng-options=\"kind for kind in vm.kinds\" ng-change=\"vm.invalidate()\"></select></div></div><button class=\"btn btn-default\" ngf-select=\"vm.choose($files)\" ngf-accept=\"\'.xlsx,.xls,.csv\'\" translate=\"wamasysApp.equipmentParc.evolution.chooseFile\"></button> {{vm.request.fileName}} <button class=\"btn btn-primary\" ng-click=\"vm.inspect()\" ng-disabled=\"!vm.request.contentBase64\" translate=\"wamasysApp.equipmentParc.evolution.previewImport\"></button></fieldset><div ng-if=\"vm.preview.valid\"><h3 translate=\"wamasysApp.equipmentParc.evolution.previewImport\"></h3><p>{{vm.preview.count}} <span translate=\"wamasysApp.equipmentParc.evolution.importRows\"></span></p><div class=\"table-responsive\" style=\"max-height:400px;overflow:auto\"><table class=\"table table-striped\"><thead><tr><th translate=\"wamasysApp.equipmentParc.evolution.sheet\"></th><th translate=\"wamasysApp.equipmentParc.evolution.line\"></th><th translate=\"wamasysApp.equipmentParc.text.code\"></th><th translate=\"wamasysApp.equipmentParc.evolution.action\"></th></tr></thead><tbody><tr ng-repeat=\"row in vm.preview.rows track by $index\"><td>{{row.sheet}}</td><td>{{row.line}}</td><td>{{row.code}}</td><td>{{(\'wamasysApp.equipmentParc.evolution.\' + row.action) | translate}}</td></tr></tbody></table></div><button class=\"btn btn-success\" ng-click=\"vm.confirm()\" ng-disabled=\"vm.busy\" translate=\"wamasysApp.equipmentParc.evolution.confirmImport\"></button></div><p class=\"alert alert-success\" ng-if=\"vm.done\">{{\'wamasysApp.equipmentParc.evolution.importDone\' | translate}} {{vm.done.count}}</p></div>");
$templateCache.put("app/business/equipment-parc/equipment-inventories.html","<div class=\"equipment-page equipment-inventories\"><div ng-include=\"\'app/business/equipment-parc/equipment-header.html\'\"></div><p class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</p><form ng-if=\"vm.newPlan\" name=\"planForm\" ng-submit=\"vm.savePlan()\" class=\"panel panel-default\"><div class=\"panel-heading\"><h3 class=\"panel-title\">{{vm.tr(\'plan\')}}</h3></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-6 form-group\"><label>{{vm.tr(\'label\')}}</label><input class=\"form-control\" ng-model=\"vm.newPlan.label\" maxlength=\"200\" required></div><div class=\"col-sm-3 form-group\"><label>{{vm.tr(\'date\')}}</label><input class=\"form-control\" type=\"date\" ng-model=\"vm.newPlan.inventoryDate\" required></div><div class=\"col-sm-3 form-group\"><label>{{vm.tr(\'nextDate\')}}</label><input class=\"form-control\" type=\"date\" ng-model=\"vm.newPlan.nextInventoryDate\"></div><div class=\"col-sm-6 form-group\"><label>AREA</label><select class=\"form-control\" ng-model=\"vm.newPlan.areaId\" ng-options=\"area.id as area.label for area in vm.meta.areas\" ng-change=\"vm.newPlan.locationId=null\" required><option value=\"\">{{vm.tr(\'choose\')}}</option></select></div><div class=\"col-sm-6 form-group\"><label>{{vm.tr(\'location\')}}</label><select class=\"form-control\" ng-model=\"vm.newPlan.locationId\" ng-options=\"location.id as location.label for location in vm.locations(vm.newPlan.areaId)\"><option value=\"\">{{vm.tr(\'allLocations\')}}</option></select></div><div class=\"col-sm-6 form-group\"><label>{{vm.tr(\'responsible\')}}</label><select class=\"form-control\" ng-model=\"vm.newPlan.responsibleLogin\" ng-options=\"user.login as user.label for user in vm.participants\" ng-change=\"vm.newPlan.validatorLogin===vm.newPlan.responsibleLogin && (vm.newPlan.validatorLogin=null)\" required><option value=\"\">{{vm.tr(\'chooseUser\')}}</option></select></div><div class=\"col-sm-6 form-group\"><label>{{vm.tr(\'validator\')}}</label><select class=\"form-control\" ng-model=\"vm.newPlan.validatorLogin\" ng-options=\"user.login as user.label for user in vm.validators()\" required><option value=\"\">{{vm.tr(\'chooseUser\')}}</option></select></div><p class=\"col-sm-12 text-muted\">{{vm.tr(\'participantsHelp\')}}</p><div class=\"col-sm-12\"><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"vm.newPlan.includeEquipment\">{{vm.tr(\'equipment\')}}</label><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"vm.newPlan.includeConsumables\">{{vm.tr(\'consumables\')}}</label></div></div></div><div class=\"panel-footer\"><button class=\"btn btn-primary\" ng-disabled=\"vm.busy || planForm.$invalid\">{{vm.tr(\'save\')}}</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.newPlan=null\">{{vm.tr(\'cancel\')}}</button></div></form><div ng-if=\"!vm.current\" class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"equipment-toolbar\"><div class=\"form-group\"><label>AREA</label><select class=\"form-control\" ng-model=\"vm.areaId\" ng-options=\"area.id as area.label for area in vm.meta.areas\" ng-change=\"vm.listPage=0;vm.load()\"><option value=\"\">{{vm.tr(\'allAreas\')}}</option></select></div><button class=\"btn btn-primary\" ng-if=\"vm.meta.canEdit\" ng-disabled=\"vm.busy\" ng-click=\"vm.plan()\"><i class=\"fa fa-plus\"></i> {{vm.tr(\'plan\')}}</button></div><p class=\"text-muted\">{{vm.tr(\'help\')}}</p><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th>{{vm.tr(\'label\')}}</th><th>{{vm.tr(\'date\')}}</th><th>AREA / {{vm.tr(\'location\')}}</th><th>{{vm.tr(\'responsible\')}}</th><th>{{vm.tr(\'validator\')}}</th><th>{{vm.tr(\'status\')}}</th><th>{{vm.tr(\'nextDate\')}}</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items track by item.id\"><td><a href=\"\" ng-click=\"vm.open(item.id)\">{{item.label}}</a></td><td>{{item.inventoryDate | date:\'shortDate\'}}</td><td>{{vm.name(vm.meta.areas,item.areaId)}}<br><small>{{item.locationId ? vm.name(vm.meta.locations,item.locationId) : vm.tr(\'allLocations\')}}</small></td><td>{{vm.userName(item.responsibleLogin)}}</td><td>{{vm.userName(item.validatorLogin)}}</td><td>{{vm.status(item.status)}}</td><td>{{item.nextInventoryDate | date:\'shortDate\'}}</td></tr></tbody></table></div><button class=\"btn btn-default\" ng-disabled=\"vm.busy || !vm.listPage\" ng-click=\"vm.pageList(-1)\">{{vm.tr(\'previous\')}}</button> {{vm.listPage+1}} · {{vm.total}} <button class=\"btn btn-default\" ng-disabled=\"vm.busy || (vm.listPage+1)*50>=vm.total\" ng-click=\"vm.pageList(1)\">{{vm.tr(\'next\')}}</button></div></div><div ng-if=\"vm.current\"><div class=\"equipment-toolbar\"><button class=\"btn btn-default\" ng-click=\"vm.back()\" ng-disabled=\"vm.busy || vm.hasEdits()\"><i class=\"fa fa-arrow-left\"></i> {{vm.tr(\'back\')}}</button><button class=\"btn btn-default\" ng-click=\"vm.exportCsv()\" ng-disabled=\"vm.busy || vm.hasEdits()\"><i class=\"fa fa-download\"></i> CSV</button></div><section class=\"panel panel-default\"><div class=\"panel-heading equipment-toolbar\"><h3 class=\"panel-title\">{{vm.current.label}}</h3><span class=\"label label-info\">{{vm.status(vm.current.status)}}</span></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-4\"><dl><dt>{{vm.tr(\'date\')}}</dt><dd>{{vm.current.inventoryDate | date:\'shortDate\'}}</dd><dt>AREA / {{vm.tr(\'location\')}}</dt><dd>{{vm.name(vm.meta.areas,vm.current.areaId)}} · {{vm.current.locationId ? vm.name(vm.meta.locations,vm.current.locationId) : vm.tr(\'allLocations\')}}</dd></dl></div><div class=\"col-sm-4\"><dl><dt>{{vm.tr(\'responsible\')}}</dt><dd>{{vm.userName(vm.current.responsibleLogin)}}</dd><dt>{{vm.tr(\'validator\')}}</dt><dd>{{vm.userName(vm.current.validatorLogin)}}</dd></dl></div><div class=\"col-sm-4\"><dl><dt>{{vm.tr(\'captured\')}}</dt><dd>{{(vm.current.capturedAt | date:\'medium\') || \'—\'}}</dd><dt>{{vm.tr(\'nextDate\')}}</dt><dd>{{(vm.current.nextInventoryDate | date:\'shortDate\') || \'—\'}}</dd></dl></div></div><div class=\"equipment-progress\"><strong>{{vm.summary.countedCount}} / {{vm.summary.lineCount}}</strong> {{vm.tr(\'countedLines\')}} <span>{{vm.summary.differenceCount}} {{vm.tr(\'differences\')}}</span><span>{{vm.summary.unvaluedCount}} {{vm.tr(\'unvalued\')}}</span></div></div></section><section class=\"panel panel-default\"><div class=\"panel-heading\"><h3 class=\"panel-title\">{{vm.tr(\'actions\')}}</h3></div><div class=\"panel-body\"><div ng-if=\"vm.current.status===\'DRAFT\' && vm.canCount()\"><button class=\"btn btn-default\" ng-disabled=\"vm.busy\" ng-click=\"vm.plan(vm.current)\">{{vm.tr(\'editPlan\')}}</button> <button class=\"btn btn-primary\" ng-disabled=\"vm.busy || vm.hasEdits()\" ng-click=\"vm.transition(\'start\')\">{{vm.tr(\'start\')}}</button></div><div ng-if=\"vm.current.status===\'COUNTING\' && vm.canCount()\"><button class=\"btn btn-primary\" ng-disabled=\"vm.busy || vm.hasEdits() || vm.summary.countedCount!==vm.summary.lineCount || !vm.summary.lineCount\" ng-click=\"vm.transition(\'submit\')\">{{vm.tr(\'submit\')}}</button><p class=\"help-block\">{{vm.tr(\'submitHelp\')}}</p></div><div ng-if=\"vm.current.status===\'REVIEW\' && vm.canValidate()\"><label><input type=\"checkbox\" ng-model=\"vm.applyStockAdjustments\"> {{vm.tr(\'applyStock\')}}</label><p class=\"text-muted\">{{vm.tr(\'stockHelp\')}}</p><button class=\"btn btn-success\" ng-disabled=\"vm.busy || vm.hasEdits()\" ng-click=\"vm.transition(\'validate\')\">{{vm.tr(\'validate\')}}</button> <button class=\"btn btn-warning\" ng-disabled=\"vm.busy || vm.hasEdits() || !vm.actionComment\" ng-click=\"vm.transition(\'reopen\')\">{{vm.tr(\'reopen\')}}</button></div><details class=\"equipment-secondary-action\" ng-if=\"(vm.canCount() || vm.canValidate()) && vm.current.status!==\'VALIDATED\' && vm.current.status!==\'CANCELLED\'\"><summary>{{vm.tr(\'actionComment\')}}</summary><div class=\"form-group\"><label>{{vm.tr(\'actionComment\')}}</label><textarea class=\"form-control\" ng-model=\"vm.actionComment\" maxlength=\"2000\"></textarea></div><button ng-if=\"vm.canCount()\" class=\"btn btn-danger btn-sm\" ng-disabled=\"vm.busy || vm.hasEdits() || !vm.actionComment\" ng-click=\"vm.transition(\'cancel\')\">{{vm.tr(\'cancelInventory\')}}</button></details><p class=\"alert alert-success\" ng-if=\"vm.current.status===\'VALIDATED\'\">{{vm.tr(\'frozen\')}} {{vm.current.validatedBy}} · {{vm.current.validatedAt | date:\'medium\'}} <span ng-if=\"vm.current.stockAdjusted\">{{vm.tr(\'stockApplied\')}}</span></p></div></section><section class=\"panel panel-default\" ng-if=\"vm.current.status!==\'DRAFT\'\"><div class=\"panel-heading\"><h3 class=\"panel-title\">{{vm.tr(\'counting\')}}</h3></div><div class=\"panel-body\"><div class=\"row equipment-filters\"><div class=\"col-sm-4 form-group\"><label>{{vm.tr(\'lineKind\')}}</label><select class=\"form-control\" ng-model=\"vm.kind\" ng-disabled=\"vm.busy || vm.hasEdits()\" ng-change=\"vm.filterLines()\"><option value=\"\">{{vm.tr(\'all\')}}</option><option value=\"EQUIPMENT\">{{vm.tr(\'equipment\')}}</option><option value=\"CONSUMABLE\">{{vm.tr(\'consumables\')}}</option></select></div><div class=\"col-sm-4 form-group\"><label>{{vm.tr(\'location\')}}</label><select class=\"form-control\" ng-model=\"vm.lineLocationId\" ng-options=\"location.id as (location.label || vm.tr(\'noLocation\')) for location in vm.lineLocations\" ng-disabled=\"vm.busy || vm.hasEdits()\" ng-change=\"vm.filterLines()\"><option value=\"\">{{vm.tr(\'allLocations\')}}</option></select></div><div class=\"col-sm-4 form-group\"><label>{{vm.tr(\'type\')}}</label><select class=\"form-control\" ng-model=\"vm.lineType\" ng-options=\"type as vm.typeLabel(type) for type in vm.lineTypes\" ng-disabled=\"vm.busy || vm.hasEdits()\" ng-change=\"vm.filterLines()\"><option value=\"\">{{vm.tr(\'allTypes\')}}</option></select></div></div><p class=\"alert alert-warning\" ng-if=\"vm.hasEdits()\">{{vm.tr(\'unsaved\')}}</p><article class=\"equipment-count-line\" ng-repeat=\"line in vm.rows track by line.id\" ng-class=\"{\'equipment-count-line-dirty\':vm.lineDirty(line)}\"><div class=\"equipment-toolbar equipment-line-heading\"><div><strong>{{line.label}}</strong><span class=\"equipment-line-code\">{{line.code}}</span><p class=\"text-muted\">{{line.locationLabel || vm.tr(\'noLocation\')}} · {{line.typeLabel ? vm.typeLabel(line.typeLabel) : (line.kind===\'EQUIPMENT\' ? vm.tr(\'equipment\') : vm.tr(\'consumables\'))}}</p></div><span class=\"label label-default\">{{line.kind===\'EQUIPMENT\' ? vm.tr(\'equipment\') : vm.tr(\'consumables\')}}</span></div><div class=\"row\" ng-if=\"vm.current.status===\'COUNTING\' && vm.canCount()\"><div class=\"col-sm-2 form-group\"><label>{{vm.tr(\'counted\')}}</label><input type=\"number\" ng-model-options=\"{allowInvalid:true}\" min=\"0\" ng-attr-max=\"{{line.kind===\'EQUIPMENT\' ? 1 : undefined}}\" ng-attr-step=\"{{line.kind===\'EQUIPMENT\' ? 1 : 0.0001}}\" class=\"form-control\" ng-model=\"line.edit.countedQuantity\" ng-change=\"line.saveError=null;line.feedback=null\"><p class=\"help-block\">{{vm.tr(\'expected\')}} : {{line.expectedQuantity}} {{line.unit===\'unit\' ? vm.tr(\'unit\') : line.unit}}</p></div><div class=\"col-sm-2 form-group\" ng-if=\"line.kind===\'EQUIPMENT\'\"><label>{{vm.tr(\'condition\')}}</label><select class=\"form-control\" ng-model=\"line.edit.observedCondition\" ng-change=\"line.saveError=null;line.feedback=null\" ng-options=\"condition as vm.condition(condition) for condition in vm.meta.conditions\"><option value=\"\">{{vm.tr(\'choose\')}}</option></select></div><div class=\"col-sm-2 form-group\" ng-if=\"line.kind===\'CONSUMABLE\'\"><label>{{vm.tr(\'unitValue\')}}</label><input type=\"number\" ng-model-options=\"{allowInvalid:true}\" min=\"0\" step=\"0.0001\" class=\"form-control\" ng-model=\"line.edit.unitValue\" ng-change=\"line.saveError=null;line.feedback=null\"><input class=\"form-control\" ng-model=\"line.edit.currency\" ng-change=\"line.saveError=null;line.feedback=null\" maxlength=\"10\" placeholder=\"EUR, XOF…\" aria-label=\"{{vm.tr(\'currency\')}}\"></div><div class=\"col-sm-3 form-group\"><label>{{vm.tr(\'adjustmentReason\')}}</label><select class=\"form-control\" ng-model=\"line.edit.adjustmentReason\" ng-change=\"line.saveError=null;line.feedback=null\" ng-options=\"reason as vm.reason(reason) for reason in vm.meta.adjustmentReasons\"><option value=\"\">—</option></select></div><div class=\"col-sm-5 form-group\"><label>{{vm.tr(\'comment\')}}</label><textarea class=\"form-control\" maxlength=\"2000\" rows=\"2\" ng-model=\"line.edit.comment\" ng-change=\"line.saveError=null;line.feedback=null\"></textarea></div></div><p ng-if=\"vm.current.status!==\'COUNTING\' || !vm.canCount()\">{{vm.tr(\'expected\')}} : <strong>{{line.expectedQuantity}}</strong> · {{vm.tr(\'counted\')}} : <strong>{{line.countedQuantity}}</strong> · {{vm.condition(line.observedCondition)}} · {{line.unitValue}} {{line.currency}}<br>{{vm.reason(line.adjustmentReason)}} · {{line.comment}}</p><div class=\"equipment-line-footer\"><div role=\"status\" aria-live=\"polite\"><span class=\"text-danger\" ng-if=\"line.saveError\">{{line.saveError}}</span><span class=\"text-warning\" ng-if=\"!line.saveError && vm.lineDirty(line) && vm.lineIssue(line)\">{{vm.lineIssue(line)}}</span><span class=\"text-success\" ng-if=\"line.feedback && !vm.lineDirty(line)\"><i class=\"fa fa-check-circle\"></i> {{line.feedback}}</span><small class=\"text-muted\" ng-if=\"line.countedBy\">{{line.countedBy}} · {{line.countedAt | date:\'short\'}}</small></div><button ng-if=\"vm.current.status===\'COUNTING\' && vm.canCount()\" class=\"btn btn-primary\" ng-disabled=\"vm.busy\" ng-click=\"vm.saveLine(line)\">{{vm.tr(\'save\')}}</button></div></article><p class=\"text-muted\" ng-if=\"!vm.rows.length\">{{vm.tr(\'noLines\')}}</p><div class=\"equipment-toolbar\"><span>{{vm.linePage+1}} · {{vm.lineTotal}} {{vm.tr(\'lines\')}}</span><div><button class=\"btn btn-default\" ng-disabled=\"vm.busy || vm.hasEdits() || !vm.linePage\" ng-click=\"vm.pageLines(-1)\">{{vm.tr(\'previous\')}}</button> <button class=\"btn btn-default\" ng-disabled=\"vm.busy || vm.hasEdits() || (vm.linePage+1)*100>=vm.lineTotal\" ng-click=\"vm.pageLines(1)\">{{vm.tr(\'next\')}}</button></div></div><form ng-if=\"vm.current.status===\'COUNTING\' && vm.canCount() && vm.current.includeConsumables\" ng-submit=\"vm.addLine()\" name=\"extraForm\" class=\"well well-sm\"><h4>{{vm.tr(\'extra\')}}</h4><div class=\"row\"><div class=\"col-sm-5\"><select class=\"form-control\" ng-model=\"vm.extra.consumableId\" ng-options=\"c.id as (c.code+\' · \'+c.label) for c in vm.meta.consumables | filter:{active:true}\" required><option value=\"\">{{vm.tr(\'choose\')}}</option></select></div><div class=\"col-sm-5\"><select class=\"form-control\" ng-model=\"vm.extra.locationId\" ng-options=\"l.id as l.label for l in vm.locations(vm.current.areaId) | filter:(vm.current.locationId ? {id:vm.current.locationId} : {}):true\" required><option value=\"\">{{vm.tr(\'location\')}}</option></select></div><div class=\"col-sm-2\"><button class=\"btn btn-default\" ng-disabled=\"vm.busy || vm.hasEdits() || extraForm.$invalid\">{{vm.tr(\'add\')}}</button></div></div></form></div></section><section class=\"panel panel-default\"><div class=\"panel-heading\"><h3 class=\"panel-title\">{{vm.tr(\'valuation\')}}</h3></div><div class=\"panel-body\"><table class=\"table table-condensed\"><thead><tr><th>{{vm.tr(\'currency\')}}</th><th>{{vm.tr(\'expectedValue\')}}</th><th>{{vm.tr(\'countedValue\')}}</th><th>{{vm.tr(\'differenceValue\')}}</th></tr></thead><tbody><tr ng-repeat=\"(currency,values) in vm.summary.valuations\"><td>{{currency}}</td><td>{{values.expected | number:4}}</td><td>{{values.counted || 0 | number:4}}</td><td>{{(values.counted || 0)-values.expected | number:4}}</td></tr></tbody></table><p class=\"text-muted\">{{vm.tr(\'valuationHelp\')}}</p></div></section><details class=\"panel panel-default equipment-history\"><summary>{{vm.tr(\'history\')}}</summary><div class=\"panel-body\"><table class=\"table table-condensed\"><tbody><tr ng-repeat=\"event in vm.events track by event.id\"><td>{{event.occurredAt | date:\'medium\'}}</td><td>{{event.actor}}</td><td>{{vm.tr(\'events.\'+event.action)}}</td><td>{{event.comment}}</td></tr></tbody></table></div></details></div></div>");
$templateCache.put("app/business/equipment-parc/equipment-it-overview.html","<!-- Conserver les formulaires lors d’un changement d’onglet. --><section class=\"equipment-tab-body\" ng-show=\"vm.itTab === \'workstation\'\"><section ng-if=\"vm.canEdit &amp;&amp; vm.canSecrets\" ng-controller=\"EquipmentWorkstationController as ws\" ng-include=\"\'app/business/equipment-parc/equipment-workstation.html\'\"></section><p class=\"alert alert-info\" ng-if=\"!vm.canEdit || !vm.canSecrets\" translate=\"wamasysApp.equipmentParc.workstation.accessHelp\"></p><div ng-include=\"\'app/business/equipment-parc/equipment-collector-packages.html\'\"></div></section><section class=\"equipment-tab-body\" ng-show=\"vm.itTab === \'collector\'\"><p ng-if=\"vm.canEdit\"><button class=\"btn btn-primary\" ng-click=\"vm.downloadCollector(false)\" ng-disabled=\"vm.collectorBusy || !vm.meta.currentAreaId\"><i class=\"fa fa-windows\"></i> <span translate=\"wamasysApp.equipmentParc.it.downloadCollector\"></span></button> <button class=\"btn btn-default\" ng-click=\"vm.itOverview()\" translate=\"wamasysApp.equipmentParc.text.refresh\"></button></p><p><strong translate=\"wamasysApp.equipmentParc.text.extra_area\"></strong> : {{vm.name(vm.meta.areas, vm.meta.currentAreaId)}}</p><p translate=\"wamasysApp.equipmentParc.it.collectorHelp\"></p><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.it.loginHelp\"></p><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.it.launcherHelp\"></p><div ng-include=\"\'app/business/equipment-parc/equipment-collector-packages.html\'\"></div></section><section class=\"equipment-tab-body\" ng-show=\"vm.itTab === \'network\'\"><p ng-if=\"vm.canEdit\"><button class=\"btn btn-primary\" ng-click=\"vm.downloadCollector(true)\" ng-disabled=\"vm.collectorBusy || !vm.meta.currentAreaId\"><i class=\"fa fa-sitemap\"></i> <span translate=\"wamasysApp.equipmentParc.it.downloadNetwork\"></span></button> <button class=\"btn btn-default\" ng-click=\"vm.itOverview()\" translate=\"wamasysApp.equipmentParc.text.refresh\"></button></p><p><strong translate=\"wamasysApp.equipmentParc.text.extra_area\"></strong> : {{vm.name(vm.meta.areas, vm.meta.currentAreaId)}}</p><p translate=\"wamasysApp.equipmentParc.it.networkHelp\"></p><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.it.launcherHelp\"></p><section><h3 translate=\"wamasysApp.equipmentParc.it.discoveries\"></h3><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.it.discoveryHelp\"></p><table class=\"table table-striped\"><thead><tr><th translate=\"wamasysApp.equipmentParc.text.extra_area\"></th><th translate=\"wamasysApp.equipmentParc.text.ip_address\"></th><th translate=\"wamasysApp.equipmentParc.text.mac_address\"></th><th translate=\"wamasysApp.equipmentParc.it.hostname\"></th><th translate=\"wamasysApp.equipmentParc.it.suggestedType\"></th><th translate=\"wamasysApp.equipmentParc.it.lastContact\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"observation in vm.network\"><td>{{vm.name(vm.meta.areas, observation.areaId)}}</td><td>{{observation.ipAddress}}</td><td>{{observation.macAddress}}</td><td>{{observation.hostname}}</td><td>{{vm.itLabel(observation.suggestedType)}}</td><td>{{observation.lastSeenAt | date:\'medium\'}}</td><td><button class=\"btn btn-default btn-sm\" ng-if=\"observation.importedEquipmentId\" ng-click=\"vm.select(observation.importedEquipmentId)\" translate=\"wamasysApp.equipmentParc.text.open_record\"></button><button class=\"btn btn-primary btn-sm\" ng-if=\"vm.canEdit &amp;&amp; !observation.importedEquipmentId\" ng-click=\"vm.importNetwork(observation)\" translate=\"wamasysApp.equipmentParc.it.confirmDiscovery\"></button></td></tr></tbody></table></section></section>");
$templateCache.put("app/business/equipment-parc/equipment-labels.html","<div class=\"equipment-page\"><div ng-include=\"\'app/business/equipment-parc/equipment-header.html\'\"></div><div class=\"alert alert-danger\" ng-if=\"vm.error\">{{vm.error}}</div><div ng-if=\"!vm.moduleDisabled\"><p class=\"alert alert-success\" role=\"status\" ng-if=\"vm.notice\">{{vm.notice}}</p><p class=\"alert alert-info\">{{\'wamasysApp.equipmentParc.text.barcodes_open_the_record_in_the_android_app_select_items\' | translate}}</p><ol class=\"equipment-print-steps\"><li ng-class=\"{active:vm.labelStep===\'selection\'}\"><span>1</span> {{\'wamasysApp.equipmentParc.ui.chooseLabels\' | translate}}</li><li ng-class=\"{active:vm.labelStep===\'preview\'}\"><span>2</span> {{\'wamasysApp.equipmentParc.ui.previewFormat\' | translate}}</li><li ng-class=\"{active:vm.printOpened}\"><span>3</span> {{\'wamasysApp.equipmentParc.text.extra_print\' | translate}}</li></ol><section ng-show=\"vm.labelStep===\'selection\'\" class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"btn-group\" style=\"margin-bottom: 16px\"><button class=\"btn btn-default\" ng-class=\"{active: vm.mode === \'ITEMS\'}\" ng-click=\"vm.changeMode(\'ITEMS\')\" translate=\"wamasysApp.equipmentParc.storage.items\"></button><button class=\"btn btn-default\" ng-class=\"{active: vm.mode === \'STORAGE\'}\" ng-click=\"vm.changeMode(\'STORAGE\')\" translate=\"wamasysApp.equipmentParc.storage.title\"></button></div><div ng-if=\"vm.mode === \'ITEMS\'\"><div class=\"row\"><div class=\"col-sm-6 form-group\"><label>{{\'wamasysApp.equipmentParc.text.search_for_equipment_or_a_consumable\' | translate}}</label><input class=\"form-control\" ng-model=\"vm.search\" type=\"search\"></div><div class=\"col-sm-6 form-group\"><label>{{\'wamasysApp.equipmentParc.text.labels\' | translate}}</label><div><button class=\"btn btn-primary\" ng-click=\"vm.preview()\" ng-disabled=\"vm.busy\"><i class=\"fa fa-barcode\" aria-hidden=\"true\"></i> {{\'wamasysApp.equipmentParc.text.preview_labels\' | translate}}</button></div></div></div><p><button class=\"btn btn-default btn-sm\" ng-click=\"vm.selectVisible(true)\">{{\'wamasysApp.equipmentParc.text.select_results\' | translate}}</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.selectVisible(false)\">{{\'wamasysApp.equipmentParc.text.deselect_results\' | translate}}</button> <span>{{vm.count()}} {{\'wamasysApp.equipmentParc.text.item_s_selected\' | translate}}</span></p><div class=\"row\"><div class=\"col-md-6\"><h3>{{\'wamasysApp.equipmentParc.text.equipment\' | translate}}</h3><div style=\"max-height: 340px; overflow: auto\"><table class=\"table table-striped\"><thead><tr><th></th><th>{{\'wamasysApp.equipmentParc.text.code\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.description_156\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"item in vm.equipment | filter:vm.matches track by item.id\"><td><input type=\"checkbox\" ng-model=\"vm.selected[\'EQUIPMENT:\' + item.id]\"></td><td>{{item.inventoryCode}}</td><td>{{item.label}}</td></tr></tbody></table></div></div><div class=\"col-md-6\"><h3>{{\'wamasysApp.equipmentParc.text.consumables\' | translate}}</h3><div style=\"max-height: 340px; overflow: auto\"><table class=\"table table-striped\"><thead><tr><th></th><th>{{\'wamasysApp.equipmentParc.text.code\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.description_156\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"item in vm.consumables | filter:vm.matches track by item.id\"><td><input type=\"checkbox\" ng-model=\"vm.selected[\'CONSUMABLE:\' + item.id]\"></td><td>{{item.code}}</td><td>{{item.label}}</td></tr></tbody></table></div></div></div></div><div ng-if=\"vm.mode === \'STORAGE\'\"><p class=\"alert alert-info\" translate=\"wamasysApp.equipmentParc.storage.help\"></p><div class=\"row\"><div class=\"col-sm-6 form-group\"><label translate=\"wamasysApp.equipmentParc.text.location\"></label><select class=\"form-control\" ng-model=\"vm.storage.locationId\" ng-options=\"location.id as location.label for location in vm.locations\"><option value=\"\" translate=\"wamasysApp.equipmentParc.storage.allLocations\"></option></select></div><div class=\"col-sm-6\"><label style=\"display:block\" translate=\"wamasysApp.equipmentParc.storage.levels\"></label><label ng-repeat=\"level in vm.levels\" style=\"margin-right:12px\"><input type=\"checkbox\" ng-model=\"vm.storage.levels[level]\"> {{vm.levelName(level)}}</label></div></div><p><label><input type=\"checkbox\" ng-model=\"vm.storage.includeStockSettings\"> <span translate=\"wamasysApp.equipmentParc.storage.fromStock\"></span></label>·<label><input type=\"checkbox\" ng-model=\"vm.storage.onlyUnprinted\"> <span translate=\"wamasysApp.equipmentParc.storage.onlyNew\"></span></label></p><h4 translate=\"wamasysApp.equipmentParc.storage.manual\"></h4><div class=\"row\"><div class=\"col-sm-2 form-group\" ng-repeat=\"level in vm.levels\"><label>{{vm.levelName(level)}}</label><input class=\"form-control\" maxlength=\"60\" ng-model=\"vm.path[vm.levelKeys[level]]\"></div><div class=\"col-sm-2\" style=\"padding-top:25px\"><button class=\"btn btn-default\" ng-click=\"vm.addPath()\" translate=\"wamasysApp.equipmentParc.storage.addPath\"></button></div></div><ul><li ng-repeat=\"path in vm.storage.paths track by $index\">{{vm.describePath(path)}} <button class=\"btn btn-link btn-xs\" ng-click=\"vm.storage.paths.splice($index,1)\" translate=\"wamasysApp.equipmentParc.storage.remove\"></button></li></ul><p><button class=\"btn btn-primary\" ng-disabled=\"vm.busy || !vm.canEdit\" ng-click=\"vm.preview()\"><i class=\"fa fa-barcode\" aria-hidden=\"true\"></i> <span translate=\"wamasysApp.equipmentParc.text.preview_labels\"></span></button></p><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.storage.printConfirmationHelp\"></p></div></div></section><section ng-if=\"vm.labelStep===\'preview\'\" class=\"panel panel-default\"><div class=\"panel-heading equipment-toolbar\"><h3 class=\"panel-title\" translate=\"wamasysApp.equipmentParc.text.label_preview\"></h3><button class=\"btn btn-default btn-sm\" ng-click=\"vm.labelStep=\'selection\'\" translate=\"wamasysApp.equipmentParc.ui.changeSelection\"></button></div><div class=\"panel-body\"><fieldset class=\"well well-sm\"><legend style=\"font-size:16px\" translate=\"wamasysApp.equipmentParc.storage.format\"></legend><div class=\"row\"><div class=\"col-sm-2\"><label translate=\"wamasysApp.equipmentParc.storage.copies\"></label><input class=\"form-control\" type=\"number\" min=\"1\" max=\"50\" ng-model=\"vm.copies\"></div><div class=\"col-sm-2\"><label translate=\"wamasysApp.equipmentParc.storage.width\"></label><input class=\"form-control\" type=\"number\" min=\"20\" max=\"190\" ng-model=\"vm.format.width\"></div><div class=\"col-sm-2\"><label translate=\"wamasysApp.equipmentParc.storage.height\"></label><input class=\"form-control\" type=\"number\" min=\"20\" max=\"150\" ng-model=\"vm.format.height\"></div><div class=\"col-sm-2\"><label translate=\"wamasysApp.equipmentParc.storage.font\"></label><input class=\"form-control\" type=\"number\" min=\"6\" max=\"32\" ng-model=\"vm.format.font\"></div><div class=\"col-sm-4\" style=\"padding-top:26px\"><label><input type=\"checkbox\" ng-model=\"vm.format.showBarcode\"> <span translate=\"wamasysApp.equipmentParc.storage.barcode\"></span></label></div></div></fieldset><p ng-if=\"vm.labels.length\">{{\'wamasysApp.equipmentParc.storage.printHelp\' | translate}}</p><div style=\"display:flex; flex-wrap:wrap; gap:10px\"><div ng-repeat=\"label in vm.labels track by $index\" ng-style=\"{width:vm.format.width+\'mm\',minHeight:vm.format.height+\'mm\',fontSize:vm.format.font+\'pt\'}\" style=\"max-width:100%; border:1px solid #ddd; padding:6px; text-align:center; overflow-wrap:anywhere\"><label><input type=\"checkbox\" ng-model=\"label.selected\"> <strong>{{label.code}}</strong></label><div style=\"font-size:80%\">{{label.label}}</div><img ng-if=\"vm.format.showBarcode\" ng-src=\"{{label.image}}\" style=\"width:100%; height:50px\" alt=\"{{label.value}}\"><small ng-if=\"vm.format.showBarcode\">{{label.value}}</small><div style=\"font-size:75%\">{{\'wamasysApp.equipmentParc.storage.copies\' | translate}} : {{vm.copies}}</div></div></div><div class=\"equipment-toolbar equipment-print-footer\"><span>{{vm.selectedLabels().length}} {{\'wamasysApp.equipmentParc.text.item_s_selected\' | translate}}</span><button class=\"btn btn-primary\" ng-click=\"vm.print()\" ng-disabled=\"!vm.selectedLabels().length\"><i class=\"fa fa-print\" aria-hidden=\"true\"></i> {{\'wamasysApp.equipmentParc.text.extra_print\' | translate}}</button></div><div class=\"alert alert-info\" ng-if=\"vm.mode===\'STORAGE\' && vm.printOpened\"><p translate=\"wamasysApp.equipmentParc.storage.printConfirmationHelp\"></p><button class=\"btn btn-success\" ng-disabled=\"vm.busy || vm.marked || !vm.selectedLabels().length || !vm.canEdit\" ng-click=\"vm.markPrinted()\" translate=\"wamasysApp.equipmentParc.storage.markPrinted\"></button></div></div></section></div></div>");
$templateCache.put("app/business/equipment-parc/equipment-license-key.html","<div class=\"modal-header\"><h3 translate=\"wamasysApp.equipmentParc.licenses.reveal\"></h3></div><div class=\"modal-body\"><p translate=\"wamasysApp.equipmentParc.secrets.audited\"></p><label translate=\"wamasysApp.equipmentParc.licenses.key\"></label><input class=\"form-control\" ng-attr-type=\"{{secret.visible ? \'text\' : \'password\'}}\" readonly=\"readonly\" ng-model=\"secret.password\" autocomplete=\"off\"><label><input type=\"checkbox\" ng-model=\"secret.visible\"> <span translate=\"wamasysApp.equipmentParc.secrets.show\"></span></label></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"secret.close()\" translate=\"wamasysApp.equipmentParc.text.close\"></button></div>");
$templateCache.put("app/business/equipment-parc/equipment-licenses.html","<section class=\"panel panel-default\" style=\"margin-top:24px\"><div class=\"panel-heading\"><h3 class=\"panel-title\" translate=\"wamasysApp.equipmentParc.licenses.title\"></h3></div><div class=\"panel-body\"><p translate=\"wamasysApp.equipmentParc.licenses.help\"></p><p><button class=\"btn btn-primary\" ng-if=\"vm.canEdit\" ng-click=\"vm.licenseForm()\" translate=\"wamasysApp.equipmentParc.licenses.add\"></button> <button class=\"btn btn-default\" ng-click=\"vm.loadLicenses()\" ng-disabled=\"vm.licenseBusy\" translate=\"wamasysApp.equipmentParc.text.refresh\"></button></p><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"wamasysApp.equipmentParc.licenses.product\"></th><th translate=\"wamasysApp.equipmentParc.licenses.reference\"></th><th translate=\"wamasysApp.equipmentParc.text.extra_agency\"></th><th translate=\"wamasysApp.equipmentParc.text.extra_area\"></th><th translate=\"wamasysApp.equipmentParc.licenses.availability\"></th><th translate=\"wamasysApp.equipmentParc.licenses.computers\"></th><th translate=\"wamasysApp.equipmentParc.licenses.expiresAt\"></th><th translate=\"wamasysApp.equipmentParc.licenses.key\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"row in vm.licenses track by row.license.id\"><td>{{row.license.product}}</td><td>{{row.license.reference}}</td><td>{{vm.name(vm.meta.owners, row.license.ownerEntiteParenteId)}}</td><td>{{vm.name(vm.meta.areas, row.license.areaId)}}</td><td>{{row.availableSeats}} / {{row.license.seats}} <span class=\"text-danger\" ng-if=\"row.expired\" translate=\"wamasysApp.equipmentParc.licenses.expired\"></span></td><td><div ng-repeat=\"assignment in row.assignments track by assignment.id\"><a href=\"\" ng-click=\"vm.select(assignment.equipmentId)\">{{assignment.inventoryCode}} — {{assignment.label}}</a> <button class=\"btn btn-default btn-xs\" ng-if=\"vm.canEdit\" ng-click=\"vm.releaseLicense(row, assignment)\" translate=\"wamasysApp.equipmentParc.licenses.release\"></button></div></td><td>{{row.license.expiresAt | date:\'shortDate\'}}</td><td><span translate=\"{{row.hasKey ? \'wamasysApp.equipmentParc.licenses.keySaved\' : \'wamasysApp.equipmentParc.licenses.noKey\'}}\"></span><button class=\"btn btn-default btn-xs\" ng-if=\"vm.canSecrets &amp;&amp; row.hasKey\" ng-click=\"vm.revealLicense(row)\" translate=\"wamasysApp.equipmentParc.licenses.reveal\"></button></td><td><button class=\"btn btn-default btn-sm\" ng-if=\"vm.canEdit\" ng-click=\"vm.licenseForm(row)\" translate=\"wamasysApp.equipmentParc.text.edit\"></button> <button class=\"btn btn-primary btn-sm\" ng-if=\"vm.canEdit &amp;&amp; row.availableSeats &gt; 0 &amp;&amp; !row.expired\" ng-click=\"vm.assignLicense(row)\" translate=\"wamasysApp.equipmentParc.licenses.assign\"></button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.licenseHistory(row)\" translate=\"wamasysApp.equipmentParc.text.historic\"></button></td></tr></tbody></table></div><p><button class=\"btn btn-default\" ng-disabled=\"vm.licensePage === 0 || vm.licenseBusy\" ng-click=\"vm.licensePage = vm.licensePage - 1; vm.loadLicenses()\" translate=\"wamasysApp.equipmentParc.text.previous\"></button> {{vm.licensePage + 1}} <button class=\"btn btn-default\" ng-disabled=\"(vm.licensePage + 1) * 25 &gt;= vm.licenseTotal || vm.licenseBusy\" ng-click=\"vm.licensePage = vm.licensePage + 1; vm.loadLicenses()\" translate=\"wamasysApp.equipmentParc.text.next\"></button></p><div ng-if=\"vm.licenseEvents\"><h4 translate=\"wamasysApp.equipmentParc.licenses.history\"></h4><table class=\"table table-condensed\"><thead><tr><th translate=\"wamasysApp.equipmentParc.text.extra_date\"></th><th translate=\"wamasysApp.equipmentParc.text.user\"></th><th translate=\"wamasysApp.equipmentParc.text.action\"></th><th translate=\"wamasysApp.equipmentParc.licenses.computers\"></th></tr></thead><tbody><tr ng-repeat=\"event in vm.licenseEvents track by event.id\"><td>{{event.occurredAt | date:\'medium\'}}</td><td>{{event.createdBy}}</td><td>{{(\'wamasysApp.equipmentParc.licenses.actions.\' + event.action) | translate}}</td><td><a href=\"\" ng-if=\"event.equipmentId\" ng-click=\"vm.select(event.equipmentId)\">#{{event.equipmentId}}</a></td></tr></tbody></table></div></div></section>");
$templateCache.put("app/business/equipment-parc/equipment-map.html","<style>.equipment-map-modal .modal-dialog{width:94%;max-width:1440px}.equipment-map-modal .modal-body{padding-top:12px}.equipment-map-legend{display:inline-block;width:14px;height:14px;border-radius:50%;margin-right:5px;vertical-align:middle;border:2px solid #fff;box-shadow:0 0 1px #555}</style><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.close()\" aria-label=\"{{\'wamasysApp.equipmentParc.map.close\' | translate}}\">&times;</button><h3 class=\"modal-title\"><i class=\"fa fa-map-marker\"></i> <span translate=\"wamasysApp.equipmentParc.map.title\"></span></h3></div><div class=\"modal-body\"><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.map.help\"></p><p class=\"alert alert-info\" ng-if=\"vm.loading\"><i class=\"fa fa-spinner fa-spin\"></i> <span translate=\"wamasysApp.equipmentParc.map.loading\"></span> {{vm.loaded}}</p><div class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</div><div ng-if=\"vm.ready\"><div class=\"row\"><div class=\"col-sm-4 form-group\"><label for=\"equipment-map-area\">AREA</label><select id=\"equipment-map-area\" class=\"form-control\" ng-model=\"vm.areaId\" ng-options=\"area.id as area.label for area in vm.areas\" ng-change=\"vm.render(true)\"><option value=\"\" translate=\"wamasysApp.equipmentParc.map.allAreas\"></option></select></div><div class=\"col-sm-8\" style=\"padding-top:27px\"><label style=\"margin-right:18px\"><input type=\"checkbox\" ng-model=\"vm.showAreas\" ng-change=\"vm.render(false)\"> <span translate=\"wamasysApp.equipmentParc.map.areaPositions\"></span></label><label style=\"margin-right:18px\"><input type=\"checkbox\" ng-model=\"vm.showZones\" ng-change=\"vm.render(false)\"> <span translate=\"wamasysApp.equipmentParc.map.areaZones\"></span></label><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.fit()\"><i class=\"fa fa-crosshairs\"></i> <span translate=\"wamasysApp.equipmentParc.map.fit\"></span></button></div></div><p><span class=\"equipment-map-legend\" style=\"background:#d9534f\"></span><span translate=\"wamasysApp.equipmentParc.map.equipment\"></span> · <span class=\"equipment-map-legend\" style=\"background:#64748b\"></span><span translate=\"wamasysApp.equipmentParc.map.areas\"></span> · {{vm.located}} / {{vm.total}} <span translate=\"wamasysApp.equipmentParc.map.located\"></span></p><p class=\"text-muted\" ng-if=\"vm.total > vm.located\">{{vm.total - vm.located}} <span translate=\"wamasysApp.equipmentParc.map.withoutPosition\"></span></p><p class=\"alert alert-warning\" ng-if=\"vm.invalidZones\">{{vm.invalidZones}} <span translate=\"wamasysApp.equipmentParc.map.invalidZones\"></span></p><leaflet id=\"{{vm.mapId}}\" center=\"vm.center\" defaults=\"vm.defaults\" markers=\"vm.markers\" layers=\"vm.layers\" geojson=\"vm.geojson\" height=\"62vh\" width=\"100%\"></leaflet></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\" translate=\"wamasysApp.equipmentParc.map.close\"></button></div>");
$templateCache.put("app/business/equipment-parc/equipment-media.html","<section style=\"margin-top:16px\"><h4 translate=\"wamasysApp.equipmentParc.media.title\"></h4><p ng-if=\"$ctrl.stats\">{{$ctrl.stats.photoCount}} <span translate=\"wamasysApp.equipmentParc.media.photos\"></span> · {{$ctrl.stats.documentCount}} <span translate=\"wamasysApp.equipmentParc.media.documents\"></span> · {{$ctrl.stats.sizeBytes / 1048576 | number:2}} <span translate=\"wamasysApp.equipmentParc.media.megabytes\"></span></p><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.media.help\"></p><p class=\"alert alert-danger\" ng-if=\"$ctrl.error\">{{$ctrl.error}}</p><p ng-if=\"$ctrl.canEdit\"><button class=\"btn btn-primary\" ngf-select=\"$ctrl.upload($files, \'PHOTO\')\" ngf-accept=\"\'image/jpeg,image/png\'\" ng-disabled=\"$ctrl.busy\"><i class=\"fa fa-camera\"></i> <span translate=\"wamasysApp.equipmentParc.media.addPhoto\"></span></button> <button class=\"btn btn-default\" ngf-select=\"$ctrl.upload($files, \'DOCUMENT\')\" ng-disabled=\"$ctrl.busy\"><i class=\"fa fa-paperclip\"></i> <span translate=\"wamasysApp.equipmentParc.media.addDocument\"></span></button> <button class=\"btn btn-warning\" ng-if=\"$ctrl.pending && !$ctrl.busy\" ng-click=\"$ctrl.send()\" translate=\"wamasysApp.equipmentParc.media.retry\"></button></p><div class=\"row\"><div class=\"col-sm-4\" ng-repeat=\"file in $ctrl.items | filter:{kind:\'PHOTO\'} track by file.id\"><div class=\"thumbnail\"><img ng-if=\"$ctrl.images[file.id]\" ng-src=\"{{$ctrl.images[file.id]}}\" style=\"height:180px;width:100%;object-fit:contain\" alt=\"{{file.fileName}}\"><button ng-if=\"!$ctrl.images[file.id]\" class=\"btn btn-default\" ng-click=\"$ctrl.preview(file)\" translate=\"wamasysApp.equipmentParc.media.showPhoto\"></button><div class=\"caption\"><p style=\"overflow-wrap:anywhere\">{{file.fileName}}</p><button class=\"btn btn-default btn-sm\" ng-click=\"$ctrl.download(file)\" translate=\"wamasysApp.equipmentParc.media.download\"></button> <button ng-if=\"$ctrl.canEdit\" class=\"btn btn-danger btn-sm\" ng-disabled=\"$ctrl.busy\" ng-click=\"$ctrl.remove(file)\" translate=\"wamasysApp.equipmentParc.media.delete\"></button></div></div></div></div><table class=\"table table-striped\"><tbody><tr ng-repeat=\"file in $ctrl.items | filter:{kind:\'DOCUMENT\'} track by file.id\"><td><i class=\"fa fa-file-o\"></i> {{file.fileName}}</td><td>{{file.sizeBytes / 1024 | number:1}} <span translate=\"wamasysApp.equipmentParc.media.kilobytes\"></span></td><td><button class=\"btn btn-default btn-sm\" ng-click=\"$ctrl.download(file)\" translate=\"wamasysApp.equipmentParc.media.download\"></button> <button class=\"btn btn-danger btn-sm\" ng-if=\"$ctrl.canEdit\" ng-disabled=\"$ctrl.busy\" ng-click=\"$ctrl.remove(file)\" translate=\"wamasysApp.equipmentParc.media.delete\"></button></td></tr></tbody></table></section>");
$templateCache.put("app/business/equipment-parc/equipment-meters.html","<div class=\"equipment-page\"><div ng-include=\"\'app/business/equipment-parc/equipment-header.html\'\"></div><p class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</p><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.evolution.meterHelp\"></p><div ng-if=\"!vm.detail\"><form class=\"form-inline\" ng-submit=\"vm.page=0;vm.load()\"><label for=\"meter-kind\" translate=\"wamasysApp.equipmentParc.evolution.meterKind\"></label><select id=\"meter-kind\" class=\"form-control\" ng-model=\"vm.kind\" ng-change=\"vm.page=0;vm.load()\"><option value=\"INDIVIDUAL\">{{vm.tr(\'INDIVIDUAL\')}}</option><option value=\"BULK\">{{vm.tr(\'BULK\')}}</option></select><label for=\"meter-state\" translate=\"wamasysApp.equipmentParc.evolution.status\"></label><select id=\"meter-state\" class=\"form-control\" ng-model=\"vm.state\" ng-change=\"vm.page=0;vm.load()\"><option value=\"\" translate=\"wamasysApp.equipmentParc.text.all\"></option><option value=\"AVAILABLE\">{{vm.tr(\'AVAILABLE\')}}</option><option value=\"ACTIVE\">{{vm.tr(\'ACTIVE\')}}</option><option value=\"ARCHIVED\">{{vm.tr(\'ARCHIVED\')}}</option></select><label for=\"meter-search\" translate=\"wamasysApp.equipmentParc.text.search\"></label><input id=\"meter-search\" class=\"form-control\" ng-model=\"vm.search\"> <button class=\"btn btn-default\" type=\"submit\" ng-disabled=\"vm.loading\" translate=\"wamasysApp.equipmentParc.text.search\"></button></form><p>{{vm.total}} {{vm.tr(\'meters\')}}</p><table class=\"table table-striped\"><thead><tr><th translate=\"wamasysApp.equipmentParc.text.serial_number_360\"></th><th translate=\"wamasysApp.equipmentParc.evolution.status\"></th><th translate=\"wamasysApp.equipmentParc.text.installation\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"meter in vm.items track by meter.id\"><td>{{meter.serialNumber}}</td><td>{{vm.tr(meter.state)}}</td><td>{{meter.installationDate | date:\'shortDate\'}}</td><td><button class=\"btn btn-default\" ng-click=\"vm.select(meter)\" translate=\"wamasysApp.equipmentParc.text.open_record\"></button></td></tr></tbody></table><uib-pagination total-items=\"vm.total\" items-per-page=\"25\" ng-model=\"vm.pagination\" ng-init=\"vm.pagination=1\" ng-change=\"vm.page=vm.pagination-1;vm.load()\"></uib-pagination></div><div ng-if=\"vm.detail\"><button class=\"btn btn-default\" ng-click=\"vm.back()\" translate=\"wamasysApp.equipmentParc.evolution.back\"></button><h3>{{vm.meter.serialNumber}} · {{vm.tr(vm.meter.kind)}}</h3><p ng-if=\"vm.meter.kind === \'BULK\'\"><a ui-sref=\"bulk-meter-detail({id:vm.meter.id})\" translate=\"wamasysApp.equipmentParc.evolution.openMeter\"></a></p><p ng-if=\"vm.meter.kind === \'INDIVIDUAL\'\" has-any-authority=\"ROLE_DATA_OPERATOR,ROLE_AREA_MANAGEMENT,ROLE_READ_ONLY\"><a ui-sref=\"individual-meter-detail({id:vm.meter.id})\" translate=\"wamasysApp.equipmentParc.evolution.openMeter\"></a></p><uib-tabset><uib-tab heading=\"{{vm.tr(\'finance\')}}\"><form name=\"meterFinance\" ng-submit=\"vm.save()\" style=\"margin-top:15px\"><fieldset ng-disabled=\"!vm.canEdit || vm.busy\"><div class=\"row\"><div class=\"col-sm-6 form-group\"><label for=\"meter-location\">{{vm.tr(\'storageLocation\')}}</label><select id=\"meter-location\" class=\"form-control\" ng-model=\"vm.form.locationId\" ng-options=\"location.id as location.label for location in vm.locations()\"><option value=\"\"></option></select></div><div class=\"col-sm-6 form-group\"><label for=\"meter-acquisition\">{{vm.tr(\'acquisitionDate\')}}</label><input id=\"meter-acquisition\" type=\"date\" class=\"form-control\" ng-model=\"vm.form.acquisitionDate\"></div><div class=\"col-sm-6 form-group\"><label for=\"meter-warranty\">{{vm.tr(\'warrantyEndDate\')}}</label><input id=\"meter-warranty\" type=\"date\" class=\"form-control\" ng-model=\"vm.form.warrantyEndDate\"></div><div class=\"col-sm-6 form-group\"><label for=\"meter-price\">{{vm.tr(\'purchasePrice\')}}</label><input id=\"meter-price\" type=\"number\" min=\"0\" step=\"0.0001\" class=\"form-control\" ng-model=\"vm.form.purchasePrice\"></div><div class=\"col-sm-6 form-group\"><label for=\"meter-currency\">{{vm.tr(\'currency\')}}</label><input id=\"meter-currency\" class=\"form-control\" maxlength=\"10\" ng-model=\"vm.form.purchaseCurrency\"></div><div class=\"col-sm-6 form-group\"><label for=\"meter-months\">{{vm.tr(\'depreciationMonths\')}}</label><input id=\"meter-months\" type=\"number\" min=\"1\" max=\"1200\" class=\"form-control\" ng-model=\"vm.form.depreciationMonths\"></div><div class=\"col-sm-6 form-group\"><label for=\"meter-start\">{{vm.tr(\'depreciationStartDate\')}}</label><input id=\"meter-start\" type=\"date\" class=\"form-control\" ng-model=\"vm.form.depreciationStartDate\"></div><div class=\"col-sm-6 form-group\"><label for=\"meter-residual\">{{vm.tr(\'residualValue\')}}</label><input id=\"meter-residual\" type=\"number\" min=\"0\" step=\"0.0001\" class=\"form-control\" ng-model=\"vm.form.residualValue\"></div></div></fieldset><button ng-if=\"vm.canEdit\" type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.busy || meterFinance.$invalid\" translate=\"wamasysApp.equipmentParc.text.confirm\"></button></form><p ng-if=\"vm.detail.valuation.configured\">{{\'wamasysApp.equipmentParc.finance.netBookValue\' | translate}} : {{vm.detail.valuation.netBookValue | number:2}} {{vm.detail.valuation.currency}}</p><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.finance.help\"></p></uib-tab><uib-tab heading=\"{{vm.tr(\'maintenance\')}}\"><p ng-if=\"!vm.detail.profile\" translate=\"wamasysApp.equipmentParc.evolution.enableMeter\"></p><button class=\"btn btn-primary\" ng-if=\"!vm.detail.profile &amp;&amp; vm.canEdit\" ng-click=\"vm.save()\" ng-disabled=\"vm.busy\" translate=\"wamasysApp.equipmentParc.evolution.enableTracking\"></button><equipment-work-orders ng-if=\"vm.detail.profile\" meter-profile-id=\"vm.detail.profile.id\" detail=\"vm.detail\" can-edit=\"vm.canEdit\" reload=\"vm.reload()\"></equipment-work-orders></uib-tab></uib-tabset></div></div>");
$templateCache.put("app/business/equipment-parc/equipment-parc-dialog.html","<form name=\"equipmentForm\" ng-submit=\"form.submit()\" novalidate><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-disabled=\"form.busy\" ng-click=\"form.close()\">&times;</button><h3 class=\"modal-title\">{{form.title}}</h3></div><div class=\"modal-body\"><p class=\"alert alert-info\" ng-if=\"form.help\">{{form.help}}</p><p class=\"alert alert-danger\" role=\"alert\" ng-if=\"form.error\">{{form.error}}</p><div class=\"row\"><div class=\"col-sm-6\" ng-repeat=\"f in form.fields track by f.key\" ng-if=\"form.visible(f)\"><div class=\"form-group\" ng-switch=\"f.type\"><label for=\"equipment-field-{{f.key}}\">{{f.label}}<span ng-if=\"f.required\"> *</span></label><select ng-switch-when=\"select\" id=\"equipment-field-{{f.key}}\" class=\"form-control\" ng-model=\"form.model[f.key]\" ng-options=\"option.id as option.label for option in form.options(f)\" ng-change=\"form.change(f)\" ng-required=\"f.required\" ng-disabled=\"form.busy || f.disabled\"><option value=\"\">{{\'wamasysApp.equipmentParc.text.choose\' | translate}}</option></select><textarea ng-switch-when=\"textarea\" id=\"equipment-field-{{f.key}}\" class=\"form-control\" rows=\"3\" maxlength=\"20000\" ng-model=\"form.model[f.key]\" ng-required=\"f.required\" ng-disabled=\"form.busy || f.disabled\"></textarea><input ng-switch-when=\"checkbox\" id=\"equipment-field-{{f.key}}\" type=\"checkbox\" ng-model=\"form.model[f.key]\" ng-required=\"f.required\" ng-disabled=\"form.busy || f.disabled\"> <input ng-switch-when=\"date\" id=\"equipment-field-{{f.key}}\" type=\"date\" class=\"form-control\" ng-model=\"form.model[f.key]\" ng-required=\"f.required\" ng-disabled=\"form.busy || f.disabled\"> <input ng-switch-when=\"datetime-local\" id=\"equipment-field-{{f.key}}\" type=\"datetime-local\" class=\"form-control\" ng-model=\"form.model[f.key]\" ng-required=\"f.required\" ng-disabled=\"form.busy || f.disabled\"> <input ng-switch-when=\"number\" id=\"equipment-field-{{f.key}}\" type=\"number\" step=\"any\" class=\"form-control\" ng-model=\"form.model[f.key]\" ng-required=\"f.required\" ng-disabled=\"form.busy || f.disabled\"> <input ng-switch-when=\"password\" id=\"equipment-field-{{f.key}}\" type=\"password\" class=\"form-control\" ng-model=\"form.model[f.key]\" autocomplete=\"new-password\" maxlength=\"4096\" ng-required=\"f.required\" ng-disabled=\"form.busy || f.disabled\"> <input ng-switch-default id=\"equipment-field-{{f.key}}\" type=\"{{f.type}}\" step=\"any\" class=\"form-control\" ng-model=\"form.model[f.key]\" ng-required=\"f.required\" ng-disabled=\"form.busy || f.disabled\" maxlength=\"500\"></div></div></div><div ng-if=\"form.hasMap\"><h4>{{\'wamasysApp.equipmentParc.text.location_on_the_map\' | translate}}</h4><equipment-position model=\"form.model\"></equipment-position></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-disabled=\"form.busy\" ng-click=\"form.close()\">{{\'wamasysApp.equipmentParc.text.cancel\' | translate}}</button><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"form.busy || equipmentForm.$invalid\">{{form.busy ? (\'wamasysApp.equipmentParc.text.saving_172\' | translate) : (\'wamasysApp.equipmentParc.text.confirm\' | translate)}}</button></div></form>");
$templateCache.put("app/business/equipment-parc/equipment-parc.html","<div class=\"equipment-page\"><div ng-include=\"\'app/business/equipment-parc/equipment-header.html\'\"></div><div class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</div><div ng-if=\"!vm.moduleDisabled\"><ul class=\"nav nav-tabs equipment-local-tabs\" ng-if=\"vm.section === \'computers\' &amp;&amp; !vm.detail\"><li ng-class=\"{active:vm.itTab===\'equipment\'}\"><a href=\"\" ng-click=\"vm.itTab=\'equipment\'\" translate=\"wamasysApp.equipmentParc.it.tabs.equipment\"></a></li><li ng-class=\"{active:vm.itTab===\'workstation\'}\"><a href=\"\" ng-click=\"vm.itTab=\'workstation\'\" translate=\"wamasysApp.equipmentParc.it.tabs.workstation\"></a></li><li ng-class=\"{active:vm.itTab===\'collector\'}\"><a href=\"\" ng-click=\"vm.itTab=\'collector\'\" translate=\"wamasysApp.equipmentParc.it.tabs.collector\"></a></li><li ng-class=\"{active:vm.itTab===\'network\'}\"><a href=\"\" ng-click=\"vm.itTab=\'network\'\" translate=\"wamasysApp.equipmentParc.it.tabs.network\"></a></li></ul><div ng-if=\"vm.tab === \'equipment\' && !vm.detail\"><div ng-show=\"vm.section !== \'computers\' || vm.itTab === \'equipment\'\"><form class=\"row\" ng-submit=\"vm.page = 0; vm.load()\"><div class=\"col-sm-4 form-group\"><label for=\"equipment-search\">{{\'wamasysApp.equipmentParc.text.search\' | translate}}</label><input id=\"equipment-search\" class=\"form-control\" ng-model=\"vm.filter.search\" placeholder=\"{{\'wamasysApp.equipmentParc.text.description_code_or_serial_number\' | translate}}\"></div><div ng-if=\"vm.section !== \'computers\'\" class=\"col-sm-3 form-group\"><label for=\"equipment-family\">{{\'wamasysApp.equipmentParc.text.family\' | translate}}</label><select id=\"equipment-family\" class=\"form-control\" ng-model=\"vm.filter.family\" ng-disabled=\"vm.section === \'computers\'\" ng-options=\"v as vm.label(v) for v in vm.meta.families\"><option value=\"\">{{\'wamasysApp.equipmentParc.text.all_472\' | translate}}</option></select></div><div ng-if=\"vm.section === \'computers\'\" class=\"col-sm-3 form-group\"><label translate=\"wamasysApp.equipmentParc.it.type\"></label><select class=\"form-control\" ng-model=\"vm.filter.itType\" ng-options=\"type as vm.itLabel(type) for type in vm.meta.itTypes\"><option value=\"\" translate=\"wamasysApp.equipmentParc.text.all\"></option></select></div><div class=\"col-sm-3 form-group\"><label for=\"equipment-status\">{{\'wamasysApp.equipmentParc.text.status\' | translate}}</label><select id=\"equipment-status\" class=\"form-control\" ng-model=\"vm.filter.status\" ng-options=\"v as vm.label(v) for v in vm.meta.statuses\"><option value=\"\">{{\'wamasysApp.equipmentParc.text.all\' | translate}}</option></select></div><div class=\"col-sm-2 form-group\"><label>&nbsp;</label><button class=\"btn btn-default btn-block\" type=\"submit\" ng-disabled=\"vm.loading\">{{\'wamasysApp.equipmentParc.text.search_409\' | translate}}</button></div></form><div class=\"row\"><div class=\"col-sm-3 form-group\" ng-if=\"vm.section !== \'computers\'\"><label for=\"equipment-type\" translate=\"wamasysApp.equipmentParc.text.type\"></label><select id=\"equipment-type\" class=\"form-control\" ng-model=\"vm.filter.typeId\" ng-options=\"t.id as t.label for t in vm.meta.types\" ng-change=\"vm.page = 0; vm.load()\"><option value=\"\" translate=\"wamasysApp.equipmentParc.text.all\"></option></select></div><div class=\"col-sm-4 form-group\"><label for=\"equipment-assigned\">{{\'wamasysApp.equipmentParc.text.extra_assignment\' | translate}}</label><select id=\"equipment-assigned\" class=\"form-control\" ng-model=\"vm.filter.assigned\" ng-options=\"option.id as (option.label | translate) for option in vm.assignmentFilters\" ng-change=\"vm.page = 0; vm.load()\"><option value=\"\">{{\'wamasysApp.equipmentParc.text.all_472\' | translate}}</option></select></div><div class=\"col-sm-5 form-group\"><label style=\"margin-top: 30px\"><input type=\"checkbox\" ng-model=\"vm.filter.maintenanceDue\" ng-change=\"vm.page = 0; vm.load()\"> {{\'wamasysApp.equipmentParc.text.maintenance_due_today_or_overdue\' | translate}}</label></div></div><div class=\"clearfix\" style=\"margin-bottom: 15px\"><span>{{vm.total}} {{\'wamasysApp.equipmentParc.text.equipment_item_s\' | translate}}</span> <button type=\"button\" class=\"btn btn-default\" style=\"margin-left:12px\" ng-if=\"vm.section !== \'computers\'\" ng-click=\"vm.showMap()\"><i class=\"fa fa-map-marker\"></i> <span translate=\"wamasysApp.equipmentParc.map.view\"></span></button><button class=\"btn btn-primary pull-right\" ng-if=\"vm.canEdit\" ng-click=\"vm.equipmentForm()\"><span class=\"glyphicon glyphicon-plus\"></span> {{\'wamasysApp.equipmentParc.text.add_equipment\' | translate}}</button></div><p class=\"alert alert-info\" ng-if=\"vm.section !== \'computers\' && !vm.meta.types.length\">{{\'wamasysApp.equipmentParc.text.start_by_creating_an_equipment_type_on_the_types_and\' | translate}}</p><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th>{{\'wamasysApp.equipmentParc.text.code\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.description_156\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.type\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.location_destination\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.installation\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.current_holder\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.scheduled_maintenance\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.status_531\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.status\' | translate}}</th><th ng-if=\"vm.section === \'computers\'\" translate=\"wamasysApp.equipmentParc.it.lastContact\"></th></tr></thead><tbody><tr ng-repeat=\"e in vm.items track by e.id\"><td><a href=\"\" ng-click=\"vm.select(e.id)\">{{e.inventoryCode}}</a></td><td><a href=\"\" ng-click=\"vm.select(e.id)\">{{e.label}}</a></td><td>{{vm.equipmentType(e)}}</td><td>{{vm.currentLocation(e)}}</td><td>{{e.installationDate | date:\'shortDate\'}}</td><td>{{vm.currentHolder(e.id)}}</td><td ng-class=\"{\'text-danger\': vm.isLate(vm.nextMaintenance(e.id))}\">{{vm.nextMaintenance(e.id) | date:\'shortDate\'}}</td><td>{{vm.label(e.condition)}}</td><td>{{vm.label(e.operationalStatus)}}</td><td ng-if=\"vm.section === \'computers\'\">{{vm.lastSeen(e.id) | date:\'medium\'}}</td></tr><tr ng-if=\"!vm.loading && !vm.items.length\"><td colspan=\"9\">{{\'wamasysApp.equipmentParc.text.no_equipment_matches_your_search\' | translate}}</td></tr></tbody></table></div><div class=\"text-center\"><button class=\"btn btn-default\" ng-disabled=\"vm.page === 0 || vm.loading\" ng-click=\"vm.page = vm.page - 1; vm.load()\">{{\'wamasysApp.equipmentParc.text.previous\' | translate}}</button> <span>{{\'wamasysApp.equipmentParc.text.page\' | translate}} {{vm.page + 1}}</span> <button class=\"btn btn-default\" ng-disabled=\"(vm.page + 1) * 25 >= vm.total || vm.loading\" ng-click=\"vm.page = vm.page + 1; vm.load()\">{{\'wamasysApp.equipmentParc.text.next\' | translate}}</button></div><div ng-if=\"vm.section === \'computers\'\" ng-include=\"\'app/business/equipment-parc/equipment-licenses.html\'\"></div></div><div ng-if=\"vm.section === \'computers\'\" ng-include=\"\'app/business/equipment-parc/equipment-it-overview.html\'\"></div></div><div ng-if=\"vm.tab === \'equipment\' && vm.detail\"><div class=\"clearfix\"><button class=\"btn btn-default\" ng-click=\"vm.back()\"><span class=\"glyphicon glyphicon-arrow-left\"></span> {{\'wamasysApp.equipmentParc.text.equipment_list\' | translate}}</button><button class=\"btn btn-primary pull-right\" ng-if=\"vm.canEdit\" ng-click=\"vm.equipmentForm(vm.detail.equipment)\">{{\'wamasysApp.equipmentParc.text.edit_record\' | translate}}</button></div><div class=\"equipment-toolbar\"><h3>{{vm.detail.equipment.inventoryCode}} — {{vm.detail.equipment.label}}</h3><button type=\"button\" class=\"btn btn-link btn-sm\" ng-click=\"vm.showBarcode(\'EQUIPMENT\', vm.selectedId)\" title=\"{{\'wamasysApp.equipmentParc.text.view_barcode\' | translate}}\" aria-label=\"{{\'wamasysApp.equipmentParc.text.view_barcode\' | translate}}\"><i class=\"fa fa-barcode\" aria-hidden=\"true\"></i></button></div><div class=\"row\"><div class=\"col-sm-6\"><dl class=\"dl-horizontal\"><dt>{{\'wamasysApp.equipmentParc.text.type\' | translate}}</dt><dd>{{vm.equipmentType(vm.detail.equipment)}}</dd><dt>{{\'wamasysApp.equipmentParc.text.extra_agency\' | translate}}</dt><dd>{{vm.name(vm.meta.owners, vm.detail.equipment.ownerEntiteParenteId)}}</dd><dt>{{\'wamasysApp.equipmentParc.text.extra_area\' | translate}}</dt><dd>{{vm.name(vm.meta.areas, vm.detail.equipment.areaId)}}</dd><dt>{{\'wamasysApp.equipmentParc.text.storage_location\' | translate}}</dt><dd>{{vm.name(vm.meta.locations, vm.detail.equipment.locationId)}}</dd><dt>{{\'wamasysApp.equipmentParc.text.coordinates\' | translate}}</dt><dd>{{vm.detail.equipment.latitude != null ? vm.detail.equipment.latitude : \"—\"}}, {{vm.detail.equipment.longitude != null ? vm.detail.equipment.longitude : \"—\"}}</dd><dt>{{\'wamasysApp.equipmentParc.text.installation\' | translate}}</dt><dd>{{vm.detail.equipment.installationDate | date:\'shortDate\'}}</dd></dl></div><div class=\"col-sm-6\"><dl class=\"dl-horizontal\"><dt>{{\'wamasysApp.equipmentParc.text.physical_condition\' | translate}}</dt><dd>{{vm.label(vm.detail.equipment.condition)}}</dd><dt>{{\'wamasysApp.equipmentParc.text.status\' | translate}}</dt><dd>{{vm.label(vm.detail.equipment.operationalStatus)}}</dd><dt>{{\'wamasysApp.equipmentParc.text.brand_model\' | translate}}</dt><dd>{{vm.detail.equipment.brand}} {{vm.detail.equipment.model}}</dd><dt>{{\'wamasysApp.equipmentParc.text.serial_number_360\' | translate}}</dt><dd>{{vm.detail.equipment.serialNumber || \'—\'}}</dd><dt>{{\'wamasysApp.equipmentParc.text.acquisition\' | translate}}</dt><dd>{{vm.detail.equipment.acquisitionDate | date:\'shortDate\'}}</dd><dt>{{\'wamasysApp.equipmentParc.text.retirement\' | translate}}</dt><dd>{{vm.detail.equipment.retirementDate | date:\'shortDate\'}}</dd></dl></div></div><map-leaflet ng-if=\"vm.detailPosition.lat != null && vm.detailPosition.lon != null\" readonly=\"true\" contrat=\"vm.detailPosition\" height=\"320px\" width=\"100%\"></map-leaflet><p ng-if=\"vm.detail.equipment.oldIdentifier\"><strong translate=\"wamasysApp.equipmentParc.preparationHistory.oldIdentifier\"></strong> : {{vm.detail.equipment.oldIdentifier}}</p><p ng-if=\"vm.detail.device.platform === \'WINDOWS\'\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.preparationHistory()\" translate=\"wamasysApp.equipmentParc.preparationHistory.title\"></button></p><p ng-if=\"vm.detail.device.platform === \'WINDOWS\'\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.remoteActions()\" translate=\"wamasysApp.equipmentParc.remote.title\"></button></p><p style=\"white-space: pre-wrap\">{{vm.detail.equipment.comment}}</p><div class=\"well\" ng-if=\"vm.detail.equipment.purchasePrice != null\"><h4 translate=\"wamasysApp.equipmentParc.finance.title\"></h4><p>{{\'wamasysApp.equipmentParc.finance.purchasePrice\' | translate}} : {{vm.detail.equipment.purchasePrice | number:2}} {{vm.detail.equipment.purchaseCurrency}}</p><p ng-if=\"vm.detail.valuation.configured\">{{\'wamasysApp.equipmentParc.finance.netBookValue\' | translate}} : {{vm.detail.valuation.netBookValue | number:2}} {{vm.detail.valuation.currency}} · {{vm.detail.valuation.elapsedMonths}} / {{vm.detail.valuation.durationMonths}} {{\'wamasysApp.equipmentParc.finance.months\' | translate}}</p><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.finance.help\"></p></div><uib-tabset><uib-tab heading=\"{{\'wamasysApp.equipmentParc.text.work_orders\' | translate}}\"><equipment-work-orders equipment-id=\"vm.selectedId\" detail=\"vm.detail\" can-edit=\"vm.canEdit\" reload=\"vm.select(vm.selectedId)\" mode=\"interventions\"></equipment-work-orders><details ng-if=\"vm.detail.events.length\"><summary translate=\"wamasysApp.equipmentParc.evolution.legacy\"></summary><p ng-repeat=\"event in vm.detail.events track by event.id\"><a ui-sref=\"event-form-detail({id:event.eventFormId})\">{{event.title}} — n° {{event.eventFormId}}</a></p></details></uib-tab><uib-tab heading=\"{{\'wamasysApp.equipmentParc.text.loans_and_assignments\' | translate}}\"><p style=\"margin-top: 15px\"><button class=\"btn btn-primary\" ng-if=\"vm.canEdit\" ng-disabled=\"vm.hasAssignment() || vm.detail.equipment.operationalStatus !== \'IN_SERVICE\'\" ng-click=\"vm.loanForm()\">{{\'wamasysApp.equipmentParc.text.check_out_or_assign_equipment\' | translate}}</button></p><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th>{{\'wamasysApp.equipmentParc.text.beneficiary\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.type\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.destination\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.stock_out\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.expected_return\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.actual_return\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.return_condition\' | translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"a in vm.detail.assignments track by a.id\" ng-class=\"{danger: !a.endedAt && vm.isLate(a.expectedReturnAt)}\"><td>{{a.beneficiaryName}}</td><td>{{vm.label(a.assignmentType)}}</td><td>{{vm.name(vm.meta.locations, a.destinationLocationId)}} {{a.destinationDescription}}</td><td>{{a.startedAt | date:\'short\'}}</td><td>{{a.expectedReturnAt | date:\'short\'}}</td><td>{{a.endedAt | date:\'short\'}}</td><td>{{vm.label(a.conditionIn)}}</td><td><button class=\"btn btn-default btn-sm\" ng-if=\"vm.canEdit && !a.endedAt\" ng-click=\"vm.returnForm(a)\">{{\'wamasysApp.equipmentParc.text.record_return\' | translate}}</button></td></tr><tr ng-if=\"!vm.detail.assignments.length\"><td colspan=\"8\">{{\'wamasysApp.equipmentParc.text.no_allocation_recorded\' | translate}}</td></tr></tbody></table></div></uib-tab><uib-tab heading=\"{{\'wamasysApp.equipmentParc.text.maintenance\' | translate}}\"><equipment-work-orders equipment-id=\"vm.selectedId\" detail=\"vm.detail\" can-edit=\"vm.canEdit\" reload=\"vm.select(vm.selectedId)\" mode=\"plans\"></equipment-work-orders></uib-tab><uib-tab heading=\"{{\'wamasysApp.equipmentParc.text.it_configuration\' | translate}}\" ng-if=\"vm.detail.device\"><p ng-if=\"vm.canEdit &amp;&amp; (vm.detail.device.inventorySource === \'MANUAL\' || vm.detail.device.inventorySource === \'NETWORK_DISCOVERY\')\"><button class=\"btn btn-default\" ng-click=\"vm.manualDeviceForm()\" translate=\"wamasysApp.equipmentParc.it.manualInfo\"></button></p><div class=\"row\" style=\"margin-top: 15px\"><div class=\"col-sm-6\"><dl class=\"dl-horizontal\"><dt>{{\'wamasysApp.equipmentParc.text.platform\' | translate}}</dt><dd>{{vm.label(vm.detail.device.platform)}}</dd><dt>{{\'wamasysApp.equipmentParc.text.computer_name\' | translate}}</dt><dd>{{vm.detail.device.hostname || \'—\'}}</dd><dt>{{\'wamasysApp.equipmentParc.text.system\' | translate}}</dt><dd>{{vm.detail.device.osName}} {{vm.detail.device.osVersion}}</dd><dt>{{\'wamasysApp.equipmentParc.text.processor\' | translate}}</dt><dd>{{vm.detail.device.cpu || \'—\'}}</dd><dt>{{\'wamasysApp.equipmentParc.text.memory\' | translate}}</dt><dd>{{vm.detail.device.ramMb || \'—\'}} {{\'wamasysApp.equipmentParc.text.extra_mb\' | translate}}</dd></dl></div><div class=\"col-sm-6\"><dl class=\"dl-horizontal\"><dt>{{\'wamasysApp.equipmentParc.text.wamasys_version\' | translate}}</dt><dd>{{vm.detail.device.applicationVersion || \'—\'}}</dd><dt>{{\'wamasysApp.equipmentParc.text.last_inventory_collection\' | translate}}</dt><dd>{{vm.detail.device.lastCollectedAt | date:\'medium\'}}</dd><dt>{{\'wamasysApp.equipmentParc.text.last_received\' | translate}}</dt><dd>{{vm.detail.device.lastReceivedAt | date:\'medium\'}}</dd><dt>{{\'wamasysApp.equipmentParc.text.ip_observed_by_the_server\' | translate}}</dt><dd>{{vm.detail.device.observedPublicIp || \'—\'}}</dd></dl></div></div><table class=\"table table-condensed\" ng-if=\"vm.detail.disks.length\"><thead><tr><th>{{\'wamasysApp.equipmentParc.text.extra_disk\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.capacity_gib\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.free_space_gib\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"disk in vm.detail.disks track by $index\"><td>{{disk.name}}</td><td>{{disk.sizeBytes / 1073741824 | number:1}}</td><td>{{disk.freeBytes / 1073741824 | number:1}}</td></tr></tbody></table><p class=\"text-muted\">{{\'wamasysApp.equipmentParc.text.these_addresses_come_from_the_last_complete_inventory_report_they\' | translate}}</p><table class=\"table table-condensed\"><thead><tr><th>{{\'wamasysApp.equipmentParc.text.interface\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.mac_address\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.ip_address\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.prefix\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.gateway\' | translate}}</th><th translate=\"wamasysApp.equipmentParc.it.dnsServers\"></th></tr></thead><tbody ng-repeat=\"network in vm.detail.interfaces track by network.id\"><tr ng-repeat=\"address in network.addresses track by address.id\"><td>{{network.name}}</td><td>{{network.macAddress || \'—\'}}</td><td>{{address.ipAddress}}</td><td>{{address.prefixLength}}</td><td>{{address.gateway || \'—\'}}</td><td>{{network.dnsServers.join(\', \')}}</td></tr></tbody></table><p ng-if=\"vm.canEdit\"><button class=\"btn btn-primary\" ng-click=\"vm.downloadCollector(false)\" ng-disabled=\"vm.collectorBusy || !vm.meta.currentAreaId\" translate=\"wamasysApp.equipmentParc.it.downloadCollector\"></button> <button class=\"btn btn-default\" ng-click=\"vm.downloadCollector(true)\" ng-disabled=\"vm.collectorBusy || !vm.meta.currentAreaId\" translate=\"wamasysApp.equipmentParc.it.downloadNetwork\"></button> <button class=\"btn btn-default\" ng-if=\"vm.detail.device.platform === \'WINDOWS\'\" ng-click=\"vm.revoke()\" translate=\"wamasysApp.equipmentParc.text.revoke_collector\"></button></p><dl class=\"dl-horizontal\"><dt translate=\"wamasysApp.equipmentParc.it.lastBoot\"></dt><dd>{{vm.detail.device.lastBootAt | date:\'medium\'}}</dd><dt translate=\"wamasysApp.equipmentParc.it.gpu\"></dt><dd>{{vm.detail.device.gpu}}</dd></dl><h4 translate=\"wamasysApp.equipmentParc.it.peripherals\"></h4><table class=\"table table-condensed\"><thead><tr><th translate=\"wamasysApp.equipmentParc.text.type\"></th><th translate=\"wamasysApp.equipmentParc.text.description_156\"></th><th translate=\"wamasysApp.equipmentParc.it.driver\"></th><th translate=\"wamasysApp.equipmentParc.it.connection\"></th><th translate=\"wamasysApp.equipmentParc.text.ip_address\"></th><th translate=\"wamasysApp.equipmentParc.it.lastContact\"></th></tr></thead><tbody><tr ng-repeat=\"peripheral in vm.detail.peripherals\"><td>{{vm.itLabel(peripheral.peripheralType)}}</td><td>{{peripheral.name}}</td><td>{{peripheral.driver}}</td><td>{{peripheral.connection}}</td><td>{{peripheral.ipAddress}}</td><td>{{peripheral.lastSeenAt | date:\'medium\'}} <span ng-if=\"!peripheral.present\" translate=\"wamasysApp.equipmentParc.it.notDetected\"></span></td></tr></tbody></table><h4 translate=\"wamasysApp.equipmentParc.licenses.title\"></h4><table class=\"table table-condensed\"><thead><tr><th translate=\"wamasysApp.equipmentParc.licenses.product\"></th><th translate=\"wamasysApp.equipmentParc.licenses.reference\"></th><th translate=\"wamasysApp.equipmentParc.licenses.expiresAt\"></th></tr></thead><tbody><tr ng-repeat=\"license in vm.detail.licenses track by $index\"><td>{{license.product}}</td><td>{{license.reference}}</td><td>{{license.expiresAt | date:\'shortDate\'}}</td></tr></tbody></table><h4 translate=\"wamasysApp.equipmentParc.it.installedSoftware\"></h4><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.it.softwareHelp\"></p><p ng-if=\"vm.detail.device.softwareCollectedAt\">{{\'wamasysApp.equipmentParc.text.last_inventory_collection\' | translate}} : {{vm.detail.device.softwareCollectedAt | date:\'medium\'}}</p><div class=\"table-responsive\"><table class=\"table table-condensed\"><thead><tr><th translate=\"wamasysApp.equipmentParc.it.softwareName\"></th><th translate=\"wamasysApp.equipmentParc.it.softwareVersion\"></th><th translate=\"wamasysApp.equipmentParc.it.softwarePublisher\"></th></tr></thead><tbody><tr ng-repeat=\"software in vm.detail.installedSoftware track by $index\"><td>{{software.name}}</td><td>{{software.version}}</td><td>{{software.publisher}}</td></tr></tbody></table></div><p class=\"alert alert-warning\" ng-if=\"vm.canSecrets &amp;&amp; !vm.meta.secretStorageAvailable\" translate=\"wamasysApp.equipmentParc.secrets.unavailable\"></p><h4 translate=\"wamasysApp.equipmentParc.it.diagnostics\"></h4><dl class=\"dl-horizontal\"><dt translate=\"wamasysApp.equipmentParc.it.gatewayLatency\"></dt><dd>{{vm.detail.diagnostics.gatewayLatencyMs}} ms</dd><dt translate=\"wamasysApp.equipmentParc.it.apiLatency\"></dt><dd>{{vm.detail.diagnostics.apiLatencyMs}} ms</dd><dt translate=\"wamasysApp.equipmentParc.it.downloadSpeed\"></dt><dd>{{vm.detail.diagnostics.downloadMbps}} Mbit/s</dd><dt translate=\"wamasysApp.equipmentParc.it.uploadSpeed\"></dt><dd>{{vm.detail.diagnostics.uploadMbps}} Mbit/s</dd></dl><h4>{{\'wamasysApp.equipmentParc.secrets.title\' | translate}}</h4><p ng-if=\"vm.canSecrets\"><button class=\"btn btn-default\" ng-click=\"vm.accountForm()\">{{\'wamasysApp.equipmentParc.secrets.add\' | translate}}</button></p><p class=\"text-muted\">{{\'wamasysApp.equipmentParc.secrets.storageHelp\' | translate}}</p><table class=\"table table-striped\"><thead><tr><th>{{\'wamasysApp.equipmentParc.text.account\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.activated\' | translate}}</th><th translate=\"wamasysApp.equipmentParc.secrets.status\"></th><th>{{\'wamasysApp.equipmentParc.text.last_observed\' | translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"a in vm.detail.adminAccounts track by a.id\"><td>{{a.label}}<br>{{a.accountName}}</td><td>{{a.enabled ? (\'wamasysApp.equipmentParc.text.yes\' | translate) : (\'wamasysApp.equipmentParc.text.no\' | translate)}}</td><td><span ng-class=\"a.passwordManagementMode === \'STORED\' ? \'text-success\' : \'text-muted\'\">{{(a.passwordManagementMode === \'STORED\' ? \'wamasysApp.equipmentParc.secrets.saved\' : \'wamasysApp.equipmentParc.secrets.toFill\') | translate}}</span><br><span ng-if=\"a.workstationManaged &amp;&amp; !a.workstationAppliedAt\" class=\"text-warning\" translate=\"wamasysApp.equipmentParc.workstation.pending\"></span><small ng-if=\"a.workstationManaged &amp;&amp; a.workstationAppliedAt\">{{\'wamasysApp.equipmentParc.workstation.confirmed\' | translate}} : {{a.workstationAppliedAt | date:\'medium\'}}</small></td><td>{{a.lastSeenAt | date:\'medium\'}}</td><td><button ng-if=\"vm.canSecrets\" class=\"btn btn-default btn-sm\" ng-click=\"vm.referenceForm(a)\">{{\'wamasysApp.equipmentParc.secrets.edit\' | translate}}</button> <button ng-if=\"vm.canSecrets &amp;&amp; a.passwordManagementMode === \'STORED\'\" class=\"btn btn-default btn-sm\" ng-click=\"vm.revealPassword(a)\" translate=\"wamasysApp.equipmentParc.secrets.reveal\"></button></td></tr></tbody></table><button ng-if=\"vm.canSecrets\" class=\"btn btn-default\" ng-click=\"vm.credentialHistory()\">{{\'wamasysApp.equipmentParc.secrets.history\' | translate}}</button><table class=\"table table-condensed\" ng-if=\"vm.credentialAccess\"><thead><tr><th>{{\'wamasysApp.equipmentParc.text.extra_date\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.user\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.action\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.result\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"entry in vm.credentialAccess track by entry.id\"><td>{{entry.occurredAt | date:\'medium\'}}</td><td>{{entry.actorLogin}}</td><td>{{vm.label(entry.action)}}</td><td>{{vm.label(entry.result)}}</td></tr></tbody></table></uib-tab><uib-tab heading=\"{{\'wamasysApp.equipmentParc.ui.mediaTab\' | translate}}\"><equipment-media equipment-id=\"vm.selectedId\" can-edit=\"vm.canEdit\"></equipment-media></uib-tab><uib-tab heading=\"{{\'wamasysApp.equipmentParc.text.historic\' | translate}}\"><table class=\"table table-striped\" style=\"margin-top: 15px\"><thead><tr><th>{{\'wamasysApp.equipmentParc.text.extra_date\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.user\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.action\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"h in vm.detail.history track by h.id\"><td>{{h.changedAt | date:\'medium\'}}</td><td>{{h.changedByLogin || (\'wamasysApp.equipmentParc.text.collector\' | translate)}}</td><td>{{vm.message(h.reason)}}<details open ng-if=\"h.diff.length\"><summary>{{h.diff.length}} <span translate=\"wamasysApp.equipmentParc.media.changes\"></span></summary><table class=\"table table-condensed\"><thead><tr><th translate=\"wamasysApp.equipmentParc.media.field\"></th><th translate=\"wamasysApp.equipmentParc.media.before\"></th><th translate=\"wamasysApp.equipmentParc.media.after\"></th></tr></thead><tbody><tr ng-repeat=\"change in h.diff\"><td>{{vm.historyField(change.key)}}</td><td style=\"white-space:pre-wrap;overflow-wrap:anywhere\">{{vm.historyValue(change.key, change.before)}}</td><td style=\"white-space:pre-wrap;overflow-wrap:anywhere\">{{vm.historyValue(change.key, change.after)}}</td></tr></tbody></table></details></td></tr></tbody></table></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("app/business/equipment-parc/equipment-password.html","<div class=\"modal-header\"><h3 translate=\"wamasysApp.equipmentParc.secrets.reveal\"></h3></div><div class=\"modal-body\"><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.secrets.audited\"></p><label translate=\"wamasysApp.equipmentParc.secrets.login\"></label><input class=\"form-control\" readonly=\"readonly\" ng-model=\"secret.login\" autocomplete=\"off\"><label translate=\"wamasysApp.equipmentParc.secrets.password\"></label><input class=\"form-control\" ng-attr-type=\"{{secret.visible ? \'text\' : \'password\'}}\" readonly=\"readonly\" ng-model=\"secret.password\" autocomplete=\"off\"><label><input type=\"checkbox\" ng-model=\"secret.visible\"> <span translate=\"wamasysApp.equipmentParc.secrets.show\"></span></label></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"secret.close()\" translate=\"wamasysApp.equipmentParc.text.close\"></button></div>");
$templateCache.put("app/business/equipment-parc/equipment-preparation-history.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"history.close()\" aria-label=\"{{\'wamasysApp.equipmentParc.preparationHistory.close\' | translate}}\">×</button><h3 class=\"modal-title\" translate=\"wamasysApp.equipmentParc.preparationHistory.title\"></h3></div><div class=\"modal-body\"><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.preparationHistory.help\"></p><p ng-if=\"history.error\" class=\"alert alert-danger\" role=\"alert\" translate=\"wamasysApp.equipmentParc.preparationHistory.failed\"></p><button type=\"button\" class=\"btn btn-default\" ng-click=\"history.load(false)\" ng-disabled=\"history.loading\" translate=\"wamasysApp.equipmentParc.preparationHistory.refresh\"></button><table class=\"table table-striped\"><thead><tr><th translate=\"wamasysApp.equipmentParc.preparationHistory.started\"></th><th translate=\"wamasysApp.equipmentParc.preparationHistory.finished\"></th><th translate=\"wamasysApp.equipmentParc.preparationHistory.status\"></th><th translate=\"wamasysApp.equipmentParc.preparationHistory.language\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"run in history.rows track by run.id\"><td>{{run.startedAt | date:\'medium\'}}</td><td>{{run.finishedAt | date:\'medium\'}}</td><td><span ng-class=\"{\'text-danger\':run.status === \'FAILED\', \'text-success\':run.status === \'SUCCESS\'}\">{{\'wamasysApp.equipmentParc.preparationHistory.\' + run.status | translate}}</span></td><td>{{run.language === \'fr\' ? \'Français\' : \'English\'}}</td><td><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"history.open(run)\" ng-disabled=\"history.loadingLog\" translate=\"wamasysApp.equipmentParc.preparationHistory.view\"></button></td></tr></tbody></table><p ng-if=\"!history.loading &amp;&amp; !history.rows.length\" translate=\"wamasysApp.equipmentParc.preparationHistory.empty\"></p><button type=\"button\" ng-if=\"history.more\" ng-disabled=\"history.loading\" class=\"btn btn-default\" ng-click=\"history.load(true)\" translate=\"wamasysApp.equipmentParc.preparationHistory.older\"></button><div ng-if=\"history.selected\"><h4>{{history.selected.startedAt | date:\'medium\'}}</h4><p class=\"alert alert-warning\" ng-if=\"history.selected.truncated\" translate=\"wamasysApp.equipmentParc.preparationHistory.truncated\"></p><pre style=\"max-height:450px;overflow:auto;white-space:pre-wrap\" ng-bind=\"history.logText\"></pre></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"history.close()\" translate=\"wamasysApp.equipmentParc.preparationHistory.close\"></button></div>");
$templateCache.put("app/business/equipment-parc/equipment-remote-actions.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"remote.close()\" aria-label=\"{{\'wamasysApp.equipmentParc.remote.close\' | translate}}\">×</button><h3 class=\"modal-title\" translate=\"wamasysApp.equipmentParc.remote.title\"></h3></div><div class=\"modal-body\"><p translate=\"wamasysApp.equipmentParc.remote.help\"></p><p class=\"alert alert-danger\" ng-if=\"remote.error\" role=\"alert\" translate=\"wamasysApp.equipmentParc.remote.failed\"></p><p class=\"alert alert-success\" ng-if=\"remote.queued\" role=\"status\" translate=\"wamasysApp.equipmentParc.remote.queued\"></p><p ng-if=\"!remote.loading &amp;&amp; !remote.agent\" class=\"alert alert-info\" translate=\"wamasysApp.equipmentParc.remote.installAgent\"></p><div ng-if=\"remote.agent\"><p><strong translate=\"wamasysApp.equipmentParc.remote.lastSeen\"></strong> {{remote.agent.lastSeen | date:\'medium\'}} · <strong translate=\"wamasysApp.equipmentParc.remote.version\"></strong> <code title=\"{{remote.agent.version}}\">{{remote.agent.version | limitTo:12}}</code></p><p class=\"text-muted\" ng-if=\"remote.updatesAvailable &amp;&amp; remote.agent.version !== remote.releaseVersion\" translate=\"wamasysApp.equipmentParc.remote.updatePending\"></p><p ng-if=\"remote.agent.error\" class=\"text-danger\">{{remote.agent.error}}</p></div><p ng-if=\"remote.agent &amp;&amp; !remote.updatesAvailable\" class=\"alert alert-info\" translate=\"wamasysApp.equipmentParc.remote.updatesUnavailable\"></p><form ng-if=\"remote.canRemote &amp;&amp; remote.agent\" ng-submit=\"remote.enqueue()\"><div class=\"form-group\"><label for=\"remote-kind\" translate=\"wamasysApp.equipmentParc.remote.kind\"></label><select id=\"remote-kind\" class=\"form-control\" ng-model=\"remote.request.kind\" ng-change=\"remote.request.itemId=null;remote.changed()\" ng-disabled=\"remote.busy\"><option value=\"INSTALL_SOFTWARE\" translate=\"wamasysApp.equipmentParc.remote.INSTALL_SOFTWARE\"></option><option value=\"SCRIPT\" translate=\"wamasysApp.equipmentParc.remote.SCRIPT\"></option></select></div><div class=\"form-group\" ng-if=\"remote.request.kind === \'INSTALL_SOFTWARE\'\"><label for=\"remote-software\" translate=\"wamasysApp.equipmentParc.remote.software\"></label><select id=\"remote-software\" class=\"form-control\" ng-model=\"remote.request.itemId\" ng-options=\"item.id as item.label for item in remote.software\" ng-change=\"remote.changed()\" ng-disabled=\"remote.busy\" required><option value=\"\" translate=\"wamasysApp.equipmentParc.remote.choose\"></option></select></div><div class=\"form-group\" ng-if=\"remote.request.kind === \'SCRIPT\'\"><label for=\"remote-command\" translate=\"wamasysApp.equipmentParc.remote.command\"></label><select id=\"remote-command\" class=\"form-control\" ng-model=\"remote.request.itemId\" ng-change=\"remote.changed()\" ng-disabled=\"remote.busy\" required><option value=\"\" translate=\"wamasysApp.equipmentParc.remote.choose\"></option><option ng-repeat=\"command in remote.commands\" value=\"{{command}}\">{{\'wamasysApp.equipmentParc.remote.\' + command | translate}}</option></select><p class=\"help-block\" ng-if=\"remote.request.itemId === \'RESTART_PRINT_SPOOLER\'\" translate=\"wamasysApp.equipmentParc.remote.printHelp\"></p></div><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"remote.busy || !remote.request.itemId\" translate=\"wamasysApp.equipmentParc.remote.enqueue\"></button></form><p ng-if=\"!remote.canRemote\" class=\"text-muted\" translate=\"wamasysApp.equipmentParc.remote.permission\"></p><hr><button type=\"button\" class=\"btn btn-default\" ng-click=\"remote.load(false)\" ng-disabled=\"remote.loading || remote.busy\" translate=\"wamasysApp.equipmentParc.remote.refresh\"></button><table class=\"table table-striped\"><thead><tr><th translate=\"wamasysApp.equipmentParc.remote.requested\"></th><th translate=\"wamasysApp.equipmentParc.remote.author\"></th><th translate=\"wamasysApp.equipmentParc.remote.action\"></th><th translate=\"wamasysApp.equipmentParc.remote.status\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"row in remote.rows track by row.id\"><td>{{row.requestedAt | date:\'medium\'}}</td><td><span ng-if=\"row.kind === \'UPDATE_AGENT\'\" translate=\"wamasysApp.equipmentParc.remote.automatic\"></span><span ng-if=\"row.kind !== \'UPDATE_AGENT\'\">{{row.createdBy}}</span></td><td>{{\'wamasysApp.equipmentParc.remote.\' + row.kind | translate}}<br><small ng-if=\"row.kind === \'INSTALL_SOFTWARE\'\">{{row.target}}</small><small ng-if=\"row.kind === \'SCRIPT\'\">{{\'wamasysApp.equipmentParc.remote.\' + row.target | translate}}</small><code ng-if=\"row.kind === \'UPDATE_AGENT\'\">{{row.target | limitTo:12}}</code></td><td>{{\'wamasysApp.equipmentParc.remote.\' + row.status | translate}}</td><td><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"remote.open(row)\" ng-disabled=\"remote.loadingLog\" translate=\"wamasysApp.equipmentParc.remote.log\"></button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"remote.canRemote &amp;&amp; (row.status === \'QUEUED\' || row.status === \'DELIVERED\')\" ng-click=\"remote.cancel(row)\" ng-disabled=\"remote.busy\" translate=\"wamasysApp.equipmentParc.remote.cancel\"></button></td></tr></tbody></table><p ng-if=\"!remote.loading &amp;&amp; !remote.rows.length\" translate=\"wamasysApp.equipmentParc.remote.empty\"></p><button type=\"button\" class=\"btn btn-default\" ng-if=\"remote.more\" ng-click=\"remote.load(true)\" ng-disabled=\"remote.loading\" translate=\"wamasysApp.equipmentParc.remote.older\"></button><div ng-if=\"remote.selected\"><h4 translate=\"wamasysApp.equipmentParc.remote.log\"></h4><p>{{\'wamasysApp.equipmentParc.preparationHistory.started\' | translate}} : {{remote.selected.startedAt | date:\'medium\'}} — {{\'wamasysApp.equipmentParc.preparationHistory.finished\' | translate}} : {{remote.selected.finishedAt | date:\'medium\'}}</p><pre ng-bind=\"remote.logText\" style=\"max-height:450px;overflow:auto;white-space:pre-wrap\"></pre></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"remote.close()\" translate=\"wamasysApp.equipmentParc.remote.close\"></button></div>");
$templateCache.put("app/business/equipment-parc/equipment-stock.html","<div class=\"equipment-page\"><div ng-include=\"\'app/business/equipment-parc/equipment-header.html\'\"></div><div class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</div><div ng-if=\"!vm.moduleDisabled\"><div ng-if=\"vm.tab === \'stock\'\"><div class=\"equipment-toolbar equipment-actions\"><span></span><div class=\"equipment-action-buttons\"><button class=\"btn btn-primary\" ng-if=\"vm.canEdit\" ng-click=\"vm.stockForm()\"><i class=\"fa fa-exchange\"></i> {{\'wamasysApp.equipmentParc.text.record_a_movement\' | translate}}</button> <button class=\"btn btn-default\" ng-if=\"vm.canEdit\" ng-click=\"vm.consumableForm()\"><i class=\"fa fa-plus\"></i> {{\'wamasysApp.equipmentParc.text.add_an_item\' | translate}}</button> <button class=\"btn btn-default\" ng-if=\"vm.canEdit\" ng-click=\"vm.thresholdForm()\">{{\'wamasysApp.equipmentParc.text.storage_address_and_threshold\' | translate}}</button> <a class=\"btn btn-default\" ui-sref=\"equipment-labels({kind:\'STORAGE\'})\"><i class=\"fa fa-print\"></i> <span translate=\"wamasysApp.equipmentParc.storage.title\"></span></a></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-4 form-group\"><label translate=\"wamasysApp.equipmentParc.text.owning_agency\"></label><select class=\"form-control\" ng-model=\"vm.stockFilter.ownerId\" ng-options=\"owner.id as owner.label for owner in vm.meta.owners\" ng-change=\"vm.changeStockScope()\"><option value=\"\" translate=\"wamasysApp.equipmentParc.dashboard.allAgencies\"></option></select></div><div class=\"col-sm-4 form-group\"><label>AREA</label><select class=\"form-control\" ng-model=\"vm.stockFilter.areaId\" ng-options=\"area.id as area.label for area in vm.stockAreas()\" ng-change=\"vm.changeStockScope()\"><option value=\"\" translate=\"wamasysApp.equipmentParc.map.allAreas\"></option></select></div><div class=\"col-sm-4 form-group\"><label translate=\"wamasysApp.equipmentParc.text.location\"></label><select class=\"form-control\" ng-model=\"vm.stockFilter.locationId\" ng-options=\"location.id as location.label for location in vm.stockLocations()\" ng-change=\"vm.changeStockScope()\"><option value=\"\" translate=\"wamasysApp.equipmentParc.storage.allLocations\"></option></select></div></div></div></div><ul class=\"nav nav-tabs equipment-local-tabs\" role=\"tablist\"><li ng-class=\"{active:vm.stockTab===\'balances\'}\"><a href=\"\" ng-click=\"vm.stockTab=\'balances\'\" translate=\"wamasysApp.equipmentParc.ui.stock\"></a></li><li ng-class=\"{active:vm.stockTab===\'movements\'}\"><a href=\"\" ng-click=\"vm.stockTab=\'movements\'\" translate=\"wamasysApp.equipmentParc.ui.movements\"></a></li><li ng-class=\"{active:vm.stockTab===\'articles\'}\"><a href=\"\" ng-click=\"vm.stockTab=\'articles\'\" translate=\"wamasysApp.equipmentParc.text.items\"></a></li></ul><section class=\"equipment-tab-body\" ng-if=\"vm.stockTab===\'balances\'\"><div class=\"alert alert-info\"><strong>Valeur estimée du stock au {{vm.stock.valuedAt | date:\'medium\'}} :</strong> <span ng-repeat=\"(currency, value) in vm.stock.valuesByCurrency\">{{value | number:2}} {{currency}} </span><p>Quantités disponibles × prix unitaires actuels. Les devises sont séparées.</p><p ng-if=\"vm.stock.unpricedPositions\">{{vm.stock.unpricedPositions}} position(s) sans prix, exclue(s) de la valorisation.</p></div><h3>{{\'wamasysApp.equipmentParc.text.stock_by_location\' | translate}}</h3><table class=\"table table-striped\"><thead><tr><th>{{\'wamasysApp.equipmentParc.text.item\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.location\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.extra_available\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.unit\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.threshold\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.storage_address\' | translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"row in vm.stockRows track by $index\" ng-class=\"{warning: row.low}\"><td>{{vm.name(vm.meta.consumables, row.consumableId)}}</td><td>{{vm.name(vm.meta.locations, row.locationId)}}</td><td>{{row.quantity}}</td><td><span ng-repeat=\"c in vm.meta.consumables | filter:{id:row.consumableId}:true\">{{c.unit}}</span></td><td>{{row.setting.minimumQuantity}} <span ng-if=\"row.low\" class=\"label label-warning\">{{\'wamasysApp.equipmentParc.text.below_threshold\' | translate}}</span></td><td>{{vm.storageAddress(row.setting)}} <a ui-sref=\"equipment-labels({kind:\'STORAGE\',locationId:row.locationId})\" title=\"{{\'wamasysApp.equipmentParc.storage.title\' | translate}}\"><i class=\"fa fa-print\"></i></a></td><td><button ng-if=\"vm.canEdit\" class=\"btn btn-default btn-sm\" ng-click=\"vm.thresholdForm(row)\">{{\'wamasysApp.equipmentParc.text.storage_address_and_threshold\' | translate}}</button></td></tr><tr ng-if=\"!vm.stockRows.length\"><td colspan=\"7\">{{\'wamasysApp.equipmentParc.text.no_stock_recorded_create_an_item_and_a_location_then\' | translate}}</td></tr></tbody></table></section><section class=\"equipment-tab-body\" ng-if=\"vm.stockTab===\'movements\'\"><h3>{{\'wamasysApp.equipmentParc.text.recent_movements\' | translate}}</h3><p class=\"text-muted\">{{\'wamasysApp.equipmentParc.text.the_last_100_movement_lines_in_this_scope_are_shown\' | translate}}</p><div class=\"table-responsive\"><table class=\"table table-condensed\"><thead><tr><th>{{\'wamasysApp.equipmentParc.text.extra_date\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.operation\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.item\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.location\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.extra_direction\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.quantity\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.beneficiary\' | translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"entry in vm.stock.history track by entry.movement.id\"><td>{{entry.operation.occurredAt | date:\'short\'}}</td><td>{{vm.label(entry.operation.operationType)}} n° {{entry.operation.id}}<p ng-if=\"entry.operation.adjustmentReason\">{{(\'wamasysApp.equipmentParc.adjustmentReasons.\' + entry.operation.adjustmentReason) | translate}}</p><p class=\"text-muted\">{{entry.operation.comment}}</p></td><td>{{vm.name(vm.meta.consumables, entry.movement.consumableId)}}</td><td>{{vm.name(vm.meta.locations, entry.movement.locationId)}}</td><td>{{vm.label(entry.movement.direction)}}</td><td>{{entry.movement.quantity}}</td><td>{{entry.operation.beneficiaryName}}</td><td><button ng-if=\"vm.canEdit && entry.operation.operationType !== \'REVERSAL\'\" class=\"btn btn-default btn-sm\" ng-click=\"vm.reverseForm(entry.operation)\">{{\'wamasysApp.equipmentParc.text.extra_reverse\' | translate}}</button></td></tr></tbody></table></div></section><section class=\"equipment-tab-body\" ng-if=\"vm.stockTab===\'articles\'\"><h3>{{\'wamasysApp.equipmentParc.text.items\' | translate}}</h3><table class=\"table table-condensed\"><thead><tr><th>{{\'wamasysApp.equipmentParc.text.code\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.description_156\' | translate}}</th><th>{{\'wamasysApp.equipmentParc.text.unit\' | translate}}</th><th>Catégorie</th><th>Prix unitaire</th><th>{{\'wamasysApp.equipmentParc.text.active\' | translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"c in vm.stockArticles() track by c.id\"><td>{{c.code}}</td><td>{{c.label}}</td><td>{{c.unit}}</td><td>{{c.categoryId ? vm.name(vm.meta.consumableCategories, c.categoryId) : (c.category || \"—\")}}</td><td>{{c.unitPrice | number:4}} {{c.priceCurrency}}</td><td>{{c.active ? (\'wamasysApp.equipmentParc.text.yes\' | translate) : (\'wamasysApp.equipmentParc.text.no\' | translate)}}</td><td><button class=\"btn btn-default btn-sm\" ng-click=\"vm.articleHistory(c)\">Historique</button> <button ng-if=\"vm.canEdit\" class=\"btn btn-default btn-sm\" ng-click=\"vm.consumableForm(c)\">{{\'wamasysApp.equipmentParc.text.edit\' | translate}}</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.showBarcode(\'CONSUMABLE\', c.id)\"><i class=\"fa fa-barcode\"></i> {{\'wamasysApp.equipmentParc.text.barcode\' | translate}}</button></td></tr></tbody></table><div ng-if=\"vm.historyArticle\"><h4>Historique — {{vm.historyArticle.label}}</h4><p>Les modifications sont conservées à partir de cette mise à jour.</p><table class=\"table table-condensed\"><thead><tr><th>Date</th><th>Utilisateur</th><th>Champ</th><th>Avant</th><th>Après</th></tr></thead><tbody ng-repeat=\"entry in vm.articleChanges | orderBy:\'-changedAt\'\"><tr ng-repeat=\"change in entry.diff\"><td>{{entry.changedAt | date:\'medium\'}}</td><td>{{entry.changedByLogin}}</td><td>{{vm.historyField(change.key)}}</td><td>{{vm.historyValue(change.key, change.before)}}</td><td>{{vm.historyValue(change.key, change.after)}}</td></tr></tbody></table></div></section></div></div></div>");
$templateCache.put("app/business/equipment-parc/equipment-token.html","<div class=\"modal-header\"><h3>{{\'wamasysApp.equipmentParc.text.collector_token\' | translate}}</h3></div><div class=\"modal-body\"><p>{{\'wamasysApp.equipmentParc.text.copy_this_token_into_the_protected_device_configuration_now_it\' | translate}}</p><textarea class=\"form-control\" rows=\"3\" readonly=\"readonly\">{{token}}</textarea></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"$close()\">{{\'wamasysApp.equipmentParc.text.close\' | translate}}</button></div>");
$templateCache.put("app/business/equipment-parc/equipment-work-orders.html","<section style=\"margin-top:15px\"><div ng-if=\"$ctrl.mode !== \'plans\'\"><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.evolution.interventionHelp\"></p><button class=\"btn btn-primary\" ng-if=\"$ctrl.canEdit\" ng-click=\"$ctrl.edit()\" translate=\"wamasysApp.equipmentParc.evolution.addIntervention\"></button><div class=\"panel panel-default\" style=\"margin-top:12px\" ng-repeat=\"work in $ctrl.detail.interventions track by work.id\"><div class=\"panel-heading\"><strong>{{work.title}}</strong> · {{$ctrl.tr(work.kind)}} · {{$ctrl.tr(work.status)}} <button class=\"btn btn-default btn-xs pull-right\" ng-if=\"$ctrl.canEdit &amp;&amp; work.status !== \'COMPLETED\' &amp;&amp; work.status !== \'CANCELLED\'\" ng-click=\"$ctrl.edit(work)\" translate=\"wamasysApp.equipmentParc.text.edit\"></button></div><div class=\"panel-body\"><p><span translate=\"wamasysApp.equipmentParc.evolution.plannedDate\"></span> : {{work.plannedDate | date:\'shortDate\'}} · <span translate=\"wamasysApp.equipmentParc.evolution.performedDate\"></span> : {{work.performedDate | date:\'shortDate\'}} · {{work.technician}}</p><p style=\"white-space:pre-wrap\">{{work.report}}</p><p ng-if=\"work.cost != null\">{{work.cost | number:2}} {{work.currency}}</p><button class=\"btn btn-default btn-sm\" ng-click=\"work.showAttachments = !work.showAttachments\" translate=\"wamasysApp.equipmentParc.media.title\"></button><equipment-media ng-if=\"work.showAttachments\" intervention-id=\"work.id\" can-edit=\"$ctrl.canEdit\"></equipment-media></div></div><p ng-if=\"!$ctrl.detail.interventions.length\" translate=\"wamasysApp.equipmentParc.evolution.noIntervention\"></p></div><div ng-if=\"$ctrl.mode !== \'interventions\'\"><h4 translate=\"wamasysApp.equipmentParc.text.maintenance\"></h4><button class=\"btn btn-primary\" ng-if=\"$ctrl.canEdit\" ng-click=\"$ctrl.plan()\" translate=\"wamasysApp.equipmentParc.evolution.planMaintenance\"></button><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"wamasysApp.equipmentParc.evolution.designation\"></th><th translate=\"wamasysApp.equipmentParc.evolution.nextDueDate\"></th><th translate=\"wamasysApp.equipmentParc.evolution.intervalMonths\"></th><th translate=\"wamasysApp.equipmentParc.evolution.status\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"plan in $ctrl.detail.plans track by plan.id\"><td>{{plan.label}}<p class=\"text-muted\">{{plan.instructions}}</p></td><td>{{plan.nextDueDate | date:\'shortDate\'}}</td><td>{{plan.intervalMonths}}</td><td>{{(plan.active ? \'wamasysApp.equipmentParc.text.active_10\' : \'wamasysApp.equipmentParc.text.inactive\') | translate}}</td><td ng-if=\"$ctrl.canEdit\"><button class=\"btn btn-default btn-sm\" ng-click=\"$ctrl.plan(plan)\" translate=\"wamasysApp.equipmentParc.text.edit\"></button> <button class=\"btn btn-default btn-sm\" ng-if=\"plan.active\" ng-click=\"$ctrl.edit(null, plan)\" translate=\"wamasysApp.equipmentParc.evolution.addIntervention\"></button> <button class=\"btn btn-success btn-sm\" ng-if=\"plan.active\" ng-click=\"$ctrl.complete(plan)\" translate=\"wamasysApp.equipmentParc.evolution.completeMaintenance\"></button></td></tr></tbody></table></div><h4 translate=\"wamasysApp.equipmentParc.text.completions\"></h4><table class=\"table table-condensed\"><thead><tr><th translate=\"wamasysApp.equipmentParc.text.completed_due_date\"></th><th translate=\"wamasysApp.equipmentParc.evolution.performedDate\"></th><th translate=\"wamasysApp.equipmentParc.evolution.nextDueDate\"></th></tr></thead><tbody><tr ng-repeat=\"execution in ($ctrl.detail.maintenanceExecutions || $ctrl.detail.executions) track by execution.id\"><td>{{execution.scheduledDueDate | date:\'shortDate\'}}</td><td>{{execution.performedDate | date:\'shortDate\'}}</td><td>{{execution.nextDueDate | date:\'shortDate\'}}</td></tr></tbody></table></div></section>");
$templateCache.put("app/business/equipment-parc/equipment-workstation.html","<div class=\"panel panel-primary\"><div class=\"panel-heading\"><h3 class=\"panel-title\"><i class=\"fa fa-desktop\"></i> <span translate=\"wamasysApp.equipmentParc.workstation.title\"></span></h3></div><div class=\"panel-body\"><div class=\"form-group\" ng-if=\"ws.downloadAgencyOnly()\"><label for=\"workstation-download-owner\" translate=\"wamasysApp.equipmentParc.text.owning_agency\"></label><select id=\"workstation-download-owner\" class=\"form-control\" ng-model=\"ws.downloadOwnerId\" ng-options=\"owner.id as owner.label for owner in vm.meta.owners\" ng-disabled=\"!vm.isAdmin || ws.downloading\"><option value=\"\" translate=\"wamasysApp.equipmentParc.text.all\"></option></select></div><p><button class=\"btn btn-primary\" ng-click=\"ws.download()\" ng-disabled=\"ws.downloading || ws.busy || !ws.ready || (ws.downloadAgencyOnly() ? !ws.downloadOwnerId || !vm.isAdmin : !vm.meta.currentAreaId)\"><i class=\"fa fa-download\"></i> <span translate=\"wamasysApp.equipmentParc.workstation.download\"></span></button> <span class=\"text-muted\" translate=\"wamasysApp.equipmentParc.workstation.downloadHelp\"></span></p><p translate=\"wamasysApp.equipmentParc.workstation.help\"></p><ol class=\"text-muted\"><li translate=\"wamasysApp.equipmentParc.workstation.steps.registration\"></li><li translate=\"wamasysApp.equipmentParc.workstation.steps.accounts\"></li><li translate=\"wamasysApp.equipmentParc.workstation.steps.settings\"></li><li translate=\"wamasysApp.equipmentParc.workstation.steps.software\"></li><li translate=\"wamasysApp.equipmentParc.workstation.steps.inventory\"></li></ol><p class=\"alert alert-danger\" role=\"alert\" ng-if=\"ws.error\">{{ws.error}}</p><p class=\"alert alert-success\" role=\"status\" ng-if=\"ws.success\">{{ws.success}}</p><button type=\"button\" class=\"btn btn-default\" ng-click=\"ws.settingsOpen = !ws.settingsOpen\" aria-expanded=\"{{!!ws.settingsOpen}}\" aria-controls=\"workstation-settings\"><i class=\"fa fa-cog\" aria-hidden=\"true\"></i> <span translate=\"wamasysApp.equipmentParc.workstation.settings\"></span></button><div id=\"workstation-settings\" ng-show=\"ws.settingsOpen\"><form name=\"ws.form\" ng-submit=\"ws.save()\" novalidate style=\"margin-top:16px\"><div class=\"form-group\"><label for=\"workstation-scope\" translate=\"wamasysApp.equipmentParc.workstation.scope\"></label><select id=\"workstation-scope\" class=\"form-control\" ng-model=\"ws.scope\" ng-change=\"ws.load()\" ng-disabled=\"ws.busy || ws.downloading\"><option ng-if=\"vm.isAdmin\" value=\"organisation\" translate=\"wamasysApp.equipmentParc.workstation.organisation\"></option><option value=\"area\" ng-disabled=\"!vm.meta.currentAreaId\" translate=\"wamasysApp.equipmentParc.workstation.area\"></option></select></div><div class=\"checkbox\" ng-if=\"ws.scope === \'area\'\"><label><input type=\"checkbox\" ng-model=\"ws.customArea\" ng-disabled=\"ws.busy\"> <span translate=\"wamasysApp.equipmentParc.workstation.customArea\"></span></label><p class=\"help-block\" translate=\"wamasysApp.equipmentParc.workstation.inheritance\"></p></div><fieldset ng-disabled=\"ws.busy || (ws.scope === \'area\' &amp;&amp; !ws.customArea)\"><div class=\"checkbox\" ng-if=\"ws.scope === \'organisation\'\"><label><input type=\"checkbox\" ng-model=\"ws.model.allowSelfServiceDownload\"> <span translate=\"wamasysApp.equipmentParc.workstation.allowSelfServiceDownload\"></span></label><p class=\"help-block\" translate=\"wamasysApp.equipmentParc.workstation.selfServiceHelp\"></p></div><div class=\"form-group\"><label for=\"workstation-attachment\" translate=\"wamasysApp.equipmentParc.workstation.attachment\"></label><select id=\"workstation-attachment\" class=\"form-control\" ng-model=\"ws.model.attachmentScope\"><option value=\"AREA\" translate=\"wamasysApp.equipmentParc.workstation.attachArea\"></option><option value=\"AGENCY\" ng-disabled=\"!vm.isAdmin\" translate=\"wamasysApp.equipmentParc.workstation.attachAgency\"></option></select><p class=\"help-block\" translate=\"wamasysApp.equipmentParc.workstation.attachmentHelp\"></p></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"ws.model.createAdminAccounts\"> <span translate=\"wamasysApp.equipmentParc.workstation.createAdmins\"></span></label></div><p class=\"help-block\" translate=\"wamasysApp.equipmentParc.workstation.adminHelp\"></p><div ng-if=\"ws.model.createAdminAccounts\"><div class=\"form-group\"><label for=\"workstation-admin\" translate=\"wamasysApp.equipmentParc.workstation.localAdmin\"></label><input id=\"workstation-admin\" class=\"form-control\" ng-model=\"ws.model.localAdminName\" maxlength=\"20\" pattern=\"[A-Za-z][A-Za-z0-9_-]{0,19}\" required></div><div class=\"form-group\"><label for=\"workstation-rescue\" translate=\"wamasysApp.equipmentParc.workstation.rescueAdmin\"></label><input id=\"workstation-rescue\" class=\"form-control\" ng-model=\"ws.model.rescueAdminName\" maxlength=\"20\" pattern=\"[A-Za-z][A-Za-z0-9_-]{0,19}\" ng-disabled=\"ws.scope === \'area\'\" required></div><div class=\"form-group\" ng-if=\"ws.scope === \'organisation\'\"><label for=\"workstation-password\" translate=\"wamasysApp.equipmentParc.workstation.rescuePassword\"></label><input id=\"workstation-password\" type=\"password\" autocomplete=\"new-password\" class=\"form-control\" ng-model=\"ws.rescuePassword\" minlength=\"8\" maxlength=\"128\"><p class=\"help-block\" translate=\"wamasysApp.equipmentParc.workstation.rescueHelp\"></p></div><p class=\"text-warning\" ng-if=\"!ws.data.secretsAvailable\" translate=\"wamasysApp.equipmentParc.secrets.unavailable\"></p></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"ws.model.disablePasswordExpiration\"> <span translate=\"wamasysApp.equipmentParc.workstation.noExpiration\"></span></label></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"ws.model.renameComputerFromReference\" ng-change=\"ws.model.askComputerName = ws.model.renameComputerFromReference ? false : ws.model.askComputerName\"> <span translate=\"wamasysApp.equipmentParc.workstation.rename\"></span></label><p class=\"help-block\" translate=\"wamasysApp.equipmentParc.workstation.renameHelp\"></p></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"ws.model.askComputerName\" ng-change=\"ws.model.renameComputerFromReference = ws.model.askComputerName ? false : ws.model.renameComputerFromReference\"> <span translate=\"wamasysApp.equipmentParc.workstation.askComputerName\"></span></label></div><div class=\"form-group\"><label for=\"workstation-wallpaper\" translate=\"wamasysApp.equipmentParc.workstation.wallpaper\"></label><input id=\"workstation-wallpaper\" type=\"url\" class=\"form-control\" ng-model=\"ws.model.wallpaperUrl\" maxlength=\"2000\" placeholder=\"https://\"><p class=\"help-block\" translate=\"wamasysApp.equipmentParc.workstation.wallpaperHelp\"></p></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"ws.model.configureFirewall\"> <span translate=\"wamasysApp.equipmentParc.workstation.firewall\"></span></label><p class=\"help-block\" translate=\"wamasysApp.equipmentParc.workstation.firewallHelp\"></p></div><h4 translate=\"wamasysApp.equipmentParc.workstation.software\"></h4><div class=\"row\"><div class=\"col-sm-4\" ng-repeat=\"software in ws.software track by software.id\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-checked=\"ws.model.software.indexOf(software.id) >= 0\" ng-click=\"ws.toggleSoftware(software.id)\"> {{software.label}}</label></div></div></div><div class=\"form-group\"><label for=\"workstation-office\" translate=\"wamasysApp.equipmentParc.workstation.office\"></label><select id=\"workstation-office\" class=\"form-control\" ng-model=\"ws.model.officeEdition\" ng-options=\"edition.id as ws.officeLabel(edition) for edition in ws.editions\"></select><p class=\"help-block\" translate=\"wamasysApp.equipmentParc.workstation.officeHelp\"></p><p class=\"text-warning\" ng-if=\"ws.selectedOffice().obsolete\" translate=\"wamasysApp.equipmentParc.workstation.officeObsolete\"></p></div></fieldset><p class=\"text-muted\" translate=\"wamasysApp.equipmentParc.workstation.mandatory\"></p><button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"ws.busy || !ws.ready || ws.downloading || ws.form.$invalid\" translate=\"wamasysApp.equipmentParc.workstation.save\"></button><details style=\"margin-top:12px\"><summary translate=\"wamasysApp.equipmentParc.workstation.json\"></summary><pre>{{ws.json}}</pre></details></form></div></div></div>");
$templateCache.put("app/business/individual-meter/individual-meter-addreading-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myIndividualMeterLabel\" translate=\"wamasysApp.individualMeter.home.addReading\">add Reading</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"alert alert-warning\"><span translate=\"wamasysApp.individualMeter.messageAddReading\"></span></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.individualMeter.numeroSerie\" for=\"field_numeroSerie\">NumeroSerie</label><input readonly=\"readonly\" type=\"text\" class=\"form-control\" name=\"numeroSerie\" id=\"field_numeroSerie\" ng-model=\"vm.individualMeter.numeroSerie\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.individualMeter.datePrecedenteLecture\" for=\"field_datePrecedenteLecture\">datePrecedenteLecture</label><input readonly=\"readonly\" type=\"text\" class=\"form-control\" name=\"datePrecedenteLecture\" id=\"field_datePrecedenteLecture\" value=\"{{vm.individualMeter.datePrecedenteLecture| date:\'medium\'}}\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.individualMeter.valeurPrecedenteLecture\" for=\"field_valeurPrecedenteLecture\">valeurPrecedenteLecture</label><input readonly=\"readonly\" type=\"text\" class=\"form-control\" name=\"numeroSerie\" id=\"field_valeurPrecedenteLecture\" ng-model=\"vm.individualMeter.valeurPrecedenteLecture\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.individualMeter.readingDate\" for=\"field_readingDate\">readingDate</label><div class=\"input-group\"><!--        <input id=\"field_readingDate\" type=\"text\" class=\"form-control\" name=\"readingDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.readingIndividualMeter.readingDate\" is-open=\"vm.datePickerOpenStatus.readingDate\"\n                    required/>\n                     --> <input id=\"field_readingDate\" type=\"text\" class=\"form-control\" name=\"readingDate\" datetime-picker=\"{{dateformat}}\" ng-click=\"vm.openCalendar(\'readingDate\')\" ng-model=\"vm.readingIndividualMeter.readingDate\" is-open=\"vm.datePickerOpenStatus.readingDate\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'readingDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.readingDate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.readingDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.individualMeter.valeurReleve\" for=\"field_valeurReleve\">valeurReleve</label><input type=\"number\" class=\"form-control\" name=\"valeurReleve\" id=\"field_valeurReleve\" ng-model=\"vm.readingIndividualMeter.valeurReleve\" required max=\"999999999999\"><div ng-show=\"editForm.valeurReleve.$invalid\"><p class=\"help-block\" ng-show=\"editForm.valeurReleve.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.valeurReleve.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999999999\">This field cannot be more than 999999999999.</p><p class=\"help-block\" ng-show=\"editForm.valeurReleve.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/individual-meter/individual-meter-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.individualMeter.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.individualMeter.delete.question\" translate-values=\"{id: \'{{vm.individualMeter.id}}\'}\">Are you sure you want to delete this IndividualMeter?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/individual-meter/individual-meter-detail.html","<div><button class=\"pull-right btn-xs btn-primary\" ui-sref=\"individual-meter-detail.addreading({id:vm.individualMeter.id})\" translate=\"wamasysApp.individualMeter.actionAddReading\">add reading</button><h2><span translate=\"wamasysApp.individualMeter.detail.title\">IndividualMeter</span> {{vm.individualMeter.id}}</h2><hr><div class=\"row\"><div class=\"col-md-8\"><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.individualMeter.numeroSerie\">NumeroSerie</span></dt><dd><span>{{vm.individualMeter.numeroSerie}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.individualMeter.dateMiseEnService\">DateMiseEnService</span></dt><dd><span>{{vm.individualMeter.dateMiseEnService | date:\'mediumDate\'}}</span></dd><hr><dt><span translate=\"wamasysApp.individualMeter.valeurInitiale\">ValeurInitiale</span></dt><dd><span>{{vm.individualMeter.valeurInitiale | number : 3}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.individualMeter.datePrecedenteLecture\">DatePrecedenteLecture</span></dt><dd><span>{{vm.individualMeter.datePrecedenteLecture | date:\'medium\'}}</span></dd><hr><dt><span translate=\"wamasysApp.individualMeter.valeurPrecedenteLecture\">ValeurPrecedenteLecture</span></dt><dd><span>{{vm.individualMeter.valeurPrecedenteLecture | number : 3}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.individualMeter.etat\">Etat</span></dt><dd><span translate=\"{{\'wamasysApp.EtatMeter.\' + vm.individualMeter.etat}}\">{{vm.individualMeter.etat}}</span></dd><hr><div ng-show=\"vm.individualMeter.etat == \'ARCHIVED\'\"><dt><span translate=\"wamasysApp.individualMeter.dateSuppression\">DateSuppression</span></dt><dd><span>{{vm.individualMeter.dateSuppression | date:\'medium\'}}</span></dd><hr></div><dt><span translate=\"wamasysApp.individualMeter.cluster\">cluster</span></dt><dd><a ui-sref=\"cluster-detail({id:vm.individualMeter.cluster.id})\">{{vm.individualMeter.cluster.numeroSerie}}</a></dd><hr><dt><span translate=\"wamasysApp.individualMeter.runningOrder\">runningOrder</span></dt><dd><span>{{vm.individualMeter.runningOrder}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.individualMeter.disableCheckMaxValue\">disableCheckMaxValue</span></dt><dd><span>{{vm.individualMeter.disableCheckMaxValue}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.individualMeter.modelMeter\">modelMeter</span></dt><dd><span>{{vm.individualMeter.modelMeter.label}}</span></dd><!-- \r\n        <hr>\r\n        <dt><span translate=\"wamasysApp.individualMeter.longitude\">Longitude</dt></dt>\r\n        <dd>\r\n            <span>{{vm.individualMeter.longitude}}<span>\r\n        </dd>\r\n        <hr>\r\n        <dt><span translate=\"wamasysApp.individualMeter.latitude\">Latitude</dt></dt>\r\n        <dd>\r\n            <span>{{vm.individualMeter.latitude}}<span>\r\n        </dd> --><hr><dt><span translate=\"wamasysApp.individualMeter.commentaire\">Commentaire</span></dt><dd><span>{{vm.individualMeter.commentaire}}</span></dd><hr><dt><span translate=\"wamasysApp.individualMeter.contrat\">Contrat</span></dt><dd><a ui-sref=\"contrat-detail.information({id:vm.individualMeter.contrat.id})\">{{vm.individualMeter.contrat.referenceContrat}}</a></dd><hr has-module=\"IOT_WATER\"><dt has-module=\"IOT_WATER\"><span translate=\"wamasysApp.individualMeter.isIOT\"></span></dt><dd has-module=\"IOT_WATER\"><input type=\"checkbox\" readonly=\"true\" disabled=\"disabled\" class=\"form-control\" name=\"isIOT\" id=\"field_isIOT\" ng-model=\"vm.individualMeter.isIOT\"></dd><hr ng-show=\"vm.individualMeter.isIOT\"><dt ng-show=\"vm.individualMeter.isIOT\"><span translate=\"wamasysApp.individualMeter.deveui\"></span></dt><dd ng-show=\"vm.individualMeter.isIOT\"><span>{{vm.individualMeter.deveui}}</span></dd><hr ng-show=\"vm.individualMeter.isIOT\"><dt ng-show=\"vm.individualMeter.isIOT\"><span translate=\"wamasysApp.individualMeter.appeui\"></span></dt><dd ng-show=\"vm.individualMeter.isIOT\"><span>{{vm.individualMeter.appeui}}</span></dd><hr ng-show=\"vm.individualMeter.isIOT\"><dt ng-show=\"vm.individualMeter.isIOT\"><span translate=\"wamasysApp.individualMeter.appkey\"></span></dt><dd ng-show=\"vm.individualMeter.isIOT\"><span>{{vm.individualMeter.appkey}}</span></dd><hr ng-show=\"vm.individualMeter.isIOT\"><dt ng-show=\"vm.individualMeter.isIOT\"><span translate=\"wamasysApp.individualMeter.metersModel\"></span></dt><dd ng-show=\"vm.individualMeter.isIOT\"><span>{{vm.individualMeter.metersModel}}</span></dd></dl></div><div class=\"col-md-4\" has-module=\"GEO\"><map-leaflet contrat=\"vm.mapMeter\" readonly=\"true\"></map-leaflet></div></div><br><div jarvis-widget id=\"hide-show-columns-table-widget\" data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"><header><span class=\"widget-icon\"><i class=\"fa fa-table\"></i></span><h2 translate=\"wamasysApp.individualMeter.listePrecedentReleve\">Liste précédent relevé</h2></header><div><div class=\"widget-body no-padding table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th translate=\"wamasysApp.collectionListe.dateFinPeriode\">Date releve</th><th translate=\"wamasysApp.collectionListe.etat\">Etat</th><th translate=\"wamasysApp.collectionListe.collecteur\">Collecteur</th><th translate=\"wamasysApp.individualMeter.valeurReleve\">Valeur releve</th></tr></thead><tbody><tr ng-repeat=\"collectionList in vm.listeCollectionList\"><td ng-if=\"collectionList.releveCompteurEtat !=null \"><a ui-sref=\"releve-compteur-detail({id:collectionList.releveCompteurId})\">{{collectionList.readingDate | date:\'medium\'}} </a></td><td ng-if=\"collectionList.releveCompteurEtat ==null\">{{collectionList.readingDate | date:\'medium\'}}</td><td ng-if=\"collectionList.releveCompteurEtat !=null\" translate=\"{{\'wamasysApp.EtatCollectionList.\' +  collectionList.releveCompteurEtat}}\">{{collectionList.releveCompteurEtat}}</td><td ng-if=\"collectionList.releveCompteurEtat ==null \">Validated (Manually created)</td><td ng-if=\"collectionList.collecteur !=null\">{{collectionList.collecteur.firstName + \' \' + collectionList.collecteur.lastName}}</td><td ng-if=\"collectionList.collecteur ==null\">{{collectionList.createdBy}}</td><td>{{collectionList.valeurReleve | number : 3}}</td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div><!-- end widget content --></div><!-- end widget div --> <button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/individual-meter/individual-meter-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myIndividualMeterLabel\" translate=\"wamasysApp.individualMeter.home.createOrEditLabel\">Create or edit a IndividualMeter</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.individualMeter.numeroSerie\" for=\"field_numeroSerie\">NumeroSerie</label><input required type=\"text\" class=\"form-control\" name=\"numeroSerie\" id=\"field_numeroSerie\" ng-model=\"vm.individualMeter.numeroSerie\" ng-maxlength=\"50\"><div ng-show=\"editForm.numeroSerie.$invalid\"><p class=\"help-block\" ng-show=\"editForm.numeroSerie.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.numeroSerie.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.individualMeter.dateMiseEnService\" for=\"field_dateMiseEnService\">DateMiseEnService</label><div class=\"input-group\"><input id=\"field_dateMiseEnService\" type=\"text\" class=\"form-control\" name=\"dateMiseEnService\" ng-click=\"vm.openCalendar(\'dateMiseEnService\')\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.individualMeter.dateMiseEnService\" is-open=\"vm.datePickerOpenStatus.dateMiseEnService\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateMiseEnService\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.dateMiseEnService.$invalid\"><p class=\"help-block\" ng-show=\"editForm.dateMiseEnService.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.individualMeter.valeurInitiale\" for=\"field_valeurInitiale\">ValeurInitiale</label><input type=\"number\" class=\"form-control\" name=\"valeurInitiale\" id=\"field_valeurInitiale\" ng-model=\"vm.individualMeter.valeurInitiale\" max=\"999999999999\"><div ng-show=\"editForm.valeurInitiale.$invalid\"><!-- <p class=\"help-block\"\n                    ng-show=\"editForm.valeurInitiale.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n                 --><p class=\"help-block\" ng-show=\"editForm.valeurInitiale.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999999999\">This field cannot be more than 999999999999.</p><p class=\"help-block\" ng-show=\"editForm.valeurInitiale.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><!-- \n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"wamasysApp.individualMeter.etat\" for=\"field_etat\">Etat</label>\n            <select class=\"form-control\" name=\"etat\" ng-model=\"vm.individualMeter.etat\" id=\"field_etat\">\n                <option value=\"ACTIVE\" translate=\"wamasysApp.EtatMeter.ACTIVE\">ACTIVE</option>\n                <option value=\"AVAILABLE\" translate=\"wamasysApp.EtatMeter.AVAILABLE\">AVAILABLE</option>\n                <option value=\"ARCHIVED\" translate=\"wamasysApp.EtatMeter.ARCHIVED\">ARCHIVED</option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"wamasysApp.individualMeter.dateSuppression\" for=\"field_dateSuppression\">DateSuppression</label>\n                <div class=\"input-group\">\n                    <input id=\"field_dateSuppression\" type=\"text\" class=\"form-control\" name=\"dateSuppression\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.individualMeter.dateSuppression\" is-open=\"vm.datePickerOpenStatus.dateSuppression\"\n                      />\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateSuppression\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n                    </span>\n                </div>\n        </div>\n         --><div class=\"form-group\"><label translate=\"wamasysApp.individualMeter.cluster\" for=\"field_cluster\">cluster</label><select required class=\"form-control\" id=\"field_cluster\" name=\"cluster\" ng-model=\"vm.individualMeter.cluster\" ng-options=\"cluster as cluster.numeroSerie for cluster in vm.clusters track by cluster.id\"><option value=\"\"></option></select><div ng-show=\"editForm.cluster.$invalid\"><p class=\"help-block\" ng-show=\"editForm.cluster.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.individualMeter.runningOrder\" for=\"field_runningOrder\">runningOrder</label><input required type=\"text\" class=\"form-control\" name=\"runningOrder\" id=\"field_runningOrder\" ng-model=\"vm.individualMeter.runningOrder\" ng-maxlength=\"50\"><div ng-show=\"editForm.runningOrder.$invalid\"><p class=\"help-block\" ng-show=\"editForm.runningOrder.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.runningOrder.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><!--         <div class=\"form-group\"> --><!--             <label class=\"control-label\" translate=\"wamasysApp.individualMeter.etageCluster\" for=\"field_etageCluster\">EtageCluster</label> --><!--             <input required type=\"text\" class=\"form-control\" name=\"etageCluster\" id=\"field_etageCluster\" --><!--                     ng-model=\"vm.individualMeter.etageCluster\" --><!--                     ng-maxlength=\"10\" /> --><!--             <div ng-show=\"editForm.etageCluster.$invalid\"> --><!--                 <p class=\"help-block\" --><!--                     ng-show=\"editForm.etageCluster.$error.required\" translate=\"entity.validation.required\"> --><!--                     This field is required. --><!--                 </p> --><!--                 <p class=\"help-block\" --><!--                     ng-show=\"editForm.etageCluster.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"10\"> --><!--                     This field cannot be longer than 10 characters. --><!--                 </p> --><!--             </div> --><!--         </div> --><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.individualMeter.disableCheckMaxValue\" for=\"field_disableCheckMaxValue\">disableCheckMaxValue</label><input type=\"checkbox\" class=\"form-control\" name=\"disableCheckMaxValue\" id=\"field_disableCheckMaxValue\" ng-model=\"vm.individualMeter.disableCheckMaxValue\"></div><div class=\"form-group\"><label translate=\"wamasysApp.individualMeter.modelMeter\" for=\"field_modelMeter\">modelMeter</label><select class=\"form-control\" id=\"field_modelMeter\" name=\"modelMeter\" ng-model=\"vm.individualMeter.modelMeter\" ng-options=\"modelMeter as modelMeter.label for modelMeter in vm.modelMeters track by modelMeter.id\"><option value=\"\"></option></select></div><div class=\"form-group\" has-module=\"IOT_WATER\"><label class=\"control-label\" translate=\"wamasysApp.individualMeter.isIOT\" for=\"field_isIOT\">isIOT</label><input type=\"checkbox\" class=\"form-control\" name=\"isIOT\" id=\"field_isIOT\" ng-model=\"vm.individualMeter.isIOT\"></div><div class=\"form-group\" has-module=\"IOT_WATER\" ng-if=\"vm.individualMeter.isIOT\"><label class=\"control-label\" translate=\"wamasysApp.individualMeter.deveui\" for=\"field_deveui\">deveui</label><input required type=\"text\" class=\"form-control\" name=\"deveui\" id=\"field_deveui\" ng-model=\"vm.individualMeter.deveui\" ng-maxlength=\"128\"><div ng-show=\"editForm.deveui.$invalid\"><p class=\"help-block\" ng-show=\"editForm.deveui.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.deveui.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"128\">This field cannot be longer than 128 characters.</p></div></div><div class=\"form-group\" has-module=\"IOT_WATER\" ng-if=\"vm.individualMeter.isIOT\"><label class=\"control-label\" translate=\"wamasysApp.individualMeter.appeui\" for=\"field_appeui\">appeui</label><input type=\"text\" class=\"form-control\" name=\"appeui\" id=\"field_appeui\" ng-model=\"vm.individualMeter.appeui\" ng-maxlength=\"128\"><div ng-show=\"editForm.appeui.$invalid\"><p class=\"help-block\" ng-show=\"editForm.appeui.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"128\">This field cannot be longer than 128 characters.</p></div></div><div class=\"form-group\" has-module=\"IOT_WATER\" ng-if=\"vm.individualMeter.isIOT\"><label class=\"control-label\" translate=\"wamasysApp.individualMeter.appkey\" for=\"field_appkey\">appkey</label><input type=\"text\" class=\"form-control\" name=\"appkey\" id=\"field_appkey\" ng-model=\"vm.individualMeter.appkey\" ng-maxlength=\"128\"><div ng-show=\"editForm.appkey.$invalid\"><p class=\"help-block\" ng-show=\"editForm.appkey.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"128\">This field cannot be longer than 128 characters.</p></div></div><div class=\"form-group\" has-module=\"IOT_WATER\" ng-if=\"vm.individualMeter.isIOT\"><label class=\"control-label\" translate=\"wamasysApp.individualMeter.metersModel\" for=\"field_metersModel\">metersModel</label><select class=\"form-control\" required name=\"metersModel\" ng-model=\"vm.individualMeter.metersModel\" id=\"field_metersModel\"><option value=\"DIEHL_HRL_C_G3\">Lora Diehl HRL-C G3</option><option value=\"AXIOMA_QALCOSONIC_W1_V1\">Lora Axioma QALCOSONIC W1</option><option value=\"BOVETECH_BECOX_V1\">Lora BoveTech BECO X / B6 Lite VW</option><option value=\"TALKPOOL_OY1300_V1\">Lora Talkpool OY1300</option><option value=\"MBUS_DIEHL_IZAR_RC_I_R4\">M-BUS Diehl Izar RC-I-R4</option></select><div ng-show=\"editForm.metersModel.$invalid\"><p class=\"help-block\" ng-show=\"editForm.metersModel.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><!-- \n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"wamasysApp.individualMeter.longitude\" for=\"field_longitude\">Longitude</label>\n            <input type=\"text\" class=\"form-control\" name=\"longitude\" id=\"field_longitude\"\n                    ng-model=\"vm.individualMeter.longitude\"\n                    ng-maxlength=\"20\" />\n            <div ng-show=\"editForm.longitude.$invalid\">\n                <p class=\"help-block\"\n                    ng-show=\"editForm.longitude.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"20\">\n                    This field cannot be longer than 20 characters.\n                </p>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"wamasysApp.individualMeter.latitude\" for=\"field_latitude\">Latitude</label>\n            <input type=\"text\" class=\"form-control\" name=\"latitude\" id=\"field_latitude\"\n                    ng-model=\"vm.individualMeter.latitude\"\n                    ng-maxlength=\"20\" />\n            <div ng-show=\"editForm.latitude.$invalid\">\n                <p class=\"help-block\"\n                    ng-show=\"editForm.latitude.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"20\">\n                    This field cannot be longer than 20 characters.\n                </p>\n            </div>\n        </div>\n --><div class=\"form-group\" has-module=\"GEO\"><map-leaflet contrat=\"vm.mapMeter\"></map-leaflet></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.individualMeter.commentaire\" for=\"field_commentaire\">Commentaire</label><textarea type=\"text\" class=\"form-control\" name=\"commentaire\" id=\"field_commentaire\" ng-model=\"vm.individualMeter.commentaire\" ng-maxlength=\"256\"></textarea><div ng-show=\"editForm.commentaire.$invalid\"><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/individual-meter/individual-meters-liste.html","<div class=\"app-entity-shell\"><div class=\"app-entity-header\"><h2 class=\"app-entity-title\" translate=\"wamasysApp.individualMeter.home.title\">IndividualMeters</h2><div class=\"app-entity-actions\"><button class=\"btn btn-default\" ng-click=\"vm.download()\" type=\"button\">download CSV</button> <button class=\"btn btn-primary\" ui-sref=\"compteur.individual-meter.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.individualMeter.home.createLabel\">Create new IndividualMeter</span></button></div></div><jhi-alert></jhi-alert><div class=\"app-filter-panel\"><form name=\"searchForm\" class=\"smart-form\" novalidate><div class=\"app-filter-grid\"><div class=\"app-filter-field\"><label class=\"app-filter-label\" translate=\"wamasysApp.individualMeter.text\" for=\"searchQuery\">Text</label><input type=\"text\" ng-model=\"vm.text\" id=\"searchQuery\" class=\"form-control\" placeholder=\"{{ \'wamasysApp.individualMeter.textPlaceholder\' | translate }}\"></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" translate=\"wamasysApp.individualMeter.etat\" for=\"field_etat\">Etat</label><select class=\"form-control\" name=\"etat\" ng-model=\"vm.etat\" id=\"field_etat\"><option value=\"\"></option><option value=\"ACTIVE\" translate=\"wamasysApp.EtatMeter.ACTIVE\">ACTIVE</option><option value=\"AVAILABLE\" translate=\"wamasysApp.EtatMeter.AVAILABLE\">AVAILABLE</option><option value=\"ARCHIVED\" translate=\"wamasysApp.EtatMeter.ARCHIVED\">ARCHIVED</option></select></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" translate=\"wamasysApp.individualMeter.modelMeter\" for=\"field_modelMeter\">modelMeter</label><select class=\"form-control\" id=\"field_modelMeter\" name=\"modelMeter\" ng-model=\"vm.modelMeter\" ng-options=\"modelMeter as modelMeter.label for modelMeter in vm.modelMeters track by modelMeter.id\"><option value=\"\"></option></select></div><div class=\"app-filter-field\" has-module=\"IOT_WATER\"><label class=\"app-filter-label\" translate=\"wamasysApp.individualMeter.isIOT\" for=\"field_isIOT\">isIOT</label><select class=\"form-control\" name=\"isIOT\" ng-model=\"vm.isIOT\" id=\"field_isIOT\"><option value=\"\"></option><option value=\"true\" translate=\"entity.value.true\">true</option><option value=\"false\" translate=\"entity.value.false\">false</option></select></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" translate=\"wamasysApp.individualMeter.cluster\" for=\"field_cluster\">Cluster</label><select class=\"form-control\" id=\"field_cluster\" name=\"cluster\" ng-model=\"vm.cluster\" ng-options=\"cluster as cluster.numeroSerie for cluster in vm.clusters track by cluster.id\"><option value=\"\"></option></select></div></div><div class=\"app-filter-actions\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.clear()\">reset</button> <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"vm.search()\">search</button></div></form></div><div class=\"table-responsive padding-top-10\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"numeroSerie\"><span translate=\"wamasysApp.individualMeter.numeroSerie\">NumeroSerie</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"etat\"><span translate=\"wamasysApp.individualMeter.etat\">Etat</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"cluster.id\"><span translate=\"wamasysApp.individualMeter.cluster\">cluster</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"runningOrder\"><span translate=\"wamasysApp.individualMeter.runningOrder\">runningOrder</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"wamasysApp.individualMeter.modelMeter\">modelMeter</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"individualMeter in vm.individualMeters track by individualMeter.id\"><td><a ui-sref=\"individual-meter-detail({id:individualMeter.id})\">{{individualMeter.numeroSerie}}</a></td><td translate=\"{{\'wamasysApp.EtatMeter.\' + individualMeter.etat}}\">{{individualMeter.etat}}</td><td><a ui-sref=\"cluster-detail({id:individualMeter.cluster.id})\">{{individualMeter.cluster.numeroSerie}}</a></td><td>{{individualMeter.runningOrder}}</td><td>{{individualMeter.modelMeter.label}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"individual-meter-detail({id:individualMeter.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"compteur.individual-meter.edit({id:individualMeter.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"compteur.individual-meter.delete({id:individualMeter.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/individual-meter/individual-meters.html","<div><h2 translate=\"wamasysApp.individualMeter.meters\">Compteurs</h2><jhi-alert></jhi-alert><uib-tabset active=\"active\"><uib-tab ui-sref-active=\"active\" ui-sref=\"compteur.individual-meter\"><uib-tab-heading><span translate=\"wamasysApp.individualMeter.home.title\">Individual Meter</span></uib-tab-heading></uib-tab><uib-tab ui-sref-active=\"active\" ui-sref=\"compteur.bulk-meter\"><uib-tab-heading><span translate=\"wamasysApp.bulkMeter.home.title\">Bulk Meter</span></uib-tab-heading></uib-tab><uib-tab ui-sref-active=\"active\" ui-sref=\"compteur.cluster\"><uib-tab-heading><span translate=\"wamasysApp.cluster.home.title\">Cluster</span></uib-tab-heading></uib-tab></uib-tabset><div ui-view=\"panneau@content\"></div></div>");
$templateCache.put("app/business/expense/expense-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.expense.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.expense.delete.question\" translate-values=\"{id: \'{{vm.expense.id}}\'}\">Are you sure you want to delete this Expense?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/expense/expense-detail.html","<div><h2><span translate=\"wamasysApp.expense.detail.title\">Expense</span> {{vm.expense.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.expense.date\">date</span></dt><dd><span>{{vm.expense.date | date:\'mediumDate\'}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.expense.label\">Libelle</span></dt><dd><span>{{vm.expense.label}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.expense.expenseType\">expenseType</span></dt><dd><span>{{vm.expense.expenseType.label}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.expense.comment\">comment</span></dt><dd><textarea readonly=\"readonly\" style=\"width: 100%\" rows=\"5\">{{vm.expense.comment}}</textarea></dd><hr><dt><span translate=\"wamasysApp.expense.amountInclTaxes\">amountInclTaxes</span></dt><dd><span>{{vm.expense.amountInclTaxes}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.expense.amountExclTaxes\">amountExclTaxes</span></dt><dd><span>{{vm.expense.amountExclTaxes}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.expense.taxes\">taxes</span></dt><dd><span>{{vm.expense.taxes}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.expense.calculatedTax\">calculatedTax</span></dt><dd><span>{{vm.expense.taxRate}} %<span></span></span></dd><hr><!--         <dt><span translate=\"global.field.dateCreation\">DateCreation</dt></dt>\r\n        <dd>\r\n            <span>{{vm.expense }} {{vm.expense.createdDate | date:\'medium\'}} by {{vm.expense.createdBy}}<span>\r\n        </dd>\r\n        <hr> --></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/expense/expense-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myExpenseLabel\" translate=\"wamasysApp.expense.home.createOrEditLabel\">Create or edit a Expense</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!--         <div class=\"form-group\">\r\n            <label for=\"id\" translate=\"global.field.id\">ID</label>\r\n            <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"\r\n                    ng-model=\"vm.expense.id\" readonly />\r\n        </div> --><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.expense.label\" for=\"field_label\">Libelle</label><input type=\"text\" class=\"form-control\" name=\"label\" id=\"field_label\" ng-model=\"vm.expense.label\" required ng-maxlength=\"50\"><div ng-show=\"editForm.label.$invalid\"><p class=\"help-block\" ng-show=\"editForm.label.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.label.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><div class=\"input-group\"><input placeholder=\"{{ \'wamasysApp.expense.date\' | translate }}\" id=\"field_date\" type=\"text\" class=\"form-control\" name=\"date\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.expense.date\" is-open=\"vm.datePickerOpenStatus.date\" required ng-click=\"vm.openCalendar(\'date\')\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'date\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.date.$invalid\"><p class=\"help-block\" ng-show=\"editForm.date.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.expense.expenseType\" for=\"field_expenseType\">expenseType</label><select required class=\"form-control\" id=\"field_expenseType\" name=\"expenseType\" ng-model=\"vm.expense.expenseType\" ng-options=\"expenseType as expenseType.label for expenseType in vm.expenseTypes track by expenseType.id\"><option value=\"\"></option></select><div ng-show=\"editForm.expenseType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.expenseType.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.expense.comment\" for=\"field_comment\">comment</label><textarea class=\"form-control\" name=\"comment\" id=\"field_comment\" ng-model=\"vm.expense.comment\" rows=\"3\" ng-maxlength=\"512\"></textarea><div ng-show=\"editForm.comment.$invalid\"><p class=\"help-block\" ng-show=\"editForm.comment.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"512\">This field cannot be longer than 512 characters.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.expense.amountInclTaxes\" for=\"field_amountInclTaxes\">amountInclTaxes</label><input required ng-change=\"vm.changeAmountInclTaxes()\" id=\"field_amountInclTaxes\" type=\"number\" min=\"0\" step=\".01\" class=\"form-control\" name=\"amountInclTaxes\" ng-model=\"vm.expense.amountInclTaxes\"><div ng-show=\"editForm.amountInclTaxes.$invalid\"><p class=\"help-block\" ng-show=\"editForm.amountInclTaxes.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.amountInclTaxes.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.expense.typeTaxs\" for=\"field_typeTaxs\">typeTaxs</label><select class=\"form-control\" id=\"field_typeTaxs\" ng-model=\"vm.taxeSelected\" ng-change=\"vm.selectTax()\" ng-options=\"typeTax as typeTax.label for typeTax in vm.typeTaxs track by typeTax.id\"><option value=\"\"></option></select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.expense.calculatedTax\">taxe calculé</label><input class=\"form-control\" disabled=\"true\" id=\"field_typeTaxs\" ng-value=\"vm.taxRate\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.expense.amountExclTaxes\" for=\"field_amountExclTaxes\">amountExclTaxes</label><input required ng-change=\"vm.changeAmountExclTaxes()\" id=\"field_amountExclTaxes\" type=\"number\" min=\"0\" step=\".01\" class=\"form-control\" name=\"amountExclTaxes\" ng-model=\"vm.expense.amountExclTaxes\"><div ng-show=\"editForm.amountExclTaxes.$invalid\"><p class=\"help-block\" ng-show=\"editForm.amountExclTaxes.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.amountExclTaxes.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"wamasysApp.expense.taxes\" for=\"field_taxes\">taxes</label><input required ng-change=\"vm.changeTaxes()\" id=\"field_taxes\" type=\"number\" min=\"0\" step=\".01\" class=\"form-control\" name=\"taxes\" ng-model=\"vm.expense.taxes\"><div ng-show=\"editForm.taxes.$invalid\"><p class=\"help-block\" ng-show=\"editForm.taxes.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.taxes.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p></div></div></div></div><!--    <div class=\"form-group\" ng-if=\"vm.expense.id\">\r\n            <label class=\"control-deleted\" translate=\"global.field.isDeleted\" for=\"field_deleted\">deleted</label>\r\n              <input type=\"checkbox\"  class=\"form-control\" name=\"deleted\" id=\"field_deleted\" ng-model=\"vm.expense.deleted\"/>\r\n        </div>\r\n --></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/expense/expenses.html","<div><h2 translate=\"wamasysApp.expense.home.title\">Expenses</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"expense.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.expense.home.createLabel\">Create new Expense</span></button></div></div></div><!--     \r\n    <div class=\"container-fluid \">\r\n	<form name=\"searchForm\" class=\"smart-form form-inline\">\r\n		<fieldset>\r\n			<div class=\"row\">\r\n				<div class=\"col-md-5\">\r\n					<div class=\"row\">\r\n					<label class=\"label col-md-4\"\r\n						translate=\"wamasysApp.eventForm.text\">Text</label>\r\n					<section class=\" col-md-8\">\r\n						<input type=\"text\"  ng-model=\"vm.searchText\"\r\n							id=\"searchText\" class=\"form-control\"\r\n							placeholder=\"{{ \'wamasysApp.eventForm.textPlaceholder\' | translate }}\"> \r\n							</section>\r\n					</div>\r\n				</div>\r\n				<div class=\"col-md-5\">\r\n					<label class=\"control-label col-md-4\" for=\"daterange1\" translate=\"wamasysApp.eventForm.dateRecord\">Date  </label>\r\n					<div class=\"col-md-8\">\r\n						<div class=\"input-group\">\r\n							<input date-range-picker id=\"daterange1\" name=\"daterange1\"\r\n								class=\"form-control date-picker\" type=\"text\"\r\n								ng-model=\"vm.date\" options=\"vm.opts\" placeholder=\"yyyy-mm-dd - yyyy-mm-dd\"/>\r\n						\r\n						</div>\r\n					</div>\r\n				</div>\r\n			</div>\r\n			<div class=\"row\">\r\n				<div class=\"col-md-5\">\r\n					<div class=\"row\">\r\n						<label class=\"label col-md-4\" translate=\"wamasysApp.eventForm.category\" >Category</label>\r\n						<section class=\" col-md-8\">\r\n							<label class=\"\"> \r\n								<select  class=\"form-control\"  ng-change=\"vm.updateSubCategory()\"\r\n									id=\"field_category\" name=\"category\" ng-model=\"vm.category\"\r\n									ng-options=\"listCategory as listCategory.label for listCategory in vm.listCategory track by listCategory.id\">\r\n										<option value=\"\"></option>\r\n								</select>\r\n							</label>\r\n						</section>\r\n					</div>\r\n				</div>\r\n				<div class=\"col-md-5\">\r\n					<div class=\"row\">\r\n						<label class=\"label col-md-4\" translate=\"wamasysApp.eventForm.subCategory\" >subCategory</label>\r\n						<section class=\" col-md-8\">\r\n							<label class=\"\"> \r\n								<select  class=\"form-control\"\r\n									id=\"field_subCategory\" name=\"subCategory\" ng-model=\"vm.subCategory\"\r\n									ng-options=\"listSubCategory as listSubCategory.label for listSubCategory in vm.listSubCategory track by listSubCategory.id\">\r\n										<option value=\"\"></option>\r\n								</select>\r\n							</label>\r\n						</section>\r\n					</div>\r\n				</div>\r\n\r\n					<div class=\"col-md-2\">\r\n						<div class=\"pull-right\">\r\n						<button class=\"btn btn-primary\" ng-click=\"vm.search()\">search</button>\r\n						<button  class=\"  btn btn-primary\" ng-click=\"vm.clear()\" ng-if=\"vm.currentSearch\">reset</button>\r\n						<button class=\"btn btn-primary\" ng-click=\"vm.download()\">Donwload</button>\r\n					</div>\r\n				</div>\r\n			</div>\r\n		</fieldset>\r\n	</form>\r\n</div> --><div class=\"container-fluid\"><div class=\"pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.download()\">Download</button></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"date\"><span translate=\"wamasysApp.expense.date\">date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"label\"><span translate=\"wamasysApp.expense.label\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"expenseType\"><span translate=\"wamasysApp.expense.expenseType\">expenseType</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"amountInclTaxes\"><span translate=\"wamasysApp.expense.amountInclTaxes\">amountInclTaxes</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"amountExclTaxes\"><span translate=\"wamasysApp.expense.amountExclTaxes\">amountExclTaxes</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taxes\"><span translate=\"wamasysApp.expense.taxes\">taxes</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"expense in vm.expenses track by expense.id\"><td><a ui-sref=\"expense-detail({id:expense.id})\">{{expense.date | date:\'mediumDate\'}}</a></td><td>{{expense.label}}</td><td>{{expense.expenseType.label}}</td><td>{{expense.amountInclTaxes}}</td><td>{{expense.amountExclTaxes}}</td><td>{{expense.taxes}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"expense-detail({id:expense.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"expense.edit({id:expense.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"expense.delete({id:expense.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/importation/importation.html","<div class=\"container-fluid\"><h2 translate=\"wamasysApp.importation.title\">Importation des données</h2><jhi-alert></jhi-alert><div class=\"alerts\" ng-show=\"vm.businessAlert\"><div class=\"alert.toast top right\"><div class=\"alert alert-danger alert-dismissible\" role=\"alert\" type=\"danger\"><button type=\"button\" class=\"close\" aria-hidden=\"false\"><span aria-hidden=\"true\">×</span> <span class=\"sr-only\">Close</span></button><div><pre>{{vm.businessAlert}}</pre></div></div></div></div><style>.panel-title > a:before {\n        font-family: FontAwesome;\n        content: \"\\f068\";\n        padding-right: 5px;\n    }\n    .panel-title > a.collapsed:before {\n        content: \"\\f067\";\n    }</style><div id=\"importLineContractPanel\" data-jarvis-widget data-widget-colorbutton=\"false\" data-widget-editbutton=\"false\" data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"><header><span class=\"widget-icon\"><i class=\"fa fa-upload\"></i></span><h2 translate=\"wamasysApp.importation.lineContract.title\"></h2><div class=\"jarviswidget-ctrls panel-title\" role=\"menu\"><a class=\"collapsed\" data-toggle=\"collapse\" data-target=\"#collapseImportLineContractPanel\" aria-expanded=\"false\" aria-controls=\"collapseImportLineContractPanel\" data-placement=\"bottom\"></a></div></header><div><div class=\"widget-body collapse\" id=\"collapseImportLineContractPanel\" aria-expanded=\"false\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">File input</label><div class=\"col-md-6\"><input type=\"file\" class=\"btn btn-default\" file-model=\"fileToImportLineContract\" ng-value=\"fileToImportLineContract\" value=\"{{fileToImportLineContract}}\" set-file-data=\"fileToImportLineContract = value;\"></div><div class=\"col-md-2\"><button ng-click=\"vm.importLineContract()\">upload</button></div></div></div></div><hr><h3 translate=\"wamasysApp.importation.lineContract.descriptionTitle\"></h3><p translate=\"wamasysApp.importation.lineContract.description\"></p><h3 translate=\"wamasysApp.importation.rulesTitle\"></h3><div translate=\"wamasysApp.importation.rules\"></div><h3 translate=\"wamasysApp.importation.format\"></h3><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th>Column</th><th>Field</th><th>Mandatory</th><th>Format / rules</th></tr></thead><tbody><tr><td>A</td><td>codeArea</td><td>Yes</td><td>Agency code in Wamasys</td></tr><tr><td>B</td><td>RefContract</td><td>Yes</td><td>Existing contract reference</td></tr><tr><td>C</td><td>codeServiceVendu</td><td>Yes</td><td>Existing sold service code for the same area</td></tr><tr><td>D</td><td>InvoiceLabel</td><td>Yes</td><td>Invoice label saved on the line</td></tr><tr><td>E</td><td>activation date</td><td>Yes</td><td>Date format yyyy-mm-dd, yyyy/mm/dd, dd-mm-yyyy or dd/mm/yyyy</td></tr><tr><td>F</td><td>quantity</td><td>Yes for one-time services</td><td>Use only with unit price</td></tr><tr><td>G</td><td>unit price</td><td>Yes for one-time services</td><td>Decimal number with \".\" separator</td></tr><tr><td>H</td><td>total credit amount</td><td>Yes for installment services</td><td>Use only with amount per installment</td></tr><tr><td>I</td><td>amount per installment</td><td>Yes for installment services</td><td>Decimal number with \".\" separator</td></tr></tbody></table></div></div></div><div id=\"importWaterConsumptionCorrectionPanel\" data-jarvis-widget data-widget-colorbutton=\"false\" data-widget-editbutton=\"false\" data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"><header><span class=\"widget-icon\"><i class=\"fa fa-upload\"></i></span><h2 translate=\"wamasysApp.importation.waterConsumptionCorrection.title\"></h2><div class=\"jarviswidget-ctrls panel-title\" role=\"menu\"><a class=\"collapsed\" data-toggle=\"collapse\" data-target=\"#collapseImportWaterConsumptionCorrectionPanel\" aria-expanded=\"false\" aria-controls=\"collapseImportWaterConsumptionCorrectionPanel\" data-placement=\"bottom\"></a></div></header><div><div class=\"widget-body collapse\" id=\"collapseImportWaterConsumptionCorrectionPanel\" aria-expanded=\"false\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">File input</label><div class=\"col-md-6\"><input type=\"file\" class=\"btn btn-default\" file-model=\"fileToImportWaterConsumptionCorrection\" ng-value=\"fileToImportWaterConsumptionCorrection\" value=\"{{fileToImportWaterConsumptionCorrection}}\" set-file-data=\"fileToImportWaterConsumptionCorrection = value;\"></div><div class=\"col-md-2\"><button ng-click=\"vm.importWaterConsumptionCorrection()\">upload</button></div></div></div></div><hr><h3 translate=\"wamasysApp.importation.waterConsumptionCorrection.descriptionTitle\"></h3><p translate=\"wamasysApp.importation.waterConsumptionCorrection.description\"></p><h3 translate=\"wamasysApp.importation.rulesTitle\"></h3><div translate=\"wamasysApp.importation.rules\"></div><h3 translate=\"wamasysApp.importation.format\"></h3><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th>Column</th><th>Field</th><th>Mandatory</th><th>Format / rules</th></tr></thead><tbody><tr><td>A</td><td>codeArea</td><td>Yes</td><td>Agency code in Wamasys</td></tr><tr><td>B</td><td>RefContrat</td><td>Yes</td><td>Existing contract reference</td></tr><tr><td>C</td><td>date debut</td><td>Yes</td><td>Date format yyyy-mm-dd, yyyy/mm/dd, dd-mm-yyyy or dd/mm/yyyy</td></tr><tr><td>D</td><td>date fin</td><td>Yes</td><td>Must be greater than or equal to start date</td></tr><tr><td>E</td><td>valeur</td><td>Yes</td><td>Signed decimal number with \".\" separator, cannot be 0</td></tr><tr><td>F</td><td>Commentaire</td><td>Yes</td><td>Reason of the correction</td></tr></tbody></table></div></div></div><div id=\"majGPSCoordonneesPanel\" data-jarvis-widget data-widget-colorbutton=\"false\" data-widget-editbutton=\"false\" data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"><header><span class=\"widget-icon\"><i class=\"fa fa-upload\"></i> </span><!-- 			<h2 translate=\"wamasysApp.contrat.majGPSCoordonnees\">majGPSCoordonnees</h2> --><h2 translate=\"wamasysApp.importation.coordinateContract.title\">Mise à jour des Coordonnées GPS sur contrat</h2><div class=\"jarviswidget-ctrls panel-title\" role=\"menu\"><a class=\"collapsed\" data-toggle=\"collapse\" data-target=\"#collapsemajGPSCoordonneesPanel\" aria-expanded=\"false\" aria-controls=\"collapsemajGPSCoordonneesPanel\" data-placement=\"bottom\"></a></div></header><div><div class=\"widget-body collapse\" id=\"collapsemajGPSCoordonneesPanel\" aria-expanded=\"false\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">File input</label><div class=\"col-md-6\"><input type=\"file\" class=\"btn btn-default\" file-model=\"fileToUploadGPSCoordonnees\" ng-value=\"fileToUploadGPSCoordonnees\" value=\"{{fileToUploadGPSCoordonnees}}\" set-file-data=\"fileToUploadGPSCoordonnees = value;\"></div><div class=\"col-md-2\"><button ng-click=\"vm.uploadFileUpdateContract()\">upload</button></div></div></div></div><hr><h3 translate=\"wamasysApp.importation.coordinateContract.descriptionTitle\">Présentation</h3><p translate=\"wamasysApp.importation.coordinateContract.description\">Cet écran vous permet de mettre à jour les coordonnées GPS sur des contrats existants.</p><h3 translate=\"wamasysApp.importation.rulesTitle\">Règles</h3><div translate=\"wamasysApp.importation.rules\"><p>Le fichier ne doit pas contenir plus de 10 000 lignes.<br>Une erreur est soulevée si une référence de contrat n\'est pas trouvée en base.<br>En cas d\'erreur sur une ligne, toutes les modifications sont annulées y compris pour les lignes précédentes.<br>La première ligne du fichier est ignorée, elle sert aux entêtes de colonne.</p></div><h3 translate=\"wamasysApp.importation.format\">Format du fichier</h3><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th>Column</th><th>Field</th><th>Mandatory</th><th>Format / rules</th></tr></thead><tbody><tr></tr><tr><td>A</td><td>Contrat number</td><td>Yes</td><td></td></tr><tr><td>B</td><td>Latitude</td><td>Yes</td><td>Number with decimal, separator \".\" Example 1.2342342342</td></tr><tr><td>C</td><td>Longitude</td><td>Yes</td><td>Number with decimal, separator \".\" Example 1.2342342342</td></tr></tbody></table></div></div></div><div id=\"importServiceCloseOrStandbyOnContracts\" data-jarvis-widget data-widget-colorbutton=\"false\" data-widget-editbutton=\"false\" data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"><header><span class=\"widget-icon\"><i class=\"fa fa-upload\"></i></span><h2 translate=\"wamasysApp.importation.serviceCloseOrStandbyOnContracts.title\">Import des services à fermer ou mettre en pause sur les contrats</h2><div class=\"jarviswidget-ctrls panel-title\" role=\"menu\"><a class=\"collapsed\" data-toggle=\"collapse\" data-target=\"#collapseimportServiceCloseOrStandbyOnContracts\" aria-expanded=\"false\" aria-controls=\"collapseimportServiceCloseOrStandbyOnContracts\" data-placement=\"bottom\"></a></div></header><div><div class=\"widget-body collapse\" id=\"collapseimportServiceCloseOrStandbyOnContracts\" aria-expanded=\"false\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">File input</label><div class=\"col-md-6\"><input type=\"file\" class=\"btn btn-default\" file-model=\"fileToImportServiceCloseOrStandbyOnContracts\" ng-value=\"fileToImportServiceCloseOrStandbyOnContracts\" value=\"{{fileToImportServiceCloseOrStandbyOnContracts}}\" set-file-data=\"fileToImportServiceCloseOrStandbyOnContracts = value;\"></div><div class=\"col-md-2\"><button ng-click=\"vm.importServiceCloseOrStandbyOnContracts()\">upload</button></div></div></div></div><hr><h3 translate=\"wamasysApp.importation.serviceCloseOrStandbyOnContracts.descriptionTitle\">Présentation</h3><p translate=\"wamasysApp.importation.serviceCloseOrStandbyOnContracts.description\">Cet écran vous permet de mettre à jour les coordonnées GPS sur des contrats existants.</p><h3 translate=\"wamasysApp.importation.rulesTitle\">Règles</h3><div translate=\"wamasysApp.importation.rules\"><p>Le fichier ne doit pas contenir plus de 10 000 lignes.<br>Une erreur est soulevée si une référence de contrat n\'est pas trouvée en base.<br>En cas d\'erreur sur une ligne, toutes les modifications sont annulées y compris pour les lignes précédentes.<br>La première ligne du fichier est ignorée, elle sert aux entêtes de colonne.</p></div><h3 translate=\"wamasysApp.importation.format\">Format du fichier</h3><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th>Column</th><th>Field</th><th>Mandatory</th><th>Format / rules</th></tr></thead><tbody><tr><td>A</td><td>Contract number</td><td>No</td><td>This column is not used by Wamasys, no control or rule applied is done on it, it is just to help you find your data in the CSV file</td></tr><tr><td>B</td><td>Contract service Id</td><td>Yes</td><td></td></tr><tr><td>C</td><td>Actions</td><td>Yes</td><td>Only the following values are allowed: CLOSE, STANDBY_ON, STANDBY_OFF</td></tr></tbody></table></div></div></div><div id=\"importCreditNote\" data-jarvis-widget data-widget-colorbutton=\"false\" data-widget-editbutton=\"false\" data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"><header><span class=\"widget-icon\"><i class=\"fa fa-upload\"></i> </span><!-- 			<h2 translate=\"wamasysApp.contrat.majGPSCoordonnees\">majGPSCoordonnees</h2> --><h2 translate=\"wamasysApp.importation.importCreditNote.title\">Import des balance transfers</h2><div class=\"jarviswidget-ctrls panel-title\" role=\"menu\"><a class=\"collapsed\" data-toggle=\"collapse\" data-target=\"#collapseimportCreditNote\" aria-expanded=\"false\" aria-controls=\"collapseimportCreditNote\" data-placement=\"bottom\"></a></div></header><div><div class=\"widget-body collapse\" id=\"collapseimportCreditNote\" aria-expanded=\"false\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">File input</label><div class=\"col-md-6\"><input type=\"file\" class=\"btn btn-default\" file-model=\"fileToImportCreditNote\" ng-value=\"fileToImportCreditNote\" value=\"{{fileToImportCreditNote}}\" set-file-data=\"fileToImportCreditNote = value;\"></div><div class=\"col-md-2\"><button ng-click=\"vm.importCreditNote()\">upload</button></div></div></div></div><hr><h3 translate=\"wamasysApp.importation.importCreditNote.descriptionTitle\">Présentation</h3><p translate=\"wamasysApp.importation.importCreditNote.description\">Cet écran vous permet de mettre à jour les coordonnées GPS sur des contrats existants.</p><h3 translate=\"wamasysApp.importation.rulesTitle\">Règles</h3><div translate=\"wamasysApp.importation.rules\"><p>Le fichier ne doit pas contenir plus de 10 000 lignes.<br>Une erreur est soulevée si une référence de contrat n\'est pas trouvée en base.<br>En cas d\'erreur sur une ligne, toutes les modifications sont annulées y compris pour les lignes précédentes.<br>La première ligne du fichier est ignorée, elle sert aux entêtes de colonne.</p></div><h3 translate=\"wamasysApp.importation.format\">Format du fichier</h3><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th>Column</th><th>Field</th><th>Mandatory</th><th>Format / rules</th></tr></thead><tbody><tr></tr><tr><td>A</td><td>Contract number</td><td>No</td><td>This column is not used by Wamasys, no control or rule applied are done on it, it is just to help you find your data in the CSV file</td></tr><tr><td>B</td><td>type</td><td>Yes</td><td>CREDIT_NOTE,DISCOUNT,DEBT_WAIVER,WINDFALL_GAIN</td></tr><tr><td>C</td><td>Contrat service Id</td><td>Yes</td><td></td></tr><tr><td>D</td><td>Amount (incl taxes)</td><td>Yes</td><td>Number with decimal, separator \".\" Example 1.2342342342</td></tr><tr><td>E</td><td>Label</td><td>Yes</td><td></td></tr><tr><td>F</td><td>Comment</td><td>Yes</td><td></td></tr><tr><td>G</td><td>typeAvoirId</td><td>Yes if type is CREDIT_NOTE</td><td></td></tr><tr><td>H</td><td>typeRemisecommercialeId</td><td>Yes if type is DISCOUNT</td><td></td></tr></tbody></table></div></div></div><div id=\"importBalanceTransfer\" data-jarvis-widget data-widget-colorbutton=\"false\" data-widget-editbutton=\"false\" data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"><header><span class=\"widget-icon\"><i class=\"fa fa-upload\"></i></span><h2 translate=\"wamasysApp.importation.balanceTransfer.title\">Import des balance transfers</h2><div class=\"jarviswidget-ctrls panel-title\" role=\"menu\"><a class=\"collapsed\" data-toggle=\"collapse\" data-target=\"#collapseimportBalanceTransfer\" aria-expanded=\"false\" aria-controls=\"collapseimportBalanceTransfer\" data-placement=\"bottom\"></a></div></header><div><div class=\"widget-body collapse\" id=\"collapseimportBalanceTransfer\" aria-expanded=\"false\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">File input</label><div class=\"col-md-6\"><input type=\"file\" class=\"btn btn-default\" file-model=\"fileToImportBalanceTransfer\" ng-value=\"fileToImportBalanceTransfer\" value=\"{{fileToImportBalanceTransfer}}\" set-file-data=\"fileToImportBalanceTransfer = value;\"></div><div class=\"col-md-2\"><button ng-click=\"vm.importBalanceTransfer()\">upload</button></div></div></div></div><hr><h3 translate=\"wamasysApp.importation.balanceTransfer.descriptionTitle\">Présentation</h3><p translate=\"wamasysApp.importation.balanceTransfer.description\">Cet écran vous permet de mettre à jour les coordonnées GPS sur des contrats existants.</p><h3 translate=\"wamasysApp.importation.rulesTitle\">Règles</h3><div translate=\"wamasysApp.importation.rules\"><p>Le fichier ne doit pas contenir plus de 10 000 lignes.<br>Une erreur est soulevée si une référence de contrat n\'est pas trouvée en base.<br>En cas d\'erreur sur une ligne, toutes les modifications sont annulées y compris pour les lignes précédentes.<br>La première ligne du fichier est ignorée, elle sert aux entêtes de colonne.</p></div><h3 translate=\"wamasysApp.importation.format\">Format du fichier</h3><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th>Column</th><th>Field</th><th>Mandatory</th><th>Format / rules</th></tr></thead><tbody><tr><td>A</td><td>Contract number</td><td>No</td><td>This column is not used by Wamasys, no control or rule applied is done on it, it is just to help you find your data in the CSV file</td></tr><tr><td>B</td><td>Contract service Id to be debited</td><td>Yes</td><td></td></tr><tr><td>C</td><td>Contract service Id to be credited</td><td>Yes</td><td></td></tr><tr><td>D</td><td>Amount (incl taxes)</td><td>Yes</td><td>Number with decimal, separator \".\" Example 1.2342342342</td></tr><tr><td>E</td><td>Comment</td><td>Yes</td><td></td></tr></tbody></table></div></div></div><div id=\"searchPanel\" has-any-authority=\"ROLE_SUPER_ADMIN\" data-jarvis-widget data-widget-colorbutton=\"false\" data-widget-editbutton=\"false\" data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"><header><span class=\"widget-icon\"><i class=\"fa fa-upload\"></i></span><h2 translate=\"wamasysApp.importation.contract.title\"></h2><div class=\"jarviswidget-ctrls panel-title\" role=\"menu\"><a class=\"collapsed\" data-toggle=\"collapse\" data-target=\"#collapsePanel\" aria-expanded=\"false\" aria-controls=\"collapsePanel\" data-placement=\"bottom\"></a></div></header><div><div class=\"widget-body collapse\" id=\"collapsePanel\" aria-expanded=\"false\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">File input</label><div class=\"col-md-6\"><input type=\"file\" class=\"btn btn-default\" file-model=\"fileToUpload\" ng-value=\"fileToUpload\" value=\"{{fileToUpload}}\" set-file-data=\"fileToUpload = value;\"></div><div class=\"col-md-2\"><button ng-click=\"vm.uploadFile()\">upload</button></div></div></div></div><hr><h3 translate=\"wamasysApp.importation.contract.descriptionTitle\">Présentation</h3><p translate=\"wamasysApp.importation.contract.description\">Cet écran vous permet d\'importer un ensemble de contrat et leur compteur depuis un fichier au format CSV.</p><h3 translate=\"wamasysApp.importation.contract.rules\">Règles</h3><div class=\"\"><p translate=\"wamasysApp.importation.rules\"></p><p>Les données : cluster, modele de contrat, portefeuille de contrat et type de contrat doivent être créés au préalable.<br>Dans le fichier CSV vous devez renseigner les ID, ceux-ci sont visibles dans l\'URL de Wamasys lorsque vous consultez la page détail d\'une entité. (ex : https://app.wamasys.com/#/portefeuille-contrat/5, l\'id du porteuille est 5)</p><p>Lors de la création des	compteurs, la dernière valeur et la date de lecture sont utilisées comme valeur initiale et date d\'activation.<br>La référence du contrat sera créée automatique, tous les contrats et les compteurs individuels sont enregistrés à l\'état actif.</p></div><h3>Format du fichier</h3><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th>Colonne</th><th>Champ</th><th>Obligtoire</th><th>Format/règle</th></tr></thead><tbody><tr></tr><tr><td>A</td><td>Code modeleContrat</td><td>Oui</td><td></td></tr><tr><td>B</td><td>Code portefeuillecontrat</td><td>Oui</td><td></td></tr><tr><td>C</td><td>Code ContractType (type de contrat)</td><td>Oui</td><td></td></tr><tr><td>D</td><td>Code ContractProfil (type de profil)</td><td>Oui</td><td></td></tr><tr><td>E</td><td>ancienneReferenceContrat</td><td>Non</td><td>max 255 caractères</td></tr><tr><td>F</td><td>Nom</td><td>Oui</td><td>max 50 caractères</td></tr><tr><td>G</td><td>adresse</td><td>Oui</td><td>max 256 caractères</td></tr><tr><td>H</td><td>phone</td><td>Non</td><td>max 30 caractères</td></tr><tr><td>I</td><td>email</td><td>Non</td><td>max 256 caractères</td></tr><tr><td>J</td><td>Nbr famille</td><td>Oui</td><td>numerique,max 999999</td></tr><tr><td>K</td><td>Nbr personne</td><td>Oui</td><td>numerique,max 999999</td></tr><tr><td>L</td><td>indexAdresse</td><td>Non</td><td>numerique, max 999999</td></tr><tr><td>M</td><td>Contrat date activtation</td><td>Oui</td><td>format(yyyy/mm/dd)</td></tr><tr><td>N</td><td>Commentaire</td><td>Non</td><td>max 256 caractères</td></tr><tr><td>O</td><td>individual meter numeroserie</td><td>Non</td><td>max 256 caractère.(facultatif, si vide le contrat ne sera relié à aucun compteur)</td></tr><tr><td>P</td><td>individual meter Code cluster</td><td>Non (obligatoire si numeroserie compteur renseigné)</td><td>numerique</td></tr><tr><td>Q</td><td>individual meter ordre de passage</td><td>Non (obligatoire si numeroserie compteur renseigné)</td><td>max 10 caractères</td></tr><tr><td>R</td><td>individual meter dernier valeur connue</td><td>Non (obligatoire si numeroserie compteur renseigné)</td><td>numerique avec 3 decimales, séprateur point (.) max 999999999999L</td></tr><tr><td>S</td><td>individual meter date mise en service</td><td>Non (obligatoire si numeroserie compteur renseigné)</td><td>Date format yyyy/mm/dd</td></tr><tr><td>T</td><td>individual meter longitude</td><td>Non</td><td>max 20 caractères</td></tr><tr><td>U</td><td>individual meter latitude</td><td>Non</td><td>max 20 caractères</td></tr><tr><td>V</td><td>individual meter commentaire</td><td>Non</td><td>max 256 caractères</td></tr><tr><td>W</td><td>individual meter Dev EUI (numéro de serie du module Smart meter)</td><td>Non , si cette colonne est remplie le meter est de type Smart meter et le model est du MBus MBUS_DIEHL_IZAR_RC_I_R4</td><td>max 256 caractères</td></tr><tr><td>X</td><td>individual meter app key (clé de chiffrement)</td><td>Non</td><td>max 256 caractères</td></tr><tr><td>Y</td><td>Reprise de solde</td><td>Non</td><td>Si elle est renseignée et différente de 0 alors le contrat est mis en facturation et une ligne reprise de solde est ajoutée sur le 1er service du contrat. Valeur numérique uniquement avec si décimal un point en séparateur.</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/business/importation/io-mobile-money.html","<div class=\"container-fluid\"><h2>Exportation et importation des paiements mobile money</h2><jhi-alert></jhi-alert><div class=\"alert\" ng-show=\"vm.businessInfo\"><div class=\"alert.toast top right\"><div class=\"alert alert-success alert-dismissible\" role=\"alert\" type=\"success\"><button type=\"button\" class=\"close\" aria-hidden=\"false\"><span aria-hidden=\"true\">×</span> <span class=\"sr-only\">Close</span></button><div><pre>{{vm.businessInfo}}</pre></div></div></div></div><div class=\"alerts\" ng-show=\"vm.businessAlert\"><div class=\"alert.toast top right\"><div class=\"alert alert-danger alert-dismissible\" role=\"alert\" type=\"danger\"><button type=\"button\" class=\"close\" aria-hidden=\"false\"><span aria-hidden=\"true\">×</span> <span class=\"sr-only\">Close</span></button><div><pre>{{vm.businessAlert}}</pre></div></div></div></div><style>.panel-title > a:before {\r\n        font-family: FontAwesome;\r\n        content: \"\\f068\";\r\n        padding-right: 5px;\r\n    }\r\n    .panel-title > a.collapsed:before {\r\n        content: \"\\f067\";\r\n    }</style><div class=\"row\"><div class=\"col-md-12\"><button class=\"btn btn-primary\" ng-click=\"vm.download()\"><span class=\"glyphicon glyphicon-download\"></span> <span>Télécharger la liste des impayés pour transfert aux providers Mobile money.</span></button></div></div><hr><div id=\"importMobileMoney\" data-jarvis-widget data-widget-colorbutton=\"false\" data-widget-editbutton=\"false\" data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"><header><span class=\"widget-icon\"><i class=\"fa fa-upload\"></i></span><h2 translate=\"wamasysApp.importation.importMobileMoney.title\">Import mobile money</h2><div class=\"jarviswidget-ctrls panel-title\" role=\"menu\"><a class=\"\" data-toggle=\"collapse\" data-target=\"#collapseimportCreditNote\" aria-expanded=\"true\" aria-controls=\"collapseimportCreditNote\" data-placement=\"bottom\"></a></div></header><div><div class=\"widget-body\" id=\"collapseimportCreditNote\" aria-expanded=\"true\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">File input</label><div class=\"col-md-6\"><input type=\"file\" class=\"btn btn-default\" file-model=\"fileToImportCreditNote\" ng-value=\"fileToImportCreditNote\" value=\"{{fileToImportCreditNote}}\" set-file-data=\"fileToImportCreditNote = value;\"></div><div class=\"col-md-2\"><button ng-click=\"vm.importCreditNote()\">upload</button></div></div></div></div><hr><h3 translate=\"wamasysApp.importation.importMobileMoney.descriptionTitle\">Présentation</h3><p translate=\"wamasysApp.importation.importMobileMoney.description\">Cet écran vous permet de mettre à jour les coordonnées GPS sur des contrats existants.</p><h3 translate=\"wamasysApp.importation.rulesTitle\">Règles</h3><div translate=\"wamasysApp.importation.rules\"><p>Le fichier ne doit pas contenir plus de 10 000 lignes.<br>Une erreur est soulevée si une référence de contrat n\'est pas trouvée en base.<br>En cas d\'erreur sur une ligne, toutes les modifications sont annulées y compris pour les lignes précédentes.<br>La première ligne du fichier est ignorée, elle sert aux entêtes de colonne.</p></div><h3 translate=\"wamasysApp.importation.format\">Format du fichier</h3><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th>Column</th><th>Field</th><th>Mandatory</th><th>Format / rules</th></tr></thead><tbody><tr></tr><tr><td>A</td><td>Type de ligne</td><td>Yes</td><td>Seules les lignes ayant la valeur 2 dans cette colonne sont lues.</td></tr><tr><td>B</td><td>Numéro de facture</td><td>No</td><td>Cette donnée est stockée dans les metadatas du paiement mais pas exploitée dans les règles d\'enregistrement.</td></tr><tr><td>C</td><td>Référence contrat</td><td>Yes</td><td>Indique la référence du contrat (ancienne ou nouvelle), cette donnée sert à trouver le contrat sur lequel le paiement sera enregistré</td></tr><tr><td>D</td><td>Date de paiement</td><td>Yes</td><td>Le format doit être jjmmaa. Elle indique la date du paiement.</td></tr><tr><td>E</td><td>Montant</td><td>Yes</td><td>Le montant payé. S\'il y a une décimale le séparateur doit être un point.</td></tr><tr><td>F</td><td>Code</td><td>No</td><td>Cette donnée est stockée dans les metadatas du paiement mais pas exploitée dans les règles d\'enregistrement.</td></tr><tr><td>G</td><td>Devise</td><td>No</td><td>Cette donnée est stockée dans les metadatas du paiement mais pas exploitée dans les règles d\'enregistrement.</td></tr><tr><td>H</td><td>Référence paiement</td><td>No</td><td>Cette donnée est stockée dans les metadatas du paiement mais pas exploitée dans les règles d\'enregistrement.</td></tr><tr><td>I</td><td>Mois de facturation</td><td>No</td><td>Cette donnée est stockée dans les metadatas du paiement mais pas exploitée dans les règles d\'enregistrement.</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/business/mobile-message/mobile-message.html","<div><h2><span translate=\"wamasysApp.mobileMessage.title\">Envoyer des messages</span></h2><p>Les messages visibles sont accessibles dans la boîte de réception Web et dans l’application Android.</p><div ng-if=\"vm.diagnostics\" class=\"alert\" ng-class=\"{\'alert-success\': vm.diagnostics.initialized, \'alert-danger\': vm.diagnostics.enabled && !vm.diagnostics.initialized, \'alert-warning\': !vm.diagnostics.enabled}\"><strong ng-if=\"vm.diagnostics.initialized\">Firebase est opérationnel sur ce serveur.</strong> <strong ng-if=\"vm.diagnostics.enabled && !vm.diagnostics.initialized\">Firebase est activé mais son initialisation a échoué.</strong> <strong ng-if=\"!vm.diagnostics.enabled\">Firebase est désactivé sur ce serveur.</strong> <span ng-if=\"vm.diagnostics.initialized && vm.diagnostics.credentialSource === \'BASE64\'\">La clé provient de la variable secrète Base64.</span> <span ng-if=\"vm.diagnostics.initialized && vm.diagnostics.credentialSource === \'FILE\'\">La clé provient d’un fichier local.</span> <span ng-if=\"!vm.diagnostics.initialized\">La boîte Web reste disponible. Les appareils Android récupèrent les messages par synchronisation.</span></div><button ng-if=\"vm.canEdit && !vm.creating\" class=\"btn btn-primary\" ng-click=\"vm.openCreate()\"><span class=\"glyphicon glyphicon-send\"></span> Nouveau message</button><div class=\"well\" ng-if=\"vm.creating\" style=\"margin-top:15px\"><h3>Envoyer un message aux utilisateurs</h3><div class=\"form-group\"><label>Type</label><select class=\"form-control\" ng-model=\"vm.form.type\" ng-change=\"vm.collectorChoice = vm.form.type === \'VISIBLE\' ? \'all\' : \'yes\'; vm.filtersChanged()\"><option value=\"VISIBLE\">Message visible</option><option value=\"UPLOAD_LOGS_AND_ARCHIVES\">Commande invisible : envoyer les journaux et archives</option></select></div><div ng-if=\"vm.form.type === \'VISIBLE\'\"><div class=\"form-group\"><label>Titre</label><input class=\"form-control\" maxlength=\"255\" ng-model=\"vm.form.title\"></div><div class=\"form-group\"><label>Message</label><textarea class=\"form-control\" rows=\"5\" ng-model=\"vm.form.body\"></textarea></div></div><div class=\"form-group\"><label>Commentaire interne</label><textarea class=\"form-control\" rows=\"2\" ng-model=\"vm.form.internalComment\"></textarea></div><div class=\"row\"><div class=\"col-sm-8 form-group\"><label for=\"message-user-query\">Rechercher un utilisateur</label><input id=\"message-user-query\" class=\"form-control\" ng-model=\"vm.userQuery\" ng-change=\"vm.filtersChanged()\" placeholder=\"Identifiant, nom ou adresse e-mail\"></div><div class=\"col-sm-4 form-group\"><label for=\"message-collector-filter\">A le rôle collecteur</label><select id=\"message-collector-filter\" class=\"form-control\" ng-model=\"vm.collectorChoice\" ng-change=\"vm.filtersChanged()\"><option value=\"all\">Tous</option><option value=\"yes\">Oui</option><option value=\"no\">Non</option></select></div></div><p role=\"status\">{{vm.totalUsers || 0}} utilisateur(s) actif(s) correspondent aux filtres.</p><label><input type=\"checkbox\" ng-model=\"vm.allMatching\" ng-change=\"vm.chooseMatching()\" ng-disabled=\"vm.loadingUsers || !vm.totalUsers\"> Sélectionner tous les {{vm.totalUsers || 0}} utilisateurs correspondant à ces filtres</label><p class=\"text-info\" ng-if=\"vm.allMatching\">L’envoi concerne {{vm.selectedCount()}} utilisateurs, y compris ceux des autres pages. Toute modification des filtres annule cette sélection.</p><p><label><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-change=\"vm.toggleAll()\" ng-disabled=\"vm.allMatching || vm.loadingUsers\"> Sélectionner cette page</label></p><div class=\"table-responsive\" style=\"max-height:360px;overflow:auto\"><table class=\"table table-condensed\"><thead><tr><th></th><th>Utilisateur</th><th>Compte</th><th>Acheminement</th><th>Dernier appareil</th><th>Notifications</th><th>Dernier enregistrement</th></tr></thead><tbody><tr ng-repeat=\"u in vm.users\" ng-class=\"{\'text-muted\': !u.accountActivated}\"><td><input type=\"checkbox\" ng-model=\"vm.selected[u.id]\" ng-disabled=\"!u.accountActivated || vm.allMatching\" aria-label=\"Sélectionner {{u.login}}\"></td><td><strong>{{u.login}}</strong><br><small>{{u.firstName}} {{u.lastName}}<span ng-if=\"u.email\"> — {{u.email}}</span></small></td><td><span class=\"label\" ng-class=\"u.accountActivated ? \'label-success\' : \'label-danger\'\">{{u.accountActivated ? \'Actif\' : \'Désactivé\'}}</span><br><small>{{u.collectorAccount ? \'Collecteur\' : \'Rôle collecteur absent\'}}</small></td><td><span class=\"label\" ng-class=\"u.deliveryMode === \'FCM\' ? \'label-success\' : (u.deliveryMode === \'POLLING\' ? \'label-warning\' : \'label-default\')\">{{vm.deliveryLabel(u)}}</span><br><small ng-if=\"u.activeDeviceCount\">{{u.activeDeviceCount}} appareil(s) actif(s)</small></td><td><span ng-if=\"u.activeDevice\">{{u.deviceModel || \'Modèle inconnu\'}}<br><small>App {{u.appVersion || \'?\'}} — Android API {{u.androidSdk || \'?\'}}</small></span><span ng-if=\"!u.activeDevice\">—</span></td><td><span ng-class=\"{\'text-success\': u.notificationPermission === true, \'text-danger\': u.notificationPermission === false}\">{{vm.permissionLabel(u.notificationPermission)}}</span></td><td>{{u.lastRegisteredDate ? (u.lastRegisteredDate | date:\'short\') : \'Jamais\'}}</td></tr></tbody></table></div><uib-pagination total-items=\"vm.totalUsers\" items-per-page=\"50\" ng-model=\"vm.userPage\" ng-change=\"vm.loadUsers()\" max-size=\"5\" boundary-links=\"true\"></uib-pagination><p><strong>{{vm.selectedCount()}} destinataire(s) sélectionné(s).</strong></p><button class=\"btn btn-primary\" ng-disabled=\"vm.saving || vm.loadingUsers || !vm.selectedCount()\" ng-click=\"vm.send()\">Envoyer à {{vm.selectedCount()}} utilisateur(s)</button> <button class=\"btn btn-default\" ng-click=\"vm.cancelCreate()\">Annuler</button></div><div class=\"table-responsive\" style=\"margin-top:15px\"><table class=\"table table-striped\"><thead><tr><th>Date</th><th>Type</th><th>Titre</th><th>Destinataires</th><th>Reçus</th><th>Lus / terminés</th><th>Échecs</th><th></th></tr></thead><tbody><tr ng-repeat=\"m in vm.messages\"><td>{{m.sentDate | date:\'short\'}}</td><td>{{m.type === \'VISIBLE\' ? \'Message\' : \'Collecte technique\'}}</td><td>{{m.title || m.internalComment}}</td><td>{{m.recipientCount}}</td><td>{{m.receivedCount}}</td><td>{{m.type === \'VISIBLE\' ? m.readCount : m.completedCount}}</td><td>{{m.failedCount}}</td><td><button class=\"btn btn-xs btn-info\" ng-click=\"vm.showDetails(m)\">Détails</button></td></tr></tbody></table></div><uib-pagination total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadPage(vm.page)\"></uib-pagination><div class=\"panel panel-default\" ng-if=\"vm.detail\"><div class=\"panel-heading\"><strong>Détail #{{vm.detail.id}}</strong><button type=\"button\" class=\"close\" ng-click=\"vm.detail=null\">×</button></div><div class=\"table-responsive\"><table class=\"table\"><thead><tr><th>Utilisateur</th><th>Compte et appareil</th><th>État du message</th><th>Reçu</th><th>Lu / terminé</th><th>Erreur d’acheminement</th></tr></thead><tbody><tr ng-repeat=\"r in vm.recipients\"><td><strong>{{r.login}}</strong><br><small>{{r.firstName}} {{r.lastName}}</small></td><td><span class=\"label\" ng-class=\"r.userDiagnostics.accountActivated ? \'label-success\' : \'label-danger\'\">{{r.userDiagnostics.accountActivated ? \'Compte actif\' : \'Compte désactivé\'}}</span> <span class=\"label\" ng-class=\"r.userDiagnostics.deliveryMode === \'FCM\' ? \'label-success\' : (r.userDiagnostics.deliveryMode === \'POLLING\' ? \'label-warning\' : \'label-default\')\">{{vm.deliveryLabel(r.userDiagnostics)}}</span><br><small ng-if=\"r.userDiagnostics.activeDevice\">{{r.userDiagnostics.deviceModel || \'Modèle inconnu\'}} — App {{r.userDiagnostics.appVersion || \'?\'}} — API {{r.userDiagnostics.androidSdk || \'?\'}} — notifications {{vm.permissionLabel(r.userDiagnostics.notificationPermission) | lowercase}}</small> <small ng-if=\"!r.userDiagnostics.activeDevice\">Aucune connexion de l’application enregistrée.</small></td><td><strong>{{vm.statusLabel(r)}}</strong></td><td>{{r.receivedDate | date:\'short\'}}<br><small ng-if=\"r.webReceivedDate\">Web : {{r.webReceivedDate | date:\'short\'}}<br></small><small ng-if=\"r.androidReceivedDate\">Android : {{r.androidReceivedDate | date:\'short\'}}</small></td><td>{{(r.readDate || r.commandCompletedDate) | date:\'short\'}}<br><small ng-if=\"r.readDate && r.readChannel\">Lecture : {{r.readChannel === \'WEB\' ? \'Web\' : r.readChannel === \'ANDROID\' ? \'Android\' : r.readChannel}}</small></td><td>{{r.errorMessage}}<small ng-if=\"r.errorMessage && vm.detail.type === \'VISIBLE\'\"><br>Un échec de notification n’empêche pas la consultation dans la boîte Web.</small></td></tr></tbody></table></div><uib-pagination total-items=\"vm.recipientTotal\" items-per-page=\"50\" ng-model=\"vm.recipientPage\" ng-change=\"vm.loadRecipients()\" max-size=\"5\" boundary-links=\"true\"></uib-pagination></div></div>");
$templateCache.put("app/business/expense-type/expense-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.expenseType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.expenseType.delete.question\" translate-values=\"{id: \'{{vm.expenseType.id}}\'}\">Are you sure you want to delete this ExpenseType?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/expense-type/expense-type-detail.html","<div><h2><span translate=\"wamasysApp.expenseType.detail.title\">ExpenseType</span> {{vm.expenseType.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.expenseType.label\">Libelle</span></dt><dd><span>{{vm.expenseType.label}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.expenseType.globalExpenseType\">globalExpenseType</span></dt><dd><span>{{vm.expenseType.globalExpenseType.label}}<span></span></span></dd><hr><dt><span translate=\"global.field.isDeleted\">isDeleted</span></dt><dd><span>{{vm.expenseType.deleted}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/expense-type/expense-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myExpenseTypeLabel\" translate=\"wamasysApp.expenseType.home.createOrEditLabel\">Create or edit a ExpenseType</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!--         <div class=\"form-group\">\r\n            <label for=\"id\" translate=\"global.field.id\">ID</label>\r\n            <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"\r\n                    ng-model=\"vm.expenseType.id\" readonly />\r\n        </div> --><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.expenseType.label\" for=\"field_label\">Libelle</label><input type=\"text\" class=\"form-control\" name=\"label\" id=\"field_label\" ng-model=\"vm.expenseType.label\" required ng-maxlength=\"50\"><div ng-show=\"editForm.label.$invalid\"><p class=\"help-block\" ng-show=\"editForm.label.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.label.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.expenseType.globalExpenseType\" for=\"field_globalExpenseType\">globalExpenseType</label><select required class=\"form-control\" id=\"field_globalExpenseType\" name=\"globalExpenseType\" ng-model=\"vm.expenseType.globalExpenseType\" ng-options=\"globalExpenseType as globalExpenseType.label for globalExpenseType in vm.globalExpenseTypes track by globalExpenseType.id\"><option value=\"\"></option></select><div ng-show=\"editForm.globalExpenseType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.globalExpenseType.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\" ng-if=\"vm.expenseType.id\"><label class=\"control-deleted\" translate=\"global.field.isDeleted\" for=\"field_deleted\">deleted</label><input type=\"checkbox\" class=\"form-control\" name=\"deleted\" id=\"field_deleted\" ng-model=\"vm.expenseType.deleted\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/expense-type/expense-types.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.expenseType.home.title\">ExpenseTypes</span> <small class=\"text-muted\" translate=\"global.configurationScope.zone\">Paramétrage propre à la zone</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"expense-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.expenseType.home.createLabel\">Create new ExpenseType</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"label\"><span translate=\"wamasysApp.expenseType.label\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"globalExpenseType\"><span translate=\"wamasysApp.expenseType.globalExpenseType\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deleted\"><span translate=\"global.field.isDeleted\">isDeleted</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"expenseType in vm.expenseTypes track by expenseType.id\"><td><a ui-sref=\"expense-type-detail({id:expenseType.id})\">{{expenseType.id}}</a></td><td>{{expenseType.label}}</td><td>{{expenseType.globalExpenseType.label}}</td><td>{{expenseType.deleted}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"expense-type-detail({id:expenseType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"expense-type.edit({id:expenseType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"expense-type.delete({id:expenseType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/event-form/event-form-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.eventForm.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.eventForm.delete.question\" translate-values=\"{id: \'{{vm.eventForm.title}}\'}\">Are you sure you want to delete this EventForm?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/event-form/event-form-detail.html","<div><h2><span translate=\"wamasysApp.eventForm.detail.title\">Événement</span> {{vm.eventForm.id}}</h2><hr><div class=\"row\"><div class=\"col-md-8\"><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.eventForm.dateRecord\">Date</span></dt><dd><span>{{vm.eventForm.dateRecord | date:\'medium\'}}</span></dd><hr><dt><span translate=\"wamasysApp.eventForm.title\">Titre</span></dt><dd><span>{{vm.eventForm.title}}</span></dd><hr><dt translate=\"wamasysApp.eventForm.workflowStatus\">État</dt><dd>{{vm.statusLabel(vm.eventForm.workflowStatus)}} - {{ \'wamasysApp.eventForm.version\' | translate }} {{vm.eventForm.documentVersion || 1}}</dd><hr><dt translate=\"wamasysApp.eventForm.agency\">Agence</dt><dd>{{vm.eventForm.agencyName}}</dd><hr><dt translate=\"wamasysApp.eventForm.area\">Area</dt><dd>{{vm.eventForm.areaName}}</dd><hr><dt><span translate=\"wamasysApp.eventForm.category\">Catégorie</span></dt><dd><span>{{vm.eventForm.category}}</span></dd><hr><dt><span translate=\"wamasysApp.eventForm.subCategory\">Sous-catégorie</span></dt><dd><span>{{vm.eventForm.subCategory}}</span></dd><hr ng-show=\"vm.eventForm.answerFields && vm.eventForm.answerFields.length > 0\"><dt ng-show=\"vm.eventForm.answerFields && vm.eventForm.answerFields.length > 0\"><span translate=\"wamasysApp.eventForm.metadata\">Données</span></dt><dd ng-show=\"vm.eventForm.answerFields && vm.eventForm.answerFields.length > 0\"><ul><li ng-repeat=\"field in vm.eventForm.answerFields track by field.code\"><strong>{{field.label}}</strong> <span class=\"text-muted\" ng-if=\"field.label !== field.code\">({{field.code}})</span> : {{field.value}}</li></ul></dd><hr><dt><span translate=\"wamasysApp.eventForm.comment\">Commentaire</span></dt><dd><textarea readonly=\"readonly\" style=\"width: 100%\" rows=\"5\">{{vm.eventForm.comment}}</textarea></dd><hr><dt translate=\"wamasysApp.eventForm.createdBy\">Créé par</dt><dd><span>{{vm.eventForm.author}}</span></dd><hr><dt translate=\"wamasysApp.eventForm.createdDate\">Date de création</dt><dd>{{vm.eventForm.createdDate | date:\'medium\'}}</dd><hr><dt translate=\"wamasysApp.eventForm.lastModifiedDate\">Dernière modification</dt><dd>{{ \'wamasysApp.eventForm.modifiedBy\' | translate:{date: (vm.eventForm.lastModifiedDate | date:\'medium\'), author: vm.eventForm.lastModifiedBy} }}</dd></dl></div><div class=\"col-md-4\"><map-leaflet readonly=\"false\" contrat=\"vm.eventForm\"></map-leaflet></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong translate=\"wamasysApp.eventForm.attachments\">Pièces jointes</strong></div><div class=\"panel-body\"><div class=\"alert alert-info\" ng-if=\"!vm.attachments.length\" translate=\"wamasysApp.eventForm.noAttachments\">Aucune pièce jointe pour le moment.</div><div class=\"table-responsive\" ng-if=\"vm.attachments.length\"><table class=\"table table-striped table-condensed\"><thead><tr><th translate=\"wamasysApp.eventForm.name\">Nom</th><th translate=\"wamasysApp.eventForm.type\">Type</th><th translate=\"wamasysApp.eventForm.size\">Taille</th><th translate=\"wamasysApp.eventForm.addedBy\">Ajoutée par</th><th translate=\"wamasysApp.eventForm.dateRecord\">Date</th><th></th></tr></thead><tbody><tr ng-repeat=\"attachment in vm.attachments track by attachment.id\"><td>{{attachment.fileName}}</td><td>{{attachment.contentType || \'application/octet-stream\'}}</td><td>{{attachment.sizeBytes || 0}} {{ \'wamasysApp.eventForm.bytesUnit\' | translate }}</td><td>{{attachment.createdBy}}</td><td>{{attachment.createdDate | date:\'medium\'}}</td><td class=\"text-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.downloadAttachment(attachment)\"><span class=\"glyphicon glyphicon-download-alt\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"wamasysApp.eventForm.download\">Télécharger</span></button></td></tr></tbody></table></div><div class=\"well\" ng-if=\"vm.hasEditRight && vm.eventLoaded\"><div class=\"row\"><div class=\"col-sm-8\"><input type=\"file\" class=\"form-control\" file-model=\"attachmentFile\" set-file-data=\"vm.setAttachmentFile(value)\"><p class=\"help-block\" ng-if=\"vm.selectedAttachmentFileName\">{{ \'wamasysApp.eventForm.selectedFile\' | translate:{name: vm.selectedAttachmentFileName} }}</p></div><div class=\"col-sm-4 text-right\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!vm.selectedAttachmentFile || vm.attachmentUploadInProgress\" ng-click=\"vm.uploadAttachment()\"><span class=\"glyphicon glyphicon-paperclip\"></span> <span translate=\"wamasysApp.eventForm.add\">Ajouter</span></button></div></div></div></div></div><div class=\"panel panel-default\" ng-if=\"vm.history.length\"><div class=\"panel-heading\"><strong translate=\"wamasysApp.eventForm.history\">Historique des modifications</strong></div><div class=\"table-responsive\"><table class=\"table table-striped table-condensed\"><thead><tr><th translate=\"wamasysApp.eventForm.dateRecord\">Date</th><th translate=\"wamasysApp.eventForm.user\">Utilisateur</th><th translate=\"wamasysApp.eventForm.version\">Version</th><th translate=\"wamasysApp.eventForm.reason\">Raison</th><th translate=\"wamasysApp.eventForm.field\">Champ</th><th translate=\"wamasysApp.eventForm.oldValue\">Ancienne valeur</th><th translate=\"wamasysApp.eventForm.newValue\">Nouvelle valeur</th></tr></thead><tbody ng-repeat=\"changeSet in vm.history track by changeSet.id\"><tr ng-repeat=\"item in changeSet.items track by $index\"><td ng-if=\"$first\" rowspan=\"{{changeSet.items.length}}\">{{changeSet.changedAt | date:\'medium\'}}</td><td ng-if=\"$first\" rowspan=\"{{changeSet.items.length}}\">{{changeSet.changedBy}}</td><td ng-if=\"$first\" rowspan=\"{{changeSet.items.length}}\">{{changeSet.documentVersion}}</td><td ng-if=\"$first\" rowspan=\"{{changeSet.items.length}}\">{{vm.reasonLabel(changeSet.reason)}}<div class=\"text-muted\" ng-if=\"changeSet.reasonComment\">{{changeSet.reasonComment}}</div></td><td>{{item.fieldCode}}</td><td>{{item.oldDisplayValue}}</td><td>{{item.newDisplayValue}}</td></tr></tbody></table></div></div><div class=\"clearfix\"><div class=\"pull-left btn-group\"><button type=\"button\" ui-sref=\"event-form-detail.edit({id: vm.eventForm.id})\" class=\"btn btn-primary\" ng-if=\"vm.hasEditRight && vm.eventLoaded\"><span class=\"glyphicon glyphicon-pencil\"></span>&nbsp;<span translate=\"wamasysApp.eventForm.edit\">Éditer</span></button> <button type=\"button\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\">Back</span></button></div><div class=\"pull-right btn-group\" ng-if=\"vm.eventLoaded\"><button type=\"button\" class=\"btn btn-success\" ng-if=\"vm.canValidate()\" ng-disabled=\"vm.statusActionInProgress\" ng-click=\"vm.validateDocument()\" translate=\"wamasysApp.eventForm.validate\">Valider</button> <button type=\"button\" class=\"btn btn-primary\" ng-if=\"vm.canControl()\" ng-disabled=\"vm.statusActionInProgress\" ng-click=\"vm.controlDocument()\" translate=\"wamasysApp.eventForm.control\">Contrôler</button> <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"vm.ticketActionInProgress\" ng-click=\"vm.createTicket()\" translate=\"wamasysApp.eventForm.createTicket\">Créer un ticket</button></div></div><div class=\"panel panel-default\" ng-if=\"vm.canReadEquipment && vm.eventForm.id\"><div class=\"panel-heading\" translate=\"wamasysApp.eventForm.linkedEquipment\">Équipements liés</div><div class=\"panel-body\"><p ng-repeat=\"equipment in vm.linkedEquipment track by $index\"><a ui-sref=\"equipment-parc({equipmentId:equipment.id})\">{{equipment.inventoryCode}} — {{equipment.label}}</a></p><a class=\"btn btn-default\" ng-if=\"vm.canCreateEquipment && !vm.linkedEquipment.length\" ui-sref=\"equipment-parc({sourceEventId:vm.eventForm.id})\" translate=\"wamasysApp.eventForm.createEquipmentFromEvent\">Créer une fiche équipement depuis cet événement</a></div></div></div>");
$templateCache.put("app/business/event-form/event-form-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save(editForm)\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myEventFormLabel\" translate=\"wamasysApp.eventForm.home.createOrEditLabel\">Create or edit a EventForm</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><input type=\"hidden\" name=\"id\" id=\"field_id\" ng-model=\"vm.eventForm.id\"><div class=\"form-group\" ng-if=\"vm.shouldShowBaseField(\'dateRecord\')\"><label class=\"control-label\" translate=\"wamasysApp.eventForm.dateRecord\" for=\"field_dateRecord\">dateRecord</label><div class=\"input-group\"><input id=\"field_dateRecord\" type=\"text\" class=\"form-control\" name=\"dateRecord\" ng-click=\"vm.openCalendar(\'dateRecord\')\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.eventForm.dateRecord\" is-open=\"vm.datePickerOpenStatus.dateRecord\" ng-required=\"vm.isBaseFieldRequired(\'dateRecord\')\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateRecord\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.dateRecord.$invalid\"><p class=\"help-block\" ng-show=\"editForm.dateRecord.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.dateRecord.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.eventForm.category\" for=\"field_category\">Category</label><select class=\"form-control\" name=\"category\" ng-model=\"vm.eventForm.category\" id=\"field_category\" required ng-options=\"category as category.label for category in vm.listCategory track by category.id\" ng-change=\"vm.updateSubCategory()\"><option value=\"\"></option></select><div ng-show=\"editForm.category.$invalid\"><p class=\"help-block\" ng-show=\"editForm.category.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.eventForm.subCategory\" for=\"field_subCategory\">subCategory</label><select class=\"form-control\" name=\"subCategory\" ng-model=\"vm.eventForm.subCategory\" id=\"field_subCategory\" required ng-options=\"category as vm.subCategoryOptionLabel(category) for category in vm.listSubCategory track by category.id\" ng-change=\"vm.onchangeSubCategory()\"><option value=\"\"></option></select><div ng-show=\"editForm.subCategory.$invalid\"><p class=\"help-block\" ng-show=\"editForm.subCategory.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\" ng-if=\"vm.shouldShowBaseField(\'title\')\"><label class=\"control-label\" translate=\"wamasysApp.eventForm.title\" for=\"field_title\">title</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.eventForm.title\" ng-required=\"vm.isBaseFieldRequired(\'title\')\" ng-maxlength=\"50\"><div ng-show=\"editForm.title.$invalid\"><p class=\"help-block\" ng-show=\"editForm.title.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p><p class=\"help-block\" ng-show=\"editForm.title.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"row\" ng-if=\"vm.eventForm.id\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_changeReason\" translate=\"wamasysApp.eventForm.changeReason\">Raison de modification</label><select class=\"form-control\" name=\"changeReason\" id=\"field_changeReason\" ng-model=\"vm.eventForm.changeReason\" ng-options=\"reason.code as reason.label for reason in vm.changeReasons\"></select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_changeReasonComment\" translate=\"wamasysApp.eventForm.changeComment\">Commentaire de modification</label><input type=\"text\" class=\"form-control\" name=\"changeReasonComment\" id=\"field_changeReasonComment\" ng-model=\"vm.eventForm.changeReasonComment\" ng-maxlength=\"2048\"></div></div></div><div id=\"listCustomFields\" ng-repeat=\"item in vm.inputsCustomFields\"><div class=\"form-group\"><label class=\"control-label\" for=\"field_{{item.name}}\">{{item.label}}</label><small class=\"text-muted\" ng-if=\"item.unit\">({{item.unit}})</small> <span ng-if=\"item.tooltip\" style=\"display: inline\" data-popover-placement=\"top\" data-popover-trigger=\"mouseenter\" data-uib-popover=\"{{item.tooltip}}\"><i class=\"fa fa-question txt-color-yellow\"></i> </span><input ng-if=\"item.type === \'decimal\'\" type=\"number\" class=\"form-control\" ng-required=\"item.required\" name=\"{{item.name}}\" id=\"field_{{item.name}}\" ng-model=\"item.value\"> <input ng-if=\"item.type === \'integer\'\" type=\"number\" step=\"1\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" class=\"form-control\" ng-required=\"item.required\" name=\"{{item.name}}\" id=\"field_{{item.name}}\" ng-model=\"item.value\"><textarea ng-if=\"item.type === \'text\'\" class=\"form-control\" name=\"{{item.name}}\" id=\"field_{{item.name}}\" ng-required=\"item.required\" ng-model=\"item.value\" rows=\"3\" ng-maxlength=\"2560\"></textarea><input ng-if=\"item.type === \'date\'\" type=\"date\" class=\"form-control\" name=\"{{item.name}}\" id=\"field_{{item.name}}\" ng-required=\"item.required\" ng-model=\"item.value\"><div ng-if=\"item.type === \'boolean\'\" class=\"checkbox\"><label><input type=\"checkbox\" name=\"{{item.name}}\" id=\"field_{{item.name}}\" ng-model=\"item.value\"> Oui / Non</label></div><select ng-if=\"item.type === \'list\'\" class=\"form-control\" ng-required=\"item.required\" name=\"{{item.name}}\" id=\"field_{{item.name}}\" ng-model=\"item.value\"><option ng-if=\"!item.required\" value=\"\"></option><option ng-repeat=\"option in item.values\" value=\"{{option}}\">{{option}}</option></select><div ng-if=\"item.type === \'satisfaction_smiley\'\" class=\"btn-group btn-group-justified\" role=\"group\"><label class=\"btn btn-default\" ng-repeat=\"option in vm.getSmileyOptions(item) track by option.value\" ng-class=\"{\'active btn-primary\': item.value === option.value}\"><input type=\"radio\" name=\"{{item.name}}\" ng-model=\"item.value\" ng-value=\"option.value\" ng-required=\"item.required\" style=\"display:none\"> {{option.label}}</label></div><div ng-show=\"editForm[item.name] && editForm[item.name].$invalid\"><p class=\"help-block\" ng-show=\"editForm[item.name].$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm[item.name].$error.date\" translate=\"wamasysApp.eventForm.invalidDate\">Saisissez une date valide.</p></div></div></div><div class=\"form-group\" ng-if=\"vm.shouldShowBaseField(\'comment\')\"><label class=\"control-label\" translate=\"wamasysApp.eventForm.comment\" for=\"field_comment\">comment</label><textarea class=\"form-control\" name=\"comment\" id=\"field_comment\" ng-model=\"vm.eventForm.comment\" ng-required=\"vm.isBaseFieldRequired(\'comment\')\" rows=\"3\" ng-maxlength=\"2048\"></textarea><div ng-show=\"editForm.comment.$invalid\"><p class=\"help-block\" ng-show=\"editForm.comment.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"2048\">This field cannot be longer than 2048 characters.</p><p class=\"help-block\" ng-show=\"editForm.comment.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\" ng-if=\"vm.shouldShowBaseField(\'gps\')\"><label class=\"control-label\" translate=\"wamasysApp.eventForm.gps\">Coordonnées GPS</label><p class=\"help-block\" ng-if=\"vm.isBaseFieldRequired(\'gps\') && vm.hasMissingRequiredGps()\" translate=\"wamasysApp.eventForm.gpsRequired\">Les coordonnées GPS sont obligatoires pour cette sous-catégorie.</p><map-leaflet contrat=\"vm.eventForm\" height=\"480px\" width=\"100%\"></map-leaflet></div><div class=\"alert alert-warning\" ng-if=\"vm.canUseDraftSubmitActions()\" translate=\"wamasysApp.eventForm.draftWarning\">Un document enregistré en brouillon ne sera pas intégré dans les reportings tant qu’il n’aura pas été soumis.</div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"button\" ng-if=\"vm.canUseDraftSubmitActions()\" ng-disabled=\"vm.isSaving\" ng-click=\"vm.saveAsDraft(editForm)\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-floppy-disk\"></span>&nbsp;<span translate=\"wamasysApp.eventForm.saveDraft\">Sauvegarder brouillon</span></button> <button type=\"submit\" ng-disabled=\"vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span>{{ (vm.canUseDraftSubmitActions() ? \'wamasysApp.eventForm.saveSubmit\' : \'wamasysApp.eventForm.save\') | translate }}</span></button></div></form>");
$templateCache.put("app/business/event-form/event-forms.html","<div class=\"app-entity-shell\"><div class=\"app-entity-header\"><h2 class=\"app-entity-title\" translate=\"wamasysApp.eventForm.home.title\">Événements</h2><div class=\"app-entity-actions\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.showWorkflowHelp()\"><span class=\"glyphicon glyphicon-question-sign\" aria-hidden=\"true\"></span> <span translate=\"wamasysApp.eventForm.workflowHelp\">Aide sur les états</span></button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"vm.canBulkChange\" ng-click=\"vm.openBulkStatus()\" ng-disabled=\"vm.bulkBusy || vm.loading || !vm.totalItems\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span> <span translate=\"wamasysApp.eventForm.bulkTitle\">Modifier les états</span> <span ng-if=\"vm.selectedCount()\">({{vm.selectedCount()}})</span></button> <button class=\"btn btn-primary\" ui-sref=\"event-form.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.eventForm.home.createLabel\">Créer un nouvel événement</span></button></div></div><jhi-alert></jhi-alert><div class=\"app-filter-panel\"><form name=\"searchForm\" class=\"smart-form\" novalidate><fieldset ng-disabled=\"vm.bulkBusy\"><div class=\"app-filter-grid\"><div class=\"app-filter-field\"><label class=\"app-filter-label\" translate=\"wamasysApp.eventForm.text\" for=\"searchText\">Texte</label><input type=\"text\" ng-model=\"vm.searchText\" id=\"searchText\" class=\"form-control\" placeholder=\"{{ \'wamasysApp.eventForm.textPlaceholder\' | translate }}\"></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" for=\"daterange1\" translate=\"wamasysApp.eventForm.dateRecord\">Date</label><input date-range-picker id=\"daterange1\" name=\"daterange1\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" options=\"vm.opts\" placeholder=\"yyyy-mm-dd - yyyy-mm-dd\"></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" for=\"field_agency\" translate=\"wamasysApp.eventForm.agency\">Agence</label><select class=\"form-control\" id=\"field_agency\" name=\"agency\" ng-model=\"vm.agency\" ng-change=\"vm.updateAreaFilter()\" ng-options=\"agency as agency.nom for agency in vm.listAgency track by agency.id\"><option value=\"\"></option></select></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" for=\"field_area\" translate=\"wamasysApp.eventForm.area\">Area</label><select class=\"form-control\" id=\"field_area\" name=\"area\" ng-model=\"vm.area\" ng-options=\"area as area.nom for area in vm.listArea track by area.id\"><option value=\"\"></option></select></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" translate=\"wamasysApp.eventForm.category\" for=\"field_category\">Catégorie</label><select class=\"form-control\" ng-change=\"vm.updateSubCategory()\" id=\"field_category\" name=\"category\" ng-model=\"vm.category\" ng-options=\"listCategory as listCategory.label for listCategory in vm.listCategory track by listCategory.id\"><option value=\"\"></option></select></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" translate=\"wamasysApp.eventForm.subCategory\" for=\"field_subCategory\">Sous-catégorie</label><select class=\"form-control\" id=\"field_subCategory\" name=\"subCategory\" ng-model=\"vm.subCategory\" ng-options=\"listSubCategory as listSubCategory.label for listSubCategory in vm.listSubCategory track by listSubCategory.id\"><option value=\"\"></option></select></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" for=\"field_workflowStatus\" translate=\"wamasysApp.eventForm.workflowStatus\">État</label><select class=\"form-control\" id=\"field_workflowStatus\" name=\"workflowStatus\" ng-model=\"vm.workflowStatus\"><option value=\"\"></option><option value=\"DRAFT\" translate=\"wamasysApp.eventForm.statuses.DRAFT\">Brouillon</option><option value=\"SUBMITTED\" translate=\"wamasysApp.eventForm.statuses.SUBMITTED\">Soumis</option><option value=\"VALIDATED\" translate=\"wamasysApp.eventForm.statuses.VALIDATED\">Validé</option><option value=\"CONTROLLED\" translate=\"wamasysApp.eventForm.statuses.CONTROLLED\">Contrôlé</option></select></div></div><div class=\"app-filter-actions\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.clear()\" translate=\"wamasysApp.eventForm.reset\">Réinitialiser</button> <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"vm.search()\" translate=\"wamasysApp.eventForm.search\">Rechercher</button></div></fieldset></form></div><div class=\"alert\" ng-if=\"vm.bulkResult\" ng-class=\"vm.bulkResult.failures.length ? \'alert-warning\' : \'alert-success\'\" role=\"status\">{{ \'wamasysApp.eventForm.bulkSummary\' | translate:{updated: vm.bulkResult.updated, unchanged: vm.bulkResult.unchanged, failed: vm.bulkResult.failures.length} }}<details ng-if=\"vm.bulkResult.failures.length\"><summary translate=\"wamasysApp.eventForm.showFailures\">Afficher les événements refusés</summary><ul><li ng-repeat=\"failure in vm.bulkResult.failures\">{{ \'wamasysApp.eventForm.failure\' | translate:{id: failure.id, message: failure.message} }}</li></ul></details></div><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th ng-if=\"vm.canBulkChange\"><input type=\"checkbox\" aria-label=\"{{ \'wamasysApp.eventForm.selectPage\' | translate }}\" ng-model=\"vm.pageSelected\" ng-change=\"vm.togglePage()\" ng-disabled=\"vm.allMatching || vm.bulkBusy || vm.loading\"></th><th jh-sort-by=\"dateRecord\"><span translate=\"wamasysApp.eventForm.dateRecord\">Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agence.entiteParente.nom\"><span translate=\"wamasysApp.eventForm.agency\">Agence</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agence.nom\"><span translate=\"wamasysApp.eventForm.area\">Area</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"subCategory.eventFormCategory.label\"><span translate=\"wamasysApp.eventForm.category\">Catégorie</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"subCategory.label\"><span translate=\"wamasysApp.eventForm.subCategory\">Sous-catégorie</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"wamasysApp.eventForm.title\">Titre</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"workflowStatus\"><span translate=\"wamasysApp.eventForm.workflowStatus\">État</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"documentVersion\">Version <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createdBy\"><span translate=\"wamasysApp.eventForm.author\">Auteur</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastModifiedDate\"><span translate=\"wamasysApp.eventForm.lastModifiedDate\">Dernière modification</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"eventForm in vm.eventForms track by eventForm.id\"><td ng-if=\"vm.canBulkChange\"><input type=\"checkbox\" aria-label=\"{{ \'wamasysApp.eventForm.selectEvent\' | translate }}\" ng-if=\"!vm.allMatching\" ng-model=\"vm.selected[eventForm.id]\" ng-disabled=\"vm.bulkBusy || vm.loading\"> <input ng-if=\"vm.allMatching\" type=\"checkbox\" checked=\"checked\" disabled=\"disabled\" aria-label=\"{{ \'wamasysApp.eventForm.selectedByFilter\' | translate }}\"></td><td><a ui-sref=\"event-form-detail({id:eventForm.id})\">{{eventForm.dateRecord | date:\'medium\'}}</a></td><td>{{eventForm.agencyName}}</td><td>{{eventForm.areaName}}</td><td>{{eventForm.category}}</td><td>{{eventForm.subCategory}}<span class=\"text-muted\" ng-if=\"eventForm.subCategoryVersionNumber\"> (v{{eventForm.subCategoryVersionNumber}})</span></td><td>{{eventForm.title}}</td><td>{{vm.statusLabel(eventForm.workflowStatus)}}</td><td>{{eventForm.documentVersion || 1}}</td><td>{{eventForm.author}}</td><td>{{eventForm.lastModifiedDate | date:\'medium\'}}<br><span class=\"text-muted\">{{eventForm.lastModifiedBy}}</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"event-form-detail({id:eventForm.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"event-form.edit({id:eventForm.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"event-form.delete({id:eventForm.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div><script type=\"text/ng-template\" id=\"eventWorkflowHelp.html\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"{{ \'wamasysApp.eventForm.close\' | translate }}\">&times;</button>\r\n        <h4 class=\"modal-title\" translate=\"wamasysApp.eventForm.helpTitle\">Les étapes d’un événement</h4></div>\r\n    <div class=\"modal-body\">\r\n        <p><strong translate=\"wamasysApp.eventForm.helpFlow\">Brouillon → Soumis → Validé → Contrôlé</strong></p>\r\n        <ul>\r\n            <li><strong>{{ \'wamasysApp.eventForm.statuses.DRAFT\' | translate }} :</strong> <span translate=\"wamasysApp.eventForm.helpDraft\">saisie en préparation, exclue des reportings.</span></li>\r\n            <li><strong>{{ \'wamasysApp.eventForm.statuses.SUBMITTED\' | translate }} :</strong> <span translate=\"wamasysApp.eventForm.helpSubmitted\">prêt pour validation, déjà inclus dans les reportings.</span></li>\r\n            <li><strong>{{ \'wamasysApp.eventForm.statuses.VALIDATED\' | translate }} :</strong> <span translate=\"wamasysApp.eventForm.helpValidated\">uniquement depuis Soumis, avec le droit FORM_VALIDATION.</span></li>\r\n            <li><strong>{{ \'wamasysApp.eventForm.statuses.CONTROLLED\' | translate }} :</strong> <span translate=\"wamasysApp.eventForm.helpControlled\">seconde vérification, uniquement depuis Validé, avec le même droit.</span></li>\r\n        </ul>\r\n        <p translate=\"wamasysApp.eventForm.helpReturn\">Un retour en Brouillon ou Soumis depuis Validé ou Contrôlé nécessite aussi le droit FORM_VALIDATION. Sur le Web, un événement validé reste modifiable avec le droit d’édition.</p>\r\n        <p translate=\"wamasysApp.eventForm.helpMobile\">Sur smartphone, seuls vos Brouillons et Soumis créés depuis moins de 30 jours restent modifiables.</p>\r\n        <p translate=\"wamasysApp.eventForm.helpDeleted\">Un événement supprimé est conservé dans l’historique et exclu des reportings. La suppression n’est pas proposée en masse ici.</p>\r\n        <p translate=\"wamasysApp.eventForm.helpSelection\">La sélection de la page concerne les lignes affichées. « Tous les événements du filtre » couvre toutes les pages et uniquement vos zones autorisées. Chaque changement est historisé ; les transitions interdites ou les événements modifiés entre-temps sont signalés dans le bilan.</p>\r\n    </div>\r\n    <div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$close()\" translate=\"wamasysApp.eventForm.close\">Fermer</button></div></script><script type=\"text/ng-template\" id=\"eventBulkStatus.html\"><div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" ng-disabled=\"vm.bulkBusy\" aria-label=\"{{ \'wamasysApp.eventForm.close\' | translate }}\">&times;</button>\r\n        <h4 class=\"modal-title\" translate=\"wamasysApp.eventForm.bulkTitle\">Modifier les états</h4>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n        <div class=\"alert alert-danger\" ng-if=\"vm.bulkError\" role=\"alert\">{{vm.bulkError}}</div>\r\n        <p><strong>{{ \'wamasysApp.eventForm.bulkSelected\' | translate:{count: vm.selectedCount()} }}</strong></p>\r\n        <div class=\"checkbox\">\r\n            <label><input type=\"checkbox\" ng-model=\"vm.allMatching\" ng-change=\"vm.toggleMatching()\"\r\n                    ng-disabled=\"vm.bulkBusy || !vm.totalItems\">\r\n                {{ \'wamasysApp.eventForm.selectMatching\' | translate:{count: (vm.totalItems || 0)} }}</label>\r\n        </div>\r\n        <div class=\"form-group\">\r\n            <label for=\"bulk_event_status\" translate=\"wamasysApp.eventForm.newStatus\">Nouvel état</label>\r\n            <select id=\"bulk_event_status\" class=\"form-control\" ng-model=\"vm.targetStatus\" ng-disabled=\"vm.bulkBusy\"\r\n                    ng-options=\"status as vm.statusLabel(status) for status in vm.bulkStatuses\">\r\n                <option value=\"\" translate=\"wamasysApp.eventForm.chooseStatus\">Choisir un état</option>\r\n            </select>\r\n        </div>\r\n        <p class=\"help-block\" translate=\"wamasysApp.eventForm.bulkHelp\">Les transitions et les droits restent contrôlés pour chaque événement. Pour couvrir toutes vos zones autorisées, laissez les filtres Agence et Zone vides puis cliquez sur Rechercher.</p>\r\n        <p ng-if=\"vm.bulkBusy\" role=\"status\" translate=\"wamasysApp.eventForm.bulkBusy\">Changement d’état en cours…</p>\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$dismiss()\" ng-disabled=\"vm.bulkBusy\" translate=\"wamasysApp.eventForm.cancel\">Annuler</button>\r\n        <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.changeStatuses()\"\r\n                ng-disabled=\"vm.bulkBusy || vm.loading || !vm.selectedCount() || !vm.targetStatus\" translate=\"wamasysApp.eventForm.applySelection\">Appliquer à la sélection</button>\r\n    </div></script>");
$templateCache.put("app/business/modele-contrat/modele-contrat-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.modeleContrat.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.modeleContrat.delete.question\" translate-values=\"{id: \'{{vm.modeleContrat.id}}\'}\">Are you sure you want to delete this ModeleContrat?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/modele-contrat/modele-contrat-detail.html","<div><h2><span translate=\"wamasysApp.modeleContrat.detail.title\">ModeleContrat</span> {{vm.modeleContrat.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.modeleContrat.libelle\">Libelle</span></dt><dd><span>{{vm.modeleContrat.libelle}}<span></span></span></dd><hr><dt><span translate=\"global.field.code\">Code</span></dt><dd><span>{{vm.modeleContrat.code}}</span></dd><hr><dt><span translate=\"wamasysApp.modeleContrat.serviceVendu\">service</span></dt><dd><span ng-repeat=\"serviceVendu in vm.modeleContrat.serviceVendus\"><a ui-sref=\"service-autre-detail({id: {{serviceVendu.id}}})\">{{serviceVendu.libelle}}</a><br><!-- {{$last ? \'\' : \', \'}} --></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/modele-contrat/modele-contrat-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myModeleContratLabel\" translate=\"wamasysApp.modeleContrat.home.createOrEditLabel\">Create or edit a ModeleContrat</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"alert alert-warning\" translate=\"wamasysApp.modeleContrat.commentaireModificationImpactPasContrat\">La modification d\'un modèle de contrat n\'impact pas les contrats déjà créés.</div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.modeleContrat.libelle\" for=\"field_libelle\">Libelle</label><input type=\"text\" class=\"form-control\" name=\"libelle\" id=\"field_libelle\" ng-model=\"vm.modeleContrat.libelle\" ng-maxlength=\"50\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.libelle.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.modeleContrat.serviceVendu\" for=\"field_serviceVendu\">serviceVendu</label><select class=\"form-control\" id=\"field_serviceVendu\" multiple=\"multiple\" name=\"serviceVendu\" ng-model=\"vm.modeleContrat.serviceVendus\" ng-options=\"serviceVendu as serviceVendu.libelle for serviceVendu in vm.serviceautres track by serviceVendu.id\"></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/modele-contrat/modele-contrats-liste-contrat.html","<div class=\"container-fluid padding-top-10\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"modele-contrat.liste-contrat.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.modeleContrat.home.createLabel\">Create new ModeleContrat</span></button></div></div></div><div class=\"table-responsive padding-top-10\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"libelle\"><span translate=\"wamasysApp.modeleContrat.libelle\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"wamasysApp.modeleContrat.serviceVendu\">serviceVendu</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"modeleContrat in vm.modeleContrats track by modeleContrat.id\"><td><a ui-sref=\"modele-contrat-detail({id:modeleContrat.id})\">{{modeleContrat.libelle}}</a></td><td><span ng-repeat=\"serviceVendu in modeleContrat.serviceVendus track by serviceVendu.id\">{{serviceVendu.libelle}}<br></span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"modele-contrat-detail({id:modeleContrat.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"modele-contrat.edit({id:modeleContrat.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"modele-contrat.delete({id:modeleContrat.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div>");
$templateCache.put("app/business/modele-contrat/modele-contrats.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"global.menu.parametragecontrats\">Configuration des ventes</span> <small class=\"text-muted\" translate=\"global.configurationScope.zone\">Paramétrage propre à la zone</small></h2><jhi-alert></jhi-alert><uib-tabset><uib-tab ui-sref-active=\"active\" ui-sref=\"modele-contrat.liste-contrat\"><uib-tab-heading><span translate=\"wamasysApp.modeleContrat.home.title\">Modèle contrat</span></uib-tab-heading></uib-tab><uib-tab ui-sref-active=\"active\" ui-sref=\"modele-contrat.service-autre\"><uib-tab-heading><span translate=\"wamasysApp.serviceVendu.home.title\">Service</span></uib-tab-heading></uib-tab><uib-tab ui-sref-active=\"active\" ui-sref=\"modele-contrat.type-tax\" has-any-authority=\"ROLE_READ_ONLY,ROLE_AREA_CONFIGURATION\"><uib-tab-heading><span translate=\"wamasysApp.typeTax.home.title\">Types de taxe</span></uib-tab-heading></uib-tab></uib-tabset><div ui-view=\"panneau@content\"></div></div>");
$templateCache.put("app/business/notifications/notification-detail.html","<section><p><a ui-sref=\"notifications\"><i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i> Tous mes messages</a></p><p ng-if=\"vm.loading\" role=\"status\">Chargement du message…</p><div class=\"alert alert-danger\" ng-if=\"vm.error\" role=\"alert\">{{vm.error}} <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.load()\">Réessayer</button></div><article ng-if=\"vm.message\"><h2>{{vm.message.title || \'Message Wamasys\'}}</h2><p class=\"text-muted\">{{vm.message.sentDate | date:\'medium\'}}</p><div style=\"white-space:pre-wrap;overflow-wrap:break-word\">{{vm.message.body}}</div><p class=\"text-muted\" style=\"margin-top:20px\" ng-if=\"vm.message.read\">Lecture confirmée par Wamasys.</p><p class=\"text-warning\" ng-if=\"vm.receiptError\" role=\"alert\">{{vm.receiptError}} <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.retryRead()\">Réessayer</button></p></article></section>");
$templateCache.put("app/business/notifications/notifications.html","<section><h2>Mes messages Wamasys</h2><p>Retrouvez ici les messages qui vous sont adressés, sur le Web et dans l’application Android.</p><div class=\"well\" ng-if=\"vm.push.available\"><span ng-if=\"!vm.push.enabled\">Recevoir aussi une notification de ce navigateur lorsque Wamasys est fermé.</span> <span ng-if=\"vm.push.enabled\">Les notifications de ce navigateur sont activées.</span> <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"vm.push.busy\" ng-if=\"!vm.push.enabled\" ng-click=\"vm.enablePush()\">Activer les notifications du navigateur</button> <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"vm.push.busy\" ng-if=\"vm.push.enabled\" ng-click=\"vm.disablePush()\">Désactiver</button><p class=\"text-warning\" ng-if=\"vm.push.error\" role=\"alert\">{{vm.push.error}}</p></div><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.load()\" ng-disabled=\"vm.loading\"><i class=\"fa fa-refresh\" aria-hidden=\"true\"></i> Actualiser</button><p ng-if=\"vm.loading\" role=\"status\">Chargement des messages…</p><p ng-if=\"vm.notice\" class=\"text-info\" role=\"status\">{{vm.notice}}</p><p ng-if=\"vm.error\" class=\"alert alert-danger\" role=\"alert\">{{vm.error}}</p><p ng-if=\"!vm.loading && !vm.messages.length && !vm.error\">Aucun message.</p><div class=\"list-group\" style=\"margin-top:15px\"><a class=\"list-group-item\" ng-repeat=\"message in vm.messages track by message.id\" ui-sref=\"notification-detail({id:message.id})\"><span class=\"label label-info pull-right\" ng-if=\"!message.read\">Non lu</span><h3 class=\"list-group-item-heading\" style=\"font-size:18px\">{{message.title || \'Message Wamasys\'}}</h3><time class=\"text-muted\">{{message.sentDate | date:\'medium\'}}</time></a></div><button type=\"button\" class=\"btn btn-default\" ng-if=\"vm.nextBeforeId\" ng-disabled=\"vm.loading\" ng-click=\"vm.more()\">Messages précédents</button></section>");
$templateCache.put("app/business/monitoring-rule/monitoring-rule-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.monitoringRule.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.monitoringRule.delete.question\" translate-values=\"{id: \'{{vm.monitoringRule.id}}\'}\">Are you sure you want to delete this MonitoringRule?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/monitoring-rule/monitoring-rule-detail.html","<div><h2><span translate=\"wamasysApp.monitoringRule.detail.title\">MonitoringRule</span> {{vm.monitoringRule.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"global.field.code\">Code</span></dt><dd><span>{{vm.monitoringRule.code}}</span></dd><hr><dt><span translate=\"wamasysApp.monitoringRule.libelle\">Libelle</span></dt><dd><span>{{vm.monitoringRule.libelle}}<span></span></span></dd><hr><dt><span translate=\"global.field.isDeleted\">isDeleted</span></dt><dd><span>{{vm.monitoringRule.deleted}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/monitoring-rule/monitoring-rule-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myMonitoringRuleLabel\" translate=\"wamasysApp.monitoringRule.home.createOrEditLabel\">Create or edit a MonitoringRule</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-if=\"vm.monitoringRule.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.monitoringRule.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label translate=\"wamasysApp.monitoringRule.typeRule\" for=\"field_typeRule\">typeRule</label><div ng-if=\"vm.isNew\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.onlyUnconfigured\" ng-change=\"vm.updateFilteredTypeRules()\"> <span translate=\"wamasysApp.monitoringRule.availability.onlyUnconfigured\">Afficher uniquement les types de règles non encore configurés</span></label></div><p class=\"help-block\" ng-if=\"vm.typesLoaded\" translate=\"wamasysApp.monitoringRule.availability.remaining\" translate-values=\"{count: vm.availableTypeCount}\"></p><p class=\"help-block\" translate=\"wamasysApp.monitoringRule.availability.help\"></p></div><p class=\"text-danger\" ng-if=\"vm.typeRulesLoadError\" translate=\"wamasysApp.monitoringRule.availability.loadError\"></p><select ng-change=\" vm.updateFilteredTypeRules()\" class=\"form-control\" id=\"field_group\" name=\"group\" ng-model=\"vm.selectedGroup\"><option value=\"\">-- All --</option><option ng-repeat=\"group in vm.groups\" value=\"{{group}}\">{{ (\'wamasysApp.monitoringRule.groupEnum.\' +group | translate) }}</option></select><br><select required class=\"form-control\" id=\"field_typeRule\" name=\"typeRule\" ng-model=\"vm.monitoringRule.typeRule\" ng-options=\"typeRule as vm.formatTypeRule(typeRule) for typeRule in vm.filteredTypeRules track by typeRule.name\"><option value=\"\"></option></select><p class=\"help-block\" ng-if=\"vm.typesLoaded && !vm.filteredTypeRules.length\" translate=\"wamasysApp.monitoringRule.availability.empty\"></p><div ng-show=\"editForm.typeRule.$invalid\"><p class=\"help-block\" ng-show=\"editForm.typeRule.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\" ng-if=\"vm.monitoringRule.typeRule.withParam1 ==true\"><label translate=\"wamasysApp.monitoringRule.param1\" for=\"field_param1\">param1</label><input ng-model=\"vm.monitoringRule.param1\" id=\"field_param1\" type=\"number\" min=\"0\" step=\"1\" class=\"form-control\" name=\"param1\"><div ng-show=\"editForm.param1.$invalid\"><p class=\"help-block\" ng-show=\"editForm.param1.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.param1.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p></div></div><div class=\"form-group\" ng-if=\"vm.monitoringRule.typeRule.withNbDays ==true\"><label translate=\"wamasysApp.monitoringRule.nbDays\" for=\"field_nbDays\">nbDays</label><input ng-model=\"vm.monitoringRule.nbDays\" id=\"field_nbDays\" type=\"number\" min=\"0\" step=\"1\" class=\"form-control\" name=\"nbDays\"><div ng-show=\"editForm.nbDays.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nbDays.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.nbDays.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.monitoringRule.destinaire\" for=\"field_destinaire\">destinaire</label><select required class=\"form-control\" id=\"field_destinaire\" name=\"destinaire\" ng-model=\"vm.monitoringRule.destinaire\"><option value=\"AREA_MANAGER\">{{ (\'wamasysApp.monitoringRule.recipientEnum.AREA_MANAGER\' | translate) }}</option><option value=\"TOP_MANAGER\">{{ (\'wamasysApp.monitoringRule.recipientEnum.TOP_MANAGER\' | translate) }}</option></select><div ng-show=\"editForm.destinaire.$invalid\"><p class=\"help-block\" ng-show=\"editForm.destinaire.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.monitoringRule.additionalRecipients\">additionalRecipients</label><ui-select multiple=\"multiple\" ng-model=\"vm.monitoringRule.additionalRecipients\" theme=\"selectize\" title=\"{{\'wamasysApp.monitoringRule.additionalRecipients\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.monitoringRule.additionalRecipientsPlaceholder\' | translate}}\">{{vm.formatUser($item)}}</ui-select-match><ui-select-choices repeat=\"user in vm.users | filter: $select.search track by user.id\"><div>{{vm.formatUser(user)}}</div><small>{{user.login}}</small></ui-select-choices></ui-select><p class=\"help-block\" translate=\"wamasysApp.monitoringRule.additionalRecipientsHelp\">Additional recipients receive the alerts for this rule in addition to the selected recipient group.</p></div><div class=\"form-group\"><label translate=\"wamasysApp.monitoringRule.agenceIncludeHelp\">agenceInclude</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.monitoringRule.agenceInclude\" theme=\"selectize\" title=\"{{\'wamasysApp.monitoringRule.agenceInclude\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.monitoringRule.agenceInclude\' | translate}}\">{{$item.nom}}</ui-select-match><ui-select-choices repeat=\"agence in vm.agences | filter: $select.search  track by agence.id\">{{agence.nom}}</ui-select-choices></ui-select></div><div class=\"form-group\"><label translate=\"wamasysApp.monitoringRule.agenceExcludeHelp\">agenceExclude</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.monitoringRule.agenceExclude\" theme=\"selectize\" title=\"{{\'wamasysApp.monitoringRule.agenceExclude\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.monitoringRule.agenceExclude\' | translate}}\">{{$item.nom}}</ui-select-match><ui-select-choices repeat=\"agence in vm.agences | filter: $select.search  track by agence.id\">{{agence.nom}}</ui-select-choices></ui-select></div><div class=\"form-group\"><label translate=\"wamasysApp.monitoringRule.commentaire\" for=\"field_commentaire\">commentaire</label><textarea class=\"form-control\" id=\"field_commentaire\" name=\"commentaire\" ng-model=\"vm.monitoringRule.commentaire\" maxlength=\"2000\"></textarea></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/monitoring-rule/monitoring-rule-exclusion-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"wamasysApp.monitoringRule.exclusion.title\">Exclusion temporaire</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"wamasysApp.monitoringRule.referenceContrat\" for=\"field_referenceContrat\">Réf contrat</label><input type=\"text\" class=\"form-control\" id=\"field_referenceContrat\" name=\"referenceContrat\" ng-model=\"vm.exclusion.referenceContrat\" maxlength=\"255\"></div><div class=\"form-group\"><label translate=\"wamasysApp.monitoringRule.serialNumber\" for=\"field_serialNumber\">Serial number</label><input type=\"text\" class=\"form-control\" id=\"field_serialNumber\" name=\"serialNumber\" ng-model=\"vm.exclusion.serialNumber\" maxlength=\"255\"></div><div class=\"form-group\"><label translate=\"wamasysApp.monitoringRule.validiteMois\" for=\"field_validiteMois\">Validité en mois</label><input type=\"number\" min=\"1\" step=\"1\" class=\"form-control\" id=\"field_validiteMois\" name=\"validiteMois\" ng-model=\"vm.exclusion.validiteMois\"></div><div class=\"form-group\"><label translate=\"wamasysApp.monitoringRule.commentaireObligatoire\" for=\"field_commentaire\">Commentaire</label><textarea required class=\"form-control\" id=\"field_commentaire\" name=\"commentaire\" maxlength=\"2000\" ng-model=\"vm.exclusion.commentaire\"></textarea></div><div class=\"checkbox\" ng-if=\"vm.historyContext && vm.historyContext.uuidExecution\"><label for=\"field_markAsProcessed\"><input type=\"checkbox\" id=\"field_markAsProcessed\" ng-model=\"vm.markAsProcessed\"> Marquer comme pris en compte apres creation de l\'exclusion</label></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/monitoring-rule/monitoring-rule-exclusions.html","<div><h2><span translate=\"wamasysApp.monitoringRule.home.viewExclusions\">Voir les exclusions</span> <small ng-if=\"vm.monitoringRule.id\">- {{ (\'wamasysApp.monitoringRule.typeEnum.\' + vm.monitoringRule.typeRule | translate).replace(\'X\', vm.monitoringRule.param1).replace(\'Y\', vm.monitoringRule.nbDays) }}</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-12 no-padding-left\"><button class=\"btn btn-primary\" ng-click=\"vm.openDialog()\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.monitoringRule.exclusion.add\">Ajouter une exclusion</span></button> <button class=\"btn btn-default\" ui-sref=\"monitoring-rule\"><span class=\"glyphicon glyphicon-arrow-left\"></span> <span translate=\"entity.action.back\">Retour</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th translate=\"wamasysApp.monitoringRule.area\">Zone</th><th translate=\"wamasysApp.monitoringRule.referenceContrat\">Réf contrat</th><th translate=\"wamasysApp.monitoringRule.serialNumber\">Serial number</th><th translate=\"wamasysApp.monitoringRule.dateValideJusqua\">Date valide jusqu\'à</th><th translate=\"wamasysApp.monitoringRule.commentaire\">Commentaire</th><th translate=\"wamasysApp.monitoringRule.createdByLabel\">Créé par</th><th></th></tr></thead><tbody><tr ng-repeat=\"exclusion in vm.exclusions track by exclusion.id\"><td>{{ exclusion.areaName }}</td><td>{{ exclusion.referenceContrat }}</td><td>{{ exclusion.serialNumber }}</td><td>{{ exclusion.dateValideJusqua | date:\'dd/MM/yyyy\' }}</td><td>{{ exclusion.commentaire }}</td><td>{{ exclusion.createdBy }}<br><small>{{ exclusion.createdDate | date:\'dd/MM/yyyy HH:mm\' }}</small></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"vm.openDialog(exclusion)\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\">Edit</span></button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"vm.delete(exclusion.id)\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\">Delete</span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/business/monitoring-rule/monitoring-rule-history-createticket-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"wamasysApp.monitoringRule.history.createTicket\">Créer un ticket</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.redmine.subject\" for=\"field_subject\">subject</label><input type=\"text\" required class=\"form-control\" name=\"subject\" id=\"field_subject\" maxlength=\"256\" ng-model=\"vm.redmineIssue.subject\"></div><div class=\"form-group\"><label translate=\"wamasysApp.redmine.tracker\" for=\"field_tracker_id\">Tracker</label><select class=\"form-control\" id=\"field_tracker_id\" name=\"tracker_id\" ng-model=\"vm.redmineIssue.tracker_id\"><option value=\"\">Client ticket</option><option value=\"8\">Feedback ticket</option></select></div><div class=\"form-group\"><label translate=\"wamasysApp.redmine.user\" for=\"field_user\">user</label><ui-select tagging ng-model=\"vm.redmineIssue.assigned_to_id\" theme=\"selectize\"><ui-select-match>{{$select.selected.firstName}} {{$select.selected.lastName}} ({{$select.selected.login}})</ui-select-match><ui-select-choices repeat=\"user.redmineUserId as user in vm.users | filter: $select.search track by user.id\">{{user.firstName}} {{user.lastName}} ({{user.login}})</ui-select-choices></ui-select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.redmine.description\" for=\"field_description\">description</label><textarea class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.redmineIssue.description\" maxlength=\"20000\" required></textarea></div><div class=\"checkbox\" ng-if=\"vm.history.uuidExecution\"><label for=\"field_markAsProcessed\"><input type=\"checkbox\" id=\"field_markAsProcessed\" ng-model=\"vm.markAsProcessed\"> Marquer comme pris en compte apres creation du ticket</label></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/monitoring-rule/monitoring-rule-history.html","<div><h2><span translate=\"wamasysApp.monitoringRule.history.title\">Historique des erreurs</span> <small class=\"\" style=\"\" translate=\"wamasysApp.monitoringRule.history.errorCount\" translate-values=\"{count: vm.stats.errorCount}\">Nombre d\'erreurs : {{ vm.stats.errorCount }}</small> <small class=\"\" style=\"\" translate=\"wamasysApp.monitoringRule.history.areaCount\" translate-values=\"{count: vm.stats.areaCount}\">Nombre de zones : {{ vm.stats.areaCount }}</small></h2><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-4\"><label translate=\"wamasysApp.monitoringRule.history.period\">Période</label><div class=\"input-group\"><input date-range-picker id=\"daterange1\" name=\"daterange1\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" options=\"vm.opts\"><div class=\"input-group-btn\"><button ng-click=\"openRangeDateTimePicker()\" class=\"btn btn-default\" type=\"button\"><span class=\"glyphicon glyphicon-calendar\"></span></button></div></div></div><div class=\"col-md-4\"><label translate=\"wamasysApp.monitoringRule.area\">Zone</label><select class=\"form-control\" ng-model=\"vm.filters.areaId\" ng-change=\"vm.onFiltersChanged()\" ng-options=\"agence.id as agence.nom for agence in vm.agences\"><option value=\"\"></option></select></div><div class=\"col-md-4\"><label translate=\"wamasysApp.monitoringRule.typeRule\">Regle</label><select class=\"form-control\" ng-model=\"vm.filters.monitoringRuleId\" ng-change=\"vm.onFiltersChanged()\" ng-options=\"rule.id as ((\'wamasysApp.monitoringRule.typeEnum.\' + rule.typeRule | translate).replace(\'X\', rule.param1).replace(\'Y\', rule.nbDays)) for rule in vm.rules\"><option value=\"\"></option></select></div></div><div class=\"row\" style=\"margin-top: 15px\"><div class=\"col-md-4\"><label translate=\"wamasysApp.monitoringRule.destinaire\">Destinataire</label><select class=\"form-control\" ng-model=\"vm.filters.recipient\" ng-change=\"vm.onFiltersChanged()\" ng-if=\"vm.canFilterRecipient\"><option value=\"\"></option><option ng-repeat=\"recipient in vm.availableRecipients\" value=\"{{ recipient }}\">{{ (\'wamasysApp.monitoringRule.recipientEnum.\' + recipient) | translate }}</option></select><input type=\"text\" class=\"form-control\" ng-if=\"!vm.canFilterRecipient && vm.availableRecipients.length === 1\" ng-value=\"(\'wamasysApp.monitoringRule.recipientEnum.\' + vm.availableRecipients[0]) | translate\" disabled=\"disabled\"></div><div class=\"col-md-4\"><label translate=\"wamasysApp.monitoringRule.history.state\">État</label><select class=\"form-control\" ng-model=\"vm.filters.processedStatus\" ng-change=\"vm.onFiltersChanged()\"><option value=\"all\" translate=\"wamasysApp.monitoringRule.history.stateAll\">Tous</option><option value=\"processed\" translate=\"wamasysApp.monitoringRule.history.stateProcessed\">Pris en compte</option><option value=\"unprocessed\" translate=\"wamasysApp.monitoringRule.history.stateUnprocessed\">Non pris en compte</option></select></div><div class=\"col-md-4\"><label translate=\"wamasysApp.monitoringRule.history.errorItems\">Éléments en erreur</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.filters.errorItemText\" ng-model-options=\"{ debounce: 300 }\" ng-change=\"vm.onFiltersChanged()\" placeholder=\"{{\'wamasysApp.monitoringRule.history.filterErrorItemPlaceholder\' | translate}}\"></div></div><div class=\"row\" style=\"margin-top: 15px\"><div class=\"col-md-4 col-md-offset-8\"><label translate=\"wamasysApp.monitoringRule.history.viewMode\">Mode de vue</label><div class=\"btn-group btn-group-sm btn-group-justified\"><a class=\"btn\" ng-class=\"vm.filters.viewMode === \'summary\' ? \'btn-primary\' : \'btn-default\'\" ng-click=\"vm.setViewMode(\'summary\')\" translate=\"wamasysApp.monitoringRule.history.viewModeSummary\">Synthèse</a> <a class=\"btn\" ng-class=\"vm.filters.viewMode === \'detail\' ? \'btn-primary\' : \'btn-default\'\" ng-click=\"vm.setViewMode(\'detail\')\" translate=\"wamasysApp.monitoringRule.history.viewModeDetail\">Détaillée</a></div></div></div><!--     <div class=\"row\" style=\"margin-top: 20px;\">\r\n        <div class=\"col-md-3\">\r\n            <div class=\"well well-sm text-center\">\r\n                <div class=\"text-muted\">Nombre erreur</div>\r\n                <div style=\"font-size: 24px; font-weight: bold;\">{{ vm.stats.errorCount }}</div>\r\n            </div>\r\n        </div>\r\n        <div class=\"col-md-3\">\r\n            <div class=\"well well-sm text-center\">\r\n                <div class=\"text-muted\">Nombre de zones</div>\r\n                <div style=\"font-size: 24px; font-weight: bold;\">{{ vm.stats.areaCount }}</div>\r\n            </div>\r\n        </div>\r\n    </div> --><div class=\"row\" ng-if=\"vm.isRefreshing\" style=\"margin-top: 10px\"><div class=\"col-md-12\"><span class=\"fa fa-spinner fa-spin\"></span> <span translate=\"wamasysApp.monitoringRule.history.refreshing\">Mise à jour de la liste...</span></div></div><div class=\"table-responsive\" style=\"margin-top: 15px\"><table class=\"jh-table table table-striped\"><thead><tr><th style=\"cursor: pointer\" ng-click=\"vm.changeSort(\'executionDate\')\"><span translate=\"wamasysApp.monitoringRule.history.executionDate\">Date</span> <span class=\"glyphicon\" ng-class=\"vm.isSortActive(\'executionDate\', \'asc\') ? \'glyphicon-chevron-up\' : (vm.isSortActive(\'executionDate\', \'desc\') ? \'glyphicon-chevron-down\' : \'glyphicon-sort\')\"></span></th><!--          <th style=\"cursor: pointer;\" ng-click=\"vm.changeSort(\'uuidExecution\')\">\r\n                        UUID anomalie\r\n                        <span class=\"glyphicon\" ng-class=\"vm.isSortActive(\'uuidExecution\', \'asc\') ? \'glyphicon-chevron-up\' : (vm.isSortActive(\'uuidExecution\', \'desc\') ? \'glyphicon-chevron-down\' : \'glyphicon-sort\')\"></span>\r\n                    </th> --><th translate=\"wamasysApp.monitoringRule.area\">Zone</th><th translate=\"wamasysApp.monitoringRule.typeRule\">Règle</th><th translate=\"wamasysApp.monitoringRule.history.value\">Valeur</th><th translate=\"wamasysApp.monitoringRule.history.errorItems\">Éléments en erreur</th><th translate=\"wamasysApp.monitoringRule.history.state\">État</th><th></th></tr></thead><tbody><tr ng-repeat=\"history in vm.histories track by history.rowKey\" ng-class=\"{\'monitoring-processed-feedback\': vm.hasProcessedFeedback(history)}\"><td>{{ history.executionDate | date:\'dd/MM/yyyy HH:mm\' }}</td><!--                <td style=\"font-family: monospace;\">{{ history.uuidExecution }}</td> --><td><div class=\"clearfix\"><span class=\"pull-left\">{{ history.areaName }}</span> <button type=\"button\" class=\"btn btn-link btn-xs pull-right\" ng-click=\"vm.applyAreaFilter(history)\" title=\"{{\'wamasysApp.monitoringRule.history.filterArea\' | translate}}\"><span class=\"glyphicon glyphicon-plus\"></span></button></div></td><td><div class=\"clearfix\"><span class=\"pull-left\">{{ vm.buildRuleLabel(history) }}</span> <button type=\"button\" class=\"btn btn-link btn-xs pull-right\" ng-click=\"vm.applyRuleFilter(history)\" title=\"{{\'wamasysApp.monitoringRule.history.filterRule\' | translate}}\"><span class=\"glyphicon glyphicon-plus\"></span></button></div></td><td>{{ history.errorValue }}{{ history.suffixErreur }}</td><td style=\"white-space: normal; word-break: break-word\"><div class=\"clearfix\"><span class=\"pull-left\">{{ history.errorItems | limitTo:50 }}{{history.errorItems.length > 50 ? \'...\' : \'\' }}</span> <button type=\"button\" class=\"btn btn-link btn-xs pull-right\" ng-if=\"vm.filters.viewMode === \'detail\' && history.errorItems\" ng-click=\"vm.applyErrorItemFilter(history)\" title=\"{{\'wamasysApp.monitoringRule.history.filterErrorItem\' | translate}}\"><span class=\"glyphicon glyphicon-plus\"></span></button></div></td><td><div ng-if=\"history.processed\"><span class=\"label label-success\" translate=\"wamasysApp.monitoringRule.history.stateProcessed\">Pris en compte</span><div class=\"small text-muted\" ng-if=\"history.processedBy\"><span translate=\"wamasysApp.monitoringRule.history.processedBy\" translate-values=\"{user: history.processedBy}\">Traité par {{ history.processedBy }}</span></div><div class=\"small text-muted\" ng-if=\"history.processedAt\"><span translate=\"wamasysApp.monitoringRule.history.processedAtLabel\">Le</span> {{ history.processedAt | date:\'dd/MM/yyyy HH:mm\' }}</div></div><span ng-if=\"!history.processed\" class=\"label label-default\" translate=\"wamasysApp.monitoringRule.history.stateUnprocessed\">Non pris en compte</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.openCreateTicket(history)\"><span class=\"glyphicon glyphicon-briefcase\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"wamasysApp.monitoringRule.history.createTicket\">Creer un ticket</span></button> <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"vm.openCreateExclusion(history)\" title=\"{{!vm.canCreateTemporaryExclusion ? (\'wamasysApp.monitoringRule.history.excludeTempAdminOnly\' | translate) : \'\'}}\"><span class=\"glyphicon glyphicon-ban-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"wamasysApp.monitoringRule.history.excludeTemp\">Exclure temporairement</span></button> <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"vm.toggleProcessed(history)\" ng-disabled=\"vm.isUpdatingProcessed(history) || vm.hasProcessedFeedback(history)\" title=\"{{!vm.canUpdateProcessedStatus ? (\'wamasysApp.monitoringRule.history.processedStatusRolesOnly\' | translate) : \'\'}}\"><span ng-if=\"vm.isUpdatingProcessed(history)\" class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></span> <span ng-if=\"!vm.isUpdatingProcessed(history)\" class=\"glyphicon\" ng-class=\"history.processed ? \'glyphicon-repeat\' : \'glyphicon-ok\'\"></span> <span class=\"hidden-xs hidden-sm\">{{ (history.processed ? \'wamasysApp.monitoringRule.history.markUnprocessed\' : \'wamasysApp.monitoringRule.history.markProcessed\') | translate }}</span></button></div></td></tr><tr ng-if=\"vm.pagination.isLoadingMore\"><td colspan=\"8\" class=\"text-center text-muted\"><span class=\"fa fa-spinner fa-spin\"></span> <span translate=\"wamasysApp.monitoringRule.history.loading\">Chargement...</span></td></tr><tr ng-if=\"!vm.histories.length\"><td colspan=\"8\" class=\"text-center text-muted\" translate=\"wamasysApp.monitoringRule.history.noResult\">Aucun résultat</td></tr></tbody></table></div></div>");
$templateCache.put("app/business/monitoring-rule/monitoring-rules.html","<div><style>@media (min-width: 1292px) {\n  .modal-lg {\n    width: 1200px;\n  }\n}\n@media (min-width: 1692px) {\n  .modal-lg {\n    width: 1600px;\n  }\n}</style><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.monitoringRule.home.title\">MonitoringRules</span> <small class=\"text-muted\" translate=\"global.configurationScope.organization\">Paramétrage commun à toute l\'organisation</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-12 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"monitoring-rule.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.monitoringRule.home.createLabel\">Create new MonitoringRule </span><span ng-if=\"vm.availableTypeCount !== null && vm.availableTypeCount !== undefined\">· <span translate=\"wamasysApp.monitoringRule.availability.button\" translate-values=\"{count: vm.availableTypeCount}\"></span></span></button> <button class=\"btn btn-primary\" ng-click=\"vm.runRules()\"><span class=\"glyphicon glyphicon-play\"></span> <span translate=\"wamasysApp.monitoringRule.home.run\">Run rules</span></button> <button class=\"btn btn-default\" ui-sref=\"monitoring-rule-history\"><span class=\"glyphicon glyphicon-time\"></span> <span translate=\"wamasysApp.monitoringRule.home.history\">Historique</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><!--                    <th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th> --><th jh-sort-by=\"destinaire\"><span translate=\"wamasysApp.monitoringRule.destinaire\">destinaire</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"wamasysApp.monitoringRule.groupeRule\">groupeRule</span></th><th jh-sort-by=\"typeRule\"><span translate=\"wamasysApp.monitoringRule.typeRule\">typeRule</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"wamasysApp.monitoringRule.commentaire\">commentaire</span></th><th><span translate=\"wamasysApp.monitoringRule.additionalRecipients\">additionalRecipients</span></th><th jh-sort-by=\"agenceInclude.id\"><span translate=\"wamasysApp.monitoringRule.agenceInclude\">agenceInclude</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"agenceExclude.id\"><span translate=\"wamasysApp.monitoringRule.agenceExclude\">agenceExclude</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"wamasysApp.monitoringRule.nbrExclusionTemporaire\">nbrExclusionTemporaire</span></th><!--                 <th jh-sort-by=\"param1\"><span translate=\"wamasysApp.monitoringRule.param1\">param1</span> <span class=\"glyphicon glyphicon-sort\"></span></th>\n                    <th jh-sort-by=\"nbDays\"><span translate=\"wamasysApp.monitoringRule.nbDays\">nbDays</span> <span class=\"glyphicon glyphicon-sort\"></span></th> --><th></th></tr></thead><tbody><tr ng-repeat=\"monitoringRule in vm.monitoringRules track by monitoringRule.id\"><!--       <td><a ui-sref=\"monitoring-rule-detail({id:monitoringRule.id})\">{{monitoringRule.id}}</a></td> --><td>{{ (\'wamasysApp.monitoringRule.recipientEnum.\' +monitoringRule.destinaire | translate) }}</td><td>{{ (\'wamasysApp.monitoringRule.groupEnum.\' +monitoringRule.typeRuleGroup | translate) }}</td><td>{{ (\'wamasysApp.monitoringRule.typeEnum.\' + monitoringRule.typeRule | translate).replace(\'X\', monitoringRule.param1).replace(\'Y\', monitoringRule.nbDays) }}</td><td>{{ monitoringRule.commentaire }}</td><td><span ng-repeat=\"recipient in monitoringRule.additionalRecipients\">{{ vm.formatRecipient(recipient) }}<span ng-if=\"!$last\">,</span></span></td><td><span ng-repeat=\"agence in monitoringRule.agenceInclude\">{{ agence.nom }}<span ng-if=\"!$last\">,</span></span></td><td><span ng-repeat=\"agence in monitoringRule.agenceExclude\">{{ agence.nom }}<span ng-if=\"!$last\">,</span></span></td><td>{{ monitoringRule.temporaryExclusionCount || 0 }}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ng-click=\"vm.runRule(monitoringRule.id)\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-play\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"wamasysApp.monitoringRule.home.run\">Run</span></button> <button type=\"submit\" ui-sref=\"monitoring-rule-exclusions({id:monitoringRule.id})\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-list-alt\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"wamasysApp.monitoringRule.home.viewExclusions\">Voir les exclusions</span></button> <button type=\"submit\" ui-sref=\"monitoring-rule.edit({id:monitoringRule.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"monitoring-rule.delete({id:monitoringRule.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div><!-- Modal Bootstrap --><div class=\"modal fade\" id=\"dataModal\" tabindex=\"-1\" aria-labelledby=\"dataModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><h5 class=\"modal-title\" id=\"dataModalLabel\">Données JSON</h5><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div><div class=\"modal-body\" id=\"modalBody\"><!-- Contenu généré dynamiquement par AngularJS --></div></div></div></div></div>");
$templateCache.put("app/business/portefeuille-contrat/billing-portefeuille-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPaiementInitialLabel\" translate=\"wamasysApp.contrat.service.etablirFacturation\">etablirFacturation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!--         <div class=\"form-group\">\r\n            <label class=\"control-label\" translate=\"wamasysApp.contrat.service.dateFacturation\" for=\"field_dateFacturation\">dateFacturation</label>\r\n                <div class=\"input-group\">\r\n                    <input id=\"field_dateFacturation\" type=\"text\" class=\"form-control\" name=\"dateFacturation\"  uib-datepicker-popup=\"{{dateformat}}\"  ng-model=\"vm.dateFacturation\" is-open=\"vm.datePickerOpenStatus.dateFacturation\"\r\n                    required  />\r\n                    <span class=\"input-group-btn\">\r\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateFacturation\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n                    </span>\r\n                </div>\r\n            <div ng-show=\"editForm.datePaiement.$invalid\">\r\n                <p class=\"help-block\"\r\n                    ng-show=\"editForm.dateFacturation.$error.required\" translate=\"entity.validation.required\">\r\n                    This field is required.\r\n                </p>\r\n                <p class=\"help-block\"\r\n                    ng-show=\"editForm.dateFacturation.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">\r\n                    This field should be a date and time.\r\n                </p>\r\n            </div>\r\n        </div> --></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/portefeuille-contrat/portefeuille-contrat-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.portefeuilleContrat.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.portefeuilleContrat.delete.question\" translate-values=\"{id: \'{{vm.portefeuilleContrat.id}}\'}\">Are you sure you want to delete this PortefeuilleContrat?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/portefeuille-contrat/portefeuille-contrat-detail.html","<div><h2><span translate=\"wamasysApp.portefeuilleContrat.detail.title\">PortefeuilleContrat</span> {{vm.portefeuilleContrat.id}}</h2><hr><button class=\"btn btn-info pull-right\" ui-sref=\"portefeuille-contrat-detail.billing({id:vm.portefeuilleContrat.id})\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.contrat.service.etablirFacturation\">Etablir facturation</span></button><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.portefeuilleContrat.libelle\">Libelle</span></dt><dd><span>{{vm.portefeuilleContrat.libelle}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.portefeuilleContrat.collecteur\">collecteur</span></dt><dd><a ui-sref=\"collecteur-detail({login:vm.portefeuilleContrat.collecteur.login})\">{{vm.portefeuilleContrat.collecteur.firstName + \' \' + vm.portefeuilleContrat.collecteur.lastName}}</a></dd><hr><dt><span translate=\"wamasysApp.portefeuilleContrat.lastDateBilling\">lastDateBilling</span></dt><dd>{{ vm.portefeuilleContrat.lastDateBilling | date:\'mediumDate\' }}</dd><hr><dt><span translate=\"wamasysApp.portefeuilleContrat.autoInvoiceNextDate\">autoInvoiceNextDate</span></dt><dd>{{ vm.portefeuilleContrat.autoInvoiceNextDate | date:\'mediumDate\' }}</dd><hr><dt><span translate=\"wamasysApp.portefeuilleContrat.autoInvoicePeriodType\">autoInvoicePeriodType</span></dt><dd>{{ vm.portefeuilleContrat.autoInvoicePeriodType}}</dd><hr><dt><span translate=\"wamasysApp.portefeuilleContrat.autoBillingInterval\">autoInvoiceInterval</span></dt><dd ng-if=\"vm.portefeuilleContrat.autoInvoicePeriodType == \'WEEKDAY\'\"><span ng-repeat=\"interval in vm.invoiceWeekday \"><span translate=\"{{interval}}\"></span></span></dd><dd ng-if=\"vm.portefeuilleContrat.autoInvoicePeriodType != \'WEEKDAY\'\">{{ vm.portefeuilleContrat.autoInvoiceInterval }}</dd><hr><dt><span translate=\"wamasysApp.portefeuilleContrat.autoBillingNextDate\">autoBillingNextDate</span></dt><dd>{{ vm.portefeuilleContrat.autoBillingNextDate | date:\'mediumDate\' }}</dd><hr><dt><span translate=\"wamasysApp.portefeuilleContrat.autoBillingPeriodType\">autoBillingPeriodType</span></dt><dd>{{ vm.portefeuilleContrat.autoBillingPeriodType}}</dd><hr><dt><span translate=\"wamasysApp.portefeuilleContrat.autoBillingInterval\">autoBillingInterval</span></dt><dd ng-if=\"vm.portefeuilleContrat.autoBillingPeriodType == \'WEEKDAY\'\"><span ng-repeat=\"interval in vm.billingWeekday \"><span translate=\"{{interval}}\"></span></span></dd><dd ng-if=\"vm.portefeuilleContrat.autoBillingPeriodType != \'WEEKDAY\'\">{{vm.portefeuilleContrat.autoBillingInterval }}</dd><hr><dt><span translate=\"global.field.code\">Code</span></dt><dd><span>{{vm.portefeuilleContrat.code}}</span></dd></dl><hr><div jarvis-widget id=\"hide-show-columns-table-widget\" data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"><header><span class=\"widget-icon\"><i class=\"fa fa-table\"></i></span><h2 translate=\"wamasysApp.portefeuilleContrat.listeContrat\">Liste contrat</h2></header><div><div class=\"widget-body no-padding table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th translate=\"wamasysApp.contrat.nomPersonne\">NomPersonne</th><th translate=\"wamasysApp.contrat.referenceContrat\">Reference contrat</th><th translate=\"wamasysApp.contrat.etat\">Etat</th><th translate=\"wamasysApp.contrat.compteur\">compteur</th></tr></thead><tbody><tr ng-repeat=\"contrat in vm.contrats\"><td><a ui-sref=\"contrat-detail.information({id:contrat.id})\">{{contrat.nomPersonne}}</a></td><td>{{contrat.referenceContrat}}</td><td translate=\"{{\'wamasysApp.EtatContrat.\' + contrat.etat}}\">{{contrat.etat}}</td><td><a ui-sref=\"individual-meter-detail({id:contrat.individualMeter.id})\">{{contrat.individualMeter.numeroSerie}}</a></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div><!-- end widget content --></div><!-- end widget div --><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/portefeuille-contrat/portefeuille-contrat-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPortefeuilleContratLabel\" translate=\"wamasysApp.portefeuilleContrat.home.createOrEditLabel\">Create or edit a PortefeuilleContrat</h4></div><div class=\"modal-body\"><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.portefeuilleContrat.libelle\" for=\"field_libelle\">Libelle</label><input ng-readonly=\"! vm.hasAreaManagementRight\" type=\"text\" class=\"form-control\" name=\"libelle\" id=\"field_libelle\" ng-model=\"vm.portefeuilleContrat.libelle\" required ng-maxlength=\"50\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.libelle.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.libelle.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.portefeuilleContrat.collecteur\" for=\"field_collecteur\">collecteur</label><select required class=\"form-control\" id=\"field_collecteur\" name=\"collecteur\" ng-model=\"vm.portefeuilleContrat.collecteur\" ng-options=\"user as (user.firstName + \' \' + user.lastName) for user in vm.users track by user.id\"><option value=\"\"></option></select><div ng-show=\"editForm.collecteur.$invalid\"><p class=\"help-block\" ng-show=\"editForm.collecteur.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.portefeuilleContrat.autoBillingEnabled\" for=\"field_autoBillingEnabled\">autoBillingEnabled</label><input type=\"checkbox\" class=\"form-control\" name=\"autoBillingEnabled\" id=\"field_autoBillingEnabled\" ng-model=\"vm.autoBillingEnabled\"></div><div ng-show=\"vm.autoBillingEnabled\" class=\"alert alert-warning\" translate=\"wamasysApp.portefeuilleContrat.messageAutoBilling\" translate-compile>Note : les paiements affichés dans ce reporting sont filtrés via la date de leur facture.</div><div class=\"row\" ng-show=\"vm.autoBillingEnabled\"><div class=\"form-group col-md-4\"><label translate=\"wamasysApp.portefeuilleContrat.autoBillingNextDate\" for=\"field_autoBillingNextDate\">autoBillingNextDate</label><div class=\"input-group\"><input ng-readonly=\"! vm.hasAreaManagementRight\" placeholder=\"{{ \'wamasysApp.portefeuilleContrat.autoBillingNextDate\' | translate }}\" id=\"field_autoBillingNextDate\" type=\"text\" class=\"form-control\" name=\"autoBillingNextDate\" ng-click=\"vm.openCalendar(\'autoBillingNextDate\')\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.portefeuilleContrat.autoBillingNextDate\" is-open=\"vm.datePickerOpenStatus.autoBillingNextDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'autoBillingNextDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group col-md-4\"><label class=\"control-label\" translate=\"wamasysApp.portefeuilleContrat.autoBillingPeriodType\" for=\"field_autoBillingPeriodType\">autoBillingPeriodType</label><select ng-readonly=\"! vm.hasAreaManagementRight\" class=\"form-control\" name=\"autoBillingPeriodType\" ng-model=\"vm.portefeuilleContrat.autoBillingPeriodType\" id=\"field_autoBillingPeriodType\"><option value=\"DAY\" translate=\"wamasysApp.portefeuilleContrat.periodType.DAY\">DAY</option><option value=\"MONTH\" translate=\"wamasysApp.portefeuilleContrat.periodType.MONTH\">MONTH</option><option value=\"WEEKDAY\" translate=\"wamasysApp.portefeuilleContrat.periodType.WEEKDAY\">WEEKDAY</option></select></div><div class=\"form-group col-md-4\" ng-if=\"vm.portefeuilleContrat.autoBillingPeriodType != \'WEEKDAY\'\"><label translate=\"wamasysApp.portefeuilleContrat.autoBillingInterval\" for=\"field_autoBillingInterval\">autoBillingInterval</label><input ng-readonly=\"! vm.hasAreaManagementRight\" type=\"number\" class=\"form-control\" name=\"autoBillingInterval\" id=\"field_autoBillingInterval\" ng-model=\"vm.portefeuilleContrat.autoBillingInterval\" min=\"0\" max=\"999999\" placeholder=\"{{ \'wamasysApp.portefeuilleContrat.autoBillingInterval\' | translate }}\"><div ng-show=\"editForm.autoBillingInterval.$invalid\"><p class=\"help-block\" ng-show=\"editForm.autoBillingInterval.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.autoBillingInterval.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.autoBillingInterval.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\">This field cannot be more than 999999.</p><p class=\"help-block\" ng-show=\"editForm.autoBillingInterval.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group col-md-4\" ng-if=\"vm.portefeuilleContrat.autoBillingPeriodType == \'WEEKDAY\'\"><label translate=\"wamasysApp.portefeuilleContrat.autoBillingInterval\" for=\"field_autoBillingInterval\">autoBillingInterval</label><select ng-change=\"vm.onUpdateBillingWeekday()\" ng-readonly=\"! vm.hasAreaManagementRight\" class=\"form-control\" multiple=\"multiple\" name=\"billingWeekday\" ng-model=\"vm.billingWeekday\" id=\"field_billingWeekday\"><option value=\"1\" translate=\"wamasysApp.portefeuilleContrat.periodType.monday\">DAY</option><option value=\"2\" translate=\"wamasysApp.portefeuilleContrat.periodType.tuesday\">DAY</option><option value=\"4\" translate=\"wamasysApp.portefeuilleContrat.periodType.wednesday\">DAY</option><option value=\"8\" translate=\"wamasysApp.portefeuilleContrat.periodType.thursday\">DAY</option><option value=\"16\" translate=\"wamasysApp.portefeuilleContrat.periodType.friday\">DAY</option><option value=\"32\" translate=\"wamasysApp.portefeuilleContrat.periodType.saturday\">DAY</option><option value=\"64\" translate=\"wamasysApp.portefeuilleContrat.periodType.sunday\">DAY</option></select></div></div><div class=\"row\" ng-show=\"vm.autoBillingEnabled\"><div class=\"form-group col-md-4\"><label translate=\"wamasysApp.portefeuilleContrat.autoInvoiceNextDate\" for=\"field_autoInvoiceNextDate\">autoInvoiceNextDate</label><div class=\"input-group\"><input ng-readonly=\"! vm.hasAreaManagementRight\" placeholder=\"{{ \'wamasysApp.portefeuilleContrat.autoInvoiceNextDate\' | translate }}\" id=\"field_autoInvoiceNextDate\" type=\"text\" class=\"form-control\" name=\"autoInvoiceNextDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.portefeuilleContrat.autoInvoiceNextDate\" is-open=\"vm.datePickerOpenStatus.autoInvoiceNextDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'autoInvoiceNextDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group col-md-4\"><label class=\"control-label\" translate=\"wamasysApp.portefeuilleContrat.autoInvoicePeriodType\" for=\"field_autoInvoicePeriodType\">autoInvoicePeriodType</label><select ng-readonly=\"! vm.hasAreaManagementRight\" class=\"form-control\" name=\"autoInvoicePeriodType\" ng-model=\"vm.portefeuilleContrat.autoInvoicePeriodType\" id=\"field_autoInvoicePeriodType\"><option value=\"DAY\" translate=\"wamasysApp.portefeuilleContrat.periodType.DAY\">DAY</option><option value=\"MONTH\" translate=\"wamasysApp.portefeuilleContrat.periodType.MONTH\">MONTH</option><option value=\"WEEKDAY\" translate=\"wamasysApp.portefeuilleContrat.periodType.WEEKDAY\">WEEKDAY</option></select></div><div class=\"form-group col-md-4\" ng-if=\"vm.portefeuilleContrat.autoInvoicePeriodType != \'WEEKDAY\'\"><label translate=\"wamasysApp.portefeuilleContrat.autoInvoiceInterval\" for=\"field_autoInvoiceInterval\">autoInvoiceInterval</label><input ng-readonly=\"! vm.hasAreaManagementRight\" type=\"number\" class=\"form-control\" name=\"autoInvoiceInterval\" id=\"field_autoInvoiceInterval\" ng-model=\"vm.portefeuilleContrat.autoInvoiceInterval\" min=\"0\" max=\"999999\" placeholder=\"{{ \'wamasysApp.portefeuilleContrat.autoInvoiceInterval\' | translate }}\"><div ng-show=\"editForm.autoInvoiceInterval.$invalid\"><p class=\"help-block\" ng-show=\"editForm.autoInvoiceInterval.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.autoInvoiceInterval.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.autoInvoiceInterval.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\">This field cannot be more than 999999.</p><p class=\"help-block\" ng-show=\"editForm.autoInvoiceInterval.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group col-md-4\" ng-if=\"vm.portefeuilleContrat.autoInvoicePeriodType == \'WEEKDAY\'\"><label translate=\"wamasysApp.portefeuilleContrat.autoInvoiceInterval\" for=\"field_autoInvoiceInterval\">autoInvoiceInterval</label><!-- 				  <ui-select tagging multiple=\"multiple\"  ng-model=\"vm.invoiceWeekday2\" theme=\"selectize\">\n								    <ui-select-match placeholder=\"{{\'wamasysApp.portefeuilleContrat.autoInvoiceInterval\' | translate}}\">{{$select.selected.label}}</ui-select-match>\n								    <ui-select-choices repeat=\"item.id as item in vm.listDay | filter: $select.search \">\n								      {{item.label}}\n								    </ui-select-choices>\n								  </ui-select>\n								   --><select tagging theme=\"selectize\" ng-change=\"vm.onUpdateInvoiceWeekday()\" ng-readonly=\"! vm.hasAreaManagementRight\" class=\"form-control\" multiple=\"multiple\" name=\"invoiceWeekday\" ng-model=\"vm.invoiceWeekday\" id=\"field_invoiceWeekday\"><option value=\"1\" translate=\"wamasysApp.portefeuilleContrat.periodType.monday\">DAY</option><option value=\"2\" translate=\"wamasysApp.portefeuilleContrat.periodType.tuesday\">DAY</option><option value=\"4\" translate=\"wamasysApp.portefeuilleContrat.periodType.wednesday\">DAY</option><option value=\"8\" translate=\"wamasysApp.portefeuilleContrat.periodType.thursday\">DAY</option><option value=\"16\" translate=\"wamasysApp.portefeuilleContrat.periodType.friday\">DAY</option><option value=\"32\" translate=\"wamasysApp.portefeuilleContrat.periodType.saturday\">DAY</option><option value=\"64\" translate=\"wamasysApp.portefeuilleContrat.periodType.sunday\">DAY</option></select></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/portefeuille-contrat/portefeuille-contrats.html","<div><h2 translate=\"wamasysApp.portefeuilleContrat.home.title\">PortefeuilleContrats</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"portefeuille-contrat.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.portefeuilleContrat.home.createLabel\">Create new PortefeuilleContrat</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"libelle\"><span translate=\"wamasysApp.portefeuilleContrat.libelle\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"collecteur.id\"><span translate=\"wamasysApp.portefeuilleContrat.collecteur\">collecteur</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastDateBilling\"><span translate=\"wamasysApp.portefeuilleContrat.lastDateBilling\">lastDateBilling</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"autoInvoiceNextDate\"><span translate=\"wamasysApp.portefeuilleContrat.autoInvoiceNextDate\">autoInvoiceNextDate</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"autoBillingNextDate\"><span translate=\"wamasysApp.portefeuilleContrat.autoBillingNextDate\">autoBillingNextDate</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"portefeuilleContrat in vm.portefeuilleContrats track by portefeuilleContrat.id\"><td><a ui-sref=\"portefeuille-contrat-detail({id:portefeuilleContrat.id})\">{{portefeuilleContrat.libelle}}</a></td><td><a ui-sref=\"collecteur-detail({login:portefeuilleContrat.collecteur.login})\">{{portefeuilleContrat.collecteur.firstName + \' \' + portefeuilleContrat.collecteur.lastName}}</a></td><td>{{portefeuilleContrat.lastDateBilling | date:\'mediumDate\'}}</td><td>{{portefeuilleContrat.autoInvoiceNextDate | date:\'mediumDate\'}}</td><td>{{portefeuilleContrat.autoBillingNextDate | date:\'mediumDate\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"portefeuille-contrat-detail({id:portefeuilleContrat.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"portefeuille-contrat.edit({id:portefeuilleContrat.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"portefeuille-contrat.delete({id:portefeuilleContrat.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/profil-contrat/profil-contrat-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.contractProfil.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.contractProfil.delete.question\" translate-values=\"{id: \'{{vm.contractProfil.id}}\'}\">Are you sure you want to delete this ContractProfil?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/profil-contrat/profil-contrat-detail.html","<div><h2><span translate=\"wamasysApp.contractProfil.detail.title\">ContractProfil</span> {{vm.contractProfil.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"global.field.code\">Code</span></dt><dd><span>{{vm.contractProfil.code}}</span></dd><hr><dt><span translate=\"wamasysApp.contractProfil.libelle\">Libelle</span></dt><dd><span>{{vm.contractProfil.libelle}}<span></span></span></dd><hr><dt><span translate=\"global.field.isDeleted\">isDeleted</span></dt><dd><span>{{vm.contractProfil.deleted}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/profil-contrat/profil-contrat-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myContractProfilLabel\" translate=\"wamasysApp.contractProfil.home.createOrEditLabel\">Create or edit a ContractProfil</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><libelle for=\"id\" translate=\"global.field.id\">ID</libelle><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.contractProfil.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"global.field.code\" for=\"field_code\">Code</label><input ng-readonly=\"vm.contractProfil.id != null\" required type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.contractProfil.code\" ng-maxlength=\"64\" ng-pattern=\"/^[_.A-Z0-9-]*$/\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.pattern\" translate=\"wamasysApp.contractProfil.codeArticleFormatError\">The article code can only contain upper-case letters and digits.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"64\">This field cannot be longer than 64 characters.</p></div></div><div class=\"form-group\"><libelle class=\"control-libelle\" translate=\"wamasysApp.contractProfil.libelle\" for=\"field_libelle\">Libelle</libelle><input type=\"text\" class=\"form-control\" name=\"libelle\" id=\"field_libelle\" ng-model=\"vm.contractProfil.libelle\" required ng-maxlength=\"50\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.libelle.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.libelle.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.contractProfil.id\"><label class=\"control-deleted\" translate=\"global.field.isDeleted\" for=\"field_deleted\">deleted</label><input type=\"checkbox\" class=\"form-control\" name=\"deleted\" id=\"field_deleted\" ng-model=\"vm.contractProfil.deleted\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/profil-contrat/profil-contrats.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.contractProfil.home.title\">ContractProfils</span> <small class=\"text-muted\" translate=\"global.configurationScope.organization\">Paramétrage commun à toute l\'organisation</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"profil-contrat.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.contractProfil.home.createLabel\">Create new ContractProfil</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"libelle\"><span translate=\"wamasysApp.contractProfil.libelle\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"global.field.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deleted\"><span translate=\"global.field.isDeleted\">isDeleted</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"contractProfil in vm.contractProfils track by contractProfil.id\"><td><a ui-sref=\"profil-contrat-detail({id:contractProfil.id})\">{{contractProfil.id}}</a></td><td>{{contractProfil.libelle}}</td><td>{{contractProfil.code}}</td><td>{{contractProfil.deleted}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"profil-contrat-detail({id:contractProfil.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"profil-contrat.edit({id:contractProfil.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"profil-contrat.delete({id:contractProfil.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/releve-compteur/releve-compteur-control.html","<div class=\"releve-compteur-control\"><style>.releve-compteur-control .control-meta dt,\n        .releve-compteur-control .control-meta dd {\n            margin: 0;\n        }\n\n        .releve-compteur-control .control-meta dd {\n            margin-top: 4px;\n        }\n\n        .releve-compteur-control .control-toolbar-actions,\n        .releve-compteur-control .control-toolbar-filters {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 10px;\n            align-items: center;\n            margin-bottom: 10px;\n        }\n\n        .releve-compteur-control .control-toolbar-filters label {\n            margin: 0 12px 0 0;\n            font-weight: normal;\n        }\n\n        .releve-compteur-control .control-primary-link {\n            font-weight: 600;\n        }\n\n        .releve-compteur-control .control-summary-grid {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 12px;\n            margin-bottom: 15px;\n        }\n\n        .releve-compteur-control .control-summary-card {\n            min-width: 150px;\n            padding: 10px 12px;\n            border: 1px solid #d7dde5;\n            border-radius: 4px;\n            background: #f8fafc;\n        }\n\n        .releve-compteur-control .control-summary-label {\n            display: block;\n            color: #5f6b7a;\n            font-size: 12px;\n            text-transform: uppercase;\n        }\n\n        .releve-compteur-control .control-summary-value {\n            display: block;\n            font-size: 24px;\n            font-weight: 700;\n            line-height: 1.2;\n        }\n\n        .releve-compteur-control .control-muted-block {\n            display: block;\n            margin-top: 3px;\n        }\n\n        .releve-compteur-control .control-distance-main {\n            font-size: 18px;\n            font-weight: 700;\n            line-height: 1.2;\n            margin-bottom: 4px;\n        }\n\n        .releve-compteur-control .control-distance-main.is-alert {\n            color: #a94442;\n        }\n\n        .releve-compteur-control .control-gps-line {\n            display: block;\n            margin-top: 2px;\n        }\n\n        .releve-compteur-control .control-last-reading-line,\n        .releve-compteur-control .control-consumption-line {\n            display: block;\n            margin-top: 3px;\n        }\n\n        .releve-compteur-control .control-actions-cell {\n            white-space: nowrap;\n            width: 1%;\n        }\n\n        .releve-compteur-control .control-actions-cell .btn-group {\n            display: flex;\n        }\n\n        .releve-compteur-control .control-inline-select {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n        }\n\n        .releve-compteur-control .control-map-filters {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 12px;\n            margin-bottom: 12px;\n        }\n\n        .releve-compteur-control .control-map-filters label {\n            margin: 0;\n            font-weight: normal;\n        }\n\n        .releve-compteur-control .control-link-action {\n            padding: 0;\n            margin-top: 4px;\n        }</style><h2><span translate=\"wamasysApp.releveCompteur.control.title\">Ecran de controle</span> <small ng-if=\"vm.releveCompteur.id\">#{{vm.releveCompteur.id}}</small></h2><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><smartphone-handoffs document-type=\"RF\" document-id=\"vm.releveCompteur.id\" document=\"vm.releveCompteur\" on-updated=\"vm.refreshHandoffDocument()\"></smartphone-handoffs><div class=\"row control-meta margin-bottom-15\" ng-if=\"vm.releveCompteur.id\"><div class=\"col-sm-2 col-xs-6\"><dt><span translate=\"wamasysApp.releveCompteur.dateReleve\">Date de lecture</span></dt><dd>{{vm.releveCompteur.dateReleve | date:\'mediumDate\'}}</dd></div><div class=\"col-sm-2 col-xs-6\"><dt><span translate=\"wamasysApp.releveCompteur.etat\">Etat</span></dt><dd><span translate=\"{{\'wamasysApp.EtatReleveCompteur.\' + vm.releveCompteur.etat}}\">{{vm.releveCompteur.etat}}</span></dd></div><div class=\"col-sm-3 col-xs-6\"><dt><span translate=\"wamasysApp.releveCompteur.collecteur\">Collecteur</span></dt><dd>{{(vm.releveCompteur.collecteur.firstName || \'\') + \' \' + (vm.releveCompteur.collecteur.lastName || \'\')}}</dd></div><div class=\"col-sm-2 col-xs-6\"><dt><span translate=\"wamasysApp.releveCompteur.createdBy\">Cree par</span></dt><dd>{{vm.releveCompteur.createdBy || \'-\'}} <small ng-if=\"vm.releveCompteur.createdDate\">({{vm.releveCompteur.createdDate | date:\'medium\'}})</small></dd></div><div class=\"col-sm-3 col-xs-12\"><dt><span translate=\"wamasysApp.releveCompteur.lastModifiedBy\">Derniere modification par</span></dt><dd>{{vm.releveCompteur.lastModifiedBy || \'-\'}} <small ng-if=\"vm.releveCompteur.lastModifiedDate\">({{vm.releveCompteur.lastModifiedDate | date:\'medium\'}})</small></dd></div></div><div class=\"control-summary-grid\" ng-if=\"vm.controlRows.length\"><div class=\"control-summary-card\"><span class=\"control-summary-label\" translate=\"wamasysApp.releveCompteur.control.summaryTotalToRead\">Total a lire</span> <span class=\"control-summary-value\">{{vm.controlSummary.totalToRead || 0}}</span></div><div class=\"control-summary-card\"><span class=\"control-summary-label\" translate=\"wamasysApp.releveCompteur.control.summaryTotalRead\">Total lu</span> <span class=\"control-summary-value\">{{vm.controlSummary.totalRead || 0}}</span></div><div class=\"control-summary-card\"><span class=\"control-summary-label\" translate=\"wamasysApp.releveCompteur.control.summaryTotalNonReading\">Cas non releve</span> <span class=\"control-summary-value\">{{vm.controlSummary.totalNonReading || 0}}</span></div><div class=\"control-summary-card\"><span class=\"control-summary-label\" translate=\"wamasysApp.releveCompteur.control.summaryWarningAbnormal\">Warnings conso anormale</span> <span class=\"control-summary-value\">{{vm.controlSummary.warnings.abnormal || 0}}</span></div><div class=\"control-summary-card\"><span class=\"control-summary-label\" translate=\"wamasysApp.releveCompteur.control.summaryWarningNoGps\">Warnings sans GPS</span> <span class=\"control-summary-value\">{{vm.controlSummary.warnings.noGps || 0}}</span></div><div class=\"control-summary-card\"><span class=\"control-summary-label\" translate=\"wamasysApp.releveCompteur.control.summaryWarningWide\">Warnings controle large</span> <span class=\"control-summary-value\">{{vm.controlSummary.warnings.wideCheck || 0}}</span></div><div class=\"control-summary-card\"><span class=\"control-summary-label\" translate=\"wamasysApp.releveCompteur.control.summaryWarningShort\">Warnings controle court</span> <span class=\"control-summary-value\">{{vm.controlSummary.warnings.shortCheck || 0}}</span></div></div><div class=\"control-toolbar-actions\" ng-if=\"vm.controlRows.length\"><div class=\"control-inline-select\"><label for=\"controlModeSelect\" translate=\"wamasysApp.releveCompteur.control.gpsFilterLabel\">Controle GPS</label><select id=\"controlModeSelect\" class=\"form-control input-sm\" ng-model=\"vm.controlMode\"><option value=\"none\" translate=\"wamasysApp.releveCompteur.control.filterNone\">Sans controle GPS</option><option value=\"large\" translate=\"wamasysApp.releveCompteur.control.filterLarge\">Controle large</option><option value=\"short\" translate=\"wamasysApp.releveCompteur.control.filterShort\">Controle court</option></select></div><div class=\"btn-group\" role=\"group\"><button type=\"button\" class=\"btn btn-info\" ng-if=\"vm.canUseOcr()\" ng-click=\"vm.analyzeImages()\" ng-disabled=\"vm.ocrRunning || !vm.hasOcrPhotos()\"><span class=\"glyphicon glyphicon-search\" aria-hidden=\"true\"></span> <span translate=\"wamasysApp.releveCompteur.ocr.analyze\">Analyser les images</span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openAllReadingsMap()\" translate=\"wamasysApp.releveCompteur.control.openAllReadingsMap\">Ouvrir la carte</button> <a class=\"btn btn-default\" ui-sref=\"releve-compteur.delete({id:vm.releveCompteur.id})\" has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" ng-if=\"vm.canModify()\"><span translate=\"wamasysApp.releveCompteur.detail.annulerreleve\">Annuler le releve</span> </a><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.applyMissingReadingGpsToContracts()\" ng-disabled=\"vm.bulkUpdatingContracts\" has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" ng-if=\"vm.canModify()\" translate=\"wamasysApp.releveCompteur.control.applyMissingContractGps\">Maj contrats sans GPS</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.applyMissingReadingGpsToMeters()\" ng-disabled=\"vm.bulkUpdatingMeters\" has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" ng-if=\"vm.canModify()\" translate=\"wamasysApp.releveCompteur.control.applyMissingMeterGps\">Maj compteurs sans GPS</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.validerReleve()\" ng-disabled=\"vm.validatingReleve || !vm.canValidate()\" has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" ng-if=\"vm.canShowValidate()\" translate=\"wamasysApp.releveCompteur.control.validateReadingForm\">Valider le releve</button></div></div><div class=\"alert alert-warning\" ng-if=\"vm.canShowValidate() && !vm.canValidate()\"><span translate=\"wamasysApp.releveCompteur.control.validationIncomplete\">Le releve de compteur n\'est pas termine.</span> <span ng-if=\"vm.controlSummary.remaining\">{{vm.controlSummary.remaining}} </span><span ng-if=\"vm.controlSummary.remaining\" translate=\"wamasysApp.releveCompteur.control.remainingRows\">ligne(s) restent a renseigner.</span></div><div class=\"alert alert-info\" ng-if=\"vm.canUseOcr() && vm.ocrTotal\"><span translate=\"wamasysApp.releveCompteur.ocr.progress\">Photos analysées</span> : {{vm.ocrCompleted}} / {{vm.ocrTotal}}. <span translate=\"wamasysApp.releveCompteur.ocr.notice\">Résultats indicatifs à vérifier sur la photo. Aucun relevé n’est modifié. Écart = index détecté − valeur enregistrée au moment de l’analyse.</span></div><div class=\"control-toolbar-filters\" ng-if=\"vm.controlRows.length\"><label><input type=\"checkbox\" ng-model=\"vm.showOnlyErrors\"> <span translate=\"wamasysApp.releveCompteur.control.showOnlyErrors\">Afficher seulement les lignes en erreur</span></label><label><input type=\"checkbox\" ng-model=\"vm.showOnlyFilled\"> <span translate=\"wamasysApp.releveCompteur.control.showOnlyFilled\">Afficher seulement les lignes renseignees</span></label><label><input type=\"checkbox\" ng-model=\"vm.showOnlyNonReadingCase\"> <span translate=\"wamasysApp.releveCompteur.control.showOnlyNonReadingCase\">Afficher seulement les cas de non releve</span></label></div><div class=\"alert alert-info\" ng-if=\"!vm.controlRows.length\" translate=\"wamasysApp.releveCompteur.control.empty\">Aucun compteur a controler.</div><div class=\"alert alert-info\" ng-if=\"vm.controlRows.length && !vm.getVisibleRows().length\" translate=\"wamasysApp.releveCompteur.control.noFilteredRows\">Aucune ligne ne correspond aux filtres actifs.</div><div class=\"table-responsive\" ng-if=\"vm.getVisibleRows().length\"><table class=\"table table-striped table-bordered\"><thead><tr><th translate=\"wamasysApp.releveCompteur.control.contract\">Contrat</th><th translate=\"wamasysApp.releveCompteur.control.meter\">Compteur</th><th translate=\"wamasysApp.releveCompteur.control.clusterOrder\">Cluster / ordre</th><th translate=\"wamasysApp.releveCompteur.control.lastReading\">Derniere lecture</th><th translate=\"wamasysApp.releveCompteur.control.date\">Date</th><th translate=\"wamasysApp.releveCompteur.control.value\">Valeur lue</th><th translate=\"wamasysApp.releveCompteur.control.nonReading\">Cas de non releve</th><th translate=\"wamasysApp.releveCompteur.control.newConsumption\">Nouvelle conso</th><th translate=\"wamasysApp.releveCompteur.control.status\">Controle</th><th translate=\"wamasysApp.releveCompteur.control.distanceGps\">Distance / GPS</th><th translate=\"wamasysApp.releveCompteur.control.photo\">Photo</th><th ng-if=\"vm.canUseOcr()\" translate=\"wamasysApp.releveCompteur.ocr.title\">Analyse des images</th><th translate=\"wamasysApp.releveCompteur.control.actions\">Actions</th></tr></thead><tbody><tr ng-repeat=\"row in vm.getVisibleRows() track by row.idLigneReleveCompteur\" ng-class=\"{\'danger\': row.abnormal || vm.isDistanceAlert(row), \'warning\': !row.abnormal && row.hasMissingReadingGps && !vm.isDistanceAlert(row)}\"><td><div ng-if=\"row.contractUrl\"><a class=\"control-primary-link\" target=\"_blank\" ng-href=\"{{row.contractUrl}}\">{{row.contractReference || \'-\'}}</a></div><div ng-if=\"!row.contractUrl\">{{row.contractReference || \'-\'}}</div><small class=\"text-muted control-muted-block\" ng-if=\"row.beneficiaryName\">{{row.beneficiaryName}}</small></td><td><div ng-if=\"row.meterUrl\"><a class=\"control-primary-link\" target=\"_blank\" ng-href=\"{{row.meterUrl}}\">{{row.meterNumber || \'-\'}}</a></div><div ng-if=\"!row.meterUrl\">{{row.meterNumber || \'-\'}}</div><small class=\"text-muted control-muted-block\">{{row.meterType}}</small></td><td><div>{{row.clusterLabel || \'-\'}}</div><small class=\"text-muted control-muted-block\"><span translate=\"wamasysApp.releveCompteur.control.readingOrder\">Reading order</span>: {{row.runningOrderLabel || \'-\'}}</small></td><td><span class=\"control-last-reading-line\"><strong translate=\"wamasysApp.releveCompteur.control.lastReadingDate\">Date</strong>: {{row.previousReadingDateLabel || \'-\'}} </span><span class=\"control-last-reading-line\"><strong translate=\"wamasysApp.releveCompteur.control.lastReadingValue\">Valeur</strong>: {{row.previousReadingValue !== null ? (row.previousReadingValue | number:3) : \'-\'}} </span><span class=\"control-last-reading-line\"><strong translate=\"wamasysApp.releveCompteur.control.lastConsumption\">Conso</strong>: {{row.previousConsumption !== null ? (row.previousConsumption | number:3) : \'-\'}}</span></td><td>{{row.readingDateLabel}}</td><td style=\"min-width: 130px\"><div ng-if=\"!row.isEditing\">{{row.readingValue !== null && row.readingValue !== undefined ? (row.readingValue | number:3) : \'-\'}}</div><input ng-if=\"row.isEditing\" type=\"number\" class=\"form-control input-sm\" step=\"0.001\" min=\"0\" ng-model=\"row.editedReadingValue\"></td><td style=\"min-width: 170px\"><div ng-if=\"!row.isEditing\">{{row.nonReadingCaseLabel || \'-\'}}</div><select ng-if=\"row.isEditing\" class=\"form-control input-sm\" ng-model=\"row.editedNonReadingCaseId\" ng-options=\"caseOption.id as caseOption.libelle for caseOption in vm.caseOptions\"><option value=\"\">-</option></select></td><td><div>{{row.consumption !== null ? (row.consumption | number:3) : \'-\'}}</div><small class=\"text-muted control-consumption-line\" ng-if=\"row.maxAcceptedConsumption !== null\"><span translate=\"wamasysApp.releveCompteur.control.maxAcceptedConsumption\">Max accepted consumption</span>: {{row.maxAcceptedConsumption | number:3}} </small><small class=\"text-muted control-consumption-line\" ng-if=\"row.maxAcceptedConsumption === null && !row.maxCheckDisabled\" translate=\"wamasysApp.releveCompteur.control.noMaxAcceptedConsumption\">Max accepted consumption unavailable </small><small class=\"text-warning control-consumption-line\" ng-if=\"row.maxCheckDisabled\" translate=\"wamasysApp.releveCompteur.control.maxCheckDisabled\">Controle max desactive sur ce compteur</small></td><td><span class=\"label\" ng-class=\"row.abnormal ? \'label-danger\' : \'label-success\'\">{{row.abnormalLabel}}</span><div class=\"margin-top-5\" ng-if=\"row.hasMissingReadingGps\"><span class=\"label label-warning\" translate=\"wamasysApp.releveCompteur.control.noGpsWarning\">Sans GPS</span></div><div class=\"margin-top-5\" ng-if=\"vm.isDistanceAlert(row)\"><span class=\"label label-danger\" translate=\"wamasysApp.releveCompteur.control.gpsMismatch\">GPS eloigne</span></div></td><td style=\"min-width: 220px\"><div class=\"control-distance-main\" ng-class=\"{\'is-alert\': vm.isDistanceAlert(row)}\">{{row.distanceHeadlineLabel}}</div><small class=\"text-muted control-gps-line\"><strong>L:</strong> {{row.readingGpsLabel}}</small> <small class=\"text-muted control-gps-line\"><strong>C:</strong> {{row.contractGpsLabel}}</small> <small class=\"text-muted control-gps-line\"><strong>M:</strong> {{row.meterGpsLabel}}</small> <button type=\"button\" class=\"btn btn-link btn-xs control-link-action\" ng-if=\"vm.shouldSuggestBulkMeterGpsUpdate(row)\" ng-click=\"vm.applyReadingGpsToMeter(row)\" ng-disabled=\"row.updatingMeter\" has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" translate=\"wamasysApp.releveCompteur.control.suggestBulkMeterGpsUpdate\">Mettre a jour GPS compteur general</button></td><td style=\"width: 150px\"><div ng-if=\"row.hasPhoto\"><div class=\"btn-group btn-group-xs\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openPhotoModal(row)\" translate=\"wamasysApp.releveCompteur.control.showPhoto\">Voir</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.downloadPhoto(row)\" ng-disabled=\"row.photoDownloading\" translate=\"wamasysApp.releveCompteur.control.downloadPhoto\">Telecharger</button></div><div class=\"margin-top-5\"><span class=\"text-muted\" ng-if=\"row.photoLoading\">Chargement...</span> <span class=\"text-danger\" ng-if=\"row.photoError\">Photo indisponible</span> <img ng-if=\"row.photoObjectUrl\" ng-src=\"{{row.photoObjectUrl}}\" alt=\"photo compteur\" style=\"max-width: 120px; max-height: 90px; cursor: pointer\" ng-click=\"vm.openPhotoModal(row)\"></div></div><span ng-if=\"!row.hasPhoto\">-</span></td><td ng-if=\"vm.canUseOcr()\" style=\"min-width: 190px\"><span ng-if=\"row.ocrLoading\" translate=\"wamasysApp.releveCompteur.ocr.loading\">Analyse en cours…</span> <span ng-if=\"row.ocrError\" class=\"text-danger\">{{row.ocrError}}</span><div ng-if=\"row.ocr\"><div><strong translate=\"wamasysApp.releveCompteur.ocr.value\">Index détecté</strong> : {{row.ocr.readingValue !== null ? (row.ocr.readingValue | number:4) : (\'wamasysApp.releveCompteur.ocr.unknown\' | translate)}}</div><div><span translate=\"wamasysApp.releveCompteur.ocr.recorded\">Valeur enregistrée</span> : {{row.ocr.recordedValue !== null ? (row.ocr.recordedValue | number:4) : \'-\'}}</div><div ng-class=\"{\'text-danger\': row.ocr.difference !== null && row.ocr.difference !== 0, \'text-success\': row.ocr.difference === 0}\"><strong translate=\"wamasysApp.releveCompteur.ocr.difference\">Écart</strong> : {{row.ocr.difference !== null ? (row.ocr.difference | number:4) : (\'wamasysApp.releveCompteur.ocr.notComparable\' | translate)}}</div><div><span translate=\"wamasysApp.releveCompteur.ocr.serial\">N° de série détecté</span> : {{row.ocr.serialNumber || (\'wamasysApp.releveCompteur.ocr.unknown\' | translate)}}</div><div><span translate=\"wamasysApp.releveCompteur.ocr.expectedSerial\">N° de série enregistré</span> : {{row.ocr.recordedSerialNumber || \'-\'}}</div><strong ng-if=\"row.ocr.serialMatches === false\" class=\"text-danger\" translate=\"wamasysApp.releveCompteur.ocr.serialMismatch\">Numéros de série différents</strong> <span ng-if=\"row.ocr.serialMatches === true\" class=\"text-success\" translate=\"wamasysApp.releveCompteur.ocr.serialMatch\">Numéros de série identiques</span> <span ng-if=\"row.ocr.serialMatches === null\" class=\"text-muted\" translate=\"wamasysApp.releveCompteur.ocr.notComparable\">Comparaison impossible</span></div><span ng-if=\"!row.ocr && !row.ocrLoading && !row.ocrError\">—</span></td><td class=\"control-actions-cell\"><div class=\"btn-group btn-group-xs\" ng-if=\"!row.isEditing\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openRowMap(row)\" title=\"{{\'wamasysApp.releveCompteur.control.openMap\' | translate}}\"><span class=\"fa fa-map-marker\"></span></button> <button type=\"button\" class=\"btn btn-warning\" ng-click=\"vm.enableCorrection(row)\" has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" ng-if=\"vm.canModify()\" title=\"{{\'wamasysApp.releveCompteur.control.correctReading\' | translate}}\"><span class=\"fa fa-pencil\"></span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.applyReadingGpsToMeter(row)\" ng-disabled=\"!row.meterId || row.readingLat === null || row.readingLon === null || row.updatingMeter\" has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" ng-if=\"vm.canModify()\" title=\"{{\'wamasysApp.releveCompteur.control.applyMeterGps\' | translate}}\"><span class=\"fa fa-tachometer\"></span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.applyReadingGpsToContract(row)\" ng-disabled=\"!row.idContrat || row.readingLat === null || row.readingLon === null || row.updatingContract\" has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" ng-if=\"vm.canModify()\" title=\"{{\'wamasysApp.releveCompteur.control.applyContractGps\' | translate}}\"><span class=\"fa fa-file-text-o\"></span></button></div><div class=\"btn-group btn-group-xs\" ng-if=\"row.isEditing\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.saveCorrection(row)\" ng-disabled=\"row.savingCorrection\" title=\"{{\'wamasysApp.releveCompteur.control.saveCorrection\' | translate}}\"><span class=\"fa fa-save\"></span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.cancelCorrection(row)\" title=\"{{\'wamasysApp.releveCompteur.control.cancelCorrection\' | translate}}\"><span class=\"fa fa-times\"></span></button></div></td></tr></tbody></table></div><photo-viewer-modal modal=\"vm.photoModal\"></photo-viewer-modal><div class=\"modal fade in\" ng-if=\"vm.mapModal.visible\" style=\"display: block; background: rgba(0, 0, 0, 0.55)\"><div class=\"modal-dialog modal-lg\" style=\"width: 92%; max-width: 1180px; margin-top: 30px\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.closeMapModal()\">&times;</button><h4 class=\"modal-title\">{{vm.mapModal.title}}</h4></div><div class=\"modal-body\"><div class=\"control-map-filters\"><label><input type=\"checkbox\" ng-model=\"vm.mapModal.showContracts\" ng-change=\"vm.updateMapModalPoints()\"> <span translate=\"wamasysApp.releveCompteur.control.mapShowContract\">Voir contrat</span></label><label><input type=\"checkbox\" ng-model=\"vm.mapModal.showReadings\" ng-change=\"vm.updateMapModalPoints()\"> <span translate=\"wamasysApp.releveCompteur.control.mapShowReading\">Voir lecture</span></label><label><input type=\"checkbox\" ng-model=\"vm.mapModal.showMeters\" ng-change=\"vm.updateMapModalPoints()\"> <span translate=\"wamasysApp.releveCompteur.control.mapShowMeter\">Voir compteur</span></label></div><journey-map points=\"vm.mapModal.points\" refresh-token=\"vm.mapModal.refreshToken\" show-route=\"vm.mapModal.showRoute\" height=\"520px\"></journey-map></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.closeMapModal()\">Fermer</button></div></div></div></div></div>");
$templateCache.put("app/business/releve-compteur/releve-compteur-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDeleteAction(vm.releveCompteur.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div ng-if=\"vm.releveCompteur.etat == \'ENCOURS\'\" class=\"alert alert-warning\" translate=\"wamasysApp.releveCompteur.messageAlerteRFEnCours\"></div><p translate=\"wamasysApp.releveCompteur.delete.question\" translate-values=\"{id: \'{{vm.releveCompteur.id}}\'}\">Are you sure you want to delete this ReleveCompteur?</p><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.releveCompteur.confirmDelete\" for=\"field_referenceCollectionList\">DateFinPeriode</label><input id=\"field_dateFinPeriode\" type=\"text\" class=\"form-control\" name=\"referenceCollectionList\" ng-model=\"vm.confirmDelete\" required><div ng-show=\"deleteForm.referenceCollectionList.$invalid\"><p class=\"help-block\" ng-show=\"editForm.dateFinPeriode.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/releve-compteur/releve-compteur-detail.html","<div><h2><span translate=\"wamasysApp.releveCompteur.detail.title\">ReleveCompteur</span> {{vm.releveCompteur.id}}</h2><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-2\"><dt><span translate=\"wamasysApp.releveCompteur.dateReleve\">DateReleve</span></dt><dd><span>{{vm.releveCompteur.dateReleve | date:\'mediumDate\'}}</span></dd></div><div class=\"col-md-2\"><dd><dt><span translate=\"wamasysApp.releveCompteur.etat\">Etat</span></dt></dd><dd><span translate=\"{{\'wamasysApp.EtatReleveCompteur.\' + vm.releveCompteur.etat}}\">{{vm.releveCompteur.etat}}</span></dd></div><div class=\"col-md-3\"><dd><dt><span translate=\"wamasysApp.releveCompteur.collecteur\">collecteur</span></dt>{{vm.releveCompteur.collecteur.firstName + \' \' + vm.releveCompteur.collecteur.lastName}}</dd></div><div class=\"col-md-2\"><dd><dt><span translate=\"wamasysApp.releveCompteur.createdBy\">createdBy</span></dt>{{vm.releveCompteur.createdBy }} <small>( {{ vm.releveCompteur.createdDate | date:\'medium\'}} )</small></dd></div><div class=\"col-md-3\"><dd><dt><span translate=\"wamasysApp.releveCompteur.lastModifiedBy\">lastModifiedBy</span></dt>{{vm.releveCompteur.lastModifiedBy }} <small>({{ vm.releveCompteur.lastModifiedDate | date:\'medium\'}} )</small></dd></div></div><div class=\"padding-10 row\"><div class=\"pull-right\"><button has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" ng-disabled=\"vm.disableBtnEdition\" id=\"btnValideReleve\" ng-show=\"vm.releveCompteur.etat == \'AVALIDER\' || vm.releveCompteur.etat == \'ENCOURS\'\" class=\"btn btn-primary\" ng-click=\"vm.valider()\"><span translate=\"wamasysApp.releveCompteur.detail.validerreleve\">Valider le relevé</span></button> <button has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" ng-disabled=\"vm.disableBtnEdition\" id=\"btnEditRows\" ng-click=\"vm.startEdit()\" ng-show=\"vm.releveCompteur.etat == \'ARENSEIGNER\' || vm.releveCompteur.etat == \'ENCOURS\' || vm.releveCompteur.etat == \'AVALIDER\' \" class=\"btn btn-primary\"><span translate=\"wamasysApp.releveCompteur.detail.modifierreleve\">Modifier le relevé</span></button> <button has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" ng-disabled=\"vm.disableBtnEdition\" ng-show=\"vm.releveCompteur.etat == \'ARENSEIGNER\' || vm.releveCompteur.etat == \'ENCOURS\' || vm.releveCompteur.etat == \'AVALIDER\' \" class=\"btn btn-primary\" ui-sref=\"releve-compteur.delete({id:vm.releveCompteur.id})\"><span translate=\"wamasysApp.releveCompteur.detail.annulerreleve\">Annuler le relevé</span></button> <a has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" ng-disabled=\"vm.disableBtnEdition\" ng-show=\"vm.releveCompteur.etat == \'ARENSEIGNER\' || vm.releveCompteur.etat == \'ENCOURS\' || vm.releveCompteur.etat == \'AVALIDER\' \" class=\"btn btn-primary\" ng-click=\"vm.print()\"><span translate=\"wamasysApp.releveCompteur.detail.imprimerreleve\">Imprimer feuille de collecte </span></a><a class=\"btn btn-default\" ng-href=\"{{vm.getMapUrl(vm.releveCompteur.id)}}\" has-module=\"NEW_FEATURES_VISIBILITY\"><span class=\"fa fa-map-marker\"></span> <span translate=\"wamasysApp.releveCompteur.detail.showMap\">Voir la carte</span> </a><a class=\"btn btn-default\" ng-href=\"{{vm.getControlUrl(vm.releveCompteur.id)}}\" target=\"_blank\" has-module=\"NEW_FEATURES_VISIBILITY\"><span class=\"fa fa-table\"></span> <span translate=\"wamasysApp.releveCompteur.detail.openControl\">Ecran de controle</span> </a><!-- Etat possible ARENSEIGNER ENCOURS AVALIDER VALIDE \"ANNULE --></div></div><div id=\"erreurReleve\" class=\"alert alert-danger\" ng-show=\"vm.erreurReleve\" translate=\"wamasysApp.releveCompteur.erreurSaisie\">Erreur sur la saisie</div><style>.ui-state-hover { color: black !important; }\n		.ui-state-hover a { color: black !important; }\n		.editable {color: black !important; }</style><!-- Widget ID (each widget will need unique ID)--><div id=\"full-screen-widget\" data-widget-colorbutton=\"false\" data-widget-editbutton=\"false\" data-widget-togglebutton=\"false\" data-widget-deletebutton=\"false\" data-widget-color=\"blue\" data-jarvis-widget><header><span class=\"widget-icon\"><i class=\"fa fa-table\"></i></span><h2 translate=\"wamasysApp.releveCompteur.detail.listeReleve\">Liste relevé</h2></header><!-- widget div--><div><!-- widget content --><div class=\"widget-body no-padding\"><div class=\"row\"><article class=\"col-sm-12\"><input has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" type=\"button\" id=\"btnSaveRows\" ng-disabled=\"vm.disableBtnSaveCancel\" class=\"btn btn-primary\" style=\"display:none\" value=\"{{\'wamasysApp.releveCompteur.detail.sauvegarder\' | translate}}\" ng-click=\"vm.saveRows(false)\"> <input has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" type=\"button\" id=\"btnSaveRowsForce\" ng-disabled=\"vm.disableBtnSaveCancel\" class=\"btn btn-primary\" style=\"display:none\" value=\"{{\'wamasysApp.releveCompteur.detail.sauvegarderForcer\' | translate}}\" ng-click=\"vm.saveRows(true)\"> <input has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" type=\"button\" id=\"btnCancelRows\" ng-disabled=\"vm.disableBtnSaveCancel\" class=\"btn btn-primary\" style=\"display:none\" value=\"{{\'wamasysApp.releveCompteur.detail.annuler\' | translate}}\" ng-click=\"vm.cancelEditRows()\"><br><!-- \n					    <div class=\"text-center\">\n					        <jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count>\n					        <uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination>\n					    </div>\n				     --><jq-grid-releve-compteur grid-data=\"gridData\" releve-compteur=\"vm.releveCompteur\"></jq-grid-releve-compteur><br><input has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" type=\"button\" id=\"btnSaveRows\" ng-disabled=\"vm.disableBtnSaveCancel\" class=\"btn btn-primary\" style=\"display:none\" value=\"{{\'wamasysApp.releveCompteur.detail.sauvegarder\' | translate}}\" ng-click=\"vm.saveRows(false)\"> <input has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" type=\"button\" id=\"btnSaveRowsForce\" ng-disabled=\"vm.disableBtnSaveCancel\" class=\"btn btn-primary\" style=\"display:none\" value=\"{{\'wamasysApp.releveCompteur.detail.sauvegarderForcer\' | translate}}\" ng-click=\"vm.saveRows(true)\"> <input has-any-authority=\"ROLE_ADMIN,ROLE_DATA_OPERATOR\" type=\"button\" id=\"btnCancelRows\" ng-disabled=\"vm.disableBtnSaveCancel\" class=\"btn btn-primary\" style=\"display:none\" value=\"{{\'wamasysApp.releveCompteur.detail.annuler\' | translate}}\" ng-click=\"vm.cancelEditRows()\"></article></div></div></div></div><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/releve-compteur/releve-compteur-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myReleveCompteurLabel\" translate=\"wamasysApp.releveCompteur.home.createOrEditLabel\">Create or edit a ReleveCompteur</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.releveCompteur.dateReleve\" for=\"field_dateReleve\">DateReleve</label><div class=\"input-group\"><input ng-click=\"vm.openCalendar(\'dateReleve\')\" id=\"field_dateReleve\" type=\"text\" class=\"form-control\" name=\"dateReleve\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.releveCompteur.dateReleve\" is-open=\"vm.datePickerOpenStatus.dateReleve\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateReleve\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.dateReleve.$invalid\"><p class=\"help-block\" ng-show=\"editForm.dateReleve.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.dateReleve.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.releveCompteur.collecteur\" for=\"field_collecteur\">collecteur</label><select ng-change=\"vm.updateCollecteur()\" class=\"form-control\" id=\"field_collecteur\" name=\"collecteur\" ng-model=\"vm.releveCompteur.collecteur\" ng-options=\"user as (user.firstName + \' \' + user.lastName) for user in vm.users track by user.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.releveCompteur.bulkMeter\" for=\"field_listeBulkMeter\">Bulk Meter</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.releveCompteur.listeBulkMeter\" theme=\"selectize\" title=\"{{\'wamasysApp.releveCompteur.bulkMeter\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.releveCompteur.bulkMeter\' | translate}}\">{{$item.numeroSerie}}</ui-select-match><ui-select-choices repeat=\"bulkMeter in vm.listBulkMeter | filter: $select.search  track by bulkMeter.id\">{{bulkMeter.numeroSerie}}</ui-select-choices></ui-select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.releveCompteur.cluster\" for=\"field_listeCluster\">Cluster</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.releveCompteur.listeCluster\" theme=\"selectize\" title=\"{{\'wamasysApp.releveCompteur.cluster\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.releveCompteur.cluster\' | translate}}\">{{$item.numeroSerie}}</ui-select-match><ui-select-choices repeat=\"cluster in vm.listCluster | filter: $select.search  track by cluster.id\">{{cluster.numeroSerie}}</ui-select-choices></ui-select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/releve-compteur/releve-compteur-map.html","<div><h2><span translate=\"wamasysApp.releveCompteur.map.title\">Carte du parcours</span> <small ng-if=\"vm.releveCompteur.dateReleve\">- {{vm.releveCompteur.dateReleve | date:\'mediumDate\'}}</small></h2><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><div class=\"row margin-bottom-10\"><div class=\"col-md-12\"><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"vm.showReadings\" ng-change=\"vm.updateVisibility()\"> <span translate=\"wamasysApp.releveCompteur.map.showReading\">Lectures</span></label><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"vm.showContracts\" ng-change=\"vm.updateVisibility()\"> <span translate=\"wamasysApp.releveCompteur.map.showContract\">Contrats associes</span></label><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"vm.showMeters\" ng-change=\"vm.updateVisibility()\"> <span translate=\"wamasysApp.releveCompteur.map.showMeter\">Compteurs associes</span></label></div></div><journey-map points=\"vm.mapPoints\" active-point-key=\"vm.activePointKey\" refresh-token=\"vm.mapRefreshToken\" show-route=\"false\" geometry=\"vm.areaGeometry\" height=\"460px\"></journey-map><div class=\"alert alert-info margin-top-10\" ng-if=\"!vm.mapPoints.length\" translate=\"wamasysApp.releveCompteur.map.empty\">Aucun point GPS disponible pour ce releve.</div><div class=\"table-responsive margin-top-10\" ng-if=\"vm.filteredRows.length\"><table class=\"table table-striped table-bordered\"><thead><tr><th translate=\"wamasysApp.releveCompteur.map.time\">Heure</th><th translate=\"wamasysApp.releveCompteur.map.reference\">Reference</th><th translate=\"wamasysApp.releveCompteur.map.meter\">Compteur</th><th translate=\"wamasysApp.releveCompteur.map.value\">Valeur</th><th translate=\"wamasysApp.releveCompteur.map.readingGps\">GPS lecture</th><th translate=\"wamasysApp.releveCompteur.map.contractGps\">GPS contrat</th><th translate=\"wamasysApp.releveCompteur.map.meterGps\">GPS compteur</th><th translate=\"wamasysApp.releveCompteur.map.actions\">Carte</th></tr></thead><tbody><tr ng-repeat=\"row in vm.filteredRows track by row.id\"><td>{{row.timeLabel}}</td><td><a ng-if=\"row.contractId\" ng-href=\"#/contrat/{{row.contractId}}/dataanalyse\" target=\"_blank\">{{row.contractReference}}</a> <span ng-if=\"!row.contractId\">{{row.contractReference}}</span></td><td><a ng-if=\"row.meterId\" ng-href=\"{{row.meterPath}}\" target=\"_blank\">{{row.meterNumber}}</a> <span ng-if=\"!row.meterId\">{{row.meterNumber}}</span></td><td>{{row.valueLabel}}</td><td>{{row.readingGpsLabel}}</td><td>{{row.contractGpsLabel}}</td><td>{{row.meterGpsLabel}}</td><td style=\"min-width: 190px\"><div class=\"btn-group btn-group-xs\"><button type=\"button\" class=\"btn btn-default\" ng-if=\"vm.showReadingPopupAction(row)\" ng-click=\"vm.openReadingPopup(row)\" translate=\"wamasysApp.releveCompteur.map.openReadingPopup\">Lecture</button> <button type=\"button\" class=\"btn btn-default\" ng-if=\"vm.showContractPopupAction(row)\" ng-click=\"vm.openContractPopup(row)\" translate=\"wamasysApp.releveCompteur.map.openContractPopup\">Contrat</button> <button type=\"button\" class=\"btn btn-default\" ng-if=\"vm.showMeterPopupAction(row)\" ng-click=\"vm.openMeterPopup(row)\" translate=\"wamasysApp.releveCompteur.map.openMeterPopup\">Compteur</button></div></td></tr></tbody></table></div><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\">Back</span></button></div>");
$templateCache.put("app/business/releve-compteur/releve-compteur-validate-confirm-dialog.html","<form name=\"validationForm\" ng-submit=\"vm.confirmValidation()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"wamasysApp.releveCompteur.validationConfirm.title\">Confirmer la validation</h4></div><div class=\"modal-body\"><div class=\"alert alert-warning\"><p translate=\"wamasysApp.releveCompteur.validationConfirm.enCoursWarning\">Cette reading form est encore en cours et n\'est pas terminée.</p><p translate=\"wamasysApp.releveCompteur.validationConfirm.enCoursConsequence\">Si vous validez maintenant, toutes les lectures de compteur qui n\'ont pas encore été envoyées seront perdues.</p></div><div class=\"form-group\"><label class=\"control-label\" for=\"field_validation_confirmation\"><span translate=\"wamasysApp.releveCompteur.validationConfirm.inputLabel\">Saisissez le texte exact</span> <code>{{vm.confirmationText}}</code></label><input id=\"field_validation_confirmation\" type=\"text\" class=\"form-control\" name=\"validationConfirmation\" ng-model=\"vm.confirmationInput\" required><p class=\"help-block\" ng-if=\"vm.confirmationInput && !vm.isConfirmationValid()\" translate=\"wamasysApp.releveCompteur.validationConfirm.inputHelp\">Le texte attendu est \"I confirm\".</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"wamasysApp.releveCompteur.detail.annuler\">Annuler</span></button> <button type=\"submit\" ng-disabled=\"validationForm.$invalid || !vm.isConfirmationValid()\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-ok-circle\"></span>&nbsp;<span translate=\"wamasysApp.releveCompteur.validationConfirm.confirmButton\">Valider quand même</span></button></div></form>");
$templateCache.put("app/business/releve-compteur/releve-compteurs.html","<div class=\"app-entity-shell\"><div class=\"app-entity-header\"><h2 class=\"app-entity-title\" translate=\"wamasysApp.releveCompteur.home.title\">ReleveCompteurs</h2><div class=\"app-entity-actions\"><button class=\"btn btn-primary\" ui-sref=\"releve-compteur.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.releveCompteur.home.createLabel\">Create new ReleveCompteur</span></button></div></div><jhi-alert></jhi-alert><div class=\"app-filter-panel\"><form name=\"searchForm\" class=\"smart-form\" novalidate><div class=\"app-filter-grid\"><div class=\"app-filter-field\"><label class=\"app-filter-label\" translate=\"wamasysApp.releveCompteur.etat\" for=\"field_etat\">Etat</label><select class=\"form-control\" name=\"etat\" ng-model=\"vm.etat\" id=\"field_etat\"><option value=\"\"></option><option value=\"ARENSEIGNER\" translate=\"wamasysApp.EtatReleveCompteur.ARENSEIGNER\">ARENSEIGNER</option><option value=\"ENCOURS\" translate=\"wamasysApp.EtatReleveCompteur.ENCOURS\">ENCOURS</option><option value=\"AVALIDER\" translate=\"wamasysApp.EtatReleveCompteur.AVALIDER\">AVALIDER</option><option value=\"VALIDE\" translate=\"wamasysApp.EtatReleveCompteur.VALIDE\">VALIDE</option></select></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" translate=\"wamasysApp.releveCompteur.collecteur\" for=\"field_collecteur\">Collecteur</label><select class=\"form-control\" id=\"field_collecteur\" name=\"collecteur\" ng-model=\"vm.collecteur\" ng-options=\"collecteur as (collecteur.firstName + \' \' + collecteur.lastName) for collecteur in vm.collecteurs track by collecteur.id\"><option value=\"\"></option></select></div><div class=\"app-filter-field app-filter-field--wide\"><label class=\"app-filter-label\" for=\"daterange1\" translate=\"wamasysApp.releveCompteur.dateReleve\">Date relev&eacute;</label><input date-range-picker id=\"daterange1\" name=\"daterange1\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" options=\"vm.opts\" placeholder=\"yyyy-mm-dd - yyyy-mm-dd\"></div></div><div class=\"app-filter-actions\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.clear()\" translate=\"entity.action.reset\">reset</button> <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"vm.search()\" translate=\"entity.action.chercher\">search</button></div></form></div><div class=\"table-responsive padding-top-10\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"dateReleve\"><span translate=\"wamasysApp.releveCompteur.dateReleve\">DateReleve</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"etat\"><span translate=\"wamasysApp.releveCompteur.etat\">Etat</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"collecteur.firstName\"><span translate=\"wamasysApp.releveCompteur.collecteur\">collecteur</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"releveCompteur in vm.releveCompteurs track by releveCompteur.id\"><td><a ui-sref=\"releve-compteur-detail({id:releveCompteur.id})\">{{releveCompteur.dateReleve | date:\'mediumDate\'}}</a></td><td translate=\"{{\'wamasysApp.EtatReleveCompteur.\' + releveCompteur.etat}}\">{{releveCompteur.etat}}</td><td>{{releveCompteur.collecteur.firstName + \' \' + releveCompteur.collecteur.lastName }}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"releve-compteur-detail({id:releveCompteur.id})\" class=\"btn btn-info btn-sm\"><span ng-show=\"releveCompteur.etat == \'VALIDE\' || releveCompteur.etat == \'ANNULE\'\" class=\"glyphicon glyphicon-eye-open\"></span> <span ng-show=\"releveCompteur.etat == \'ARENSEIGNER\' || releveCompteur.etat == \'AVALIDER\' || releveCompteur.etat == \'ENCOURS\'\" class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <a ng-href=\"{{vm.getMapUrl(releveCompteur.id)}}\" class=\"btn btn-warning btn-sm\" has-module=\"NEW_FEATURES_VISIBILITY\"><span class=\"fa fa-map-marker\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"wamasysApp.releveCompteur.detail.showMap\">Voir la carte</span> </a><a class=\"btn btn-warning btn-sm\" ng-href=\"{{vm.getControlUrl(releveCompteur.id)}}\" target=\"_blank\" has-module=\"NEW_FEATURES_VISIBILITY\"><span class=\"fa fa-table\"></span> <span translate=\"wamasysApp.releveCompteur.detail.openControl\">Ecran de controle</span> </a><button type=\"submit\" ng-show=\"releveCompteur.etat == \'ARENSEIGNER\' || releveCompteur.etat == \'ENCOURS\' || releveCompteur.etat == \'AVALIDER\'\" ui-sref=\"releve-compteur.delete({id:releveCompteur.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/reporting-accounting/reporting-accounting.html","<div class=\"container-fluid\"><h2 translate=\"wamasysApp.reportingGlobal.titreAccounting\">Accounting export</h2><jhi-alert-error></jhi-alert-error><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"global.field.dateCreation\">executionDate</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"reportingAccounting in vm.reportingAccountings track by reportingAccounting.fileName\"><td>{{vm.getDisplayFileName(reportingAccounting.fileName)}}</td><td>{{reportingAccounting.executionDate | date:\'medium\'}}</td><td class=\"text-right\"><a class=\"btn-sm btn-primary\" ng-if=\"reportingAccounting.fileName\" ng-click=\"downloadAccounting(reportingAccounting.agence.id,vm.getDisplayFileName(reportingAccounting.fileName))\">Download</a></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/reporting-agence/reporting-agence.html","<div class=\"container-fluid\"><a class=\"btn btn-default pull-right\" ui-sref=\"reporting-zone-analysis\" has-any-authority=\"ROLE_READ_ONLY,ROLE_AREA_MANAGEMENT,ROLE_ADMIN,ROLE_SUPER_ADMIN\"><span class=\"glyphicon glyphicon-stats\"></span> <span translate=\"wamasysApp.zoneAnalysis.title\">Analyse IA de la zone</span></a><h2 translate=\"wamasysApp.reportingGlobal.titreAgence\">Reporting zone</h2><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label col-md-2\" for=\"daterange1\" translate=\"wamasysApp.reportingGlobal.periodeRecherche\">Période recherchée</label><div class=\"col-md-10\"><div class=\"input-group\"><input date-range-picker id=\"daterange1\" name=\"daterange1\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" options=\"vm.opts\"><div class=\"input-group-btn\"><button ng-click=\"openRangeDateTimePicker()\" class=\"btn btn-default\" type=\"button\"><span class=\"glyphicon glyphicon-calendar\"></span></button></div></div></div></div></div><div class=\"col-md-4\"><button class=\"btn btn-primary\" ng-click=\"vm.newSearch()\" translate=\"wamasysApp.reportingGlobal.chercher\">search</button><div class=\"btn-group pull-right\"><button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\">Download <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\"><li><a ng-click=\"vm.download()\">Download Dashboard</a></li><li><a ng-click=\"vm.downloadBilling()\">Download Billing</a></li><li><a ng-click=\"vm.downloadFinancialAdjustement()\">Download Financial adjustement</a></li><li><a ng-click=\"vm.downloadFactureZip()\">Download Invoices PDF (ZIP)</a></li></ul></div></div></div><br><!-- 	 	 <h3>  {{vm.reporting.agence.nom}}</h3> --><uib-tabset ng-show=\"vm.reporting\"><uib-tab><uib-tab-heading><span translate=\"wamasysApp.reportingGlobal.summary\"></span></uib-tab-heading><uib-tab-content><div class=\"row\" style=\"margin-top: 20px\"><div class=\"col-md-4\"><div class=\"panel panel-blue\"><div class=\"panel-heading text-align-center\"><h4 class=\"panel-title\" translate=\"wamasysApp.reportingGlobal.totalAPayer\">Billing</h4><h5>{{vm.reporting.totalBilled | currency:\"\":2}}</h5></div><div class=\"panel-body no-padding text-align-center\"><!-- 					<div class=\"the-price\"> --><!-- 						<h1>{{vm.reporting.totalBilled | currency:\"\":2}}</h1> --><!-- 						<small>1 month FREE trial</small> --><!-- 					</div> --><table class=\"table\"><tbody><tr><td>{{\"wamasysApp.reportingGlobal.totalFactureViaCL\" | translate}}</td><td>{{vm.reporting.totalBilledWithoutDiscountCreditNote | currency:\"\":2}}</td><td></td></tr><tr><td>{{\"wamasysApp.reportingGlobal.TypePenalitRemiseRegul.DISCOUNT\" | translate}}</td><td>- {{vm.reporting.totalDiscount | currency:\"\":2}}</td><td>{{ ( vm.reporting.totalDiscount / vm.reporting.totalBilledWithoutDiscountCreditNote *100 ) | number:2}} %</td></tr><tr><td>{{\"wamasysApp.reportingGlobal.TypePenalitRemiseRegul.CREDIT_NOTE\" | translate}}</td><td>- {{vm.reporting.totalCreditNote | currency:\"\":2}}</td><td>{{ ( vm.reporting.totalCreditNote / vm.reporting.totalBilledWithoutDiscountCreditNote *100 ) | number:2}} %</td></tr></tbody></table></div><div class=\"panel-footer no-padding\"><!--                 <a class=\"btn bg-color-blue txt-color-white btn-block\" role=\"button\">Sign Up</a> --></div></div></div><div class=\"col-md-4\"><div class=\"panel panel-teal\"><div class=\"panel-heading text-align-center\"><h4 class=\"panel-title\" translate=\"wamasysApp.reportingGlobal.totalPaye\">Payments</h4><h5>{{vm.reporting.totalPaid | currency:\"\":2}}</h5></div><div class=\"panel-body no-padding text-align-center\"><!-- 					<div class=\"the-price\"> --><!-- 						<h1>{{vm.reporting.totalPaid | currency:\"\":2}}</h1> --><!-- 						<small>1 month FREE trial</small> --><!-- 					</div> --><table class=\"table\"><tbody><tr ng-repeat=\"payment in vm.reporting.listePayment\"><td>{{\'wamasysApp.reportingGlobal.TypePayment.\'+payment.label | translate}}</td><td>{{payment.totalPaye | currency:\"\":2}}</td><td>{{ (payment.totalPaye / vm.reporting.totalPaid *100 ) | number:2}} %</td></tr></tbody></table></div><div class=\"panel-footer no-padding\"><!--                 <a class=\"btn bg-color-blue txt-color-white btn-block\" role=\"button\">Sign Up</a> --></div></div></div><div class=\"col-md-4\"><div class=\"panel panel-pinkDark\"><div class=\"panel-heading text-align-center\"><h4 class=\"panel-title\" translate=\"wamasysApp.reportingGlobal.collectedRate\">Result</h4><h5>{{ ( vm.reporting.totalPaid / vm.reporting.totalBilled *100 ) | number:2}} %</h5></div><div class=\"panel-body no-padding text-align-center\"><!-- 					<div class=\"the-price\"> --><!-- 						<h3 class=\"panel-title\">Balance End Of Period {{vm.reporting.balanceEndOfPeriod | currency:\"\":2}}</h3> --><!-- 						<small>balanceEndOfPeriod : {{vm.reporting.balanceEndOfPeriod | currency:\"\":2}}</small> --><!-- 					</div> --><table class=\"table\"><tbody><tr style=\"color: #ffffff; background-color: #bf98b6\"><td>{{\"wamasysApp.reportingGlobal.collectionRateIncludindArreas\" | translate}}</td><td>{{ ( vm.reporting.totalPaid/ (vm.reporting.totalBilled + vm.reporting.sumBilledFromBeggining - vm.reporting.sumPaidFromBeggining )*100 ) | number:2}} %</td></tr><tr><td>{{\"wamasysApp.reportingGlobal.totalMoneyboxDebutPeriode\" | translate}}</td><td>{{( vm.reporting.sumPaidFromBeggining - vm.reporting.sumBilledFromBeggining ) | currency:\"\":2}}</td></tr><tr><td>{{\"wamasysApp.reportingGlobal.TotalImpayes\" | translate}}</td><td>{{(vm.reporting.totalPaid - vm.reporting.totalBilled ) | currency:\"\":2}}</td></tr><tr ng-if=\"vm.reporting.totalRepriseSolde && vm.reporting.totalRepriseSolde != 0  \"><td>{{\"wamasysApp.reportingGlobal.TypePenalitRemiseRegul.REPRISE_SOLDE\" | translate}}</td><td>{{(vm.reporting.totalRepriseSolde ) | currency:\"\":2}}</td></tr><tr><td>{{\"wamasysApp.reportingGlobal.TypePenalitRemiseRegul.DEBT_WAIVER\" | translate}}</td><td>{{vm.reporting.totalDebtWaiver | currency:\"\":2}}</td></tr><tr><td>{{\"wamasysApp.reportingGlobal.TypePenalitRemiseRegul.WINDFALL_GAIN\" | translate}}</td><td>{{vm.reporting.totalWindfallGain | currency:\"\":2}}</td></tr><!-- 							<tr> --><!-- 								<td>sumBilledFromBeggining and sumPaidFromBeggining</td> --><!-- 								<td> {{(vm.reporting.sumBilledFromBeggining ) | currency:\"\":2}} / {{(vm.reporting.sumPaidFromBeggining ) | currency:\"\":2}}</td> --><!-- 							</tr> --><!-- 							<tr > --><!-- 								<td>Check</td> --><!-- 								<td>balanceEndOfPeriod {{(vm.reporting.balanceEndOfPeriod ) | currency:\"\":2}} --><!-- 								</td> --><!-- 							</tr> --><!-- 				<tr >\r\n								<td>Check</td>\r\n								<td>balanceBegginingOfPeriod {{(vm.reporting.balanceBegginingOfPeriod ) | currency:\"\":2}}<br/>\r\n								balanceEndOfPeriod {{vm.reporting.balanceEndOfPeriod | currency:\"\":2}}\r\n								\r\n								</td>\r\n							</tr> --></tbody></table></div><div class=\"panel-footer bg-color-pinkDark text-align-center\"><h4 style=\"display:inline\" class=\"txt-color-white\">{{\"wamasysApp.reportingGlobal.totalMoneyboxFinPeriode\" | translate}} : {{ (vm.reporting.sumPaidFromBeggining - vm.reporting.sumBilledFromBeggining + vm.reporting.totalPaid - vm.reporting.totalBilled + vm.reporting.totalDebtWaiver - vm.reporting.totalWindfallGain ) | currency:\"\":2}}</h4><span data-popover-placement=\"top\" data-popover-trigger=\"mouseenter\" data-uib-popover=\"{{\'wamasysApp.reportingGlobal.commentBalance\' | translate}}\"><!--                                data-popover-title=\"{{\'wamasysApp.reportingGlobal.commentBalance\' | translate}}\" --> <i class=\"fa fa-question txt-color-yellow\"></i> </span><!--                 <a class=\"btn bg-color-blue txt-color-white btn-block\" role=\"button\">Sign Up</a> --></div></div></div></div></uib-tab-content></uib-tab><uib-tab ng-click=\"vm.search()\"><uib-tab-heading><span translate=\"wamasysApp.reportingGlobal.billingDetail\"></span></uib-tab-heading><uib-tab-content><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\" ng-show=\"vm.reporting.listeTypeService\"><thead><!-- 			<tr> --><!-- 					<th colspan=\"2\" translate=\"wamasysApp.reportingGlobal.service\">service</th> --><!-- 					<th colspan=\"4\" translate=\"wamasysApp.reportingGlobal.resultat\">Résultat</th> --><!-- 					<th colspan=\"2\" translate=\"wamasysApp.reportingGlobal.moneyBox\" >Money Box</th> --><!-- 			</tr> --><tr><th translate=\"wamasysApp.reportingGlobal.typeService\">typeService</th><th translate=\"wamasysApp.reportingGlobal.serviceVendu\">serviceVendu</th><th translate=\"wamasysApp.reportingGlobal.quantity\">quantity</th><th>{{\'wamasysApp.reportingGlobal.totalFactureViaCL\' | translate}}<!-- 							<span  --><!-- 			                               data-popover-placement=\"top\" --><!-- 			                               data-popover-trigger=\"mouseenter\" --><!-- 			                               data-popover-title=\"{{\'wamasysApp.reportingGlobal.totalAPayer\' | translate}}\" --><!-- 			                               data-uib-popover=\"Include taxes and discount\"> --><!-- 			                               <i class=\"fa  fa-question txt-color-yellow\" > </i> --><!-- 			                        </span>		 --></th><!-- 					<th > --><!-- 						{{\'wamasysApp.reportingGlobal.totalPaye\' | translate}} --><!-- 							<span  --><!-- 			                               data-popover-placement=\"top\" --><!-- 			                               data-popover-trigger=\"mouseenter\" --><!-- 			                               data-popover-title=\"{{\'wamasysApp.reportingGlobal.totalPaye\' | translate}}\" --><!-- 			                               data-uib-popover=\"Include refund\"> --><!-- 			                               <i class=\"fa  fa-question txt-color-yellow\" > </i> --><!-- 			                        </span>	 --><!-- 			       </th> --><th translate=\"wamasysApp.reportingGlobal.totalDiscount\">totalDiscount</th><th translate=\"wamasysApp.reportingGlobal.totalAvoir \">totalAvoir</th><th translate=\"wamasysApp.reportingGlobal.totalAPayer \">total</th><!-- 					<th > --><!-- 						{{\'wamasysApp.reportingGlobal.TotalImpayes\' | translate}} --><!-- 						<span  data-popover-placement=\"top\" --><!--                                data-popover-trigger=\"mouseenter\" --><!--                                data-popover-title=\"{{\'wamasysApp.reportingGlobal.TotalImpayes\' | translate}}\" --><!--                                data-uib-popover=\"Positive amounts are overpaid and negative amounts are unpaid. Unpaid = Paid - to be paid - refund - credit note\"> --><!--                                <i class=\"fa  fa-question txt-color-yellow\" > </i> --><!--                         </span>	 --><!--  					</th> --><!-- 					<th > --><!-- 						{{\'wamasysApp.reportingGlobal.totalArriereDebutPeriode\' | translate}} --><!-- 						<span  data-popover-placement=\"top\" --><!--                                data-popover-trigger=\"mouseenter\" --><!--                                data-popover-title=\"{{\'wamasysApp.reportingGlobal.totalArriereDebutPeriode\' | translate}}\" --><!--                                data-uib-popover=\"{{\'wamasysApp.reportingGlobal.texteAideMoneyBox\' | translate}}\"> --><!--                                <i class=\"fa  fa-question txt-color-yellow\" > </i> --><!--                         </span>	 --><!-- 					 </th> --><!-- 					<th > --><!-- 						{{\'wamasysApp.reportingGlobal.totalMoneyboxFinPeriode\' | translate}} --><!-- 						<span  data-popover-placement=\"top\" --><!--                                data-popover-trigger=\"mouseenter\" --><!--                                data-popover-title=\"{{\'wamasysApp.reportingGlobal.totalMoneyboxFinPeriode\' | translate}}\" --><!--                                data-uib-popover=\"{{\'wamasysApp.reportingGlobal.texteAideMoneyBox\' | translate}}\"> --><!--                                <i class=\"fa  fa-question txt-color-yellow\" > </i> --><!--                         </span>	 --><!-- 			 		</th> --></tr></thead><tbody><tr ng-repeat=\"listeTypeService in vm.reporting.listeTypeService\"><td>{{listeTypeService.serviceVendu.typeService.libelle}}</td><td>{{ listeTypeService.serviceVendu.libelle }}</td><td>{{listeTypeService.quantity | currency:\"\":2}}</td><td>{{listeTypeService.totalAPayer + listeTypeService.cumulDiscount | currency:\"\":2}}</td><td>{{listeTypeService.cumulDiscount | currency:\"\":2}}</td><td>{{ listeTypeService.cumulCreditNote | currency:\"\":2}}</td><td>{{ listeTypeService.totalAPayer - listeTypeService.cumulCreditNote | currency:\"\":2}}</td></tr><tr><td colspan=\"2\"><strong>Total</strong></td><td></td><td><strong>{{getTotalAPayer()| currency:\"\":2}}</strong></td><td><strong>{{getTotalDiscount()| currency:\"\":2}}</strong></td><td><strong>{{getTotalAvoir()| currency:\"\":2}}</strong></td><td><strong>{{getTotalFacture()| currency:\"\":2}}</strong></td><!-- Important pour avoir la vraie money box on ajoute les paiements d\'acomptes car ceux-ci ne sont pas inclus ds les money box début de période --><!-- 				<td><strong>{{(getTotalMoneyboxDebutPeriode() )| currency:\"\":0}}</strong></td> --><!-- 				<td><strong>{{getTotalMoneyboxFinPeriode()| currency:\"\":0}}</strong></td> --></tr></tbody></table></div><!-- 	 <div  ng-show=\"vm.reporting.listeTypeService\" class=\"alert alert-warning\" translate=\"wamasysApp.reportingGlobal.billing.message\" translate-compile> --><!--             Note : les paiements affichés dans ce reporting sont filtrés via la date de leur facture. --><!--      </div>	 --></uib-tab-content></uib-tab><uib-tab ng-click=\"vm.search()\"><uib-tab-heading><span translate=\"wamasysApp.reportingGlobal.detailPayment\"></span></uib-tab-heading><uib-tab-content><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\" ng-show=\"vm.reporting.listeTypeService\"><thead><tr><th translate=\"wamasysApp.reportingGlobal.typeService\">typeService</th><th translate=\"wamasysApp.reportingGlobal.serviceVendu\">serviceVendu</th><th translate=\"wamasysApp.reportingGlobal.paye\">paye</th><th translate=\"wamasysApp.reportingGlobal.refund\">Refund</th><th translate=\"wamasysApp.reportingGlobal.paymentBalanceTransfer\">PaymentBalanceTransfer</th><th translate=\"wamasysApp.reportingGlobal.refundBalanceTransfer\">refundBalanceTransfer</th><th translate=\"wamasysApp.reportingGlobal.correctionPayment\">correctionPayment</th><th translate=\"wamasysApp.reportingGlobal.totalPaye\">totalPaye</th></tr></thead><tbody><tr ng-repeat=\"listeTypeService in vm.reporting.listeTypeService\"><td>{{listeTypeService.serviceVendu.typeService.libelle}}</td><td>{{ listeTypeService.serviceVendu.libelle }}</td><td>{{ listeTypeService.totalCollecte | currency:\"\":2}}</td><td>{{ listeTypeService.cumulRefund | currency:\"\":2}}</td><td>{{ listeTypeService.cumulPaymentBalanceTransfer | currency:\"\":2}}</td><td>{{ listeTypeService.cumulRefundBalanceTransfer | currency:\"\":2}}</td><td>{{ listeTypeService.cumulRefundPaymentCorrection | currency:\"\":2}}</td><td>{{( listeTypeService.totalCollecte - listeTypeService.cumulRefund - listeTypeService.cumulRefundBalanceTransfer + listeTypeService.cumulRefundPaymentCorrection + listeTypeService.cumulPaymentBalanceTransfer ) | currency:\"\":2}}</td></tr><tr><td colspan=\"2\"><strong>Total</strong></td><td><strong>{{getTotalCollecte()| currency:\"\":2}}</strong></td><td><strong>{{getTotalRefund() | currency:\"\":2}}</strong></td><td><strong>{{getTotalPaymentBalanceTransfer()| currency:\"\":2}}</strong></td><td><strong>{{getTotalRefundBalanceTransfer()| currency:\"\":02}}</strong></td><td><strong>{{getTotalCorrectionPayment()| currency:\"\":02}}</strong></td><td><strong>{{getTotalPaye()| currency:\"\":2}}</strong></td></tr></tbody></table></div></uib-tab-content></uib-tab><!-- 	<uib-tab>  --><!-- 		<uib-tab-heading> --><!-- 			<span translate=\"wamasysApp.reportingGlobal.detailRefund\"> </span>  --><!-- 		</uib-tab-heading> 	 --><!-- 		<uib-tab-content> --><!-- 		<div  class=\"table-responsive\">   --><!-- 				  <table class=\"table table-striped table-bordered table-hover\" width=\"100%\" > --><!-- 					<thead> --><!-- 						<tr> --><!-- 								<th translate=\"wamasysApp.reportingGlobal.typeService\">typeService</th> --><!-- 								<th translate=\"wamasysApp.reportingGlobal.serviceVendu\">serviceVendu</th> --><!-- 								<th translate=\"wamasysApp.reportingGlobal.typeAvoirRemiseRegul\">Type</th> --><!-- 								<th translate=\"wamasysApp.reportingGlobal.montantPenaliteRemiseRegul\">montant</th> --><!-- 						</tr> --><!-- 					</thead> --><!-- 					<tbody  ng-repeat=\"typeService in vm.reporting.listeTypeService\"> --><!-- 						<tr  ng-repeat=\"avoir in typeService.listRemiseAvoirRemboursement\" ng-if=\"avoir.type === \'REFUND\' || avoir.type === \'REFUND_BALANCE_TRANSFER\'\"> --><!-- 							<td>{{typeService.serviceVendu.typeService.libelle}} </td> --><!-- 							<td>{{typeService.serviceVendu.libelle}} </td> --><!-- 							<td > --><!-- 							{{\'wamasysApp.reportingGlobal.TypePenalitRemiseRegul.\'+avoir.type | translate}} --><!-- 							</td> --><!-- 							<td>{{avoir.totalMontant}}</td> --><!-- 						</tr> --><!-- 					</tbody> --><!-- 				</table> --><!-- 			</div> --><!-- 		</uib-tab-content> --><!-- 	</uib-tab>  --><uib-tab ng-click=\"vm.search()\"><uib-tab-heading><span translate=\"wamasysApp.reportingGlobal.detailDiscountCreditNote\"></span></uib-tab-heading><uib-tab-content><!-- 			<p translate=\"wamasysApp.reportingGlobal.texteExplicationTableauDiscount\"> </p> --><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th translate=\"wamasysApp.reportingGlobal.typeService\">typeService</th><th translate=\"wamasysApp.reportingGlobal.serviceVendu\">serviceVendu</th><!-- 	<th translate=\"wamasysApp.reportingGlobal.service\">Service</th> --><th translate=\"wamasysApp.reportingGlobal.typeAvoirRemiseRegul\">Type</th><th translate=\"wamasysApp.reportingGlobal.raisonPenaliteRemiseRegul\">Raison</th><th translate=\"wamasysApp.reportingGlobal.montantPenaliteRemiseRegul\">montant</th></tr></thead><tbody ng-repeat=\"typeService in vm.reporting.listeTypeService\"><tr ng-repeat=\"avoir in typeService.listRemiseAvoirRemboursement\" ng-if=\"avoir.type === \'CREDIT_NOTE\' || avoir.type === \'DISCOUNT\' || avoir.type === \'REPRISE_SOLDE\'\"><td>{{typeService.serviceVendu.typeService.libelle}}</td><td>{{typeService.serviceVendu.libelle}}</td><td>{{\'wamasysApp.reportingGlobal.TypePenalitRemiseRegul.\'+avoir.type | translate}}</td><td ng-if=\"avoir.typeRemisecommerciale\">{{avoir.typeRemisecommerciale.libelle}}</td><td ng-if=\"! avoir.typeRemisecommerciale\">{{avoir.typeAvoir.libelle}}</td><td>{{avoir.totalMontant| currency:\"\":2}}</td></tr></tbody></table></div></uib-tab-content></uib-tab><uib-tab ng-click=\"vm.search()\"><uib-tab-heading><span translate=\"wamasysApp.reportingGlobal.detailDebtWaiverWindfallGain\"></span></uib-tab-heading><uib-tab-content><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th translate=\"wamasysApp.reportingGlobal.typeService\">typeService</th><th translate=\"wamasysApp.reportingGlobal.serviceVendu\">serviceVendu</th><!-- 	<th translate=\"wamasysApp.reportingGlobal.service\">Service</th> --><th translate=\"wamasysApp.reportingGlobal.typeAvoirRemiseRegul\">Type</th><!-- 								<th translate=\"wamasysApp.reportingGlobal.raisonPenaliteRemiseRegul\">Raison</th> --><th translate=\"wamasysApp.reportingGlobal.montantPenaliteRemiseRegul\">montant</th></tr></thead><tbody ng-repeat=\"typeService in vm.reporting.listeTypeService\"><tr ng-repeat=\"avoir in typeService.listRemiseAvoirRemboursement\" ng-if=\" avoir.type === \'DEBT_WAIVER\' || avoir.type === \'WINDFALL_GAIN\'\"><td>{{typeService.serviceVendu.typeService.libelle}}</td><td>{{typeService.serviceVendu.libelle}}</td><td>{{\'wamasysApp.reportingGlobal.TypePenalitRemiseRegul.\'+avoir.type | translate}}</td><!-- 							<td ng-if=\"avoir.typeRemisecommerciale\">{{avoir.typeRemisecommerciale.libelle}}</td> --><!-- 							<td ng-if=\"! avoir.typeRemisecommerciale\">{{avoir.typeAvoir.libelle}}</td> --><td>{{avoir.totalMontant| currency:\"\":2}}</td></tr></tbody></table></div></uib-tab-content></uib-tab></uib-tabset><!-- 	<hr/> --><!-- 	<div ng-show=\"vm.reporting.listePayment\">  --><!-- 		<h4 translate=\"wamasysApp.reportingGlobal.detailPayment\">Détail Paiement</h4> --><!-- 	</div> --><!-- 	<hr ng-show=\"\" /> --><!-- 	<div ng-show=\"vm.reporting.listeTypeService\">  --><!-- 		<h4 translate=\"wamasysApp.reportingGlobal.detailRefund\">Détail REFUND</h4> --><!-- 	</div> --><!-- 	<hr ng-show=\"vm.reporting.listeTypeService\" /> --><!-- 	<div ng-show=\"vm.reporting.listeTypeService\">  --><!-- 		<h4 translate=\"wamasysApp.reportingGlobal.detailDiscount\">Détail DISCOUNT</h4> --><!-- 		<p>Les discounts sont déjà soustraits des montants à payer affiché plus haut.</p> --><!-- 		<div>    --><!-- 			  <table class=\"table table-striped table-bordered table-hover\" width=\"100%\" > --><!-- 				<thead> --><!-- 					<tr> --><!-- 							<th translate=\"wamasysApp.reportingGlobal.typeService\">typeService</th> --><!-- 							<th translate=\"wamasysApp.reportingGlobal.serviceVendu\">serviceVendu</th> --><!-- 							<th translate=\"wamasysApp.reportingGlobal.service\">Service</th> --><!-- 							<th translate=\"wamasysApp.reportingGlobal.typeAvoirRemiseRegul\">Type</th> --><!-- 							<th translate=\"wamasysApp.reportingGlobal.raisonPenaliteRemiseRegul\">Raison</th> --><!-- 							<th translate=\"wamasysApp.reportingGlobal.montantPenaliteRemiseRegul\">montant</th> --><!-- 					</tr> --><!-- 				</thead> --><!-- 				<tbody  ng-repeat=\"typeService in vm.reporting.listeTypeService\"> --><!-- 					<tr  ng-repeat=\"avoir in typeService.listRemiseAvoirRemboursement\" ng-if=\"avoir.type === \'DISCOUNT\'\"> --><!-- 						<td>{{typeService.serviceVendu.typeService.libelle}} </td> --><!-- 						<td>{{typeService.serviceVendu.libelle}} </td> --><!-- 						<td > --><!-- 						{{\'wamasysApp.reportingGlobal.TypePenalitRemiseRegul.\'+avoir.type | translate}} --><!-- 						</td> --><!-- 						<td ng-if=\"avoir.typeRemisecommerciale\">{{avoir.typeRemisecommerciale.libelle}}</td> --><!-- 						<td ng-if=\"! avoir.typeRemisecommerciale\">{{avoir.typeAvoir.libelle}}</td> --><!-- 						<td>{{avoir.totalMontant}}</td> --><!-- 					</tr> --><!-- 				</tbody> --><!-- 			</table> --><!-- 		</div> --><!-- 	</div> --><!-- 	<hr ng-show=\"vm.reporting.listeTypeService\" /> --><!-- 	<div ng-show=\"vm.reporting.listeTypeService\">   --><!-- 		<h4 translate=\"wamasysApp.reportingGlobal.detailCreditNote\">détail CREDIT_NOTE OU DEBT_WAIVER</h4> --><!-- 		<div>    --><!-- 			  <table class=\"table table-striped table-bordered table-hover\" width=\"100%\" > --><!-- 				<thead> --><!-- 					<tr> --><!-- 							<th translate=\"wamasysApp.reportingGlobal.typeService\">typeService</th> --><!-- 							<th translate=\"wamasysApp.reportingGlobal.serviceVendu\">serviceVendu</th> --><!-- 							<th translate=\"wamasysApp.reportingGlobal.service\">Service</th> --><!-- 							<th translate=\"wamasysApp.reportingGlobal.typeAvoirRemiseRegul\">Type</th> --><!-- 							<th translate=\"wamasysApp.reportingGlobal.raisonPenaliteRemiseRegul\">Raison</th> --><!-- 							<th translate=\"wamasysApp.reportingGlobal.montantPenaliteRemiseRegul\">montant</th> --><!-- 					</tr> --><!-- 				</thead> --><!-- 				<tbody  ng-repeat=\"typeService in vm.reporting.listeTypeService\"> --><!-- 					<tr  ng-repeat=\"avoir in typeService.listRemiseAvoirRemboursement\" ng-if=\"avoir.type === \'CREDIT_NOTE\' || avoir.type === \'DEBT_WAIVER\'\"> --><!-- 						<td>{{typeService.serviceVendu.typeService.libelle}} </td> --><!-- 						<td>{{typeService.serviceVendu.libelle}} </td> --><!-- 						<td > --><!-- 						{{\'wamasysApp.reportingGlobal.TypePenalitRemiseRegul.\'+avoir.type | translate}} --><!-- 						</td> --><!-- 						<td ng-if=\"avoir.typeRemisecommerciale\">{{avoir.typeRemisecommerciale.libelle}}</td> --><!-- 						<td ng-if=\"! avoir.typeRemisecommerciale\">{{avoir.typeAvoir.libelle}}</td> --><!-- 						<td>{{avoir.totalMontant}}</td> --><!-- 					</tr> --><!-- 				</tbody> --><!-- 			</table> --><!-- 		</div> --><!-- 	</div> --></div>");
$templateCache.put("app/business/reporting-area-activity/reporting-area-activity.html","<div class=\"reporting-area-activity-page\"><style>.reporting-area-activity-page {\n            height: calc(100vh - 150px);\n            overflow: hidden;\n        }\n        .reporting-area-activity .raa-toolbar {\n            margin-bottom: 20px;\n            flex: 0 0 auto;\n        }\n        .reporting-area-activity .raa-subtitle {\n            color: #6b6f76;\n            margin-top: 6px;\n        }\n        .reporting-area-activity {\n            height: 100%;\n            overflow: hidden;\n            display: flex;\n            flex-direction: column;\n        }\n        .reporting-area-activity .raa-title-row {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            gap: 12px;\n            flex-wrap: wrap;\n            margin-bottom: 12px;\n        }\n        .reporting-area-activity .raa-title-main {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            flex-wrap: wrap;\n        }\n        .reporting-area-activity .raa-title-main h2 {\n            margin: 0;\n        }\n        .reporting-area-activity .raa-period-pill {\n            display: inline-block;\n            padding: 4px 10px;\n            background: #eef4fb;\n            color: #275b8d;\n            border-radius: 999px;\n            font-size: 12px;\n            font-weight: 600;\n        }\n        .reporting-area-activity .raa-summary {\n            display: inline-block;\n            margin-left: 8px;\n            margin-top: 6px;\n        }\n        .reporting-area-activity .raa-summary .label {\n            margin-left: 6px;\n        }\n        .reporting-area-activity .raa-filters {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 16px;\n            margin-top: 16px;\n        }\n        .reporting-area-activity .raa-filter-box {\n            min-width: 280px;\n            flex: 1 1 320px;\n            border: 1px solid #ddd;\n            background: #fafafa;\n            padding: 12px 14px;\n        }\n        .reporting-area-activity .raa-filter-title {\n            font-weight: 600;\n            margin-bottom: 10px;\n            color: #2e3640;\n        }\n        .reporting-area-activity .raa-filter-options {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 8px 14px;\n            max-height: 140px;\n            overflow-y: auto;\n        }\n        .reporting-area-activity .raa-filter-options label {\n            font-weight: 400;\n            margin: 0;\n        }\n        .reporting-area-activity .raa-filter-toggle {\n            margin-right: 8px;\n        }\n        .reporting-area-activity .raa-apply-btn {\n            margin-right: 8px;\n        }\n        .reporting-area-activity .raa-table-wrapper {\n            overflow-x: auto;\n            overflow-y: auto;\n            flex: 1 1 auto;\n            min-height: 0;\n            border: 1px solid #ddd;\n            background: #fff;\n        }\n        .reporting-area-activity .raa-table {\n            margin-bottom: 0;\n            width: max-content;\n            min-width: 100%;\n        }\n        .reporting-area-activity .raa-table th,\n        .reporting-area-activity .raa-table td {\n            vertical-align: top !important;\n            text-align: center;\n            padding: 6px 8px;\n        }\n        .reporting-area-activity .raa-table th:first-child,\n        .reporting-area-activity .raa-table td:first-child {\n            text-align: left;\n            position: sticky;\n            left: 0;\n            z-index: 2;\n            background: #fff;\n            width: 170px;\n            min-width: 170px;\n            max-width: 170px;\n        }\n        .reporting-area-activity .raa-table thead th {\n            background: #f7f7f7;\n            width: 120px;\n            min-width: 120px;\n            max-width: 120px;\n            white-space: normal;\n            position: sticky;\n            top: 32px;\n            z-index: 4;\n            box-shadow: inset 0 -1px 0 #ddd;\n        }\n        .reporting-area-activity .raa-table thead tr:first-child th {\n            top: 0;\n            z-index: 5;\n            background: #eceff3;\n            text-transform: uppercase;\n            font-size: 11px;\n            letter-spacing: .04em;\n        }\n        .reporting-area-activity .raa-table thead tr:first-child th:first-child {\n            z-index: 7;\n        }\n        .reporting-area-activity .raa-table thead tr:nth-child(2) th:first-child {\n            z-index: 6;\n        }\n        .reporting-area-activity .raa-table tbody tr:nth-child(even) td:first-child {\n            background: #f9f9f9;\n        }\n        .reporting-area-activity .raa-header-btn {\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            gap: 4px;\n            width: 100%;\n            border: 0;\n            background: transparent;\n            padding: 0;\n            font-weight: 600;\n            color: #2e3640;\n        }\n        .reporting-area-activity .raa-header-btn:hover {\n            color: #2276c9;\n        }\n        .reporting-area-activity .raa-area-name {\n            font-weight: 600;\n            word-break: break-word;\n        }\n        .reporting-area-activity .raa-area-meta {\n            color: #6b6f76;\n            font-size: 11px;\n            margin-top: 3px;\n            word-break: break-word;\n        }\n        .reporting-area-activity .raa-cell {\n            width: 120px;\n            min-width: 120px;\n            max-width: 120px;\n        }\n        .reporting-area-activity .raa-value {\n            font-weight: 600;\n            margin-bottom: 3px;\n        }\n        .reporting-area-activity .raa-subvalue {\n            font-size: 11px;\n            color: #6b6f76;\n            margin-bottom: 3px;\n        }\n        .reporting-area-activity .raa-value-main {\n            color: #2276c9;\n            font-size: 15px;\n        }\n        .reporting-area-activity .raa-value-ratio {\n            color: #333;\n        }\n        .reporting-area-activity .raa-sparkline {\n            width: 108px;\n            height: 28px;\n            display: block;\n            margin: 0 auto;\n        }\n        .reporting-area-activity .raa-sparkline polyline {\n            stroke: #2276c9;\n            stroke-width: 2;\n            fill: none;\n        }\n        .reporting-area-activity .raa-sparkline circle {\n            fill: #2276c9;\n            stroke: #fff;\n            stroke-width: 1;\n        }\n        .reporting-area-activity .raa-sparkline .raa-sparkline-hitbox {\n            fill: rgba(34, 118, 201, 0.01);\n            stroke: none;\n        }\n        .reporting-area-activity .raa-empty {\n            padding: 25px 0;\n            color: #6b6f76;\n        }</style><div class=\"reporting-area-activity\"><div class=\"raa-toolbar clearfix\"><div class=\"raa-title-row\"><div class=\"raa-title-main\"><h2 translate=\"wamasysApp.reportingAreaActivity.home.title\"></h2><span class=\"raa-period-pill\" ng-if=\"vm.reporting && vm.reporting.fromMonth && vm.reporting.toMonth\">{{vm.reporting.fromMonth}} - {{vm.reporting.toMonth}}</span></div><div><button type=\"button\" class=\"btn btn-default raa-filter-toggle\" ng-click=\"vm.toggleFilters()\"><i class=\"fa\" ng-class=\"vm.filtersCollapsed ? \'fa-filter\' : \'fa-times\'\"></i> <span>{{(vm.filtersCollapsed ? \'wamasysApp.reportingAreaActivity.actions.showFilters\' : \'wamasysApp.reportingAreaActivity.actions.hideFilters\') | translate}}</span></button> <button type=\"button\" class=\"btn btn-primary raa-apply-btn\" ng-click=\"vm.applyFilters()\" ng-disabled=\"vm.loading || !vm.filterOptionsReady || !vm.hasSelectedAreas()\"><i class=\"fa fa-search\"></i> <span translate=\"wamasysApp.reportingAreaActivity.actions.applyFilters\"></span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.downloadJson()\"><i class=\"fa fa-download\"></i> <span translate=\"wamasysApp.reportingAreaActivity.actions.downloadJson\"></span></button></div></div><div class=\"raa-filters\" ng-if=\"!vm.loading && vm.filterOptionsReady && !vm.filtersCollapsed\"><div class=\"raa-filter-box\"><div class=\"raa-filter-title\" translate=\"wamasysApp.reportingAreaActivity.filters.agencies\"></div><div class=\"raa-filter-options\"><label class=\"checkbox-inline\" ng-repeat=\"agencyOption in vm.agencyOptions track by agencyOption.id\"><input type=\"checkbox\" ng-model=\"vm.agencyFilters[agencyOption.id]\" ng-change=\"vm.onAgencyFilterChanged(agencyOption.id)\"> <span>{{agencyOption.name}}</span></label></div></div><div class=\"raa-filter-box\"><div class=\"raa-filter-title\" translate=\"wamasysApp.reportingAreaActivity.filters.areas\"></div><div class=\"raa-filter-options\"><label class=\"checkbox-inline\" ng-repeat=\"areaOption in vm.areaOptions track by areaOption.id\"><input type=\"checkbox\" ng-model=\"vm.areaFilters[areaOption.id]\" ng-change=\"vm.onAreaFilterChanged(areaOption.id)\"> <span>{{areaOption.name}}</span></label></div></div><div class=\"raa-filter-box\"><div class=\"raa-filter-title\" translate=\"wamasysApp.reportingAreaActivity.filters.groups\"></div><div class=\"raa-filter-options\"><label class=\"checkbox-inline\" ng-repeat=\"groupOption in vm.groupOptions track by groupOption.key\"><input type=\"checkbox\" ng-model=\"vm.groupFilters[groupOption.key]\"> <span>{{groupOption.label}}</span></label></div></div></div></div><div class=\"text-center\" ng-if=\"vm.loading\"><i class=\"fa fa-spinner fa-spin\"></i></div><div class=\"raa-empty\" ng-if=\"!vm.loading && vm.filterOptionsReady && !vm.areaOptions.length\"><span translate=\"wamasysApp.reportingAreaActivity.home.empty\"></span></div><div class=\"raa-empty\" ng-if=\"!vm.loading && !vm.hasLoadedData && vm.filterOptionsReady && vm.areaOptions.length\"><span translate=\"wamasysApp.reportingAreaActivity.home.selectionHint\"></span></div><div class=\"raa-empty\" ng-if=\"!vm.loading && vm.hasLoadedData && !vm.sortedAreas.length\"><span translate=\"wamasysApp.reportingAreaActivity.home.filteredEmpty\"></span></div><div ng-if=\"!vm.loading && vm.hasLoadedData && vm.sortedAreas.length\" class=\"raa-table-wrapper\"><table class=\"table table-striped table-condensed raa-table\"><thead><tr><th rowspan=\"2\"><button type=\"button\" class=\"raa-header-btn\" ng-click=\"vm.sortBy(\'areaName\')\"><span translate=\"wamasysApp.reportingAreaActivity.table.area\"></span> <i class=\"fa\" ng-class=\"vm.getSortIcon(\'areaName\')\"></i></button></th><th ng-repeat=\"group in vm.visibleKpiGroups track by group.key\" ng-attr-colspan=\"{{group.span}}\">{{group.label}}</th></tr><tr><th ng-repeat=\"kpi in vm.visibleKpis track by kpi.key\"><button type=\"button\" class=\"raa-header-btn\" ng-click=\"vm.sortBy(kpi.key)\"><span>{{kpi.label}}</span> <i class=\"fa\" ng-class=\"vm.getSortIcon(kpi.key)\"></i></button></th></tr></thead><tbody><tr ng-repeat=\"area in vm.sortedAreas track by area.areaId\"><td><div class=\"raa-area-name\">{{area.areaName}}</div><div class=\"raa-area-meta\">{{area.agencyName || \'-\'}}</div><div class=\"raa-area-meta\">{{area.latestKnownActiveContracts || 0}} <span translate=\"wamasysApp.reportingAreaActivity.summary.activeContracts\"></span></div><div class=\"raa-area-meta\">{{area.latestKnownCollectors || 0}} <span translate=\"wamasysApp.reportingAreaActivity.summary.collectors\"></span> <span ng-if=\"area.contractsPerCollector !== null\">({{area.contractsPerCollector | number:1}})</span> | {{area.latestKnownReaders || 0}} <span translate=\"wamasysApp.reportingAreaActivity.summary.readers\"></span> <span ng-if=\"area.contractsPerReader !== null\">({{area.contractsPerReader | number:1}})</span></div></td><td ng-repeat=\"cell in area.visibleCells track by cell.key\" class=\"raa-cell\" ng-attr-title=\"{{cell.tooltip}}\"><div class=\"raa-value raa-value-main\"><span>{{cell.total | number:0}}</span></div><div class=\"raa-subvalue raa-value-ratio\"><span ng-if=\"cell.ratio !== null\">{{cell.ratio | number:2}} / <span translate=\"wamasysApp.reportingAreaActivity.table.contract\"></span></span> <span ng-if=\"cell.ratio === null\">-</span></div><svg ng-if=\"cell.sparkline\" class=\"raa-sparkline\" ng-attr-width=\"{{cell.sparkline.width}}\" ng-attr-height=\"{{cell.sparkline.height}}\"><polyline ng-attr-points=\"{{cell.sparkline.polylinePoints}}\"></polyline><circle ng-repeat=\"point in cell.sparkline.points track by (\'hover-\' + $index)\" class=\"raa-sparkline-hitbox\" ng-attr-cx=\"{{point.x}}\" ng-attr-cy=\"{{point.y}}\" r=\"7\"><title>{{point.title}}</title></circle><circle ng-repeat=\"point in cell.sparkline.points track by $index\" ng-attr-cx=\"{{point.x}}\" ng-attr-cy=\"{{point.y}}\" r=\"2.5\"><title>{{point.title}}</title></circle></svg></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/business/reporting-fuite-eau/reporting-fuite-eau.html","<div class=\"container-fluid\"><h2 translate=\"wamasysApp.reportingConsoEau.titre\">Suivi perte d\'eau</h2><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label col-md-2\" for=\"daterange1\" translate=\"wamasysApp.reportingConsoEau.periodeRecherche\">Période recherchée</label><div class=\"col-md-10\"><div class=\"input-group\"><input date-range-picker id=\"daterange1\" name=\"daterange1\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" options=\"vm.opts\"><div class=\"input-group-btn\"><button ng-click=\"openRangeDateTimePicker()\" class=\"btn btn-default\" type=\"button\"><span class=\"glyphicon glyphicon-calendar\"></span></button></div></div></div></div></div><div class=\"col-md-4 pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.search()\" translate=\"wamasysApp.reportingConsoEau.chercher\">search</button></div></div><br><hr><strong><span translate=\"wamasysApp.reportingConsoEau.totalConsoEauContrat\">Total consommation d\'eau sur contrat</span> : </strong>{{vm.reportConsoEau.totalConsoEauContrats }}<br><strong><span translate=\"wamasysApp.reportingConsoEau.totalConsoEauBulkMeter\">Total consommation d\'eau sur Bulk meters</span> : </strong>{{vm.reportConsoEau.totalConsoEauBulkMeters }}<br><strong><span translate=\"wamasysApp.reportingConsoEau.pourcentagePerte\">Pourcentage de perte</span> : </strong>{{vm.reportConsoEau.pourcentagePerte }} %<br><hr><div ng-show=\"vm.reportConsoEau.listeErreur.length\"><span translate=\"wamasysApp.reportingConsoEau.listeErreur\">Liste des erreurs</span><br><small><span translate=\"wamasysApp.reportingConsoEau.noteErreur\">Cette liste affiche les contrats et bulk meters pour lesquels les dates de relevé de compteur ne correspondent pas à la période recherchée.<br>Certains contrats peuvent être cloturés ou ouverts pendant la période ce qui explique l\'absence de relevé.<br>Note : Les contrats pour lesquels aucun relevé de compteur n\'est disponible sur la période recherchée ne sont pas affichés dans ce tableau.</span></small><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th translate=\"wamasysApp.reportingConsoEau.contractNumber\">Reférence</th><th translate=\"wamasysApp.reportingConsoEau.clientName\">Nom contrat</th><th translate=\"wamasysApp.reportingConsoEau.beginningDate\">date deb</th><th translate=\"wamasysApp.reportingConsoEau.endingDate\">date fin</th></tr></thead><tbody><tr ng-repeat=\"erreur in vm.reportConsoEau.listeErreur\"><td ng-show=\"erreur.idContrat\"><a ui-sref=\"contrat-detail.historiqueconso({id:erreur.idContrat})\">{{erreur.refContrat}}</a></td><td ng-show=\"erreur.idBulkMeter\"><a ui-sref=\"bulk-meter-detail({id:erreur.idBulkMeter})\">{{erreur.refContrat}}</a></td><td>{{erreur.nomContrat}}</td><td>{{erreur.dateDebut}}</td><td>{{erreur.dateFin}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/business/reporting-global/reporting-global.html","<div class=\"container-fluid\"><h2 translate=\"wamasysApp.reportingGlobal.titre\">Reporting global</h2><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label col-md-2\" for=\"daterange1\" translate=\"wamasysApp.reportingGlobal.periodeRecherche\">Période recherchée</label><div class=\"col-md-10\"><div class=\"input-group\"><input date-range-picker id=\"daterange1\" name=\"daterange1\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" options=\"vm.opts\"><div class=\"input-group-btn\"><button ng-click=\"openRangeDateTimePicker()\" class=\"btn btn-default\" type=\"button\"><span class=\"glyphicon glyphicon-calendar\"></span></button></div></div></div></div></div><div class=\"col-md-4 pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.search()\" translate=\"wamasysApp.reportingGlobal.chercher\">search</button></div></div><br><div ng-repeat=\"entiteParente in vm.reporting.listeEntiteParente\"><h2 style=\"background-color: #32c6cb\">{{entiteParente.entiteParente.nom}}</h2><div ng-repeat=\"agence in entiteParente.listeAgence\"><h3 id=\"agence.id\" style=\"background-color: #2ba6cb\">{{agence.agence.nom}}</h3><table class=\"table table-striped table-bordered table-hover\" width=\"100%\" ng-show=\"agence.listeCluster\"><thead><tr><th translate=\"wamasysApp.reportingGlobal.cluster\">cluster</th><th translate=\"wamasysApp.reportingGlobal.nbrIndividualMeterActifs\">nbrIndividualMeterActifs</th><th translate=\"wamasysApp.reportingGlobal.nbrFamilles\">nbrFamilles</th><th translate=\"wamasysApp.reportingGlobal.nbrIndividus\">nbrIndividus</th></tr></thead><tbody><tr ng-repeat=\"cluster in agence.listeCluster\"><td>{{cluster.cluster.numeroSerie}}</td><td>{{cluster.nbrIndividualMeterActifs}}</td><td>{{cluster.nbrFamilles}}</td><td>{{cluster.nbrIndividus}}</td></tr></tbody></table><br><table class=\"table table-striped table-bordered table-hover\" width=\"100%\" ng-show=\"agence.listeContractType\"><thead><tr><th translate=\"wamasysApp.reportingGlobal.contractType\">contractType</th><th translate=\"wamasysApp.reportingGlobal.consommationEau\">consommationEau</th></tr></thead><tbody><tr ng-repeat=\"listeContractType in agence.listeContractType\"><td>{{listeContractType.libelle}}</td><td>{{listeContractType.consommationEauTotale}}</td></tr></tbody></table><br><table class=\"table table-striped table-bordered table-hover\" width=\"100%\" ng-show=\"agence.listeBulkMeter\"><thead><tr><th translate=\"wamasysApp.reportingGlobal.bulkMeter\">bulkMeter</th><th translate=\"wamasysApp.reportingGlobal.consommationEau\">consommationEau</th></tr></thead><tbody><tr ng-repeat=\"listeBulkMeter in agence.listeBulkMeter\"><td>{{listeBulkMeter.bulkMeter.numeroSerie}}</td><td>{{listeBulkMeter.consoEauTotale}}</td></tr></tbody></table><br><table class=\"table table-striped table-bordered table-hover\" width=\"100%\" ng-show=\"agence.listeTypeService\"><thead><tr><th translate=\"wamasysApp.reportingGlobal.typeService\">typeService</th><th translate=\"wamasysApp.reportingGlobal.combienACollecterSurPeriode\">combienACollecterSurPeriode</th><th translate=\"wamasysApp.reportingGlobal.combienCollecteSurPeriode\">combienCollecteSurPeriode</th><th translate=\"wamasysApp.reportingGlobal.totalMoneyboxDebutPeriode\">totalMoneyboxDebutPeriode</th><th translate=\"wamasysApp.reportingGlobal.totalMoneyboxFinPeriode\">totalMoneyboxFinPeriode</th></tr></thead><tbody><tr ng-repeat=\"listeTypeService in agence.listeTypeService\"><td>{{listeTypeService.typeService.libelle}}</td><td>{{listeTypeService.combienACollecterSurPeriode}}</td><td>{{listeTypeService.combienCollecteSurPeriode}}</td><td>{{listeTypeService.totalMoneyboxDebutPeriode}}</td><td>{{listeTypeService.totalMoneyboxFinPeriode}}</td></tr></tbody></table></div><hr></div></div>");
$templateCache.put("app/business/manual-help/manual-help.html","<style>#header>:first-child,aside {\n     width:auto !important;\n}</style><script type=\"text/ng-template\" id=\"manual-help-section-node.html\"><div class=\"manual-help-sectiontree__node\">\n        <div class=\"manual-help-sectiontree__row\">\n            <button type=\"button\"\n                    class=\"manual-help-sectiontree__toggle\"\n                    ng-if=\"node.children.length\"\n                    ng-click=\"vm.toggleSectionNode(node, $event)\"\n                    ng-attr-aria-label=\"{{node.isExpanded ? \'Replier le chapitre\' : \'Déplier le chapitre\'}}\"\n                    ng-attr-aria-expanded=\"{{node.isExpanded}}\">\n                <i class=\"fa\" ng-class=\"node.isExpanded ? \'fa-minus\' : \'fa-plus\'\"></i>\n            </button>\n            <span class=\"manual-help-sectiontree__toggle manual-help-sectiontree__toggle--placeholder\"\n                  ng-if=\"!node.children.length\"></span>\n\n            <button type=\"button\"\n                    class=\"manual-help-sectiontree__item manual-help-sectionlist__item\"\n                    ng-class=\"{\n                        \'manual-help-sectionlist__item--active\': vm.activeSectionId === node.id,\n                        \'manual-help-sectiontree__item--branch\': node.children.length\n                    }\"\n                    ng-click=\"vm.openSectionFromTree(node)\">\n                {{node.title}}\n            </button>\n        </div>\n\n        <div class=\"manual-help-sectiontree__children\"\n             ng-if=\"node.children.length\"\n             ng-show=\"node.isExpanded\">\n            <div ng-repeat=\"node in node.children track by node.id\" ng-include=\"\'manual-help-section-node.html\'\"></div>\n        </div>\n    </div></script><div class=\"app-entity-shell manual-help-page\"><jhi-alert></jhi-alert><div class=\"manual-help-hero\"><div><div class=\"manual-help-eyebrow\">Wamasys Manual</div><h1 class=\"manual-help-title\">Centre d\'aide</h1><p class=\"manual-help-subtitle\">Consultez la documentation en markdown, naviguez par chapitre et interrogez l\'assistant documentaire sans quitter votre écran.</p></div><div class=\"manual-help-hero-actions\"><a class=\"btn btn-default\" ui-sref=\"admin-tools\" ng-if=\"vm.canIndexDocuments\"><i class=\"fa fa-wrench\"></i> Admin tools</a></div></div><div class=\"manual-help-layout\"><aside class=\"manual-help-sidebar\"><div class=\"manual-help-card\"><div class=\"manual-help-card__title\">Documents</div><div class=\"manual-help-doclist\" ng-if=\"!vm.isLoadingDocuments\"><button type=\"button\" class=\"manual-help-doclist__item\" ng-class=\"{\'manual-help-doclist__item--active\': vm.activeDocumentKey === doc.key}\" ng-repeat=\"doc in vm.documents track by doc.key\" ng-click=\"vm.openDocument(doc.key)\"><span class=\"manual-help-doclist__title\">{{doc.title}}</span> <span class=\"manual-help-doclist__description\">{{doc.description}}</span></button></div><div class=\"text-muted\" ng-if=\"vm.isLoadingDocuments\">Chargement des documents...</div></div><div class=\"manual-help-card\" ng-if=\"vm.currentDocument && vm.sectionTree.length\"><div class=\"manual-help-card__header\"><div class=\"manual-help-card__title\">Chapitres</div><div class=\"manual-help-card__actions\"><button type=\"button\" class=\"manual-help-card__action\" ng-click=\"vm.expandAllSections()\"><i class=\"fa fa-plus\"></i> Tout ouvrir</button> <button type=\"button\" class=\"manual-help-card__action\" ng-click=\"vm.collapseAllSections()\"><i class=\"fa fa-minus\"></i> Tout fermer</button></div></div><div class=\"manual-help-sectiontree\"><div ng-repeat=\"node in vm.sectionTree track by node.id\" ng-include=\"\'manual-help-section-node.html\'\"></div></div></div><div class=\"manual-help-card\" ng-if=\"vm.context.documentResults.length\"><div class=\"manual-help-card__title\">Résultats IA récents</div><div class=\"manual-help-resultlist\"><button type=\"button\" class=\"manual-help-resultlist__item\" ng-class=\"{\'manual-help-resultlist__item--active\': vm.isResultForCurrentDocument(result)}\" ng-repeat=\"result in vm.context.documentResults track by result.chunkId\" ng-click=\"vm.openSearchResult(result)\"><span class=\"manual-help-resultlist__title\">{{result.docTitle}}</span> <span class=\"manual-help-resultlist__path\">{{result.sectionPath}}</span> <span class=\"manual-help-resultlist__snippet\">{{result.snippet}}</span></button></div></div></aside><section class=\"manual-help-content\"><div class=\"manual-help-card manual-help-content-card\" ng-if=\"vm.currentDocument\"><div class=\"manual-help-content-header\"><div><div class=\"manual-help-content-label\">Document actif</div><h2>{{vm.currentDocument.title}}</h2></div><button type=\"button\" class=\"btn btn-default\" ng-if=\"vm.canSearchAssistant\" ng-click=\"vm.openAssistant()\"><i class=\"fa fa-search\"></i> Rechercher dans la doc</button></div><div class=\"manual-help-markdown\" ng-class=\"{\'manual-help-markdown--loading\': vm.isLoadingDocument}\" ng-bind-html=\"vm.documentHtml\"></div></div><div class=\"manual-help-card\" ng-if=\"!vm.currentDocument && !vm.isLoadingDocuments\"><div class=\"text-muted\">Aucun document disponible.</div></div></section></div></div>");
$templateCache.put("app/business/reporting-global-graph-eau/reporting-global-graph-eau.html","<div class=\"container-fluid\"><!--  <h2 translate=\"wamasysApp.reportingGlobal.titre\" >Reporting global</h2>\r\n\r\n    <jhi-alert-error></jhi-alert-error>\r\n    \r\n  \r\n        <div class=\"row\">\r\n        <div class=\" col-md-8\">\r\n\r\n  \r\n						<div class=\"form-group\">\r\n							<label class=\"control-label col-md-2\" for=\"daterange1\" translate=\"wamasysApp.reportingGlobal.periodeRecherche\">Période recherchée</label>\r\n							<div class=\"col-md-10\">\r\n								<div class=\"input-group\">\r\n									<input date-range-picker id=\"daterange1\" name=\"daterange1\"\r\n										class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\"\r\n										options=\"vm.opts\" />\r\n									<div class=\"input-group-btn\">\r\n										<button ng-click=\"openRangeDateTimePicker()\"\r\n											class=\"btn btn-default\" type=\"button\">\r\n											<span class=\"glyphicon glyphicon-calendar\"></span>\r\n										</button>\r\n\r\n									</div>\r\n								</div>\r\n							</div>\r\n						</div>\r\n\r\n	    </div>\r\n        <div class=\" col-md-4 pull-right\">\r\n                    <button class=\"btn btn-primary\" ng-click=\"vm.search()\"  translate=\"wamasysApp.reportingGlobal.chercher\">search</button>\r\n	    </div>\r\n\r\n   </div>\r\n    --></div><my-iframe iddashboard=\"{{vm.idDashboard}}\" endurl=\"{{vm.endUrl}}\" idgotodashboard=\"{{vm.idGotoDashboard}}\" idcontrat=\"\" filtreagence=\"{{vm.filtreagence}}\" periodkibana=\"{{vm.periodKibana}}\" height=\"800px\" width=\"100%\" scrolling=\"auto\"></my-iframe>");
$templateCache.put("app/business/reporting-paiement/reporting-paiement.html","<div class=\"container-fluid\"><h2 translate=\"wamasysApp.reportingGlobal.titrePaiement\">Reporting zone</h2><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label col-md-2\" for=\"daterange1\" translate=\"wamasysApp.reportingGlobal.periodeRecherche\">Période recherchée</label><div class=\"col-md-10\"><div class=\"input-group\"><input date-range-picker id=\"daterange1\" name=\"daterange1\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" options=\"vm.opts\"><div class=\"input-group-btn\"><button ng-click=\"openRangeDateTimePicker()\" class=\"btn btn-default\" type=\"button\"><span class=\"glyphicon glyphicon-calendar\"></span></button></div></div></div></div></div><div class=\"col-md-4\"><button class=\"btn btn-primary\" ng-click=\"vm.search()\" translate=\"wamasysApp.reportingGlobal.chercher\">search</button><div class=\"btn-group pull-right\"><button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\">Download <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\"><li><a ng-click=\"vm.downloadReceipts()\">Download receipts</a></li><li><a ng-click=\"vm.downloadPayments()\">Download payments</a></li></ul></div><!--  \r\n                    <button class=\" pull-right btn-xs btn-primary\" ng-click=\"vm.download()\"  target=\"_blank\">Download Excel</button>\r\n                    \r\n                    <button class=\" pull-right btn-xs btn-primary\" ng-click=\"vm.downloadBilling()\"  target=\"_blank\">Download Billing</button>   --></div></div><br><h3>{{vm.reporting.paiement.nom}}</h3><!-- <uib-tabset ng-show=\"vm.reporting.listePayment\">  --><!-- 	<uib-tab  ng-show=\"vm.reporting.listePayment\" >  --><!-- 		<uib-tab-heading> --><!-- 			<span translate=\"wamasysApp.reportingGlobal.detailPayment\"> </span>  --><!-- 		</uib-tab-heading> 	 --><!-- 		<uib-tab-content> --><div class=\"table-responsive\" ng-show=\"vm.reporting.listePayment\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><!-- 								<th translate=\"wamasysApp.reportingGlobal.typeService\">typeService</th> --><!-- 								<th translate=\"wamasysApp.reportingGlobal.serviceVendu\">serviceVendu</th> --><th translate=\"wamasysApp.reportingGlobal.codeOriginPayment\">codeOrigin Payment</th><th translate=\"wamasysApp.reportingGlobal.montantPenaliteRemiseRegul\">montant</th></tr></thead><tbody><tr ng-repeat=\"payment in vm.reporting.listePayment\"><!-- 							<td>{{payment.serviceVendu.typeService.libelle}} </td> --><!-- 							<td>{{payment.serviceVendu.libelle}} </td> --><td>{{payment.label}}<!-- 							{{\'wamasysApp.contrat.paiement.origin.\'+payment.codeOrigin | translate }} --></td><td>{{payment.totalPaye | currency:\"\":2}}</td></tr><tr><td><strong>Total</strong></td><td><strong>{{getTotalPaye()| currency:\"\":2}}</strong></td></tr></tbody></table></div><!-- 		</uib-tab-content> --><!-- 	</uib-tab>  --><!-- 	<uib-tab>  --><!-- 		<uib-tab-heading> --><!-- 			<span translate=\"wamasysApp.reportingGlobal.detailRefund\"> </span>  --><!-- 		</uib-tab-heading> 	 --><!-- 		<uib-tab-content> --><!-- 		<div  class=\"table-responsive\">   --><!-- 				  <table class=\"table table-striped table-bordered table-hover\" width=\"100%\" > --><!-- 					<thead> --><!-- 						<tr> --><!-- 								<th translate=\"wamasysApp.reportingGlobal.serviceVendu\">serviceVendu</th> --><!-- 								<th translate=\"wamasysApp.reportingGlobal.service\">Service</th> --><!-- 								<th translate=\"wamasysApp.reportingGlobal.typeAvoirRemiseRegul\">Type</th> --><!-- 								<th translate=\"wamasysApp.reportingGlobal.montantPenaliteRemiseRegul\">montant</th> --><!-- 						</tr> --><!-- 					</thead> --><!-- 					<tbody  ng-repeat=\"typeService in vm.reporting.listeTypeService\"> --><!-- 						<tr  ng-repeat=\"avoir in typeService.listRemiseAvoirRemboursement\" ng-if=\"avoir.type === \'REFUND\' || avoir.type === \'REFUND_BALANCE_TRANSFER\'\"> --><!-- 							<td>{{typeService.serviceVendu.libelle}} </td> --><!-- 							<td> --><!-- 							{{\'wamasysApp.reportingGlobal.TypePenalitRemiseRegul.\'+avoir.type | translate}} --><!-- 							 </td> --><!-- 							<td>{{avoir.totalMontant}}</td> --><!-- 						</tr> --><!-- 					</tbody> --><!-- 				</table> --><!-- 			</div> --><!-- 		</uib-tab-content> --><!-- 	</uib-tab>  --><!-- </uib-tabset> --><div ng-show=\"vm.reporting.listeTypeService\" class=\"alert alert-warning\" translate=\"wamasysApp.reportingGlobal.payment.message\" translate-compile>Note : les paiements affichés dans ce reporting sont filtrés via leur date de paiement.</div></div>");
$templateCache.put("app/business/organisation/organisation-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.organisation.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.organisation.delete.question\" translate-values=\"{id: \'{{vm.organisation.id}}\'}\">Are you sure you want to delete this Organisation?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/organisation/organisation-detail.html","<div><h2><span translate=\"wamasysApp.organisation.detail.title\">Organisation</span> {{vm.organisation.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.organisation.name\">Name</span></dt><dd><span>{{vm.organisation.name}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.organisation.description\">Description</span></dt><dd><span>{{vm.organisation.description}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.organisation.address\">Address</span></dt><dd><span>{{vm.organisation.address}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.organisation.country\">Country</span></dt><dd><span>{{vm.organisation.country}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.organisation.activated\">activated</span></dt><dd><span>{{vm.organisation.activated}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.organisation.modules\">modules</span></dt><dd><span ng-repeat=\"module in vm.organisation.modules\">{{module}} {{$last ? \'\' : \', \'}}</span></dd><hr><dt><span>userOwnerLogin</span></dt><dd>{{vm.organisation.userOwnerLogin}}</dd><hr><dt><span>userOwnerEMail</span></dt><dd>{{vm.organisation.userOwnerEMail}}</dd><hr><dt><span>countArea</span></dt><dd>{{vm.organisation.countArea}}</dd><hr><dt><span>countUser</span></dt><dd>{{vm.organisation.countUser}}</dd><hr><dt><span translate=\"wamasysApp.organisation.idSpaceKibana\">idSpaceKibana</span></dt><dd>{{vm.organisation.idSpaceKibana}}</dd><hr><dt><span translate=\"wamasysApp.organisation.listDashboardKibana\">listDashboardKibana</span></dt><dd>{{vm.organisation.listDashboardKibana}}</dd><hr><dt><span translate=\"wamasysApp.organisation.assistantMonthlyOrganisationCostLimitUsd\">assistantMonthlyOrganisationCostLimitUsd</span></dt><dd>{{vm.organisation.assistantMonthlyOrganisationCostLimitUsd}}</dd><hr><dt><span translate=\"wamasysApp.organisation.assistantDefaultMonthlyUserCostLimitUsd\">assistantDefaultMonthlyUserCostLimitUsd</span></dt><dd>{{vm.organisation.assistantDefaultMonthlyUserCostLimitUsd}}</dd><hr><dt><span t>redmineProjetId</span></dt><dd>{{vm.organisation.redmineProjetId}}</dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/organisation/organisation-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOrganisationLabel\" translate=\"wamasysApp.organisation.home.createOrEditLabel\">Create or edit a Organisation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.organisation.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.organisation.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.organisation.name\" required ng-maxlength=\"50\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.organisation.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.organisation.description\" ng-maxlength=\"2048\"><div ng-show=\"editForm.description.$invalid\"><p class=\"help-block\" ng-show=\"editForm.description.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"2048\">This field cannot be longer than 2048 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.organisation.address\" for=\"field_address\">Address</label><input type=\"text\" class=\"form-control\" name=\"address\" id=\"field_address\" ng-model=\"vm.organisation.address\" ng-maxlength=\"256\"><div ng-show=\"editForm.address.$invalid\"><p class=\"help-block\" ng-show=\"editForm.address.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"256\">This field cannot be longer than 256 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.organisation.activated\" for=\"field_activated\">activated</label><input type=\"checkbox\" class=\"form-control\" name=\"activated\" id=\"field_activated\" ng-model=\"vm.organisation.activated\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.organisation.country\" for=\"field_country\">Country</label><input type=\"text\" class=\"form-control\" name=\"country\" id=\"field_country\" ng-model=\"vm.organisation.country\" required ng-maxlength=\"5\"><div ng-show=\"editForm.country.$invalid\"><p class=\"help-block\" ng-show=\"editForm.country.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.country.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"5\">This field cannot be longer than 5 characters.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.organisation.modules\" for=\"field_modules\">modules</label><select multiple=\"multiple\" class=\"form-control\" name=\"modules\" ng-model=\"vm.organisation.modules\" id=\"field_module\"><option value=\"ELK\" translate=\"wamasysApp.Module.ELK\">ELK</option><option value=\"GEO\" translate=\"wamasysApp.Module.GEO\">GEO</option><option value=\"TEAM\" translate=\"wamasysApp.Module.TEAM\">TEAM</option><option value=\"EQUIPMENT\" translate=\"wamasysApp.Module.EQUIPMENT\">Équipements</option><option value=\"WATER_QUALITY\" translate=\"wamasysApp.Module.WATER_QUALITY\">Qualité de l’eau</option><option value=\"EVENT_FORM\" translate=\"wamasysApp.Module.EVENT_FORM\">EVENT_FORM</option><option value=\"BUDGET\" translate=\"wamasysApp.Module.BUDGET\">BUDGET</option><option value=\"CLIENT_PORTAL\" translate=\"wamasysApp.Module.CLIENT_PORTAL\">CLIENT_PORTAL</option><option value=\"ONLINE_PAYMENT\" translate=\"wamasysApp.Module.ONLINE_PAYMENT\">ONLINE_PAYMENT</option><option value=\"COMMUNICATION\" translate=\"wamasysApp.Module.COMMUNICATION\">COMMUNICATION</option><option value=\"IOT_WATER\" translate=\"wamasysApp.Module.IOT_WATER\">IOT_WATER</option><option value=\"ACCOUNTING_EXPORT\" translate=\"wamasysApp.Module.ACCOUNTING_EXPORT\">ACCOUNTING_EXPORT</option><option value=\"AI_ASSISTANT\" translate=\"wamasysApp.Module.AI_ASSISTANT\">AI_ASSISTANT</option><option value=\"OCR\" translate=\"wamasysApp.Module.OCR\">OCR</option><option value=\"NEW_FEATURES_VISIBILITY\" translate=\"wamasysApp.Module.NEW_FEATURES_VISIBILITY\">NEW_FEATURES_VISIBILITY</option></select><!--             <select class=\"form-control\" id=\"field_modules\" multiple name=\"modules\" ng-model=\"vm.organisation.moduless\" ng-options=\"moduleValue as moduleValue.id for moduleValue in vm.modulevalues track by moduleValue.id\"></select> --></div><div class=\"form-group\"><label translate=\"wamasysApp.organisation.userOwner\" for=\"field_userOwner\">userOwner</label><select class=\"form-control\" id=\"field_userOwner\" name=\"userOwnerId\" ng-model=\"vm.organisation.userOwnerId\" ng-options=\"user.id as user.login for user in vm.users \"><option value=\"\"></option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.organisation.idSpaceKibana\" for=\"field_idSpaceKibana\">idSpaceKibana</label><p>Attention les spaces ne sont pas créés automatiquement dans Kibana (les rôles et droits sur User le sont par contre)</p><input type=\"text\" class=\"form-control\" name=\"idSpaceKibana\" id=\"field_idSpaceKibana\" ng-model=\"vm.organisation.idSpaceKibana\" ng-maxlength=\"255\"><div ng-show=\"editForm.idSpaceKibana.$invalid\"><p class=\"help-block\" ng-show=\"editForm.idSpaceKibana.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.organisation.listDashboardKibana\" for=\"field_listDashboardKibana\">listDashboardKibana</label><br><small>Example ancienne conf MyDashbords {\"dashboards\":[{\"index\":1,\"label\":\"Label dashboard\",\"url\":\"/s/eau-et-vie/app/kibana#/dashboard/691dde40-519a-11ea-b497-25fc6f82f62a\"},{\"index\":2,\"label\":\"Label dashboard\",\"url\":\"/s/eau-et-vie/app/maps\"}]}</small><br><small>Example nouvelle conf (à noter que les 2 peuvent être dans le même flux json) : {\"dashboardsmenu\":[ {\"label\":\"NGO dashboards\", \"index\":1 ,\"items\":[ {\"index\":1,\"label\":\"Activities\",\"url\":\"/s/eau-et-vie/app/kibana#/dashboard/691dde40-519a-11ea-b497-25fc6f82f62a\"}, {\"index\":2,\"label\":\"Clean-Up activities\",\"url\":\"/s/eau-et-vie/app/kibana#/dashboard/1ca68cd0-827e-11ec-b02e-0d911b0c35b1\",\"filtreagence\":\"false\",\"periodKibana\":\"true\"} ]} ]}</small> <input type=\"text\" class=\"form-control\" name=\"listDashboardKibana\" id=\"field_listDashboardKibana\" ng-model=\"vm.organisation.listDashboardKibana\" ng-maxlength=\"20480\"><div ng-show=\"editForm.listDashboardKibana.$invalid\"><p class=\"help-block\" ng-show=\"editForm.listDashboardKibana.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"20480\">This field cannot be longer than 20480 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.organisation.assistantMonthlyOrganisationCostLimitUsd\" for=\"field_assistantMonthlyOrganisationCostLimitUsd\">Plafond mensuel USD assistant IA organisation</label><p class=\"help-block\">Vide : plafond global par défaut. Zéro : sans plafond. Montants en USD.</p><input type=\"number\" class=\"form-control\" name=\"assistantMonthlyOrganisationCostLimitUsd\" id=\"field_assistantMonthlyOrganisationCostLimitUsd\" ng-model=\"vm.organisation.assistantMonthlyOrganisationCostLimitUsd\" min=\"0\" step=\"0.01\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.organisation.assistantDefaultMonthlyUserCostLimitUsd\" for=\"field_assistantDefaultMonthlyUserCostLimitUsd\">Plafond mensuel USD assistant IA utilisateur par défaut</label><p class=\"help-block\">Vide : plafond utilisateur global. Zéro : sans plafond.</p><input type=\"number\" class=\"form-control\" name=\"assistantDefaultMonthlyUserCostLimitUsd\" id=\"field_assistantDefaultMonthlyUserCostLimitUsd\" ng-model=\"vm.organisation.assistantDefaultMonthlyUserCostLimitUsd\" min=\"0\" step=\"0.01\"></div><div class=\"form-group\"><label class=\"control-label\" for=\"field_redmineProjetId\">Redmine project id</label><input type=\"text\" class=\"form-control\" name=\"redmineProjetId\" id=\"field_redmineProjetId\" ng-model=\"vm.organisation.redmineProjetId\" ng-maxlength=\"255\"><div ng-show=\"editForm.redmineProjetId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.redmineProjetId.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/organisation/organisations.html","<div><h2 translate=\"wamasysApp.organisation.home.title\">Organisations</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"organisation.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.organisation.home.createLabel\">Create new Organisation</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"wamasysApp.organisation.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--                     <th jh-sort-by=\"description\"><span translate=\"wamasysApp.organisation.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th> --><!--                     <th jh-sort-by=\"address\"><span translate=\"wamasysApp.organisation.address\">Address</span> <span class=\"glyphicon glyphicon-sort\"></span></th> --><th jh-sort-by=\"country\"><span translate=\"wamasysApp.organisation.country\">Country</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"userOwner.id\"><span translate=\"wamasysApp.organisation.userOwner\">userOwner</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"activated\"><span translate=\"wamasysApp.organisation.activated\">activated</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th>module</th><th jh-sort-by=\"activated\"><span translate=\"wamasysApp.organisation.listDashboardKibana\">listDashboardKibana</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"activated\"><span translate=\"wamasysApp.organisation.idSpaceKibana\">idSpaceKibana</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"organisation in vm.organisations track by organisation.id\"><td><a ui-sref=\"organisation-detail({id:organisation.id})\">{{organisation.id}}</a></td><td>{{organisation.name}}</td><!--                     <td>{{organisation.description}}</td> --><!--                     <td>{{organisation.address}}</td> --><td>{{organisation.country}}</td><td>{{organisation.userOwnerEMail}}</td><td>{{organisation.activated}}</td><td><span ng-repeat=\"module in organisation.modules\">{{module}} {{$last ? \'\' : \', \'}}</span></td><td>{{organisation.listDashboardKibana}}</td><td>{{organisation.idSpaceKibana}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"organisation-detail({id:organisation.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"organisation.edit({id:organisation.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"organisation.delete({id:organisation.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/reporting-collection-list/reporting-collection-list.html","<div class=\"container-fluid\"><h2 translate=\"wamasysApp.reportingCollectionList.titre\">Reporting collection list</h2><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label col-md-4\" for=\"daterange1\" translate=\"wamasysApp.reportingGlobal.periodeRecherche\">Période recherchée</label><div class=\"col-md-8\"><div class=\"input-group\"><input date-range-picker id=\"daterange1\" name=\"daterange1\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" options=\"vm.opts\"><div class=\"input-group-btn\"><button ng-click=\"openRangeDateTimePicker()\" class=\"btn btn-default\" type=\"button\"><span class=\"glyphicon glyphicon-calendar\"></span></button></div></div></div></div></div><div class=\"col-md-6\"><label class=\"control-label col-md-2\" translate=\"wamasysApp.reportingGlobal.collector\">collecteur</label><section class=\"col-md-10\"><ui-select tagging multiple=\"multiple\" ng-model=\"vm.collecteurNotPromise\" theme=\"selectize\" title=\"{{\'wamasysApp.reportingGlobal.collector\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.reportingGlobal.collector\' | translate}}\">{{$item.login}}</ui-select-match><ui-select-choices repeat=\"collecteur in vm.collecteurs | filter: $select.search  track by collecteur.id\">{{collecteur.login}}</ui-select-choices></ui-select></section></div></div><div class=\"row\"><div class=\"col-md-12\"><label class=\"control-label col-md-2\" translate=\"wamasysApp.reportingGlobal.serviceVendu\">serviceVendu</label><section class=\"col-md-9\"><ui-select tagging multiple=\"multiple\" ng-model=\"vm.serviceVenduNotPromise\" theme=\"selectize\" title=\"{{\'wamasysApp.contrat.serviceVendu\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.contrat.serviceVendu\' | translate}}\">{{$item.libelle}}</ui-select-match><ui-select-choices repeat=\"serviceVendu in vm.serviceVendus | filter: $select.search  track by serviceVendu.id\">{{(serviceVendu.deleted==true)?\"&#x274c; \":\"\"}} {{serviceVendu.libelle}}</ui-select-choices></ui-select></section><div class=\"col-md-1 pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.search()\" translate=\"wamasysApp.reportingGlobal.chercher\">search</button></div></div></div><br><h3 ng-show=\"vm.reporting\" translate=\"wamasysApp.reportingCollectionList.detail\">Détail par cluster</h3><table class=\"table table-striped table-bordered table-hover\" width=\"100%\" ng-show=\"vm.reporting\"><thead><tr><th translate=\"wamasysApp.reportingCollectionList.collectionliste\">collectionListe</th><th translate=\"wamasysApp.reportingCollectionList.date\">date</th><th translate=\"wamasysApp.reportingCollectionList.collecteur\">collecteur</th><!-- 						<th translate=\"wamasysApp.reportingCollectionList.quantity\" >quantity</th> --><th translate=\"wamasysApp.reportingCollectionList.totalFacture\">totalFacture</th><th translate=\"wamasysApp.reportingCollectionList.totalACollecte\">totalACollecte</th><th translate=\"wamasysApp.reportingCollectionList.totalCollecteParCollecteur\">totalCollecteParCollecteur</th><th translate=\"wamasysApp.reportingCollectionList.totalCorrectionPaiement\">totalCorrectionPaiement</th><th translate=\"wamasysApp.reportingCollectionList.totalCollectedCorrected\">Total collected corrected</th><!-- 						<th translate=\"wamasysApp.reportingCollectionList.totalCollecte\">totalCollecte </th> --><th translate=\"wamasysApp.reportingCollectionList.ratioCollecteFacture\">ratioCollecteCollecteur</th><th translate=\"wamasysApp.reportingCollectionList.ratioCollecteTotal\">ratioCollecteTotal</th></tr></thead><tbody><tr ng-repeat=\"clReporting in vm.reporting\"><td><a ui-sref=\"collection-liste-detail({id:clReporting.collectionListe.id})\">{{clReporting.collectionListe.referenceCollectionList}}</a></td><td>{{clReporting.collectionListe.dateFinPeriode}}</td><td>{{clReporting.collectionListe.collecteur.login}}</td><!-- 					<td>{{clReporting.quantity | currency:\"\":3}}</td> --><td>{{clReporting.totalFacture | currency:\"\":2}}</td><td>{{clReporting.totalACollecte | currency:\"\":2}}</td><td>{{clReporting.totalCollecteParCollecteur | currency:\"\":2}}</td><td>{{clReporting.totalCorrectionPaiement | currency:\"\":2}}</td><td>{{(clReporting.totalCollecteParCollecteur +clReporting.totalCorrectionPaiement) | currency:\"\":2}}</td><!-- 					<td>{{clReporting.totalCollecte | currency:\"\":2}}</td> --><td>{{getRatioCollecteFacture(clReporting)| currency:\"%\":0}}</td><td>{{getRatioCollecteTotal(clReporting)| currency:\"%\":0}}</td></tr><tr><td colspan=\"3\"><strong>Total</strong></td><td><strong>{{getTotal(\'totalFacture\') | currency:\"\":2}}</strong></td><td><strong>{{getTotal(\'totalACollecte\') | currency:\"\":2}}</strong></td><td><strong>{{getTotal(\'totalCollecteParCollecteur\') | currency:\"\":2}}</strong></td><td><strong>{{getTotal(\'totalCorrectionPaiement\') | currency:\"\":2}}</strong></td><td><strong>{{getTotal(\'totalCollecteParCollecteur\',\'totalCorrectionPaiement\') | currency:\"\":2}}</strong></td><td><strong></strong></td><!--  {{getTotalRatioCollecteFacture() | currency:\"%\":0}} --><td><strong>{{getTotalRatioCollecteTotal() | currency:\"%\":0}}</strong></td></tr></tbody></table></div>");
$templateCache.put("app/business/reporting-consommation-eau/reporting-consommation-eau.html","<div class=\"container-fluid\"><h2 translate=\"wamasysApp.reportingGlobal.titreReportingWaterConsumption\">Reporting zone</h2><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label col-md-2\" for=\"daterange1\" translate=\"wamasysApp.reportingGlobal.periodeRecherche\">Période recherchée</label><div class=\"col-md-10\"><div class=\"input-group\"><input date-range-picker id=\"daterange1\" name=\"daterange1\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" options=\"vm.opts\"><div class=\"input-group-btn\"><button ng-click=\"openRangeDateTimePicker()\" class=\"btn btn-default\" type=\"button\"><span class=\"glyphicon glyphicon-calendar\"></span></button></div></div></div></div></div><div class=\"col-md-4 pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.search()\" translate=\"wamasysApp.reportingGlobal.chercher\">search</button></div></div><br><!-- 	  <h3>  {{vm.reporting.agence.nom}}</h3> --><div class=\"alert alert-warning\" ng-show=\"vm.showExplanation\"><span translate=\"wamasysApp.reportingGlobal.explanationInternalReportingWaterConsumption\"></span></div><br><div ng-show=\"vm.reporting\" class=\"row\"><div class=\"col-md-4\"><strong><span translate=\"wamasysApp.reportingGlobal.totalConsoEauContrat\">Total consommation d\'eau sur contrat</span> : </strong>{{getTotalConsommationEauTotale() | number:3}}</div><div class=\"col-md-4\"><strong><span translate=\"wamasysApp.reportingGlobal.totalConsoEauBulkMeter\">Total consommation d\'eau sur Bulk meters</span> : </strong>{{getTotalConsommationEauBulk() | number:3}}</div><div class=\"col-md-4\"><strong><span translate=\"wamasysApp.reportingGlobal.pourcentagePerte\">Pourcentage de perte</span> : </strong>{{getPourcentagePerte() | number:2}} %</div><hr></div><h4 ng-show=\"vm.reporting.listeTypeService\" translate=\"wamasysApp.reportingGlobal.detailCluster\">Détail par cluster</h4><table class=\"table table-striped table-bordered table-hover\" width=\"100%\" ng-show=\"vm.reporting.listeCluster\"><thead><tr><th translate=\"wamasysApp.reportingGlobal.cluster\">cluster</th><th translate=\"wamasysApp.reportingGlobal.consommationEau\">consommationEau</th><th translate=\"wamasysApp.reportingGlobal.nbrIndividualMeterActifs\">nbrIndividualMeterActifs</th><th translate=\"wamasysApp.reportingGlobal.nbrFamilles\">nbrFamilles</th><th translate=\"wamasysApp.reportingGlobal.nbrIndividus\">nbrIndividus</th></tr></thead><tbody><tr ng-repeat=\"cluster in vm.reporting.listeCluster\"><td>{{cluster.numeroSerie}}</td><td>{{cluster.consommationEauTotale}}</td><td>{{cluster.nbrIndividualMeterActifs}}</td><td>{{cluster.nbrFamilles}}</td><td>{{cluster.nbrIndividus}}</td></tr><tr><td><strong>Total</strong></td><td><strong>{{getTotalConsommationEauTotale() | currency:\"\":2}}</strong></td><td><strong>{{getTotalIndividualMeterActifs()}}</strong></td><td><strong>{{getTotalFamilles()}}</strong></td><td><strong>{{getTotalIndividus()}}</strong></td></tr></tbody></table><hr><h4 ng-show=\"vm.reporting.listeProfilService\" translate=\"wamasysApp.reportingGlobal.detailParContractProfil\">Détail par type de contrat</h4><table class=\"table table-striped table-bordered table-hover\" width=\"100%\" ng-show=\"vm.reporting.listeContractProfil\"><thead><tr><th translate=\"wamasysApp.reportingGlobal.contractProfil\">contractProfil</th><th translate=\"wamasysApp.reportingGlobal.consommationEau\">consommationEau</th><th translate=\"wamasysApp.reportingGlobal.nbrContratActifs\">nbrContratActifs</th><th translate=\"wamasysApp.reportingGlobal.nbrFamilles\">nbrFamilles</th><th translate=\"wamasysApp.reportingGlobal.nbrIndividus\">nbrIndividus</th></tr></thead><tbody><tr ng-repeat=\"listeContractProfil in vm.reporting.listeContractProfil\"><td>{{listeContractProfil.contractProfil.libelle}}</td><td>{{listeContractProfil.consommationEauTotale}}</td><td>{{listeContractProfil.nbrIndividualMeterActifs}}</td><td>{{listeContractProfil.nbrFamilles}}</td><td>{{listeContractProfil.nbrIndividus}}</td></tr><tr><td><strong>Total</strong></td><td><strong>{{getTotalConsommationEauContrat() | currency:\"\":2}}</strong></td><td><strong>{{getTotalnbrIndividualMeterActifs()}}</strong></td><td><strong>{{getTotalnbrFamilles()}}</strong></td><td><strong>{{getTotalnbrIndividus()}}</strong></td></tr></tbody></table><hr><h4 ng-show=\"vm.reporting.listeTypeService\" translate=\"wamasysApp.reportingGlobal.detailParBulkMeter\">Détail par bulkMeter</h4><table class=\"table table-striped table-bordered table-hover\" width=\"100%\" ng-show=\"vm.reporting.listeBulkMeter\"><thead><tr><th translate=\"wamasysApp.reportingGlobal.bulkMeter\">bulkMeter</th><th translate=\"wamasysApp.reportingGlobal.consommationEau\">consommationEau</th></tr></thead><tbody><tr ng-repeat=\"listeBulkMeter in vm.reporting.listeBulkMeter\"><td>{{listeBulkMeter.bulkMeter.numeroSerie}}</td><td>{{listeBulkMeter.consoEauTotale}}</td></tr><tr><td><strong>Total</strong></td><td><strong>{{getTotalConsommationEauBulk()| currency:\"\":2}}</strong></td></tr></tbody></table><br></div>");
$templateCache.put("app/business/reporting-pending-field-documents/reporting-pending-field-documents.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-9\"><h2 translate=\"wamasysApp.pendingFieldDocuments.title\">CL et RF en attente</h2><p class=\"text-muted\" translate=\"wamasysApp.pendingFieldDocuments.intro\">Documents non validés de toutes les zones de l\'organisation.</p></div><div class=\"col-md-3 text-right\"><button class=\"btn btn-default\" ng-click=\"vm.load()\" ng-disabled=\"vm.loading\"><span class=\"glyphicon glyphicon-refresh\" ng-class=\"{\'fa-spin\': vm.loading}\"></span> <span translate=\"wamasysApp.pendingFieldDocuments.refresh\">Actualiser</span></button></div></div><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-sm-2\"><div class=\"well well-sm\"><strong>{{vm.count()}}</strong><br><span translate=\"wamasysApp.pendingFieldDocuments.summary.total\">Total en attente</span></div></div><div class=\"col-sm-2\"><div class=\"well well-sm\"><strong>{{vm.count(\'CL\')}}</strong><br><span translate=\"wamasysApp.pendingFieldDocuments.summary.collectionLists\">CL</span></div></div><div class=\"col-sm-2\"><div class=\"well well-sm\"><strong>{{vm.count(\'RF\')}}</strong><br><span translate=\"wamasysApp.pendingFieldDocuments.summary.readingForms\">RF</span></div></div><div class=\"col-sm-2\"><div class=\"well well-sm\"><strong>{{vm.count(null, \'ENCOURS\')}}</strong><br><span translate=\"wamasysApp.pendingFieldDocuments.status.ENCOURS\">En cours</span></div></div><div class=\"col-sm-2\"><div class=\"well well-sm\"><strong>{{vm.count(null, \'AVALIDER\')}}</strong><br><span translate=\"wamasysApp.pendingFieldDocuments.status.AVALIDER\">À valider</span></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\" translate=\"wamasysApp.pendingFieldDocuments.filters.title\">Filtres</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4 form-group\"><label translate=\"wamasysApp.pendingFieldDocuments.filters.search\">Recherche</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.filters.search\" ng-change=\"vm.applyFilters()\" placeholder=\"{{\'wamasysApp.pendingFieldDocuments.filters.searchPlaceholder\' | translate}}\"></div><div class=\"col-md-3 form-group\"><label translate=\"wamasysApp.pendingFieldDocuments.filters.area\">Zone</label><select class=\"form-control\" ng-model=\"vm.filters.areaId\" ng-change=\"vm.applyFilters()\" ng-options=\"area.id as area.label for area in vm.areas\"><option value=\"\" translate=\"wamasysApp.pendingFieldDocuments.filters.allAreas\">Toutes les zones</option></select></div><div class=\"col-md-2 form-group\"><label translate=\"wamasysApp.pendingFieldDocuments.filters.type\">Type</label><select class=\"form-control\" ng-model=\"vm.filters.type\" ng-change=\"vm.applyFilters()\"><option value=\"\" translate=\"wamasysApp.pendingFieldDocuments.filters.allTypes\">Tous</option><option value=\"CL\">CL</option><option value=\"RF\">RF</option></select></div><div class=\"col-md-2 form-group\"><label translate=\"wamasysApp.pendingFieldDocuments.filters.status\">État</label><select class=\"form-control\" ng-model=\"vm.filters.status\" ng-change=\"vm.applyFilters()\"><option value=\"\" translate=\"wamasysApp.pendingFieldDocuments.filters.allStatuses\">Tous</option><option value=\"ACOLLECTER\" translate=\"wamasysApp.pendingFieldDocuments.status.ACOLLECTER\">À collecter</option><option value=\"ARENSEIGNER\" translate=\"wamasysApp.pendingFieldDocuments.status.ARENSEIGNER\">À renseigner</option><option value=\"ENCOURS\" translate=\"wamasysApp.pendingFieldDocuments.status.ENCOURS\">En cours</option><option value=\"AVALIDER\" translate=\"wamasysApp.pendingFieldDocuments.status.AVALIDER\">À valider</option></select></div><div class=\"col-md-1 form-group\"><label>&nbsp;</label><button class=\"btn btn-default form-control\" ng-click=\"vm.resetFilters()\" title=\"{{\'wamasysApp.pendingFieldDocuments.filters.reset\' | translate}}\"><span class=\"glyphicon glyphicon-remove\"></span></button></div></div></div></div><div class=\"row\"><div class=\"col-sm-4 form-group\"><label for=\"pending-sort-field\" translate=\"wamasysApp.pendingFieldDocuments.sort.field\">Trier par</label><select id=\"pending-sort-field\" class=\"form-control\" ng-model=\"vm.sort.field\" ng-change=\"vm.applySort()\"><option value=\"collectorLogin\" translate=\"wamasysApp.pendingFieldDocuments.sort.collector\">Utilisateur (compte du collecteur)</option><option value=\"creatorLogin\" translate=\"wamasysApp.pendingFieldDocuments.createdBy\">Créé par</option><option value=\"createdDate\" translate=\"wamasysApp.pendingFieldDocuments.createdDate\">Création</option><option value=\"fieldDate\" translate=\"wamasysApp.pendingFieldDocuments.fieldDate\">Terrain</option><option value=\"lastModifiedDate\" translate=\"wamasysApp.pendingFieldDocuments.updatedDate\">Mise à jour</option><option value=\"areaName\" translate=\"wamasysApp.pendingFieldDocuments.columns.area\">Zone</option><option value=\"status\" translate=\"wamasysApp.pendingFieldDocuments.columns.status\">État</option></select></div><div class=\"col-sm-3 form-group\"><label for=\"pending-sort-direction\" translate=\"wamasysApp.pendingFieldDocuments.sort.direction\">Ordre</label><select id=\"pending-sort-direction\" class=\"form-control\" ng-model=\"vm.sort.direction\" ng-change=\"vm.applySort()\"><option value=\"asc\" translate=\"wamasysApp.pendingFieldDocuments.sort.asc\">Croissant (A–Z / plus ancien)</option><option value=\"desc\" translate=\"wamasysApp.pendingFieldDocuments.sort.desc\">Décroissant (Z–A / plus récent)</option></select></div></div><div class=\"alert alert-info\" ng-if=\"!vm.loading && vm.documents.length && !vm.filteredDocuments.length\" translate=\"wamasysApp.pendingFieldDocuments.noFilteredResult\">Aucun document ne correspond aux filtres.</div><div class=\"alert alert-success\" ng-if=\"!vm.loading && !vm.documents.length\" translate=\"wamasysApp.pendingFieldDocuments.noResult\">Aucune CL ou RF en attente.</div><div class=\"table-responsive\" ng-if=\"vm.filteredDocuments.length\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th translate=\"wamasysApp.pendingFieldDocuments.columns.document\">Document</th><th translate=\"wamasysApp.pendingFieldDocuments.columns.area\">Zone</th><th translate=\"wamasysApp.pendingFieldDocuments.columns.status\">État</th><th translate=\"wamasysApp.pendingFieldDocuments.columns.people\">Création / affectation</th><th translate=\"wamasysApp.pendingFieldDocuments.columns.received\">Informations reçues</th><th translate=\"wamasysApp.pendingFieldDocuments.columns.smartphone\">Dernier envoi smartphone</th><th translate=\"wamasysApp.pendingFieldDocuments.columns.dates\">Dates</th></tr></thead><tbody><tr ng-repeat=\"document in vm.filteredDocuments track by (document.documentType + \'-\' + document.documentId)\"><td><span class=\"label\" ng-class=\"document.documentType === \'CL\' ? \'label-primary\' : \'label-info\'\">{{document.documentType}}</span> <strong>{{document.reference}}</strong><div class=\"text-muted\">#{{document.documentId}}</div></td><td><strong>{{document.areaCode}}</strong><br>{{document.areaName}}</td><td><span class=\"label\" ng-class=\"{\'label-warning\': document.status === \'ENCOURS\', \'label-info\': document.status === \'ACOLLECTER\' || document.status === \'ARENSEIGNER\', \'label-primary\': document.status === \'AVALIDER\'}\">{{(\'wamasysApp.pendingFieldDocuments.status.\' + document.status) | translate}}</span></td><td><span translate=\"wamasysApp.pendingFieldDocuments.createdBy\">Créé par</span> : {{document.creatorLogin || \'-\'}}<br><span translate=\"wamasysApp.pendingFieldDocuments.assignedCollector\">Collecteur</span> : <strong>{{document.collectorDisplayName || \'-\'}}</strong> <span class=\"text-muted\" ng-if=\"document.collectorLogin && document.collectorDisplayName !== document.collectorLogin\">({{document.collectorLogin}})</span></td><td ng-if=\"document.documentType === \'CL\'\"><strong>{{document.receivedItems}} / {{document.totalItems}}</strong> <span translate=\"wamasysApp.pendingFieldDocuments.payments\">paiements saisis</span><br><span translate=\"wamasysApp.pendingFieldDocuments.amount\">Montant</span> : {{document.amountReceived | currency:\'\':2}}<br><span translate=\"wamasysApp.pendingFieldDocuments.signatures\">Signatures</span> : {{document.signatureItems}}</td><td ng-if=\"document.documentType === \'RF\'\"><strong>{{document.receivedItems}} / {{document.totalItems}}</strong> <span translate=\"wamasysApp.pendingFieldDocuments.readings\">relevés ou motifs reçus</span><br><span translate=\"wamasysApp.pendingFieldDocuments.nonReadings\">Non relevés</span> : {{document.nonReadingItems}}<br><span translate=\"wamasysApp.pendingFieldDocuments.photos\">Photos</span> : {{document.photoItems}}</td><td><div ng-if=\"document.lastReceivedAt\">{{document.lastReceivedAt | date:\'short\'}}<br><span class=\"label\" ng-class=\"document.handoffAnomalyItems ? \'label-danger\' : \'label-default\'\">{{(\'wamasysApp.pendingFieldDocuments.handoff.\' + document.handoffProcessingStatus) | translate}} </span><br><small><span translate=\"wamasysApp.pendingFieldDocuments.applied\">appliquées</span> : {{document.handoffAppliedItems || 0}}, <span translate=\"wamasysApp.pendingFieldDocuments.alreadyReceived\">déjà reçues</span> : {{document.handoffAlreadyReceivedItems || 0}}, <span translate=\"wamasysApp.pendingFieldDocuments.skipped\">ignorées</span> : {{document.handoffSkippedItems || 0}}, <span translate=\"wamasysApp.pendingFieldDocuments.anomalies\">anomalies</span> : {{document.handoffAnomalyItems || 0}}</small></div><span class=\"text-muted\" ng-if=\"!document.lastReceivedAt\" translate=\"wamasysApp.pendingFieldDocuments.noHandoff\">Aucun dépôt tracé</span></td><td><span translate=\"wamasysApp.pendingFieldDocuments.fieldDate\">Terrain</span> : {{document.fieldDate | date:\'shortDate\'}}<br><span translate=\"wamasysApp.pendingFieldDocuments.createdDate\">Création</span> : {{document.createdDate | date:\'short\'}}<br><span translate=\"wamasysApp.pendingFieldDocuments.updatedDate\">Mise à jour</span> : {{(document.lastModifiedDate || document.createdDate) | date:\'short\'}} <span class=\"text-muted\">({{document.lastModifiedBy || document.creatorLogin || \'-\'}})</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/business/s3-filesexplorer/s3-fileexplorer.html","<div class=\"container\" ng-controller=\"S3FileExplorerController as vm\"><h2>Explorateur S3</h2><p class=\"text-muted\">Le comptage par repertoire est charge a la demande pour limiter les appels S3.</p><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"storageSystem\">Bucket</label><select id=\"storageSystem\" class=\"form-control\" ng-model=\"vm.storageSystem\" ng-options=\"item.key as item.label for item in vm.storageSystems\" ng-change=\"vm.changeStorageSystem()\"></select></div></div><div class=\"col-sm-8\"><p class=\"text-muted\" style=\"margin-top: 30px\">Bucket courant : <strong>{{ vm.currentStorageSystemLabel() }}</strong></p></div></div><div class=\"breadcrumb\"><span ng-repeat=\"c in vm.breadcrumb\"><a ng-click=\"vm.goUp(c.prefix)\">{{ c.name }}</a> <span ng-if=\"!$last\">/</span></span></div><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Rechercher un fichier...\" ng-model=\"vm.searchText\"></div><h4>Dossiers</h4><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"d in vm.folders\"><i class=\"fa fa-folder\"></i> <a ng-click=\"vm.enter(d)\">{{ d }}</a></li><li class=\"list-group-item\" ng-if=\"!vm.folders.length\">Aucun dossier</li></ul><h4>Fichiers</h4><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"f in vm.filteredFiles()\"><i class=\"fa fa-file\"></i> {{ f.key.split(\'/\').slice(-1)[0] }} <span class=\"pull-right\"><a class=\"btn btn-xs btn-primary\" ng-click=\"vm.download(f)\">Telecharger</a></span><br><small>{{ f.size }} bytes - {{ f.lastModified | date:\'short\' }}</small></li><li class=\"list-group-item\" ng-if=\"!vm.filteredFiles().length\">Aucun fichier</li></ul><div class=\"text-center\" ng-if=\"vm.truncated\"><button class=\"btn btn-default\" ng-click=\"vm.loadMore()\">Charger plus</button></div><hr><div class=\"clearfix\"><h4 class=\"pull-left\">Comptage des documents</h4><button class=\"btn btn-default pull-right\" ng-click=\"vm.loadDirectoryCounts()\" ng-disabled=\"vm.directoryCountsLoading\">{{ vm.directoryCountsLoading ? \'Chargement...\' : \'Charger les statistiques du repertoire courant\' }}</button></div><p class=\"text-muted\" ng-if=\"vm.directoryCountsLoaded\">Resultats pour le chemin courant du bucket selectionne.</p><table class=\"table table-striped table-condensed\" ng-if=\"vm.directoryCountsLoaded\"><thead><tr><th>Repertoire</th><th class=\"text-right\">Nb documents</th></tr></thead><tbody><tr ng-repeat=\"item in vm.directoryCounts\"><td>{{ item.directory }}</td><td class=\"text-right\">{{ item.documentCount }}</td></tr><tr ng-if=\"!vm.directoryCounts.length\"><td colspan=\"2\">Aucun document trouve dans ce repertoire.</td></tr></tbody></table></div>");
$templateCache.put("app/business/reporting-zone-analysis/reporting-zone-analysis.html","<div class=\"container-fluid zone-ai-report\"><div class=\"clearfix\"><a class=\"btn btn-default pull-right\" ui-sref=\"reporting-agence\" translate=\"wamasysApp.zoneAnalysis.back\">Retour au reporting de zone</a><h2><span translate=\"wamasysApp.zoneAnalysis.title\">Analyse IA de la zone</span> <small ng-bind=\"vm.areaName\"></small></h2></div><p class=\"text-muted\" translate=\"wamasysApp.zoneAnalysis.introduction\">Une synthèse pour les décideurs, guidée par vos objectifs et votre contexte.</p><div class=\"alert alert-danger\" ng-if=\"vm.error\" role=\"alert\" ng-bind=\"vm.error\"></div><div class=\"alert alert-info\" ng-if=\"vm.loading\" translate=\"wamasysApp.zoneAnalysis.loading\">Chargement…</div><div class=\"alert alert-warning\" ng-if=\"!vm.loading && !vm.configured\" translate=\"wamasysApp.zoneAnalysis.notConfigured\">L’analyse IA n’est pas configurée. Vous pouvez préparer les prompts et consulter les analyses déjà enregistrées.</div><details class=\"panel panel-default zone-ai-prompt-editor\" ng-if=\"!vm.loading\"><summary class=\"panel-heading\"><span class=\"panel-title\" translate=\"wamasysApp.zoneAnalysis.managerPrompts\">Objectifs et contexte du manager</span></summary><div class=\"panel-body\"><p translate=\"wamasysApp.zoneAnalysis.promptHelp\">Ces deux champs guident les analyses. Chaque enregistrement conserve une nouvelle version datée.</p><p class=\"text-muted\" ng-if=\"vm.latestPrompt\"><span translate=\"wamasysApp.zoneAnalysis.updated\">Dernière mise à jour</span> : {{vm.latestPrompt.updatedAt | date:\'dd/MM/yyyy HH:mm\'}} — {{vm.latestPrompt.authorLogin}}</p><form name=\"promptForm\" ng-submit=\"vm.save()\"><div class=\"row\"><div class=\"col-md-6 form-group\"><label for=\"zone-analysis-objectives\" translate=\"wamasysApp.zoneAnalysis.objectives\">Objectifs</label><textarea id=\"zone-analysis-objectives\" class=\"form-control\" rows=\"4\" maxlength=\"6000\" ng-model=\"vm.form.objectives\" ng-readonly=\"!vm.canEdit || vm.saving\" placeholder=\"{{\'wamasysApp.zoneAnalysis.objectivesPlaceholder\' | translate}}\"></textarea></div><div class=\"col-md-6 form-group\"><label for=\"zone-analysis-context\" translate=\"wamasysApp.zoneAnalysis.context\">Contexte</label><textarea id=\"zone-analysis-context\" class=\"form-control\" rows=\"4\" maxlength=\"6000\" ng-model=\"vm.form.context\" ng-readonly=\"!vm.canEdit || vm.saving\" placeholder=\"{{\'wamasysApp.zoneAnalysis.contextPlaceholder\' | translate}}\"></textarea></div></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.form.weeklyEnabled\" ng-disabled=\"!vm.canEdit || vm.saving\"> <span translate=\"wamasysApp.zoneAnalysis.weeklyEnabled\">Activer l’analyse hebdomadaire pour cette zone</span></label></div><p class=\"text-muted\" translate=\"wamasysApp.zoneAnalysis.schedule\">Par défaut, l’analyse démarre le lundi à 6 h (heure de Paris) et porte sur la dernière semaine complète. Le lancement manuel utilise la même période et les derniers prompts enregistrés.</p><button type=\"submit\" class=\"btn btn-primary\" ng-if=\"vm.canEdit\" ng-disabled=\"vm.saving || !vm.hasUnsavedChanges() || (!vm.form.objectives.trim() && !vm.form.context.trim())\" translate=\"wamasysApp.zoneAnalysis.save\">Enregistrer une nouvelle version</button> <span class=\"text-success\" ng-if=\"vm.saved\" translate=\"wamasysApp.zoneAnalysis.saved\">Version enregistrée.</span></form><hr><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.run()\" has-any-authority=\"ROLE_ADMIN,ROLE_SUPER_ADMIN\" ng-disabled=\"vm.launching || vm.saving || vm.hasUnsavedChanges() || !vm.latestPrompt || !vm.configured || vm.busy()\"><span class=\"glyphicon glyphicon-play\"></span> <span translate=\"wamasysApp.zoneAnalysis.runNow\">Lancer l’analyse maintenant</span></button> <span ng-if=\"vm.busy()\" class=\"text-info\" translate=\"wamasysApp.zoneAnalysis.running\">Une analyse est en cours. Les résultats s’actualisent automatiquement.</span><p class=\"text-muted\" ng-if=\"vm.canRun && vm.hasUnsavedChanges()\" translate=\"wamasysApp.zoneAnalysis.saveBeforeRun\">Enregistrez vos modifications avant de lancer l’analyse.</p></div></details><details class=\"zone-ai-history\" ng-if=\"!vm.loading\"><summary translate=\"wamasysApp.zoneAnalysis.historyToggle\">Historique des analyses et des prompts</summary><uib-tabset><uib-tab><uib-tab-heading><span translate=\"wamasysApp.zoneAnalysis.analyses\">Historique des analyses</span></uib-tab-heading><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"wamasysApp.zoneAnalysis.period\">Période analysée</th><th translate=\"wamasysApp.zoneAnalysis.created\">Lancement</th><th translate=\"wamasysApp.zoneAnalysis.trigger\">Origine</th><th translate=\"wamasysApp.zoneAnalysis.status\">État</th><th translate=\"wamasysApp.zoneAnalysis.inputTokens\">Tokens d’entrée</th><th translate=\"wamasysApp.zoneAnalysis.outputTokens\">Tokens de sortie</th><th translate=\"wamasysApp.zoneAnalysis.cost\">Coût estimé (USD)</th><th translate=\"wamasysApp.zoneAnalysis.duration\">Durée totale</th><th></th></tr></thead><tbody><tr ng-repeat=\"analysis in vm.analyses track by analysis.id\" ng-class=\"{info: vm.selectedId === analysis.id}\"><td>{{analysis.fromDate | date:\'dd/MM/yyyy\'}} — {{analysis.toDate | date:\'dd/MM/yyyy\'}}</td><td>{{analysis.createdAt | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{\'wamasysApp.zoneAnalysis.triggers.\' + analysis.triggerType | translate}}</td><td>{{\'wamasysApp.zoneAnalysis.statuses.\' + analysis.status | translate}}</td><td>{{analysis.inputTokens == null ? \'—\' : (analysis.inputTokens | number:0)}}</td><td>{{analysis.outputTokens == null ? \'—\' : (analysis.outputTokens | number:0)}}</td><td title=\"{{\'wamasysApp.zoneAnalysis.costHelp\' | translate}}\">{{analysis.estimatedCostUsd == null ? \'—\' : (analysis.estimatedCostUsd | number:6)}}</td><td>{{vm.durationLabel(analysis.durationMillis)}}</td><td><button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"vm.select(analysis)\" translate=\"wamasysApp.zoneAnalysis.view\">Consulter</button></td></tr></tbody></table></div><p ng-if=\"!vm.analyses.length\" translate=\"wamasysApp.zoneAnalysis.noAnalyses\">Aucune analyse enregistrée pour cette zone.</p><div class=\"btn-group\"><button class=\"btn btn-default btn-sm\" ng-click=\"vm.analysisHistory(vm.analysisPage - 1)\" ng-disabled=\"vm.analysisPage === 0 || vm.loadingAnalyses\" translate=\"wamasysApp.zoneAnalysis.previous\">Précédent</button><button class=\"btn btn-default btn-sm\" ng-click=\"vm.analysisHistory(vm.analysisPage + 1)\" ng-disabled=\"vm.analyses.length < 20 || vm.loadingAnalyses\" translate=\"wamasysApp.zoneAnalysis.next\">Suivant</button></div><button class=\"btn btn-default btn-sm\" ng-click=\"vm.analysisHistory(0)\" ng-disabled=\"vm.loadingAnalyses\" translate=\"wamasysApp.zoneAnalysis.refresh\">Actualiser</button></uib-tab><uib-tab><uib-tab-heading><span translate=\"wamasysApp.zoneAnalysis.promptHistory\">Historique des prompts</span></uib-tab-heading><p class=\"text-muted\" translate=\"wamasysApp.zoneAnalysis.historyHelp\">Les versions précédentes restent consultables. Elles ne remplacent pas la version utilisée pour la prochaine analyse.</p><div class=\"panel panel-default\" ng-repeat=\"prompt in vm.prompts track by prompt.id\"><div class=\"panel-heading\">{{prompt.updatedAt | date:\'dd/MM/yyyy HH:mm\'}} — {{prompt.authorLogin}} · <span translate=\"wamasysApp.zoneAnalysis.version\">Version</span> {{prompt.id}}</div><div class=\"panel-body\"><details><summary translate=\"wamasysApp.zoneAnalysis.viewPrompts\">Afficher les objectifs et le contexte</summary><h4 translate=\"wamasysApp.zoneAnalysis.objectives\">Objectifs</h4><p style=\"white-space: pre-wrap\" ng-bind=\"prompt.objectives\"></p><h4 translate=\"wamasysApp.zoneAnalysis.context\">Contexte</h4><p style=\"white-space: pre-wrap\" ng-bind=\"prompt.context\"></p><p>{{\'wamasysApp.zoneAnalysis.weeklyEnabled\' | translate}} : {{(prompt.weeklyEnabled ? \'wamasysApp.zoneAnalysis.yes\' : \'wamasysApp.zoneAnalysis.no\') | translate}}</p></details></div></div><p ng-if=\"!vm.prompts.length\" translate=\"wamasysApp.zoneAnalysis.noPrompts\">Aucun prompt enregistré.</p><div class=\"btn-group\"><button class=\"btn btn-default btn-sm\" ng-click=\"vm.promptHistory(vm.promptPage - 1)\" ng-disabled=\"vm.promptPage === 0 || vm.loadingPrompts\" translate=\"wamasysApp.zoneAnalysis.previous\">Précédent</button><button class=\"btn btn-default btn-sm\" ng-click=\"vm.promptHistory(vm.promptPage + 1)\" ng-disabled=\"vm.prompts.length < 20 || vm.loadingPrompts\" translate=\"wamasysApp.zoneAnalysis.next\">Suivant</button></div></uib-tab></uib-tabset></details><div class=\"text-muted\" ng-if=\"vm.loadingDetail\" translate=\"wamasysApp.zoneAnalysis.loading\">Chargement…</div><div class=\"zone-ai-result\" ng-if=\"vm.detail && vm.detail.id === vm.selectedId\" aria-live=\"polite\"><header class=\"zone-ai-result-header\"><h3 translate=\"wamasysApp.zoneAnalysis.result\">Résultat de l’analyse sélectionnée</h3><span class=\"zone-ai-period\">{{vm.detail.fromDate | date:\'dd/MM/yyyy\'}} — {{vm.detail.toDate | date:\'dd/MM/yyyy\'}}</span> <small class=\"text-muted\">{{\'wamasysApp.zoneAnalysis.version\' | translate}} {{vm.detail.promptId}}</small></header><div class=\"alert alert-danger\" ng-if=\"vm.detail.errorMessage\" ng-bind=\"vm.detail.errorMessage\"></div><div class=\"alert alert-info\" ng-if=\"vm.detail.status === \'QUEUED\' || vm.detail.status === \'RUNNING\'\">{{\'wamasysApp.zoneAnalysis.statuses.\' + vm.detail.status | translate}}</div><div ng-if=\"vm.result\"><div class=\"zone-ai-summary\"><span class=\"zone-ai-label\" translate=\"wamasysApp.zoneAnalysis.summary\">L’essentiel</span><p ng-bind=\"vm.result.summary\"></p></div><section class=\"zone-ai-section\" ng-repeat=\"section in vm.sections\" ng-if=\"vm.result[section].length\"><h4>{{\'wamasysApp.zoneAnalysis.sections.\' + section | translate}} <span class=\"zone-ai-count\">{{vm.result[section].length}}</span></h4><div class=\"zone-ai-grid\"><article class=\"zone-ai-card\" ng-repeat=\"finding in vm.result[section] track by $index\" ng-class=\"\'zone-ai-\' + section\"><h5 ng-bind=\"finding.title\"></h5><div class=\"zone-ai-evidence\"><span class=\"zone-ai-label\" translate=\"wamasysApp.zoneAnalysis.evidence\">Faits observés</span><p><span ng-repeat=\"part in vm.evidenceParts(finding.evidence) track by $index\" ng-class=\"{\'zone-ai-number\': part.highlighted}\" ng-bind=\"part.text\"></span></p></div><div class=\"zone-ai-action\"><span class=\"zone-ai-label\" translate=\"wamasysApp.zoneAnalysis.recommendation\">Proposition</span><p ng-bind=\"finding.recommendation\"></p></div><details class=\"zone-ai-interpretation\"><summary translate=\"wamasysApp.zoneAnalysis.interpretation\">Interprétation et hypothèses</summary><p ng-bind=\"finding.interpretation\"></p></details><div class=\"zone-ai-sources\"><span class=\"zone-ai-label\" translate=\"wamasysApp.zoneAnalysis.sourceLabel\">Sources</span> <a href=\"\" class=\"zone-ai-source\" ng-repeat=\"source in finding.sources track by $index\" ng-if=\"vm.hasSource(source)\" ng-click=\"$event.preventDefault(); vm.showSource(source)\" title=\"{{\'wamasysApp.zoneAnalysis.viewSource\' | translate}}\"><span class=\"glyphicon glyphicon-search\" aria-hidden=\"true\"></span> {{\'wamasysApp.zoneAnalysis.sources.\' + source | translate}}</a> <a class=\"zone-ai-source\" ng-repeat=\"link in vm.reportingLinks(finding.sources) track by link.state\" ui-sref=\"{{link.state}}\"><span class=\"glyphicon glyphicon-stats\" aria-hidden=\"true\"></span> {{\'wamasysApp.zoneAnalysis.reportings.\' + link.state | translate}}</a></div></article></div></section><details class=\"zone-ai-limitations\" ng-if=\"vm.result.limitations.length\"><summary><span translate=\"wamasysApp.zoneAnalysis.limitations\">Limites de l’analyse</span> ({{vm.result.limitations.length}})</summary><ul><li ng-repeat=\"limit in vm.result.limitations track by $index\" ng-bind=\"limit\"></li></ul></details><p class=\"zone-ai-review text-muted\" translate=\"wamasysApp.zoneAnalysis.review\">Les interprétations et recommandations de l’IA restent à vérifier avant toute décision. Aucun paramétrage n’est modifié automatiquement.</p></div><details class=\"zone-ai-used-prompts\" ng-if=\"vm.snapshot.managerPrompt\"><summary translate=\"wamasysApp.zoneAnalysis.usedPrompts\">Prompts utilisés pour cette analyse</summary><p>{{vm.snapshot.managerPrompt.updatedAt | date:\'dd/MM/yyyy HH:mm\'}} — {{vm.snapshot.managerPrompt.authorLogin}}</p><h4 translate=\"wamasysApp.zoneAnalysis.objectives\">Objectifs</h4><p ng-bind=\"vm.snapshot.managerPrompt.objectives\"></p><h4 translate=\"wamasysApp.zoneAnalysis.context\">Contexte</h4><p ng-bind=\"vm.snapshot.managerPrompt.context\"></p></details></div><script type=\"text/ng-template\" id=\"zone-analysis-source.html\"><div class=\"zone-ai-source-dialog\">\r\n            <div class=\"modal-header\"><button class=\"close\" type=\"button\" ng-click=\"sourceVm.close()\" aria-label=\"{{\'wamasysApp.zoneAnalysis.close\' | translate}}\">&times;</button><h4 class=\"modal-title\">{{\'wamasysApp.zoneAnalysis.sources.\' + sourceVm.source.id | translate}}</h4></div>\r\n            <div class=\"modal-body\"><p class=\"text-muted\" translate=\"wamasysApp.zoneAnalysis.sourceHelp\">Données conservées au moment de l’analyse. Le reporting actuel peut avoir évolué.</p><pre>{{sourceVm.source.data | json}}</pre></div>\r\n            <div class=\"modal-footer\"><a class=\"btn btn-primary btn-sm\" ng-if=\"sourceVm.source.state\" ui-sref=\"{{sourceVm.source.state}}\" ng-click=\"sourceVm.close()\" translate=\"wamasysApp.zoneAnalysis.openReporting\">Ouvrir le reporting</a><button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"sourceVm.close()\" translate=\"wamasysApp.zoneAnalysis.close\">Fermer</button></div>\r\n        </div></script></div>");
$templateCache.put("app/business/reporting-payment-arrears/reporting-payment-arrears.html","<div><!--     <h2 translate=\"wamasysApp.contrat.home.title\">Contrats</h2> --><jhi-alert></jhi-alert><style>.panel-title > a:before {\n        font-family: FontAwesome;\n        content: \"\\f068\";\n        padding-right: 5px;\n    }\n    .panel-title > a.collapsed:before {\n        content: \"\\f067\";\n    }</style><div class=\"container-fluid\"><div class=\"row\"><article class=\"col-md-12\"><div id=\"searchPanel\" data-jarvis-widget data-widget-colorbutton=\"false\" data-widget-editbutton=\"false\" data-widget-color=\"blueDark\" data-widget-editbutton=\"false\"><!-- 			<div > --><!-- 				<div data-widget-color=\"blueDark\" data-widget-editbutton=\"false\" class=\"jarviswidget-color-blueDark jarviswidget\"> --><header><span class=\"widget-icon\"><i class=\"fa fa-search\"></i></span><h2 translate=\"wamasysApp.contrat.search\">Search</h2><div class=\"jarviswidget-ctrls panel-title\" role=\"menu\"><a class=\"\" data-toggle=\"collapse\" data-target=\"#collapsePanel\" aria-expanded=\"false\" aria-controls=\"collapsePanel\" data-placement=\"bottom\"></a></div></header><div><div class=\"widget-body collapse in\" id=\"collapsePanel\" aria-expanded=\"true\"><form name=\"searchForm\" class=\"smart-form form-inline\"><fieldset><div class=\"row\"><div class=\"col-md-4\"><label class=\"label col-md-4\" translate=\"wamasysApp.contrat.balance\" for=\"field_etat\"></label><section class=\"col-md-8\"><select class=\"form-control\" name=\"etat\" ng-model=\"vm.currentBalanceSigne\" id=\"field_currentBalanceSigne\"><option value=\"<\">&#60;</option><option value=\">\">&#62;</option><option value=\"<>\">&#8800;</option><option value=\"=\">&#61;</option></select><input type=\"text\" class=\"form-control\" ng-model=\"vm.currentBalanceValue\" id=\"currentBalanceValue\" placeholder=\"\"></section></div><div class=\"col-md-4\"><label for=\"field_filterBalanceWithService\" class=\"label\"><input type=\"checkbox\" id=\"field_filterBalanceWithService\" class=\"form-control\" ng-model=\"vm.filterBalanceWithService\" name=\"filterBalanceWithService\"><span translate=\"wamasysApp.contrat.filterBalanceWithService\">filterBalanceWithService</span></label></div><div class=\"col-md-4\"><label for=\"field_tooMuchPaid\" class=\"label\"><input type=\"checkbox\" id=\"field_tooMuchPaid\" class=\"form-control\" ng-model=\"vm.tooMuchPaid\" name=\"tooMuchPaid\"><span translate=\"wamasysApp.contrat.tooMuchPaid\">tooMuchPaid</span> <span data-popover-placement=\"top\" data-popover-trigger=\"mouseenter\" data-uib-popover=\"{{\'wamasysApp.contrat.tooMuchPaidComment\' | translate}}\"><i class=\"fa fa-question txt-color-yellow\"></i></span></label></div><!--                   <div class=\"col-md-4\">\n						<label class=\"label col-md-6\" translate=\"wamasysApp.contrat.dontPaidSince\"\n							for=\"field_dontPaidSince\">dontPaidSince</label>\n						<section class=\"col-md-6\">\n						   <div class=\"form-group input-group\">\n				                 <input 	placeholder=\"{{ \'wamasysApp.contrat.dontPaidSince\' | translate }}\"  id=\"field_dontPaidSince\" type=\"text\" \n				                 class=\"form-control\" name=\"dontPaidSince\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.dontPaidSince\"   is-open=\"vm.datePickerOpenStatus.dontPaidSince\"\n				                  ng-click=\"vm.openCalendar(\'dontPaidSince\')\"/>\n				                 <span class=\"input-group-btn\">\n				                     <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dontPaidSince\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n				                 </span>\n				             </div>\n\n						</section>\n					</div>\n                    <div class=\"col-md-4\">\n						<label class=\"label col-md-6\" translate=\"wamasysApp.contrat.anyBillSince\"\n							for=\"field_anyBillSince\">anyBillSince</label>\n						<section class=\"col-md-6\">\n						   <div class=\"form-group input-group\">\n				                 <input 	placeholder=\"{{ \'wamasysApp.contrat.anyBillSince\' | translate }}\"  id=\"field_anyBillSince\" type=\"text\" \n				                 class=\"form-control\" name=\"anyBillSince\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.anyBillSince\"   is-open=\"vm.datePickerOpenStatus.anyBillSince\"\n				                 ng-click=\"vm.openCalendar(\'anyBillSince\')\"/>\n				                 <span class=\"input-group-btn\">\n				                     <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'anyBillSince\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n				                 </span>\n				             </div>\n\n						</section>\n					</div>\n					 --></div><div class=\"row\"><div class=\"col-md-4\"><label class=\"label col-md-4\" translate=\"wamasysApp.contrat.minAmountPaid\">Sum of payment less than</label><section class=\"col-md-2\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.minAmountPaid\" id=\"minAmountPaid\" placeholder=\"\"></section><section class=\"col-md-4\"><div class=\"form-group input-group\"><input placeholder=\"{{ \'wamasysApp.contrat.since\' | translate }}\" id=\"field_toDatePayment\" type=\"text\" class=\"form-control\" name=\"toDatePayment\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.toDatePayment\" is-open=\"vm.datePickerOpenStatus.toDatePayment\" ng-click=\"vm.openCalendar(\'toDatePayment\')\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDatePayment\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></section></div><div class=\"col-md-4\"><label class=\"label col-md-4\" translate=\"wamasysApp.contrat.minAmountBilled\">Sum of billing less than</label><section class=\"col-md-2\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.minAmountBilled\" id=\"minAmountBilled\" placeholder=\"\"></section><section class=\"col-md-4\"><div class=\"form-group input-group\"><input placeholder=\"{{ \'wamasysApp.contrat.since\' | translate }}\" id=\"field_toDateBilling\" type=\"text\" class=\"form-control\" name=\"toDateBilling\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.toDateBilling\" is-open=\"vm.datePickerOpenStatus.toDateBilling\" ng-click=\"vm.openCalendar(\'toDateBilling\')\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDateBilling\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></section></div><div class=\"col-md-4\"><label class=\"label col-md-4\" translate=\"wamasysApp.contrat.maxWaterConsumption\">Sum of water consumption less than</label><section class=\"col-md-2\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.maxWaterConsumption\" id=\"maxWaterConsumption\" placeholder=\"\"></section><section class=\"col-md-4\"><div class=\"form-group input-group\"><input placeholder=\"{{ \'wamasysApp.contrat.since\' | translate }}\" id=\"field_toDateWaterConsumption\" type=\"text\" class=\"form-control\" name=\"toDateWaterConsumption\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.toDateWaterConsumption\" is-open=\"vm.datePickerOpenStatus.toDateWaterConsumption\" ng-click=\"vm.openCalendar(\'toDateWaterConsumption\')\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDateWaterConsumption\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></section></div></div><hr><div class=\"row\" style=\"margin-top:20px\"><div class=\"col-md-3\"><label class=\"label col-md-8\" translate=\"wamasysApp.contrat.etat\" for=\"field_etat\">Etat</label><section class=\"col-md-4\"><label class=\"\"><select class=\"form-control\" name=\"etat\" ng-model=\"vm.etat\" id=\"field_etat\"><option value=\"ACTIVE\" translate=\"wamasysApp.EtatContrat.ACTIVE\">ACTIVE</option><option value=\"CLOSED\" translate=\"wamasysApp.EtatContrat.CLOSED\">CLOSED</option></select></label></section></div><div class=\"col-md-3\"><label class=\"label col-md-8\" translate=\"wamasysApp.contrat.compteurFerme\">compteurFerme</label><section class=\"col-md-4\"><label class=\"\"><select class=\"form-control\" id=\"compteurFerme\" ng-model=\"vm.compteurFerme\"><option value=\"\"></option><option value=\"true\" translate=\"entity.value.true\">true</option><option value=\"false\" translate=\"entity.value.false\">false</option></select></label></section></div><div class=\"col-md-6\"><label class=\"control-label col-md-4\" translate=\"wamasysApp.contrat.serviceVendu\">serviceVendu</label><section class=\"col-md-8\"><!-- 								<label class=\"\"> --><ui-select tagging multiple=\"multiple\" ng-model=\"vm.serviceVenduNotPromise\" theme=\"selectize\" title=\"{{\'wamasysApp.contrat.serviceVendu\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.contrat.serviceVendu\' | translate}}\">{{$item.libelle}}</ui-select-match><ui-select-choices repeat=\"serviceVendu in vm.serviceVendus | filter: $select.search  track by serviceVendu.id\">{{(serviceVendu.deleted==true)?\"&#x274c; \":\"\"}} {{serviceVendu.libelle}}</ui-select-choices></ui-select></section></div></div><div class=\"row\"><div class=\"col-md-4\"><label class=\"label col-md-4\" translate=\"wamasysApp.contrat.contractType\">ContractType</label><section class=\"col-md-8\"><ui-select tagging multiple=\"multiple\" ng-model=\"vm.contractTypeNotPromise\" theme=\"selectize\" title=\"{{\'wamasysApp.contrat.contractType\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.contrat.contractType\' | translate}}\">{{$item.label}}</ui-select-match><ui-select-choices repeat=\"contractType in vm.contractTypes | filter: $select.search  track by contractType.id\">{{(contractType.deleted==true)?\"&#x274c; \":\"\"}} {{contractType.label}}</ui-select-choices></ui-select><!-- 		\n								<label class=\"\"> <select class=\"form-control\"\n									id=\"field_contractType\" name=\"contractType\"\n									ng-model=\"vm.contractType\"\n									ng-options=\"contractType as contractType.label for contractType in vm.contractTypes track by contractType.id\">\n										<option value=\"\"></option>\n								</select>\n								</label> --></section></div><div class=\"col-md-4\"><label class=\"label col-md-4\" translate=\"wamasysApp.contrat.contractProfil\">ContractProfil</label><section class=\"col-md-8\"><ui-select tagging multiple=\"multiple\" ng-model=\"vm.contractProfilNotPromise\" theme=\"selectize\" title=\"{{\'wamasysApp.contrat.contractProfil\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.contrat.contractProfil\' | translate}}\">{{$item.libelle}}</ui-select-match><ui-select-choices repeat=\"contractProfil in vm.contractProfils | filter: $select.search  track by contractProfil.id\">{{(contractProfil.deleted==true)?\"&#x274c; \":\"\"}} {{contractProfil.libelle}}</ui-select-choices></ui-select><!-- 			<label class=\"\"> <select class=\"form-control\"\n									id=\"field_contractProfil\" name=\"contractProfil\"\n									ng-model=\"vm.contractProfil\"\n									ng-options=\"contractProfil as contractProfil.libelle for contractProfil in vm.contractProfils track by contractProfil.id\">\n										<option value=\"\"></option>\n								</select>\n								</label> --></section></div><div class=\"col-md-4\"><label class=\"label col-md-4\" translate=\"wamasysApp.contrat.portefeuilleContrat\">Portefeuille client</label><section class=\"col-md-8\"><ui-select tagging multiple=\"multiple\" ng-model=\"vm.portefeuilleContratNotPromise\" theme=\"selectize\" title=\"{{\'wamasysApp.contrat.portefeuilleContrat\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.contrat.portefeuilleContrat\' | translate}}\">{{$item.libelle}}</ui-select-match><ui-select-choices repeat=\"portefeuilleContrat in vm.portefeuilleContrats | filter: $select.search  track by portefeuilleContrat.id\">{{portefeuilleContrat.libelle}}</ui-select-choices></ui-select><!-- \n								<label class=\"\"> <select class=\"form-control\"\n									id=\"field_portefeuilleContrat\" name=\"portefeuilleContrat\"\n									ng-model=\"vm.portefeuilleContrat\"\n									ng-options=\"portefeuilleContrat as portefeuilleContrat.libelle for portefeuilleContrat in vm.portefeuillecontrats track by portefeuilleContrat.id\">\n										<option value=\"\"></option>\n								</select>\n								</label> --></section></div></div><div class=\"row\" has-module=\"ONLINE_PAYMENT\"><div class=\"col-md-2\"><label class=\"label col-md-8\" translate=\"wamasysApp.contrat.onlinePayment.searchTitle\">onlinePayment.titre</label></div><div class=\"col-md-2\"><label class=\"label col-md-8\" translate=\"wamasysApp.contrat.onlinePayment.active\">onlinePayment.active</label><section class=\"col-md-4\"><label class=\"\"><select class=\"form-control\" id=\"onlinePaymentActive\" ng-model=\"vm.onlinePaymentActive\"><option value=\"\"></option><option value=\"true\" translate=\"entity.value.true\">true</option><option value=\"false\" translate=\"entity.value.false\">false</option></select></label></section></div><div class=\"col-md-3\"><label class=\"label col-md-4\" translate=\"wamasysApp.contrat.onlinePayment.type\">Type</label><section class=\"col-md-8\"><label class=\"\"><select class=\"form-control\" id=\"field_onlinePaymentType\" name=\"onlinePaymentType\" ng-model=\"vm.onlinePaymentType\"><option value=\"\"></option><option value=\"MTN_USSD_V1\">MTN USSD</option><option value=\"MPESA_PAYBILL_V1\">M-Pesa Paybill</option></select></label></section></div><div class=\"col-md-5\"><label class=\"label col-md-4\" translate=\"wamasysApp.contrat.onlinePayment.idExterne\">id</label><section class=\"col-md-8\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.onlinePaymentQuery\" id=\"onlinePaymentQuery\" placeholder=\"{{ \'wamasysApp.contrat.onlinePayment.idPlaceholder\' | translate }}\"></section></div></div><div class=\"row\"><div class=\"col-md-4\"><label class=\"label col-md-3\" translate=\"wamasysApp.contrat.nomRefEmail\">Nom, référence contrat ou email</label><section class=\"col-md-9\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'wamasysApp.contrat.nomRefEmail\' | translate }}\"></section></div><div class=\"col-md-3\"><label class=\"control-label col-md-4\" for=\"daterange1\" translate=\"wamasysApp.contrat.dateActivation\">Date d\'activation</label><div class=\"col-md-8\"><div class=\"input-group\"><input date-range-picker id=\"daterange1\" name=\"daterange1\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" options=\"vm.opts\" placeholder=\"yyyy-mm-dd - yyyy-mm-dd\"></div></div></div><div class=\"col-md-3\"><!--            <label for=\"field_forAllAreas\" class=\"label \" >\n				                <input type=\"checkbox\" id=\"field_forAllAreas\" class=\"form-control\"  ng-model=\"vm.forAllAreas\"  name=\"forAllAreas\" \n				                ></input>  \n				                  <span translate=\"wamasysApp.contrat.forAllAreas\">forAllAreas</span>\n				                \n				            </label>\n             --><label class=\"label col-md-4\" translate=\"wamasysApp.contrat.agence\">Agence</label><section class=\"col-md-8\"><ui-select tagging multiple=\"multiple\" ng-model=\"vm.agenceIdNotPromise\" theme=\"selectize\" title=\"{{\'wamasysApp.contrat.agence\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.contrat.agence\' | translate}}\">{{$item.nom}}</ui-select-match><ui-select-choices repeat=\"agence in vm.agencesRattachement | filter: $select.search  track by agence.id\">{{agence.nom}}</ui-select-choices></ui-select></section></div><div class=\"col-md-2\"><div class=\"pull-right\"><button class=\"btn-xs btn-primary pull-right\" style=\"margin-left:10px\" ng-click=\"vm.search()\" translate=\"entity.action.chercher\">search</button>&nbsp;&nbsp;&nbsp; <button class=\"btn-xs btn-primary pull-right\" ng-click=\"vm.clear()\" ng-if=\"vm.currentSearch\" translate=\"entity.action.reset\">reset</button></div></div></div></fieldset></form></div></div><!-- 				</div> --><!-- 			</div> --></div></article></div></div><div class=\"container-fluid\"></div><div class=\"table-responsive padding-top-10\"><button class=\"pull-right btn-xs btn-primary\" ng-click=\"vm.download()\" target=\"_blank\" translate=\"entity.action.download\">download CSV</button><!-- <div class=\"btn-group btn-xs pull-right\">\n				<button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" > {{\'entity.action.download\' | translate}} <span class=\"caret\"></span>\n				</button>\n				<ul class=\"dropdown-menu pull-right\">\n			\n					<li >\n						<a ng-click=\"vm.download()\"  target=\"_blank\"  translate=\"wamasysApp.contrat.downloadContract\" >Download receipts</a>\n					</li>\n					<li >\n						<a ng-click=\"vm.downloadService()\"  target=\"_blank\"  translate=\"wamasysApp.contrat.downloadServiceDetailCSV\" >Download receipts</a>\n					</li>\n					<li >\n						<a ng-click=\"vm.downloadDetailServiceNotClosedcsv()\"  target=\"_blank\"  translate=\"wamasysApp.contrat.downloadDetailServiceNotClosedcsv\" >Download payments</a>\n					</li>\n				</ul>\n			</div>      \n --><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"nomPersonne\"><span translate=\"wamasysApp.contrat.nomPersonne\">NomPersonne</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"referenceContrat\"><span translate=\"wamasysApp.contrat.referenceContrat\">ReferenceContrat</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--                     <th jh-sort-by=\"indexAdresse\"><span translate=\"wamasysApp.contrat.indexAdresse\">IndexAdresse</span> <span class=\"glyphicon glyphicon-sort\"></span></th> --><!--                     <th jh-sort-by=\"adresse\"><span translate=\"wamasysApp.contrat.adresse\">Adresse</span> <span class=\"glyphicon glyphicon-sort\"></span></th> --><th jh-sort-by=\"etat\"><span translate=\"wamasysApp.contrat.etat\">Etat</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dateActivation\"><span translate=\"wamasysApp.contrat.dateActivation\">Date Activation</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"compteurFerme\"><span translate=\"wamasysApp.contrat.compteurFerme\">compteurFerme</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"portefeuilleContrat.id\"><span translate=\"wamasysApp.contrat.portefeuilleContrat\">portefeuilleContrat</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"balance\"><span translate=\"wamasysApp.contrat.balance\">balance</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--jh-sort-by=\"lastPaymentDate\"--><!-- <th ><span translate=\"wamasysApp.contrat.lastPaymentDate\">lastPaymentDate</span> <span class=\"glyphicon glyphicon-sort\"></span></th> --><th></th></tr></thead><tbody><tr ng-if=\"vm.wait === true\"><td colspan=\"8\" class=\"text-center\"><img class=\"responsive-img\" src=\"/content/spinner.gif\"></td></tr><tr ng-repeat=\"contrat in vm.contrats track by contrat.id\"><td><a ui-sref=\"contrat-detail.information({id:contrat.id})\">{{contrat.nomPersonne}}</a></td><td>{{contrat.referenceContrat}}</td><!--                     <td>{{contrat.indexAdresse}}</td> --><!--                     <td>{{contrat.adresse}}</td> --><td translate=\"{{\'wamasysApp.EtatContrat.\' + contrat.etat}}\">{{contrat.etat}}</td><td>{{contrat.dateActivation | date:\'mediumDate\'}}</td><td ng-show=\"contrat.compteurFerme != null\" translate=\"{{\'entity.value.\' + contrat.compteurFerme}}\">{{contrat.compteurFerme}}</td><td ng-show=\"contrat.compteurFerme == null\" translate=\"entity.value.false\">false</td><td><a ng-if=\"contrat.portefeuilleContrat\" ui-sref=\"portefeuille-contrat-detail({id:contrat.portefeuilleContrat.id})\">{{contrat.portefeuilleContrat.libelle}}</a> <a ng-if=\"contrat.portefeuilleContratId\" ui-sref=\"portefeuille-contrat-detail({id:contrat.portefeuilleContratId})\">{{contrat.portefeuilleContratLabel}}</a></td><td>{{contrat.balance}}</td><!--	<td>{{contrat.lastPaymentDate | date:\'mediumDate\'}}   </td>--><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"contrat-detail.information({id:contrat.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"contrat.delete({id:contrat.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/reporting-taxe/reporting-taxe.html","<div class=\"container-fluid\"><h2 translate=\"wamasysApp.reportingGlobal.titreReportingTaxe\">Reporting Taxe</h2><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label class=\"control-label col-md-2\" for=\"daterange1\" translate=\"wamasysApp.reportingGlobal.periodeRecherche\">Période recherchée</label><div class=\"col-md-10\"><div class=\"input-group\"><input date-range-picker id=\"daterange1\" name=\"daterange1\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" options=\"vm.opts\"><div class=\"input-group-btn\"><button ng-click=\"openRangeDateTimePicker()\" class=\"btn btn-default\" type=\"button\"><span class=\"glyphicon glyphicon-calendar\"></span></button></div></div></div></div></div><div class=\"col-md-4 pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.search()\" translate=\"wamasysApp.reportingGlobal.chercher\">search</button><!--                  <button class=\" pull-right btn-xs btn-primary\" ng-click=\"vm.download()\"  target=\"_blank\">Download Excel</button> --></div></div><br><table class=\"table table-striped table-bordered table-hover\" width=\"100%\" ng-show=\"vm.reporting\"><thead><tr><th translate=\"wamasysApp.reportingGlobal.serviceLibelle\">serviceLibelle</th><th translate=\"wamasysApp.reportingGlobal.codeArticle\">codeArticle</th><th translate=\"wamasysApp.reportingGlobal.globalServiceLibelle\">globalServiceLibelle</th><th translate=\"wamasysApp.reportingGlobal.libelleTaxe\">libelleTaxe</th><th translate=\"wamasysApp.reportingGlobal.tauxTaxe\">tauxTaxe</th><th translate=\"wamasysApp.reportingGlobal.totalFacture\">totalFacture</th><th translate=\"wamasysApp.reportingGlobal.totalTaxFacture\">totalTaxFacture</th><th translate=\"wamasysApp.reportingGlobal.totalEncaisse\">totalEncaisse</th><th translate=\"wamasysApp.reportingGlobal.totalTaxEncaisse\">totalTaxEncaisse</th><th translate=\"wamasysApp.reportingGlobal.totalWindFallGainTtc\">totalWindFallGainTtc</th><th translate=\"wamasysApp.reportingGlobal.totalWindFallGainTax\">totalWindFallGainTax</th></tr></thead><tbody><tr ng-repeat=\"ligneService in vm.reporting\"><td>{{ligneService.service.libelle}}</td><td>{{ligneService.service.codeArticle}}</td><td>{{ligneService.service.typeService.libelle}}</td><td>{{ligneService.typeTax.label}}</td><td>{{ligneService.typeTax.taxRate}} <span ng-if=\"ligneService.typeTax.taxRate\">%</span></td><td>{{ligneService.totalFacture| currency:\"\":2}}</td><td>{{ligneService.totalTaxFacture| currency:\"\":2}}</td><td>{{ligneService.totalEncaisseTtc| currency:\"\":2}}</td><td>{{ligneService.totalEncaisseTtc - ligneService.totalEncaisseHt| currency:\"\":2}}</td><td>{{ligneService.totalWindFallGainTtc| currency:\"\":2}}</td><td>{{ligneService.totalWindFallGainTax| currency:\"\":2}}</td></tr><tr><td colspan=\"5\"><strong>Total</strong></td><td><strong>{{getTotalFacture()| currency:\"\":2}}</strong></td><td><strong>{{getTotalTaxFacture()| currency:\"\":2}}</strong></td><td><strong>{{getTotalEncaisseTtc()| currency:\"\":2}}</strong></td><td><strong>{{getTotalTaxEncaisse()| currency:\"\":2}}</strong></td><td><strong>{{getTotalWindFallGainTtc()| currency:\"\":2}}</strong></td><td><strong>{{getTotalWindFallGainTax()| currency:\"\":2}}</strong></td></tr></tbody></table><div translate=\"wamasysApp.reportingGlobal.texteExplicationReportingTax\"></div></div>");
$templateCache.put("app/business/model-meter/model-meter-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.modelMeter.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.modelMeter.delete.question\" translate-values=\"{id: \'{{vm.modelMeter.id}}\'}\">Are you sure you want to delete this ModelMeter?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/model-meter/model-meter-detail.html","<div><h2><span translate=\"wamasysApp.modelMeter.detail.title\">ModelMeter</span> {{vm.modelMeter.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.modelMeter.label\">label</span></dt><dd><span>{{vm.modelMeter.label}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/model-meter/model-meter-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myModelMeterLabel\" translate=\"wamasysApp.modelMeter.home.createOrEditLabel\">Create or edit a ModelMeter</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.modelMeter.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.modelMeter.label\" for=\"field_label\">Libelle</label><input type=\"text\" class=\"form-control\" name=\"label\" id=\"field_label\" ng-model=\"vm.modelMeter.label\" required ng-maxlength=\"50\"><div ng-show=\"editForm.label.$invalid\"><p class=\"help-block\" ng-show=\"editForm.label.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.label.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/model-meter/model-meters.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.modelMeter.home.title\">ModelMeters</span> <small class=\"text-muted\" translate=\"global.configurationScope.organization\">Paramétrage commun à toute l\'organisation</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"model-meter.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.modelMeter.home.createLabel\">Create new ModelMeter</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"label\"><span translate=\"wamasysApp.modelMeter.label\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"modelMeter in vm.modelMeters track by modelMeter.id\"><td><a ui-sref=\"model-meter-detail({id:modelMeter.id})\">{{modelMeter.id}}</a></td><td>{{modelMeter.label}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"model-meter-detail({id:modelMeter.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"model-meter.edit({id:modelMeter.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"model-meter.delete({id:modelMeter.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/reporting-casnonreleve/reporting-casnonreleve.html","<div class=\"app-entity-shell\"><div class=\"app-entity-header\"><h2 class=\"app-entity-title\">Reporting cas non relev&eacute;s</h2><div class=\"app-entity-actions\"><button class=\"btn btn-default\" ng-click=\"vm.download()\" type=\"button\" translate=\"entity.action.download\">download CSV</button></div></div><jhi-alert></jhi-alert><div class=\"app-filter-panel\"><form name=\"searchForm\" class=\"smart-form\" novalidate><div class=\"app-filter-grid\"><div class=\"app-filter-field app-filter-field--wide\"><label class=\"app-filter-label\" translate=\"wamasysApp.casNonReleve.libelle\">casNonReleveId</label><ui-select multiple=\"multiple\" ng-model=\"vm.casNonReleveNotPromise\" theme=\"bootstrap\" title=\"{{\'wamasysApp.casNonReleve.home.title\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.casNonReleve.home.title\' | translate}}\">{{$item.libelle}}</ui-select-match><ui-select-choices repeat=\"casNonReleve in vm.casNonReleves | filter: $select.search track by casNonReleve.id\">{{(casNonReleve.deleted==true)?\"&#x274c; \":\"\"}}{{casNonReleve.libelle}}</ui-select-choices></ui-select></div><div class=\"app-filter-field app-filter-field--wide\"><label class=\"app-filter-label\" translate=\"wamasysApp.casNonReleve.cluster\">cluster</label><ui-select multiple=\"multiple\" ng-model=\"vm.clusterNotPromise\" theme=\"bootstrap\" title=\"{{\'wamasysApp.casNonReleve.cluster\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.casNonReleve.cluster\' | translate}}\">{{$item.numeroSerie}}</ui-select-match><ui-select-choices repeat=\"cluster in vm.clusters | filter: $select.search track by cluster.id\">{{cluster.numeroSerie}}</ui-select-choices></ui-select></div><div class=\"app-filter-field app-filter-field--wide\"><label class=\"app-filter-label\" translate=\"wamasysApp.casNonReleve.collector\">collecteur</label><ui-select multiple=\"multiple\" ng-model=\"vm.collecteurNotPromise\" theme=\"bootstrap\" title=\"{{\'wamasysApp.casNonReleve.collector\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.casNonReleve.collector\' | translate}}\">{{$item.login}}</ui-select-match><ui-select-choices repeat=\"collecteur in vm.collecteurs | filter: $select.search track by collecteur.id\">{{collecteur.login}}</ui-select-choices></ui-select></div><div class=\"app-filter-field app-filter-field--wide\"><label class=\"app-filter-label\" translate=\"wamasysApp.casNonReleve.nomRef\">Nom, r&eacute;f&eacute;rence contrat ou email</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'wamasysApp.casNonReleve.nomRef\' | translate }}\"></div><div class=\"app-filter-field\"><label class=\"app-filter-label\" for=\"daterange1\" translate=\"wamasysApp.casNonReleve.period\">Date</label><input date-range-picker id=\"daterange1\" name=\"daterange1\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" options=\"vm.opts\" placeholder=\"yyyy-mm-dd - yyyy-mm-dd\"></div><div class=\"app-filter-field app-filter-field--wide\"><label class=\"app-filter-label\" translate=\"wamasysApp.casNonReleve.agence\">Agence</label><ui-select multiple=\"multiple\" ng-model=\"vm.agenceIdNotPromise\" theme=\"bootstrap\" title=\"{{\'wamasysApp.casNonReleve.agence\' | translate}}\"><ui-select-match placeholder=\"{{\'wamasysApp.casNonReleve.agence\' | translate}}\">{{$item.nom}}</ui-select-match><ui-select-choices repeat=\"agence in vm.agencesRattachement | filter: $select.search track by agence.id\">{{agence.nom}}</ui-select-choices></ui-select></div></div><div class=\"app-filter-actions\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.clear()\" translate=\"entity.action.reset\">reset</button> <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"vm.search()\" translate=\"entity.action.chercher\">search</button></div></form></div><div class=\"table-responsive padding-top-10\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"individualMeter.numeroSerie\"><span translate=\"wamasysApp.casNonReleve.nomRef\">numeroSerie</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"individualMeter.cluster.numeroSerie\"><span translate=\"wamasysApp.casNonReleve.cluster\">cluster</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"casNonReleve.libelle\"><span translate=\"wamasysApp.casNonReleve.home.title\">casNonReleve.libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"commentaire\"><span translate=\"wamasysApp.casNonReleve.commentaire\">commentaire</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"datePrecedentReleveCompteur\"><span translate=\"wamasysApp.casNonReleve.datePrecedentReleveCompteur\">datePrecedentReleveCompteur</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"valeurPrecedentReleve\"><span translate=\"wamasysApp.casNonReleve.valeurPrecedentReleve\">valeurPrecedentReleve</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"readingDate\"><span translate=\"wamasysApp.casNonReleve.readingDate\">readingDate</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"valeurReleve\"><span translate=\"wamasysApp.casNonReleve.valeurReleve\">valeurReleve</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-if=\"vm.wait === true\"><td colspan=\"8\" class=\"text-center\"><img class=\"responsive-img\" src=\"/content/spinner.gif\"></td></tr><tr ng-repeat=\"contrat in vm.contrats track by contrat.id\"><td><a ui-sref=\"individual-meter-detail({id:contrat.individualMeter.id})\">{{contrat.individualMeter.numeroSerie}}</a> <a ui-sref=\"bulk-meter-detail({id:contrat.bulkMeter.id})\">{{contrat.bulkMeter.numeroSerie}}</a></td><td>{{contrat.individualMeter.cluster.numeroSerie}}</td><td>{{contrat.casNonReleve.libelle}}</td><td>{{contrat.commentaire}}</td><td>{{contrat.datePrecedentReleveCompteur | date:\'mediumDate\'}}</td><td>{{contrat.valeurPrecedentReleve}}</td><td>{{contrat.readingDate | date:\'mediumDate\'}}</td><td>{{contrat.valeurReleve}}</td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/service-autre/service-autre-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.serviceVendu.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.serviceVendu.delete.question\" translate-values=\"{id: \'{{vm.serviceVendu.id}}\'}\">Are you sure you want to delete this ServiceVendu?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/service-autre/service-autre-detail.html","<div><h2><span translate=\"wamasysApp.serviceVendu.detail.title\">ServiceVendu</span> {{vm.serviceVendu.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.serviceVendu.libelle\">Libelle</span></dt><dd><span>{{vm.serviceVendu.libelle}}</span></dd><hr><dt><span translate=\"wamasysApp.serviceVendu.clientLabel\">clientLabel</span></dt><dd><span>{{vm.serviceVendu.clientLabel}}</span></dd><hr><dt><span translate=\"wamasysApp.serviceVendu.codeArticle\">codeArticle</span></dt><dd><span>{{vm.serviceVendu.codeArticle}}</span></dd><hr><dt><span translate=\"wamasysApp.serviceVendu.typeService\">typeService</span></dt><dd><a ui-sref=\"type-service-detail({id:vm.serviceVendu.typeService.id})\">{{vm.serviceVendu.typeService.libelle}}</a></dd><hr><dt><span translate=\"wamasysApp.serviceVendu.typePaiement\">TypePaiement</span></dt><dd><span translate=\"{{\'wamasysApp.TypePaiementService.\' + vm.serviceVendu.typePaiement}}\">{{vm.serviceVendu.typePaiement}}</span></dd><hr><dt><span translate=\"wamasysApp.serviceVendu.typeTax\">typeTax</span></dt><dd><span>{{vm.serviceVendu.typeTax.label}} ( {{vm.serviceVendu.typeTax.taxRate}}%)</span></dd><hr><dt ng-if-start=\"vm.serviceVendu.typePaiement == \'A_PAYER_EN_UNE_FOIS\'\"><span translate=\"wamasysApp.serviceVendu.unitPrice\">MontantAPayerAcompte</span></dt><dd><span>{{vm.serviceVendu.unitPrice}}</span></dd><hr ng-if-end><!-- 		        <dt ng-if-start=\"vm.serviceVendu.typePaiement == \'A_PAYER_PAR_JOUR\'\"><span translate=\"wamasysApp.serviceVendu.unitPrice\">MontantAPayerParJour</dt></dt>\n		        <dd >\n		            <span>{{vm.serviceVendu.unitPrice}}</span> \n		        </dd>\n		        <hr  ng-if-end>\n --><dt ng-if-start=\"vm.serviceVendu.typePaiement == \'A_PAYER_PAR_JOUR\'\"><span translate=\"wamasysApp.serviceVendu.amountPerInstallment\">MontantAPayerParCollecte</span></dt><dd><span>{{vm.serviceVendu.amountPerInstallment}}</span></dd><hr><dt><span translate=\"wamasysApp.serviceVendu.frequency\">frequency</span></dt><dd><span>{{vm.serviceVendu.frequency}}</span></dd><hr><dt><span translate=\"wamasysApp.serviceVendu.intervalTypeLabel\">intervalTypeLabel</span></dt><dd><span translate=\"{{\'wamasysApp.serviceVendu.intervalType.\' + vm.serviceVendu.intervalType}}\">{{vm.serviceVendu.intervalType}}</span></dd><hr ng-if-end><dt ng-if-start=\"vm.serviceVendu.typePaiement == \'A_PAYER_SUR_CONSO_EAU\'\"><span translate=\"wamasysApp.serviceVendu.unitPrice\">MontantAPayerConsoEau</span></dt><dd><span>{{vm.serviceVendu.unitPrice}}</span></dd><hr ng-if-end><dt ng-if-start=\"vm.serviceVendu.typePaiement == \'A_PAYER_AVEC_ECHELONNEMENT\'\"><span translate=\"wamasysApp.serviceVendu.amountPerInstallment\">MontantAPayerParCollecte</span></dt><dd><span>{{vm.serviceVendu.amountPerInstallment}}</span></dd><hr><dt><span translate=\"wamasysApp.serviceVendu.totalCredit\">MontantTotalAPayerParCollecte</span></dt><dd><span>{{vm.serviceVendu.totalCredit}}</span></dd><hr><dt><span translate=\"wamasysApp.serviceVendu.frequency\">frequency</span></dt><dd><span>{{vm.serviceVendu.frequency}}</span></dd><hr><dt><span translate=\"wamasysApp.serviceVendu.intervalTypeLabel\">intervalTypeLabel</span></dt><dd><span translate=\"{{\'wamasysApp.serviceVendu.intervalType.\' + vm.serviceVendu.intervalType}}\">{{vm.serviceVendu.intervalType}}</span></dd><hr ng-if-end><dt><span translate=\"global.field.isDeleted\">isDeleted</span></dt><dd><span>{{vm.serviceVendu.deleted}}<span></span></span></dd><hr><dt><span translate=\"global.field.code\">Code</span></dt><dd><span>{{vm.serviceVendu.code}}</span></dd><hr></dl><!-- widget div--><div class=\"row\"><div class=\"col-sm-12\"><div jarvis-widget><header><span class=\"widget-icon\"><i class=\"fa fa-table\"></i></span><h2 translate=\"wamasysApp.serviceVendu.historique\">Historique</h2></header><div><div class=\"widget-body no-padding table-responsive\"><table class=\"table table-striped table-bordered table-hover\" width=\"100%\"><thead><tr><th translate=\"wamasysApp.serviceVendu.dateMiseAjour\">Date de modification</th><th translate=\"wamasysApp.serviceVendu.modifiedBy\">Modifié par</th><th width=\"45%\" translate=\"wamasysApp.serviceVendu.changes\">Modifications</th><th translate=\"wamasysApp.serviceVendu.commentaire\">Commentaire</th></tr></thead><tbody><tr ng-repeat=\"historyRow in vm.historyRows track by historyRow.id\"><td>{{historyRow.dateCreation | date:\'medium\'}}</td><td>{{historyRow.createdBy || \'—\'}}</td><td><div ng-repeat=\"change in historyRow.changes\" ng-class=\"{\'m-b-10\': !$last}\"><strong translate=\"{{change.labelKey}}\">Champ modifié</strong><div class=\"row\"><div class=\"col-sm-6\"><small class=\"text-muted\" translate=\"wamasysApp.serviceVendu.oldValue\">Ancienne valeur</small><br><span>{{change.oldValue !== null ? change.oldValue : \'—\'}}</span></div><div class=\"col-sm-6\"><small class=\"text-muted\" translate=\"wamasysApp.serviceVendu.newValue\">Nouvelle valeur</small><br><strong>{{change.newValue !== null ? change.newValue : \'—\'}}</strong></div></div></div><span class=\"text-muted\" ng-if=\"!historyRow.changes.length\" translate=\"wamasysApp.serviceVendu.noCostChange\">Aucun paramètre de coût modifié</span></td><td>{{historyRow.commentaire}}</td></tr><tr ng-if=\"!vm.historyRows.length\"><td colspan=\"4\" class=\"text-center text-muted\" translate=\"wamasysApp.serviceVendu.noHistory\">Aucun historique</td></tr></tbody></table></div></div></div></div></div><!-- end widget --> <button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/service-autre/service-autre-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myServiceVenduLabel\" translate=\"wamasysApp.serviceVendu.home.createOrEditLabel\">Create or edit a ServiceVendu</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!--         <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"global.field.code\" for=\"field_code\">Code</label>\n            <input  ng-readonly=\"vm.serviceVendu.id != null\" required type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\"\n                    ng-model=\"vm.serviceVendu.code\"   ng-maxlength=\"64\"  ng-pattern=\"/^[_.A-Z0-9-]*$/\" />\n            <div ng-show=\"editForm.libelle.$invalid\">\n                <p class=\"help-block\"\n                    ng-show=\"editForm.code.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n                 <p class=\"help-block\"      ng-show=\"editForm.code.$error.pattern\" translate=\"wamasysApp.serviceVendu.codeArticleFormatError\">\n                     The article code can only contain upper-case letters and digits.\n           	  </p>\n                <p class=\"help-block\"\n                    ng-show=\"editForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"64\">\n                    This field cannot be longer than 64 characters.\n                </p>\n            </div>\n        </div> --><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.serviceVendu.libelle\" for=\"field_libelle\">Libelle</label><input required type=\"text\" class=\"form-control\" name=\"libelle\" id=\"field_libelle\" ng-model=\"vm.serviceVendu.libelle\" ng-maxlength=\"50\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.libelle.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.libelle.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.serviceVendu.clientLabel\" for=\"field_clientLabel\">clientLabel</label><input required type=\"text\" class=\"form-control\" name=\"clientLabel\" id=\"field_clientLabel\" ng-model=\"vm.serviceVendu.clientLabel\" ng-maxlength=\"30\"><div ng-show=\"editForm.clientLabel.$invalid\"><p class=\"help-block\" ng-show=\"editForm.clientLabel.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.clientLabel.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"30\">This field cannot be longer than 30 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.serviceVendu.codeArticle\" for=\"field_codeArticle\">codeArticle</label><input required type=\"text\" class=\"form-control\" name=\"codeArticle\" id=\"field_codeArticle\" ng-model=\"vm.serviceVendu.codeArticle\" ng-maxlength=\"50\" ng-pattern=\"/^[_.A-Z0-9-]*$/\"><div ng-show=\"editForm.codeArticle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.codeArticle.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.codeArticle.$error.pattern\" translate=\"wamasysApp.serviceVendu.codeArticleFormatError\">The article code can only contain upper-case letters and digits.</p><p class=\"help-block\" ng-show=\"editForm.codeArticle.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.serviceVendu.typeService\" for=\"field_typeService\">typeService</label><select class=\"form-control\" id=\"field_typeService\" name=\"typeService\" ng-model=\"vm.serviceVendu.typeService\" ng-options=\"typeService as typeService.libelle for typeService in vm.typeservices track by typeService.id\"><option value=\"\"></option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.serviceVendu.typePaiement\" for=\"field_typePaiement\">TypePaiement</label><select class=\"form-control\" name=\"typePaiement\" ng-model=\"vm.serviceVendu.typePaiement\" id=\"field_typePaiement\" required><option value=\"A_PAYER_PAR_JOUR\" translate=\"wamasysApp.TypePaiementService.A_PAYER_PAR_JOUR\">A_PAYER_PAR_JOUR</option><option value=\"A_PAYER_EN_UNE_FOIS\" translate=\"wamasysApp.TypePaiementService.A_PAYER_EN_UNE_FOIS\">A_PAYER_EN_UNE_FOIS</option><option value=\"A_PAYER_AVEC_ECHELONNEMENT\" translate=\"wamasysApp.TypePaiementService.A_PAYER_AVEC_ECHELONNEMENT\">A_PAYER_AVEC_ECHELONNEMENT</option><option value=\"A_PAYER_SUR_CONSO_EAU\" translate=\"wamasysApp.TypePaiementService.A_PAYER_SUR_CONSO_EAU\">A_PAYER_SUR_CONSO_EAU</option></select><div ng-show=\"editForm.typePaiement.$invalid\"><p class=\"help-block\" ng-show=\"editForm.typePaiement.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"alert alert-warning\" ng-if=\"vm.serviceVendu.id\"><span translate=\"wamasysApp.serviceVendu.messageImpactChangePrice\"></span></div><div class=\"alert alert-warning\"><span translate=\"wamasysApp.serviceVendu.messageTaxe\"></span></div><div class=\"form-group\" ng-if=\"vm.serviceVendu.typePaiement == \'A_PAYER_EN_UNE_FOIS\'\"><label class=\"control-label\" translate=\"wamasysApp.serviceVendu.unitPrice\" for=\"field_unitPrice\">MontantAPayerAcompte</label><input type=\"number\" class=\"form-control\" name=\"unitPrice\" id=\"field_unitPrice\" ng-model=\"vm.serviceVendu.unitPrice\" required min=\"0\" max=\"999999\"><div ng-show=\"editForm.unitPrice.$invalid\"><p class=\"help-block\" ng-show=\"editForm.unitPrice.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.unitPrice.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.unitPrice.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\">This field cannot be more than 999999.</p><p class=\"help-block\" ng-show=\"editForm.unitPrice.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><!--         <div class=\"form-group\" ng-if=\"vm.serviceVendu.typePaiement == \'A_PAYER_PAR_JOUR\'\" > --><!--             <label class=\"control-label\" translate=\"wamasysApp.serviceVendu.unitPrice\" for=\"field_unitPrice\">MontantAPayerParJour</label> --><!--             <input type=\"number\" class=\"form-control\" name=\"unitPrice\" id=\"field_unitPrice\" --><!--                     ng-model=\"vm.serviceVendu.unitPrice\" --><!--                      min=\"0\" max=\"999999\" /> --><!--             <div ng-show=\"editForm.unitPrice.$invalid\"> --><!--                 <p class=\"help-block\" --><!--                     ng-show=\"editForm.unitPrice.$error.required\" translate=\"entity.validation.required\"> --><!--                     This field is required. --><!--                 </p> --><!--                 <p class=\"help-block\" --><!--                     ng-show=\"editForm.unitPrice.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\"> --><!--                     This field should be more than 0. --><!--                 </p> --><!--                 <p class=\"help-block\" --><!--                     ng-show=\"editForm.unitPrice.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\"> --><!--                     This field cannot be more than 999999. --><!--                 </p> --><!--                 <p class=\"help-block\" --><!--                     ng-show=\"editForm.unitPrice.$error.number\" translate=\"entity.validation.number\"> --><!--                     This field should be a number. --><!--                 </p> --><!--             </div> --><!--         </div> --><div class=\"form-group\" ng-if=\"vm.serviceVendu.typePaiement == \'A_PAYER_SUR_CONSO_EAU\'\"><label class=\"control-label\" translate=\"wamasysApp.serviceVendu.unitPrice\" for=\"field_unitPrice\">MontantAPayerConsoEau</label><input type=\"number\" class=\"form-control\" name=\"unitPrice\" id=\"field_unitPrice\" ng-model=\"vm.serviceVendu.unitPrice\" min=\"0\" max=\"999999\"><div ng-show=\"editForm.unitPrice.$invalid\"><p class=\"help-block\" ng-show=\"editForm.unitPrice.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.unitPrice.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.unitPrice.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\">This field cannot be more than 999999.</p><p class=\"help-block\" ng-show=\"editForm.unitPrice.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\" ng-if=\"vm.serviceVendu.typePaiement == \'A_PAYER_AVEC_ECHELONNEMENT\' || vm.serviceVendu.typePaiement == \'A_PAYER_PAR_JOUR\'\"><label class=\"control-label\" translate=\"wamasysApp.serviceVendu.amountPerInstallment\" for=\"field_amountPerInstallment\">MontantAPayerParCollecte</label><input type=\"number\" class=\"form-control\" name=\"amountPerInstallment\" id=\"field_amountPerInstallment\" ng-model=\"vm.serviceVendu.amountPerInstallment\" min=\"0\" max=\"999999\"><div ng-show=\"editForm.amountPerInstallment.$invalid\"><p class=\"help-block\" ng-show=\"editForm.amountPerInstallment.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.amountPerInstallment.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.amountPerInstallment.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\">This field cannot be more than 999999.</p><p class=\"help-block\" ng-show=\"editForm.amountPerInstallment.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\" ng-if=\"vm.serviceVendu.typePaiement == \'A_PAYER_AVEC_ECHELONNEMENT\'\"><label class=\"control-label\" translate=\"wamasysApp.serviceVendu.totalCredit\" for=\"field_totalCredit\">MontantTotalAPayerParCollecte</label><input type=\"number\" class=\"form-control\" name=\"totalCredit\" id=\"field_totalCredit\" ng-model=\"vm.serviceVendu.totalCredit\" min=\"0\" max=\"999999\"><div ng-show=\"editForm.totalCredit.$invalid\"><p class=\"help-block\" ng-show=\"editForm.totalCredit.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.totalCredit.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.totalCredit.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\">This field cannot be more than 999999.</p><p class=\"help-block\" ng-show=\"editForm.totalCredit.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"alert alert-warning\" ng-if=\"vm.serviceVendu.typePaiement == \'A_PAYER_AVEC_ECHELONNEMENT\' || vm.serviceVendu.typePaiement == \'A_PAYER_PAR_JOUR\'\"><span translate=\"wamasysApp.serviceVendu.messageIntervalFrequency\"></span></div><div class=\"form-group\" ng-if=\"vm.serviceVendu.typePaiement == \'A_PAYER_AVEC_ECHELONNEMENT\' || vm.serviceVendu.typePaiement == \'A_PAYER_PAR_JOUR\'\"><label class=\"control-label\" translate=\"wamasysApp.serviceVendu.intervalTypeLabel\" for=\"field_intervalType\">intervalType</label><select class=\"form-control\" name=\"intervalType\" ng-model=\"vm.serviceVendu.intervalType\" id=\"field_intervalType\" required><option value=\"DAY\" translate=\"wamasysApp.serviceVendu.intervalType.DAY\">DAY</option><option value=\"MONTH\" translate=\"wamasysApp.serviceVendu.intervalType.MONTH\">MONTH</option></select><div ng-show=\"editForm.intervalType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.intervalType.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\" ng-if=\"vm.serviceVendu.typePaiement == \'A_PAYER_AVEC_ECHELONNEMENT\' || vm.serviceVendu.typePaiement == \'A_PAYER_PAR_JOUR\'\"><label class=\"control-label\" translate=\"wamasysApp.serviceVendu.frequency\" for=\"field_frequency\">frequency</label><input type=\"number\" class=\"form-control\" name=\"frequency\" id=\"field_frequency\" ng-model=\"vm.serviceVendu.frequency\" required min=\"0\" max=\"999999\"><div ng-show=\"editForm.frequency.$invalid\"><p class=\"help-block\" ng-show=\"editForm.frequency.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.frequency.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.frequency.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\">This field cannot be more than 999999.</p><p class=\"help-block\" ng-show=\"editForm.frequency.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.serviceVendu.typeTax\" for=\"field_typeTax\">typeTax</label><select class=\"form-control\" id=\"field_typeTax\" name=\"typeTax\" ng-model=\"vm.serviceVendu.typeTax\" ng-options=\"typeTax as typeTax.label for typeTax in vm.typeTaxs track by typeTax.id\"><option value=\"\"></option></select></div><!-- \n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"wamasysApp.serviceVendu.libelleTaxe\" for=\"field_libelleTaxe\">libelleTaxe</label>\n            <input type=\"text\" class=\"form-control\" name=\"libelleTaxe\" id=\"field_libelleTaxe\"\n                    ng-model=\"vm.serviceVendu.libelleTaxe\"\n                    ng-maxlength=\"50\" />\n            <div ng-show=\"editForm.libelleTaxe.$invalid\">\n                <p class=\"help-block\"\n                    ng-show=\"editForm.libelleTaxe.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n                <p class=\"help-block\"\n                    ng-show=\"editForm.libelleTaxe.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">\n                    This field cannot be longer than 50 characters.\n                </p>\n            </div>\n        </div>\n       \n        <div class=\"form-group\" >\n            <label class=\"control-label\" translate=\"wamasysApp.serviceVendu.tauxTaxe\" for=\"field_tauxTaxe\">tauxTaxe</label>\n            <input type=\"number\" class=\"form-control\" name=\"tauxTaxe\" id=\"field_tauxTaxe\"\n                    ng-model=\"vm.serviceVendu.tauxTaxe\"\n                     min=\"0\" max=\"999\" />\n            <div ng-show=\"editForm.tauxTaxe.$invalid\">\n                <p class=\"help-block\"\n                    ng-show=\"editForm.tauxTaxe.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n                <p class=\"help-block\"\n                    ng-show=\"editForm.tauxTaxe.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">\n                    This field should be more than 0.\n                </p>\n                <p class=\"help-block\"\n                    ng-show=\"editForm.tauxTaxe.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999\">\n                    This field cannot be more than 999999.\n                </p>\n                <p class=\"help-block\"\n                    ng-show=\"editForm.tauxTaxe.$error.number\" translate=\"entity.validation.number\">\n                    This field should be a number.\n                </p>\n            </div>\n        </div>\n         --><div class=\"form-group\" ng-if=\"vm.serviceVendu.id\"><label class=\"control-label\" translate=\"wamasysApp.serviceVendu.commentaire\" for=\"field_commentaire\">Commentaire</label><textarea ng-required=\"vm.serviceVendu.id\" rows=\"4\" cols=\"50\" type=\"text\" class=\"form-control\" name=\"commentaire\" id=\"field_commentaire\" ng-model=\"vm.serviceVendu.commentaire\" ng-maxlength=\"512\"></textarea><div ng-show=\"editForm.commentaire.$invalid\"><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.commentaire.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"512\">This field cannot be longer than 512 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.serviceVendu.id\"><label class=\"control-deleted\" translate=\"global.field.isDeleted\" for=\"field_deleted\">deleted</label><input type=\"checkbox\" class=\"form-control\" name=\"deleted\" id=\"field_deleted\" ng-model=\"vm.serviceVendu.deleted\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/service-autre/service-autres.html","<div><div class=\"container-fluid padding-top-10\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"modele-contrat.service-autre.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.serviceVendu.home.createLabel\">Create new ServiceVendu</span></button></div></div></div><div class=\"table-responsive padding-top-10\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"libelle\"><span translate=\"wamasysApp.serviceVendu.libelle\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"codeArticle\"><span translate=\"wamasysApp.serviceVendu.codeArticle\">codeArticle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"typeService.libelle\"><span translate=\"wamasysApp.serviceVendu.typeService\">typeService</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"wamasysApp.serviceVendu.typePaiement\">TypePaiement</span></th><th><span translate=\"wamasysApp.serviceVendu.amount\">amount</span></th><th><span translate=\"wamasysApp.serviceVendu.frequency\">frequency</span></th><th jh-sort-by=\"deleted\"><span translate=\"global.field.isDeleted\">isDeleted</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"serviceVendu in vm.serviceVendus track by serviceVendu.id\"><td><a ui-sref=\"service-autre-detail({id:serviceVendu.id})\">{{serviceVendu.libelle}}</a></td><td>{{serviceVendu.codeArticle}}</td><td><a ui-sref=\"type-service-detail({id:serviceVendu.typeService.id})\">{{serviceVendu.typeService.libelle}}</a></td><td translate=\"{{\'wamasysApp.TypePaiementService.\' + serviceVendu.typePaiement}}\">{{serviceVendu.typePaiement}}</td><!-- 	        		<td ng-if=\" serviceVendu.unitPrice\"> --><!--                     {{serviceVendu.unitPrice}} --><!--                     </td> --><!-- 	        		<td ng-if=\"serviceVendu.unitPrice\"> --><!--                     {{serviceVendu.unitPrice}} --><!--                     </td> --><td ng-if=\"serviceVendu.totalCredit\">{{serviceVendu.amountPerInstallment}} / {{serviceVendu.totalCredit}}</td><td ng-if=\"! serviceVendu.totalCredit && serviceVendu.amountPerInstallment\">{{serviceVendu.amountPerInstallment}}</td><td ng-if=\"! serviceVendu.totalCredit && ! serviceVendu.amountPerInstallment &&  serviceVendu.unitPrice \">{{serviceVendu.unitPrice}}</td><td ng-if=\"! serviceVendu.totalCredit && ! serviceVendu.amountPerInstallment &&  !serviceVendu.unitPrice \">0</td><td ng-if=\"serviceVendu.frequency \"><!--                    		 {{serviceVendu.amountPerInstallment}} / --> {{serviceVendu.frequency}} {{ \'wamasysApp.serviceVendu.intervalType.\' + serviceVendu.intervalType | translate}}</td><td ng-if=\"! serviceVendu.frequency \"></td><td>{{serviceVendu.deleted}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"service-autre-detail({id:serviceVendu.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"modele-contrat.service-autre.edit({id:serviceVendu.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"modele-contrat.service-autre.delete({id:serviceVendu.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/stored-document-stats/stored-document-stats.html","<div><h2>Statistiques S3 depuis la base</h2><p class=\"text-muted\">Cet écran se base uniquement sur les chemins stockés en base. Les anciens chemins non rattachables aux conteneurs <code>s1</code> et <code>s2</code> ne sont pas comptés.</p><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"storedDocumentStatsSearch\">Filtrer</label><input id=\"storedDocumentStatsSearch\" type=\"text\" class=\"form-control\" ng-model=\"vm.searchText\" ng-change=\"vm.applyFilter()\" placeholder=\"Organisation, conteneur ou type de fichier\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label>&nbsp;</label><button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"vm.load()\" ng-disabled=\"vm.loading\"><span class=\"glyphicon glyphicon-refresh\"></span> {{ vm.loading ? \'Chargement...\' : \'Actualiser\' }}</button></div></div></div><div class=\"row\" ng-if=\"!vm.loading\"><div class=\"col-sm-3\"><div class=\"well text-center\"><div class=\"h3\">{{vm.summary.totalFileCount || 0}}</div><div>Fichiers recensés</div></div></div><div class=\"col-sm-3\"><div class=\"well text-center\"><div class=\"h3\">{{vm.summary.organisationCount || 0}}</div><div>Organisations</div></div></div><div class=\"col-sm-3\"><div class=\"well text-center\"><div class=\"h3\">{{vm.summary.groupCount || 0}}</div><div>Groupes organisation / type</div></div></div><div class=\"col-sm-3\"><div class=\"well text-center\"><div class=\"h3\">{{vm.formatBytes(vm.summary.totalSizeBytes)}}</div><div>Taille totale connue</div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong>Détail par organisation et type de fichier</strong> <span class=\"pull-right text-muted\">{{vm.filteredRows.length || 0}} ligne(s)</span></div><div class=\"panel-body\" ng-if=\"vm.loading\">Chargement des statistiques...</div><div class=\"table-responsive\" ng-if=\"!vm.loading\"><table class=\"table table-striped table-condensed\"><thead><tr><th>Organisation</th><th>Conteneur</th><th>Type de fichier</th><th class=\"text-right\">Nb fichiers</th><th class=\"text-right\">Nb tailles connues</th><th class=\"text-right\">Taille totale connue</th></tr></thead><tbody><tr ng-repeat=\"row in vm.filteredRows\"><td>{{row.organisationName}}</td><td>{{row.storageLabel}}</td><td>{{row.fileTypeLabel}}</td><td class=\"text-right\">{{row.fileCount | number}}</td><td class=\"text-right\">{{row.knownSizeFileCount | number}}</td><td class=\"text-right\">{{vm.formatBytes(row.totalSizeBytes)}}</td></tr><tr ng-if=\"!vm.filteredRows.length\"><td colspan=\"6\" class=\"text-center text-muted\">Aucun fichier trouvé pour ce filtre.</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/business/type-remisecommerciale/type-remisecommerciale-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.typeRemisecommerciale.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.typeRemisecommerciale.delete.question\" translate-values=\"{id: \'{{vm.typeRemisecommerciale.id}}\'}\">Are you sure you want to delete this TypeRemisecommerciale?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/type-remisecommerciale/type-remisecommerciale-detail.html","<div><h2><span translate=\"wamasysApp.typeRemisecommerciale.detail.title\">TypeRemisecommerciale</span> {{vm.typeRemisecommerciale.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"global.field.code\">Code</span></dt><dd><span>{{vm.typeRemisecommerciale.code}}</span></dd><hr><dt><span translate=\"wamasysApp.typeRemisecommerciale.libelle\">Libelle</span></dt><dd><span>{{vm.typeRemisecommerciale.libelle}}<span></span></span></dd><hr><dt><span translate=\"global.field.isDeleted\">isDeleted</span></dt><dd><span>{{vm.typeRemisecommerciale.deleted}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/type-remisecommerciale/type-remisecommerciale-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTypeRemisecommercialeLabel\" translate=\"wamasysApp.typeRemisecommerciale.home.createOrEditLabel\">Create or edit a TypeRemisecommerciale</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"global.field.code\" for=\"field_code\">Code</label><input ng-readonly=\"vm.typeRemisecommerciale.id != null\" required type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.typeRemisecommerciale.code\" ng-maxlength=\"64\" ng-pattern=\"/^[_.A-Z0-9-]*$/\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.pattern\" translate=\"wamasysApp.typeRemisecommerciale.codeArticleFormatError\">The article code can only contain upper-case letters and digits.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"64\">This field cannot be longer than 64 characters.</p></div></div><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.typeRemisecommerciale.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.typeRemisecommerciale.libelle\" for=\"field_libelle\">Libelle</label><input type=\"text\" class=\"form-control\" name=\"libelle\" id=\"field_libelle\" ng-model=\"vm.typeRemisecommerciale.libelle\" required ng-maxlength=\"50\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.libelle.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.libelle.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.typeRemisecommerciale.id\"><label class=\"control-deleted\" translate=\"global.field.isDeleted\" for=\"field_deleted\">deleted</label><input type=\"checkbox\" class=\"form-control\" name=\"deleted\" id=\"field_deleted\" ng-model=\"vm.typeRemisecommerciale.deleted\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/type-remisecommerciale/type-remisecommerciales.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.typeRemisecommerciale.home.title\">TypeRemisecommerciales</span> <small class=\"text-muted\" translate=\"global.configurationScope.organization\">Paramétrage commun à toute l\'organisation</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"type-remisecommerciale.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.typeRemisecommerciale.home.createLabel\">Create new TypeRemisecommerciale</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"libelle\"><span translate=\"wamasysApp.typeRemisecommerciale.libelle\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"global.field.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deleted\"><span translate=\"global.field.isDeleted\">isDeleted</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"typeRemisecommerciale in vm.typeRemisecommerciales track by typeRemisecommerciale.id\"><td><a ui-sref=\"type-remisecommerciale-detail({id:typeRemisecommerciale.id})\">{{typeRemisecommerciale.id}}</a></td><td>{{typeRemisecommerciale.libelle}}</td><td>{{typeRemisecommerciale.code}}</td><td>{{typeRemisecommerciale.deleted}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"type-remisecommerciale-detail({id:typeRemisecommerciale.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"type-remisecommerciale.edit({id:typeRemisecommerciale.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"type-remisecommerciale.delete({id:typeRemisecommerciale.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/type-avoir/type-avoir-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.typeAvoir.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.typeAvoir.delete.question\" translate-values=\"{id: \'{{vm.typeAvoir.id}}\'}\">Are you sure you want to delete this TypeAvoir?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/type-avoir/type-avoir-detail.html","<div><h2><span translate=\"wamasysApp.typeAvoir.detail.title\">TypeAvoir</span> {{vm.typeAvoir.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"global.field.code\">Code</span></dt><dd><span>{{vm.typeAvoir.code}}</span></dd><hr><dt><span translate=\"wamasysApp.typeAvoir.libelle\">Libelle</span></dt><dd><span>{{vm.typeAvoir.libelle}}<span></span></span></dd><hr><dt><span translate=\"global.field.isDeleted\">isDeleted</span></dt><dd><span>{{vm.typeAvoir.deleted}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/type-avoir/type-avoir-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTypeAvoirLabel\" translate=\"wamasysApp.typeAvoir.home.createOrEditLabel\">Create or edit a TypeAvoir</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"global.field.code\" for=\"field_code\">Code</label><input ng-readonly=\"vm.typeAvoir.id != null\" required type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.typeAvoir.code\" ng-maxlength=\"64\" ng-pattern=\"/^[_.A-Z0-9-]*$/\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.pattern\" translate=\"wamasysApp.typeAvoir.codeArticleFormatError\">The article code can only contain upper-case letters and digits.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"64\">This field cannot be longer than 64 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.typeAvoir.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.typeAvoir.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.typeAvoir.libelle\" for=\"field_libelle\">Libelle</label><input type=\"text\" class=\"form-control\" name=\"libelle\" id=\"field_libelle\" ng-model=\"vm.typeAvoir.libelle\" required ng-maxlength=\"50\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.libelle.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.libelle.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.typeAvoir.id\"><label class=\"control-deleted\" translate=\"global.field.isDeleted\" for=\"field_deleted\">deleted</label><input type=\"checkbox\" class=\"form-control\" name=\"deleted\" id=\"field_deleted\" ng-model=\"vm.typeAvoir.deleted\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/type-avoir/type-avoirs.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.typeAvoir.home.title\">TypeAvoirs</span> <small class=\"text-muted\" translate=\"global.configurationScope.organization\">Paramétrage commun à toute l\'organisation</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"type-avoir.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.typeAvoir.home.createLabel\">Create new TypeAvoir</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"libelle\"><span translate=\"wamasysApp.typeAvoir.libelle\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"global.field.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deleted\"><span translate=\"global.field.isDeleted\">isDeleted</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"typeAvoir in vm.typeAvoirs track by typeAvoir.id\"><td><a ui-sref=\"type-avoir-detail({id:typeAvoir.id})\">{{typeAvoir.id}}</a></td><td>{{typeAvoir.libelle}}</td><td>{{typeAvoir.code}}</td><td>{{typeAvoir.deleted}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"type-avoir-detail({id:typeAvoir.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"type-avoir.edit({id:typeAvoir.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"type-avoir.delete({id:typeAvoir.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/test-plan/test-plan-create.html","<div><div class=\"clearfix\"><h2 class=\"pull-left\" translate=\"testPlan.create.title\">Créer un plan de test</h2><a class=\"btn btn-default pull-right margin-top-10\" ui-sref=\"test-plan-monitoring\"><span class=\"fa fa-arrow-left\"></span> <span translate=\"testPlan.create.backToMonitoring\">Retour au monitoring</span></a></div><jhi-alert></jhi-alert><div class=\"alert alert-success\" ng-if=\"vm.successMessage\">{{vm.successMessage}}</div><div class=\"alert alert-danger\" ng-if=\"vm.errorMessage\">{{vm.errorMessage}}</div><div class=\"alert alert-info\"><strong translate=\"testPlan.create.currentOrganisationTitle\">Organisation active</strong> <span translate=\"testPlan.create.currentOrganisationHint\">Le plan sera créé pour l\'organisation active et la liste affiche ses utilisateurs actifs, toutes zones confondues.</span></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong translate=\"testPlan.create.formTitle\">Paramètres du plan</strong></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label translate=\"testPlan.monitoring.planFile\">Fichier JSON du plan</label><input id=\"testPlanCreateFile\" type=\"file\" class=\"form-control\" file-model=\"vm.planFile\" set-file-data=\"vm.setPlanFile(value)\" accept=\".json\"></div></div><div class=\"col-md-6 text-right\"><label class=\"display-block\">&nbsp;</label><button class=\"btn btn-primary\" ng-click=\"vm.createPlan()\" ng-disabled=\"vm.isSubmitting || vm.isLoadingUsers\"><span class=\"fa fa-upload\"></span> <span ng-if=\"!vm.isSubmitting\" translate=\"testPlan.create.submit\">Créer le plan de test</span> <span ng-if=\"vm.isSubmitting\" translate=\"testPlan.create.submitting\">Création en cours...</span></button></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong translate=\"testPlan.create.usersTitle\">Utilisateurs concernés</strong> <span class=\"pull-right\">{{vm.selectedCount()}} <span translate=\"testPlan.create.selectedSuffix\">sélectionné(s)</span></span></div><div class=\"panel-body\"><div class=\"row margin-bottom-10\"><div class=\"col-md-4\"><label translate=\"testPlan.create.filterLabel\">Filtre</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.filter\" ng-change=\"vm.applyFilters()\" ng-model-options=\"{debounce: 250}\"></div><div class=\"col-md-3\"><label translate=\"testPlan.create.roleFilter\">Rôle</label><select class=\"form-control\" ng-model=\"vm.selectedRole\" ng-change=\"vm.applyFilters()\" ng-options=\"role as role for role in vm.availableRoles\"><option value=\"\" translate=\"testPlan.create.allRoles\">Tous les rôles</option></select></div><div class=\"col-md-3\"><label translate=\"testPlan.create.areaFilter\">Zone</label><select class=\"form-control\" ng-model=\"vm.selectedAgenceId\" ng-change=\"vm.applyFilters()\" ng-options=\"agence.id as agence.nom for agence in vm.availableAgences track by agence.id\"><option value=\"\" translate=\"testPlan.create.allAreas\">Toutes les zones</option></select></div><div class=\"col-md-2\"><label>&nbsp;</label><button class=\"btn btn-default btn-block\" type=\"button\" ng-click=\"vm.resetFilters()\"><span translate=\"entity.action.reset\">Reset</span></button></div></div><div class=\"clearfix margin-bottom-10\"><span class=\"text-muted\" ng-if=\"!vm.isLoadingUsers\">{{vm.filteredUserCount()}} <span translate=\"testPlan.create.visibleSuffix\">utilisateur(s) affiché(s)</span> </span><button class=\"btn btn-link pull-right\" type=\"button\" ng-if=\"vm.selectedCount() > 0\" ng-click=\"vm.clearSelection()\"><span translate=\"testPlan.create.clearSelection\">Vider la sélection</span></button></div><div class=\"alert alert-info\" ng-if=\"vm.isLoadingUsers\" translate=\"testPlan.create.loadingUsers\">Chargement des utilisateurs...</div><div class=\"alert alert-warning\" ng-if=\"!vm.isLoadingUsers && !vm.hasUsers()\" translate=\"testPlan.create.noUser\">Aucun utilisateur actif ne correspond aux filtres.</div><div class=\"table-responsive\" ng-if=\"!vm.isLoadingUsers && vm.hasUsers()\"><table class=\"table table-striped table-condensed\"><thead><tr><th class=\"text-center\" style=\"width: 40px\"><input type=\"checkbox\" ng-model=\"vm.selectAllVisible\" ng-change=\"vm.toggleSelectAllVisible()\"></th><th translate=\"testPlan.common.user\">Utilisateur</th><th translate=\"testPlan.common.email\">Email</th><th translate=\"testPlan.create.roleFilter\">Rôle</th><th translate=\"testPlan.create.areaFilter\">Zone</th></tr></thead><tbody><tr ng-repeat=\"user in vm.filteredUsers track by user.login\"><td class=\"text-center\"><input type=\"checkbox\" ng-model=\"vm.selectedUsers[user.login]\" ng-change=\"vm.updateSelectAllVisibleState()\"></td><td>{{user.firstName}} {{user.lastName}} ({{user.login}})</td><td>{{user.email}}</td><td><span class=\"label label-info margin-right-5\" ng-repeat=\"authority in user.authorities track by authority\">{{authority}}</span></td><td><span class=\"label label-default margin-right-5\" ng-repeat=\"agence in user.agencesRattachement track by agence.id\">{{agence.nom}}</span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/business/test-plan/test-plan-monitoring.html","<div><div class=\"clearfix\"><h2 class=\"pull-left\" translate=\"testPlan.monitoring.title\">Plans de test</h2><a class=\"btn btn-primary pull-right margin-top-10\" ui-sref=\"test-plan-create\"><span class=\"fa fa-plus\"></span> <span translate=\"testPlan.monitoring.createButton\">Créer un plan de test</span></a></div><jhi-alert></jhi-alert><div class=\"alert alert-danger\" ng-if=\"vm.errorMessage\">{{vm.errorMessage}}</div><div class=\"row\"><div class=\"col-md-4\"><div class=\"btn-group margin-bottom-10\"><button class=\"btn\" ng-class=\"{\'btn-primary\': vm.status === \'TODO\', \'btn-default\': vm.status !== \'TODO\'}\" ng-click=\"vm.changeStatus(\'TODO\')\" translate=\"testPlan.monitoring.todoTab\">Tests à faire</button> <button class=\"btn\" ng-class=\"{\'btn-primary\': vm.status === \'DONE\', \'btn-default\': vm.status !== \'DONE\'}\" ng-click=\"vm.changeStatus(\'DONE\')\" translate=\"testPlan.monitoring.doneTab\">Tests terminés</button></div><div class=\"list-group\"><a href=\"\" class=\"list-group-item\" ng-repeat=\"plan in vm.plans track by plan.storageKey\" ng-click=\"vm.showPlan(plan)\"><h4 class=\"list-group-item-heading\">{{plan.title}}</h4><p class=\"list-group-item-text\">{{plan.completedCount}} / {{plan.assignedCount}} <span translate=\"testPlan.monitoring.completedSuffix\">terminés</span></p><p class=\"list-group-item-text\" ng-if=\"plan.dueDate\">{{\'testPlan.common.dueDate\' | translate}} : {{plan.dueDate}}</p></a></div></div><div class=\"col-md-8\" ng-if=\"vm.selectedPlan\"><div class=\"panel panel-default\"><div class=\"panel-heading clearfix\"><strong>{{vm.selectedPlan.summary.title}}</strong> <button type=\"button\" class=\"btn btn-danger btn-xs pull-right\" ng-click=\"vm.deletePlan()\" ng-disabled=\"vm.deleting\"><span class=\"fa fa-trash\"></span> <span translate=\"testPlan.monitoring.deleteButton\">Supprimer ce plan</span></button> <button type=\"button\" class=\"btn btn-default btn-xs pull-right\" style=\"margin-right: 8px\" ng-click=\"vm.hidePlan()\" ng-disabled=\"vm.deleting\"><span translate=\"testPlan.monitoring.hideButton\">Masquer ce plan</span></button></div><div class=\"panel-body\"><p ng-if=\"vm.selectedPlan.plan.summary\">{{vm.selectedPlan.plan.summary}}</p><p ng-if=\"vm.selectedPlan.plan.dueDate\"><strong>{{\'testPlan.common.dueDate\' | translate}} :</strong> {{vm.selectedPlan.plan.dueDate}}</p><h4 translate=\"testPlan.common.instructions\">Consignes générales</h4><ul><li ng-repeat=\"instruction in vm.selectedPlan.plan.instructions track by $index\">{{instruction}}</li><li ng-repeat=\"instruction in vm.selectedPlan.plan.consignes track by (\'c\' + $index)\">{{instruction}}</li></ul><h4 translate=\"testPlan.common.domains\">Domaines</h4><div class=\"panel panel-info\" ng-repeat=\"domain in vm.selectedPlan.plan.domains track by domain.domainId\"><div class=\"panel-heading\">{{domain.title}}</div><div class=\"panel-body\"><p ng-if=\"domain.description\">{{domain.description}}</p><p><strong translate=\"testPlan.common.prerequisites\">Prérequis</strong></p><ul><li ng-repeat=\"item in domain.prerequisites track by $index\">{{item}}</li></ul><p><strong translate=\"testPlan.common.scenarios\">Scénarios</strong></p><ul><li ng-repeat=\"scenario in domain.scenarios track by scenario.scenarioId\">{{scenario.title}}</li></ul></div></div><div class=\"test-plan-monitoring-summary\" ng-if=\"vm.planStats\"><h4 translate=\"testPlan.monitoring.summaryTitle\">Synthèse du plan</h4><div class=\"row\"><div class=\"col-sm-6 col-lg-3\"><div class=\"test-plan-monitoring-summary-card test-plan-monitoring-summary-card--users\"><div class=\"test-plan-monitoring-summary-card__title\" translate=\"testPlan.monitoring.summaryUsers\">Utilisateurs</div><div class=\"test-plan-monitoring-summary-card__value\">{{vm.planStats.assignedCount}}</div><div class=\"test-plan-monitoring-summary-card__list\"><div>{{\'testPlan.monitoring.completedCount\' | translate}} : {{vm.planStats.completedCount}}</div><div>{{\'testPlan.monitoring.inProgressCount\' | translate}} : {{vm.planStats.inProgressCount}}</div><div>{{\'testPlan.monitoring.notStartedCount\' | translate}} : {{vm.planStats.notStartedCount}}</div></div></div></div><div class=\"col-sm-6 col-lg-3\"><div class=\"test-plan-monitoring-summary-card test-plan-monitoring-summary-card--questions\"><div class=\"test-plan-monitoring-summary-card__title\" translate=\"testPlan.monitoring.summaryQuestions\">Questions</div><div class=\"test-plan-monitoring-summary-card__value\">{{vm.planStats.answeredCount}} / {{vm.planStats.totalScenarioCount}}</div><div class=\"test-plan-monitoring-summary-card__list\"><div>{{\'testPlan.monitoring.answeredCount\' | translate}} : {{vm.planStats.answeredCount}}</div><div>{{\'testPlan.monitoring.pendingCount\' | translate}} : {{vm.planStats.pendingCount}}</div></div></div></div><div class=\"col-sm-6 col-lg-3\"><div class=\"test-plan-monitoring-summary-card test-plan-monitoring-summary-card--status\"><div class=\"test-plan-monitoring-summary-card__title\" translate=\"testPlan.monitoring.summaryStatus\">Statuts</div><div class=\"test-plan-monitoring-summary-card__value\">{{vm.planStats.okCount + vm.planStats.koCount + vm.planStats.unableCount}}</div><div class=\"test-plan-monitoring-summary-card__list\"><div>{{\'testPlan.monitoring.okCount\' | translate}} : {{vm.planStats.okCount}}</div><div>{{\'testPlan.monitoring.koCount\' | translate}} : {{vm.planStats.koCount}}</div><div>{{\'testPlan.monitoring.unableCount\' | translate}} : {{vm.planStats.unableCount}}</div></div></div></div><div class=\"col-sm-6 col-lg-3\"><div class=\"test-plan-monitoring-summary-card test-plan-monitoring-summary-card--satisfaction\"><div class=\"test-plan-monitoring-summary-card__title\" translate=\"testPlan.monitoring.summarySatisfaction\">Satisfaction</div><div class=\"test-plan-monitoring-summary-card__value\" ng-if=\"vm.planStats.ratingAverage !== null\">{{vm.planStats.ratingAverage | number:1}}/10</div><div class=\"test-plan-monitoring-summary-card__value\" ng-if=\"vm.planStats.ratingAverage === null && vm.planStats.smileyDominantLabelKey\">{{vm.planStats.smileyDominantLabelKey | translate}}</div><div class=\"test-plan-monitoring-summary-card__value\" ng-if=\"vm.planStats.ratingAverage === null && !vm.planStats.smileyDominantLabelKey\">-</div><div class=\"test-plan-monitoring-summary-card__list\"><div>{{\'testPlan.monitoring.averageRating\' | translate}} : <span ng-if=\"vm.planStats.ratingAverage !== null\">{{vm.planStats.ratingAverage | number:1}}/10</span> <span ng-if=\"vm.planStats.ratingAverage === null\" translate=\"testPlan.monitoring.noData\">Aucune donnée</span></div><div>{{\'testPlan.monitoring.dominantSmiley\' | translate}} : <span ng-if=\"vm.planStats.smileyDominantLabelKey\">{{vm.planStats.smileyDominantLabelKey | translate}}</span> <span ng-if=\"!vm.planStats.smileyDominantLabelKey\" translate=\"testPlan.monitoring.noData\">Aucune donnée</span></div></div></div></div></div></div><h4 translate=\"testPlan.monitoring.resultsByUser\">Résultats par utilisateur</h4><table class=\"table table-bordered table-striped\"><thead><tr><th translate=\"testPlan.common.user\">Utilisateur</th><th translate=\"testPlan.common.status\">Statut</th><th translate=\"testPlan.monitoring.progress\">Progression</th><th translate=\"testPlan.monitoring.lastUpdate\">Dernière mise à jour</th></tr></thead><tbody><tr ng-repeat=\"result in vm.selectedPlan.results track by result.tester.login\"><td>{{result.tester.firstName}} {{result.tester.lastName}} ({{result.tester.login}})</td><td>{{vm.getOverallStatusLabel(result.overallStatus)}}</td><td>{{vm.getResultProgressLabel(result)}}</td><td>{{result.lastUpdatedAt | date:\'yyyy-MM-dd HH:mm:ss\'}}</td></tr></tbody></table><h4 translate=\"testPlan.monitoring.detailedResultsByUser\">Détail des réponses par utilisateur</h4><div ng-repeat=\"result in vm.selectedPlan.results track by (\'details-\' + result.tester.login)\" class=\"test-plan-monitoring-user-block\"><h5>{{\'testPlan.monitoring.questionResultsFor\' | translate}} {{result.tester.firstName}} {{result.tester.lastName}}</h5><p class=\"text-muted\">{{vm.getOverallStatusLabel(result.overallStatus)}} | {{\'testPlan.monitoring.progress\' | translate}} : {{vm.getResultProgressLabel(result)}}</p><table class=\"table table-bordered table-condensed test-plan-monitoring-result-table\" ng-if=\"result.scenarioResults.length > 0\"><thead><tr><th translate=\"testPlan.common.domain\">Domaine</th><th translate=\"testPlan.common.scenario\">Scénario</th><th translate=\"testPlan.monitoring.responseType\">Type</th><th translate=\"testPlan.common.answer\">Réponse</th><th translate=\"testPlan.common.comment\">Commentaire</th><th translate=\"testPlan.monitoring.attachments\">Pièces jointes</th><th translate=\"testPlan.monitoring.testedAt\">Répondu le</th></tr></thead><tbody><tr ng-repeat=\"scenarioResult in result.scenarioResults track by (scenarioResult.domainId + \'-\' + scenarioResult.scenarioId)\"><td>{{vm.getScenarioDomainTitle(scenarioResult)}}</td><td>{{vm.getScenarioTitle(scenarioResult)}}</td><td>{{vm.getScenarioResponseTypeLabel(scenarioResult)}}</td><td>{{vm.getScenarioAnswerLabel(scenarioResult)}}</td><td><div ng-if=\"scenarioResult.comment\">{{scenarioResult.comment}}</div><div class=\"text-muted\" ng-if=\"!scenarioResult.comment\" translate=\"testPlan.monitoring.noComment\">Aucun commentaire</div></td><td><div class=\"text-muted\" ng-if=\"!vm.getAttachmentCount(scenarioResult)\" translate=\"testPlan.monitoring.noAttachment\">Aucune pièce jointe</div><div ng-if=\"vm.getAttachmentCount(scenarioResult)\"><div class=\"test-plan-monitoring-attachment-count\">{{vm.getAttachmentCount(scenarioResult)}} <span translate=\"testPlan.monitoring.attachments\">Pièces jointes</span></div><div class=\"margin-top-10\"><img ng-repeat=\"attachment in scenarioResult.attachments track by $index\" class=\"test-plan-monitoring-attachment-preview\" ng-src=\"{{attachment.dataUrl}}\" alt=\"{{attachment.fileName}}\"></div></div></td><td><span ng-if=\"scenarioResult.testedAt\">{{scenarioResult.testedAt | date:\'yyyy-MM-dd HH:mm:ss\'}}</span> <span class=\"text-muted\" ng-if=\"!scenarioResult.testedAt\" translate=\"testPlan.monitoring.noData\">Aucune donnée</span></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/business/test-plan/test-plan-runner.html","<div><h2 translate=\"testPlan.runner.title\">Mes tests</h2><div class=\"row\" ng-if=\"vm.myPlans.length === 0\"><div class=\"col-md-12\"><div class=\"alert alert-info\" translate=\"testPlan.runner.noPlan\">Aucun plan de test à faire pour votre utilisateur.</div></div></div><div class=\"row\" ng-if=\"vm.myPlans.length > 0 && vm.isChoosingPlan\"><div class=\"col-md-12\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong translate=\"testPlan.runner.chooseTitle\">Choisissez un plan de test</strong></div><div class=\"list-group\"><a href=\"\" class=\"list-group-item\" ng-repeat=\"plan in vm.myPlans track by plan.storageKey\" ng-click=\"vm.loadPlan(plan.storageKey)\"><h4 class=\"list-group-item-heading\">{{plan.title}}</h4><p class=\"list-group-item-text\">{{plan.myOverallStatus}}</p><p class=\"list-group-item-text\" ng-if=\"plan.dueDate\">{{\'testPlan.common.dueDate\' | translate}} : {{plan.dueDate}}</p></a></div></div></div></div><div class=\"row\" ng-if=\"vm.currentPlan && !vm.isChoosingPlan\"><div class=\"col-md-12\"><div class=\"panel panel-default\"><div class=\"panel-heading clearfix\"><strong>{{vm.currentPlan.title}}</strong> <button type=\"button\" class=\"btn btn-default btn-xs pull-right\" ng-click=\"vm.choosePlan()\" translate=\"testPlan.runner.changePlan\">Choisir un autre plan</button></div><div class=\"panel-body\"><div class=\"test-plan-runner-intro\"><div class=\"test-plan-runner-intro__header\"><div><h4 class=\"test-plan-runner-intro__title\" translate=\"testPlan.runner.overviewTitle\">Vue d\'ensemble du plan</h4><p class=\"test-plan-runner-intro__subtitle\" ng-if=\"vm.isIntroCollapsed\" translate=\"testPlan.runner.overviewCollapsedHint\">Le résumé et les consignes sont masqués.</p></div><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.toggleIntro()\"><span class=\"fa\" ng-class=\"vm.isIntroCollapsed ? \'fa-chevron-down\' : \'fa-chevron-up\'\"></span> <span ng-if=\"vm.isIntroCollapsed\" translate=\"testPlan.runner.showOverview\">Afficher</span> <span ng-if=\"!vm.isIntroCollapsed\" translate=\"testPlan.runner.hideOverview\">Replier</span></button></div><div class=\"test-plan-runner-intro__body\" ng-if=\"!vm.isIntroCollapsed\"><p ng-if=\"vm.currentPlan.summary\" class=\"test-plan-runner-intro__summary\">{{vm.currentPlan.summary}}</p><p ng-if=\"vm.currentPlan.dueDate\" class=\"test-plan-runner-intro__due-date\"><strong>{{\'testPlan.common.dueDate\' | translate}} :</strong> {{vm.currentPlan.dueDate}}</p><h5 class=\"test-plan-runner-intro__section-title\" translate=\"testPlan.common.instructions\">Consignes générales</h5><ul class=\"test-plan-runner-intro__instructions\"><li ng-repeat=\"instruction in vm.currentPlan.instructions track by $index\">{{instruction}}</li><li ng-repeat=\"instruction in vm.currentPlan.consignes track by (\'cg-\' + $index)\">{{instruction}}</li></ul></div></div><div class=\"test-plan-runner-wizard\" ng-if=\"vm.currentPlan.domains && vm.currentPlan.domains.length\"><div class=\"test-plan-runner-wizard__steps\" role=\"tablist\" aria-label=\"{{\'testPlan.common.domains\' | translate}}\"><button type=\"button\" class=\"test-plan-runner-wizard__step\" ng-repeat=\"domain in vm.currentPlan.domains track by domain.domainId\" ng-class=\"{\n                                        \'test-plan-runner-wizard__step--active\': vm.isSelectedDomain(domain),\n                                        \'test-plan-runner-wizard__step--complete\': vm.isDomainCompleted(domain),\n                                        \'test-plan-runner-wizard__step--progress\': !vm.isDomainCompleted(domain) && vm.isDomainStarted(domain),\n                                        \'test-plan-runner-wizard__step--pending\': !vm.isDomainCompleted(domain) && !vm.isDomainStarted(domain)\n                                    }\" ng-click=\"vm.selectDomain(domain)\"><span class=\"test-plan-runner-wizard__step-index\">{{$index + 1}}</span> <span class=\"test-plan-runner-wizard__step-body\"><span class=\"test-plan-runner-wizard__step-title\">{{domain.title}}</span> <span class=\"test-plan-runner-wizard__step-progress\">{{vm.domainProgress(domain)}}</span></span></button></div><div class=\"test-plan-runner-wizard__toolbar\" ng-if=\"vm.selectedDomain\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.previousDomain()\" ng-disabled=\"!vm.hasPreviousDomain()\" translate=\"testPlan.runner.previousSection\">Section précédente</button> <span class=\"test-plan-runner-wizard__counter\" translate=\"testPlan.runner.sectionCounter\" translate-values=\"{ current: vm.getSelectedDomainIndex() + 1, total: vm.currentPlan.domains.length }\">Section 1 / 1 </span><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.nextDomain()\" ng-disabled=\"!vm.hasNextDomain()\" translate=\"testPlan.runner.nextSection\">Section suivante</button></div></div><div class=\"test-plan-runner-domain\" ng-if=\"vm.selectedDomain\"><div class=\"test-plan-runner-domain__header\"><h4 class=\"test-plan-runner-domain__title\">{{vm.selectedDomain.title}}</h4><span class=\"test-plan-runner-domain__progress\">{{vm.domainProgress(vm.selectedDomain)}}</span></div><p ng-if=\"vm.selectedDomain.description\" class=\"test-plan-runner-domain__description\">{{vm.selectedDomain.description}}</p><div class=\"test-plan-runner-domain__prerequisites\" ng-if=\"vm.selectedDomain.prerequisites && vm.selectedDomain.prerequisites.length\"><p><strong translate=\"testPlan.common.prerequisites\">Prérequis</strong></p><ul><li ng-repeat=\"item in vm.selectedDomain.prerequisites track by $index\">{{item}}</li></ul></div><div class=\"test-plan-runner-scenarios\"><div class=\"panel test-plan-runner-scenario\" ng-repeat=\"scenario in vm.selectedDomain.scenarios track by scenario.scenarioId\" ng-init=\"scenarioKey = vm.getScenarioKey(vm.selectedDomain.domainId, scenario.scenarioId)\" ng-class=\"{\n                                     \'test-plan-runner-scenario--pending\': vm.getScenarioState(vm.scenarioResultsByKey[scenarioKey]) === \'pending\',\n                                     \'test-plan-runner-scenario--ko-pending\': vm.getScenarioState(vm.scenarioResultsByKey[scenarioKey]) === \'ko-pending\',\n                                     \'test-plan-runner-scenario--ok\': vm.getScenarioState(vm.scenarioResultsByKey[scenarioKey]) === \'ok\',\n                                     \'test-plan-runner-scenario--ko\': vm.getScenarioState(vm.scenarioResultsByKey[scenarioKey]) === \'ko\',\n                                     \'test-plan-runner-scenario--answered\': vm.getScenarioState(vm.scenarioResultsByKey[scenarioKey]) === \'answered\',\n                                     \'test-plan-runner-scenario--unable\': vm.getScenarioState(vm.scenarioResultsByKey[scenarioKey]) === \'unable\'\n                                 }\"><div class=\"panel-heading test-plan-runner-scenario__heading\"><button type=\"button\" class=\"test-plan-runner-scenario__toggle\" ng-click=\"vm.toggleScenario(vm.selectedDomain.domainId, scenario.scenarioId)\" ng-attr-aria-expanded=\"{{vm.isScenarioExpanded(vm.selectedDomain.domainId, scenario.scenarioId)}}\"><span class=\"test-plan-runner-scenario__heading-main\"><span class=\"test-plan-runner-scenario__title\">{{scenario.title}}</span> <span class=\"test-plan-runner-scenario__preview\" ng-if=\"!vm.isScenarioExpanded(vm.selectedDomain.domainId, scenario.scenarioId) && vm.getScenarioCommentPreview(vm.scenarioResultsByKey[scenarioKey])\">{{vm.getScenarioCommentPreview(vm.scenarioResultsByKey[scenarioKey])}} </span></span><span class=\"test-plan-runner-scenario__heading-side\"><span class=\"test-plan-runner-scenario__status\" ng-class=\"\'test-plan-runner-scenario__status--\' + vm.getScenarioState(vm.scenarioResultsByKey[scenarioKey])\"><span ng-if=\"vm.getScenarioState(vm.scenarioResultsByKey[scenarioKey]) !== \'answered\'\">{{vm.getScenarioStatusLabelKey(vm.scenarioResultsByKey[scenarioKey]) | translate}} </span><span ng-if=\"vm.getScenarioState(vm.scenarioResultsByKey[scenarioKey]) === \'answered\' && vm.isRatingQuestion(scenario)\">{{\'testPlan.runner.ratingValue\' | translate:{ value: vm.scenarioResultsByKey[scenarioKey].answerValue }}} </span><span ng-if=\"vm.getScenarioState(vm.scenarioResultsByKey[scenarioKey]) === \'answered\' && vm.isSmileyQuestion(scenario)\">{{vm.getSmileyLabelKey(vm.scenarioResultsByKey[scenarioKey].answerValue) | translate}} </span></span><span class=\"test-plan-runner-scenario__attachments\" ng-if=\"vm.scenarioResultsByKey[scenarioKey].attachments && vm.scenarioResultsByKey[scenarioKey].attachments.length\"><i class=\"fa fa-paperclip\"></i> {{vm.scenarioResultsByKey[scenarioKey].attachments.length}} </span><span class=\"test-plan-runner-scenario__chevron fa\" ng-class=\"vm.isScenarioExpanded(vm.selectedDomain.domainId, scenario.scenarioId) ? \'fa-chevron-up\' : \'fa-chevron-down\'\"></span></span></button></div><div class=\"panel-body\" ng-if=\"vm.isScenarioExpanded(vm.selectedDomain.domainId, scenario.scenarioId)\"><p ng-if=\"scenario.description\">{{scenario.description}}</p><p><strong translate=\"testPlan.common.steps\">Étapes</strong></p><ol ng-if=\"scenario.steps && scenario.steps.length\"><li ng-repeat=\"step in scenario.steps track by $index\">{{step}}</li></ol><p ng-if=\"(!scenario.steps || !scenario.steps.length)\" class=\"text-muted\" translate=\"testPlan.runner.noStepDetail\">Aucune étape détaillée pour cette question.</p><p ng-if=\"scenario.expectedResult\"><strong translate=\"testPlan.common.expectedResult\">Résultat attendu :</strong> {{scenario.expectedResult}}</p><p ng-if=\"scenario.dataSet\"><strong translate=\"testPlan.common.dataSet\">Données :</strong> {{scenario.dataSet}}</p><div class=\"test-plan-runner-answer-block\" ng-if=\"vm.isStatusQuestion(scenario)\"><p class=\"test-plan-runner-answer-block__label\" translate=\"testPlan.common.status\">Statut</p><div class=\"test-plan-runner-answer-choices\"><button type=\"button\" class=\"test-plan-runner-answer-choice test-plan-runner-answer-choice--ok\" ng-class=\"{\'test-plan-runner-answer-choice--selected\': vm.scenarioResultsByKey[scenarioKey].status === \'OK\'}\" ng-click=\"vm.setScenarioStatus(vm.selectedDomain.domainId, scenario.scenarioId, \'OK\')\">OK</button> <button type=\"button\" class=\"test-plan-runner-answer-choice test-plan-runner-answer-choice--ko\" ng-class=\"{\'test-plan-runner-answer-choice--selected\': vm.scenarioResultsByKey[scenarioKey].status === \'KO\'}\" ng-click=\"vm.setScenarioStatus(vm.selectedDomain.domainId, scenario.scenarioId, \'KO\')\">KO</button> <button type=\"button\" class=\"test-plan-runner-answer-choice test-plan-runner-answer-choice--pending\" ng-class=\"{\'test-plan-runner-answer-choice--selected\': vm.scenarioResultsByKey[scenarioKey].status === \'NOT_TESTED\'}\" ng-click=\"vm.setScenarioStatus(vm.selectedDomain.domainId, scenario.scenarioId, \'NOT_TESTED\')\" translate=\"testPlan.runner.notTested\">Pas répondu</button> <button type=\"button\" class=\"test-plan-runner-answer-choice test-plan-runner-answer-choice--unable\" ng-class=\"{\'test-plan-runner-answer-choice--selected\': vm.scenarioResultsByKey[scenarioKey].status === \'UNABLE_TO_ANSWER\'}\" ng-click=\"vm.setScenarioStatus(vm.selectedDomain.domainId, scenario.scenarioId, \'UNABLE_TO_ANSWER\')\" translate=\"testPlan.runner.unableToAnswer\">Ne peut pas répondre</button></div></div><div class=\"test-plan-runner-answer-block\" ng-if=\"vm.isRatingQuestion(scenario)\"><p class=\"test-plan-runner-answer-block__label\" translate=\"testPlan.runner.rateFrom1To10\">Donnez une note de 1 à 10</p><div class=\"test-plan-runner-rating-scale\"><button type=\"button\" class=\"test-plan-runner-rating-scale__item\" ng-repeat=\"rating in [1,2,3,4,5,6,7,8,9,10] track by rating\" ng-class=\"{\n                                                        \'test-plan-runner-rating-scale__item--selected\': vm.scenarioResultsByKey[scenarioKey].status === \'ANSWERED\' && vm.scenarioResultsByKey[scenarioKey].answerValue === rating\n                                                    }\" ng-click=\"vm.selectScenarioRating(vm.selectedDomain.domainId, scenario.scenarioId, rating)\">{{rating}}</button></div></div><div class=\"test-plan-runner-answer-block\" ng-if=\"vm.isSmileyQuestion(scenario)\"><p class=\"test-plan-runner-answer-block__label\" translate=\"testPlan.runner.chooseSmiley\">Choisissez un smiley</p><div class=\"test-plan-runner-smiley-scale\"><button type=\"button\" class=\"test-plan-runner-smiley-scale__item\" ng-repeat=\"smiley in [1,2,3,4] track by smiley\" ng-class=\"[\'test-plan-runner-smiley-scale__item--tone-\' + smiley, vm.scenarioResultsByKey[scenarioKey].status === \'ANSWERED\' && vm.scenarioResultsByKey[scenarioKey].answerValue === smiley ? \'test-plan-runner-smiley-scale__item--selected\' : \'\']\" ng-click=\"vm.selectScenarioSmiley(vm.selectedDomain.domainId, scenario.scenarioId, smiley)\"><img class=\"test-plan-runner-smiley-scale__image\" ng-src=\"{{vm.getSmileyImagePath(smiley)}}\" alt=\"{{vm.getSmileyLabelKey(smiley) | translate}}\"> <span class=\"test-plan-runner-smiley-scale__label\">{{vm.getSmileyLabelKey(smiley) | translate}}</span></button></div></div><div class=\"test-plan-runner-answer-actions\" ng-if=\"!vm.isStatusQuestion(scenario)\"><button type=\"button\" class=\"test-plan-runner-answer-choice test-plan-runner-answer-choice--pending\" ng-class=\"{\'test-plan-runner-answer-choice--selected\': vm.scenarioResultsByKey[scenarioKey].status === \'NOT_TESTED\'}\" ng-click=\"vm.setScenarioStatus(vm.selectedDomain.domainId, scenario.scenarioId, \'NOT_TESTED\')\" translate=\"testPlan.runner.notTested\">Pas répondu</button> <button type=\"button\" class=\"test-plan-runner-answer-choice test-plan-runner-answer-choice--unable\" ng-class=\"{\'test-plan-runner-answer-choice--selected\': vm.scenarioResultsByKey[scenarioKey].status === \'UNABLE_TO_ANSWER\'}\" ng-click=\"vm.setScenarioStatus(vm.selectedDomain.domainId, scenario.scenarioId, \'UNABLE_TO_ANSWER\')\" translate=\"testPlan.runner.unableToAnswer\">Ne peut pas répondre</button></div><div class=\"form-group\"><label translate=\"testPlan.common.comment\">Commentaire</label><textarea class=\"form-control\" rows=\"4\" ng-model=\"vm.scenarioResultsByKey[scenarioKey].comment\" ng-blur=\"vm.onScenarioCommentBlur(vm.selectedDomain.domainId, scenario.scenarioId)\" ng-paste=\"vm.handleCommentPaste($event, vm.scenarioResultsByKey[scenarioKey])\" placeholder=\"{{\'testPlan.runner.commentPlaceholder\' | translate}}\"></textarea><p class=\"help-block\" translate=\"testPlan.runner.pasteHelp\">Vous pouvez aussi coller une image dans ce champ pour l\'ajouter au résultat.</p></div><div class=\"row\" ng-if=\"vm.scenarioResultsByKey[scenarioKey].attachments && vm.scenarioResultsByKey[scenarioKey].attachments.length\"><div class=\"col-sm-4\" ng-repeat=\"attachment in vm.scenarioResultsByKey[scenarioKey].attachments track by $index\"><div class=\"thumbnail\"><img ng-src=\"{{attachment.dataUrl}}\" alt=\"{{attachment.fileName}}\" style=\"max-height: 140px\"><div class=\"caption\"><p class=\"small\">{{attachment.fileName}}</p><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.removeAttachment(vm.scenarioResultsByKey[scenarioKey], $index)\" translate=\"testPlan.runner.removeImage\">Retirer l\'image</button></div></div></div></div></div></div></div><button class=\"btn btn-primary\" ng-click=\"vm.save()\" translate=\"testPlan.runner.save\">Enregistrer mes résultats</button></div></div></div></div></div></div>");
$templateCache.put("app/business/teamwork/native-tickets.html","<div class=\"native-tickets\" ng-cloak><div class=\"ticket-page-heading\"><div><h1><i class=\"fa fa-ticket\"></i> Tickets et tâches</h1><p class=\"text-muted\">Suivre les demandes, préparer les interventions et organiser les tâches récurrentes.</p></div><button class=\"btn btn-primary\" ng-disabled=\"vm.meta.readOnly\" ng-click=\"vm.showSection(\'tickets\');vm.newTicket()\"><i class=\"fa fa-plus\"></i> Nouveau ticket</button></div><ul class=\"nav nav-tabs\"><li ng-class=\"{active:vm.section===\'tickets\'}\"><a href=\"\" ng-click=\"vm.showSection(\'tickets\')\">Tickets</a></li><li ng-if=\"vm.meta.manager\" ng-class=\"{active:vm.section===\'schedules\'}\"><a href=\"\" ng-click=\"vm.showSection(\'schedules\')\">Récurrences</a></li><li ng-if=\"vm.meta.manager\" ng-class=\"{active:vm.section===\'categories\'}\"><a href=\"\" ng-click=\"vm.showSection(\'categories\')\">Catégories et sous-catégories</a></li></ul><div class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</div><div class=\"alert alert-success\" role=\"status\" ng-if=\"vm.notice\">{{vm.notice}}</div><div ng-show=\"vm.section===\'tickets\'\"><form class=\"ticket-filters\" ng-submit=\"vm.filter()\"><label>Vue<select class=\"form-control\" ng-model=\"vm.filters.view\" ng-change=\"vm.filter()\"><option value=\"all\">Tous mes tickets autorisés</option><option value=\"mine\">Affectés à moi</option><option value=\"created\">Créés par moi</option><option value=\"watched\">Tickets suivis</option><option value=\"unassigned\" ng-if=\"vm.meta.manager\">À affecter</option><option value=\"archive\">Historique, tous les états</option></select></label><label>Zone<select class=\"form-control\" ng-model=\"vm.filters.areaId\" ng-options=\"area.id as area.label for area in vm.meta.areas\" ng-change=\"vm.filter()\"><option value=\"\">Toutes mes zones</option></select></label><label>Type<select class=\"form-control\" ng-model=\"vm.filters.type\" ng-change=\"vm.filter()\"><option value=\"\">Tous les types</option><option ng-repeat=\"type in vm.meta.types\" value=\"{{type}}\">{{vm.label(type)}}</option></select></label><label>État<select class=\"form-control\" ng-model=\"vm.filters.status\" ng-change=\"vm.filter()\"><option value=\"\">États ouverts</option><option ng-repeat=\"status in vm.meta.statuses\" value=\"{{status}}\">{{vm.label(status)}}</option></select></label><label class=\"ticket-search\">Recherche<input class=\"form-control\" ng-model=\"vm.filters.search\" placeholder=\"Titre ou description\" maxlength=\"255\"></label><button class=\"btn btn-default\" type=\"submit\"><i class=\"fa fa-search\"></i> Rechercher</button></form><div class=\"row\"><div ng-class=\"vm.ticket ? \'col-lg-5\' : \'col-lg-12\'\"><p class=\"text-muted\" ng-if=\"!vm.loading\">{{vm.total || 0}} ticket(s)</p><p ng-if=\"vm.loading\"><i class=\"fa fa-spinner fa-spin\"></i> Chargement…</p><div class=\"table-responsive\"><table class=\"table table-hover ticket-list\"><thead><tr><th>Ticket</th><th>État</th><th>Échéance</th></tr></thead><tbody><tr ng-repeat=\"ticket in vm.items track by ticket.id\" ng-class=\"{active:vm.ticket.id===ticket.id}\"><td><button class=\"btn btn-link ticket-subject\" ng-click=\"vm.open(ticket.id)\">#{{ticket.id}} — {{ticket.subject}}</button><small>{{vm.areaName(ticket.areaId)}} · {{vm.label(ticket.type)}} · {{vm.label(ticket.priority)}}</small><small>{{vm.name(ticket.assigneeId)}}</small></td><td><span class=\"label\" ng-class=\"vm.closed(ticket.status) ? \'label-default\' : ticket.status===\'IN_PROGRESS\' ? \'label-primary\' : \'label-info\'\">{{vm.label(ticket.status)}}</span></td><td>{{ticket.dueDate | date:\'dd/MM/yyyy\'}}</td></tr><tr ng-if=\"!vm.items.length && !vm.loading\"><td colspan=\"3\" class=\"text-muted\">Aucun ticket dans cette vue.</td></tr></tbody></table></div><div class=\"ticket-pagination\"><button class=\"btn btn-default btn-sm\" ng-disabled=\"vm.filters.page===0 || vm.loading\" ng-click=\"vm.page(-1)\">Précédent</button><span>Page {{vm.filters.page+1}}</span><button class=\"btn btn-default btn-sm\" ng-disabled=\"(vm.filters.page+1)*50>=vm.total || vm.loading\" ng-click=\"vm.page(1)\">Suivant</button></div></div><div class=\"col-lg-7\" ng-if=\"vm.ticket\"><div class=\"ticket-card\"><div class=\"ticket-card-heading\"><h2>{{vm.ticket.id ? \'Ticket #\'+vm.ticket.id : \'Nouveau ticket\'}}</h2><div><button class=\"btn btn-default btn-sm\" ng-if=\"vm.meta.manager && vm.ticket.id\" ng-click=\"vm.plan()\">Créer une récurrence</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.ticket=null\">Fermer la fiche</button></div></div><p ng-if=\"vm.ticket.scheduleId\" class=\"text-info\">Occurrence du {{vm.ticket.occurrenceDate | date:\'dd/MM/yyyy\'}} — récurrence #{{vm.ticket.scheduleId}}</p><p ng-if=\"vm.closed(vm.ticket.status)\" class=\"alert alert-info\">Ce ticket est {{vm.label(vm.ticket.status) | lowercase}}. <button class=\"btn btn-default btn-xs\" ng-if=\"vm.canClose\" ng-disabled=\"vm.saving\" ng-click=\"vm.reopen()\">Rouvrir le ticket</button></p><form name=\"ticketForm\" ng-submit=\"vm.save()\" novalidate><fieldset ng-disabled=\"!vm.editable || vm.saving\"><div class=\"form-group\"><label for=\"ticket-title\">Titre *</label><input id=\"ticket-title\" class=\"form-control\" ng-model=\"vm.ticket.subject\" required maxlength=\"255\"></div><div class=\"row\"><div class=\"col-sm-6 form-group\"><label for=\"ticket-area\">Zone *</label><select id=\"ticket-area\" class=\"form-control\" ng-disabled=\"vm.ticket.id\" ng-model=\"vm.ticket.areaId\" ng-options=\"area.id as area.label for area in vm.meta.areas\" ng-change=\"vm.changeArea()\" required></select></div><div class=\"col-sm-6 form-group\"><label for=\"ticket-type\">Type *</label><select id=\"ticket-type\" class=\"form-control\" ng-model=\"vm.ticket.type\" ng-options=\"type as vm.label(type) for type in vm.meta.types\" ng-change=\"vm.changeType()\" required></select></div></div><div class=\"row\"><div class=\"col-sm-6 form-group\"><label for=\"ticket-category\">Catégorie</label><select id=\"ticket-category\" class=\"form-control\" ng-model=\"vm.ticket.categoryId\" ng-options=\"category.id as category.label + (category.active ? \'\' : \' (archivée)\') for category in vm.categories(null,vm.ticket.categoryId)\" ng-change=\"vm.ticket.subcategoryId=null\"><option value=\"\">Non classé</option></select></div><div class=\"col-sm-6 form-group\"><label for=\"ticket-subcategory\">Sous-catégorie</label><select id=\"ticket-subcategory\" class=\"form-control\" ng-model=\"vm.ticket.subcategoryId\" ng-options=\"category.id as category.label + (category.active ? \'\' : \' (archivée)\') for category in vm.categories(vm.ticket.categoryId,vm.ticket.subcategoryId)\" ng-disabled=\"!vm.ticket.categoryId\"><option value=\"\">Aucune</option></select></div></div><div class=\"row\"><div class=\"col-sm-4 form-group\"><label for=\"ticket-status\">État *</label><select id=\"ticket-status\" class=\"form-control\" ng-model=\"vm.ticket.status\" required><option ng-repeat=\"status in vm.meta.statuses\" value=\"{{status}}\" ng-disabled=\"vm.closed(status) && !vm.canClose\">{{vm.label(status)}}</option></select></div><div class=\"col-sm-4 form-group\"><label for=\"ticket-priority\">Priorité</label><select id=\"ticket-priority\" class=\"form-control\" ng-model=\"vm.ticket.priority\" ng-options=\"priority as vm.label(priority) for priority in vm.meta.priorities\"></select></div><div class=\"col-sm-4 form-group\"><label for=\"ticket-progress\">Avancement (%)</label><input id=\"ticket-progress\" class=\"form-control\" type=\"number\" min=\"0\" max=\"100\" step=\"1\" ng-model=\"vm.ticket.doneRatio\" required></div></div><div class=\"form-group\"><label for=\"ticket-assignee\">Responsable</label><select id=\"ticket-assignee\" class=\"form-control\" ng-model=\"vm.ticket.assigneeId\" ng-options=\"user.id as user.label for user in vm.users()\"><option value=\"\">À affecter</option></select></div><div class=\"form-group\"><label for=\"ticket-watchers\">Observateurs</label><select id=\"ticket-watchers\" class=\"form-control\" multiple=\"multiple\" ng-model=\"vm.ticket.watcherIds\" ng-options=\"user.id as user.label for user in vm.users()\"></select><p class=\"help-block\">Les observateurs peuvent lire et commenter ce ticket dans leur zone.</p></div><div class=\"row\"><div class=\"col-sm-6 form-group\"><label for=\"ticket-start\">Début prévu</label><input id=\"ticket-start\" type=\"date\" class=\"form-control\" ng-model=\"vm.ticket.startDate\"></div><div class=\"col-sm-6 form-group\"><label for=\"ticket-due\">Échéance</label><input id=\"ticket-due\" type=\"date\" class=\"form-control\" ng-model=\"vm.ticket.dueDate\"></div></div><div class=\"row\"><div class=\"col-sm-6 form-group\"><label for=\"ticket-estimate\">Durée estimée (heures)</label><input id=\"ticket-estimate\" class=\"form-control\" type=\"number\" min=\"0\" step=\"0.01\" ng-model=\"vm.ticket.estimatedHours\"></div><div class=\"col-sm-6 form-group\"><label for=\"ticket-spent\">Durée passée (heures)</label><input id=\"ticket-spent\" class=\"form-control\" type=\"number\" min=\"0\" step=\"0.01\" ng-model=\"vm.ticket.spentHours\"></div></div><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"vm.ticket.privateTicket\"> Ticket confidentiel</label><p class=\"help-block\">L’accès reste limité aux participants et aux responsables autorisés de la zone.</p><h3>Rattachements métier</h3><div class=\"row\"><div class=\"col-sm-6 form-group\"><label for=\"ticket-contract-search\">Contrat</label><div class=\"input-group\"><input id=\"ticket-contract-search\" class=\"form-control\" ng-model=\"vm.contractSearch\" placeholder=\"Référence ou nom\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.lookup(\'contract\')\">Chercher</button></span></div><select aria-label=\"Contrat rattaché\" class=\"form-control\" ng-model=\"vm.ticket.contractId\" ng-options=\"value.id as value.label for value in vm.contractResults\"><option value=\"\">{{vm.ticket.contractId ? \'Contrat #\'+vm.ticket.contractId : \'Aucun contrat\'}}</option></select><button type=\"button\" class=\"btn btn-link btn-xs\" ng-if=\"vm.ticket.contractId\" ng-click=\"vm.ticket.contractId=null\">Retirer le contrat</button></div><div class=\"col-sm-6 form-group\"><label for=\"ticket-equipment-search\">Équipement</label><div class=\"input-group\"><input id=\"ticket-equipment-search\" class=\"form-control\" ng-model=\"vm.equipmentSearch\" placeholder=\"Code ou libellé\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.lookup(\'equipment\')\">Chercher</button></span></div><select aria-label=\"Équipement rattaché\" class=\"form-control\" ng-model=\"vm.ticket.equipmentId\" ng-options=\"value.id as value.label for value in vm.equipmentResults\"><option value=\"\">{{vm.ticket.equipmentId ? \'Équipement #\'+vm.ticket.equipmentId : \'Aucun équipement\'}}</option></select><button type=\"button\" class=\"btn btn-link btn-xs\" ng-if=\"vm.ticket.equipmentId\" ng-click=\"vm.ticket.equipmentId=null\">Retirer l’équipement</button></div></div><div class=\"row\"><div class=\"col-sm-8 form-group\"><label for=\"ticket-sector\">Secteur / lieu d’intervention</label><input id=\"ticket-sector\" class=\"form-control\" ng-model=\"vm.ticket.sector\" maxlength=\"255\"></div><div class=\"col-sm-4 form-group\"><label for=\"ticket-parent\">Ticket parent (numéro)</label><input id=\"ticket-parent\" class=\"form-control\" type=\"number\" min=\"1\" step=\"1\" ng-model=\"vm.ticket.parentId\"></div></div><h3>Localisation</h3><div class=\"form-group\"><label for=\"ticket-address\">Adresse / indications d’accès</label><textarea id=\"ticket-address\" class=\"form-control\" ng-model=\"vm.ticket.address\" rows=\"2\" maxlength=\"1000\"></textarea></div><div class=\"row\"><div class=\"col-sm-4 form-group\"><label for=\"ticket-latitude\">Latitude</label><input id=\"ticket-latitude\" class=\"form-control\" type=\"number\" min=\"-90\" max=\"90\" step=\"any\" ng-model=\"vm.ticket.latitude\"></div><div class=\"col-sm-4 form-group\"><label for=\"ticket-longitude\">Longitude</label><input id=\"ticket-longitude\" class=\"form-control\" type=\"number\" min=\"-180\" max=\"180\" step=\"any\" ng-model=\"vm.ticket.longitude\"></div><div class=\"col-sm-4 form-group\"><label>&nbsp;</label><button type=\"button\" class=\"btn btn-default btn-block\" ng-disabled=\"vm.locating\" ng-click=\"vm.locate()\"><i class=\"fa fa-location-arrow\"></i> Ma position</button></div></div><p class=\"text-muted\" ng-if=\"vm.geoNotice\">{{vm.geoNotice}}</p><h3>Description</h3><ticket-editor ng-if=\"vm.editable\" ng-model=\"vm.ticket.descriptionMarkdown\" ticket-id=\"vm.ticket.id\" draft-key=\"vm.draftKey\" busy=\"vm.descriptionBusy\"></ticket-editor><div class=\"ticket-markdown\" ng-if=\"!vm.editable\" ng-bind-html=\"vm.descriptionHtml\" ticket-images></div><div class=\"form-group\"><label for=\"ticket-attachments\">Pièces jointes (20 Mo maximum par fichier)</label><input id=\"ticket-attachments\" type=\"file\" multiple=\"multiple\" ticket-file-picker=\"vm.uploadFiles(files)\" ng-disabled=\"vm.fileBusy\"><p ng-if=\"vm.fileBusy\">Transmission des fichiers…</p><ul><li ng-repeat=\"file in vm.pendingAttachments\">{{file.fileName}} — prêt à être enregistré <button type=\"button\" class=\"btn btn-link btn-xs\" ng-click=\"vm.pendingAttachments.splice($index,1)\">Retirer</button></li></ul></div><div class=\"form-group\"><label for=\"ticket-resolution\">Conclusion / motif de clôture</label><textarea id=\"ticket-resolution\" class=\"form-control\" ng-model=\"vm.ticket.resolution\" maxlength=\"2000\" rows=\"2\" ng-required=\"vm.closed(vm.ticket.status)\"></textarea></div></fieldset><button class=\"btn btn-primary\" type=\"submit\" ng-if=\"vm.editable\" ng-disabled=\"ticketForm.$invalid || vm.saving || vm.descriptionBusy || vm.commentBusy || vm.fileBusy\"><i class=\"fa fa-save\"></i> Enregistrer le ticket</button></form><div ng-if=\"vm.detail\"><h3>Pièces jointes</h3><ul><li ng-repeat=\"file in vm.detail.attachments\"><button type=\"button\" class=\"btn btn-link\" ng-click=\"vm.download(file)\">{{file.fileName}}</button> <small>{{file.sizeBytes/1024 | number:0}} Ko</small></li></ul><p ng-if=\"!vm.detail.attachments.length\" class=\"text-muted\">Aucune pièce jointe.</p><p class=\"text-muted\">Durées cumulées avec les sous-tickets autorisés : {{vm.detail.totalEstimatedHours | number:2}} h estimées, {{vm.detail.totalSpentHours | number:2}} h passées.</p><p class=\"text-muted\" ng-if=\"vm.detail.ticket.closedAt\">Clôturé le {{vm.detail.ticket.closedAt | date:\'dd/MM/yyyy HH:mm\'}}.</p><h3>Historique et échanges</h3><p class=\"text-muted\">Créé le {{vm.detail.ticket.createdAt | date:\'dd/MM/yyyy HH:mm\'}} par {{vm.name(vm.ticket.authorId)}}. Dernière modification le {{vm.detail.ticket.updatedAt | date:\'dd/MM/yyyy HH:mm\'}}.</p><article class=\"ticket-journal\" ng-repeat=\"line in vm.detail.history track by line.entry.id\"><p><strong>{{vm.name(line.entry.actorId)}}</strong> · {{line.entry.createdAt | date:\'dd/MM/yyyy HH:mm\'}} <span class=\"label label-warning\" ng-if=\"line.entry.privateNote\">Note privée</span></p><div class=\"ticket-markdown\" ng-bind-html=\"line.html\" ticket-images></div><ul ng-if=\"line.changes.length\"><li ng-repeat=\"change in line.changes\"><strong>{{change.label}} :</strong> {{change.value}}</li></ul></article><div ng-if=\"vm.detail.canComment && !vm.closed(vm.ticket.status)\"><h4>Ajouter une note</h4><ticket-editor ng-model=\"vm.commentMarkdown\" ticket-id=\"vm.ticket.id\" draft-key=\"vm.commentDraftKey\" busy=\"vm.commentBusy\"></ticket-editor><label><input type=\"checkbox\" ng-model=\"vm.privateNote\"> Note privée : visible uniquement par son auteur et les responsables autorisés</label><br><button type=\"button\" class=\"btn btn-default\" ng-disabled=\"!vm.commentMarkdown || vm.saving || vm.commentBusy || vm.descriptionBusy\" ng-click=\"vm.addComment()\">Ajouter la note</button></div></div></div></div></div></div><div class=\"ticket-card\" ng-if=\"vm.section===\'categories\' && vm.meta.manager\"><h2>Classement par type de ticket</h2><p>Une catégorie contient des sous-catégories. Archivez les valeurs devenues inutiles : les tickets existants conservent leur classement.</p><div class=\"row\"><div class=\"col-md-7\"><label for=\"category-filter\">Type</label><select id=\"category-filter\" class=\"form-control\" ng-model=\"vm.categoryType\" ng-options=\"type as vm.label(type) for type in vm.meta.types\" ng-change=\"vm.newCategory()\"><option value=\"\">Tous les types</option></select><table class=\"table table-hover\"><thead><tr><th>Type</th><th>Catégorie / sous-catégorie</th><th>État</th><th></th></tr></thead><tbody><tr ng-repeat=\"category in vm.meta.categories | filter:(vm.categoryType ? {type:vm.categoryType} : {})\"><td>{{vm.label(category.type)}}</td><td>{{category.parentId ? vm.categoryName(category.parentId)+\' → \' : \'\'}}{{category.label}}</td><td>{{category.active ? \'Active\' : \'Archivée\'}}</td><td><button class=\"btn btn-default btn-xs\" ng-click=\"vm.editCategory(category)\">Modifier</button></td></tr><tr ng-if=\"!vm.meta.categories.length\"><td colspan=\"4\">Créez une première catégorie pour commencer.</td></tr></tbody></table></div><div class=\"col-md-5\"><h3>{{vm.category.id ? \'Modifier le classement\' : \'Ajouter un classement\'}}</h3><form name=\"categoryForm\" ng-submit=\"vm.saveCategory()\"><div class=\"form-group\"><label>Type<select class=\"form-control\" ng-disabled=\"vm.category.id\" ng-model=\"vm.category.type\" ng-options=\"type as vm.label(type) for type in vm.meta.types\" ng-change=\"vm.category.parentId=null\" required></select></label></div><div class=\"form-group\"><label>Catégorie parente<select class=\"form-control\" ng-disabled=\"vm.category.id\" ng-model=\"vm.category.parentId\" ng-options=\"parent.id as parent.label for parent in vm.categoryParents()\"><option value=\"\">Aucune — créer une catégorie</option></select></label></div><div class=\"form-group\"><label>Libellé<input class=\"form-control\" ng-model=\"vm.category.label\" maxlength=\"150\" required></label></div><label><input type=\"checkbox\" ng-model=\"vm.category.active\"> Active pour les nouvelles saisies</label><div><button class=\"btn btn-primary\" ng-disabled=\"categoryForm.$invalid || vm.saving\">Enregistrer</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.newCategory()\">Nouveau</button></div></form></div></div></div><div class=\"ticket-card\" ng-if=\"vm.section===\'schedules\' && vm.meta.manager\"><div class=\"ticket-card-heading\"><h2>Tâches récurrentes</h2><button class=\"btn btn-default\" ng-disabled=\"vm.saving\" ng-click=\"vm.generate()\">Préparer les tâches dues</button></div><p>Pour créer une série, ouvrez un ticket puis choisissez « Créer une récurrence ». Chaque occurrence aura son propre ticket et son historique. Le traitement automatique vérifie les échéances chaque heure.</p><table class=\"table table-hover\"><thead><tr><th>Nom</th><th>Zone</th><th>Fréquence</th><th>Prochaine date</th><th>État</th><th></th></tr></thead><tbody><tr ng-repeat=\"schedule in vm.schedules track by schedule.id\"><td>{{schedule.label}}</td><td>{{vm.areaName(schedule.areaId)}}</td><td>Tous les {{schedule.intervalCount}} {{vm.label(schedule.frequency)}}</td><td>{{schedule.nextDate | date:\'dd/MM/yyyy\'}}</td><td>{{schedule.active ? \'Active\' : \'Arrêtée\'}}</td><td><button class=\"btn btn-default btn-xs\" ng-click=\"vm.editSchedule(schedule)\">Modifier</button> <button class=\"btn btn-default btn-xs\" ng-if=\"schedule.active\" ng-disabled=\"vm.saving\" ng-click=\"vm.stopSchedule(schedule)\">Arrêter</button></td></tr><tr ng-if=\"!vm.schedules.length\"><td colspan=\"6\">Aucune récurrence.</td></tr></tbody></table><form name=\"scheduleForm\" ng-if=\"vm.schedule\" ng-submit=\"vm.saveSchedule()\"><h3>{{vm.schedule.id ? \'Modifier la série\' : \'Nouvelle série\'}}</h3><p>Modèle : {{vm.scheduleTemplate.subject}} — {{vm.label(vm.scheduleTemplate.type)}}. Les tickets déjà générés sont conservés.</p><div class=\"row\"><div class=\"col-md-6 form-group\"><label>Nom<input class=\"form-control\" ng-model=\"vm.schedule.label\" required maxlength=\"150\"></label></div><div class=\"col-md-3 form-group\"><label>Début<input class=\"form-control\" type=\"date\" ng-model=\"vm.schedule.startDate\" required></label></div><div class=\"col-md-3 form-group\"><label>Fin facultative<input class=\"form-control\" type=\"date\" ng-model=\"vm.schedule.endDate\"></label></div></div><div class=\"row\"><div class=\"col-sm-3 form-group\"><label>Tous les<input class=\"form-control\" type=\"number\" min=\"1\" max=\"366\" step=\"1\" ng-model=\"vm.schedule.intervalCount\" required></label></div><div class=\"col-sm-3 form-group\"><label>Unité<select class=\"form-control\" ng-model=\"vm.schedule.frequency\" required><option value=\"DAYS\">Jours</option><option value=\"WEEKS\">Semaines</option><option value=\"MONTHS\">Mois</option><option value=\"YEARS\">Années</option></select></label></div><div class=\"col-sm-3 form-group\"><label>Délai de réalisation (jours)<input class=\"form-control\" type=\"number\" min=\"0\" max=\"3660\" step=\"1\" ng-model=\"vm.schedule.dueAfterDays\" required></label></div><div class=\"col-sm-3 form-group\"><label>Fuseau horaire<input class=\"form-control\" ng-model=\"vm.schedule.zoneId\" required placeholder=\"Europe/Paris\"></label></div></div><label><input type=\"checkbox\" ng-model=\"vm.schedule.active\"> Série active</label><p class=\"help-block\">Une nouvelle série commençant dans le passé démarre à la première date à venir. Les retards d’une série déjà active sont repris après une interruption. Une répétition au 31 utilise le dernier jour des mois plus courts.</p><div><button class=\"btn btn-primary\" ng-disabled=\"scheduleForm.$invalid || vm.saving\">Enregistrer la récurrence</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.schedule=null\">Annuler</button></div></form></div></div>");
$templateCache.put("app/business/teamwork/redmine-createticket-dialog.controller.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-subject\" id=\"myRedmineLabel\" translate=\"wamasysApp.redmine.titleAdd\">add ticket</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"wamasysApp.redmine.area\">area</label>:<label>{{vm.currentAgence}}</label><!--             <label class=\"control-label\" translate=\"wamasysApp.redmine.area\" for=\"field_area\">area</label> --><!--             <input type=\"text\" readonly=\"readonly\" class=\"form-control\" name=\"area\" id=\"field_area\" --><!--                     ng-model=\"vm.currentAgence\" --><!--                     /> --></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.redmine.subject\" for=\"field_subject\">subject</label><input type=\"text\" required class=\"form-control\" name=\"subject\" id=\"field_subject\" maxlength=\"256\" ng-model=\"vm.redmineIssue.subject\"><div ng-show=\"editForm.subject.$invalid\"><p class=\"help-block\" ng-show=\"editForm.subject.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.subject.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"256\">This field cannot be more than 256.</p></div></div><div class=\"form-group\"><label translate=\"wamasysApp.redmine.user\" for=\"field_user\">user</label><ui-select tagging ng-model=\"vm.redmineIssue.assigned_to_id\" theme=\"selectize\"><ui-select-match>{{$select.selected.firstName}} {{$select.selected.lastName}} ({{$select.selected.login}} )</ui-select-match><ui-select-choices repeat=\"user.redmineUserId as user in vm.users | filter: $select.search  track by user.id\">{{user.firstName}} {{user.lastName}} ({{user.login}} )</ui-select-choices></ui-select><!--            <select  class=\"form-control\" id=\"field_user\" name=\"user\" ng-model=\"vm.redmineIssue.assigned_to_id\" ng-options=\"user.redmineUserId as user.login for user in vm.users track by user.id\">\n                <option value=\"\"></option>\n            </select> --></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.redmine.description\" for=\"field_description\">description</label><textarea class=\"form-control\" name=\"description\" id=\"field_description\" maxlength=\"20000\" ng-model=\"vm.redmineIssue.description\" required></textarea><div ng-show=\"editForm.description.$invalid\"><p class=\"help-block\" ng-show=\"editForm.description.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><p class=\"help-block\" ng-show=\"editForm.description.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"20000\">This field cannot be more than 20000.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/teamwork/teamwork.html","<div ng-cloak><p has-module=\"TEAM\"><a class=\"btn btn-primary\" ui-sref=\"native-tickets\"><i class=\"fa fa-ticket\"></i> Ouvrir les tickets et tâches Wama</a></p><div class=\"row\"><div class=\"col-md-12\"><div><div class=\"row\"><div class=\"col-md-12\" has-module=\"TEAM\"><uib-tabset active=\"vm.indextab\"><uib-tab ng-click=\"vm.myIssues()\" index=\"0\"><uib-tab-heading><span>Tickets assigned to me</span></uib-tab-heading></uib-tab><uib-tab ng-click=\"vm.issuesNotAssigned()\" index=\"1\"><uib-tab-heading><span>Tickets not assigned</span></uib-tab-heading></uib-tab><uib-tab ng-click=\"vm.issuesCreatedByMe()\" index=\"2\"><uib-tab-heading><span>Tickets created by me</span></uib-tab-heading></uib-tab></uib-tabset><div class=\"sortable-grid ui-sortable\"><div class=\"\" id=\"wid-id-5\" data-widget-colorbutton=\"false\" data-widget-editbutton=\"false\" data-widget-togglebutton=\"false\" data-widget-deletebutton=\"false\" data-widget-fullscreenbutton=\"false\" data-widget-custombutton=\"false\" data-widget-collapsed=\"false\" data-widget-sortable=\"false\" role=\"widget\"><br><div role=\"content\"><div class=\"widget-body no-padding\"><div class=\"table-responsive no-margin custom-scroll\" style=\"height:500px; overflow-y: scroll\"><table class=\"table highlight table-border-0 table-hover table-condensed\"><thead><tr><th>subject</th><th class=\"\">priority</th><th class=\"\">status</th><th class=\"\">tracker</th><th ng-show=\"vm.issuefilter != \'createdbyme\'\">author</th><th ng-show=\"vm.issuefilter != \'myissues\'\">Assigned to</th><th class=\"\">Last updated</th></tr></thead><tbody><tr ng-repeat=\"issue in vm.listIssues.issues track by issue.id\"><td class=\"v-align-m\"><a href=\"{{vm.user.teamworkUrl}}/issues/{{issue.id}}\" target=\"_blank\">{{issue.subject}}</a></td><td class=\"v-align-m\">{{issue.priority.name}}</td><td class=\"v-align-m\">{{issue.status.name}}</td><td class=\"v-align-m\">{{issue.tracker.name}}</td><td ng-show=\"vm.issuefilter != \'createdbyme\'\" class=\"v-align-m\">{{issue.author.name}}</td><td ng-show=\"vm.issuefilter != \'myissues\'\" class=\"v-align-m\">{{issue.assigned_to.name}}</td><td class=\"v-align-m\">{{issue.updated_on}}</td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/business/teamwork/ticket-editor.html","<div class=\"ticket-editor\"><div class=\"btn-toolbar\" role=\"toolbar\" aria-label=\"Mise en forme du texte\"><div class=\"btn-group btn-group-sm\"><button type=\"button\" class=\"btn btn-default\" ng-mousedown=\"$event.preventDefault()\" ng-click=\"format(\'bold\')\" title=\"Gras\"><strong>G</strong></button> <button type=\"button\" class=\"btn btn-default\" ng-mousedown=\"$event.preventDefault()\" ng-click=\"format(\'italic\')\" title=\"Italique\"><em>I</em></button> <button type=\"button\" class=\"btn btn-default\" ng-mousedown=\"$event.preventDefault()\" ng-click=\"format(\'formatBlock\',\'h2\')\">Titre</button> <button type=\"button\" class=\"btn btn-default\" ng-mousedown=\"$event.preventDefault()\" ng-click=\"format(\'insertUnorderedList\')\" title=\"Liste à puces\">• Liste</button> <button type=\"button\" class=\"btn btn-default\" ng-mousedown=\"$event.preventDefault()\" ng-click=\"format(\'insertOrderedList\')\" title=\"Liste numérotée\">1. Liste</button> <button type=\"button\" class=\"btn btn-default\" ng-mousedown=\"$event.preventDefault()\" ng-click=\"format(\'formatBlock\',\'blockquote\')\">Citation</button> <button type=\"button\" class=\"btn btn-default\" ng-mousedown=\"$event.preventDefault()\" ng-click=\"format(\'createLink\')\">Lien</button> <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"busy\" ng-click=\"chooseImage()\"><i class=\"fa fa-image\"></i> Image</button></div><div class=\"btn-group btn-group-sm pull-right\"><button type=\"button\" class=\"btn btn-default\" ng-class=\"{active:mode===\'visual\'}\" ng-click=\"switchMode(\'visual\')\">Visuel</button> <button type=\"button\" class=\"btn btn-default\" ng-class=\"{active:mode===\'markdown\'}\" ng-click=\"switchMode(\'markdown\')\">Markdown</button></div></div><div contenteditable=\"true\" role=\"textbox\" aria-label=\"Texte du ticket\" aria-multiline=\"true\" class=\"ticket-editor-visual\" ng-show=\"mode===\'visual\'\" ticket-images></div><textarea class=\"form-control ticket-editor-source\" aria-label=\"Source Markdown\" ng-model=\"raw\" ng-change=\"rawChanged()\" ng-show=\"mode===\'markdown\'\" rows=\"12\"></textarea><input type=\"file\" accept=\"image/png,image/jpeg\" multiple=\"multiple\" style=\"display:none\" aria-label=\"Ajouter des images\"><p class=\"help-block\">Collez une image avec Ctrl+V ou utilisez « Image ». Le texte est conservé en Markdown.</p><p class=\"text-info\" ng-if=\"busy\"><i class=\"fa fa-spinner fa-spin\"></i> Chargement en cours…</p><p class=\"text-danger\" role=\"alert\" ng-if=\"error\">{{error}}</p></div>");
$templateCache.put("app/business/type-contrat/type-contrat-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.contractType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.contractType.delete.question\" translate-values=\"{id: \'{{vm.contractType.id}}\'}\">Are you sure you want to delete this ContractType?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/type-contrat/type-contrat-detail.html","<div><h2><span translate=\"wamasysApp.contractType.detail.title\">ContractType</span> {{vm.contractType.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"global.field.code\">Code</span></dt><dd><span>{{vm.contractType.code}}</span></dd><hr><dt><span translate=\"wamasysApp.contractType.label\">Libelle</span></dt><dd><span>{{vm.contractType.label}}<span></span></span></dd><hr><dt><span translate=\"global.field.isDeleted\">isDeleted</span></dt><dd><span>{{vm.contractType.deleted}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/type-contrat/type-contrat-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myContractTypeLabel\" translate=\"wamasysApp.contractType.home.createOrEditLabel\">Create or edit a ContractType</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.contractType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"global.field.code\" for=\"field_code\">Code</label><input ng-readonly=\"vm.contractType.id != null\" required type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.contractType.code\" ng-maxlength=\"64\" ng-pattern=\"/^[_.A-Z0-9-]*$/\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.pattern\" translate=\"wamasysApp.contractType.codeArticleFormatError\">The article code can only contain upper-case letters and digits.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"64\">This field cannot be longer than 64 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.contractType.label\" for=\"field_label\">Libelle</label><input type=\"text\" class=\"form-control\" name=\"label\" id=\"field_label\" ng-model=\"vm.contractType.label\" required ng-maxlength=\"50\"><div ng-show=\"editForm.label.$invalid\"><p class=\"help-block\" ng-show=\"editForm.label.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.label.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.contractType.id\"><label class=\"control-deleted\" translate=\"global.field.isDeleted\" for=\"field_deleted\">deleted</label><input type=\"checkbox\" class=\"form-control\" name=\"deleted\" id=\"field_deleted\" ng-model=\"vm.contractType.deleted\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/type-contrat/type-contrats.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.contractType.home.title\">ContractTypes</span> <small class=\"text-muted\" translate=\"global.configurationScope.organization\">Paramétrage commun à toute l\'organisation</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"type-contrat.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.contractType.home.createLabel\">Create new ContractType</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"label\"><span translate=\"wamasysApp.contractType.label\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"global.field.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deleted\"><span translate=\"global.field.isDeleted\">isDeleted</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"contractType in vm.contractTypes track by contractType.id\"><td><a ui-sref=\"type-contrat-detail({id:contractType.id})\">{{contractType.id}}</a></td><td>{{contractType.label}}</td><td>{{contractType.code}}</td><td>{{contractType.deleted}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"type-contrat-detail({id:contractType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"type-contrat.edit({id:contractType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"type-contrat.delete({id:contractType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/water-quality/water-quality-detail.html","<h3>Contrôle n° {{vm.detail.check.id}} — {{vm.detail.check.locationLabel}} <span class=\"label label-default\">{{vm.labels[vm.detail.check.status]}}</span></h3><p>AREA {{vm.areaLabel(vm.detail.check.areaId)}} · Date souhaitée : <strong>{{vm.detail.check.plannedDate | date:\'dd/MM/yyyy\'}}</strong></p><p ng-if=\"vm.detail.check.comment\">{{vm.detail.check.comment}}</p><p class=\"alert alert-warning\" ng-if=\"vm.detail.check.status===\'CANCELLED\'\">Cette fiche est annulée. {{vm.detail.check.statusComment}}</p><section class=\"quality-progress\" aria-label=\"Progression du contrôle\"><ol class=\"quality-progress-steps\"><li ng-repeat=\"step in vm.controlSteps track by $index\" ng-class=\"{\'is-complete\':$index<vm.progressStep(), \'is-current\':$index===vm.progressStep() && vm.detail.check.status!==\'CANCELLED\'}\" ng-attr-aria-current=\"{{$index===vm.progressStep() && vm.detail.check.status!==\'CANCELLED\' ? \'step\' : undefined}}\"><span class=\"quality-progress-marker\" aria-hidden=\"true\"><i class=\"fa fa-check\" ng-if=\"$index<vm.progressStep()\"></i><span ng-if=\"$index>=vm.progressStep()\">{{$index+1}}</span></span><!-- Comparaison inversée pour éviter un signe inférieur dans le texte traité par le minificateur HTML. --> <span class=\"quality-progress-label\">{{step}}<small>{{vm.progressStep()>$index ? \'Terminée\' : vm.detail.check.status===\'CANCELLED\' ? \'Non poursuivie\' : $index===vm.progressStep() ? \'En cours\' : \'À venir\'}}</small></span></li></ol><p class=\"quality-progress-summary\" role=\"status\"><span ng-if=\"vm.detail.check.status===\'CANCELLED\'\">Contrôle annulé : aucune étape en cours.</span> <span ng-if=\"vm.detail.check.status===\'VALIDATED\'\">Contrôle validé : toutes les étapes sont terminées.</span> <span ng-if=\"vm.detail.check.status!==\'CANCELLED\' && vm.detail.check.status!==\'VALIDATED\' && !vm.detail.check.sampledAt\">Prélèvement : renseignez le jour, l’heure et l’opérateur effectifs.</span> <span ng-if=\"vm.detail.check.status!==\'CANCELLED\' && vm.detail.check.status!==\'VALIDATED\' && vm.detail.check.sampledAt\">Résultats : {{vm.detail.analyses.length-vm.missingCount()}} sur {{vm.detail.analyses.length}} renseignés.<span ng-if=\"!vm.missingCount()\"> Le contrôle est prêt à être validé.</span></span></p></section><button type=\"button\" class=\"btn btn-default\" ng-if=\"vm.editable() && !vm.detail.check.sampledAt\" ng-click=\"vm.editPlanning()\" ng-disabled=\"vm.busy\">Modifier la planification</button><form novalidate name=\"planningForm\" ng-if=\"vm.planning\" class=\"well\" ng-submit=\"vm.savePlanning()\"><fieldset ng-disabled=\"vm.busy\"><label>Lieu<select class=\"form-control\" ng-model=\"vm.planning.locationId\" ng-options=\"l.id as l.label for l in vm.activeLocations()\" required></select></label><label>Date souhaitée<input type=\"date\" class=\"form-control\" ng-model=\"vm.planning.plannedDate\" required></label><label>Opérateur prévu<select class=\"form-control\" ng-model=\"vm.planning.operatorId\" ng-options=\"o.id as o.label for o in vm.operators(vm.planning.locationId,false)\"><option value=\"\">À affecter</option></select></label><label>Consignes<textarea class=\"form-control\" maxlength=\"4000\" ng-model=\"vm.planning.comment\"></textarea></label><button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"planningForm.$invalid\">Enregistrer la planification</button></fieldset></form><section class=\"panel panel-default\" style=\"margin-top:15px\"><div class=\"panel-heading\"><h4 class=\"panel-title\">Prélèvement réel</h4></div><div class=\"panel-body\"><p ng-if=\"vm.detail.check.sampledAt\"><strong>{{vm.detail.check.sampledAt | date:\'dd/MM/yyyy HH:mm\'}}</strong> · {{vm.detail.check.operatorName}}</p><p ng-if=\"!vm.detail.check.sampledAt\">Le prélèvement n’a pas encore été réalisé. Sa date souhaitée ne remplace pas la date et l’heure réelles.</p><form novalidate name=\"samplingForm\" ng-if=\"vm.editable() && !vm.detail.check.sampledAt\" ng-submit=\"vm.sample()\"><fieldset ng-disabled=\"vm.busy\"><label>Jour et heure réels<input type=\"datetime-local\" class=\"form-control\" ng-model=\"vm.sampling.sampledAt\" required></label><label>Opérateur effectif<select class=\"form-control\" ng-model=\"vm.sampling.operatorId\" ng-options=\"o.id as o.label for o in vm.operators(vm.detail.check.locationId,true)\" required></select></label><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"samplingForm.$invalid\">Enregistrer le prélèvement</button></fieldset></form></div></section><section class=\"panel panel-default\"><div class=\"panel-heading\"><h4 class=\"panel-title\">Mesures terrain</h4></div><div class=\"panel-body\"><div ng-repeat=\"line in vm.lines(\'FIELD\') track by line.id\" ng-include=\"\'app/business/water-quality/water-quality-result.html\'\"></div><p ng-if=\"!vm.lines(\'FIELD\').length\">Aucune mesure terrain prévue.</p></div></section><section class=\"panel panel-default\"><div class=\"panel-heading\"><h4 class=\"panel-title\">Analyses de laboratoire</h4></div><div class=\"panel-body\"><p>Après le prélèvement, renseignez l’envoi et les paramètres attendus. Revenez ensuite sur cette fiche pour saisir les résultats et joindre le rapport.</p><div class=\"well well-sm\" ng-repeat=\"dispatch in vm.detail.dispatches track by dispatch.id\"><strong>{{dispatch.laboratory}} — {{dispatch.reference}}</strong><p>Envoyé le {{dispatch.sentAt | date:\'dd/MM/yyyy HH:mm\'}} · Résultats attendus le {{dispatch.expectedAt | date:\'dd/MM/yyyy HH:mm\'}}</p><button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"vm.editable()\" ng-click=\"vm.editLab(dispatch)\" ng-disabled=\"vm.busy\">Modifier l’envoi</button></div><button type=\"button\" class=\"btn btn-default\" ng-if=\"vm.editable() && vm.detail.check.sampledAt && vm.unassignedLabCount()\" ng-click=\"vm.editLab()\" ng-disabled=\"vm.busy || vm.pendingLab\">Renseigner un envoi laboratoire</button><form novalidate name=\"labForm\" class=\"well\" ng-if=\"vm.lab\" ng-submit=\"vm.saveLab()\" style=\"margin-top:10px\"><fieldset ng-disabled=\"vm.busy || vm.pendingLab\"><div class=\"row\"><div class=\"col-sm-6\"><label>Laboratoire<input class=\"form-control\" ng-model=\"vm.lab.laboratory\" maxlength=\"150\" required></label></div><div class=\"col-sm-6\"><label>Référence<input class=\"form-control\" ng-model=\"vm.lab.reference\" maxlength=\"150\" required></label></div></div><div class=\"row\"><div class=\"col-sm-6\"><label>Date d’envoi<input type=\"datetime-local\" class=\"form-control\" ng-model=\"vm.lab.sentAt\" required></label></div><div class=\"col-sm-6\"><label>Résultats attendus le<input type=\"datetime-local\" class=\"form-control\" ng-model=\"vm.lab.expectedAt\" required></label></div></div><h5>Paramètres de cet envoi</h5><label class=\"checkbox\" ng-repeat=\"line in vm.labCandidates()\"><input type=\"checkbox\" ng-model=\"vm.labSelection[line.id]\" ng-disabled=\"!!line.dispatchId\">{{line.parameterLabel}} ({{line.unit}})</label></fieldset><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.busy || (labForm.$invalid && !vm.pendingLab)\">{{vm.pendingLab ? \'Réessayer la transmission\' : \'Enregistrer l’envoi\'}}</button></form><div ng-repeat=\"line in vm.lines(\'LAB\') track by line.id\" ng-include=\"\'app/business/water-quality/water-quality-result.html\'\"></div><p ng-if=\"!vm.lines(\'LAB\').length\">Aucune analyse laboratoire prévue.</p></div></section><div ng-if=\"vm.editable()\" class=\"well\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.extraAnalysis={source:\'FIELD\'}\" ng-disabled=\"vm.busy || vm.pendingAnalysis\">Ajouter un paramètre attendu</button><form novalidate name=\"extraForm\" ng-if=\"vm.extraAnalysis\" ng-submit=\"vm.addAnalysis()\"><fieldset ng-disabled=\"vm.busy || vm.pendingAnalysis\"><label>Paramètre<select class=\"form-control\" ng-model=\"vm.extraAnalysis.parameterId\" ng-options=\"p.id as p.label for p in vm.activeParameters()\" required></select></label><label>Origine<select class=\"form-control\" ng-model=\"vm.extraAnalysis.source\"><option value=\"FIELD\">Terrain</option><option value=\"LAB\">Laboratoire</option></select></label></fieldset><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.busy || (extraForm.$invalid && !vm.pendingAnalysis)\">Ajouter le paramètre</button></form></div><div ng-include=\"\'app/business/water-quality/water-quality-documents.html\'\"></div><div class=\"well\" ng-if=\"vm.canEdit\"><h4>État du contrôle : {{vm.labels[vm.detail.check.status]}}</h4><p ng-if=\"vm.missingCount()\">{{vm.missingCount()}} résultat(s) attendu(s) encore manquant(s).</p><button class=\"btn btn-success\" type=\"button\" ng-if=\"vm.detail.check.status===\'IN_PROGRESS\'\" ng-disabled=\"vm.busy || vm.missingCount()\" ng-click=\"vm.setStatus(\'VALIDATED\')\">Valider le contrôle</button> <button class=\"btn btn-default\" type=\"button\" ng-if=\"vm.detail.check.status===\'VALIDATED\' || (vm.detail.check.status===\'CANCELLED\' && vm.detail.check.sampledAt)\" ng-disabled=\"vm.busy\" ng-click=\"vm.setStatus(\'IN_PROGRESS\')\">Rouvrir pour compléter ou corriger</button> <button class=\"btn btn-default\" type=\"button\" ng-if=\"vm.detail.check.status===\'CANCELLED\' && !vm.detail.check.sampledAt\" ng-disabled=\"vm.busy\" ng-click=\"vm.setStatus(\'TO_DO\')\">Remettre à faire</button> <button class=\"btn btn-warning\" type=\"button\" ng-if=\"vm.detail.check.status!==\'CANCELLED\'\" ng-disabled=\"vm.busy\" ng-click=\"vm.setStatus(\'CANCELLED\')\">Annuler le contrôle</button><p class=\"help-block\">La validation confirme que la fiche est complète. Les alertes de qualité restent visibles si une valeur est hors limites.</p></div>");
$templateCache.put("app/business/water-quality/water-quality-documents.html","<section class=\"panel panel-default\"><div class=\"panel-heading\"><h4 class=\"panel-title\">Photos, justificatifs et rapports</h4></div><div class=\"panel-body\"><p>L’ajout du rapport ne remplit pas les résultats : saisissez chaque valeur séparément.</p><ul><li ng-repeat=\"file in vm.detail.attachments track by file.id\"><button type=\"button\" class=\"btn btn-link\" ng-click=\"vm.download(file)\" ng-disabled=\"vm.busy\">{{file.fileName}}</button> — {{vm.labels[file.kind]}}</li></ul><form novalidate name=\"uploadForm\" ng-if=\"vm.editable()\" ng-submit=\"vm.upload()\"><fieldset ng-disabled=\"vm.busy || vm.pendingUpload\"><label>Type<select class=\"form-control\" ng-model=\"vm.uploadForm.kind\"><option value=\"PHOTO\">Photo</option><option value=\"DOCUMENT\">Justificatif</option><option value=\"LAB_REPORT\" ng-if=\"vm.detail.dispatches.length\">Rapport laboratoire</option></select></label><label ng-if=\"vm.detail.dispatches.length\">Envoi concerné<select class=\"form-control\" ng-model=\"vm.uploadForm.dispatchId\" ng-options=\"d.id as (d.laboratory+\' — \'+d.reference) for d in vm.detail.dispatches\" ng-required=\"vm.uploadForm.kind===\'LAB_REPORT\'\"><option value=\"\">Aucun</option></select></label><label>Choisir un fichier<input type=\"file\" accept=\"application/pdf,image/jpeg,image/png\" water-quality-file=\"vm.fileSelected(file)\"></label><label ng-if=\"vm.uploadForm.kind===\'PHOTO\'\">Prendre une photo<input type=\"file\" accept=\"image/*\" capture=\"environment\" water-quality-file=\"vm.fileSelected(file)\"></label><p ng-if=\"vm.file\">{{vm.file.name}}</p></fieldset><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.busy || uploadForm.$invalid || (!vm.file && !vm.pendingUpload)\">{{vm.pendingUpload ? \'Réessayer l’envoi\' : \'Ajouter le fichier\'}}</button></form></div></section>");
$templateCache.put("app/business/water-quality/water-quality-planning.html","<h3>{{vm.section===\'planning\' ? \'Prélèvements à planifier et à réaliser\' : \'Suivi des prélèvements et des résultats\'}}</h3><p ng-if=\"vm.section===\'planning\'\">Préparez les paramètres à contrôler et une date souhaitée. Cette vue affiche par défaut les prélèvements « À faire ». Le jour et l’heure réels seront enregistrés lors du prélèvement.</p><p ng-if=\"vm.section===\'records\'\">Cette vue affiche par défaut les contrôles « En cours », après le prélèvement. Ouvrez une fiche pour compléter les mesures terrain, l’envoi au laboratoire et ses résultats, puis valider le contrôle. Le filtre « État » permet aussi de consulter les contrôles validés ou annulés. Les deux vues donnent accès aux mêmes fiches.</p><button type=\"button\" class=\"btn btn-primary\" ng-if=\"vm.canEdit\" ng-click=\"vm.newPlan()\" ng-disabled=\"vm.busy || vm.pendingPlan\">Planifier un prélèvement</button><form novalidate name=\"planForm\" ng-if=\"vm.showPlan\" ng-submit=\"vm.savePlan()\" class=\"well\" style=\"margin-top:15px\"><h4>Nouveau prélèvement planifié</h4><fieldset ng-disabled=\"vm.busy || vm.pendingPlan\"><div class=\"row\"><div class=\"col-sm-4 form-group\"><label>Lieu de prélèvement<select class=\"form-control\" ng-model=\"vm.draft.locationId\" ng-options=\"l.id as (l.label+\' — \'+vm.areaLabel(l.areaId)) for l in vm.activeLocations()\" required><option value=\"\">Choisir un lieu</option></select></label></div><div class=\"col-sm-4 form-group\"><label>Date souhaitée<input type=\"date\" class=\"form-control\" ng-model=\"vm.draft.plannedDate\" required></label></div><div class=\"col-sm-4 form-group\"><label>Opérateur prévu (facultatif)<select class=\"form-control\" ng-model=\"vm.draft.operatorId\" ng-options=\"o.id as o.label for o in vm.operators(vm.draft.locationId,false)\"><option value=\"\">À affecter</option></select></label></div></div><div class=\"form-group\"><label>Consignes<textarea class=\"form-control\" ng-model=\"vm.draft.comment\" maxlength=\"4000\"></textarea></label></div><h4>Paramètres attendus</h4><div class=\"row\" ng-repeat=\"line in vm.draft.analyses track by $index\"><div class=\"col-sm-6 form-group\"><label>Paramètre<select class=\"form-control\" ng-model=\"line.parameterId\" ng-options=\"p.id as (p.label+\' (\'+p.unit+\')\') for p in vm.activeParameters()\" required></select></label></div><div class=\"col-sm-3 form-group\"><label>Analyse<select class=\"form-control\" ng-model=\"line.source\"><option value=\"FIELD\">Terrain</option><option value=\"LAB\">Laboratoire</option></select></label></div><div class=\"col-sm-3\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.draft.analyses.splice($index,1)\" ng-disabled=\"vm.draft.analyses.length===1\">Retirer</button></div></div><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.draft.analyses.push({source:\'FIELD\'})\">Ajouter un paramètre</button></fieldset><p class=\"help-block\">Les informations du laboratoire seront renseignées après le prélèvement.</p><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.busy || (planForm.$invalid && !vm.pendingPlan)\">{{vm.pendingPlan ? \'Réessayer la transmission\' : \'Enregistrer la planification\'}}</button></form><div class=\"form-group\" style=\"margin-top:15px\"><label>État<select class=\"form-control\" ng-model=\"vm.statusFilter\" ng-change=\"vm.filterChanged()\"><option value=\"\">Tous les états</option><option value=\"TO_DO\">À faire</option><option value=\"IN_PROGRESS\">En cours</option><option value=\"VALIDATED\">Validé</option><option value=\"CANCELLED\">Annulé</option></select></label></div><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th>Fiche</th><th>Date souhaitée</th><th>Lieu / AREA</th><th>Prélèvement réel</th><th>Opérateur</th><th>État</th></tr></thead><tbody><tr ng-repeat=\"check in vm.checks track by check.id\"><td><a ui-sref=\"water-quality-check({checkId:check.id})\">Ouvrir n° {{check.id}}</a></td><td>{{check.plannedDate | date:\'dd/MM/yyyy\'}}</td><td>{{check.locationLabel}}<br><small>{{vm.areaLabel(check.areaId)}}</small></td><td>{{check.sampledAt ? (check.sampledAt | date:\'dd/MM/yyyy HH:mm\') : \'Non réalisé\'}}</td><td>{{check.operatorName || \'À affecter\'}}</td><td><span class=\"label\" ng-class=\"{\'label-default\':check.status===\'TO_DO\',\'label-info\':check.status===\'IN_PROGRESS\',\'label-success\':check.status===\'VALIDATED\',\'label-warning\':check.status===\'CANCELLED\'}\">{{vm.labels[check.status]}}</span></td></tr><tr ng-if=\"!vm.checks.length\"><td colspan=\"6\">Aucun prélèvement dans cette sélection.</td></tr></tbody></table></div><button class=\"btn btn-default\" ng-click=\"vm.pageBy(-1)\" ng-disabled=\"vm.busy || !vm.page\">Précédent</button> Page {{vm.page+1}} <button class=\"btn btn-default\" ng-click=\"vm.pageBy(1)\" ng-disabled=\"vm.busy || vm.checks.length<25\">Suivant</button>");
$templateCache.put("app/business/water-quality/water-quality-references.html","<div ng-if=\"vm.section===\'locations\'\"><h3>Lieux de prélèvement</h3><button type=\"button\" class=\"btn btn-primary\" ng-if=\"vm.canEdit\" ng-click=\"vm.editLocation()\">Nouveau lieu</button><label><input type=\"checkbox\" ng-model=\"vm.showArchived\"> Afficher les lieux supprimés</label><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th>Lieu</th><th>AREA / zone affichée</th><th>Description</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"location in vm.meta.locations track by location.id\" ng-if=\"location.active || vm.showArchived\"><td>{{location.label}} <span ng-if=\"!location.active\" class=\"text-muted\">(supprimé)</span></td><td>{{vm.areaLabel(location.areaId)}}</td><td>{{location.description}}</td><td><button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"vm.canEdit\" ng-click=\"vm.editLocation(location)\">Modifier</button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-if=\"vm.canEdit && location.active\" ng-click=\"vm.deleteReference(\'locations\',location)\" ng-disabled=\"vm.busy\">Supprimer</button></td></tr></tbody></table></div><form novalidate name=\"locationForm\" ng-if=\"vm.location && vm.canEdit\" ng-submit=\"vm.saveLocation()\" class=\"well\"><h4>{{vm.location.id ? \'Modifier le lieu\' : \'Nouveau lieu\'}}</h4><fieldset ng-disabled=\"vm.busy\"><div class=\"row\"><div class=\"col-sm-6\"><label>Nom du lieu<input class=\"form-control\" ng-model=\"vm.location.label\" maxlength=\"150\" required></label></div><div class=\"col-sm-6\"><label>AREA / zone<select class=\"form-control\" ng-model=\"vm.location.areaId\" ng-options=\"a.id as a.label for a in vm.meta.areas\" required></select></label></div></div><div class=\"form-group\"><label>Description<textarea class=\"form-control\" ng-model=\"vm.location.description\" maxlength=\"2000\"></textarea></label></div><p>La zone de l’AREA du lieu est présélectionnée sur la carte. Activez la modification de position pour placer le point de prélèvement.</p><water-quality-position model=\"vm.location\" areas=\"vm.meta.areas\"></water-quality-position><label ng-if=\"vm.location.id\"><input type=\"checkbox\" ng-model=\"vm.location.active\"> Disponible pour les nouvelles saisies</label><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"locationForm.$invalid\">Enregistrer le lieu</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.location=null\">Fermer</button></fieldset></form></div><div ng-if=\"vm.section===\'parameters\'\"><h3>Paramètres analysés</h3><button type=\"button\" class=\"btn btn-primary\" ng-if=\"vm.canEdit\" ng-click=\"vm.editParameter()\">Nouveau paramètre</button><label><input type=\"checkbox\" ng-model=\"vm.showArchived\"> Afficher les paramètres supprimés</label><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th>Code</th><th>Paramètre</th><th>Unité</th><th>Type</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"parameter in vm.meta.parameters track by parameter.id\" ng-if=\"parameter.active || vm.showArchived\"><td>{{parameter.code}}</td><td>{{parameter.label}} <span ng-if=\"!parameter.active\">(supprimé)</span></td><td>{{parameter.unit}}</td><td>{{parameter.numeric ? \'Numérique\' : \'Qualitatif\'}}</td><td><button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"vm.canEdit\" ng-click=\"vm.editParameter(parameter)\">Modifier</button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-if=\"vm.canEdit && parameter.active\" ng-click=\"vm.deleteReference(\'parameters\',parameter)\" ng-disabled=\"vm.busy\">Supprimer</button></td></tr></tbody></table></div><form novalidate name=\"parameterForm\" ng-if=\"vm.parameter && vm.canEdit\" class=\"well\" ng-submit=\"vm.saveParameter()\"><fieldset ng-disabled=\"vm.busy\"><label>Code<input class=\"form-control\" ng-model=\"vm.parameter.code\" maxlength=\"50\" required></label><label>Libellé<input class=\"form-control\" ng-model=\"vm.parameter.label\" maxlength=\"150\" required></label><label>Unité<input class=\"form-control\" ng-model=\"vm.parameter.unit\" maxlength=\"50\" required></label><label><input type=\"checkbox\" ng-model=\"vm.parameter.numeric\"> Résultat numérique</label><label ng-if=\"vm.parameter.id\"><input type=\"checkbox\" ng-model=\"vm.parameter.active\"> Disponible pour les nouvelles saisies</label><p class=\"help-block\">L’unité et le type d’un paramètre déjà utilisé sont conservés pour protéger l’historique. Le code et le libellé restent modifiables.</p><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"parameterForm.$invalid\">Enregistrer le paramètre</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.parameter=null\">Fermer</button></fieldset></form></div><div ng-if=\"vm.section===\'thresholds\'\"><h3>Seuils par paramètre et par lieu</h3><p>Un lieu vide signifie « Tous les lieux ». Un seuil spécifique au lieu est prioritaire. Les bornes sont inclusives ; chaque résultat conserve les seuils utilisés au prélèvement.</p><button type=\"button\" class=\"btn btn-primary\" ng-if=\"vm.canEdit\" ng-click=\"vm.editThreshold()\">Nouveau seuil</button><label><input type=\"checkbox\" ng-model=\"vm.showThresholdHistory\"> Afficher toutes les versions</label><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th>Paramètre</th><th>Lieu</th><th>Minimum</th><th>Maximum</th><th>Depuis le</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"threshold in (vm.showThresholdHistory ? vm.meta.thresholds : vm.currentThresholds()) track by threshold.id\"><td>{{vm.parameterFor(threshold.parameterId).label}} ({{vm.parameterFor(threshold.parameterId).unit}})</td><td>{{threshold.locationId ? vm.locationFor(threshold.locationId).label : \'Tous les lieux\'}}</td><td>{{threshold.minimum==null ? \'Non défini\' : threshold.minimum}}</td><td>{{threshold.maximum==null ? \'Non défini\' : threshold.maximum}}</td><td>{{threshold.effectiveFrom | date:\'dd/MM/yyyy HH:mm\'}} <span ng-if=\"!threshold.active\">— supprimé</span></td><td ng-if=\"vm.canEdit && vm.isCurrentThreshold(threshold)\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.editThreshold(threshold)\">Modifier</button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"vm.deleteThreshold(threshold)\" ng-disabled=\"vm.busy\">Supprimer</button></td></tr></tbody></table></div><form novalidate name=\"thresholdForm\" class=\"well\" ng-if=\"vm.threshold && vm.canEdit\" ng-submit=\"vm.saveThreshold()\"><fieldset ng-disabled=\"vm.busy\"><label>Paramètre<select class=\"form-control\" ng-model=\"vm.threshold.parameterId\" ng-options=\"p.id as (p.label+\' (\'+p.unit+\')\') for p in vm.activeParameters() | filter:{numeric:true}\" ng-disabled=\"!!vm.threshold.id\" required></select></label><label>Lieu (facultatif)<select class=\"form-control\" ng-model=\"vm.threshold.locationId\" ng-options=\"l.id as l.label for l in vm.activeLocations()\" ng-disabled=\"!!vm.threshold.id\"><option value=\"\">Tous les lieux</option></select></label><label>Minimum<input type=\"number\" step=\"any\" class=\"form-control\" ng-model=\"vm.threshold.minimum\"></label><label>Maximum<input type=\"number\" step=\"any\" class=\"form-control\" ng-model=\"vm.threshold.maximum\"></label><p class=\"help-block\">La modification crée une nouvelle version. Les anciennes évaluations ne sont pas recalculées.</p><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"thresholdForm.$invalid || (vm.threshold.minimum==null && vm.threshold.maximum==null)\">Enregistrer les seuils</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.threshold=null\">Fermer</button></fieldset></form></div>");
$templateCache.put("app/business/water-quality/water-quality-result.html","<div class=\"well well-sm\"><h5><strong>{{line.parameterLabel}} ({{line.unit}})</strong> <span ng-if=\"line.dispatchId\">· {{vm.dispatchFor(line.dispatchId).laboratory}}</span></h5><p ng-if=\"!line.currentResultId\">{{line.source===\'LAB\' && !line.dispatchId ? \'Envoi laboratoire à renseigner après le prélèvement.\' : \'Résultat attendu, non reçu.\'}}</p><p ng-if=\"line.currentResultId\" ng-class=\"{\'text-danger\':vm.resultFor(line).evaluation===\'OUT_OF_LIMITS\'}\"><strong>{{line.numeric ? vm.labels[vm.resultFor(line).qualifier] : \'\'}} {{vm.resultFor(line).value}} {{vm.resultFor(line).textValue}} {{line.unit}}</strong> — {{vm.labels[vm.resultFor(line).evaluation]}}<br><small>Mesure du {{vm.resultFor(line).measuredAt | date:\'dd/MM/yyyy HH:mm\'}}</small></p><button type=\"button\" class=\"btn btn-primary btn-sm\" ng-if=\"vm.editable() && vm.detail.check.sampledAt && (line.source===\'FIELD\' || line.dispatchId)\" ng-click=\"vm.editResult(line)\" ng-disabled=\"vm.busy || line.pending\">{{line.currentResultId ? \'Corriger le résultat\' : \'Saisir le résultat\'}}</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"vm.editable() && !line.currentResultId && !line.dispatchId\" ng-click=\"vm.deleteAnalysis(line)\" ng-disabled=\"vm.busy\">Retirer ce paramètre</button><form novalidate name=\"resultForm\" ng-if=\"line.showEditor && vm.editable()\" ng-submit=\"vm.saveResult(line)\" style=\"margin-top:10px\"><fieldset ng-disabled=\"vm.busy || line.pending\"><div class=\"row\"><div class=\"col-sm-2\" ng-if=\"line.numeric\"><label>Comparateur<select class=\"form-control\" ng-model=\"line.edit.qualifier\"><option value=\"EQ\">=</option><option value=\"LT\">&lt;</option><option value=\"LE\">≤</option><option value=\"GT\">&gt;</option><option value=\"GE\">≥</option></select></label></div><div class=\"col-sm-3\"><label>Valeur ({{line.unit}})<input ng-if=\"line.numeric\" type=\"number\" step=\"any\" class=\"form-control\" ng-model=\"line.edit.value\" required><input ng-if=\"!line.numeric\" class=\"form-control\" ng-model=\"line.edit.textValue\" maxlength=\"500\" required></label></div><div class=\"col-sm-3\"><label>Date et heure de mesure<input type=\"datetime-local\" class=\"form-control\" ng-model=\"line.edit.measuredAt\" required></label></div><div class=\"col-sm-4\"><label>{{line.currentResultId ? \'Motif de correction\' : \'Commentaire\'}}<input class=\"form-control\" ng-model=\"line.edit.reason\" maxlength=\"2000\" ng-required=\"!!line.currentResultId\"></label></div></div></fieldset><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.busy || (resultForm.$invalid && !line.pending)\">{{line.pending ? \'Réessayer la transmission\' : \'Enregistrer le résultat\'}}</button></form><details ng-if=\"line.currentResultId\" style=\"margin-top:10px\"><summary>Historique des valeurs et seuils utilisés</summary><p ng-repeat=\"result in vm.detail.results | filter:{analysisId:line.id}:true track by result.id\">{{result.receivedAt | date:\'dd/MM/yyyy HH:mm\'}} · {{result.recordedBy}} · {{line.numeric ? vm.labels[result.qualifier] : \'\'}} {{result.value}} {{result.textValue}} {{result.unit}} · {{vm.labels[result.evaluation]}}<br>Minimum : {{result.minimum==null ? \'Non défini\' : result.minimum}} · Maximum : {{result.maximum==null ? \'Non défini\' : result.maximum}}<br>{{result.reason}}</p></details></div>");
$templateCache.put("app/business/water-quality/water-quality-schedules.html","<h3>Récurrences de prélèvements</h3><p>À l’enregistrement, les dates souhaitées sont préparées jusqu’à un mois à partir d’aujourd’hui. Chaque lundi à 3 h (heure du serveur), cette période est complétée pour couvrir à nouveau le mois à venir. Chaque occurrence reste une fiche indépendante, à réaliser puis à compléter.</p><button type=\"button\" class=\"btn btn-primary\" ng-if=\"vm.canEdit\" ng-click=\"vm.editSchedule()\">Nouvelle récurrence</button><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th>Récurrence</th><th>Lieu</th><th>Fréquence</th><th>Période</th><th>État</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"schedule in vm.schedules.items track by schedule.id\"><td>{{schedule.label}}</td><td>{{vm.locationFor(schedule.locationId).label}}</td><td>Tous les {{schedule.intervalCount}} {{vm.labels[schedule.frequency]}}</td><td>{{schedule.startDate | date:\'dd/MM/yyyy\'}} — {{schedule.endDate ? (schedule.endDate | date:\'dd/MM/yyyy\') : \'Sans fin\'}}</td><td>{{vm.scheduleState(schedule)}}</td><td><button class=\"btn btn-default btn-sm\" type=\"button\" ng-if=\"vm.canEdit\" ng-click=\"vm.editSchedule(schedule)\">Modifier</button> <button class=\"btn btn-danger btn-sm\" type=\"button\" ng-if=\"vm.canEdit && schedule.active\" ng-click=\"vm.deleteSchedule(schedule)\" ng-disabled=\"vm.busy\">Arrêter / supprimer</button></td></tr></tbody></table></div><form novalidate name=\"scheduleForm\" class=\"well\" ng-if=\"vm.schedule && vm.canEdit\" ng-submit=\"vm.saveSchedule()\"><fieldset ng-disabled=\"vm.busy || vm.pendingSchedule\"><label>Nom<input class=\"form-control\" ng-model=\"vm.schedule.label\" maxlength=\"150\" required></label><label>Lieu<select class=\"form-control\" ng-model=\"vm.schedule.locationId\" ng-options=\"l.id as l.label for l in vm.activeLocations()\" required></select></label><label>Opérateur prévu<select class=\"form-control\" ng-model=\"vm.schedule.operatorId\" ng-options=\"o.id as o.label for o in vm.operators(vm.schedule.locationId,false)\"><option value=\"\">À affecter</option></select></label><div class=\"row\"><div class=\"col-sm-3\"><label>Premier jour souhaité<input type=\"date\" class=\"form-control\" ng-model=\"vm.schedule.startDate\" required></label></div><div class=\"col-sm-3\"><label>Jusqu’au (facultatif)<input type=\"date\" class=\"form-control\" ng-model=\"vm.schedule.endDate\"></label></div><div class=\"col-sm-3\"><label>Tous les<input type=\"number\" class=\"form-control\" min=\"1\" max=\"366\" step=\"1\" ng-model=\"vm.schedule.intervalCount\" required></label></div><div class=\"col-sm-3\"><label>Fréquence<select class=\"form-control\" ng-model=\"vm.schedule.frequency\"><option value=\"DAYS\">Jours</option><option value=\"WEEKS\">Semaines</option><option value=\"MONTHS\">Mois</option><option value=\"YEARS\">Années</option></select></label></div></div><h4>Paramètres à contrôler</h4><div class=\"row\" ng-repeat=\"line in vm.schedule.analyses track by $index\"><div class=\"col-sm-6\"><label>Paramètre<select class=\"form-control\" ng-model=\"line.parameterId\" ng-options=\"p.id as p.label for p in vm.activeParameters()\" required></select></label></div><div class=\"col-sm-3\"><label>Analyse<select class=\"form-control\" ng-model=\"line.source\"><option value=\"FIELD\">Terrain</option><option value=\"LAB\">Laboratoire</option></select></label></div><div class=\"col-sm-3\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.schedule.analyses.splice($index,1)\" ng-disabled=\"vm.schedule.analyses.length===1\">Retirer</button></div></div><button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.schedule.analyses.push({source:\'FIELD\'})\">Ajouter un paramètre</button></fieldset><p class=\"help-block\">Une modification remplace les occurrences futures non commencées. Les prélèvements réalisés et leurs résultats sont conservés.</p><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.busy || (scheduleForm.$invalid && !vm.pendingSchedule)\">{{vm.pendingSchedule ? \'Réessayer la transmission\' : \'Enregistrer la récurrence\'}}</button></form>");
$templateCache.put("app/business/water-quality/water-quality.html","<div class=\"water-quality\"><h2><i class=\"fa fa-tint\"></i> Qualité de l’eau</h2><p class=\"alert alert-warning\" ng-if=\"vm.moduleDisabled\">Le module Qualité de l’eau doit être activé dans l’organisation.</p><p class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</p><p class=\"alert alert-success\" role=\"status\" ng-if=\"vm.success\">{{vm.success}}</p><div ng-if=\"!vm.moduleDisabled\"><button type=\"button\" class=\"btn btn-default pull-right\" ng-click=\"vm.refresh()\" ng-disabled=\"vm.busy\">Actualiser</button><div ng-if=\"vm.section===\'planning\' || vm.section===\'records\'\" ng-include=\"\'app/business/water-quality/water-quality-planning.html\'\"></div><div ng-if=\"vm.section===\'detail\' && vm.detail\" ng-include=\"\'app/business/water-quality/water-quality-detail.html\'\"></div><div ng-if=\"vm.section===\'locations\' || vm.section===\'parameters\' || vm.section===\'thresholds\'\" ng-include=\"\'app/business/water-quality/water-quality-references.html\'\"></div><div ng-if=\"vm.section===\'schedules\'\" ng-include=\"\'app/business/water-quality/water-quality-schedules.html\'\"></div><div ng-if=\"vm.section===\'alerts\'\"><h3>Alertes de qualité et résultats attendus</h3><label><input type=\"checkbox\" ng-model=\"vm.includeResolved\" ng-change=\"vm.filterChanged()\"> Inclure les alertes résolues</label><p>Les retards de laboratoire sont détectés chaque minute, y compris lors d’une réception partielle. Aucune notification externe n’est envoyée.</p><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th>Fiche</th><th>Analyse</th><th>Alerte</th><th>Depuis le</th><th>Résolution</th></tr></thead><tbody><tr ng-repeat=\"alert in vm.alerts track by alert.id\"><td><a ui-sref=\"water-quality-check({checkId:alert.checkId})\">Ouvrir n° {{alert.checkId}}</a></td><td>{{alert.analysisId}}</td><td>{{vm.labels[alert.kind]}}</td><td>{{alert.openedAt | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{alert.resolvedAt ? (alert.resolvedAt | date:\'dd/MM/yyyy HH:mm\') : \'À traiter\'}}</td></tr><tr ng-if=\"!vm.alerts.length\"><td colspan=\"5\">Aucune alerte.</td></tr></tbody></table></div><button class=\"btn btn-default\" ng-click=\"vm.pageBy(-1)\" ng-disabled=\"vm.busy || !vm.page\">Précédent</button> Page {{vm.page+1}} <button class=\"btn btn-default\" ng-click=\"vm.pageBy(1)\" ng-disabled=\"vm.busy || vm.alerts.length<25\">Suivant</button></div></div></div>");
$templateCache.put("app/business/water-network/water-network-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.waterNetwork.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.waterNetwork.delete.question\" translate-values=\"{id: \'{{vm.waterNetwork.id}}\'}\">Are you sure you want to delete this WaterNetwork?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/water-network/water-network-detail.html","<div><h2><span translate=\"wamasysApp.waterNetwork.detail.title\">WaterNetwork</span> {{vm.waterNetwork.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.waterNetwork.label\">Libelle</span></dt><dd><span>{{vm.waterNetwork.label}}<span></span></span></dd><hr><dt><span translate=\"global.field.isDeleted\">isDeleted</span></dt><dd><span>{{vm.waterNetwork.deleted}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/water-network/water-network-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myWaterNetworkLabel\" translate=\"wamasysApp.waterNetwork.home.createOrEditLabel\">Create or edit a WaterNetwork</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!--         <div class=\"form-group\">\r\n            <label for=\"id\" translate=\"global.field.id\">ID</label>\r\n            <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"\r\n                    ng-model=\"vm.waterNetwork.id\" readonly />\r\n        </div> --><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.waterNetwork.label\" for=\"field_label\">Libelle</label><input type=\"text\" class=\"form-control\" name=\"label\" id=\"field_label\" ng-model=\"vm.waterNetwork.label\" required ng-maxlength=\"50\"><div ng-show=\"editForm.label.$invalid\"><p class=\"help-block\" ng-show=\"editForm.label.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.label.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"global.field.code\" for=\"field_code\">Code</label><input ng-readonly=\"vm.waterNetwork.id != null\" required type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.waterNetwork.code\" ng-maxlength=\"64\" ng-pattern=\"/^[_.A-Z0-9-]*$/\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.pattern\" translate=\"wamasysApp.waterNetwork.codeArticleFormatError\">The article code can only contain upper-case letters and digits.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"64\">This field cannot be longer than 64 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.waterNetwork.id\"><label class=\"control-deleted\" translate=\"global.field.isDeleted\" for=\"field_deleted\">deleted</label><input type=\"checkbox\" class=\"form-control\" name=\"deleted\" id=\"field_deleted\" ng-model=\"vm.waterNetwork.deleted\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/water-network/water-networks.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.waterNetwork.home.title\">WaterNetworks</span> <small class=\"text-muted\" translate=\"global.configurationScope.organization\">Paramétrage commun à toute l\'organisation</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"water-network.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.waterNetwork.home.createLabel\">Create new WaterNetwork</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"label\"><span translate=\"wamasysApp.waterNetwork.label\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"global.field.code\">code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deleted\"><span translate=\"global.field.isDeleted\">isDeleted</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"waterNetwork in vm.waterNetworks track by waterNetwork.id\"><td><a ui-sref=\"water-network-detail({id:waterNetwork.id})\">{{waterNetwork.id}}</a></td><td>{{waterNetwork.label}}</td><td>{{waterNetwork.code}}</td><td>{{waterNetwork.deleted}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"water-network-detail({id:waterNetwork.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"water-network.edit({id:waterNetwork.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"water-network.delete({id:waterNetwork.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/business/type-service/type-service-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.typeService.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.typeService.delete.question\" translate-values=\"{id: \'{{vm.typeService.id}}\'}\">Are you sure you want to delete this TypeService?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/type-service/type-service-detail.html","<div><h2><span translate=\"wamasysApp.typeService.detail.title\">TypeService</span> {{vm.typeService.id}}</h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"global.field.code\">Code</span></dt><dd><span>{{vm.typeService.code}}</span></dd><hr><dt><span translate=\"wamasysApp.typeService.libelle\">Libelle</span></dt><dd><span>{{vm.typeService.libelle}}<span></span></span></dd><hr><dt><span translate=\"global.field.isDeleted\">isDeleted</span></dt><dd><span>{{vm.typeService.deleted}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/type-service/type-service-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTypeServiceLabel\" translate=\"wamasysApp.typeService.home.createOrEditLabel\">Create or edit a TypeService</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"global.field.code\" for=\"field_code\">Code</label><input ng-readonly=\"vm.typeService.id != null\" required type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.typeService.code\" ng-maxlength=\"64\" ng-pattern=\"/^[_.A-Z0-9-]*$/\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.pattern\" translate=\"wamasysApp.typeService.codeArticleFormatError\">The article code can only contain upper-case letters and digits.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"64\">This field cannot be longer than 64 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.typeService.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.typeService.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.typeService.libelle\" for=\"field_libelle\">Libelle</label><input type=\"text\" class=\"form-control\" name=\"libelle\" id=\"field_libelle\" ng-model=\"vm.typeService.libelle\" ng-maxlength=\"50\"><div ng-show=\"editForm.libelle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.libelle.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.typeService.id\"><label class=\"control-deleted\" translate=\"global.field.isDeleted\" for=\"field_deleted\">deleted</label><input type=\"checkbox\" class=\"form-control\" name=\"deleted\" id=\"field_deleted\" ng-model=\"vm.typeService.deleted\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/type-service/type-services.html","<div><!-- Précise le périmètre du paramétrage. --><h2><span translate=\"wamasysApp.typeService.home.title\">TypeServices</span> <small class=\"text-muted\" translate=\"global.configurationScope.organization\">Paramétrage commun à toute l\'organisation</small></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"type-service.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.typeService.home.createLabel\">Create new TypeService</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"libelle\"><span translate=\"wamasysApp.typeService.libelle\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"global.field.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deleted\"><span translate=\"global.field.isDeleted\">isDeleted</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"typeService in vm.typeServices track by typeService.id\"><td><a ui-sref=\"type-service-detail({id:typeService.id})\">{{typeService.id}}</a></td><td>{{typeService.libelle}}</td><td>{{typeService.code}}</td><td>{{typeService.deleted}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"type-service-detail({id:typeService.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"type-service.edit({id:typeService.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"type-service.delete({id:typeService.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/components/current-agence/current-agence.tpl.html","<div class=\"project-context dropdown\" dropdown><!-- hidden-xs --> <span class=\"label\">{{account.login}} - <i>{{currentOrganisation}}</i></span> <span id=\"spanAgence\" ng-click=\"showInputFilter(this)\" class=\"project-selector dropdown-toggle\" data-toggle=\"dropdown\"><span class=\"current-agence-name\" title=\"{{currentAgence}}\">{{currentAgence}}</span> <i id=\"iBalAgence\" ng-if=\"agencesRattachement.length\" class=\"fa fa-angle-down\"></i></span> <input ng-blur=\"filterLostFocus()\" style=\"display: none; background-color : #d1d1d1; border :none\" class=\"input-xs\" ng-change=\"applyFilter()\" ng_model=\"filterCurrentAgency\" id=\"currentAgenceFilter\" ng-model-options=\"{debounce: 50}\" type=\"text\"><style>.scrollable-menu {\r\n    height: auto;\r\n    max-height: 400px;\r\n    overflow-x: hidden;\r\n}\r\n\r\n/* width */\r\n.project-context ::-webkit-scrollbar {\r\n  width: 4px;\r\n}\r\n\r\n/* Track */\r\n.project-context ::-webkit-scrollbar-track {\r\n  background: #f1f1f1; \r\n}\r\n \r\n/* Handle */\r\n.project-context ::-webkit-scrollbar-thumb {\r\n  background: #888; \r\n}\r\n\r\n/* Handle on hover */\r\n.project-context ::-webkit-scrollbar-thumb:hover {\r\n  background: #555; \r\n}</style><ul class=\"dropdown-menu scrollable-menu\"><li ng-repeat=\"agence in agencesRattachement  | orderBy:\'nom\'  |  filter:filterCurrentAgency as results track by agence.id \"><a ng-click=\"changerAgence(agence.id)\">{{agence.nom}}</a></li><!--         <li class=\"divider\"></li> --><!--         <li> --><!--             <a ng-click=\"clearProjects()\"><i class=\"fa fa-power-off\"></i> Clear</a> --><!--         </li> --></ul></div>");
$templateCache.put("app/business/user/user-management-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.user.login)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"alert alert-danger\" ng-if=\"vm.deleteError\">{{vm.deleteError}}</div><p translate=\"userManagement.delete.question\" translate-values=\"{login: \'{{vm.user.login}}\'}\">Are you sure you want to delete this User?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/user/user-management-detail.html","<div><h2><span translate=\"userManagement.detail.title\">User</span> \"{{vm.user.login}}\"</h2><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"entity.detail.field\">Field</th><th translate=\"entity.detail.value\">Value</th></tr></thead><tbody><tr><td><span translate=\"userManagement.login\">Login</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.login}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.firstName\">FirstName</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.firstName}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.lastName\">LastName</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.lastName}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.email\">Email</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.email}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.agency\">Agency</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.agence.nom}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.agencesRattachement\">Agences rattachement</span></td><td><ul class=\"list-unstyled\"><li ng-repeat=\"agence in vm.user.agencesRattachement\"><span>{{agence.nom}}</span></li></ul></td></tr><tr><td><span translate=\"userManagement.activated\">Activated</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.activated}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.langKey\">LangKey</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.langKey}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.createdBy\">CreatedBy</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.createdBy}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.createdDate\">CreatedDate</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.lastModifiedBy\">LastModifiedBy</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.lastModifiedBy}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.lastModifiedDate\">LastCreatedDate</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}\" readonly=\"readonly\"></td></tr><tr><td><span translate=\"userManagement.profiles\">Profiles</span></td><td><ul class=\"list-unstyled\"><li ng-repeat=\"authority in vm.user.authorities\"><span>{{authority}}</span></li></ul></td></tr><tr><td><span translate=\"userManagement.assistantMonthlyCostLimitUsd\">Plafond mensuel USD assistant IA</span></td><td><input type=\"text\" class=\"input-sm form-control\" value=\"{{vm.user.assistantMonthlyCostLimitUsd == null ? \'Défaut\' : (vm.user.assistantMonthlyCostLimitUsd === 0 ? \'Illimité\' : vm.user.assistantMonthlyCostLimitUsd)}}\" readonly=\"readonly\"></td></tr></tbody></table></div><div has-any-authority=\"ROLE_ADMIN,ROLE_SUPER_ADMIN\" ng-if=\"vm.mfaStatus\"><h3 translate=\"mfa.title\">Double authentification</h3><p>{{(vm.mfaStatus.enabled ? \'mfa.enabledStatus\' : \'mfa.disabledStatus\') | translate}}</p><div class=\"alert alert-success\" ng-if=\"vm.mfaSuccess\" translate=\"mfa.adminDisabled\">La double authentification a été désactivée pour ce compte.</div><div class=\"alert alert-danger\" ng-if=\"vm.mfaError\" translate=\"mfa.adminFailed\">La double authentification n\'a pas pu être désactivée. Vérifiez votre périmètre autorisé.</div><button type=\"button\" class=\"btn btn-warning\" ng-if=\"vm.mfaStatus.enabled\" ng-click=\"vm.disableMfa()\" ng-disabled=\"vm.mfaBusy\" translate=\"mfa.adminDisable\">Désactiver la double authentification</button><p class=\"help-block\" ng-if=\"vm.mfaStatus.enabled\" translate=\"mfa.adminHelp\">Vérifiez l\'identité de l\'utilisateur avant de débloquer son compte après la perte de son téléphone.</p></div><!-- Diagnostic des installations connues : la date provient de leur dernier enregistrement. --><h3 translate=\"userManagement.android.title\">Appareils Android liés au compte</h3><p><strong translate=\"userManagement.android.latestVersion\">Dernière version de l’application Smartphone vue</strong> : <span>{{vm.user.lastSmartphoneAppVersion || (\'userManagement.android.unknown\' | translate)}}</span> <span ng-if=\"vm.user.lastSmartphoneAppVersionDate\">({{vm.user.lastSmartphoneAppVersionDate | date:\'dd/MM/yyyy HH:mm\'}})</span></p><p class=\"text-muted\" translate=\"userManagement.android.explanation\">Informations déclarées lors du dernier enregistrement de chaque installation, y compris les installations inactives.</p><p ng-if=\"vm.user.androidDevices.length === 0\" translate=\"userManagement.android.empty\">Aucun appareil Android enregistré pour ce compte.</p><div class=\"table-responsive\" ng-if=\"vm.user.androidDevices.length\"><table class=\"table table-striped\"><thead><tr><th translate=\"userManagement.android.model\">Modèle</th><th translate=\"userManagement.android.installation\">Identifiant d’installation</th><th translate=\"userManagement.android.sdk\">Android (niveau SDK)</th><th translate=\"userManagement.android.version\">Version de l’application</th><th translate=\"userManagement.android.state\">État</th><th translate=\"userManagement.android.registrationType\">Mode de notification</th><th translate=\"userManagement.android.permission\">Notifications autorisées</th><th translate=\"userManagement.android.lastSeen\">Dernier enregistrement</th></tr></thead><tbody><tr ng-repeat=\"device in vm.user.androidDevices track by device.id\"><td>{{device.deviceModel || (\'userManagement.android.unknown\' | translate)}}</td><td>{{device.installationId}}</td><td>{{device.androidSdk == null ? (\'userManagement.android.unknown\' | translate) : device.androidSdk}}</td><td>{{device.appVersion || (\'userManagement.android.unknown\' | translate)}}</td><td>{{(device.active ? \'userManagement.android.active\' : \'userManagement.android.inactive\') | translate}}</td><td>{{device.registrationType || (\'userManagement.android.unknown\' | translate)}}</td><td>{{(device.notificationPermission == null ? \'userManagement.android.unknown\' : (device.notificationPermission ? \'userManagement.android.yes\' : \'userManagement.android.no\')) | translate}}</td><td>{{device.lastRegisteredDate | date:\'dd/MM/yyyy HH:mm\'}}</td></tr></tbody></table></div><button type=\"submit\" ui-sref=\"user-management\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/user/user-management-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myUserLabel\" translate=\"userManagement.home.createOrEditLabel\">Create or edit a User</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.login\">Login</label><input type=\"text\" class=\"form-control\" name=\"login\" ng-pattern=\"/^[_.@a-z0-9-]*$/\" ng-readonly=\"vm.user.id\" ng-model=\"vm.user.login\" ng-required=\"vm.user.id == null\" ng-maxlength=\"50\"><div ng-show=\"editForm.login.$invalid\"><p class=\"help-block\" ng-show=\"editForm.login.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.login.$error.pattern\" translate=\"error.user.loginPattern\">Your username can only contain lower-case letters and digits.</p><p class=\"help-block\" ng-show=\"editForm.login.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.firstName\">FirstName</label><input type=\"text\" class=\"form-control\" name=\"firstName\" ng-model=\"vm.user.firstName\" ng-maxlength=\"50\"><div ng-show=\"editForm.firstName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.firstName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"userManagement.lastName\">LastName</label><input type=\"text\" class=\"form-control\" name=\"lastName\" ng-model=\"vm.user.lastName\" ng-maxlength=\"50\"><div ng-show=\"editForm.lastName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.email\">Email</label><input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"vm.user.email\" required ng-maxlength=\"100\"><div ng-show=\"editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p></div></div><div class=\"form-group\" ng-show=\"vm.user.id  !== null\"><label for=\"activated\"><input ng-disabled=\"vm.user.id === null\" type=\"checkbox\" id=\"activated\" ng-model=\"vm.user.activated\"> <span translate=\"userManagement.activated\">Activated</span></label></div><div class=\"form-group\"><label translate=\"userManagement.langKey\">LangKey</label><select class=\"form-control\" name=\"langKey\" ng-model=\"vm.user.langKey\" ng-options=\"language as language for language in vm.languages track by language\"></select></div><!-- \r\n		<div class=\"form-group\"  ng-if=\"vm.user.id != null\">\r\n			<label class=\"control-label\"\r\n				translate=\"userManagement.redmineUserId\"\r\n				for=\"field_redmineUserId\">redmineUserId</label>\r\n			\r\n			<input type=\"number\"\r\n				class=\"form-control\" name=\"redmineUserId\" id=\"field_redmineUserId\"\r\n				ng-model=\"vm.user.redmineUserId\" min=\"0\" max=\"9999999\" />\r\n			\r\n			<div ng-show=\"editForm.redmineUserId.$invalid\">\r\n				<p class=\"help-block\" ng-show=\"editForm.redmineUserId.$error.min\"\r\n					translate=\"entity.validation.min\" translate-value-min=\"0\">\r\n					This field should be more than 0.</p>\r\n				<p class=\"help-block\" ng-show=\"editForm.redmineUserId.$error.max\"\r\n					translate=\"entity.validation.max\" translate-value-max=\"9999999\">\r\n					This field cannot be more than 9999999.</p>\r\n				<p class=\"help-block\"\r\n					ng-show=\"editForm.redmineUserId.$error.number\"\r\n					translate=\"entity.validation.number\">This field should be a\r\n					number.</p>\r\n			</div>\r\n		</div>\r\n --><div class=\"form-group\"><label translate=\"userManagement.agencesRattachement\">agencesRattachement</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.user.agencesRattachement\" theme=\"selectize\" title=\"{{\'userManagement.agencesRattachement\' | translate}}\"><ui-select-match placeholder=\"{{\'userManagement.agencesRattachement\' | translate}}\">{{$item.nom}}</ui-select-match><ui-select-choices repeat=\"agence in vm.agences | filter: $select.search  track by agence.id\">{{agence.nom}}</ui-select-choices></ui-select></div><div class=\"form-group\"><label translate=\"userManagement.profiles\">Profiles</label><ui-select tagging multiple=\"multiple\" ng-model=\"vm.user.authorities\" theme=\"selectize\" title=\"{{\'userManagement.profiles\' | translate}}\"><ui-select-match placeholder=\"{{\'userManagement.profiles\' | translate}}\">{{$item === \'ROLE_EQUIPMENT_REMOTE_CONTROL\' ? (\'userManagement.remoteControl\' | translate) : $item}}</ui-select-match><ui-select-choices repeat=\"authority in vm.authorities | filter: $select.search \">{{authority === \'ROLE_EQUIPMENT_REMOTE_CONTROL\' ? (\'userManagement.remoteControl\' | translate) : authority}}</ui-select-choices></ui-select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.assistantMonthlyCostLimitUsd\">Plafond mensuel USD assistant IA</label><p class=\"help-block\">Vide : hérite du plafond par défaut. Zéro : sans plafond. Montants en USD.</p><input type=\"number\" class=\"form-control\" name=\"assistantMonthlyCostLimitUsd\" ng-model=\"vm.user.assistantMonthlyCostLimitUsd\" min=\"0\" step=\"0.01\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/user/user-management.html","<div><h2 translate=\"userManagement.home.title\">Users</h2><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-12 text-right\"><div class=\"btn-group\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.downloadCsv()\"><span class=\"glyphicon glyphicon-download-alt\"></span> <span translate=\"userManagement.actions.downloadCsv\">Télécharger CSV</span></button><div class=\"btn-group\" uib-dropdown><button class=\"btn btn-default dropdown-toggle\" type=\"button\" uib-dropdown-toggle ng-disabled=\"!vm.hasSelection()\"><span class=\"glyphicon glyphicon-edit\"></span> <span translate=\"userManagement.bulk.menu\">Modifier</span> <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu><li><a href=\"\" ng-click=\"vm.openBulkEdit(\'ADD_AUTHORITY\')\">{{ \'userManagement.bulk.actions.ADD_AUTHORITY\' | translate }}</a></li><li><a href=\"\" ng-click=\"vm.openBulkEdit(\'REMOVE_AUTHORITY\')\">{{ \'userManagement.bulk.actions.REMOVE_AUTHORITY\' | translate }}</a></li><li><a href=\"\" ng-click=\"vm.openBulkEdit(\'ADD_AGENCE\')\">{{ \'userManagement.bulk.actions.ADD_AGENCE\' | translate }}</a></li><li><a href=\"\" ng-click=\"vm.openBulkEdit(\'REMOVE_AGENCE\')\">{{ \'userManagement.bulk.actions.REMOVE_AGENCE\' | translate }}</a></li></ul></div><button class=\"btn btn-primary\" ui-sref=\"user-management.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"userManagement.home.createLabel\">Create a new User</span></button></div></div></div><div class=\"row\"><div class=\"col-md-3\"><label translate=\"userManagement.home.filter\">Filtre</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.filter\" ng-change=\"vm.applyFilters()\" ng-model-options=\"{debounce: 400}\"></div><div class=\"col-md-3\"><label translate=\"userManagement.filters.role\">Rôle</label><select class=\"form-control\" ng-model=\"vm.selectedRole\" ng-change=\"vm.applyFilters()\" ng-options=\"role as role for role in vm.authorities\"><option value=\"\" translate=\"userManagement.filters.allRoles\">Tous les rôles</option></select></div><div class=\"col-md-3\"><label translate=\"userManagement.filters.agencyAccess\">Droit d\'accès zone</label><select class=\"form-control\" ng-model=\"vm.selectedAgenceId\" ng-change=\"vm.applyFilters()\" ng-options=\"agence.id as agence.nom for agence in vm.agences track by agence.id\"><option value=\"\" translate=\"userManagement.filters.allAreas\">Toutes les zones</option></select></div><div class=\"col-md-2\"><label translate=\"userManagement.filters.state\">État</label><select class=\"form-control\" ng-model=\"vm.selectedActivated\" ng-change=\"vm.applyFilters()\" ng-options=\"option.value as (option.labelKey | translate) for option in vm.stateOptions\"></select></div><div class=\"col-md-1\"><label>&nbsp;</label><button class=\"btn btn-default btn-block\" type=\"button\" ng-click=\"vm.resetFilters()\"><span translate=\"entity.action.reset\">Reset</span></button></div></div><div class=\"row\"><div class=\"col-md-3\"><label translate=\"userManagement.android.registered\">Appareil Android enregistré</label><select class=\"form-control\" ng-model=\"vm.selectedAndroidDevice\" ng-change=\"vm.applyFilters()\" ng-options=\"option.value as (option.labelKey | translate) for option in vm.androidDeviceOptions\"></select></div><div class=\"col-md-3\"><label translate=\"userManagement.android.exactVersion\">Version de l’application Android =</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.selectedAppVersion\" ng-change=\"vm.applyFilters()\" ng-model-options=\"{debounce: 400}\"></div><div class=\"col-md-3\"><label translate=\"userManagement.mfa.title\">MFA</label><select class=\"form-control\" ng-model=\"vm.selectedMfaEnabled\" ng-change=\"vm.applyFilters()\" ng-options=\"option.value as (option.labelKey | translate) for option in vm.mfaOptions\"></select></div></div><p class=\"help-block\" translate=\"userManagement.presence.help\">Présence estimée à partir des échanges Web et Android des deux dernières minutes. Actualisation toutes les 30 secondes.</p><p class=\"help-block\" translate=\"userManagement.android.filterHelp\">Les filtres incluent les installations inactives. La version doit correspondre exactement à celle d’une installation liée au compte.</p><p ng-if=\"vm.totalItems !== null\"><strong translate=\"userManagement.resultCount\" translate-values=\"{count: vm.totalItems}\">{{vm.totalItems}} utilisateur(s) trouvé(s)</strong></p><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th class=\"text-center\" style=\"width: 40px\"><input type=\"checkbox\" ng-model=\"vm.selectAllOnPage\" ng-change=\"vm.toggleSelectAll()\"></th><th translate=\"userManagement.login\">Login</th><th translate=\"userManagement.email\">Email</th><th translate=\"userManagement.agency\">Agency</th><th translate=\"userManagement.state\">État</th><th translate=\"userManagement.profiles\">Profiles</th><th translate=\"userManagement.assistantMonthlyCostLimitUsd\">Plafond mensuel USD assistant IA</th><th translate=\"userManagement.mfa.title\">MFA</th><th translate=\"userManagement.android.latestVersion\">Dernière version de l’application Smartphone vue</th><th translate=\"userManagement.presence.status\">Présence</th><th translate=\"userManagement.presence.lastLogin\">Dernière connexion</th><th translate=\"userManagement.presence.lastSeen\">Dernière activité</th><th></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users track by user.id\"><td class=\"text-center\"><input type=\"checkbox\" ng-model=\"vm.selection[user.id]\" ng-change=\"vm.updateSelectAllState()\"></td><td><a ui-sref=\"user-management-detail({login:user.login})\">{{user.login}}</a></td><td>{{user.email}}</td><td><div ng-repeat=\"agence in user.agencesRattachement\"><span class=\"label label-info\">{{ agence.nom }}</span></div></td><td><span class=\"label label-danger\" ng-click=\"vm.setActive(user, true)\" ng-show=\"!user.activated\" translate=\"userManagement.deactivated\" style=\"cursor: pointer\">Desactivated</span> <span class=\"label label-success\" ng-click=\"vm.setActive(user, false)\" ng-show=\"user.activated\" translate=\"userManagement.activated\" style=\"cursor: pointer\">Activated</span></td><td><div ng-repeat=\"authority in user.authorities\"><span class=\"label label-info\">{{ authority }}</span></div></td><td>{{user.assistantMonthlyCostLimitUsd == null ? \"Défaut\" : (user.assistantMonthlyCostLimitUsd === 0 ? \"Illimité\" : user.assistantMonthlyCostLimitUsd)}}</td><td><div>{{(user.mfaEnabled ? \'userManagement.mfa.enabled\' : \'userManagement.mfa.disabled\') | translate}}</div><button type=\"button\" class=\"btn btn-warning btn-xs\" ng-if=\"user.mfaEnabled\" has-any-authority=\"ROLE_ADMIN,ROLE_SUPER_ADMIN\" ng-click=\"vm.disableMfa(user)\" ng-disabled=\"user.mfaBusy\" translate=\"mfa.adminDisableShort\">Désactiver</button><div class=\"text-danger\" ng-if=\"user.mfaError\" translate=\"mfa.adminFailed\">La double authentification n\'a pas pu être désactivée. Vérifiez votre périmètre autorisé.</div></td><td>{{user.lastSmartphoneAppVersion || (\'userManagement.android.unknown\' | translate)}}<div class=\"text-muted\" ng-if=\"user.lastSmartphoneAppVersionDate\">{{user.lastSmartphoneAppVersionDate | date:\'dd/MM/yyyy HH:mm\'}}</div></td><td><span class=\"label\" ng-class=\"user.online ? \'label-success\' : \'label-default\'\" translate=\"{{user.online ? \'userManagement.presence.online\' : \'userManagement.presence.offline\'}}\"></span></td><td>{{user.lastLoginDate ? (user.lastLoginDate | date:\'dd/MM/yyyy HH:mm:ss\') : (\'userManagement.presence.unknown\' | translate)}}</td><td>{{user.lastSeenDate ? (user.lastSeenDate | date:\'dd/MM/yyyy HH:mm:ss\') : (\'userManagement.presence.unknown\' | translate)}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"user-management-detail({login:user.login})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"user-management.edit({login:user.login})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"user-management.delete({login:user.login})\" class=\"btn btn-danger btn-sm\" ng-disabled=\"vm.currentAccount.login==user.login\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div>");
$templateCache.put("app/business/type-tax/type-tax-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.typeTax.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"wamasysApp.typeTax.delete.question\" translate-values=\"{id: \'{{vm.typeTax.id}}\'}\">Are you sure you want to delete this TypeTax?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/business/type-tax/type-tax-detail.html","<div><h2><span translate=\"wamasysApp.typeTax.detail.title\">TypeTax</span><!--     {{vm.typeTax.id}} --></h2><hr><dl class=\"dl-horizontal\"><dt><span translate=\"wamasysApp.typeTax.label\">Libelle</span></dt><dd><span>{{vm.typeTax.label}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.typeTax.taxRate\">taxRate</span></dt><dd><span>{{vm.typeTax.taxRate}}<span></span></span></dd><hr><dt><span translate=\"wamasysApp.typeTax.codeTax\">codeTax</span></dt><dd><span>{{vm.typeTax.codeTax}}<span></span></span></dd><hr><dt><span translate=\"global.field.isDeleted\">isDeleted</span></dt><dd><span>{{vm.typeTax.deleted}}<span></span></span></dd><hr></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/business/type-tax/type-tax-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTypeTaxLabel\" translate=\"wamasysApp.typeTax.home.createOrEditLabel\">Create or edit a TypeTax</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><!--         <div class=\"form-group\"> --><!--             <label for=\"id\" translate=\"global.field.id\">ID</label> --><!--             <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" --><!--                     ng-model=\"vm.typeTax.id\" readonly /> --><!--         </div> --><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.typeTax.label\" for=\"field_label\">Libelle</label><input type=\"text\" class=\"form-control\" name=\"label\" id=\"field_label\" ng-model=\"vm.typeTax.label\" required ng-maxlength=\"50\"><div ng-show=\"editForm.label.$invalid\"><p class=\"help-block\" ng-show=\"editForm.label.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.label.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"alert alert-warning\"><span translate=\"wamasysApp.serviceVendu.messageRateTaxe\"></span></div><div class=\"form-group\"><label class=\"control-label\" translate=\"wamasysApp.typeTax.taxRate\" for=\"field_taxRate\">TaxRate</label><input type=\"number\" class=\"form-control\" name=\"taxRate\" id=\"field_taxRate\" ng-model=\"vm.typeTax.taxRate\" required min=\"0\" max=\"100\"><div ng-show=\"editForm.taxRate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.taxRate.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.taxRate.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.taxRate.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999999\">This field cannot be more than 999999.</p><p class=\"help-block\" ng-show=\"editForm.taxRate.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><codetax class=\"control-codeTax\" translate=\"wamasysApp.typeTax.codeTax\" for=\"field_codeTax\">codeTax</codetax><input type=\"text\" class=\"form-control\" name=\"codeTax\" id=\"field_codeTax\" ng-model=\"vm.typeTax.codeTax\" required ng-maxlength=\"50\"><div ng-show=\"editForm.codeTax.$invalid\"><p class=\"help-block\" ng-show=\"editForm.codeTax.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.codeTax.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\" ng-if=\"vm.typeTax.id\"><label class=\"control-deleted\" translate=\"global.field.isDeleted\" for=\"field_deleted\">deleted</label><input type=\"checkbox\" class=\"form-control\" name=\"deleted\" id=\"field_deleted\" ng-model=\"vm.typeTax.deleted\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/business/type-tax/type-taxs.html","<div><h2 ng-if=\"!vm.isEmbeddedInContractSetup\" translate=\"wamasysApp.typeTax.home.title\">TypeTaxs</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\".new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"wamasysApp.typeTax.home.createLabel\">Create new TypeTax</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><!--                     <th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th> --><th jh-sort-by=\"label\"><span translate=\"wamasysApp.typeTax.label\">Libelle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"codeTax\"><span translate=\"wamasysApp.typeTax.codeTax\">codeTax</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taxRate\"><span translate=\"wamasysApp.typeTax.taxRate\">taxRate</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deleted\"><span translate=\"global.field.isDeleted\">isDeleted</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"typeTax in vm.typeTaxs track by typeTax.id\"><!--                     <td><a ui-sref=\"type-tax-detail({id:typeTax.id})\">{{typeTax.id}}</a></td> --><td><a ui-sref=\"type-tax-detail({id:typeTax.id})\">{{typeTax.label}}</a></td><td>{{typeTax.codeTax}}</td><td>{{typeTax.taxRate}}</td><td>{{typeTax.deleted}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"type-tax-detail({id:typeTax.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button><!--                             <button type=\"submit\" --><!--                                     ui-sref=\".edit({id:typeTax.id})\" --><!--                                     class=\"btn btn-primary btn-sm\"> --><!--                                 <span class=\"glyphicon glyphicon-pencil\"></span> --><!--                                 <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span> --><!--                             </button> --> <button type=\"submit\" ui-sref=\".delete({id:typeTax.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/components/photo-viewer-modal/photo-viewer-modal.tpl.html","<div class=\"modal fade in\" ng-if=\"$ctrl.modal && $ctrl.modal.visible\" style=\"display: block; background: rgba(0, 0, 0, 0.65)\"><div class=\"modal-dialog modal-lg\" style=\"width: 92%; max-width: 1180px; margin-top: 30px\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$ctrl.close()\">&times;</button><h4 class=\"modal-title\">{{$ctrl.modal.title}}</h4></div><div class=\"modal-body\"><div class=\"btn-toolbar margin-bottom-10\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.zoomOut()\"><span class=\"fa fa-search-minus\"></span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.zoomIn()\"><span class=\"fa fa-search-plus\"></span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.rotate()\"><span class=\"fa fa-rotate-right\"></span></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\"><span class=\"fa fa-refresh\"></span></button></div></div><div style=\"height: 70vh; overflow: hidden; background: #111; position: relative; border-radius: 4px; display: flex; align-items: center; justify-content: center\"><img ng-src=\"{{$ctrl.modal.url}}\" alt=\"{{$ctrl.modal.title || \'photo\'}}\" draggable=\"false\" ng-mousedown=\"$ctrl.startDrag($event)\" ng-style=\"$ctrl.getImageStyle()\" style=\"max-width: 100%; max-height: 100%; width: auto; height: auto; transform-origin: center center\"><div style=\"position: absolute; bottom: 12px; right: 16px; color: #fff; background: rgba(0, 0, 0, 0.4); padding: 6px 10px; border-radius: 4px\">x{{($ctrl.modal.scale || 1) | number:2}}</div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.close()\">Fermer</button></div></div></div></div>");
$templateCache.put("app/components/assistant/assistant-panel.html","<div class=\"assistant-panel\" ng-if=\"vm.state.isOpen\"><div class=\"assistant-panel__header\"><div><strong>{{vm.state.context.title || \'Assistant\'}}</strong><div class=\"assistant-panel__subtitle\" ng-if=\"vm.state.context.subtitle\">{{vm.state.context.subtitle}}</div></div><div class=\"assistant-panel__actions\"><div class=\"btn-group\" uib-dropdown auto-close=\"outsideClick\"><button type=\"button\" class=\"btn btn-link btn-xs\" uib-dropdown-toggle><span class=\"glyphicon glyphicon-cog\"></span></button><ul class=\"dropdown-menu dropdown-menu-right assistant-panel__menu\" uib-dropdown-menu><li class=\"dropdown-header\" translate=\"global.assistant.optionsTitle\">Options</li><li ng-if=\"vm.canConfigureDataScopes()\"><label class=\"assistant-panel__menu-item\"><input type=\"checkbox\" ng-model=\"vm.state.allowAssistantToChooseData\"> <span translate=\"global.assistant.usePlanner\">Utiliser le planner pour choisir les donnees</span></label></li><li class=\"dropdown-header\" ng-if=\"vm.canConfigureDataScopes() && !vm.state.allowAssistantToChooseData\" translate=\"global.assistant.dataScopesTitle\">Donnees envoyees</li><li ng-if=\"vm.canConfigureDataScopes() && !vm.state.allowAssistantToChooseData\" ng-repeat=\"scope in vm.state.availableDataScopes track by scope.key\"><label class=\"assistant-panel__menu-item\"><input type=\"checkbox\" ng-checked=\"vm.isScopeSelected(scope.key)\" ng-click=\"vm.toggleScope(scope.key)\"> <span translate=\"{{scope.labelKey}}\"></span></label></li><li class=\"dropdown-header\" ng-if=\"vm.canConfigureDataScopes()\" translate=\"global.assistant.instructionDomainsTitle\">Regles metier envoyees</li><li ng-if=\"vm.canConfigureDataScopes() && !vm.state.allowAssistantToChooseData\" ng-repeat=\"domain in vm.state.availableInstructionDomains track by domain.key\"><label class=\"assistant-panel__menu-item\"><input type=\"checkbox\" ng-checked=\"vm.isInstructionDomainSelected(domain.key)\" ng-click=\"vm.toggleInstructionDomain(domain.key)\"> <span translate=\"{{domain.labelKey}}\"></span></label><div class=\"text-muted small assistant-panel__menu-item\" translate=\"{{domain.descriptionKey}}\"></div></li><li role=\"separator\" class=\"divider\"></li><li class=\"assistant-panel__menu-item\" ng-if=\"vm.supportsAssistantFlowModes()\"><label translate=\"global.assistant.flowModeLabel\">Mode assistant</label><select class=\"form-control input-sm\" ng-model=\"vm.state.selectedAssistantFlowMode\"><option value=\"LEGACY\" translate=\"global.assistant.flowModeLegacy\">Mode existant</option><option value=\"OPTIMIZED\" translate=\"global.assistant.flowModeOptimized\">Mode optimise</option></select></li><li class=\"assistant-panel__menu-item\" ng-if=\"vm.supportsAssistantFlowModes()\"><div class=\"text-muted small\" translate=\"global.assistant.flowModeHelp\">Le mode optimise privilegie les resumes metier et les actions partielles.</div></li><li class=\"assistant-panel__menu-item\"><label translate=\"global.assistant.responseLevel\">Niveau de reponse</label><select class=\"form-control input-sm\" ng-model=\"vm.state.responseDetailLevel\"><option value=\"SHORT\" translate=\"global.assistant.responseLevelShort\">Courte</option><option value=\"DETAILED\" translate=\"global.assistant.responseLevelDetailed\">Detaillee</option></select></li><li class=\"assistant-panel__menu-item\"><label translate=\"global.assistant.modelLabel\">Modele</label><select class=\"form-control input-sm\" ng-model=\"vm.state.selectedModel\"><option value=\"AUTO\">Configuration serveur</option><option value=\"gpt-5-mini\">GPT-5 mini</option><option value=\"gpt-5\">GPT-5</option><option value=\"ollama/mistral-small3.1:24b\">Ollama Mistral Small 3.1 24B</option><option value=\"ollama/gemma3:4b\">Ollama Gemma3 4b</option><option value=\"ollama/qwen3:14b\">Ollama Qwen3 14B</option><option value=\"ollama/qwen3:30b\">Ollama Qwen3 30B</option></select></li><li class=\"assistant-panel__menu-item\"><label translate=\"global.assistant.styleLabel\">Style de reponse</label><select class=\"form-control input-sm\" ng-model=\"vm.state.creativityLevel\"><option value=\"PRECISE\" translate=\"global.assistant.stylePrecise\">Precise</option><option value=\"EQUILIBREE\" translate=\"global.assistant.styleBalanced\">Equilibree</option><option value=\"CREATIVE\" translate=\"global.assistant.styleCreative\">Creative</option></select></li><li class=\"assistant-panel__menu-item\" ng-if=\"vm.getMaxOutputTokenOptions().length\"><label>Max tokens sortie</label><select class=\"form-control input-sm\" ng-model=\"vm.state.selectedMaxOutputTokens\" ng-options=\"option as option for option in vm.getMaxOutputTokenOptions()\"></select><div class=\"text-muted small\">Plus eleve = moins de coupures, mais plus de cout.</div></li></ul></div><a class=\"btn btn-link btn-xs\" href=\"content/user-guides/ai-assistant-actions-help.html\" target=\"_blank\" rel=\"noopener noreferrer\" title=\"Aide assistant IA\"><span class=\"glyphicon glyphicon-question-sign\"></span> </a><button has-any-authority=\"ROLE_SUPER_ADMIN\" type=\"button\" class=\"btn btn-link btn-xs\" ng-click=\"vm.copyConversationDebugJson()\" title=\"Copier le JSON debug de la conversation\"><span class=\"glyphicon glyphicon-copy\"></span></button> <button type=\"button\" class=\"btn btn-link btn-xs\" ng-click=\"vm.toggleMinimized()\"><span class=\"glyphicon\" ng-class=\"vm.state.isMinimized ? \'glyphicon-chevron-up\' : \'glyphicon-chevron-down\'\"></span></button> <button type=\"button\" class=\"btn btn-link btn-xs\" ng-click=\"vm.close(\'WINDOW_CLOSE\')\"><span class=\"glyphicon glyphicon-remove\"></span></button></div></div><div class=\"assistant-panel__body\" ng-if=\"!vm.state.isMinimized\"><div class=\"alert alert-danger\" ng-if=\"vm.state.errorMessage\">{{vm.state.errorMessage}}</div><div class=\"alert alert-success\" ng-if=\"vm.state.debugCopySuccess\">JSON debug copie dans le presse-papiers.</div><div class=\"alert alert-warning\" ng-if=\"vm.state.context.tokenWarningMessage\">{{vm.state.context.tokenWarningMessage}}</div><div class=\"alert alert-info\" ng-if=\"vm.state.context.llmUpgradeMessage\"><div>{{vm.state.context.llmUpgradeMessage}}</div><button type=\"button\" class=\"btn btn-primary btn-sm margin-top-10\" ng-click=\"vm.state.context.enableLlmMode()\"><span translate=\"global.assistant.manualEnableLlm\">Passer en mode IA</span></button></div><div class=\"alert alert-info\" ng-if=\"vm.state.context.llmUpgradeLockedMessage\">{{vm.state.context.llmUpgradeLockedMessage}}</div><div class=\"assistant-panel__usage\" ng-if=\"vm.state.latestUsage\"><div class=\"assistant-panel__usage-header\"><div><strong translate=\"global.assistant.tokenUsage\">Budget IA (USD)</strong> <span translate=\"global.assistant.userLabel\">Utilisateur</span> <span class=\"{{vm.getUserUsageStatusClass()}}\">{{vm.getUserUsageStatusLabel()}}</span> <span translate=\"global.assistant.organisationLabel\">Organisation</span> <span class=\"{{vm.getOrganisationUsageStatusClass()}}\">{{vm.getOrganisationUsageStatusLabel()}}</span></div><button type=\"button\" class=\"btn btn-link btn-xs\" ng-click=\"vm.toggleUsageDetails()\"><span class=\"glyphicon\" ng-class=\"vm.state.usageExpanded ? \'glyphicon-chevron-up\' : \'glyphicon-chevron-down\'\"></span></button></div><div class=\"assistant-panel__usage-details\" ng-if=\"vm.state.usageExpanded\"><div class=\"text-muted\">Consommation budgétaire avec marge de sécurité et appels en cours.</div><div class=\"text-muted assistant-panel__usage-period\">{{vm.getUsagePeriodLabel()}}</div><div><span translate=\"global.assistant.userLabel\">Utilisateur</span>: {{vm.formatTokenUsage(vm.state.latestUsage.currentMonthUserCostUsd, vm.state.latestUsage.monthlyUserCostLimitUsd)}}</div><div><span translate=\"global.assistant.organisationLabel\">Organisation</span>: {{vm.formatTokenUsage(vm.state.latestUsage.currentMonthOrganisationCostUsd, vm.state.latestUsage.monthlyOrganisationCostLimitUsd)}}</div><div ng-if=\"vm.state.latestUsage.resolvedMaxOutputTokens\">Max tokens sortie: {{vm.state.latestUsage.resolvedMaxOutputTokens}}</div><div ng-if=\"vm.state.latestUsage.requestTotalTokens\"><span translate=\"global.assistant.lastRequest\">Derniere requete</span>: {{vm.state.latestUsage.requestTotalTokens}}</div></div></div><div class=\"assistant-panel__loading alert alert-info\" ng-if=\"vm.state.isSending\"><span class=\"glyphicon glyphicon-refresh assistant-panel__spinner\"></span><div><div>{{vm.state.processingStatus || (\'global.assistant.serverWorking\' | translate)}}</div><div class=\"assistant-panel__loading-subtext\" ng-if=\"vm.state.delayedProcessingMessage\">{{vm.state.delayedProcessingMessage}}</div></div></div><div class=\"alert alert-info assistant-panel__feedback\" ng-if=\"vm.state.feedbackPromptVisible\"><strong translate=\"global.assistant.feedbackQuestion\">Etes-vous satisfait du resultat ?</strong><div class=\"assistant-panel__feedback-actions\"><button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"vm.submitFeedback(true)\" translate=\"global.assistant.feedbackYes\">Oui</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.beginUnsatisfiedFeedback()\" translate=\"global.assistant.feedbackNo\">Non</button> <button type=\"button\" class=\"btn btn-link btn-sm\" ng-click=\"vm.dismissFeedbackPrompt()\" translate=\"global.assistant.feedbackLater\">Plus tard</button></div><div ng-if=\"vm.state.feedbackReasonPromptVisible\" class=\"margin-top-10\"><label class=\"control-label\" translate=\"global.assistant.feedbackCommentLabel\">Si vous voulez, dites-nous pourquoi</label><textarea class=\"form-control\" rows=\"3\" ng-model=\"vm.state.feedbackComment\" placeholder=\"{{\'global.assistant.feedbackCommentPlaceholder\' | translate}}\"></textarea><div class=\"assistant-panel__feedback-actions margin-top-10\"><button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"vm.submitUnsatisfiedFeedback()\" translate=\"global.assistant.feedbackSend\">Envoyer</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.submitFeedback(false)\" translate=\"global.assistant.feedbackSkipComment\">Envoyer sans commentaire</button></div></div></div><div class=\"assistant-panel__messages\"><div class=\"assistant-panel__message\" ng-repeat=\"message in vm.state.messages track by $index\"><div class=\"label\" ng-class=\"message.role === \'user\' ? \'label-primary\' : \'label-default\'\">{{ (message.role === \'user\' ? \'global.assistant.userRole\' : \'global.assistant.assistantRole\') | translate }}</div><div class=\"assistant-panel__message-content\">{{message.content}}</div><div ng-if=\"message.configurationProposal\" class=\"panel panel-default\"><div class=\"panel-body\"><p>Vérifiez la proposition avant de la créer. Les ajouts à une sous-catégorie conservent son historique.</p><p ng-if=\"message.configurationProposal.dashboard\"><strong>{{message.configurationProposal.dashboard.label}}</strong><br>{{message.configurationProposal.dashboard.description}}</p><ul ng-if=\"message.configurationProposal.fields\"><li ng-repeat=\"field in message.configurationProposal.fields track by field.fieldCode\"><strong>{{field.label || field.fieldCode}}</strong> : {{field.reuse ? \'réutilisation du champ existant\' : field.dataType}} <span ng-if=\"field.unit\">({{field.unit}})</span><span ng-if=\"field.required\"> — obligatoire</span> <span ng-if=\"field.values.length\">— choix : {{field.values.join(\', \')}}</span></li></ul><button type=\"button\" class=\"btn btn-link btn-sm\" ng-click=\"message.showConfigurationJson = !message.showConfigurationJson\">Afficher / masquer le JSON</button><pre ng-if=\"message.showConfigurationJson\" style=\"max-height:300px; overflow:auto\">{{message.configurationJson}}</pre><button type=\"button\" class=\"btn btn-primary\" ng-click=\"message.confirmConfiguration()\" ng-disabled=\"message.configurationCreating || message.configurationCreated || message.configurationSuperseded || vm.state.isSending\">{{message.configurationCreating ? \'Création en cours…\' : message.configurationButton}}</button><p class=\"text-success\" ng-if=\"message.configurationCreated\">La configuration a été créée.</p><p class=\"text-muted\" ng-if=\"message.configurationSuperseded && !message.configurationCreated\">Cette proposition a été remplacée par la suite de la discussion.</p></div></div><div class=\"alert alert-danger\" ng-if=\"message.configurationError\">{{message.configurationError}}</div><div class=\"text-muted small\" ng-if=\"message.role === \'assistant\' && vm.buildSentContextInfo(message)\"><em>{{vm.buildSentContextInfo(message)}}</em></div><div class=\"alert alert-info assistant-panel__document-results\" ng-if=\"message.role === \'assistant\' && message.documentResults && message.documentResults.length\"><strong translate=\"global.assistant.manualResultsTitle\">Passages documentaires trouves</strong><div class=\"assistant-panel__document-result\" ng-repeat=\"result in message.documentResults track by result.chunkId\"><button type=\"button\" class=\"btn btn-link btn-xs assistant-panel__document-link\" ng-click=\"vm.openDocumentResult(result)\">{{result.docTitle}} - {{result.sectionPath}}</button><div class=\"text-muted small\">{{result.snippet}}</div></div></div><div class=\"alert alert-info\" ng-if=\"message.role === \'assistant\' && message.awaitingUserInput && message.clarificationQuestions.length\"><strong translate=\"global.assistant.needInformation\">Informations necessaires</strong><ul class=\"assistant-panel__list\"><li ng-repeat=\"question in message.clarificationQuestions track by $index\">{{question}}</li></ul></div><div class=\"alert alert-info\" ng-if=\"vm.supportsActionProposal() && message.role === \'assistant\' && message.shouldSuggestAction && !message.proposedActionSummaries.length\"><div translate=\"global.assistant.actionMayBeRelevant\">Une correction semble pertinente.</div></div><div class=\"alert alert-warning\" ng-if=\"vm.supportsActionProposal() && message.role === \'assistant\' && message.proposedActionSummaries.length\"><strong translate=\"global.assistant.proposedActionsTitle\">Actions proposees</strong><div class=\"assistant-panel__apply-question\" translate=\"{{message.proposedActionSummaries.length > 1 ? \'global.assistant.applyActionsQuestion\' : \'global.assistant.applyActionQuestion\'}}\">Est-ce que l\'on applique cette action ?</div><ul class=\"assistant-panel__list\"><li ng-repeat=\"summary in message.proposedActionSummaries track by $index\">{{summary}}</li></ul><button type=\"button\" class=\"btn btn-primary btn-sm\" ng-if=\"message.canExecuteActions && !message.actionsExecuted\" ng-disabled=\"message.isExecutingActions\" ng-click=\"vm.executeActions(message)\"><span class=\"glyphicon glyphicon-ok\"></span> <span translate=\"global.assistant.executeActions\">Executer ces actions</span></button><div class=\"text-warning assistant-panel__action-warning\" ng-if=\"!message.actionsExecuted && !vm.areProposedActionsReady(message)\"><span translate=\"global.assistant.actionsNotReady\">Ces actions sont structurees mais pas encore executables. Completez les champs manquants ou fournissez le contexte attendu.</span></div><div class=\"text-warning assistant-panel__action-warning\" ng-if=\"!message.actionsExecuted && vm.areProposedActionsReady(message) && !message.canExecuteActions\">Vous n\'avez pas les droits necessaires pour executer cette action.</div></div><div class=\"alert assistant-panel__executed-actions\" ng-if=\"vm.supportsActionProposal() && message.role === \'assistant\' && vm.showExecutedActionsBlock(message)\"><strong translate=\"global.assistant.actionsExecuted\">Actions executees</strong><ul class=\"assistant-panel__list\" ng-if=\"message.executedActionSummaries.length\"><li ng-repeat=\"summary in message.executedActionSummaries track by $index\">{{summary}}</li></ul><div class=\"assistant-panel__action-warning\" ng-if=\"vm.showAdjustmentFollowUp(message)\">Controlez le resultat. Si cela vous convient, faites etablir la facturation. Sinon, vous pouvez supprimer les lignes creees.</div></div></div></div><div class=\"form-group assistant-panel__prompt-group\"><label translate=\"global.assistant.requestLabel\">Votre demande</label><textarea class=\"form-control assistant-panel__prompt-input\" rows=\"4\" ng-model=\"vm.state.prompt\" ng-keydown=\"vm.handlePromptKeydown($event)\" placeholder=\"{{vm.state.context.promptPlaceholder || (\'global.assistant.defaultPromptPlaceholder\' | translate)}}\"></textarea></div><div class=\"assistant-panel__footer\"><button type=\"button\" class=\"btn btn-link\" ng-disabled=\"vm.state.isSending\" ng-click=\"vm.finishConversation()\" translate=\"global.assistant.finishConversation\">Finir la conversation</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"vm.state.isSending || !vm.state.prompt || !vm.state.prompt.trim()\" ng-click=\"vm.askQuestion()\"><span translate=\"global.assistant.assistantSend\">Poser une question</span></button></div></div></div>");
$templateCache.put("app/components/smartphone-handoffs/smartphone-handoffs.html","<section class=\"panel panel-default\" ng-if=\"handoffs.length || error || loading\"><div class=\"panel-heading\"><strong translate=\"global.handoff.title\">Réception des collectes du téléphone</strong> <button type=\"button\" class=\"btn btn-default btn-xs pull-right\" ng-click=\"refresh()\" ng-disabled=\"loading\" translate=\"global.handoff.refresh\">Actualiser</button></div><div class=\"panel-body\"><p translate=\"global.handoff.explanation\">Reçu signifie conservé sur le serveur, pas nécessairement validé. Les anomalies se traitent au bureau ; les pièces facultatives peuvent arriver ensuite.</p><p class=\"text-info\" ng-if=\"loading\" translate=\"global.handoff.loading\">Chargement…</p><p class=\"alert alert-warning\" ng-if=\"error\" translate=\"global.handoff.unavailable\">Le suivi des dépôts est indisponible. Il n\'est pas possible de confirmer leur absence.</p><article class=\"well well-sm\" ng-repeat=\"handoff in handoffs track by (handoff.handoffId || handoff.id)\"><span class=\"label\" ng-class=\"handoff.received ? \'label-success\' : \'label-default\'\" translate=\"{{handoff.received ? \'global.handoff.received\' : \'global.handoff.receiving\'}}\"></span> <span class=\"label\" ng-class=\"handoff.processingStatus === \'ANOMALY\' ? \'label-warning\' : \'label-info\'\" translate=\"{{statusKey(handoff)}}\"></span> <span ng-bind=\"handoff.receivedAt | date:\'medium\'\"></span><p><span translate=\"global.handoff.submittedBy\">Compte ayant déposé :</span> <span ng-bind=\"handoff.collectorLogin\"></span></p><p class=\"alert alert-warning\" ng-if=\"handoff.received && !handoff.applicationAuthorized\" translate=\"global.handoff.assignmentReview\">L\'affectation doit être vérifiée par le support. Ce dépôt ne modifie pas automatiquement une collecte attribuée à un autre utilisateur.</p><p class=\"alert alert-info\" ng-if=\"handoff.report.waitingReason === \'OTHER_HANDOFF_PENDING\'\" translate=\"global.handoff.otherPending\">Ce dépôt est conforme. La CL attend le contrôle d\'un autre dépôt avant sa validation automatique.</p><p class=\"alert alert-warning\" ng-if=\"handoff.report.waitingReason === \'OTHER_HANDOFF_ANOMALY\'\" translate=\"global.handoff.otherAnomaly\">Ce dépôt est conforme, mais une anomalie dans un autre dépôt doit être rapprochée avant de valider la CL.</p><p ng-if=\"handoff.report.applied !== undefined\"><span ng-if=\"documentType === \'RF\' && handoff.report.incompleteReadings > 0\"><span translate=\"global.handoff.incompleteReadings\">Lignes à compléter au dernier contrôle :</span> <span ng-bind=\"handoff.report.incompleteReadings\"></span> — </span><span translate=\"global.handoff.applied\">Éléments traités :</span> <span ng-bind=\"handoff.report.applied\"></span> — <span translate=\"global.handoff.alreadyReceived\">Déjà enregistrés :</span> <span ng-bind=\"handoff.report.alreadyReceived || 0\"></span> <span ng-if=\"documentType === \'CL\'\">— <span translate=\"global.handoff.skipped\">Contrats sans paiement déclaré :</span> <span ng-bind=\"handoff.report.skipped || 0\"></span></span></p><p class=\"text-warning\" ng-if=\"handoff.reportUnavailable\" translate=\"global.handoff.reportUnavailable\">Le rapport n\'est pas lisible. Téléchargez la source pour le support.</p><p class=\"alert alert-warning\" ng-if=\"handoff.anomalies.length\" translate=\"global.handoff.blocked\">Les données sont conservées. Les anomalies ci-dessous empêchent la validation de la collecte.</p><div class=\"table-responsive\" ng-if=\"handoff.anomalies.length\"><table class=\"table table-condensed\"><thead><tr><th translate=\"global.handoff.item\">Contrat ou compteur concerné</th><th translate=\"global.handoff.cause\">Cause du blocage</th><th translate=\"global.handoff.reason\">Action à effectuer</th></tr></thead><tbody><tr ng-repeat=\"anomaly in handoff.anomalies | limitTo:50 track by $index\"><td><span ng-if=\"itemLabel(anomaly)\" ng-bind=\"itemLabel(anomaly)\"></span><span ng-if=\"!itemLabel(anomaly)\" translate=\"{{anomaly.itemId == null ? \'global.handoff.wholeDocument\' : \'global.handoff.unidentifiedItem\'}}\"></span></td><td translate=\"{{issueKey(anomaly, \'cause\')}}\"></td><td translate=\"{{issueKey(anomaly, \'action\')}}\"></td></tr></tbody></table><p ng-if=\"handoff.anomalies.length > 50\" translate=\"global.handoff.firstFifty\">Les 50 premières anomalies sont affichées.</p></div><p class=\"alert alert-danger\" ng-if=\"handoff.error\" translate=\"global.handoff.actionFailed\">L\'action n\'a pas abouti. Le dépôt original reste conservé.</p><button type=\"button\" class=\"btn btn-link btn-sm\" ng-click=\"handoff.showTechnical = !handoff.showTechnical\" aria-expanded=\"{{!!handoff.showTechnical}}\" translate=\"global.handoff.technical\">Détails pour le support</button><div ng-if=\"handoff.showTechnical\" class=\"well well-sm\"><p><span ng-bind=\"handoff.handoffId || handoff.id\"></span> — <span ng-bind=\"handoff.processingStatus\"></span></p><p><span translate=\"global.handoff.originalCollector\">Collecteur déclaré à l\'origine :</span> <span ng-bind=\"handoff.originalCollectorLogin\"></span></p><p ng-repeat=\"anomaly in handoff.anomalies | limitTo:50 track by $index\"><span ng-bind=\"anomaly.itemId\"></span> — <span ng-bind=\"anomaly.code\"></span> — <span ng-bind=\"anomaly.reason\"></span></p><button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"handoff.received\" ng-click=\"downloadSource(handoff)\" translate=\"global.handoff.download\">Télécharger la source pour le support</button></div><button type=\"button\" class=\"btn btn-primary btn-sm\" has-any-authority=\"ROLE_DATA_OPERATOR\" ng-if=\"handoff.received\" ng-disabled=\"handoff.busy\" ng-click=\"retry(handoff)\" translate=\"global.handoff.retry\">Recontrôler côté serveur</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"handoff.received\" ng-disabled=\"handoff.loadingAttachments\" ng-click=\"loadAttachments(handoff)\" translate=\"global.handoff.showAttachments\">Voir les pièces reçues</button><p ng-if=\"handoff.attachmentsLoaded && !handoff.attachments.length\" translate=\"global.handoff.noAttachments\">Aucune pièce séparée reçue pour ce dépôt. Certaines signatures peuvent se trouver dans la source.</p><ul ng-if=\"handoff.attachments.length\"><li ng-repeat=\"attachment in handoff.attachments track by (attachment.attachmentId || attachment.id)\"><button type=\"button\" class=\"btn btn-link\" ng-click=\"downloadAttachment(handoff, attachment)\"><span ng-bind=\"attachment.kind\"></span> — <span ng-bind=\"attachment.lineId || attachment.meterId || attachment.attachmentId || attachment.id\"></span></button></li></ul></article><button type=\"button\" class=\"btn btn-default\" ng-if=\"hasNext\" ng-disabled=\"loading\" ng-click=\"next()\" translate=\"global.handoff.more\">Dépôts suivants</button></div></section>");
$templateCache.put("app/components/user-management-bulk-edit/user-management-bulk-edit-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\">{{ vm.getTitleKey() | translate }}</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"userManagement.bulk.selectionCount\" translate-values=\"{ count: vm.selectionCount }\">{{ vm.selectionCount }} utilisateur(s) sélectionné(s)</p><div class=\"form-group\" ng-if=\"vm.isAuthorityAction()\"><label class=\"control-label\" translate=\"userManagement.profiles\">Droits</label><select class=\"form-control\" name=\"authority\" ng-model=\"vm.form.authority\" ng-options=\"authority as authority for authority in vm.authorities\" required></select></div><div class=\"form-group\" ng-if=\"vm.isAgenceAction()\"><label class=\"control-label\" translate=\"userManagement.agencesRattachement\">Droits d\'accès zone</label><select class=\"form-control\" name=\"agenceId\" ng-model=\"vm.form.agenceId\" ng-options=\"agence.id as agence.nom for agence in vm.agences track by agence.id\" required></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"userManagement.bulk.apply\">Appliquer</span></button></div></form>");
$templateCache.put("app/components/journey-map/journey-map.tpl.html","<div class=\"journey-map-wrapper\"><div style=\"position: relative\"><leaflet id=\"{{$ctrl.mapId}}\" ng-if=\"renderMap\" bounds=\"bounds\" center=\"center\" defaults=\"defaults\" layers=\"layers\" markers=\"markers\" paths=\"paths\" height=\"{{$ctrl.height || \'420px\'}}\" width=\"100%\"></leaflet><div style=\"position:absolute; top:78px; left:10px; z-index:1000\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"$ctrl.zoomToData()\"><span class=\"glyphicon glyphicon-fullscreen\"></span> <span>Zoom zone</span></button></div></div></div>");
$templateCache.put("app/components/map-leaflet/map-leaflet.tpl.html","<style>.map-leaflet-wrapper {\n    width: 100%;\n    position: relative;\n    border: 1px solid black;\n}\n\n.map-leaflet-toolbar {\n    position: absolute;\n    top: 65px;\n    left: 5px;\n    z-index: 10;\n}\n\n.map-leaflet-help {\n    margin-top: 8px;\n}</style><div class=\"map-leaflet-wrapper\"><leaflet defaults=\"defaults\" bounds=\"bounds\" paths=\"paths\" event-broadcast=\"events\" id=\"{{$ctrl.mapId}}\" center=\"center\" layers=\"layers\" markers=\"markers\" height=\"{{$ctrl.height || \'320px\'}}\" width=\"{{$ctrl.width || \'100%\'}}\"></leaflet><div class=\"map-leaflet-toolbar\" ng-if=\"!$ctrl.isReadonly()\"><a value=\"Center\" ng-click=\"centerMap()\" class=\"btn btnStyle\"><span class=\"fa fa-crosshairs\"></span></a><br><a ng-if=\"$ctrl.hasGeometryEditor()\" value=\"Delete geometry\" ng-click=\"$ctrl.clearGeometry()\" class=\"btn btnStyle\"><span class=\"fa fa-trash-o\"></span> </a><a ng-if=\"!$ctrl.hasGeometryEditor()\" value=\"Delete marker\" ng-click=\"deleteMarker()\" class=\"btn btnStyle\"><span class=\"fa fa-trash-o\"></span></a><br><a ng-if=\"!$ctrl.hasGeometryEditor()\" value=\"Edit marker\" ng-click=\"editMarker()\" class=\"btn btnStyle\" ng-class=\"{\'btn-danger\': $ctrl.markerEditMode}\"><span class=\"fa fa-edit\"></span> </a><span ng-if=\"!$ctrl.hasGeometryEditor()\"><br></span><a ng-if=\"$ctrl.hasGeometryEditor()\" value=\"Edit geometry\" ng-click=\"$ctrl.toggleGeometryEditMode()\" class=\"btn btnStyle\" ng-class=\"{\'btn-danger\': $ctrl.geometryEditMode}\"><span class=\"fa fa-edit\"></span></a><br ng-if=\"$ctrl.hasGeometryEditor()\"><a ng-if=\"$ctrl.hasGeometryEditor()\" value=\"Add point\" ng-click=\"$ctrl.toggleGeometryPointCreationMode()\" class=\"btn btnStyle\" ng-class=\"{\'btn-danger\': $ctrl.geometryPointCreationMode}\"><span class=\"fa fa-plus-circle\"></span></a></div></div><div class=\"alert alert-info map-leaflet-help margin-bottom-10\" ng-if=\"$ctrl.hasGeometryEditor()\" translate=\"wamasysApp.agence.geometryEditorHelp\" translate-compile></div><div class=\"form-group row\" ng-if=\"!$ctrl.hasGeometryEditor()\"><div class=\"col-md-6\"><input type=\"number\" class=\"form-control\" name=\"lat\" id=\"field_lat\" ng-readonly=\"$ctrl.isReadonly()\" title=\"{{\'global.field.latitude\' | translate}}\" placeholder=\"{{\'global.field.latitude\' | translate}}\" ng-model=\"$ctrl.contrat.lat\" ng-change=\"$ctrl.updateCoord()\" min=\"-90\" max=\"90\"><div ng-show=\"editForm.lat.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lat.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.lat.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.lat.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999\">This field cannot be more than 999.</p><p class=\"help-block\" ng-show=\"editForm.lat.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"col-md-6\"><input type=\"number\" class=\"form-control\" name=\"lon\" id=\"field_lon\" ng-readonly=\"$ctrl.isReadonly()\" title=\"{{\'global.field.longitude\' | translate}}\" placeholder=\"{{\'global.field.longitude\' | translate}}\" ng-model=\"$ctrl.contrat.lon\" ng-change=\"$ctrl.updateCoord()\" min=\"-180\" max=\"180\"><div ng-show=\"editForm.lon.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lon.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.lon.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"0\">This field should be more than 0.</p><p class=\"help-block\" ng-show=\"editForm.lon.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"999\">This field cannot be more than 999.</p><p class=\"help-block\" ng-show=\"editForm.lon.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></div>");
$templateCache.put("app/components/login/login.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" translate=\"login.title\">Sign in</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1 translate=\"login.title\">Sign in</h1></div><div class=\"col-md-8 col-md-offset-2\"><div class=\"alert alert-danger\" ng-show=\"vm.authenticationError\">{{ vm.textErreur | translate}}<!-- \r\n                <strong>Failed to sign in!</strong> Please check your credentials and try again.\r\n                 --></div></div><div class=\"col-md-8 col-md-offset-2\"><form class=\"form\" role=\"form\" ng-submit=\"vm.login($event)\"><div class=\"form-group\"><label for=\"username\" translate=\"global.form.username\">Login</label><input type=\"text\" class=\"form-control\" id=\"username\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.username\"></div><div class=\"form-group\"><label for=\"password\" translate=\"login.form.password\">Password</label><input type=\"password\" class=\"form-control\" id=\"password\" placeholder=\"{{\'login.form.password.placeholder\' | translate}}\" ng-model=\"vm.password\"></div><div class=\"form-group\" ng-if=\"vm.mfaRequired\"><label for=\"mfaCode\" translate=\"login.form.mfaCode\">Code de double authentification</label><input type=\"text\" class=\"form-control\" id=\"mfaCode\" ng-model=\"vm.mfaCode\" inputmode=\"numeric\" autocomplete=\"one-time-code\" maxlength=\"6\" ng-pattern=\"/^[0-9]{6}$/\" required><p class=\"help-block\" translate=\"login.form.mfaHelp\">Saisissez le code à six chiffres de Google Authenticator.</p></div><div class=\"form-group\"><label for=\"rememberMe\"><input type=\"checkbox\" id=\"rememberMe\" ng-model=\"vm.rememberMe\" checked=\"checked\"> <span translate=\"login.form.rememberme\">Remember me</span></label></div><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.submitting\" translate=\"login.form.button\">Sign in</button></form><p></p><div class=\"alert alert-warning\"><a class=\"alert-link\" href=\"\" ng-click=\"vm.requestResetPassword()\" translate=\"login.password.forgot\">Did you forget your password?</a></div><!-- \r\n            <div class=\"alert alert-warning\" translate=\"global.messages.info.register\" translate-compile>\r\n                You don\'t have an account yet? <a class=\"alert-link\" href=\"\" ng-click=\"vm.register()\">Register a new account</a>\r\n            </div>\r\n             --></div></div></div>");
$templateCache.put("app/account/reset/request/reset.request.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"reset.request.title\">Reset your password</h1><div class=\"alert alert-danger\" translate=\"reset.request.messages.notfound\" ng-show=\"vm.errorEmailNotExists\"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class=\"alert alert-warning\" ng-hide=\"vm.success\"><p translate=\"reset.request.messages.info\">Enter the e-mail address you used to register.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success == \'OK\'\"><p translate=\"reset.request.messages.success\">Check your e-mails for details on how to reset your password.</p><a class=\"alert-link\" href=\"\" ng-click=\"vm.requestLoginPage()\" translate=\"reset.request.messages.goHome\">Go to home</a></div><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.requestReset()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"reset.request.form.button\">Reset</button></form></div></div></div>");
$templateCache.put("app/account/reset/finish/reset.finish.html","<div><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1 translate=\"reset.finish.title\">Reset password</h1><div class=\"alert alert-danger\" translate=\"reset.finish.messages.keymissing\" ng-show=\"vm.keyMissing\"><strong>The password reset key is missing.</strong></div><div class=\"alert alert-warning\" ng-hide=\"vm.success || vm.keyMissing\"><p translate=\"reset.finish.messages.info\">Choose a new password</p></div><div class=\"alert alert-danger\" ng-show=\"vm.error\"><p translate=\"reset.finish.messages.error\">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success\"><p translate=\"reset.finish.messages.success\" translate-compile><strong>Your password has been reset.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"login\">sign in</a>.</p></div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><div ng-hide=\"vm.keyMissing\"><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.finishReset()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.password\" ng-minlength=\"5\" ng-maxlength=\"50\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.pattern\" translate=\"global.messages.validate.confirmpassword.pattern\">Password should contain one number, one upper case and one lower case character.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.resetAccount.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"5\" ng-maxlength=\"50\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your password confirmation is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.pattern\" translate=\"global.messages.validate.confirmpassword.pattern\">Password should contain one number, one upper case and one lower case character.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your password confirmation is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"reset.finish.form.button\">Reset Password</button></form></div></div></div></div>");
$templateCache.put("app/components/smartadmin/forms/directives/bootstrap-validation/bootstrap-attribute-form.tpl.html","<form id=\"attributeForm\" class=\"form-horizontal\" data-bv-message=\"This value is not valid\" data-bv-feedbackicons-valid=\"glyphicon glyphicon-ok\" data-bv-feedbackicons-invalid=\"glyphicon glyphicon-remove\" data-bv-feedbackicons-validating=\"glyphicon glyphicon-refresh\"><fieldset><legend>Set validator options via HTML attributes</legend><div class=\"alert alert-warning\"><code>&lt; input data-bv-validatorname data-bv-validatorname-validatoroption=\"...\" / &gt;</code><br><br>More validator options can be found here: <a href=\"http://bootstrapvalidator.com/validators/\" target=\"_blank\">http://bootstrapvalidator.com/validators/</a></div><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Full name</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control\" name=\"firstName\" placeholder=\"First name\" data-bv-notempty=\"true\" data-bv-notempty-message=\"The first name is required and cannot be empty\"></div><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control\" name=\"lastName\" placeholder=\"Last name\" data-bv-notempty=\"true\" data-bv-notempty-message=\"The last name is required and cannot be empty\"></div></div></fieldset><fieldset><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Username</label><div class=\"col-lg-5\"><input type=\"text\" class=\"form-control\" name=\"username\" data-bv-message=\"The username is not valid\" data-bv-notempty=\"true\" data-bv-notempty-message=\"The username is required and cannot be empty\" data-bv-regexp=\"true\" data-bv-regexp-regexp=\"^[a-zA-Z0-9_\\.]+$\" data-bv-regexp-message=\"The username can only consist of alphabetical, number, dot and underscore\" data-bv-stringlength=\"true\" data-bv-stringlength-min=\"6\" data-bv-stringlength-max=\"30\" data-bv-stringlength-message=\"The username must be more than 6 and less than 30 characters long\" data-bv-different=\"true\" data-bv-different-field=\"password\" data-bv-different-message=\"The username and password cannot be the same as each other\"></div></div></fieldset><fieldset><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Email address</label><div class=\"col-lg-5\"><input class=\"form-control\" name=\"email\" type=\"email\" data-bv-emailaddress=\"true\" data-bv-emailaddress-message=\"The input is not a valid email address\"></div></div></fieldset><fieldset><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Password</label><div class=\"col-lg-5\"><input type=\"password\" class=\"form-control\" name=\"password\" data-bv-notempty=\"true\" data-bv-notempty-message=\"The password is required and cannot be empty\" data-bv-identical=\"true\" data-bv-identical-field=\"confirmPassword\" data-bv-identical-message=\"The password and its confirm are not the same\" data-bv-different=\"true\" data-bv-different-field=\"username\" data-bv-different-message=\"The password cannot be the same as username\"></div></div></fieldset><fieldset><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Retype password</label><div class=\"col-lg-5\"><input type=\"password\" class=\"form-control\" name=\"confirmPassword\" data-bv-notempty=\"true\" data-bv-notempty-message=\"The confirm password is required and cannot be empty\" data-bv-identical=\"true\" data-bv-identical-field=\"password\" data-bv-identical-message=\"The password and its confirm are not the same\" data-bv-different=\"true\" data-bv-different-field=\"username\" data-bv-different-message=\"The password cannot be the same as username\"></div></div></fieldset><fieldset><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Languages</label><div class=\"col-lg-5\"><div class=\"checkbox\"><label><input type=\"checkbox\" name=\"languages[]\" value=\"english\" data-bv-message=\"Please specify at least one language you can speak\" data-bv-notempty=\"true\"> English</label></div><div class=\"checkbox\"><label><input type=\"checkbox\" name=\"languages[]\" value=\"french\"> French</label></div><div class=\"checkbox\"><label><input type=\"checkbox\" name=\"languages[]\" value=\"german\"> German</label></div><div class=\"checkbox\"><label><input type=\"checkbox\" name=\"languages[]\" value=\"russian\"> Russian</label></div><div class=\"checkbox\"><label><input type=\"checkbox\" name=\"languages[]\" value=\"other\"> Other</label></div></div></div></fieldset><div class=\"form-actions\"><div class=\"row\"><div class=\"col-md-12\"><button class=\"btn btn-default\" type=\"submit\"><i class=\"fa fa-eye\"></i> Validate</button></div></div></div></form>");
$templateCache.put("app/components/smartadmin/forms/directives/bootstrap-validation/bootstrap-button-group-form.tpl.html","<form id=\"buttonGroupForm\" method=\"post\" class=\"form-horizontal\"><fieldset><legend>Default Form Elements</legend><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Gender</label><div class=\"col-lg-9\"><div class=\"btn-group\" data-toggle=\"buttons\"><label class=\"btn btn-default\"><input type=\"radio\" name=\"gender\" value=\"male\"> Male</label><label class=\"btn btn-default\"><input type=\"radio\" name=\"gender\" value=\"female\"> Female</label><label class=\"btn btn-default\"><input type=\"radio\" name=\"gender\" value=\"other\"> Other</label></div></div></div></fieldset><fieldset><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Languages</label><div class=\"col-lg-9\"><div class=\"btn-group\" data-toggle=\"buttons\"><label class=\"btn btn-default\"><input type=\"checkbox\" name=\"languages[]\" value=\"english\"> English</label><label class=\"btn btn-default\"><input type=\"checkbox\" name=\"languages[]\" value=\"german\"> German</label><label class=\"btn btn-default\"><input type=\"checkbox\" name=\"languages[]\" value=\"french\"> French</label><label class=\"btn btn-default\"><input type=\"checkbox\" name=\"languages[]\" value=\"russian\"> Russian</label><label class=\"btn btn-default\"><input type=\"checkbox\" name=\"languages[]\" value=\"italian\"> Italian</label></div></div></div></fieldset><div class=\"form-actions\"><div class=\"row\"><div class=\"col-md-12\"><button class=\"btn btn-default\" type=\"submit\"><i class=\"fa fa-eye\"></i> Validate</button></div></div></div></form>");
$templateCache.put("app/components/smartadmin/forms/directives/bootstrap-validation/bootstrap-contact-form.tpl.html","<form id=\"contactForm\" method=\"post\" class=\"form-horizontal\"><fieldset><legend>Showing messages in custom area</legend><div class=\"form-group\"><label class=\"col-md-3 control-label\">Full name</label><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" name=\"fullName\"></div></div></fieldset><fieldset><div class=\"form-group\"><label class=\"col-md-3 control-label\">Email</label><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" name=\"email\"></div></div></fieldset><fieldset><div class=\"form-group\"><label class=\"col-md-3 control-label\">Title</label><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" name=\"title\"></div></div></fieldset><fieldset><div class=\"form-group\"><label class=\"col-md-3 control-label\">Content</label><div class=\"col-md-6\"><textarea class=\"form-control\" name=\"content\" rows=\"5\"></textarea></div></div></fieldset><fieldset><!-- #messages is where the messages are placed inside --><div class=\"form-group\"><div class=\"col-md-9 col-md-offset-3\"><div id=\"messages\"></div></div></div></fieldset><div class=\"form-actions\"><div class=\"row\"><div class=\"col-md-12\"><button class=\"btn btn-default\" type=\"submit\"><i class=\"fa fa-eye\"></i> Validate</button></div></div></div></form>");
$templateCache.put("app/components/smartadmin/forms/directives/bootstrap-validation/bootstrap-movie-form.tpl.html","<form id=\"movieForm\" method=\"post\"><fieldset><legend>Default Form Elements</legend><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-8\"><label class=\"control-label\">Movie title</label><input type=\"text\" class=\"form-control\" name=\"title\"></div><div class=\"col-md-4 selectContainer\"><label class=\"control-label\">Genre</label><select class=\"form-control\" name=\"genre\"><option value=\"\">Choose a genre</option><option value=\"action\">Action</option><option value=\"comedy\">Comedy</option><option value=\"horror\">Horror</option><option value=\"romance\">Romance</option></select></div></div></div></fieldset><fieldset><div class=\"form-group\"><div class=\"row\"><div class=\"col-sm-12 col-md-4\"><label class=\"control-label\">Director</label><input type=\"text\" class=\"form-control\" name=\"director\"></div><div class=\"col-sm-12 col-md-4\"><label class=\"control-label\">Writer</label><input type=\"text\" class=\"form-control\" name=\"writer\"></div><div class=\"col-sm-12 col-md-4\"><label class=\"control-label\">Producer</label><input type=\"text\" class=\"form-control\" name=\"producer\"></div></div></div></fieldset><fieldset><div class=\"form-group\"><div class=\"row\"><div class=\"col-sm-12 col-md-6\"><label class=\"control-label\">Website</label><input type=\"text\" class=\"form-control\" name=\"website\"></div><div class=\"col-sm-12 col-md-6\"><label class=\"control-label\">Youtube trailer</label><input type=\"text\" class=\"form-control\" name=\"trailer\"></div></div></div></fieldset><fieldset><div class=\"form-group\"><label class=\"control-label\">Review</label><textarea class=\"form-control\" name=\"review\" rows=\"8\"></textarea></div></fieldset><fieldset><div class=\"form-group\"><div class=\"row\"><div class=\"col-sm-12 col-md-12\"><label class=\"control-label\">Rating</label></div><div class=\"col-sm-12 col-md-10\"><label class=\"radio radio-inline no-margin\"><input type=\"radio\" name=\"rating\" value=\"terrible\" class=\"radiobox style-2\"> <span>Terrible</span></label><label class=\"radio radio-inline\"><input type=\"radio\" name=\"rating\" value=\"watchable\" class=\"radiobox style-2\"> <span>Watchable</span></label><label class=\"radio radio-inline\"><input type=\"radio\" name=\"rating\" value=\"best\" class=\"radiobox style-2\"> <span>Best ever</span></label></div></div></div></fieldset><div class=\"form-actions\"><div class=\"row\"><div class=\"col-md-12\"><button class=\"btn btn-default\" type=\"submit\"><i class=\"fa fa-eye\"></i> Validate</button></div></div></div></form>");
$templateCache.put("app/components/smartadmin/forms/directives/bootstrap-validation/bootstrap-product-form.tpl.html","<form id=\"productForm\" class=\"form-horizontal\"><fieldset><legend>Default Form Elements</legend><div class=\"form-group\"><label class=\"col-xs-2 col-lg-3 control-label\">Price</label><div class=\"col-xs-9 col-lg-6 inputGroupContainer\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"price\"> <span class=\"input-group-addon\">$</span></div></div></div></fieldset><fieldset><div class=\"form-group\"><label class=\"col-xs-2 col-lg-3 control-label\">Amount</label><div class=\"col-xs-9 col-lg-6 inputGroupContainer\"><div class=\"input-group\"><span class=\"input-group-addon\">&#8364;</span> <input type=\"text\" class=\"form-control\" name=\"amount\"></div></div></div></fieldset><fieldset><div class=\"form-group\"><label class=\"col-xs-2 col-lg-3 control-label\">Color</label><div class=\"col-xs-9 col-lg-6 selectContainer\"><select class=\"form-control\" name=\"color\"><option value=\"\">Choose a color</option><option value=\"blue\">Blue</option><option value=\"green\">Green</option><option value=\"red\">Red</option><option value=\"yellow\">Yellow</option><option value=\"white\">White</option></select></div></div></fieldset><fieldset><div class=\"form-group\"><label class=\"col-xs-2 col-lg-3 control-label\">Size</label><div class=\"col-xs-9 col-lg-6 selectContainer\"><select class=\"form-control\" name=\"size\"><option value=\"\">Choose a size</option><option value=\"S\">S</option><option value=\"M\">M</option><option value=\"L\">L</option><option value=\"XL\">XL</option></select></div></div></fieldset><div class=\"form-actions\"><div class=\"row\"><div class=\"col-md-12\"><button class=\"btn btn-default\" type=\"submit\"><i class=\"fa fa-eye\"></i> Validate</button></div></div></div></form>");
$templateCache.put("app/components/smartadmin/forms/directives/bootstrap-validation/bootstrap-profile-form.tpl.html","<form id=\"profileForm\"><fieldset><legend>Default Form Elements</legend><div class=\"form-group\"><label>Email address</label><input type=\"text\" class=\"form-control\" name=\"email\"></div></fieldset><fieldset><div class=\"form-group\"><label>Password</label><input type=\"password\" class=\"form-control\" name=\"password\"></div></fieldset><div class=\"form-actions\"><div class=\"row\"><div class=\"col-md-12\"><button class=\"btn btn-default\" type=\"submit\"><i class=\"fa fa-eye\"></i> Validate</button></div></div></div></form>");
$templateCache.put("app/components/smartadmin/forms/directives/bootstrap-validation/bootstrap-toggling-form.tpl.html","<form id=\"togglingForm\" method=\"post\" class=\"form-horizontal\"><fieldset><legend>Default Form Elements</legend><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Full name <sup>*</sup></label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control\" name=\"firstName\" placeholder=\"First name\"></div><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control\" name=\"lastName\" placeholder=\"Last name\"></div></div></fieldset><fieldset><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Company <sup>*</sup></label><div class=\"col-lg-5\"><input type=\"text\" class=\"form-control\" name=\"company\" required data-bv-notempty-message=\"The company name is required\"></div><div class=\"col-lg-2\"><button type=\"button\" class=\"btn btn-info btn-sm\" data-toggle=\"#jobInfo\">Add more info</button></div></div></fieldset><!-- These fields will not be validated as long as they are not visible --><div id=\"jobInfo\" style=\"display: none\"><fieldset><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Job title <sup>*</sup></label><div class=\"col-lg-5\"><input type=\"text\" class=\"form-control\" name=\"job\"></div></div></fieldset><fieldset><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Department <sup>*</sup></label><div class=\"col-lg-5\"><input type=\"text\" class=\"form-control\" name=\"department\"></div></div></fieldset></div><fieldset><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Mobile phone <sup>*</sup></label><div class=\"col-lg-5\"><input type=\"text\" class=\"form-control\" name=\"mobilePhone\"></div><div class=\"col-lg-2\"><button type=\"button\" class=\"btn btn-info btn-sm\" data-toggle=\"#phoneInfo\">Add more phone numbers</button></div></div></fieldset><!-- These fields will not be validated as long as they are not visible --><div id=\"phoneInfo\" style=\"display: none\"><fieldset><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Home phone</label><div class=\"col-lg-5\"><input type=\"text\" class=\"form-control\" name=\"homePhone\"></div></div></fieldset><fieldset><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Office phone</label><div class=\"col-lg-5\"><input type=\"text\" class=\"form-control\" name=\"officePhone\"></div></div></fieldset></div><div class=\"form-actions\"><div class=\"row\"><div class=\"col-md-12\"><button class=\"btn btn-default\" type=\"submit\"><i class=\"fa fa-eye\"></i> Validate</button></div></div></div></form>");}]);})();